/*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */
!(function (e, t) {
  "use strict";
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document)
              throw new Error("jQuery requires a window with a document");
            return t(e);
          })
    : t(e);
})("undefined" != typeof window ? window : this, function (C, e) {
  "use strict";
  var t = [],
    r = Object.getPrototypeOf,
    s = t.slice,
    g = t.flat
      ? function (e) {
          return t.flat.call(e);
        }
      : function (e) {
          return t.concat.apply([], e);
        },
    u = t.push,
    i = t.indexOf,
    n = {},
    o = n.toString,
    v = n.hasOwnProperty,
    a = v.toString,
    l = a.call(Object),
    y = {},
    m = function (e) {
      return "function" == typeof e && "number" != typeof e.nodeType;
    },
    x = function (e) {
      return null != e && e === e.window;
    },
    E = C.document,
    c = { type: !0, src: !0, nonce: !0, noModule: !0 };
  function b(e, t, n) {
    var r,
      i,
      o = (n = n || E).createElement("script");
    if (((o.text = e), t))
      for (r in c)
        (i = t[r] || (t.getAttribute && t.getAttribute(r))) &&
          o.setAttribute(r, i);
    n.head.appendChild(o).parentNode.removeChild(o);
  }
  function w(e) {
    return null == e
      ? e + ""
      : "object" == typeof e || "function" == typeof e
      ? n[o.call(e)] || "object"
      : typeof e;
  }
  var f = "3.5.1",
    S = function (e, t) {
      return new S.fn.init(e, t);
    };
  function p(e) {
    var t = !!e && "length" in e && e.length,
      n = w(e);
    return (
      !m(e) &&
      !x(e) &&
      ("array" === n ||
        0 === t ||
        ("number" == typeof t && 0 < t && t - 1 in e))
    );
  }
  (S.fn = S.prototype = {
    jquery: f,
    constructor: S,
    length: 0,
    toArray: function () {
      return s.call(this);
    },
    get: function (e) {
      return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
    },
    pushStack: function (e) {
      var t = S.merge(this.constructor(), e);
      return (t.prevObject = this), t;
    },
    each: function (e) {
      return S.each(this, e);
    },
    map: function (n) {
      return this.pushStack(
        S.map(this, function (e, t) {
          return n.call(e, t, e);
        })
      );
    },
    slice: function () {
      return this.pushStack(s.apply(this, arguments));
    },
    first: function () {
      return this.eq(0);
    },
    last: function () {
      return this.eq(-1);
    },
    even: function () {
      return this.pushStack(
        S.grep(this, function (e, t) {
          return (t + 1) % 2;
        })
      );
    },
    odd: function () {
      return this.pushStack(
        S.grep(this, function (e, t) {
          return t % 2;
        })
      );
    },
    eq: function (e) {
      var t = this.length,
        n = +e + (e < 0 ? t : 0);
      return this.pushStack(0 <= n && n < t ? [this[n]] : []);
    },
    end: function () {
      return this.prevObject || this.constructor();
    },
    push: u,
    sort: t.sort,
    splice: t.splice,
  }),
    (S.extend = S.fn.extend = function () {
      var e,
        t,
        n,
        r,
        i,
        o,
        a = arguments[0] || {},
        s = 1,
        u = arguments.length,
        l = !1;
      for (
        "boolean" == typeof a && ((l = a), (a = arguments[s] || {}), s++),
          "object" == typeof a || m(a) || (a = {}),
          s === u && ((a = this), s--);
        s < u;
        s++
      )
        if (null != (e = arguments[s]))
          for (t in e)
            (r = e[t]),
              "__proto__" !== t &&
                a !== r &&
                (l && r && (S.isPlainObject(r) || (i = Array.isArray(r)))
                  ? ((n = a[t]),
                    (o =
                      i && !Array.isArray(n)
                        ? []
                        : i || S.isPlainObject(n)
                        ? n
                        : {}),
                    (i = !1),
                    (a[t] = S.extend(l, o, r)))
                  : void 0 !== r && (a[t] = r));
      return a;
    }),
    S.extend({
      expando: "jQuery" + (f + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, n;
        return (
          !(!e || "[object Object]" !== o.call(e)) &&
          (!(t = r(e)) ||
            ("function" ==
              typeof (n = v.call(t, "constructor") && t.constructor) &&
              a.call(n) === l))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e, t, n) {
        b(e, { nonce: t && t.nonce }, n);
      },
      each: function (e, t) {
        var n,
          r = 0;
        if (p(e)) {
          for (n = e.length; r < n; r++)
            if (!1 === t.call(e[r], r, e[r])) break;
        } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
        return e;
      },
      makeArray: function (e, t) {
        var n = t || [];
        return (
          null != e &&
            (p(Object(e))
              ? S.merge(n, "string" == typeof e ? [e] : e)
              : u.call(n, e)),
          n
        );
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : i.call(t, e, n);
      },
      merge: function (e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
        return (e.length = i), e;
      },
      grep: function (e, t, n) {
        for (var r = [], i = 0, o = e.length, a = !n; i < o; i++)
          !t(e[i], i) !== a && r.push(e[i]);
        return r;
      },
      map: function (e, t, n) {
        var r,
          i,
          o = 0,
          a = [];
        if (p(e))
          for (r = e.length; o < r; o++)
            null != (i = t(e[o], o, n)) && a.push(i);
        else for (o in e) null != (i = t(e[o], o, n)) && a.push(i);
        return g(a);
      },
      guid: 1,
      support: y,
    }),
    "function" == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]),
    S.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (e, t) {
        n["[object " + t + "]"] = t.toLowerCase();
      }
    );
  var d = (function (n) {
    var e,
      d,
      b,
      o,
      i,
      h,
      f,
      g,
      w,
      u,
      l,
      T,
      C,
      a,
      E,
      v,
      s,
      c,
      y,
      S = "sizzle" + 1 * new Date(),
      p = n.document,
      k = 0,
      r = 0,
      m = ue(),
      x = ue(),
      A = ue(),
      N = ue(),
      D = function (e, t) {
        return e === t && (l = !0), 0;
      },
      j = {}.hasOwnProperty,
      t = [],
      q = t.pop,
      L = t.push,
      H = t.push,
      O = t.slice,
      P = function (e, t) {
        for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
        return -1;
      },
      R =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      M = "[\\x20\\t\\r\\n\\f]",
      I =
        "(?:\\\\[\\da-fA-F]{1,6}" +
        M +
        "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
      W =
        "\\[" +
        M +
        "*(" +
        I +
        ")(?:" +
        M +
        "*([*^$|!~]?=)" +
        M +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        I +
        "))|)" +
        M +
        "*\\]",
      F =
        ":(" +
        I +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        W +
        ")*)|.*)\\)|)",
      B = new RegExp(M + "+", "g"),
      $ = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
      _ = new RegExp("^" + M + "*," + M + "*"),
      z = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
      U = new RegExp(M + "|>"),
      X = new RegExp(F),
      V = new RegExp("^" + I + "$"),
      G = {
        ID: new RegExp("^#(" + I + ")"),
        CLASS: new RegExp("^\\.(" + I + ")"),
        TAG: new RegExp("^(" + I + "|[*])"),
        ATTR: new RegExp("^" + W),
        PSEUDO: new RegExp("^" + F),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            M +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            M +
            "*(?:([+-]|)" +
            M +
            "*(\\d+)|))" +
            M +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + R + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            M +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            M +
            "*((?:-\\d)?\\d*)" +
            M +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      Y = /HTML$/i,
      Q = /^(?:input|select|textarea|button)$/i,
      J = /^h\d$/i,
      K = /^[^{]+\{\s*\[native \w/,
      Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      ee = /[+~]/,
      te = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"),
      ne = function (e, t) {
        var n = "0x" + e.slice(1) - 65536;
        return (
          t ||
          (n < 0
            ? String.fromCharCode(n + 65536)
            : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
        );
      },
      re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      ie = function (e, t) {
        return t
          ? "\0" === e
            ? "\ufffd"
            : e.slice(0, -1) +
              "\\" +
              e.charCodeAt(e.length - 1).toString(16) +
              " "
          : "\\" + e;
      },
      oe = function () {
        T();
      },
      ae = be(
        function (e) {
          return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
        },
        { dir: "parentNode", next: "legend" }
      );
    try {
      H.apply((t = O.call(p.childNodes)), p.childNodes),
        t[p.childNodes.length].nodeType;
    } catch (e) {
      H = {
        apply: t.length
          ? function (e, t) {
              L.apply(e, O.call(t));
            }
          : function (e, t) {
              var n = e.length,
                r = 0;
              while ((e[n++] = t[r++]));
              e.length = n - 1;
            },
      };
    }
    function se(t, e, n, r) {
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f = e && e.ownerDocument,
        p = e ? e.nodeType : 9;
      if (
        ((n = n || []),
        "string" != typeof t || !t || (1 !== p && 9 !== p && 11 !== p))
      )
        return n;
      if (!r && (T(e), (e = e || C), E)) {
        if (11 !== p && (u = Z.exec(t)))
          if ((i = u[1])) {
            if (9 === p) {
              if (!(a = e.getElementById(i))) return n;
              if (a.id === i) return n.push(a), n;
            } else if (f && (a = f.getElementById(i)) && y(e, a) && a.id === i)
              return n.push(a), n;
          } else {
            if (u[2]) return H.apply(n, e.getElementsByTagName(t)), n;
            if (
              (i = u[3]) &&
              d.getElementsByClassName &&
              e.getElementsByClassName
            )
              return H.apply(n, e.getElementsByClassName(i)), n;
          }
        if (
          d.qsa &&
          !N[t + " "] &&
          (!v || !v.test(t)) &&
          (1 !== p || "object" !== e.nodeName.toLowerCase())
        ) {
          if (((c = t), (f = e), 1 === p && (U.test(t) || z.test(t)))) {
            ((f = (ee.test(t) && ye(e.parentNode)) || e) === e && d.scope) ||
              ((s = e.getAttribute("id"))
                ? (s = s.replace(re, ie))
                : e.setAttribute("id", (s = S))),
              (o = (l = h(t)).length);
            while (o--) l[o] = (s ? "#" + s : ":scope") + " " + xe(l[o]);
            c = l.join(",");
          }
          try {
            return H.apply(n, f.querySelectorAll(c)), n;
          } catch (e) {
            N(t, !0);
          } finally {
            s === S && e.removeAttribute("id");
          }
        }
      }
      return g(t.replace($, "$1"), e, n, r);
    }
    function ue() {
      var r = [];
      return function e(t, n) {
        return (
          r.push(t + " ") > b.cacheLength && delete e[r.shift()],
          (e[t + " "] = n)
        );
      };
    }
    function le(e) {
      return (e[S] = !0), e;
    }
    function ce(e) {
      var t = C.createElement("fieldset");
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function fe(e, t) {
      var n = e.split("|"),
        r = n.length;
      while (r--) b.attrHandle[n[r]] = t;
    }
    function pe(e, t) {
      var n = t && e,
        r =
          n &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          e.sourceIndex - t.sourceIndex;
      if (r) return r;
      if (n) while ((n = n.nextSibling)) if (n === t) return -1;
      return e ? 1 : -1;
    }
    function de(t) {
      return function (e) {
        return "input" === e.nodeName.toLowerCase() && e.type === t;
      };
    }
    function he(n) {
      return function (e) {
        var t = e.nodeName.toLowerCase();
        return ("input" === t || "button" === t) && e.type === n;
      };
    }
    function ge(t) {
      return function (e) {
        return "form" in e
          ? e.parentNode && !1 === e.disabled
            ? "label" in e
              ? "label" in e.parentNode
                ? e.parentNode.disabled === t
                : e.disabled === t
              : e.isDisabled === t || (e.isDisabled !== !t && ae(e) === t)
            : e.disabled === t
          : "label" in e && e.disabled === t;
      };
    }
    function ve(a) {
      return le(function (o) {
        return (
          (o = +o),
          le(function (e, t) {
            var n,
              r = a([], e.length, o),
              i = r.length;
            while (i--) e[(n = r[i])] && (e[n] = !(t[n] = e[n]));
          })
        );
      });
    }
    function ye(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e;
    }
    for (e in ((d = se.support = {}),
    (i = se.isXML = function (e) {
      var t = e.namespaceURI,
        n = (e.ownerDocument || e).documentElement;
      return !Y.test(t || (n && n.nodeName) || "HTML");
    }),
    (T = se.setDocument = function (e) {
      var t,
        n,
        r = e ? e.ownerDocument || e : p;
      return (
        r != C &&
          9 === r.nodeType &&
          r.documentElement &&
          ((a = (C = r).documentElement),
          (E = !i(C)),
          p != C &&
            (n = C.defaultView) &&
            n.top !== n &&
            (n.addEventListener
              ? n.addEventListener("unload", oe, !1)
              : n.attachEvent && n.attachEvent("onunload", oe)),
          (d.scope = ce(function (e) {
            return (
              a.appendChild(e).appendChild(C.createElement("div")),
              "undefined" != typeof e.querySelectorAll &&
                !e.querySelectorAll(":scope fieldset div").length
            );
          })),
          (d.attributes = ce(function (e) {
            return (e.className = "i"), !e.getAttribute("className");
          })),
          (d.getElementsByTagName = ce(function (e) {
            return (
              e.appendChild(C.createComment("")),
              !e.getElementsByTagName("*").length
            );
          })),
          (d.getElementsByClassName = K.test(C.getElementsByClassName)),
          (d.getById = ce(function (e) {
            return (
              (a.appendChild(e).id = S),
              !C.getElementsByName || !C.getElementsByName(S).length
            );
          })),
          d.getById
            ? ((b.filter.ID = function (e) {
                var t = e.replace(te, ne);
                return function (e) {
                  return e.getAttribute("id") === t;
                };
              }),
              (b.find.ID = function (e, t) {
                if ("undefined" != typeof t.getElementById && E) {
                  var n = t.getElementById(e);
                  return n ? [n] : [];
                }
              }))
            : ((b.filter.ID = function (e) {
                var n = e.replace(te, ne);
                return function (e) {
                  var t =
                    "undefined" != typeof e.getAttributeNode &&
                    e.getAttributeNode("id");
                  return t && t.value === n;
                };
              }),
              (b.find.ID = function (e, t) {
                if ("undefined" != typeof t.getElementById && E) {
                  var n,
                    r,
                    i,
                    o = t.getElementById(e);
                  if (o) {
                    if ((n = o.getAttributeNode("id")) && n.value === e)
                      return [o];
                    (i = t.getElementsByName(e)), (r = 0);
                    while ((o = i[r++]))
                      if ((n = o.getAttributeNode("id")) && n.value === e)
                        return [o];
                  }
                  return [];
                }
              })),
          (b.find.TAG = d.getElementsByTagName
            ? function (e, t) {
                return "undefined" != typeof t.getElementsByTagName
                  ? t.getElementsByTagName(e)
                  : d.qsa
                  ? t.querySelectorAll(e)
                  : void 0;
              }
            : function (e, t) {
                var n,
                  r = [],
                  i = 0,
                  o = t.getElementsByTagName(e);
                if ("*" === e) {
                  while ((n = o[i++])) 1 === n.nodeType && r.push(n);
                  return r;
                }
                return o;
              }),
          (b.find.CLASS =
            d.getElementsByClassName &&
            function (e, t) {
              if ("undefined" != typeof t.getElementsByClassName && E)
                return t.getElementsByClassName(e);
            }),
          (s = []),
          (v = []),
          (d.qsa = K.test(C.querySelectorAll)) &&
            (ce(function (e) {
              var t;
              (a.appendChild(e).innerHTML =
                "<a id='" +
                S +
                "'></a><select id='" +
                S +
                "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                e.querySelectorAll("[msallowcapture^='']").length &&
                  v.push("[*^$]=" + M + "*(?:''|\"\")"),
                e.querySelectorAll("[selected]").length ||
                  v.push("\\[" + M + "*(?:value|" + R + ")"),
                e.querySelectorAll("[id~=" + S + "-]").length || v.push("~="),
                (t = C.createElement("input")).setAttribute("name", ""),
                e.appendChild(t),
                e.querySelectorAll("[name='']").length ||
                  v.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"),
                e.querySelectorAll(":checked").length || v.push(":checked"),
                e.querySelectorAll("a#" + S + "+*").length ||
                  v.push(".#.+[+~]"),
                e.querySelectorAll("\\\f"),
                v.push("[\\r\\n\\f]");
            }),
            ce(function (e) {
              e.innerHTML =
                "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
              var t = C.createElement("input");
              t.setAttribute("type", "hidden"),
                e.appendChild(t).setAttribute("name", "D"),
                e.querySelectorAll("[name=d]").length &&
                  v.push("name" + M + "*[*^$|!~]?="),
                2 !== e.querySelectorAll(":enabled").length &&
                  v.push(":enabled", ":disabled"),
                (a.appendChild(e).disabled = !0),
                2 !== e.querySelectorAll(":disabled").length &&
                  v.push(":enabled", ":disabled"),
                e.querySelectorAll("*,:x"),
                v.push(",.*:");
            })),
          (d.matchesSelector = K.test(
            (c =
              a.matches ||
              a.webkitMatchesSelector ||
              a.mozMatchesSelector ||
              a.oMatchesSelector ||
              a.msMatchesSelector)
          )) &&
            ce(function (e) {
              (d.disconnectedMatch = c.call(e, "*")),
                c.call(e, "[s!='']:x"),
                s.push("!=", F);
            }),
          (v = v.length && new RegExp(v.join("|"))),
          (s = s.length && new RegExp(s.join("|"))),
          (t = K.test(a.compareDocumentPosition)),
          (y =
            t || K.test(a.contains)
              ? function (e, t) {
                  var n = 9 === e.nodeType ? e.documentElement : e,
                    r = t && t.parentNode;
                  return (
                    e === r ||
                    !(
                      !r ||
                      1 !== r.nodeType ||
                      !(n.contains
                        ? n.contains(r)
                        : e.compareDocumentPosition &&
                          16 & e.compareDocumentPosition(r))
                    )
                  );
                }
              : function (e, t) {
                  if (t) while ((t = t.parentNode)) if (t === e) return !0;
                  return !1;
                }),
          (D = t
            ? function (e, t) {
                if (e === t) return (l = !0), 0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return (
                  n ||
                  (1 &
                    (n =
                      (e.ownerDocument || e) == (t.ownerDocument || t)
                        ? e.compareDocumentPosition(t)
                        : 1) ||
                  (!d.sortDetached && t.compareDocumentPosition(e) === n)
                    ? e == C || (e.ownerDocument == p && y(p, e))
                      ? -1
                      : t == C || (t.ownerDocument == p && y(p, t))
                      ? 1
                      : u
                      ? P(u, e) - P(u, t)
                      : 0
                    : 4 & n
                    ? -1
                    : 1)
                );
              }
            : function (e, t) {
                if (e === t) return (l = !0), 0;
                var n,
                  r = 0,
                  i = e.parentNode,
                  o = t.parentNode,
                  a = [e],
                  s = [t];
                if (!i || !o)
                  return e == C
                    ? -1
                    : t == C
                    ? 1
                    : i
                    ? -1
                    : o
                    ? 1
                    : u
                    ? P(u, e) - P(u, t)
                    : 0;
                if (i === o) return pe(e, t);
                n = e;
                while ((n = n.parentNode)) a.unshift(n);
                n = t;
                while ((n = n.parentNode)) s.unshift(n);
                while (a[r] === s[r]) r++;
                return r ? pe(a[r], s[r]) : a[r] == p ? -1 : s[r] == p ? 1 : 0;
              })),
        C
      );
    }),
    (se.matches = function (e, t) {
      return se(e, null, null, t);
    }),
    (se.matchesSelector = function (e, t) {
      if (
        (T(e),
        d.matchesSelector &&
          E &&
          !N[t + " "] &&
          (!s || !s.test(t)) &&
          (!v || !v.test(t)))
      )
        try {
          var n = c.call(e, t);
          if (
            n ||
            d.disconnectedMatch ||
            (e.document && 11 !== e.document.nodeType)
          )
            return n;
        } catch (e) {
          N(t, !0);
        }
      return 0 < se(t, C, null, [e]).length;
    }),
    (se.contains = function (e, t) {
      return (e.ownerDocument || e) != C && T(e), y(e, t);
    }),
    (se.attr = function (e, t) {
      (e.ownerDocument || e) != C && T(e);
      var n = b.attrHandle[t.toLowerCase()],
        r = n && j.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !E) : void 0;
      return void 0 !== r
        ? r
        : d.attributes || !E
        ? e.getAttribute(t)
        : (r = e.getAttributeNode(t)) && r.specified
        ? r.value
        : null;
    }),
    (se.escape = function (e) {
      return (e + "").replace(re, ie);
    }),
    (se.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }),
    (se.uniqueSort = function (e) {
      var t,
        n = [],
        r = 0,
        i = 0;
      if (
        ((l = !d.detectDuplicates),
        (u = !d.sortStable && e.slice(0)),
        e.sort(D),
        l)
      ) {
        while ((t = e[i++])) t === e[i] && (r = n.push(i));
        while (r--) e.splice(n[r], 1);
      }
      return (u = null), e;
    }),
    (o = se.getText = function (e) {
      var t,
        n = "",
        r = 0,
        i = e.nodeType;
      if (i) {
        if (1 === i || 9 === i || 11 === i) {
          if ("string" == typeof e.textContent) return e.textContent;
          for (e = e.firstChild; e; e = e.nextSibling) n += o(e);
        } else if (3 === i || 4 === i) return e.nodeValue;
      } else while ((t = e[r++])) n += o(t);
      return n;
    }),
    ((b = se.selectors = {
      cacheLength: 50,
      createPseudo: le,
      match: G,
      attrHandle: {},
      find: {},
      relative: {
        ">": { dir: "parentNode", first: !0 },
        " ": { dir: "parentNode" },
        "+": { dir: "previousSibling", first: !0 },
        "~": { dir: "previousSibling" },
      },
      preFilter: {
        ATTR: function (e) {
          return (
            (e[1] = e[1].replace(te, ne)),
            (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
            "~=" === e[2] && (e[3] = " " + e[3] + " "),
            e.slice(0, 4)
          );
        },
        CHILD: function (e) {
          return (
            (e[1] = e[1].toLowerCase()),
            "nth" === e[1].slice(0, 3)
              ? (e[3] || se.error(e[0]),
                (e[4] = +(e[4]
                  ? e[5] + (e[6] || 1)
                  : 2 * ("even" === e[3] || "odd" === e[3]))),
                (e[5] = +(e[7] + e[8] || "odd" === e[3])))
              : e[3] && se.error(e[0]),
            e
          );
        },
        PSEUDO: function (e) {
          var t,
            n = !e[6] && e[2];
          return G.CHILD.test(e[0])
            ? null
            : (e[3]
                ? (e[2] = e[4] || e[5] || "")
                : n &&
                  X.test(n) &&
                  (t = h(n, !0)) &&
                  (t = n.indexOf(")", n.length - t) - n.length) &&
                  ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
              e.slice(0, 3));
        },
      },
      filter: {
        TAG: function (e) {
          var t = e.replace(te, ne).toLowerCase();
          return "*" === e
            ? function () {
                return !0;
              }
            : function (e) {
                return e.nodeName && e.nodeName.toLowerCase() === t;
              };
        },
        CLASS: function (e) {
          var t = m[e + " "];
          return (
            t ||
            ((t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) &&
              m(e, function (e) {
                return t.test(
                  ("string" == typeof e.className && e.className) ||
                    ("undefined" != typeof e.getAttribute &&
                      e.getAttribute("class")) ||
                    ""
                );
              }))
          );
        },
        ATTR: function (n, r, i) {
          return function (e) {
            var t = se.attr(e, n);
            return null == t
              ? "!=" === r
              : !r ||
                  ((t += ""),
                  "=" === r
                    ? t === i
                    : "!=" === r
                    ? t !== i
                    : "^=" === r
                    ? i && 0 === t.indexOf(i)
                    : "*=" === r
                    ? i && -1 < t.indexOf(i)
                    : "$=" === r
                    ? i && t.slice(-i.length) === i
                    : "~=" === r
                    ? -1 < (" " + t.replace(B, " ") + " ").indexOf(i)
                    : "|=" === r &&
                      (t === i || t.slice(0, i.length + 1) === i + "-"));
          };
        },
        CHILD: function (h, e, t, g, v) {
          var y = "nth" !== h.slice(0, 3),
            m = "last" !== h.slice(-4),
            x = "of-type" === e;
          return 1 === g && 0 === v
            ? function (e) {
                return !!e.parentNode;
              }
            : function (e, t, n) {
                var r,
                  i,
                  o,
                  a,
                  s,
                  u,
                  l = y !== m ? "nextSibling" : "previousSibling",
                  c = e.parentNode,
                  f = x && e.nodeName.toLowerCase(),
                  p = !n && !x,
                  d = !1;
                if (c) {
                  if (y) {
                    while (l) {
                      a = e;
                      while ((a = a[l]))
                        if (
                          x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType
                        )
                          return !1;
                      u = l = "only" === h && !u && "nextSibling";
                    }
                    return !0;
                  }
                  if (((u = [m ? c.firstChild : c.lastChild]), m && p)) {
                    (d =
                      (s =
                        (r =
                          (i =
                            (o = (a = c)[S] || (a[S] = {}))[a.uniqueID] ||
                            (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]) &&
                      r[2]),
                      (a = s && c.childNodes[s]);
                    while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                      if (1 === a.nodeType && ++d && a === e) {
                        i[h] = [k, s, d];
                        break;
                      }
                  } else if (
                    (p &&
                      (d = s =
                        (r =
                          (i =
                            (o = (a = e)[S] || (a[S] = {}))[a.uniqueID] ||
                            (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]),
                    !1 === d)
                  )
                    while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                      if (
                        (x
                          ? a.nodeName.toLowerCase() === f
                          : 1 === a.nodeType) &&
                        ++d &&
                        (p &&
                          ((i =
                            (o = a[S] || (a[S] = {}))[a.uniqueID] ||
                            (o[a.uniqueID] = {}))[h] = [k, d]),
                        a === e)
                      )
                        break;
                  return (d -= v) === g || (d % g == 0 && 0 <= d / g);
                }
              };
        },
        PSEUDO: function (e, o) {
          var t,
            a =
              b.pseudos[e] ||
              b.setFilters[e.toLowerCase()] ||
              se.error("unsupported pseudo: " + e);
          return a[S]
            ? a(o)
            : 1 < a.length
            ? ((t = [e, e, "", o]),
              b.setFilters.hasOwnProperty(e.toLowerCase())
                ? le(function (e, t) {
                    var n,
                      r = a(e, o),
                      i = r.length;
                    while (i--) e[(n = P(e, r[i]))] = !(t[n] = r[i]);
                  })
                : function (e) {
                    return a(e, 0, t);
                  })
            : a;
        },
      },
      pseudos: {
        not: le(function (e) {
          var r = [],
            i = [],
            s = f(e.replace($, "$1"));
          return s[S]
            ? le(function (e, t, n, r) {
                var i,
                  o = s(e, null, r, []),
                  a = e.length;
                while (a--) (i = o[a]) && (e[a] = !(t[a] = i));
              })
            : function (e, t, n) {
                return (r[0] = e), s(r, null, n, i), (r[0] = null), !i.pop();
              };
        }),
        has: le(function (t) {
          return function (e) {
            return 0 < se(t, e).length;
          };
        }),
        contains: le(function (t) {
          return (
            (t = t.replace(te, ne)),
            function (e) {
              return -1 < (e.textContent || o(e)).indexOf(t);
            }
          );
        }),
        lang: le(function (n) {
          return (
            V.test(n || "") || se.error("unsupported lang: " + n),
            (n = n.replace(te, ne).toLowerCase()),
            function (e) {
              var t;
              do {
                if (
                  (t = E
                    ? e.lang
                    : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                )
                  return (
                    (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-")
                  );
              } while ((e = e.parentNode) && 1 === e.nodeType);
              return !1;
            }
          );
        }),
        target: function (e) {
          var t = n.location && n.location.hash;
          return t && t.slice(1) === e.id;
        },
        root: function (e) {
          return e === a;
        },
        focus: function (e) {
          return (
            e === C.activeElement &&
            (!C.hasFocus || C.hasFocus()) &&
            !!(e.type || e.href || ~e.tabIndex)
          );
        },
        enabled: ge(!1),
        disabled: ge(!0),
        checked: function (e) {
          var t = e.nodeName.toLowerCase();
          return (
            ("input" === t && !!e.checked) || ("option" === t && !!e.selected)
          );
        },
        selected: function (e) {
          return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
        },
        empty: function (e) {
          for (e = e.firstChild; e; e = e.nextSibling)
            if (e.nodeType < 6) return !1;
          return !0;
        },
        parent: function (e) {
          return !b.pseudos.empty(e);
        },
        header: function (e) {
          return J.test(e.nodeName);
        },
        input: function (e) {
          return Q.test(e.nodeName);
        },
        button: function (e) {
          var t = e.nodeName.toLowerCase();
          return ("input" === t && "button" === e.type) || "button" === t;
        },
        text: function (e) {
          var t;
          return (
            "input" === e.nodeName.toLowerCase() &&
            "text" === e.type &&
            (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
          );
        },
        first: ve(function () {
          return [0];
        }),
        last: ve(function (e, t) {
          return [t - 1];
        }),
        eq: ve(function (e, t, n) {
          return [n < 0 ? n + t : n];
        }),
        even: ve(function (e, t) {
          for (var n = 0; n < t; n += 2) e.push(n);
          return e;
        }),
        odd: ve(function (e, t) {
          for (var n = 1; n < t; n += 2) e.push(n);
          return e;
        }),
        lt: ve(function (e, t, n) {
          for (var r = n < 0 ? n + t : t < n ? t : n; 0 <= --r; ) e.push(r);
          return e;
        }),
        gt: ve(function (e, t, n) {
          for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
          return e;
        }),
      },
    }).pseudos.nth = b.pseudos.eq),
    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
      b.pseudos[e] = de(e);
    for (e in { submit: !0, reset: !0 }) b.pseudos[e] = he(e);
    function me() {}
    function xe(e) {
      for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
      return r;
    }
    function be(s, e, t) {
      var u = e.dir,
        l = e.next,
        c = l || u,
        f = t && "parentNode" === c,
        p = r++;
      return e.first
        ? function (e, t, n) {
            while ((e = e[u])) if (1 === e.nodeType || f) return s(e, t, n);
            return !1;
          }
        : function (e, t, n) {
            var r,
              i,
              o,
              a = [k, p];
            if (n) {
              while ((e = e[u]))
                if ((1 === e.nodeType || f) && s(e, t, n)) return !0;
            } else
              while ((e = e[u]))
                if (1 === e.nodeType || f)
                  if (
                    ((i =
                      (o = e[S] || (e[S] = {}))[e.uniqueID] ||
                      (o[e.uniqueID] = {})),
                    l && l === e.nodeName.toLowerCase())
                  )
                    e = e[u] || e;
                  else {
                    if ((r = i[c]) && r[0] === k && r[1] === p)
                      return (a[2] = r[2]);
                    if (((i[c] = a)[2] = s(e, t, n))) return !0;
                  }
            return !1;
          };
    }
    function we(i) {
      return 1 < i.length
        ? function (e, t, n) {
            var r = i.length;
            while (r--) if (!i[r](e, t, n)) return !1;
            return !0;
          }
        : i[0];
    }
    function Te(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
        (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
      return a;
    }
    function Ce(d, h, g, v, y, e) {
      return (
        v && !v[S] && (v = Ce(v)),
        y && !y[S] && (y = Ce(y, e)),
        le(function (e, t, n, r) {
          var i,
            o,
            a,
            s = [],
            u = [],
            l = t.length,
            c =
              e ||
              (function (e, t, n) {
                for (var r = 0, i = t.length; r < i; r++) se(e, t[r], n);
                return n;
              })(h || "*", n.nodeType ? [n] : n, []),
            f = !d || (!e && h) ? c : Te(c, s, d, n, r),
            p = g ? (y || (e ? d : l || v) ? [] : t) : f;
          if ((g && g(f, p, n, r), v)) {
            (i = Te(p, u)), v(i, [], n, r), (o = i.length);
            while (o--) (a = i[o]) && (p[u[o]] = !(f[u[o]] = a));
          }
          if (e) {
            if (y || d) {
              if (y) {
                (i = []), (o = p.length);
                while (o--) (a = p[o]) && i.push((f[o] = a));
                y(null, (p = []), i, r);
              }
              o = p.length;
              while (o--)
                (a = p[o]) &&
                  -1 < (i = y ? P(e, a) : s[o]) &&
                  (e[i] = !(t[i] = a));
            }
          } else (p = Te(p === t ? p.splice(l, p.length) : p)), y ? y(null, t, p, r) : H.apply(t, p);
        })
      );
    }
    function Ee(e) {
      for (
        var i,
          t,
          n,
          r = e.length,
          o = b.relative[e[0].type],
          a = o || b.relative[" "],
          s = o ? 1 : 0,
          u = be(
            function (e) {
              return e === i;
            },
            a,
            !0
          ),
          l = be(
            function (e) {
              return -1 < P(i, e);
            },
            a,
            !0
          ),
          c = [
            function (e, t, n) {
              var r =
                (!o && (n || t !== w)) ||
                ((i = t).nodeType ? u(e, t, n) : l(e, t, n));
              return (i = null), r;
            },
          ];
        s < r;
        s++
      )
        if ((t = b.relative[e[s].type])) c = [be(we(c), t)];
        else {
          if ((t = b.filter[e[s].type].apply(null, e[s].matches))[S]) {
            for (n = ++s; n < r; n++) if (b.relative[e[n].type]) break;
            return Ce(
              1 < s && we(c),
              1 < s &&
                xe(
                  e
                    .slice(0, s - 1)
                    .concat({ value: " " === e[s - 2].type ? "*" : "" })
                ).replace($, "$1"),
              t,
              s < n && Ee(e.slice(s, n)),
              n < r && Ee((e = e.slice(n))),
              n < r && xe(e)
            );
          }
          c.push(t);
        }
      return we(c);
    }
    return (
      (me.prototype = b.filters = b.pseudos),
      (b.setFilters = new me()),
      (h = se.tokenize = function (e, t) {
        var n,
          r,
          i,
          o,
          a,
          s,
          u,
          l = x[e + " "];
        if (l) return t ? 0 : l.slice(0);
        (a = e), (s = []), (u = b.preFilter);
        while (a) {
          for (o in ((n && !(r = _.exec(a))) ||
            (r && (a = a.slice(r[0].length) || a), s.push((i = []))),
          (n = !1),
          (r = z.exec(a)) &&
            ((n = r.shift()),
            i.push({ value: n, type: r[0].replace($, " ") }),
            (a = a.slice(n.length))),
          b.filter))
            !(r = G[o].exec(a)) ||
              (u[o] && !(r = u[o](r))) ||
              ((n = r.shift()),
              i.push({ value: n, type: o, matches: r }),
              (a = a.slice(n.length)));
          if (!n) break;
        }
        return t ? a.length : a ? se.error(e) : x(e, s).slice(0);
      }),
      (f = se.compile = function (e, t) {
        var n,
          v,
          y,
          m,
          x,
          r,
          i = [],
          o = [],
          a = A[e + " "];
        if (!a) {
          t || (t = h(e)), (n = t.length);
          while (n--) (a = Ee(t[n]))[S] ? i.push(a) : o.push(a);
          (a = A(
            e,
            ((v = o),
            (m = 0 < (y = i).length),
            (x = 0 < v.length),
            (r = function (e, t, n, r, i) {
              var o,
                a,
                s,
                u = 0,
                l = "0",
                c = e && [],
                f = [],
                p = w,
                d = e || (x && b.find.TAG("*", i)),
                h = (k += null == p ? 1 : Math.random() || 0.1),
                g = d.length;
              for (
                i && (w = t == C || t || i);
                l !== g && null != (o = d[l]);
                l++
              ) {
                if (x && o) {
                  (a = 0), t || o.ownerDocument == C || (T(o), (n = !E));
                  while ((s = v[a++]))
                    if (s(o, t || C, n)) {
                      r.push(o);
                      break;
                    }
                  i && (k = h);
                }
                m && ((o = !s && o) && u--, e && c.push(o));
              }
              if (((u += l), m && l !== u)) {
                a = 0;
                while ((s = y[a++])) s(c, f, t, n);
                if (e) {
                  if (0 < u) while (l--) c[l] || f[l] || (f[l] = q.call(r));
                  f = Te(f);
                }
                H.apply(r, f),
                  i &&
                    !e &&
                    0 < f.length &&
                    1 < u + y.length &&
                    se.uniqueSort(r);
              }
              return i && ((k = h), (w = p)), c;
            }),
            m ? le(r) : r)
          )).selector = e;
        }
        return a;
      }),
      (g = se.select = function (e, t, n, r) {
        var i,
          o,
          a,
          s,
          u,
          l = "function" == typeof e && e,
          c = !r && h((e = l.selector || e));
        if (((n = n || []), 1 === c.length)) {
          if (
            2 < (o = c[0] = c[0].slice(0)).length &&
            "ID" === (a = o[0]).type &&
            9 === t.nodeType &&
            E &&
            b.relative[o[1].type]
          ) {
            if (!(t = (b.find.ID(a.matches[0].replace(te, ne), t) || [])[0]))
              return n;
            l && (t = t.parentNode), (e = e.slice(o.shift().value.length));
          }
          i = G.needsContext.test(e) ? 0 : o.length;
          while (i--) {
            if (((a = o[i]), b.relative[(s = a.type)])) break;
            if (
              (u = b.find[s]) &&
              (r = u(
                a.matches[0].replace(te, ne),
                (ee.test(o[0].type) && ye(t.parentNode)) || t
              ))
            ) {
              if ((o.splice(i, 1), !(e = r.length && xe(o))))
                return H.apply(n, r), n;
              break;
            }
          }
        }
        return (
          (l || f(e, c))(
            r,
            t,
            !E,
            n,
            !t || (ee.test(e) && ye(t.parentNode)) || t
          ),
          n
        );
      }),
      (d.sortStable = S.split("").sort(D).join("") === S),
      (d.detectDuplicates = !!l),
      T(),
      (d.sortDetached = ce(function (e) {
        return 1 & e.compareDocumentPosition(C.createElement("fieldset"));
      })),
      ce(function (e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          "#" === e.firstChild.getAttribute("href")
        );
      }) ||
        fe("type|href|height|width", function (e, t, n) {
          if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }),
      (d.attributes &&
        ce(function (e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          );
        })) ||
        fe("value", function (e, t, n) {
          if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      ce(function (e) {
        return null == e.getAttribute("disabled");
      }) ||
        fe(R, function (e, t, n) {
          var r;
          if (!n)
            return !0 === e[t]
              ? t.toLowerCase()
              : (r = e.getAttributeNode(t)) && r.specified
              ? r.value
              : null;
        }),
      se
    );
  })(C);
  (S.find = d),
    (S.expr = d.selectors),
    (S.expr[":"] = S.expr.pseudos),
    (S.uniqueSort = S.unique = d.uniqueSort),
    (S.text = d.getText),
    (S.isXMLDoc = d.isXML),
    (S.contains = d.contains),
    (S.escapeSelector = d.escape);
  var h = function (e, t, n) {
      var r = [],
        i = void 0 !== n;
      while ((e = e[t]) && 9 !== e.nodeType)
        if (1 === e.nodeType) {
          if (i && S(e).is(n)) break;
          r.push(e);
        }
      return r;
    },
    T = function (e, t) {
      for (var n = []; e; e = e.nextSibling)
        1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    k = S.expr.match.needsContext;
  function A(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function D(e, n, r) {
    return m(n)
      ? S.grep(e, function (e, t) {
          return !!n.call(e, t, e) !== r;
        })
      : n.nodeType
      ? S.grep(e, function (e) {
          return (e === n) !== r;
        })
      : "string" != typeof n
      ? S.grep(e, function (e) {
          return -1 < i.call(n, e) !== r;
        })
      : S.filter(n, e, r);
  }
  (S.filter = function (e, t, n) {
    var r = t[0];
    return (
      n && (e = ":not(" + e + ")"),
      1 === t.length && 1 === r.nodeType
        ? S.find.matchesSelector(r, e)
          ? [r]
          : []
        : S.find.matches(
            e,
            S.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    S.fn.extend({
      find: function (e) {
        var t,
          n,
          r = this.length,
          i = this;
        if ("string" != typeof e)
          return this.pushStack(
            S(e).filter(function () {
              for (t = 0; t < r; t++) if (S.contains(i[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < r; t++) S.find(e, i[t], n);
        return 1 < r ? S.uniqueSort(n) : n;
      },
      filter: function (e) {
        return this.pushStack(D(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(D(this, e || [], !0));
      },
      is: function (e) {
        return !!D(this, "string" == typeof e && k.test(e) ? S(e) : e || [], !1)
          .length;
      },
    });
  var j,
    q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((S.fn.init = function (e, t, n) {
    var r, i;
    if (!e) return this;
    if (((n = n || j), "string" == typeof e)) {
      if (
        !(r =
          "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length
            ? [null, e, null]
            : q.exec(e)) ||
        (!r[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (r[1]) {
        if (
          ((t = t instanceof S ? t[0] : t),
          S.merge(
            this,
            S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : E, !0)
          ),
          N.test(r[1]) && S.isPlainObject(t))
        )
          for (r in t) m(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
        return this;
      }
      return (
        (i = E.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this
      );
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : m(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(S)
      : S.makeArray(e, this);
  }).prototype = S.fn),
    (j = S(E));
  var L = /^(?:parents|prev(?:Until|All))/,
    H = { children: !0, contents: !0, next: !0, prev: !0 };
  function O(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType);
    return e;
  }
  S.fn.extend({
    has: function (e) {
      var t = S(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (S.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var n,
        r = 0,
        i = this.length,
        o = [],
        a = "string" != typeof e && S(e);
      if (!k.test(e))
        for (; r < i; r++)
          for (n = this[r]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (a
                ? -1 < a.index(n)
                : 1 === n.nodeType && S.find.matchesSelector(n, e))
            ) {
              o.push(n);
              break;
            }
      return this.pushStack(1 < o.length ? S.uniqueSort(o) : o);
    },
    index: function (e) {
      return e
        ? "string" == typeof e
          ? i.call(S(e), this[0])
          : i.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    S.each(
      {
        parent: function (e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function (e) {
          return h(e, "parentNode");
        },
        parentsUntil: function (e, t, n) {
          return h(e, "parentNode", n);
        },
        next: function (e) {
          return O(e, "nextSibling");
        },
        prev: function (e) {
          return O(e, "previousSibling");
        },
        nextAll: function (e) {
          return h(e, "nextSibling");
        },
        prevAll: function (e) {
          return h(e, "previousSibling");
        },
        nextUntil: function (e, t, n) {
          return h(e, "nextSibling", n);
        },
        prevUntil: function (e, t, n) {
          return h(e, "previousSibling", n);
        },
        siblings: function (e) {
          return T((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return T(e.firstChild);
        },
        contents: function (e) {
          return null != e.contentDocument && r(e.contentDocument)
            ? e.contentDocument
            : (A(e, "template") && (e = e.content || e),
              S.merge([], e.childNodes));
        },
      },
      function (r, i) {
        S.fn[r] = function (e, t) {
          var n = S.map(this, i, e);
          return (
            "Until" !== r.slice(-5) && (t = e),
            t && "string" == typeof t && (n = S.filter(t, n)),
            1 < this.length &&
              (H[r] || S.uniqueSort(n), L.test(r) && n.reverse()),
            this.pushStack(n)
          );
        };
      }
    );
  var P = /[^\x20\t\r\n\f]+/g;
  function R(e) {
    return e;
  }
  function M(e) {
    throw e;
  }
  function I(e, t, n, r) {
    var i;
    try {
      e && m((i = e.promise))
        ? i.call(e).done(t).fail(n)
        : e && m((i = e.then))
        ? i.call(e, t, n)
        : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  (S.Callbacks = function (r) {
    var e, n;
    r =
      "string" == typeof r
        ? ((e = r),
          (n = {}),
          S.each(e.match(P) || [], function (e, t) {
            n[t] = !0;
          }),
          n)
        : S.extend({}, r);
    var i,
      t,
      o,
      a,
      s = [],
      u = [],
      l = -1,
      c = function () {
        for (a = a || r.once, o = i = !0; u.length; l = -1) {
          t = u.shift();
          while (++l < s.length)
            !1 === s[l].apply(t[0], t[1]) &&
              r.stopOnFalse &&
              ((l = s.length), (t = !1));
        }
        r.memory || (t = !1), (i = !1), a && (s = t ? [] : "");
      },
      f = {
        add: function () {
          return (
            s &&
              (t && !i && ((l = s.length - 1), u.push(t)),
              (function n(e) {
                S.each(e, function (e, t) {
                  m(t)
                    ? (r.unique && f.has(t)) || s.push(t)
                    : t && t.length && "string" !== w(t) && n(t);
                });
              })(arguments),
              t && !i && c()),
            this
          );
        },
        remove: function () {
          return (
            S.each(arguments, function (e, t) {
              var n;
              while (-1 < (n = S.inArray(t, s, n)))
                s.splice(n, 1), n <= l && l--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? -1 < S.inArray(e, s) : 0 < s.length;
        },
        empty: function () {
          return s && (s = []), this;
        },
        disable: function () {
          return (a = u = []), (s = t = ""), this;
        },
        disabled: function () {
          return !s;
        },
        lock: function () {
          return (a = u = []), t || i || (s = t = ""), this;
        },
        locked: function () {
          return !!a;
        },
        fireWith: function (e, t) {
          return (
            a ||
              ((t = [e, (t = t || []).slice ? t.slice() : t]),
              u.push(t),
              i || c()),
            this
          );
        },
        fire: function () {
          return f.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!o;
        },
      };
    return f;
  }),
    S.extend({
      Deferred: function (e) {
        var o = [
            [
              "notify",
              "progress",
              S.Callbacks("memory"),
              S.Callbacks("memory"),
              2,
            ],
            [
              "resolve",
              "done",
              S.Callbacks("once memory"),
              S.Callbacks("once memory"),
              0,
              "resolved",
            ],
            [
              "reject",
              "fail",
              S.Callbacks("once memory"),
              S.Callbacks("once memory"),
              1,
              "rejected",
            ],
          ],
          i = "pending",
          a = {
            state: function () {
              return i;
            },
            always: function () {
              return s.done(arguments).fail(arguments), this;
            },
            catch: function (e) {
              return a.then(null, e);
            },
            pipe: function () {
              var i = arguments;
              return S.Deferred(function (r) {
                S.each(o, function (e, t) {
                  var n = m(i[t[4]]) && i[t[4]];
                  s[t[1]](function () {
                    var e = n && n.apply(this, arguments);
                    e && m(e.promise)
                      ? e
                          .promise()
                          .progress(r.notify)
                          .done(r.resolve)
                          .fail(r.reject)
                      : r[t[0] + "With"](this, n ? [e] : arguments);
                  });
                }),
                  (i = null);
              }).promise();
            },
            then: function (t, n, r) {
              var u = 0;
              function l(i, o, a, s) {
                return function () {
                  var n = this,
                    r = arguments,
                    e = function () {
                      var e, t;
                      if (!(i < u)) {
                        if ((e = a.apply(n, r)) === o.promise())
                          throw new TypeError("Thenable self-resolution");
                        (t =
                          e &&
                          ("object" == typeof e || "function" == typeof e) &&
                          e.then),
                          m(t)
                            ? s
                              ? t.call(e, l(u, o, R, s), l(u, o, M, s))
                              : (u++,
                                t.call(
                                  e,
                                  l(u, o, R, s),
                                  l(u, o, M, s),
                                  l(u, o, R, o.notifyWith)
                                ))
                            : (a !== R && ((n = void 0), (r = [e])),
                              (s || o.resolveWith)(n, r));
                      }
                    },
                    t = s
                      ? e
                      : function () {
                          try {
                            e();
                          } catch (e) {
                            S.Deferred.exceptionHook &&
                              S.Deferred.exceptionHook(e, t.stackTrace),
                              u <= i + 1 &&
                                (a !== M && ((n = void 0), (r = [e])),
                                o.rejectWith(n, r));
                          }
                        };
                  i
                    ? t()
                    : (S.Deferred.getStackHook &&
                        (t.stackTrace = S.Deferred.getStackHook()),
                      C.setTimeout(t));
                };
              }
              return S.Deferred(function (e) {
                o[0][3].add(l(0, e, m(r) ? r : R, e.notifyWith)),
                  o[1][3].add(l(0, e, m(t) ? t : R)),
                  o[2][3].add(l(0, e, m(n) ? n : M));
              }).promise();
            },
            promise: function (e) {
              return null != e ? S.extend(e, a) : a;
            },
          },
          s = {};
        return (
          S.each(o, function (e, t) {
            var n = t[2],
              r = t[5];
            (a[t[1]] = n.add),
              r &&
                n.add(
                  function () {
                    i = r;
                  },
                  o[3 - e][2].disable,
                  o[3 - e][3].disable,
                  o[0][2].lock,
                  o[0][3].lock
                ),
              n.add(t[3].fire),
              (s[t[0]] = function () {
                return (
                  s[t[0] + "With"](this === s ? void 0 : this, arguments), this
                );
              }),
              (s[t[0] + "With"] = n.fireWith);
          }),
          a.promise(s),
          e && e.call(s, s),
          s
        );
      },
      when: function (e) {
        var n = arguments.length,
          t = n,
          r = Array(t),
          i = s.call(arguments),
          o = S.Deferred(),
          a = function (t) {
            return function (e) {
              (r[t] = this),
                (i[t] = 1 < arguments.length ? s.call(arguments) : e),
                --n || o.resolveWith(r, i);
            };
          };
        if (
          n <= 1 &&
          (I(e, o.done(a(t)).resolve, o.reject, !n),
          "pending" === o.state() || m(i[t] && i[t].then))
        )
          return o.then();
        while (t--) I(i[t], a(t), o.reject);
        return o.promise();
      },
    });
  var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (S.Deferred.exceptionHook = function (e, t) {
    C.console &&
      C.console.warn &&
      e &&
      W.test(e.name) &&
      C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
  }),
    (S.readyException = function (e) {
      C.setTimeout(function () {
        throw e;
      });
    });
  var F = S.Deferred();
  function B() {
    E.removeEventListener("DOMContentLoaded", B),
      C.removeEventListener("load", B),
      S.ready();
  }
  (S.fn.ready = function (e) {
    return (
      F.then(e)["catch"](function (e) {
        S.readyException(e);
      }),
      this
    );
  }),
    S.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --S.readyWait : S.isReady) ||
          ((S.isReady = !0) !== e && 0 < --S.readyWait) ||
          F.resolveWith(E, [S]);
      },
    }),
    (S.ready.then = F.then),
    "complete" === E.readyState ||
    ("loading" !== E.readyState && !E.documentElement.doScroll)
      ? C.setTimeout(S.ready)
      : (E.addEventListener("DOMContentLoaded", B),
        C.addEventListener("load", B));
  var $ = function (e, t, n, r, i, o, a) {
      var s = 0,
        u = e.length,
        l = null == n;
      if ("object" === w(n))
        for (s in ((i = !0), n)) $(e, t, s, n[s], !0, o, a);
      else if (
        void 0 !== r &&
        ((i = !0),
        m(r) || (a = !0),
        l &&
          (a
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function (e, t, n) {
                return l.call(S(e), n);
              }))),
        t)
      )
        for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
    },
    _ = /^-ms-/,
    z = /-([a-z])/g;
  function U(e, t) {
    return t.toUpperCase();
  }
  function X(e) {
    return e.replace(_, "ms-").replace(z, U);
  }
  var V = function (e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };
  function G() {
    this.expando = S.expando + G.uid++;
  }
  (G.uid = 1),
    (G.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            V(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, n) {
        var r,
          i = this.cache(e);
        if ("string" == typeof t) i[X(t)] = n;
        else for (r in t) i[X(r)] = t[r];
        return i;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][X(t)];
      },
      access: function (e, t, n) {
        return void 0 === t || (t && "string" == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          r = e[this.expando];
        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t)
              ? t.map(X)
              : (t = X(t)) in r
              ? [t]
              : t.match(P) || []).length;
            while (n--) delete r[t[n]];
          }
          (void 0 === t || S.isEmptyObject(r)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !S.isEmptyObject(t);
      },
    });
  var Y = new G(),
    Q = new G(),
    J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    K = /[A-Z]/g;
  function Z(e, t, n) {
    var r, i;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((r = "data-" + t.replace(K, "-$&").toLowerCase()),
        "string" == typeof (n = e.getAttribute(r)))
      ) {
        try {
          n =
            "true" === (i = n) ||
            ("false" !== i &&
              ("null" === i
                ? null
                : i === +i + ""
                ? +i
                : J.test(i)
                ? JSON.parse(i)
                : i));
        } catch (e) {}
        Q.set(e, t, n);
      } else n = void 0;
    return n;
  }
  S.extend({
    hasData: function (e) {
      return Q.hasData(e) || Y.hasData(e);
    },
    data: function (e, t, n) {
      return Q.access(e, t, n);
    },
    removeData: function (e, t) {
      Q.remove(e, t);
    },
    _data: function (e, t, n) {
      return Y.access(e, t, n);
    },
    _removeData: function (e, t) {
      Y.remove(e, t);
    },
  }),
    S.fn.extend({
      data: function (n, e) {
        var t,
          r,
          i,
          o = this[0],
          a = o && o.attributes;
        if (void 0 === n) {
          if (
            this.length &&
            ((i = Q.get(o)), 1 === o.nodeType && !Y.get(o, "hasDataAttrs"))
          ) {
            t = a.length;
            while (t--)
              a[t] &&
                0 === (r = a[t].name).indexOf("data-") &&
                ((r = X(r.slice(5))), Z(o, r, i[r]));
            Y.set(o, "hasDataAttrs", !0);
          }
          return i;
        }
        return "object" == typeof n
          ? this.each(function () {
              Q.set(this, n);
            })
          : $(
              this,
              function (e) {
                var t;
                if (o && void 0 === e)
                  return void 0 !== (t = Q.get(o, n))
                    ? t
                    : void 0 !== (t = Z(o, n))
                    ? t
                    : void 0;
                this.each(function () {
                  Q.set(this, n, e);
                });
              },
              null,
              e,
              1 < arguments.length,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          Q.remove(this, e);
        });
      },
    }),
    S.extend({
      queue: function (e, t, n) {
        var r;
        if (e)
          return (
            (t = (t || "fx") + "queue"),
            (r = Y.get(e, t)),
            n &&
              (!r || Array.isArray(n)
                ? (r = Y.access(e, t, S.makeArray(n)))
                : r.push(n)),
            r || []
          );
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var n = S.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = S._queueHooks(e, t);
        "inprogress" === i && ((i = n.shift()), r--),
          i &&
            ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            i.call(
              e,
              function () {
                S.dequeue(e, t);
              },
              o
            )),
          !r && o && o.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + "queueHooks";
        return (
          Y.get(e, n) ||
          Y.access(e, n, {
            empty: S.Callbacks("once memory").add(function () {
              Y.remove(e, [t + "queue", n]);
            }),
          })
        );
      },
    }),
    S.fn.extend({
      queue: function (t, n) {
        var e = 2;
        return (
          "string" != typeof t && ((n = t), (t = "fx"), e--),
          arguments.length < e
            ? S.queue(this[0], t)
            : void 0 === n
            ? this
            : this.each(function () {
                var e = S.queue(this, t, n);
                S._queueHooks(this, t),
                  "fx" === t && "inprogress" !== e[0] && S.dequeue(this, t);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          S.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", []);
      },
      promise: function (e, t) {
        var n,
          r = 1,
          i = S.Deferred(),
          o = this,
          a = this.length,
          s = function () {
            --r || i.resolveWith(o, [o]);
          };
        "string" != typeof e && ((t = e), (e = void 0)), (e = e || "fx");
        while (a--)
          (n = Y.get(o[a], e + "queueHooks")) &&
            n.empty &&
            (r++, n.empty.add(s));
        return s(), i.promise(t);
      },
    });
  var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
    ne = ["Top", "Right", "Bottom", "Left"],
    re = E.documentElement,
    ie = function (e) {
      return S.contains(e.ownerDocument, e);
    },
    oe = { composed: !0 };
  re.getRootNode &&
    (ie = function (e) {
      return (
        S.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument
      );
    });
  var ae = function (e, t) {
    return (
      "none" === (e = t || e).style.display ||
      ("" === e.style.display && ie(e) && "none" === S.css(e, "display"))
    );
  };
  function se(e, t, n, r) {
    var i,
      o,
      a = 20,
      s = r
        ? function () {
            return r.cur();
          }
        : function () {
            return S.css(e, t, "");
          },
      u = s(),
      l = (n && n[3]) || (S.cssNumber[t] ? "" : "px"),
      c =
        e.nodeType &&
        (S.cssNumber[t] || ("px" !== l && +u)) &&
        te.exec(S.css(e, t));
    if (c && c[3] !== l) {
      (u /= 2), (l = l || c[3]), (c = +u || 1);
      while (a--)
        S.style(e, t, c + l),
          (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0),
          (c /= o);
      (c *= 2), S.style(e, t, c + l), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    );
  }
  var ue = {};
  function le(e, t) {
    for (var n, r, i, o, a, s, u, l = [], c = 0, f = e.length; c < f; c++)
      (r = e[c]).style &&
        ((n = r.style.display),
        t
          ? ("none" === n &&
              ((l[c] = Y.get(r, "display") || null),
              l[c] || (r.style.display = "")),
            "" === r.style.display &&
              ae(r) &&
              (l[c] =
                ((u = a = o = void 0),
                (a = (i = r).ownerDocument),
                (s = i.nodeName),
                (u = ue[s]) ||
                  ((o = a.body.appendChild(a.createElement(s))),
                  (u = S.css(o, "display")),
                  o.parentNode.removeChild(o),
                  "none" === u && (u = "block"),
                  (ue[s] = u)))))
          : "none" !== n && ((l[c] = "none"), Y.set(r, "display", n)));
    for (c = 0; c < f; c++) null != l[c] && (e[c].style.display = l[c]);
    return e;
  }
  S.fn.extend({
    show: function () {
      return le(this, !0);
    },
    hide: function () {
      return le(this);
    },
    toggle: function (e) {
      return "boolean" == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ae(this) ? S(this).show() : S(this).hide();
          });
    },
  });
  var ce,
    fe,
    pe = /^(?:checkbox|radio)$/i,
    de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
    he = /^$|^module$|\/(?:java|ecma)script/i;
  (ce = E.createDocumentFragment().appendChild(E.createElement("div"))),
    (fe = E.createElement("input")).setAttribute("type", "radio"),
    fe.setAttribute("checked", "checked"),
    fe.setAttribute("name", "t"),
    ce.appendChild(fe),
    (y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked),
    (ce.innerHTML = "<textarea>x</textarea>"),
    (y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue),
    (ce.innerHTML = "<option></option>"),
    (y.option = !!ce.lastChild);
  var ge = {
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""],
  };
  function ve(e, t) {
    var n;
    return (
      (n =
        "undefined" != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : "undefined" != typeof e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : []),
      void 0 === t || (t && A(e, t)) ? S.merge([e], n) : n
    );
  }
  function ye(e, t) {
    for (var n = 0, r = e.length; n < r; n++)
      Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
  }
  (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
    (ge.th = ge.td),
    y.option ||
      (ge.optgroup = ge.option = [
        1,
        "<select multiple='multiple'>",
        "</select>",
      ]);
  var me = /<|&#?\w+;/;
  function xe(e, t, n, r, i) {
    for (
      var o,
        a,
        s,
        u,
        l,
        c,
        f = t.createDocumentFragment(),
        p = [],
        d = 0,
        h = e.length;
      d < h;
      d++
    )
      if ((o = e[d]) || 0 === o)
        if ("object" === w(o)) S.merge(p, o.nodeType ? [o] : o);
        else if (me.test(o)) {
          (a = a || f.appendChild(t.createElement("div"))),
            (s = (de.exec(o) || ["", ""])[1].toLowerCase()),
            (u = ge[s] || ge._default),
            (a.innerHTML = u[1] + S.htmlPrefilter(o) + u[2]),
            (c = u[0]);
          while (c--) a = a.lastChild;
          S.merge(p, a.childNodes), ((a = f.firstChild).textContent = "");
        } else p.push(t.createTextNode(o));
    (f.textContent = ""), (d = 0);
    while ((o = p[d++]))
      if (r && -1 < S.inArray(o, r)) i && i.push(o);
      else if (
        ((l = ie(o)), (a = ve(f.appendChild(o), "script")), l && ye(a), n)
      ) {
        c = 0;
        while ((o = a[c++])) he.test(o.type || "") && n.push(o);
      }
    return f;
  }
  var be = /^key/,
    we = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    Te = /^([^.]*)(?:\.(.+)|)/;
  function Ce() {
    return !0;
  }
  function Ee() {
    return !1;
  }
  function Se(e, t) {
    return (
      (e ===
        (function () {
          try {
            return E.activeElement;
          } catch (e) {}
        })()) ==
      ("focus" === t)
    );
  }
  function ke(e, t, n, r, i, o) {
    var a, s;
    if ("object" == typeof t) {
      for (s in ("string" != typeof n && ((r = r || n), (n = void 0)), t))
        ke(e, s, n, r, t[s], o);
      return e;
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i &&
          ("string" == typeof n
            ? ((i = r), (r = void 0))
            : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = Ee;
    else if (!i) return e;
    return (
      1 === o &&
        ((a = i),
        ((i = function (e) {
          return S().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = S.guid++))),
      e.each(function () {
        S.event.add(this, t, i, r, n);
      })
    );
  }
  function Ae(e, i, o) {
    o
      ? (Y.set(e, i, !1),
        S.event.add(e, i, {
          namespace: !1,
          handler: function (e) {
            var t,
              n,
              r = Y.get(this, i);
            if (1 & e.isTrigger && this[i]) {
              if (r.length)
                (S.event.special[i] || {}).delegateType && e.stopPropagation();
              else if (
                ((r = s.call(arguments)),
                Y.set(this, i, r),
                (t = o(this, i)),
                this[i](),
                r !== (n = Y.get(this, i)) || t ? Y.set(this, i, !1) : (n = {}),
                r !== n)
              )
                return (
                  e.stopImmediatePropagation(), e.preventDefault(), n.value
                );
            } else
              r.length &&
                (Y.set(this, i, {
                  value: S.event.trigger(
                    S.extend(r[0], S.Event.prototype),
                    r.slice(1),
                    this
                  ),
                }),
                e.stopImmediatePropagation());
          },
        }))
      : void 0 === Y.get(e, i) && S.event.add(e, i, Ce);
  }
  (S.event = {
    global: {},
    add: function (t, e, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        v = Y.get(t);
      if (V(t)) {
        n.handler && ((n = (o = n).handler), (i = o.selector)),
          i && S.find.matchesSelector(re, i),
          n.guid || (n.guid = S.guid++),
          (u = v.events) || (u = v.events = Object.create(null)),
          (a = v.handle) ||
            (a = v.handle = function (e) {
              return "undefined" != typeof S && S.event.triggered !== e.type
                ? S.event.dispatch.apply(t, arguments)
                : void 0;
            }),
          (l = (e = (e || "").match(P) || [""]).length);
        while (l--)
          (d = g = (s = Te.exec(e[l]) || [])[1]),
            (h = (s[2] || "").split(".").sort()),
            d &&
              ((f = S.event.special[d] || {}),
              (d = (i ? f.delegateType : f.bindType) || d),
              (f = S.event.special[d] || {}),
              (c = S.extend(
                {
                  type: d,
                  origType: g,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && S.expr.match.needsContext.test(i),
                  namespace: h.join("."),
                },
                o
              )),
              (p = u[d]) ||
                (((p = u[d] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(t, r, h, a)) ||
                  (t.addEventListener && t.addEventListener(d, a))),
              f.add &&
                (f.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (S.event.global[d] = !0));
      }
    },
    remove: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        v = Y.hasData(e) && Y.get(e);
      if (v && (u = v.events)) {
        l = (t = (t || "").match(P) || [""]).length;
        while (l--)
          if (
            ((d = g = (s = Te.exec(t[l]) || [])[1]),
            (h = (s[2] || "").split(".").sort()),
            d)
          ) {
            (f = S.event.special[d] || {}),
              (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
              (s =
                s[2] &&
                new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")),
              (a = o = p.length);
            while (o--)
              (c = p[o]),
                (!i && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (s && !s.test(c.namespace)) ||
                  (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                  (p.splice(o, 1),
                  c.selector && p.delegateCount--,
                  f.remove && f.remove.call(e, c));
            a &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, h, v.handle)) ||
                S.removeEvent(e, d, v.handle),
              delete u[d]);
          } else for (d in u) S.event.remove(e, d + t[l], n, r, !0);
        S.isEmptyObject(u) && Y.remove(e, "handle events");
      }
    },
    dispatch: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s = new Array(arguments.length),
        u = S.event.fix(e),
        l = (Y.get(this, "events") || Object.create(null))[u.type] || [],
        c = S.event.special[u.type] || {};
      for (s[0] = u, t = 1; t < arguments.length; t++) s[t] = arguments[t];
      if (
        ((u.delegateTarget = this),
        !c.preDispatch || !1 !== c.preDispatch.call(this, u))
      ) {
        (a = S.event.handlers.call(this, u, l)), (t = 0);
        while ((i = a[t++]) && !u.isPropagationStopped()) {
          (u.currentTarget = i.elem), (n = 0);
          while ((o = i.handlers[n++]) && !u.isImmediatePropagationStopped())
            (u.rnamespace &&
              !1 !== o.namespace &&
              !u.rnamespace.test(o.namespace)) ||
              ((u.handleObj = o),
              (u.data = o.data),
              void 0 !==
                (r = (
                  (S.event.special[o.origType] || {}).handle || o.handler
                ).apply(i.elem, s)) &&
                !1 === (u.result = r) &&
                (u.preventDefault(), u.stopPropagation()));
        }
        return c.postDispatch && c.postDispatch.call(this, u), u.result;
      }
    },
    handlers: function (e, t) {
      var n,
        r,
        i,
        o,
        a,
        s = [],
        u = t.delegateCount,
        l = e.target;
      if (u && l.nodeType && !("click" === e.type && 1 <= e.button))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
            for (o = [], a = {}, n = 0; n < u; n++)
              void 0 === a[(i = (r = t[n]).selector + " ")] &&
                (a[i] = r.needsContext
                  ? -1 < S(i, this).index(l)
                  : S.find(i, this, null, [l]).length),
                a[i] && o.push(r);
            o.length && s.push({ elem: l, handlers: o });
          }
      return (
        (l = this), u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s
      );
    },
    addProp: function (t, e) {
      Object.defineProperty(S.Event.prototype, t, {
        enumerable: !0,
        configurable: !0,
        get: m(e)
          ? function () {
              if (this.originalEvent) return e(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[t];
            },
        set: function (e) {
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e,
          });
        },
      });
    },
    fix: function (e) {
      return e[S.expando] ? e : new S.Event(e);
    },
    special: {
      load: { noBubble: !0 },
      click: {
        setup: function (e) {
          var t = this || e;
          return (
            pe.test(t.type) && t.click && A(t, "input") && Ae(t, "click", Ce),
            !1
          );
        },
        trigger: function (e) {
          var t = this || e;
          return (
            pe.test(t.type) && t.click && A(t, "input") && Ae(t, "click"), !0
          );
        },
        _default: function (e) {
          var t = e.target;
          return (
            (pe.test(t.type) &&
              t.click &&
              A(t, "input") &&
              Y.get(t, "click")) ||
            A(t, "a")
          );
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (S.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (S.Event = function (e, t) {
      if (!(this instanceof S.Event)) return new S.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented ||
            (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? Ce
              : Ee),
          (this.target =
            e.target && 3 === e.target.nodeType
              ? e.target.parentNode
              : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && S.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[S.expando] = !0);
    }),
    (S.Event.prototype = {
      constructor: S.Event,
      isDefaultPrevented: Ee,
      isPropagationStopped: Ee,
      isImmediatePropagationStopped: Ee,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = Ce),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = Ce),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = Ce),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    S.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button;
          return null == e.which && be.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && we.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        },
      },
      S.event.addProp
    ),
    S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
      S.event.special[e] = {
        setup: function () {
          return Ae(this, e, Se), !1;
        },
        trigger: function () {
          return Ae(this, e), !0;
        },
        delegateType: t,
      };
    }),
    S.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (e, i) {
        S.event.special[e] = {
          delegateType: i,
          bindType: i,
          handle: function (e) {
            var t,
              n = e.relatedTarget,
              r = e.handleObj;
            return (
              (n && (n === this || S.contains(this, n))) ||
                ((e.type = r.origType),
                (t = r.handler.apply(this, arguments)),
                (e.type = i)),
              t
            );
          },
        };
      }
    ),
    S.fn.extend({
      on: function (e, t, n, r) {
        return ke(this, e, t, n, r);
      },
      one: function (e, t, n, r) {
        return ke(this, e, t, n, r, 1);
      },
      off: function (e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            S(e.delegateTarget).off(
              r.namespace ? r.origType + "." + r.namespace : r.origType,
              r.selector,
              r.handler
            ),
            this
          );
        if ("object" == typeof e) {
          for (i in e) this.off(i, t, e[i]);
          return this;
        }
        return (
          (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = Ee),
          this.each(function () {
            S.event.remove(this, e, n, t);
          })
        );
      },
    });
  var Ne = /<script|<style|<link/i,
    De = /checked\s*(?:[^=]|=\s*.checked.)/i,
    je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function qe(e, t) {
    return (
      (A(e, "table") &&
        A(11 !== t.nodeType ? t : t.firstChild, "tr") &&
        S(e).children("tbody")[0]) ||
      e
    );
  }
  function Le(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
  }
  function He(e) {
    return (
      "true/" === (e.type || "").slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute("type"),
      e
    );
  }
  function Oe(e, t) {
    var n, r, i, o, a, s;
    if (1 === t.nodeType) {
      if (Y.hasData(e) && (s = Y.get(e).events))
        for (i in (Y.remove(t, "handle events"), s))
          for (n = 0, r = s[i].length; n < r; n++) S.event.add(t, i, s[i][n]);
      Q.hasData(e) && ((o = Q.access(e)), (a = S.extend({}, o)), Q.set(t, a));
    }
  }
  function Pe(n, r, i, o) {
    r = g(r);
    var e,
      t,
      a,
      s,
      u,
      l,
      c = 0,
      f = n.length,
      p = f - 1,
      d = r[0],
      h = m(d);
    if (h || (1 < f && "string" == typeof d && !y.checkClone && De.test(d)))
      return n.each(function (e) {
        var t = n.eq(e);
        h && (r[0] = d.call(this, e, t.html())), Pe(t, r, i, o);
      });
    if (
      f &&
      ((t = (e = xe(r, n[0].ownerDocument, !1, n, o)).firstChild),
      1 === e.childNodes.length && (e = t),
      t || o)
    ) {
      for (s = (a = S.map(ve(e, "script"), Le)).length; c < f; c++)
        (u = e),
          c !== p &&
            ((u = S.clone(u, !0, !0)), s && S.merge(a, ve(u, "script"))),
          i.call(n[c], u, c);
      if (s)
        for (l = a[a.length - 1].ownerDocument, S.map(a, He), c = 0; c < s; c++)
          (u = a[c]),
            he.test(u.type || "") &&
              !Y.access(u, "globalEval") &&
              S.contains(l, u) &&
              (u.src && "module" !== (u.type || "").toLowerCase()
                ? S._evalUrl &&
                  !u.noModule &&
                  S._evalUrl(
                    u.src,
                    { nonce: u.nonce || u.getAttribute("nonce") },
                    l
                  )
                : b(u.textContent.replace(je, ""), u, l));
    }
    return n;
  }
  function Re(e, t, n) {
    for (var r, i = t ? S.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || S.cleanData(ve(r)),
        r.parentNode &&
          (n && ie(r) && ye(ve(r, "script")), r.parentNode.removeChild(r));
    return e;
  }
  S.extend({
    htmlPrefilter: function (e) {
      return e;
    },
    clone: function (e, t, n) {
      var r,
        i,
        o,
        a,
        s,
        u,
        l,
        c = e.cloneNode(!0),
        f = ie(e);
      if (
        !(
          y.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          S.isXMLDoc(e)
        )
      )
        for (a = ve(c), r = 0, i = (o = ve(e)).length; r < i; r++)
          (s = o[r]),
            (u = a[r]),
            void 0,
            "input" === (l = u.nodeName.toLowerCase()) && pe.test(s.type)
              ? (u.checked = s.checked)
              : ("input" !== l && "textarea" !== l) ||
                (u.defaultValue = s.defaultValue);
      if (t)
        if (n)
          for (o = o || ve(e), a = a || ve(c), r = 0, i = o.length; r < i; r++)
            Oe(o[r], a[r]);
        else Oe(e, c);
      return (
        0 < (a = ve(c, "script")).length && ye(a, !f && ve(e, "script")), c
      );
    },
    cleanData: function (e) {
      for (var t, n, r, i = S.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if (V(n)) {
          if ((t = n[Y.expando])) {
            if (t.events)
              for (r in t.events)
                i[r] ? S.event.remove(n, r) : S.removeEvent(n, r, t.handle);
            n[Y.expando] = void 0;
          }
          n[Q.expando] && (n[Q.expando] = void 0);
        }
    },
  }),
    S.fn.extend({
      detach: function (e) {
        return Re(this, e, !0);
      },
      remove: function (e) {
        return Re(this, e);
      },
      text: function (e) {
        return $(
          this,
          function (e) {
            return void 0 === e
              ? S.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return Pe(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            qe(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return Pe(this, arguments, function (e) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var t = qe(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return Pe(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return Pe(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (S.cleanData(ve(e, !1)), (e.textContent = ""));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return S.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return $(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              "string" == typeof e &&
              !Ne.test(e) &&
              !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = S.htmlPrefilter(e);
              try {
                for (; n < r; n++)
                  1 === (t = this[n] || {}).nodeType &&
                    (S.cleanData(ve(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var n = [];
        return Pe(
          this,
          arguments,
          function (e) {
            var t = this.parentNode;
            S.inArray(this, n) < 0 &&
              (S.cleanData(ve(this)), t && t.replaceChild(e, this));
          },
          n
        );
      },
    }),
    S.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (e, a) {
        S.fn[e] = function (e) {
          for (var t, n = [], r = S(e), i = r.length - 1, o = 0; o <= i; o++)
            (t = o === i ? this : this.clone(!0)),
              S(r[o])[a](t),
              u.apply(n, t.get());
          return this.pushStack(n);
        };
      }
    );
  var Me = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
    Ie = function (e) {
      var t = e.ownerDocument.defaultView;
      return (t && t.opener) || (t = C), t.getComputedStyle(e);
    },
    We = function (e, t, n) {
      var r,
        i,
        o = {};
      for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
      for (i in ((r = n.call(e)), t)) e.style[i] = o[i];
      return r;
    },
    Fe = new RegExp(ne.join("|"), "i");
  function Be(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.style;
    return (
      (n = n || Ie(e)) &&
        ("" !== (a = n.getPropertyValue(t) || n[t]) ||
          ie(e) ||
          (a = S.style(e, t)),
        !y.pixelBoxStyles() &&
          Me.test(a) &&
          Fe.test(t) &&
          ((r = s.width),
          (i = s.minWidth),
          (o = s.maxWidth),
          (s.minWidth = s.maxWidth = s.width = a),
          (a = n.width),
          (s.width = r),
          (s.minWidth = i),
          (s.maxWidth = o))),
      void 0 !== a ? a + "" : a
    );
  }
  function $e(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      },
    };
  }
  !(function () {
    function e() {
      if (l) {
        (u.style.cssText =
          "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
          (l.style.cssText =
            "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
          re.appendChild(u).appendChild(l);
        var e = C.getComputedStyle(l);
        (n = "1%" !== e.top),
          (s = 12 === t(e.marginLeft)),
          (l.style.right = "60%"),
          (o = 36 === t(e.right)),
          (r = 36 === t(e.width)),
          (l.style.position = "absolute"),
          (i = 12 === t(l.offsetWidth / 3)),
          re.removeChild(u),
          (l = null);
      }
    }
    function t(e) {
      return Math.round(parseFloat(e));
    }
    var n,
      r,
      i,
      o,
      a,
      s,
      u = E.createElement("div"),
      l = E.createElement("div");
    l.style &&
      ((l.style.backgroundClip = "content-box"),
      (l.cloneNode(!0).style.backgroundClip = ""),
      (y.clearCloneStyle = "content-box" === l.style.backgroundClip),
      S.extend(y, {
        boxSizingReliable: function () {
          return e(), r;
        },
        pixelBoxStyles: function () {
          return e(), o;
        },
        pixelPosition: function () {
          return e(), n;
        },
        reliableMarginLeft: function () {
          return e(), s;
        },
        scrollboxSize: function () {
          return e(), i;
        },
        reliableTrDimensions: function () {
          var e, t, n, r;
          return (
            null == a &&
              ((e = E.createElement("table")),
              (t = E.createElement("tr")),
              (n = E.createElement("div")),
              (e.style.cssText = "position:absolute;left:-11111px"),
              (t.style.height = "1px"),
              (n.style.height = "9px"),
              re.appendChild(e).appendChild(t).appendChild(n),
              (r = C.getComputedStyle(t)),
              (a = 3 < parseInt(r.height)),
              re.removeChild(e)),
            a
          );
        },
      }));
  })();
  var _e = ["Webkit", "Moz", "ms"],
    ze = E.createElement("div").style,
    Ue = {};
  function Xe(e) {
    var t = S.cssProps[e] || Ue[e];
    return (
      t ||
      (e in ze
        ? e
        : (Ue[e] =
            (function (e) {
              var t = e[0].toUpperCase() + e.slice(1),
                n = _e.length;
              while (n--) if ((e = _e[n] + t) in ze) return e;
            })(e) || e))
    );
  }
  var Ve = /^(none|table(?!-c[ea]).+)/,
    Ge = /^--/,
    Ye = { position: "absolute", visibility: "hidden", display: "block" },
    Qe = { letterSpacing: "0", fontWeight: "400" };
  function Je(e, t, n) {
    var r = te.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
  }
  function Ke(e, t, n, r, i, o) {
    var a = "width" === t ? 1 : 0,
      s = 0,
      u = 0;
    if (n === (r ? "border" : "content")) return 0;
    for (; a < 4; a += 2)
      "margin" === n && (u += S.css(e, n + ne[a], !0, i)),
        r
          ? ("content" === n && (u -= S.css(e, "padding" + ne[a], !0, i)),
            "margin" !== n &&
              (u -= S.css(e, "border" + ne[a] + "Width", !0, i)))
          : ((u += S.css(e, "padding" + ne[a], !0, i)),
            "padding" !== n
              ? (u += S.css(e, "border" + ne[a] + "Width", !0, i))
              : (s += S.css(e, "border" + ne[a] + "Width", !0, i)));
    return (
      !r &&
        0 <= o &&
        (u +=
          Math.max(
            0,
            Math.ceil(
              e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5
            )
          ) || 0),
      u
    );
  }
  function Ze(e, t, n) {
    var r = Ie(e),
      i =
        (!y.boxSizingReliable() || n) &&
        "border-box" === S.css(e, "boxSizing", !1, r),
      o = i,
      a = Be(e, t, r),
      s = "offset" + t[0].toUpperCase() + t.slice(1);
    if (Me.test(a)) {
      if (!n) return a;
      a = "auto";
    }
    return (
      ((!y.boxSizingReliable() && i) ||
        (!y.reliableTrDimensions() && A(e, "tr")) ||
        "auto" === a ||
        (!parseFloat(a) && "inline" === S.css(e, "display", !1, r))) &&
        e.getClientRects().length &&
        ((i = "border-box" === S.css(e, "boxSizing", !1, r)),
        (o = s in e) && (a = e[s])),
      (a = parseFloat(a) || 0) +
        Ke(e, t, n || (i ? "border" : "content"), o, r, a) +
        "px"
    );
  }
  function et(e, t, n, r, i) {
    return new et.prototype.init(e, t, n, r, i);
  }
  S.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = Be(e, "opacity");
            return "" === n ? "1" : n;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: {},
    style: function (e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          a,
          s = X(t),
          u = Ge.test(t),
          l = e.style;
        if (
          (u || (t = Xe(s)), (a = S.cssHooks[t] || S.cssHooks[s]), void 0 === n)
        )
          return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        "string" === (o = typeof n) &&
          (i = te.exec(n)) &&
          i[1] &&
          ((n = se(e, t, i)), (o = "number")),
          null != n &&
            n == n &&
            ("number" !== o ||
              u ||
              (n += (i && i[3]) || (S.cssNumber[s] ? "" : "px")),
            y.clearCloneStyle ||
              "" !== n ||
              0 !== t.indexOf("background") ||
              (l[t] = "inherit"),
            (a && "set" in a && void 0 === (n = a.set(e, n, r))) ||
              (u ? l.setProperty(t, n) : (l[t] = n)));
      }
    },
    css: function (e, t, n, r) {
      var i,
        o,
        a,
        s = X(t);
      return (
        Ge.test(t) || (t = Xe(s)),
        (a = S.cssHooks[t] || S.cssHooks[s]) &&
          "get" in a &&
          (i = a.get(e, !0, n)),
        void 0 === i && (i = Be(e, t, r)),
        "normal" === i && t in Qe && (i = Qe[t]),
        "" === n || n
          ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i)
          : i
      );
    },
  }),
    S.each(["height", "width"], function (e, u) {
      S.cssHooks[u] = {
        get: function (e, t, n) {
          if (t)
            return !Ve.test(S.css(e, "display")) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? Ze(e, u, n)
              : We(e, Ye, function () {
                  return Ze(e, u, n);
                });
        },
        set: function (e, t, n) {
          var r,
            i = Ie(e),
            o = !y.scrollboxSize() && "absolute" === i.position,
            a = (o || n) && "border-box" === S.css(e, "boxSizing", !1, i),
            s = n ? Ke(e, u, n, a, i) : 0;
          return (
            a &&
              o &&
              (s -= Math.ceil(
                e["offset" + u[0].toUpperCase() + u.slice(1)] -
                  parseFloat(i[u]) -
                  Ke(e, u, "border", !1, i) -
                  0.5
              )),
            s &&
              (r = te.exec(t)) &&
              "px" !== (r[3] || "px") &&
              ((e.style[u] = t), (t = S.css(e, u))),
            Je(0, t, s)
          );
        },
      };
    }),
    (S.cssHooks.marginLeft = $e(y.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(Be(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              We(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
              })) + "px"
        );
    })),
    S.each({ margin: "", padding: "", border: "Width" }, function (i, o) {
      (S.cssHooks[i + o] = {
        expand: function (e) {
          for (
            var t = 0, n = {}, r = "string" == typeof e ? e.split(" ") : [e];
            t < 4;
            t++
          )
            n[i + ne[t] + o] = r[t] || r[t - 2] || r[0];
          return n;
        },
      }),
        "margin" !== i && (S.cssHooks[i + o].set = Je);
    }),
    S.fn.extend({
      css: function (e, t) {
        return $(
          this,
          function (e, t, n) {
            var r,
              i,
              o = {},
              a = 0;
            if (Array.isArray(t)) {
              for (r = Ie(e), i = t.length; a < i; a++)
                o[t[a]] = S.css(e, t[a], !1, r);
              return o;
            }
            return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
          },
          e,
          t,
          1 < arguments.length
        );
      },
    }),
    (((S.Tween = et).prototype = {
      constructor: et,
      init: function (e, t, n, r, i, o) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = i || S.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (S.cssNumber[n] ? "" : "px"));
      },
      cur: function () {
        var e = et.propHooks[this.prop];
        return e && e.get ? e.get(this) : et.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          n = et.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t = S.easing[this.easing](
                e,
                this.options.duration * e,
                0,
                1,
                this.options.duration
              ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : et.propHooks._default.set(this),
          this
        );
      },
    }).init.prototype = et.prototype),
    ((et.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = S.css(e.elem, e.prop, "")) && "auto" !== t
            ? t
            : 0;
        },
        set: function (e) {
          S.fx.step[e.prop]
            ? S.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (!S.cssHooks[e.prop] && null == e.elem.style[Xe(e.prop)])
            ? (e.elem[e.prop] = e.now)
            : S.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }).scrollTop = et.propHooks.scrollLeft = {
      set: function (e) {
        e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
      },
    }),
    (S.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (S.fx = et.prototype.init),
    (S.fx.step = {});
  var tt,
    nt,
    rt,
    it,
    ot = /^(?:toggle|show|hide)$/,
    at = /queueHooks$/;
  function st() {
    nt &&
      (!1 === E.hidden && C.requestAnimationFrame
        ? C.requestAnimationFrame(st)
        : C.setTimeout(st, S.fx.interval),
      S.fx.tick());
  }
  function ut() {
    return (
      C.setTimeout(function () {
        tt = void 0;
      }),
      (tt = Date.now())
    );
  }
  function lt(e, t) {
    var n,
      r = 0,
      i = { height: e };
    for (t = t ? 1 : 0; r < 4; r += 2 - t)
      i["margin" + (n = ne[r])] = i["padding" + n] = e;
    return t && (i.opacity = i.width = e), i;
  }
  function ct(e, t, n) {
    for (
      var r,
        i = (ft.tweeners[t] || []).concat(ft.tweeners["*"]),
        o = 0,
        a = i.length;
      o < a;
      o++
    )
      if ((r = i[o].call(n, t, e))) return r;
  }
  function ft(o, e, t) {
    var n,
      a,
      r = 0,
      i = ft.prefilters.length,
      s = S.Deferred().always(function () {
        delete u.elem;
      }),
      u = function () {
        if (a) return !1;
        for (
          var e = tt || ut(),
            t = Math.max(0, l.startTime + l.duration - e),
            n = 1 - (t / l.duration || 0),
            r = 0,
            i = l.tweens.length;
          r < i;
          r++
        )
          l.tweens[r].run(n);
        return (
          s.notifyWith(o, [l, n, t]),
          n < 1 && i
            ? t
            : (i || s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l]), !1)
        );
      },
      l = s.promise({
        elem: o,
        props: S.extend({}, e),
        opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, t),
        originalProperties: e,
        originalOptions: t,
        startTime: tt || ut(),
        duration: t.duration,
        tweens: [],
        createTween: function (e, t) {
          var n = S.Tween(
            o,
            l.opts,
            e,
            t,
            l.opts.specialEasing[e] || l.opts.easing
          );
          return l.tweens.push(n), n;
        },
        stop: function (e) {
          var t = 0,
            n = e ? l.tweens.length : 0;
          if (a) return this;
          for (a = !0; t < n; t++) l.tweens[t].run(1);
          return (
            e
              ? (s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l, e]))
              : s.rejectWith(o, [l, e]),
            this
          );
        },
      }),
      c = l.props;
    for (
      !(function (e, t) {
        var n, r, i, o, a;
        for (n in e)
          if (
            ((i = t[(r = X(n))]),
            (o = e[n]),
            Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
            n !== r && ((e[r] = o), delete e[n]),
            (a = S.cssHooks[r]) && ("expand" in a))
          )
            for (n in ((o = a.expand(o)), delete e[r], o))
              (n in e) || ((e[n] = o[n]), (t[n] = i));
          else t[r] = i;
      })(c, l.opts.specialEasing);
      r < i;
      r++
    )
      if ((n = ft.prefilters[r].call(l, o, c, l.opts)))
        return (
          m(n.stop) &&
            (S._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)),
          n
        );
    return (
      S.map(c, ct, l),
      m(l.opts.start) && l.opts.start.call(o, l),
      l
        .progress(l.opts.progress)
        .done(l.opts.done, l.opts.complete)
        .fail(l.opts.fail)
        .always(l.opts.always),
      S.fx.timer(S.extend(u, { elem: o, anim: l, queue: l.opts.queue })),
      l
    );
  }
  (S.Animation = S.extend(ft, {
    tweeners: {
      "*": [
        function (e, t) {
          var n = this.createTween(e, t);
          return se(n.elem, e, te.exec(t), n), n;
        },
      ],
    },
    tweener: function (e, t) {
      m(e) ? ((t = e), (e = ["*"])) : (e = e.match(P));
      for (var n, r = 0, i = e.length; r < i; r++)
        (n = e[r]),
          (ft.tweeners[n] = ft.tweeners[n] || []),
          ft.tweeners[n].unshift(t);
    },
    prefilters: [
      function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c,
          f = "width" in t || "height" in t,
          p = this,
          d = {},
          h = e.style,
          g = e.nodeType && ae(e),
          v = Y.get(e, "fxshow");
        for (r in (n.queue ||
          (null == (a = S._queueHooks(e, "fx")).unqueued &&
            ((a.unqueued = 0),
            (s = a.empty.fire),
            (a.empty.fire = function () {
              a.unqueued || s();
            })),
          a.unqueued++,
          p.always(function () {
            p.always(function () {
              a.unqueued--, S.queue(e, "fx").length || a.empty.fire();
            });
          })),
        t))
          if (((i = t[r]), ot.test(i))) {
            if (
              (delete t[r],
              (o = o || "toggle" === i),
              i === (g ? "hide" : "show"))
            ) {
              if ("show" !== i || !v || void 0 === v[r]) continue;
              g = !0;
            }
            d[r] = (v && v[r]) || S.style(e, r);
          }
        if ((u = !S.isEmptyObject(t)) || !S.isEmptyObject(d))
          for (r in (f &&
            1 === e.nodeType &&
            ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
            null == (l = v && v.display) && (l = Y.get(e, "display")),
            "none" === (c = S.css(e, "display")) &&
              (l
                ? (c = l)
                : (le([e], !0),
                  (l = e.style.display || l),
                  (c = S.css(e, "display")),
                  le([e]))),
            ("inline" === c || ("inline-block" === c && null != l)) &&
              "none" === S.css(e, "float") &&
              (u ||
                (p.done(function () {
                  h.display = l;
                }),
                null == l && ((c = h.display), (l = "none" === c ? "" : c))),
              (h.display = "inline-block"))),
          n.overflow &&
            ((h.overflow = "hidden"),
            p.always(function () {
              (h.overflow = n.overflow[0]),
                (h.overflowX = n.overflow[1]),
                (h.overflowY = n.overflow[2]);
            })),
          (u = !1),
          d))
            u ||
              (v
                ? "hidden" in v && (g = v.hidden)
                : (v = Y.access(e, "fxshow", { display: l })),
              o && (v.hidden = !g),
              g && le([e], !0),
              p.done(function () {
                for (r in (g || le([e]), Y.remove(e, "fxshow"), d))
                  S.style(e, r, d[r]);
              })),
              (u = ct(g ? v[r] : 0, r, p)),
              r in v ||
                ((v[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? ft.prefilters.unshift(e) : ft.prefilters.push(e);
    },
  })),
    (S.speed = function (e, t, n) {
      var r =
        e && "object" == typeof e
          ? S.extend({}, e)
          : {
              complete: n || (!n && t) || (m(e) && e),
              duration: e,
              easing: (n && t) || (t && !m(t) && t),
            };
      return (
        S.fx.off
          ? (r.duration = 0)
          : "number" != typeof r.duration &&
            (r.duration in S.fx.speeds
              ? (r.duration = S.fx.speeds[r.duration])
              : (r.duration = S.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
        (r.old = r.complete),
        (r.complete = function () {
          m(r.old) && r.old.call(this), r.queue && S.dequeue(this, r.queue);
        }),
        r
      );
    }),
    S.fn.extend({
      fadeTo: function (e, t, n, r) {
        return this.filter(ae)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: t }, e, n, r);
      },
      animate: function (t, e, n, r) {
        var i = S.isEmptyObject(t),
          o = S.speed(e, n, r),
          a = function () {
            var e = ft(this, S.extend({}, t), o);
            (i || Y.get(this, "finish")) && e.stop(!0);
          };
        return (
          (a.finish = a),
          i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
        );
      },
      stop: function (i, e, o) {
        var a = function (e) {
          var t = e.stop;
          delete e.stop, t(o);
        };
        return (
          "string" != typeof i && ((o = e), (e = i), (i = void 0)),
          e && this.queue(i || "fx", []),
          this.each(function () {
            var e = !0,
              t = null != i && i + "queueHooks",
              n = S.timers,
              r = Y.get(this);
            if (t) r[t] && r[t].stop && a(r[t]);
            else for (t in r) r[t] && r[t].stop && at.test(t) && a(r[t]);
            for (t = n.length; t--; )
              n[t].elem !== this ||
                (null != i && n[t].queue !== i) ||
                (n[t].anim.stop(o), (e = !1), n.splice(t, 1));
            (!e && o) || S.dequeue(this, i);
          })
        );
      },
      finish: function (a) {
        return (
          !1 !== a && (a = a || "fx"),
          this.each(function () {
            var e,
              t = Y.get(this),
              n = t[a + "queue"],
              r = t[a + "queueHooks"],
              i = S.timers,
              o = n ? n.length : 0;
            for (
              t.finish = !0,
                S.queue(this, a, []),
                r && r.stop && r.stop.call(this, !0),
                e = i.length;
              e--;

            )
              i[e].elem === this &&
                i[e].queue === a &&
                (i[e].anim.stop(!0), i.splice(e, 1));
            for (e = 0; e < o; e++)
              n[e] && n[e].finish && n[e].finish.call(this);
            delete t.finish;
          })
        );
      },
    }),
    S.each(["toggle", "show", "hide"], function (e, r) {
      var i = S.fn[r];
      S.fn[r] = function (e, t, n) {
        return null == e || "boolean" == typeof e
          ? i.apply(this, arguments)
          : this.animate(lt(r, !0), e, t, n);
      };
    }),
    S.each(
      {
        slideDown: lt("show"),
        slideUp: lt("hide"),
        slideToggle: lt("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (e, r) {
        S.fn[e] = function (e, t, n) {
          return this.animate(r, e, t, n);
        };
      }
    ),
    (S.timers = []),
    (S.fx.tick = function () {
      var e,
        t = 0,
        n = S.timers;
      for (tt = Date.now(); t < n.length; t++)
        (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || S.fx.stop(), (tt = void 0);
    }),
    (S.fx.timer = function (e) {
      S.timers.push(e), S.fx.start();
    }),
    (S.fx.interval = 13),
    (S.fx.start = function () {
      nt || ((nt = !0), st());
    }),
    (S.fx.stop = function () {
      nt = null;
    }),
    (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (S.fn.delay = function (r, e) {
      return (
        (r = (S.fx && S.fx.speeds[r]) || r),
        (e = e || "fx"),
        this.queue(e, function (e, t) {
          var n = C.setTimeout(e, r);
          t.stop = function () {
            C.clearTimeout(n);
          };
        })
      );
    }),
    (rt = E.createElement("input")),
    (it = E.createElement("select").appendChild(E.createElement("option"))),
    (rt.type = "checkbox"),
    (y.checkOn = "" !== rt.value),
    (y.optSelected = it.selected),
    ((rt = E.createElement("input")).value = "t"),
    (rt.type = "radio"),
    (y.radioValue = "t" === rt.value);
  var pt,
    dt = S.expr.attrHandle;
  S.fn.extend({
    attr: function (e, t) {
      return $(this, S.attr, e, t, 1 < arguments.length);
    },
    removeAttr: function (e) {
      return this.each(function () {
        S.removeAttr(this, e);
      });
    },
  }),
    S.extend({
      attr: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return "undefined" == typeof e.getAttribute
            ? S.prop(e, t, n)
            : ((1 === o && S.isXMLDoc(e)) ||
                (i =
                  S.attrHooks[t.toLowerCase()] ||
                  (S.expr.match.bool.test(t) ? pt : void 0)),
              void 0 !== n
                ? null === n
                  ? void S.removeAttr(e, t)
                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                  ? r
                  : (e.setAttribute(t, n + ""), n)
                : i && "get" in i && null !== (r = i.get(e, t))
                ? r
                : null == (r = S.find.attr(e, t))
                ? void 0
                : r);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!y.radioValue && "radio" === t && A(e, "input")) {
              var n = e.value;
              return e.setAttribute("type", t), n && (e.value = n), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var n,
          r = 0,
          i = t && t.match(P);
        if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
      },
    }),
    (pt = {
      set: function (e, t, n) {
        return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
      },
    }),
    S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var a = dt[t] || S.find.attr;
      dt[t] = function (e, t, n) {
        var r,
          i,
          o = t.toLowerCase();
        return (
          n ||
            ((i = dt[o]),
            (dt[o] = r),
            (r = null != a(e, t, n) ? o : null),
            (dt[o] = i)),
          r
        );
      };
    });
  var ht = /^(?:input|select|textarea|button)$/i,
    gt = /^(?:a|area)$/i;
  function vt(e) {
    return (e.match(P) || []).join(" ");
  }
  function yt(e) {
    return (e.getAttribute && e.getAttribute("class")) || "";
  }
  function mt(e) {
    return Array.isArray(e) ? e : ("string" == typeof e && e.match(P)) || [];
  }
  S.fn.extend({
    prop: function (e, t) {
      return $(this, S.prop, e, t, 1 < arguments.length);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[S.propFix[e] || e];
      });
    },
  }),
    S.extend({
      prop: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && S.isXMLDoc(e)) ||
              ((t = S.propFix[t] || t), (i = S.propHooks[t])),
            void 0 !== n
              ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && "get" in i && null !== (r = i.get(e, t))
              ? r
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = S.find.attr(e, "tabindex");
            return t
              ? parseInt(t, 10)
              : ht.test(e.nodeName) || (gt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    y.optSelected ||
      (S.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        },
      }),
    S.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        S.propFix[this.toLowerCase()] = this;
      }
    ),
    S.fn.extend({
      addClass: function (t) {
        var e,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;
        if (m(t))
          return this.each(function (e) {
            S(this).addClass(t.call(this, e, yt(this)));
          });
        if ((e = mt(t)).length)
          while ((n = this[u++]))
            if (((i = yt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
              a = 0;
              while ((o = e[a++]))
                r.indexOf(" " + o + " ") < 0 && (r += o + " ");
              i !== (s = vt(r)) && n.setAttribute("class", s);
            }
        return this;
      },
      removeClass: function (t) {
        var e,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;
        if (m(t))
          return this.each(function (e) {
            S(this).removeClass(t.call(this, e, yt(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ((e = mt(t)).length)
          while ((n = this[u++]))
            if (((i = yt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
              a = 0;
              while ((o = e[a++]))
                while (-1 < r.indexOf(" " + o + " "))
                  r = r.replace(" " + o + " ", " ");
              i !== (s = vt(r)) && n.setAttribute("class", s);
            }
        return this;
      },
      toggleClass: function (i, t) {
        var o = typeof i,
          a = "string" === o || Array.isArray(i);
        return "boolean" == typeof t && a
          ? t
            ? this.addClass(i)
            : this.removeClass(i)
          : m(i)
          ? this.each(function (e) {
              S(this).toggleClass(i.call(this, e, yt(this), t), t);
            })
          : this.each(function () {
              var e, t, n, r;
              if (a) {
                (t = 0), (n = S(this)), (r = mt(i));
                while ((e = r[t++]))
                  n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
              } else (void 0 !== i && "boolean" !== o) || ((e = yt(this)) && Y.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === i ? "" : Y.get(this, "__className__") || ""));
            });
      },
      hasClass: function (e) {
        var t,
          n,
          r = 0;
        t = " " + e + " ";
        while ((n = this[r++]))
          if (1 === n.nodeType && -1 < (" " + vt(yt(n)) + " ").indexOf(t))
            return !0;
        return !1;
      },
    });
  var xt = /\r/g;
  S.fn.extend({
    val: function (n) {
      var r,
        e,
        i,
        t = this[0];
      return arguments.length
        ? ((i = m(n)),
          this.each(function (e) {
            var t;
            1 === this.nodeType &&
              (null == (t = i ? n.call(this, e, S(this).val()) : n)
                ? (t = "")
                : "number" == typeof t
                ? (t += "")
                : Array.isArray(t) &&
                  (t = S.map(t, function (e) {
                    return null == e ? "" : e + "";
                  })),
              ((r =
                S.valHooks[this.type] ||
                S.valHooks[this.nodeName.toLowerCase()]) &&
                "set" in r &&
                void 0 !== r.set(this, t, "value")) ||
                (this.value = t));
          }))
        : t
        ? (r = S.valHooks[t.type] || S.valHooks[t.nodeName.toLowerCase()]) &&
          "get" in r &&
          void 0 !== (e = r.get(t, "value"))
          ? e
          : "string" == typeof (e = t.value)
          ? e.replace(xt, "")
          : null == e
          ? ""
          : e
        : void 0;
    },
  }),
    S.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = S.find.attr(e, "value");
            return null != t ? t : vt(S.text(e));
          },
        },
        select: {
          get: function (e) {
            var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = "select-one" === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;
            for (r = o < 0 ? u : a ? o : 0; r < u; r++)
              if (
                ((n = i[r]).selected || r === o) &&
                !n.disabled &&
                (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))
              ) {
                if (((t = S(n).val()), a)) return t;
                s.push(t);
              }
            return s;
          },
          set: function (e, t) {
            var n,
              r,
              i = e.options,
              o = S.makeArray(t),
              a = i.length;
            while (a--)
              ((r = i[a]).selected =
                -1 < S.inArray(S.valHooks.option.get(r), o)) && (n = !0);
            return n || (e.selectedIndex = -1), o;
          },
        },
      },
    }),
    S.each(["radio", "checkbox"], function () {
      (S.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t))
            return (e.checked = -1 < S.inArray(S(e).val(), t));
        },
      }),
        y.checkOn ||
          (S.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value;
          });
    }),
    (y.focusin = "onfocusin" in C);
  var bt = /^(?:focusinfocus|focusoutblur)$/,
    wt = function (e) {
      e.stopPropagation();
    };
  S.extend(S.event, {
    trigger: function (e, t, n, r) {
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p = [n || E],
        d = v.call(e, "type") ? e.type : e,
        h = v.call(e, "namespace") ? e.namespace.split(".") : [];
      if (
        ((o = f = a = n = n || E),
        3 !== n.nodeType &&
          8 !== n.nodeType &&
          !bt.test(d + S.event.triggered) &&
          (-1 < d.indexOf(".") && ((d = (h = d.split(".")).shift()), h.sort()),
          (u = d.indexOf(":") < 0 && "on" + d),
          ((e = e[S.expando]
            ? e
            : new S.Event(d, "object" == typeof e && e)).isTrigger = r ? 2 : 3),
          (e.namespace = h.join(".")),
          (e.rnamespace = e.namespace
            ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (e.result = void 0),
          e.target || (e.target = n),
          (t = null == t ? [e] : S.makeArray(t, [e])),
          (c = S.event.special[d] || {}),
          r || !c.trigger || !1 !== c.trigger.apply(n, t)))
      ) {
        if (!r && !c.noBubble && !x(n)) {
          for (
            s = c.delegateType || d, bt.test(s + d) || (o = o.parentNode);
            o;
            o = o.parentNode
          )
            p.push(o), (a = o);
          a === (n.ownerDocument || E) &&
            p.push(a.defaultView || a.parentWindow || C);
        }
        i = 0;
        while ((o = p[i++]) && !e.isPropagationStopped())
          (f = o),
            (e.type = 1 < i ? s : c.bindType || d),
            (l =
              (Y.get(o, "events") || Object.create(null))[e.type] &&
              Y.get(o, "handle")) && l.apply(o, t),
            (l = u && o[u]) &&
              l.apply &&
              V(o) &&
              ((e.result = l.apply(o, t)),
              !1 === e.result && e.preventDefault());
        return (
          (e.type = d),
          r ||
            e.isDefaultPrevented() ||
            (c._default && !1 !== c._default.apply(p.pop(), t)) ||
            !V(n) ||
            (u &&
              m(n[d]) &&
              !x(n) &&
              ((a = n[u]) && (n[u] = null),
              (S.event.triggered = d),
              e.isPropagationStopped() && f.addEventListener(d, wt),
              n[d](),
              e.isPropagationStopped() && f.removeEventListener(d, wt),
              (S.event.triggered = void 0),
              a && (n[u] = a))),
          e.result
        );
      }
    },
    simulate: function (e, t, n) {
      var r = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
      S.event.trigger(r, null, t);
    },
  }),
    S.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          S.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        if (n) return S.event.trigger(e, t, n, !0);
      },
    }),
    y.focusin ||
      S.each({ focus: "focusin", blur: "focusout" }, function (n, r) {
        var i = function (e) {
          S.event.simulate(r, e.target, S.event.fix(e));
        };
        S.event.special[r] = {
          setup: function () {
            var e = this.ownerDocument || this.document || this,
              t = Y.access(e, r);
            t || e.addEventListener(n, i, !0), Y.access(e, r, (t || 0) + 1);
          },
          teardown: function () {
            var e = this.ownerDocument || this.document || this,
              t = Y.access(e, r) - 1;
            t
              ? Y.access(e, r, t)
              : (e.removeEventListener(n, i, !0), Y.remove(e, r));
          },
        };
      });
  var Tt = C.location,
    Ct = { guid: Date.now() },
    Et = /\?/;
  S.parseXML = function (e) {
    var t;
    if (!e || "string" != typeof e) return null;
    try {
      t = new C.DOMParser().parseFromString(e, "text/xml");
    } catch (e) {
      t = void 0;
    }
    return (
      (t && !t.getElementsByTagName("parsererror").length) ||
        S.error("Invalid XML: " + e),
      t
    );
  };
  var St = /\[\]$/,
    kt = /\r?\n/g,
    At = /^(?:submit|button|image|reset|file)$/i,
    Nt = /^(?:input|select|textarea|keygen)/i;
  function Dt(n, e, r, i) {
    var t;
    if (Array.isArray(e))
      S.each(e, function (e, t) {
        r || St.test(n)
          ? i(n, t)
          : Dt(
              n + "[" + ("object" == typeof t && null != t ? e : "") + "]",
              t,
              r,
              i
            );
      });
    else if (r || "object" !== w(e)) i(n, e);
    else for (t in e) Dt(n + "[" + t + "]", e[t], r, i);
  }
  (S.param = function (e, t) {
    var n,
      r = [],
      i = function (e, t) {
        var n = m(t) ? t() : t;
        r[r.length] =
          encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
      };
    if (null == e) return "";
    if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
      S.each(e, function () {
        i(this.name, this.value);
      });
    else for (n in e) Dt(n, e[n], t, i);
    return r.join("&");
  }),
    S.fn.extend({
      serialize: function () {
        return S.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = S.prop(this, "elements");
          return e ? S.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !S(this).is(":disabled") &&
              Nt.test(this.nodeName) &&
              !At.test(e) &&
              (this.checked || !pe.test(e))
            );
          })
          .map(function (e, t) {
            var n = S(this).val();
            return null == n
              ? null
              : Array.isArray(n)
              ? S.map(n, function (e) {
                  return { name: t.name, value: e.replace(kt, "\r\n") };
                })
              : { name: t.name, value: n.replace(kt, "\r\n") };
          })
          .get();
      },
    });
  var jt = /%20/g,
    qt = /#.*$/,
    Lt = /([?&])_=[^&]*/,
    Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Ot = /^(?:GET|HEAD)$/,
    Pt = /^\/\//,
    Rt = {},
    Mt = {},
    It = "*/".concat("*"),
    Wt = E.createElement("a");
  function Ft(o) {
    return function (e, t) {
      "string" != typeof e && ((t = e), (e = "*"));
      var n,
        r = 0,
        i = e.toLowerCase().match(P) || [];
      if (m(t))
        while ((n = i[r++]))
          "+" === n[0]
            ? ((n = n.slice(1) || "*"), (o[n] = o[n] || []).unshift(t))
            : (o[n] = o[n] || []).push(t);
    };
  }
  function Bt(t, i, o, a) {
    var s = {},
      u = t === Mt;
    function l(e) {
      var r;
      return (
        (s[e] = !0),
        S.each(t[e] || [], function (e, t) {
          var n = t(i, o, a);
          return "string" != typeof n || u || s[n]
            ? u
              ? !(r = n)
              : void 0
            : (i.dataTypes.unshift(n), l(n), !1);
        }),
        r
      );
    }
    return l(i.dataTypes[0]) || (!s["*"] && l("*"));
  }
  function $t(e, t) {
    var n,
      r,
      i = S.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    return r && S.extend(!0, e, r), e;
  }
  (Wt.href = Tt.href),
    S.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Tt.href,
        type: "GET",
        isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
          Tt.protocol
        ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": It,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": JSON.parse,
          "text xml": S.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e, t) {
        return t ? $t($t(e, S.ajaxSettings), t) : $t(S.ajaxSettings, e);
      },
      ajaxPrefilter: Ft(Rt),
      ajaxTransport: Ft(Mt),
      ajax: function (e, t) {
        "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
        var c,
          f,
          p,
          n,
          d,
          r,
          h,
          g,
          i,
          o,
          v = S.ajaxSetup({}, t),
          y = v.context || v,
          m = v.context && (y.nodeType || y.jquery) ? S(y) : S.event,
          x = S.Deferred(),
          b = S.Callbacks("once memory"),
          w = v.statusCode || {},
          a = {},
          s = {},
          u = "canceled",
          T = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (h) {
                if (!n) {
                  n = {};
                  while ((t = Ht.exec(p)))
                    n[t[1].toLowerCase() + " "] = (
                      n[t[1].toLowerCase() + " "] || []
                    ).concat(t[2]);
                }
                t = n[e.toLowerCase() + " "];
              }
              return null == t ? null : t.join(", ");
            },
            getAllResponseHeaders: function () {
              return h ? p : null;
            },
            setRequestHeader: function (e, t) {
              return (
                null == h &&
                  ((e = s[e.toLowerCase()] = s[e.toLowerCase()] || e),
                  (a[e] = t)),
                this
              );
            },
            overrideMimeType: function (e) {
              return null == h && (v.mimeType = e), this;
            },
            statusCode: function (e) {
              var t;
              if (e)
                if (h) T.always(e[T.status]);
                else for (t in e) w[t] = [w[t], e[t]];
              return this;
            },
            abort: function (e) {
              var t = e || u;
              return c && c.abort(t), l(0, t), this;
            },
          };
        if (
          (x.promise(T),
          (v.url = ((e || v.url || Tt.href) + "").replace(
            Pt,
            Tt.protocol + "//"
          )),
          (v.type = t.method || t.type || v.method || v.type),
          (v.dataTypes = (v.dataType || "*").toLowerCase().match(P) || [""]),
          null == v.crossDomain)
        ) {
          r = E.createElement("a");
          try {
            (r.href = v.url),
              (r.href = r.href),
              (v.crossDomain =
                Wt.protocol + "//" + Wt.host != r.protocol + "//" + r.host);
          } catch (e) {
            v.crossDomain = !0;
          }
        }
        if (
          (v.data &&
            v.processData &&
            "string" != typeof v.data &&
            (v.data = S.param(v.data, v.traditional)),
          Bt(Rt, v, t, T),
          h)
        )
          return T;
        for (i in ((g = S.event && v.global) &&
          0 == S.active++ &&
          S.event.trigger("ajaxStart"),
        (v.type = v.type.toUpperCase()),
        (v.hasContent = !Ot.test(v.type)),
        (f = v.url.replace(qt, "")),
        v.hasContent
          ? v.data &&
            v.processData &&
            0 ===
              (v.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) &&
            (v.data = v.data.replace(jt, "+"))
          : ((o = v.url.slice(f.length)),
            v.data &&
              (v.processData || "string" == typeof v.data) &&
              ((f += (Et.test(f) ? "&" : "?") + v.data), delete v.data),
            !1 === v.cache &&
              ((f = f.replace(Lt, "$1")),
              (o = (Et.test(f) ? "&" : "?") + "_=" + Ct.guid++ + o)),
            (v.url = f + o)),
        v.ifModified &&
          (S.lastModified[f] &&
            T.setRequestHeader("If-Modified-Since", S.lastModified[f]),
          S.etag[f] && T.setRequestHeader("If-None-Match", S.etag[f])),
        ((v.data && v.hasContent && !1 !== v.contentType) || t.contentType) &&
          T.setRequestHeader("Content-Type", v.contentType),
        T.setRequestHeader(
          "Accept",
          v.dataTypes[0] && v.accepts[v.dataTypes[0]]
            ? v.accepts[v.dataTypes[0]] +
                ("*" !== v.dataTypes[0] ? ", " + It + "; q=0.01" : "")
            : v.accepts["*"]
        ),
        v.headers))
          T.setRequestHeader(i, v.headers[i]);
        if (v.beforeSend && (!1 === v.beforeSend.call(y, T, v) || h))
          return T.abort();
        if (
          ((u = "abort"),
          b.add(v.complete),
          T.done(v.success),
          T.fail(v.error),
          (c = Bt(Mt, v, t, T)))
        ) {
          if (((T.readyState = 1), g && m.trigger("ajaxSend", [T, v]), h))
            return T;
          v.async &&
            0 < v.timeout &&
            (d = C.setTimeout(function () {
              T.abort("timeout");
            }, v.timeout));
          try {
            (h = !1), c.send(a, l);
          } catch (e) {
            if (h) throw e;
            l(-1, e);
          }
        } else l(-1, "No Transport");
        function l(e, t, n, r) {
          var i,
            o,
            a,
            s,
            u,
            l = t;
          h ||
            ((h = !0),
            d && C.clearTimeout(d),
            (c = void 0),
            (p = r || ""),
            (T.readyState = 0 < e ? 4 : 0),
            (i = (200 <= e && e < 300) || 304 === e),
            n &&
              (s = (function (e, t, n) {
                var r,
                  i,
                  o,
                  a,
                  s = e.contents,
                  u = e.dataTypes;
                while ("*" === u[0])
                  u.shift(),
                    void 0 === r &&
                      (r = e.mimeType || t.getResponseHeader("Content-Type"));
                if (r)
                  for (i in s)
                    if (s[i] && s[i].test(r)) {
                      u.unshift(i);
                      break;
                    }
                if (u[0] in n) o = u[0];
                else {
                  for (i in n) {
                    if (!u[0] || e.converters[i + " " + u[0]]) {
                      o = i;
                      break;
                    }
                    a || (a = i);
                  }
                  o = o || a;
                }
                if (o) return o !== u[0] && u.unshift(o), n[o];
              })(v, T, n)),
            !i &&
              -1 < S.inArray("script", v.dataTypes) &&
              (v.converters["text script"] = function () {}),
            (s = (function (e, t, n, r) {
              var i,
                o,
                a,
                s,
                u,
                l = {},
                c = e.dataTypes.slice();
              if (c[1])
                for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
              o = c.shift();
              while (o)
                if (
                  (e.responseFields[o] && (n[e.responseFields[o]] = t),
                  !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (u = o),
                  (o = c.shift()))
                )
                  if ("*" === o) o = u;
                  else if ("*" !== u && u !== o) {
                    if (!(a = l[u + " " + o] || l["* " + o]))
                      for (i in l)
                        if (
                          (s = i.split(" "))[1] === o &&
                          (a = l[u + " " + s[0]] || l["* " + s[0]])
                        ) {
                          !0 === a
                            ? (a = l[i])
                            : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                          break;
                        }
                    if (!0 !== a)
                      if (a && e["throws"]) t = a(t);
                      else
                        try {
                          t = a(t);
                        } catch (e) {
                          return {
                            state: "parsererror",
                            error: a
                              ? e
                              : "No conversion from " + u + " to " + o,
                          };
                        }
                  }
              return { state: "success", data: t };
            })(v, s, T, i)),
            i
              ? (v.ifModified &&
                  ((u = T.getResponseHeader("Last-Modified")) &&
                    (S.lastModified[f] = u),
                  (u = T.getResponseHeader("etag")) && (S.etag[f] = u)),
                204 === e || "HEAD" === v.type
                  ? (l = "nocontent")
                  : 304 === e
                  ? (l = "notmodified")
                  : ((l = s.state), (o = s.data), (i = !(a = s.error))))
              : ((a = l), (!e && l) || ((l = "error"), e < 0 && (e = 0))),
            (T.status = e),
            (T.statusText = (t || l) + ""),
            i ? x.resolveWith(y, [o, l, T]) : x.rejectWith(y, [T, l, a]),
            T.statusCode(w),
            (w = void 0),
            g && m.trigger(i ? "ajaxSuccess" : "ajaxError", [T, v, i ? o : a]),
            b.fireWith(y, [T, l]),
            g &&
              (m.trigger("ajaxComplete", [T, v]),
              --S.active || S.event.trigger("ajaxStop")));
        }
        return T;
      },
      getJSON: function (e, t, n) {
        return S.get(e, t, n, "json");
      },
      getScript: function (e, t) {
        return S.get(e, void 0, t, "script");
      },
    }),
    S.each(["get", "post"], function (e, i) {
      S[i] = function (e, t, n, r) {
        return (
          m(t) && ((r = r || n), (n = t), (t = void 0)),
          S.ajax(
            S.extend(
              { url: e, type: i, dataType: r, data: t, success: n },
              S.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    S.ajaxPrefilter(function (e) {
      var t;
      for (t in e.headers)
        "content-type" === t.toLowerCase() &&
          (e.contentType = e.headers[t] || "");
    }),
    (S._evalUrl = function (e, t, n) {
      return S.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        converters: { "text script": function () {} },
        dataFilter: function (e) {
          S.globalEval(e, t, n);
        },
      });
    }),
    S.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (m(e) && (e = e.call(this[0])),
            (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                var e = this;
                while (e.firstElementChild) e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (n) {
        return m(n)
          ? this.each(function (e) {
              S(this).wrapInner(n.call(this, e));
            })
          : this.each(function () {
              var e = S(this),
                t = e.contents();
              t.length ? t.wrapAll(n) : e.append(n);
            });
      },
      wrap: function (t) {
        var n = m(t);
        return this.each(function (e) {
          S(this).wrapAll(n ? t.call(this, e) : t);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not("body")
            .each(function () {
              S(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (S.expr.pseudos.hidden = function (e) {
      return !S.expr.pseudos.visible(e);
    }),
    (S.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (S.ajaxSettings.xhr = function () {
      try {
        return new C.XMLHttpRequest();
      } catch (e) {}
    });
  var _t = { 0: 200, 1223: 204 },
    zt = S.ajaxSettings.xhr();
  (y.cors = !!zt && "withCredentials" in zt),
    (y.ajax = zt = !!zt),
    S.ajaxTransport(function (i) {
      var o, a;
      if (y.cors || (zt && !i.crossDomain))
        return {
          send: function (e, t) {
            var n,
              r = i.xhr();
            if (
              (r.open(i.type, i.url, i.async, i.username, i.password),
              i.xhrFields)
            )
              for (n in i.xhrFields) r[n] = i.xhrFields[n];
            for (n in (i.mimeType &&
              r.overrideMimeType &&
              r.overrideMimeType(i.mimeType),
            i.crossDomain ||
              e["X-Requested-With"] ||
              (e["X-Requested-With"] = "XMLHttpRequest"),
            e))
              r.setRequestHeader(n, e[n]);
            (o = function (e) {
              return function () {
                o &&
                  ((o = a = r.onload = r.onerror = r.onabort = r.ontimeout = r.onreadystatechange = null),
                  "abort" === e
                    ? r.abort()
                    : "error" === e
                    ? "number" != typeof r.status
                      ? t(0, "error")
                      : t(r.status, r.statusText)
                    : t(
                        _t[r.status] || r.status,
                        r.statusText,
                        "text" !== (r.responseType || "text") ||
                          "string" != typeof r.responseText
                          ? { binary: r.response }
                          : { text: r.responseText },
                        r.getAllResponseHeaders()
                      ));
              };
            }),
              (r.onload = o()),
              (a = r.onerror = r.ontimeout = o("error")),
              void 0 !== r.onabort
                ? (r.onabort = a)
                : (r.onreadystatechange = function () {
                    4 === r.readyState &&
                      C.setTimeout(function () {
                        o && a();
                      });
                  }),
              (o = o("abort"));
            try {
              r.send((i.hasContent && i.data) || null);
            } catch (e) {
              if (o) throw e;
            }
          },
          abort: function () {
            o && o();
          },
        };
    }),
    S.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    S.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (e) {
          return S.globalEval(e), e;
        },
      },
    }),
    S.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }),
    S.ajaxTransport("script", function (n) {
      var r, i;
      if (n.crossDomain || n.scriptAttrs)
        return {
          send: function (e, t) {
            (r = S("<script>")
              .attr(n.scriptAttrs || {})
              .prop({ charset: n.scriptCharset, src: n.url })
              .on(
                "load error",
                (i = function (e) {
                  r.remove(),
                    (i = null),
                    e && t("error" === e.type ? 404 : 200, e.type);
                })
              )),
              E.head.appendChild(r[0]);
          },
          abort: function () {
            i && i();
          },
        };
    });
  var Ut,
    Xt = [],
    Vt = /(=)\?(?=&|$)|\?\?/;
  S.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var e = Xt.pop() || S.expando + "_" + Ct.guid++;
      return (this[e] = !0), e;
    },
  }),
    S.ajaxPrefilter("json jsonp", function (e, t, n) {
      var r,
        i,
        o,
        a =
          !1 !== e.jsonp &&
          (Vt.test(e.url)
            ? "url"
            : "string" == typeof e.data &&
              0 ===
                (e.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              Vt.test(e.data) &&
              "data");
      if (a || "jsonp" === e.dataTypes[0])
        return (
          (r = e.jsonpCallback = m(e.jsonpCallback)
            ? e.jsonpCallback()
            : e.jsonpCallback),
          a
            ? (e[a] = e[a].replace(Vt, "$1" + r))
            : !1 !== e.jsonp &&
              (e.url += (Et.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
          (e.converters["script json"] = function () {
            return o || S.error(r + " was not called"), o[0];
          }),
          (e.dataTypes[0] = "json"),
          (i = C[r]),
          (C[r] = function () {
            o = arguments;
          }),
          n.always(function () {
            void 0 === i ? S(C).removeProp(r) : (C[r] = i),
              e[r] && ((e.jsonpCallback = t.jsonpCallback), Xt.push(r)),
              o && m(i) && i(o[0]),
              (o = i = void 0);
          }),
          "script"
        );
    }),
    (y.createHTMLDocument =
      (((Ut = E.implementation.createHTMLDocument("").body).innerHTML =
        "<form></form><form></form>"),
      2 === Ut.childNodes.length)),
    (S.parseHTML = function (e, t, n) {
      return "string" != typeof e
        ? []
        : ("boolean" == typeof t && ((n = t), (t = !1)),
          t ||
            (y.createHTMLDocument
              ? (((r = (t = E.implementation.createHTMLDocument(
                  ""
                )).createElement("base")).href = E.location.href),
                t.head.appendChild(r))
              : (t = E)),
          (o = !n && []),
          (i = N.exec(e))
            ? [t.createElement(i[1])]
            : ((i = xe([e], t, o)),
              o && o.length && S(o).remove(),
              S.merge([], i.childNodes)));
      var r, i, o;
    }),
    (S.fn.load = function (e, t, n) {
      var r,
        i,
        o,
        a = this,
        s = e.indexOf(" ");
      return (
        -1 < s && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
        m(t)
          ? ((n = t), (t = void 0))
          : t && "object" == typeof t && (i = "POST"),
        0 < a.length &&
          S.ajax({ url: e, type: i || "GET", dataType: "html", data: t })
            .done(function (e) {
              (o = arguments),
                a.html(r ? S("<div>").append(S.parseHTML(e)).find(r) : e);
            })
            .always(
              n &&
                function (e, t) {
                  a.each(function () {
                    n.apply(this, o || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    (S.expr.pseudos.animated = function (t) {
      return S.grep(S.timers, function (e) {
        return t === e.elem;
      }).length;
    }),
    (S.offset = {
      setOffset: function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l = S.css(e, "position"),
          c = S(e),
          f = {};
        "static" === l && (e.style.position = "relative"),
          (s = c.offset()),
          (o = S.css(e, "top")),
          (u = S.css(e, "left")),
          ("absolute" === l || "fixed" === l) && -1 < (o + u).indexOf("auto")
            ? ((a = (r = c.position()).top), (i = r.left))
            : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          m(t) && (t = t.call(e, n, S.extend({}, s))),
          null != t.top && (f.top = t.top - s.top + a),
          null != t.left && (f.left = t.left - s.left + i),
          "using" in t
            ? t.using.call(e, f)
            : ("number" == typeof f.top && (f.top += "px"),
              "number" == typeof f.left && (f.left += "px"),
              c.css(f));
      },
    }),
    S.fn.extend({
      offset: function (t) {
        if (arguments.length)
          return void 0 === t
            ? this
            : this.each(function (e) {
                S.offset.setOffset(this, t, e);
              });
        var e,
          n,
          r = this[0];
        return r
          ? r.getClientRects().length
            ? ((e = r.getBoundingClientRect()),
              (n = r.ownerDocument.defaultView),
              { top: e.top + n.pageYOffset, left: e.left + n.pageXOffset })
            : { top: 0, left: 0 }
          : void 0;
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n,
            r = this[0],
            i = { top: 0, left: 0 };
          if ("fixed" === S.css(r, "position")) t = r.getBoundingClientRect();
          else {
            (t = this.offset()),
              (n = r.ownerDocument),
              (e = r.offsetParent || n.documentElement);
            while (
              e &&
              (e === n.body || e === n.documentElement) &&
              "static" === S.css(e, "position")
            )
              e = e.parentNode;
            e &&
              e !== r &&
              1 === e.nodeType &&
              (((i = S(e).offset()).top += S.css(e, "borderTopWidth", !0)),
              (i.left += S.css(e, "borderLeftWidth", !0)));
          }
          return {
            top: t.top - i.top - S.css(r, "marginTop", !0),
            left: t.left - i.left - S.css(r, "marginLeft", !0),
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var e = this.offsetParent;
          while (e && "static" === S.css(e, "position")) e = e.offsetParent;
          return e || re;
        });
      },
    }),
    S.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (
      t,
      i
    ) {
      var o = "pageYOffset" === i;
      S.fn[t] = function (e) {
        return $(
          this,
          function (e, t, n) {
            var r;
            if (
              (x(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView),
              void 0 === n)
            )
              return r ? r[i] : e[t];
            r
              ? r.scrollTo(o ? r.pageXOffset : n, o ? n : r.pageYOffset)
              : (e[t] = n);
          },
          t,
          e,
          arguments.length
        );
      };
    }),
    S.each(["top", "left"], function (e, n) {
      S.cssHooks[n] = $e(y.pixelPosition, function (e, t) {
        if (t)
          return (t = Be(e, n)), Me.test(t) ? S(e).position()[n] + "px" : t;
      });
    }),
    S.each({ Height: "height", Width: "width" }, function (a, s) {
      S.each({ padding: "inner" + a, content: s, "": "outer" + a }, function (
        r,
        o
      ) {
        S.fn[o] = function (e, t) {
          var n = arguments.length && (r || "boolean" != typeof e),
            i = r || (!0 === e || !0 === t ? "margin" : "border");
          return $(
            this,
            function (e, t, n) {
              var r;
              return x(e)
                ? 0 === o.indexOf("outer")
                  ? e["inner" + a]
                  : e.document.documentElement["client" + a]
                : 9 === e.nodeType
                ? ((r = e.documentElement),
                  Math.max(
                    e.body["scroll" + a],
                    r["scroll" + a],
                    e.body["offset" + a],
                    r["offset" + a],
                    r["client" + a]
                  ))
                : void 0 === n
                ? S.css(e, t, i)
                : S.style(e, t, n, i);
            },
            s,
            n ? e : void 0,
            n
          );
        };
      });
    }),
    S.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (e, t) {
        S.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    S.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length
          ? this.off(e, "**")
          : this.off(t, e || "**", n);
      },
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      },
    }),
    S.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
        " "
      ),
      function (e, n) {
        S.fn[n] = function (e, t) {
          return 0 < arguments.length
            ? this.on(n, null, e, t)
            : this.trigger(n);
        };
      }
    );
  var Gt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (S.proxy = function (e, t) {
    var n, r, i;
    if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), m(e)))
      return (
        (r = s.call(arguments, 2)),
        ((i = function () {
          return e.apply(t || this, r.concat(s.call(arguments)));
        }).guid = e.guid = e.guid || S.guid++),
        i
      );
  }),
    (S.holdReady = function (e) {
      e ? S.readyWait++ : S.ready(!0);
    }),
    (S.isArray = Array.isArray),
    (S.parseJSON = JSON.parse),
    (S.nodeName = A),
    (S.isFunction = m),
    (S.isWindow = x),
    (S.camelCase = X),
    (S.type = w),
    (S.now = Date.now),
    (S.isNumeric = function (e) {
      var t = S.type(e);
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
    }),
    (S.trim = function (e) {
      return null == e ? "" : (e + "").replace(Gt, "");
    }),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return S;
      });
  var Yt = C.jQuery,
    Qt = C.$;
  return (
    (S.noConflict = function (e) {
      return C.$ === S && (C.$ = Qt), e && C.jQuery === S && (C.jQuery = Yt), S;
    }),
    "undefined" == typeof e && (C.jQuery = C.$ = S),
    S
  );
});

!(function (e, n) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = n())
    : "function" == typeof define && define.amd
    ? define([], n)
    : "object" == typeof exports
    ? (exports.feather = n())
    : (e.feather = n());
})("undefined" != typeof self ? self : this, function () {
  return (function (e) {
    var n = {};
    function i(t) {
      if (n[t]) return n[t].exports;
      var l = (n[t] = { i: t, l: !1, exports: {} });
      return e[t].call(l.exports, l, l.exports, i), (l.l = !0), l.exports;
    }
    return (
      (i.m = e),
      (i.c = n),
      (i.d = function (e, n, t) {
        i.o(e, n) ||
          Object.defineProperty(e, n, {
            configurable: !1,
            enumerable: !0,
            get: t,
          });
      }),
      (i.r = function (e) {
        Object.defineProperty(e, "__esModule", { value: !0 });
      }),
      (i.n = function (e) {
        var n =
          e && e.__esModule
            ? function () {
                return e.default;
              }
            : function () {
                return e;
              };
        return i.d(n, "a", n), n;
      }),
      (i.o = function (e, n) {
        return Object.prototype.hasOwnProperty.call(e, n);
      }),
      (i.p = ""),
      i((i.s = 80))
    );
  })([
    function (e, n, i) {
      (function (n) {
        var i = "object",
          t = function (e) {
            return e && e.Math == Math && e;
          };
        e.exports =
          t(typeof globalThis == i && globalThis) ||
          t(typeof window == i && window) ||
          t(typeof self == i && self) ||
          t(typeof n == i && n) ||
          Function("return this")();
      }.call(this, i(75)));
    },
    function (e, n) {
      var i = {}.hasOwnProperty;
      e.exports = function (e, n) {
        return i.call(e, n);
      };
    },
    function (e, n, i) {
      var t = i(0),
        l = i(11),
        r = i(33),
        o = i(62),
        a = t.Symbol,
        c = l("wks");
      e.exports = function (e) {
        return c[e] || (c[e] = (o && a[e]) || (o ? a : r)("Symbol." + e));
      };
    },
    function (e, n, i) {
      var t = i(6);
      e.exports = function (e) {
        if (!t(e)) throw TypeError(String(e) + " is not an object");
        return e;
      };
    },
    function (e, n) {
      e.exports = function (e) {
        try {
          return !!e();
        } catch (e) {
          return !0;
        }
      };
    },
    function (e, n, i) {
      var t = i(8),
        l = i(7),
        r = i(10);
      e.exports = t
        ? function (e, n, i) {
            return l.f(e, n, r(1, i));
          }
        : function (e, n, i) {
            return (e[n] = i), e;
          };
    },
    function (e, n) {
      e.exports = function (e) {
        return "object" == typeof e ? null !== e : "function" == typeof e;
      };
    },
    function (e, n, i) {
      var t = i(8),
        l = i(35),
        r = i(3),
        o = i(18),
        a = Object.defineProperty;
      n.f = t
        ? a
        : function (e, n, i) {
            if ((r(e), (n = o(n, !0)), r(i), l))
              try {
                return a(e, n, i);
              } catch (e) {}
            if ("get" in i || "set" in i)
              throw TypeError("Accessors not supported");
            return "value" in i && (e[n] = i.value), e;
          };
    },
    function (e, n, i) {
      var t = i(4);
      e.exports = !t(function () {
        return (
          7 !=
          Object.defineProperty({}, "a", {
            get: function () {
              return 7;
            },
          }).a
        );
      });
    },
    function (e, n) {
      e.exports = {};
    },
    function (e, n) {
      e.exports = function (e, n) {
        return {
          enumerable: !(1 & e),
          configurable: !(2 & e),
          writable: !(4 & e),
          value: n,
        };
      };
    },
    function (e, n, i) {
      var t = i(0),
        l = i(19),
        r = i(17),
        o = t["__core-js_shared__"] || l("__core-js_shared__", {});
      (e.exports = function (e, n) {
        return o[e] || (o[e] = void 0 !== n ? n : {});
      })("versions", []).push({
        version: "3.1.3",
        mode: r ? "pure" : "global",
        copyright: "© 2019 Denis Pushkarev (zloirock.ru)",
      });
    },
    function (e, n, i) {
      "use strict";
      Object.defineProperty(n, "__esModule", { value: !0 });
      var t = o(i(43)),
        l = o(i(41)),
        r = o(i(40));
      function o(e) {
        return e && e.__esModule ? e : { default: e };
      }
      n.default = Object.keys(l.default)
        .map(function (e) {
          return new t.default(e, l.default[e], r.default[e]);
        })
        .reduce(function (e, n) {
          return (e[n.name] = n), e;
        }, {});
    },
    function (e, n) {
      e.exports = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf",
      ];
    },
    function (e, n, i) {
      var t = i(72),
        l = i(20);
      e.exports = function (e) {
        return t(l(e));
      };
    },
    function (e, n) {
      e.exports = {};
    },
    function (e, n, i) {
      var t = i(11),
        l = i(33),
        r = t("keys");
      e.exports = function (e) {
        return r[e] || (r[e] = l(e));
      };
    },
    function (e, n) {
      e.exports = !1;
    },
    function (e, n, i) {
      var t = i(6);
      e.exports = function (e, n) {
        if (!t(e)) return e;
        var i, l;
        if (n && "function" == typeof (i = e.toString) && !t((l = i.call(e))))
          return l;
        if ("function" == typeof (i = e.valueOf) && !t((l = i.call(e))))
          return l;
        if (!n && "function" == typeof (i = e.toString) && !t((l = i.call(e))))
          return l;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    function (e, n, i) {
      var t = i(0),
        l = i(5);
      e.exports = function (e, n) {
        try {
          l(t, e, n);
        } catch (i) {
          t[e] = n;
        }
        return n;
      };
    },
    function (e, n) {
      e.exports = function (e) {
        if (void 0 == e) throw TypeError("Can't call method on " + e);
        return e;
      };
    },
    function (e, n) {
      var i = Math.ceil,
        t = Math.floor;
      e.exports = function (e) {
        return isNaN((e = +e)) ? 0 : (e > 0 ? t : i)(e);
      };
    },
    function (e, n, i) {
      var t;
      /*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
      /*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
      !(function () {
        "use strict";
        var i = (function () {
          function e() {}
          function n(e, n) {
            for (var i = n.length, t = 0; t < i; ++t) l(e, n[t]);
          }
          e.prototype = Object.create(null);
          var i = {}.hasOwnProperty;
          var t = /\s+/;
          function l(e, l) {
            if (l) {
              var r = typeof l;
              "string" === r
                ? (function (e, n) {
                    for (var i = n.split(t), l = i.length, r = 0; r < l; ++r)
                      e[i[r]] = !0;
                  })(e, l)
                : Array.isArray(l)
                ? n(e, l)
                : "object" === r
                ? (function (e, n) {
                    for (var t in n) i.call(n, t) && (e[t] = !!n[t]);
                  })(e, l)
                : "number" === r &&
                  (function (e, n) {
                    e[n] = !0;
                  })(e, l);
            }
          }
          return function () {
            for (var i = arguments.length, t = Array(i), l = 0; l < i; l++)
              t[l] = arguments[l];
            var r = new e();
            n(r, t);
            var o = [];
            for (var a in r) r[a] && o.push(a);
            return o.join(" ");
          };
        })();
        void 0 !== e && e.exports
          ? (e.exports = i)
          : void 0 ===
              (t = function () {
                return i;
              }.apply(n, [])) || (e.exports = t);
      })();
    },
    function (e, n, i) {
      var t = i(7).f,
        l = i(1),
        r = i(2)("toStringTag");
      e.exports = function (e, n, i) {
        e &&
          !l((e = i ? e : e.prototype), r) &&
          t(e, r, { configurable: !0, value: n });
      };
    },
    function (e, n, i) {
      var t = i(20);
      e.exports = function (e) {
        return Object(t(e));
      };
    },
    function (e, n, i) {
      var t = i(1),
        l = i(24),
        r = i(16),
        o = i(63),
        a = r("IE_PROTO"),
        c = Object.prototype;
      e.exports = o
        ? Object.getPrototypeOf
        : function (e) {
            return (
              (e = l(e)),
              t(e, a)
                ? e[a]
                : "function" == typeof e.constructor &&
                  e instanceof e.constructor
                ? e.constructor.prototype
                : e instanceof Object
                ? c
                : null
            );
          };
    },
    function (e, n, i) {
      "use strict";
      var t,
        l,
        r,
        o = i(25),
        a = i(5),
        c = i(1),
        p = i(2),
        y = i(17),
        h = p("iterator"),
        x = !1;
      [].keys &&
        ("next" in (r = [].keys())
          ? (l = o(o(r))) !== Object.prototype && (t = l)
          : (x = !0)),
        void 0 == t && (t = {}),
        y ||
          c(t, h) ||
          a(t, h, function () {
            return this;
          }),
        (e.exports = { IteratorPrototype: t, BUGGY_SAFARI_ITERATORS: x });
    },
    function (e, n, i) {
      var t = i(21),
        l = Math.min;
      e.exports = function (e) {
        return e > 0 ? l(t(e), 9007199254740991) : 0;
      };
    },
    function (e, n, i) {
      var t = i(1),
        l = i(14),
        r = i(68),
        o = i(15),
        a = r(!1);
      e.exports = function (e, n) {
        var i,
          r = l(e),
          c = 0,
          p = [];
        for (i in r) !t(o, i) && t(r, i) && p.push(i);
        for (; n.length > c; ) t(r, (i = n[c++])) && (~a(p, i) || p.push(i));
        return p;
      };
    },
    function (e, n, i) {
      var t = i(0),
        l = i(11),
        r = i(5),
        o = i(1),
        a = i(19),
        c = i(36),
        p = i(37),
        y = p.get,
        h = p.enforce,
        x = String(c).split("toString");
      l("inspectSource", function (e) {
        return c.call(e);
      }),
        (e.exports = function (e, n, i, l) {
          var c = !!l && !!l.unsafe,
            p = !!l && !!l.enumerable,
            y = !!l && !!l.noTargetGet;
          "function" == typeof i &&
            ("string" != typeof n || o(i, "name") || r(i, "name", n),
            (h(i).source = x.join("string" == typeof n ? n : ""))),
            e !== t
              ? (c ? !y && e[n] && (p = !0) : delete e[n],
                p ? (e[n] = i) : r(e, n, i))
              : p
              ? (e[n] = i)
              : a(n, i);
        })(Function.prototype, "toString", function () {
          return ("function" == typeof this && y(this).source) || c.call(this);
        });
    },
    function (e, n) {
      var i = {}.toString;
      e.exports = function (e) {
        return i.call(e).slice(8, -1);
      };
    },
    function (e, n, i) {
      var t = i(8),
        l = i(73),
        r = i(10),
        o = i(14),
        a = i(18),
        c = i(1),
        p = i(35),
        y = Object.getOwnPropertyDescriptor;
      n.f = t
        ? y
        : function (e, n) {
            if (((e = o(e)), (n = a(n, !0)), p))
              try {
                return y(e, n);
              } catch (e) {}
            if (c(e, n)) return r(!l.f.call(e, n), e[n]);
          };
    },
    function (e, n, i) {
      var t = i(0),
        l = i(31).f,
        r = i(5),
        o = i(29),
        a = i(19),
        c = i(71),
        p = i(65);
      e.exports = function (e, n) {
        var i,
          y,
          h,
          x,
          s,
          u = e.target,
          d = e.global,
          f = e.stat;
        if ((i = d ? t : f ? t[u] || a(u, {}) : (t[u] || {}).prototype))
          for (y in n) {
            if (
              ((x = n[y]),
              (h = e.noTargetGet ? (s = l(i, y)) && s.value : i[y]),
              !p(d ? y : u + (f ? "." : "#") + y, e.forced) && void 0 !== h)
            ) {
              if (typeof x == typeof h) continue;
              c(x, h);
            }
            (e.sham || (h && h.sham)) && r(x, "sham", !0), o(i, y, x, e);
          }
      };
    },
    function (e, n) {
      var i = 0,
        t = Math.random();
      e.exports = function (e) {
        return "Symbol(".concat(
          void 0 === e ? "" : e,
          ")_",
          (++i + t).toString(36)
        );
      };
    },
    function (e, n, i) {
      var t = i(0),
        l = i(6),
        r = t.document,
        o = l(r) && l(r.createElement);
      e.exports = function (e) {
        return o ? r.createElement(e) : {};
      };
    },
    function (e, n, i) {
      var t = i(8),
        l = i(4),
        r = i(34);
      e.exports =
        !t &&
        !l(function () {
          return (
            7 !=
            Object.defineProperty(r("div"), "a", {
              get: function () {
                return 7;
              },
            }).a
          );
        });
    },
    function (e, n, i) {
      var t = i(11);
      e.exports = t("native-function-to-string", Function.toString);
    },
    function (e, n, i) {
      var t,
        l,
        r,
        o = i(76),
        a = i(0),
        c = i(6),
        p = i(5),
        y = i(1),
        h = i(16),
        x = i(15),
        s = a.WeakMap;
      if (o) {
        var u = new s(),
          d = u.get,
          f = u.has,
          v = u.set;
        (t = function (e, n) {
          return v.call(u, e, n), n;
        }),
          (l = function (e) {
            return d.call(u, e) || {};
          }),
          (r = function (e) {
            return f.call(u, e);
          });
      } else {
        var g = h("state");
        (x[g] = !0),
          (t = function (e, n) {
            return p(e, g, n), n;
          }),
          (l = function (e) {
            return y(e, g) ? e[g] : {};
          }),
          (r = function (e) {
            return y(e, g);
          });
      }
      e.exports = {
        set: t,
        get: l,
        has: r,
        enforce: function (e) {
          return r(e) ? l(e) : t(e, {});
        },
        getterFor: function (e) {
          return function (n) {
            var i;
            if (!c(n) || (i = l(n)).type !== e)
              throw TypeError("Incompatible receiver, " + e + " required");
            return i;
          };
        },
      };
    },
    function (e, n, i) {
      "use strict";
      Object.defineProperty(n, "__esModule", { value: !0 });
      var t =
          Object.assign ||
          function (e) {
            for (var n = 1; n < arguments.length; n++) {
              var i = arguments[n];
              for (var t in i)
                Object.prototype.hasOwnProperty.call(i, t) && (e[t] = i[t]);
            }
            return e;
          },
        l = o(i(22)),
        r = o(i(12));
      function o(e) {
        return e && e.__esModule ? e : { default: e };
      }
      n.default = function () {
        var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        if ("undefined" == typeof document)
          throw new Error(
            "`feather.replace()` only works in a browser environment."
          );
        var n = document.querySelectorAll("[data-feather]");
        Array.from(n).forEach(function (n) {
          return (function (e) {
            var n =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {},
              i = (function (e) {
                return Array.from(e.attributes).reduce(function (e, n) {
                  return (e[n.name] = n.value), e;
                }, {});
              })(e),
              o = i["data-feather"];
            delete i["data-feather"];
            var a = r.default[o].toSvg(
                t({}, n, i, { class: (0, l.default)(n.class, i.class) })
              ),
              c = new DOMParser()
                .parseFromString(a, "image/svg+xml")
                .querySelector("svg");
            e.parentNode.replaceChild(c, e);
          })(n, e);
        });
      };
    },
    function (e, n, i) {
      "use strict";
      Object.defineProperty(n, "__esModule", { value: !0 });
      var t,
        l = i(12),
        r = (t = l) && t.__esModule ? t : { default: t };
      n.default = function (e) {
        var n =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (
          (console.warn(
            "feather.toSvg() is deprecated. Please use feather.icons[name].toSvg() instead."
          ),
          !e)
        )
          throw new Error(
            "The required `key` (icon name) parameter is missing."
          );
        if (!r.default[e])
          throw new Error(
            "No icon matching '" +
              e +
              "'. See the complete list of icons at https://feathericons.com"
          );
        return r.default[e].toSvg(n);
      };
    },
    function (e) {
      e.exports = {
        activity: ["pulse", "health", "action", "motion"],
        airplay: ["stream", "cast", "mirroring"],
        "alert-circle": ["warning", "alert", "danger"],
        "alert-octagon": ["warning", "alert", "danger"],
        "alert-triangle": ["warning", "alert", "danger"],
        "at-sign": ["mention", "at", "email", "message"],
        award: ["achievement", "badge"],
        aperture: ["camera", "photo"],
        bell: ["alarm", "notification", "sound"],
        "bell-off": ["alarm", "notification", "silent"],
        bluetooth: ["wireless"],
        "book-open": ["read", "library"],
        book: ["read", "dictionary", "booklet", "magazine", "library"],
        bookmark: ["read", "clip", "marker", "tag"],
        briefcase: ["work", "bag", "baggage", "folder"],
        clipboard: ["copy"],
        clock: ["time", "watch", "alarm"],
        "cloud-drizzle": ["weather", "shower"],
        "cloud-lightning": ["weather", "bolt"],
        "cloud-rain": ["weather"],
        "cloud-snow": ["weather", "blizzard"],
        cloud: ["weather"],
        codepen: ["logo"],
        codesandbox: ["logo"],
        coffee: ["drink", "cup", "mug", "tea", "cafe", "hot", "beverage"],
        command: ["keyboard", "cmd", "terminal", "prompt"],
        compass: ["navigation", "safari", "travel", "direction"],
        copy: ["clone", "duplicate"],
        "corner-down-left": ["arrow"],
        "corner-down-right": ["arrow"],
        "corner-left-down": ["arrow"],
        "corner-left-up": ["arrow"],
        "corner-right-down": ["arrow"],
        "corner-right-up": ["arrow"],
        "corner-up-left": ["arrow"],
        "corner-up-right": ["arrow"],
        "credit-card": ["purchase", "payment", "cc"],
        crop: ["photo", "image"],
        crosshair: ["aim", "target"],
        database: ["storage", "memory"],
        delete: ["remove"],
        disc: ["album", "cd", "dvd", "music"],
        "dollar-sign": ["currency", "money", "payment"],
        droplet: ["water"],
        edit: ["pencil", "change"],
        "edit-2": ["pencil", "change"],
        "edit-3": ["pencil", "change"],
        eye: ["view", "watch"],
        "eye-off": ["view", "watch", "hide", "hidden"],
        "external-link": ["outbound"],
        facebook: ["logo", "social"],
        "fast-forward": ["music"],
        figma: ["logo", "design", "tool"],
        film: ["movie", "video"],
        "folder-minus": ["directory"],
        "folder-plus": ["directory"],
        folder: ["directory"],
        framer: ["logo", "design", "tool"],
        frown: ["emoji", "face", "bad", "sad", "emotion"],
        gift: ["present", "box", "birthday", "party"],
        "git-branch": ["code", "version control"],
        "git-commit": ["code", "version control"],
        "git-merge": ["code", "version control"],
        "git-pull-request": ["code", "version control"],
        github: ["logo", "version control"],
        gitlab: ["logo", "version control"],
        global: ["world", "browser", "language", "translate"],
        "hard-drive": ["computer", "server", "memory", "data"],
        hash: ["hashtag", "number", "pound"],
        headphones: ["music", "audio", "sound"],
        heart: ["like", "love", "emotion"],
        "help-circle": ["question mark"],
        hexagon: ["shape", "node.js", "logo"],
        home: ["house", "living"],
        image: ["picture"],
        inbox: ["email"],
        instagram: ["logo", "camera"],
        key: ["password", "login", "authentication", "secure"],
        "life-bouy": ["help", "life ring", "support"],
        linkedin: ["logo", "social media"],
        lock: ["security", "password", "secure"],
        "log-in": ["sign in", "arrow", "enter"],
        "log-out": ["sign out", "arrow", "exit"],
        mail: ["email", "message"],
        "map-pin": ["location", "navigation", "travel", "marker"],
        map: ["location", "navigation", "travel"],
        maximize: ["fullscreen"],
        "maximize-2": ["fullscreen", "arrows", "expand"],
        meh: ["emoji", "face", "neutral", "emotion"],
        menu: ["bars", "navigation", "hamburger"],
        "message-circle": ["comment", "chat"],
        "message-square": ["comment", "chat"],
        "mic-off": ["record", "sound", "mute"],
        mic: ["record", "sound", "listen"],
        minimize: ["exit fullscreen", "close"],
        "minimize-2": ["exit fullscreen", "arrows", "close"],
        monitor: ["tv", "screen", "display"],
        moon: ["dark", "night"],
        "more-horizontal": ["ellipsis"],
        "more-vertical": ["ellipsis"],
        "mouse-pointer": ["arrow", "cursor"],
        move: ["arrows"],
        navigation: ["location", "travel"],
        "navigation-2": ["location", "travel"],
        octagon: ["stop"],
        package: ["box", "container"],
        paperclip: ["attachment"],
        pause: ["music", "stop"],
        "pause-circle": ["music", "audio", "stop"],
        "pen-tool": ["vector", "drawing"],
        play: ["music", "start"],
        "play-circle": ["music", "start"],
        plus: ["add", "new"],
        "plus-circle": ["add", "new"],
        "plus-square": ["add", "new"],
        pocket: ["logo", "save"],
        power: ["on", "off"],
        radio: ["signal"],
        rewind: ["music"],
        rss: ["feed", "subscribe"],
        save: ["floppy disk"],
        search: ["find", "magnifier", "magnifying glass"],
        send: ["message", "mail", "email", "paper airplane", "paper aeroplane"],
        settings: ["cog", "edit", "gear", "preferences"],
        shield: ["security", "secure"],
        "shield-off": ["security", "insecure"],
        "shopping-bag": ["ecommerce", "cart", "purchase", "store"],
        "shopping-cart": ["ecommerce", "cart", "purchase", "store"],
        shuffle: ["music"],
        "skip-back": ["music"],
        "skip-forward": ["music"],
        slash: ["ban", "no"],
        sliders: ["settings", "controls"],
        smile: ["emoji", "face", "happy", "good", "emotion"],
        speaker: ["music"],
        star: ["bookmark", "favorite", "like"],
        sun: ["brightness", "weather", "light"],
        sunrise: ["weather", "time", "morning", "day"],
        sunset: ["weather", "time", "evening", "night"],
        tag: ["label"],
        target: ["bullseye"],
        terminal: ["code", "command line", "prompt"],
        "thumbs-down": ["dislike", "bad", "emotion"],
        "thumbs-up": ["like", "good", "emotion"],
        "toggle-left": ["on", "off", "switch"],
        "toggle-right": ["on", "off", "switch"],
        trash: ["garbage", "delete", "remove", "bin"],
        "trash-2": ["garbage", "delete", "remove", "bin"],
        triangle: ["delta"],
        truck: ["delivery", "van", "shipping", "transport", "lorry"],
        twitter: ["logo", "social"],
        umbrella: ["rain", "weather"],
        "video-off": ["camera", "movie", "film"],
        video: ["camera", "movie", "film"],
        voicemail: ["phone"],
        volume: ["music", "sound", "mute"],
        "volume-1": ["music", "sound"],
        "volume-2": ["music", "sound"],
        "volume-x": ["music", "sound", "mute"],
        watch: ["clock", "time"],
        wind: ["weather", "air"],
        "x-circle": ["cancel", "close", "delete", "remove", "times", "clear"],
        "x-octagon": ["delete", "stop", "alert", "warning", "times", "clear"],
        "x-square": ["cancel", "close", "delete", "remove", "times", "clear"],
        x: ["cancel", "close", "delete", "remove", "times", "clear"],
        youtube: ["logo", "video", "play"],
        "zap-off": ["flash", "camera", "lightning"],
        zap: ["flash", "camera", "lightning"],
      };
    },
    function (e) {
      e.exports = {
        activity:
          '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>',
        airplay:
          '<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon>',
        "alert-circle":
          '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
        "alert-octagon":
          '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
        "alert-triangle":
          '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>',
        "align-center":
          '<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>',
        "align-justify":
          '<line x1="21" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="3" y2="18"></line>',
        "align-left":
          '<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>',
        "align-right":
          '<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>',
        anchor:
          '<circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path>',
        aperture:
          '<circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>',
        archive:
          '<polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line>',
        "arrow-down-circle":
          '<circle cx="12" cy="12" r="10"></circle><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="8" x2="12" y2="16"></line>',
        "arrow-down-left":
          '<line x1="17" y1="7" x2="7" y2="17"></line><polyline points="17 17 7 17 7 7"></polyline>',
        "arrow-down-right":
          '<line x1="7" y1="7" x2="17" y2="17"></line><polyline points="17 7 17 17 7 17"></polyline>',
        "arrow-down":
          '<line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline>',
        "arrow-left-circle":
          '<circle cx="12" cy="12" r="10"></circle><polyline points="12 8 8 12 12 16"></polyline><line x1="16" y1="12" x2="8" y2="12"></line>',
        "arrow-left":
          '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>',
        "arrow-right-circle":
          '<circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line>',
        "arrow-right":
          '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>',
        "arrow-up-circle":
          '<circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line>',
        "arrow-up-left":
          '<line x1="17" y1="17" x2="7" y2="7"></line><polyline points="7 17 7 7 17 7"></polyline>',
        "arrow-up-right":
          '<line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline>',
        "arrow-up":
          '<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>',
        "at-sign":
          '<circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>',
        award:
          '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>',
        "bar-chart-2":
          '<line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line>',
        "bar-chart":
          '<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>',
        "battery-charging":
          '<path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline>',
        battery:
          '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>',
        "bell-off":
          '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
        bell:
          '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>',
        bluetooth:
          '<polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>',
        bold:
          '<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>',
        "book-open":
          '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>',
        book:
          '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>',
        bookmark:
          '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>',
        box:
          '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
        briefcase:
          '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>',
        calendar:
          '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>',
        "camera-off":
          '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"></path>',
        camera:
          '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle>',
        cast:
          '<path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2.01" y2="20"></line>',
        "check-circle":
          '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>',
        "check-square":
          '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>',
        check: '<polyline points="20 6 9 17 4 12"></polyline>',
        "chevron-down": '<polyline points="6 9 12 15 18 9"></polyline>',
        "chevron-left": '<polyline points="15 18 9 12 15 6"></polyline>',
        "chevron-right": '<polyline points="9 18 15 12 9 6"></polyline>',
        "chevron-up": '<polyline points="18 15 12 9 6 15"></polyline>',
        "chevrons-down":
          '<polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline>',
        "chevrons-left":
          '<polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>',
        "chevrons-right":
          '<polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>',
        "chevrons-up":
          '<polyline points="17 11 12 6 7 11"></polyline><polyline points="17 18 12 13 7 18"></polyline>',
        chrome:
          '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>',
        circle: '<circle cx="12" cy="12" r="10"></circle>',
        clipboard:
          '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>',
        clock:
          '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>',
        "cloud-drizzle":
          '<line x1="8" y1="19" x2="8" y2="21"></line><line x1="8" y1="13" x2="8" y2="15"></line><line x1="16" y1="19" x2="16" y2="21"></line><line x1="16" y1="13" x2="16" y2="15"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="12" y1="15" x2="12" y2="17"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
        "cloud-lightning":
          '<path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline points="13 11 9 17 15 17 11 23"></polyline>',
        "cloud-off":
          '<path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
        "cloud-rain":
          '<line x1="16" y1="13" x2="16" y2="21"></line><line x1="8" y1="13" x2="8" y2="21"></line><line x1="12" y1="15" x2="12" y2="23"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
        "cloud-snow":
          '<path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="8" y1="20" x2="8.01" y2="20"></line><line x1="12" y1="18" x2="12.01" y2="18"></line><line x1="12" y1="22" x2="12.01" y2="22"></line><line x1="16" y1="16" x2="16.01" y2="16"></line><line x1="16" y1="20" x2="16.01" y2="20"></line>',
        cloud:
          '<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>',
        code:
          '<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>',
        codepen:
          '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>',
        codesandbox:
          '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
        coffee:
          '<path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line>',
        columns:
          '<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>',
        command:
          '<path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>',
        compass:
          '<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>',
        copy:
          '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>',
        "corner-down-left":
          '<polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path>',
        "corner-down-right":
          '<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>',
        "corner-left-down":
          '<polyline points="14 15 9 20 4 15"></polyline><path d="M20 4h-7a4 4 0 0 0-4 4v12"></path>',
        "corner-left-up":
          '<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>',
        "corner-right-down":
          '<polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>',
        "corner-right-up":
          '<polyline points="10 9 15 4 20 9"></polyline><path d="M4 20h7a4 4 0 0 0 4-4V4"></path>',
        "corner-up-left":
          '<polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>',
        "corner-up-right":
          '<polyline points="15 14 20 9 15 4"></polyline><path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>',
        cpu:
          '<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line>',
        "credit-card":
          '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>',
        crop:
          '<path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>',
        crosshair:
          '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>',
        database:
          '<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>',
        delete:
          '<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line>',
        disc:
          '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>',
        "dollar-sign":
          '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>',
        "download-cloud":
          '<polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>',
        download:
          '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>',
        droplet: '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>',
        "edit-2":
          '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>',
        "edit-3":
          '<path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>',
        edit:
          '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>',
        "external-link":
          '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>',
        "eye-off":
          '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
        eye:
          '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
        facebook:
          '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>',
        "fast-forward":
          '<polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon>',
        feather:
          '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>',
        figma:
          '<path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"></path><path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"></path><path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"></path><path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"></path><path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"></path>',
        "file-minus":
          '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="9" y1="15" x2="15" y2="15"></line>',
        "file-plus":
          '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line>',
        "file-text":
          '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>',
        file:
          '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>',
        film:
          '<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line>',
        filter:
          '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>',
        flag:
          '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>',
        "folder-minus":
          '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="9" y1="14" x2="15" y2="14"></line>',
        "folder-plus":
          '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line>',
        folder:
          '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>',
        framer: '<path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>',
        frown:
          '<circle cx="12" cy="12" r="10"></circle><path d="M16 16s-1.5-2-4-2-4 2-4 2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
        gift:
          '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>',
        "git-branch":
          '<line x1="6" y1="3" x2="6" y2="15"></line><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path>',
        "git-commit":
          '<circle cx="12" cy="12" r="4"></circle><line x1="1.05" y1="12" x2="7" y2="12"></line><line x1="17.01" y1="12" x2="22.96" y2="12"></line>',
        "git-merge":
          '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M6 21V9a9 9 0 0 0 9 9"></path>',
        "git-pull-request":
          '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M13 6h3a2 2 0 0 1 2 2v7"></path><line x1="6" y1="9" x2="6" y2="21"></line>',
        github:
          '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>',
        gitlab:
          '<path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>',
        globe:
          '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>',
        grid:
          '<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>',
        "hard-drive":
          '<line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line>',
        hash:
          '<line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line>',
        headphones:
          '<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>',
        heart:
          '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
        "help-circle":
          '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>',
        hexagon:
          '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>',
        home:
          '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>',
        image:
          '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>',
        inbox:
          '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>',
        info:
          '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
        instagram:
          '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>',
        italic:
          '<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>',
        key:
          '<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>',
        layers:
          '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>',
        layout:
          '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line>',
        "life-buoy":
          '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line><line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>',
        "link-2":
          '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path><line x1="8" y1="12" x2="16" y2="12"></line>',
        link:
          '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>',
        linkedin:
          '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>',
        list:
          '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>',
        loader:
          '<line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>',
        lock:
          '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>',
        "log-in":
          '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>',
        "log-out":
          '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>',
        mail:
          '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>',
        "map-pin":
          '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>',
        map:
          '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line>',
        "maximize-2":
          '<polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
        maximize:
          '<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>',
        meh:
          '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
        menu:
          '<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>',
        "message-circle":
          '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>',
        "message-square":
          '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>',
        "mic-off":
          '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
        mic:
          '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
        "minimize-2":
          '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
        minimize:
          '<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>',
        "minus-circle":
          '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line>',
        "minus-square":
          '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>',
        minus: '<line x1="5" y1="12" x2="19" y2="12"></line>',
        monitor:
          '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>',
        moon:
          '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>',
        "more-horizontal":
          '<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>',
        "more-vertical":
          '<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>',
        "mouse-pointer":
          '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="M13 13l6 6"></path>',
        move:
          '<polyline points="5 9 2 12 5 15"></polyline><polyline points="9 5 12 2 15 5"></polyline><polyline points="15 19 12 22 9 19"></polyline><polyline points="19 9 22 12 19 15"></polyline><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line>',
        music:
          '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>',
        "navigation-2":
          '<polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>',
        navigation: '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>',
        octagon:
          '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>',
        package:
          '<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
        paperclip:
          '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>',
        "pause-circle":
          '<circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line>',
        pause:
          '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>',
        "pen-tool":
          '<path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle>',
        percent:
          '<line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>',
        "phone-call":
          '<path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
        "phone-forwarded":
          '<polyline points="19 1 23 5 19 9"></polyline><line x1="15" y1="5" x2="23" y2="5"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
        "phone-incoming":
          '<polyline points="16 2 16 8 22 8"></polyline><line x1="23" y1="1" x2="16" y2="8"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
        "phone-missed":
          '<line x1="23" y1="1" x2="17" y2="7"></line><line x1="17" y1="1" x2="23" y2="7"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
        "phone-off":
          '<path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line>',
        "phone-outgoing":
          '<polyline points="23 7 23 1 17 1"></polyline><line x1="16" y1="8" x2="23" y2="1"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
        phone:
          '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
        "pie-chart":
          '<path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>',
        "play-circle":
          '<circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon>',
        play: '<polygon points="5 3 19 12 5 21 5 3"></polygon>',
        "plus-circle":
          '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
        "plus-square":
          '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
        plus:
          '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>',
        pocket:
          '<path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path><polyline points="8 10 12 14 16 10"></polyline>',
        power:
          '<path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line>',
        printer:
          '<polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect>',
        radio:
          '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>',
        "refresh-ccw":
          '<polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>',
        "refresh-cw":
          '<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>',
        repeat:
          '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>',
        rewind:
          '<polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>',
        "rotate-ccw":
          '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>',
        "rotate-cw":
          '<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>',
        rss:
          '<path d="M4 11a9 9 0 0 1 9 9"></path><path d="M4 4a16 16 0 0 1 16 16"></path><circle cx="5" cy="19" r="1"></circle>',
        save:
          '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>',
        scissors:
          '<circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>',
        search:
          '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>',
        send:
          '<line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>',
        server:
          '<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line>',
        settings:
          '<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>',
        "share-2":
          '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>',
        share:
          '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line>',
        "shield-off":
          '<path d="M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"></path><path d="M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
        shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>',
        "shopping-bag":
          '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>',
        "shopping-cart":
          '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
        shuffle:
          '<polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>',
        sidebar:
          '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line>',
        "skip-back":
          '<polygon points="19 20 9 12 19 4 19 20"></polygon><line x1="5" y1="19" x2="5" y2="5"></line>',
        "skip-forward":
          '<polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line>',
        slack:
          '<path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>',
        slash:
          '<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>',
        sliders:
          '<line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line>',
        smartphone:
          '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
        smile:
          '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
        speaker:
          '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><circle cx="12" cy="14" r="4"></circle><line x1="12" y1="6" x2="12.01" y2="6"></line>',
        square:
          '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
        star:
          '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>',
        "stop-circle":
          '<circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6"></rect>',
        sun:
          '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>',
        sunrise:
          '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>',
        sunset:
          '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>',
        tablet:
          '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
        tag:
          '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>',
        target:
          '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>',
        terminal:
          '<polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line>',
        thermometer:
          '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>',
        "thumbs-down":
          '<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>',
        "thumbs-up":
          '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>',
        "toggle-left":
          '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>',
        "toggle-right":
          '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>',
        tool:
          '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>',
        "trash-2":
          '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>',
        trash:
          '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>',
        trello:
          '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><rect x="7" y="7" width="3" height="9"></rect><rect x="14" y="7" width="3" height="5"></rect>',
        "trending-down":
          '<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline>',
        "trending-up":
          '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>',
        triangle:
          '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>',
        truck:
          '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>',
        tv:
          '<rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline>',
        twitch: '<path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"></path>',
        twitter:
          '<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>',
        type:
          '<polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line>',
        umbrella:
          '<path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"></path>',
        underline:
          '<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>',
        unlock:
          '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path>',
        "upload-cloud":
          '<polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline>',
        upload:
          '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>',
        "user-check":
          '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline>',
        "user-minus":
          '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line>',
        "user-plus":
          '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>',
        "user-x":
          '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line>',
        user:
          '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>',
        users:
          '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
        "video-off":
          '<path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
        video:
          '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>',
        voicemail:
          '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>',
        "volume-1":
          '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
        "volume-2":
          '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
        "volume-x":
          '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>',
        volume:
          '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>',
        watch:
          '<circle cx="12" cy="12" r="7"></circle><polyline points="12 9 12 12 13.5 13.5"></polyline><path d="M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"></path>',
        "wifi-off":
          '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path><path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
        wifi:
          '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
        wind:
          '<path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path>',
        "x-circle":
          '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
        "x-octagon":
          '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
        "x-square":
          '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line>',
        x:
          '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
        youtube:
          '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>',
        "zap-off":
          '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>',
        zap:
          '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>',
        "zoom-in":
          '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
        "zoom-out":
          '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
      };
    },
    function (e) {
      e.exports = {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": 2,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      };
    },
    function (e, n, i) {
      "use strict";
      Object.defineProperty(n, "__esModule", { value: !0 });
      var t =
          Object.assign ||
          function (e) {
            for (var n = 1; n < arguments.length; n++) {
              var i = arguments[n];
              for (var t in i)
                Object.prototype.hasOwnProperty.call(i, t) && (e[t] = i[t]);
            }
            return e;
          },
        l = (function () {
          function e(e, n) {
            for (var i = 0; i < n.length; i++) {
              var t = n[i];
              (t.enumerable = t.enumerable || !1),
                (t.configurable = !0),
                "value" in t && (t.writable = !0),
                Object.defineProperty(e, t.key, t);
            }
          }
          return function (n, i, t) {
            return i && e(n.prototype, i), t && e(n, t), n;
          };
        })(),
        r = a(i(22)),
        o = a(i(42));
      function a(e) {
        return e && e.__esModule ? e : { default: e };
      }
      var c = (function () {
        function e(n, i) {
          var l =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
          !(function (e, n) {
            if (!(e instanceof n))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.name = n),
            (this.contents = i),
            (this.tags = l),
            (this.attrs = t({}, o.default, { class: "feather feather-" + n }));
        }
        return (
          l(e, [
            {
              key: "toSvg",
              value: function () {
                var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {};
                return (
                  "<svg " +
                  (function (e) {
                    return Object.keys(e)
                      .map(function (n) {
                        return n + '="' + e[n] + '"';
                      })
                      .join(" ");
                  })(
                    t({}, this.attrs, e, {
                      class: (0, r.default)(this.attrs.class, e.class),
                    })
                  ) +
                  ">" +
                  this.contents +
                  "</svg>"
                );
              },
            },
            {
              key: "toString",
              value: function () {
                return this.contents;
              },
            },
          ]),
          e
        );
      })();
      n.default = c;
    },
    function (e, n, i) {
      "use strict";
      var t = o(i(12)),
        l = o(i(39)),
        r = o(i(38));
      function o(e) {
        return e && e.__esModule ? e : { default: e };
      }
      e.exports = { icons: t.default, toSvg: l.default, replace: r.default };
    },
    function (e, n, i) {
      e.exports = i(0);
    },
    function (e, n, i) {
      var t = i(2)("iterator"),
        l = !1;
      try {
        var r = 0,
          o = {
            next: function () {
              return { done: !!r++ };
            },
            return: function () {
              l = !0;
            },
          };
        (o[t] = function () {
          return this;
        }),
          Array.from(o, function () {
            throw 2;
          });
      } catch (e) {}
      e.exports = function (e, n) {
        if (!n && !l) return !1;
        var i = !1;
        try {
          var r = {};
          (r[t] = function () {
            return {
              next: function () {
                return { done: (i = !0) };
              },
            };
          }),
            e(r);
        } catch (e) {}
        return i;
      };
    },
    function (e, n, i) {
      var t = i(30),
        l = i(2)("toStringTag"),
        r =
          "Arguments" ==
          t(
            (function () {
              return arguments;
            })()
          );
      e.exports = function (e) {
        var n, i, o;
        return void 0 === e
          ? "Undefined"
          : null === e
          ? "Null"
          : "string" ==
            typeof (i = (function (e, n) {
              try {
                return e[n];
              } catch (e) {}
            })((n = Object(e)), l))
          ? i
          : r
          ? t(n)
          : "Object" == (o = t(n)) && "function" == typeof n.callee
          ? "Arguments"
          : o;
      };
    },
    function (e, n, i) {
      var t = i(47),
        l = i(9),
        r = i(2)("iterator");
      e.exports = function (e) {
        if (void 0 != e) return e[r] || e["@@iterator"] || l[t(e)];
      };
    },
    function (e, n, i) {
      "use strict";
      var t = i(18),
        l = i(7),
        r = i(10);
      e.exports = function (e, n, i) {
        var o = t(n);
        o in e ? l.f(e, o, r(0, i)) : (e[o] = i);
      };
    },
    function (e, n, i) {
      var t = i(2),
        l = i(9),
        r = t("iterator"),
        o = Array.prototype;
      e.exports = function (e) {
        return void 0 !== e && (l.Array === e || o[r] === e);
      };
    },
    function (e, n, i) {
      var t = i(3);
      e.exports = function (e, n, i, l) {
        try {
          return l ? n(t(i)[0], i[1]) : n(i);
        } catch (n) {
          var r = e.return;
          throw (void 0 !== r && t(r.call(e)), n);
        }
      };
    },
    function (e, n) {
      e.exports = function (e) {
        if ("function" != typeof e)
          throw TypeError(String(e) + " is not a function");
        return e;
      };
    },
    function (e, n, i) {
      var t = i(52);
      e.exports = function (e, n, i) {
        if ((t(e), void 0 === n)) return e;
        switch (i) {
          case 0:
            return function () {
              return e.call(n);
            };
          case 1:
            return function (i) {
              return e.call(n, i);
            };
          case 2:
            return function (i, t) {
              return e.call(n, i, t);
            };
          case 3:
            return function (i, t, l) {
              return e.call(n, i, t, l);
            };
        }
        return function () {
          return e.apply(n, arguments);
        };
      };
    },
    function (e, n, i) {
      "use strict";
      var t = i(53),
        l = i(24),
        r = i(51),
        o = i(50),
        a = i(27),
        c = i(49),
        p = i(48);
      e.exports = function (e) {
        var n,
          i,
          y,
          h,
          x = l(e),
          s = "function" == typeof this ? this : Array,
          u = arguments.length,
          d = u > 1 ? arguments[1] : void 0,
          f = void 0 !== d,
          v = 0,
          g = p(x);
        if (
          (f && (d = t(d, u > 2 ? arguments[2] : void 0, 2)),
          void 0 == g || (s == Array && o(g)))
        )
          for (i = new s((n = a(x.length))); n > v; v++)
            c(i, v, f ? d(x[v], v) : x[v]);
        else
          for (h = g.call(x), i = new s(); !(y = h.next()).done; v++)
            c(i, v, f ? r(h, d, [y.value, v], !0) : y.value);
        return (i.length = v), i;
      };
    },
    function (e, n, i) {
      var t = i(32),
        l = i(54);
      t(
        {
          target: "Array",
          stat: !0,
          forced: !i(46)(function (e) {
            Array.from(e);
          }),
        },
        { from: l }
      );
    },
    function (e, n, i) {
      var t = i(6),
        l = i(3);
      e.exports = function (e, n) {
        if ((l(e), !t(n) && null !== n))
          throw TypeError("Can't set " + String(n) + " as a prototype");
      };
    },
    function (e, n, i) {
      var t = i(56);
      e.exports =
        Object.setPrototypeOf ||
        ("__proto__" in {}
          ? (function () {
              var e,
                n = !1,
                i = {};
              try {
                (e = Object.getOwnPropertyDescriptor(
                  Object.prototype,
                  "__proto__"
                ).set).call(i, []),
                  (n = i instanceof Array);
              } catch (e) {}
              return function (i, l) {
                return t(i, l), n ? e.call(i, l) : (i.__proto__ = l), i;
              };
            })()
          : void 0);
    },
    function (e, n, i) {
      var t = i(0).document;
      e.exports = t && t.documentElement;
    },
    function (e, n, i) {
      var t = i(28),
        l = i(13);
      e.exports =
        Object.keys ||
        function (e) {
          return t(e, l);
        };
    },
    function (e, n, i) {
      var t = i(8),
        l = i(7),
        r = i(3),
        o = i(59);
      e.exports = t
        ? Object.defineProperties
        : function (e, n) {
            r(e);
            for (var i, t = o(n), a = t.length, c = 0; a > c; )
              l.f(e, (i = t[c++]), n[i]);
            return e;
          };
    },
    function (e, n, i) {
      var t = i(3),
        l = i(60),
        r = i(13),
        o = i(15),
        a = i(58),
        c = i(34),
        p = i(16)("IE_PROTO"),
        y = function () {},
        h = function () {
          var e,
            n = c("iframe"),
            i = r.length;
          for (
            n.style.display = "none",
              a.appendChild(n),
              n.src = String("javascript:"),
              (e = n.contentWindow.document).open(),
              e.write("<script>document.F=Object</script>"),
              e.close(),
              h = e.F;
            i--;

          )
            delete h.prototype[r[i]];
          return h();
        };
      (e.exports =
        Object.create ||
        function (e, n) {
          var i;
          return (
            null !== e
              ? ((y.prototype = t(e)),
                (i = new y()),
                (y.prototype = null),
                (i[p] = e))
              : (i = h()),
            void 0 === n ? i : l(i, n)
          );
        }),
        (o[p] = !0);
    },
    function (e, n, i) {
      var t = i(4);
      e.exports =
        !!Object.getOwnPropertySymbols &&
        !t(function () {
          return !String(Symbol());
        });
    },
    function (e, n, i) {
      var t = i(4);
      e.exports = !t(function () {
        function e() {}
        return (
          (e.prototype.constructor = null),
          Object.getPrototypeOf(new e()) !== e.prototype
        );
      });
    },
    function (e, n, i) {
      "use strict";
      var t = i(26).IteratorPrototype,
        l = i(61),
        r = i(10),
        o = i(23),
        a = i(9),
        c = function () {
          return this;
        };
      e.exports = function (e, n, i) {
        var p = n + " Iterator";
        return (
          (e.prototype = l(t, { next: r(1, i) })),
          o(e, p, !1, !0),
          (a[p] = c),
          e
        );
      };
    },
    function (e, n, i) {
      var t = i(4),
        l = /#|\.prototype\./,
        r = function (e, n) {
          var i = a[o(e)];
          return i == p || (i != c && ("function" == typeof n ? t(n) : !!n));
        },
        o = (r.normalize = function (e) {
          return String(e).replace(l, ".").toLowerCase();
        }),
        a = (r.data = {}),
        c = (r.NATIVE = "N"),
        p = (r.POLYFILL = "P");
      e.exports = r;
    },
    function (e, n) {
      n.f = Object.getOwnPropertySymbols;
    },
    function (e, n, i) {
      var t = i(21),
        l = Math.max,
        r = Math.min;
      e.exports = function (e, n) {
        var i = t(e);
        return i < 0 ? l(i + n, 0) : r(i, n);
      };
    },
    function (e, n, i) {
      var t = i(14),
        l = i(27),
        r = i(67);
      e.exports = function (e) {
        return function (n, i, o) {
          var a,
            c = t(n),
            p = l(c.length),
            y = r(o, p);
          if (e && i != i) {
            for (; p > y; ) if ((a = c[y++]) != a) return !0;
          } else
            for (; p > y; y++)
              if ((e || y in c) && c[y] === i) return e || y || 0;
          return !e && -1;
        };
      };
    },
    function (e, n, i) {
      var t = i(28),
        l = i(13).concat("length", "prototype");
      n.f =
        Object.getOwnPropertyNames ||
        function (e) {
          return t(e, l);
        };
    },
    function (e, n, i) {
      var t = i(0),
        l = i(69),
        r = i(66),
        o = i(3),
        a = t.Reflect;
      e.exports =
        (a && a.ownKeys) ||
        function (e) {
          var n = l.f(o(e)),
            i = r.f;
          return i ? n.concat(i(e)) : n;
        };
    },
    function (e, n, i) {
      var t = i(1),
        l = i(70),
        r = i(31),
        o = i(7);
      e.exports = function (e, n) {
        for (var i = l(n), a = o.f, c = r.f, p = 0; p < i.length; p++) {
          var y = i[p];
          t(e, y) || a(e, y, c(n, y));
        }
      };
    },
    function (e, n, i) {
      var t = i(4),
        l = i(30),
        r = "".split;
      e.exports = t(function () {
        return !Object("z").propertyIsEnumerable(0);
      })
        ? function (e) {
            return "String" == l(e) ? r.call(e, "") : Object(e);
          }
        : Object;
    },
    function (e, n, i) {
      "use strict";
      var t = {}.propertyIsEnumerable,
        l = Object.getOwnPropertyDescriptor,
        r = l && !t.call({ 1: 2 }, 1);
      n.f = r
        ? function (e) {
            var n = l(this, e);
            return !!n && n.enumerable;
          }
        : t;
    },
    function (e, n, i) {
      "use strict";
      var t = i(32),
        l = i(64),
        r = i(25),
        o = i(57),
        a = i(23),
        c = i(5),
        p = i(29),
        y = i(2),
        h = i(17),
        x = i(9),
        s = i(26),
        u = s.IteratorPrototype,
        d = s.BUGGY_SAFARI_ITERATORS,
        f = y("iterator"),
        v = function () {
          return this;
        };
      e.exports = function (e, n, i, y, s, g, m) {
        l(i, n, y);
        var M,
          w,
          b,
          z = function (e) {
            if (e === s && O) return O;
            if (!d && e in H) return H[e];
            switch (e) {
              case "keys":
              case "values":
              case "entries":
                return function () {
                  return new i(this, e);
                };
            }
            return function () {
              return new i(this);
            };
          },
          A = n + " Iterator",
          k = !1,
          H = e.prototype,
          V = H[f] || H["@@iterator"] || (s && H[s]),
          O = (!d && V) || z(s),
          j = ("Array" == n && H.entries) || V;
        if (
          (j &&
            ((M = r(j.call(new e()))),
            u !== Object.prototype &&
              M.next &&
              (h ||
                r(M) === u ||
                (o ? o(M, u) : "function" != typeof M[f] && c(M, f, v)),
              a(M, A, !0, !0),
              h && (x[A] = v))),
          "values" == s &&
            V &&
            "values" !== V.name &&
            ((k = !0),
            (O = function () {
              return V.call(this);
            })),
          (h && !m) || H[f] === O || c(H, f, O),
          (x[n] = O),
          s)
        )
          if (
            ((w = {
              values: z("values"),
              keys: g ? O : z("keys"),
              entries: z("entries"),
            }),
            m)
          )
            for (b in w) (!d && !k && b in H) || p(H, b, w[b]);
          else t({ target: n, proto: !0, forced: d || k }, w);
        return w;
      };
    },
    function (e, n) {
      var i;
      i = (function () {
        return this;
      })();
      try {
        i = i || Function("return this")() || (0, eval)("this");
      } catch (e) {
        "object" == typeof window && (i = window);
      }
      e.exports = i;
    },
    function (e, n, i) {
      var t = i(0),
        l = i(36),
        r = t.WeakMap;
      e.exports = "function" == typeof r && /native code/.test(l.call(r));
    },
    function (e, n, i) {
      var t = i(21),
        l = i(20);
      e.exports = function (e, n, i) {
        var r,
          o,
          a = String(l(e)),
          c = t(n),
          p = a.length;
        return c < 0 || c >= p
          ? i
            ? ""
            : void 0
          : (r = a.charCodeAt(c)) < 55296 ||
            r > 56319 ||
            c + 1 === p ||
            (o = a.charCodeAt(c + 1)) < 56320 ||
            o > 57343
          ? i
            ? a.charAt(c)
            : r
          : i
          ? a.slice(c, c + 2)
          : o - 56320 + ((r - 55296) << 10) + 65536;
      };
    },
    function (e, n, i) {
      "use strict";
      var t = i(77),
        l = i(37),
        r = i(74),
        o = l.set,
        a = l.getterFor("String Iterator");
      r(
        String,
        "String",
        function (e) {
          o(this, { type: "String Iterator", string: String(e), index: 0 });
        },
        function () {
          var e,
            n = a(this),
            i = n.string,
            l = n.index;
          return l >= i.length
            ? { value: void 0, done: !0 }
            : ((e = t(i, l, !0)),
              (n.index += e.length),
              { value: e, done: !1 });
        }
      );
    },
    function (e, n, i) {
      i(78), i(55);
      var t = i(45);
      e.exports = t.Array.from;
    },
    function (e, n, i) {
      i(79), (e.exports = i(44));
    },
  ]);
});
//# sourceMappingURL=feather.min.js.map
!(function (a) {
  var t = {};
  function c(h) {
    if (t[h]) return t[h].exports;
    var l = (t[h] = { i: h, l: !1, exports: {} });
    return a[h].call(l.exports, l, l.exports, c), (l.l = !0), l.exports;
  }
  (c.m = a),
    (c.c = t),
    (c.d = function (a, t, h) {
      c.o(a, t) || Object.defineProperty(a, t, { enumerable: !0, get: h });
    }),
    (c.r = function (a) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(a, "__esModule", { value: !0 });
    }),
    (c.t = function (a, t) {
      if ((1 & t && (a = c(a)), 8 & t)) return a;
      if (4 & t && "object" == typeof a && a && a.__esModule) return a;
      var h = Object.create(null);
      if (
        (c.r(h),
        Object.defineProperty(h, "default", { enumerable: !0, value: a }),
        2 & t && "string" != typeof a)
      )
        for (var l in a)
          c.d(
            h,
            l,
            function (t) {
              return a[t];
            }.bind(null, l)
          );
      return h;
    }),
    (c.n = function (a) {
      var t =
        a && a.__esModule
          ? function () {
              return a.default;
            }
          : function () {
              return a;
            };
      return c.d(t, "a", t), t;
    }),
    (c.o = function (a, t) {
      return Object.prototype.hasOwnProperty.call(a, t);
    }),
    (c.p = ""),
    c((c.s = 1));
})([
  function (a) {
    a.exports = {
      activity:
        '    <path class="vi-primary" d="M20,33a2,2,0,0,1-1.788-1.1l-3.6-7.183-2.047,2.551A2,2,0,0,1,11,28.013H7a1.994,1.994,0,1,1,0-3.988h3.039l3.4-4.237a2,2,0,0,1,3.351.354l2.7,5.386,2.588-9.03a2,2,0,0,1,3.75-.262l3.473,7.79H32a1.994,1.994,0,1,1,0,3.988H28a2,2,0,0,1-1.827-1.184L24.41,22.874l-2.487,8.678a2,2,0,0,1-1.737,1.437C20.123,33,20.061,33,20,33Z"></path>  <path class="vi-accent" d="M37,32a6,6,0,1,1,6-6A6,6,0,0,1,37,32Zm0-8.717A2.72,2.72,0,1,0,39.728,26,2.724,2.724,0,0,0,37,23.283Z"></path>',
      angleBottom:
        '    <path class="vi-primary" d="M9,18L24,33,39,18l-3-3L24,27,12,15Z"></path>  <path class="vi-accent" d="M17.5,20.5l-3,3L9,18l3-3Zm13,0L36,15l3,3-5.5,5.5Z"></path>',
      angleLeft:
        '    <path class="vi-primary" d="M30,9L15,24,30,39l3-3L21,24,33,12Z"></path>  <path class="vi-accent" d="M27.5,17.5l-3-3L30,9l3,3Zm0,13L33,36l-3,3-5.5-5.5Z"></path>',
      angleRight:
        '    <path class="vi-primary" d="M17,9L32,24,17,39l-3-3L26,24,14,12Z"></path>  <path class="vi-accent" d="M19.5,17.5l3-3L17,9l-3,3Zm0,13L14,36l3,3,5.5-5.5Z"></path>',
      angleTop:
        '    <path class="vi-primary" d="M9,30L24,15,39,30l-3,3L24,21,12,33Z"></path>  <path class="vi-accent" d="M17.5,27.5l-3-3L9,30l3,3Zm13,0L36,33l3-3-5.5-5.5Z"></path>',
      arrowBottom:
        '    <path class="vi-primary" d="M26,10V30l5-5,3,3L24,38,14,28l3-3,5,5V10h4Z"></path>  <path class="vi-accent" d="M22,18h4V10H22v8Z"></path>',
      arrowLeft:
        '    <path class="vi-primary" d="M38,26H18l5,5-3,3L10,24,20,14l3,3-5,5H38v4Z"></path>  <path class="vi-accent" d="M30,22v4h8V22H30Z"></path>',
      arrowRight:
        '    <path class="vi-primary" d="M10,26H30l-5,5,3,3L38,24,28,14l-3,3,5,5H10v4Z"></path>  <path class="vi-accent" d="M18,22v4H10V22h8Z"></path>',
      arrowTop:
        '    <path class="vi-primary" d="M26,38V18l5,5,3-3L24,10,14,20l3,3,5-5V38h4Z"></path>  <rect class="vi-accent" x="22" y="30" width="4" height="8"></rect>',
      badge:
        '    <path class="vi-primary" d="M17.012,29V43L24,36l6.988,7V29H17.012Z"></path>  <circle class="vi-accent" cx="24" cy="19" r="14"></circle>  <circle class="vi-primary" cx="24" cy="19" r="6"></circle>',
      bag:
        '    <path class="vi-primary" d="M13.394,15H34.606L38,41H10Z"></path>  <path class="vi-accent" d="M10,41h0l0.522-4H37.478L38,41H10ZM28,14c0-1.516-.737-5-4-5s-4,3.484-4,5v1H17l0.01-2.951C17.01,9.017,20.053,6,24,6s6.99,3.017,6.99,6.049L31,15H28V14Z"></path>  <path class="vi-prop" d="M17,15L17.009,17l3,0V15H17Zm10.989,0v1.989l3,0L31,15H27.991Z"></path>',
      battery:
        '    <rect class="vi-primary" x="6" y="15" width="34" height="18"></rect>  <path class="vi-accent" d="M40,19h3V29H40V19ZM23,18l-5,6,4,1-4,5,11-6-6-1,6-5H23Z"></path>',
      bottle:
        '    <path class="vi-primary" d="M20,8V5h8V8H20ZM16,43V25.187c0-10.6,8-10.179,8-10.179h0s8-.57,8,10.179V43H16Z"></path>  <path class="vi-accent" d="M21,16V8h6v8H21Zm4,9h7V37H25V25Z"></path>',
      box:
        '    <rect class="vi-primary" x="8" y="17" width="32" height="24"></rect>  <path class="vi-accent" d="M40,17H26l7-9H47ZM1,8H15l7,9H8ZM40,41H8V39H40v2Z"></path>',
      briefcase:
        '    <path class="vi-primary" d="M7,18H41V36H7V18Zm11-6h3V11h6v1h3V8H18v4Z"></path>  <path class="vi-accent" d="M6,17V12H42v5C41.983,26.1,6,27.672,6,17Z"></path>  <circle class="vi-prop" cx="24" cy="24" r="5"></circle>  <circle class="vi-accent" cx="24" cy="24" r="2"></circle>',
      building:
        '    <path class="vi-primary" d="M41,42H8V7H25V17.99H41V42Z"></path>  <path class="vi-accent" d="M35.012,39V36.01h3V39h-3Zm0-8.01h3v3.018h-3V30.99Zm0-4.992h3v2.989h-3V26Zm0-4.993h3V24h-3v-2.99Zm-5,15.005h3V39h-3V36.01Zm0-5.021h3v3.018h-3V30.99Zm0-4.992h3v2.989h-3V26Zm0-4.993h3V24h-3v-2.99ZM25,18h2V42H25V18ZM11.994,37h9.012v2.015H11.994V37Zm0-5h9.012v2.015H11.994V31.994Zm0-5h9.012v2.015H11.994V26.992Zm0-5h9.012v2.015H11.994V21.991Zm0-5h9.012V19H11.994V16.989Zm0-5h9.012V14H11.994V11.987Z"></path>',
      bulb:
        '    <rect class="vi-accent" x="19" y="37" width="10" height="5"></rect>  <path class="vi-primary" d="M31,30c-1.917,1.186-2,3.742-2,6v1H19V36c0-2.258-.118-4.874-2-6a13.355,13.355,0,0,1-6-11.308A12.849,12.849,0,0,1,24,6,12.849,12.849,0,0,1,37,18.692,13.355,13.355,0,0,1,31,30Z"></path>  <path class="vi-prop" d="M26,27.633V37H22V27.633A5.982,5.982,0,0,1,18,22h3.6a2.4,2.4,0,0,0,4.8,0H30A5.982,5.982,0,0,1,26,27.633Z"></path>',
      bullhorn:
        '    <path class="vi-primary" d="M10.248,32.648l1.359,7.366L17.945,40,16,32ZM17,32L14,22,32.518,8,39,35Z"></path>  <path class="vi-accent" d="M20,17l7-5,5,22-8-1ZM7,30c-0.633-2.541.638-5.319,3-6l4-2,3,10-4,1C10.638,33.681,7.633,32.542,7,30ZM36.82,25.917L34.5,16.255A4.945,4.945,0,0,1,36,16,4.992,4.992,0,0,1,36.82,25.917Z"></path>',
      calculator:
        '    <path class="vi-primary" d="M38,43H11V5H38V43Z"></path>  <path class="vi-accent" d="M15,9H34v7H15V9Zm2.5,11A2.5,2.5,0,1,1,15,22.5,2.5,2.5,0,0,1,17.5,20Zm7,0A2.5,2.5,0,1,1,22,22.5,2.5,2.5,0,0,1,24.5,20Zm7,0A2.5,2.5,0,1,1,29,22.5,2.5,2.5,0,0,1,31.5,20Zm-14,7A2.5,2.5,0,1,1,15,29.5,2.5,2.5,0,0,1,17.5,27Zm7,0A2.5,2.5,0,1,1,22,29.5,2.5,2.5,0,0,1,24.5,27Zm7,0A2.5,2.5,0,1,1,29,29.5,2.5,2.5,0,0,1,31.5,27Zm-14,7A2.5,2.5,0,1,1,15,36.5,2.5,2.5,0,0,1,17.5,34Zm7,0A2.5,2.5,0,1,1,22,36.5,2.5,2.5,0,0,1,24.5,34Zm7,0A2.5,2.5,0,1,1,29,36.5,2.5,2.5,0,0,1,31.5,34Z"></path>',
      calendar:
        '    <path class="vi-primary" d="M7,41V7.009H42V41H7Z"></path>  <path class="vi-accent" d="M10.007,17.013h4.984V22H10.007V17.013Zm7.991,0h5.014V22H18V17.013Zm7.99,0H31V22H25.988V17.013Zm-15.981,8h4.984V30H10.007V25.009Zm7.991,0h5.014V30H18V25.009Zm7.99,0H31V30H25.988V25.009ZM10.007,33h4.984v4.987H10.007V33ZM18,33h5.014v4.987H18V33Zm7.99,0H31v4.987H25.988V33Zm8.021-15.991h4.983V22H34.009V17.013Zm0,8h4.983V30H34.009V25.009Zm0,8h4.983v4.987H34.009V33ZM7,7H42v7H7V7Z"></path>  <path class="vi-primary" d="M15,4h4v6H15V4ZM30,4h4v6H30V4Z"></path>',
      camera:
        '    <rect class="vi-primary" x="6" y="13" width="36" height="22"></rect>  <path class="vi-accent" fill-rule="evenodd" d="M24,17a7,7,0,1,1-7,7A7,7,0,0,1,24,17Zm0,4a3,3,0,1,1-3,3A3,3,0,0,1,24,21Zm11.5-4A1.5,1.5,0,1,1,34,18.5,1.5,1.5,0,0,1,35.5,17ZM10,13l4-4h6l4,4H10Z"></path>',
      card:
        '    <rect class="vi-primary" x="8" y="13" width="32" height="22" rx="3" ry="3"></rect>  <rect class="vi-accent" x="8" y="19" width="32" height="5"></rect>',
      cart:
        '    <path class="vi-primary" d="M14.58,35.043a3.479,3.479,0,1,1-3.527,3.479A3.5,3.5,0,0,1,14.58,35.043Zm11.771,0a3.479,3.479,0,1,1-3.542,3.479A3.511,3.511,0,0,1,26.351,35.043ZM44,12H14L9,6H4L18,26H30l-2,3H13L9,33H30Z"></path>  <path class="vi-accent" d="M16,16H36l-2,2H18Zm3,4H32l-2,2H21Z"></path>',
      chat:
        '    <path class="vi-primary" d="M24,39.765A18.556,18.556,0,0,1,13.924,37.1L7,44V23.882l0.012,0.006C7.011,23.791,7,23.7,7,23.6,7,14.369,13.247,8,24,8s17,6.652,17,15.882S34.753,39.765,24,39.765Z"></path>  <path class="vi-accent" d="M31.994,20.99a3,3,0,1,1-3,3A3,3,0,0,1,31.994,20.99ZM24,21a3,3,0,1,1-3,3A3,3,0,0,1,24,21Zm-8,0a3,3,0,1,1-3,3A3,3,0,0,1,16,21Z"></path>',
      check:
        '    <path class="vi-primary" d="M16,32l3,3L37,17l-3-3Z"></path>  <path class="vi-accent" d="M22,32l-3,3-8-8,3-3Z"></path>',
      clock:
        '    <circle class="vi-primary" cx="24" cy="24" r="18"></circle>  <circle class="vi-accent" cx="24" cy="24" r="14"></circle>  <path class="vi-primary" d="M21,16V27h9V24H24V16H21Z"></path>',
      close:
        '    <path class="vi-primary" d="M35,32l-3,3-7.5-7.5L17,35l-3-3,7.5-7.5L14,17l3-3,7.5,7.5L32,14l3,3-7.5,7.5Z"></path>  <path class="vi-accent" d="M20,32l-3,3-3-3,3-3ZM35,17l-3,3-3-3,3-3ZM29,32l3,3,3-3-3-3ZM14,17l3,3,3-3-3-3Z"></path>',
      cloudTools:
        '    <path class="vi-primary" d="M37.22,37H13.492A9.67,9.67,0,0,1,4,27.162C4,21.729,7.758,18,13,18a17.222,17.222,0,0,1,3,0c1.607-3.882,5.022-7,9.356-7C31.16,11,36,14.985,36,21c0,0.411.043,1.6,0,2a3.292,3.292,0,0,1,1,0,7.046,7.046,0,0,1,7,6.973A6.907,6.907,0,0,1,37.22,37Z"></path>  <path class="vi-accent" d="M8.809,35.713l12.414-12.49L24.9,26.9,14.853,37H13.492A9.183,9.183,0,0,1,8.809,35.713Z"></path>  <path class="vi-prop" d="M32.427,19.171a7.041,7.041,0,0,1-1.443,7.754,6.869,6.869,0,0,1-6.426,1.862,7.573,7.573,0,0,1-5.387-6.655,6.981,6.981,0,0,1,2.008-5.1,6.885,6.885,0,0,1,7.683-1.456l-5.009,5.055,3.566,3.6Z"></path>',
      cloud:
        '    <path class="vi-primary" d="M37.22,37H13.492A9.67,9.67,0,0,1,4,27.162C4,21.729,7.758,18,13,18a17.222,17.222,0,0,1,3,0c1.607-3.882,5.022-7,9.356-7C31.16,11,36,14.985,36,21c0,0.411.043,1.6,0,2a3.292,3.292,0,0,1,1,0,7.046,7.046,0,0,1,7,6.973A6.907,6.907,0,0,1,37.22,37Z"></path>',
      cog:
        '    <path class="vi-primary" d="M19.08,12.122L21,6h6l1.92,6.122H19.08ZM18.986,36l1.938,6h6.153l1.938-6H18.986ZM35.878,19.08L42,21v6l-6.122,1.92V19.08ZM12,18.986L6,20.924v6.153l6,1.938V18.986ZM28.92,12.122l5.686-2.971,4.243,4.243L35.878,19.08ZM11.967,28.942L9.1,34.553,13.447,38.9l5.611-2.87Zm23.911-.022,2.971,5.686-4.243,4.243L28.92,35.878ZM19.058,11.967L13.447,9.1,9.1,13.447l2.87,5.611Z"></path>  <path class="vi-accent" d="M24,37A13,13,0,1,1,37,24,13,13,0,0,1,24,37Zm0-17.875A4.875,4.875,0,1,0,28.875,24,4.875,4.875,0,0,0,24,19.125Z"></path>  <path class="vi-primary" d="M24,31a7,7,0,1,1,7-7A7,7,0,0,1,24,31Zm0-10a3,3,0,1,0,3,3A3,3,0,0,0,24,21Z"></path>',
      controller:
        '    <path class="vi-primary" d="M35.55,37a10.459,10.459,0,0,1-10.307-8.842H22.757A10.449,10.449,0,1,1,12.45,16h23.1A10.5,10.5,0,0,1,35.55,37Z"></path>  <path class="vi-accent" d="M17,14H31v2H17V14Zm0,14H14v3H11V28H8V25h3V22h3v3h3v3Zm19-9a2,2,0,1,1-2,2A2,2,0,0,1,36,19Zm0,10a2,2,0,1,1-2,2A2,2,0,0,1,36,29Zm5-5a2,2,0,1,1-2,2A2,2,0,0,1,41,24ZM31,24a2,2,0,1,1-2,2A2,2,0,0,1,31,24Z"></path>',
      cookie:
        '    <path class="vi-primary" d="M41,28.6a17.976,17.976,0,0,1-29.265,7.655,18.08,18.08,0,0,1,7.36-29.259A5.373,5.373,0,0,0,20.779,9.1a5.812,5.812,0,0,0,1.06,1.075c-0.424,1.105-1.643,4.895.9,6.37,0.534,0.958,1.616,1.66,3.613,1.7,0.02,1.381.325,3.629,1.969,4.624,0.925,1.482,2.811,2.365,6.6.751A5.55,5.55,0,0,0,37,27.228,3.282,3.282,0,0,0,41,28.6Z"></path>  <path class="vi-accent" d="M13.5,25A1.5,1.5,0,1,1,12,26.5,1.5,1.5,0,0,1,13.5,25Zm9,9A1.5,1.5,0,1,1,21,35.5,1.5,1.5,0,0,1,22.5,34Zm0-10A1.5,1.5,0,1,1,21,25.5,1.5,1.5,0,0,1,22.5,24Zm-6-10A1.5,1.5,0,1,1,15,15.5,1.5,1.5,0,0,1,16.5,14Zm17,15A1.5,1.5,0,1,1,32,30.5,1.5,1.5,0,0,1,33.5,29Z"></path>',
      cup:
        '    <path class="vi-primary" d="M35,11L32,41H16L13,11H10l5-4H33l5,4H35Z"></path>  <path class="vi-accent" d="M13,11H35l-0.3,3H13.3ZM24,21a4,4,0,1,1-4,4A4,4,0,0,1,24,21Z"></path>',
      desktop:
        '    <path class="vi-primary" d="M43,36H5V9H43V36ZM31,43H17V41H31v2Z"></path>  <path class="vi-accent" d="M8,33V12H40V33H8Zm11,3H29v3l2,2H17l2-2V36Z"></path>',
      doc:
        '    <rect class="vi-primary" x="11" y="7" width="26" height="34"></rect>  <path class="vi-accent" d="M16,7V18l3-3,3,3V7H16ZM28,19h9v2H28V19Zm0,6h9v2H28V25Zm0,5h9v2H28V30Z"></path>  <path class="vi-prop" d="M24.995,19.005v1.982h3.01V19.005h-3.01Zm0,6.01V27h3.01V25.016h-3.01Zm0,4.978v2.014h3.01V29.993h-3.01Z"></path>',
      envelope:
        '    <rect class="vi-primary" x="5" y="10" width="38" height="28"></rect>  <path class="vi-accent" d="M5,10H43L24,27Z"></path>',
      equaliser:
        '    <path class="vi-primary" d="M8,36V32H40v4H8ZM8,22H40v4H8V22ZM8,12H40v4H8V12Z"></path>  <path class="vi-accent" d="M30,29a5,5,0,1,1,5-5A5,5,0,0,1,30,29ZM19,19a5,5,0,1,1,5-5A5,5,0,0,1,19,19Zm3,15a5,5,0,1,1-5-5A5,5,0,0,1,22,34Z"></path>  <path class="vi-prop" d="M19,12a2,2,0,1,1-2,2A2,2,0,0,1,19,12ZM30,22a2,2,0,1,1-2,2A2,2,0,0,1,30,22ZM17,32a2,2,0,1,1-2,2A2,2,0,0,1,17,32Z"></path>',
      export:
        '    <rect class="vi-primary" x="5" y="10" width="28" height="28"></rect>  <path class="vi-accent" d="M17,25H39l-3,3,2,2,6-6V23l-6-6-2,2,3,3H17v3Z"></path>',
      eye:
        '    <path class="vi-primary" d="M24,13c11.267,0,17,11.5,17,11.5S35.267,35,24,35,7,24.5,7,24.5,12.733,13,24,13Z"></path>  <circle class="vi-accent" cx="24" cy="24" r="6"></circle>  <circle class="vi-prop" cx="24" cy="24" r="3"></circle>',
      fingerprint:
        '        <g>        <path class="vi-primary" d="M28.3661302,34.7363961 C28.6559368,35.2798687 29.0043865,35.8015205 29.4012511,36.2836223 C29.9999574,37.0098434 29.895627,38.0845144 29.1687239,38.6825388 C28.8509595,38.9443875 28.4670511,39.0712205 28.0858702,39.0712205 C27.5942219,39.0712205 27.105983,38.8598322 26.7691255,38.4500116 C26.2276987,37.793344 25.7524159,37.0814427 25.3548695,36.3354465 C25.3337306,36.2945326 24.8400366,35.3610145 24.4977239,34.3218023 C23.9747083,32.7302528 23.9372039,31.1121093 23.9017452,29.5464719 C23.8758331,28.4056569 23.8506029,27.3282583 23.6358051,26.3783747 C23.342589,25.081405 22.6231868,23.8178484 21.4994192,22.625891 C20.853662,21.9405837 20.8857112,20.8618214 21.5703366,20.2160641 C22.2563258,19.5703069 23.3344062,19.6016742 23.9801635,20.2869815 C25.5280715,21.9289914 26.5311432,23.7257922 26.9614207,25.6262414 C27.2519092,26.9088912 27.2812308,28.2099522 27.3105524,29.4680536 C27.3419197,30.8454872 27.3712413,32.1458664 27.7360566,33.255996 C27.9849493,34.0108569 28.3627207,34.7288953 28.3661302,34.7363961 Z M32.4841793,28.7791323 C32.8210368,29.38193 33.2431315,29.9465413 33.7375074,30.4593285 C34.3921293,31.136453 34.3730362,32.2152154 33.6952298,32.8691554 C33.019469,33.5237773 31.9400248,33.5060479 31.2854029,32.8275596 C30.5871396,32.104066 29.9891152,31.3021542 29.5090591,30.4436448 C28.2107257,28.1245104 28.1739032,26.1047291 28.1411721,24.3229301 C28.1138962,22.8268463 28.088666,21.4132721 27.3378965,19.739213 C26.9389863,18.8486545 26.3361886,17.503952 25.0385371,16.8888802 C23.9761403,16.3856396 22.3048087,16.2676712 21.1435368,17.1984618 C19.7736041,18.2969991 19.8799801,20.346784 19.9147569,21.020499 C19.980901,22.2936022 20.4200432,23.022551 21.0276141,24.0303959 C21.4524365,24.7361602 21.9338563,25.5360263 22.3143553,26.5895584 C23.4203936,29.6540072 23.0610334,33.2748846 21.2458214,37.3512697 C20.9628338,37.9861165 20.3395792,38.363206 19.687003,38.363206 C19.4558397,38.363206 19.219903,38.3147913 18.9948768,38.2152342 C18.1350036,37.8313257 17.7476857,36.8241627 18.1309122,35.9636076 C19.5758537,32.7191378 19.9045284,29.955406 19.1073899,27.746739 C18.8407679,27.0082437 18.4841353,26.4163564 18.1070458,25.7896923 C17.4101462,24.6331936 16.6198267,23.3219041 16.5100411,21.1971105 C16.3559322,18.2329007 17.1973941,15.9921845 19.0112423,14.5376965 C21.3283311,12.6802069 24.4418765,12.832952 26.4991622,13.8080658 C28.9335374,14.9618369 29.9195616,17.1623212 30.4493962,18.344732 C31.4845171,20.6543199 31.5192939,22.5704527 31.5499793,24.2601955 C31.5806647,25.9062968 31.6038492,27.205994 32.4841793,28.7791323 Z M36.5269468,21.3464461 C36.7321981,22.7102418 36.7772033,24.0460796 36.6708273,25.3723708 C36.5951366,26.3113441 35.7741316,27.0048342 34.8351584,26.9352806 C33.8961851,26.8589081 33.1965579,26.0372212 33.2722486,25.0989298 C33.3581677,24.0324416 33.3213452,22.9584526 33.1631449,21.9069661 C32.9633489,20.566355 32.3810081,16.6611263 29.1249461,14.0160447 C27.9363982,13.0491136 25.7795554,11.9001158 23.8531941,11.6600877 C21.8443231,11.411195 19.8913678,12.165374 19.3397125,12.4026745 C18.0700188,12.9488746 17.0962687,13.6941889 16.4457382,14.6174785 C14.7859989,16.9713898 15.2149126,20.4170194 15.4760795,21.7889978 C15.7242903,23.0921045 16.0843323,23.9253837 16.4661951,24.8070775 C16.9653443,25.9608486 17.4815409,27.1541698 17.5926903,29.088032 C17.7072491,31.0880383 17.3465252,33.1112291 16.5187012,35.1016888 C16.246624,35.7569926 15.612459,36.1524933 14.9441992,36.1524933 C14.7259919,36.1524933 14.5043751,36.1102157 14.2902592,36.0215689 C13.4208395,35.6601631 13.0089732,34.6625466 13.370379,33.792445 C13.9984069,32.2827232 14.2738936,30.7648187 14.1886564,29.2837367 C14.1122839,27.9526721 13.7870186,27.2005389 13.3369661,26.1606447 C12.9189627,25.1950774 12.4457256,24.1006314 12.1265974,22.4272542 C11.7010932,20.192675 11.3342322,15.9512707 13.6588218,12.6529309 C14.6775771,11.2073076 16.1354747,10.0692201 17.9916005,9.2707178 C18.9537583,8.85680583 21.4883725,7.93010671 24.273925,8.27651079 C27.0601595,8.62359678 29.7870689,10.1599125 31.2756518,11.3695993 C35.55797,14.8493238 36.2869188,19.7398949 36.5269468,21.3464461 Z"></path>    </g>',
      flag:
        '    <path class="vi-primary" d="M31,25l8,8H18V28H13V10H27v7H39Z"></path>  <path class="vi-accent" d="M9,8h4V43H9V8ZM26,28l-8,5V28h8Z"></path>',
      flame:
        '    <path class="vi-primary" d="M35.555,32.1A11.979,11.979,0,0,1,12,28.857a7.933,7.933,0,0,1,.485-2.924c1.158-7.338,8.3-7.87,4.315-18.933,0,0,6.65,1.727,8,12.143,0,0,4.919-.163,1.6-7.286A21.311,21.311,0,0,1,36,27,24.911,24.911,0,0,1,35.555,32.1Z"></path>  <path class="vi-accent" d="M31,33.5a7.5,7.5,0,0,1-14.975.484L16,34s-0.075-3.272,0-4c0.684-6.611,2.6-9.563,5-14,0.067-2.639-1.115,7.273,5,10A8.188,8.188,0,0,1,31,33.5Z"></path>',
      flask:
        '    <path class="vi-primary" d="M10,41L21,19V7h7V19L39,41H10Z"></path>  <path class="vi-accent" d="M21,7v3h7V7H21Z"></path>',
      gem:
        '    <path class="vi-primary" d="M24,40L7,18,13,8H35l6,10Z"></path>  <path class="vi-accent" d="M7,18L13,8H35l6,10H7Z"></path>',
      gift:
        '    <path class="vi-primary" d="M8,20H40V43H8V20Zm3-9a4.939,4.939,0,0,1,4.875-5c1.866,0,2.2.489,4.125,2l4,3,4-3c1.711-1.621,2.259-2,4.125-2A4.939,4.939,0,0,1,37,11a4.939,4.939,0,0,1-4.875,5H15.875A4.939,4.939,0,0,1,11,11Zm21,2a2,2,0,0,0,0-4,2.463,2.463,0,0,0-1.776,1.1L27,13h5ZM17.776,10.1A2.463,2.463,0,0,0,16,9a2,2,0,0,0,0,4h5Z"></path>  <path class="vi-accent" d="M15.875,16H39.99v4H26V43H22V20H7.99V16h7.885Z"></path>',
      graduationCap:
        '    <path class="vi-accent" d="M24,41L11,33V22H37V33ZM6,34a2.993,2.993,0,0,1-1-5.816V20l2,1v7.184A2.993,2.993,0,0,1,6,34Z"></path>  <path class="vi-primary" d="M24,7.012l21.986,12.5L24,32.013,2.014,19.513Z"></path>',
      graphBar:
        '    <rect class="vi-accent" x="6" y="35" width="36" height="4"></rect>  <path class="vi-primary" d="M9,20h5V35H9V20Zm8,5h5V35H17V25Zm8-9h5V35H25V16Zm8-7h5V35H33V9Z"></path>',
      graphPie:
        '    <path class="vi-primary" d="M24,24H42c-0.32,9.671-8.233,18-17.981,18A18.019,18.019,0,0,1,6,23.981C6,14.233,14.329,6.32,24,6V24Z"></path>  <path class="vi-accent" d="M26,6A17.773,17.773,0,0,1,42,22H26V6Z"></path>',
      graphPoly:
        '    <path class="vi-primary" d="M36.214,28.786a7,7,0,1,1-12.428,0l-5.02-5.02a6.925,6.925,0,0,1-5.612-.921L7,29,4,26l6.477-6.477a7,7,0,1,1,11.947,1.9l4.363,4.363a6.965,6.965,0,0,1,6.428,0L42,17l3,3Z"></path>  <path class="vi-accent" d="M17,14a3,3,0,1,1-3,3A3,3,0,0,1,17,14ZM30,29a3,3,0,1,1-3,3A3,3,0,0,1,30,29Z"></path>',
      headphone:
        '    <path class="vi-primary" d="M10,21v3h3V21H10Zm25,0v3h3V21H35ZM11,24h2V40H11a5,5,0,0,1-5-5V29A5,5,0,0,1,11,24Zm24,0h2a5,5,0,0,1,5,5v6a5,5,0,0,1-5,5H35V24Z"></path>  <path class="vi-accent" d="M35.789,21C34.552,14.817,29.755,10.2,24,10.2S13.448,14.817,12.211,21H10.03C11.425,13.574,17.134,8,24,8s12.575,5.573,13.97,13H35.789ZM13,24h3V40H13V24ZM6,28H9v8H6V28Zm26-4h3V40H32V24Zm7,4h3v8H39V28Z"></path>',
      heart:
        '    <path class="vi-primary" d="M24,40S7,35.578,7,18.482C7,13.245,11.349,8,16.714,8A10.088,10.088,0,0,1,24,11.556,10.088,10.088,0,0,1,31.286,8C36.651,8,41,13.245,41,18.482,41,35.523,24,40,24,40Z"></path>',
      home:
        '    <path class="vi-primary" d="M5,24L24,5,43,24H38V40H10V24H5Z"></path>  <path class="vi-accent" d="M19,40V26H29V40H19Z"></path>',
      hotel:
        '    <path class="vi-primary" d="M14,7l2,2H31l2-2H14ZM12,28V41H36V28H12Zm2-14H34v9H14V14Z"></path>  <path class="vi-accent" d="M13,14L8,9H39l-5,5H13Zm4,1h4v3.017H17V15Zm4,6.983H17V19.005h4v2.977ZM22,15h4v3.017H22V15Zm4,6.983H22V19.005h4v2.977ZM27,15h4v3.017H27V15Zm4,6.983H27V19.005h4v2.977ZM37,29H11L5,23H43Zm-8,5H28v7H20V34H19V31H29v3Z"></path>',
      hourglass:
        '    <path class="vi-primary" d="M35.79,35.83v4.177H38V43H10V40.007h2.211V35.83S14.138,26.473,22,25V23c-7.863-1.473-9.789-10.83-9.789-10.83V7.993H10V5H38V7.993H35.79V12.17S33.863,21.527,26,23v2C33.863,26.473,35.79,35.83,35.79,35.83Z"></path>  <path class="vi-accent" d="M12.211,40V37H35.79v3H12.211Zm0-29V8H35.79v3H12.211Z"></path>',
      image:
        '    <rect class="vi-primary" x="6" y="11" width="36" height="26"></rect>  <path class="vi-accent" d="M6,37L19,24l5,5L35,18l7,7V37H6ZM24.5,17A2.5,2.5,0,1,1,22,19.5,2.5,2.5,0,0,1,24.5,17Z"></path>',
      import:
        '    <rect class="vi-primary" x="15" y="10" width="28" height="28"></rect>  <path class="vi-accent" d="M4,25H27l-3,3,2,2,6-6V23l-6-6-2,2,3,3H4v3Z"></path>',
      industry:
        '    <path class="vi-primary" d="M41,24V41H7V19h4V13l8-8V19h5v5h7.326l2.388-11.8h3.643L39.745,24H41Z"></path>  <path class="vi-accent" d="M34,39V34h5v5H34Zm0-12h5v5H34V27ZM26.188,11c-1-1.677,1.633-5.308,6.124-3.529a11.823,11.823,0,0,0,3.674,1.4V11a13.26,13.26,0,0,1-4.9-1.176A4.185,4.185,0,0,0,26.188,11ZM17,36h5v5H17V36Zm0-7h5v5H17V29Zm0-7h5v5H17V22Zm-6-9,8-8V8l-8,8V13Zm3,14H9V22h5v5Zm0,7H9V29h5v5Zm0,7H9V36h5v5Zm17-9H26V27h5v5Zm0,7H26V34h5v5Z"></path>',
      infinity:
        '    <path class="vi-accent" d="M33.952,33a9.04,9.04,0,0,1-7.2-3.56L21.288,24l5.469-5.44A9.024,9.024,0,1,1,33.952,33Zm-0.1-14.4a5.56,5.56,0,0,0-4.4,2.136L26.112,24l3.342,3.264a5.559,5.559,0,0,0,4.4,2.136A5.4,5.4,0,1,0,33.852,18.6Z"></path>  <path class="vi-primary" d="M21.243,29.44a9,9,0,1,1,0-10.88L26.712,24Zm-2.7-8.7a5.56,5.56,0,0,0-4.4-2.136,5.4,5.4,0,1,0,0,10.8,5.559,5.559,0,0,0,4.4-2.136L21.888,24Z"></path>',
      jar:
        '    <path class="vi-primary" d="M15,43V17l4-4V5H30v8l4,4V43H15Z"></path>  <path class="vi-accent" d="M18,5v5H31V5H18Zm1,22v8H31V27H19Z"></path>',
      laptop:
        '    <path class="vi-primary" d="M43,35H5V9H43V35Z"></path>  <path class="vi-accent" d="M8,12H40V32H8V12ZM47,39H1V35H47v4Z"></path>',
      layers:
        '    <path class="vi-primary" d="M24,20.6l17.013,9.7L24,39.99l-17.013-9.7Z"></path>  <path class="vi-accent" d="M24,14.8l17.013,9.7L24,34.2,6.987,24.5Z"></path>  <path class="vi-primary" d="M24,9.01l17.013,9.7L24,28.4l-17.013-9.7Z"></path>',
      lock:
        '    <rect class="vi-primary" x="11" y="18" width="26" height="23"></rect>  <path class="vi-accent" d="M31,18V15a7.213,7.213,0,0,0-7-7c-3.584,0-7,3.863-7,7v3H14V15A10.068,10.068,0,0,1,24,5c6.188,0,10,5.656,10,10v3H31ZM11,39H37v2H11V39ZM24,24a4,4,0,1,1-4,4A4,4,0,0,1,24,24Zm-2,4h4v8H22V28Z"></path>',
      mapMarker:
        '    <path class="vi-primary" d="M24,6c7.732,0,14,5.641,14,12.6C38,29.963,24,42,24,42S10,30.064,10,18.6C10,11.641,16.268,6,24,6Z"></path>  <circle class="vi-accent" cx="24" cy="20" r="7"></circle>',
      menu:
        '    <path class="vi-primary" d="M9,12H39v4H9V12ZM9,22H39v4H9V22ZM9,32H39v4H9V32Z"></path>  <path class="vi-accent" d="M9,12h4v4H9V12ZM9,22h4v4H9V22ZM9,32h4v4H9V32ZM35,12h4v4H35V12Zm0,10h4v4H35V22Zm0,10h4v4H35V32Z"></path>',
      message:
        '    <path class="vi-primary" d="M4,10V45l7-7H44V10H4Z"></path>  <path class="vi-accent" d="M10,18H37v4H10V18Zm0,8H26v4H10V26Z"></path>',
      mobile:
        '    <rect class="vi-primary" x="13" y="3" width="22" height="42"></rect>  <path class="vi-accent" d="M24,39a2,2,0,1,1-2,2A2,2,0,0,1,24,39ZM16,7H32V37H16V7Z"></path>',
      moon:
        '    <path class="vi-primary" d="M20.848,27.134A17.853,17.853,0,0,0,41,30.675,17.849,17.849,0,1,1,17.3,7,17.815,17.815,0,0,0,20.848,27.134Z"></path>',
      move:
        '    <path class="vi-primary" d="M34,30l-2-2,2-2H26v8l2-2,2,2-5,5H24l-5-5,2-2,2,2V26H15l2,2-2,2-5-5V24l5-5,2,2-2,2h8V15l-2,2-2-2,5-5h1l5,5-2,2-2-2v8h8l-2-2,2-2,5,5v1Z"></path>  <path class="vi-accent" d="M19,23v3h4v4h3V26h4V23H26V19H23v4H19Z"></path>',
      musicNote:
        '            <g transform="translate(10.000000, 7.000000)">            <path class="vi-primary" d="M22.957,30.769 C19.657,30.769 16.982,28.141 16.982,24.898 C16.982,21.656 19.657,19.028 22.957,19.028 C23.393,19.028 23.818,19.076 24.228,19.164 L24.228,7.408 L28.931,6.047 L28.931,24.898 C28.931,28.141 26.256,30.769 22.957,30.769 Z M6.94,35 C3.64,35 0.965,32.372 0.965,29.13 C0.965,25.887 3.64,23.259 6.94,23.259 C7.376,23.259 7.801,23.308 8.211,23.395 L8.211,12.043 L12.914,10.682 L12.914,29.208 L12.91,29.208 C12.867,32.414 10.213,35 6.94,35 Z"></path>            <polygon class="vi-accent" points="28.931 6.047 28.931 5.912 28.931 0.999 8.211 6.995 8.211 10.221 8.211 12.043"></polygon>        </g>',
      mute:
        '            <g transform="translate(9.000000, 8.000000)" id="Shape">            <polygon class="vi-primary" points="18.009 32.01 6 24 6 8 18.009 0.014"></polygon>            <path class="vi-accent" d="M27.447,15.759 L30.17,18.482 L28.849,19.804 L26.126,17.08 L23.402,19.804 L22.081,18.483 L24.805,15.759 L22.081,13.036 L23.403,11.715 L26.126,14.438 L28.849,11.714 L30.171,13.036 L27.447,15.759 Z M0.994,8.001 L6.006,8.001 L6.006,23.992 L0.994,23.992 L0.994,8.001 Z"></path>        </g>',
      newspaper:
        '    <path class="vi-primary" d="M37,39h3v3H7V6H37V39Z"></path>  <path class="vi-accent" d="M43,39a2.7,2.7,0,0,1-3,3c-2.787,0-3-3-3-3l0.011-17H43V39ZM21,32.981H32V35H21V32.981Zm0-9.961H32V25H21V23.019ZM12,12H32v3H12V12Zm6,13H12V19h6v6Zm0,10H12V29h6v6ZM28,21l-7-.019V19h7v2Zm0,10-7-.01V29h7v2Z"></path>',
      pen:
        '    <path class="vi-primary" d="M29.556,38H18.444L13,22,24,6,35,22Z"></path>  <path class="vi-accent" d="M15,42V38H33v4H15Zm9-22a2,2,0,1,1,2-2A2,2,0,0,1,24,20Z"></path>',
      pencil:
        '    <path class="vi-primary" d="M33.694,5.994l8.312,8.312L17.07,39.243,8.758,30.93Z"></path>  <path class="vi-accent" d="M33.694,5.994l8.312,8.312L37.85,18.462,29.538,10.15ZM5.987,42.013L8.758,30.93l8.312,8.312Z"></path>',
      processor:
        '    <rect class="vi-primary" x="12" y="12" width="24" height="24"></rect>  <path class="vi-accent" d="M16,16H32V32H16V16ZM8,16h4v3H8V16Zm0,6h4v3H8V22Zm0,6h4v3H8V28ZM36,16h4v3H36V16Zm0,6h4v3H36V22Zm0,6h4v3H36V28ZM32,8v4H29V8h3ZM26,8v4H23V8h3ZM20,8v4H17V8h3ZM31,36v4H28V36h3Zm-6,0v4H22V36h3Zm-6,0v4H16V36h3Z"></path>',
      radio:
        '            <g transform="translate(6.000000, 4.000000)" id="Shape">            <polygon class="vi-primary" points="36.994 35.988 0.989 35.988 0.989 11.988 3.908 11.988 31.43 0.89 32.927 4.607 14.622 11.988 36.994 11.988"></polygon>            <path class="vi-accent" d="M33.542,24.785 C33.542,28.893 30.213,32.223 26.106,32.223 C22,32.223 18.67,28.893 18.67,24.785 C18.67,20.677 22,17.346 26.106,17.346 C30.213,17.346 33.542,20.677 33.542,24.785 Z"></path>            <path class="vi-prop" d="M5.002,29.013 L5.002,25.994 L14.988,25.994 L14.988,29.013 L5.002,29.013 Z M5.002,19.994 L14.988,19.994 L14.988,23.013 L5.002,23.013 L5.002,19.994 Z" fill-rule="nonzero"></path>        </g>',
      refresh:
        '    <path class="vi-accent" d="M15.518,23.936A8.576,8.576,0,0,0,24,32.606V34.94l-0.944,4.286A15.186,15.186,0,0,1,9,23.936,14.953,14.953,0,0,1,21,9h2l0.048,6.323A8.6,8.6,0,0,0,15.518,23.936Z"></path>  <path class="vi-primary" d="M24,39.275c-0.319,0-.63-0.029-0.944-0.049L24,34.94V32.606a8.672,8.672,0,0,0,0-17.34,8.346,8.346,0,0,0-.949.058L23,13s-0.658-4.4,1-4.4A15.172,15.172,0,0,1,39,23.936,15.172,15.172,0,0,1,24,39.275Z"></path>  <path class="vi-primary" d="M26.005,42V28L19,35Z"></path>  <path class="vi-accent" d="M21.989,6V19l6.024-6.494Z"></path>',
      rocket:
        '    <path class="vi-primary" d="M29.624,43.785L25.381,32.472l7.778-7.778,2.075,8.735ZM4.168,18.329l10.357-5.611,8.735,2.075-7.778,7.778ZM5.624,34.991c1.92-4.929,5.24-2.274,5.24-2.274l2.222,2.217,2.2,2.193s2.627,3.28-2.295,5.213a12.725,12.725,0,0,1-4.578.376c-0.815-.076-3.537,1.6-4.347,1.222-0.39-.814,1.288-3.537,1.207-4.355A12.681,12.681,0,0,1,5.624,34.991Z"></path>  <path class="vi-accent" d="M10.7,24.537C29.323,6.122,43.983,3.986,43.983,3.986S41.823,18.484,23.2,36.9c0,0-4.841,5.327-11.38-1.14A8.244,8.244,0,0,1,10.7,24.537Z"></path>  <path class="vi-primary" d="M27.646,20.336a4.454,4.454,0,1,1-6.346-.058A4.512,4.512,0,0,1,27.646,20.336Z"></path>',
      searchDisabled:
        '    <path class="vi-accent" d="M25.283,28.611L35.889,39.218l2.828-2.828L28.111,25.783Zm-2.454-4.368L20,21.414l-2.828,2.828-1.414-1.414L18.586,20l-2.828-2.828,1.414-1.414L20,18.586l2.828-2.828,1.414,1.414L21.414,20l2.828,2.828Z"></path>  <path class="vi-primary" d="M20,32A12,12,0,1,1,32,20,12,12,0,0,1,20,32Zm0-20a8,8,0,1,0,8,8A8,8,0,0,0,20,12Z"></path>',
      search:
        '    <path class="vi-accent" d="M25.283,28.611L35.889,39.218l2.828-2.828L28.111,25.783Z"></path>  <path class="vi-primary" d="M20,32A12,12,0,1,1,32,20,12,12,0,0,1,20,32Zm0-20a8,8,0,1,0,8,8A8,8,0,0,0,20,12Z"></path>',
      server:
        '    <path class="vi-primary" d="M11,14H37v7H11V14Zm0,14H37v7H11V28Z"></path>  <path class="vi-accent" d="M11,7H37v7H11V7Zm0,14H37v7H11V21Zm0,14H37v7H11V35Z"></path>  <path class="vi-prop" d="M14.5,37A1.5,1.5,0,1,1,13,38.5,1.5,1.5,0,0,1,14.5,37Zm0-7A1.5,1.5,0,1,1,13,31.5,1.5,1.5,0,0,1,14.5,30Zm0-7A1.5,1.5,0,1,1,13,24.5,1.5,1.5,0,0,1,14.5,23Zm0-7A1.5,1.5,0,1,1,13,17.5,1.5,1.5,0,0,1,14.5,16Zm0-7A1.5,1.5,0,1,1,13,10.5,1.5,1.5,0,0,1,14.5,9Z"></path>',
      share:
        '    <path class="vi-accent" d="M29.954,15.211L16.818,22.76l-2.066-2.57,13.137-7.549ZM29.86,32.772L16.632,24.72l-2.081,2.808L27.78,35.58Z"></path>  <path class="vi-primary" d="M15,18a6,6,0,1,1-6,6A6,6,0,0,1,15,18ZM33,6a6,6,0,1,1-6,6A6,6,0,0,1,33,6Zm0,24a6,6,0,1,1-6,6A6,6,0,0,1,33,30Z"></path>',
      shield:
        '    <path class="vi-primary" d="M24.516,41C8.586,34.828,10.032,13.8,10.032,13.8,19.675,15.578,24.516,7,24.516,7s4.83,8.578,14.452,6.8C38.968,13.8,40.411,34.828,24.516,41Z"></path>  <path class="vi-accent" d="M17,25l5,5L32,20l-2-2-8,8-3-3Z"></path>',
      shop:
        '    <path class="vi-primary" d="M41,11V41H7V11H5V7H43v4H41Z"></path>  <path class="vi-accent" d="M38.5,18c-4.3,0-4.5-5-4.5-5a5,5,0,0,1-10,0,5,5,0,0,1-10,0s-0.2,5-4.5,5A4.5,4.5,0,0,1,5,13.5V11H43v2.5A4.5,4.5,0,0,1,38.5,18ZM22.01,35.01h-9V25.99h9v9.02ZM34.993,41h-8V25.99h8V41Z"></path>',
      star:
        '    <path class="vi-primary" d="M34.865,39.83l-10.25-5.621-10.153,5.8,2.091-11.647L7.99,20.335l11.542-1.577L24.394,8l5.042,10.672L41,20.047l-8.426,8.173Z"></path>',
      sun:
        '    <path class="vi-primary" d="M36.021,11.979L36,19l5,5-5,5,0.021,7.021L29,36l-5,5-5-5-7.021.021L12,29,7,24l5-5-0.021-7.021L19,12l5-5,5,5Z"></path>  <circle class="vi-accent" cx="24" cy="24" r="9"></circle>',
      switchOff:
        '    <rect class="vi-primary" x="7" y="18" width="34" height="12"></rect>  <rect class="vi-accent" x="9" y="20" width="8" height="8"></rect>',
      switchOn:
        '    <rect class="vi-primary" x="7" y="18" width="34" height="12"></rect>  <rect class="vi-accent" x="31" y="20" width="8" height="8"></rect>',
      tablet:
        '    <rect class="vi-primary" x="10" y="3" width="28" height="42"></rect>  <path class="vi-accent" d="M24,39a2,2,0,1,1-2,2A2,2,0,0,1,24,39ZM13,7H35V37H13V7Z"></path>',
      tag:
        '    <path class="vi-primary" d="M6.008,27.205L25.215,8,41,8V23L22,43Z"></path>  <path class="vi-accent" d="M9.8,27.205l2.526-2.526,12,12L21.795,39.2ZM30.951,13.629a3.126,3.126,0,1,1,0,4.42A3.126,3.126,0,0,1,30.951,13.629Z"></path>',
      tee:
        '    <path class="vi-primary" d="M37,22l-3-3V41H14V19l-3,3L6,17,14.952,7h18.1L42,17Z"></path>  <path class="vi-accent" d="M18,7H30A6,6,0,0,1,18,7ZM14,39H34v2H14V39Z"></path>',
      thunder:
        '    <path class="vi-primary" d="M33,8H20.842L14,22h6L12,40,36,21H27Z"></path>  <path class="vi-accent" d="M28.421,27L12,40l5.778-13H28.421Z"></path>',
      ticket:
        '    <path class="vi-primary" d="M37.659,15.308l4.346,4.346L19.654,42.005l-4.346-4.346a3.512,3.512,0,1,0-4.967-4.967L5.995,28.346,28.346,5.995l4.346,4.346A3.512,3.512,0,1,0,37.659,15.308Z"></path>  <path class="vi-accent" d="M14.066,26.484L26.484,14.066l7.45,7.451L21.517,33.934Z"></path>',
      trash:
        '    <rect class="vi-primary" x="13" y="16" width="22" height="26"></rect>  <path class="vi-accent" d="M18.969,7h9.969L33,11H15ZM11,11H37v5H11V11Zm7,9h4V37H18V20Zm8,0h4V37H26V20Z"></path>',
      user:
        '    <path class="vi-primary" d="M8,41l5.818-10.889L18.182,28.3l2.909-5.445h5.818L29.818,28.3l4.364,1.815L40,41H8Z"></path>  <path class="vi-accent" d="M32,17l-1,3H30l-1,3-4,3H23l-4-3-1-3H17l-1-3h2l-1-6,7-4,7,4-1,6h2Z"></path>',
      van:
        '    <path class="vi-primary" d="M4,11V33.012H29.994V11H4Z"></path>  <path class="vi-accent" d="M29.994,17.014H38.32l5.68,6v10H29.994v-16Z"></path>  <circle class="vi-accent" cx="12" cy="33" r="5"></circle>  <circle class="vi-primary" cx="37" cy="33" r="5"></circle>  <path class="vi-prop" d="M12,31a2,2,0,1,1-2,2A2,2,0,0,1,12,31Zm25,0a2,2,0,1,1-2,2A2,2,0,0,1,37,31ZM36,20l4,4H33V20h3Z"></path>',
      videoRecording:
        '            <g transform="translate(5.000000, 13.000000)" id="Shape">            <polygon class="vi-primary" points="29.002 22 0.011 22 0.011 0.996 29.002 0.996"></polygon>            <polygon class="vi-accent" points="38.995 22 29.002 14.773 29.002 8.223 38.995 0.996"></polygon>            <path class="vi-prop" d="M6.892,5.649 C6.892,6.988 5.795,8.074 4.443,8.074 C3.09,8.074 1.994,6.988 1.994,5.649 C1.994,4.31 3.09,3.224 4.443,3.224 C5.795,3.224 6.892,4.31 6.892,5.649 Z" fill-rule="nonzero"></path>        </g>',
      volumeHigh:
        '               <g transform="translate(7.000000, 5.000000)" id="Shape">            <polygon class="vi-primary" points="18.009 36.01 6 28 6 12 18.009 4.014"></polygon>            <path class="vi-accent" d="M20.174,38 L20.174,35.94 C27.526,34.028 32.974,27.391 32.974,19.498 C32.974,11.604 27.526,4.968 20.174,3.056 L20.174,0.996 C28.646,2.953 34.984,10.497 34.984,19.498 C34.984,28.499 28.646,36.043 20.174,38 Z M0.994,12.001 L6.006,12.001 L6.006,27.992 L0.994,27.992 L0.994,12.001 Z M30.137,19.498 C30.137,25.827 25.944,31.198 20.174,33.025 L20.174,30.901 C24.813,29.156 28.127,24.71 28.127,19.498 C28.127,14.286 24.813,9.839 20.174,8.095 L20.174,5.97 C25.944,7.797 30.137,13.169 30.137,19.498 Z M24.805,19.498 C24.805,22.846 22.932,25.765 20.174,27.285 L20.174,24.889 C21.769,23.623 22.795,21.679 22.795,19.498 C22.795,17.317 21.769,15.372 20.174,14.106 L20.174,11.711 C22.932,13.23 24.805,16.149 24.805,19.498 Z"></path>        </g>',
      volumeMedium:
        '            <g transform="translate(9.000000, 8.000000)" id="Shape">            <polygon class="vi-primary" points="18.009 32.01 6 24 6 8 18.009 0.014"></polygon>            <path class="vi-accent" d="M20.174,29.025 L20.174,26.901 C24.813,25.156 28.127,20.71 28.127,15.498 C28.127,10.286 24.813,5.839 20.174,4.095 L20.174,1.97 C25.944,3.797 30.137,9.169 30.137,15.498 C30.137,21.827 25.944,27.198 20.174,29.025 Z M0.994,8.001 L6.006,8.001 L6.006,23.992 L0.994,23.992 L0.994,8.001 Z M24.805,15.498 C24.805,18.846 22.932,21.765 20.174,23.285 L20.174,20.889 C21.769,19.623 22.795,17.679 22.795,15.498 C22.795,13.317 21.769,11.372 20.174,10.106 L20.174,7.711 C22.932,9.23 24.805,12.149 24.805,15.498 Z"></path>        </g>',
      volumeSlow:
        '            <g transform="translate(12.000000, 8.000000)" id="Shape">            <polygon class="vi-primary" points="18.009 32.01 6 24 6 8 18.009 0.014"></polygon>            <path class="vi-accent" d="M20.174,23.285 L20.174,20.889 C21.769,19.623 22.795,17.679 22.795,15.498 C22.795,13.317 21.769,11.372 20.174,10.106 L20.174,7.711 C22.932,9.23 24.805,12.149 24.805,15.498 C24.805,18.846 22.932,21.765 20.174,23.285 Z M0.994,8.001 L6.006,8.001 L6.006,23.992 L0.994,23.992 L0.994,8.001 Z"></path>        </g>',
      vr:
        '    <path class="vi-accent" d="M19.035,26.992L19,32.006H29l-0.039-5.014H19.035Z"></path>  <path class="vi-primary" d="M30,35l-2.945-5.685c-1.619-3.125-4.5-3.125-6.123,0L17.743,35H7V15H41V35H30Z"></path>  <path class="vi-accent" d="M35.995,14.988L36,12H12l0.005,2.988H35.995ZM41,21h2v7H41V21ZM5,21H7v7H5V21Zm10.5,1A2.5,2.5,0,1,1,13,24.5,2.5,2.5,0,0,1,15.5,22Zm17,0A2.5,2.5,0,1,1,30,24.5,2.5,2.5,0,0,1,32.5,22Z"></path>',
      website:
        '    <rect class="vi-primary" x="7" y="10" width="34" height="28"></rect>  <path class="vi-accent" d="M7,10H41v3H7V10Zm4,7H37v5H11V17Zm0,9h8v8H11V26Zm11,0H37v3H22V26Zm0,5h8v3H22V31Z"></path>',
      wrench:
        '    <path class="vi-accent" d="M7,36L24,19l6,6L13,42Z"></path>  <path class="vi-primary" d="M23.206,24.763a11,11,0,0,1,0-15.556A11.952,11.952,0,0,1,36,7l-8,8v5h5l8-7a10.314,10.314,0,0,1-2.238,11.763A11,11,0,0,1,23.206,24.763Z"></path>  <circle class="vi-prop" cx="14" cy="35" r="2"></circle>',
      zoomIn:
        '    <path class="vi-accent" d="M25.283,28.611L35.889,39.218l2.828-2.828L28.111,25.783ZM25,21H21v4H19V21H15V19h4V15h2v4h4v2Z"></path>  <path class="vi-primary" d="M20,32A12,12,0,1,1,32,20,12,12,0,0,1,20,32Zm0-20a8,8,0,1,0,8,8A8,8,0,0,0,20,12Z"></path>',
      zoomOut:
        '    <path class="vi-accent" d="M25.283,28.611L35.889,39.218l2.828-2.828L28.111,25.783ZM25,21H15V19H25v2Z"></path>  <path class="vi-primary" d="M20,32A12,12,0,1,1,32,20,12,12,0,0,1,20,32Zm0-20a8,8,0,1,0,8,8A8,8,0,0,0,20,12Z"></path>',
    };
  },
  function (a, t, c) {
    "use strict";
    c.r(t);
    let h = "48",
      l = "#FF6E6E",
      p = "#0C0058",
      i = "#FFFFFF",
      s = function (a, t) {
        for (let c in t) a.setAttribute(c, t[c]);
      };
    let r,
      e = c(0),
      v = function () {
        (r = document.querySelectorAll("[data-vi]")).forEach(function (a, t) {
          let c = a,
            r = c.dataset.vi;
          e[r];
          -1 !== r.indexOf("-") &&
            (r = r.replace(/-([a-z])/g, function (a) {
              return a[1].toUpperCase();
            }));
          var v = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          v.innerHTML = e[r];
          let Z = v.querySelectorAll(".vi-primary"),
            H = v.querySelectorAll(".vi-accent"),
            V = v.querySelectorAll(".vi-prop");
          if (void 0 != Z && null != Z && (void 0 !== l || "" !== l))
            for (let a = 0; a < Z.length; a++) Z[a].style.fill = l;
          if (void 0 != H && null != H && (void 0 !== p || "" !== p))
            for (let a = 0; a < H.length; a++) H[a].style.fill = p;
          if (void 0 != V && null != V && (void 0 !== i || "" !== i))
            for (let a = 0; a < V.length; a++) V[a].style.fill = i;
          if (
            (s(
              v,
              void 0 !== h && "" !== h
                ? { width: h, height: h, viewBox: "0 0 48 48" }
                : { width: "48", height: "48", viewBox: "0 0 48 48" }
            ),
            void 0 != v)
          ) {
            if (
              (void 0 !== c.dataset.viSize &&
                null !== c.dataset.viSize &&
                s(v, { width: c.dataset.viSize, height: c.dataset.viSize }),
              void 0 !== c.dataset.viPrimary && null !== c.dataset.viPrimary)
            ) {
              let a = v.querySelectorAll(".vi-primary");
              for (let t = 0; t < a.length; t++)
                a[t].style.fill = c.dataset.viPrimary;
            }
            if (void 0 !== c.dataset.viAccent && null !== c.dataset.viAccent) {
              let a = v.querySelectorAll(".vi-accent");
              for (let t = 0; t < a.length; t++)
                a[t].style.fill = c.dataset.viAccent;
            }
            if (void 0 !== c.dataset.viProp && null !== c.dataset.viProp) {
              let a = v.querySelectorAll(".vi-prop");
              for (let t = 0; t < a.length; t++)
                a[t].style.fill = c.dataset.viProp;
            }
            c.parentNode.replaceChild(v, c);
          } else {
            let a = '%c Vivid Error: No icon found for data-vi="' + r + '"';
            console.log(a, "color: #ff4646; font-weight: bold");
          }
        });
      };
    "loading" !== document.readyState
      ? v()
      : document.addEventListener("DOMContentLoaded", function () {
          v();
        });
  },
]);
!(function (i) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], i)
    : "undefined" != typeof exports
    ? (module.exports = i(require("jquery")))
    : i(jQuery);
})(function (i) {
  "use strict";
  var e = window.Slick || {};
  ((e = (function () {
    var e = 0;
    return function (t, o) {
      var s,
        n = this;
      (n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(t),
        appendDots: i(t),
        arrows: !0,
        asNavFor: null,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function (e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3,
      }),
        (n.initials = {
          animating: !1,
          dragging: !1,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          scrolling: !1,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: !1,
          slideOffset: 0,
          swipeLeft: null,
          swiping: !1,
          $list: null,
          touchObject: {},
          transformsEnabled: !1,
          unslicked: !1,
        }),
        i.extend(n, n.initials),
        (n.activeBreakpoint = null),
        (n.animType = null),
        (n.animProp = null),
        (n.breakpoints = []),
        (n.breakpointSettings = []),
        (n.cssTransitions = !1),
        (n.focussed = !1),
        (n.interrupted = !1),
        (n.hidden = "hidden"),
        (n.paused = !0),
        (n.positionProp = null),
        (n.respondTo = null),
        (n.rowCount = 1),
        (n.shouldClick = !0),
        (n.$slider = i(t)),
        (n.$slidesCache = null),
        (n.transformType = null),
        (n.transitionType = null),
        (n.visibilityChange = "visibilitychange"),
        (n.windowWidth = 0),
        (n.windowTimer = null),
        (s = i(t).data("slick") || {}),
        (n.options = i.extend({}, n.defaults, o, s)),
        (n.currentSlide = n.options.initialSlide),
        (n.originalSettings = n.options),
        void 0 !== document.mozHidden
          ? ((n.hidden = "mozHidden"),
            (n.visibilityChange = "mozvisibilitychange"))
          : void 0 !== document.webkitHidden &&
            ((n.hidden = "webkitHidden"),
            (n.visibilityChange = "webkitvisibilitychange")),
        (n.autoPlay = i.proxy(n.autoPlay, n)),
        (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
        (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
        (n.changeSlide = i.proxy(n.changeSlide, n)),
        (n.clickHandler = i.proxy(n.clickHandler, n)),
        (n.selectHandler = i.proxy(n.selectHandler, n)),
        (n.setPosition = i.proxy(n.setPosition, n)),
        (n.swipeHandler = i.proxy(n.swipeHandler, n)),
        (n.dragHandler = i.proxy(n.dragHandler, n)),
        (n.keyHandler = i.proxy(n.keyHandler, n)),
        (n.instanceUid = e++),
        (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
        n.registerBreakpoints(),
        n.init(!0);
    };
  })()).prototype.activateADA = function () {
    this.$slideTrack
      .find(".slick-active")
      .attr({ "aria-hidden": "false" })
      .find("a, input, button, select")
      .attr({ tabindex: "0" });
  }),
    (e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
      var s = this;
      if ("boolean" == typeof t) (o = t), (t = null);
      else if (t < 0 || t >= s.slideCount) return !1;
      s.unload(),
        "number" == typeof t
          ? 0 === t && 0 === s.$slides.length
            ? i(e).appendTo(s.$slideTrack)
            : o
            ? i(e).insertBefore(s.$slides.eq(t))
            : i(e).insertAfter(s.$slides.eq(t))
          : !0 === o
          ? i(e).prependTo(s.$slideTrack)
          : i(e).appendTo(s.$slideTrack),
        (s.$slides = s.$slideTrack.children(this.options.slide)),
        s.$slideTrack.children(this.options.slide).detach(),
        s.$slideTrack.append(s.$slides),
        s.$slides.each(function (e, t) {
          i(t).attr("data-slick-index", e);
        }),
        (s.$slidesCache = s.$slides),
        s.reinit();
    }),
    (e.prototype.animateHeight = function () {
      var i = this;
      if (
        1 === i.options.slidesToShow &&
        !0 === i.options.adaptiveHeight &&
        !1 === i.options.vertical
      ) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
        i.$list.animate({ height: e }, i.options.speed);
      }
    }),
    (e.prototype.animateSlide = function (e, t) {
      var o = {},
        s = this;
      s.animateHeight(),
        !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
        !1 === s.transformsEnabled
          ? !1 === s.options.vertical
            ? s.$slideTrack.animate(
                { left: e },
                s.options.speed,
                s.options.easing,
                t
              )
            : s.$slideTrack.animate(
                { top: e },
                s.options.speed,
                s.options.easing,
                t
              )
          : !1 === s.cssTransitions
          ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
            i({ animStart: s.currentLeft }).animate(
              { animStart: e },
              {
                duration: s.options.speed,
                easing: s.options.easing,
                step: function (i) {
                  (i = Math.ceil(i)),
                    !1 === s.options.vertical
                      ? ((o[s.animType] = "translate(" + i + "px, 0px)"),
                        s.$slideTrack.css(o))
                      : ((o[s.animType] = "translate(0px," + i + "px)"),
                        s.$slideTrack.css(o));
                },
                complete: function () {
                  t && t.call();
                },
              }
            ))
          : (s.applyTransition(),
            (e = Math.ceil(e)),
            !1 === s.options.vertical
              ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)")
              : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
            s.$slideTrack.css(o),
            t &&
              setTimeout(function () {
                s.disableTransition(), t.call();
              }, s.options.speed));
    }),
    (e.prototype.getNavTarget = function () {
      var e = this,
        t = e.options.asNavFor;
      return t && null !== t && (t = i(t).not(e.$slider)), t;
    }),
    (e.prototype.asNavFor = function (e) {
      var t = this.getNavTarget();
      null !== t &&
        "object" == typeof t &&
        t.each(function () {
          var t = i(this).slick("getSlick");
          t.unslicked || t.slideHandler(e, !0);
        });
    }),
    (e.prototype.applyTransition = function (i) {
      var e = this,
        t = {};
      !1 === e.options.fade
        ? (t[e.transitionType] =
            e.transformType + " " + e.options.speed + "ms " + e.options.cssEase)
        : (t[e.transitionType] =
            "opacity " + e.options.speed + "ms " + e.options.cssEase),
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
    }),
    (e.prototype.autoPlay = function () {
      var i = this;
      i.autoPlayClear(),
        i.slideCount > i.options.slidesToShow &&
          (i.autoPlayTimer = setInterval(
            i.autoPlayIterator,
            i.options.autoplaySpeed
          ));
    }),
    (e.prototype.autoPlayClear = function () {
      var i = this;
      i.autoPlayTimer && clearInterval(i.autoPlayTimer);
    }),
    (e.prototype.autoPlayIterator = function () {
      var i = this,
        e = i.currentSlide + i.options.slidesToScroll;
      i.paused ||
        i.interrupted ||
        i.focussed ||
        (!1 === i.options.infinite &&
          (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
            ? (i.direction = 0)
            : 0 === i.direction &&
              ((e = i.currentSlide - i.options.slidesToScroll),
              i.currentSlide - 1 == 0 && (i.direction = 1))),
        i.slideHandler(e));
    }),
    (e.prototype.buildArrows = function () {
      var e = this;
      !0 === e.options.arrows &&
        ((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")),
        (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
        e.slideCount > e.options.slidesToShow
          ? (e.$prevArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e.$nextArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e.htmlExpr.test(e.options.prevArrow) &&
              e.$prevArrow.prependTo(e.options.appendArrows),
            e.htmlExpr.test(e.options.nextArrow) &&
              e.$nextArrow.appendTo(e.options.appendArrows),
            !0 !== e.options.infinite &&
              e.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"))
          : e.$prevArrow
              .add(e.$nextArrow)
              .addClass("slick-hidden")
              .attr({ "aria-disabled": "true", tabindex: "-1" }));
    }),
    (e.prototype.buildDots = function () {
      var e,
        t,
        o = this;
      if (!0 === o.options.dots) {
        for (
          o.$slider.addClass("slick-dotted"),
            t = i("<ul />").addClass(o.options.dotsClass),
            e = 0;
          e <= o.getDotCount();
          e += 1
        )
          t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
        (o.$dots = t.appendTo(o.options.appendDots)),
          o.$dots.find("li").first().addClass("slick-active");
      }
    }),
    (e.prototype.buildOut = function () {
      var e = this;
      (e.$slides = e.$slider
        .children(e.options.slide + ":not(.slick-cloned)")
        .addClass("slick-slide")),
        (e.slideCount = e.$slides.length),
        e.$slides.each(function (e, t) {
          i(t)
            .attr("data-slick-index", e)
            .data("originalStyling", i(t).attr("style") || "");
        }),
        e.$slider.addClass("slick-slider"),
        (e.$slideTrack =
          0 === e.slideCount
            ? i('<div class="slick-track"/>').appendTo(e.$slider)
            : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
        (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
        e.$slideTrack.css("opacity", 0),
        (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
          (e.options.slidesToScroll = 1),
        i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
        e.setupInfinite(),
        e.buildArrows(),
        e.buildDots(),
        e.updateDots(),
        e.setSlideClasses(
          "number" == typeof e.currentSlide ? e.currentSlide : 0
        ),
        !0 === e.options.draggable && e.$list.addClass("draggable");
    }),
    (e.prototype.buildRows = function () {
      var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;
      if (
        ((o = document.createDocumentFragment()),
        (n = l.$slider.children()),
        l.options.rows > 1)
      ) {
        for (
          r = l.options.slidesPerRow * l.options.rows,
            s = Math.ceil(n.length / r),
            i = 0;
          i < s;
          i++
        ) {
          var d = document.createElement("div");
          for (e = 0; e < l.options.rows; e++) {
            var a = document.createElement("div");
            for (t = 0; t < l.options.slidesPerRow; t++) {
              var c = i * r + (e * l.options.slidesPerRow + t);
              n.get(c) && a.appendChild(n.get(c));
            }
            d.appendChild(a);
          }
          o.appendChild(d);
        }
        l.$slider.empty().append(o),
          l.$slider
            .children()
            .children()
            .children()
            .css({
              width: 100 / l.options.slidesPerRow + "%",
              display: "inline-block",
            });
      }
    }),
    (e.prototype.checkResponsive = function (e, t) {
      var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();
      if (
        ("window" === r.respondTo
          ? (n = a)
          : "slider" === r.respondTo
          ? (n = d)
          : "min" === r.respondTo && (n = Math.min(a, d)),
        r.options.responsive &&
          r.options.responsive.length &&
          null !== r.options.responsive)
      ) {
        s = null;
        for (o in r.breakpoints)
          r.breakpoints.hasOwnProperty(o) &&
            (!1 === r.originalSettings.mobileFirst
              ? n < r.breakpoints[o] && (s = r.breakpoints[o])
              : n > r.breakpoints[o] && (s = r.breakpoints[o]));
        null !== s
          ? null !== r.activeBreakpoint
            ? (s !== r.activeBreakpoint || t) &&
              ((r.activeBreakpoint = s),
              "unslick" === r.breakpointSettings[s]
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (l = s))
            : ((r.activeBreakpoint = s),
              "unslick" === r.breakpointSettings[s]
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (l = s))
          : null !== r.activeBreakpoint &&
            ((r.activeBreakpoint = null),
            (r.options = r.originalSettings),
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e),
            (l = s)),
          e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
      }
    }),
    (e.prototype.changeSlide = function (e, t) {
      var o,
        s,
        n,
        r = this,
        l = i(e.currentTarget);
      switch (
        (l.is("a") && e.preventDefault(),
        l.is("li") || (l = l.closest("li")),
        (n = r.slideCount % r.options.slidesToScroll != 0),
        (o = n
          ? 0
          : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
        e.data.message)
      ) {
        case "previous":
          (s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o),
            r.slideCount > r.options.slidesToShow &&
              r.slideHandler(r.currentSlide - s, !1, t);
          break;
        case "next":
          (s = 0 === o ? r.options.slidesToScroll : o),
            r.slideCount > r.options.slidesToShow &&
              r.slideHandler(r.currentSlide + s, !1, t);
          break;
        case "index":
          var d =
            0 === e.data.index
              ? 0
              : e.data.index || l.index() * r.options.slidesToScroll;
          r.slideHandler(r.checkNavigable(d), !1, t),
            l.children().trigger("focus");
          break;
        default:
          return;
      }
    }),
    (e.prototype.checkNavigable = function (i) {
      var e, t;
      if (((e = this.getNavigableIndexes()), (t = 0), i > e[e.length - 1]))
        i = e[e.length - 1];
      else
        for (var o in e) {
          if (i < e[o]) {
            i = t;
            break;
          }
          t = e[o];
        }
      return i;
    }),
    (e.prototype.cleanUpEvents = function () {
      var e = this;
      e.options.dots &&
        null !== e.$dots &&
        (i("li", e.$dots)
          .off("click.slick", e.changeSlide)
          .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
          .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
        !0 === e.options.accessibility &&
          e.$dots.off("keydown.slick", e.keyHandler)),
        e.$slider.off("focus.slick blur.slick"),
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
          e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
          !0 === e.options.accessibility &&
            (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
            e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
        e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
        e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
        e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
        e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
        e.$list.off("click.slick", e.clickHandler),
        i(document).off(e.visibilityChange, e.visibility),
        e.cleanUpSlideEvents(),
        !0 === e.options.accessibility &&
          e.$list.off("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().off("click.slick", e.selectHandler),
        i(window).off(
          "orientationchange.slick.slick-" + e.instanceUid,
          e.orientationChange
        ),
        i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
        i("[draggable!=true]", e.$slideTrack).off(
          "dragstart",
          e.preventDefault
        ),
        i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
    }),
    (e.prototype.cleanUpSlideEvents = function () {
      var e = this;
      e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
    }),
    (e.prototype.cleanUpRows = function () {
      var i,
        e = this;
      e.options.rows > 1 &&
        ((i = e.$slides.children().children()).removeAttr("style"),
        e.$slider.empty().append(i));
    }),
    (e.prototype.clickHandler = function (i) {
      !1 === this.shouldClick &&
        (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
    }),
    (e.prototype.destroy = function (e) {
      var t = this;
      t.autoPlayClear(),
        (t.touchObject = {}),
        t.cleanUpEvents(),
        i(".slick-cloned", t.$slider).detach(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow &&
          t.$prevArrow.length &&
          (t.$prevArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
        t.$nextArrow &&
          t.$nextArrow.length &&
          (t.$nextArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
        t.$slides &&
          (t.$slides
            .removeClass(
              "slick-slide slick-active slick-center slick-visible slick-current"
            )
            .removeAttr("aria-hidden")
            .removeAttr("data-slick-index")
            .each(function () {
              i(this).attr("style", i(this).data("originalStyling"));
            }),
          t.$slideTrack.children(this.options.slide).detach(),
          t.$slideTrack.detach(),
          t.$list.detach(),
          t.$slider.append(t.$slides)),
        t.cleanUpRows(),
        t.$slider.removeClass("slick-slider"),
        t.$slider.removeClass("slick-initialized"),
        t.$slider.removeClass("slick-dotted"),
        (t.unslicked = !0),
        e || t.$slider.trigger("destroy", [t]);
    }),
    (e.prototype.disableTransition = function (i) {
      var e = this,
        t = {};
      (t[e.transitionType] = ""),
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
    }),
    (e.prototype.fadeSlide = function (i, e) {
      var t = this;
      !1 === t.cssTransitions
        ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
          t.$slides
            .eq(i)
            .animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
        : (t.applyTransition(i),
          t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
          e &&
            setTimeout(function () {
              t.disableTransition(i), e.call();
            }, t.options.speed));
    }),
    (e.prototype.fadeSlideOut = function (i) {
      var e = this;
      !1 === e.cssTransitions
        ? e.$slides
            .eq(i)
            .animate(
              { opacity: 0, zIndex: e.options.zIndex - 2 },
              e.options.speed,
              e.options.easing
            )
        : (e.applyTransition(i),
          e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
    }),
    (e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
      var e = this;
      null !== i &&
        ((e.$slidesCache = e.$slides),
        e.unload(),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slidesCache.filter(i).appendTo(e.$slideTrack),
        e.reinit());
    }),
    (e.prototype.focusHandler = function () {
      var e = this;
      e.$slider
        .off("focus.slick blur.slick")
        .on("focus.slick blur.slick", "*", function (t) {
          t.stopImmediatePropagation();
          var o = i(this);
          setTimeout(function () {
            e.options.pauseOnFocus &&
              ((e.focussed = o.is(":focus")), e.autoPlay());
          }, 0);
        });
    }),
    (e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
      return this.currentSlide;
    }),
    (e.prototype.getDotCount = function () {
      var i = this,
        e = 0,
        t = 0,
        o = 0;
      if (!0 === i.options.infinite)
        if (i.slideCount <= i.options.slidesToShow) ++o;
        else
          for (; e < i.slideCount; )
            ++o,
              (e = t + i.options.slidesToScroll),
              (t +=
                i.options.slidesToScroll <= i.options.slidesToShow
                  ? i.options.slidesToScroll
                  : i.options.slidesToShow);
      else if (!0 === i.options.centerMode) o = i.slideCount;
      else if (i.options.asNavFor)
        for (; e < i.slideCount; )
          ++o,
            (e = t + i.options.slidesToScroll),
            (t +=
              i.options.slidesToScroll <= i.options.slidesToShow
                ? i.options.slidesToScroll
                : i.options.slidesToShow);
      else
        o =
          1 +
          Math.ceil(
            (i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll
          );
      return o - 1;
    }),
    (e.prototype.getLeft = function (i) {
      var e,
        t,
        o,
        s,
        n = this,
        r = 0;
      return (
        (n.slideOffset = 0),
        (t = n.$slides.first().outerHeight(!0)),
        !0 === n.options.infinite
          ? (n.slideCount > n.options.slidesToShow &&
              ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
              (s = -1),
              !0 === n.options.vertical &&
                !0 === n.options.centerMode &&
                (2 === n.options.slidesToShow
                  ? (s = -1.5)
                  : 1 === n.options.slidesToShow && (s = -2)),
              (r = t * n.options.slidesToShow * s)),
            n.slideCount % n.options.slidesToScroll != 0 &&
              i + n.options.slidesToScroll > n.slideCount &&
              n.slideCount > n.options.slidesToShow &&
              (i > n.slideCount
                ? ((n.slideOffset =
                    (n.options.slidesToShow - (i - n.slideCount)) *
                    n.slideWidth *
                    -1),
                  (r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1))
                : ((n.slideOffset =
                    (n.slideCount % n.options.slidesToScroll) *
                    n.slideWidth *
                    -1),
                  (r = (n.slideCount % n.options.slidesToScroll) * t * -1))))
          : i + n.options.slidesToShow > n.slideCount &&
            ((n.slideOffset =
              (i + n.options.slidesToShow - n.slideCount) * n.slideWidth),
            (r = (i + n.options.slidesToShow - n.slideCount) * t)),
        n.slideCount <= n.options.slidesToShow &&
          ((n.slideOffset = 0), (r = 0)),
        !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
          ? (n.slideOffset =
              (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
              (n.slideWidth * n.slideCount) / 2)
          : !0 === n.options.centerMode && !0 === n.options.infinite
          ? (n.slideOffset +=
              n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
              n.slideWidth)
          : !0 === n.options.centerMode &&
            ((n.slideOffset = 0),
            (n.slideOffset +=
              n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
        (e =
          !1 === n.options.vertical
            ? i * n.slideWidth * -1 + n.slideOffset
            : i * t * -1 + r),
        !0 === n.options.variableWidth &&
          ((o =
            n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite
              ? n.$slideTrack.children(".slick-slide").eq(i)
              : n.$slideTrack
                  .children(".slick-slide")
                  .eq(i + n.options.slidesToShow)),
          (e =
            !0 === n.options.rtl
              ? o[0]
                ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                : 0
              : o[0]
              ? -1 * o[0].offsetLeft
              : 0),
          !0 === n.options.centerMode &&
            ((o =
              n.slideCount <= n.options.slidesToShow ||
              !1 === n.options.infinite
                ? n.$slideTrack.children(".slick-slide").eq(i)
                : n.$slideTrack
                    .children(".slick-slide")
                    .eq(i + n.options.slidesToShow + 1)),
            (e =
              !0 === n.options.rtl
                ? o[0]
                  ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                ? -1 * o[0].offsetLeft
                : 0),
            (e += (n.$list.width() - o.outerWidth()) / 2))),
        e
      );
    }),
    (e.prototype.getOption = e.prototype.slickGetOption = function (i) {
      return this.options[i];
    }),
    (e.prototype.getNavigableIndexes = function () {
      var i,
        e = this,
        t = 0,
        o = 0,
        s = [];
      for (
        !1 === e.options.infinite
          ? (i = e.slideCount)
          : ((t = -1 * e.options.slidesToScroll),
            (o = -1 * e.options.slidesToScroll),
            (i = 2 * e.slideCount));
        t < i;

      )
        s.push(t),
          (t = o + e.options.slidesToScroll),
          (o +=
            e.options.slidesToScroll <= e.options.slidesToShow
              ? e.options.slidesToScroll
              : e.options.slidesToShow);
      return s;
    }),
    (e.prototype.getSlick = function () {
      return this;
    }),
    (e.prototype.getSlideCount = function () {
      var e,
        t,
        o = this;
      return (
        (t =
          !0 === o.options.centerMode
            ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
            : 0),
        !0 === o.options.swipeToSlide
          ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
              if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft)
                return (e = n), !1;
            }),
            Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1)
          : o.options.slidesToScroll
      );
    }),
    (e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
      this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
    }),
    (e.prototype.init = function (e) {
      var t = this;
      i(t.$slider).hasClass("slick-initialized") ||
        (i(t.$slider).addClass("slick-initialized"),
        t.buildRows(),
        t.buildOut(),
        t.setProps(),
        t.startLoad(),
        t.loadSlider(),
        t.initializeEvents(),
        t.updateArrows(),
        t.updateDots(),
        t.checkResponsive(!0),
        t.focusHandler()),
        e && t.$slider.trigger("init", [t]),
        !0 === t.options.accessibility && t.initADA(),
        t.options.autoplay && ((t.paused = !1), t.autoPlay());
    }),
    (e.prototype.initADA = function () {
      var e = this,
        t = Math.ceil(e.slideCount / e.options.slidesToShow),
        o = e.getNavigableIndexes().filter(function (i) {
          return i >= 0 && i < e.slideCount;
        });
      e.$slides
        .add(e.$slideTrack.find(".slick-cloned"))
        .attr({ "aria-hidden": "true", tabindex: "-1" })
        .find("a, input, button, select")
        .attr({ tabindex: "-1" }),
        null !== e.$dots &&
          (e.$slides
            .not(e.$slideTrack.find(".slick-cloned"))
            .each(function (t) {
              var s = o.indexOf(t);
              i(this).attr({
                role: "tabpanel",
                id: "slick-slide" + e.instanceUid + t,
                tabindex: -1,
              }),
                -1 !== s &&
                  i(this).attr({
                    "aria-describedby":
                      "slick-slide-control" + e.instanceUid + s,
                  });
            }),
          e.$dots
            .attr("role", "tablist")
            .find("li")
            .each(function (s) {
              var n = o[s];
              i(this).attr({ role: "presentation" }),
                i(this)
                  .find("button")
                  .first()
                  .attr({
                    role: "tab",
                    id: "slick-slide-control" + e.instanceUid + s,
                    "aria-controls": "slick-slide" + e.instanceUid + n,
                    "aria-label": s + 1 + " of " + t,
                    "aria-selected": null,
                    tabindex: "-1",
                  });
            })
            .eq(e.currentSlide)
            .find("button")
            .attr({ "aria-selected": "true", tabindex: "0" })
            .end());
      for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++)
        e.$slides.eq(s).attr("tabindex", 0);
      e.activateADA();
    }),
    (e.prototype.initArrowEvents = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow
          .off("click.slick")
          .on("click.slick", { message: "previous" }, i.changeSlide),
        i.$nextArrow
          .off("click.slick")
          .on("click.slick", { message: "next" }, i.changeSlide),
        !0 === i.options.accessibility &&
          (i.$prevArrow.on("keydown.slick", i.keyHandler),
          i.$nextArrow.on("keydown.slick", i.keyHandler)));
    }),
    (e.prototype.initDotEvents = function () {
      var e = this;
      !0 === e.options.dots &&
        (i("li", e.$dots).on(
          "click.slick",
          { message: "index" },
          e.changeSlide
        ),
        !0 === e.options.accessibility &&
          e.$dots.on("keydown.slick", e.keyHandler)),
        !0 === e.options.dots &&
          !0 === e.options.pauseOnDotsHover &&
          i("li", e.$dots)
            .on("mouseenter.slick", i.proxy(e.interrupt, e, !0))
            .on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
    }),
    (e.prototype.initSlideEvents = function () {
      var e = this;
      e.options.pauseOnHover &&
        (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
    }),
    (e.prototype.initializeEvents = function () {
      var e = this;
      e.initArrowEvents(),
        e.initDotEvents(),
        e.initSlideEvents(),
        e.$list.on(
          "touchstart.slick mousedown.slick",
          { action: "start" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchmove.slick mousemove.slick",
          { action: "move" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchend.slick mouseup.slick",
          { action: "end" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchcancel.slick mouseleave.slick",
          { action: "end" },
          e.swipeHandler
        ),
        e.$list.on("click.slick", e.clickHandler),
        i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
        !0 === e.options.accessibility &&
          e.$list.on("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        i(window).on(
          "orientationchange.slick.slick-" + e.instanceUid,
          i.proxy(e.orientationChange, e)
        ),
        i(window).on(
          "resize.slick.slick-" + e.instanceUid,
          i.proxy(e.resize, e)
        ),
        i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
        i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
        i(e.setPosition);
    }),
    (e.prototype.initUI = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow.show(), i.$nextArrow.show()),
        !0 === i.options.dots &&
          i.slideCount > i.options.slidesToShow &&
          i.$dots.show();
    }),
    (e.prototype.keyHandler = function (i) {
      var e = this;
      i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
        (37 === i.keyCode && !0 === e.options.accessibility
          ? e.changeSlide({
              data: { message: !0 === e.options.rtl ? "next" : "previous" },
            })
          : 39 === i.keyCode &&
            !0 === e.options.accessibility &&
            e.changeSlide({
              data: { message: !0 === e.options.rtl ? "previous" : "next" },
            }));
    }),
    (e.prototype.lazyLoad = function () {
      function e(e) {
        i("img[data-lazy]", e).each(function () {
          var e = i(this),
            t = i(this).attr("data-lazy"),
            o = i(this).attr("data-srcset"),
            s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
            r = document.createElement("img");
          (r.onload = function () {
            e.animate({ opacity: 0 }, 100, function () {
              o && (e.attr("srcset", o), s && e.attr("sizes", s)),
                e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                  e.removeAttr("data-lazy data-srcset data-sizes").removeClass(
                    "slick-loading"
                  );
                }),
                n.$slider.trigger("lazyLoaded", [n, e, t]);
            });
          }),
            (r.onerror = function () {
              e
                .removeAttr("data-lazy")
                .removeClass("slick-loading")
                .addClass("slick-lazyload-error"),
                n.$slider.trigger("lazyLoadError", [n, e, t]);
            }),
            (r.src = t);
        });
      }
      var t,
        o,
        s,
        n = this;
      if (
        (!0 === n.options.centerMode
          ? !0 === n.options.infinite
            ? (s =
                (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                n.options.slidesToShow +
                2)
            : ((o = Math.max(
                0,
                n.currentSlide - (n.options.slidesToShow / 2 + 1)
              )),
              (s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
          : ((o = n.options.infinite
              ? n.options.slidesToShow + n.currentSlide
              : n.currentSlide),
            (s = Math.ceil(o + n.options.slidesToShow)),
            !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)),
        (t = n.$slider.find(".slick-slide").slice(o, s)),
        "anticipated" === n.options.lazyLoad)
      )
        for (
          var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0;
          a < n.options.slidesToScroll;
          a++
        )
          r < 0 && (r = n.slideCount - 1),
            (t = (t = t.add(d.eq(r))).add(d.eq(l))),
            r--,
            l++;
      e(t),
        n.slideCount <= n.options.slidesToShow
          ? e(n.$slider.find(".slick-slide"))
          : n.currentSlide >= n.slideCount - n.options.slidesToShow
          ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow))
          : 0 === n.currentSlide &&
            e(
              n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow)
            );
    }),
    (e.prototype.loadSlider = function () {
      var i = this;
      i.setPosition(),
        i.$slideTrack.css({ opacity: 1 }),
        i.$slider.removeClass("slick-loading"),
        i.initUI(),
        "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
    }),
    (e.prototype.next = e.prototype.slickNext = function () {
      this.changeSlide({ data: { message: "next" } });
    }),
    (e.prototype.orientationChange = function () {
      var i = this;
      i.checkResponsive(), i.setPosition();
    }),
    (e.prototype.pause = e.prototype.slickPause = function () {
      var i = this;
      i.autoPlayClear(), (i.paused = !0);
    }),
    (e.prototype.play = e.prototype.slickPlay = function () {
      var i = this;
      i.autoPlay(),
        (i.options.autoplay = !0),
        (i.paused = !1),
        (i.focussed = !1),
        (i.interrupted = !1);
    }),
    (e.prototype.postSlide = function (e) {
      var t = this;
      t.unslicked ||
        (t.$slider.trigger("afterChange", [t, e]),
        (t.animating = !1),
        t.slideCount > t.options.slidesToShow && t.setPosition(),
        (t.swipeLeft = null),
        t.options.autoplay && t.autoPlay(),
        !0 === t.options.accessibility &&
          (t.initADA(),
          t.options.focusOnChange &&
            i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
    }),
    (e.prototype.prev = e.prototype.slickPrev = function () {
      this.changeSlide({ data: { message: "previous" } });
    }),
    (e.prototype.preventDefault = function (i) {
      i.preventDefault();
    }),
    (e.prototype.progressiveLazyLoad = function (e) {
      e = e || 1;
      var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i("img[data-lazy]", l.$slider);
      d.length
        ? ((t = d.first()),
          (o = t.attr("data-lazy")),
          (s = t.attr("data-srcset")),
          (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
          ((r = document.createElement("img")).onload = function () {
            s && (t.attr("srcset", s), n && t.attr("sizes", n)),
              t
                .attr("src", o)
                .removeAttr("data-lazy data-srcset data-sizes")
                .removeClass("slick-loading"),
              !0 === l.options.adaptiveHeight && l.setPosition(),
              l.$slider.trigger("lazyLoaded", [l, t, o]),
              l.progressiveLazyLoad();
          }),
          (r.onerror = function () {
            e < 3
              ? setTimeout(function () {
                  l.progressiveLazyLoad(e + 1);
                }, 500)
              : (t
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                l.$slider.trigger("lazyLoadError", [l, t, o]),
                l.progressiveLazyLoad());
          }),
          (r.src = o))
        : l.$slider.trigger("allImagesLoaded", [l]);
    }),
    (e.prototype.refresh = function (e) {
      var t,
        o,
        s = this;
      (o = s.slideCount - s.options.slidesToShow),
        !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
        s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
        (t = s.currentSlide),
        s.destroy(!0),
        i.extend(s, s.initials, { currentSlide: t }),
        s.init(),
        e || s.changeSlide({ data: { message: "index", index: t } }, !1);
    }),
    (e.prototype.registerBreakpoints = function () {
      var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;
      if ("array" === i.type(n) && n.length) {
        s.respondTo = s.options.respondTo || "window";
        for (e in n)
          if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
            for (t = n[e].breakpoint; o >= 0; )
              s.breakpoints[o] &&
                s.breakpoints[o] === t &&
                s.breakpoints.splice(o, 1),
                o--;
            s.breakpoints.push(t), (s.breakpointSettings[t] = n[e].settings);
          }
        s.breakpoints.sort(function (i, e) {
          return s.options.mobileFirst ? i - e : e - i;
        });
      }
    }),
    (e.prototype.reinit = function () {
      var e = this;
      (e.$slides = e.$slideTrack
        .children(e.options.slide)
        .addClass("slick-slide")),
        (e.slideCount = e.$slides.length),
        e.currentSlide >= e.slideCount &&
          0 !== e.currentSlide &&
          (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
        e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
        e.registerBreakpoints(),
        e.setProps(),
        e.setupInfinite(),
        e.buildArrows(),
        e.updateArrows(),
        e.initArrowEvents(),
        e.buildDots(),
        e.updateDots(),
        e.initDotEvents(),
        e.cleanUpSlideEvents(),
        e.initSlideEvents(),
        e.checkResponsive(!1, !0),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        e.setSlideClasses(
          "number" == typeof e.currentSlide ? e.currentSlide : 0
        ),
        e.setPosition(),
        e.focusHandler(),
        (e.paused = !e.options.autoplay),
        e.autoPlay(),
        e.$slider.trigger("reInit", [e]);
    }),
    (e.prototype.resize = function () {
      var e = this;
      i(window).width() !== e.windowWidth &&
        (clearTimeout(e.windowDelay),
        (e.windowDelay = window.setTimeout(function () {
          (e.windowWidth = i(window).width()),
            e.checkResponsive(),
            e.unslicked || e.setPosition();
        }, 50)));
    }),
    (e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
      var o = this;
      if (
        ((i =
          "boolean" == typeof i
            ? !0 === (e = i)
              ? 0
              : o.slideCount - 1
            : !0 === e
            ? --i
            : i),
        o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
      )
        return !1;
      o.unload(),
        !0 === t
          ? o.$slideTrack.children().remove()
          : o.$slideTrack.children(this.options.slide).eq(i).remove(),
        (o.$slides = o.$slideTrack.children(this.options.slide)),
        o.$slideTrack.children(this.options.slide).detach(),
        o.$slideTrack.append(o.$slides),
        (o.$slidesCache = o.$slides),
        o.reinit();
    }),
    (e.prototype.setCSS = function (i) {
      var e,
        t,
        o = this,
        s = {};
      !0 === o.options.rtl && (i = -i),
        (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
        (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
        (s[o.positionProp] = i),
        !1 === o.transformsEnabled
          ? o.$slideTrack.css(s)
          : ((s = {}),
            !1 === o.cssTransitions
              ? ((s[o.animType] = "translate(" + e + ", " + t + ")"),
                o.$slideTrack.css(s))
              : ((s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)"),
                o.$slideTrack.css(s)));
    }),
    (e.prototype.setDimensions = function () {
      var i = this;
      !1 === i.options.vertical
        ? !0 === i.options.centerMode &&
          i.$list.css({ padding: "0px " + i.options.centerPadding })
        : (i.$list.height(
            i.$slides.first().outerHeight(!0) * i.options.slidesToShow
          ),
          !0 === i.options.centerMode &&
            i.$list.css({ padding: i.options.centerPadding + " 0px" })),
        (i.listWidth = i.$list.width()),
        (i.listHeight = i.$list.height()),
        !1 === i.options.vertical && !1 === i.options.variableWidth
          ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)),
            i.$slideTrack.width(
              Math.ceil(
                i.slideWidth * i.$slideTrack.children(".slick-slide").length
              )
            ))
          : !0 === i.options.variableWidth
          ? i.$slideTrack.width(5e3 * i.slideCount)
          : ((i.slideWidth = Math.ceil(i.listWidth)),
            i.$slideTrack.height(
              Math.ceil(
                i.$slides.first().outerHeight(!0) *
                  i.$slideTrack.children(".slick-slide").length
              )
            ));
      var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
      !1 === i.options.variableWidth &&
        i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
    }),
    (e.prototype.setFade = function () {
      var e,
        t = this;
      t.$slides.each(function (o, s) {
        (e = t.slideWidth * o * -1),
          !0 === t.options.rtl
            ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              })
            : i(s).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              });
      }),
        t.$slides
          .eq(t.currentSlide)
          .css({ zIndex: t.options.zIndex - 1, opacity: 1 });
    }),
    (e.prototype.setHeight = function () {
      var i = this;
      if (
        1 === i.options.slidesToShow &&
        !0 === i.options.adaptiveHeight &&
        !1 === i.options.vertical
      ) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
        i.$list.css("height", e);
      }
    }),
    (e.prototype.setOption = e.prototype.slickSetOption = function () {
      var e,
        t,
        o,
        s,
        n,
        r = this,
        l = !1;
      if (
        ("object" === i.type(arguments[0])
          ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
          : "string" === i.type(arguments[0]) &&
            ((o = arguments[0]),
            (s = arguments[1]),
            (l = arguments[2]),
            "responsive" === arguments[0] && "array" === i.type(arguments[1])
              ? (n = "responsive")
              : void 0 !== arguments[1] && (n = "single")),
        "single" === n)
      )
        r.options[o] = s;
      else if ("multiple" === n)
        i.each(o, function (i, e) {
          r.options[i] = e;
        });
      else if ("responsive" === n)
        for (t in s)
          if ("array" !== i.type(r.options.responsive))
            r.options.responsive = [s[t]];
          else {
            for (e = r.options.responsive.length - 1; e >= 0; )
              r.options.responsive[e].breakpoint === s[t].breakpoint &&
                r.options.responsive.splice(e, 1),
                e--;
            r.options.responsive.push(s[t]);
          }
      l && (r.unload(), r.reinit());
    }),
    (e.prototype.setPosition = function () {
      var i = this;
      i.setDimensions(),
        i.setHeight(),
        !1 === i.options.fade
          ? i.setCSS(i.getLeft(i.currentSlide))
          : i.setFade(),
        i.$slider.trigger("setPosition", [i]);
    }),
    (e.prototype.setProps = function () {
      var i = this,
        e = document.body.style;
      (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
        "top" === i.positionProp
          ? i.$slider.addClass("slick-vertical")
          : i.$slider.removeClass("slick-vertical"),
        (void 0 === e.WebkitTransition &&
          void 0 === e.MozTransition &&
          void 0 === e.msTransition) ||
          (!0 === i.options.useCSS && (i.cssTransitions = !0)),
        i.options.fade &&
          ("number" == typeof i.options.zIndex
            ? i.options.zIndex < 3 && (i.options.zIndex = 3)
            : (i.options.zIndex = i.defaults.zIndex)),
        void 0 !== e.OTransform &&
          ((i.animType = "OTransform"),
          (i.transformType = "-o-transform"),
          (i.transitionType = "OTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.webkitPerspective &&
            (i.animType = !1)),
        void 0 !== e.MozTransform &&
          ((i.animType = "MozTransform"),
          (i.transformType = "-moz-transform"),
          (i.transitionType = "MozTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.MozPerspective &&
            (i.animType = !1)),
        void 0 !== e.webkitTransform &&
          ((i.animType = "webkitTransform"),
          (i.transformType = "-webkit-transform"),
          (i.transitionType = "webkitTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.webkitPerspective &&
            (i.animType = !1)),
        void 0 !== e.msTransform &&
          ((i.animType = "msTransform"),
          (i.transformType = "-ms-transform"),
          (i.transitionType = "msTransition"),
          void 0 === e.msTransform && (i.animType = !1)),
        void 0 !== e.transform &&
          !1 !== i.animType &&
          ((i.animType = "transform"),
          (i.transformType = "transform"),
          (i.transitionType = "transition")),
        (i.transformsEnabled =
          i.options.useTransform && null !== i.animType && !1 !== i.animType);
    }),
    (e.prototype.setSlideClasses = function (i) {
      var e,
        t,
        o,
        s,
        n = this;
      if (
        ((t = n.$slider
          .find(".slick-slide")
          .removeClass("slick-active slick-center slick-current")
          .attr("aria-hidden", "true")),
        n.$slides.eq(i).addClass("slick-current"),
        !0 === n.options.centerMode)
      ) {
        var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
        (e = Math.floor(n.options.slidesToShow / 2)),
          !0 === n.options.infinite &&
            (i >= e && i <= n.slideCount - 1 - e
              ? n.$slides
                  .slice(i - e + r, i + e + 1)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : ((o = n.options.slidesToShow + i),
                t
                  .slice(o - e + 1 + r, o + e + 2)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")),
            0 === i
              ? t
                  .eq(t.length - 1 - n.options.slidesToShow)
                  .addClass("slick-center")
              : i === n.slideCount - 1 &&
                t.eq(n.options.slidesToShow).addClass("slick-center")),
          n.$slides.eq(i).addClass("slick-center");
      } else
        i >= 0 && i <= n.slideCount - n.options.slidesToShow
          ? n.$slides
              .slice(i, i + n.options.slidesToShow)
              .addClass("slick-active")
              .attr("aria-hidden", "false")
          : t.length <= n.options.slidesToShow
          ? t.addClass("slick-active").attr("aria-hidden", "false")
          : ((s = n.slideCount % n.options.slidesToShow),
            (o = !0 === n.options.infinite ? n.options.slidesToShow + i : i),
            n.options.slidesToShow == n.options.slidesToScroll &&
            n.slideCount - i < n.options.slidesToShow
              ? t
                  .slice(o - (n.options.slidesToShow - s), o + s)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : t
                  .slice(o, o + n.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false"));
      ("ondemand" !== n.options.lazyLoad &&
        "anticipated" !== n.options.lazyLoad) ||
        n.lazyLoad();
    }),
    (e.prototype.setupInfinite = function () {
      var e,
        t,
        o,
        s = this;
      if (
        (!0 === s.options.fade && (s.options.centerMode = !1),
        !0 === s.options.infinite &&
          !1 === s.options.fade &&
          ((t = null), s.slideCount > s.options.slidesToShow))
      ) {
        for (
          o =
            !0 === s.options.centerMode
              ? s.options.slidesToShow + 1
              : s.options.slidesToShow,
            e = s.slideCount;
          e > s.slideCount - o;
          e -= 1
        )
          (t = e - 1),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t - s.slideCount)
              .prependTo(s.$slideTrack)
              .addClass("slick-cloned");
        for (e = 0; e < o + s.slideCount; e += 1)
          (t = e),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t + s.slideCount)
              .appendTo(s.$slideTrack)
              .addClass("slick-cloned");
        s.$slideTrack
          .find(".slick-cloned")
          .find("[id]")
          .each(function () {
            i(this).attr("id", "");
          });
      }
    }),
    (e.prototype.interrupt = function (i) {
      var e = this;
      i || e.autoPlay(), (e.interrupted = i);
    }),
    (e.prototype.selectHandler = function (e) {
      var t = this,
        o = i(e.target).is(".slick-slide")
          ? i(e.target)
          : i(e.target).parents(".slick-slide"),
        s = parseInt(o.attr("data-slick-index"));
      s || (s = 0),
        t.slideCount <= t.options.slidesToShow
          ? t.slideHandler(s, !1, !0)
          : t.slideHandler(s);
    }),
    (e.prototype.slideHandler = function (i, e, t) {
      var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
      if (
        ((e = e || !1),
        !(
          (!0 === a.animating && !0 === a.options.waitForAnimate) ||
          (!0 === a.options.fade && a.currentSlide === i)
        ))
      )
        if (
          (!1 === e && a.asNavFor(i),
          (o = i),
          (d = a.getLeft(o)),
          (r = a.getLeft(a.currentSlide)),
          (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
          !1 === a.options.infinite &&
            !1 === a.options.centerMode &&
            (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
        )
          !1 === a.options.fade &&
            ((o = a.currentSlide),
            !0 !== t
              ? a.animateSlide(r, function () {
                  a.postSlide(o);
                })
              : a.postSlide(o));
        else if (
          !1 === a.options.infinite &&
          !0 === a.options.centerMode &&
          (i < 0 || i > a.slideCount - a.options.slidesToScroll)
        )
          !1 === a.options.fade &&
            ((o = a.currentSlide),
            !0 !== t
              ? a.animateSlide(r, function () {
                  a.postSlide(o);
                })
              : a.postSlide(o));
        else {
          if (
            (a.options.autoplay && clearInterval(a.autoPlayTimer),
            (s =
              o < 0
                ? a.slideCount % a.options.slidesToScroll != 0
                  ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                  : a.slideCount + o
                : o >= a.slideCount
                ? a.slideCount % a.options.slidesToScroll != 0
                  ? 0
                  : o - a.slideCount
                : o),
            (a.animating = !0),
            a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
            (n = a.currentSlide),
            (a.currentSlide = s),
            a.setSlideClasses(a.currentSlide),
            a.options.asNavFor &&
              (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <=
                l.options.slidesToShow &&
              l.setSlideClasses(a.currentSlide),
            a.updateDots(),
            a.updateArrows(),
            !0 === a.options.fade)
          )
            return (
              !0 !== t
                ? (a.fadeSlideOut(n),
                  a.fadeSlide(s, function () {
                    a.postSlide(s);
                  }))
                : a.postSlide(s),
              void a.animateHeight()
            );
          !0 !== t
            ? a.animateSlide(d, function () {
                a.postSlide(s);
              })
            : a.postSlide(s);
        }
    }),
    (e.prototype.startLoad = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow.hide(), i.$nextArrow.hide()),
        !0 === i.options.dots &&
          i.slideCount > i.options.slidesToShow &&
          i.$dots.hide(),
        i.$slider.addClass("slick-loading");
    }),
    (e.prototype.swipeDirection = function () {
      var i,
        e,
        t,
        o,
        s = this;
      return (
        (i = s.touchObject.startX - s.touchObject.curX),
        (e = s.touchObject.startY - s.touchObject.curY),
        (t = Math.atan2(e, i)),
        (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
        o <= 45 && o >= 0
          ? !1 === s.options.rtl
            ? "left"
            : "right"
          : o <= 360 && o >= 315
          ? !1 === s.options.rtl
            ? "left"
            : "right"
          : o >= 135 && o <= 225
          ? !1 === s.options.rtl
            ? "right"
            : "left"
          : !0 === s.options.verticalSwiping
          ? o >= 35 && o <= 135
            ? "down"
            : "up"
          : "vertical"
      );
    }),
    (e.prototype.swipeEnd = function (i) {
      var e,
        t,
        o = this;
      if (((o.dragging = !1), (o.swiping = !1), o.scrolling))
        return (o.scrolling = !1), !1;
      if (
        ((o.interrupted = !1),
        (o.shouldClick = !(o.touchObject.swipeLength > 10)),
        void 0 === o.touchObject.curX)
      )
        return !1;
      if (
        (!0 === o.touchObject.edgeHit &&
          o.$slider.trigger("edge", [o, o.swipeDirection()]),
        o.touchObject.swipeLength >= o.touchObject.minSwipe)
      ) {
        switch ((t = o.swipeDirection())) {
          case "left":
          case "down":
            (e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide + o.getSlideCount())
              : o.currentSlide + o.getSlideCount()),
              (o.currentDirection = 0);
            break;
          case "right":
          case "up":
            (e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide - o.getSlideCount())
              : o.currentSlide - o.getSlideCount()),
              (o.currentDirection = 1);
        }
        "vertical" != t &&
          (o.slideHandler(e),
          (o.touchObject = {}),
          o.$slider.trigger("swipe", [o, t]));
      } else
        o.touchObject.startX !== o.touchObject.curX &&
          (o.slideHandler(o.currentSlide), (o.touchObject = {}));
    }),
    (e.prototype.swipeHandler = function (i) {
      var e = this;
      if (
        !(
          !1 === e.options.swipe ||
          ("ontouchend" in document && !1 === e.options.swipe) ||
          (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))
        )
      )
        switch (
          ((e.touchObject.fingerCount =
            i.originalEvent && void 0 !== i.originalEvent.touches
              ? i.originalEvent.touches.length
              : 1),
          (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
          !0 === e.options.verticalSwiping &&
            (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
          i.data.action)
        ) {
          case "start":
            e.swipeStart(i);
            break;
          case "move":
            e.swipeMove(i);
            break;
          case "end":
            e.swipeEnd(i);
        }
    }),
    (e.prototype.swipeMove = function (i) {
      var e,
        t,
        o,
        s,
        n,
        r,
        l = this;
      return (
        (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
        !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
          ((e = l.getLeft(l.currentSlide)),
          (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
          (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
          (l.touchObject.swipeLength = Math.round(
            Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))
          )),
          (r = Math.round(
            Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))
          )),
          !l.options.verticalSwiping && !l.swiping && r > 4
            ? ((l.scrolling = !0), !1)
            : (!0 === l.options.verticalSwiping &&
                (l.touchObject.swipeLength = r),
              (t = l.swipeDirection()),
              void 0 !== i.originalEvent &&
                l.touchObject.swipeLength > 4 &&
                ((l.swiping = !0), i.preventDefault()),
              (s =
                (!1 === l.options.rtl ? 1 : -1) *
                (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
              !0 === l.options.verticalSwiping &&
                (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
              (o = l.touchObject.swipeLength),
              (l.touchObject.edgeHit = !1),
              !1 === l.options.infinite &&
                ((0 === l.currentSlide && "right" === t) ||
                  (l.currentSlide >= l.getDotCount() && "left" === t)) &&
                ((o = l.touchObject.swipeLength * l.options.edgeFriction),
                (l.touchObject.edgeHit = !0)),
              !1 === l.options.vertical
                ? (l.swipeLeft = e + o * s)
                : (l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s),
              !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
              !0 !== l.options.fade &&
                !1 !== l.options.touchMove &&
                (!0 === l.animating
                  ? ((l.swipeLeft = null), !1)
                  : void l.setCSS(l.swipeLeft))))
      );
    }),
    (e.prototype.swipeStart = function (i) {
      var e,
        t = this;
      if (
        ((t.interrupted = !0),
        1 !== t.touchObject.fingerCount ||
          t.slideCount <= t.options.slidesToShow)
      )
        return (t.touchObject = {}), !1;
      void 0 !== i.originalEvent &&
        void 0 !== i.originalEvent.touches &&
        (e = i.originalEvent.touches[0]),
        (t.touchObject.startX = t.touchObject.curX =
          void 0 !== e ? e.pageX : i.clientX),
        (t.touchObject.startY = t.touchObject.curY =
          void 0 !== e ? e.pageY : i.clientY),
        (t.dragging = !0);
    }),
    (e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
      var i = this;
      null !== i.$slidesCache &&
        (i.unload(),
        i.$slideTrack.children(this.options.slide).detach(),
        i.$slidesCache.appendTo(i.$slideTrack),
        i.reinit());
    }),
    (e.prototype.unload = function () {
      var e = this;
      i(".slick-cloned", e.$slider).remove(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow &&
          e.htmlExpr.test(e.options.prevArrow) &&
          e.$prevArrow.remove(),
        e.$nextArrow &&
          e.htmlExpr.test(e.options.nextArrow) &&
          e.$nextArrow.remove(),
        e.$slides
          .removeClass("slick-slide slick-active slick-visible slick-current")
          .attr("aria-hidden", "true")
          .css("width", "");
    }),
    (e.prototype.unslick = function (i) {
      var e = this;
      e.$slider.trigger("unslick", [e, i]), e.destroy();
    }),
    (e.prototype.updateArrows = function () {
      var i = this;
      Math.floor(i.options.slidesToShow / 2),
        !0 === i.options.arrows &&
          i.slideCount > i.options.slidesToShow &&
          !i.options.infinite &&
          (i.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          i.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          0 === i.currentSlide
            ? (i.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : i.currentSlide >= i.slideCount - i.options.slidesToShow &&
              !1 === i.options.centerMode
            ? (i.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : i.currentSlide >= i.slideCount - 1 &&
              !0 === i.options.centerMode &&
              (i.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
    }),
    (e.prototype.updateDots = function () {
      var i = this;
      null !== i.$dots &&
        (i.$dots.find("li").removeClass("slick-active").end(),
        i.$dots
          .find("li")
          .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
          .addClass("slick-active"));
    }),
    (e.prototype.visibility = function () {
      var i = this;
      i.options.autoplay &&
        (document[i.hidden] ? (i.interrupted = !0) : (i.interrupted = !1));
    }),
    (i.fn.slick = function () {
      var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;
      for (i = 0; i < r; i++)
        if (
          ("object" == typeof s || void 0 === s
            ? (o[i].slick = new e(o[i], s))
            : (t = o[i].slick[s].apply(o[i].slick, n)),
          void 0 !== t)
        )
          return t;
      return o;
    });
});

/*! EmojioneArea v3.4.0 | MIT license */
(window =
  "undefined" != typeof global
    ? global
    : "undefined" != typeof self
    ? self
    : "undefined" != typeof window
    ? window
    : {}),
  (document = window.document || {}),
  (function (a, b) {
    "function" == typeof require &&
    "object" == typeof exports &&
    "object" == typeof module
      ? a(require("jquery"))
      : "function" == typeof define && define.amd
      ? define(["jquery"], a)
      : a(b.jQuery);
  })(function (a) {
    "use strict";
    var b = 0,
      c = {},
      d = {},
      e = window.emojione,
      f = [];
    function g(a) {
      e ? a() : f.push(a);
    }
    var h =
        "data:image/gif;base64,R0lGODlhAQABAJH/AP///wAAAMDAwAAAACH5BAEAAAIALAAAAAABAAEAAAICVAEAOw==",
      i = [].slice,
      j = "emojionearea",
      k = 0,
      l = "&#8203;";
    function m(b, d, e) {
      var f = !0,
        g = 1;
      if (d) {
        d = d.toLowerCase();
        do {
          var h = 1 == g ? "@" + d : d;
          c[b.id][h] &&
            c[b.id][h].length &&
            a.each(c[b.id][h], function (a, c) {
              return (f = c.apply(b, e || []) !== !1);
            });
        } while (f && g--);
      }
      return f;
    }
    function n(b, c, e, f) {
      (f =
        f ||
        function (b, c) {
          return a(c.currentTarget);
        }),
        a.each(e, function (g, h) {
          (g = a.isArray(e) ? h : g),
            (d[b.id][h] || (d[b.id][h] = [])).push([c, g, f]);
        });
    }
    function o(a, b, c) {
      var d = e.imageType,
        f;
      f = "svg" == d ? e.imagePathSVG : e.imagePathPNG;
      var g = "";
      c &&
        (g = c
          .substr(1, c.length - 2)
          .replace(/_/g, " ")
          .replace(/\w\S*/g, function (a) {
            return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase();
          }));
      var h = "";
      return (
        b.uc_base && k > 4
          ? ((h = b.uc_base), (b = b.uc_output.toUpperCase()))
          : (h = b),
        a
          .replace("{name}", c || "")
          .replace("{friendlyName}", g)
          .replace("{img}", f + (2 > k ? h.toUpperCase() : h) + "." + d)
          .replace("{uni}", b)
          .replace("{alt}", e.convert(b))
      );
    }
    function p(a, b, c) {
      return a.replace(/:?\+?[\w_\-]+:?/g, function (a) {
        a = ":" + a.replace(/:$/, "").replace(/^:/, "") + ":";
        var d = e.emojioneList[a];
        return d
          ? k > 4
            ? o(b, d, a)
            : (k > 3 && (d = d.unicode), o(b, d[d.length - 1], a))
          : c
          ? ""
          : a;
      });
    }
    function q(a) {
      var b, c;
      if (window.getSelection) {
        if (((b = window.getSelection()), b.getRangeAt && b.rangeCount)) {
          (c = b.getRangeAt(0)), c.deleteContents();
          var d = document.createElement("div");
          d.innerHTML = a;
          var e = document.createDocumentFragment(),
            f,
            g;
          while ((f = d.firstChild)) g = e.appendChild(f);
          c.insertNode(e),
            g &&
              ((c = c.cloneRange()),
              c.setStartAfter(g),
              c.collapse(!0),
              b.removeAllRanges(),
              b.addRange(c));
        }
      } else document.selection && "Control" != document.selection.type && document.selection.createRange().pasteHTML(a);
    }
    function r() {
      return window.emojioneVersion || "3.1.2";
    }
    function s(a) {
      return "object" == typeof a;
    }
    function t(a) {
      var b;
      return a.cacheBustParam
        ? ((b = a.cacheBustParam),
          s(a.jsEscapeMap)
            ? "?v=1.2.4" === b
              ? "2.0.0"
              : "?v=2.0.1" === b
              ? "2.1.0"
              : "?v=2.1.1" === b
              ? "2.1.1"
              : "?v=2.1.2" === b
              ? "2.1.2"
              : "?v=2.1.3" === b
              ? "2.1.3"
              : "?v=2.1.4" === b
              ? "2.1.4"
              : "2.2.7"
            : "1.5.2")
        : a.emojiVersion;
    }
    function u(a) {
      switch (a) {
        case "1.5.2":
          return 0;
        case "2.0.0":
          return 1;
        case "2.1.0":
        case "2.1.1":
          return 2;
        case "2.1.2":
          return 3;
        case "2.1.3":
        case "2.1.4":
        case "2.2.7":
          return 4;
        case "3.0.1":
        case "3.0.2":
        case "3.0.3":
        case "3.0":
          return 5;
        case "3.1.0":
        case "3.1.1":
        case "3.1.2":
        case "3.1":
        default:
          return 6;
      }
    }
    function v() {
      if (a.fn.emojioneArea && a.fn.emojioneArea.defaults)
        return a.fn.emojioneArea.defaults;
      var b = {
          attributes: {
            dir: "ltr",
            spellcheck: !1,
            autocomplete: "off",
            autocorrect: "off",
            autocapitalize: "off",
          },
          search: !0,
          placeholder: null,
          emojiPlaceholder: ":smiley:",
          searchPlaceholder: "SEARCH",
          container: null,
          hideSource: !0,
          shortnames: !0,
          sprite: !0,
          pickerPosition: "top",
          filtersPosition: "top",
          searchPosition: "top",
          hidePickerOnBlur: !0,
          buttonTitle: "Use the TAB key to insert emoji faster",
          tones: !0,
          tonesStyle: "bullet",
          inline: null,
          saveEmojisAs: "unicode",
          shortcuts: !0,
          autocomplete: !0,
          autocompleteTones: !1,
          standalone: !1,
          useInternalCDN: !0,
          imageType: "png",
          recentEmojis: !0,
          textcomplete: { maxCount: 15, placement: null },
        },
        c = u(e ? t(e) : r());
      return (
        c > 4
          ? (b.filters = {
              tones: {
                title: "Diversity",
                emoji:
                  "open_hands raised_hands clap pray thumbsup thumbsdown punch fist left_facing_fist right_facing_fist fingers_crossed v metal ok_hand point_left point_right point_up_2 point_down point_up raised_hand raised_back_of_hand hand_splayed vulcan wave call_me muscle middle_finger writing_hand selfie nail_care ear nose baby boy girl man woman blond-haired_woman blond_haired_person blond-haired_man older_man older_woman man_with_chinese_cap woman_wearing_turban person_wearing_turban man_wearing_turban woman_police_officer police_officer man_police_officer woman_construction_worker construction_worker man_construction_worker woman_guard guard man_guard woman_detective detective man_detective woman_health_worker man_health_worker woman_farmer man_farmer woman_cook man_cook woman_student man_student woman_singer man_singer woman_teacher man_teacher woman_factory_worker man_factory_worker woman_technologist man_technologist woman_office_worker man_office_worker woman_mechanic man_mechanic woman_scientist man_scientist woman_artist man_artist woman_firefighter man_firefighter woman_pilot man_pilot woman_astronaut man_astronaut woman_judge man_judge mrs_claus santa princess prince bride_with_veil man_in_tuxedo angel pregnant_woman woman_bowing person_bowing man_bowing person_tipping_hand man_tipping_hand woman_tipping_hand person_gesturing_no man_gesturing_no woman_gesturing_no person_gesturing_ok man_gesturing_ok woman_gesturing_ok person_raising_hand man_raising_hand woman_raising_hand woman_facepalming man_facepalming person_facepalming woman_shrugging man_shrugging person_shrugging person_pouting man_pouting woman_pouting person_frowning man_frowning woman_frowning person_getting_haircut man_getting_haircut woman_getting_haircut person_getting_massage man_getting_face_massage woman_getting_face_massage levitate dancer man_dancing woman_walking person_walking man_walking woman_running person_running man_running adult child older_adult bearded_person woman_with_headscarf mage fairy vampire merperson elf love_you_gesture palms_up_together woman_mage man_mage woman_fairy man_fairy woman_vampire man_vampire mermaid merman woman_elf man_elf snowboarder woman_lifting_weights person_lifting_weights man_lifting_weights woman_cartwheeling man_cartwheeling person_doing_cartwheel woman_bouncing_ball person_bouncing_ball man_bouncing_ball woman_playing_handball man_playing_handball person_playing_handball woman_golfing person_golfing man_golfing woman_surfing person_surfing man_surfing woman_swimming person_swimming man_swimming woman_playing_water_polo man_playing_water_polo person_playing_water_polo woman_rowing_boat person_rowing_boat man_rowing_boat horse_racing woman_biking person_biking man_biking woman_mountain_biking person_mountain_biking man_mountain_biking woman_juggling man_juggling person_juggling breast_feeding person_in_steamy_room person_climbing person_in_lotus_position woman_in_steamy_room man_in_steamy_room woman_climbing man_climbing woman_in_lotus_position man_in_lotus_position bath sleeping_accommodation",
              },
              recent: { icon: "clock3", title: "Recent", emoji: "" },
              smileys_people: {
                icon: "yum",
                title: "Smileys & People",
                emoji:
                  "grinning smiley smile grin laughing sweat_smile joy rofl relaxed blush innocent slight_smile upside_down wink relieved heart_eyes kissing_heart kissing kissing_smiling_eyes kissing_closed_eyes yum stuck_out_tongue_winking_eye stuck_out_tongue_closed_eyes stuck_out_tongue money_mouth hugging nerd sunglasses clown cowboy smirk unamused disappointed pensive worried confused slight_frown frowning2 persevere confounded tired_face weary triumph angry rage no_mouth neutral_face expressionless hushed frowning anguished open_mouth astonished dizzy_face flushed scream fearful cold_sweat cry disappointed_relieved drooling_face sob sweat sleepy sleeping rolling_eyes thinking lying_face grimacing zipper_mouth nauseated_face sneezing_face mask thermometer_face head_bandage smiling_imp imp japanese_ogre japanese_goblin poop ghost skull skull_crossbones alien space_invader robot jack_o_lantern smiley_cat smile_cat joy_cat heart_eyes_cat smirk_cat kissing_cat scream_cat crying_cat_face pouting_cat open_hands raised_hands clap pray handshake thumbsup thumbsdown punch fist left_facing_fist right_facing_fist fingers_crossed v metal ok_hand point_left point_right point_up_2 point_down point_up raised_hand raised_back_of_hand hand_splayed vulcan wave call_me muscle middle_finger writing_hand selfie nail_care ring lipstick kiss lips tongue ear nose footprints eye eyes speaking_head bust_in_silhouette busts_in_silhouette baby boy girl man woman blond-haired_woman blond_haired_person older_man older_woman man_with_chinese_cap woman_wearing_turban person_wearing_turban woman_police_officer police_officer woman_construction_worker construction_worker woman_guard guard woman_detective detective woman_health_worker man_health_worker woman_farmer man_farmer woman_cook man_cook woman_student man_student woman_singer man_singer woman_teacher man_teacher woman_factory_worker man_factory_worker woman_technologist man_technologist woman_office_worker man_office_worker woman_mechanic man_mechanic woman_scientist man_scientist woman_artist man_artist woman_firefighter man_firefighter woman_pilot man_pilot woman_astronaut man_astronaut woman_judge man_judge mrs_claus santa princess prince bride_with_veil man_in_tuxedo angel pregnant_woman woman_bowing person_bowing person_tipping_hand man_tipping_hand person_gesturing_no man_gesturing_no person_gesturing_ok man_gesturing_ok person_raising_hand man_raising_hand woman_facepalming man_facepalming woman_shrugging man_shrugging person_pouting man_pouting person_frowning man_frowning person_getting_haircut man_getting_haircut person_getting_massage man_getting_face_massage levitate dancer man_dancing people_with_bunny_ears_partying men_with_bunny_ears_partying woman_walking person_walking woman_running person_running couple two_women_holding_hands two_men_holding_hands couple_with_heart couple_ww couple_mm couplekiss kiss_ww kiss_mm family family_mwg family_mwgb family_mwbb family_mwgg family_wwb family_wwg family_wwgb family_wwbb family_wwgg family_mmb family_mmg family_mmgb family_mmbb family_mmgg family_woman_boy family_woman_girl family_woman_girl_boy family_woman_boy_boy family_woman_girl_girl family_man_boy family_man_girl family_man_girl_boy family_man_boy_boy family_man_girl_girl womans_clothes shirt jeans necktie dress bikini kimono high_heel sandal boot mans_shoe athletic_shoe womans_hat tophat mortar_board crown helmet_with_cross school_satchel pouch purse handbag briefcase eyeglasses dark_sunglasses closed_umbrella umbrella2 face_with_raised_eyebrow star_struck crazy_face shushing_face face_with_symbols_over_mouth face_with_hand_over_mouth face_vomiting exploding_head face_with_monocle adult child older_adult bearded_person woman_with_headscarf brain billed_cap scarf gloves coat socks love_you_gesture palms_up_together woman_mage man_mage woman_fairy man_fairy woman_vampire man_vampire mermaid merman woman_elf man_elf woman_genie man_genie woman_zombie man_zombie",
              },
              animals_nature: {
                icon: "hamster",
                title: "Animals & Nature",
                emoji:
                  "dog cat mouse hamster rabbit fox bear panda_face koala tiger lion_face cow pig pig_nose frog monkey_face see_no_evil hear_no_evil speak_no_evil monkey chicken penguin bird baby_chick hatching_chick hatched_chick duck eagle owl bat wolf boar horse unicorn bee bug butterfly snail shell beetle ant spider spider_web turtle snake lizard scorpion crab squid octopus shrimp tropical_fish fish blowfish dolphin shark whale whale2 crocodile leopard tiger2 water_buffalo ox cow2 deer dromedary_camel camel elephant rhino gorilla racehorse pig2 goat ram sheep dog2 poodle cat2 rooster turkey dove rabbit2 mouse2 rat chipmunk feet dragon dragon_face cactus christmas_tree evergreen_tree deciduous_tree palm_tree seedling herb shamrock four_leaf_clover bamboo tanabata_tree leaves fallen_leaf maple_leaf mushroom ear_of_rice bouquet tulip rose wilted_rose sunflower blossom cherry_blossom hibiscus earth_americas earth_africa earth_asia full_moon waning_gibbous_moon last_quarter_moon waning_crescent_moon new_moon waxing_crescent_moon first_quarter_moon waxing_gibbous_moon new_moon_with_face full_moon_with_face sun_with_face first_quarter_moon_with_face last_quarter_moon_with_face crescent_moon dizzy star star2 sparkles zap fire boom comet sunny white_sun_small_cloud partly_sunny white_sun_cloud white_sun_rain_cloud rainbow cloud cloud_rain thunder_cloud_rain cloud_lightning cloud_snow snowman2 snowman snowflake wind_blowing_face dash cloud_tornado fog ocean droplet sweat_drops umbrella giraffe zebra hedgehog sauropod t_rex cricket",
              },
              food_drink: {
                icon: "pizza",
                title: "Food & Drink",
                emoji:
                  "green_apple apple pear tangerine lemon banana watermelon grapes strawberry melon cherries peach pineapple kiwi avocado tomato eggplant cucumber carrot corn hot_pepper potato sweet_potato chestnut peanuts honey_pot croissant bread french_bread cheese egg cooking bacon pancakes fried_shrimp poultry_leg meat_on_bone pizza hotdog hamburger fries stuffed_flatbread taco burrito salad shallow_pan_of_food spaghetti ramen stew fish_cake sushi bento curry rice_ball rice rice_cracker oden dango shaved_ice ice_cream icecream cake birthday custard lollipop candy chocolate_bar popcorn doughnut cookie milk baby_bottle coffee tea sake beer beers champagne_glass wine_glass tumbler_glass cocktail tropical_drink champagne spoon fork_and_knife fork_knife_plate dumpling fortune_cookie takeout_box chopsticks bowl_with_spoon cup_with_straw coconut broccoli pie pretzel cut_of_meat sandwich canned_food",
              },
              activity: {
                icon: "basketball",
                title: "Activity",
                emoji:
                  "soccer basketball football baseball tennis volleyball rugby_football 8ball ping_pong badminton goal hockey field_hockey cricket_game golf bow_and_arrow fishing_pole_and_fish boxing_glove martial_arts_uniform ice_skate ski skier snowboarder woman_lifting_weights person_lifting_weights person_fencing women_wrestling men_wrestling woman_cartwheeling man_cartwheeling woman_bouncing_ball person_bouncing_ball woman_playing_handball man_playing_handball woman_golfing person_golfing woman_surfing person_surfing woman_swimming person_swimming woman_playing_water_polo man_playing_water_polo woman_rowing_boat person_rowing_boat horse_racing woman_biking person_biking woman_mountain_biking person_mountain_biking running_shirt_with_sash medal military_medal first_place second_place third_place trophy rosette reminder_ribbon ticket tickets circus_tent woman_juggling man_juggling performing_arts art clapper microphone headphones musical_score musical_keyboard drum saxophone trumpet guitar violin game_die dart bowling video_game slot_machine sled breast_feeding curling_stone woman_in_steamy_room man_in_steamy_room woman_climbing man_climbing woman_in_lotus_position man_in_lotus_position",
              },
              travel_places: {
                icon: "rocket",
                title: "Travel & Places",
                emoji:
                  "red_car taxi blue_car bus trolleybus race_car police_car ambulance fire_engine minibus truck articulated_lorry tractor scooter bike motor_scooter motorcycle rotating_light oncoming_police_car oncoming_bus oncoming_automobile oncoming_taxi aerial_tramway mountain_cableway suspension_railway railway_car train mountain_railway monorail bullettrain_side bullettrain_front light_rail steam_locomotive train2 metro tram station helicopter airplane_small airplane airplane_departure airplane_arriving rocket satellite_orbital seat canoe sailboat motorboat speedboat cruise_ship ferry ship anchor construction fuelpump busstop vertical_traffic_light traffic_light map moyai statue_of_liberty fountain tokyo_tower european_castle japanese_castle stadium ferris_wheel roller_coaster carousel_horse beach_umbrella beach island mountain mountain_snow mount_fuji volcano desert camping tent railway_track motorway construction_site factory house house_with_garden homes house_abandoned office department_store post_office european_post_office hospital bank hotel convenience_store school love_hotel wedding classical_building church mosque synagogue kaaba shinto_shrine japan rice_scene park sunrise sunrise_over_mountains stars sparkler fireworks city_sunset city_dusk cityscape night_with_stars milky_way bridge_at_night foggy flying_saucer",
              },
              objects: {
                icon: "bulb",
                title: "Objects",
                emoji:
                  "watch iphone calling computer keyboard desktop printer mouse_three_button trackball joystick compression minidisc floppy_disk cd dvd vhs camera camera_with_flash video_camera movie_camera projector film_frames telephone_receiver telephone pager fax tv radio microphone2 level_slider control_knobs stopwatch timer alarm_clock clock hourglass hourglass_flowing_sand satellite battery electric_plug bulb flashlight candle wastebasket oil money_with_wings dollar yen euro pound moneybag credit_card gem scales wrench hammer hammer_pick tools pick nut_and_bolt gear chains gun bomb knife dagger crossed_swords shield smoking coffin urn amphora crystal_ball prayer_beads barber alembic telescope microscope hole pill syringe thermometer toilet potable_water shower bathtub bath bellhop key key2 door couch bed sleeping_accommodation frame_photo shopping_bags shopping_cart gift balloon flags ribbon confetti_ball tada dolls izakaya_lantern wind_chime envelope envelope_with_arrow incoming_envelope e-mail love_letter inbox_tray outbox_tray package label mailbox_closed mailbox mailbox_with_mail mailbox_with_no_mail postbox postal_horn scroll page_with_curl page_facing_up bookmark_tabs bar_chart chart_with_upwards_trend chart_with_downwards_trend notepad_spiral calendar_spiral calendar date card_index card_box ballot_box file_cabinet clipboard file_folder open_file_folder dividers newspaper2 newspaper notebook notebook_with_decorative_cover ledger closed_book green_book blue_book orange_book books book bookmark link paperclip paperclips triangular_ruler straight_ruler pushpin round_pushpin scissors pen_ballpoint pen_fountain black_nib paintbrush crayon pencil pencil2 mag mag_right lock_with_ink_pen closed_lock_with_key lock unlock orange_heart",
              },
              symbols: {
                icon: "heartpulse",
                title: "Symbols",
                emoji:
                  "heart yellow_heart green_heart blue_heart purple_heart black_heart broken_heart heart_exclamation two_hearts revolving_hearts heartbeat heartpulse sparkling_heart cupid gift_heart heart_decoration peace cross star_and_crescent om_symbol wheel_of_dharma star_of_david six_pointed_star menorah yin_yang orthodox_cross place_of_worship ophiuchus aries taurus gemini cancer leo virgo libra scorpius sagittarius capricorn aquarius pisces id atom accept radioactive biohazard mobile_phone_off vibration_mode u6709 u7121 u7533 u55b6 u6708 eight_pointed_black_star vs white_flower ideograph_advantage secret congratulations u5408 u6e80 u5272 u7981 a b ab cl o2 sos x o octagonal_sign no_entry name_badge no_entry_sign 100 anger hotsprings no_pedestrians do_not_litter no_bicycles non-potable_water underage no_mobile_phones no_smoking exclamation grey_exclamation question grey_question bangbang interrobang low_brightness high_brightness part_alternation_mark warning children_crossing trident fleur-de-lis beginner recycle white_check_mark u6307 chart sparkle eight_spoked_asterisk negative_squared_cross_mark globe_with_meridians diamond_shape_with_a_dot_inside m cyclone zzz atm wc wheelchair parking u7a7a sa passport_control customs baggage_claim left_luggage mens womens baby_symbol restroom put_litter_in_its_place cinema signal_strength koko symbols information_source abc abcd capital_abcd ng ok up cool new free zero one two three four five six seven eight nine keycap_ten 1234 hash asterisk arrow_forward pause_button play_pause stop_button record_button eject track_next track_previous fast_forward rewind arrow_double_up arrow_double_down arrow_backward arrow_up_small arrow_down_small arrow_right arrow_left arrow_up arrow_down arrow_upper_right arrow_lower_right arrow_lower_left arrow_upper_left arrow_up_down left_right_arrow arrow_right_hook leftwards_arrow_with_hook arrow_heading_up arrow_heading_down twisted_rightwards_arrows repeat repeat_one arrows_counterclockwise arrows_clockwise musical_note notes heavy_plus_sign heavy_minus_sign heavy_division_sign heavy_multiplication_x heavy_dollar_sign currency_exchange tm copyright registered wavy_dash curly_loop loop end back on top soon heavy_check_mark ballot_box_with_check radio_button white_circle black_circle red_circle blue_circle small_red_triangle small_red_triangle_down small_orange_diamond small_blue_diamond large_orange_diamond large_blue_diamond white_square_button black_square_button black_small_square white_small_square black_medium_small_square white_medium_small_square black_medium_square white_medium_square black_large_square white_large_square speaker mute sound loud_sound bell no_bell mega loudspeaker speech_left eye_in_speech_bubble speech_balloon thought_balloon anger_right spades clubs hearts diamonds black_joker flower_playing_cards mahjong clock1 clock2 clock3 clock4 clock5 clock6 clock7 clock8 clock9 clock10 clock11 clock12 clock130 clock230 clock330 clock430 clock530 clock630 clock730 clock830 clock930 clock1030 clock1130 clock1230",
              },
              flags: {
                icon: "flag_gb",
                title: "Flags",
                emoji:
                  "flag_white flag_black checkered_flag triangular_flag_on_post rainbow_flag flag_af flag_ax flag_al flag_dz flag_as flag_ad flag_ao flag_ai flag_aq flag_ag flag_ar flag_am flag_aw flag_au flag_at flag_az flag_bs flag_bh flag_bd flag_bb flag_by flag_be flag_bz flag_bj flag_bm flag_bt flag_bo flag_ba flag_bw flag_br flag_io flag_vg flag_bn flag_bg flag_bf flag_bi flag_kh flag_cm flag_ca flag_ic flag_cv flag_bq flag_ky flag_cf flag_td flag_cl flag_cn flag_cx flag_cc flag_co flag_km flag_cg flag_cd flag_ck flag_cr flag_ci flag_hr flag_cu flag_cw flag_cy flag_cz flag_dk flag_dj flag_dm flag_do flag_ec flag_eg flag_sv flag_gq flag_er flag_ee flag_et flag_eu flag_fk flag_fo flag_fj flag_fi flag_fr flag_gf flag_pf flag_tf flag_ga flag_gm flag_ge flag_de flag_gh flag_gi flag_gr flag_gl flag_gd flag_gp flag_gu flag_gt flag_gg flag_gn flag_gw flag_gy flag_ht flag_hn flag_hk flag_hu flag_is flag_in flag_id flag_ir flag_iq flag_ie flag_im flag_il flag_it flag_jm flag_jp crossed_flags flag_je flag_jo flag_kz flag_ke flag_ki flag_xk flag_kw flag_kg flag_la flag_lv flag_lb flag_ls flag_lr flag_ly flag_li flag_lt flag_lu flag_mo flag_mk flag_mg flag_mw flag_my flag_mv flag_ml flag_mt flag_mh flag_mq flag_mr flag_mu flag_yt flag_mx flag_fm flag_md flag_mc flag_mn flag_me flag_ms flag_ma flag_mz flag_mm flag_na flag_nr flag_np flag_nl flag_nc flag_nz flag_ni flag_ne flag_ng flag_nu flag_nf flag_kp flag_mp flag_no flag_om flag_pk flag_pw flag_ps flag_pa flag_pg flag_py flag_pe flag_ph flag_pn flag_pl flag_pt flag_pr flag_qa flag_re flag_ro flag_ru flag_rw flag_ws flag_sm flag_st flag_sa flag_sn flag_rs flag_sc flag_sl flag_sg flag_sx flag_sk flag_si flag_gs flag_sb flag_so flag_za flag_kr flag_ss flag_es flag_lk flag_bl flag_sh flag_kn flag_lc flag_pm flag_vc flag_sd flag_sr flag_sz flag_se flag_ch flag_sy flag_tw flag_tj flag_tz flag_th flag_tl flag_tg flag_tk flag_to flag_tt flag_tn flag_tr flag_tm flag_tc flag_tv flag_vi flag_ug flag_ua flag_ae flag_gb flag_us flag_uy flag_uz flag_vu flag_va flag_ve flag_vn flag_wf flag_eh flag_ye flag_zm flag_zw flag_ac flag_ta flag_bv flag_hm flag_sj flag_um flag_ea flag_cp flag_dg flag_mf united_nations england scotland wales",
              },
            })
          : (b.filters = {
              tones: {
                title: "Diversity",
                emoji:
                  "santa runner surfer swimmer lifter ear nose point_up_2 point_down point_left point_right punch wave ok_hand thumbsup thumbsdown clap open_hands boy girl man woman cop bride_with_veil person_with_blond_hair man_with_gua_pi_mao man_with_turban older_man grandma baby construction_worker princess angel information_desk_person guardsman dancer nail_care massage haircut muscle spy hand_splayed middle_finger vulcan no_good ok_woman bow raising_hand raised_hands person_frowning person_with_pouting_face pray rowboat bicyclist mountain_bicyclist walking bath metal point_up basketball_player fist raised_hand v writing_hand",
              },
              recent: { icon: "clock3", title: "Recent", emoji: "" },
              smileys_people: {
                icon: "yum",
                title: "Smileys & People",
                emoji:
                  "grinning grimacing grin joy smiley smile sweat_smile laughing innocent wink blush slight_smile upside_down relaxed yum relieved heart_eyes kissing_heart kissing kissing_smiling_eyes kissing_closed_eyes stuck_out_tongue_winking_eye stuck_out_tongue_closed_eyes stuck_out_tongue money_mouth nerd sunglasses hugging smirk no_mouth neutral_face expressionless unamused rolling_eyes thinking flushed disappointed worried angry rage pensive confused slight_frown frowning2 persevere confounded tired_face weary triumph open_mouth scream fearful cold_sweat hushed frowning anguished cry disappointed_relieved sleepy sweat sob dizzy_face astonished zipper_mouth mask thermometer_face head_bandage sleeping zzz poop smiling_imp imp japanese_ogre japanese_goblin skull ghost alien robot smiley_cat smile_cat joy_cat heart_eyes_cat smirk_cat kissing_cat scream_cat crying_cat_face pouting_cat raised_hands clap wave thumbsup thumbsdown punch fist v ok_hand raised_hand open_hands muscle pray point_up point_up_2 point_down point_left point_right middle_finger hand_splayed metal vulcan writing_hand nail_care lips tongue ear nose eye eyes bust_in_silhouette busts_in_silhouette speaking_head baby boy girl man woman person_with_blond_hair older_man older_woman man_with_gua_pi_mao man_with_turban cop construction_worker guardsman spy santa angel princess bride_with_veil walking runner dancer dancers couple two_men_holding_hands two_women_holding_hands bow information_desk_person no_good ok_woman raising_hand person_with_pouting_face person_frowning haircut massage couple_with_heart couple_ww couple_mm couplekiss kiss_ww kiss_mm family family_mwg family_mwgb family_mwbb family_mwgg family_wwb family_wwg family_wwgb family_wwbb family_wwgg family_mmb family_mmg family_mmgb family_mmbb family_mmgg womans_clothes shirt jeans necktie dress bikini kimono lipstick kiss footprints high_heel sandal boot mans_shoe athletic_shoe womans_hat tophat helmet_with_cross mortar_board crown school_satchel pouch purse handbag briefcase eyeglasses dark_sunglasses ring closed_umbrella",
              },
              animals_nature: {
                icon: "hamster",
                title: "Animals & Nature",
                emoji:
                  "dog cat mouse hamster rabbit bear panda_face koala tiger lion_face cow pig pig_nose frog octopus monkey_face see_no_evil hear_no_evil speak_no_evil monkey chicken penguin bird baby_chick hatching_chick hatched_chick wolf boar horse unicorn bee bug snail beetle ant spider scorpion crab snake turtle tropical_fish fish blowfish dolphin whale whale2 crocodile leopard tiger2 water_buffalo ox cow2 dromedary_camel camel elephant goat ram sheep racehorse pig2 rat mouse2 rooster turkey dove dog2 poodle cat2 rabbit2 chipmunk feet dragon dragon_face cactus christmas_tree evergreen_tree deciduous_tree palm_tree seedling herb shamrock four_leaf_clover bamboo tanabata_tree leaves fallen_leaf maple_leaf ear_of_rice hibiscus sunflower rose tulip blossom cherry_blossom bouquet mushroom chestnut jack_o_lantern shell spider_web earth_americas earth_africa earth_asia full_moon waning_gibbous_moon last_quarter_moon waning_crescent_moon new_moon waxing_crescent_moon first_quarter_moon waxing_gibbous_moon new_moon_with_face full_moon_with_face first_quarter_moon_with_face last_quarter_moon_with_face sun_with_face crescent_moon star star2 dizzy sparkles comet sunny white_sun_small_cloud partly_sunny white_sun_cloud white_sun_rain_cloud cloud cloud_rain thunder_cloud_rain cloud_lightning zap fire boom snowflake cloud_snow snowman2 snowman wind_blowing_face dash cloud_tornado fog umbrella2 umbrella droplet sweat_drops ocean",
              },
              food_drink: {
                icon: "pizza",
                title: "Food & Drink",
                emoji:
                  "green_apple apple pear tangerine lemon banana watermelon grapes strawberry melon cherries peach pineapple tomato eggplant hot_pepper corn sweet_potato honey_pot bread cheese poultry_leg meat_on_bone fried_shrimp egg hamburger fries hotdog pizza spaghetti taco burrito ramen stew fish_cake sushi bento curry rice_ball rice rice_cracker oden dango shaved_ice ice_cream icecream cake birthday custard candy lollipop chocolate_bar popcorn doughnut cookie beer beers wine_glass cocktail tropical_drink champagne sake tea coffee baby_bottle fork_and_knife fork_knife_plate",
              },
              activity: {
                icon: "basketball",
                title: "Activity",
                emoji:
                  "soccer basketball football baseball tennis volleyball rugby_football 8ball golf golfer ping_pong badminton hockey field_hockey cricket ski skier snowboarder ice_skate bow_and_arrow fishing_pole_and_fish rowboat swimmer surfer bath basketball_player lifter bicyclist mountain_bicyclist horse_racing levitate trophy running_shirt_with_sash medal military_medal reminder_ribbon rosette ticket tickets performing_arts art circus_tent microphone headphones musical_score musical_keyboard saxophone trumpet guitar violin clapper video_game space_invader dart game_die slot_machine bowling",
              },
              travel_places: {
                icon: "rocket",
                title: "Travel & Places",
                emoji:
                  "red_car taxi blue_car bus trolleybus race_car police_car ambulance fire_engine minibus truck articulated_lorry tractor motorcycle bike rotating_light oncoming_police_car oncoming_bus oncoming_automobile oncoming_taxi aerial_tramway mountain_cableway suspension_railway railway_car train monorail bullettrain_side bullettrain_front light_rail mountain_railway steam_locomotive train2 metro tram station helicopter airplane_small airplane airplane_departure airplane_arriving sailboat motorboat speedboat ferry cruise_ship rocket satellite_orbital seat anchor construction fuelpump busstop vertical_traffic_light traffic_light checkered_flag ship ferris_wheel roller_coaster carousel_horse construction_site foggy tokyo_tower factory fountain rice_scene mountain mountain_snow mount_fuji volcano japan camping tent park motorway railway_track sunrise sunrise_over_mountains desert beach island city_sunset city_dusk cityscape night_with_stars bridge_at_night milky_way stars sparkler fireworks rainbow homes european_castle japanese_castle stadium statue_of_liberty house house_with_garden house_abandoned office department_store post_office european_post_office hospital bank hotel convenience_store school love_hotel wedding classical_building church mosque synagogue kaaba shinto_shrine",
              },
              objects: {
                icon: "bulb",
                title: "Objects",
                emoji:
                  "watch iphone calling computer keyboard desktop printer mouse_three_button trackball joystick compression minidisc floppy_disk cd dvd vhs camera camera_with_flash video_camera movie_camera projector film_frames telephone_receiver telephone pager fax tv radio microphone2 level_slider control_knobs stopwatch timer alarm_clock clock hourglass_flowing_sand hourglass satellite battery electric_plug bulb flashlight candle wastebasket oil money_with_wings dollar yen euro pound moneybag credit_card gem scales wrench hammer hammer_pick tools pick nut_and_bolt gear chains gun bomb knife dagger crossed_swords shield smoking skull_crossbones coffin urn amphora crystal_ball prayer_beads barber alembic telescope microscope hole pill syringe thermometer label bookmark toilet shower bathtub key key2 couch sleeping_accommodation bed door bellhop frame_photo map beach_umbrella moyai shopping_bags balloon flags ribbon gift confetti_ball tada dolls wind_chime crossed_flags izakaya_lantern envelope envelope_with_arrow incoming_envelope e-mail love_letter postbox mailbox_closed mailbox mailbox_with_mail mailbox_with_no_mail package postal_horn inbox_tray outbox_tray scroll page_with_curl bookmark_tabs bar_chart chart_with_upwards_trend chart_with_downwards_trend page_facing_up date calendar calendar_spiral card_index card_box ballot_box file_cabinet clipboard notepad_spiral file_folder open_file_folder dividers newspaper2 newspaper notebook closed_book green_book blue_book orange_book notebook_with_decorative_cover ledger books book link paperclip paperclips scissors triangular_ruler straight_ruler pushpin round_pushpin triangular_flag_on_post flag_white flag_black closed_lock_with_key lock unlock lock_with_ink_pen pen_ballpoint pen_fountain black_nib pencil pencil2 crayon paintbrush mag mag_right",
              },
              symbols: {
                icon: "heartpulse",
                title: "Symbols",
                emoji:
                  "heart yellow_heart green_heart blue_heart purple_heart broken_heart heart_exclamation two_hearts revolving_hearts heartbeat heartpulse sparkling_heart cupid gift_heart heart_decoration peace cross star_and_crescent om_symbol wheel_of_dharma star_of_david six_pointed_star menorah yin_yang orthodox_cross place_of_worship ophiuchus aries taurus gemini cancer leo virgo libra scorpius sagittarius capricorn aquarius pisces id atom u7a7a u5272 radioactive biohazard mobile_phone_off vibration_mode u6709 u7121 u7533 u55b6 u6708 eight_pointed_black_star vs accept white_flower ideograph_advantage secret congratulations u5408 u6e80 u7981 a b ab cl o2 sos no_entry name_badge no_entry_sign x o anger hotsprings no_pedestrians do_not_litter no_bicycles non-potable_water underage no_mobile_phones exclamation grey_exclamation question grey_question bangbang interrobang 100 low_brightness high_brightness trident fleur-de-lis part_alternation_mark warning children_crossing beginner recycle u6307 chart sparkle eight_spoked_asterisk negative_squared_cross_mark white_check_mark diamond_shape_with_a_dot_inside cyclone loop globe_with_meridians m atm sa passport_control customs baggage_claim left_luggage wheelchair no_smoking wc parking potable_water mens womens baby_symbol restroom put_litter_in_its_place cinema signal_strength koko ng ok up cool new free zero one two three four five six seven eight nine ten 1234 arrow_forward pause_button play_pause stop_button record_button track_next track_previous fast_forward rewind twisted_rightwards_arrows repeat repeat_one arrow_backward arrow_up_small arrow_down_small arrow_double_up arrow_double_down arrow_right arrow_left arrow_up arrow_down arrow_upper_right arrow_lower_right arrow_lower_left arrow_upper_left arrow_up_down left_right_arrow arrows_counterclockwise arrow_right_hook leftwards_arrow_with_hook arrow_heading_up arrow_heading_down hash asterisk information_source abc abcd capital_abcd symbols musical_note notes wavy_dash curly_loop heavy_check_mark arrows_clockwise heavy_plus_sign heavy_minus_sign heavy_division_sign heavy_multiplication_x heavy_dollar_sign currency_exchange copyright registered tm end back on top soon ballot_box_with_check radio_button white_circle black_circle red_circle large_blue_circle small_orange_diamond small_blue_diamond large_orange_diamond large_blue_diamond small_red_triangle black_small_square white_small_square black_large_square white_large_square small_red_triangle_down black_medium_square white_medium_square black_medium_small_square white_medium_small_square black_square_button white_square_button speaker sound loud_sound mute mega loudspeaker bell no_bell black_joker mahjong spades clubs hearts diamonds flower_playing_cards thought_balloon anger_right speech_balloon clock1 clock2 clock3 clock4 clock5 clock6 clock7 clock8 clock9 clock10 clock11 clock12 clock130 clock230 clock330 clock430 clock530 clock630 clock730 clock830 clock930 clock1030 clock1130 clock1230 eye_in_speech_bubble",
              },
              flags: {
                icon: "flag_gb",
                title: "Flags",
                emoji:
                  "ac af al dz ad ao ai ag ar am aw au at az bs bh bd bb by be bz bj bm bt bo ba bw br bn bg bf bi cv kh cm ca ky cf td flag_cl cn co km cg flag_cd cr hr cu cy cz dk dj dm do ec eg sv gq er ee et fk fo fj fi fr pf ga gm ge de gh gi gr gl gd gu gt gn gw gy ht hn hk hu is in flag_id ir iq ie il it ci jm jp je jo kz ke ki xk kw kg la lv lb ls lr ly li lt lu mo mk mg mw my mv ml mt mh mr mu mx fm md mc mn me ms ma mz mm na nr np nl nc nz ni ne flag_ng nu kp no om pk pw ps pa pg py pe ph pl pt pr qa ro ru rw sh kn lc vc ws sm st flag_sa sn rs sc sl sg sk si sb so za kr es lk sd sr sz se ch sy tw tj tz th tl tg to tt tn tr flag_tm flag_tm ug ua ae gb us vi uy uz vu va ve vn wf eh ye zm zw re ax ta io bq cx cc gg im yt nf pn bl pm gs tk bv hm sj um ic ea cp dg as aq vg ck cw eu gf tf gp mq mp sx ss tc ",
              },
            }),
        b
      );
    }
    function w(b) {
      var c = v();
      if (b && b.filters) {
        var d = c.filters;
        a.each(b.filters, function (b, c) {
          return !s(c) || a.isEmptyObject(c)
            ? void delete d[b]
            : void a.each(c, function (a, c) {
                d[b][a] = c;
              });
        }),
          (b.filters = d);
      }
      return a.extend({}, c, b);
    }
    var x, y;
    window.getSelection && document.createRange
      ? ((x = function (a) {
          var b = window.getSelection && window.getSelection();
          return b && b.rangeCount > 0 ? b.getRangeAt(0) : void 0;
        }),
        (y = function (a, b) {
          var c = document.createRange();
          c.setStart(b.startContainer, b.startOffset),
            c.setEnd(b.endContainer, b.endOffset),
            (b = window.getSelection()),
            b.removeAllRanges(),
            b.addRange(c);
        }))
      : document.selection &&
        document.body.createTextRange &&
        ((x = function (a) {
          return document.selection.createRange();
        }),
        (y = function (a, b) {
          var c = document.body.createTextRange();
          c.moveToElementText(a),
            c.setStart(b.startContanier, b.startOffset),
            c.setEnd(b.endContainer, b.endOffset),
            c.select();
        }));
    var z;
    function A(a, b) {
      return a.replace(z, function (a) {
        var c = e[0 === k ? "jsecapeMap" : "jsEscapeMap"];
        return "undefined" != typeof a && a in c ? o(b, c[a]) : a;
      });
    }
    function B(a, b) {
      return (
        (a = a
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#x27;")
          .replace(/`/g, "&#x60;")
          .replace(/(?:\r\n|\r|\n)/g, "\n")
          .replace(/(\n+)/g, "<div>$1</div>")
          .replace(/\n/g, "<br/>")
          .replace(/<br\/><\/div>/g, "</div>")),
        b.shortnames && (a = e.shortnameToUnicode(a)),
        A(a, b.emojiTemplate)
          .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
          .replace(/  /g, "&nbsp;&nbsp;")
      );
    }
    function C(a, b) {
      switch (
        ((a = a
          .replace(/&#10;/g, "\n")
          .replace(/&#09;/g, "	")
          .replace(/<img[^>]*alt="([^"]+)"[^>]*>/gi, "$1")
          .replace(/\n|\r/g, "")
          .replace(/<br[^>]*>/gi, "\n")
          .replace(/(?:<(?:div|p|ol|ul|li|pre|code|object)[^>]*>)+/gi, "<div>")
          .replace(/(?:<\/(?:div|p|ol|ul|li|pre|code|object)>)+/gi, "</div>")
          .replace(/\n<div><\/div>/gi, "\n")
          .replace(/<div><\/div>\n/gi, "\n")
          .replace(/(?:<div>)+<\/div>/gi, "\n")
          .replace(/([^\n])<\/div><div>/gi, "$1\n")
          .replace(/(?:<\/div>)+/gi, "</div>")
          .replace(/([^\n])<\/div>([^\n])/gi, "$1\n$2")
          .replace(/<\/div>/gi, "")
          .replace(/([^\n])<div>/gi, "$1\n")
          .replace(/\n<div>/gi, "\n")
          .replace(/<div>\n/gi, "\n\n")
          .replace(/<(?:[^>]+)?>/g, "")
          .replace(new RegExp(l, "g"), "")
          .replace(/&nbsp;/g, " ")
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&quot;/g, '"')
          .replace(/&#x27;/g, "'")
          .replace(/&#x60;/g, "`")
          .replace(/&#60;/g, "<")
          .replace(/&#62;/g, ">")
          .replace(/&amp;/g, "&")),
        b.saveEmojisAs)
      ) {
        case "image":
          a = A(a, b.emojiTemplate);
          break;
        case "shortname":
          a = e.toShort(a);
      }
      return a;
    }
    function D() {
      var a = this,
        b = a.editor[0].offsetWidth - a.editor[0].clientWidth,
        c = parseInt(a.button.css("marginRight"));
      c !== b &&
        (a.button.css({ marginRight: b }),
        a.floatingPicker &&
          a.picker.css({ right: parseInt(a.picker.css("right")) - c + b }));
    }
    function E() {
      var b = this;
      if (!b.sprite && b.lasyEmoji[0]) {
        var c = b.picker.offset().top,
          d = c + b.picker.height() + 20;
        b.lasyEmoji.each(function () {
          var b = a(this),
            e = b.offset().top;
          e > c &&
            d > e &&
            b.attr("src", b.data("src")).removeClass("lazy-emoji");
        }),
          (b.lasyEmoji = b.lasyEmoji.filter(".lazy-emoji"));
      }
    }
    function F(a, b) {
      return (b ? "" : ".") + j + (a ? "-" + a : "");
    }
    function G(b) {
      var c = a("<div/>", s(b) ? b : { class: F(b, !0) });
      return (
        a.each(i.call(arguments).slice(1), function (b, d) {
          a.isFunction(d) && (d = d.call(c)), d && a(d).appendTo(c);
        }),
        c
      );
    }
    function H() {
      return localStorage.getItem("recent_emojis") || "";
    }
    function I(b, c) {
      var d = H();
      if (!b.recent || b.recent !== d || c) {
        if (d.length) {
          var e = b.scrollArea.is(".skinnable"),
            f,
            g;
          e ||
            ((f = b.scrollArea.scrollTop()),
            c && b.recentCategory.show(),
            (g = b.recentCategory.is(":visible")
              ? b.recentCategory.height()
              : 0));
          var h = p(d, b.emojiBtnTemplate, !0).split("|").join("");
          if (
            (b.recentCategory.children(".emojibtn").remove(),
            a(h).insertAfter(
              b.recentCategory.children(".emojionearea-category-title")
            ),
            b.recentCategory.children(".emojibtn").on("click", function () {
              b.trigger("emojibtn.click", a(this));
            }),
            b.recentFilter.show(),
            !e)
          ) {
            b.recentCategory.show();
            var i = b.recentCategory.height();
            g !== i && b.scrollArea.scrollTop(f + i - g);
          }
        } else
          b.recentFilter.hasClass("active") &&
            b.recentFilter.removeClass("active").next().addClass("active"),
            b.recentCategory.hide(),
            b.recentFilter.hide();
        b.recent = d;
      }
    }
    function J(a, b) {
      var c = H(),
        d = c.split("|"),
        e = d.indexOf(b);
      -1 !== e && d.splice(e, 1),
        d.unshift(b),
        d.length > 9 && d.pop(),
        localStorage.setItem("recent_emojis", d.join("|")),
        I(a);
    }
    function K() {
      var a = "test";
      try {
        return localStorage.setItem(a, a), localStorage.removeItem(a), !0;
      } catch (b) {
        return !1;
      }
    }
    function L(b, c, d) {
      (b.options = d = w(d)),
        (b.sprite = d.sprite && 3 > k),
        (b.inline = null === d.inline ? c.is("INPUT") : d.inline),
        (b.shortnames = d.shortnames),
        (b.saveEmojisAs = d.saveEmojisAs),
        (b.standalone = d.standalone),
        (b.emojiTemplate =
          '<img alt="{alt}" class="emojione' +
          (b.sprite ? '-{uni}" src="' + h + '"/>' : 'emoji" src="{img}"/>')),
        (b.emojiTemplateAlt = b.sprite
          ? '<i class="emojione-{uni}"/>'
          : '<img class="emojioneemoji" src="{img}"/>'),
        (b.emojiBtnTemplate =
          '<i class="emojibtn" role="button" data-name="{name}" title="{friendlyName}">' +
          b.emojiTemplateAlt +
          "</i>"),
        (b.recentEmojis = d.recentEmojis && K());
      var f = d.pickerPosition;
      (b.floatingPicker = "top" === f || "bottom" === f),
        (b.source = c),
        (c.is(":disabled") || c.is(".disabled")) && b.disable();
      var g = c.is("TEXTAREA") || c.is("INPUT") ? "val" : "text",
        i,
        o,
        r,
        t,
        u,
        v,
        z,
        A,
        L,
        M,
        N = G(
          "tones",
          d.tones
            ? function () {
                this.addClass(F("tones-" + d.tonesStyle, !0));
                for (var b = 0; 5 >= b; b++)
                  this.append(
                    a("<i/>", {
                      class: "btn-tone btn-tone-" + b + (b ? "" : " active"),
                      "data-skin": b,
                      role: "button",
                    })
                  );
              }
            : null
        ),
        O = G(
          {
            class:
              j +
              (b.standalone ? " " + j + "-standalone " : " ") +
              (c.attr("class") || ""),
            role: "application",
          },
          (i = b.editor = G("editor").attr({
            contenteditable: !b.standalone,
            placeholder:
              d.placeholder ||
              c.data("placeholder") ||
              c.attr("placeholder") ||
              "",
            tabindex: 0,
          })),
          (o = b.button = G("button", G("button-open"), G("button-close")).attr(
            "title",
            d.buttonTitle
          )),
          (r = b.picker = G(
            "picker",
            G(
              "wrapper",
              (t = G("filters")),
              d.search
                ? (v = G(
                    "search-panel",
                    G(
                      "search",
                      d.search
                        ? function () {
                            (b.search = a("<input/>", {
                              placeholder: d.searchPlaceholder || "",
                              type: "text",
                              class: "search",
                            })),
                              this.append(b.search);
                          }
                        : null
                    ),
                    N
                  ))
                : null,
              (M = G(
                "scroll-area",
                d.tones && !d.search ? G("tones-panel", N) : null,
                (z = G("emojis-list"))
              ))
            )
          )
            .addClass(F("picker-position-" + d.pickerPosition, !0))
            .addClass(F("filters-position-" + d.filtersPosition, !0))
            .addClass(F("search-position-" + d.searchPosition, !0))
            .addClass("hidden"))
        );
      d.search && v.addClass(F("with-search", !0)),
        (b.searchSel = null),
        i.data(c.data()),
        a.each(d.attributes, function (a, b) {
          i.attr(a, b);
        });
      var P = G("category-block").attr({ "data-tone": 0 }).prependTo(z);
      if (
        (a.each(d.filters, function (c, e) {
          var f = 0;
          if ("recent" !== c || b.recentEmojis) {
            if ("tones" !== c)
              a("<i/>", {
                class: F("filter", !0) + " " + F("filter-" + c, !0),
                "data-filter": c,
                title: e.title,
              })
                .wrapInner(p(e.icon, b.emojiTemplateAlt))
                .appendTo(t);
            else {
              if (!d.tones) return;
              f = 5;
            }
            do {
              var g,
                h = e.emoji.replace(/[\s,;]+/g, "|");
              (g =
                0 === f
                  ? G("category").attr({ name: c, "data-tone": f }).appendTo(P)
                  : G("category-block")
                      .attr({ name: c, "data-tone": f })
                      .appendTo(z)),
                f > 0 &&
                  (g.hide(),
                  (h = h.split("|").join("_tone" + f + "|") + "_tone" + f)),
                "recent" === c && (h = H()),
                (h = p(
                  h,
                  b.sprite
                    ? '<i class="emojibtn" role="button" data-name="{name}" title="{friendlyName}"><i class="emojione-{uni}"></i></i>'
                    : '<i class="emojibtn" role="button" data-name="{name}" title="{friendlyName}"><img class="emojioneemoji lazy-emoji" data-src="{img}"/></i>',
                  !0
                )
                  .split("|")
                  .join("")),
                g.html(h),
                a('<div class="emojionearea-category-title"/>')
                  .text(e.title)
                  .prependTo(g);
            } while (--f > 0);
          }
        }),
        (d.filters = null),
        b.sprite || (b.lasyEmoji = z.find(".lazy-emoji")),
        (u = t.find(F("filter"))),
        u.eq(0).addClass("active"),
        (L = z.find(F("category-block"))),
        (A = z.find(F("category"))),
        (b.recentFilter = u.filter('[data-filter="recent"]')),
        (b.recentCategory = A.filter("[name=recent]")),
        (b.scrollArea = M),
        d.container ? a(d.container).wrapInner(O) : O.insertAfter(c),
        d.hideSource && c.hide(),
        b.setText(c[g]()),
        c[g](b.getText()),
        D.apply(b),
        b.standalone && !b.getText().length)
      ) {
        var Q = a(c).data("emoji-placeholder") || d.emojiPlaceholder;
        b.setText(Q), i.addClass("has-placeholder");
      }
      n(b, z.find(".emojibtn"), { click: "emojibtn.click" }),
        n(b, window, { resize: "!resize" }),
        n(b, N.children(), { click: "tone.click" }),
        n(b, [r, o], { mousedown: "!mousedown" }, i),
        n(b, o, { click: "button.click" }),
        n(b, i, { paste: "!paste" }, i),
        n(b, i, ["focus", "blur"], function () {
          return b.stayFocused ? !1 : i;
        }),
        n(b, r, {
          mousedown: "picker.mousedown",
          mouseup: "picker.mouseup",
          click: "picker.click",
          keyup: "picker.keyup",
          keydown: "picker.keydown",
          keypress: "picker.keypress",
        }),
        n(b, i, [
          "mousedown",
          "mouseup",
          "click",
          "keyup",
          "keydown",
          "keypress",
        ]),
        n(b, r.find(".emojionearea-filter"), { click: "filter.click" }),
        n(b, c, { change: "source.change" }),
        d.search &&
          n(b, b.search, {
            keyup: "search.keypress",
            focus: "search.focus",
            blur: "search.blur",
          });
      var R = !1;
      if (
        (M.on("scroll", function () {
          if (!R && (E.call(b), M.is(":not(.skinnable)"))) {
            var c = A.eq(0),
              d = M.offset().top;
            A.each(function (b, e) {
              return a(e).offset().top - d >= 10 ? !1 : void (c = a(e));
            });
            var e = u.filter('[data-filter="' + c.attr("name") + '"]');
            e[0] &&
              !e.is(".active") &&
              (u.removeClass("active"), e.addClass("active"));
          }
        }),
        b
          .on("@filter.click", function (a) {
            var c = a.is(".active");
            if (M.is(".skinnable")) {
              if (c) return;
              N.children().eq(0).click();
            }
            (R = !0),
              c ||
                (u.filter(".active").removeClass("active"),
                a.addClass("active"));
            var d = A.filter('[name="' + a.data("filter") + '"]').offset().top,
              e = M.scrollTop(),
              f = M.offset().top;
            M.stop().animate(
              { scrollTop: d + e - f - 2 },
              200,
              "swing",
              function () {
                E.call(b), (R = !1);
              }
            );
          })
          .on("@picker.show", function () {
            b.recentEmojis && I(b), E.call(b);
          })
          .on("@tone.click", function (a) {
            N.children().removeClass("active");
            var c = a.addClass("active").data("skin");
            c
              ? (M.addClass("skinnable"),
                L.hide()
                  .filter("[data-tone=" + c + "]")
                  .show(),
                u.removeClass("active"))
              : (M.removeClass("skinnable"),
                L.hide().filter("[data-tone=0]").show(),
                u.eq(0).click()),
              E.call(b),
              d.search && b.trigger("search.keypress");
          })
          .on("@button.click", function (a) {
            a.is(".active")
              ? b.hidePicker()
              : (b.showPicker(), (b.searchSel = null));
          })
          .on("@!paste", function (c, d) {
            var e = function (d) {
              var e = "caret-" + new Date().getTime(),
                f = B(d, b);
              q(f), q('<i id="' + e + '"></i>'), c.scrollTop(h);
              var g = a("#" + e),
                i = g.offset().top - c.offset().top,
                j = c.height();
              (h + i >= j || h > i) && c.scrollTop(h + i - (2 * j) / 3),
                g.remove(),
                (b.stayFocused = !1),
                D.apply(b),
                m(b, "paste", [c, d, f]);
            };
            if (d.originalEvent.clipboardData) {
              var f = d.originalEvent.clipboardData.getData("text/plain");
              return (
                e(f),
                d.preventDefault ? d.preventDefault() : d.stop(),
                (d.returnValue = !1),
                d.stopPropagation(),
                !1
              );
            }
            (b.stayFocused = !0), q("<span>" + l + "</span>");
            var g = x(c[0]),
              h = c.scrollTop(),
              i = a("<div/>", { contenteditable: !0 })
                .css({
                  position: "fixed",
                  left: "-999px",
                  width: "1px",
                  height: "1px",
                  top: "20px",
                  overflow: "hidden",
                })
                .appendTo(a("BODY"))
                .focus();
            window.setTimeout(function () {
              c.focus(), y(c[0], g);
              var a = C(i.html().replace(/\r\n|\n|\r/g, "<br>"), b);
              i.remove(), e(a);
            }, 200);
          })
          .on("@emojibtn.click", function (a) {
            i.removeClass("has-placeholder"),
              null !== b.searchSel &&
                (i.focus(), y(i[0], b.searchSel), (b.searchSel = null)),
              b.standalone
                ? (i.html(p(a.data("name"), b.emojiTemplate)),
                  b.trigger("blur"))
                : (x(i[0]), q(p(a.data("name"), b.emojiTemplate))),
              b.recentEmojis && J(b, a.data("name")),
              b.trigger("search.keypress");
          })
          .on("@!resize @keyup @emojibtn.click", D)
          .on("@!mousedown", function (c, d) {
            return (
              a(d.target).hasClass("search")
                ? ((b.stayFocused = !0),
                  null === b.searchSel && (b.searchSel = x(c[0])))
                : (O.is(".focused") || c.focus(), d.preventDefault()),
              !1
            );
          })
          .on("@change", function () {
            var a = b.editor.html().replace(/<\/?(?:div|span|p)[^>]*>/gi, "");
            (a.length && !/^<br[^>]*>$/i.test(a)) ||
              b.editor.html((b.content = "")),
              c[g](b.getText());
          })
          .on("@source.change", function () {
            b.setText(c[g]()), m("change");
          })
          .on("@focus", function () {
            O.addClass("focused");
          })
          .on("@blur", function () {
            O.removeClass("focused"), d.hidePickerOnBlur && b.hidePicker();
            var a = b.editor.html();
            b.content !== a
              ? ((b.content = a),
                m(b, "change", [b.editor]),
                c.blur().trigger("change"))
              : c.blur(),
              d.search && (b.search.val(""), b.trigger("search.keypress", !0));
          }),
        d.search &&
          b
            .on("@search.focus", function () {
              (b.stayFocused = !0), b.search.addClass("focused");
            })
            .on("@search.keypress", function (c) {
              var e = r.find(".emojionearea-filter"),
                f = d.tones ? N.find("i.active").data("skin") : 0,
                g = b.search.val().replace(/ /g, "_").replace(/"/g, '\\"');
              g && g.length
                ? (b.recentFilter.hasClass("active") &&
                    b.recentFilter
                      .removeClass("active")
                      .next()
                      .addClass("active"),
                  b.recentCategory.hide(),
                  b.recentFilter.hide(),
                  L.each(function () {
                    var b = function (a, b) {
                        var c = a.find('.emojibtn[data-name*="' + g + '"]');
                        if (0 === c.length)
                          a.data("tone") === b && a.hide(),
                            e
                              .filter('[data-filter="' + a.attr("name") + '"]')
                              .hide();
                        else {
                          var d = a.find(
                            '.emojibtn:not([data-name*="' + g + '"])'
                          );
                          d.hide(),
                            c.show(),
                            a.data("tone") === b && a.show(),
                            e
                              .filter('[data-filter="' + a.attr("name") + '"]')
                              .show();
                        }
                      },
                      c = a(this);
                    0 === c.data("tone")
                      ? A.filter(':not([name="recent"])').each(function () {
                          b(a(this), 0);
                        })
                      : b(c, f);
                  }),
                  R ? E.call(b) : M.trigger("scroll"))
                : (I(b, !0),
                  L.filter(
                    '[data-tone="' +
                      N.find("i.active").data("skin") +
                      '"]:not([name="recent"])'
                  ).show(),
                  a(".emojibtn", L).show(),
                  e.show(),
                  c || E.call(b));
            })
            .on("@search.blur", function () {
              (b.stayFocused = !1),
                b.search.removeClass("focused"),
                b.trigger("blur");
            }),
        d.shortcuts &&
          b.on("@keydown", function (a, c) {
            c.ctrlKey ||
              (9 == c.which
                ? (c.preventDefault(), o.click())
                : 27 == c.which &&
                  (c.preventDefault(), o.is(".active") && b.hidePicker()));
          }),
        s(d.events) &&
          !a.isEmptyObject(d.events) &&
          a.each(d.events, function (a, c) {
            b.on(a.replace(/_/g, "."), c);
          }),
        d.autocomplete)
      ) {
        var S = function () {
            var c = {
              maxCount: d.textcomplete.maxCount,
              placement: d.textcomplete.placement,
            };
            d.shortcuts &&
              (c.onKeydown = function (a, b) {
                return a.ctrlKey || 13 != a.which ? void 0 : b.KEY_ENTER;
              });
            var f = a.map(e.emojioneList, function (a, b) {
              return d.autocompleteTones
                ? b
                : /_tone[12345]/.test(b)
                ? null
                : b;
            });
            f.sort(),
              i.textcomplete(
                [
                  {
                    id: j,
                    match: /\B(:[\-+\w]*)$/,
                    search: function (b, c) {
                      c(
                        a.map(f, function (a) {
                          return 0 === a.indexOf(b) ? a : null;
                        })
                      );
                    },
                    template: function (a) {
                      return p(a, b.emojiTemplate) + " " + a.replace(/:/g, "");
                    },
                    replace: function (a) {
                      return p(a, b.emojiTemplate);
                    },
                    cache: !0,
                    index: 1,
                  },
                ],
                c
              ),
              d.textcomplete.placement &&
                "static" ==
                  a(i.data("textComplete").option.appendTo).css("position") &&
                a(i.data("textComplete").option.appendTo).css(
                  "position",
                  "relative"
                );
          },
          T = function () {
            if (b.disabled) {
              var a = function () {
                b.off("enabled", a), S();
              };
              b.on("enabled", a);
            } else S();
          };
        a.fn.textcomplete
          ? T()
          : a.ajax({
              url:
                "https://cdn.rawgit.com/yuku-t/jquery-textcomplete/v1.3.4/dist/jquery.textcomplete.js",
              dataType: "script",
              cache: !0,
              success: T,
            });
      }
      b.inline &&
        (O.addClass(F("inline", !0)),
        b.on("@keydown", function (a, b) {
          13 == b.which && b.preventDefault();
        })),
        /firefox/i.test(navigator.userAgent) &&
          document.execCommand("enableObjectResizing", !1, !1),
        (b.isReady = !0),
        b.trigger("onLoad", i),
        b.trigger("ready", i);
    }
    var M = {
      defaultBase: "https://cdnjs.cloudflare.com/ajax/libs/emojione/",
      defaultBase3: "https://cdn.jsdelivr.net/",
      base: null,
      isLoading: !1,
    };
    function N(b) {
      var c = r();
      if (((b = w(b)), !M.isLoading))
        if (!e || u(t(e)) < 2) {
          M.isLoading = !0;
          var d;
          (d =
            u(c) > 5
              ? M.defaultBase3 + "npm/emojione@" + c
              : u(c) > 4
              ? M.defaultBase3 + "emojione/" + c
              : M.defaultBase + "/" + c),
            a.ajax({
              url: d + "/lib/js/emojione.min.js",
              dataType: "script",
              cache: !0,
              success: function () {
                (e = window.emojione), (c = t(e)), (k = u(c));
                var d;
                k > 4
                  ? ((M.base = M.defaultBase3 + "emojione/assets/" + c),
                    (d =
                      M.base +
                      "/sprites/emojione-sprite-" +
                      e.emojiSize +
                      ".css"))
                  : ((M.base = M.defaultBase + c + "/assets"),
                    (d = M.base + "/sprites/emojione.sprites.css")),
                  b.sprite &&
                    (document.createStyleSheet
                      ? document.createStyleSheet(d)
                      : a("<link/>", { rel: "stylesheet", href: d }).appendTo(
                          "head"
                        ));
                while (f.length) f.shift().call();
                M.isLoading = !1;
              },
            });
        } else
          (c = t(e)),
            (k = u(c)),
            k > 4
              ? (M.base = M.defaultBase3 + "emojione/assets/" + c)
              : (M.base = M.defaultBase + c + "/assets");
      g(function () {
        var a = "";
        b.useInternalCDN &&
          (k > 4 && (a = e.emojiSize + "/"),
          (e.imagePathPNG = M.base + "/png/" + a),
          (e.imagePathSVG = M.base + "/svg/" + a),
          (e.imagePathSVGSprites = M.base + "/sprites/emojione.sprites.svg"),
          (e.imageType = b.imageType)),
          u(c) > 4
            ? ((z = e.regUnicode), (e.imageType = b.imageType || "png"))
            : (z = new RegExp(
                "<object[^>]*>.*?</object>|<span[^>]*>.*?</span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(" +
                  e.unicodeRegexp +
                  ")",
                "gi"
              ));
      });
    }
    var O = function (a, e) {
      var f = this;
      N(e),
        (c[(f.id = ++b)] = {}),
        (d[f.id] = {}),
        g(function () {
          L(f, a, e);
        });
    };
    function P(b, c) {
      c = c.replace(/^@/, "");
      var e = b.id;
      d[e][c] &&
        (a.each(d[e][c], function (d, e) {
          a.each(a.isArray(e[0]) ? e[0] : [e[0]], function (d, f) {
            a(f).on(e[1], function () {
              var d = i.call(arguments),
                f = a.isFunction(e[2]) ? e[2].apply(b, [c].concat(d)) : e[2];
              f && m(b, c, [f].concat(d));
            });
          });
        }),
        (d[e][c] = null));
    }
    (O.prototype.on = function (b, d) {
      if (b && a.isFunction(d)) {
        var e = this;
        a.each(b.toLowerCase().split(" "), function (a, b) {
          P(e, b), (c[e.id][b] || (c[e.id][b] = [])).push(d);
        });
      }
      return this;
    }),
      (O.prototype.off = function (b, d) {
        if (b) {
          var e = this.id;
          a.each(b.toLowerCase().replace(/_/g, ".").split(" "), function (
            b,
            f
          ) {
            c[e][f] &&
              !/^@/.test(f) &&
              (d
                ? a.each(c[e][f], function (a, b) {
                    b === d && (c[e][f] = c[e][f].splice(a, 1));
                  })
                : (c[e][f] = []));
          });
        }
        return this;
      }),
      (O.prototype.trigger = function () {
        var a = i.call(arguments),
          b = [this].concat(a.slice(0, 1));
        return b.push(a.slice(1)), m.apply(this, b);
      }),
      (O.prototype.setFocus = function () {
        var a = this;
        return (
          g(function () {
            a.editor.focus();
          }),
          a
        );
      }),
      (O.prototype.setText = function (a) {
        var b = this;
        return (
          g(function () {
            b.editor.html(B(a, b)),
              (b.content = b.editor.html()),
              m(b, "change", [b.editor]),
              D.apply(b);
          }),
          b
        );
      }),
      (O.prototype.getText = function () {
        return C(this.editor.html(), this);
      }),
      (O.prototype.showPicker = function () {
        var a = this;
        return (
          a._sh_timer && window.clearTimeout(a._sh_timer),
          a.picker.removeClass("hidden"),
          (a._sh_timer = window.setTimeout(function () {
            a.button.addClass("active");
          }, 50)),
          m(a, "picker.show", [a.picker]),
          a
        );
      }),
      (O.prototype.hidePicker = function () {
        var a = this;
        return (
          a._sh_timer && window.clearTimeout(a._sh_timer),
          a.button.removeClass("active"),
          (a._sh_timer = window.setTimeout(function () {
            a.picker.addClass("hidden");
          }, 500)),
          m(a, "picker.hide", [a.picker]),
          a
        );
      }),
      (O.prototype.enable = function () {
        var a = this,
          b = function () {
            (a.disabled = !1),
              a.editor.prop("contenteditable", !0),
              a.button.show();
            var b = a[a.standalone ? "button" : "editor"];
            b.parent().removeClass("emojionearea-disable"),
              m(a, "enabled", [b]);
          };
        return a.isReady ? b() : a.on("ready", b), a;
      }),
      (O.prototype.disable = function () {
        var a = this;
        a.disabled = !0;
        var b = function () {
          a.editor.prop("contenteditable", !1), a.hidePicker(), a.button.hide();
          var b = a[a.standalone ? "button" : "editor"];
          b.parent().addClass("emojionearea-disable"), m(a, "disabled", [b]);
        };
        return a.isReady ? b() : a.on("ready", b), a;
      }),
      (a.fn.emojioneArea = function (b) {
        return this.each(function () {
          return this.emojioneArea
            ? this.emojioneArea
            : (a.data(
                this,
                "emojioneArea",
                (this.emojioneArea = new O(a(this), b))
              ),
              this.emojioneArea);
        });
      }),
      (a.fn.emojioneArea.defaults = v()),
      (a.fn.emojioneAreaText = function (b) {
        b = w(b);
        var c = this,
          d = {
            shortnames:
              b && "undefined" != typeof b.shortnames ? b.shortnames : !0,
            emojiTemplate:
              '<img alt="{alt}" class="emojione' +
              (b && b.sprite && 3 > k
                ? '-{uni}" src="' + h
                : 'emoji" src="{img}') +
              '"/>',
          };
        return (
          N(b),
          g(function () {
            c.each(function () {
              var b = a(this);
              return (
                b.hasClass("emojionearea-text") ||
                  b
                    .addClass("emojionearea-text")
                    .html(
                      B(
                        b.is("TEXTAREA") || b.is("INPUT") ? b.val() : b.text(),
                        d
                      )
                    ),
                b
              );
            });
          }),
          this
        );
      });
  }, window);
//# sourceMappingURL=emojionearea.min.map
/*
 *  webui popover plugin  - v1.2.17
 *  A lightWeight popover plugin with jquery ,enchance the  popover plugin of bootstrap with some awesome new features. It works well with bootstrap ,but bootstrap is not necessary!
 *  https://github.com/sandywalker/webui-popover
 *
 *  Made by Sandy Duan
 *  Under MIT License
 */
!(function (a, b, c) {
  "use strict";
  !(function (b) {
    "function" == typeof define && define.amd
      ? define(["jquery"], b)
      : "object" == typeof exports
      ? (module.exports = b(require("jquery")))
      : b(a.jQuery);
  })(function (d) {
    function e(a, b) {
      return (
        (this.$element = d(a)),
        b &&
          ("string" === d.type(b.delay) || "number" === d.type(b.delay)) &&
          (b.delay = { show: b.delay, hide: b.delay }),
        (this.options = d.extend({}, i, b)),
        (this._defaults = i),
        (this._name = f),
        (this._targetclick = !1),
        this.init(),
        k.push(this.$element),
        this
      );
    }
    var f = "webuiPopover",
      g = "webui-popover",
      h = "webui.popover",
      i = {
        placement: "auto",
        container: null,
        width: "auto",
        height: "auto",
        trigger: "click",
        style: "",
        selector: !1,
        delay: { show: null, hide: 300 },
        async: { type: "GET", before: null, success: null, error: null },
        cache: !0,
        multi: !1,
        arrow: !0,
        title: "",
        content: "",
        closeable: !1,
        padding: !0,
        url: "",
        type: "html",
        direction: "",
        animation: null,
        template:
          '<div class="webui-popover"><div class="webui-arrow"></div><div class="webui-popover-inner"><a href="#" class="close"></a><h3 class="webui-popover-title"></h3><div class="webui-popover-content"><i class="icon-refresh"></i> <p>&nbsp;</p></div></div></div>',
        backdrop: !1,
        dismissible: !0,
        onShow: null,
        onHide: null,
        abortXHR: !0,
        autoHide: !1,
        offsetTop: 0,
        offsetLeft: 0,
        iframeOptions: {
          frameborder: "0",
          allowtransparency: "true",
          id: "",
          name: "",
          scrolling: "",
          onload: "",
          height: "",
          width: "",
        },
        hideEmpty: !1,
      },
      j = g + "-rtl",
      k = [],
      l = d('<div class="webui-popover-backdrop"></div>'),
      m = 0,
      n = !1,
      o = -2e3,
      p = d(b),
      q = function (a, b) {
        return isNaN(a) ? b || 0 : Number(a);
      },
      r = function (a) {
        return a.data("plugin_" + f);
      },
      s = function () {
        for (var a = null, b = 0; b < k.length; b++)
          (a = r(k[b])), a && a.hide(!0);
        p.trigger("hiddenAll." + h);
      },
      t = function (a) {
        for (var b = null, c = 0; c < k.length; c++)
          (b = r(k[c])), b && b.id !== a.id && b.hide(!0);
        p.trigger("hiddenAll." + h);
      },
      u =
        "ontouchstart" in b.documentElement && /Mobi/.test(navigator.userAgent),
      v = function (a) {
        var b = { x: 0, y: 0 };
        if (
          "touchstart" === a.type ||
          "touchmove" === a.type ||
          "touchend" === a.type ||
          "touchcancel" === a.type
        ) {
          var c =
            a.originalEvent.touches[0] || a.originalEvent.changedTouches[0];
          (b.x = c.pageX), (b.y = c.pageY);
        } else
          ("mousedown" === a.type ||
            "mouseup" === a.type ||
            "click" === a.type) &&
            ((b.x = a.pageX), (b.y = a.pageY));
        return b;
      };
    (e.prototype = {
      init: function () {
        if (this.$element[0] instanceof b.constructor && !this.options.selector)
          throw new Error(
            "`selector` option must be specified when initializing " +
              this.type +
              " on the window.document object!"
          );
        "manual" !== this.getTrigger() &&
          (u
            ? this.$element
                .off("touchend", this.options.selector)
                .on(
                  "touchend",
                  this.options.selector,
                  d.proxy(this.toggle, this)
                )
            : "click" === this.getTrigger()
            ? this.$element
                .off("click", this.options.selector)
                .on("click", this.options.selector, d.proxy(this.toggle, this))
            : "hover" === this.getTrigger() &&
              this.$element
                .off("mouseenter mouseleave click", this.options.selector)
                .on(
                  "mouseenter",
                  this.options.selector,
                  d.proxy(this.mouseenterHandler, this)
                )
                .on(
                  "mouseleave",
                  this.options.selector,
                  d.proxy(this.mouseleaveHandler, this)
                )),
          (this._poped = !1),
          (this._inited = !0),
          (this._opened = !1),
          (this._idSeed = m),
          (this.id = f + this._idSeed),
          (this.options.container = d(
            this.options.container || b.body
          ).first()),
          this.options.backdrop && l.appendTo(this.options.container).hide(),
          m++,
          "sticky" === this.getTrigger() && this.show(),
          this.options.selector &&
            (this._options = d.extend({}, this.options, { selector: "" }));
      },
      destroy: function () {
        for (var a = -1, b = 0; b < k.length; b++)
          if (k[b] === this.$element) {
            a = b;
            break;
          }
        k.splice(a, 1),
          this.hide(),
          this.$element.data("plugin_" + f, null),
          "click" === this.getTrigger()
            ? this.$element.off("click")
            : "hover" === this.getTrigger() &&
              this.$element.off("mouseenter mouseleave"),
          this.$target && this.$target.remove();
      },
      getDelegateOptions: function () {
        var a = {};
        return (
          this._options &&
            d.each(this._options, function (b, c) {
              i[b] !== c && (a[b] = c);
            }),
          a
        );
      },
      hide: function (a, b) {
        if ((a || "sticky" !== this.getTrigger()) && this._opened) {
          b && (b.preventDefault(), b.stopPropagation()),
            this.xhr &&
              this.options.abortXHR === !0 &&
              (this.xhr.abort(), (this.xhr = null));
          var c = d.Event("hide." + h);
          if ((this.$element.trigger(c, [this.$target]), this.$target)) {
            this.$target.removeClass("in").addClass(this.getHideAnimation());
            var e = this;
            setTimeout(function () {
              e.$target.hide(), e.getCache() || e.$target.remove();
            }, e.getHideDelay());
          }
          this.options.backdrop && l.hide(),
            (this._opened = !1),
            this.$element.trigger("hidden." + h, [this.$target]),
            this.options.onHide && this.options.onHide(this.$target);
        }
      },
      resetAutoHide: function () {
        var a = this,
          b = a.getAutoHide();
        b &&
          (a.autoHideHandler && clearTimeout(a.autoHideHandler),
          (a.autoHideHandler = setTimeout(function () {
            a.hide();
          }, b)));
      },
      delegate: function (a) {
        var b = d(a).data("plugin_" + f);
        return (
          b ||
            ((b = new e(a, this.getDelegateOptions())),
            d(a).data("plugin_" + f, b)),
          b
        );
      },
      toggle: function (a) {
        var b = this;
        a &&
          (a.preventDefault(),
          a.stopPropagation(),
          this.options.selector && (b = this.delegate(a.currentTarget))),
          b[b.getTarget().hasClass("in") ? "hide" : "show"]();
      },
      hideAll: function () {
        s();
      },
      hideOthers: function () {
        t(this);
      },
      show: function () {
        if (!this._opened) {
          var a = this.getTarget()
            .removeClass()
            .addClass(g)
            .addClass(this._customTargetClass);
          if (
            (this.options.multi || this.hideOthers(),
            !this.getCache() || !this._poped || "" === this.content)
          ) {
            if (
              ((this.content = ""),
              this.setTitle(this.getTitle()),
              this.options.closeable || a.find(".close").off("click").remove(),
              this.isAsync()
                ? this.setContentASync(this.options.content)
                : this.setContent(this.getContent()),
              this.canEmptyHide() && "" === this.content)
            )
              return;
            a.show();
          }
          this.displayContent(),
            this.options.onShow && this.options.onShow(a),
            this.bindBodyEvents(),
            this.options.backdrop && l.show(),
            (this._opened = !0),
            this.resetAutoHide();
        }
      },
      displayContent: function () {
        var a = this.getElementPosition(),
          b = this.getTarget()
            .removeClass()
            .addClass(g)
            .addClass(this._customTargetClass),
          c = this.getContentElement(),
          e = b[0].offsetWidth,
          f = b[0].offsetHeight,
          i = "bottom",
          k = d.Event("show." + h);
        if (this.canEmptyHide()) {
          var l = c.children().html();
          if (null !== l && 0 === l.trim().length) return;
        }
        this.$element.trigger(k, [b]);
        var m = this.$element.data("width") || this.options.width;
        "" === m && (m = this._defaults.width), "auto" !== m && b.width(m);
        var n = this.$element.data("height") || this.options.height;
        "" === n && (n = this._defaults.height),
          "auto" !== n && c.height(n),
          this.options.style &&
            this.$target.addClass(g + "-" + this.options.style),
          "rtl" !== this.options.direction || c.hasClass(j) || c.addClass(j),
          this.options.arrow || b.find(".webui-arrow").remove(),
          b.detach().css({ top: o, left: o, display: "block" }),
          this.getAnimation() && b.addClass(this.getAnimation()),
          b.appendTo(this.options.container),
          (i = this.getPlacement(a)),
          this.$element.trigger("added." + h),
          this.initTargetEvents(),
          this.options.padding ||
            ("auto" !== this.options.height && c.css("height", c.outerHeight()),
            this.$target.addClass("webui-no-padding")),
          this.options.maxHeight && c.css("maxHeight", this.options.maxHeight),
          this.options.maxWidth && c.css("maxWidth", this.options.maxWidth),
          (e = b[0].offsetWidth),
          (f = b[0].offsetHeight);
        var p = this.getTargetPositin(a, i, e, f);
        if (
          (this.$target.css(p.position).addClass(i).addClass("in"),
          "iframe" === this.options.type)
        ) {
          var q = b.find("iframe"),
            r = b.width(),
            s = q.parent().height();
          "" !== this.options.iframeOptions.width &&
            "auto" !== this.options.iframeOptions.width &&
            (r = this.options.iframeOptions.width),
            "" !== this.options.iframeOptions.height &&
              "auto" !== this.options.iframeOptions.height &&
              (s = this.options.iframeOptions.height),
            q.width(r).height(s);
        }
        if (
          (this.options.arrow || this.$target.css({ margin: 0 }),
          this.options.arrow)
        ) {
          var t = this.$target.find(".webui-arrow");
          t.removeAttr("style"),
            "left" === i || "right" === i
              ? t.css({ top: this.$target.height() / 2 })
              : ("top" === i || "bottom" === i) &&
                t.css({ left: this.$target.width() / 2 }),
            p.arrowOffset &&
              (-1 === p.arrowOffset.left || -1 === p.arrowOffset.top
                ? t.hide()
                : t.css(p.arrowOffset));
        }
        (this._poped = !0), this.$element.trigger("shown." + h, [this.$target]);
      },
      isTargetLoaded: function () {
        return 0 === this.getTarget().find("i.glyphicon-refresh").length;
      },
      getTriggerElement: function () {
        return this.$element;
      },
      getTarget: function () {
        if (!this.$target) {
          var a = f + this._idSeed;
          (this.$target = d(this.options.template).attr("id", a)),
            (this._customTargetClass =
              this.$target.attr("class") !== g
                ? this.$target.attr("class")
                : null),
            this.getTriggerElement().attr("data-target", a);
        }
        return (
          this.$target.data("trigger-element") ||
            this.$target.data("trigger-element", this.getTriggerElement()),
          this.$target
        );
      },
      removeTarget: function () {
        this.$target.remove(),
          (this.$target = null),
          (this.$contentElement = null);
      },
      getTitleElement: function () {
        return this.getTarget().find("." + g + "-title");
      },
      getContentElement: function () {
        return (
          this.$contentElement ||
            (this.$contentElement = this.getTarget().find(
              "." + g + "-content"
            )),
          this.$contentElement
        );
      },
      getTitle: function () {
        return (
          this.$element.attr("data-title") ||
          this.options.title ||
          this.$element.attr("title")
        );
      },
      getUrl: function () {
        return this.$element.attr("data-url") || this.options.url;
      },
      getAutoHide: function () {
        return this.$element.attr("data-auto-hide") || this.options.autoHide;
      },
      getOffsetTop: function () {
        return (
          q(this.$element.attr("data-offset-top")) || this.options.offsetTop
        );
      },
      getOffsetLeft: function () {
        return (
          q(this.$element.attr("data-offset-left")) || this.options.offsetLeft
        );
      },
      getCache: function () {
        var a = this.$element.attr("data-cache");
        if ("undefined" != typeof a)
          switch (a.toLowerCase()) {
            case "true":
            case "yes":
            case "1":
              return !0;
            case "false":
            case "no":
            case "0":
              return !1;
          }
        return this.options.cache;
      },
      getTrigger: function () {
        return this.$element.attr("data-trigger") || this.options.trigger;
      },
      getDelayShow: function () {
        var a = this.$element.attr("data-delay-show");
        return "undefined" != typeof a
          ? a
          : 0 === this.options.delay.show
          ? 0
          : this.options.delay.show || 100;
      },
      getHideDelay: function () {
        var a = this.$element.attr("data-delay-hide");
        return "undefined" != typeof a
          ? a
          : 0 === this.options.delay.hide
          ? 0
          : this.options.delay.hide || 100;
      },
      getAnimation: function () {
        var a = this.$element.attr("data-animation");
        return a || this.options.animation;
      },
      getHideAnimation: function () {
        var a = this.getAnimation();
        return a ? a + "-out" : "out";
      },
      setTitle: function (a) {
        var b = this.getTitleElement();
        a
          ? ("rtl" !== this.options.direction || b.hasClass(j) || b.addClass(j),
            b.html(a))
          : b.remove();
      },
      hasContent: function () {
        return this.getContent();
      },
      canEmptyHide: function () {
        return this.options.hideEmpty && "html" === this.options.type;
      },
      getIframe: function () {
        var a = d("<iframe></iframe>").attr("src", this.getUrl()),
          b = this;
        return (
          d.each(this._defaults.iframeOptions, function (c) {
            "undefined" != typeof b.options.iframeOptions[c] &&
              a.attr(c, b.options.iframeOptions[c]);
          }),
          a
        );
      },
      getContent: function () {
        if (this.getUrl())
          switch (this.options.type) {
            case "iframe":
              this.content = this.getIframe();
              break;
            case "html":
              try {
                (this.content = d(this.getUrl())),
                  this.content.is(":visible") || this.content.show();
              } catch (a) {
                throw new Error(
                  "Unable to get popover content. Invalid selector specified."
                );
              }
          }
        else if (!this.content) {
          var b = "";
          if (
            ((b = d.isFunction(this.options.content)
              ? this.options.content.apply(this.$element[0], [this])
              : this.options.content),
            (this.content = this.$element.attr("data-content") || b),
            !this.content)
          ) {
            var c = this.$element.next();
            c && c.hasClass(g + "-content") && (this.content = c);
          }
        }
        return this.content;
      },
      setContent: function (a) {
        var b = this.getTarget(),
          c = this.getContentElement();
        "string" == typeof a
          ? c.html(a)
          : a instanceof d &&
            (c.html(""),
            this.options.cache
              ? a.removeClass(g + "-content").appendTo(c)
              : a
                  .clone(!0, !0)
                  .removeClass(g + "-content")
                  .appendTo(c)),
          (this.$target = b);
      },
      isAsync: function () {
        return "async" === this.options.type;
      },
      setContentASync: function (a) {
        var b = this;
        this.xhr ||
          (this.xhr = d.ajax({
            url: this.getUrl(),
            type: this.options.async.type,
            cache: this.getCache(),
            beforeSend: function (a, c) {
              b.options.async.before && b.options.async.before(b, a, c);
            },
            success: function (c) {
              b.bindBodyEvents(),
                a && d.isFunction(a)
                  ? (b.content = a.apply(b.$element[0], [c]))
                  : (b.content = c),
                b.setContent(b.content);
              var e = b.getContentElement();
              e.removeAttr("style"),
                b.displayContent(),
                b.options.async.success && b.options.async.success(b, c);
            },
            complete: function () {
              b.xhr = null;
            },
            error: function (a, c) {
              b.options.async.error && b.options.async.error(b, a, c);
            },
          }));
      },
      bindBodyEvents: function () {
        n ||
          (this.options.dismissible && "click" === this.getTrigger()
            ? u
              ? p
                  .off("touchstart.webui-popover")
                  .on(
                    "touchstart.webui-popover",
                    d.proxy(this.bodyTouchStartHandler, this)
                  )
              : (p
                  .off("keyup.webui-popover")
                  .on("keyup.webui-popover", d.proxy(this.escapeHandler, this)),
                p
                  .off("click.webui-popover")
                  .on(
                    "click.webui-popover",
                    d.proxy(this.bodyClickHandler, this)
                  ))
            : "hover" === this.getTrigger() &&
              p
                .off("touchend.webui-popover")
                .on(
                  "touchend.webui-popover",
                  d.proxy(this.bodyClickHandler, this)
                ));
      },
      mouseenterHandler: function (a) {
        var b = this;
        a && this.options.selector && (b = this.delegate(a.currentTarget)),
          b._timeout && clearTimeout(b._timeout),
          (b._enterTimeout = setTimeout(function () {
            b.getTarget().is(":visible") || b.show();
          }, this.getDelayShow()));
      },
      mouseleaveHandler: function () {
        var a = this;
        clearTimeout(a._enterTimeout),
          (a._timeout = setTimeout(function () {
            a.hide();
          }, this.getHideDelay()));
      },
      escapeHandler: function (a) {
        27 === a.keyCode && this.hideAll();
      },
      bodyTouchStartHandler: function (a) {
        var b = this,
          c = d(a.currentTarget);
        c.on("touchend", function (a) {
          b.bodyClickHandler(a), c.off("touchend");
        }),
          c.on("touchmove", function () {
            c.off("touchend");
          });
      },
      bodyClickHandler: function (a) {
        n = !0;
        for (var b = !0, c = 0; c < k.length; c++) {
          var d = r(k[c]);
          if (d && d._opened) {
            var e = d.getTarget().offset(),
              f = e.left,
              g = e.top,
              h = e.left + d.getTarget().width(),
              i = e.top + d.getTarget().height(),
              j = v(a),
              l = j.x >= f && j.x <= h && j.y >= g && j.y <= i;
            if (l) {
              b = !1;
              break;
            }
          }
        }
        b && s();
      },
      initTargetEvents: function () {
        "hover" === this.getTrigger() &&
          this.$target
            .off("mouseenter mouseleave")
            .on("mouseenter", d.proxy(this.mouseenterHandler, this))
            .on("mouseleave", d.proxy(this.mouseleaveHandler, this)),
          this.$target
            .find(".close")
            .off("click")
            .on("click", d.proxy(this.hide, this, !0));
      },
      getPlacement: function (a) {
        var b,
          c = this.options.container,
          d = c.innerWidth(),
          e = c.innerHeight(),
          f = c.scrollTop(),
          g = c.scrollLeft(),
          h = Math.max(0, a.left - g),
          i = Math.max(0, a.top - f);
        b =
          "function" == typeof this.options.placement
            ? this.options.placement.call(
                this,
                this.getTarget()[0],
                this.$element[0]
              )
            : this.$element.data("placement") || this.options.placement;
        var j = "horizontal" === b,
          k = "vertical" === b,
          l = "auto" === b || j || k;
        return (
          l
            ? (b =
                d / 3 > h
                  ? e / 3 > i
                    ? j
                      ? "right-bottom"
                      : "bottom-right"
                    : (2 * e) / 3 > i
                    ? k
                      ? e / 2 >= i
                        ? "bottom-right"
                        : "top-right"
                      : "right"
                    : j
                    ? "right-top"
                    : "top-right"
                  : (2 * d) / 3 > h
                  ? e / 3 > i
                    ? j
                      ? d / 2 >= h
                        ? "right-bottom"
                        : "left-bottom"
                      : "bottom"
                    : (2 * e) / 3 > i
                    ? j
                      ? d / 2 >= h
                        ? "right"
                        : "left"
                      : e / 2 >= i
                      ? "bottom"
                      : "top"
                    : j
                    ? d / 2 >= h
                      ? "right-top"
                      : "left-top"
                    : "top"
                  : e / 3 > i
                  ? j
                    ? "left-bottom"
                    : "bottom-left"
                  : (2 * e) / 3 > i
                  ? k
                    ? e / 2 >= i
                      ? "bottom-left"
                      : "top-left"
                    : "left"
                  : j
                  ? "left-top"
                  : "top-left")
            : "auto-top" === b
            ? (b =
                d / 3 > h ? "top-right" : (2 * d) / 3 > h ? "top" : "top-left")
            : "auto-bottom" === b
            ? (b =
                d / 3 > h
                  ? "bottom-right"
                  : (2 * d) / 3 > h
                  ? "bottom"
                  : "bottom-left")
            : "auto-left" === b
            ? (b =
                e / 3 > i
                  ? "left-top"
                  : (2 * e) / 3 > i
                  ? "left"
                  : "left-bottom")
            : "auto-right" === b &&
              (b =
                e / 3 > i
                  ? "right-bottom"
                  : (2 * e) / 3 > i
                  ? "right"
                  : "right-top"),
          b
        );
      },
      getElementPosition: function () {
        var a = this.$element[0].getBoundingClientRect(),
          c = this.options.container,
          e = c.css("position");
        if (c.is(b.body) || "static" === e)
          return d.extend({}, this.$element.offset(), {
            width: this.$element[0].offsetWidth || a.width,
            height: this.$element[0].offsetHeight || a.height,
          });
        if ("fixed" === e) {
          var f = c[0].getBoundingClientRect();
          return {
            top: a.top - f.top + c.scrollTop(),
            left: a.left - f.left + c.scrollLeft(),
            width: a.width,
            height: a.height,
          };
        }
        return "relative" === e
          ? {
              top: this.$element.offset().top - c.offset().top,
              left: this.$element.offset().left - c.offset().left,
              width: this.$element[0].offsetWidth || a.width,
              height: this.$element[0].offsetHeight || a.height,
            }
          : void 0;
      },
      getTargetPositin: function (a, c, d, e) {
        var f = a,
          g = this.options.container,
          h = this.$element.outerWidth(),
          i = this.$element.outerHeight(),
          j = b.documentElement.scrollTop + g.scrollTop(),
          k = b.documentElement.scrollLeft + g.scrollLeft(),
          l = {},
          m = null,
          n = this.options.arrow ? 20 : 0,
          p = 10,
          q = n + p > h ? n : 0,
          r = n + p > i ? n : 0,
          s = 0,
          t = b.documentElement.clientHeight + j,
          u = b.documentElement.clientWidth + k,
          v = f.left + f.width / 2 - q > 0,
          w = f.left + f.width / 2 + q < u,
          x = f.top + f.height / 2 - r > 0,
          y = f.top + f.height / 2 + r < t;
        switch (c) {
          case "bottom":
            l = { top: f.top + f.height, left: f.left + f.width / 2 - d / 2 };
            break;
          case "top":
            l = { top: f.top - e, left: f.left + f.width / 2 - d / 2 };
            break;
          case "left":
            l = { top: f.top + f.height / 2 - e / 2, left: f.left - d };
            break;
          case "right":
            l = { top: f.top + f.height / 2 - e / 2, left: f.left + f.width };
            break;
          case "top-right":
            (l = { top: f.top - e, left: v ? f.left - q : p }),
              (m = { left: v ? Math.min(h, d) / 2 + q : o });
            break;
          case "top-left":
            (s = w ? q : -p),
              (l = { top: f.top - e, left: f.left - d + f.width + s }),
              (m = { left: w ? d - Math.min(h, d) / 2 - q : o });
            break;
          case "bottom-right":
            (l = { top: f.top + f.height, left: v ? f.left - q : p }),
              (m = { left: v ? Math.min(h, d) / 2 + q : o });
            break;
          case "bottom-left":
            (s = w ? q : -p),
              (l = { top: f.top + f.height, left: f.left - d + f.width + s }),
              (m = { left: w ? d - Math.min(h, d) / 2 - q : o });
            break;
          case "right-top":
            (s = y ? r : -p),
              (l = { top: f.top - e + f.height + s, left: f.left + f.width }),
              (m = { top: y ? e - Math.min(i, e) / 2 - r : o });
            break;
          case "right-bottom":
            (l = { top: x ? f.top - r : p, left: f.left + f.width }),
              (m = { top: x ? Math.min(i, e) / 2 + r : o });
            break;
          case "left-top":
            (s = y ? r : -p),
              (l = { top: f.top - e + f.height + s, left: f.left - d }),
              (m = { top: y ? e - Math.min(i, e) / 2 - r : o });
            break;
          case "left-bottom":
            (l = { top: x ? f.top - r : p, left: f.left - d }),
              (m = { top: x ? Math.min(i, e) / 2 + r : o });
        }
        return (
          (l.top += this.getOffsetTop()),
          (l.left += this.getOffsetLeft()),
          { position: l, arrowOffset: m }
        );
      },
    }),
      (d.fn[f] = function (a, b) {
        var c = [],
          g = this.each(function () {
            var g = d.data(this, "plugin_" + f);
            g
              ? "destroy" === a
                ? g.destroy()
                : "string" == typeof a && c.push(g[a]())
              : (a
                  ? "string" == typeof a
                    ? "destroy" !== a &&
                      (b || ((g = new e(this, null)), c.push(g[a]())))
                    : "object" == typeof a && (g = new e(this, a))
                  : (g = new e(this, null)),
                d.data(this, "plugin_" + f, g));
          });
        return c.length ? c : g;
      });
    var w = (function () {
      var a = function () {
          s();
        },
        b = function (a, b) {
          (b = b || {}), d(a).webuiPopover(b);
        },
        e = function (a) {
          var b = !0;
          return (
            d(a).each(function (a, e) {
              b = b && d(e).data("plugin_" + f) !== c;
            }),
            b
          );
        },
        g = function (a, b) {
          b
            ? d(a).webuiPopover(b).webuiPopover("show")
            : d(a).webuiPopover("show");
        },
        h = function (a) {
          d(a).webuiPopover("hide");
        },
        j = function (a) {
          i = d.extend({}, i, a);
        },
        k = function (a, b) {
          var c = d(a).data("plugin_" + f);
          if (c) {
            var e = c.getCache();
            (c.options.cache = !1),
              (c.options.content = b),
              c._opened
                ? ((c._opened = !1), c.show())
                : c.isAsync()
                ? c.setContentASync(b)
                : c.setContent(b),
              (c.options.cache = e);
          }
        },
        l = function (a, b) {
          var c = d(a).data("plugin_" + f);
          if (c) {
            var e = c.getCache(),
              g = c.options.type;
            (c.options.cache = !1),
              (c.options.url = b),
              c._opened
                ? ((c._opened = !1), c.show())
                : ((c.options.type = "async"), c.setContentASync(c.content)),
              (c.options.cache = e),
              (c.options.type = g);
          }
        };
      return {
        show: g,
        hide: h,
        create: b,
        isCreated: e,
        hideAll: a,
        updateContent: k,
        updateContentAsync: l,
        setDefaultOptions: j,
      };
    })();
    a.WebuiPopovers = w;
  });
})(window, document);
/*
 * easy-autocomplete
 * jQuery plugin for autocompletion
 *
 * @author Łukasz Pawełczak (http://github.com/pawelczak)
 * @version 1.3.5
 * Copyright  License:
 */

var EasyAutocomplete = (function (a) {
    return (
      (a.Configuration = function (a) {
        function b() {
          if (
            ("xml" === a.dataType &&
              (a.getValue ||
                (a.getValue = function (a) {
                  return $(a).text();
                }),
              a.list || (a.list = {}),
              a.list.sort || (a.list.sort = {}),
              (a.list.sort.method = function (b, c) {
                return (
                  (b = a.getValue(b)),
                  (c = a.getValue(c)),
                  c > b ? -1 : b > c ? 1 : 0
                );
              }),
              a.list.match || (a.list.match = {}),
              (a.list.match.method = function (a, b) {
                return a.search(b) > -1;
              })),
            void 0 !== a.categories && a.categories instanceof Array)
          ) {
            for (var b = [], c = 0, d = a.categories.length; d > c; c += 1) {
              var e = a.categories[c];
              for (var f in h.categories[0])
                void 0 === e[f] && (e[f] = h.categories[0][f]);
              b.push(e);
            }
            a.categories = b;
          }
        }
        function c() {
          function b(a, c) {
            var d = a || {};
            for (var e in a)
              void 0 !== c[e] &&
                null !== c[e] &&
                ("object" != typeof c[e] || c[e] instanceof Array
                  ? (d[e] = c[e])
                  : b(a[e], c[e]));
            return (
              void 0 !== c.data &&
                null !== c.data &&
                "object" == typeof c.data &&
                (d.data = c.data),
              d
            );
          }
          h = b(h, a);
        }
        function d() {
          if ("list-required" !== h.url && "function" != typeof h.url) {
            var b = h.url;
            h.url = function () {
              return b;
            };
          }
          if (
            void 0 !== h.ajaxSettings.url &&
            "function" != typeof h.ajaxSettings.url
          ) {
            var b = h.ajaxSettings.url;
            h.ajaxSettings.url = function () {
              return b;
            };
          }
          if ("string" == typeof h.listLocation) {
            var c = h.listLocation;
            "XML" === h.dataType.toUpperCase()
              ? (h.listLocation = function (a) {
                  return $(a).find(c);
                })
              : (h.listLocation = function (a) {
                  return a[c];
                });
          }
          if ("string" == typeof h.getValue) {
            var d = h.getValue;
            h.getValue = function (a) {
              return a[d];
            };
          }
          void 0 !== a.categories && (h.categoriesAssigned = !0);
        }
        function e() {
          void 0 !== a.ajaxSettings && "object" == typeof a.ajaxSettings
            ? (h.ajaxSettings = a.ajaxSettings)
            : (h.ajaxSettings = {});
        }
        function f(a) {
          return void 0 !== h[a] && null !== h[a];
        }
        function g(a, b) {
          function c(b, d) {
            for (var e in d)
              void 0 === b[e] &&
                a.log(
                  "Property '" +
                    e +
                    "' does not exist in EasyAutocomplete options API."
                ),
                "object" == typeof b[e] &&
                  -1 === $.inArray(e, i) &&
                  c(b[e], d[e]);
          }
          c(h, b);
        }
        var h = {
            data: "list-required",
            url: "list-required",
            dataType: "json",
            listLocation: function (a) {
              return a;
            },
            xmlElementName: "",
            getValue: function (a) {
              return a;
            },
            autocompleteOff: !0,
            placeholder: !1,
            ajaxCallback: function () {},
            matchResponseProperty: !1,
            list: {
              sort: {
                enabled: !1,
                method: function (a, b) {
                  return (
                    (a = h.getValue(a)),
                    (b = h.getValue(b)),
                    b > a ? -1 : a > b ? 1 : 0
                  );
                },
              },
              maxNumberOfElements: 6,
              hideOnEmptyPhrase: !0,
              match: {
                enabled: !1,
                caseSensitive: !1,
                method: function (a, b) {
                  return a.search(b) > -1;
                },
              },
              showAnimation: {
                type: "normal",
                time: 400,
                callback: function () {},
              },
              hideAnimation: {
                type: "normal",
                time: 400,
                callback: function () {},
              },
              onClickEvent: function () {},
              onSelectItemEvent: function () {},
              onLoadEvent: function () {},
              onChooseEvent: function () {},
              onKeyEnterEvent: function () {},
              onMouseOverEvent: function () {},
              onMouseOutEvent: function () {},
              onShowListEvent: function () {},
              onHideListEvent: function () {},
            },
            highlightPhrase: !0,
            theme: "",
            cssClasses: "",
            minCharNumber: 0,
            requestDelay: 0,
            adjustWidth: !0,
            ajaxSettings: {},
            preparePostData: function (a, b) {
              return a;
            },
            loggerEnabled: !0,
            template: "",
            categoriesAssigned: !1,
            categories: [{ maxNumberOfElements: 4 }],
          },
          i = ["ajaxSettings", "template"];
        (this.get = function (a) {
          return h[a];
        }),
          (this.equals = function (a, b) {
            return !(!f(a) || h[a] !== b);
          }),
          (this.checkDataUrlProperties = function () {
            return "list-required" !== h.url || "list-required" !== h.data;
          }),
          (this.checkRequiredProperties = function () {
            for (var a in h)
              if ("required" === h[a])
                return logger.error("Option " + a + " must be defined"), !1;
            return !0;
          }),
          (this.printPropertiesThatDoesntExist = function (a, b) {
            g(a, b);
          }),
          b(),
          c(),
          h.loggerEnabled === !0 && g(console, a),
          e(),
          d();
      }),
      a
    );
  })(EasyAutocomplete || {}),
  EasyAutocomplete = (function (a) {
    return (
      (a.Logger = function () {
        (this.error = function (a) {
          console.log("ERROR: " + a);
        }),
          (this.warning = function (a) {
            console.log("WARNING: " + a);
          });
      }),
      a
    );
  })(EasyAutocomplete || {}),
  EasyAutocomplete = (function (a) {
    return (
      (a.Constans = function () {
        var a = {
          CONTAINER_CLASS: "easy-autocomplete-container",
          CONTAINER_ID: "eac-container-",
          WRAPPER_CSS_CLASS: "easy-autocomplete",
        };
        this.getValue = function (b) {
          return a[b];
        };
      }),
      a
    );
  })(EasyAutocomplete || {}),
  EasyAutocomplete = (function (a) {
    return (
      (a.ListBuilderService = function (a, b) {
        function c(b, c) {
          function d() {
            var d,
              e = {};
            return (
              void 0 !== b.xmlElementName &&
                (e.xmlElementName = b.xmlElementName),
              void 0 !== b.listLocation
                ? (d = b.listLocation)
                : void 0 !== a.get("listLocation") &&
                  (d = a.get("listLocation")),
              void 0 !== d
                ? "string" == typeof d
                  ? (e.data = $(c).find(d))
                  : "function" == typeof d && (e.data = d(c))
                : (e.data = c),
              e
            );
          }
          function e() {
            var a = {};
            return (
              void 0 !== b.listLocation
                ? "string" == typeof b.listLocation
                  ? (a.data = c[b.listLocation])
                  : "function" == typeof b.listLocation &&
                    (a.data = b.listLocation(c))
                : (a.data = c),
              a
            );
          }
          var f = {};
          if (
            ((f = "XML" === a.get("dataType").toUpperCase() ? d() : e()),
            void 0 !== b.header && (f.header = b.header),
            void 0 !== b.maxNumberOfElements &&
              (f.maxNumberOfElements = b.maxNumberOfElements),
            void 0 !== a.get("list").maxNumberOfElements &&
              (f.maxListSize = a.get("list").maxNumberOfElements),
            void 0 !== b.getValue)
          )
            if ("string" == typeof b.getValue) {
              var g = b.getValue;
              f.getValue = function (a) {
                return a[g];
              };
            } else "function" == typeof b.getValue && (f.getValue = b.getValue);
          else f.getValue = a.get("getValue");
          return f;
        }
        function d(b) {
          var c = [];
          return (
            void 0 === b.xmlElementName &&
              (b.xmlElementName = a.get("xmlElementName")),
            $(b.data)
              .find(b.xmlElementName)
              .each(function () {
                c.push(this);
              }),
            c
          );
        }
        (this.init = function (b) {
          var c = [],
            d = {};
          return (
            (d.data = a.get("listLocation")(b)),
            (d.getValue = a.get("getValue")),
            (d.maxListSize = a.get("list").maxNumberOfElements),
            c.push(d),
            c
          );
        }),
          (this.updateCategories = function (b, d) {
            if (a.get("categoriesAssigned")) {
              b = [];
              for (var e = 0; e < a.get("categories").length; e += 1) {
                var f = c(a.get("categories")[e], d);
                b.push(f);
              }
            }
            return b;
          }),
          (this.convertXml = function (b) {
            if ("XML" === a.get("dataType").toUpperCase())
              for (var c = 0; c < b.length; c += 1) b[c].data = d(b[c]);
            return b;
          }),
          (this.processData = function (c, d) {
            for (var e = 0, f = c.length; f > e; e += 1)
              c[e].data = b(a, c[e], d);
            return c;
          }),
          (this.checkIfDataExists = function (a) {
            for (var b = 0, c = a.length; c > b; b += 1)
              if (
                void 0 !== a[b].data &&
                a[b].data instanceof Array &&
                a[b].data.length > 0
              )
                return !0;
            return !1;
          });
      }),
      a
    );
  })(EasyAutocomplete || {}),
  EasyAutocomplete = (function (a) {
    return (
      (a.proccess = function (b, c, d) {
        function e(a, c) {
          var d = [],
            e = "";
          if (b.get("list").match.enabled)
            for (var g = 0, h = a.length; h > g; g += 1)
              (e = b.get("getValue")(a[g])), f(e, c) && d.push(a[g]);
          else d = a;
          return d;
        }
        function f(a, c) {
          return (
            b.get("list").match.caseSensitive ||
              ("string" == typeof a && (a = a.toLowerCase()),
              (c = c.toLowerCase())),
            !!b.get("list").match.method(a, c)
          );
        }
        function g(a) {
          return (
            void 0 !== c.maxNumberOfElements &&
              a.length > c.maxNumberOfElements &&
              (a = a.slice(0, c.maxNumberOfElements)),
            a
          );
        }
        function h(a) {
          return (
            b.get("list").sort.enabled && a.sort(b.get("list").sort.method), a
          );
        }
        a.proccess.match = f;
        var i = c.data,
          j = d;
        return (i = e(i, j)), (i = g(i)), (i = h(i));
      }),
      a
    );
  })(EasyAutocomplete || {}),
  EasyAutocomplete = (function (a) {
    return (
      (a.Template = function (a) {
        var b = {
            basic: {
              type: "basic",
              method: function (a) {
                return a;
              },
              cssClass: "",
            },
            description: {
              type: "description",
              fields: { description: "description" },
              method: function (a) {
                return a + " - description";
              },
              cssClass: "eac-description",
            },
            iconLeft: {
              type: "iconLeft",
              fields: { icon: "" },
              method: function (a) {
                return a;
              },
              cssClass: "eac-icon-left",
            },
            iconRight: {
              type: "iconRight",
              fields: { iconSrc: "" },
              method: function (a) {
                return a;
              },
              cssClass: "eac-icon-right",
            },
            links: {
              type: "links",
              fields: { link: "" },
              method: function (a) {
                return a;
              },
              cssClass: "",
            },
            custom: { type: "custom", method: function () {}, cssClass: "" },
          },
          c = function (a) {
            var c,
              d = a.fields;
            return "description" === a.type
              ? ((c = b.description.method),
                "string" == typeof d.description
                  ? (c = function (a, b) {
                      return a + " - <span>" + b[d.description] + "</span>";
                    })
                  : "function" == typeof d.description &&
                    (c = function (a, b) {
                      return a + " - <span>" + d.description(b) + "</span>";
                    }),
                c)
              : "iconRight" === a.type
              ? ("string" == typeof d.iconSrc
                  ? (c = function (a, b) {
                      return (
                        a +
                        "<img class='eac-icon' src='" +
                        b[d.iconSrc] +
                        "' />"
                      );
                    })
                  : "function" == typeof d.iconSrc &&
                    (c = function (a, b) {
                      return (
                        a +
                        "<img class='eac-icon' src='" +
                        d.iconSrc(b) +
                        "' />"
                      );
                    }),
                c)
              : "iconLeft" === a.type
              ? ("string" == typeof d.iconSrc
                  ? (c = function (a, b) {
                      return (
                        "<img class='eac-icon' src='" +
                        b[d.iconSrc] +
                        "' />" +
                        a
                      );
                    })
                  : "function" == typeof d.iconSrc &&
                    (c = function (a, b) {
                      return (
                        "<img class='eac-icon' src='" +
                        d.iconSrc(b) +
                        "' />" +
                        a
                      );
                    }),
                c)
              : "links" === a.type
              ? ("string" == typeof d.link
                  ? (c = function (a, b) {
                      return "<a href='" + b[d.link] + "' >" + a + "</a>";
                    })
                  : "function" == typeof d.link &&
                    (c = function (a, b) {
                      return "<a href='" + d.link(b) + "' >" + a + "</a>";
                    }),
                c)
              : "custom" === a.type
              ? a.method
              : b.basic.method;
          },
          d = function (a) {
            return a && a.type && a.type && b[a.type] ? c(a) : b.basic.method;
          },
          e = function (a) {
            var c = function () {
              return "";
            };
            return a && a.type && a.type && b[a.type]
              ? (function () {
                  var c = b[a.type].cssClass;
                  return function () {
                    return c;
                  };
                })()
              : c;
          };
        (this.getTemplateClass = e(a)), (this.build = d(a));
      }),
      a
    );
  })(EasyAutocomplete || {}),
  EasyAutocomplete = (function (a) {
    return (
      (a.main = function (b, c) {
        function d() {
          return 0 === t.length
            ? void p.error("Input field doesn't exist.")
            : o.checkDataUrlProperties()
            ? o.checkRequiredProperties()
              ? (e(), void g())
              : void p.error("Will not work without mentioned properties.")
            : void p.error(
                "One of options variables 'data' or 'url' must be defined."
              );
        }
        function e() {
          function a() {
            var a = $("<div>"),
              c = n.getValue("WRAPPER_CSS_CLASS");
            o.get("theme") &&
              "" !== o.get("theme") &&
              (c += " eac-" + o.get("theme")),
              o.get("cssClasses") &&
                "" !== o.get("cssClasses") &&
                (c += " " + o.get("cssClasses")),
              "" !== q.getTemplateClass() && (c += " " + q.getTemplateClass()),
              a.addClass(c),
              t.wrap(a),
              o.get("adjustWidth") === !0 && b();
          }
          function b() {
            var a = t.outerWidth();
            t.parent().css("width", a);
          }
          function c() {
            t.unwrap();
          }
          function d() {
            var a = $("<div>").addClass(n.getValue("CONTAINER_CLASS"));
            a.attr("id", f()).prepend($("<ul>")),
              (function () {
                a.on("show.eac", function () {
                  switch (o.get("list").showAnimation.type) {
                    case "slide":
                      var b = o.get("list").showAnimation.time,
                        c = o.get("list").showAnimation.callback;
                      a.find("ul").slideDown(b, c);
                      break;
                    case "fade":
                      var b = o.get("list").showAnimation.time,
                        c = o.get("list").showAnimation.callback;
                      a.find("ul").fadeIn(b), c;
                      break;
                    default:
                      a.find("ul").show();
                  }
                  o.get("list").onShowListEvent();
                })
                  .on("hide.eac", function () {
                    switch (o.get("list").hideAnimation.type) {
                      case "slide":
                        var b = o.get("list").hideAnimation.time,
                          c = o.get("list").hideAnimation.callback;
                        a.find("ul").slideUp(b, c);
                        break;
                      case "fade":
                        var b = o.get("list").hideAnimation.time,
                          c = o.get("list").hideAnimation.callback;
                        a.find("ul").fadeOut(b, c);
                        break;
                      default:
                        a.find("ul").hide();
                    }
                    o.get("list").onHideListEvent();
                  })
                  .on("selectElement.eac", function () {
                    a.find("ul li").removeClass("selected"),
                      a.find("ul li").eq(w).addClass("selected"),
                      o.get("list").onSelectItemEvent();
                  })
                  .on("loadElements.eac", function (b, c, d) {
                    var e = "",
                      f = a.find("ul");
                    f.empty().detach(), (v = []);
                    for (var h = 0, i = 0, k = c.length; k > i; i += 1) {
                      var l = c[i].data;
                      if (0 !== l.length) {
                        void 0 !== c[i].header &&
                          c[i].header.length > 0 &&
                          f.append(
                            "<div class='eac-category' >" +
                              c[i].header +
                              "</div>"
                          );
                        for (
                          var m = 0, n = l.length;
                          n > m && h < c[i].maxListSize;
                          m += 1
                        )
                          (e = $("<li><div class='eac-item'></div></li>")),
                            (function () {
                              var a = m,
                                b = h,
                                f = c[i].getValue(l[a]);
                              e.find(" > div")
                                .on("click", function () {
                                  t.val(f).trigger("change"),
                                    (w = b),
                                    j(b),
                                    o.get("list").onClickEvent(),
                                    o.get("list").onChooseEvent();
                                })
                                .mouseover(function () {
                                  (w = b),
                                    j(b),
                                    o.get("list").onMouseOverEvent();
                                })
                                .mouseout(function () {
                                  o.get("list").onMouseOutEvent();
                                })
                                .html(q.build(g(f, d), l[a]));
                            })(),
                            f.append(e),
                            v.push(l[m]),
                            (h += 1);
                      }
                    }
                    a.append(f), o.get("list").onLoadEvent();
                  });
              })(),
              t.after(a);
          }
          function e() {
            t.next("." + n.getValue("CONTAINER_CLASS")).remove();
          }
          function g(a, b) {
            return o.get("highlightPhrase") && "" !== b ? i(a, b) : a;
          }
          function h(a) {
            return a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
          }
          function i(a, b) {
            var c = h(b);
            return (a + "").replace(
              new RegExp("(" + c + ")", "gi"),
              "<b>$1</b>"
            );
          }
          t.parent().hasClass(n.getValue("WRAPPER_CSS_CLASS")) && (e(), c()),
            a(),
            d(),
            (u = $("#" + f())),
            o.get("placeholder") && t.attr("placeholder", o.get("placeholder"));
        }
        function f() {
          var a = t.attr("id");
          return (a = n.getValue("CONTAINER_ID") + a);
        }
        function g() {
          function a() {
            s("autocompleteOff", !0) && n(), b(), c(), d(), e(), f(), g();
          }
          function b() {
            t.focusout(function () {
              var a,
                b = t.val();
              o.get("list").match.caseSensitive || (b = b.toLowerCase());
              for (var c = 0, d = v.length; d > c; c += 1)
                if (
                  ((a = o.get("getValue")(v[c])),
                  o.get("list").match.caseSensitive || (a = a.toLowerCase()),
                  a === b)
                )
                  return (w = c), void j(w);
            });
          }
          function c() {
            t.off("keyup").keyup(function (a) {
              function b(a) {
                function b() {
                  var a = {},
                    b = o.get("ajaxSettings") || {};
                  for (var c in b) a[c] = b[c];
                  return a;
                }
                function c(a, b) {
                  return o.get("matchResponseProperty") !== !1
                    ? "string" == typeof o.get("matchResponseProperty")
                      ? b[o.get("matchResponseProperty")] === a
                      : "function" == typeof o.get("matchResponseProperty")
                      ? o.get("matchResponseProperty")(b) === a
                      : !0
                    : !0;
                }
                if (!(a.length < o.get("minCharNumber"))) {
                  if ("list-required" !== o.get("data")) {
                    var d = o.get("data"),
                      e = r.init(d);
                    (e = r.updateCategories(e, d)),
                      (e = r.processData(e, a)),
                      k(e, a),
                      t.parent().find("li").length > 0 ? h() : i();
                  }
                  var f = b();
                  (void 0 !== f.url && "" !== f.url) || (f.url = o.get("url")),
                    (void 0 !== f.dataType && "" !== f.dataType) ||
                      (f.dataType = o.get("dataType")),
                    void 0 !== f.url &&
                      "list-required" !== f.url &&
                      ((f.url = f.url(a)),
                      (f.data = o.get("preparePostData")(f.data, a)),
                      $.ajax(f)
                        .done(function (b) {
                          var d = r.init(b);
                          (d = r.updateCategories(d, b)),
                            (d = r.convertXml(d)),
                            c(a, b) && ((d = r.processData(d, a)), k(d, a)),
                            r.checkIfDataExists(d) &&
                            t.parent().find("li").length > 0
                              ? h()
                              : i(),
                            o.get("ajaxCallback")();
                        })
                        .fail(function () {
                          p.warning("Fail to load response data");
                        })
                        .always(function () {}));
                }
              }
              switch (a.keyCode) {
                case 27:
                  i(), l();
                  break;
                case 38:
                  a.preventDefault(),
                    v.length > 0 &&
                      w > 0 &&
                      ((w -= 1), t.val(o.get("getValue")(v[w])), j(w));
                  break;
                case 40:
                  a.preventDefault(),
                    v.length > 0 &&
                      w < v.length - 1 &&
                      ((w += 1), t.val(o.get("getValue")(v[w])), j(w));
                  break;
                default:
                  if (a.keyCode > 40 || 8 === a.keyCode) {
                    var c = t.val();
                    o.get("list").hideOnEmptyPhrase !== !0 ||
                    8 !== a.keyCode ||
                    "" !== c
                      ? o.get("requestDelay") > 0
                        ? (void 0 !== m && clearTimeout(m),
                          (m = setTimeout(function () {
                            b(c);
                          }, o.get("requestDelay"))))
                        : b(c)
                      : i();
                  }
              }
            });
          }
          function d() {
            t.on("keydown", function (a) {
              a = a || window.event;
              var b = a.keyCode;
              return 38 === b ? ((suppressKeypress = !0), !1) : void 0;
            }).keydown(function (a) {
              13 === a.keyCode &&
                w > -1 &&
                (t.val(o.get("getValue")(v[w])),
                o.get("list").onKeyEnterEvent(),
                o.get("list").onChooseEvent(),
                (w = -1),
                i(),
                a.preventDefault());
            });
          }
          function e() {
            t.off("keypress");
          }
          function f() {
            t.focus(function () {
              "" !== t.val() && v.length > 0 && ((w = -1), h());
            });
          }
          function g() {
            t.blur(function () {
              setTimeout(function () {
                (w = -1), i();
              }, 250);
            });
          }
          function n() {
            t.attr("autocomplete", "off");
          }
          a();
        }
        function h() {
          u.trigger("show.eac");
        }
        function i() {
          u.trigger("hide.eac");
        }
        function j(a) {
          u.trigger("selectElement.eac", a);
        }
        function k(a, b) {
          u.trigger("loadElements.eac", [a, b]);
        }
        function l() {
          t.trigger("blur");
        }
        var m,
          n = new a.Constans(),
          o = new a.Configuration(c),
          p = new a.Logger(),
          q = new a.Template(c.template),
          r = new a.ListBuilderService(o, a.proccess),
          s = o.equals,
          t = b,
          u = "",
          v = [],
          w = -1;
        (a.consts = n),
          (this.getConstants = function () {
            return n;
          }),
          (this.getConfiguration = function () {
            return o;
          }),
          (this.getContainer = function () {
            return u;
          }),
          (this.getSelectedItemIndex = function () {
            return w;
          }),
          (this.getItems = function () {
            return v;
          }),
          (this.getItemData = function (a) {
            return v.length < a || void 0 === v[a] ? -1 : v[a];
          }),
          (this.getSelectedItemData = function () {
            return this.getItemData(w);
          }),
          (this.build = function () {
            e();
          }),
          (this.init = function () {
            d();
          });
      }),
      (a.eacHandles = []),
      (a.getHandle = function (b) {
        return a.eacHandles[b];
      }),
      (a.inputHasId = function (a) {
        return void 0 !== $(a).attr("id") && $(a).attr("id").length > 0;
      }),
      (a.assignRandomId = function (b) {
        var c = "";
        do c = "eac-" + Math.floor(1e4 * Math.random());
        while (0 !== $("#" + c).length);
        (elementId = a.consts.getValue("CONTAINER_ID") + c), $(b).attr("id", c);
      }),
      (a.setHandle = function (b, c) {
        a.eacHandles[c] = b;
      }),
      a
    );
  })(EasyAutocomplete || {});
!(function (a) {
  (a.fn.easyAutocomplete = function (b) {
    return this.each(function () {
      var c = a(this),
        d = new EasyAutocomplete.main(c, b);
      EasyAutocomplete.inputHasId(c) || EasyAutocomplete.assignRandomId(c),
        d.init(),
        EasyAutocomplete.setHandle(d, c.attr("id"));
    });
  }),
    (a.fn.getSelectedItemIndex = function () {
      var b = a(this).attr("id");
      return void 0 !== b
        ? EasyAutocomplete.getHandle(b).getSelectedItemIndex()
        : -1;
    }),
    (a.fn.getItems = function () {
      var b = a(this).attr("id");
      return void 0 !== b ? EasyAutocomplete.getHandle(b).getItems() : -1;
    }),
    (a.fn.getItemData = function (b) {
      var c = a(this).attr("id");
      return void 0 !== c && b > -1
        ? EasyAutocomplete.getHandle(c).getItemData(b)
        : -1;
    }),
    (a.fn.getSelectedItemData = function () {
      var b = a(this).attr("id");
      return void 0 !== b
        ? EasyAutocomplete.getHandle(b).getSelectedItemData()
        : -1;
    });
})(jQuery);
("use strict");
function _possibleConstructorReturn(a, b) {
  if (!a)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  return !b || ("object" != typeof b && "function" != typeof b) ? a : b;
}
function _inherits(a, b) {
  if ("function" != typeof b && null !== b)
    throw new TypeError(
      "Super expression must either be null or a function, not " + typeof b
    );
  (a.prototype = Object.create(b && b.prototype, {
    constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 },
  })),
    b &&
      (Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : (a.__proto__ = b));
}
function _classCallCheck(a, b) {
  if (!(a instanceof b))
    throw new TypeError("Cannot call a class as a function");
}
function __guard__(a, b) {
  return void 0 !== a && null !== a ? b(a) : void 0;
}
function __guardMethod__(a, b, c) {
  return void 0 !== a && null !== a && "function" == typeof a[b]
    ? c(a, b)
    : void 0;
}
var _createClass = (function () {
    function a(a, b) {
      for (var c = 0; c < b.length; c++) {
        var d = b[c];
        (d.enumerable = d.enumerable || !1),
          (d.configurable = !0),
          "value" in d && (d.writable = !0),
          Object.defineProperty(a, d.key, d);
      }
    }
    return function (b, c, d) {
      return c && a(b.prototype, c), d && a(b, d), b;
    };
  })(),
  Emitter = (function () {
    function a() {
      _classCallCheck(this, a);
    }
    return (
      _createClass(a, [
        {
          key: "on",
          value: function (a, b) {
            return (
              (this._callbacks = this._callbacks || {}),
              this._callbacks[a] || (this._callbacks[a] = []),
              this._callbacks[a].push(b),
              this
            );
          },
        },
        {
          key: "emit",
          value: function (a) {
            this._callbacks = this._callbacks || {};
            var b = this._callbacks[a];
            if (b) {
              for (
                var c = arguments.length, d = Array(c > 1 ? c - 1 : 0), e = 1;
                e < c;
                e++
              )
                d[e - 1] = arguments[e];
              for (var f = b, g = 0, f = f; ; ) {
                var h;
                if (g >= f.length) break;
                h = f[g++];
                h.apply(this, d);
              }
            }
            return this;
          },
        },
        {
          key: "off",
          value: function (a, b) {
            if (!this._callbacks || 0 === arguments.length)
              return (this._callbacks = {}), this;
            var c = this._callbacks[a];
            if (!c) return this;
            if (1 === arguments.length) return delete this._callbacks[a], this;
            for (var d = 0; d < c.length; d++) {
              if (c[d] === b) {
                c.splice(d, 1);
                break;
              }
            }
            return this;
          },
        },
      ]),
      a
    );
  })(),
  Dropzone = (function (a) {
    function b(a, c) {
      _classCallCheck(this, b);
      var d = _possibleConstructorReturn(
          this,
          (b.__proto__ || Object.getPrototypeOf(b)).call(this)
        ),
        e = void 0,
        f = void 0;
      if (
        ((d.element = a),
        (d.version = b.version),
        (d.defaultOptions.previewTemplate = d.defaultOptions.previewTemplate.replace(
          /\n*/g,
          ""
        )),
        (d.clickableElements = []),
        (d.listeners = []),
        (d.files = []),
        "string" == typeof d.element &&
          (d.element = document.querySelector(d.element)),
        !d.element || null == d.element.nodeType)
      )
        throw new Error("Invalid dropzone element.");
      if (d.element.dropzone) throw new Error("Dropzone already attached.");
      b.instances.push(d), (d.element.dropzone = d);
      var g = null != (f = b.optionsForElement(d.element)) ? f : {};
      if (
        ((d.options = b.extend({}, d.defaultOptions, g, null != c ? c : {})),
        d.options.forceFallback || !b.isBrowserSupported())
      ) {
        var h;
        return (
          (h = d.options.fallback.call(d)), _possibleConstructorReturn(d, h)
        );
      }
      if (
        (null == d.options.url &&
          (d.options.url = d.element.getAttribute("action")),
        !d.options.url)
      )
        throw new Error("No URL provided.");
      if (d.options.acceptedFiles && d.options.acceptedMimeTypes)
        throw new Error(
          "You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated."
        );
      if (d.options.uploadMultiple && d.options.chunking)
        throw new Error("You cannot set both: uploadMultiple and chunking.");
      return (
        d.options.acceptedMimeTypes &&
          ((d.options.acceptedFiles = d.options.acceptedMimeTypes),
          delete d.options.acceptedMimeTypes),
        null != d.options.renameFilename &&
          (d.options.renameFile = function (a) {
            return d.options.renameFilename.call(d, a.name, a);
          }),
        (d.options.method = d.options.method.toUpperCase()),
        (e = d.getExistingFallback()) &&
          e.parentNode &&
          e.parentNode.removeChild(e),
        !1 !== d.options.previewsContainer &&
          (d.options.previewsContainer
            ? (d.previewsContainer = b.getElement(
                d.options.previewsContainer,
                "previewsContainer"
              ))
            : (d.previewsContainer = d.element)),
        d.options.clickable &&
          (!0 === d.options.clickable
            ? (d.clickableElements = [d.element])
            : (d.clickableElements = b.getElements(
                d.options.clickable,
                "clickable"
              ))),
        d.init(),
        d
      );
    }
    return (
      _inherits(b, a),
      _createClass(b, null, [
        {
          key: "initClass",
          value: function () {
            (this.prototype.Emitter = Emitter),
              (this.prototype.events = [
                "drop",
                "dragstart",
                "dragend",
                "dragenter",
                "dragover",
                "dragleave",
                "addedfile",
                "addedfiles",
                "removedfile",
                "thumbnail",
                "error",
                "errormultiple",
                "processing",
                "processingmultiple",
                "uploadprogress",
                "totaluploadprogress",
                "sending",
                "sendingmultiple",
                "success",
                "successmultiple",
                "canceled",
                "canceledmultiple",
                "complete",
                "completemultiple",
                "reset",
                "maxfilesexceeded",
                "maxfilesreached",
                "queuecomplete",
              ]),
              (this.prototype.defaultOptions = {
                url: null,
                method: "post",
                withCredentials: !1,
                timeout: 3e4,
                parallelUploads: 2,
                uploadMultiple: !1,
                chunking: !1,
                forceChunking: !1,
                chunkSize: 2e6,
                parallelChunkUploads: !1,
                retryChunks: !1,
                retryChunksLimit: 3,
                maxFilesize: 256,
                paramName: "file",
                createImageThumbnails: !0,
                maxThumbnailFilesize: 10,
                thumbnailWidth: 120,
                thumbnailHeight: 120,
                thumbnailMethod: "crop",
                resizeWidth: null,
                resizeHeight: null,
                resizeMimeType: null,
                resizeQuality: 0.8,
                resizeMethod: "contain",
                filesizeBase: 1e3,
                maxFiles: null,
                headers: null,
                clickable: !0,
                ignoreHiddenFiles: !0,
                acceptedFiles: null,
                acceptedMimeTypes: null,
                autoProcessQueue: !0,
                autoQueue: !0,
                addRemoveLinks: !1,
                previewsContainer: null,
                hiddenInputContainer: "body",
                capture: null,
                renameFilename: null,
                renameFile: null,
                forceFallback: !1,
                dictDefaultMessage: "Drop files here to upload",
                dictFallbackMessage:
                  "Your browser does not support drag'n'drop file uploads.",
                dictFallbackText:
                  "Please use the fallback form below to upload your files like in the olden days.",
                dictFileTooBig:
                  "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
                dictInvalidFileType: "You can't upload files of this type.",
                dictResponseError: "Server responded with {{statusCode}} code.",
                dictCancelUpload: "Cancel upload",
                dictUploadCanceled: "Upload canceled.",
                dictCancelUploadConfirmation:
                  "Are you sure you want to cancel this upload?",
                dictRemoveFile: "Remove file",
                dictRemoveFileConfirmation: null,
                dictMaxFilesExceeded: "You can not upload any more files.",
                dictFileSizeUnits: {
                  tb: "TB",
                  gb: "GB",
                  mb: "MB",
                  kb: "KB",
                  b: "b",
                },
                init: function () {},
                params: function (a, b, c) {
                  if (c)
                    return {
                      dzuuid: c.file.upload.uuid,
                      dzchunkindex: c.index,
                      dztotalfilesize: c.file.size,
                      dzchunksize: this.options.chunkSize,
                      dztotalchunkcount: c.file.upload.totalChunkCount,
                      dzchunkbyteoffset: c.index * this.options.chunkSize,
                    };
                },
                accept: function (a, b) {
                  return b();
                },
                chunksUploaded: function (a, b) {
                  b();
                },
                fallback: function () {
                  var a = void 0;
                  this.element.className =
                    this.element.className + " dz-browser-not-supported";
                  for (
                    var c = this.element.getElementsByTagName("div"),
                      d = 0,
                      c = c;
                    ;

                  ) {
                    var e;
                    if (d >= c.length) break;
                    e = c[d++];
                    var f = e;
                    if (/(^| )dz-message($| )/.test(f.className)) {
                      (a = f), (f.className = "dz-message");
                      break;
                    }
                  }
                  a ||
                    ((a = b.createElement(
                      '<div class="dz-message"><span></span></div>'
                    )),
                    this.element.appendChild(a));
                  var g = a.getElementsByTagName("span")[0];
                  return (
                    g &&
                      (null != g.textContent
                        ? (g.textContent = this.options.dictFallbackMessage)
                        : null != g.innerText &&
                          (g.innerText = this.options.dictFallbackMessage)),
                    this.element.appendChild(this.getFallbackForm())
                  );
                },
                resize: function (a, b, c, d) {
                  var e = {
                      srcX: 0,
                      srcY: 0,
                      srcWidth: a.width,
                      srcHeight: a.height,
                    },
                    f = a.width / a.height;
                  null == b && null == c
                    ? ((b = e.srcWidth), (c = e.srcHeight))
                    : null == b
                    ? (b = c * f)
                    : null == c && (c = b / f),
                    (b = Math.min(b, e.srcWidth)),
                    (c = Math.min(c, e.srcHeight));
                  var g = b / c;
                  if (e.srcWidth > b || e.srcHeight > c)
                    if ("crop" === d)
                      f > g
                        ? ((e.srcHeight = a.height),
                          (e.srcWidth = e.srcHeight * g))
                        : ((e.srcWidth = a.width),
                          (e.srcHeight = e.srcWidth / g));
                    else {
                      if ("contain" !== d)
                        throw new Error("Unknown resizeMethod '" + d + "'");
                      f > g ? (c = b / f) : (b = c * f);
                    }
                  return (
                    (e.srcX = (a.width - e.srcWidth) / 2),
                    (e.srcY = (a.height - e.srcHeight) / 2),
                    (e.trgWidth = b),
                    (e.trgHeight = c),
                    e
                  );
                },
                transformFile: function (a, b) {
                  return (this.options.resizeWidth ||
                    this.options.resizeHeight) &&
                    a.type.match(/image.*/)
                    ? this.resizeImage(
                        a,
                        this.options.resizeWidth,
                        this.options.resizeHeight,
                        this.options.resizeMethod,
                        b
                      )
                    : b(a);
                },
                previewTemplate:
                  '<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail /></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size></span></div>\n    <div class="dz-filename"><span data-dz-name></span></div>\n  </div>\n  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n  <div class="dz-error-message"><span data-dz-errormessage></span></div>\n  <div class="dz-success-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Check</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>\n      </g>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Error</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">\n          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>',
                drop: function (a) {
                  return this.element.classList.remove("dz-drag-hover");
                },
                dragstart: function (a) {},
                dragend: function (a) {
                  return this.element.classList.remove("dz-drag-hover");
                },
                dragenter: function (a) {
                  return this.element.classList.add("dz-drag-hover");
                },
                dragover: function (a) {
                  return this.element.classList.add("dz-drag-hover");
                },
                dragleave: function (a) {
                  return this.element.classList.remove("dz-drag-hover");
                },
                paste: function (a) {},
                reset: function () {
                  return this.element.classList.remove("dz-started");
                },
                addedfile: function (a) {
                  var c = this;
                  if (
                    (this.element === this.previewsContainer &&
                      this.element.classList.add("dz-started"),
                    this.previewsContainer)
                  ) {
                    (a.previewElement = b.createElement(
                      this.options.previewTemplate.trim()
                    )),
                      (a.previewTemplate = a.previewElement),
                      this.previewsContainer.appendChild(a.previewElement);
                    for (
                      var d = a.previewElement.querySelectorAll(
                          "[data-dz-name]"
                        ),
                        e = 0,
                        d = d;
                      ;

                    ) {
                      var f;
                      if (e >= d.length) break;
                      f = d[e++];
                      var g = f;
                      g.textContent = a.name;
                    }
                    for (
                      var h = a.previewElement.querySelectorAll(
                          "[data-dz-size]"
                        ),
                        i = 0,
                        h = h;
                      !(i >= h.length);

                    )
                      (g = h[i++]), (g.innerHTML = this.filesize(a.size));
                    this.options.addRemoveLinks &&
                      ((a._removeLink = b.createElement(
                        '<a class="dz-remove" href="javascript:undefined;" data-dz-remove>' +
                          this.options.dictRemoveFile +
                          "</a>"
                      )),
                      a.previewElement.appendChild(a._removeLink));
                    for (
                      var j = function (d) {
                          return (
                            d.preventDefault(),
                            d.stopPropagation(),
                            a.status === b.UPLOADING
                              ? b.confirm(
                                  c.options.dictCancelUploadConfirmation,
                                  function () {
                                    return c.removeFile(a);
                                  }
                                )
                              : c.options.dictRemoveFileConfirmation
                              ? b.confirm(
                                  c.options.dictRemoveFileConfirmation,
                                  function () {
                                    return c.removeFile(a);
                                  }
                                )
                              : c.removeFile(a)
                          );
                        },
                        k = a.previewElement.querySelectorAll(
                          "[data-dz-remove]"
                        ),
                        l = 0,
                        k = k;
                      ;

                    ) {
                      var m;
                      if (l >= k.length) break;
                      m = k[l++];
                      m.addEventListener("click", j);
                    }
                  }
                },
                removedfile: function (a) {
                  return (
                    null != a.previewElement &&
                      null != a.previewElement.parentNode &&
                      a.previewElement.parentNode.removeChild(a.previewElement),
                    this._updateMaxFilesReachedClass()
                  );
                },
                thumbnail: function (a, b) {
                  if (a.previewElement) {
                    a.previewElement.classList.remove("dz-file-preview");
                    for (
                      var c = a.previewElement.querySelectorAll(
                          "[data-dz-thumbnail]"
                        ),
                        d = 0,
                        c = c;
                      ;

                    ) {
                      var e;
                      if (d >= c.length) break;
                      e = c[d++];
                      var f = e;
                      (f.alt = a.name), (f.src = b);
                    }
                    return setTimeout(function () {
                      return a.previewElement.classList.add("dz-image-preview");
                    }, 1);
                  }
                },
                error: function (a, b) {
                  if (a.previewElement) {
                    a.previewElement.classList.add("dz-error"),
                      "String" != typeof b && b.error && (b = b.error);
                    for (
                      var c = a.previewElement.querySelectorAll(
                          "[data-dz-errormessage]"
                        ),
                        d = 0,
                        c = c;
                      ;

                    ) {
                      var e;
                      if (d >= c.length) break;
                      e = c[d++];
                      e.textContent = b;
                    }
                  }
                },
                errormultiple: function () {},
                processing: function (a) {
                  if (
                    a.previewElement &&
                    (a.previewElement.classList.add("dz-processing"),
                    a._removeLink)
                  )
                    return (a._removeLink.innerHTML = this.options.dictCancelUpload);
                },
                processingmultiple: function () {},
                uploadprogress: function (a, b, c) {
                  if (a.previewElement)
                    for (
                      var d = a.previewElement.querySelectorAll(
                          "[data-dz-uploadprogress]"
                        ),
                        e = 0,
                        d = d;
                      ;

                    ) {
                      var f;
                      if (e >= d.length) break;
                      f = d[e++];
                      var g = f;
                      "PROGRESS" === g.nodeName
                        ? (g.value = b)
                        : (g.style.width = b + "%");
                    }
                },
                totaluploadprogress: function () {},
                sending: function () {},
                sendingmultiple: function () {},
                success: function (a) {
                  if (a.previewElement)
                    return a.previewElement.classList.add("dz-success");
                },
                successmultiple: function () {},
                canceled: function (a) {
                  return this.emit("error", a, this.options.dictUploadCanceled);
                },
                canceledmultiple: function () {},
                complete: function (a) {
                  if (
                    (a._removeLink &&
                      (a._removeLink.innerHTML = this.options.dictRemoveFile),
                    a.previewElement)
                  )
                    return a.previewElement.classList.add("dz-complete");
                },
                completemultiple: function () {},
                maxfilesexceeded: function () {},
                maxfilesreached: function () {},
                queuecomplete: function () {},
                addedfiles: function () {},
              }),
              (this.prototype._thumbnailQueue = []),
              (this.prototype._processingThumbnail = !1);
          },
        },
        {
          key: "extend",
          value: function (a) {
            for (
              var b = arguments.length, c = Array(b > 1 ? b - 1 : 0), d = 1;
              d < b;
              d++
            )
              c[d - 1] = arguments[d];
            for (var e = c, f = 0, e = e; ; ) {
              var g;
              if (f >= e.length) break;
              g = e[f++];
              var h = g;
              for (var i in h) {
                var j = h[i];
                a[i] = j;
              }
            }
            return a;
          },
        },
      ]),
      _createClass(
        b,
        [
          {
            key: "getAcceptedFiles",
            value: function () {
              return this.files
                .filter(function (a) {
                  return a.accepted;
                })
                .map(function (a) {
                  return a;
                });
            },
          },
          {
            key: "getRejectedFiles",
            value: function () {
              return this.files
                .filter(function (a) {
                  return !a.accepted;
                })
                .map(function (a) {
                  return a;
                });
            },
          },
          {
            key: "getFilesWithStatus",
            value: function (a) {
              return this.files
                .filter(function (b) {
                  return b.status === a;
                })
                .map(function (a) {
                  return a;
                });
            },
          },
          {
            key: "getQueuedFiles",
            value: function () {
              return this.getFilesWithStatus(b.QUEUED);
            },
          },
          {
            key: "getUploadingFiles",
            value: function () {
              return this.getFilesWithStatus(b.UPLOADING);
            },
          },
          {
            key: "getAddedFiles",
            value: function () {
              return this.getFilesWithStatus(b.ADDED);
            },
          },
          {
            key: "getActiveFiles",
            value: function () {
              return this.files
                .filter(function (a) {
                  return a.status === b.UPLOADING || a.status === b.QUEUED;
                })
                .map(function (a) {
                  return a;
                });
            },
          },
          {
            key: "init",
            value: function () {
              var a = this;
              if (
                ("form" === this.element.tagName &&
                  this.element.setAttribute("enctype", "multipart/form-data"),
                this.element.classList.contains("dropzone") &&
                  !this.element.querySelector(".dz-message") &&
                  this.element.appendChild(
                    b.createElement(
                      '<div class="dz-default dz-message"><span>' +
                        this.options.dictDefaultMessage +
                        "</span></div>"
                    )
                  ),
                this.clickableElements.length)
              ) {
                !(function c() {
                  return (
                    a.hiddenFileInput &&
                      a.hiddenFileInput.parentNode.removeChild(
                        a.hiddenFileInput
                      ),
                    (a.hiddenFileInput = document.createElement("input")),
                    a.hiddenFileInput.setAttribute("type", "file"),
                    (null === a.options.maxFiles || a.options.maxFiles > 1) &&
                      a.hiddenFileInput.setAttribute("multiple", "multiple"),
                    (a.hiddenFileInput.className = "dz-hidden-input"),
                    null !== a.options.acceptedFiles &&
                      a.hiddenFileInput.setAttribute(
                        "accept",
                        a.options.acceptedFiles
                      ),
                    null !== a.options.capture &&
                      a.hiddenFileInput.setAttribute(
                        "capture",
                        a.options.capture
                      ),
                    (a.hiddenFileInput.style.visibility = "hidden"),
                    (a.hiddenFileInput.style.position = "absolute"),
                    (a.hiddenFileInput.style.top = "0"),
                    (a.hiddenFileInput.style.left = "0"),
                    (a.hiddenFileInput.style.height = "0"),
                    (a.hiddenFileInput.style.width = "0"),
                    b
                      .getElement(
                        a.options.hiddenInputContainer,
                        "hiddenInputContainer"
                      )
                      .appendChild(a.hiddenFileInput),
                    a.hiddenFileInput.addEventListener("change", function () {
                      var b = a.hiddenFileInput.files;
                      if (b.length)
                        for (var d = b, e = 0, d = d; ; ) {
                          var f;
                          if (e >= d.length) break;
                          f = d[e++];
                          var g = f;
                          a.addFile(g);
                        }
                      return a.emit("addedfiles", b), c();
                    })
                  );
                })();
              }
              this.URL = null !== window.URL ? window.URL : window.webkitURL;
              for (var c = this.events, d = 0, c = c; ; ) {
                var e;
                if (d >= c.length) break;
                e = c[d++];
                var f = e;
                this.on(f, this.options[f]);
              }
              this.on("uploadprogress", function () {
                return a.updateTotalUploadProgress();
              }),
                this.on("removedfile", function () {
                  return a.updateTotalUploadProgress();
                }),
                this.on("canceled", function (b) {
                  return a.emit("complete", b);
                }),
                this.on("complete", function (b) {
                  if (
                    0 === a.getAddedFiles().length &&
                    0 === a.getUploadingFiles().length &&
                    0 === a.getQueuedFiles().length
                  )
                    return setTimeout(function () {
                      return a.emit("queuecomplete");
                    }, 0);
                });
              var g = function (a) {
                return (
                  a.stopPropagation(),
                  a.preventDefault ? a.preventDefault() : (a.returnValue = !1)
                );
              };
              return (
                (this.listeners = [
                  {
                    element: this.element,
                    events: {
                      dragstart: function (b) {
                        return a.emit("dragstart", b);
                      },
                      dragenter: function (b) {
                        return g(b), a.emit("dragenter", b);
                      },
                      dragover: function (b) {
                        var c = void 0;
                        try {
                          c = b.dataTransfer.effectAllowed;
                        } catch (a) {}
                        return (
                          (b.dataTransfer.dropEffect =
                            "move" === c || "linkMove" === c ? "move" : "copy"),
                          g(b),
                          a.emit("dragover", b)
                        );
                      },
                      dragleave: function (b) {
                        return a.emit("dragleave", b);
                      },
                      drop: function (b) {
                        return g(b), a.drop(b);
                      },
                      dragend: function (b) {
                        return a.emit("dragend", b);
                      },
                    },
                  },
                ]),
                this.clickableElements.forEach(function (c) {
                  return a.listeners.push({
                    element: c,
                    events: {
                      click: function (d) {
                        return (
                          (c !== a.element ||
                            d.target === a.element ||
                            b.elementInside(
                              d.target,
                              a.element.querySelector(".dz-message")
                            )) &&
                            a.hiddenFileInput.click(),
                          !0
                        );
                      },
                    },
                  });
                }),
                this.enable(),
                this.options.init.call(this)
              );
            },
          },
          {
            key: "destroy",
            value: function () {
              return (
                this.disable(),
                this.removeAllFiles(!0),
                (null != this.hiddenFileInput
                  ? this.hiddenFileInput.parentNode
                  : void 0) &&
                  (this.hiddenFileInput.parentNode.removeChild(
                    this.hiddenFileInput
                  ),
                  (this.hiddenFileInput = null)),
                delete this.element.dropzone,
                b.instances.splice(b.instances.indexOf(this), 1)
              );
            },
          },
          {
            key: "updateTotalUploadProgress",
            value: function () {
              var a = void 0,
                b = 0,
                c = 0;
              if (this.getActiveFiles().length) {
                for (var d = this.getActiveFiles(), e = 0, d = d; ; ) {
                  var f;
                  if (e >= d.length) break;
                  f = d[e++];
                  var g = f;
                  (b += g.upload.bytesSent), (c += g.upload.total);
                }
                a = (100 * b) / c;
              } else a = 100;
              return this.emit("totaluploadprogress", a, c, b);
            },
          },
          {
            key: "_getParamName",
            value: function (a) {
              return "function" == typeof this.options.paramName
                ? this.options.paramName(a)
                : this.options.paramName +
                    (this.options.uploadMultiple ? "[" + a + "]" : "");
            },
          },
          {
            key: "_renameFile",
            value: function (a) {
              return "function" != typeof this.options.renameFile
                ? a.name
                : this.options.renameFile(a);
            },
          },
          {
            key: "getFallbackForm",
            value: function () {
              var a = void 0,
                c = void 0;
              if ((a = this.getExistingFallback())) return a;
              var d = '<div class="dz-fallback">';
              this.options.dictFallbackText &&
                (d += "<p>" + this.options.dictFallbackText + "</p>"),
                (d +=
                  '<input type="file" name="' +
                  this._getParamName(0) +
                  '" ' +
                  (this.options.uploadMultiple
                    ? 'multiple="multiple"'
                    : void 0) +
                  ' /><input type="submit" value="Upload!"></div>');
              var e = b.createElement(d);
              return (
                "FORM" !== this.element.tagName
                  ? ((c = b.createElement(
                      '<form action="' +
                        this.options.url +
                        '" enctype="multipart/form-data" method="' +
                        this.options.method +
                        '"></form>'
                    )),
                    c.appendChild(e))
                  : (this.element.setAttribute(
                      "enctype",
                      "multipart/form-data"
                    ),
                    this.element.setAttribute("method", this.options.method)),
                null != c ? c : e
              );
            },
          },
          {
            key: "getExistingFallback",
            value: function () {
              for (var a = ["div", "form"], b = 0; b < a.length; b++) {
                var c,
                  d = a[b];
                if (
                  (c = (function (a) {
                    for (var b = a, c = 0, b = b; ; ) {
                      var d;
                      if (c >= b.length) break;
                      d = b[c++];
                      var e = d;
                      if (/(^| )fallback($| )/.test(e.className)) return e;
                    }
                  })(this.element.getElementsByTagName(d)))
                )
                  return c;
              }
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              return this.listeners.map(function (a) {
                return (function () {
                  var b = [];
                  for (var c in a.events) {
                    var d = a.events[c];
                    b.push(a.element.addEventListener(c, d, !1));
                  }
                  return b;
                })();
              });
            },
          },
          {
            key: "removeEventListeners",
            value: function () {
              return this.listeners.map(function (a) {
                return (function () {
                  var b = [];
                  for (var c in a.events) {
                    var d = a.events[c];
                    b.push(a.element.removeEventListener(c, d, !1));
                  }
                  return b;
                })();
              });
            },
          },
          {
            key: "disable",
            value: function () {
              var a = this;
              return (
                this.clickableElements.forEach(function (a) {
                  return a.classList.remove("dz-clickable");
                }),
                this.removeEventListeners(),
                (this.disabled = !0),
                this.files.map(function (b) {
                  return a.cancelUpload(b);
                })
              );
            },
          },
          {
            key: "enable",
            value: function () {
              return (
                delete this.disabled,
                this.clickableElements.forEach(function (a) {
                  return a.classList.add("dz-clickable");
                }),
                this.setupEventListeners()
              );
            },
          },
          {
            key: "filesize",
            value: function (a) {
              var b = 0,
                c = "b";
              if (a > 0) {
                for (
                  var d = ["tb", "gb", "mb", "kb", "b"], e = 0;
                  e < d.length;
                  e++
                ) {
                  var f = d[e];
                  if (a >= Math.pow(this.options.filesizeBase, 4 - e) / 10) {
                    (b = a / Math.pow(this.options.filesizeBase, 4 - e)),
                      (c = f);
                    break;
                  }
                }
                b = Math.round(10 * b) / 10;
              }
              return (
                "<strong>" +
                b +
                "</strong> " +
                this.options.dictFileSizeUnits[c]
              );
            },
          },
          {
            key: "_updateMaxFilesReachedClass",
            value: function () {
              return null != this.options.maxFiles &&
                this.getAcceptedFiles().length >= this.options.maxFiles
                ? (this.getAcceptedFiles().length === this.options.maxFiles &&
                    this.emit("maxfilesreached", this.files),
                  this.element.classList.add("dz-max-files-reached"))
                : this.element.classList.remove("dz-max-files-reached");
            },
          },
          {
            key: "drop",
            value: function (a) {
              if (a.dataTransfer) {
                this.emit("drop", a);
                for (var b = [], c = 0; c < a.dataTransfer.files.length; c++)
                  b[c] = a.dataTransfer.files[c];
                if ((this.emit("addedfiles", b), b.length)) {
                  var d = a.dataTransfer.items;
                  d && d.length && null != d[0].webkitGetAsEntry
                    ? this._addFilesFromItems(d)
                    : this.handleFiles(b);
                }
              }
            },
          },
          {
            key: "paste",
            value: function (a) {
              if (
                null !=
                __guard__(null != a ? a.clipboardData : void 0, function (a) {
                  return a.items;
                })
              ) {
                this.emit("paste", a);
                var b = a.clipboardData.items;
                return b.length ? this._addFilesFromItems(b) : void 0;
              }
            },
          },
          {
            key: "handleFiles",
            value: function (a) {
              for (var b = a, c = 0, b = b; ; ) {
                var d;
                if (c >= b.length) break;
                d = b[c++];
                var e = d;
                this.addFile(e);
              }
            },
          },
          {
            key: "_addFilesFromItems",
            value: function (a) {
              var b = this;
              return (function () {
                for (var c = [], d = a, e = 0, d = d; ; ) {
                  var f;
                  if (e >= d.length) break;
                  f = d[e++];
                  var g,
                    h = f;
                  null != h.webkitGetAsEntry && (g = h.webkitGetAsEntry())
                    ? g.isFile
                      ? c.push(b.addFile(h.getAsFile()))
                      : g.isDirectory
                      ? c.push(b._addFilesFromDirectory(g, g.name))
                      : c.push(void 0)
                    : null != h.getAsFile &&
                      (null == h.kind || "file" === h.kind)
                    ? c.push(b.addFile(h.getAsFile()))
                    : c.push(void 0);
                }
                return c;
              })();
            },
          },
          {
            key: "_addFilesFromDirectory",
            value: function (a, b) {
              var c = this,
                d = a.createReader(),
                e = function (a) {
                  return __guardMethod__(console, "log", function (b) {
                    return b.log(a);
                  });
                };
              return (function a() {
                return d.readEntries(function (d) {
                  if (d.length > 0) {
                    for (var e = d, f = 0, e = e; ; ) {
                      var g;
                      if (f >= e.length) break;
                      g = e[f++];
                      var h = g;
                      h.isFile
                        ? h.file(function (a) {
                            if (
                              !c.options.ignoreHiddenFiles ||
                              "." !== a.name.substring(0, 1)
                            )
                              return (
                                (a.fullPath = b + "/" + a.name), c.addFile(a)
                              );
                          })
                        : h.isDirectory &&
                          c._addFilesFromDirectory(h, b + "/" + h.name);
                    }
                    a();
                  }
                  return null;
                }, e);
              })();
            },
          },
          {
            key: "accept",
            value: function (a, c) {
              return this.options.maxFilesize &&
                a.size > 1024 * this.options.maxFilesize * 1024
                ? c(
                    this.options.dictFileTooBig
                      .replace(
                        "{{filesize}}",
                        Math.round(a.size / 1024 / 10.24) / 100
                      )
                      .replace("{{maxFilesize}}", this.options.maxFilesize)
                  )
                : b.isValidFile(a, this.options.acceptedFiles)
                ? null != this.options.maxFiles &&
                  this.getAcceptedFiles().length >= this.options.maxFiles
                  ? (c(
                      this.options.dictMaxFilesExceeded.replace(
                        "{{maxFiles}}",
                        this.options.maxFiles
                      )
                    ),
                    this.emit("maxfilesexceeded", a))
                  : this.options.accept.call(this, a, c)
                : c(this.options.dictInvalidFileType);
            },
          },
          {
            key: "addFile",
            value: function (a) {
              var c = this;
              return (
                (a.upload = {
                  uuid: b.uuidv4(),
                  progress: 0,
                  total: a.size,
                  bytesSent: 0,
                  filename: this._renameFile(a),
                  chunked:
                    this.options.chunking &&
                    (this.options.forceChunking ||
                      a.size > this.options.chunkSize),
                  totalChunkCount: Math.ceil(a.size / this.options.chunkSize),
                }),
                this.files.push(a),
                (a.status = b.ADDED),
                this.emit("addedfile", a),
                this._enqueueThumbnail(a),
                this.accept(a, function (b) {
                  return (
                    b
                      ? ((a.accepted = !1), c._errorProcessing([a], b))
                      : ((a.accepted = !0),
                        c.options.autoQueue && c.enqueueFile(a)),
                    c._updateMaxFilesReachedClass()
                  );
                })
              );
            },
          },
          {
            key: "enqueueFiles",
            value: function (a) {
              for (var b = a, c = 0, b = b; ; ) {
                var d;
                if (c >= b.length) break;
                d = b[c++];
                var e = d;
                this.enqueueFile(e);
              }
              return null;
            },
          },
          {
            key: "enqueueFile",
            value: function (a) {
              var c = this;
              if (a.status !== b.ADDED || !0 !== a.accepted)
                throw new Error(
                  "This file can't be queued because it has already been processed or was rejected."
                );
              if (((a.status = b.QUEUED), this.options.autoProcessQueue))
                return setTimeout(function () {
                  return c.processQueue();
                }, 0);
            },
          },
          {
            key: "_enqueueThumbnail",
            value: function (a) {
              var b = this;
              if (
                this.options.createImageThumbnails &&
                a.type.match(/image.*/) &&
                a.size <= 1024 * this.options.maxThumbnailFilesize * 1024
              )
                return (
                  this._thumbnailQueue.push(a),
                  setTimeout(function () {
                    return b._processThumbnailQueue();
                  }, 0)
                );
            },
          },
          {
            key: "_processThumbnailQueue",
            value: function () {
              var a = this;
              if (
                !this._processingThumbnail &&
                0 !== this._thumbnailQueue.length
              ) {
                this._processingThumbnail = !0;
                var b = this._thumbnailQueue.shift();
                return this.createThumbnail(
                  b,
                  this.options.thumbnailWidth,
                  this.options.thumbnailHeight,
                  this.options.thumbnailMethod,
                  !0,
                  function (c) {
                    return (
                      a.emit("thumbnail", b, c),
                      (a._processingThumbnail = !1),
                      a._processThumbnailQueue()
                    );
                  }
                );
              }
            },
          },
          {
            key: "removeFile",
            value: function (a) {
              if (
                (a.status === b.UPLOADING && this.cancelUpload(a),
                (this.files = without(this.files, a)),
                this.emit("removedfile", a),
                0 === this.files.length)
              )
                return this.emit("reset");
            },
          },
          {
            key: "removeAllFiles",
            value: function (a) {
              null == a && (a = !1);
              for (var c = this.files.slice(), d = 0, c = c; ; ) {
                var e;
                if (d >= c.length) break;
                e = c[d++];
                var f = e;
                (f.status !== b.UPLOADING || a) && this.removeFile(f);
              }
              return null;
            },
          },
          {
            key: "resizeImage",
            value: function (a, c, d, e, f) {
              var g = this;
              return this.createThumbnail(a, c, d, e, !0, function (c, d) {
                if (null == d) return f(a);
                var e = g.options.resizeMimeType;
                null == e && (e = a.type);
                var h = d.toDataURL(e, g.options.resizeQuality);
                return (
                  ("image/jpeg" !== e && "image/jpg" !== e) ||
                    (h = ExifRestore.restore(a.dataURL, h)),
                  f(b.dataURItoBlob(h))
                );
              });
            },
          },
          {
            key: "createThumbnail",
            value: function (a, b, c, d, e, f) {
              var g = this,
                h = new FileReader();
              return (
                (h.onload = function () {
                  return (
                    (a.dataURL = h.result),
                    "image/svg+xml" === a.type
                      ? void (null != f && f(h.result))
                      : g.createThumbnailFromUrl(a, b, c, d, e, f)
                  );
                }),
                h.readAsDataURL(a)
              );
            },
          },
          {
            key: "createThumbnailFromUrl",
            value: function (a, b, c, d, e, f, g) {
              var h = this,
                i = document.createElement("img");
              return (
                g && (i.crossOrigin = g),
                (i.onload = function () {
                  var g = function (a) {
                    return a(1);
                  };
                  return (
                    "undefined" != typeof EXIF &&
                      null !== EXIF &&
                      e &&
                      (g = function (a) {
                        return EXIF.getData(i, function () {
                          return a(EXIF.getTag(this, "Orientation"));
                        });
                      }),
                    g(function (e) {
                      (a.width = i.width), (a.height = i.height);
                      var g = h.options.resize.call(h, a, b, c, d),
                        j = document.createElement("canvas"),
                        k = j.getContext("2d");
                      switch (
                        ((j.width = g.trgWidth),
                        (j.height = g.trgHeight),
                        e > 4 &&
                          ((j.width = g.trgHeight), (j.height = g.trgWidth)),
                        e)
                      ) {
                        case 2:
                          k.translate(j.width, 0), k.scale(-1, 1);
                          break;
                        case 3:
                          k.translate(j.width, j.height), k.rotate(Math.PI);
                          break;
                        case 4:
                          k.translate(0, j.height), k.scale(1, -1);
                          break;
                        case 5:
                          k.rotate(0.5 * Math.PI), k.scale(1, -1);
                          break;
                        case 6:
                          k.rotate(0.5 * Math.PI), k.translate(0, -j.width);
                          break;
                        case 7:
                          k.rotate(0.5 * Math.PI),
                            k.translate(j.height, -j.width),
                            k.scale(-1, 1);
                          break;
                        case 8:
                          k.rotate(-0.5 * Math.PI), k.translate(-j.height, 0);
                      }
                      drawImageIOSFix(
                        k,
                        i,
                        null != g.srcX ? g.srcX : 0,
                        null != g.srcY ? g.srcY : 0,
                        g.srcWidth,
                        g.srcHeight,
                        null != g.trgX ? g.trgX : 0,
                        null != g.trgY ? g.trgY : 0,
                        g.trgWidth,
                        g.trgHeight
                      );
                      var l = j.toDataURL("image/png");
                      if (null != f) return f(l, j);
                    })
                  );
                }),
                null != f && (i.onerror = f),
                (i.src = a.dataURL)
              );
            },
          },
          {
            key: "processQueue",
            value: function () {
              var a = this.options.parallelUploads,
                b = this.getUploadingFiles().length,
                c = b;
              if (!(b >= a)) {
                var d = this.getQueuedFiles();
                if (d.length > 0) {
                  if (this.options.uploadMultiple)
                    return this.processFiles(d.slice(0, a - b));
                  for (; c < a; ) {
                    if (!d.length) return;
                    this.processFile(d.shift()), c++;
                  }
                }
              }
            },
          },
          {
            key: "processFile",
            value: function (a) {
              return this.processFiles([a]);
            },
          },
          {
            key: "processFiles",
            value: function (a) {
              for (var c = a, d = 0, c = c; ; ) {
                var e;
                if (d >= c.length) break;
                e = c[d++];
                var f = e;
                (f.processing = !0),
                  (f.status = b.UPLOADING),
                  this.emit("processing", f);
              }
              return (
                this.options.uploadMultiple &&
                  this.emit("processingmultiple", a),
                this.uploadFiles(a)
              );
            },
          },
          {
            key: "_getFilesWithXhr",
            value: function (a) {
              return this.files
                .filter(function (b) {
                  return b.xhr === a;
                })
                .map(function (a) {
                  return a;
                });
            },
          },
          {
            key: "cancelUpload",
            value: function (a) {
              if (a.status === b.UPLOADING) {
                for (
                  var c = this._getFilesWithXhr(a.xhr), d = c, e = 0, d = d;
                  ;

                ) {
                  var f;
                  if (e >= d.length) break;
                  f = d[e++];
                  f.status = b.CANCELED;
                }
                void 0 !== a.xhr && a.xhr.abort();
                for (var g = c, h = 0, g = g; ; ) {
                  var i;
                  if (h >= g.length) break;
                  i = g[h++];
                  var j = i;
                  this.emit("canceled", j);
                }
                this.options.uploadMultiple && this.emit("canceledmultiple", c);
              } else
                (a.status !== b.ADDED && a.status !== b.QUEUED) ||
                  ((a.status = b.CANCELED),
                  this.emit("canceled", a),
                  this.options.uploadMultiple &&
                    this.emit("canceledmultiple", [a]));
              if (this.options.autoProcessQueue) return this.processQueue();
            },
          },
          {
            key: "resolveOption",
            value: function (a) {
              if ("function" == typeof a) {
                for (
                  var b = arguments.length, c = Array(b > 1 ? b - 1 : 0), d = 1;
                  d < b;
                  d++
                )
                  c[d - 1] = arguments[d];
                return a.apply(this, c);
              }
              return a;
            },
          },
          {
            key: "uploadFile",
            value: function (a) {
              return this.uploadFiles([a]);
            },
          },
          {
            key: "uploadFiles",
            value: function (a) {
              var c = this;
              this._transformFiles(a, function (d) {
                if (a[0].upload.chunked) {
                  var e = a[0],
                    f = d[0],
                    g = 0;
                  e.upload.chunks = [];
                  var h = function () {
                    for (var d = 0; void 0 !== e.upload.chunks[d]; ) d++;
                    if (!(d >= e.upload.totalChunkCount)) {
                      g++;
                      var h = d * c.options.chunkSize,
                        i = Math.min(h + c.options.chunkSize, e.size),
                        j = {
                          name: c._getParamName(0),
                          data: f.webkitSlice
                            ? f.webkitSlice(h, i)
                            : f.slice(h, i),
                          filename: e.upload.filename,
                          chunkIndex: d,
                        };
                      (e.upload.chunks[d] = {
                        file: e,
                        index: d,
                        dataBlock: j,
                        status: b.UPLOADING,
                        progress: 0,
                        retries: 0,
                      }),
                        c._uploadData(a, [j]);
                    }
                  };
                  if (
                    ((e.upload.finishedChunkUpload = function (d) {
                      var f = !0;
                      (d.status = b.SUCCESS),
                        (d.dataBlock = null),
                        (d.xhr = null);
                      for (var g = 0; g < e.upload.totalChunkCount; g++) {
                        if (void 0 === e.upload.chunks[g]) return h();
                        e.upload.chunks[g].status !== b.SUCCESS && (f = !1);
                      }
                      f &&
                        c.options.chunksUploaded(e, function () {
                          c._finished(a, "", null);
                        });
                    }),
                    c.options.parallelChunkUploads)
                  )
                    for (var i = 0; i < e.upload.totalChunkCount; i++) h();
                  else h();
                } else {
                  for (var j = [], k = 0; k < a.length; k++)
                    j[k] = {
                      name: c._getParamName(k),
                      data: d[k],
                      filename: a[k].upload.filename,
                    };
                  c._uploadData(a, j);
                }
              });
            },
          },
          {
            key: "_getChunk",
            value: function (a, b) {
              for (var c = 0; c < a.upload.totalChunkCount; c++)
                if (
                  void 0 !== a.upload.chunks[c] &&
                  a.upload.chunks[c].xhr === b
                )
                  return a.upload.chunks[c];
            },
          },
          {
            key: "_uploadData",
            value: function (a, c) {
              for (
                var d = this, e = new XMLHttpRequest(), f = a, g = 0, f = f;
                ;

              ) {
                var h;
                if (g >= f.length) break;
                h = f[g++];
                h.xhr = e;
              }
              a[0].upload.chunked &&
                (a[0].upload.chunks[c[0].chunkIndex].xhr = e);
              var i = this.resolveOption(this.options.method, a),
                j = this.resolveOption(this.options.url, a);
              e.open(i, j, !0),
                (e.timeout = this.resolveOption(this.options.timeout, a)),
                (e.withCredentials = !!this.options.withCredentials),
                (e.onload = function (b) {
                  d._finishedUploading(a, e, b);
                }),
                (e.onerror = function () {
                  d._handleUploadError(a, e);
                }),
                ((null != e.upload ? e.upload : e).onprogress = function (b) {
                  return d._updateFilesUploadProgress(a, e, b);
                });
              var k = {
                Accept: "application/json",
                "Cache-Control": "no-cache",
                "X-Requested-With": "XMLHttpRequest",
              };
              this.options.headers && b.extend(k, this.options.headers);
              for (var l in k) {
                var m = k[l];
                m && e.setRequestHeader(l, m);
              }
              var n = new FormData();
              if (this.options.params) {
                var o = this.options.params;
                "function" == typeof o &&
                  (o = o.call(
                    this,
                    a,
                    e,
                    a[0].upload.chunked ? this._getChunk(a[0], e) : null
                  ));
                for (var p in o) {
                  var q = o[p];
                  n.append(p, q);
                }
              }
              for (var r = a, s = 0, r = r; ; ) {
                var t;
                if (s >= r.length) break;
                t = r[s++];
                var u = t;
                this.emit("sending", u, e, n);
              }
              this.options.uploadMultiple &&
                this.emit("sendingmultiple", a, e, n),
                this._addFormElementData(n);
              for (var v = 0; v < c.length; v++) {
                var w = c[v];
                n.append(w.name, w.data, w.filename);
              }
              this.submitRequest(e, n, a);
            },
          },
          {
            key: "_transformFiles",
            value: function (a, b) {
              for (var c = this, d = [], e = 0, f = 0; f < a.length; f++)
                !(function (f) {
                  c.options.transformFile.call(c, a[f], function (c) {
                    (d[f] = c), ++e === a.length && b(d);
                  });
                })(f);
            },
          },
          {
            key: "_addFormElementData",
            value: function (a) {
              if ("FORM" === this.element.tagName)
                for (
                  var b = this.element.querySelectorAll(
                      "input, textarea, select, button"
                    ),
                    c = 0,
                    b = b;
                  ;

                ) {
                  var d;
                  if (c >= b.length) break;
                  d = b[c++];
                  var e = d,
                    f = e.getAttribute("name"),
                    g = e.getAttribute("type");
                  if ((g && (g = g.toLowerCase()), void 0 !== f && null !== f))
                    if ("SELECT" === e.tagName && e.hasAttribute("multiple"))
                      for (var h = e.options, i = 0, h = h; ; ) {
                        var j;
                        if (i >= h.length) break;
                        j = h[i++];
                        var k = j;
                        k.selected && a.append(f, k.value);
                      }
                    else
                      (!g ||
                        ("checkbox" !== g && "radio" !== g) ||
                        e.checked) &&
                        a.append(f, e.value);
                }
            },
          },
          {
            key: "_updateFilesUploadProgress",
            value: function (a, b, c) {
              var d = void 0;
              if (void 0 !== c) {
                if (((d = (100 * c.loaded) / c.total), a[0].upload.chunked)) {
                  var e = a[0],
                    f = this._getChunk(e, b);
                  (f.progress = d),
                    (f.total = c.total),
                    (f.bytesSent = c.loaded);
                  (e.upload.progress = 0),
                    (e.upload.total = 0),
                    (e.upload.bytesSent = 0);
                  for (var g = 0; g < e.upload.totalChunkCount; g++)
                    void 0 !== e.upload.chunks[g] &&
                      void 0 !== e.upload.chunks[g].progress &&
                      ((e.upload.progress += e.upload.chunks[g].progress),
                      (e.upload.total += e.upload.chunks[g].total),
                      (e.upload.bytesSent += e.upload.chunks[g].bytesSent));
                  e.upload.progress =
                    e.upload.progress / e.upload.totalChunkCount;
                } else
                  for (var h = a, i = 0, h = h; ; ) {
                    var j;
                    if (i >= h.length) break;
                    j = h[i++];
                    var k = j;
                    (k.upload.progress = d),
                      (k.upload.total = c.total),
                      (k.upload.bytesSent = c.loaded);
                  }
                for (var l = a, m = 0, l = l; ; ) {
                  var n;
                  if (m >= l.length) break;
                  n = l[m++];
                  var o = n;
                  this.emit(
                    "uploadprogress",
                    o,
                    o.upload.progress,
                    o.upload.bytesSent
                  );
                }
              } else {
                var p = !0;
                d = 100;
                for (var q = a, r = 0, q = q; ; ) {
                  var s;
                  if (r >= q.length) break;
                  s = q[r++];
                  var t = s;
                  (100 === t.upload.progress &&
                    t.upload.bytesSent === t.upload.total) ||
                    (p = !1),
                    (t.upload.progress = d),
                    (t.upload.bytesSent = t.upload.total);
                }
                if (p) return;
                for (var u = a, v = 0, u = u; ; ) {
                  var w;
                  if (v >= u.length) break;
                  w = u[v++];
                  var x = w;
                  this.emit("uploadprogress", x, d, x.upload.bytesSent);
                }
              }
            },
          },
          {
            key: "_finishedUploading",
            value: function (a, c, d) {
              var e = void 0;
              if (a[0].status !== b.CANCELED && 4 === c.readyState) {
                if (
                  "arraybuffer" !== c.responseType &&
                  "blob" !== c.responseType &&
                  ((e = c.responseText),
                  c.getResponseHeader("content-type") &&
                    ~c
                      .getResponseHeader("content-type")
                      .indexOf("application/json"))
                )
                  try {
                    e = JSON.parse(e);
                  } catch (a) {
                    (d = a), (e = "Invalid JSON response from server.");
                  }
                this._updateFilesUploadProgress(a),
                  200 <= c.status && c.status < 300
                    ? a[0].upload.chunked
                      ? a[0].upload.finishedChunkUpload(this._getChunk(a[0], c))
                      : this._finished(a, e, d)
                    : this._handleUploadError(a, c, e);
              }
            },
          },
          {
            key: "_handleUploadError",
            value: function (a, c, d) {
              if (a[0].status !== b.CANCELED) {
                if (a[0].upload.chunked && this.options.retryChunks) {
                  var e = this._getChunk(a[0], c);
                  if (e.retries++ < this.options.retryChunksLimit)
                    return void this._uploadData(a, [e.dataBlock]);
                  console.warn("Retried this chunk too often. Giving up.");
                }
                for (var f = a, g = 0, f = f; ; ) {
                  if (g >= f.length) break;
                  f[g++];
                  this._errorProcessing(
                    a,
                    d ||
                      this.options.dictResponseError.replace(
                        "{{statusCode}}",
                        c.status
                      ),
                    c
                  );
                }
              }
            },
          },
          {
            key: "submitRequest",
            value: function (a, b, c) {
              a.send(b);
            },
          },
          {
            key: "_finished",
            value: function (a, c, d) {
              for (var e = a, f = 0, e = e; ; ) {
                var g;
                if (f >= e.length) break;
                g = e[f++];
                var h = g;
                (h.status = b.SUCCESS),
                  this.emit("success", h, c, d),
                  this.emit("complete", h);
              }
              if (
                (this.options.uploadMultiple &&
                  (this.emit("successmultiple", a, c, d),
                  this.emit("completemultiple", a)),
                this.options.autoProcessQueue)
              )
                return this.processQueue();
            },
          },
          {
            key: "_errorProcessing",
            value: function (a, c, d) {
              for (var e = a, f = 0, e = e; ; ) {
                var g;
                if (f >= e.length) break;
                g = e[f++];
                var h = g;
                (h.status = b.ERROR),
                  this.emit("error", h, c, d),
                  this.emit("complete", h);
              }
              if (
                (this.options.uploadMultiple &&
                  (this.emit("errormultiple", a, c, d),
                  this.emit("completemultiple", a)),
                this.options.autoProcessQueue)
              )
                return this.processQueue();
            },
          },
        ],
        [
          {
            key: "uuidv4",
            value: function () {
              return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function (a) {
                  var b = (16 * Math.random()) | 0;
                  return ("x" === a ? b : (3 & b) | 8).toString(16);
                }
              );
            },
          },
        ]
      ),
      b
    );
  })(Emitter);
Dropzone.initClass(),
  (Dropzone.version = "5.5.1"),
  (Dropzone.options = {}),
  (Dropzone.optionsForElement = function (a) {
    return a.getAttribute("id")
      ? Dropzone.options[camelize(a.getAttribute("id"))]
      : void 0;
  }),
  (Dropzone.instances = []),
  (Dropzone.forElement = function (a) {
    if (
      ("string" == typeof a && (a = document.querySelector(a)),
      null == (null != a ? a.dropzone : void 0))
    )
      throw new Error(
        "No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone."
      );
    return a.dropzone;
  }),
  (Dropzone.autoDiscover = !0),
  (Dropzone.discover = function () {
    var a = void 0;
    if (document.querySelectorAll) a = document.querySelectorAll(".dropzone");
    else {
      a = [];
      var b = function (b) {
        return (function () {
          for (var c = [], d = b, e = 0, d = d; ; ) {
            var f;
            if (e >= d.length) break;
            f = d[e++];
            var g = f;
            /(^| )dropzone($| )/.test(g.className)
              ? c.push(a.push(g))
              : c.push(void 0);
          }
          return c;
        })();
      };
      b(document.getElementsByTagName("div")),
        b(document.getElementsByTagName("form"));
    }
    return (function () {
      for (var b = [], c = a, d = 0, c = c; ; ) {
        var e;
        if (d >= c.length) break;
        e = c[d++];
        var f = e;
        !1 !== Dropzone.optionsForElement(f)
          ? b.push(new Dropzone(f))
          : b.push(void 0);
      }
      return b;
    })();
  }),
  (Dropzone.blacklistedBrowsers = [
    /opera.*(Macintosh|Windows Phone).*version\/12/i,
  ]),
  (Dropzone.isBrowserSupported = function () {
    var a = !0;
    if (
      window.File &&
      window.FileReader &&
      window.FileList &&
      window.Blob &&
      window.FormData &&
      document.querySelector
    )
      if ("classList" in document.createElement("a"))
        for (var b = Dropzone.blacklistedBrowsers, c = 0, b = b; ; ) {
          var d;
          if (c >= b.length) break;
          d = b[c++];
          var e = d;
          e.test(navigator.userAgent) && (a = !1);
        }
      else a = !1;
    else a = !1;
    return a;
  }),
  (Dropzone.dataURItoBlob = function (a) {
    for (
      var b = atob(a.split(",")[1]),
        c = a.split(",")[0].split(":")[1].split(";")[0],
        d = new ArrayBuffer(b.length),
        e = new Uint8Array(d),
        f = 0,
        g = b.length,
        h = 0 <= g;
      h ? f <= g : f >= g;
      h ? f++ : f--
    )
      e[f] = b.charCodeAt(f);
    return new Blob([d], { type: c });
  });
var without = function (a, b) {
    return a
      .filter(function (a) {
        return a !== b;
      })
      .map(function (a) {
        return a;
      });
  },
  camelize = function (a) {
    return a.replace(/[\-_](\w)/g, function (a) {
      return a.charAt(1).toUpperCase();
    });
  };
(Dropzone.createElement = function (a) {
  var b = document.createElement("div");
  return (b.innerHTML = a), b.childNodes[0];
}),
  (Dropzone.elementInside = function (a, b) {
    if (a === b) return !0;
    for (; (a = a.parentNode); ) if (a === b) return !0;
    return !1;
  }),
  (Dropzone.getElement = function (a, b) {
    var c = void 0;
    if (
      ("string" == typeof a
        ? (c = document.querySelector(a))
        : null != a.nodeType && (c = a),
      null == c)
    )
      throw new Error(
        "Invalid `" +
          b +
          "` option provided. Please provide a CSS selector or a plain HTML element."
      );
    return c;
  }),
  (Dropzone.getElements = function (a, b) {
    var c = void 0,
      d = void 0;
    if (a instanceof Array) {
      d = [];
      try {
        for (var e = a, f = 0, e = e; !(f >= e.length); )
          (c = e[f++]), d.push(this.getElement(c, b));
      } catch (a) {
        d = null;
      }
    } else if ("string" == typeof a) {
      d = [];
      for (
        var g = document.querySelectorAll(a), h = 0, g = g;
        !(h >= g.length);

      )
        (c = g[h++]), d.push(c);
    } else null != a.nodeType && (d = [a]);
    if (null == d || !d.length)
      throw new Error(
        "Invalid `" +
          b +
          "` option provided. Please provide a CSS selector, a plain HTML element or a list of those."
      );
    return d;
  }),
  (Dropzone.confirm = function (a, b, c) {
    return window.confirm(a) ? b() : null != c ? c() : void 0;
  }),
  (Dropzone.isValidFile = function (a, b) {
    if (!b) return !0;
    b = b.split(",");
    for (var c = a.type, d = c.replace(/\/.*$/, ""), e = b, f = 0, e = e; ; ) {
      var g;
      if (f >= e.length) break;
      g = e[f++];
      var h = g;
      if (((h = h.trim()), "." === h.charAt(0))) {
        if (
          -1 !==
          a.name
            .toLowerCase()
            .indexOf(h.toLowerCase(), a.name.length - h.length)
        )
          return !0;
      } else if (/\/\*$/.test(h)) {
        if (d === h.replace(/\/.*$/, "")) return !0;
      } else if (c === h) return !0;
    }
    return !1;
  }),
  "undefined" != typeof jQuery &&
    null !== jQuery &&
    (jQuery.fn.dropzone = function (a) {
      return this.each(function () {
        return new Dropzone(this, a);
      });
    }),
  "undefined" != typeof module && null !== module
    ? (module.exports = Dropzone)
    : (window.Dropzone = Dropzone),
  (Dropzone.ADDED = "added"),
  (Dropzone.QUEUED = "queued"),
  (Dropzone.ACCEPTED = Dropzone.QUEUED),
  (Dropzone.UPLOADING = "uploading"),
  (Dropzone.PROCESSING = Dropzone.UPLOADING),
  (Dropzone.CANCELED = "canceled"),
  (Dropzone.ERROR = "error"),
  (Dropzone.SUCCESS = "success");
var detectVerticalSquash = function (a) {
    var b = (a.naturalWidth, a.naturalHeight),
      c = document.createElement("canvas");
    (c.width = 1), (c.height = b);
    var d = c.getContext("2d");
    d.drawImage(a, 0, 0);
    for (
      var e = d.getImageData(1, 0, 1, b), f = e.data, g = 0, h = b, i = b;
      i > g;

    ) {
      0 === f[4 * (i - 1) + 3] ? (h = i) : (g = i), (i = (h + g) >> 1);
    }
    var j = i / b;
    return 0 === j ? 1 : j;
  },
  drawImageIOSFix = function (a, b, c, d, e, f, g, h, i, j) {
    var k = detectVerticalSquash(b);
    return a.drawImage(b, c, d, e, f, g, h, i, j / k);
  },
  ExifRestore = (function () {
    function a() {
      _classCallCheck(this, a);
    }
    return (
      _createClass(a, null, [
        {
          key: "initClass",
          value: function () {
            this.KEY_STR =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          },
        },
        {
          key: "encode64",
          value: function (a) {
            for (
              var b = "",
                c = void 0,
                d = void 0,
                e = "",
                f = void 0,
                g = void 0,
                h = void 0,
                i = "",
                j = 0;
              ;

            )
              if (
                ((c = a[j++]),
                (d = a[j++]),
                (e = a[j++]),
                (f = c >> 2),
                (g = ((3 & c) << 4) | (d >> 4)),
                (h = ((15 & d) << 2) | (e >> 6)),
                (i = 63 & e),
                isNaN(d) ? (h = i = 64) : isNaN(e) && (i = 64),
                (b =
                  b +
                  this.KEY_STR.charAt(f) +
                  this.KEY_STR.charAt(g) +
                  this.KEY_STR.charAt(h) +
                  this.KEY_STR.charAt(i)),
                (c = d = e = ""),
                (f = g = h = i = ""),
                !(j < a.length))
              )
                break;
            return b;
          },
        },
        {
          key: "restore",
          value: function (a, b) {
            if (!a.match("data:image/jpeg;base64,")) return b;
            var c = this.decode64(a.replace("data:image/jpeg;base64,", "")),
              d = this.slice2Segments(c),
              e = this.exifManipulation(b, d);
            return "data:image/jpeg;base64," + this.encode64(e);
          },
        },
        {
          key: "exifManipulation",
          value: function (a, b) {
            var c = this.getExifArray(b),
              d = this.insertExif(a, c);
            return new Uint8Array(d);
          },
        },
        {
          key: "getExifArray",
          value: function (a) {
            for (var b = void 0, c = 0; c < a.length; ) {
              if (((b = a[c]), (255 === b[0]) & (225 === b[1]))) return b;
              c++;
            }
            return [];
          },
        },
        {
          key: "insertExif",
          value: function (a, b) {
            var c = a.replace("data:image/jpeg;base64,", ""),
              d = this.decode64(c),
              e = d.indexOf(255, 3),
              f = d.slice(0, e),
              g = d.slice(e),
              h = f;
            return (h = h.concat(b)), (h = h.concat(g));
          },
        },
        {
          key: "slice2Segments",
          value: function (a) {
            for (var b = 0, c = []; ; ) {
              var d;
              if ((255 === a[b]) & (218 === a[b + 1])) break;
              if ((255 === a[b]) & (216 === a[b + 1])) b += 2;
              else {
                d = 256 * a[b + 2] + a[b + 3];
                var e = b + d + 2,
                  f = a.slice(b, e);
                c.push(f), (b = e);
              }
              if (b > a.length) break;
            }
            return c;
          },
        },
        {
          key: "decode64",
          value: function (a) {
            var b = void 0,
              c = void 0,
              d = "",
              e = void 0,
              f = void 0,
              g = void 0,
              h = "",
              i = 0,
              j = [],
              k = /[^A-Za-z0-9\+\/\=]/g;
            for (
              k.exec(a) &&
                console.warn(
                  "There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding."
                ),
                a = a.replace(/[^A-Za-z0-9\+\/\=]/g, "");
              ;

            )
              if (
                ((e = this.KEY_STR.indexOf(a.charAt(i++))),
                (f = this.KEY_STR.indexOf(a.charAt(i++))),
                (g = this.KEY_STR.indexOf(a.charAt(i++))),
                (h = this.KEY_STR.indexOf(a.charAt(i++))),
                (b = (e << 2) | (f >> 4)),
                (c = ((15 & f) << 4) | (g >> 2)),
                (d = ((3 & g) << 6) | h),
                j.push(b),
                64 !== g && j.push(c),
                64 !== h && j.push(d),
                (b = c = d = ""),
                (e = f = g = h = ""),
                !(i < a.length))
              )
                break;
            return j;
          },
        },
      ]),
      a
    );
  })();
ExifRestore.initClass();
var contentLoaded = function (a, b) {
  var c = !1,
    d = !0,
    e = a.document,
    f = e.documentElement,
    g = e.addEventListener ? "addEventListener" : "attachEvent",
    h = e.addEventListener ? "removeEventListener" : "detachEvent",
    i = e.addEventListener ? "" : "on",
    j = function d(f) {
      if ("readystatechange" !== f.type || "complete" === e.readyState)
        return (
          ("load" === f.type ? a : e)[h](i + f.type, d, !1),
          !c && (c = !0) ? b.call(a, f.type || f) : void 0
        );
    };
  if ("complete" !== e.readyState) {
    if (e.createEventObject && f.doScroll) {
      try {
        d = !a.frameElement;
      } catch (a) {}
      d &&
        (function a() {
          try {
            f.doScroll("left");
          } catch (b) {
            return void setTimeout(a, 50);
          }
          return j("poll");
        })();
    }
    return (
      e[g](i + "DOMContentLoaded", j, !1),
      e[g](i + "readystatechange", j, !1),
      a[g](i + "load", j, !1)
    );
  }
};
(Dropzone._autoDiscoverFunction = function () {
  if (Dropzone.autoDiscover) return Dropzone.discover();
}),
  contentLoaded(window, Dropzone._autoDiscoverFunction);
/*!
 * Datepicker v0.6.5
 * https://github.com/fengyuanchen/datepicker
 *
 * Copyright (c) 2014-2018 Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2018-03-31T06:17:11.587Z
 */
!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? t(require("jquery"))
    : "function" == typeof define && define.amd
    ? define(["jquery"], t)
    : t(e.jQuery);
})(this, function (D) {
  "use strict";
  D = D && D.hasOwnProperty("default") ? D.default : D;
  var a = {
      autoShow: !1,
      autoHide: !1,
      autoPick: !1,
      inline: !1,
      container: null,
      trigger: null,
      language: "",
      format: "mm/dd/yyyy",
      date: null,
      startDate: null,
      endDate: null,
      startView: 0,
      weekStart: 0,
      yearFirst: !1,
      yearSuffix: "",
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      monthsShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      itemTag: "li",
      mutedClass: "muted",
      pickedClass: "picked",
      disabledClass: "disabled",
      highlightedClass: "highlighted",
      template:
        '<div class="datepicker-container"><div class="datepicker-panel" data-view="years picker"><ul><li data-view="years prev">&lsaquo;</li><li data-view="years current"></li><li data-view="years next">&rsaquo;</li></ul><ul data-view="years"></ul></div><div class="datepicker-panel" data-view="months picker"><ul><li data-view="year prev">&lsaquo;</li><li data-view="year current"></li><li data-view="year next">&rsaquo;</li></ul><ul data-view="months"></ul></div><div class="datepicker-panel" data-view="days picker"><ul><li data-view="month prev">&lsaquo;</li><li data-view="month current"></li><li data-view="month next">&rsaquo;</li></ul><ul data-view="week"></ul><ul data-view="days"></ul></div></div>',
      offset: 10,
      zIndex: 1e3,
      filter: null,
      show: null,
      hide: null,
      pick: null,
    },
    e = "undefined" != typeof window ? window : {},
    d = "datepicker",
    s = "click." + d,
    n = "focus." + d,
    r = "hide." + d,
    h = "keyup." + d,
    o = "pick." + d,
    t = "resize." + d,
    l = "show." + d,
    u = d + "-hide",
    c = {},
    p = 0,
    f = 1,
    g = 2,
    i = Object.prototype.toString;
  function y(e) {
    return "string" == typeof e;
  }
  var v = Number.isNaN || e.isNaN;
  function m(e) {
    return "number" == typeof e && !v(e);
  }
  function w(e) {
    return void 0 === e;
  }
  function k(e) {
    return "date" === ((t = e), i.call(t).slice(8, -1).toLowerCase());
    var t;
  }
  function b(a, s) {
    for (
      var e = arguments.length, n = Array(2 < e ? e - 2 : 0), t = 2;
      t < e;
      t++
    )
      n[t - 2] = arguments[t];
    return function () {
      for (var e = arguments.length, t = Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      return a.apply(s, n.concat(t));
    };
  }
  function C(e) {
    return '[data-view="' + e + '"]';
  }
  function G(e, t) {
    return [
      31,
      ((i = e), (i % 4 == 0 && i % 100 != 0) || i % 400 == 0 ? 29 : 28),
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ][t];
    var i;
  }
  function $(e, t, i) {
    return Math.min(i, G(e, t));
  }
  var x = /(y|m|d)+/g;
  var F = /\d+/g,
    M = {
      show: function () {
        this.built || this.build(),
          this.shown ||
            this.trigger(l).isDefaultPrevented() ||
            ((this.shown = !0),
            this.$picker.removeClass(u).on(s, D.proxy(this.click, this)),
            this.showView(this.options.startView),
            this.inline ||
              (D(window).on(t, (this.onResize = b(this.place, this))),
              D(document).on(
                s,
                (this.onGlobalClick = b(this.globalClick, this))
              ),
              D(document).on(
                h,
                (this.onGlobalKeyup = b(this.globalKeyup, this))
              ),
              this.place()));
      },
      hide: function () {
        this.shown &&
          (this.trigger(r).isDefaultPrevented() ||
            ((this.shown = !1),
            this.$picker.addClass(u).off(s, this.click),
            this.inline ||
              (D(window).off(t, this.onResize),
              D(document).off(s, this.onGlobalClick),
              D(document).off(h, this.onGlobalKeyup))));
      },
      toggle: function () {
        this.shown ? this.hide() : this.show();
      },
      update: function () {
        var e = this.getValue();
        e !== this.oldValue && (this.setDate(e, !0), (this.oldValue = e));
      },
      pick: function (e) {
        var t = this.$element,
          i = this.date;
        this.trigger(o, { view: e || "", date: i }).isDefaultPrevented() ||
          ((i = this.formatDate(this.date)),
          this.setValue(i),
          this.isInput && (t.trigger("input"), t.trigger("change")));
      },
      reset: function () {
        this.setDate(this.initialDate, !0),
          this.setValue(this.initialValue),
          this.shown && this.showView(this.options.startView);
      },
      getMonthName: function (e, t) {
        var i = this.options,
          a = i.monthsShort,
          s = i.months;
        return (
          D.isNumeric(e) ? (e = Number(e)) : w(t) && (t = e),
          !0 === t && (s = a),
          s[m(e) ? e : this.date.getMonth()]
        );
      },
      getDayName: function (e, t, i) {
        var a = this.options,
          s = a.days;
        return (
          D.isNumeric(e) ? (e = Number(e)) : (w(i) && (i = t), w(t) && (t = e)),
          i ? (s = a.daysMin) : t && (s = a.daysShort),
          s[m(e) ? e : this.date.getDay()]
        );
      },
      getDate: function (e) {
        var t = this.date;
        return e ? this.formatDate(t) : new Date(t);
      },
      setDate: function (e, t) {
        var i = this.options.filter;
        if (k(e) || y(e)) {
          if (
            ((e = this.parseDate(e)),
            D.isFunction(i) && !1 === i.call(this.$element, e))
          )
            return;
          (this.date = e),
            (this.viewDate = new Date(e)),
            t || this.pick(),
            this.built && this.render();
        }
      },
      setStartDate: function (e) {
        (k(e) || y(e)) &&
          ((this.startDate = this.parseDate(e)), this.built && this.render());
      },
      setEndDate: function (e) {
        (k(e) || y(e)) &&
          ((this.endDate = this.parseDate(e)), this.built && this.render());
      },
      parseDate: function (e) {
        var a = this.format,
          t = [];
        if (k(e)) return new Date(e.getFullYear(), e.getMonth(), e.getDate());
        y(e) && (t = e.match(F) || []), (e = new Date());
        var i = a.parts.length,
          s = e.getFullYear(),
          n = e.getDate(),
          r = e.getMonth();
        return (
          t.length === i &&
            D.each(t, function (e, t) {
              var i = parseInt(t, 10) || 1;
              switch (a.parts[e]) {
                case "dd":
                case "d":
                  n = i;
                  break;
                case "mm":
                case "m":
                  r = i - 1;
                  break;
                case "yy":
                  s = 2e3 + i;
                  break;
                case "yyyy":
                  s = i;
              }
            }),
          new Date(s, r, n)
        );
      },
      formatDate: function (e) {
        var t = this.format,
          i = "";
        if (k(e)) {
          var a = e.getFullYear(),
            s = {
              d: e.getDate(),
              m: e.getMonth() + 1,
              yy: a.toString().substring(2),
              yyyy: a,
            };
          (s.dd = (s.d < 10 ? "0" : "") + s.d),
            (s.mm = (s.m < 10 ? "0" : "") + s.m),
            (i = t.source),
            D.each(t.parts, function (e, t) {
              i = i.replace(t, s[t]);
            });
        }
        return i;
      },
      destroy: function () {
        this.unbind(), this.unbuild(), this.$element.removeData(d);
      },
    },
    V = {
      click: function (e) {
        var t = D(e.target),
          i = this.options,
          a = this.viewDate,
          s = this.format;
        if (
          (e.stopPropagation(), e.preventDefault(), !t.hasClass("disabled"))
        ) {
          var n = t.data("view"),
            r = a.getFullYear(),
            h = a.getMonth(),
            o = a.getDate();
          switch (n) {
            case "years prev":
            case "years next":
              (r = "years prev" === n ? r - 10 : r + 10),
                (this.viewDate = new Date(r, h, $(r, h, o))),
                this.renderYears();
              break;
            case "year prev":
            case "year next":
              (r = "year prev" === n ? r - 1 : r + 1),
                (this.viewDate = new Date(r, h, $(r, h, o))),
                this.renderMonths();
              break;
            case "year current":
              s.hasYear && this.showView(g);
              break;
            case "year picked":
              s.hasMonth
                ? this.showView(f)
                : (t
                    .addClass(i.pickedClass)
                    .siblings()
                    .removeClass(i.pickedClass),
                  this.hideView()),
                this.pick("year");
              break;
            case "year":
              (r = parseInt(t.text(), 10)),
                (this.date = new Date(r, h, $(r, h, o))),
                s.hasMonth
                  ? ((this.viewDate = new Date(this.date)), this.showView(f))
                  : (t
                      .addClass(i.pickedClass)
                      .siblings()
                      .removeClass(i.pickedClass),
                    this.hideView()),
                this.pick("year");
              break;
            case "month prev":
            case "month next":
              (h = "month prev" === n ? h - 1 : h + 1) < 0
                ? ((r -= 1), (h += 12))
                : 11 < h && ((r += 1), (h -= 12)),
                (this.viewDate = new Date(r, h, $(r, h, o))),
                this.renderDays();
              break;
            case "month current":
              s.hasMonth && this.showView(f);
              break;
            case "month picked":
              s.hasDay
                ? this.showView(p)
                : (t
                    .addClass(i.pickedClass)
                    .siblings()
                    .removeClass(i.pickedClass),
                  this.hideView()),
                this.pick("month");
              break;
            case "month":
              (h = D.inArray(t.text(), i.monthsShort)),
                (this.date = new Date(r, h, $(r, h, o))),
                s.hasDay
                  ? ((this.viewDate = new Date(r, h, $(r, h, o))),
                    this.showView(p))
                  : (t
                      .addClass(i.pickedClass)
                      .siblings()
                      .removeClass(i.pickedClass),
                    this.hideView()),
                this.pick("month");
              break;
            case "day prev":
            case "day next":
            case "day":
              "day prev" === n ? (h -= 1) : "day next" === n && (h += 1),
                (o = parseInt(t.text(), 10)),
                (this.date = new Date(r, h, o)),
                (this.viewDate = new Date(r, h, o)),
                this.renderDays(),
                "day" === n && this.hideView(),
                this.pick("day");
              break;
            case "day picked":
              this.hideView(), this.pick("day");
          }
        }
      },
      globalClick: function (e) {
        for (
          var t = e.target, i = this.element, a = this.$trigger[0], s = !0;
          t !== document;

        ) {
          if (t === a || t === i) {
            s = !1;
            break;
          }
          t = t.parentNode;
        }
        s && this.hide();
      },
      keyup: function () {
        this.update();
      },
      globalKeyup: function (e) {
        var t = e.target,
          i = e.key,
          a = e.keyCode;
        this.isInput &&
          t !== this.element &&
          this.shown &&
          ("Tab" === i || 9 === a) &&
          this.hide();
      },
    },
    Y = {
      render: function () {
        this.renderYears(), this.renderMonths(), this.renderDays();
      },
      renderWeek: function () {
        var i = this,
          a = [],
          e = this.options,
          t = e.weekStart,
          s = e.daysMin;
        (t = parseInt(t, 10) % 7),
          (s = s.slice(t).concat(s.slice(0, t))),
          D.each(s, function (e, t) {
            a.push(i.createItem({ text: t }));
          }),
          this.$week.html(a.join(""));
      },
      renderYears: function () {
        var e = this.options,
          t = this.startDate,
          i = this.endDate,
          a = e.disabledClass,
          s = e.filter,
          n = e.yearSuffix,
          r = this.viewDate.getFullYear(),
          h = new Date().getFullYear(),
          o = this.date.getFullYear(),
          l = [],
          d = !1,
          u = !1,
          c = void 0;
        for (c = -5; c <= 6; c += 1) {
          var p = new Date(r + c, 1, 1),
            f = !1;
          t && ((f = p.getFullYear() < t.getFullYear()), -5 === c && (d = f)),
            !f &&
              i &&
              ((f = p.getFullYear() > i.getFullYear()), 6 === c && (u = f)),
            !f && s && (f = !1 === s.call(this.$element, p));
          var g = r + c === o,
            y = g ? "year picked" : "year";
          l.push(
            this.createItem({
              picked: g,
              disabled: f,
              text: r + c,
              view: f ? "year disabled" : y,
              highlighted: p.getFullYear() === h,
            })
          );
        }
        this.$yearsPrev.toggleClass(a, d),
          this.$yearsNext.toggleClass(a, u),
          this.$yearsCurrent
            .toggleClass(a, !0)
            .html(r + -5 + n + " - " + (r + 6) + n),
          this.$years.html(l.join(""));
      },
      renderMonths: function () {
        var e = this.options,
          t = this.startDate,
          i = this.endDate,
          a = this.viewDate,
          s = e.disabledClass || "",
          n = e.monthsShort,
          r = D.isFunction(e.filter) && e.filter,
          h = a.getFullYear(),
          o = new Date(),
          l = o.getFullYear(),
          d = o.getMonth(),
          u = this.date.getFullYear(),
          c = this.date.getMonth(),
          p = [],
          f = !1,
          g = !1,
          y = void 0;
        for (y = 0; y <= 11; y += 1) {
          var v = new Date(h, y, 1),
            m = !1;
          t &&
            (m =
              (f = v.getFullYear() === t.getFullYear()) &&
              v.getMonth() < t.getMonth()),
            !m &&
              i &&
              (m =
                (g = v.getFullYear() === i.getFullYear()) &&
                v.getMonth() > i.getMonth()),
            !m && r && (m = !1 === r.call(this.$element, v));
          var w = h === u && y === c,
            k = w ? "month picked" : "month";
          p.push(
            this.createItem({
              disabled: m,
              picked: w,
              highlighted: h === l && v.getMonth() === d,
              index: y,
              text: n[y],
              view: m ? "month disabled" : k,
            })
          );
        }
        this.$yearPrev.toggleClass(s, f),
          this.$yearNext.toggleClass(s, g),
          this.$yearCurrent.toggleClass(s, f && g).html(h + e.yearSuffix || ""),
          this.$months.html(p.join(""));
      },
      renderDays: function () {
        var e = this.$element,
          t = this.options,
          i = this.startDate,
          a = this.endDate,
          s = this.viewDate,
          n = this.date,
          r = t.disabledClass,
          h = t.filter,
          o = t.monthsShort,
          l = t.weekStart,
          d = t.yearSuffix,
          u = s.getFullYear(),
          c = s.getMonth(),
          p = new Date(),
          f = p.getFullYear(),
          g = p.getMonth(),
          y = p.getDate(),
          v = n.getFullYear(),
          m = n.getMonth(),
          w = n.getDate(),
          k = void 0,
          D = void 0,
          b = void 0,
          C = [],
          $ = u,
          x = c,
          F = !1;
        0 === c ? (($ -= 1), (x = 11)) : (x -= 1), (k = G($, x));
        var M = new Date(u, c, 1);
        for (
          (b = M.getDay() - (parseInt(l, 10) % 7)) <= 0 && (b += 7),
            i && (F = M.getTime() <= i.getTime()),
            D = k - (b - 1);
          D <= k;
          D += 1
        ) {
          var V = new Date($, x, D),
            Y = !1;
          i && (Y = V.getTime() < i.getTime()),
            !Y && h && (Y = !1 === h.call(e, V)),
            C.push(
              this.createItem({
                disabled: Y,
                highlighted: $ === f && x === g && V.getDate() === y,
                muted: !0,
                picked: $ === v && x === m && D === w,
                text: D,
                view: "day prev",
              })
            );
        }
        var I = [],
          S = u,
          T = c,
          N = !1;
        11 === c ? ((S += 1), (T = 0)) : (T += 1),
          (k = G(u, c)),
          (b = 42 - (C.length + k));
        var P = new Date(u, c, k);
        for (a && (N = P.getTime() >= a.getTime()), D = 1; D <= b; D += 1) {
          var j = new Date(S, T, D),
            q = S === v && T === m && D === w,
            A = !1;
          a && (A = j.getTime() > a.getTime()),
            !A && h && (A = !1 === h.call(e, j)),
            I.push(
              this.createItem({
                disabled: A,
                picked: q,
                highlighted: S === f && T === g && j.getDate() === y,
                muted: !0,
                text: D,
                view: "day next",
              })
            );
        }
        var W = [];
        for (D = 1; D <= k; D += 1) {
          var z = new Date(u, c, D),
            J = !1;
          i && (J = z.getTime() < i.getTime()),
            !J && a && (J = z.getTime() > a.getTime()),
            !J && h && (J = !1 === h.call(e, z));
          var O = u === v && c === m && D === w,
            E = O ? "day picked" : "day";
          W.push(
            this.createItem({
              disabled: J,
              picked: O,
              highlighted: u === f && c === g && z.getDate() === y,
              text: D,
              view: J ? "day disabled" : E,
            })
          );
        }
        this.$monthPrev.toggleClass(r, F),
          this.$monthNext.toggleClass(r, N),
          this.$monthCurrent
            .toggleClass(r, F && N)
            .html(t.yearFirst ? u + d + " " + o[c] : o[c] + " " + u + d),
          this.$days.html(C.join("") + W.join("") + I.join(""));
      },
    },
    I = (function () {
      function a(e, t) {
        for (var i = 0; i < t.length; i++) {
          var a = t[i];
          (a.enumerable = a.enumerable || !1),
            (a.configurable = !0),
            "value" in a && (a.writable = !0),
            Object.defineProperty(e, a.key, a);
        }
      }
      return function (e, t, i) {
        return t && a(e.prototype, t), i && a(e, i), e;
      };
    })();
  var S = d + "-top-left",
    T = d + "-bottom-left",
    N = [S, d + "-top-right", T, d + "-bottom-right"].join(" "),
    P = (function () {
      function i(e) {
        var t =
          1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
        !(function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, i),
          (this.$element = D(e)),
          (this.element = e),
          (this.options = D.extend({}, a, c[t.language], t)),
          (this.built = !1),
          (this.shown = !1),
          (this.isInput = !1),
          (this.inline = !1),
          (this.initialValue = ""),
          (this.initialDate = null),
          (this.startDate = null),
          (this.endDate = null),
          this.init();
      }
      return (
        I(
          i,
          [
            {
              key: "init",
              value: function () {
                var e = this.$element,
                  t = this.options,
                  i = t.startDate,
                  a = t.endDate,
                  s = t.date;
                (this.$trigger = D(t.trigger)),
                  (this.isInput = e.is("input") || e.is("textarea")),
                  (this.inline = t.inline && (t.container || !this.isInput)),
                  (this.format = (function (i) {
                    var e = String(i).toLowerCase(),
                      t = e.match(x);
                    if (!t || 0 === t.length)
                      throw new Error("Invalid date format.");
                    return (
                      (i = { source: e, parts: t }),
                      D.each(t, function (e, t) {
                        switch (t) {
                          case "dd":
                          case "d":
                            i.hasDay = !0;
                            break;
                          case "mm":
                          case "m":
                            i.hasMonth = !0;
                            break;
                          case "yyyy":
                          case "yy":
                            i.hasYear = !0;
                        }
                      }),
                      i
                    );
                  })(t.format));
                var n = this.getValue();
                (this.initialValue = n),
                  (this.oldValue = n),
                  (s = this.parseDate(s || n)),
                  i &&
                    ((i = this.parseDate(i)),
                    s.getTime() < i.getTime() && (s = new Date(i)),
                    (this.startDate = i)),
                  a &&
                    ((a = this.parseDate(a)),
                    i && a.getTime() < i.getTime() && (a = new Date(i)),
                    s.getTime() > a.getTime() && (s = new Date(a)),
                    (this.endDate = a)),
                  (this.date = s),
                  (this.viewDate = new Date(s)),
                  (this.initialDate = new Date(this.date)),
                  this.bind(),
                  (t.autoShow || this.inline) && this.show(),
                  t.autoPick && this.pick();
              },
            },
            {
              key: "build",
              value: function () {
                if (!this.built) {
                  this.built = !0;
                  var e = this.$element,
                    t = this.options,
                    i = D(t.template);
                  (this.$picker = i),
                    (this.$week = i.find(C("week"))),
                    (this.$yearsPicker = i.find(C("years picker"))),
                    (this.$yearsPrev = i.find(C("years prev"))),
                    (this.$yearsNext = i.find(C("years next"))),
                    (this.$yearsCurrent = i.find(C("years current"))),
                    (this.$years = i.find(C("years"))),
                    (this.$monthsPicker = i.find(C("months picker"))),
                    (this.$yearPrev = i.find(C("year prev"))),
                    (this.$yearNext = i.find(C("year next"))),
                    (this.$yearCurrent = i.find(C("year current"))),
                    (this.$months = i.find(C("months"))),
                    (this.$daysPicker = i.find(C("days picker"))),
                    (this.$monthPrev = i.find(C("month prev"))),
                    (this.$monthNext = i.find(C("month next"))),
                    (this.$monthCurrent = i.find(C("month current"))),
                    (this.$days = i.find(C("days"))),
                    this.inline
                      ? D(t.container || e).append(i.addClass(d + "-inline"))
                      : (D(document.body).append(i.addClass(d + "-dropdown")),
                        i.addClass(u)),
                    this.renderWeek();
                }
              },
            },
            {
              key: "unbuild",
              value: function () {
                this.built && ((this.built = !1), this.$picker.remove());
              },
            },
            {
              key: "bind",
              value: function () {
                var e = this.options,
                  t = this.$element;
                D.isFunction(e.show) && t.on(l, e.show),
                  D.isFunction(e.hide) && t.on(r, e.hide),
                  D.isFunction(e.pick) && t.on(o, e.pick),
                  this.isInput && t.on(h, D.proxy(this.keyup, this)),
                  this.inline ||
                    (e.trigger
                      ? this.$trigger.on(s, D.proxy(this.toggle, this))
                      : this.isInput
                      ? t.on(n, D.proxy(this.show, this))
                      : t.on(s, D.proxy(this.show, this)));
              },
            },
            {
              key: "unbind",
              value: function () {
                var e = this.$element,
                  t = this.options;
                D.isFunction(t.show) && e.off(l, t.show),
                  D.isFunction(t.hide) && e.off(r, t.hide),
                  D.isFunction(t.pick) && e.off(o, t.pick),
                  this.isInput && e.off(h, this.keyup),
                  this.inline ||
                    (t.trigger
                      ? this.$trigger.off(s, this.toggle)
                      : this.isInput
                      ? e.off(n, this.show)
                      : e.off(s, this.show));
              },
            },
            {
              key: "showView",
              value: function (e) {
                var t = this.$yearsPicker,
                  i = this.$monthsPicker,
                  a = this.$daysPicker,
                  s = this.format;
                if (s.hasYear || s.hasMonth || s.hasDay)
                  switch (Number(e)) {
                    case g:
                      i.addClass(u),
                        a.addClass(u),
                        s.hasYear
                          ? (this.renderYears(), t.removeClass(u), this.place())
                          : this.showView(p);
                      break;
                    case f:
                      t.addClass(u),
                        a.addClass(u),
                        s.hasMonth
                          ? (this.renderMonths(),
                            i.removeClass(u),
                            this.place())
                          : this.showView(g);
                      break;
                    default:
                      t.addClass(u),
                        i.addClass(u),
                        s.hasDay
                          ? (this.renderDays(), a.removeClass(u), this.place())
                          : this.showView(f);
                  }
              },
            },
            {
              key: "hideView",
              value: function () {
                !this.inline && this.options.autoHide && this.hide();
              },
            },
            {
              key: "place",
              value: function () {
                if (!this.inline) {
                  var e = this.$element,
                    t = this.options,
                    i = this.$picker,
                    a = D(document).outerWidth(),
                    s = D(document).outerHeight(),
                    n = e.outerWidth(),
                    r = e.outerHeight(),
                    h = i.width(),
                    o = i.height(),
                    l = e.offset(),
                    d = l.left,
                    u = l.top,
                    c = parseFloat(t.offset),
                    p = S;
                  v(c) && (c = 10),
                    o < u && s < u + r + o
                      ? ((u -= o + c), (p = T))
                      : (u += r + c),
                    a < d + h &&
                      ((d += n - h), (p = p.replace("left", "right"))),
                    i
                      .removeClass(N)
                      .addClass(p)
                      .css({ top: u, left: d, zIndex: parseInt(t.zIndex, 10) });
                }
              },
            },
            {
              key: "trigger",
              value: function (e, t) {
                var i = D.Event(e, t);
                return this.$element.trigger(i), i;
              },
            },
            {
              key: "createItem",
              value: function (e) {
                var t = this.options,
                  i = t.itemTag,
                  a = {
                    text: "",
                    view: "",
                    muted: !1,
                    picked: !1,
                    disabled: !1,
                    highlighted: !1,
                  },
                  s = [];
                return (
                  D.extend(a, e),
                  a.muted && s.push(t.mutedClass),
                  a.highlighted && s.push(t.highlightedClass),
                  a.picked && s.push(t.pickedClass),
                  a.disabled && s.push(t.disabledClass),
                  "<" +
                    i +
                    ' class="' +
                    s.join(" ") +
                    '" data-view="' +
                    a.view +
                    '">' +
                    a.text +
                    "</" +
                    i +
                    ">"
                );
              },
            },
            {
              key: "getValue",
              value: function () {
                var e = this.$element;
                return this.isInput ? e.val() : e.text();
              },
            },
            {
              key: "setValue",
              value: function () {
                var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : "",
                  t = this.$element;
                this.isInput ? t.val(e) : t.text(e);
              },
            },
          ],
          [
            {
              key: "setDefaults",
              value: function () {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : {};
                D.extend(a, c[e.language], e);
              },
            },
          ]
        ),
        i
      );
    })();
  if ((D.extend && D.extend(P.prototype, Y, V, M), D.fn)) {
    var j = D.fn.datepicker;
    (D.fn.datepicker = function (h) {
      for (
        var e = arguments.length, o = Array(1 < e ? e - 1 : 0), t = 1;
        t < e;
        t++
      )
        o[t - 1] = arguments[t];
      var l = void 0;
      return (
        this.each(function (e, t) {
          var i = D(t),
            a = "destroy" === h,
            s = i.data(d);
          if (!s) {
            if (a) return;
            var n = D.extend({}, i.data(), D.isPlainObject(h) && h);
            (s = new P(t, n)), i.data(d, s);
          }
          if (y(h)) {
            var r = s[h];
            D.isFunction(r) && ((l = r.apply(s, o)), a && i.removeData(d));
          }
        }),
        w(l) ? this : l
      );
    }),
      (D.fn.datepicker.Constructor = P),
      (D.fn.datepicker.languages = c),
      (D.fn.datepicker.setDefaults = P.setDefaults),
      (D.fn.datepicker.noConflict = function () {
        return (D.fn.datepicker = j), this;
      });
  }
});
/*
 * iziToast | v1.4.0
 * http://izitoast.marcelodolce.com
 * by Marcelo Dolce.
 */
!(function (t, e) {
  "function" == typeof define && define.amd
    ? define([], e(t))
    : "object" == typeof exports
    ? (module.exports = e(t))
    : (t.iziToast = e(t));
})(
  "undefined" != typeof global ? global : window || this.window || this.global,
  function (t) {
    "use strict";
    var e = {},
      n = "iziToast",
      o = (document.querySelector("body"), !!/Mobi/.test(navigator.userAgent)),
      i =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor),
      s = "undefined" != typeof InstallTrigger,
      a = "ontouchstart" in document.documentElement,
      r = [
        "bottomRight",
        "bottomLeft",
        "bottomCenter",
        "topRight",
        "topLeft",
        "topCenter",
        "center",
      ],
      l = {
        info: { color: "blue", icon: "ico-info" },
        success: { color: "green", icon: "ico-success" },
        warning: { color: "orange", icon: "ico-warning" },
        error: { color: "red", icon: "ico-error" },
        question: { color: "yellow", icon: "ico-question" },
      },
      d = 568,
      c = {};
    e.children = {};
    var u = {
      id: null,
      class: "",
      title: "",
      titleColor: "",
      titleSize: "",
      titleLineHeight: "",
      message: "",
      messageColor: "",
      messageSize: "",
      messageLineHeight: "",
      backgroundColor: "",
      theme: "light",
      color: "",
      icon: "",
      iconText: "",
      iconColor: "",
      iconUrl: null,
      image: "",
      imageWidth: 50,
      maxWidth: null,
      zindex: null,
      layout: 1,
      balloon: !1,
      close: !0,
      closeOnEscape: !1,
      closeOnClick: !1,
      displayMode: 0,
      position: "bottomRight",
      target: "",
      targetFirst: !0,
      timeout: 5e3,
      rtl: !1,
      animateInside: !0,
      drag: !0,
      pauseOnHover: !0,
      resetOnHover: !1,
      progressBar: !0,
      progressBarColor: "",
      progressBarEasing: "linear",
      overlay: !1,
      overlayClose: !1,
      overlayColor: "rgba(0, 0, 0, 0.6)",
      transitionIn: "fadeInUp",
      transitionOut: "fadeOut",
      transitionInMobile: "fadeInUp",
      transitionOutMobile: "fadeOutDown",
      buttons: {},
      inputs: {},
      onOpening: function () {},
      onOpened: function () {},
      onClosing: function () {},
      onClosed: function () {},
    };
    if (
      ("remove" in Element.prototype ||
        (Element.prototype.remove = function () {
          this.parentNode && this.parentNode.removeChild(this);
        }),
      "function" != typeof window.CustomEvent)
    ) {
      var p = function (t, e) {
        e = e || { bubbles: !1, cancelable: !1, detail: void 0 };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(t, e.bubbles, e.cancelable, e.detail), n;
      };
      (p.prototype = window.Event.prototype), (window.CustomEvent = p);
    }
    var m = function (t, e, n) {
        if ("[object Object]" === Object.prototype.toString.call(t))
          for (var o in t)
            Object.prototype.hasOwnProperty.call(t, o) && e.call(n, t[o], o, t);
        else if (t)
          for (var i = 0, s = t.length; s > i; i++) e.call(n, t[i], i, t);
      },
      g = function (t, e) {
        var n = {};
        return (
          m(t, function (e, o) {
            n[o] = t[o];
          }),
          m(e, function (t, o) {
            n[o] = e[o];
          }),
          n
        );
      },
      f = function (t) {
        var e = document.createDocumentFragment(),
          n = document.createElement("div");
        for (n.innerHTML = t; n.firstChild; ) e.appendChild(n.firstChild);
        return e;
      },
      v = function (t) {
        var e = btoa(encodeURIComponent(t));
        return e.replace(/=/g, "");
      },
      y = function (t) {
        return (
          "#" == t.substring(0, 1) ||
          "rgb" == t.substring(0, 3) ||
          "hsl" == t.substring(0, 3)
        );
      },
      h = function (t) {
        try {
          return btoa(atob(t)) == t;
        } catch (e) {
          return !1;
        }
      },
      b = (function () {
        return {
          move: function (t, e, o, a) {
            var r,
              l = 0.3,
              d = 180;
            0 !== a &&
              (t.classList.add(n + "-dragged"),
              (t.style.transform = "translateX(" + a + "px)"),
              a > 0
                ? ((r = (d - a) / d),
                  l > r &&
                    e.hide(
                      g(o, {
                        transitionOut: "fadeOutRight",
                        transitionOutMobile: "fadeOutRight",
                      }),
                      t,
                      "drag"
                    ))
                : ((r = (d + a) / d),
                  l > r &&
                    e.hide(
                      g(o, {
                        transitionOut: "fadeOutLeft",
                        transitionOutMobile: "fadeOutLeft",
                      }),
                      t,
                      "drag"
                    )),
              (t.style.opacity = r),
              l > r &&
                ((i || s) && (t.style.left = a + "px"),
                (t.parentNode.style.opacity = l),
                this.stopMoving(t, null)));
          },
          startMoving: function (t, e, n, o) {
            o = o || window.event;
            var i = a ? o.touches[0].clientX : o.clientX,
              s = t.style.transform.replace("px)", "");
            s = s.replace("translateX(", "");
            var r = i - s;
            n.transitionIn && t.classList.remove(n.transitionIn),
              n.transitionInMobile && t.classList.remove(n.transitionInMobile),
              (t.style.transition = ""),
              a
                ? (document.ontouchmove = function (o) {
                    o.preventDefault(), (o = o || window.event);
                    var i = o.touches[0].clientX,
                      s = i - r;
                    b.move(t, e, n, s);
                  })
                : (document.onmousemove = function (o) {
                    o.preventDefault(), (o = o || window.event);
                    var i = o.clientX,
                      s = i - r;
                    b.move(t, e, n, s);
                  });
          },
          stopMoving: function (t, e) {
            a
              ? (document.ontouchmove = function () {})
              : (document.onmousemove = function () {}),
              (t.style.opacity = ""),
              (t.style.transform = ""),
              t.classList.contains(n + "-dragged") &&
                (t.classList.remove(n + "-dragged"),
                (t.style.transition = "transform 0.4s ease, opacity 0.4s ease"),
                setTimeout(function () {
                  t.style.transition = "";
                }, 400));
          },
        };
      })();
    return (
      (e.setSetting = function (t, n, o) {
        e.children[t][n] = o;
      }),
      (e.getSetting = function (t, n) {
        return e.children[t][n];
      }),
      (e.destroy = function () {
        m(document.querySelectorAll("." + n + "-overlay"), function (t, e) {
          t.remove();
        }),
          m(document.querySelectorAll("." + n + "-wrapper"), function (t, e) {
            t.remove();
          }),
          m(document.querySelectorAll("." + n), function (t, e) {
            t.remove();
          }),
          (this.children = {}),
          document.removeEventListener(n + "-opened", {}, !1),
          document.removeEventListener(n + "-opening", {}, !1),
          document.removeEventListener(n + "-closing", {}, !1),
          document.removeEventListener(n + "-closed", {}, !1),
          document.removeEventListener("keyup", {}, !1),
          (c = {});
      }),
      (e.settings = function (t) {
        e.destroy(), (c = t), (u = g(u, t || {}));
      }),
      m(l, function (t, n) {
        e[n] = function (e) {
          var n = g(c, e || {});
          (n = g(t, n || {})), this.show(n);
        };
      }),
      (e.progress = function (t, e, o) {
        var i = this,
          s = e.getAttribute("data-iziToast-ref"),
          a = g(this.children[s], t || {}),
          r = e.querySelector("." + n + "-progressbar div");
        return {
          start: function () {
            "undefined" == typeof a.time.REMAINING &&
              (e.classList.remove(n + "-reseted"),
              null !== r &&
                ((r.style.transition =
                  "width " + a.timeout + "ms " + a.progressBarEasing),
                (r.style.width = "0%")),
              (a.time.START = new Date().getTime()),
              (a.time.END = a.time.START + a.timeout),
              (a.time.TIMER = setTimeout(function () {
                clearTimeout(a.time.TIMER),
                  e.classList.contains(n + "-closing") ||
                    (i.hide(a, e, "timeout"),
                    "function" == typeof o && o.apply(i));
              }, a.timeout)),
              i.setSetting(s, "time", a.time));
          },
          pause: function () {
            if (
              "undefined" != typeof a.time.START &&
              !e.classList.contains(n + "-paused") &&
              !e.classList.contains(n + "-reseted")
            ) {
              if (
                (e.classList.add(n + "-paused"),
                (a.time.REMAINING = a.time.END - new Date().getTime()),
                clearTimeout(a.time.TIMER),
                i.setSetting(s, "time", a.time),
                null !== r)
              ) {
                var t = window.getComputedStyle(r),
                  l = t.getPropertyValue("width");
                (r.style.transition = "none"), (r.style.width = l);
              }
              "function" == typeof o &&
                setTimeout(function () {
                  o.apply(i);
                }, 10);
            }
          },
          resume: function () {
            "undefined" != typeof a.time.REMAINING
              ? (e.classList.remove(n + "-paused"),
                null !== r &&
                  ((r.style.transition =
                    "width " + a.time.REMAINING + "ms " + a.progressBarEasing),
                  (r.style.width = "0%")),
                (a.time.END = new Date().getTime() + a.time.REMAINING),
                (a.time.TIMER = setTimeout(function () {
                  clearTimeout(a.time.TIMER),
                    e.classList.contains(n + "-closing") ||
                      (i.hide(a, e, "timeout"),
                      "function" == typeof o && o.apply(i));
                }, a.time.REMAINING)),
                i.setSetting(s, "time", a.time))
              : this.start();
          },
          reset: function () {
            clearTimeout(a.time.TIMER),
              delete a.time.REMAINING,
              i.setSetting(s, "time", a.time),
              e.classList.add(n + "-reseted"),
              e.classList.remove(n + "-paused"),
              null !== r &&
                ((r.style.transition = "none"), (r.style.width = "100%")),
              "function" == typeof o &&
                setTimeout(function () {
                  o.apply(i);
                }, 10);
          },
        };
      }),
      (e.hide = function (t, e, i) {
        "object" != typeof e && (e = document.querySelector(e));
        var s = this,
          a = g(this.children[e.getAttribute("data-iziToast-ref")], t || {});
        (a.closedBy = i || null),
          delete a.time.REMAINING,
          e.classList.add(n + "-closing"),
          (function () {
            var t = document.querySelector("." + n + "-overlay");
            if (null !== t) {
              var e = t.getAttribute("data-iziToast-ref");
              e = e.split(",");
              var o = e.indexOf(String(a.ref));
              -1 !== o && e.splice(o, 1),
                t.setAttribute("data-iziToast-ref", e.join()),
                0 === e.length &&
                  (t.classList.remove("fadeIn"),
                  t.classList.add("fadeOut"),
                  setTimeout(function () {
                    t.remove();
                  }, 700));
            }
          })(),
          a.transitionIn && e.classList.remove(a.transitionIn),
          a.transitionInMobile && e.classList.remove(a.transitionInMobile),
          o || window.innerWidth <= d
            ? a.transitionOutMobile && e.classList.add(a.transitionOutMobile)
            : a.transitionOut && e.classList.add(a.transitionOut);
        var r = e.parentNode.offsetHeight;
        (e.parentNode.style.height = r + "px"),
          (e.style.pointerEvents = "none"),
          (!o || window.innerWidth > d) &&
            (e.parentNode.style.transitionDelay = "0.2s");
        try {
          var l = new CustomEvent(n + "-closing", {
            detail: a,
            bubbles: !0,
            cancelable: !0,
          });
          document.dispatchEvent(l);
        } catch (c) {
          console.warn(c);
        }
        setTimeout(function () {
          (e.parentNode.style.height = "0px"),
            (e.parentNode.style.overflow = ""),
            setTimeout(function () {
              delete s.children[a.ref], e.parentNode.remove();
              try {
                var t = new CustomEvent(n + "-closed", {
                  detail: a,
                  bubbles: !0,
                  cancelable: !0,
                });
                document.dispatchEvent(t);
              } catch (o) {
                console.warn(o);
              }
              "undefined" != typeof a.onClosed &&
                a.onClosed.apply(null, [a, e, i]);
            }, 1e3);
        }, 200),
          "undefined" != typeof a.onClosing &&
            a.onClosing.apply(null, [a, e, i]);
      }),
      (e.show = function (t) {
        var i = this,
          s = g(c, t || {});
        if (
          ((s = g(u, s)),
          (s.time = {}),
          null === s.id && (s.id = v(s.title + s.message + s.color)),
          1 === s.displayMode || "once" == s.displayMode)
        )
          try {
            if (document.querySelectorAll("." + n + "#" + s.id).length > 0)
              return !1;
          } catch (l) {
            console.warn(
              "[" +
                n +
                "] Could not find an element with this selector: #" +
                s.id +
                ". Try to set an valid id."
            );
          }
        if (2 === s.displayMode || "replace" == s.displayMode)
          try {
            m(document.querySelectorAll("." + n + "#" + s.id), function (t, e) {
              i.hide(s, t, "replaced");
            });
          } catch (l) {
            console.warn(
              "[" +
                n +
                "] Could not find an element with this selector: #" +
                s.id +
                ". Try to set an valid id."
            );
          }
        (s.ref = new Date().getTime() + Math.floor(1e7 * Math.random() + 1)),
          (e.children[s.ref] = s);
        var p = {
          body: document.querySelector("body"),
          overlay: document.createElement("div"),
          toast: document.createElement("div"),
          toastBody: document.createElement("div"),
          toastTexts: document.createElement("div"),
          toastCapsule: document.createElement("div"),
          cover: document.createElement("div"),
          buttons: document.createElement("div"),
          inputs: document.createElement("div"),
          icon: s.iconUrl
            ? document.createElement("img")
            : document.createElement("i"),
          wrapper: null,
        };
        p.toast.setAttribute("data-iziToast-ref", s.ref),
          p.toast.appendChild(p.toastBody),
          p.toastCapsule.appendChild(p.toast),
          (function () {
            if (
              (p.toast.classList.add(n),
              p.toast.classList.add(n + "-opening"),
              p.toastCapsule.classList.add(n + "-capsule"),
              p.toastBody.classList.add(n + "-body"),
              p.toastTexts.classList.add(n + "-texts"),
              o || window.innerWidth <= d
                ? s.transitionInMobile &&
                  p.toast.classList.add(s.transitionInMobile)
                : s.transitionIn && p.toast.classList.add(s.transitionIn),
              s["class"])
            ) {
              var t = s["class"].split(" ");
              m(t, function (t, e) {
                p.toast.classList.add(t);
              });
            }
            s.id && (p.toast.id = s.id),
              s.rtl &&
                (p.toast.classList.add(n + "-rtl"),
                p.toast.setAttribute("dir", "rtl")),
              s.layout > 1 && p.toast.classList.add(n + "-layout" + s.layout),
              s.balloon && p.toast.classList.add(n + "-balloon"),
              s.maxWidth &&
                (isNaN(s.maxWidth)
                  ? (p.toast.style.maxWidth = s.maxWidth)
                  : (p.toast.style.maxWidth = s.maxWidth + "px")),
              ("" === s.theme && "light" === s.theme) ||
                p.toast.classList.add(n + "-theme-" + s.theme),
              s.color &&
                (y(s.color)
                  ? (p.toast.style.background = s.color)
                  : p.toast.classList.add(n + "-color-" + s.color)),
              s.backgroundColor &&
                ((p.toast.style.background = s.backgroundColor),
                s.balloon && (p.toast.style.borderColor = s.backgroundColor));
          })(),
          (function () {
            s.image &&
              (p.cover.classList.add(n + "-cover"),
              (p.cover.style.width = s.imageWidth + "px"),
              h(s.image.replace(/ /g, ""))
                ? (p.cover.style.backgroundImage =
                    "url(data:image/png;base64," +
                    s.image.replace(/ /g, "") +
                    ")")
                : (p.cover.style.backgroundImage = "url(" + s.image + ")"),
              s.rtl
                ? (p.toastBody.style.marginRight = s.imageWidth + 10 + "px")
                : (p.toastBody.style.marginLeft = s.imageWidth + 10 + "px"),
              p.toast.appendChild(p.cover));
          })(),
          (function () {
            s.close
              ? ((p.buttonClose = document.createElement("button")),
                (p.buttonClose.type = "button"),
                p.buttonClose.classList.add(n + "-close"),
                p.buttonClose.addEventListener("click", function (t) {
                  t.target;
                  i.hide(s, p.toast, "button");
                }),
                p.toast.appendChild(p.buttonClose))
              : s.rtl
              ? (p.toast.style.paddingLeft = "18px")
              : (p.toast.style.paddingRight = "18px");
          })(),
          (function () {
            s.progressBar &&
              ((p.progressBar = document.createElement("div")),
              (p.progressBarDiv = document.createElement("div")),
              p.progressBar.classList.add(n + "-progressbar"),
              (p.progressBarDiv.style.background = s.progressBarColor),
              p.progressBar.appendChild(p.progressBarDiv),
              p.toast.appendChild(p.progressBar)),
              s.timeout &&
                (s.pauseOnHover &&
                  !s.resetOnHover &&
                  (p.toast.addEventListener("mouseenter", function (t) {
                    i.progress(s, p.toast).pause();
                  }),
                  p.toast.addEventListener("mouseleave", function (t) {
                    i.progress(s, p.toast).resume();
                  })),
                s.resetOnHover &&
                  (p.toast.addEventListener("mouseenter", function (t) {
                    i.progress(s, p.toast).reset();
                  }),
                  p.toast.addEventListener("mouseleave", function (t) {
                    i.progress(s, p.toast).start();
                  })));
          })(),
          (function () {
            s.iconUrl
              ? (p.icon.setAttribute("class", n + "-icon"),
                p.icon.setAttribute("src", s.iconUrl))
              : s.icon &&
                (p.icon.setAttribute("class", n + "-icon " + s.icon),
                s.iconText &&
                  p.icon.appendChild(document.createTextNode(s.iconText)),
                s.iconColor && (p.icon.style.color = s.iconColor)),
              (s.icon || s.iconUrl) &&
                (s.rtl
                  ? (p.toastBody.style.paddingRight = "33px")
                  : (p.toastBody.style.paddingLeft = "33px"),
                p.toastBody.appendChild(p.icon));
          })(),
          (function () {
            s.title.length > 0 &&
              ((p.strong = document.createElement("strong")),
              p.strong.classList.add(n + "-title"),
              p.strong.appendChild(f(s.title)),
              p.toastTexts.appendChild(p.strong),
              s.titleColor && (p.strong.style.color = s.titleColor),
              s.titleSize &&
                (isNaN(s.titleSize)
                  ? (p.strong.style.fontSize = s.titleSize)
                  : (p.strong.style.fontSize = s.titleSize + "px")),
              s.titleLineHeight &&
                (isNaN(s.titleSize)
                  ? (p.strong.style.lineHeight = s.titleLineHeight)
                  : (p.strong.style.lineHeight = s.titleLineHeight + "px"))),
              s.message.length > 0 &&
                ((p.p = document.createElement("p")),
                p.p.classList.add(n + "-message"),
                p.p.appendChild(f(s.message)),
                p.toastTexts.appendChild(p.p),
                s.messageColor && (p.p.style.color = s.messageColor),
                s.messageSize &&
                  (isNaN(s.titleSize)
                    ? (p.p.style.fontSize = s.messageSize)
                    : (p.p.style.fontSize = s.messageSize + "px")),
                s.messageLineHeight &&
                  (isNaN(s.titleSize)
                    ? (p.p.style.lineHeight = s.messageLineHeight)
                    : (p.p.style.lineHeight = s.messageLineHeight + "px"))),
              s.title.length > 0 &&
                s.message.length > 0 &&
                (s.rtl
                  ? (p.strong.style.marginLeft = "10px")
                  : 2 === s.layout ||
                    s.rtl ||
                    (p.strong.style.marginRight = "10px"));
          })(),
          p.toastBody.appendChild(p.toastTexts);
        var L;
        !(function () {
          s.inputs.length > 0 &&
            (p.inputs.classList.add(n + "-inputs"),
            m(s.inputs, function (t, e) {
              p.inputs.appendChild(f(t[0])),
                (L = p.inputs.childNodes),
                L[e].classList.add(n + "-inputs-child"),
                t[3] &&
                  setTimeout(function () {
                    L[e].focus();
                  }, 300),
                L[e].addEventListener(t[1], function (e) {
                  var n = t[2];
                  return n(i, p.toast, this, e);
                });
            }),
            p.toastBody.appendChild(p.inputs));
        })(),
          (function () {
            s.buttons.length > 0 &&
              (p.buttons.classList.add(n + "-buttons"),
              m(s.buttons, function (t, e) {
                p.buttons.appendChild(f(t[0]));
                var o = p.buttons.childNodes;
                o[e].classList.add(n + "-buttons-child"),
                  t[2] &&
                    setTimeout(function () {
                      o[e].focus();
                    }, 300),
                  o[e].addEventListener("click", function (e) {
                    e.preventDefault();
                    var n = t[1];
                    return n(i, p.toast, this, e, L);
                  });
              })),
              p.toastBody.appendChild(p.buttons);
          })(),
          s.message.length > 0 &&
            (s.inputs.length > 0 || s.buttons.length > 0) &&
            (p.p.style.marginBottom = "0"),
          (s.inputs.length > 0 || s.buttons.length > 0) &&
            (s.rtl
              ? (p.toastTexts.style.marginLeft = "10px")
              : (p.toastTexts.style.marginRight = "10px"),
            s.inputs.length > 0 &&
              s.buttons.length > 0 &&
              (s.rtl
                ? (p.inputs.style.marginLeft = "8px")
                : (p.inputs.style.marginRight = "8px"))),
          (function () {
            (p.toastCapsule.style.visibility = "hidden"),
              setTimeout(function () {
                var t = p.toast.offsetHeight,
                  e = p.toast.currentStyle || window.getComputedStyle(p.toast),
                  n = e.marginTop;
                (n = n.split("px")), (n = parseInt(n[0]));
                var o = e.marginBottom;
                (o = o.split("px")),
                  (o = parseInt(o[0])),
                  (p.toastCapsule.style.visibility = ""),
                  (p.toastCapsule.style.height = t + o + n + "px"),
                  setTimeout(function () {
                    (p.toastCapsule.style.height = "auto"),
                      s.target && (p.toastCapsule.style.overflow = "visible");
                  }, 500),
                  s.timeout && i.progress(s, p.toast).start();
              }, 100);
          })(),
          (function () {
            var t = s.position;
            if (s.target)
              (p.wrapper = document.querySelector(s.target)),
                p.wrapper.classList.add(n + "-target"),
                s.targetFirst
                  ? p.wrapper.insertBefore(p.toastCapsule, p.wrapper.firstChild)
                  : p.wrapper.appendChild(p.toastCapsule);
            else {
              if (-1 == r.indexOf(s.position))
                return void console.warn(
                  "[" + n + "] Incorrect position.\nIt can be › " + r
                );
              (t =
                o || window.innerWidth <= d
                  ? "bottomLeft" == s.position ||
                    "bottomRight" == s.position ||
                    "bottomCenter" == s.position
                    ? n + "-wrapper-bottomCenter"
                    : "topLeft" == s.position ||
                      "topRight" == s.position ||
                      "topCenter" == s.position
                    ? n + "-wrapper-topCenter"
                    : n + "-wrapper-center"
                  : n + "-wrapper-" + t),
                (p.wrapper = document.querySelector("." + n + "-wrapper." + t)),
                p.wrapper ||
                  ((p.wrapper = document.createElement("div")),
                  p.wrapper.classList.add(n + "-wrapper"),
                  p.wrapper.classList.add(t),
                  document.body.appendChild(p.wrapper)),
                "topLeft" == s.position ||
                "topCenter" == s.position ||
                "topRight" == s.position
                  ? p.wrapper.insertBefore(p.toastCapsule, p.wrapper.firstChild)
                  : p.wrapper.appendChild(p.toastCapsule);
            }
            isNaN(s.zindex)
              ? console.warn("[" + n + "] Invalid zIndex.")
              : (p.wrapper.style.zIndex = s.zindex);
          })(),
          (function () {
            s.overlay &&
              (null !== document.querySelector("." + n + "-overlay.fadeIn")
                ? ((p.overlay = document.querySelector("." + n + "-overlay")),
                  p.overlay.setAttribute(
                    "data-iziToast-ref",
                    p.overlay.getAttribute("data-iziToast-ref") + "," + s.ref
                  ),
                  isNaN(s.zindex) ||
                    null === s.zindex ||
                    (p.overlay.style.zIndex = s.zindex - 1))
                : (p.overlay.classList.add(n + "-overlay"),
                  p.overlay.classList.add("fadeIn"),
                  (p.overlay.style.background = s.overlayColor),
                  p.overlay.setAttribute("data-iziToast-ref", s.ref),
                  isNaN(s.zindex) ||
                    null === s.zindex ||
                    (p.overlay.style.zIndex = s.zindex - 1),
                  document.querySelector("body").appendChild(p.overlay)),
              s.overlayClose
                ? (p.overlay.removeEventListener("click", {}),
                  p.overlay.addEventListener("click", function (t) {
                    i.hide(s, p.toast, "overlay");
                  }))
                : p.overlay.removeEventListener("click", {}));
          })(),
          (function () {
            if (s.animateInside) {
              p.toast.classList.add(n + "-animateInside");
              var t = [200, 100, 300];
              ("bounceInLeft" != s.transitionIn &&
                "bounceInRight" != s.transitionIn) ||
                (t = [400, 200, 400]),
                s.title.length > 0 &&
                  setTimeout(function () {
                    p.strong.classList.add("slideIn");
                  }, t[0]),
                s.message.length > 0 &&
                  setTimeout(function () {
                    p.p.classList.add("slideIn");
                  }, t[1]),
                (s.icon || s.iconUrl) &&
                  setTimeout(function () {
                    p.icon.classList.add("revealIn");
                  }, t[2]);
              var e = 150;
              s.buttons.length > 0 &&
                p.buttons &&
                setTimeout(
                  function () {
                    m(p.buttons.childNodes, function (t, n) {
                      setTimeout(function () {
                        t.classList.add("revealIn");
                      }, e),
                        (e += 150);
                    });
                  },
                  s.inputs.length > 0 ? 150 : 0
                ),
                s.inputs.length > 0 &&
                  p.inputs &&
                  ((e = 150),
                  m(p.inputs.childNodes, function (t, n) {
                    setTimeout(function () {
                      t.classList.add("revealIn");
                    }, e),
                      (e += 150);
                  }));
            }
          })(),
          s.onOpening.apply(null, [s, p.toast]);
        try {
          var C = new CustomEvent(n + "-opening", {
            detail: s,
            bubbles: !0,
            cancelable: !0,
          });
          document.dispatchEvent(C);
        } catch (w) {
          console.warn(w);
        }
        setTimeout(function () {
          p.toast.classList.remove(n + "-opening"),
            p.toast.classList.add(n + "-opened");
          try {
            var t = new CustomEvent(n + "-opened", {
              detail: s,
              bubbles: !0,
              cancelable: !0,
            });
            document.dispatchEvent(t);
          } catch (e) {
            console.warn(e);
          }
          s.onOpened.apply(null, [s, p.toast]);
        }, 1e3),
          s.drag &&
            (a
              ? (p.toast.addEventListener(
                  "touchstart",
                  function (t) {
                    b.startMoving(this, i, s, t);
                  },
                  !1
                ),
                p.toast.addEventListener(
                  "touchend",
                  function (t) {
                    b.stopMoving(this, t);
                  },
                  !1
                ))
              : (p.toast.addEventListener(
                  "mousedown",
                  function (t) {
                    t.preventDefault(), b.startMoving(this, i, s, t);
                  },
                  !1
                ),
                p.toast.addEventListener(
                  "mouseup",
                  function (t) {
                    t.preventDefault(), b.stopMoving(this, t);
                  },
                  !1
                ))),
          s.closeOnEscape &&
            document.addEventListener("keyup", function (t) {
              (t = t || window.event),
                27 == t.keyCode && i.hide(s, p.toast, "esc");
            }),
          s.closeOnClick &&
            p.toast.addEventListener("click", function (t) {
              i.hide(s, p.toast, "toast");
            }),
          (i.toast = p.toast);
      }),
      e
    );
  }
);
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
!(function (t, e) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define([], e)
    : "object" == typeof exports
    ? (exports.Quill = e())
    : (t.Quill = e());
})("undefined" != typeof self ? self : this, function () {
  return (function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;
      var o = (n[r] = { i: r, l: !1, exports: {} });
      return t[r].call(o.exports, o, o.exports, e), (o.l = !0), o.exports;
    }
    var n = {};
    return (
      (e.m = t),
      (e.c = n),
      (e.d = function (t, n, r) {
        e.o(t, n) ||
          Object.defineProperty(t, n, {
            configurable: !1,
            enumerable: !0,
            get: r,
          });
      }),
      (e.n = function (t) {
        var n =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return e.d(n, "a", n), n;
      }),
      (e.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (e.p = ""),
      e((e.s = 45))
    );
  })([
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var r = n(17),
        o = n(18),
        i = n(19),
        l = n(48),
        a = n(49),
        s = n(50),
        u = n(51),
        c = n(52),
        f = n(11),
        h = n(29),
        p = n(30),
        d = n(28),
        y = n(1),
        v = {
          Scope: y.Scope,
          create: y.create,
          find: y.find,
          query: y.query,
          register: y.register,
          Container: r.default,
          Format: o.default,
          Leaf: i.default,
          Embed: u.default,
          Scroll: l.default,
          Block: s.default,
          Inline: a.default,
          Text: c.default,
          Attributor: {
            Attribute: f.default,
            Class: h.default,
            Style: p.default,
            Store: d.default,
          },
        };
      e.default = v;
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        var n = i(t);
        if (null == n) throw new s("Unable to create " + t + " blot");
        var r = n;
        return new r(
          t instanceof Node || t.nodeType === Node.TEXT_NODE ? t : r.create(e),
          e
        );
      }
      function o(t, n) {
        return (
          void 0 === n && (n = !1),
          null == t
            ? null
            : null != t[e.DATA_KEY]
            ? t[e.DATA_KEY].blot
            : n
            ? o(t.parentNode, n)
            : null
        );
      }
      function i(t, e) {
        void 0 === e && (e = p.ANY);
        var n;
        if ("string" == typeof t) n = h[t] || u[t];
        else if (t instanceof Text || t.nodeType === Node.TEXT_NODE) n = h.text;
        else if ("number" == typeof t)
          t & p.LEVEL & p.BLOCK
            ? (n = h.block)
            : t & p.LEVEL & p.INLINE && (n = h.inline);
        else if (t instanceof HTMLElement) {
          var r = (t.getAttribute("class") || "").split(/\s+/);
          for (var o in r) if ((n = c[r[o]])) break;
          n = n || f[t.tagName];
        }
        return null == n
          ? null
          : e & p.LEVEL & n.scope && e & p.TYPE & n.scope
          ? n
          : null;
      }
      function l() {
        for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
        if (t.length > 1)
          return t.map(function (t) {
            return l(t);
          });
        var n = t[0];
        if ("string" != typeof n.blotName && "string" != typeof n.attrName)
          throw new s("Invalid definition");
        if ("abstract" === n.blotName)
          throw new s("Cannot register abstract class");
        if (((h[n.blotName || n.attrName] = n), "string" == typeof n.keyName))
          u[n.keyName] = n;
        else if (
          (null != n.className && (c[n.className] = n), null != n.tagName)
        ) {
          Array.isArray(n.tagName)
            ? (n.tagName = n.tagName.map(function (t) {
                return t.toUpperCase();
              }))
            : (n.tagName = n.tagName.toUpperCase());
          var r = Array.isArray(n.tagName) ? n.tagName : [n.tagName];
          r.forEach(function (t) {
            (null != f[t] && null != n.className) || (f[t] = n);
          });
        }
        return n;
      }
      var a =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var s = (function (t) {
        function e(e) {
          var n = this;
          return (
            (e = "[Parchment] " + e),
            (n = t.call(this, e) || this),
            (n.message = e),
            (n.name = n.constructor.name),
            n
          );
        }
        return a(e, t), e;
      })(Error);
      e.ParchmentError = s;
      var u = {},
        c = {},
        f = {},
        h = {};
      e.DATA_KEY = "__blot";
      var p;
      !(function (t) {
        (t[(t.TYPE = 3)] = "TYPE"),
          (t[(t.LEVEL = 12)] = "LEVEL"),
          (t[(t.ATTRIBUTE = 13)] = "ATTRIBUTE"),
          (t[(t.BLOT = 14)] = "BLOT"),
          (t[(t.INLINE = 7)] = "INLINE"),
          (t[(t.BLOCK = 11)] = "BLOCK"),
          (t[(t.BLOCK_BLOT = 10)] = "BLOCK_BLOT"),
          (t[(t.INLINE_BLOT = 6)] = "INLINE_BLOT"),
          (t[(t.BLOCK_ATTRIBUTE = 9)] = "BLOCK_ATTRIBUTE"),
          (t[(t.INLINE_ATTRIBUTE = 5)] = "INLINE_ATTRIBUTE"),
          (t[(t.ANY = 15)] = "ANY");
      })((p = e.Scope || (e.Scope = {}))),
        (e.create = r),
        (e.find = o),
        (e.query = i),
        (e.register = l);
    },
    function (t, e) {
      "use strict";
      var n = Object.prototype.hasOwnProperty,
        r = Object.prototype.toString,
        o = Object.defineProperty,
        i = Object.getOwnPropertyDescriptor,
        l = function (t) {
          return "function" == typeof Array.isArray
            ? Array.isArray(t)
            : "[object Array]" === r.call(t);
        },
        a = function (t) {
          if (!t || "[object Object]" !== r.call(t)) return !1;
          var e = n.call(t, "constructor"),
            o =
              t.constructor &&
              t.constructor.prototype &&
              n.call(t.constructor.prototype, "isPrototypeOf");
          if (t.constructor && !e && !o) return !1;
          var i;
          for (i in t);
          return void 0 === i || n.call(t, i);
        },
        s = function (t, e) {
          o && "__proto__" === e.name
            ? o(t, e.name, {
                enumerable: !0,
                configurable: !0,
                value: e.newValue,
                writable: !0,
              })
            : (t[e.name] = e.newValue);
        },
        u = function (t, e) {
          if ("__proto__" === e) {
            if (!n.call(t, e)) return;
            if (i) return i(t, e).value;
          }
          return t[e];
        };
      t.exports = function t() {
        var e,
          n,
          r,
          o,
          i,
          c,
          f = arguments[0],
          h = 1,
          p = arguments.length,
          d = !1;
        for (
          "boolean" == typeof f && ((d = f), (f = arguments[1] || {}), (h = 2)),
            (null == f || ("object" != typeof f && "function" != typeof f)) &&
              (f = {});
          h < p;
          ++h
        )
          if (null != (e = arguments[h]))
            for (n in e)
              (r = u(f, n)),
                (o = u(e, n)),
                f !== o &&
                  (d && o && (a(o) || (i = l(o)))
                    ? (i
                        ? ((i = !1), (c = r && l(r) ? r : []))
                        : (c = r && a(r) ? r : {}),
                      s(f, { name: n, newValue: t(d, c, o) }))
                    : void 0 !== o && s(f, { name: n, newValue: o }));
        return f;
      };
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      function a(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return null == t
          ? e
          : ("function" == typeof t.formats &&
              (e = (0, f.default)(e, t.formats())),
            null == t.parent ||
            "scroll" == t.parent.blotName ||
            t.parent.statics.scope !== t.statics.scope
              ? e
              : a(t.parent, e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = e.BlockEmbed = e.bubbleFormats = void 0);
      var s = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        u = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        c = n(2),
        f = r(c),
        h = n(4),
        p = r(h),
        d = n(0),
        y = r(d),
        v = n(14),
        b = r(v),
        g = n(5),
        m = r(g),
        _ = n(8),
        O = r(_),
        w = (function (t) {
          function e() {
            return (
              o(this, e),
              i(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            l(e, t),
            s(e, [
              {
                key: "attach",
                value: function () {
                  u(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "attach",
                    this
                  ).call(this),
                    (this.attributes = new y.default.Attributor.Store(
                      this.domNode
                    ));
                },
              },
              {
                key: "delta",
                value: function () {
                  return new p.default().insert(
                    this.value(),
                    (0, f.default)(this.formats(), this.attributes.values())
                  );
                },
              },
              {
                key: "format",
                value: function (t, e) {
                  var n = y.default.query(t, y.default.Scope.BLOCK_ATTRIBUTE);
                  null != n && this.attributes.attribute(n, e);
                },
              },
              {
                key: "formatAt",
                value: function (t, e, n, r) {
                  this.format(n, r);
                },
              },
              {
                key: "insertAt",
                value: function (t, n, r) {
                  if ("string" == typeof n && n.endsWith("\n")) {
                    var o = y.default.create(x.blotName);
                    this.parent.insertBefore(o, 0 === t ? this : this.next),
                      o.insertAt(0, n.slice(0, -1));
                  } else
                    u(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "insertAt",
                      this
                    ).call(this, t, n, r);
                },
              },
            ]),
            e
          );
        })(y.default.Embed);
      w.scope = y.default.Scope.BLOCK_BLOT;
      var x = (function (t) {
        function e(t) {
          o(this, e);
          var n = i(
            this,
            (e.__proto__ || Object.getPrototypeOf(e)).call(this, t)
          );
          return (n.cache = {}), n;
        }
        return (
          l(e, t),
          s(e, [
            {
              key: "delta",
              value: function () {
                return (
                  null == this.cache.delta &&
                    (this.cache.delta = this.descendants(y.default.Leaf)
                      .reduce(function (t, e) {
                        return 0 === e.length() ? t : t.insert(e.value(), a(e));
                      }, new p.default())
                      .insert("\n", a(this))),
                  this.cache.delta
                );
              },
            },
            {
              key: "deleteAt",
              value: function (t, n) {
                u(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "deleteAt",
                  this
                ).call(this, t, n),
                  (this.cache = {});
              },
            },
            {
              key: "formatAt",
              value: function (t, n, r, o) {
                n <= 0 ||
                  (y.default.query(r, y.default.Scope.BLOCK)
                    ? t + n === this.length() && this.format(r, o)
                    : u(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "formatAt",
                        this
                      ).call(this, t, Math.min(n, this.length() - t - 1), r, o),
                  (this.cache = {}));
              },
            },
            {
              key: "insertAt",
              value: function (t, n, r) {
                if (null != r)
                  return u(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "insertAt",
                    this
                  ).call(this, t, n, r);
                if (0 !== n.length) {
                  var o = n.split("\n"),
                    i = o.shift();
                  i.length > 0 &&
                    (t < this.length() - 1 || null == this.children.tail
                      ? u(
                          e.prototype.__proto__ ||
                            Object.getPrototypeOf(e.prototype),
                          "insertAt",
                          this
                        ).call(this, Math.min(t, this.length() - 1), i)
                      : this.children.tail.insertAt(
                          this.children.tail.length(),
                          i
                        ),
                    (this.cache = {}));
                  var l = this;
                  o.reduce(function (t, e) {
                    return (l = l.split(t, !0)), l.insertAt(0, e), e.length;
                  }, t + i.length);
                }
              },
            },
            {
              key: "insertBefore",
              value: function (t, n) {
                var r = this.children.head;
                u(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "insertBefore",
                  this
                ).call(this, t, n),
                  r instanceof b.default && r.remove(),
                  (this.cache = {});
              },
            },
            {
              key: "length",
              value: function () {
                return (
                  null == this.cache.length &&
                    (this.cache.length =
                      u(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "length",
                        this
                      ).call(this) + 1),
                  this.cache.length
                );
              },
            },
            {
              key: "moveChildren",
              value: function (t, n) {
                u(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "moveChildren",
                  this
                ).call(this, t, n),
                  (this.cache = {});
              },
            },
            {
              key: "optimize",
              value: function (t) {
                u(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "optimize",
                  this
                ).call(this, t),
                  (this.cache = {});
              },
            },
            {
              key: "path",
              value: function (t) {
                return u(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "path",
                  this
                ).call(this, t, !0);
              },
            },
            {
              key: "removeChild",
              value: function (t) {
                u(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "removeChild",
                  this
                ).call(this, t),
                  (this.cache = {});
              },
            },
            {
              key: "split",
              value: function (t) {
                var n =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1];
                if (n && (0 === t || t >= this.length() - 1)) {
                  var r = this.clone();
                  return 0 === t
                    ? (this.parent.insertBefore(r, this), this)
                    : (this.parent.insertBefore(r, this.next), r);
                }
                var o = u(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "split",
                  this
                ).call(this, t, n);
                return (this.cache = {}), o;
              },
            },
          ]),
          e
        );
      })(y.default.Block);
      (x.blotName = "block"),
        (x.tagName = "P"),
        (x.defaultChild = "break"),
        (x.allowedChildren = [m.default, y.default.Embed, O.default]),
        (e.bubbleFormats = a),
        (e.BlockEmbed = w),
        (e.default = x);
    },
    function (t, e, n) {
      var r = n(54),
        o = n(12),
        i = n(2),
        l = n(20),
        a = String.fromCharCode(0),
        s = function (t) {
          Array.isArray(t)
            ? (this.ops = t)
            : null != t && Array.isArray(t.ops)
            ? (this.ops = t.ops)
            : (this.ops = []);
        };
      (s.prototype.insert = function (t, e) {
        var n = {};
        return 0 === t.length
          ? this
          : ((n.insert = t),
            null != e &&
              "object" == typeof e &&
              Object.keys(e).length > 0 &&
              (n.attributes = e),
            this.push(n));
      }),
        (s.prototype.delete = function (t) {
          return t <= 0 ? this : this.push({ delete: t });
        }),
        (s.prototype.retain = function (t, e) {
          if (t <= 0) return this;
          var n = { retain: t };
          return (
            null != e &&
              "object" == typeof e &&
              Object.keys(e).length > 0 &&
              (n.attributes = e),
            this.push(n)
          );
        }),
        (s.prototype.push = function (t) {
          var e = this.ops.length,
            n = this.ops[e - 1];
          if (((t = i(!0, {}, t)), "object" == typeof n)) {
            if ("number" == typeof t.delete && "number" == typeof n.delete)
              return (this.ops[e - 1] = { delete: n.delete + t.delete }), this;
            if (
              "number" == typeof n.delete &&
              null != t.insert &&
              ((e -= 1), "object" != typeof (n = this.ops[e - 1]))
            )
              return this.ops.unshift(t), this;
            if (o(t.attributes, n.attributes)) {
              if ("string" == typeof t.insert && "string" == typeof n.insert)
                return (
                  (this.ops[e - 1] = { insert: n.insert + t.insert }),
                  "object" == typeof t.attributes &&
                    (this.ops[e - 1].attributes = t.attributes),
                  this
                );
              if ("number" == typeof t.retain && "number" == typeof n.retain)
                return (
                  (this.ops[e - 1] = { retain: n.retain + t.retain }),
                  "object" == typeof t.attributes &&
                    (this.ops[e - 1].attributes = t.attributes),
                  this
                );
            }
          }
          return (
            e === this.ops.length ? this.ops.push(t) : this.ops.splice(e, 0, t),
            this
          );
        }),
        (s.prototype.chop = function () {
          var t = this.ops[this.ops.length - 1];
          return t && t.retain && !t.attributes && this.ops.pop(), this;
        }),
        (s.prototype.filter = function (t) {
          return this.ops.filter(t);
        }),
        (s.prototype.forEach = function (t) {
          this.ops.forEach(t);
        }),
        (s.prototype.map = function (t) {
          return this.ops.map(t);
        }),
        (s.prototype.partition = function (t) {
          var e = [],
            n = [];
          return (
            this.forEach(function (r) {
              (t(r) ? e : n).push(r);
            }),
            [e, n]
          );
        }),
        (s.prototype.reduce = function (t, e) {
          return this.ops.reduce(t, e);
        }),
        (s.prototype.changeLength = function () {
          return this.reduce(function (t, e) {
            return e.insert ? t + l.length(e) : e.delete ? t - e.delete : t;
          }, 0);
        }),
        (s.prototype.length = function () {
          return this.reduce(function (t, e) {
            return t + l.length(e);
          }, 0);
        }),
        (s.prototype.slice = function (t, e) {
          (t = t || 0), "number" != typeof e && (e = 1 / 0);
          for (
            var n = [], r = l.iterator(this.ops), o = 0;
            o < e && r.hasNext();

          ) {
            var i;
            o < t ? (i = r.next(t - o)) : ((i = r.next(e - o)), n.push(i)),
              (o += l.length(i));
          }
          return new s(n);
        }),
        (s.prototype.compose = function (t) {
          var e = l.iterator(this.ops),
            n = l.iterator(t.ops),
            r = [],
            i = n.peek();
          if (
            null != i &&
            "number" == typeof i.retain &&
            null == i.attributes
          ) {
            for (
              var a = i.retain;
              "insert" === e.peekType() && e.peekLength() <= a;

            )
              (a -= e.peekLength()), r.push(e.next());
            i.retain - a > 0 && n.next(i.retain - a);
          }
          for (var u = new s(r); e.hasNext() || n.hasNext(); )
            if ("insert" === n.peekType()) u.push(n.next());
            else if ("delete" === e.peekType()) u.push(e.next());
            else {
              var c = Math.min(e.peekLength(), n.peekLength()),
                f = e.next(c),
                h = n.next(c);
              if ("number" == typeof h.retain) {
                var p = {};
                "number" == typeof f.retain
                  ? (p.retain = c)
                  : (p.insert = f.insert);
                var d = l.attributes.compose(
                  f.attributes,
                  h.attributes,
                  "number" == typeof f.retain
                );
                if (
                  (d && (p.attributes = d),
                  u.push(p),
                  !n.hasNext() && o(u.ops[u.ops.length - 1], p))
                ) {
                  var y = new s(e.rest());
                  return u.concat(y).chop();
                }
              } else
                "number" == typeof h.delete &&
                  "number" == typeof f.retain &&
                  u.push(h);
            }
          return u.chop();
        }),
        (s.prototype.concat = function (t) {
          var e = new s(this.ops.slice());
          return (
            t.ops.length > 0 &&
              (e.push(t.ops[0]), (e.ops = e.ops.concat(t.ops.slice(1)))),
            e
          );
        }),
        (s.prototype.diff = function (t, e) {
          if (this.ops === t.ops) return new s();
          var n = [this, t].map(function (e) {
              return e
                .map(function (n) {
                  if (null != n.insert)
                    return "string" == typeof n.insert ? n.insert : a;
                  var r = e === t ? "on" : "with";
                  throw new Error("diff() called " + r + " non-document");
                })
                .join("");
            }),
            i = new s(),
            u = r(n[0], n[1], e),
            c = l.iterator(this.ops),
            f = l.iterator(t.ops);
          return (
            u.forEach(function (t) {
              for (var e = t[1].length; e > 0; ) {
                var n = 0;
                switch (t[0]) {
                  case r.INSERT:
                    (n = Math.min(f.peekLength(), e)), i.push(f.next(n));
                    break;
                  case r.DELETE:
                    (n = Math.min(e, c.peekLength())), c.next(n), i.delete(n);
                    break;
                  case r.EQUAL:
                    n = Math.min(c.peekLength(), f.peekLength(), e);
                    var a = c.next(n),
                      s = f.next(n);
                    o(a.insert, s.insert)
                      ? i.retain(
                          n,
                          l.attributes.diff(a.attributes, s.attributes)
                        )
                      : i.push(s).delete(n);
                }
                e -= n;
              }
            }),
            i.chop()
          );
        }),
        (s.prototype.eachLine = function (t, e) {
          e = e || "\n";
          for (
            var n = l.iterator(this.ops), r = new s(), o = 0;
            n.hasNext();

          ) {
            if ("insert" !== n.peekType()) return;
            var i = n.peek(),
              a = l.length(i) - n.peekLength(),
              u = "string" == typeof i.insert ? i.insert.indexOf(e, a) - a : -1;
            if (u < 0) r.push(n.next());
            else if (u > 0) r.push(n.next(u));
            else {
              if (!1 === t(r, n.next(1).attributes || {}, o)) return;
              (o += 1), (r = new s());
            }
          }
          r.length() > 0 && t(r, {}, o);
        }),
        (s.prototype.transform = function (t, e) {
          if (((e = !!e), "number" == typeof t))
            return this.transformPosition(t, e);
          for (
            var n = l.iterator(this.ops), r = l.iterator(t.ops), o = new s();
            n.hasNext() || r.hasNext();

          )
            if ("insert" !== n.peekType() || (!e && "insert" === r.peekType()))
              if ("insert" === r.peekType()) o.push(r.next());
              else {
                var i = Math.min(n.peekLength(), r.peekLength()),
                  a = n.next(i),
                  u = r.next(i);
                if (a.delete) continue;
                u.delete
                  ? o.push(u)
                  : o.retain(
                      i,
                      l.attributes.transform(a.attributes, u.attributes, e)
                    );
              }
            else o.retain(l.length(n.next()));
          return o.chop();
        }),
        (s.prototype.transformPosition = function (t, e) {
          e = !!e;
          for (var n = l.iterator(this.ops), r = 0; n.hasNext() && r <= t; ) {
            var o = n.peekLength(),
              i = n.peekType();
            n.next(),
              "delete" !== i
                ? ("insert" === i && (r < t || !e) && (t += o), (r += o))
                : (t -= Math.min(o, t - r));
          }
          return t;
        }),
        (t.exports = s);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var a = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        s = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        u = n(8),
        c = r(u),
        f = n(0),
        h = r(f),
        p = (function (t) {
          function e() {
            return (
              o(this, e),
              i(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            l(e, t),
            a(
              e,
              [
                {
                  key: "formatAt",
                  value: function (t, n, r, o) {
                    if (
                      e.compare(this.statics.blotName, r) < 0 &&
                      h.default.query(r, h.default.Scope.BLOT)
                    ) {
                      var i = this.isolate(t, n);
                      o && i.wrap(r, o);
                    } else
                      s(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "formatAt",
                        this
                      ).call(this, t, n, r, o);
                  },
                },
                {
                  key: "optimize",
                  value: function (t) {
                    if (
                      (s(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "optimize",
                        this
                      ).call(this, t),
                      this.parent instanceof e &&
                        e.compare(
                          this.statics.blotName,
                          this.parent.statics.blotName
                        ) > 0)
                    ) {
                      var n = this.parent.isolate(this.offset(), this.length());
                      this.moveChildren(n), n.wrap(this);
                    }
                  },
                },
              ],
              [
                {
                  key: "compare",
                  value: function (t, n) {
                    var r = e.order.indexOf(t),
                      o = e.order.indexOf(n);
                    return r >= 0 || o >= 0
                      ? r - o
                      : t === n
                      ? 0
                      : t < n
                      ? -1
                      : 1;
                  },
                },
              ]
            ),
            e
          );
        })(h.default.Inline);
      (p.allowedChildren = [p, h.default.Embed, c.default]),
        (p.order = [
          "cursor",
          "inline",
          "underline",
          "strike",
          "italic",
          "bold",
          "script",
          "link",
          "code",
        ]),
        (e.default = p);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function i(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function l(t, e) {
        if (
          ((e = (0, N.default)(
            !0,
            {
              container: t,
              modules: { clipboard: !0, keyboard: !0, history: !0 },
            },
            e
          )),
          e.theme && e.theme !== S.DEFAULTS.theme)
        ) {
          if (((e.theme = S.import("themes/" + e.theme)), null == e.theme))
            throw new Error(
              "Invalid theme " + e.theme + ". Did you register it?"
            );
        } else e.theme = T.default;
        var n = (0, N.default)(!0, {}, e.theme.DEFAULTS);
        [n, e].forEach(function (t) {
          (t.modules = t.modules || {}),
            Object.keys(t.modules).forEach(function (e) {
              !0 === t.modules[e] && (t.modules[e] = {});
            });
        });
        var r = Object.keys(n.modules).concat(Object.keys(e.modules)),
          o = r.reduce(function (t, e) {
            var n = S.import("modules/" + e);
            return (
              null == n
                ? P.error(
                    "Cannot load " +
                      e +
                      " module. Are you sure you registered it?"
                  )
                : (t[e] = n.DEFAULTS || {}),
              t
            );
          }, {});
        return (
          null != e.modules &&
            e.modules.toolbar &&
            e.modules.toolbar.constructor !== Object &&
            (e.modules.toolbar = { container: e.modules.toolbar }),
          (e = (0, N.default)(!0, {}, S.DEFAULTS, { modules: o }, n, e)),
          ["bounds", "container", "scrollingContainer"].forEach(function (t) {
            "string" == typeof e[t] && (e[t] = document.querySelector(e[t]));
          }),
          (e.modules = Object.keys(e.modules).reduce(function (t, n) {
            return e.modules[n] && (t[n] = e.modules[n]), t;
          }, {})),
          e
        );
      }
      function a(t, e, n, r) {
        if (
          this.options.strict &&
          !this.isEnabled() &&
          e === g.default.sources.USER
        )
          return new d.default();
        var o = null == n ? null : this.getSelection(),
          i = this.editor.delta,
          l = t();
        if (
          (null != o &&
            (!0 === n && (n = o.index),
            null == r ? (o = u(o, l, e)) : 0 !== r && (o = u(o, n, r, e)),
            this.setSelection(o, g.default.sources.SILENT)),
          l.length() > 0)
        ) {
          var a,
            s = [g.default.events.TEXT_CHANGE, l, i, e];
          if (
            ((a = this.emitter).emit.apply(
              a,
              [g.default.events.EDITOR_CHANGE].concat(s)
            ),
            e !== g.default.sources.SILENT)
          ) {
            var c;
            (c = this.emitter).emit.apply(c, s);
          }
        }
        return l;
      }
      function s(t, e, n, r, o) {
        var i = {};
        return (
          "number" == typeof t.index && "number" == typeof t.length
            ? "number" != typeof e
              ? ((o = r), (r = n), (n = e), (e = t.length), (t = t.index))
              : ((e = t.length), (t = t.index))
            : "number" != typeof e && ((o = r), (r = n), (n = e), (e = 0)),
          "object" === (void 0 === n ? "undefined" : c(n))
            ? ((i = n), (o = r))
            : "string" == typeof n && (null != r ? (i[n] = r) : (o = n)),
          (o = o || g.default.sources.API),
          [t, e, i, o]
        );
      }
      function u(t, e, n, r) {
        if (null == t) return null;
        var o = void 0,
          i = void 0;
        if (e instanceof d.default) {
          var l = [t.index, t.index + t.length].map(function (t) {
              return e.transformPosition(t, r !== g.default.sources.USER);
            }),
            a = f(l, 2);
          (o = a[0]), (i = a[1]);
        } else {
          var s = [t.index, t.index + t.length].map(function (t) {
              return t < e || (t === e && r === g.default.sources.USER)
                ? t
                : n >= 0
                ? t + n
                : Math.max(e, t + n);
            }),
            u = f(s, 2);
          (o = u[0]), (i = u[1]);
        }
        return new x.Range(o, i - o);
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = e.overload = e.expandConfig = void 0);
      var c =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              },
        f = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        h = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })();
      n(53);
      var p = n(4),
        d = r(p),
        y = n(57),
        v = r(y),
        b = n(9),
        g = r(b),
        m = n(7),
        _ = r(m),
        O = n(0),
        w = r(O),
        x = n(22),
        k = r(x),
        E = n(2),
        N = r(E),
        j = n(10),
        A = r(j),
        q = n(32),
        T = r(q),
        P = (0, A.default)("quill"),
        S = (function () {
          function t(e) {
            var n = this,
              r =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            if (
              (i(this, t),
              (this.options = l(e, r)),
              (this.container = this.options.container),
              null == this.container)
            )
              return P.error("Invalid Quill container", e);
            this.options.debug && t.debug(this.options.debug);
            var o = this.container.innerHTML.trim();
            this.container.classList.add("ql-container"),
              (this.container.innerHTML = ""),
              (this.container.__quill = this),
              (this.root = this.addContainer("ql-editor")),
              this.root.classList.add("ql-blank"),
              this.root.setAttribute("data-gramm", !1),
              (this.scrollingContainer =
                this.options.scrollingContainer || this.root),
              (this.emitter = new g.default()),
              (this.scroll = w.default.create(this.root, {
                emitter: this.emitter,
                whitelist: this.options.formats,
              })),
              (this.editor = new v.default(this.scroll)),
              (this.selection = new k.default(this.scroll, this.emitter)),
              (this.theme = new this.options.theme(this, this.options)),
              (this.keyboard = this.theme.addModule("keyboard")),
              (this.clipboard = this.theme.addModule("clipboard")),
              (this.history = this.theme.addModule("history")),
              this.theme.init(),
              this.emitter.on(g.default.events.EDITOR_CHANGE, function (t) {
                t === g.default.events.TEXT_CHANGE &&
                  n.root.classList.toggle("ql-blank", n.editor.isBlank());
              }),
              this.emitter.on(g.default.events.SCROLL_UPDATE, function (t, e) {
                var r = n.selection.lastRange,
                  o = r && 0 === r.length ? r.index : void 0;
                a.call(
                  n,
                  function () {
                    return n.editor.update(null, e, o);
                  },
                  t
                );
              });
            var s = this.clipboard.convert(
              "<div class='ql-editor' style=\"white-space: normal;\">" +
                o +
                "<p><br></p></div>"
            );
            this.setContents(s),
              this.history.clear(),
              this.options.placeholder &&
                this.root.setAttribute(
                  "data-placeholder",
                  this.options.placeholder
                ),
              this.options.readOnly && this.disable();
          }
          return (
            h(t, null, [
              {
                key: "debug",
                value: function (t) {
                  !0 === t && (t = "log"), A.default.level(t);
                },
              },
              {
                key: "find",
                value: function (t) {
                  return t.__quill || w.default.find(t);
                },
              },
              {
                key: "import",
                value: function (t) {
                  return (
                    null == this.imports[t] &&
                      P.error(
                        "Cannot import " +
                          t +
                          ". Are you sure it was registered?"
                      ),
                    this.imports[t]
                  );
                },
              },
              {
                key: "register",
                value: function (t, e) {
                  var n = this,
                    r =
                      arguments.length > 2 &&
                      void 0 !== arguments[2] &&
                      arguments[2];
                  if ("string" != typeof t) {
                    var o = t.attrName || t.blotName;
                    "string" == typeof o
                      ? this.register("formats/" + o, t, e)
                      : Object.keys(t).forEach(function (r) {
                          n.register(r, t[r], e);
                        });
                  } else
                    null == this.imports[t] ||
                      r ||
                      P.warn("Overwriting " + t + " with", e),
                      (this.imports[t] = e),
                      (t.startsWith("blots/") || t.startsWith("formats/")) &&
                      "abstract" !== e.blotName
                        ? w.default.register(e)
                        : t.startsWith("modules") &&
                          "function" == typeof e.register &&
                          e.register();
                },
              },
            ]),
            h(t, [
              {
                key: "addContainer",
                value: function (t) {
                  var e =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : null;
                  if ("string" == typeof t) {
                    var n = t;
                    (t = document.createElement("div")), t.classList.add(n);
                  }
                  return this.container.insertBefore(t, e), t;
                },
              },
              {
                key: "blur",
                value: function () {
                  this.selection.setRange(null);
                },
              },
              {
                key: "deleteText",
                value: function (t, e, n) {
                  var r = this,
                    o = s(t, e, n),
                    i = f(o, 4);
                  return (
                    (t = i[0]),
                    (e = i[1]),
                    (n = i[3]),
                    a.call(
                      this,
                      function () {
                        return r.editor.deleteText(t, e);
                      },
                      n,
                      t,
                      -1 * e
                    )
                  );
                },
              },
              {
                key: "disable",
                value: function () {
                  this.enable(!1);
                },
              },
              {
                key: "enable",
                value: function () {
                  var t =
                    !(arguments.length > 0 && void 0 !== arguments[0]) ||
                    arguments[0];
                  this.scroll.enable(t),
                    this.container.classList.toggle("ql-disabled", !t);
                },
              },
              {
                key: "focus",
                value: function () {
                  var t = this.scrollingContainer.scrollTop;
                  this.selection.focus(),
                    (this.scrollingContainer.scrollTop = t),
                    this.scrollIntoView();
                },
              },
              {
                key: "format",
                value: function (t, e) {
                  var n = this,
                    r =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : g.default.sources.API;
                  return a.call(
                    this,
                    function () {
                      var r = n.getSelection(!0),
                        i = new d.default();
                      if (null == r) return i;
                      if (w.default.query(t, w.default.Scope.BLOCK))
                        i = n.editor.formatLine(r.index, r.length, o({}, t, e));
                      else {
                        if (0 === r.length) return n.selection.format(t, e), i;
                        i = n.editor.formatText(r.index, r.length, o({}, t, e));
                      }
                      return n.setSelection(r, g.default.sources.SILENT), i;
                    },
                    r
                  );
                },
              },
              {
                key: "formatLine",
                value: function (t, e, n, r, o) {
                  var i = this,
                    l = void 0,
                    u = s(t, e, n, r, o),
                    c = f(u, 4);
                  return (
                    (t = c[0]),
                    (e = c[1]),
                    (l = c[2]),
                    (o = c[3]),
                    a.call(
                      this,
                      function () {
                        return i.editor.formatLine(t, e, l);
                      },
                      o,
                      t,
                      0
                    )
                  );
                },
              },
              {
                key: "formatText",
                value: function (t, e, n, r, o) {
                  var i = this,
                    l = void 0,
                    u = s(t, e, n, r, o),
                    c = f(u, 4);
                  return (
                    (t = c[0]),
                    (e = c[1]),
                    (l = c[2]),
                    (o = c[3]),
                    a.call(
                      this,
                      function () {
                        return i.editor.formatText(t, e, l);
                      },
                      o,
                      t,
                      0
                    )
                  );
                },
              },
              {
                key: "getBounds",
                value: function (t) {
                  var e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : 0,
                    n = void 0;
                  n =
                    "number" == typeof t
                      ? this.selection.getBounds(t, e)
                      : this.selection.getBounds(t.index, t.length);
                  var r = this.container.getBoundingClientRect();
                  return {
                    bottom: n.bottom - r.top,
                    height: n.height,
                    left: n.left - r.left,
                    right: n.right - r.left,
                    top: n.top - r.top,
                    width: n.width,
                  };
                },
              },
              {
                key: "getContents",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : 0,
                    e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : this.getLength() - t,
                    n = s(t, e),
                    r = f(n, 2);
                  return (t = r[0]), (e = r[1]), this.editor.getContents(t, e);
                },
              },
              {
                key: "getFormat",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : this.getSelection(!0),
                    e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : 0;
                  return "number" == typeof t
                    ? this.editor.getFormat(t, e)
                    : this.editor.getFormat(t.index, t.length);
                },
              },
              {
                key: "getIndex",
                value: function (t) {
                  return t.offset(this.scroll);
                },
              },
              {
                key: "getLength",
                value: function () {
                  return this.scroll.length();
                },
              },
              {
                key: "getLeaf",
                value: function (t) {
                  return this.scroll.leaf(t);
                },
              },
              {
                key: "getLine",
                value: function (t) {
                  return this.scroll.line(t);
                },
              },
              {
                key: "getLines",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : 0,
                    e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : Number.MAX_VALUE;
                  return "number" != typeof t
                    ? this.scroll.lines(t.index, t.length)
                    : this.scroll.lines(t, e);
                },
              },
              {
                key: "getModule",
                value: function (t) {
                  return this.theme.modules[t];
                },
              },
              {
                key: "getSelection",
                value: function () {
                  return (
                    arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0] &&
                      this.focus(),
                    this.update(),
                    this.selection.getRange()[0]
                  );
                },
              },
              {
                key: "getText",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : 0,
                    e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : this.getLength() - t,
                    n = s(t, e),
                    r = f(n, 2);
                  return (t = r[0]), (e = r[1]), this.editor.getText(t, e);
                },
              },
              {
                key: "hasFocus",
                value: function () {
                  return this.selection.hasFocus();
                },
              },
              {
                key: "insertEmbed",
                value: function (e, n, r) {
                  var o = this,
                    i =
                      arguments.length > 3 && void 0 !== arguments[3]
                        ? arguments[3]
                        : t.sources.API;
                  return a.call(
                    this,
                    function () {
                      return o.editor.insertEmbed(e, n, r);
                    },
                    i,
                    e
                  );
                },
              },
              {
                key: "insertText",
                value: function (t, e, n, r, o) {
                  var i = this,
                    l = void 0,
                    u = s(t, 0, n, r, o),
                    c = f(u, 4);
                  return (
                    (t = c[0]),
                    (l = c[2]),
                    (o = c[3]),
                    a.call(
                      this,
                      function () {
                        return i.editor.insertText(t, e, l);
                      },
                      o,
                      t,
                      e.length
                    )
                  );
                },
              },
              {
                key: "isEnabled",
                value: function () {
                  return !this.container.classList.contains("ql-disabled");
                },
              },
              {
                key: "off",
                value: function () {
                  return this.emitter.off.apply(this.emitter, arguments);
                },
              },
              {
                key: "on",
                value: function () {
                  return this.emitter.on.apply(this.emitter, arguments);
                },
              },
              {
                key: "once",
                value: function () {
                  return this.emitter.once.apply(this.emitter, arguments);
                },
              },
              {
                key: "pasteHTML",
                value: function (t, e, n) {
                  this.clipboard.dangerouslyPasteHTML(t, e, n);
                },
              },
              {
                key: "removeFormat",
                value: function (t, e, n) {
                  var r = this,
                    o = s(t, e, n),
                    i = f(o, 4);
                  return (
                    (t = i[0]),
                    (e = i[1]),
                    (n = i[3]),
                    a.call(
                      this,
                      function () {
                        return r.editor.removeFormat(t, e);
                      },
                      n,
                      t
                    )
                  );
                },
              },
              {
                key: "scrollIntoView",
                value: function () {
                  this.selection.scrollIntoView(this.scrollingContainer);
                },
              },
              {
                key: "setContents",
                value: function (t) {
                  var e = this,
                    n =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : g.default.sources.API;
                  return a.call(
                    this,
                    function () {
                      t = new d.default(t);
                      var n = e.getLength(),
                        r = e.editor.deleteText(0, n),
                        o = e.editor.applyDelta(t),
                        i = o.ops[o.ops.length - 1];
                      return (
                        null != i &&
                          "string" == typeof i.insert &&
                          "\n" === i.insert[i.insert.length - 1] &&
                          (e.editor.deleteText(e.getLength() - 1, 1),
                          o.delete(1)),
                        r.compose(o)
                      );
                    },
                    n
                  );
                },
              },
              {
                key: "setSelection",
                value: function (e, n, r) {
                  if (null == e)
                    this.selection.setRange(null, n || t.sources.API);
                  else {
                    var o = s(e, n, r),
                      i = f(o, 4);
                    (e = i[0]),
                      (n = i[1]),
                      (r = i[3]),
                      this.selection.setRange(new x.Range(e, n), r),
                      r !== g.default.sources.SILENT &&
                        this.selection.scrollIntoView(this.scrollingContainer);
                  }
                },
              },
              {
                key: "setText",
                value: function (t) {
                  var e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : g.default.sources.API,
                    n = new d.default().insert(t);
                  return this.setContents(n, e);
                },
              },
              {
                key: "update",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : g.default.sources.USER,
                    e = this.scroll.update(t);
                  return this.selection.update(t), e;
                },
              },
              {
                key: "updateContents",
                value: function (t) {
                  var e = this,
                    n =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : g.default.sources.API;
                  return a.call(
                    this,
                    function () {
                      return (t = new d.default(t)), e.editor.applyDelta(t, n);
                    },
                    n,
                    !0
                  );
                },
              },
            ]),
            t
          );
        })();
      (S.DEFAULTS = {
        bounds: null,
        formats: null,
        modules: {},
        placeholder: "",
        readOnly: !1,
        scrollingContainer: null,
        strict: !0,
        theme: "default",
      }),
        (S.events = g.default.events),
        (S.sources = g.default.sources),
        (S.version = "1.3.7"),
        (S.imports = {
          delta: d.default,
          parchment: w.default,
          "core/module": _.default,
          "core/theme": T.default,
        }),
        (e.expandConfig = l),
        (e.overload = s),
        (e.default = S);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = function t(e) {
        var n =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        r(this, t), (this.quill = e), (this.options = n);
      };
      (o.DEFAULTS = {}), (e.default = o);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = n(0),
        a = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(l),
        s = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return i(e, t), e;
        })(a.default.Text);
      e.default = s;
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var a = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        s = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        u = n(58),
        c = r(u),
        f = n(10),
        h = r(f),
        p = (0, h.default)("quill:events");
      ["selectionchange", "mousedown", "mouseup", "click"].forEach(function (
        t
      ) {
        document.addEventListener(t, function () {
          for (var t = arguments.length, e = Array(t), n = 0; n < t; n++)
            e[n] = arguments[n];
          [].slice
            .call(document.querySelectorAll(".ql-container"))
            .forEach(function (t) {
              if (t.__quill && t.__quill.emitter) {
                var n;
                (n = t.__quill.emitter).handleDOM.apply(n, e);
              }
            });
        });
      });
      var d = (function (t) {
        function e() {
          o(this, e);
          var t = i(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return (t.listeners = {}), t.on("error", p.error), t;
        }
        return (
          l(e, t),
          a(e, [
            {
              key: "emit",
              value: function () {
                p.log.apply(p, arguments),
                  s(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "emit",
                    this
                  ).apply(this, arguments);
              },
            },
            {
              key: "handleDOM",
              value: function (t) {
                for (
                  var e = arguments.length, n = Array(e > 1 ? e - 1 : 0), r = 1;
                  r < e;
                  r++
                )
                  n[r - 1] = arguments[r];
                (this.listeners[t.type] || []).forEach(function (e) {
                  var r = e.node,
                    o = e.handler;
                  (t.target === r || r.contains(t.target)) &&
                    o.apply(void 0, [t].concat(n));
                });
              },
            },
            {
              key: "listenDOM",
              value: function (t, e, n) {
                this.listeners[t] || (this.listeners[t] = []),
                  this.listeners[t].push({ node: e, handler: n });
              },
            },
          ]),
          e
        );
      })(c.default);
      (d.events = {
        EDITOR_CHANGE: "editor-change",
        SCROLL_BEFORE_UPDATE: "scroll-before-update",
        SCROLL_OPTIMIZE: "scroll-optimize",
        SCROLL_UPDATE: "scroll-update",
        SELECTION_CHANGE: "selection-change",
        TEXT_CHANGE: "text-change",
      }),
        (d.sources = { API: "api", SILENT: "silent", USER: "user" }),
        (e.default = d);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        if (i.indexOf(t) <= i.indexOf(l)) {
          for (
            var e, n = arguments.length, r = Array(n > 1 ? n - 1 : 0), o = 1;
            o < n;
            o++
          )
            r[o - 1] = arguments[o];
          (e = console)[t].apply(e, r);
        }
      }
      function o(t) {
        return i.reduce(function (e, n) {
          return (e[n] = r.bind(console, n, t)), e;
        }, {});
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var i = ["error", "warn", "log", "info"],
        l = "warn";
      (r.level = o.level = function (t) {
        l = t;
      }),
        (e.default = o);
    },
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var r = n(1),
        o = (function () {
          function t(t, e, n) {
            void 0 === n && (n = {}), (this.attrName = t), (this.keyName = e);
            var o = r.Scope.TYPE & r.Scope.ATTRIBUTE;
            null != n.scope
              ? (this.scope = (n.scope & r.Scope.LEVEL) | o)
              : (this.scope = r.Scope.ATTRIBUTE),
              null != n.whitelist && (this.whitelist = n.whitelist);
          }
          return (
            (t.keys = function (t) {
              return [].map.call(t.attributes, function (t) {
                return t.name;
              });
            }),
            (t.prototype.add = function (t, e) {
              return (
                !!this.canAdd(t, e) && (t.setAttribute(this.keyName, e), !0)
              );
            }),
            (t.prototype.canAdd = function (t, e) {
              return (
                null !=
                  r.query(t, r.Scope.BLOT & (this.scope | r.Scope.TYPE)) &&
                (null == this.whitelist ||
                  ("string" == typeof e
                    ? this.whitelist.indexOf(e.replace(/["']/g, "")) > -1
                    : this.whitelist.indexOf(e) > -1))
              );
            }),
            (t.prototype.remove = function (t) {
              t.removeAttribute(this.keyName);
            }),
            (t.prototype.value = function (t) {
              var e = t.getAttribute(this.keyName);
              return this.canAdd(t, e) && e ? e : "";
            }),
            t
          );
        })();
      e.default = o;
    },
    function (t, e, n) {
      function r(t) {
        return null === t || void 0 === t;
      }
      function o(t) {
        return (
          !(!t || "object" != typeof t || "number" != typeof t.length) &&
          "function" == typeof t.copy &&
          "function" == typeof t.slice &&
          !(t.length > 0 && "number" != typeof t[0])
        );
      }
      function i(t, e, n) {
        var i, c;
        if (r(t) || r(e)) return !1;
        if (t.prototype !== e.prototype) return !1;
        if (s(t))
          return !!s(e) && ((t = l.call(t)), (e = l.call(e)), u(t, e, n));
        if (o(t)) {
          if (!o(e)) return !1;
          if (t.length !== e.length) return !1;
          for (i = 0; i < t.length; i++) if (t[i] !== e[i]) return !1;
          return !0;
        }
        try {
          var f = a(t),
            h = a(e);
        } catch (t) {
          return !1;
        }
        if (f.length != h.length) return !1;
        for (f.sort(), h.sort(), i = f.length - 1; i >= 0; i--)
          if (f[i] != h[i]) return !1;
        for (i = f.length - 1; i >= 0; i--)
          if (((c = f[i]), !u(t[c], e[c], n))) return !1;
        return typeof t == typeof e;
      }
      var l = Array.prototype.slice,
        a = n(55),
        s = n(56),
        u = (t.exports = function (t, e, n) {
          return (
            n || (n = {}),
            t === e ||
              (t instanceof Date && e instanceof Date
                ? t.getTime() === e.getTime()
                : !t || !e || ("object" != typeof t && "object" != typeof e)
                ? n.strict
                  ? t === e
                  : t == e
                : i(t, e, n))
          );
        });
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = e.Code = void 0);
      var a = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        s = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        u = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        c = n(4),
        f = r(c),
        h = n(0),
        p = r(h),
        d = n(3),
        y = r(d),
        v = n(5),
        b = r(v),
        g = n(8),
        m = r(g),
        _ = (function (t) {
          function e() {
            return (
              o(this, e),
              i(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return l(e, t), e;
        })(b.default);
      (_.blotName = "code"), (_.tagName = "CODE");
      var O = (function (t) {
        function e() {
          return (
            o(this, e),
            i(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
            )
          );
        }
        return (
          l(e, t),
          s(
            e,
            [
              {
                key: "delta",
                value: function () {
                  var t = this,
                    e = this.domNode.textContent;
                  return (
                    e.endsWith("\n") && (e = e.slice(0, -1)),
                    e.split("\n").reduce(function (e, n) {
                      return e.insert(n).insert("\n", t.formats());
                    }, new f.default())
                  );
                },
              },
              {
                key: "format",
                value: function (t, n) {
                  if (t !== this.statics.blotName || !n) {
                    var r = this.descendant(m.default, this.length() - 1),
                      o = a(r, 1),
                      i = o[0];
                    null != i && i.deleteAt(i.length() - 1, 1),
                      u(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "format",
                        this
                      ).call(this, t, n);
                  }
                },
              },
              {
                key: "formatAt",
                value: function (t, n, r, o) {
                  if (
                    0 !== n &&
                    null != p.default.query(r, p.default.Scope.BLOCK) &&
                    (r !== this.statics.blotName ||
                      o !== this.statics.formats(this.domNode))
                  ) {
                    var i = this.newlineIndex(t);
                    if (!(i < 0 || i >= t + n)) {
                      var l = this.newlineIndex(t, !0) + 1,
                        a = i - l + 1,
                        s = this.isolate(l, a),
                        u = s.next;
                      s.format(r, o),
                        u instanceof e && u.formatAt(0, t - l + n - a, r, o);
                    }
                  }
                },
              },
              {
                key: "insertAt",
                value: function (t, e, n) {
                  if (null == n) {
                    var r = this.descendant(m.default, t),
                      o = a(r, 2),
                      i = o[0],
                      l = o[1];
                    i.insertAt(l, e);
                  }
                },
              },
              {
                key: "length",
                value: function () {
                  var t = this.domNode.textContent.length;
                  return this.domNode.textContent.endsWith("\n") ? t : t + 1;
                },
              },
              {
                key: "newlineIndex",
                value: function (t) {
                  if (
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1]
                  )
                    return this.domNode.textContent
                      .slice(0, t)
                      .lastIndexOf("\n");
                  var e = this.domNode.textContent.slice(t).indexOf("\n");
                  return e > -1 ? t + e : -1;
                },
              },
              {
                key: "optimize",
                value: function (t) {
                  this.domNode.textContent.endsWith("\n") ||
                    this.appendChild(p.default.create("text", "\n")),
                    u(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "optimize",
                      this
                    ).call(this, t);
                  var n = this.next;
                  null != n &&
                    n.prev === this &&
                    n.statics.blotName === this.statics.blotName &&
                    this.statics.formats(this.domNode) ===
                      n.statics.formats(n.domNode) &&
                    (n.optimize(t), n.moveChildren(this), n.remove());
                },
              },
              {
                key: "replace",
                value: function (t) {
                  u(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "replace",
                    this
                  ).call(this, t),
                    [].slice
                      .call(this.domNode.querySelectorAll("*"))
                      .forEach(function (t) {
                        var e = p.default.find(t);
                        null == e
                          ? t.parentNode.removeChild(t)
                          : e instanceof p.default.Embed
                          ? e.remove()
                          : e.unwrap();
                      });
                },
              },
            ],
            [
              {
                key: "create",
                value: function (t) {
                  var n = u(
                    e.__proto__ || Object.getPrototypeOf(e),
                    "create",
                    this
                  ).call(this, t);
                  return n.setAttribute("spellcheck", !1), n;
                },
              },
              {
                key: "formats",
                value: function () {
                  return !0;
                },
              },
            ]
          ),
          e
        );
      })(y.default);
      (O.blotName = "code-block"),
        (O.tagName = "PRE"),
        (O.TAB = "  "),
        (e.Code = _),
        (e.default = O);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(0),
        u = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(s),
        c = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            l(
              e,
              [
                {
                  key: "insertInto",
                  value: function (t, n) {
                    0 === t.children.length
                      ? a(
                          e.prototype.__proto__ ||
                            Object.getPrototypeOf(e.prototype),
                          "insertInto",
                          this
                        ).call(this, t, n)
                      : this.remove();
                  },
                },
                {
                  key: "length",
                  value: function () {
                    return 0;
                  },
                },
                {
                  key: "value",
                  value: function () {
                    return "";
                  },
                },
              ],
              [{ key: "value", value: function () {} }]
            ),
            e
          );
        })(u.default.Embed);
      (c.blotName = "break"), (c.tagName = "BR"), (e.default = c);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      function l(t, e) {
        var n = document.createElement("a");
        n.href = t;
        var r = n.href.slice(0, n.href.indexOf(":"));
        return e.indexOf(r) > -1;
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.sanitize = e.default = void 0);
      var a = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        s = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        u = n(5),
        c = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(u),
        f = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            a(
              e,
              [
                {
                  key: "format",
                  value: function (t, n) {
                    if (t !== this.statics.blotName || !n)
                      return s(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "format",
                        this
                      ).call(this, t, n);
                    (n = this.constructor.sanitize(n)),
                      this.domNode.setAttribute("href", n);
                  },
                },
              ],
              [
                {
                  key: "create",
                  value: function (t) {
                    var n = s(
                      e.__proto__ || Object.getPrototypeOf(e),
                      "create",
                      this
                    ).call(this, t);
                    return (
                      (t = this.sanitize(t)),
                      n.setAttribute("href", t),
                      n.setAttribute("rel", "noopener noreferrer"),
                      n.setAttribute("target", "_blank"),
                      n
                    );
                  },
                },
                {
                  key: "formats",
                  value: function (t) {
                    return t.getAttribute("href");
                  },
                },
                {
                  key: "sanitize",
                  value: function (t) {
                    return l(t, this.PROTOCOL_WHITELIST)
                      ? t
                      : this.SANITIZED_URL;
                  },
                },
              ]
            ),
            e
          );
        })(c.default);
      (f.blotName = "link"),
        (f.tagName = "A"),
        (f.SANITIZED_URL = "about:blank"),
        (f.PROTOCOL_WHITELIST = ["http", "https", "mailto", "tel"]),
        (e.default = f),
        (e.sanitize = l);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        t.setAttribute(e, !("true" === t.getAttribute(e)));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              },
        a = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        s = n(25),
        u = r(s),
        c = n(106),
        f = r(c),
        h = 0,
        p = (function () {
          function t(e) {
            var n = this;
            o(this, t),
              (this.select = e),
              (this.container = document.createElement("span")),
              this.buildPicker(),
              (this.select.style.display = "none"),
              this.select.parentNode.insertBefore(this.container, this.select),
              this.label.addEventListener("mousedown", function () {
                n.togglePicker();
              }),
              this.label.addEventListener("keydown", function (t) {
                switch (t.keyCode) {
                  case u.default.keys.ENTER:
                    n.togglePicker();
                    break;
                  case u.default.keys.ESCAPE:
                    n.escape(), t.preventDefault();
                }
              }),
              this.select.addEventListener("change", this.update.bind(this));
          }
          return (
            a(t, [
              {
                key: "togglePicker",
                value: function () {
                  this.container.classList.toggle("ql-expanded"),
                    i(this.label, "aria-expanded"),
                    i(this.options, "aria-hidden");
                },
              },
              {
                key: "buildItem",
                value: function (t) {
                  var e = this,
                    n = document.createElement("span");
                  return (
                    (n.tabIndex = "0"),
                    n.setAttribute("role", "button"),
                    n.classList.add("ql-picker-item"),
                    t.hasAttribute("value") &&
                      n.setAttribute("data-value", t.getAttribute("value")),
                    t.textContent &&
                      n.setAttribute("data-label", t.textContent),
                    n.addEventListener("click", function () {
                      e.selectItem(n, !0);
                    }),
                    n.addEventListener("keydown", function (t) {
                      switch (t.keyCode) {
                        case u.default.keys.ENTER:
                          e.selectItem(n, !0), t.preventDefault();
                          break;
                        case u.default.keys.ESCAPE:
                          e.escape(), t.preventDefault();
                      }
                    }),
                    n
                  );
                },
              },
              {
                key: "buildLabel",
                value: function () {
                  var t = document.createElement("span");
                  return (
                    t.classList.add("ql-picker-label"),
                    (t.innerHTML = f.default),
                    (t.tabIndex = "0"),
                    t.setAttribute("role", "button"),
                    t.setAttribute("aria-expanded", "false"),
                    this.container.appendChild(t),
                    t
                  );
                },
              },
              {
                key: "buildOptions",
                value: function () {
                  var t = this,
                    e = document.createElement("span");
                  e.classList.add("ql-picker-options"),
                    e.setAttribute("aria-hidden", "true"),
                    (e.tabIndex = "-1"),
                    (e.id = "ql-picker-options-" + h),
                    (h += 1),
                    this.label.setAttribute("aria-controls", e.id),
                    (this.options = e),
                    [].slice.call(this.select.options).forEach(function (n) {
                      var r = t.buildItem(n);
                      e.appendChild(r), !0 === n.selected && t.selectItem(r);
                    }),
                    this.container.appendChild(e);
                },
              },
              {
                key: "buildPicker",
                value: function () {
                  var t = this;
                  [].slice.call(this.select.attributes).forEach(function (e) {
                    t.container.setAttribute(e.name, e.value);
                  }),
                    this.container.classList.add("ql-picker"),
                    (this.label = this.buildLabel()),
                    this.buildOptions();
                },
              },
              {
                key: "escape",
                value: function () {
                  var t = this;
                  this.close(),
                    setTimeout(function () {
                      return t.label.focus();
                    }, 1);
                },
              },
              {
                key: "close",
                value: function () {
                  this.container.classList.remove("ql-expanded"),
                    this.label.setAttribute("aria-expanded", "false"),
                    this.options.setAttribute("aria-hidden", "true");
                },
              },
              {
                key: "selectItem",
                value: function (t) {
                  var e =
                      arguments.length > 1 &&
                      void 0 !== arguments[1] &&
                      arguments[1],
                    n = this.container.querySelector(".ql-selected");
                  if (
                    t !== n &&
                    (null != n && n.classList.remove("ql-selected"),
                    null != t &&
                      (t.classList.add("ql-selected"),
                      (this.select.selectedIndex = [].indexOf.call(
                        t.parentNode.children,
                        t
                      )),
                      t.hasAttribute("data-value")
                        ? this.label.setAttribute(
                            "data-value",
                            t.getAttribute("data-value")
                          )
                        : this.label.removeAttribute("data-value"),
                      t.hasAttribute("data-label")
                        ? this.label.setAttribute(
                            "data-label",
                            t.getAttribute("data-label")
                          )
                        : this.label.removeAttribute("data-label"),
                      e))
                  ) {
                    if ("function" == typeof Event)
                      this.select.dispatchEvent(new Event("change"));
                    else if (
                      "object" ===
                      ("undefined" == typeof Event ? "undefined" : l(Event))
                    ) {
                      var r = document.createEvent("Event");
                      r.initEvent("change", !0, !0),
                        this.select.dispatchEvent(r);
                    }
                    this.close();
                  }
                },
              },
              {
                key: "update",
                value: function () {
                  var t = void 0;
                  if (this.select.selectedIndex > -1) {
                    var e = this.container.querySelector(".ql-picker-options")
                      .children[this.select.selectedIndex];
                    (t = this.select.options[this.select.selectedIndex]),
                      this.selectItem(e);
                  } else this.selectItem(null);
                  var n =
                    null != t &&
                    t !== this.select.querySelector("option[selected]");
                  this.label.classList.toggle("ql-active", n);
                },
              },
            ]),
            t
          );
        })();
      e.default = p;
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        var e = a.find(t);
        if (null == e)
          try {
            e = a.create(t);
          } catch (n) {
            (e = a.create(a.Scope.INLINE)),
              [].slice.call(t.childNodes).forEach(function (t) {
                e.domNode.appendChild(t);
              }),
              t.parentNode && t.parentNode.replaceChild(e.domNode, t),
              e.attach();
          }
        return e;
      }
      var o =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var i = n(47),
        l = n(27),
        a = n(1),
        s = (function (t) {
          function e(e) {
            var n = t.call(this, e) || this;
            return n.build(), n;
          }
          return (
            o(e, t),
            (e.prototype.appendChild = function (t) {
              this.insertBefore(t);
            }),
            (e.prototype.attach = function () {
              t.prototype.attach.call(this),
                this.children.forEach(function (t) {
                  t.attach();
                });
            }),
            (e.prototype.build = function () {
              var t = this;
              (this.children = new i.default()),
                [].slice
                  .call(this.domNode.childNodes)
                  .reverse()
                  .forEach(function (e) {
                    try {
                      var n = r(e);
                      t.insertBefore(n, t.children.head || void 0);
                    } catch (t) {
                      if (t instanceof a.ParchmentError) return;
                      throw t;
                    }
                  });
            }),
            (e.prototype.deleteAt = function (t, e) {
              if (0 === t && e === this.length()) return this.remove();
              this.children.forEachAt(t, e, function (t, e, n) {
                t.deleteAt(e, n);
              });
            }),
            (e.prototype.descendant = function (t, n) {
              var r = this.children.find(n),
                o = r[0],
                i = r[1];
              return (null == t.blotName && t(o)) ||
                (null != t.blotName && o instanceof t)
                ? [o, i]
                : o instanceof e
                ? o.descendant(t, i)
                : [null, -1];
            }),
            (e.prototype.descendants = function (t, n, r) {
              void 0 === n && (n = 0), void 0 === r && (r = Number.MAX_VALUE);
              var o = [],
                i = r;
              return (
                this.children.forEachAt(n, r, function (n, r, l) {
                  ((null == t.blotName && t(n)) ||
                    (null != t.blotName && n instanceof t)) &&
                    o.push(n),
                    n instanceof e && (o = o.concat(n.descendants(t, r, i))),
                    (i -= l);
                }),
                o
              );
            }),
            (e.prototype.detach = function () {
              this.children.forEach(function (t) {
                t.detach();
              }),
                t.prototype.detach.call(this);
            }),
            (e.prototype.formatAt = function (t, e, n, r) {
              this.children.forEachAt(t, e, function (t, e, o) {
                t.formatAt(e, o, n, r);
              });
            }),
            (e.prototype.insertAt = function (t, e, n) {
              var r = this.children.find(t),
                o = r[0],
                i = r[1];
              if (o) o.insertAt(i, e, n);
              else {
                var l = null == n ? a.create("text", e) : a.create(e, n);
                this.appendChild(l);
              }
            }),
            (e.prototype.insertBefore = function (t, e) {
              if (
                null != this.statics.allowedChildren &&
                !this.statics.allowedChildren.some(function (e) {
                  return t instanceof e;
                })
              )
                throw new a.ParchmentError(
                  "Cannot insert " +
                    t.statics.blotName +
                    " into " +
                    this.statics.blotName
                );
              t.insertInto(this, e);
            }),
            (e.prototype.length = function () {
              return this.children.reduce(function (t, e) {
                return t + e.length();
              }, 0);
            }),
            (e.prototype.moveChildren = function (t, e) {
              this.children.forEach(function (n) {
                t.insertBefore(n, e);
              });
            }),
            (e.prototype.optimize = function (e) {
              if (
                (t.prototype.optimize.call(this, e), 0 === this.children.length)
              )
                if (null != this.statics.defaultChild) {
                  var n = a.create(this.statics.defaultChild);
                  this.appendChild(n), n.optimize(e);
                } else this.remove();
            }),
            (e.prototype.path = function (t, n) {
              void 0 === n && (n = !1);
              var r = this.children.find(t, n),
                o = r[0],
                i = r[1],
                l = [[this, t]];
              return o instanceof e
                ? l.concat(o.path(i, n))
                : (null != o && l.push([o, i]), l);
            }),
            (e.prototype.removeChild = function (t) {
              this.children.remove(t);
            }),
            (e.prototype.replace = function (n) {
              n instanceof e && n.moveChildren(this),
                t.prototype.replace.call(this, n);
            }),
            (e.prototype.split = function (t, e) {
              if ((void 0 === e && (e = !1), !e)) {
                if (0 === t) return this;
                if (t === this.length()) return this.next;
              }
              var n = this.clone();
              return (
                this.parent.insertBefore(n, this.next),
                this.children.forEachAt(t, this.length(), function (t, r, o) {
                  (t = t.split(r, e)), n.appendChild(t);
                }),
                n
              );
            }),
            (e.prototype.unwrap = function () {
              this.moveChildren(this.parent, this.next), this.remove();
            }),
            (e.prototype.update = function (t, e) {
              var n = this,
                o = [],
                i = [];
              t.forEach(function (t) {
                t.target === n.domNode &&
                  "childList" === t.type &&
                  (o.push.apply(o, t.addedNodes),
                  i.push.apply(i, t.removedNodes));
              }),
                i.forEach(function (t) {
                  if (
                    !(
                      null != t.parentNode &&
                      "IFRAME" !== t.tagName &&
                      document.body.compareDocumentPosition(t) &
                        Node.DOCUMENT_POSITION_CONTAINED_BY
                    )
                  ) {
                    var e = a.find(t);
                    null != e &&
                      ((null != e.domNode.parentNode &&
                        e.domNode.parentNode !== n.domNode) ||
                        e.detach());
                  }
                }),
                o
                  .filter(function (t) {
                    return t.parentNode == n.domNode;
                  })
                  .sort(function (t, e) {
                    return t === e
                      ? 0
                      : t.compareDocumentPosition(e) &
                        Node.DOCUMENT_POSITION_FOLLOWING
                      ? 1
                      : -1;
                  })
                  .forEach(function (t) {
                    var e = null;
                    null != t.nextSibling && (e = a.find(t.nextSibling));
                    var o = r(t);
                    (o.next == e && null != o.next) ||
                      (null != o.parent && o.parent.removeChild(n),
                      n.insertBefore(o, e || void 0));
                  });
            }),
            e
          );
        })(l.default);
      e.default = s;
    },
    function (t, e, n) {
      "use strict";
      var r =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = n(11),
        i = n(28),
        l = n(17),
        a = n(1),
        s = (function (t) {
          function e(e) {
            var n = t.call(this, e) || this;
            return (n.attributes = new i.default(n.domNode)), n;
          }
          return (
            r(e, t),
            (e.formats = function (t) {
              return (
                "string" == typeof this.tagName ||
                (Array.isArray(this.tagName) ? t.tagName.toLowerCase() : void 0)
              );
            }),
            (e.prototype.format = function (t, e) {
              var n = a.query(t);
              n instanceof o.default
                ? this.attributes.attribute(n, e)
                : e &&
                  (null == n ||
                    (t === this.statics.blotName && this.formats()[t] === e) ||
                    this.replaceWith(t, e));
            }),
            (e.prototype.formats = function () {
              var t = this.attributes.values(),
                e = this.statics.formats(this.domNode);
              return null != e && (t[this.statics.blotName] = e), t;
            }),
            (e.prototype.replaceWith = function (e, n) {
              var r = t.prototype.replaceWith.call(this, e, n);
              return this.attributes.copy(r), r;
            }),
            (e.prototype.update = function (e, n) {
              var r = this;
              t.prototype.update.call(this, e, n),
                e.some(function (t) {
                  return t.target === r.domNode && "attributes" === t.type;
                }) && this.attributes.build();
            }),
            (e.prototype.wrap = function (n, r) {
              var o = t.prototype.wrap.call(this, n, r);
              return (
                o instanceof e &&
                  o.statics.scope === this.statics.scope &&
                  this.attributes.move(o),
                o
              );
            }),
            e
          );
        })(l.default);
      e.default = s;
    },
    function (t, e, n) {
      "use strict";
      var r =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = n(27),
        i = n(1),
        l = (function (t) {
          function e() {
            return (null !== t && t.apply(this, arguments)) || this;
          }
          return (
            r(e, t),
            (e.value = function (t) {
              return !0;
            }),
            (e.prototype.index = function (t, e) {
              return this.domNode === t ||
                this.domNode.compareDocumentPosition(t) &
                  Node.DOCUMENT_POSITION_CONTAINED_BY
                ? Math.min(e, 1)
                : -1;
            }),
            (e.prototype.position = function (t, e) {
              var n = [].indexOf.call(
                this.parent.domNode.childNodes,
                this.domNode
              );
              return t > 0 && (n += 1), [this.parent.domNode, n];
            }),
            (e.prototype.value = function () {
              var t;
              return (
                (t = {}),
                (t[this.statics.blotName] =
                  this.statics.value(this.domNode) || !0),
                t
              );
            }),
            (e.scope = i.Scope.INLINE_BLOT),
            e
          );
        })(o.default);
      e.default = l;
    },
    function (t, e, n) {
      function r(t) {
        (this.ops = t), (this.index = 0), (this.offset = 0);
      }
      var o = n(12),
        i = n(2),
        l = {
          attributes: {
            compose: function (t, e, n) {
              "object" != typeof t && (t = {}),
                "object" != typeof e && (e = {});
              var r = i(!0, {}, e);
              n ||
                (r = Object.keys(r).reduce(function (t, e) {
                  return null != r[e] && (t[e] = r[e]), t;
                }, {}));
              for (var o in t)
                void 0 !== t[o] && void 0 === e[o] && (r[o] = t[o]);
              return Object.keys(r).length > 0 ? r : void 0;
            },
            diff: function (t, e) {
              "object" != typeof t && (t = {}),
                "object" != typeof e && (e = {});
              var n = Object.keys(t)
                .concat(Object.keys(e))
                .reduce(function (n, r) {
                  return (
                    o(t[r], e[r]) || (n[r] = void 0 === e[r] ? null : e[r]), n
                  );
                }, {});
              return Object.keys(n).length > 0 ? n : void 0;
            },
            transform: function (t, e, n) {
              if ("object" != typeof t) return e;
              if ("object" == typeof e) {
                if (!n) return e;
                var r = Object.keys(e).reduce(function (n, r) {
                  return void 0 === t[r] && (n[r] = e[r]), n;
                }, {});
                return Object.keys(r).length > 0 ? r : void 0;
              }
            },
          },
          iterator: function (t) {
            return new r(t);
          },
          length: function (t) {
            return "number" == typeof t.delete
              ? t.delete
              : "number" == typeof t.retain
              ? t.retain
              : "string" == typeof t.insert
              ? t.insert.length
              : 1;
          },
        };
      (r.prototype.hasNext = function () {
        return this.peekLength() < 1 / 0;
      }),
        (r.prototype.next = function (t) {
          t || (t = 1 / 0);
          var e = this.ops[this.index];
          if (e) {
            var n = this.offset,
              r = l.length(e);
            if (
              (t >= r - n
                ? ((t = r - n), (this.index += 1), (this.offset = 0))
                : (this.offset += t),
              "number" == typeof e.delete)
            )
              return { delete: t };
            var o = {};
            return (
              e.attributes && (o.attributes = e.attributes),
              "number" == typeof e.retain
                ? (o.retain = t)
                : "string" == typeof e.insert
                ? (o.insert = e.insert.substr(n, t))
                : (o.insert = e.insert),
              o
            );
          }
          return { retain: 1 / 0 };
        }),
        (r.prototype.peek = function () {
          return this.ops[this.index];
        }),
        (r.prototype.peekLength = function () {
          return this.ops[this.index]
            ? l.length(this.ops[this.index]) - this.offset
            : 1 / 0;
        }),
        (r.prototype.peekType = function () {
          return this.ops[this.index]
            ? "number" == typeof this.ops[this.index].delete
              ? "delete"
              : "number" == typeof this.ops[this.index].retain
              ? "retain"
              : "insert"
            : "retain";
        }),
        (r.prototype.rest = function () {
          if (this.hasNext()) {
            if (0 === this.offset) return this.ops.slice(this.index);
            var t = this.offset,
              e = this.index,
              n = this.next(),
              r = this.ops.slice(this.index);
            return (this.offset = t), (this.index = e), [n].concat(r);
          }
          return [];
        }),
        (t.exports = l);
    },
    function (t, e) {
      var n = (function () {
        "use strict";
        function t(t, e) {
          return null != e && t instanceof e;
        }
        function e(n, r, o, i, c) {
          function f(n, o) {
            if (null === n) return null;
            if (0 === o) return n;
            var y, v;
            if ("object" != typeof n) return n;
            if (t(n, a)) y = new a();
            else if (t(n, s)) y = new s();
            else if (t(n, u))
              y = new u(function (t, e) {
                n.then(
                  function (e) {
                    t(f(e, o - 1));
                  },
                  function (t) {
                    e(f(t, o - 1));
                  }
                );
              });
            else if (e.__isArray(n)) y = [];
            else if (e.__isRegExp(n))
              (y = new RegExp(n.source, l(n))),
                n.lastIndex && (y.lastIndex = n.lastIndex);
            else if (e.__isDate(n)) y = new Date(n.getTime());
            else {
              if (d && Buffer.isBuffer(n))
                return (
                  (y = Buffer.allocUnsafe
                    ? Buffer.allocUnsafe(n.length)
                    : new Buffer(n.length)),
                  n.copy(y),
                  y
                );
              t(n, Error)
                ? (y = Object.create(n))
                : void 0 === i
                ? ((v = Object.getPrototypeOf(n)), (y = Object.create(v)))
                : ((y = Object.create(i)), (v = i));
            }
            if (r) {
              var b = h.indexOf(n);
              if (-1 != b) return p[b];
              h.push(n), p.push(y);
            }
            t(n, a) &&
              n.forEach(function (t, e) {
                var n = f(e, o - 1),
                  r = f(t, o - 1);
                y.set(n, r);
              }),
              t(n, s) &&
                n.forEach(function (t) {
                  var e = f(t, o - 1);
                  y.add(e);
                });
            for (var g in n) {
              var m;
              v && (m = Object.getOwnPropertyDescriptor(v, g)),
                (m && null == m.set) || (y[g] = f(n[g], o - 1));
            }
            if (Object.getOwnPropertySymbols)
              for (
                var _ = Object.getOwnPropertySymbols(n), g = 0;
                g < _.length;
                g++
              ) {
                var O = _[g],
                  w = Object.getOwnPropertyDescriptor(n, O);
                (!w || w.enumerable || c) &&
                  ((y[O] = f(n[O], o - 1)),
                  w.enumerable ||
                    Object.defineProperty(y, O, { enumerable: !1 }));
              }
            if (c)
              for (
                var x = Object.getOwnPropertyNames(n), g = 0;
                g < x.length;
                g++
              ) {
                var k = x[g],
                  w = Object.getOwnPropertyDescriptor(n, k);
                (w && w.enumerable) ||
                  ((y[k] = f(n[k], o - 1)),
                  Object.defineProperty(y, k, { enumerable: !1 }));
              }
            return y;
          }
          "object" == typeof r &&
            ((o = r.depth),
            (i = r.prototype),
            (c = r.includeNonEnumerable),
            (r = r.circular));
          var h = [],
            p = [],
            d = "undefined" != typeof Buffer;
          return void 0 === r && (r = !0), void 0 === o && (o = 1 / 0), f(n, o);
        }
        function n(t) {
          return Object.prototype.toString.call(t);
        }
        function r(t) {
          return "object" == typeof t && "[object Date]" === n(t);
        }
        function o(t) {
          return "object" == typeof t && "[object Array]" === n(t);
        }
        function i(t) {
          return "object" == typeof t && "[object RegExp]" === n(t);
        }
        function l(t) {
          var e = "";
          return (
            t.global && (e += "g"),
            t.ignoreCase && (e += "i"),
            t.multiline && (e += "m"),
            e
          );
        }
        var a;
        try {
          a = Map;
        } catch (t) {
          a = function () {};
        }
        var s;
        try {
          s = Set;
        } catch (t) {
          s = function () {};
        }
        var u;
        try {
          u = Promise;
        } catch (t) {
          u = function () {};
        }
        return (
          (e.clonePrototype = function (t) {
            if (null === t) return null;
            var e = function () {};
            return (e.prototype = t), new e();
          }),
          (e.__objToStr = n),
          (e.__isDate = r),
          (e.__isArray = o),
          (e.__isRegExp = i),
          (e.__getRegExpFlags = l),
          e
        );
      })();
      "object" == typeof t && t.exports && (t.exports = n);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = Array(t.length); e < t.length; e++) n[e] = t[e];
          return n;
        }
        return Array.from(t);
      }
      function i(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function l(t, e) {
        try {
          e.parentNode;
        } catch (t) {
          return !1;
        }
        return e instanceof Text && (e = e.parentNode), t.contains(e);
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = e.Range = void 0);
      var a = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        s = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        u = n(0),
        c = r(u),
        f = n(21),
        h = r(f),
        p = n(12),
        d = r(p),
        y = n(9),
        v = r(y),
        b = n(10),
        g = r(b),
        m = (0, g.default)("quill:selection"),
        _ = function t(e) {
          var n =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          i(this, t), (this.index = e), (this.length = n);
        },
        O = (function () {
          function t(e, n) {
            var r = this;
            i(this, t),
              (this.emitter = n),
              (this.scroll = e),
              (this.composing = !1),
              (this.mouseDown = !1),
              (this.root = this.scroll.domNode),
              (this.cursor = c.default.create("cursor", this)),
              (this.lastRange = this.savedRange = new _(0, 0)),
              this.handleComposition(),
              this.handleDragging(),
              this.emitter.listenDOM("selectionchange", document, function () {
                r.mouseDown ||
                  setTimeout(r.update.bind(r, v.default.sources.USER), 1);
              }),
              this.emitter.on(v.default.events.EDITOR_CHANGE, function (t, e) {
                t === v.default.events.TEXT_CHANGE &&
                  e.length() > 0 &&
                  r.update(v.default.sources.SILENT);
              }),
              this.emitter.on(
                v.default.events.SCROLL_BEFORE_UPDATE,
                function () {
                  if (r.hasFocus()) {
                    var t = r.getNativeRange();
                    null != t &&
                      t.start.node !== r.cursor.textNode &&
                      r.emitter.once(
                        v.default.events.SCROLL_UPDATE,
                        function () {
                          try {
                            r.setNativeRange(
                              t.start.node,
                              t.start.offset,
                              t.end.node,
                              t.end.offset
                            );
                          } catch (t) {}
                        }
                      );
                  }
                }
              ),
              this.emitter.on(v.default.events.SCROLL_OPTIMIZE, function (
                t,
                e
              ) {
                if (e.range) {
                  var n = e.range,
                    o = n.startNode,
                    i = n.startOffset,
                    l = n.endNode,
                    a = n.endOffset;
                  r.setNativeRange(o, i, l, a);
                }
              }),
              this.update(v.default.sources.SILENT);
          }
          return (
            s(t, [
              {
                key: "handleComposition",
                value: function () {
                  var t = this;
                  this.root.addEventListener("compositionstart", function () {
                    t.composing = !0;
                  }),
                    this.root.addEventListener("compositionend", function () {
                      if (((t.composing = !1), t.cursor.parent)) {
                        var e = t.cursor.restore();
                        if (!e) return;
                        setTimeout(function () {
                          t.setNativeRange(
                            e.startNode,
                            e.startOffset,
                            e.endNode,
                            e.endOffset
                          );
                        }, 1);
                      }
                    });
                },
              },
              {
                key: "handleDragging",
                value: function () {
                  var t = this;
                  this.emitter.listenDOM(
                    "mousedown",
                    document.body,
                    function () {
                      t.mouseDown = !0;
                    }
                  ),
                    this.emitter.listenDOM(
                      "mouseup",
                      document.body,
                      function () {
                        (t.mouseDown = !1), t.update(v.default.sources.USER);
                      }
                    );
                },
              },
              {
                key: "focus",
                value: function () {
                  this.hasFocus() ||
                    (this.root.focus(), this.setRange(this.savedRange));
                },
              },
              {
                key: "format",
                value: function (t, e) {
                  if (
                    null == this.scroll.whitelist ||
                    this.scroll.whitelist[t]
                  ) {
                    this.scroll.update();
                    var n = this.getNativeRange();
                    if (
                      null != n &&
                      n.native.collapsed &&
                      !c.default.query(t, c.default.Scope.BLOCK)
                    ) {
                      if (n.start.node !== this.cursor.textNode) {
                        var r = c.default.find(n.start.node, !1);
                        if (null == r) return;
                        if (r instanceof c.default.Leaf) {
                          var o = r.split(n.start.offset);
                          r.parent.insertBefore(this.cursor, o);
                        } else r.insertBefore(this.cursor, n.start.node);
                        this.cursor.attach();
                      }
                      this.cursor.format(t, e),
                        this.scroll.optimize(),
                        this.setNativeRange(
                          this.cursor.textNode,
                          this.cursor.textNode.data.length
                        ),
                        this.update();
                    }
                  }
                },
              },
              {
                key: "getBounds",
                value: function (t) {
                  var e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : 0,
                    n = this.scroll.length();
                  (t = Math.min(t, n - 1)), (e = Math.min(t + e, n - 1) - t);
                  var r = void 0,
                    o = this.scroll.leaf(t),
                    i = a(o, 2),
                    l = i[0],
                    s = i[1];
                  if (null == l) return null;
                  var u = l.position(s, !0),
                    c = a(u, 2);
                  (r = c[0]), (s = c[1]);
                  var f = document.createRange();
                  if (e > 0) {
                    f.setStart(r, s);
                    var h = this.scroll.leaf(t + e),
                      p = a(h, 2);
                    if (((l = p[0]), (s = p[1]), null == l)) return null;
                    var d = l.position(s, !0),
                      y = a(d, 2);
                    return (
                      (r = y[0]),
                      (s = y[1]),
                      f.setEnd(r, s),
                      f.getBoundingClientRect()
                    );
                  }
                  var v = "left",
                    b = void 0;
                  return (
                    r instanceof Text
                      ? (s < r.data.length
                          ? (f.setStart(r, s), f.setEnd(r, s + 1))
                          : (f.setStart(r, s - 1),
                            f.setEnd(r, s),
                            (v = "right")),
                        (b = f.getBoundingClientRect()))
                      : ((b = l.domNode.getBoundingClientRect()),
                        s > 0 && (v = "right")),
                    {
                      bottom: b.top + b.height,
                      height: b.height,
                      left: b[v],
                      right: b[v],
                      top: b.top,
                      width: 0,
                    }
                  );
                },
              },
              {
                key: "getNativeRange",
                value: function () {
                  var t = document.getSelection();
                  if (null == t || t.rangeCount <= 0) return null;
                  var e = t.getRangeAt(0);
                  if (null == e) return null;
                  var n = this.normalizeNative(e);
                  return m.info("getNativeRange", n), n;
                },
              },
              {
                key: "getRange",
                value: function () {
                  var t = this.getNativeRange();
                  return null == t
                    ? [null, null]
                    : [this.normalizedToRange(t), t];
                },
              },
              {
                key: "hasFocus",
                value: function () {
                  return document.activeElement === this.root;
                },
              },
              {
                key: "normalizedToRange",
                value: function (t) {
                  var e = this,
                    n = [[t.start.node, t.start.offset]];
                  t.native.collapsed || n.push([t.end.node, t.end.offset]);
                  var r = n.map(function (t) {
                      var n = a(t, 2),
                        r = n[0],
                        o = n[1],
                        i = c.default.find(r, !0),
                        l = i.offset(e.scroll);
                      return 0 === o
                        ? l
                        : i instanceof c.default.Container
                        ? l + i.length()
                        : l + i.index(r, o);
                    }),
                    i = Math.min(
                      Math.max.apply(Math, o(r)),
                      this.scroll.length() - 1
                    ),
                    l = Math.min.apply(Math, [i].concat(o(r)));
                  return new _(l, i - l);
                },
              },
              {
                key: "normalizeNative",
                value: function (t) {
                  if (
                    !l(this.root, t.startContainer) ||
                    (!t.collapsed && !l(this.root, t.endContainer))
                  )
                    return null;
                  var e = {
                    start: { node: t.startContainer, offset: t.startOffset },
                    end: { node: t.endContainer, offset: t.endOffset },
                    native: t,
                  };
                  return (
                    [e.start, e.end].forEach(function (t) {
                      for (
                        var e = t.node, n = t.offset;
                        !(e instanceof Text) && e.childNodes.length > 0;

                      )
                        if (e.childNodes.length > n)
                          (e = e.childNodes[n]), (n = 0);
                        else {
                          if (e.childNodes.length !== n) break;
                          (e = e.lastChild),
                            (n =
                              e instanceof Text
                                ? e.data.length
                                : e.childNodes.length + 1);
                        }
                      (t.node = e), (t.offset = n);
                    }),
                    e
                  );
                },
              },
              {
                key: "rangeToNative",
                value: function (t) {
                  var e = this,
                    n = t.collapsed ? [t.index] : [t.index, t.index + t.length],
                    r = [],
                    o = this.scroll.length();
                  return (
                    n.forEach(function (t, n) {
                      t = Math.min(o - 1, t);
                      var i = void 0,
                        l = e.scroll.leaf(t),
                        s = a(l, 2),
                        u = s[0],
                        c = s[1],
                        f = u.position(c, 0 !== n),
                        h = a(f, 2);
                      (i = h[0]), (c = h[1]), r.push(i, c);
                    }),
                    r.length < 2 && (r = r.concat(r)),
                    r
                  );
                },
              },
              {
                key: "scrollIntoView",
                value: function (t) {
                  var e = this.lastRange;
                  if (null != e) {
                    var n = this.getBounds(e.index, e.length);
                    if (null != n) {
                      var r = this.scroll.length() - 1,
                        o = this.scroll.line(Math.min(e.index, r)),
                        i = a(o, 1),
                        l = i[0],
                        s = l;
                      if (e.length > 0) {
                        var u = this.scroll.line(
                          Math.min(e.index + e.length, r)
                        );
                        s = a(u, 1)[0];
                      }
                      if (null != l && null != s) {
                        var c = t.getBoundingClientRect();
                        n.top < c.top
                          ? (t.scrollTop -= c.top - n.top)
                          : n.bottom > c.bottom &&
                            (t.scrollTop += n.bottom - c.bottom);
                      }
                    }
                  }
                },
              },
              {
                key: "setNativeRange",
                value: function (t, e) {
                  var n =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : t,
                    r =
                      arguments.length > 3 && void 0 !== arguments[3]
                        ? arguments[3]
                        : e,
                    o =
                      arguments.length > 4 &&
                      void 0 !== arguments[4] &&
                      arguments[4];
                  if (
                    (m.info("setNativeRange", t, e, n, r),
                    null == t ||
                      (null != this.root.parentNode &&
                        null != t.parentNode &&
                        null != n.parentNode))
                  ) {
                    var i = document.getSelection();
                    if (null != i)
                      if (null != t) {
                        this.hasFocus() || this.root.focus();
                        var l = (this.getNativeRange() || {}).native;
                        if (
                          null == l ||
                          o ||
                          t !== l.startContainer ||
                          e !== l.startOffset ||
                          n !== l.endContainer ||
                          r !== l.endOffset
                        ) {
                          "BR" == t.tagName &&
                            ((e = [].indexOf.call(t.parentNode.childNodes, t)),
                            (t = t.parentNode)),
                            "BR" == n.tagName &&
                              ((r = [].indexOf.call(
                                n.parentNode.childNodes,
                                n
                              )),
                              (n = n.parentNode));
                          var a = document.createRange();
                          a.setStart(t, e),
                            a.setEnd(n, r),
                            i.removeAllRanges(),
                            i.addRange(a);
                        }
                      } else
                        i.removeAllRanges(),
                          this.root.blur(),
                          document.body.focus();
                  }
                },
              },
              {
                key: "setRange",
                value: function (t) {
                  var e =
                      arguments.length > 1 &&
                      void 0 !== arguments[1] &&
                      arguments[1],
                    n =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : v.default.sources.API;
                  if (
                    ("string" == typeof e && ((n = e), (e = !1)),
                    m.info("setRange", t),
                    null != t)
                  ) {
                    var r = this.rangeToNative(t);
                    this.setNativeRange.apply(this, o(r).concat([e]));
                  } else this.setNativeRange(null);
                  this.update(n);
                },
              },
              {
                key: "update",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : v.default.sources.USER,
                    e = this.lastRange,
                    n = this.getRange(),
                    r = a(n, 2),
                    o = r[0],
                    i = r[1];
                  if (
                    ((this.lastRange = o),
                    null != this.lastRange &&
                      (this.savedRange = this.lastRange),
                    !(0, d.default)(e, this.lastRange))
                  ) {
                    var l;
                    !this.composing &&
                      null != i &&
                      i.native.collapsed &&
                      i.start.node !== this.cursor.textNode &&
                      this.cursor.restore();
                    var s = [
                      v.default.events.SELECTION_CHANGE,
                      (0, h.default)(this.lastRange),
                      (0, h.default)(e),
                      t,
                    ];
                    if (
                      ((l = this.emitter).emit.apply(
                        l,
                        [v.default.events.EDITOR_CHANGE].concat(s)
                      ),
                      t !== v.default.sources.SILENT)
                    ) {
                      var u;
                      (u = this.emitter).emit.apply(u, s);
                    }
                  }
                },
              },
            ]),
            t
          );
        })();
      (e.Range = _), (e.default = O);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var a = n(0),
        s = r(a),
        u = n(3),
        c = r(u),
        f = (function (t) {
          function e() {
            return (
              o(this, e),
              i(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return l(e, t), e;
        })(s.default.Container);
      (f.allowedChildren = [c.default, u.BlockEmbed, f]), (e.default = f);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.ColorStyle = e.ColorClass = e.ColorAttributor = void 0);
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(0),
        u = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(s),
        c = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            l(e, [
              {
                key: "value",
                value: function (t) {
                  var n = a(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "value",
                    this
                  ).call(this, t);
                  return n.startsWith("rgb(")
                    ? ((n = n.replace(/^[^\d]+/, "").replace(/[^\d]+$/, "")),
                      "#" +
                        n
                          .split(",")
                          .map(function (t) {
                            return ("00" + parseInt(t).toString(16)).slice(-2);
                          })
                          .join(""))
                    : n;
                },
              },
            ]),
            e
          );
        })(u.default.Attributor.Style),
        f = new u.default.Attributor.Class("color", "ql-color", {
          scope: u.default.Scope.INLINE,
        }),
        h = new c("color", "color", { scope: u.default.Scope.INLINE });
      (e.ColorAttributor = c), (e.ColorClass = f), (e.ColorStyle = h);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function i(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function l(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function a(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      function s(t, e) {
        var n,
          r = t === D.keys.LEFT ? "prefix" : "suffix";
        return (
          (n = { key: t, shiftKey: e, altKey: null }),
          o(n, r, /^$/),
          o(n, "handler", function (n) {
            var r = n.index;
            t === D.keys.RIGHT && (r += n.length + 1);
            var o = this.quill.getLeaf(r);
            return (
              !(b(o, 1)[0] instanceof T.default.Embed) ||
              (t === D.keys.LEFT
                ? e
                  ? this.quill.setSelection(
                      n.index - 1,
                      n.length + 1,
                      S.default.sources.USER
                    )
                  : this.quill.setSelection(n.index - 1, S.default.sources.USER)
                : e
                ? this.quill.setSelection(
                    n.index,
                    n.length + 1,
                    S.default.sources.USER
                  )
                : this.quill.setSelection(
                    n.index + n.length + 1,
                    S.default.sources.USER
                  ),
              !1)
            );
          }),
          n
        );
      }
      function u(t, e) {
        if (!(0 === t.index || this.quill.getLength() <= 1)) {
          var n = this.quill.getLine(t.index),
            r = b(n, 1),
            o = r[0],
            i = {};
          if (0 === e.offset) {
            var l = this.quill.getLine(t.index - 1),
              a = b(l, 1),
              s = a[0];
            if (null != s && s.length() > 1) {
              var u = o.formats(),
                c = this.quill.getFormat(t.index - 1, 1);
              i = A.default.attributes.diff(u, c) || {};
            }
          }
          var f = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(e.prefix) ? 2 : 1;
          this.quill.deleteText(t.index - f, f, S.default.sources.USER),
            Object.keys(i).length > 0 &&
              this.quill.formatLine(t.index - f, f, i, S.default.sources.USER),
            this.quill.focus();
        }
      }
      function c(t, e) {
        var n = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(e.suffix) ? 2 : 1;
        if (!(t.index >= this.quill.getLength() - n)) {
          var r = {},
            o = 0,
            i = this.quill.getLine(t.index),
            l = b(i, 1),
            a = l[0];
          if (e.offset >= a.length() - 1) {
            var s = this.quill.getLine(t.index + 1),
              u = b(s, 1),
              c = u[0];
            if (c) {
              var f = a.formats(),
                h = this.quill.getFormat(t.index, 1);
              (r = A.default.attributes.diff(f, h) || {}), (o = c.length());
            }
          }
          this.quill.deleteText(t.index, n, S.default.sources.USER),
            Object.keys(r).length > 0 &&
              this.quill.formatLine(
                t.index + o - 1,
                n,
                r,
                S.default.sources.USER
              );
        }
      }
      function f(t) {
        var e = this.quill.getLines(t),
          n = {};
        if (e.length > 1) {
          var r = e[0].formats(),
            o = e[e.length - 1].formats();
          n = A.default.attributes.diff(o, r) || {};
        }
        this.quill.deleteText(t, S.default.sources.USER),
          Object.keys(n).length > 0 &&
            this.quill.formatLine(t.index, 1, n, S.default.sources.USER),
          this.quill.setSelection(t.index, S.default.sources.SILENT),
          this.quill.focus();
      }
      function h(t, e) {
        var n = this;
        t.length > 0 && this.quill.scroll.deleteAt(t.index, t.length);
        var r = Object.keys(e.format).reduce(function (t, n) {
          return (
            T.default.query(n, T.default.Scope.BLOCK) &&
              !Array.isArray(e.format[n]) &&
              (t[n] = e.format[n]),
            t
          );
        }, {});
        this.quill.insertText(t.index, "\n", r, S.default.sources.USER),
          this.quill.setSelection(t.index + 1, S.default.sources.SILENT),
          this.quill.focus(),
          Object.keys(e.format).forEach(function (t) {
            null == r[t] &&
              (Array.isArray(e.format[t]) ||
                ("link" !== t &&
                  n.quill.format(t, e.format[t], S.default.sources.USER)));
          });
      }
      function p(t) {
        return {
          key: D.keys.TAB,
          shiftKey: !t,
          format: { "code-block": !0 },
          handler: function (e) {
            var n = T.default.query("code-block"),
              r = e.index,
              o = e.length,
              i = this.quill.scroll.descendant(n, r),
              l = b(i, 2),
              a = l[0],
              s = l[1];
            if (null != a) {
              var u = this.quill.getIndex(a),
                c = a.newlineIndex(s, !0) + 1,
                f = a.newlineIndex(u + s + o),
                h = a.domNode.textContent.slice(c, f).split("\n");
              (s = 0),
                h.forEach(function (e, i) {
                  t
                    ? (a.insertAt(c + s, n.TAB),
                      (s += n.TAB.length),
                      0 === i ? (r += n.TAB.length) : (o += n.TAB.length))
                    : e.startsWith(n.TAB) &&
                      (a.deleteAt(c + s, n.TAB.length),
                      (s -= n.TAB.length),
                      0 === i ? (r -= n.TAB.length) : (o -= n.TAB.length)),
                    (s += e.length + 1);
                }),
                this.quill.update(S.default.sources.USER),
                this.quill.setSelection(r, o, S.default.sources.SILENT);
            }
          },
        };
      }
      function d(t) {
        return {
          key: t[0].toUpperCase(),
          shortKey: !0,
          handler: function (e, n) {
            this.quill.format(t, !n.format[t], S.default.sources.USER);
          },
        };
      }
      function y(t) {
        if ("string" == typeof t || "number" == typeof t) return y({ key: t });
        if (
          ("object" === (void 0 === t ? "undefined" : v(t)) &&
            (t = (0, _.default)(t, !1)),
          "string" == typeof t.key)
        )
          if (null != D.keys[t.key.toUpperCase()])
            t.key = D.keys[t.key.toUpperCase()];
          else {
            if (1 !== t.key.length) return null;
            t.key = t.key.toUpperCase().charCodeAt(0);
          }
        return t.shortKey && ((t[B] = t.shortKey), delete t.shortKey), t;
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.SHORTKEY = e.default = void 0);
      var v =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              },
        b = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        g = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        m = n(21),
        _ = r(m),
        O = n(12),
        w = r(O),
        x = n(2),
        k = r(x),
        E = n(4),
        N = r(E),
        j = n(20),
        A = r(j),
        q = n(0),
        T = r(q),
        P = n(6),
        S = r(P),
        C = n(10),
        L = r(C),
        M = n(7),
        R = r(M),
        I = (0, L.default)("quill:keyboard"),
        B = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey",
        D = (function (t) {
          function e(t, n) {
            i(this, e);
            var r = l(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
            );
            return (
              (r.bindings = {}),
              Object.keys(r.options.bindings).forEach(function (e) {
                ("list autofill" !== e ||
                  null == t.scroll.whitelist ||
                  t.scroll.whitelist.list) &&
                  r.options.bindings[e] &&
                  r.addBinding(r.options.bindings[e]);
              }),
              r.addBinding({ key: e.keys.ENTER, shiftKey: null }, h),
              r.addBinding(
                {
                  key: e.keys.ENTER,
                  metaKey: null,
                  ctrlKey: null,
                  altKey: null,
                },
                function () {}
              ),
              /Firefox/i.test(navigator.userAgent)
                ? (r.addBinding(
                    { key: e.keys.BACKSPACE },
                    { collapsed: !0 },
                    u
                  ),
                  r.addBinding({ key: e.keys.DELETE }, { collapsed: !0 }, c))
                : (r.addBinding(
                    { key: e.keys.BACKSPACE },
                    { collapsed: !0, prefix: /^.?$/ },
                    u
                  ),
                  r.addBinding(
                    { key: e.keys.DELETE },
                    { collapsed: !0, suffix: /^.?$/ },
                    c
                  )),
              r.addBinding({ key: e.keys.BACKSPACE }, { collapsed: !1 }, f),
              r.addBinding({ key: e.keys.DELETE }, { collapsed: !1 }, f),
              r.addBinding(
                {
                  key: e.keys.BACKSPACE,
                  altKey: null,
                  ctrlKey: null,
                  metaKey: null,
                  shiftKey: null,
                },
                { collapsed: !0, offset: 0 },
                u
              ),
              r.listen(),
              r
            );
          }
          return (
            a(e, t),
            g(e, null, [
              {
                key: "match",
                value: function (t, e) {
                  return (
                    (e = y(e)),
                    !["altKey", "ctrlKey", "metaKey", "shiftKey"].some(
                      function (n) {
                        return !!e[n] !== t[n] && null !== e[n];
                      }
                    ) && e.key === (t.which || t.keyCode)
                  );
                },
              },
            ]),
            g(e, [
              {
                key: "addBinding",
                value: function (t) {
                  var e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    n =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {},
                    r = y(t);
                  if (null == r || null == r.key)
                    return I.warn(
                      "Attempted to add invalid keyboard binding",
                      r
                    );
                  "function" == typeof e && (e = { handler: e }),
                    "function" == typeof n && (n = { handler: n }),
                    (r = (0, k.default)(r, e, n)),
                    (this.bindings[r.key] = this.bindings[r.key] || []),
                    this.bindings[r.key].push(r);
                },
              },
              {
                key: "listen",
                value: function () {
                  var t = this;
                  this.quill.root.addEventListener("keydown", function (n) {
                    if (!n.defaultPrevented) {
                      var r = n.which || n.keyCode,
                        o = (t.bindings[r] || []).filter(function (t) {
                          return e.match(n, t);
                        });
                      if (0 !== o.length) {
                        var i = t.quill.getSelection();
                        if (null != i && t.quill.hasFocus()) {
                          var l = t.quill.getLine(i.index),
                            a = b(l, 2),
                            s = a[0],
                            u = a[1],
                            c = t.quill.getLeaf(i.index),
                            f = b(c, 2),
                            h = f[0],
                            p = f[1],
                            d =
                              0 === i.length
                                ? [h, p]
                                : t.quill.getLeaf(i.index + i.length),
                            y = b(d, 2),
                            g = y[0],
                            m = y[1],
                            _ =
                              h instanceof T.default.Text
                                ? h.value().slice(0, p)
                                : "",
                            O =
                              g instanceof T.default.Text
                                ? g.value().slice(m)
                                : "",
                            x = {
                              collapsed: 0 === i.length,
                              empty: 0 === i.length && s.length() <= 1,
                              format: t.quill.getFormat(i),
                              offset: u,
                              prefix: _,
                              suffix: O,
                            };
                          o.some(function (e) {
                            if (
                              null != e.collapsed &&
                              e.collapsed !== x.collapsed
                            )
                              return !1;
                            if (null != e.empty && e.empty !== x.empty)
                              return !1;
                            if (null != e.offset && e.offset !== x.offset)
                              return !1;
                            if (Array.isArray(e.format)) {
                              if (
                                e.format.every(function (t) {
                                  return null == x.format[t];
                                })
                              )
                                return !1;
                            } else if (
                              "object" === v(e.format) &&
                              !Object.keys(e.format).every(function (t) {
                                return !0 === e.format[t]
                                  ? null != x.format[t]
                                  : !1 === e.format[t]
                                  ? null == x.format[t]
                                  : (0, w.default)(e.format[t], x.format[t]);
                              })
                            )
                              return !1;
                            return (
                              !(null != e.prefix && !e.prefix.test(x.prefix)) &&
                              !(null != e.suffix && !e.suffix.test(x.suffix)) &&
                              !0 !== e.handler.call(t, i, x)
                            );
                          }) && n.preventDefault();
                        }
                      }
                    }
                  });
                },
              },
            ]),
            e
          );
        })(R.default);
      (D.keys = {
        BACKSPACE: 8,
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        DELETE: 46,
      }),
        (D.DEFAULTS = {
          bindings: {
            bold: d("bold"),
            italic: d("italic"),
            underline: d("underline"),
            indent: {
              key: D.keys.TAB,
              format: ["blockquote", "indent", "list"],
              handler: function (t, e) {
                if (e.collapsed && 0 !== e.offset) return !0;
                this.quill.format("indent", "+1", S.default.sources.USER);
              },
            },
            outdent: {
              key: D.keys.TAB,
              shiftKey: !0,
              format: ["blockquote", "indent", "list"],
              handler: function (t, e) {
                if (e.collapsed && 0 !== e.offset) return !0;
                this.quill.format("indent", "-1", S.default.sources.USER);
              },
            },
            "outdent backspace": {
              key: D.keys.BACKSPACE,
              collapsed: !0,
              shiftKey: null,
              metaKey: null,
              ctrlKey: null,
              altKey: null,
              format: ["indent", "list"],
              offset: 0,
              handler: function (t, e) {
                null != e.format.indent
                  ? this.quill.format("indent", "-1", S.default.sources.USER)
                  : null != e.format.list &&
                    this.quill.format("list", !1, S.default.sources.USER);
              },
            },
            "indent code-block": p(!0),
            "outdent code-block": p(!1),
            "remove tab": {
              key: D.keys.TAB,
              shiftKey: !0,
              collapsed: !0,
              prefix: /\t$/,
              handler: function (t) {
                this.quill.deleteText(t.index - 1, 1, S.default.sources.USER);
              },
            },
            tab: {
              key: D.keys.TAB,
              handler: function (t) {
                this.quill.history.cutoff();
                var e = new N.default()
                  .retain(t.index)
                  .delete(t.length)
                  .insert("\t");
                this.quill.updateContents(e, S.default.sources.USER),
                  this.quill.history.cutoff(),
                  this.quill.setSelection(
                    t.index + 1,
                    S.default.sources.SILENT
                  );
              },
            },
            "list empty enter": {
              key: D.keys.ENTER,
              collapsed: !0,
              format: ["list"],
              empty: !0,
              handler: function (t, e) {
                this.quill.format("list", !1, S.default.sources.USER),
                  e.format.indent &&
                    this.quill.format("indent", !1, S.default.sources.USER);
              },
            },
            "checklist enter": {
              key: D.keys.ENTER,
              collapsed: !0,
              format: { list: "checked" },
              handler: function (t) {
                var e = this.quill.getLine(t.index),
                  n = b(e, 2),
                  r = n[0],
                  o = n[1],
                  i = (0, k.default)({}, r.formats(), { list: "checked" }),
                  l = new N.default()
                    .retain(t.index)
                    .insert("\n", i)
                    .retain(r.length() - o - 1)
                    .retain(1, { list: "unchecked" });
                this.quill.updateContents(l, S.default.sources.USER),
                  this.quill.setSelection(
                    t.index + 1,
                    S.default.sources.SILENT
                  ),
                  this.quill.scrollIntoView();
              },
            },
            "header enter": {
              key: D.keys.ENTER,
              collapsed: !0,
              format: ["header"],
              suffix: /^$/,
              handler: function (t, e) {
                var n = this.quill.getLine(t.index),
                  r = b(n, 2),
                  o = r[0],
                  i = r[1],
                  l = new N.default()
                    .retain(t.index)
                    .insert("\n", e.format)
                    .retain(o.length() - i - 1)
                    .retain(1, { header: null });
                this.quill.updateContents(l, S.default.sources.USER),
                  this.quill.setSelection(
                    t.index + 1,
                    S.default.sources.SILENT
                  ),
                  this.quill.scrollIntoView();
              },
            },
            "list autofill": {
              key: " ",
              collapsed: !0,
              format: { list: !1 },
              prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
              handler: function (t, e) {
                var n = e.prefix.length,
                  r = this.quill.getLine(t.index),
                  o = b(r, 2),
                  i = o[0],
                  l = o[1];
                if (l > n) return !0;
                var a = void 0;
                switch (e.prefix.trim()) {
                  case "[]":
                  case "[ ]":
                    a = "unchecked";
                    break;
                  case "[x]":
                    a = "checked";
                    break;
                  case "-":
                  case "*":
                    a = "bullet";
                    break;
                  default:
                    a = "ordered";
                }
                this.quill.insertText(t.index, " ", S.default.sources.USER),
                  this.quill.history.cutoff();
                var s = new N.default()
                  .retain(t.index - l)
                  .delete(n + 1)
                  .retain(i.length() - 2 - l)
                  .retain(1, { list: a });
                this.quill.updateContents(s, S.default.sources.USER),
                  this.quill.history.cutoff(),
                  this.quill.setSelection(
                    t.index - n,
                    S.default.sources.SILENT
                  );
              },
            },
            "code exit": {
              key: D.keys.ENTER,
              collapsed: !0,
              format: ["code-block"],
              prefix: /\n\n$/,
              suffix: /^\s+$/,
              handler: function (t) {
                var e = this.quill.getLine(t.index),
                  n = b(e, 2),
                  r = n[0],
                  o = n[1],
                  i = new N.default()
                    .retain(t.index + r.length() - o - 2)
                    .retain(1, { "code-block": null })
                    .delete(1);
                this.quill.updateContents(i, S.default.sources.USER);
              },
            },
            "embed left": s(D.keys.LEFT, !1),
            "embed left shift": s(D.keys.LEFT, !0),
            "embed right": s(D.keys.RIGHT, !1),
            "embed right shift": s(D.keys.RIGHT, !0),
          },
        }),
        (e.default = D),
        (e.SHORTKEY = B);
    },
    function (t, e, n) {
      "use strict";
      t.exports = {
        align: { "": n(75), center: n(76), right: n(77), justify: n(78) },
        background: n(79),
        blockquote: n(80),
        bold: n(81),
        clean: n(82),
        code: n(40),
        "code-block": n(40),
        color: n(83),
        direction: { "": n(84), rtl: n(85) },
        float: { center: n(86), full: n(87), left: n(88), right: n(89) },
        formula: n(90),
        header: { 1: n(91), 2: n(92) },
        italic: n(93),
        image: n(94),
        indent: { "+1": n(95), "-1": n(96) },
        link: n(97),
        list: { ordered: n(98), bullet: n(99), check: n(100) },
        script: { sub: n(101), super: n(102) },
        strike: n(103),
        underline: n(104),
        video: n(105),
      };
    },
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var r = n(1),
        o = (function () {
          function t(t) {
            (this.domNode = t), (this.domNode[r.DATA_KEY] = { blot: this });
          }
          return (
            Object.defineProperty(t.prototype, "statics", {
              get: function () {
                return this.constructor;
              },
              enumerable: !0,
              configurable: !0,
            }),
            (t.create = function (t) {
              if (null == this.tagName)
                throw new r.ParchmentError("Blot definition missing tagName");
              var e;
              return (
                Array.isArray(this.tagName)
                  ? ("string" == typeof t &&
                      ((t = t.toUpperCase()),
                      parseInt(t).toString() === t && (t = parseInt(t))),
                    (e =
                      "number" == typeof t
                        ? document.createElement(this.tagName[t - 1])
                        : this.tagName.indexOf(t) > -1
                        ? document.createElement(t)
                        : document.createElement(this.tagName[0])))
                  : (e = document.createElement(this.tagName)),
                this.className && e.classList.add(this.className),
                e
              );
            }),
            (t.prototype.attach = function () {
              null != this.parent && (this.scroll = this.parent.scroll);
            }),
            (t.prototype.clone = function () {
              var t = this.domNode.cloneNode(!1);
              return r.create(t);
            }),
            (t.prototype.detach = function () {
              null != this.parent && this.parent.removeChild(this),
                delete this.domNode[r.DATA_KEY];
            }),
            (t.prototype.deleteAt = function (t, e) {
              this.isolate(t, e).remove();
            }),
            (t.prototype.formatAt = function (t, e, n, o) {
              var i = this.isolate(t, e);
              if (null != r.query(n, r.Scope.BLOT) && o) i.wrap(n, o);
              else if (null != r.query(n, r.Scope.ATTRIBUTE)) {
                var l = r.create(this.statics.scope);
                i.wrap(l), l.format(n, o);
              }
            }),
            (t.prototype.insertAt = function (t, e, n) {
              var o = null == n ? r.create("text", e) : r.create(e, n),
                i = this.split(t);
              this.parent.insertBefore(o, i);
            }),
            (t.prototype.insertInto = function (t, e) {
              void 0 === e && (e = null),
                null != this.parent && this.parent.children.remove(this);
              var n = null;
              t.children.insertBefore(this, e),
                null != e && (n = e.domNode),
                (this.domNode.parentNode == t.domNode &&
                  this.domNode.nextSibling == n) ||
                  t.domNode.insertBefore(this.domNode, n),
                (this.parent = t),
                this.attach();
            }),
            (t.prototype.isolate = function (t, e) {
              var n = this.split(t);
              return n.split(e), n;
            }),
            (t.prototype.length = function () {
              return 1;
            }),
            (t.prototype.offset = function (t) {
              return (
                void 0 === t && (t = this.parent),
                null == this.parent || this == t
                  ? 0
                  : this.parent.children.offset(this) + this.parent.offset(t)
              );
            }),
            (t.prototype.optimize = function (t) {
              null != this.domNode[r.DATA_KEY] &&
                delete this.domNode[r.DATA_KEY].mutations;
            }),
            (t.prototype.remove = function () {
              null != this.domNode.parentNode &&
                this.domNode.parentNode.removeChild(this.domNode),
                this.detach();
            }),
            (t.prototype.replace = function (t) {
              null != t.parent &&
                (t.parent.insertBefore(this, t.next), t.remove());
            }),
            (t.prototype.replaceWith = function (t, e) {
              var n = "string" == typeof t ? r.create(t, e) : t;
              return n.replace(this), n;
            }),
            (t.prototype.split = function (t, e) {
              return 0 === t ? this : this.next;
            }),
            (t.prototype.update = function (t, e) {}),
            (t.prototype.wrap = function (t, e) {
              var n = "string" == typeof t ? r.create(t, e) : t;
              return (
                null != this.parent && this.parent.insertBefore(n, this.next),
                n.appendChild(this),
                n
              );
            }),
            (t.blotName = "abstract"),
            t
          );
        })();
      e.default = o;
    },
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var r = n(11),
        o = n(29),
        i = n(30),
        l = n(1),
        a = (function () {
          function t(t) {
            (this.attributes = {}), (this.domNode = t), this.build();
          }
          return (
            (t.prototype.attribute = function (t, e) {
              e
                ? t.add(this.domNode, e) &&
                  (null != t.value(this.domNode)
                    ? (this.attributes[t.attrName] = t)
                    : delete this.attributes[t.attrName])
                : (t.remove(this.domNode), delete this.attributes[t.attrName]);
            }),
            (t.prototype.build = function () {
              var t = this;
              this.attributes = {};
              var e = r.default.keys(this.domNode),
                n = o.default.keys(this.domNode),
                a = i.default.keys(this.domNode);
              e.concat(n)
                .concat(a)
                .forEach(function (e) {
                  var n = l.query(e, l.Scope.ATTRIBUTE);
                  n instanceof r.default && (t.attributes[n.attrName] = n);
                });
            }),
            (t.prototype.copy = function (t) {
              var e = this;
              Object.keys(this.attributes).forEach(function (n) {
                var r = e.attributes[n].value(e.domNode);
                t.format(n, r);
              });
            }),
            (t.prototype.move = function (t) {
              var e = this;
              this.copy(t),
                Object.keys(this.attributes).forEach(function (t) {
                  e.attributes[t].remove(e.domNode);
                }),
                (this.attributes = {});
            }),
            (t.prototype.values = function () {
              var t = this;
              return Object.keys(this.attributes).reduce(function (e, n) {
                return (e[n] = t.attributes[n].value(t.domNode)), e;
              }, {});
            }),
            t
          );
        })();
      e.default = a;
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        return (t.getAttribute("class") || "")
          .split(/\s+/)
          .filter(function (t) {
            return 0 === t.indexOf(e + "-");
          });
      }
      var o =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var i = n(11),
        l = (function (t) {
          function e() {
            return (null !== t && t.apply(this, arguments)) || this;
          }
          return (
            o(e, t),
            (e.keys = function (t) {
              return (t.getAttribute("class") || "")
                .split(/\s+/)
                .map(function (t) {
                  return t.split("-").slice(0, -1).join("-");
                });
            }),
            (e.prototype.add = function (t, e) {
              return (
                !!this.canAdd(t, e) &&
                (this.remove(t), t.classList.add(this.keyName + "-" + e), !0)
              );
            }),
            (e.prototype.remove = function (t) {
              r(t, this.keyName).forEach(function (e) {
                t.classList.remove(e);
              }),
                0 === t.classList.length && t.removeAttribute("class");
            }),
            (e.prototype.value = function (t) {
              var e = r(t, this.keyName)[0] || "",
                n = e.slice(this.keyName.length + 1);
              return this.canAdd(t, n) ? n : "";
            }),
            e
          );
        })(i.default);
      e.default = l;
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        var e = t.split("-"),
          n = e
            .slice(1)
            .map(function (t) {
              return t[0].toUpperCase() + t.slice(1);
            })
            .join("");
        return e[0] + n;
      }
      var o =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var i = n(11),
        l = (function (t) {
          function e() {
            return (null !== t && t.apply(this, arguments)) || this;
          }
          return (
            o(e, t),
            (e.keys = function (t) {
              return (t.getAttribute("style") || "")
                .split(";")
                .map(function (t) {
                  return t.split(":")[0].trim();
                });
            }),
            (e.prototype.add = function (t, e) {
              return (
                !!this.canAdd(t, e) && ((t.style[r(this.keyName)] = e), !0)
              );
            }),
            (e.prototype.remove = function (t) {
              (t.style[r(this.keyName)] = ""),
                t.getAttribute("style") || t.removeAttribute("style");
            }),
            (e.prototype.value = function (t) {
              var e = t.style[r(this.keyName)];
              return this.canAdd(t, e) ? e : "";
            }),
            e
          );
        })(i.default);
      e.default = l;
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var a = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        s = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        u = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        c = n(0),
        f = r(c),
        h = n(8),
        p = r(h),
        d = (function (t) {
          function e(t, n) {
            o(this, e);
            var r = i(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t)
            );
            return (
              (r.selection = n),
              (r.textNode = document.createTextNode(e.CONTENTS)),
              r.domNode.appendChild(r.textNode),
              (r._length = 0),
              r
            );
          }
          return (
            l(e, t),
            u(e, null, [{ key: "value", value: function () {} }]),
            u(e, [
              {
                key: "detach",
                value: function () {
                  null != this.parent && this.parent.removeChild(this);
                },
              },
              {
                key: "format",
                value: function (t, n) {
                  if (0 !== this._length)
                    return s(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "format",
                      this
                    ).call(this, t, n);
                  for (
                    var r = this, o = 0;
                    null != r && r.statics.scope !== f.default.Scope.BLOCK_BLOT;

                  )
                    (o += r.offset(r.parent)), (r = r.parent);
                  null != r &&
                    ((this._length = e.CONTENTS.length),
                    r.optimize(),
                    r.formatAt(o, e.CONTENTS.length, t, n),
                    (this._length = 0));
                },
              },
              {
                key: "index",
                value: function (t, n) {
                  return t === this.textNode
                    ? 0
                    : s(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "index",
                        this
                      ).call(this, t, n);
                },
              },
              {
                key: "length",
                value: function () {
                  return this._length;
                },
              },
              {
                key: "position",
                value: function () {
                  return [this.textNode, this.textNode.data.length];
                },
              },
              {
                key: "remove",
                value: function () {
                  s(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "remove",
                    this
                  ).call(this),
                    (this.parent = null);
                },
              },
              {
                key: "restore",
                value: function () {
                  if (!this.selection.composing && null != this.parent) {
                    var t = this.textNode,
                      n = this.selection.getNativeRange(),
                      r = void 0,
                      o = void 0,
                      i = void 0;
                    if (null != n && n.start.node === t && n.end.node === t) {
                      var l = [t, n.start.offset, n.end.offset];
                      (r = l[0]), (o = l[1]), (i = l[2]);
                    }
                    for (
                      ;
                      null != this.domNode.lastChild &&
                      this.domNode.lastChild !== this.textNode;

                    )
                      this.domNode.parentNode.insertBefore(
                        this.domNode.lastChild,
                        this.domNode
                      );
                    if (this.textNode.data !== e.CONTENTS) {
                      var s = this.textNode.data.split(e.CONTENTS).join("");
                      this.next instanceof p.default
                        ? ((r = this.next.domNode),
                          this.next.insertAt(0, s),
                          (this.textNode.data = e.CONTENTS))
                        : ((this.textNode.data = s),
                          this.parent.insertBefore(
                            f.default.create(this.textNode),
                            this
                          ),
                          (this.textNode = document.createTextNode(e.CONTENTS)),
                          this.domNode.appendChild(this.textNode));
                    }
                    if ((this.remove(), null != o)) {
                      var u = [o, i].map(function (t) {
                          return Math.max(0, Math.min(r.data.length, t - 1));
                        }),
                        c = a(u, 2);
                      return (
                        (o = c[0]),
                        (i = c[1]),
                        {
                          startNode: r,
                          startOffset: o,
                          endNode: r,
                          endOffset: i,
                        }
                      );
                    }
                  }
                },
              },
              {
                key: "update",
                value: function (t, e) {
                  var n = this;
                  if (
                    t.some(function (t) {
                      return (
                        "characterData" === t.type && t.target === n.textNode
                      );
                    })
                  ) {
                    var r = this.restore();
                    r && (e.range = r);
                  }
                },
              },
              {
                key: "value",
                value: function () {
                  return "";
                },
              },
            ]),
            e
          );
        })(f.default.Embed);
      (d.blotName = "cursor"),
        (d.className = "ql-cursor"),
        (d.tagName = "span"),
        (d.CONTENTS = "\ufeff"),
        (e.default = d);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        i = (function () {
          function t(e, n) {
            r(this, t),
              (this.quill = e),
              (this.options = n),
              (this.modules = {});
          }
          return (
            o(t, [
              {
                key: "init",
                value: function () {
                  var t = this;
                  Object.keys(this.options.modules).forEach(function (e) {
                    null == t.modules[e] && t.addModule(e);
                  });
                },
              },
              {
                key: "addModule",
                value: function (t) {
                  var e = this.quill.constructor.import("modules/" + t);
                  return (
                    (this.modules[t] = new e(
                      this.quill,
                      this.options.modules[t] || {}
                    )),
                    this.modules[t]
                  );
                },
              },
            ]),
            t
          );
        })();
      (i.DEFAULTS = { modules: {} }),
        (i.themes = { default: i }),
        (e.default = i);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var a = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        s = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        u = n(0),
        c = r(u),
        f = n(8),
        h = r(f),
        p = "\ufeff",
        d = (function (t) {
          function e(t) {
            o(this, e);
            var n = i(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t)
            );
            return (
              (n.contentNode = document.createElement("span")),
              n.contentNode.setAttribute("contenteditable", !1),
              [].slice.call(n.domNode.childNodes).forEach(function (t) {
                n.contentNode.appendChild(t);
              }),
              (n.leftGuard = document.createTextNode(p)),
              (n.rightGuard = document.createTextNode(p)),
              n.domNode.appendChild(n.leftGuard),
              n.domNode.appendChild(n.contentNode),
              n.domNode.appendChild(n.rightGuard),
              n
            );
          }
          return (
            l(e, t),
            a(e, [
              {
                key: "index",
                value: function (t, n) {
                  return t === this.leftGuard
                    ? 0
                    : t === this.rightGuard
                    ? 1
                    : s(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "index",
                        this
                      ).call(this, t, n);
                },
              },
              {
                key: "restore",
                value: function (t) {
                  var e = void 0,
                    n = void 0,
                    r = t.data.split(p).join("");
                  if (t === this.leftGuard)
                    if (this.prev instanceof h.default) {
                      var o = this.prev.length();
                      this.prev.insertAt(o, r),
                        (e = {
                          startNode: this.prev.domNode,
                          startOffset: o + r.length,
                        });
                    } else
                      (n = document.createTextNode(r)),
                        this.parent.insertBefore(c.default.create(n), this),
                        (e = { startNode: n, startOffset: r.length });
                  else
                    t === this.rightGuard &&
                      (this.next instanceof h.default
                        ? (this.next.insertAt(0, r),
                          (e = {
                            startNode: this.next.domNode,
                            startOffset: r.length,
                          }))
                        : ((n = document.createTextNode(r)),
                          this.parent.insertBefore(
                            c.default.create(n),
                            this.next
                          ),
                          (e = { startNode: n, startOffset: r.length })));
                  return (t.data = p), e;
                },
              },
              {
                key: "update",
                value: function (t, e) {
                  var n = this;
                  t.forEach(function (t) {
                    if (
                      "characterData" === t.type &&
                      (t.target === n.leftGuard || t.target === n.rightGuard)
                    ) {
                      var r = n.restore(t.target);
                      r && (e.range = r);
                    }
                  });
                },
              },
            ]),
            e
          );
        })(c.default.Embed);
      e.default = d;
    },
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.AlignStyle = e.AlignClass = e.AlignAttribute = void 0);
      var r = n(0),
        o = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(r),
        i = {
          scope: o.default.Scope.BLOCK,
          whitelist: ["right", "center", "justify"],
        },
        l = new o.default.Attributor.Attribute("align", "align", i),
        a = new o.default.Attributor.Class("align", "ql-align", i),
        s = new o.default.Attributor.Style("align", "text-align", i);
      (e.AlignAttribute = l), (e.AlignClass = a), (e.AlignStyle = s);
    },
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.BackgroundStyle = e.BackgroundClass = void 0);
      var r = n(0),
        o = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(r),
        i = n(24),
        l = new o.default.Attributor.Class("background", "ql-bg", {
          scope: o.default.Scope.INLINE,
        }),
        a = new i.ColorAttributor("background", "background-color", {
          scope: o.default.Scope.INLINE,
        });
      (e.BackgroundClass = l), (e.BackgroundStyle = a);
    },
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.DirectionStyle = e.DirectionClass = e.DirectionAttribute = void 0);
      var r = n(0),
        o = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(r),
        i = { scope: o.default.Scope.BLOCK, whitelist: ["rtl"] },
        l = new o.default.Attributor.Attribute("direction", "dir", i),
        a = new o.default.Attributor.Class("direction", "ql-direction", i),
        s = new o.default.Attributor.Style("direction", "direction", i);
      (e.DirectionAttribute = l),
        (e.DirectionClass = a),
        (e.DirectionStyle = s);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.FontClass = e.FontStyle = void 0);
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(0),
        u = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(s),
        c = {
          scope: u.default.Scope.INLINE,
          whitelist: ["serif", "monospace"],
        },
        f = new u.default.Attributor.Class("font", "ql-font", c),
        h = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            l(e, [
              {
                key: "value",
                value: function (t) {
                  return a(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "value",
                    this
                  )
                    .call(this, t)
                    .replace(/["']/g, "");
                },
              },
            ]),
            e
          );
        })(u.default.Attributor.Style),
        p = new h("font", "font-family", c);
      (e.FontStyle = p), (e.FontClass = f);
    },
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.SizeStyle = e.SizeClass = void 0);
      var r = n(0),
        o = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(r),
        i = new o.default.Attributor.Class("size", "ql-size", {
          scope: o.default.Scope.INLINE,
          whitelist: ["small", "large", "huge"],
        }),
        l = new o.default.Attributor.Style("size", "font-size", {
          scope: o.default.Scope.INLINE,
          whitelist: ["10px", "18px", "32px"],
        });
      (e.SizeClass = i), (e.SizeStyle = l);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(5),
        u = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(s),
        c = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            l(
              e,
              [
                {
                  key: "optimize",
                  value: function (t) {
                    a(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "optimize",
                      this
                    ).call(this, t),
                      this.domNode.tagName !== this.statics.tagName[0] &&
                        this.replaceWith(this.statics.blotName);
                  },
                },
              ],
              [
                {
                  key: "create",
                  value: function () {
                    return a(
                      e.__proto__ || Object.getPrototypeOf(e),
                      "create",
                      this
                    ).call(this);
                  },
                },
                {
                  key: "formats",
                  value: function () {
                    return !0;
                  },
                },
              ]
            ),
            e
          );
        })(u.default);
      (c.blotName = "bold"), (c.tagName = ["STRONG", "B"]), (e.default = c);
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>';
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(16),
        u = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(s),
        c = (function (t) {
          function e(t, n) {
            r(this, e);
            var i = o(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t)
            );
            return (
              (i.label.innerHTML = n),
              i.container.classList.add("ql-color-picker"),
              [].slice
                .call(i.container.querySelectorAll(".ql-picker-item"), 0, 7)
                .forEach(function (t) {
                  t.classList.add("ql-primary");
                }),
              i
            );
          }
          return (
            i(e, t),
            l(e, [
              {
                key: "buildItem",
                value: function (t) {
                  var n = a(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "buildItem",
                    this
                  ).call(this, t);
                  return (
                    (n.style.backgroundColor = t.getAttribute("value") || ""), n
                  );
                },
              },
              {
                key: "selectItem",
                value: function (t, n) {
                  a(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "selectItem",
                    this
                  ).call(this, t, n);
                  var r = this.label.querySelector(".ql-color-label"),
                    o = t ? t.getAttribute("data-value") || "" : "";
                  r &&
                    ("line" === r.tagName
                      ? (r.style.stroke = o)
                      : (r.style.fill = o));
                },
              },
            ]),
            e
          );
        })(u.default);
      e.default = c;
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(16),
        u = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(s),
        c = (function (t) {
          function e(t, n) {
            r(this, e);
            var i = o(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t)
            );
            return (
              i.container.classList.add("ql-icon-picker"),
              [].forEach.call(
                i.container.querySelectorAll(".ql-picker-item"),
                function (t) {
                  t.innerHTML = n[t.getAttribute("data-value") || ""];
                }
              ),
              (i.defaultItem = i.container.querySelector(".ql-selected")),
              i.selectItem(i.defaultItem),
              i
            );
          }
          return (
            i(e, t),
            l(e, [
              {
                key: "selectItem",
                value: function (t, n) {
                  a(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "selectItem",
                    this
                  ).call(this, t, n),
                    (t = t || this.defaultItem),
                    (this.label.innerHTML = t.innerHTML);
                },
              },
            ]),
            e
          );
        })(u.default);
      e.default = c;
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        i = (function () {
          function t(e, n) {
            var o = this;
            r(this, t),
              (this.quill = e),
              (this.boundsContainer = n || document.body),
              (this.root = e.addContainer("ql-tooltip")),
              (this.root.innerHTML = this.constructor.TEMPLATE),
              this.quill.root === this.quill.scrollingContainer &&
                this.quill.root.addEventListener("scroll", function () {
                  o.root.style.marginTop = -1 * o.quill.root.scrollTop + "px";
                }),
              this.hide();
          }
          return (
            o(t, [
              {
                key: "hide",
                value: function () {
                  this.root.classList.add("ql-hidden");
                },
              },
              {
                key: "position",
                value: function (t) {
                  var e = t.left + t.width / 2 - this.root.offsetWidth / 2,
                    n = t.bottom + this.quill.root.scrollTop;
                  (this.root.style.left = e + "px"),
                    (this.root.style.top = n + "px"),
                    this.root.classList.remove("ql-flip");
                  var r = this.boundsContainer.getBoundingClientRect(),
                    o = this.root.getBoundingClientRect(),
                    i = 0;
                  if (
                    (o.right > r.right &&
                      ((i = r.right - o.right),
                      (this.root.style.left = e + i + "px")),
                    o.left < r.left &&
                      ((i = r.left - o.left),
                      (this.root.style.left = e + i + "px")),
                    o.bottom > r.bottom)
                  ) {
                    var l = o.bottom - o.top,
                      a = t.bottom - t.top + l;
                    (this.root.style.top = n - a + "px"),
                      this.root.classList.add("ql-flip");
                  }
                  return i;
                },
              },
              {
                key: "show",
                value: function () {
                  this.root.classList.remove("ql-editing"),
                    this.root.classList.remove("ql-hidden");
                },
              },
            ]),
            t
          );
        })();
      e.default = i;
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      function a(t) {
        var e =
          t.match(
            /^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/
          ) ||
          t.match(
            /^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/
          );
        return e
          ? (e[1] || "https") +
              "://www.youtube.com/embed/" +
              e[2] +
              "?showinfo=0"
          : (e = t.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/))
          ? (e[1] || "https") + "://player.vimeo.com/video/" + e[2] + "/"
          : t;
      }
      function s(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        e.forEach(function (e) {
          var r = document.createElement("option");
          e === n
            ? r.setAttribute("selected", "selected")
            : r.setAttribute("value", e),
            t.appendChild(r);
        });
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = e.BaseTooltip = void 0);
      var u = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        c = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        f = n(2),
        h = r(f),
        p = n(4),
        d = r(p),
        y = n(9),
        v = r(y),
        b = n(25),
        g = r(b),
        m = n(32),
        _ = r(m),
        O = n(41),
        w = r(O),
        x = n(42),
        k = r(x),
        E = n(16),
        N = r(E),
        j = n(43),
        A = r(j),
        q = [!1, "center", "right", "justify"],
        T = [
          "#000000",
          "#e60000",
          "#ff9900",
          "#ffff00",
          "#008a00",
          "#0066cc",
          "#9933ff",
          "#ffffff",
          "#facccc",
          "#ffebcc",
          "#ffffcc",
          "#cce8cc",
          "#cce0f5",
          "#ebd6ff",
          "#bbbbbb",
          "#f06666",
          "#ffc266",
          "#ffff66",
          "#66b966",
          "#66a3e0",
          "#c285ff",
          "#888888",
          "#a10000",
          "#b26b00",
          "#b2b200",
          "#006100",
          "#0047b2",
          "#6b24b2",
          "#444444",
          "#5c0000",
          "#663d00",
          "#666600",
          "#003700",
          "#002966",
          "#3d1466",
        ],
        P = [!1, "serif", "monospace"],
        S = ["1", "2", "3", !1],
        C = ["small", !1, "large", "huge"],
        L = (function (t) {
          function e(t, n) {
            o(this, e);
            var r = i(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
              ),
              l = function e(n) {
                if (!document.body.contains(t.root))
                  return document.body.removeEventListener("click", e);
                null == r.tooltip ||
                  r.tooltip.root.contains(n.target) ||
                  document.activeElement === r.tooltip.textbox ||
                  r.quill.hasFocus() ||
                  r.tooltip.hide(),
                  null != r.pickers &&
                    r.pickers.forEach(function (t) {
                      t.container.contains(n.target) || t.close();
                    });
              };
            return t.emitter.listenDOM("click", document.body, l), r;
          }
          return (
            l(e, t),
            u(e, [
              {
                key: "addModule",
                value: function (t) {
                  var n = c(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "addModule",
                    this
                  ).call(this, t);
                  return "toolbar" === t && this.extendToolbar(n), n;
                },
              },
              {
                key: "buildButtons",
                value: function (t, e) {
                  t.forEach(function (t) {
                    (t.getAttribute("class") || "")
                      .split(/\s+/)
                      .forEach(function (n) {
                        if (
                          n.startsWith("ql-") &&
                          ((n = n.slice("ql-".length)), null != e[n])
                        )
                          if ("direction" === n)
                            t.innerHTML = e[n][""] + e[n].rtl;
                          else if ("string" == typeof e[n]) t.innerHTML = e[n];
                          else {
                            var r = t.value || "";
                            null != r && e[n][r] && (t.innerHTML = e[n][r]);
                          }
                      });
                  });
                },
              },
              {
                key: "buildPickers",
                value: function (t, e) {
                  var n = this;
                  this.pickers = t.map(function (t) {
                    if (t.classList.contains("ql-align"))
                      return (
                        null == t.querySelector("option") && s(t, q),
                        new k.default(t, e.align)
                      );
                    if (
                      t.classList.contains("ql-background") ||
                      t.classList.contains("ql-color")
                    ) {
                      var n = t.classList.contains("ql-background")
                        ? "background"
                        : "color";
                      return (
                        null == t.querySelector("option") &&
                          s(t, T, "background" === n ? "#ffffff" : "#000000"),
                        new w.default(t, e[n])
                      );
                    }
                    return (
                      null == t.querySelector("option") &&
                        (t.classList.contains("ql-font")
                          ? s(t, P)
                          : t.classList.contains("ql-header")
                          ? s(t, S)
                          : t.classList.contains("ql-size") && s(t, C)),
                      new N.default(t)
                    );
                  });
                  var r = function () {
                    n.pickers.forEach(function (t) {
                      t.update();
                    });
                  };
                  this.quill.on(v.default.events.EDITOR_CHANGE, r);
                },
              },
            ]),
            e
          );
        })(_.default);
      L.DEFAULTS = (0, h.default)(!0, {}, _.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              formula: function () {
                this.quill.theme.tooltip.edit("formula");
              },
              image: function () {
                var t = this,
                  e = this.container.querySelector("input.ql-image[type=file]");
                null == e &&
                  ((e = document.createElement("input")),
                  e.setAttribute("type", "file"),
                  e.setAttribute(
                    "accept",
                    "image/png, image/gif, image/jpeg, image/bmp, image/x-icon"
                  ),
                  e.classList.add("ql-image"),
                  e.addEventListener("change", function () {
                    if (null != e.files && null != e.files[0]) {
                      var n = new FileReader();
                      (n.onload = function (n) {
                        var r = t.quill.getSelection(!0);
                        t.quill.updateContents(
                          new d.default()
                            .retain(r.index)
                            .delete(r.length)
                            .insert({ image: n.target.result }),
                          v.default.sources.USER
                        ),
                          t.quill.setSelection(
                            r.index + 1,
                            v.default.sources.SILENT
                          ),
                          (e.value = "");
                      }),
                        n.readAsDataURL(e.files[0]);
                    }
                  }),
                  this.container.appendChild(e)),
                  e.click();
              },
              video: function () {
                this.quill.theme.tooltip.edit("video");
              },
            },
          },
        },
      });
      var M = (function (t) {
        function e(t, n) {
          o(this, e);
          var r = i(
            this,
            (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
          );
          return (
            (r.textbox = r.root.querySelector('input[type="text"]')),
            r.listen(),
            r
          );
        }
        return (
          l(e, t),
          u(e, [
            {
              key: "listen",
              value: function () {
                var t = this;
                this.textbox.addEventListener("keydown", function (e) {
                  g.default.match(e, "enter")
                    ? (t.save(), e.preventDefault())
                    : g.default.match(e, "escape") &&
                      (t.cancel(), e.preventDefault());
                });
              },
            },
            {
              key: "cancel",
              value: function () {
                this.hide();
              },
            },
            {
              key: "edit",
              value: function () {
                var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : "link",
                  e =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : null;
                this.root.classList.remove("ql-hidden"),
                  this.root.classList.add("ql-editing"),
                  null != e
                    ? (this.textbox.value = e)
                    : t !== this.root.getAttribute("data-mode") &&
                      (this.textbox.value = ""),
                  this.position(
                    this.quill.getBounds(this.quill.selection.savedRange)
                  ),
                  this.textbox.select(),
                  this.textbox.setAttribute(
                    "placeholder",
                    this.textbox.getAttribute("data-" + t) || ""
                  ),
                  this.root.setAttribute("data-mode", t);
              },
            },
            {
              key: "restoreFocus",
              value: function () {
                var t = this.quill.scrollingContainer.scrollTop;
                this.quill.focus(),
                  (this.quill.scrollingContainer.scrollTop = t);
              },
            },
            {
              key: "save",
              value: function () {
                var t = this.textbox.value;
                switch (this.root.getAttribute("data-mode")) {
                  case "link":
                    var e = this.quill.root.scrollTop;
                    this.linkRange
                      ? (this.quill.formatText(
                          this.linkRange,
                          "link",
                          t,
                          v.default.sources.USER
                        ),
                        delete this.linkRange)
                      : (this.restoreFocus(),
                        this.quill.format("link", t, v.default.sources.USER)),
                      (this.quill.root.scrollTop = e);
                    break;
                  case "video":
                    t = a(t);
                  case "formula":
                    if (!t) break;
                    var n = this.quill.getSelection(!0);
                    if (null != n) {
                      var r = n.index + n.length;
                      this.quill.insertEmbed(
                        r,
                        this.root.getAttribute("data-mode"),
                        t,
                        v.default.sources.USER
                      ),
                        "formula" === this.root.getAttribute("data-mode") &&
                          this.quill.insertText(
                            r + 1,
                            " ",
                            v.default.sources.USER
                          ),
                        this.quill.setSelection(r + 2, v.default.sources.USER);
                    }
                }
                (this.textbox.value = ""), this.hide();
              },
            },
          ]),
          e
        );
      })(A.default);
      (e.BaseTooltip = M), (e.default = L);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = n(46),
        i = r(o),
        l = n(34),
        a = n(36),
        s = n(62),
        u = n(63),
        c = r(u),
        f = n(64),
        h = r(f),
        p = n(65),
        d = r(p),
        y = n(35),
        v = n(24),
        b = n(37),
        g = n(38),
        m = n(39),
        _ = r(m),
        O = n(66),
        w = r(O),
        x = n(15),
        k = r(x),
        E = n(67),
        N = r(E),
        j = n(68),
        A = r(j),
        q = n(69),
        T = r(q),
        P = n(70),
        S = r(P),
        C = n(71),
        L = r(C),
        M = n(13),
        R = r(M),
        I = n(72),
        B = r(I),
        D = n(73),
        U = r(D),
        F = n(74),
        H = r(F),
        K = n(26),
        z = r(K),
        V = n(16),
        Z = r(V),
        W = n(41),
        G = r(W),
        Y = n(42),
        X = r(Y),
        $ = n(43),
        Q = r($),
        J = n(107),
        tt = r(J),
        et = n(108),
        nt = r(et);
      i.default.register(
        {
          "attributors/attribute/direction": a.DirectionAttribute,
          "attributors/class/align": l.AlignClass,
          "attributors/class/background": y.BackgroundClass,
          "attributors/class/color": v.ColorClass,
          "attributors/class/direction": a.DirectionClass,
          "attributors/class/font": b.FontClass,
          "attributors/class/size": g.SizeClass,
          "attributors/style/align": l.AlignStyle,
          "attributors/style/background": y.BackgroundStyle,
          "attributors/style/color": v.ColorStyle,
          "attributors/style/direction": a.DirectionStyle,
          "attributors/style/font": b.FontStyle,
          "attributors/style/size": g.SizeStyle,
        },
        !0
      ),
        i.default.register(
          {
            "formats/align": l.AlignClass,
            "formats/direction": a.DirectionClass,
            "formats/indent": s.IndentClass,
            "formats/background": y.BackgroundStyle,
            "formats/color": v.ColorStyle,
            "formats/font": b.FontClass,
            "formats/size": g.SizeClass,
            "formats/blockquote": c.default,
            "formats/code-block": R.default,
            "formats/header": h.default,
            "formats/list": d.default,
            "formats/bold": _.default,
            "formats/code": M.Code,
            "formats/italic": w.default,
            "formats/link": k.default,
            "formats/script": N.default,
            "formats/strike": A.default,
            "formats/underline": T.default,
            "formats/image": S.default,
            "formats/video": L.default,
            "formats/list/item": p.ListItem,
            "modules/formula": B.default,
            "modules/syntax": U.default,
            "modules/toolbar": H.default,
            "themes/bubble": tt.default,
            "themes/snow": nt.default,
            "ui/icons": z.default,
            "ui/picker": Z.default,
            "ui/icon-picker": X.default,
            "ui/color-picker": G.default,
            "ui/tooltip": Q.default,
          },
          !0
        ),
        (e.default = i.default);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = n(0),
        i = r(o),
        l = n(6),
        a = r(l),
        s = n(3),
        u = r(s),
        c = n(14),
        f = r(c),
        h = n(23),
        p = r(h),
        d = n(31),
        y = r(d),
        v = n(33),
        b = r(v),
        g = n(5),
        m = r(g),
        _ = n(59),
        O = r(_),
        w = n(8),
        x = r(w),
        k = n(60),
        E = r(k),
        N = n(61),
        j = r(N),
        A = n(25),
        q = r(A);
      a.default.register({
        "blots/block": u.default,
        "blots/block/embed": s.BlockEmbed,
        "blots/break": f.default,
        "blots/container": p.default,
        "blots/cursor": y.default,
        "blots/embed": b.default,
        "blots/inline": m.default,
        "blots/scroll": O.default,
        "blots/text": x.default,
        "modules/clipboard": E.default,
        "modules/history": j.default,
        "modules/keyboard": q.default,
      }),
        i.default.register(
          u.default,
          f.default,
          y.default,
          m.default,
          O.default,
          x.default
        ),
        (e.default = a.default);
    },
    function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var r = (function () {
        function t() {
          (this.head = this.tail = null), (this.length = 0);
        }
        return (
          (t.prototype.append = function () {
            for (var t = [], e = 0; e < arguments.length; e++)
              t[e] = arguments[e];
            this.insertBefore(t[0], null),
              t.length > 1 && this.append.apply(this, t.slice(1));
          }),
          (t.prototype.contains = function (t) {
            for (var e, n = this.iterator(); (e = n()); )
              if (e === t) return !0;
            return !1;
          }),
          (t.prototype.insertBefore = function (t, e) {
            t &&
              ((t.next = e),
              null != e
                ? ((t.prev = e.prev),
                  null != e.prev && (e.prev.next = t),
                  (e.prev = t),
                  e === this.head && (this.head = t))
                : null != this.tail
                ? ((this.tail.next = t), (t.prev = this.tail), (this.tail = t))
                : ((t.prev = null), (this.head = this.tail = t)),
              (this.length += 1));
          }),
          (t.prototype.offset = function (t) {
            for (var e = 0, n = this.head; null != n; ) {
              if (n === t) return e;
              (e += n.length()), (n = n.next);
            }
            return -1;
          }),
          (t.prototype.remove = function (t) {
            this.contains(t) &&
              (null != t.prev && (t.prev.next = t.next),
              null != t.next && (t.next.prev = t.prev),
              t === this.head && (this.head = t.next),
              t === this.tail && (this.tail = t.prev),
              (this.length -= 1));
          }),
          (t.prototype.iterator = function (t) {
            return (
              void 0 === t && (t = this.head),
              function () {
                var e = t;
                return null != t && (t = t.next), e;
              }
            );
          }),
          (t.prototype.find = function (t, e) {
            void 0 === e && (e = !1);
            for (var n, r = this.iterator(); (n = r()); ) {
              var o = n.length();
              if (
                t < o ||
                (e && t === o && (null == n.next || 0 !== n.next.length()))
              )
                return [n, t];
              t -= o;
            }
            return [null, 0];
          }),
          (t.prototype.forEach = function (t) {
            for (var e, n = this.iterator(); (e = n()); ) t(e);
          }),
          (t.prototype.forEachAt = function (t, e, n) {
            if (!(e <= 0))
              for (
                var r,
                  o = this.find(t),
                  i = o[0],
                  l = o[1],
                  a = t - l,
                  s = this.iterator(i);
                (r = s()) && a < t + e;

              ) {
                var u = r.length();
                t > a
                  ? n(r, t - a, Math.min(e, a + u - t))
                  : n(r, 0, Math.min(u, t + e - a)),
                  (a += u);
              }
          }),
          (t.prototype.map = function (t) {
            return this.reduce(function (e, n) {
              return e.push(t(n)), e;
            }, []);
          }),
          (t.prototype.reduce = function (t, e) {
            for (var n, r = this.iterator(); (n = r()); ) e = t(e, n);
            return e;
          }),
          t
        );
      })();
      e.default = r;
    },
    function (t, e, n) {
      "use strict";
      var r =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = n(17),
        i = n(1),
        l = {
          attributes: !0,
          characterData: !0,
          characterDataOldValue: !0,
          childList: !0,
          subtree: !0,
        },
        a = (function (t) {
          function e(e) {
            var n = t.call(this, e) || this;
            return (
              (n.scroll = n),
              (n.observer = new MutationObserver(function (t) {
                n.update(t);
              })),
              n.observer.observe(n.domNode, l),
              n.attach(),
              n
            );
          }
          return (
            r(e, t),
            (e.prototype.detach = function () {
              t.prototype.detach.call(this), this.observer.disconnect();
            }),
            (e.prototype.deleteAt = function (e, n) {
              this.update(),
                0 === e && n === this.length()
                  ? this.children.forEach(function (t) {
                      t.remove();
                    })
                  : t.prototype.deleteAt.call(this, e, n);
            }),
            (e.prototype.formatAt = function (e, n, r, o) {
              this.update(), t.prototype.formatAt.call(this, e, n, r, o);
            }),
            (e.prototype.insertAt = function (e, n, r) {
              this.update(), t.prototype.insertAt.call(this, e, n, r);
            }),
            (e.prototype.optimize = function (e, n) {
              var r = this;
              void 0 === e && (e = []),
                void 0 === n && (n = {}),
                t.prototype.optimize.call(this, n);
              for (
                var l = [].slice.call(this.observer.takeRecords());
                l.length > 0;

              )
                e.push(l.pop());
              for (
                var a = function (t, e) {
                    void 0 === e && (e = !0),
                      null != t &&
                        t !== r &&
                        null != t.domNode.parentNode &&
                        (null == t.domNode[i.DATA_KEY].mutations &&
                          (t.domNode[i.DATA_KEY].mutations = []),
                        e && a(t.parent));
                  },
                  s = function (t) {
                    null != t.domNode[i.DATA_KEY] &&
                      null != t.domNode[i.DATA_KEY].mutations &&
                      (t instanceof o.default && t.children.forEach(s),
                      t.optimize(n));
                  },
                  u = e,
                  c = 0;
                u.length > 0;
                c += 1
              ) {
                if (c >= 100)
                  throw new Error(
                    "[Parchment] Maximum optimize iterations reached"
                  );
                for (
                  u.forEach(function (t) {
                    var e = i.find(t.target, !0);
                    null != e &&
                      (e.domNode === t.target &&
                        ("childList" === t.type
                          ? (a(i.find(t.previousSibling, !1)),
                            [].forEach.call(t.addedNodes, function (t) {
                              var e = i.find(t, !1);
                              a(e, !1),
                                e instanceof o.default &&
                                  e.children.forEach(function (t) {
                                    a(t, !1);
                                  });
                            }))
                          : "attributes" === t.type && a(e.prev)),
                      a(e));
                  }),
                    this.children.forEach(s),
                    u = [].slice.call(this.observer.takeRecords()),
                    l = u.slice();
                  l.length > 0;

                )
                  e.push(l.pop());
              }
            }),
            (e.prototype.update = function (e, n) {
              var r = this;
              void 0 === n && (n = {}),
                (e = e || this.observer.takeRecords()),
                e
                  .map(function (t) {
                    var e = i.find(t.target, !0);
                    return null == e
                      ? null
                      : null == e.domNode[i.DATA_KEY].mutations
                      ? ((e.domNode[i.DATA_KEY].mutations = [t]), e)
                      : (e.domNode[i.DATA_KEY].mutations.push(t), null);
                  })
                  .forEach(function (t) {
                    null != t &&
                      t !== r &&
                      null != t.domNode[i.DATA_KEY] &&
                      t.update(t.domNode[i.DATA_KEY].mutations || [], n);
                  }),
                null != this.domNode[i.DATA_KEY].mutations &&
                  t.prototype.update.call(
                    this,
                    this.domNode[i.DATA_KEY].mutations,
                    n
                  ),
                this.optimize(e, n);
            }),
            (e.blotName = "scroll"),
            (e.defaultChild = "block"),
            (e.scope = i.Scope.BLOCK_BLOT),
            (e.tagName = "DIV"),
            e
          );
        })(o.default);
      e.default = a;
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (Object.keys(t).length !== Object.keys(e).length) return !1;
        for (var n in t) if (t[n] !== e[n]) return !1;
        return !0;
      }
      var o =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var i = n(18),
        l = n(1),
        a = (function (t) {
          function e() {
            return (null !== t && t.apply(this, arguments)) || this;
          }
          return (
            o(e, t),
            (e.formats = function (n) {
              if (n.tagName !== e.tagName) return t.formats.call(this, n);
            }),
            (e.prototype.format = function (n, r) {
              var o = this;
              n !== this.statics.blotName || r
                ? t.prototype.format.call(this, n, r)
                : (this.children.forEach(function (t) {
                    t instanceof i.default || (t = t.wrap(e.blotName, !0)),
                      o.attributes.copy(t);
                  }),
                  this.unwrap());
            }),
            (e.prototype.formatAt = function (e, n, r, o) {
              if (null != this.formats()[r] || l.query(r, l.Scope.ATTRIBUTE)) {
                this.isolate(e, n).format(r, o);
              } else t.prototype.formatAt.call(this, e, n, r, o);
            }),
            (e.prototype.optimize = function (n) {
              t.prototype.optimize.call(this, n);
              var o = this.formats();
              if (0 === Object.keys(o).length) return this.unwrap();
              var i = this.next;
              i instanceof e &&
                i.prev === this &&
                r(o, i.formats()) &&
                (i.moveChildren(this), i.remove());
            }),
            (e.blotName = "inline"),
            (e.scope = l.Scope.INLINE_BLOT),
            (e.tagName = "SPAN"),
            e
          );
        })(i.default);
      e.default = a;
    },
    function (t, e, n) {
      "use strict";
      var r =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = n(18),
        i = n(1),
        l = (function (t) {
          function e() {
            return (null !== t && t.apply(this, arguments)) || this;
          }
          return (
            r(e, t),
            (e.formats = function (n) {
              var r = i.query(e.blotName).tagName;
              if (n.tagName !== r) return t.formats.call(this, n);
            }),
            (e.prototype.format = function (n, r) {
              null != i.query(n, i.Scope.BLOCK) &&
                (n !== this.statics.blotName || r
                  ? t.prototype.format.call(this, n, r)
                  : this.replaceWith(e.blotName));
            }),
            (e.prototype.formatAt = function (e, n, r, o) {
              null != i.query(r, i.Scope.BLOCK)
                ? this.format(r, o)
                : t.prototype.formatAt.call(this, e, n, r, o);
            }),
            (e.prototype.insertAt = function (e, n, r) {
              if (null == r || null != i.query(n, i.Scope.INLINE))
                t.prototype.insertAt.call(this, e, n, r);
              else {
                var o = this.split(e),
                  l = i.create(n, r);
                o.parent.insertBefore(l, o);
              }
            }),
            (e.prototype.update = function (e, n) {
              navigator.userAgent.match(/Trident/)
                ? this.build()
                : t.prototype.update.call(this, e, n);
            }),
            (e.blotName = "block"),
            (e.scope = i.Scope.BLOCK_BLOT),
            (e.tagName = "P"),
            e
          );
        })(o.default);
      e.default = l;
    },
    function (t, e, n) {
      "use strict";
      var r =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = n(19),
        i = (function (t) {
          function e() {
            return (null !== t && t.apply(this, arguments)) || this;
          }
          return (
            r(e, t),
            (e.formats = function (t) {}),
            (e.prototype.format = function (e, n) {
              t.prototype.formatAt.call(this, 0, this.length(), e, n);
            }),
            (e.prototype.formatAt = function (e, n, r, o) {
              0 === e && n === this.length()
                ? this.format(r, o)
                : t.prototype.formatAt.call(this, e, n, r, o);
            }),
            (e.prototype.formats = function () {
              return this.statics.formats(this.domNode);
            }),
            e
          );
        })(o.default);
      e.default = i;
    },
    function (t, e, n) {
      "use strict";
      var r =
        (this && this.__extends) ||
        (function () {
          var t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
            };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })();
      Object.defineProperty(e, "__esModule", { value: !0 });
      var o = n(19),
        i = n(1),
        l = (function (t) {
          function e(e) {
            var n = t.call(this, e) || this;
            return (n.text = n.statics.value(n.domNode)), n;
          }
          return (
            r(e, t),
            (e.create = function (t) {
              return document.createTextNode(t);
            }),
            (e.value = function (t) {
              var e = t.data;
              return e.normalize && (e = e.normalize()), e;
            }),
            (e.prototype.deleteAt = function (t, e) {
              this.domNode.data = this.text =
                this.text.slice(0, t) + this.text.slice(t + e);
            }),
            (e.prototype.index = function (t, e) {
              return this.domNode === t ? e : -1;
            }),
            (e.prototype.insertAt = function (e, n, r) {
              null == r
                ? ((this.text = this.text.slice(0, e) + n + this.text.slice(e)),
                  (this.domNode.data = this.text))
                : t.prototype.insertAt.call(this, e, n, r);
            }),
            (e.prototype.length = function () {
              return this.text.length;
            }),
            (e.prototype.optimize = function (n) {
              t.prototype.optimize.call(this, n),
                (this.text = this.statics.value(this.domNode)),
                0 === this.text.length
                  ? this.remove()
                  : this.next instanceof e &&
                    this.next.prev === this &&
                    (this.insertAt(this.length(), this.next.value()),
                    this.next.remove());
            }),
            (e.prototype.position = function (t, e) {
              return void 0 === e && (e = !1), [this.domNode, t];
            }),
            (e.prototype.split = function (t, e) {
              if ((void 0 === e && (e = !1), !e)) {
                if (0 === t) return this;
                if (t === this.length()) return this.next;
              }
              var n = i.create(this.domNode.splitText(t));
              return (
                this.parent.insertBefore(n, this.next),
                (this.text = this.statics.value(this.domNode)),
                n
              );
            }),
            (e.prototype.update = function (t, e) {
              var n = this;
              t.some(function (t) {
                return "characterData" === t.type && t.target === n.domNode;
              }) && (this.text = this.statics.value(this.domNode));
            }),
            (e.prototype.value = function () {
              return this.text;
            }),
            (e.blotName = "text"),
            (e.scope = i.Scope.INLINE_BLOT),
            e
          );
        })(o.default);
      e.default = l;
    },
    function (t, e, n) {
      "use strict";
      var r = document.createElement("div");
      if (
        (r.classList.toggle("test-class", !1),
        r.classList.contains("test-class"))
      ) {
        var o = DOMTokenList.prototype.toggle;
        DOMTokenList.prototype.toggle = function (t, e) {
          return arguments.length > 1 && !this.contains(t) == !e
            ? e
            : o.call(this, t);
        };
      }
      String.prototype.startsWith ||
        (String.prototype.startsWith = function (t, e) {
          return (e = e || 0), this.substr(e, t.length) === t;
        }),
        String.prototype.endsWith ||
          (String.prototype.endsWith = function (t, e) {
            var n = this.toString();
            ("number" != typeof e ||
              !isFinite(e) ||
              Math.floor(e) !== e ||
              e > n.length) &&
              (e = n.length),
              (e -= t.length);
            var r = n.indexOf(t, e);
            return -1 !== r && r === e;
          }),
        Array.prototype.find ||
          Object.defineProperty(Array.prototype, "find", {
            value: function (t) {
              if (null === this)
                throw new TypeError(
                  "Array.prototype.find called on null or undefined"
                );
              if ("function" != typeof t)
                throw new TypeError("predicate must be a function");
              for (
                var e,
                  n = Object(this),
                  r = n.length >>> 0,
                  o = arguments[1],
                  i = 0;
                i < r;
                i++
              )
                if (((e = n[i]), t.call(o, e, i, n))) return e;
            },
          }),
        document.addEventListener("DOMContentLoaded", function () {
          document.execCommand("enableObjectResizing", !1, !1),
            document.execCommand("autoUrlDetect", !1, !1);
        });
    },
    function (t, e) {
      function n(t, e, n) {
        if (t == e) return t ? [[v, t]] : [];
        (n < 0 || t.length < n) && (n = null);
        var o = l(t, e),
          i = t.substring(0, o);
        (t = t.substring(o)), (e = e.substring(o)), (o = a(t, e));
        var s = t.substring(t.length - o);
        (t = t.substring(0, t.length - o)), (e = e.substring(0, e.length - o));
        var c = r(t, e);
        return (
          i && c.unshift([v, i]),
          s && c.push([v, s]),
          u(c),
          null != n && (c = f(c, n)),
          (c = h(c))
        );
      }
      function r(t, e) {
        var r;
        if (!t) return [[y, e]];
        if (!e) return [[d, t]];
        var i = t.length > e.length ? t : e,
          l = t.length > e.length ? e : t,
          a = i.indexOf(l);
        if (-1 != a)
          return (
            (r = [
              [y, i.substring(0, a)],
              [v, l],
              [y, i.substring(a + l.length)],
            ]),
            t.length > e.length && (r[0][0] = r[2][0] = d),
            r
          );
        if (1 == l.length)
          return [
            [d, t],
            [y, e],
          ];
        var u = s(t, e);
        if (u) {
          var c = u[0],
            f = u[1],
            h = u[2],
            p = u[3],
            b = u[4],
            g = n(c, h),
            m = n(f, p);
          return g.concat([[v, b]], m);
        }
        return o(t, e);
      }
      function o(t, e) {
        for (
          var n = t.length,
            r = e.length,
            o = Math.ceil((n + r) / 2),
            l = o,
            a = 2 * o,
            s = new Array(a),
            u = new Array(a),
            c = 0;
          c < a;
          c++
        )
          (s[c] = -1), (u[c] = -1);
        (s[l + 1] = 0), (u[l + 1] = 0);
        for (
          var f = n - r, h = f % 2 != 0, p = 0, v = 0, b = 0, g = 0, m = 0;
          m < o;
          m++
        ) {
          for (var _ = -m + p; _ <= m - v; _ += 2) {
            var O,
              w = l + _;
            O =
              _ == -m || (_ != m && s[w - 1] < s[w + 1])
                ? s[w + 1]
                : s[w - 1] + 1;
            for (var x = O - _; O < n && x < r && t.charAt(O) == e.charAt(x); )
              O++, x++;
            if (((s[w] = O), O > n)) v += 2;
            else if (x > r) p += 2;
            else if (h) {
              var k = l + f - _;
              if (k >= 0 && k < a && -1 != u[k]) {
                var E = n - u[k];
                if (O >= E) return i(t, e, O, x);
              }
            }
          }
          for (var N = -m + b; N <= m - g; N += 2) {
            var E,
              k = l + N;
            E =
              N == -m || (N != m && u[k - 1] < u[k + 1])
                ? u[k + 1]
                : u[k - 1] + 1;
            for (
              var j = E - N;
              E < n && j < r && t.charAt(n - E - 1) == e.charAt(r - j - 1);

            )
              E++, j++;
            if (((u[k] = E), E > n)) g += 2;
            else if (j > r) b += 2;
            else if (!h) {
              var w = l + f - N;
              if (w >= 0 && w < a && -1 != s[w]) {
                var O = s[w],
                  x = l + O - w;
                if (((E = n - E), O >= E)) return i(t, e, O, x);
              }
            }
          }
        }
        return [
          [d, t],
          [y, e],
        ];
      }
      function i(t, e, r, o) {
        var i = t.substring(0, r),
          l = e.substring(0, o),
          a = t.substring(r),
          s = e.substring(o),
          u = n(i, l),
          c = n(a, s);
        return u.concat(c);
      }
      function l(t, e) {
        if (!t || !e || t.charAt(0) != e.charAt(0)) return 0;
        for (var n = 0, r = Math.min(t.length, e.length), o = r, i = 0; n < o; )
          t.substring(i, o) == e.substring(i, o) ? ((n = o), (i = n)) : (r = o),
            (o = Math.floor((r - n) / 2 + n));
        return o;
      }
      function a(t, e) {
        if (!t || !e || t.charAt(t.length - 1) != e.charAt(e.length - 1))
          return 0;
        for (var n = 0, r = Math.min(t.length, e.length), o = r, i = 0; n < o; )
          t.substring(t.length - o, t.length - i) ==
          e.substring(e.length - o, e.length - i)
            ? ((n = o), (i = n))
            : (r = o),
            (o = Math.floor((r - n) / 2 + n));
        return o;
      }
      function s(t, e) {
        function n(t, e, n) {
          for (
            var r,
              o,
              i,
              s,
              u = t.substring(n, n + Math.floor(t.length / 4)),
              c = -1,
              f = "";
            -1 != (c = e.indexOf(u, c + 1));

          ) {
            var h = l(t.substring(n), e.substring(c)),
              p = a(t.substring(0, n), e.substring(0, c));
            f.length < p + h &&
              ((f = e.substring(c - p, c) + e.substring(c, c + h)),
              (r = t.substring(0, n - p)),
              (o = t.substring(n + h)),
              (i = e.substring(0, c - p)),
              (s = e.substring(c + h)));
          }
          return 2 * f.length >= t.length ? [r, o, i, s, f] : null;
        }
        var r = t.length > e.length ? t : e,
          o = t.length > e.length ? e : t;
        if (r.length < 4 || 2 * o.length < r.length) return null;
        var i,
          s = n(r, o, Math.ceil(r.length / 4)),
          u = n(r, o, Math.ceil(r.length / 2));
        if (!s && !u) return null;
        i = u ? (s && s[4].length > u[4].length ? s : u) : s;
        var c, f, h, p;
        return (
          t.length > e.length
            ? ((c = i[0]), (f = i[1]), (h = i[2]), (p = i[3]))
            : ((h = i[0]), (p = i[1]), (c = i[2]), (f = i[3])),
          [c, f, h, p, i[4]]
        );
      }
      function u(t) {
        t.push([v, ""]);
        for (var e, n = 0, r = 0, o = 0, i = "", s = ""; n < t.length; )
          switch (t[n][0]) {
            case y:
              o++, (s += t[n][1]), n++;
              break;
            case d:
              r++, (i += t[n][1]), n++;
              break;
            case v:
              r + o > 1
                ? (0 !== r &&
                    0 !== o &&
                    ((e = l(s, i)),
                    0 !== e &&
                      (n - r - o > 0 && t[n - r - o - 1][0] == v
                        ? (t[n - r - o - 1][1] += s.substring(0, e))
                        : (t.splice(0, 0, [v, s.substring(0, e)]), n++),
                      (s = s.substring(e)),
                      (i = i.substring(e))),
                    0 !== (e = a(s, i)) &&
                      ((t[n][1] = s.substring(s.length - e) + t[n][1]),
                      (s = s.substring(0, s.length - e)),
                      (i = i.substring(0, i.length - e)))),
                  0 === r
                    ? t.splice(n - o, r + o, [y, s])
                    : 0 === o
                    ? t.splice(n - r, r + o, [d, i])
                    : t.splice(n - r - o, r + o, [d, i], [y, s]),
                  (n = n - r - o + (r ? 1 : 0) + (o ? 1 : 0) + 1))
                : 0 !== n && t[n - 1][0] == v
                ? ((t[n - 1][1] += t[n][1]), t.splice(n, 1))
                : n++,
                (o = 0),
                (r = 0),
                (i = ""),
                (s = "");
          }
        "" === t[t.length - 1][1] && t.pop();
        var c = !1;
        for (n = 1; n < t.length - 1; )
          t[n - 1][0] == v &&
            t[n + 1][0] == v &&
            (t[n][1].substring(t[n][1].length - t[n - 1][1].length) ==
            t[n - 1][1]
              ? ((t[n][1] =
                  t[n - 1][1] +
                  t[n][1].substring(0, t[n][1].length - t[n - 1][1].length)),
                (t[n + 1][1] = t[n - 1][1] + t[n + 1][1]),
                t.splice(n - 1, 1),
                (c = !0))
              : t[n][1].substring(0, t[n + 1][1].length) == t[n + 1][1] &&
                ((t[n - 1][1] += t[n + 1][1]),
                (t[n][1] = t[n][1].substring(t[n + 1][1].length) + t[n + 1][1]),
                t.splice(n + 1, 1),
                (c = !0))),
            n++;
        c && u(t);
      }
      function c(t, e) {
        if (0 === e) return [v, t];
        for (var n = 0, r = 0; r < t.length; r++) {
          var o = t[r];
          if (o[0] === d || o[0] === v) {
            var i = n + o[1].length;
            if (e === i) return [r + 1, t];
            if (e < i) {
              t = t.slice();
              var l = e - n,
                a = [o[0], o[1].slice(0, l)],
                s = [o[0], o[1].slice(l)];
              return t.splice(r, 1, a, s), [r + 1, t];
            }
            n = i;
          }
        }
        throw new Error("cursor_pos is out of bounds!");
      }
      function f(t, e) {
        var n = c(t, e),
          r = n[1],
          o = n[0],
          i = r[o],
          l = r[o + 1];
        if (null == i) return t;
        if (i[0] !== v) return t;
        if (null != l && i[1] + l[1] === l[1] + i[1])
          return r.splice(o, 2, l, i), p(r, o, 2);
        if (null != l && 0 === l[1].indexOf(i[1])) {
          r.splice(o, 2, [l[0], i[1]], [0, i[1]]);
          var a = l[1].slice(i[1].length);
          return a.length > 0 && r.splice(o + 2, 0, [l[0], a]), p(r, o, 3);
        }
        return t;
      }
      function h(t) {
        for (
          var e = !1,
            n = function (t) {
              return t.charCodeAt(0) >= 56320 && t.charCodeAt(0) <= 57343;
            },
            r = 2;
          r < t.length;
          r += 1
        )
          t[r - 2][0] === v &&
            (function (t) {
              return (
                t.charCodeAt(t.length - 1) >= 55296 &&
                t.charCodeAt(t.length - 1) <= 56319
              );
            })(t[r - 2][1]) &&
            t[r - 1][0] === d &&
            n(t[r - 1][1]) &&
            t[r][0] === y &&
            n(t[r][1]) &&
            ((e = !0),
            (t[r - 1][1] = t[r - 2][1].slice(-1) + t[r - 1][1]),
            (t[r][1] = t[r - 2][1].slice(-1) + t[r][1]),
            (t[r - 2][1] = t[r - 2][1].slice(0, -1)));
        if (!e) return t;
        for (var o = [], r = 0; r < t.length; r += 1)
          t[r][1].length > 0 && o.push(t[r]);
        return o;
      }
      function p(t, e, n) {
        for (var r = e + n - 1; r >= 0 && r >= e - 1; r--)
          if (r + 1 < t.length) {
            var o = t[r],
              i = t[r + 1];
            o[0] === i[1] && t.splice(r, 2, [o[0], o[1] + i[1]]);
          }
        return t;
      }
      var d = -1,
        y = 1,
        v = 0,
        b = n;
      (b.INSERT = y), (b.DELETE = d), (b.EQUAL = v), (t.exports = b);
    },
    function (t, e) {
      function n(t) {
        var e = [];
        for (var n in t) e.push(n);
        return e;
      }
      (e = t.exports = "function" == typeof Object.keys ? Object.keys : n),
        (e.shim = n);
    },
    function (t, e) {
      function n(t) {
        return "[object Arguments]" == Object.prototype.toString.call(t);
      }
      function r(t) {
        return (
          (t &&
            "object" == typeof t &&
            "number" == typeof t.length &&
            Object.prototype.hasOwnProperty.call(t, "callee") &&
            !Object.prototype.propertyIsEnumerable.call(t, "callee")) ||
          !1
        );
      }
      var o =
        "[object Arguments]" ==
        (function () {
          return Object.prototype.toString.call(arguments);
        })();
      (e = t.exports = o ? n : r), (e.supported = n), (e.unsupported = r);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function i(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function l(t, e) {
        return Object.keys(e).reduce(function (n, r) {
          return null == t[r]
            ? n
            : (e[r] === t[r]
                ? (n[r] = e[r])
                : Array.isArray(e[r])
                ? e[r].indexOf(t[r]) < 0 && (n[r] = e[r].concat([t[r]]))
                : (n[r] = [e[r], t[r]]),
              n);
        }, {});
      }
      function a(t) {
        return t.reduce(function (t, e) {
          if (1 === e.insert) {
            var n = (0, N.default)(e.attributes);
            return delete n.image, t.insert({ image: e.attributes.image }, n);
          }
          if (
            (null == e.attributes ||
              (!0 !== e.attributes.list && !0 !== e.attributes.bullet) ||
              ((e = (0, N.default)(e)),
              e.attributes.list
                ? (e.attributes.list = "ordered")
                : ((e.attributes.list = "bullet"), delete e.attributes.bullet)),
            "string" == typeof e.insert)
          ) {
            var r = e.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
            return t.insert(r, e.attributes);
          }
          return t.push(e);
        }, new h.default());
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var s =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              },
        u = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        c = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        f = n(4),
        h = r(f),
        p = n(20),
        d = r(p),
        y = n(0),
        v = r(y),
        b = n(13),
        g = r(b),
        m = n(31),
        _ = r(m),
        O = n(3),
        w = r(O),
        x = n(14),
        k = r(x),
        E = n(21),
        N = r(E),
        j = n(12),
        A = r(j),
        q = n(2),
        T = r(q),
        P = /^[ -~]*$/,
        S = (function () {
          function t(e) {
            i(this, t), (this.scroll = e), (this.delta = this.getDelta());
          }
          return (
            c(t, [
              {
                key: "applyDelta",
                value: function (t) {
                  var e = this,
                    n = !1;
                  this.scroll.update();
                  var r = this.scroll.length();
                  return (
                    this.scroll.batchStart(),
                    (t = a(t)),
                    t.reduce(function (t, o) {
                      var i = o.retain || o.delete || o.insert.length || 1,
                        l = o.attributes || {};
                      if (null != o.insert) {
                        if ("string" == typeof o.insert) {
                          var a = o.insert;
                          a.endsWith("\n") &&
                            n &&
                            ((n = !1), (a = a.slice(0, -1))),
                            t >= r && !a.endsWith("\n") && (n = !0),
                            e.scroll.insertAt(t, a);
                          var c = e.scroll.line(t),
                            f = u(c, 2),
                            h = f[0],
                            p = f[1],
                            y = (0, T.default)({}, (0, O.bubbleFormats)(h));
                          if (h instanceof w.default) {
                            var b = h.descendant(v.default.Leaf, p),
                              g = u(b, 1),
                              m = g[0];
                            y = (0, T.default)(y, (0, O.bubbleFormats)(m));
                          }
                          l = d.default.attributes.diff(y, l) || {};
                        } else if ("object" === s(o.insert)) {
                          var _ = Object.keys(o.insert)[0];
                          if (null == _) return t;
                          e.scroll.insertAt(t, _, o.insert[_]);
                        }
                        r += i;
                      }
                      return (
                        Object.keys(l).forEach(function (n) {
                          e.scroll.formatAt(t, i, n, l[n]);
                        }),
                        t + i
                      );
                    }, 0),
                    t.reduce(function (t, n) {
                      return "number" == typeof n.delete
                        ? (e.scroll.deleteAt(t, n.delete), t)
                        : t + (n.retain || n.insert.length || 1);
                    }, 0),
                    this.scroll.batchEnd(),
                    this.update(t)
                  );
                },
              },
              {
                key: "deleteText",
                value: function (t, e) {
                  return (
                    this.scroll.deleteAt(t, e),
                    this.update(new h.default().retain(t).delete(e))
                  );
                },
              },
              {
                key: "formatLine",
                value: function (t, e) {
                  var n = this,
                    r =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {};
                  return (
                    this.scroll.update(),
                    Object.keys(r).forEach(function (o) {
                      if (null == n.scroll.whitelist || n.scroll.whitelist[o]) {
                        var i = n.scroll.lines(t, Math.max(e, 1)),
                          l = e;
                        i.forEach(function (e) {
                          var i = e.length();
                          if (e instanceof g.default) {
                            var a = t - e.offset(n.scroll),
                              s = e.newlineIndex(a + l) - a + 1;
                            e.formatAt(a, s, o, r[o]);
                          } else e.format(o, r[o]);
                          l -= i;
                        });
                      }
                    }),
                    this.scroll.optimize(),
                    this.update(
                      new h.default().retain(t).retain(e, (0, N.default)(r))
                    )
                  );
                },
              },
              {
                key: "formatText",
                value: function (t, e) {
                  var n = this,
                    r =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {};
                  return (
                    Object.keys(r).forEach(function (o) {
                      n.scroll.formatAt(t, e, o, r[o]);
                    }),
                    this.update(
                      new h.default().retain(t).retain(e, (0, N.default)(r))
                    )
                  );
                },
              },
              {
                key: "getContents",
                value: function (t, e) {
                  return this.delta.slice(t, t + e);
                },
              },
              {
                key: "getDelta",
                value: function () {
                  return this.scroll.lines().reduce(function (t, e) {
                    return t.concat(e.delta());
                  }, new h.default());
                },
              },
              {
                key: "getFormat",
                value: function (t) {
                  var e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : 0,
                    n = [],
                    r = [];
                  0 === e
                    ? this.scroll.path(t).forEach(function (t) {
                        var e = u(t, 1),
                          o = e[0];
                        o instanceof w.default
                          ? n.push(o)
                          : o instanceof v.default.Leaf && r.push(o);
                      })
                    : ((n = this.scroll.lines(t, e)),
                      (r = this.scroll.descendants(v.default.Leaf, t, e)));
                  var o = [n, r].map(function (t) {
                    if (0 === t.length) return {};
                    for (
                      var e = (0, O.bubbleFormats)(t.shift());
                      Object.keys(e).length > 0;

                    ) {
                      var n = t.shift();
                      if (null == n) return e;
                      e = l((0, O.bubbleFormats)(n), e);
                    }
                    return e;
                  });
                  return T.default.apply(T.default, o);
                },
              },
              {
                key: "getText",
                value: function (t, e) {
                  return this.getContents(t, e)
                    .filter(function (t) {
                      return "string" == typeof t.insert;
                    })
                    .map(function (t) {
                      return t.insert;
                    })
                    .join("");
                },
              },
              {
                key: "insertEmbed",
                value: function (t, e, n) {
                  return (
                    this.scroll.insertAt(t, e, n),
                    this.update(new h.default().retain(t).insert(o({}, e, n)))
                  );
                },
              },
              {
                key: "insertText",
                value: function (t, e) {
                  var n = this,
                    r =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {};
                  return (
                    (e = e.replace(/\r\n/g, "\n").replace(/\r/g, "\n")),
                    this.scroll.insertAt(t, e),
                    Object.keys(r).forEach(function (o) {
                      n.scroll.formatAt(t, e.length, o, r[o]);
                    }),
                    this.update(
                      new h.default().retain(t).insert(e, (0, N.default)(r))
                    )
                  );
                },
              },
              {
                key: "isBlank",
                value: function () {
                  if (0 == this.scroll.children.length) return !0;
                  if (this.scroll.children.length > 1) return !1;
                  var t = this.scroll.children.head;
                  return (
                    t.statics.blotName === w.default.blotName &&
                    !(t.children.length > 1) &&
                    t.children.head instanceof k.default
                  );
                },
              },
              {
                key: "removeFormat",
                value: function (t, e) {
                  var n = this.getText(t, e),
                    r = this.scroll.line(t + e),
                    o = u(r, 2),
                    i = o[0],
                    l = o[1],
                    a = 0,
                    s = new h.default();
                  null != i &&
                    ((a =
                      i instanceof g.default
                        ? i.newlineIndex(l) - l + 1
                        : i.length() - l),
                    (s = i
                      .delta()
                      .slice(l, l + a - 1)
                      .insert("\n")));
                  var c = this.getContents(t, e + a),
                    f = c.diff(new h.default().insert(n).concat(s)),
                    p = new h.default().retain(t).concat(f);
                  return this.applyDelta(p);
                },
              },
              {
                key: "update",
                value: function (t) {
                  var e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : [],
                    n =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : void 0,
                    r = this.delta;
                  if (
                    1 === e.length &&
                    "characterData" === e[0].type &&
                    e[0].target.data.match(P) &&
                    v.default.find(e[0].target)
                  ) {
                    var o = v.default.find(e[0].target),
                      i = (0, O.bubbleFormats)(o),
                      l = o.offset(this.scroll),
                      a = e[0].oldValue.replace(_.default.CONTENTS, ""),
                      s = new h.default().insert(a),
                      u = new h.default().insert(o.value());
                    (t = new h.default()
                      .retain(l)
                      .concat(s.diff(u, n))
                      .reduce(function (t, e) {
                        return e.insert ? t.insert(e.insert, i) : t.push(e);
                      }, new h.default())),
                      (this.delta = r.compose(t));
                  } else
                    (this.delta = this.getDelta()),
                      (t && (0, A.default)(r.compose(t), this.delta)) ||
                        (t = r.diff(this.delta, n));
                  return t;
                },
              },
            ]),
            t
          );
        })();
      e.default = S;
    },
    function (t, e) {
      "use strict";
      function n() {}
      function r(t, e, n) {
        (this.fn = t), (this.context = e), (this.once = n || !1);
      }
      function o() {
        (this._events = new n()), (this._eventsCount = 0);
      }
      var i = Object.prototype.hasOwnProperty,
        l = "~";
      Object.create &&
        ((n.prototype = Object.create(null)), new n().__proto__ || (l = !1)),
        (o.prototype.eventNames = function () {
          var t,
            e,
            n = [];
          if (0 === this._eventsCount) return n;
          for (e in (t = this._events))
            i.call(t, e) && n.push(l ? e.slice(1) : e);
          return Object.getOwnPropertySymbols
            ? n.concat(Object.getOwnPropertySymbols(t))
            : n;
        }),
        (o.prototype.listeners = function (t, e) {
          var n = l ? l + t : t,
            r = this._events[n];
          if (e) return !!r;
          if (!r) return [];
          if (r.fn) return [r.fn];
          for (var o = 0, i = r.length, a = new Array(i); o < i; o++)
            a[o] = r[o].fn;
          return a;
        }),
        (o.prototype.emit = function (t, e, n, r, o, i) {
          var a = l ? l + t : t;
          if (!this._events[a]) return !1;
          var s,
            u,
            c = this._events[a],
            f = arguments.length;
          if (c.fn) {
            switch ((c.once && this.removeListener(t, c.fn, void 0, !0), f)) {
              case 1:
                return c.fn.call(c.context), !0;
              case 2:
                return c.fn.call(c.context, e), !0;
              case 3:
                return c.fn.call(c.context, e, n), !0;
              case 4:
                return c.fn.call(c.context, e, n, r), !0;
              case 5:
                return c.fn.call(c.context, e, n, r, o), !0;
              case 6:
                return c.fn.call(c.context, e, n, r, o, i), !0;
            }
            for (u = 1, s = new Array(f - 1); u < f; u++)
              s[u - 1] = arguments[u];
            c.fn.apply(c.context, s);
          } else {
            var h,
              p = c.length;
            for (u = 0; u < p; u++)
              switch (
                (c[u].once && this.removeListener(t, c[u].fn, void 0, !0), f)
              ) {
                case 1:
                  c[u].fn.call(c[u].context);
                  break;
                case 2:
                  c[u].fn.call(c[u].context, e);
                  break;
                case 3:
                  c[u].fn.call(c[u].context, e, n);
                  break;
                case 4:
                  c[u].fn.call(c[u].context, e, n, r);
                  break;
                default:
                  if (!s)
                    for (h = 1, s = new Array(f - 1); h < f; h++)
                      s[h - 1] = arguments[h];
                  c[u].fn.apply(c[u].context, s);
              }
          }
          return !0;
        }),
        (o.prototype.on = function (t, e, n) {
          var o = new r(e, n || this),
            i = l ? l + t : t;
          return (
            this._events[i]
              ? this._events[i].fn
                ? (this._events[i] = [this._events[i], o])
                : this._events[i].push(o)
              : ((this._events[i] = o), this._eventsCount++),
            this
          );
        }),
        (o.prototype.once = function (t, e, n) {
          var o = new r(e, n || this, !0),
            i = l ? l + t : t;
          return (
            this._events[i]
              ? this._events[i].fn
                ? (this._events[i] = [this._events[i], o])
                : this._events[i].push(o)
              : ((this._events[i] = o), this._eventsCount++),
            this
          );
        }),
        (o.prototype.removeListener = function (t, e, r, o) {
          var i = l ? l + t : t;
          if (!this._events[i]) return this;
          if (!e)
            return (
              0 == --this._eventsCount
                ? (this._events = new n())
                : delete this._events[i],
              this
            );
          var a = this._events[i];
          if (a.fn)
            a.fn !== e ||
              (o && !a.once) ||
              (r && a.context !== r) ||
              (0 == --this._eventsCount
                ? (this._events = new n())
                : delete this._events[i]);
          else {
            for (var s = 0, u = [], c = a.length; s < c; s++)
              (a[s].fn !== e ||
                (o && !a[s].once) ||
                (r && a[s].context !== r)) &&
                u.push(a[s]);
            u.length
              ? (this._events[i] = 1 === u.length ? u[0] : u)
              : 0 == --this._eventsCount
              ? (this._events = new n())
              : delete this._events[i];
          }
          return this;
        }),
        (o.prototype.removeAllListeners = function (t) {
          var e;
          return (
            t
              ? ((e = l ? l + t : t),
                this._events[e] &&
                  (0 == --this._eventsCount
                    ? (this._events = new n())
                    : delete this._events[e]))
              : ((this._events = new n()), (this._eventsCount = 0)),
            this
          );
        }),
        (o.prototype.off = o.prototype.removeListener),
        (o.prototype.addListener = o.prototype.on),
        (o.prototype.setMaxListeners = function () {
          return this;
        }),
        (o.prefixed = l),
        (o.EventEmitter = o),
        void 0 !== t && (t.exports = o);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      function a(t) {
        return t instanceof v.default || t instanceof y.BlockEmbed;
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var s = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        u = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        c = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        f = n(0),
        h = r(f),
        p = n(9),
        d = r(p),
        y = n(3),
        v = r(y),
        b = n(14),
        g = r(b),
        m = n(13),
        _ = r(m),
        O = n(23),
        w = r(O),
        x = (function (t) {
          function e(t, n) {
            o(this, e);
            var r = i(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t)
            );
            return (
              (r.emitter = n.emitter),
              Array.isArray(n.whitelist) &&
                (r.whitelist = n.whitelist.reduce(function (t, e) {
                  return (t[e] = !0), t;
                }, {})),
              r.domNode.addEventListener("DOMNodeInserted", function () {}),
              r.optimize(),
              r.enable(),
              r
            );
          }
          return (
            l(e, t),
            u(e, [
              {
                key: "batchStart",
                value: function () {
                  this.batch = !0;
                },
              },
              {
                key: "batchEnd",
                value: function () {
                  (this.batch = !1), this.optimize();
                },
              },
              {
                key: "deleteAt",
                value: function (t, n) {
                  var r = this.line(t),
                    o = s(r, 2),
                    i = o[0],
                    l = o[1],
                    a = this.line(t + n),
                    u = s(a, 1),
                    f = u[0];
                  if (
                    (c(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "deleteAt",
                      this
                    ).call(this, t, n),
                    null != f && i !== f && l > 0)
                  ) {
                    if (i instanceof y.BlockEmbed || f instanceof y.BlockEmbed)
                      return void this.optimize();
                    if (i instanceof _.default) {
                      var h = i.newlineIndex(i.length(), !0);
                      if (h > -1 && (i = i.split(h + 1)) === f)
                        return void this.optimize();
                    } else if (f instanceof _.default) {
                      var p = f.newlineIndex(0);
                      p > -1 && f.split(p + 1);
                    }
                    var d =
                      f.children.head instanceof g.default
                        ? null
                        : f.children.head;
                    i.moveChildren(f, d), i.remove();
                  }
                  this.optimize();
                },
              },
              {
                key: "enable",
                value: function () {
                  var t =
                    !(arguments.length > 0 && void 0 !== arguments[0]) ||
                    arguments[0];
                  this.domNode.setAttribute("contenteditable", t);
                },
              },
              {
                key: "formatAt",
                value: function (t, n, r, o) {
                  (null == this.whitelist || this.whitelist[r]) &&
                    (c(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "formatAt",
                      this
                    ).call(this, t, n, r, o),
                    this.optimize());
                },
              },
              {
                key: "insertAt",
                value: function (t, n, r) {
                  if (
                    null == r ||
                    null == this.whitelist ||
                    this.whitelist[n]
                  ) {
                    if (t >= this.length())
                      if (
                        null == r ||
                        null == h.default.query(n, h.default.Scope.BLOCK)
                      ) {
                        var o = h.default.create(this.statics.defaultChild);
                        this.appendChild(o),
                          null == r && n.endsWith("\n") && (n = n.slice(0, -1)),
                          o.insertAt(0, n, r);
                      } else {
                        var i = h.default.create(n, r);
                        this.appendChild(i);
                      }
                    else
                      c(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "insertAt",
                        this
                      ).call(this, t, n, r);
                    this.optimize();
                  }
                },
              },
              {
                key: "insertBefore",
                value: function (t, n) {
                  if (t.statics.scope === h.default.Scope.INLINE_BLOT) {
                    var r = h.default.create(this.statics.defaultChild);
                    r.appendChild(t), (t = r);
                  }
                  c(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "insertBefore",
                    this
                  ).call(this, t, n);
                },
              },
              {
                key: "leaf",
                value: function (t) {
                  return this.path(t).pop() || [null, -1];
                },
              },
              {
                key: "line",
                value: function (t) {
                  return t === this.length()
                    ? this.line(t - 1)
                    : this.descendant(a, t);
                },
              },
              {
                key: "lines",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : 0,
                    e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : Number.MAX_VALUE;
                  return (function t(e, n, r) {
                    var o = [],
                      i = r;
                    return (
                      e.children.forEachAt(n, r, function (e, n, r) {
                        a(e)
                          ? o.push(e)
                          : e instanceof h.default.Container &&
                            (o = o.concat(t(e, n, i))),
                          (i -= r);
                      }),
                      o
                    );
                  })(this, t, e);
                },
              },
              {
                key: "optimize",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : [],
                    n =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {};
                  !0 !== this.batch &&
                    (c(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "optimize",
                      this
                    ).call(this, t, n),
                    t.length > 0 &&
                      this.emitter.emit(
                        d.default.events.SCROLL_OPTIMIZE,
                        t,
                        n
                      ));
                },
              },
              {
                key: "path",
                value: function (t) {
                  return c(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "path",
                    this
                  )
                    .call(this, t)
                    .slice(1);
                },
              },
              {
                key: "update",
                value: function (t) {
                  if (!0 !== this.batch) {
                    var n = d.default.sources.USER;
                    "string" == typeof t && (n = t),
                      Array.isArray(t) || (t = this.observer.takeRecords()),
                      t.length > 0 &&
                        this.emitter.emit(
                          d.default.events.SCROLL_BEFORE_UPDATE,
                          n,
                          t
                        ),
                      c(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "update",
                        this
                      ).call(this, t.concat([])),
                      t.length > 0 &&
                        this.emitter.emit(d.default.events.SCROLL_UPDATE, n, t);
                  }
                },
              },
            ]),
            e
          );
        })(h.default.Scroll);
      (x.blotName = "scroll"),
        (x.className = "ql-editor"),
        (x.tagName = "DIV"),
        (x.defaultChild = "block"),
        (x.allowedChildren = [v.default, y.BlockEmbed, w.default]),
        (e.default = x);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function i(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function l(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function a(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      function s(t, e, n) {
        return "object" === (void 0 === e ? "undefined" : x(e))
          ? Object.keys(e).reduce(function (t, n) {
              return s(t, n, e[n]);
            }, t)
          : t.reduce(function (t, r) {
              return r.attributes && r.attributes[e]
                ? t.push(r)
                : t.insert(
                    r.insert,
                    (0, j.default)({}, o({}, e, n), r.attributes)
                  );
            }, new q.default());
      }
      function u(t) {
        if (t.nodeType !== Node.ELEMENT_NODE) return {};
        return (
          t["__ql-computed-style"] ||
          (t["__ql-computed-style"] = window.getComputedStyle(t))
        );
      }
      function c(t, e) {
        for (
          var n = "", r = t.ops.length - 1;
          r >= 0 && n.length < e.length;
          --r
        ) {
          var o = t.ops[r];
          if ("string" != typeof o.insert) break;
          n = o.insert + n;
        }
        return n.slice(-1 * e.length) === e;
      }
      function f(t) {
        return (
          0 !== t.childNodes.length &&
          ["block", "list-item"].indexOf(u(t).display) > -1
        );
      }
      function h(t, e, n) {
        return t.nodeType === t.TEXT_NODE
          ? n.reduce(function (e, n) {
              return n(t, e);
            }, new q.default())
          : t.nodeType === t.ELEMENT_NODE
          ? [].reduce.call(
              t.childNodes || [],
              function (r, o) {
                var i = h(o, e, n);
                return (
                  o.nodeType === t.ELEMENT_NODE &&
                    ((i = e.reduce(function (t, e) {
                      return e(o, t);
                    }, i)),
                    (i = (o[W] || []).reduce(function (t, e) {
                      return e(o, t);
                    }, i))),
                  r.concat(i)
                );
              },
              new q.default()
            )
          : new q.default();
      }
      function p(t, e, n) {
        return s(n, t, !0);
      }
      function d(t, e) {
        var n = P.default.Attributor.Attribute.keys(t),
          r = P.default.Attributor.Class.keys(t),
          o = P.default.Attributor.Style.keys(t),
          i = {};
        return (
          n
            .concat(r)
            .concat(o)
            .forEach(function (e) {
              var n = P.default.query(e, P.default.Scope.ATTRIBUTE);
              (null != n && ((i[n.attrName] = n.value(t)), i[n.attrName])) ||
                ((n = Y[e]),
                null == n ||
                  (n.attrName !== e && n.keyName !== e) ||
                  (i[n.attrName] = n.value(t) || void 0),
                null == (n = X[e]) ||
                  (n.attrName !== e && n.keyName !== e) ||
                  ((n = X[e]), (i[n.attrName] = n.value(t) || void 0)));
            }),
          Object.keys(i).length > 0 && (e = s(e, i)),
          e
        );
      }
      function y(t, e) {
        var n = P.default.query(t);
        if (null == n) return e;
        if (n.prototype instanceof P.default.Embed) {
          var r = {},
            o = n.value(t);
          null != o &&
            ((r[n.blotName] = o),
            (e = new q.default().insert(r, n.formats(t))));
        } else
          "function" == typeof n.formats &&
            (e = s(e, n.blotName, n.formats(t)));
        return e;
      }
      function v(t, e) {
        return c(e, "\n") || e.insert("\n"), e;
      }
      function b() {
        return new q.default();
      }
      function g(t, e) {
        var n = P.default.query(t);
        if (null == n || "list-item" !== n.blotName || !c(e, "\n")) return e;
        for (
          var r = -1, o = t.parentNode;
          !o.classList.contains("ql-clipboard");

        )
          "list" === (P.default.query(o) || {}).blotName && (r += 1),
            (o = o.parentNode);
        return r <= 0
          ? e
          : e.compose(
              new q.default().retain(e.length() - 1).retain(1, { indent: r })
            );
      }
      function m(t, e) {
        return (
          c(e, "\n") ||
            ((f(t) || (e.length() > 0 && t.nextSibling && f(t.nextSibling))) &&
              e.insert("\n")),
          e
        );
      }
      function _(t, e) {
        if (f(t) && null != t.nextElementSibling && !c(e, "\n\n")) {
          var n =
            t.offsetHeight +
            parseFloat(u(t).marginTop) +
            parseFloat(u(t).marginBottom);
          t.nextElementSibling.offsetTop > t.offsetTop + 1.5 * n &&
            e.insert("\n");
        }
        return e;
      }
      function O(t, e) {
        var n = {},
          r = t.style || {};
        return (
          r.fontStyle && "italic" === u(t).fontStyle && (n.italic = !0),
          r.fontWeight &&
            (u(t).fontWeight.startsWith("bold") ||
              parseInt(u(t).fontWeight) >= 700) &&
            (n.bold = !0),
          Object.keys(n).length > 0 && (e = s(e, n)),
          parseFloat(r.textIndent || 0) > 0 &&
            (e = new q.default().insert("\t").concat(e)),
          e
        );
      }
      function w(t, e) {
        var n = t.data;
        if ("O:P" === t.parentNode.tagName) return e.insert(n.trim());
        if (
          0 === n.trim().length &&
          t.parentNode.classList.contains("ql-clipboard")
        )
          return e;
        if (!u(t.parentNode).whiteSpace.startsWith("pre")) {
          var r = function (t, e) {
            return (
              (e = e.replace(/[^\u00a0]/g, "")), e.length < 1 && t ? " " : e
            );
          };
          (n = n.replace(/\r\n/g, " ").replace(/\n/g, " ")),
            (n = n.replace(/\s\s+/g, r.bind(r, !0))),
            ((null == t.previousSibling && f(t.parentNode)) ||
              (null != t.previousSibling && f(t.previousSibling))) &&
              (n = n.replace(/^\s+/, r.bind(r, !1))),
            ((null == t.nextSibling && f(t.parentNode)) ||
              (null != t.nextSibling && f(t.nextSibling))) &&
              (n = n.replace(/\s+$/, r.bind(r, !1)));
        }
        return e.insert(n);
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.matchText = e.matchSpacing = e.matchNewline = e.matchBlot = e.matchAttributor = e.default = void 0);
      var x =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              },
        k = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        E = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        N = n(2),
        j = r(N),
        A = n(4),
        q = r(A),
        T = n(0),
        P = r(T),
        S = n(6),
        C = r(S),
        L = n(10),
        M = r(L),
        R = n(7),
        I = r(R),
        B = n(34),
        D = n(35),
        U = n(13),
        F = r(U),
        H = n(24),
        K = n(36),
        z = n(37),
        V = n(38),
        Z = (0, M.default)("quill:clipboard"),
        W = "__ql-matcher",
        G = [
          [Node.TEXT_NODE, w],
          [Node.TEXT_NODE, m],
          ["br", v],
          [Node.ELEMENT_NODE, m],
          [Node.ELEMENT_NODE, y],
          [Node.ELEMENT_NODE, _],
          [Node.ELEMENT_NODE, d],
          [Node.ELEMENT_NODE, O],
          ["li", g],
          ["b", p.bind(p, "bold")],
          ["i", p.bind(p, "italic")],
          ["style", b],
        ],
        Y = [B.AlignAttribute, K.DirectionAttribute].reduce(function (t, e) {
          return (t[e.keyName] = e), t;
        }, {}),
        X = [
          B.AlignStyle,
          D.BackgroundStyle,
          H.ColorStyle,
          K.DirectionStyle,
          z.FontStyle,
          V.SizeStyle,
        ].reduce(function (t, e) {
          return (t[e.keyName] = e), t;
        }, {}),
        $ = (function (t) {
          function e(t, n) {
            i(this, e);
            var r = l(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
            );
            return (
              r.quill.root.addEventListener("paste", r.onPaste.bind(r)),
              (r.container = r.quill.addContainer("ql-clipboard")),
              r.container.setAttribute("contenteditable", !0),
              r.container.setAttribute("tabindex", -1),
              (r.matchers = []),
              G.concat(r.options.matchers).forEach(function (t) {
                var e = k(t, 2),
                  o = e[0],
                  i = e[1];
                (n.matchVisual || i !== _) && r.addMatcher(o, i);
              }),
              r
            );
          }
          return (
            a(e, t),
            E(e, [
              {
                key: "addMatcher",
                value: function (t, e) {
                  this.matchers.push([t, e]);
                },
              },
              {
                key: "convert",
                value: function (t) {
                  if ("string" == typeof t)
                    return (
                      (this.container.innerHTML = t.replace(
                        /\>\r?\n +\</g,
                        "><"
                      )),
                      this.convert()
                    );
                  var e = this.quill.getFormat(
                    this.quill.selection.savedRange.index
                  );
                  if (e[F.default.blotName]) {
                    var n = this.container.innerText;
                    return (
                      (this.container.innerHTML = ""),
                      new q.default().insert(
                        n,
                        o({}, F.default.blotName, e[F.default.blotName])
                      )
                    );
                  }
                  var r = this.prepareMatching(),
                    i = k(r, 2),
                    l = i[0],
                    a = i[1],
                    s = h(this.container, l, a);
                  return (
                    c(s, "\n") &&
                      null == s.ops[s.ops.length - 1].attributes &&
                      (s = s.compose(
                        new q.default().retain(s.length() - 1).delete(1)
                      )),
                    Z.log("convert", this.container.innerHTML, s),
                    (this.container.innerHTML = ""),
                    s
                  );
                },
              },
              {
                key: "dangerouslyPasteHTML",
                value: function (t, e) {
                  var n =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : C.default.sources.API;
                  if ("string" == typeof t)
                    this.quill.setContents(this.convert(t), e),
                      this.quill.setSelection(0, C.default.sources.SILENT);
                  else {
                    var r = this.convert(e);
                    this.quill.updateContents(
                      new q.default().retain(t).concat(r),
                      n
                    ),
                      this.quill.setSelection(
                        t + r.length(),
                        C.default.sources.SILENT
                      );
                  }
                },
              },
              {
                key: "onPaste",
                value: function (t) {
                  var e = this;
                  if (!t.defaultPrevented && this.quill.isEnabled()) {
                    var n = this.quill.getSelection(),
                      r = new q.default().retain(n.index),
                      o = this.quill.scrollingContainer.scrollTop;
                    this.container.focus(),
                      this.quill.selection.update(C.default.sources.SILENT),
                      setTimeout(function () {
                        (r = r.concat(e.convert()).delete(n.length)),
                          e.quill.updateContents(r, C.default.sources.USER),
                          e.quill.setSelection(
                            r.length() - n.length,
                            C.default.sources.SILENT
                          ),
                          (e.quill.scrollingContainer.scrollTop = o),
                          e.quill.focus();
                      }, 1);
                  }
                },
              },
              {
                key: "prepareMatching",
                value: function () {
                  var t = this,
                    e = [],
                    n = [];
                  return (
                    this.matchers.forEach(function (r) {
                      var o = k(r, 2),
                        i = o[0],
                        l = o[1];
                      switch (i) {
                        case Node.TEXT_NODE:
                          n.push(l);
                          break;
                        case Node.ELEMENT_NODE:
                          e.push(l);
                          break;
                        default:
                          [].forEach.call(
                            t.container.querySelectorAll(i),
                            function (t) {
                              (t[W] = t[W] || []), t[W].push(l);
                            }
                          );
                      }
                    }),
                    [e, n]
                  );
                },
              },
            ]),
            e
          );
        })(I.default);
      ($.DEFAULTS = { matchers: [], matchVisual: !0 }),
        (e.default = $),
        (e.matchAttributor = d),
        (e.matchBlot = y),
        (e.matchNewline = m),
        (e.matchSpacing = _),
        (e.matchText = w);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      function a(t) {
        var e = t.ops[t.ops.length - 1];
        return (
          null != e &&
          (null != e.insert
            ? "string" == typeof e.insert && e.insert.endsWith("\n")
            : null != e.attributes &&
              Object.keys(e.attributes).some(function (t) {
                return null != f.default.query(t, f.default.Scope.BLOCK);
              }))
        );
      }
      function s(t) {
        var e = t.reduce(function (t, e) {
            return (t += e.delete || 0);
          }, 0),
          n = t.length() - e;
        return a(t) && (n -= 1), n;
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.getLastChangeIndex = e.default = void 0);
      var u = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        c = n(0),
        f = r(c),
        h = n(6),
        p = r(h),
        d = n(7),
        y = r(d),
        v = (function (t) {
          function e(t, n) {
            o(this, e);
            var r = i(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
            );
            return (
              (r.lastRecorded = 0),
              (r.ignoreChange = !1),
              r.clear(),
              r.quill.on(p.default.events.EDITOR_CHANGE, function (t, e, n, o) {
                t !== p.default.events.TEXT_CHANGE ||
                  r.ignoreChange ||
                  (r.options.userOnly && o !== p.default.sources.USER
                    ? r.transform(e)
                    : r.record(e, n));
              }),
              r.quill.keyboard.addBinding(
                { key: "Z", shortKey: !0 },
                r.undo.bind(r)
              ),
              r.quill.keyboard.addBinding(
                { key: "Z", shortKey: !0, shiftKey: !0 },
                r.redo.bind(r)
              ),
              /Win/i.test(navigator.platform) &&
                r.quill.keyboard.addBinding(
                  { key: "Y", shortKey: !0 },
                  r.redo.bind(r)
                ),
              r
            );
          }
          return (
            l(e, t),
            u(e, [
              {
                key: "change",
                value: function (t, e) {
                  if (0 !== this.stack[t].length) {
                    var n = this.stack[t].pop();
                    this.stack[e].push(n),
                      (this.lastRecorded = 0),
                      (this.ignoreChange = !0),
                      this.quill.updateContents(n[t], p.default.sources.USER),
                      (this.ignoreChange = !1);
                    var r = s(n[t]);
                    this.quill.setSelection(r);
                  }
                },
              },
              {
                key: "clear",
                value: function () {
                  this.stack = { undo: [], redo: [] };
                },
              },
              {
                key: "cutoff",
                value: function () {
                  this.lastRecorded = 0;
                },
              },
              {
                key: "record",
                value: function (t, e) {
                  if (0 !== t.ops.length) {
                    this.stack.redo = [];
                    var n = this.quill.getContents().diff(e),
                      r = Date.now();
                    if (
                      this.lastRecorded + this.options.delay > r &&
                      this.stack.undo.length > 0
                    ) {
                      var o = this.stack.undo.pop();
                      (n = n.compose(o.undo)), (t = o.redo.compose(t));
                    } else this.lastRecorded = r;
                    this.stack.undo.push({ redo: t, undo: n }),
                      this.stack.undo.length > this.options.maxStack &&
                        this.stack.undo.shift();
                  }
                },
              },
              {
                key: "redo",
                value: function () {
                  this.change("redo", "undo");
                },
              },
              {
                key: "transform",
                value: function (t) {
                  this.stack.undo.forEach(function (e) {
                    (e.undo = t.transform(e.undo, !0)),
                      (e.redo = t.transform(e.redo, !0));
                  }),
                    this.stack.redo.forEach(function (e) {
                      (e.undo = t.transform(e.undo, !0)),
                        (e.redo = t.transform(e.redo, !0));
                    });
                },
              },
              {
                key: "undo",
                value: function () {
                  this.change("undo", "redo");
                },
              },
            ]),
            e
          );
        })(y.default);
      (v.DEFAULTS = { delay: 1e3, maxStack: 100, userOnly: !1 }),
        (e.default = v),
        (e.getLastChangeIndex = s);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.IndentClass = void 0);
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(0),
        u = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(s),
        c = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            l(e, [
              {
                key: "add",
                value: function (t, n) {
                  if ("+1" === n || "-1" === n) {
                    var r = this.value(t) || 0;
                    n = "+1" === n ? r + 1 : r - 1;
                  }
                  return 0 === n
                    ? (this.remove(t), !0)
                    : a(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "add",
                        this
                      ).call(this, t, n);
                },
              },
              {
                key: "canAdd",
                value: function (t, n) {
                  return (
                    a(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "canAdd",
                      this
                    ).call(this, t, n) ||
                    a(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "canAdd",
                      this
                    ).call(this, t, parseInt(n))
                  );
                },
              },
              {
                key: "value",
                value: function (t) {
                  return (
                    parseInt(
                      a(
                        e.prototype.__proto__ ||
                          Object.getPrototypeOf(e.prototype),
                        "value",
                        this
                      ).call(this, t)
                    ) || void 0
                  );
                },
              },
            ]),
            e
          );
        })(u.default.Attributor.Class),
        f = new c("indent", "ql-indent", {
          scope: u.default.Scope.BLOCK,
          whitelist: [1, 2, 3, 4, 5, 6, 7, 8],
        });
      e.IndentClass = f;
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = n(3),
        a = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(l),
        s = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return i(e, t), e;
        })(a.default);
      (s.blotName = "blockquote"), (s.tagName = "blockquote"), (e.default = s);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = n(3),
        s = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(a),
        u = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            l(e, null, [
              {
                key: "formats",
                value: function (t) {
                  return this.tagName.indexOf(t.tagName) + 1;
                },
              },
            ]),
            e
          );
        })(s.default);
      (u.blotName = "header"),
        (u.tagName = ["H1", "H2", "H3", "H4", "H5", "H6"]),
        (e.default = u);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function i(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function l(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function a(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = e.ListItem = void 0);
      var s = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        u = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        c = n(0),
        f = r(c),
        h = n(3),
        p = r(h),
        d = n(23),
        y = r(d),
        v = (function (t) {
          function e() {
            return (
              i(this, e),
              l(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            a(e, t),
            s(
              e,
              [
                {
                  key: "format",
                  value: function (t, n) {
                    t !== b.blotName || n
                      ? u(
                          e.prototype.__proto__ ||
                            Object.getPrototypeOf(e.prototype),
                          "format",
                          this
                        ).call(this, t, n)
                      : this.replaceWith(f.default.create(this.statics.scope));
                  },
                },
                {
                  key: "remove",
                  value: function () {
                    null == this.prev && null == this.next
                      ? this.parent.remove()
                      : u(
                          e.prototype.__proto__ ||
                            Object.getPrototypeOf(e.prototype),
                          "remove",
                          this
                        ).call(this);
                  },
                },
                {
                  key: "replaceWith",
                  value: function (t, n) {
                    return (
                      this.parent.isolate(
                        this.offset(this.parent),
                        this.length()
                      ),
                      t === this.parent.statics.blotName
                        ? (this.parent.replaceWith(t, n), this)
                        : (this.parent.unwrap(),
                          u(
                            e.prototype.__proto__ ||
                              Object.getPrototypeOf(e.prototype),
                            "replaceWith",
                            this
                          ).call(this, t, n))
                    );
                  },
                },
              ],
              [
                {
                  key: "formats",
                  value: function (t) {
                    return t.tagName === this.tagName
                      ? void 0
                      : u(
                          e.__proto__ || Object.getPrototypeOf(e),
                          "formats",
                          this
                        ).call(this, t);
                  },
                },
              ]
            ),
            e
          );
        })(p.default);
      (v.blotName = "list-item"), (v.tagName = "LI");
      var b = (function (t) {
        function e(t) {
          i(this, e);
          var n = l(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t)
            ),
            r = function (e) {
              if (e.target.parentNode === t) {
                var r = n.statics.formats(t),
                  o = f.default.find(e.target);
                "checked" === r
                  ? o.format("list", "unchecked")
                  : "unchecked" === r && o.format("list", "checked");
              }
            };
          return (
            t.addEventListener("touchstart", r),
            t.addEventListener("mousedown", r),
            n
          );
        }
        return (
          a(e, t),
          s(e, null, [
            {
              key: "create",
              value: function (t) {
                var n = "ordered" === t ? "OL" : "UL",
                  r = u(
                    e.__proto__ || Object.getPrototypeOf(e),
                    "create",
                    this
                  ).call(this, n);
                return (
                  ("checked" !== t && "unchecked" !== t) ||
                    r.setAttribute("data-checked", "checked" === t),
                  r
                );
              },
            },
            {
              key: "formats",
              value: function (t) {
                return "OL" === t.tagName
                  ? "ordered"
                  : "UL" === t.tagName
                  ? t.hasAttribute("data-checked")
                    ? "true" === t.getAttribute("data-checked")
                      ? "checked"
                      : "unchecked"
                    : "bullet"
                  : void 0;
              },
            },
          ]),
          s(e, [
            {
              key: "format",
              value: function (t, e) {
                this.children.length > 0 && this.children.tail.format(t, e);
              },
            },
            {
              key: "formats",
              value: function () {
                return o(
                  {},
                  this.statics.blotName,
                  this.statics.formats(this.domNode)
                );
              },
            },
            {
              key: "insertBefore",
              value: function (t, n) {
                if (t instanceof v)
                  u(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "insertBefore",
                    this
                  ).call(this, t, n);
                else {
                  var r = null == n ? this.length() : n.offset(this),
                    o = this.split(r);
                  o.parent.insertBefore(t, o);
                }
              },
            },
            {
              key: "optimize",
              value: function (t) {
                u(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "optimize",
                  this
                ).call(this, t);
                var n = this.next;
                null != n &&
                  n.prev === this &&
                  n.statics.blotName === this.statics.blotName &&
                  n.domNode.tagName === this.domNode.tagName &&
                  n.domNode.getAttribute("data-checked") ===
                    this.domNode.getAttribute("data-checked") &&
                  (n.moveChildren(this), n.remove());
              },
            },
            {
              key: "replace",
              value: function (t) {
                if (t.statics.blotName !== this.statics.blotName) {
                  var n = f.default.create(this.statics.defaultChild);
                  t.moveChildren(n), this.appendChild(n);
                }
                u(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "replace",
                  this
                ).call(this, t);
              },
            },
          ]),
          e
        );
      })(y.default);
      (b.blotName = "list"),
        (b.scope = f.default.Scope.BLOCK_BLOT),
        (b.tagName = ["OL", "UL"]),
        (b.defaultChild = "list-item"),
        (b.allowedChildren = [v]),
        (e.ListItem = v),
        (e.default = b);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = n(39),
        a = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(l),
        s = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return i(e, t), e;
        })(a.default);
      (s.blotName = "italic"), (s.tagName = ["EM", "I"]), (e.default = s);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(5),
        u = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(s),
        c = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            l(e, null, [
              {
                key: "create",
                value: function (t) {
                  return "super" === t
                    ? document.createElement("sup")
                    : "sub" === t
                    ? document.createElement("sub")
                    : a(
                        e.__proto__ || Object.getPrototypeOf(e),
                        "create",
                        this
                      ).call(this, t);
                },
              },
              {
                key: "formats",
                value: function (t) {
                  return "SUB" === t.tagName
                    ? "sub"
                    : "SUP" === t.tagName
                    ? "super"
                    : void 0;
                },
              },
            ]),
            e
          );
        })(u.default);
      (c.blotName = "script"), (c.tagName = ["SUB", "SUP"]), (e.default = c);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = n(5),
        a = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(l),
        s = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return i(e, t), e;
        })(a.default);
      (s.blotName = "strike"), (s.tagName = "S"), (e.default = s);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = n(5),
        a = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(l),
        s = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return i(e, t), e;
        })(a.default);
      (s.blotName = "underline"), (s.tagName = "U"), (e.default = s);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(0),
        u = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(s),
        c = n(15),
        f = ["alt", "height", "width"],
        h = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            l(
              e,
              [
                {
                  key: "format",
                  value: function (t, n) {
                    f.indexOf(t) > -1
                      ? n
                        ? this.domNode.setAttribute(t, n)
                        : this.domNode.removeAttribute(t)
                      : a(
                          e.prototype.__proto__ ||
                            Object.getPrototypeOf(e.prototype),
                          "format",
                          this
                        ).call(this, t, n);
                  },
                },
              ],
              [
                {
                  key: "create",
                  value: function (t) {
                    var n = a(
                      e.__proto__ || Object.getPrototypeOf(e),
                      "create",
                      this
                    ).call(this, t);
                    return (
                      "string" == typeof t &&
                        n.setAttribute("src", this.sanitize(t)),
                      n
                    );
                  },
                },
                {
                  key: "formats",
                  value: function (t) {
                    return f.reduce(function (e, n) {
                      return t.hasAttribute(n) && (e[n] = t.getAttribute(n)), e;
                    }, {});
                  },
                },
                {
                  key: "match",
                  value: function (t) {
                    return (
                      /\.(jpe?g|gif|png)$/.test(t) ||
                      /^data:image\/.+;base64/.test(t)
                    );
                  },
                },
                {
                  key: "sanitize",
                  value: function (t) {
                    return (0, c.sanitize)(t, ["http", "https", "data"])
                      ? t
                      : "//:0";
                  },
                },
                {
                  key: "value",
                  value: function (t) {
                    return t.getAttribute("src");
                  },
                },
              ]
            ),
            e
          );
        })(u.default.Embed);
      (h.blotName = "image"), (h.tagName = "IMG"), (e.default = h);
    },
    function (t, e, n) {
      "use strict";
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function o(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function i(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var l = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = n(3),
        u = n(15),
        c = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(u),
        f = ["height", "width"],
        h = (function (t) {
          function e() {
            return (
              r(this, e),
              o(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            i(e, t),
            l(
              e,
              [
                {
                  key: "format",
                  value: function (t, n) {
                    f.indexOf(t) > -1
                      ? n
                        ? this.domNode.setAttribute(t, n)
                        : this.domNode.removeAttribute(t)
                      : a(
                          e.prototype.__proto__ ||
                            Object.getPrototypeOf(e.prototype),
                          "format",
                          this
                        ).call(this, t, n);
                  },
                },
              ],
              [
                {
                  key: "create",
                  value: function (t) {
                    var n = a(
                      e.__proto__ || Object.getPrototypeOf(e),
                      "create",
                      this
                    ).call(this, t);
                    return (
                      n.setAttribute("frameborder", "0"),
                      n.setAttribute("allowfullscreen", !0),
                      n.setAttribute("src", this.sanitize(t)),
                      n
                    );
                  },
                },
                {
                  key: "formats",
                  value: function (t) {
                    return f.reduce(function (e, n) {
                      return t.hasAttribute(n) && (e[n] = t.getAttribute(n)), e;
                    }, {});
                  },
                },
                {
                  key: "sanitize",
                  value: function (t) {
                    return c.default.sanitize(t);
                  },
                },
                {
                  key: "value",
                  value: function (t) {
                    return t.getAttribute("src");
                  },
                },
              ]
            ),
            e
          );
        })(s.BlockEmbed);
      (h.blotName = "video"),
        (h.className = "ql-video"),
        (h.tagName = "IFRAME"),
        (e.default = h);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = e.FormulaBlot = void 0);
      var a = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        s = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        u = n(33),
        c = r(u),
        f = n(6),
        h = r(f),
        p = n(7),
        d = r(p),
        y = (function (t) {
          function e() {
            return (
              o(this, e),
              i(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            l(e, t),
            a(e, null, [
              {
                key: "create",
                value: function (t) {
                  var n = s(
                    e.__proto__ || Object.getPrototypeOf(e),
                    "create",
                    this
                  ).call(this, t);
                  return (
                    "string" == typeof t &&
                      (window.katex.render(t, n, {
                        throwOnError: !1,
                        errorColor: "#f00",
                      }),
                      n.setAttribute("data-value", t)),
                    n
                  );
                },
              },
              {
                key: "value",
                value: function (t) {
                  return t.getAttribute("data-value");
                },
              },
            ]),
            e
          );
        })(c.default);
      (y.blotName = "formula"),
        (y.className = "ql-formula"),
        (y.tagName = "SPAN");
      var v = (function (t) {
        function e() {
          o(this, e);
          var t = i(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          if (null == window.katex)
            throw new Error("Formula module requires KaTeX.");
          return t;
        }
        return (
          l(e, t),
          a(e, null, [
            {
              key: "register",
              value: function () {
                h.default.register(y, !0);
              },
            },
          ]),
          e
        );
      })(d.default);
      (e.FormulaBlot = y), (e.default = v);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = e.CodeToken = e.CodeBlock = void 0);
      var a = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        s = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        u = n(0),
        c = r(u),
        f = n(6),
        h = r(f),
        p = n(7),
        d = r(p),
        y = n(13),
        v = r(y),
        b = (function (t) {
          function e() {
            return (
              o(this, e),
              i(
                this,
                (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments)
              )
            );
          }
          return (
            l(e, t),
            a(e, [
              {
                key: "replaceWith",
                value: function (t) {
                  (this.domNode.textContent = this.domNode.textContent),
                    this.attach(),
                    s(
                      e.prototype.__proto__ ||
                        Object.getPrototypeOf(e.prototype),
                      "replaceWith",
                      this
                    ).call(this, t);
                },
              },
              {
                key: "highlight",
                value: function (t) {
                  var e = this.domNode.textContent;
                  this.cachedText !== e &&
                    ((e.trim().length > 0 || null == this.cachedText) &&
                      ((this.domNode.innerHTML = t(e)),
                      this.domNode.normalize(),
                      this.attach()),
                    (this.cachedText = e));
                },
              },
            ]),
            e
          );
        })(v.default);
      b.className = "ql-syntax";
      var g = new c.default.Attributor.Class("token", "hljs", {
          scope: c.default.Scope.INLINE,
        }),
        m = (function (t) {
          function e(t, n) {
            o(this, e);
            var r = i(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
            );
            if ("function" != typeof r.options.highlight)
              throw new Error(
                "Syntax module requires highlight.js. Please include the library on the page before Quill."
              );
            var l = null;
            return (
              r.quill.on(h.default.events.SCROLL_OPTIMIZE, function () {
                clearTimeout(l),
                  (l = setTimeout(function () {
                    r.highlight(), (l = null);
                  }, r.options.interval));
              }),
              r.highlight(),
              r
            );
          }
          return (
            l(e, t),
            a(e, null, [
              {
                key: "register",
                value: function () {
                  h.default.register(g, !0), h.default.register(b, !0);
                },
              },
            ]),
            a(e, [
              {
                key: "highlight",
                value: function () {
                  var t = this;
                  if (!this.quill.selection.composing) {
                    this.quill.update(h.default.sources.USER);
                    var e = this.quill.getSelection();
                    this.quill.scroll.descendants(b).forEach(function (e) {
                      e.highlight(t.options.highlight);
                    }),
                      this.quill.update(h.default.sources.SILENT),
                      null != e &&
                        this.quill.setSelection(e, h.default.sources.SILENT);
                  }
                },
              },
            ]),
            e
          );
        })(d.default);
      (m.DEFAULTS = {
        highlight: (function () {
          return null == window.hljs
            ? null
            : function (t) {
                return window.hljs.highlightAuto(t).value;
              };
        })(),
        interval: 1e3,
      }),
        (e.CodeBlock = b),
        (e.CodeToken = g),
        (e.default = m);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function i(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function l(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function a(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      function s(t, e, n) {
        var r = document.createElement("button");
        r.setAttribute("type", "button"),
          r.classList.add("ql-" + e),
          null != n && (r.value = n),
          t.appendChild(r);
      }
      function u(t, e) {
        Array.isArray(e[0]) || (e = [e]),
          e.forEach(function (e) {
            var n = document.createElement("span");
            n.classList.add("ql-formats"),
              e.forEach(function (t) {
                if ("string" == typeof t) s(n, t);
                else {
                  var e = Object.keys(t)[0],
                    r = t[e];
                  Array.isArray(r) ? c(n, e, r) : s(n, e, r);
                }
              }),
              t.appendChild(n);
          });
      }
      function c(t, e, n) {
        var r = document.createElement("select");
        r.classList.add("ql-" + e),
          n.forEach(function (t) {
            var e = document.createElement("option");
            !1 !== t
              ? e.setAttribute("value", t)
              : e.setAttribute("selected", "selected"),
              r.appendChild(e);
          }),
          t.appendChild(r);
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.addControls = e.default = void 0);
      var f = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        h = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        p = n(4),
        d = r(p),
        y = n(0),
        v = r(y),
        b = n(6),
        g = r(b),
        m = n(10),
        _ = r(m),
        O = n(7),
        w = r(O),
        x = (0, _.default)("quill:toolbar"),
        k = (function (t) {
          function e(t, n) {
            i(this, e);
            var r = l(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
            );
            if (Array.isArray(r.options.container)) {
              var o = document.createElement("div");
              u(o, r.options.container),
                t.container.parentNode.insertBefore(o, t.container),
                (r.container = o);
            } else
              "string" == typeof r.options.container
                ? (r.container = document.querySelector(r.options.container))
                : (r.container = r.options.container);
            if (!(r.container instanceof HTMLElement)) {
              var a;
              return (
                (a = x.error("Container required for toolbar", r.options)),
                l(r, a)
              );
            }
            return (
              r.container.classList.add("ql-toolbar"),
              (r.controls = []),
              (r.handlers = {}),
              Object.keys(r.options.handlers).forEach(function (t) {
                r.addHandler(t, r.options.handlers[t]);
              }),
              [].forEach.call(
                r.container.querySelectorAll("button, select"),
                function (t) {
                  r.attach(t);
                }
              ),
              r.quill.on(g.default.events.EDITOR_CHANGE, function (t, e) {
                t === g.default.events.SELECTION_CHANGE && r.update(e);
              }),
              r.quill.on(g.default.events.SCROLL_OPTIMIZE, function () {
                var t = r.quill.selection.getRange(),
                  e = f(t, 1),
                  n = e[0];
                r.update(n);
              }),
              r
            );
          }
          return (
            a(e, t),
            h(e, [
              {
                key: "addHandler",
                value: function (t, e) {
                  this.handlers[t] = e;
                },
              },
              {
                key: "attach",
                value: function (t) {
                  var e = this,
                    n = [].find.call(t.classList, function (t) {
                      return 0 === t.indexOf("ql-");
                    });
                  if (n) {
                    if (
                      ((n = n.slice("ql-".length)),
                      "BUTTON" === t.tagName &&
                        t.setAttribute("type", "button"),
                      null == this.handlers[n])
                    ) {
                      if (
                        null != this.quill.scroll.whitelist &&
                        null == this.quill.scroll.whitelist[n]
                      )
                        return void x.warn(
                          "ignoring attaching to disabled format",
                          n,
                          t
                        );
                      if (null == v.default.query(n))
                        return void x.warn(
                          "ignoring attaching to nonexistent format",
                          n,
                          t
                        );
                    }
                    var r = "SELECT" === t.tagName ? "change" : "click";
                    t.addEventListener(r, function (r) {
                      var i = void 0;
                      if ("SELECT" === t.tagName) {
                        if (t.selectedIndex < 0) return;
                        var l = t.options[t.selectedIndex];
                        i = !l.hasAttribute("selected") && (l.value || !1);
                      } else (i = !t.classList.contains("ql-active") && (t.value || !t.hasAttribute("value"))), r.preventDefault();
                      e.quill.focus();
                      var a = e.quill.selection.getRange(),
                        s = f(a, 1),
                        u = s[0];
                      if (null != e.handlers[n]) e.handlers[n].call(e, i);
                      else if (
                        v.default.query(n).prototype instanceof v.default.Embed
                      ) {
                        if (!(i = prompt("Enter " + n))) return;
                        e.quill.updateContents(
                          new d.default()
                            .retain(u.index)
                            .delete(u.length)
                            .insert(o({}, n, i)),
                          g.default.sources.USER
                        );
                      } else e.quill.format(n, i, g.default.sources.USER);
                      e.update(u);
                    }),
                      this.controls.push([n, t]);
                  }
                },
              },
              {
                key: "update",
                value: function (t) {
                  var e = null == t ? {} : this.quill.getFormat(t);
                  this.controls.forEach(function (n) {
                    var r = f(n, 2),
                      o = r[0],
                      i = r[1];
                    if ("SELECT" === i.tagName) {
                      var l = void 0;
                      if (null == t) l = null;
                      else if (null == e[o])
                        l = i.querySelector("option[selected]");
                      else if (!Array.isArray(e[o])) {
                        var a = e[o];
                        "string" == typeof a && (a = a.replace(/\"/g, '\\"')),
                          (l = i.querySelector('option[value="' + a + '"]'));
                      }
                      null == l
                        ? ((i.value = ""), (i.selectedIndex = -1))
                        : (l.selected = !0);
                    } else if (null == t) i.classList.remove("ql-active");
                    else if (i.hasAttribute("value")) {
                      var s =
                        e[o] === i.getAttribute("value") ||
                        (null != e[o] &&
                          e[o].toString() === i.getAttribute("value")) ||
                        (null == e[o] && !i.getAttribute("value"));
                      i.classList.toggle("ql-active", s);
                    } else i.classList.toggle("ql-active", null != e[o]);
                  });
                },
              },
            ]),
            e
          );
        })(w.default);
      (k.DEFAULTS = {}),
        (k.DEFAULTS = {
          container: null,
          handlers: {
            clean: function () {
              var t = this,
                e = this.quill.getSelection();
              if (null != e)
                if (0 == e.length) {
                  var n = this.quill.getFormat();
                  Object.keys(n).forEach(function (e) {
                    null != v.default.query(e, v.default.Scope.INLINE) &&
                      t.quill.format(e, !1);
                  });
                } else this.quill.removeFormat(e, g.default.sources.USER);
            },
            direction: function (t) {
              var e = this.quill.getFormat().align;
              "rtl" === t && null == e
                ? this.quill.format("align", "right", g.default.sources.USER)
                : t ||
                  "right" !== e ||
                  this.quill.format("align", !1, g.default.sources.USER),
                this.quill.format("direction", t, g.default.sources.USER);
            },
            indent: function (t) {
              var e = this.quill.getSelection(),
                n = this.quill.getFormat(e),
                r = parseInt(n.indent || 0);
              if ("+1" === t || "-1" === t) {
                var o = "+1" === t ? 1 : -1;
                "rtl" === n.direction && (o *= -1),
                  this.quill.format("indent", r + o, g.default.sources.USER);
              }
            },
            link: function (t) {
              !0 === t && (t = prompt("Enter link URL:")),
                this.quill.format("link", t, g.default.sources.USER);
            },
            list: function (t) {
              var e = this.quill.getSelection(),
                n = this.quill.getFormat(e);
              "check" === t
                ? "checked" === n.list || "unchecked" === n.list
                  ? this.quill.format("list", !1, g.default.sources.USER)
                  : this.quill.format(
                      "list",
                      "unchecked",
                      g.default.sources.USER
                    )
                : this.quill.format("list", t, g.default.sources.USER);
            },
          },
        }),
        (e.default = k),
        (e.addControls = u);
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>';
    },
    function (t, e) {
      t.exports =
        '<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>';
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = e.BubbleTooltip = void 0);
      var a = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        s = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        u = n(2),
        c = r(u),
        f = n(9),
        h = r(f),
        p = n(44),
        d = r(p),
        y = n(22),
        v = n(26),
        b = r(v),
        g = [
          ["bold", "italic", "link"],
          [{ header: 1 }, { header: 2 }, "blockquote"],
        ],
        m = (function (t) {
          function e(t, n) {
            o(this, e),
              null != n.modules.toolbar &&
                null == n.modules.toolbar.container &&
                (n.modules.toolbar.container = g);
            var r = i(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
            );
            return r.quill.container.classList.add("ql-bubble"), r;
          }
          return (
            l(e, t),
            s(e, [
              {
                key: "extendToolbar",
                value: function (t) {
                  (this.tooltip = new _(this.quill, this.options.bounds)),
                    this.tooltip.root.appendChild(t.container),
                    this.buildButtons(
                      [].slice.call(t.container.querySelectorAll("button")),
                      b.default
                    ),
                    this.buildPickers(
                      [].slice.call(t.container.querySelectorAll("select")),
                      b.default
                    );
                },
              },
            ]),
            e
          );
        })(d.default);
      m.DEFAULTS = (0, c.default)(!0, {}, d.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              link: function (t) {
                t
                  ? this.quill.theme.tooltip.edit()
                  : this.quill.format("link", !1);
              },
            },
          },
        },
      });
      var _ = (function (t) {
        function e(t, n) {
          o(this, e);
          var r = i(
            this,
            (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
          );
          return (
            r.quill.on(h.default.events.EDITOR_CHANGE, function (t, e, n, o) {
              if (t === h.default.events.SELECTION_CHANGE)
                if (null != e && e.length > 0 && o === h.default.sources.USER) {
                  r.show(),
                    (r.root.style.left = "0px"),
                    (r.root.style.width = ""),
                    (r.root.style.width = r.root.offsetWidth + "px");
                  var i = r.quill.getLines(e.index, e.length);
                  if (1 === i.length) r.position(r.quill.getBounds(e));
                  else {
                    var l = i[i.length - 1],
                      a = r.quill.getIndex(l),
                      s = Math.min(l.length() - 1, e.index + e.length - a),
                      u = r.quill.getBounds(new y.Range(a, s));
                    r.position(u);
                  }
                } else
                  document.activeElement !== r.textbox &&
                    r.quill.hasFocus() &&
                    r.hide();
            }),
            r
          );
        }
        return (
          l(e, t),
          s(e, [
            {
              key: "listen",
              value: function () {
                var t = this;
                a(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "listen",
                  this
                ).call(this),
                  this.root
                    .querySelector(".ql-close")
                    .addEventListener("click", function () {
                      t.root.classList.remove("ql-editing");
                    }),
                  this.quill.on(h.default.events.SCROLL_OPTIMIZE, function () {
                    setTimeout(function () {
                      if (!t.root.classList.contains("ql-hidden")) {
                        var e = t.quill.getSelection();
                        null != e && t.position(t.quill.getBounds(e));
                      }
                    }, 1);
                  });
              },
            },
            {
              key: "cancel",
              value: function () {
                this.show();
              },
            },
            {
              key: "position",
              value: function (t) {
                var n = a(
                    e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                    "position",
                    this
                  ).call(this, t),
                  r = this.root.querySelector(".ql-tooltip-arrow");
                if (((r.style.marginLeft = ""), 0 === n)) return n;
                r.style.marginLeft = -1 * n - r.offsetWidth / 2 + "px";
              },
            },
          ]),
          e
        );
      })(p.BaseTooltip);
      (_.TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        "</div>",
      ].join("")),
        (e.BubbleTooltip = _),
        (e.default = m);
    },
    function (t, e, n) {
      "use strict";
      function r(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function o(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (!t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !e || ("object" != typeof e && "function" != typeof e) ? t : e;
      }
      function l(t, e) {
        if ("function" != typeof e && null !== e)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof e
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          e &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(t, e)
              : (t.__proto__ = e));
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var a = (function () {
          function t(t, e) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (
                var l, a = t[Symbol.iterator]();
                !(r = (l = a.next()).done) &&
                (n.push(l.value), !e || n.length !== e);
                r = !0
              );
            } catch (t) {
              (o = !0), (i = t);
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }
          return function (e, n) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return t(e, n);
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          };
        })(),
        s = function t(e, n, r) {
          null === e && (e = Function.prototype);
          var o = Object.getOwnPropertyDescriptor(e, n);
          if (void 0 === o) {
            var i = Object.getPrototypeOf(e);
            return null === i ? void 0 : t(i, n, r);
          }
          if ("value" in o) return o.value;
          var l = o.get;
          if (void 0 !== l) return l.call(r);
        },
        u = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), e;
          };
        })(),
        c = n(2),
        f = r(c),
        h = n(9),
        p = r(h),
        d = n(44),
        y = r(d),
        v = n(15),
        b = r(v),
        g = n(22),
        m = n(26),
        _ = r(m),
        O = [
          [{ header: ["1", "2", "3", !1] }],
          ["bold", "italic", "underline", "link"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["clean"],
        ],
        w = (function (t) {
          function e(t, n) {
            o(this, e),
              null != n.modules.toolbar &&
                null == n.modules.toolbar.container &&
                (n.modules.toolbar.container = O);
            var r = i(
              this,
              (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
            );
            return r.quill.container.classList.add("ql-snow"), r;
          }
          return (
            l(e, t),
            u(e, [
              {
                key: "extendToolbar",
                value: function (t) {
                  t.container.classList.add("ql-snow"),
                    this.buildButtons(
                      [].slice.call(t.container.querySelectorAll("button")),
                      _.default
                    ),
                    this.buildPickers(
                      [].slice.call(t.container.querySelectorAll("select")),
                      _.default
                    ),
                    (this.tooltip = new x(this.quill, this.options.bounds)),
                    t.container.querySelector(".ql-link") &&
                      this.quill.keyboard.addBinding(
                        { key: "K", shortKey: !0 },
                        function (e, n) {
                          t.handlers.link.call(t, !n.format.link);
                        }
                      );
                },
              },
            ]),
            e
          );
        })(y.default);
      w.DEFAULTS = (0, f.default)(!0, {}, y.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              link: function (t) {
                if (t) {
                  var e = this.quill.getSelection();
                  if (null == e || 0 == e.length) return;
                  var n = this.quill.getText(e);
                  /^\S+@\S+\.\S+$/.test(n) &&
                    0 !== n.indexOf("mailto:") &&
                    (n = "mailto:" + n);
                  this.quill.theme.tooltip.edit("link", n);
                } else this.quill.format("link", !1);
              },
            },
          },
        },
      });
      var x = (function (t) {
        function e(t, n) {
          o(this, e);
          var r = i(
            this,
            (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)
          );
          return (r.preview = r.root.querySelector("a.ql-preview")), r;
        }
        return (
          l(e, t),
          u(e, [
            {
              key: "listen",
              value: function () {
                var t = this;
                s(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "listen",
                  this
                ).call(this),
                  this.root
                    .querySelector("a.ql-action")
                    .addEventListener("click", function (e) {
                      t.root.classList.contains("ql-editing")
                        ? t.save()
                        : t.edit("link", t.preview.textContent),
                        e.preventDefault();
                    }),
                  this.root
                    .querySelector("a.ql-remove")
                    .addEventListener("click", function (e) {
                      if (null != t.linkRange) {
                        var n = t.linkRange;
                        t.restoreFocus(),
                          t.quill.formatText(
                            n,
                            "link",
                            !1,
                            p.default.sources.USER
                          ),
                          delete t.linkRange;
                      }
                      e.preventDefault(), t.hide();
                    }),
                  this.quill.on(p.default.events.SELECTION_CHANGE, function (
                    e,
                    n,
                    r
                  ) {
                    if (null != e) {
                      if (0 === e.length && r === p.default.sources.USER) {
                        var o = t.quill.scroll.descendant(b.default, e.index),
                          i = a(o, 2),
                          l = i[0],
                          s = i[1];
                        if (null != l) {
                          t.linkRange = new g.Range(e.index - s, l.length());
                          var u = b.default.formats(l.domNode);
                          return (
                            (t.preview.textContent = u),
                            t.preview.setAttribute("href", u),
                            t.show(),
                            void t.position(t.quill.getBounds(t.linkRange))
                          );
                        }
                      } else delete t.linkRange;
                      t.hide();
                    }
                  });
              },
            },
            {
              key: "show",
              value: function () {
                s(
                  e.prototype.__proto__ || Object.getPrototypeOf(e.prototype),
                  "show",
                  this
                ).call(this),
                  this.root.removeAttribute("data-mode");
              },
            },
          ]),
          e
        );
      })(d.BaseTooltip);
      (x.TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>',
      ].join("")),
        (e.default = w);
    },
  ]).default;
});
//# sourceMappingURL=quill.min.js.map
!(function (e, t) {
  "function" == typeof define && define.amd
    ? define(t)
    : "object" == typeof exports && "string" != typeof exports.nodeName
    ? (module.exports = t())
    : (e.Croppie = t());
})("undefined" != typeof self ? self : this, function () {
  "function" != typeof Promise &&
    (function (e) {
      function n(e, t) {
        return function () {
          e.apply(t, arguments);
        };
      }
      function r(e) {
        if ("object" != typeof this)
          throw new TypeError("Promises must be constructed via new");
        if ("function" != typeof e) throw new TypeError("not a function");
        (this._state = null),
          (this._value = null),
          (this._deferreds = []),
          u(e, n(i, this), n(o, this));
      }
      function a(n) {
        var i = this;
        return null === this._state
          ? void this._deferreds.push(n)
          : void c(function () {
              var e = i._state ? n.onFulfilled : n.onRejected;
              if (null !== e) {
                var t;
                try {
                  t = e(i._value);
                } catch (e) {
                  return void n.reject(e);
                }
                n.resolve(t);
              } else (i._state ? n.resolve : n.reject)(i._value);
            });
      }
      function i(e) {
        try {
          if (e === this)
            throw new TypeError("A promise cannot be resolved with itself.");
          if (e && ("object" == typeof e || "function" == typeof e)) {
            var t = e.then;
            if ("function" == typeof t)
              return void u(n(t, e), n(i, this), n(o, this));
          }
          (this._state = !0), (this._value = e), s.call(this);
        } catch (e) {
          o.call(this, e);
        }
      }
      function o(e) {
        (this._state = !1), (this._value = e), s.call(this);
      }
      function s() {
        for (var e = 0, t = this._deferreds.length; e < t; e++)
          a.call(this, this._deferreds[e]);
        this._deferreds = null;
      }
      function l(e, t, n, i) {
        (this.onFulfilled = "function" == typeof e ? e : null),
          (this.onRejected = "function" == typeof t ? t : null),
          (this.resolve = n),
          (this.reject = i);
      }
      function u(e, t, n) {
        var i = !1;
        try {
          e(
            function (e) {
              i || ((i = !0), t(e));
            },
            function (e) {
              i || ((i = !0), n(e));
            }
          );
        } catch (e) {
          if (i) return;
          (i = !0), n(e);
        }
      }
      var t = setTimeout,
        c =
          ("function" == typeof setImmediate && setImmediate) ||
          function (e) {
            t(e, 1);
          },
        h =
          Array.isArray ||
          function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          };
      (r.prototype.catch = function (e) {
        return this.then(null, e);
      }),
        (r.prototype.then = function (n, i) {
          var o = this;
          return new r(function (e, t) {
            a.call(o, new l(n, i, e, t));
          });
        }),
        (r.all = function () {
          var s = Array.prototype.slice.call(
            1 === arguments.length && h(arguments[0]) ? arguments[0] : arguments
          );
          return new r(function (i, o) {
            function r(t, e) {
              try {
                if (e && ("object" == typeof e || "function" == typeof e)) {
                  var n = e.then;
                  if ("function" == typeof n)
                    return void n.call(
                      e,
                      function (e) {
                        r(t, e);
                      },
                      o
                    );
                }
                (s[t] = e), 0 == --a && i(s);
              } catch (e) {
                o(e);
              }
            }
            if (0 === s.length) return i([]);
            for (var a = s.length, e = 0; e < s.length; e++) r(e, s[e]);
          });
        }),
        (r.resolve = function (t) {
          return t && "object" == typeof t && t.constructor === r
            ? t
            : new r(function (e) {
                e(t);
              });
        }),
        (r.reject = function (n) {
          return new r(function (e, t) {
            t(n);
          });
        }),
        (r.race = function (o) {
          return new r(function (e, t) {
            for (var n = 0, i = o.length; n < i; n++) o[n].then(e, t);
          });
        }),
        (r._setImmediateFn = function (e) {
          c = e;
        }),
        "undefined" != typeof module && module.exports
          ? (module.exports = r)
          : e.Promise || (e.Promise = r);
    })(this),
    "function" != typeof window.CustomEvent &&
      (function () {
        function e(e, t) {
          t = t || { bubbles: !1, cancelable: !1, detail: void 0 };
          var n = document.createEvent("CustomEvent");
          return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
        }
        (e.prototype = window.Event.prototype), (window.CustomEvent = e);
      })(),
    HTMLCanvasElement.prototype.toBlob ||
      Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
        value: function (e, t, n) {
          for (
            var i = atob(this.toDataURL(t, n).split(",")[1]),
              o = i.length,
              r = new Uint8Array(o),
              a = 0;
            a < o;
            a++
          )
            r[a] = i.charCodeAt(a);
          e(new Blob([r], { type: t || "image/png" }));
        },
      });
  var v,
    g,
    w,
    i = ["Webkit", "Moz", "ms"],
    o = document.createElement("div").style,
    l = [1, 8, 3, 6],
    u = [2, 7, 4, 5];
  function e(e) {
    if (e in o) return e;
    for (var t = e[0].toUpperCase() + e.slice(1), n = i.length; n--; )
      if ((e = i[n] + t) in o) return e;
  }
  function p(e, t) {
    for (var n in ((e = e || {}), t))
      t[n] && t[n].constructor && t[n].constructor === Object
        ? ((e[n] = e[n] || {}), p(e[n], t[n]))
        : (e[n] = t[n]);
    return e;
  }
  function d(e) {
    return p({}, e);
  }
  function y(e) {
    if ("createEvent" in document) {
      var t = document.createEvent("HTMLEvents");
      t.initEvent("change", !1, !0), e.dispatchEvent(t);
    } else e.fireEvent("onchange");
  }
  function b(e, t, n) {
    if ("string" == typeof t) {
      var i = t;
      (t = {})[i] = n;
    }
    for (var o in t) e.style[o] = t[o];
  }
  function x(e, t) {
    e.classList ? e.classList.add(t) : (e.className += " " + t);
  }
  function c(e, t) {
    for (var n in t) e.setAttribute(n, t[n]);
  }
  function C(e) {
    return parseInt(e, 10);
  }
  function m(e, t) {
    var n = e.naturalWidth,
      i = e.naturalHeight,
      o = t || f(e);
    if (o && 5 <= o) {
      var r = n;
      (n = i), (i = r);
    }
    return { width: n, height: i };
  }
  (g = e("transform")), (v = e("transformOrigin")), (w = e("userSelect"));
  var t = { translate3d: { suffix: ", 0px" }, translate: { suffix: "" } },
    E = function (e, t, n) {
      (this.x = parseFloat(e)),
        (this.y = parseFloat(t)),
        (this.scale = parseFloat(n));
    };
  (E.parse = function (e) {
    return e.style
      ? E.parse(e.style[g])
      : -1 < e.indexOf("matrix") || -1 < e.indexOf("none")
      ? E.fromMatrix(e)
      : E.fromString(e);
  }),
    (E.fromMatrix = function (e) {
      var t = e.substring(7).split(",");
      return (
        (t.length && "none" !== e) || (t = [1, 0, 0, 1, 0, 0]),
        new E(C(t[4]), C(t[5]), parseFloat(t[0]))
      );
    }),
    (E.fromString = function (e) {
      var t = e.split(") "),
        n = t[0].substring(T.globals.translate.length + 1).split(","),
        i = 1 < t.length ? t[1].substring(6) : 1,
        o = 1 < n.length ? n[0] : 0,
        r = 1 < n.length ? n[1] : 0;
      return new E(o, r, i);
    }),
    (E.prototype.toString = function () {
      var e = t[T.globals.translate].suffix || "";
      return (
        T.globals.translate +
        "(" +
        this.x +
        "px, " +
        this.y +
        "px" +
        e +
        ") scale(" +
        this.scale +
        ")"
      );
    });
  var L = function (e) {
    if (!e || !e.style[v]) return (this.x = 0), void (this.y = 0);
    var t = e.style[v].split(" ");
    (this.x = parseFloat(t[0])), (this.y = parseFloat(t[1]));
  };
  function f(e) {
    return e.exifdata && e.exifdata.Orientation ? C(e.exifdata.Orientation) : 1;
  }
  function _(e, t, n) {
    var i = t.width,
      o = t.height,
      r = e.getContext("2d");
    switch (((e.width = t.width), (e.height = t.height), r.save(), n)) {
      case 2:
        r.translate(i, 0), r.scale(-1, 1);
        break;
      case 3:
        r.translate(i, o), r.rotate((180 * Math.PI) / 180);
        break;
      case 4:
        r.translate(0, o), r.scale(1, -1);
        break;
      case 5:
        (e.width = o),
          (e.height = i),
          r.rotate((90 * Math.PI) / 180),
          r.scale(1, -1);
        break;
      case 6:
        (e.width = o),
          (e.height = i),
          r.rotate((90 * Math.PI) / 180),
          r.translate(0, -o);
        break;
      case 7:
        (e.width = o),
          (e.height = i),
          r.rotate((-90 * Math.PI) / 180),
          r.translate(-i, o),
          r.scale(1, -1);
        break;
      case 8:
        (e.width = o),
          (e.height = i),
          r.translate(0, i),
          r.rotate((-90 * Math.PI) / 180);
    }
    r.drawImage(t, 0, 0, i, o), r.restore();
  }
  function r() {
    var e,
      t,
      n,
      i,
      o,
      r,
      a = this,
      s = a.options.viewport.type ? "cr-vp-" + a.options.viewport.type : null;
    (a.options.useCanvas = a.options.enableOrientation || R.call(a)),
      (a.data = {}),
      (a.elements = {}),
      (e = a.elements.boundary = document.createElement("div")),
      (n = a.elements.viewport = document.createElement("div")),
      (t = a.elements.img = document.createElement("img")),
      (i = a.elements.overlay = document.createElement("div")),
      a.options.useCanvas
        ? ((a.elements.canvas = document.createElement("canvas")),
          (a.elements.preview = a.elements.canvas))
        : (a.elements.preview = t),
      x(e, "cr-boundary"),
      e.setAttribute("aria-dropeffect", "none"),
      (o = a.options.boundary.width),
      (r = a.options.boundary.height),
      b(e, {
        width: o + (isNaN(o) ? "" : "px"),
        height: r + (isNaN(r) ? "" : "px"),
      }),
      x(n, "cr-viewport"),
      s && x(n, s),
      b(n, {
        width: a.options.viewport.width + "px",
        height: a.options.viewport.height + "px",
      }),
      n.setAttribute("tabindex", 0),
      x(a.elements.preview, "cr-image"),
      c(a.elements.preview, { alt: "preview", "aria-grabbed": "false" }),
      x(i, "cr-overlay"),
      a.element.appendChild(e),
      e.appendChild(a.elements.preview),
      e.appendChild(n),
      e.appendChild(i),
      x(a.element, "croppie-container"),
      a.options.customClass && x(a.element, a.options.customClass),
      function () {
        var h,
          p,
          d,
          l,
          m,
          f = this,
          n = !1;
        function v(e, t) {
          var n = f.elements.preview.getBoundingClientRect(),
            i = m.y + t,
            o = m.x + e;
          f.options.enforceBoundary
            ? (l.top > n.top + t && l.bottom < n.bottom + t && (m.y = i),
              l.left > n.left + e && l.right < n.right + e && (m.x = o))
            : ((m.y = i), (m.x = o));
        }
        function i(e) {
          f.elements.preview.setAttribute("aria-grabbed", e),
            f.elements.boundary.setAttribute(
              "aria-dropeffect",
              e ? "move" : "none"
            );
        }
        function e(e) {
          if (
            (void 0 === e.button || 0 === e.button) &&
            (e.preventDefault(), !n)
          ) {
            if (((n = !0), (h = e.pageX), (p = e.pageY), e.touches)) {
              var t = e.touches[0];
              (h = t.pageX), (p = t.pageY);
            }
            i(n),
              (m = E.parse(f.elements.preview)),
              window.addEventListener("mousemove", o),
              window.addEventListener("touchmove", o),
              window.addEventListener("mouseup", r),
              window.addEventListener("touchend", r),
              (document.body.style[w] = "none"),
              (l = f.elements.viewport.getBoundingClientRect());
          }
        }
        function o(e) {
          e.preventDefault();
          var t = e.pageX,
            n = e.pageY;
          if (e.touches) {
            var i = e.touches[0];
            (t = i.pageX), (n = i.pageY);
          }
          var o = t - h,
            r = n - p,
            a = {};
          if ("touchmove" === e.type && 1 < e.touches.length) {
            var s = e.touches[0],
              l = e.touches[1],
              u = Math.sqrt(
                (s.pageX - l.pageX) * (s.pageX - l.pageX) +
                  (s.pageY - l.pageY) * (s.pageY - l.pageY)
              );
            d || (d = u / f._currentZoom);
            var c = u / d;
            return B.call(f, c), void y(f.elements.zoomer);
          }
          v(o, r),
            (a[g] = m.toString()),
            b(f.elements.preview, a),
            z.call(f),
            (p = n),
            (h = t);
        }
        function r() {
          i((n = !1)),
            window.removeEventListener("mousemove", o),
            window.removeEventListener("touchmove", o),
            window.removeEventListener("mouseup", r),
            window.removeEventListener("touchend", r),
            (document.body.style[w] = ""),
            Z.call(f),
            F.call(f),
            (d = 0);
        }
        f.elements.overlay.addEventListener("mousedown", e),
          f.elements.viewport.addEventListener("keydown", function (e) {
            if (!e.shiftKey || (38 !== e.keyCode && 40 !== e.keyCode)) {
              if (
                f.options.enableKeyMovement &&
                37 <= e.keyCode &&
                e.keyCode <= 40
              ) {
                e.preventDefault();
                var t = s(e.keyCode);
                (m = E.parse(f.elements.preview)),
                  (document.body.style[w] = "none"),
                  (l = f.elements.viewport.getBoundingClientRect()),
                  (o = (i = t)[0]),
                  (r = i[1]),
                  (a = {}),
                  v(o, r),
                  (a[g] = m.toString()),
                  b(f.elements.preview, a),
                  z.call(f),
                  (document.body.style[w] = ""),
                  Z.call(f),
                  F.call(f),
                  (d = 0);
              }
            } else {
              var n;
              (n =
                38 === e.keyCode
                  ? parseFloat(f.elements.zoomer.value) +
                    parseFloat(f.elements.zoomer.step)
                  : parseFloat(f.elements.zoomer.value) -
                    parseFloat(f.elements.zoomer.step)),
                f.setZoom(n);
            }
            var i, o, r, a;
            function s(e) {
              switch (e) {
                case 37:
                  return [1, 0];
                case 38:
                  return [0, 1];
                case 39:
                  return [-1, 0];
                case 40:
                  return [0, -1];
              }
            }
          }),
          f.elements.overlay.addEventListener("touchstart", e);
      }.call(this),
      a.options.enableZoom &&
        function () {
          var i = this,
            e = (i.elements.zoomerWrap = document.createElement("div")),
            t = (i.elements.zoomer = document.createElement("input"));
          function o() {
            (function (e) {
              var t = this,
                n = e ? e.transform : E.parse(t.elements.preview),
                i = e
                  ? e.viewportRect
                  : t.elements.viewport.getBoundingClientRect(),
                o = e ? e.origin : new L(t.elements.preview);
              function r() {
                var e = {};
                (e[g] = n.toString()),
                  (e[v] = o.toString()),
                  b(t.elements.preview, e);
              }
              if (
                ((t._currentZoom = e ? e.value : t._currentZoom),
                (n.scale = t._currentZoom),
                t.elements.zoomer.setAttribute("aria-valuenow", t._currentZoom),
                r(),
                t.options.enforceBoundary)
              ) {
                var a = function (e) {
                    var t = this._currentZoom,
                      n = e.width,
                      i = e.height,
                      o = this.elements.boundary.clientWidth / 2,
                      r = this.elements.boundary.clientHeight / 2,
                      a = this.elements.preview.getBoundingClientRect(),
                      s = a.width,
                      l = a.height,
                      u = n / 2,
                      c = i / 2,
                      h = -1 * (u / t - o),
                      p = -1 * (c / t - r),
                      d = (1 / t) * u,
                      m = (1 / t) * c;
                    return {
                      translate: {
                        maxX: h,
                        minX: h - (s * (1 / t) - n * (1 / t)),
                        maxY: p,
                        minY: p - (l * (1 / t) - i * (1 / t)),
                      },
                      origin: {
                        maxX: s * (1 / t) - d,
                        minX: d,
                        maxY: l * (1 / t) - m,
                        minY: m,
                      },
                    };
                  }.call(t, i),
                  s = a.translate,
                  l = a.origin;
                n.x >= s.maxX && ((o.x = l.minX), (n.x = s.maxX)),
                  n.x <= s.minX && ((o.x = l.maxX), (n.x = s.minX)),
                  n.y >= s.maxY && ((o.y = l.minY), (n.y = s.maxY)),
                  n.y <= s.minY && ((o.y = l.maxY), (n.y = s.minY));
              }
              r(), I.call(t), F.call(t);
            }.call(i, {
              value: parseFloat(t.value),
              origin: new L(i.elements.preview),
              viewportRect: i.elements.viewport.getBoundingClientRect(),
              transform: E.parse(i.elements.preview),
            }));
          }
          function n(e) {
            var t, n;
            if ("ctrl" === i.options.mouseWheelZoom && !0 !== e.ctrlKey)
              return 0;
            (t = e.wheelDelta
              ? e.wheelDelta / 1200
              : e.deltaY
              ? e.deltaY / 1060
              : e.detail
              ? e.detail / -60
              : 0),
              (n = i._currentZoom + t * i._currentZoom),
              e.preventDefault(),
              B.call(i, n),
              o.call(i);
          }
          x(e, "cr-slider-wrap"),
            x(t, "cr-slider"),
            (t.type = "range"),
            (t.step = "0.0001"),
            (t.value = "1"),
            (t.style.display = i.options.showZoomer ? "" : "none"),
            t.setAttribute("aria-label", "zoom"),
            i.element.appendChild(e),
            e.appendChild(t),
            (i._currentZoom = 1),
            i.elements.zoomer.addEventListener("input", o),
            i.elements.zoomer.addEventListener("change", o),
            i.options.mouseWheelZoom &&
              (i.elements.boundary.addEventListener("mousewheel", n),
              i.elements.boundary.addEventListener("DOMMouseScroll", n));
        }.call(a),
      a.options.enableResize &&
        function () {
          var l,
            u,
            c,
            h,
            p,
            e,
            t,
            d = this,
            m = document.createElement("div"),
            i = !1,
            f = 50;
          x(m, "cr-resizer"),
            b(m, {
              width: this.options.viewport.width + "px",
              height: this.options.viewport.height + "px",
            }),
            this.options.resizeControls.height &&
              (x((e = document.createElement("div")), "cr-resizer-vertical"),
              m.appendChild(e));
          this.options.resizeControls.width &&
            (x((t = document.createElement("div")), "cr-resizer-horisontal"),
            m.appendChild(t));
          function n(e) {
            if (
              (void 0 === e.button || 0 === e.button) &&
              (e.preventDefault(), !i)
            ) {
              var t = d.elements.overlay.getBoundingClientRect();
              if (
                ((i = !0),
                (u = e.pageX),
                (c = e.pageY),
                (l =
                  -1 !== e.currentTarget.className.indexOf("vertical")
                    ? "v"
                    : "h"),
                (h = t.width),
                (p = t.height),
                e.touches)
              ) {
                var n = e.touches[0];
                (u = n.pageX), (c = n.pageY);
              }
              window.addEventListener("mousemove", o),
                window.addEventListener("touchmove", o),
                window.addEventListener("mouseup", r),
                window.addEventListener("touchend", r),
                (document.body.style[w] = "none");
            }
          }
          function o(e) {
            var t = e.pageX,
              n = e.pageY;
            if ((e.preventDefault(), e.touches)) {
              var i = e.touches[0];
              (t = i.pageX), (n = i.pageY);
            }
            var o = t - u,
              r = n - c,
              a = d.options.viewport.height + r,
              s = d.options.viewport.width + o;
            "v" === l && f <= a && a <= p
              ? (b(m, { height: a + "px" }),
                (d.options.boundary.height += r),
                b(d.elements.boundary, {
                  height: d.options.boundary.height + "px",
                }),
                (d.options.viewport.height += r),
                b(d.elements.viewport, {
                  height: d.options.viewport.height + "px",
                }))
              : "h" === l &&
                f <= s &&
                s <= h &&
                (b(m, { width: s + "px" }),
                (d.options.boundary.width += o),
                b(d.elements.boundary, {
                  width: d.options.boundary.width + "px",
                }),
                (d.options.viewport.width += o),
                b(d.elements.viewport, {
                  width: d.options.viewport.width + "px",
                })),
              z.call(d),
              W.call(d),
              Z.call(d),
              F.call(d),
              (c = n),
              (u = t);
          }
          function r() {
            (i = !1),
              window.removeEventListener("mousemove", o),
              window.removeEventListener("touchmove", o),
              window.removeEventListener("mouseup", r),
              window.removeEventListener("touchend", r),
              (document.body.style[w] = "");
          }
          e &&
            (e.addEventListener("mousedown", n),
            e.addEventListener("touchstart", n));
          t &&
            (t.addEventListener("mousedown", n),
            t.addEventListener("touchstart", n));
          this.elements.boundary.appendChild(m);
        }.call(a);
  }
  function R() {
    return this.options.enableExif && window.EXIF;
  }
  function B(e) {
    if (this.options.enableZoom) {
      var t = this.elements.zoomer,
        n = A(e, 4);
      t.value = Math.max(
        parseFloat(t.min),
        Math.min(parseFloat(t.max), n)
      ).toString();
    }
  }
  function Z(e) {
    var t = this,
      n = t._currentZoom,
      i = t.elements.preview.getBoundingClientRect(),
      o = t.elements.viewport.getBoundingClientRect(),
      r = E.parse(t.elements.preview.style[g]),
      a = new L(t.elements.preview),
      s = o.top - i.top + o.height / 2,
      l = o.left - i.left + o.width / 2,
      u = {},
      c = {};
    if (e) {
      var h = a.x,
        p = a.y,
        d = r.x,
        m = r.y;
      (u.y = h), (u.x = p), (r.y = d), (r.x = m);
    } else (u.y = s / n), (u.x = l / n), (c.y = (u.y - a.y) * (1 - n)), (c.x = (u.x - a.x) * (1 - n)), (r.x -= c.x), (r.y -= c.y);
    var f = {};
    (f[v] = u.x + "px " + u.y + "px"),
      (f[g] = r.toString()),
      b(t.elements.preview, f);
  }
  function z() {
    if (this.elements) {
      var e = this.elements.boundary.getBoundingClientRect(),
        t = this.elements.preview.getBoundingClientRect();
      b(this.elements.overlay, {
        width: t.width + "px",
        height: t.height + "px",
        top: t.top - e.top + "px",
        left: t.left - e.left + "px",
      });
    }
  }
  L.prototype.toString = function () {
    return this.x + "px " + this.y + "px";
  };
  var a,
    s,
    h,
    M,
    I =
      ((a = z),
      (s = 500),
      function () {
        var e = this,
          t = arguments,
          n = h && !M;
        clearTimeout(M),
          (M = setTimeout(function () {
            (M = null), h || a.apply(e, t);
          }, s)),
          n && a.apply(e, t);
      });
  function F() {
    var e,
      t = this,
      n = t.get();
    X.call(t) &&
      (t.options.update.call(t, n),
      t.$ && "undefined" == typeof Prototype
        ? t.$(t.element).trigger("update.croppie", n)
        : (window.CustomEvent
            ? (e = new CustomEvent("update", { detail: n }))
            : (e = document.createEvent("CustomEvent")).initCustomEvent(
                "update",
                !0,
                !0,
                n
              ),
          t.element.dispatchEvent(e)));
  }
  function X() {
    return (
      0 < this.elements.preview.offsetHeight &&
      0 < this.elements.preview.offsetWidth
    );
  }
  function Y() {
    var e,
      t = this,
      n = {},
      i = t.elements.preview,
      o = new E(0, 0, 1),
      r = new L();
    X.call(t) &&
      !t.data.bound &&
      ((t.data.bound = !0),
      (n[g] = o.toString()),
      (n[v] = r.toString()),
      (n.opacity = 1),
      b(i, n),
      (e = t.elements.preview.getBoundingClientRect()),
      (t._originalImageWidth = e.width),
      (t._originalImageHeight = e.height),
      (t.data.orientation = f(t.elements.img)),
      t.options.enableZoom ? W.call(t, !0) : (t._currentZoom = 1),
      (o.scale = t._currentZoom),
      (n[g] = o.toString()),
      b(i, n),
      t.data.points.length
        ? function (e) {
            if (4 !== e.length)
              throw "Croppie - Invalid number of points supplied: " + e;
            var t = this,
              n = e[2] - e[0],
              i = t.elements.viewport.getBoundingClientRect(),
              o = t.elements.boundary.getBoundingClientRect(),
              r = { left: i.left - o.left, top: i.top - o.top },
              a = i.width / n,
              s = e[1],
              l = e[0],
              u = -1 * e[1] + r.top,
              c = -1 * e[0] + r.left,
              h = {};
            (h[v] = l + "px " + s + "px"),
              (h[g] = new E(c, u, a).toString()),
              b(t.elements.preview, h),
              B.call(t, a),
              (t._currentZoom = a);
          }.call(t, t.data.points)
        : function () {
            var e = this,
              t = e.elements.preview.getBoundingClientRect(),
              n = e.elements.viewport.getBoundingClientRect(),
              i = e.elements.boundary.getBoundingClientRect(),
              o = n.left - i.left,
              r = n.top - i.top,
              a = o - (t.width - n.width) / 2,
              s = r - (t.height - n.height) / 2,
              l = new E(a, s, e._currentZoom);
            b(e.elements.preview, g, l.toString());
          }.call(t),
      Z.call(t),
      z.call(t));
  }
  function W(e) {
    var t,
      n,
      i,
      o,
      r = this,
      a = Math.max(r.options.minZoom, 0) || 0,
      s = r.options.maxZoom || 1.5,
      l = r.elements.zoomer,
      u = parseFloat(l.value),
      c = r.elements.boundary.getBoundingClientRect(),
      h = m(r.elements.img, r.data.orientation),
      p = r.elements.viewport.getBoundingClientRect();
    r.options.enforceBoundary &&
      ((i = p.width / h.width),
      (o = p.height / h.height),
      (a = Math.max(i, o))),
      s <= a && (s = a + 1),
      (l.min = A(a, 4)),
      (l.max = A(s, 4)),
      !e && (u < l.min || u > l.max)
        ? B.call(r, u < l.min ? l.min : l.max)
        : e &&
          ((n = Math.max(c.width / h.width, c.height / h.height)),
          (t = null !== r.data.boundZoom ? r.data.boundZoom : n),
          B.call(r, t)),
      y(l);
  }
  function O(e) {
    var t = e.points,
      n = C(t[0]),
      i = C(t[1]),
      o = C(t[2]) - n,
      r = C(t[3]) - i,
      a = e.circle,
      s = document.createElement("canvas"),
      l = s.getContext("2d"),
      u = e.outputWidth || o,
      c = e.outputHeight || r;
    (s.width = u),
      (s.height = c),
      e.backgroundColor &&
        ((l.fillStyle = e.backgroundColor), l.fillRect(0, 0, u, c));
    var h = n,
      p = i,
      d = o,
      m = r,
      f = 0,
      v = 0,
      g = u,
      w = c;
    return (
      n < 0 && ((h = 0), (f = (Math.abs(n) / o) * u)),
      d + h > this._originalImageWidth &&
        (g = ((d = this._originalImageWidth - h) / o) * u),
      i < 0 && ((p = 0), (v = (Math.abs(i) / r) * c)),
      m + p > this._originalImageHeight &&
        (w = ((m = this._originalImageHeight - p) / r) * c),
      l.drawImage(this.elements.preview, h, p, d, m, f, v, g, w),
      a &&
        ((l.fillStyle = "#fff"),
        (l.globalCompositeOperation = "destination-in"),
        l.beginPath(),
        l.arc(s.width / 2, s.height / 2, s.width / 2, 0, 2 * Math.PI, !0),
        l.closePath(),
        l.fill()),
      s
    );
  }
  function k(c, h) {
    var e,
      i,
      o,
      r,
      p = this,
      d = [],
      t = null,
      n = R.call(p);
    if ("string" == typeof c) (e = c), (c = {});
    else if (Array.isArray(c)) d = c.slice();
    else {
      if (void 0 === c && p.data.url) return Y.call(p), F.call(p), null;
      (e = c.url),
        (d = c.points || []),
        (t = void 0 === c.zoom ? null : c.zoom);
    }
    return (
      (p.data.bound = !1),
      (p.data.url = e || p.data.url),
      (p.data.boundZoom = t),
      ((i = e),
      (o = n),
      (r = new Image()),
      (r.style.opacity = "0"),
      new Promise(function (e, t) {
        function n() {
          (r.style.opacity = "1"),
            setTimeout(function () {
              e(r);
            }, 1);
        }
        r.removeAttribute("crossOrigin"),
          i.match(/^https?:\/\/|^\/\//) &&
            r.setAttribute("crossOrigin", "anonymous"),
          (r.onload = function () {
            o
              ? EXIF.getData(r, function () {
                  n();
                })
              : n();
          }),
          (r.onerror = function (e) {
            (r.style.opacity = 1),
              setTimeout(function () {
                t(e);
              }, 1);
          }),
          (r.src = i);
      })).then(function (e) {
        if (
          (function (t) {
            this.elements.img.parentNode &&
              (Array.prototype.forEach.call(
                this.elements.img.classList,
                function (e) {
                  t.classList.add(e);
                }
              ),
              this.elements.img.parentNode.replaceChild(t, this.elements.img),
              (this.elements.preview = t)),
              (this.elements.img = t);
          }.call(p, e),
          d.length)
        )
          p.options.relative &&
            (d = [
              (d[0] * e.naturalWidth) / 100,
              (d[1] * e.naturalHeight) / 100,
              (d[2] * e.naturalWidth) / 100,
              (d[3] * e.naturalHeight) / 100,
            ]);
        else {
          var t,
            n,
            i = m(e),
            o = p.elements.viewport.getBoundingClientRect(),
            r = o.width / o.height;
          r < i.width / i.height
            ? (t = (n = i.height) * r)
            : ((t = i.width), (n = i.height / r));
          var a = (i.width - t) / 2,
            s = (i.height - n) / 2,
            l = a + t,
            u = s + n;
          p.data.points = [a, s, l, u];
        }
        (p.data.points = d.map(function (e) {
          return parseFloat(e);
        })),
          p.options.useCanvas &&
            function (e) {
              var t = this.elements.canvas,
                n = this.elements.img;
              t.getContext("2d").clearRect(0, 0, t.width, t.height),
                (t.width = n.width),
                (t.height = n.height),
                _(t, n, (this.options.enableOrientation && e) || f(n));
            }.call(p, c.orientation),
          Y.call(p),
          F.call(p),
          h && h();
      })
    );
  }
  function A(e, t) {
    return parseFloat(e).toFixed(t || 0);
  }
  function j() {
    var e = this,
      t = e.elements.preview.getBoundingClientRect(),
      n = e.elements.viewport.getBoundingClientRect(),
      i = n.left - t.left,
      o = n.top - t.top,
      r = (n.width - e.elements.viewport.offsetWidth) / 2,
      a = (n.height - e.elements.viewport.offsetHeight) / 2,
      s = i + e.elements.viewport.offsetWidth + r,
      l = o + e.elements.viewport.offsetHeight + a,
      u = e._currentZoom;
    (u === 1 / 0 || isNaN(u)) && (u = 1);
    var c = e.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
    return (
      (i = Math.max(c, i / u)),
      (o = Math.max(c, o / u)),
      (s = Math.max(c, s / u)),
      (l = Math.max(c, l / u)),
      {
        points: [A(i), A(o), A(s), A(l)],
        zoom: u,
        orientation: e.data.orientation,
      }
    );
  }
  var H = { type: "canvas", format: "png", quality: 1 },
    N = ["jpeg", "webp", "png"];
  function n(e) {
    var t = this,
      n = j.call(t),
      i = p(d(H), d(e)),
      o = "string" == typeof e ? e : i.type || "base64",
      r = i.size || "viewport",
      a = i.format,
      s = i.quality,
      l = i.backgroundColor,
      u =
        "boolean" == typeof i.circle
          ? i.circle
          : "circle" === t.options.viewport.type,
      c = t.elements.viewport.getBoundingClientRect(),
      h = c.width / c.height;
    return (
      "viewport" === r
        ? ((n.outputWidth = c.width), (n.outputHeight = c.height))
        : "object" == typeof r &&
          (r.width && r.height
            ? ((n.outputWidth = r.width), (n.outputHeight = r.height))
            : r.width
            ? ((n.outputWidth = r.width), (n.outputHeight = r.width / h))
            : r.height &&
              ((n.outputWidth = r.height * h), (n.outputHeight = r.height))),
      -1 < N.indexOf(a) && ((n.format = "image/" + a), (n.quality = s)),
      (n.circle = u),
      (n.url = t.data.url),
      (n.backgroundColor = l),
      new Promise(function (e) {
        switch (o.toLowerCase()) {
          case "rawcanvas":
            e(O.call(t, n));
            break;
          case "canvas":
          case "base64":
            e(
              function (e) {
                return O.call(this, e).toDataURL(e.format, e.quality);
              }.call(t, n)
            );
            break;
          case "blob":
            (function (e) {
              var n = this;
              return new Promise(function (t) {
                O.call(n, e).toBlob(
                  function (e) {
                    t(e);
                  },
                  e.format,
                  e.quality
                );
              });
            }
              .call(t, n)
              .then(e));
            break;
          default:
            e(
              function (e) {
                var t = e.points,
                  n = document.createElement("div"),
                  i = document.createElement("img"),
                  o = t[2] - t[0],
                  r = t[3] - t[1];
                return (
                  x(n, "croppie-result"),
                  n.appendChild(i),
                  b(i, { left: -1 * t[0] + "px", top: -1 * t[1] + "px" }),
                  (i.src = e.url),
                  b(n, { width: o + "px", height: r + "px" }),
                  n
                );
              }.call(t, n)
            );
        }
      })
    );
  }
  function S(e) {
    if (!this.options.useCanvas || !this.options.enableOrientation)
      throw "Croppie: Cannot rotate without enableOrientation && EXIF.js included";
    var t,
      n,
      i,
      o,
      r,
      a = this,
      s = a.elements.canvas;
    (a.data.orientation =
      ((t = a.data.orientation),
      (n = e),
      (i = -1 < l.indexOf(t) ? l : u),
      (o = i.indexOf(t)),
      (r = (n / 90) % i.length),
      i[(i.length + o + (r % i.length)) % i.length])),
      _(s, a.elements.img, a.data.orientation),
      Z.call(a, !0),
      W.call(a);
  }
  if (window.jQuery) {
    var P = window.jQuery;
    P.fn.croppie = function (n) {
      if ("string" !== typeof n)
        return this.each(function () {
          var e = new T(this, n);
          (e.$ = P)(this).data("croppie", e);
        });
      var i = Array.prototype.slice.call(arguments, 1),
        e = P(this).data("croppie");
      return "get" === n
        ? e.get()
        : "result" === n
        ? e.result.apply(e, i)
        : "bind" === n
        ? e.bind.apply(e, i)
        : this.each(function () {
            var e = P(this).data("croppie");
            if (e) {
              var t = e[n];
              if (!P.isFunction(t)) throw "Croppie " + n + " method not found";
              t.apply(e, i), "destroy" === n && P(this).removeData("croppie");
            }
          });
    };
  }
  function T(e, t) {
    if (-1 < e.className.indexOf("croppie-container"))
      throw new Error("Croppie: Can't initialize croppie more than once");
    if (
      ((this.element = e),
      (this.options = p(d(T.defaults), t)),
      "img" === this.element.tagName.toLowerCase())
    ) {
      var n = this.element;
      x(n, "cr-original-image"), c(n, { "aria-hidden": "true", alt: "" });
      var i = document.createElement("div");
      this.element.parentNode.appendChild(i),
        i.appendChild(n),
        (this.element = i),
        (this.options.url = this.options.url || n.src);
    }
    if ((r.call(this), this.options.url)) {
      var o = { url: this.options.url, points: this.options.points };
      delete this.options.url, delete this.options.points, k.call(this, o);
    }
  }
  return (
    (T.defaults = {
      viewport: { width: 100, height: 100, type: "square" },
      boundary: {},
      orientationControls: { enabled: !0, leftClass: "", rightClass: "" },
      resizeControls: { width: !0, height: !0 },
      customClass: "",
      showZoomer: !0,
      enableZoom: !0,
      enableResize: !1,
      mouseWheelZoom: !0,
      enableExif: !1,
      enforceBoundary: !0,
      enableOrientation: !1,
      enableKeyMovement: !0,
      update: function () {},
    }),
    (T.globals = { translate: "translate3d" }),
    p(T.prototype, {
      bind: function (e, t) {
        return k.call(this, e, t);
      },
      get: function () {
        var e = j.call(this),
          t = e.points;
        return (
          this.options.relative &&
            ((t[0] /= this.elements.img.naturalWidth / 100),
            (t[1] /= this.elements.img.naturalHeight / 100),
            (t[2] /= this.elements.img.naturalWidth / 100),
            (t[3] /= this.elements.img.naturalHeight / 100)),
          e
        );
      },
      result: function (e) {
        return n.call(this, e);
      },
      refresh: function () {
        return function () {
          Y.call(this);
        }.call(this);
      },
      setZoom: function (e) {
        B.call(this, e), y(this.elements.zoomer);
      },
      rotate: function (e) {
        S.call(this, e);
      },
      destroy: function () {
        return function () {
          var e,
            t,
            n = this;
          n.element.removeChild(n.elements.boundary),
            (e = n.element),
            (t = "croppie-container"),
            e.classList
              ? e.classList.remove(t)
              : (e.className = e.className.replace(t, "")),
            n.options.enableZoom &&
              n.element.removeChild(n.elements.zoomerWrap),
            delete n.elements;
        }.call(this);
      },
    }),
    T
  );
});
/*!
 * Cropper.js v1.5.6
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2019-10-04T04:33:48.372Z
 */
!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : ((t = t || self).Cropper = e());
})(this, function () {
  "use strict";
  function e(t) {
    return (e =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (t) {
            return typeof t;
          }
        : function (t) {
            return t &&
              "function" == typeof Symbol &&
              t.constructor === Symbol &&
              t !== Symbol.prototype
              ? "symbol"
              : typeof t;
          })(t);
  }
  function a(t, e) {
    for (var i = 0; i < e.length; i++) {
      var a = e[i];
      (a.enumerable = a.enumerable || !1),
        (a.configurable = !0),
        "value" in a && (a.writable = !0),
        Object.defineProperty(t, a.key, a);
    }
  }
  function i(e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      t &&
        (a = a.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })),
        i.push.apply(i, a);
    }
    return i;
  }
  function C(n) {
    for (var t = 1; t < arguments.length; t++) {
      var o = null != arguments[t] ? arguments[t] : {};
      t % 2
        ? i(o, !0).forEach(function (t) {
            var e, i, a;
            (e = n),
              (a = o[(i = t)]),
              i in e
                ? Object.defineProperty(e, i, {
                    value: a,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[i] = a);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o))
        : i(o).forEach(function (t) {
            Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(o, t));
          });
    }
    return n;
  }
  function P(t) {
    return (
      (function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, i = new Array(t.length); e < t.length; e++)
            i[e] = t[e];
          return i;
        }
      })(t) ||
      (function (t) {
        if (
          Symbol.iterator in Object(t) ||
          "[object Arguments]" === Object.prototype.toString.call(t)
        )
          return Array.from(t);
      })(t) ||
      (function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      })()
    );
  }
  var n = "undefined" != typeof window && void 0 !== window.document,
    r = n ? window : {},
    t = n && "ontouchstart" in r.document.documentElement,
    o = n && "PointerEvent" in r,
    l = "cropper",
    D = "all",
    B = "crop",
    k = "move",
    O = "zoom",
    T = "e",
    E = "w",
    W = "s",
    N = "n",
    H = "ne",
    L = "nw",
    z = "se",
    Y = "sw",
    h = "".concat(l, "-crop"),
    s = "".concat(l, "-disabled"),
    X = "".concat(l, "-hidden"),
    d = "".concat(l, "-hide"),
    p = "".concat(l, "-invisible"),
    c = "".concat(l, "-modal"),
    u = "".concat(l, "-move"),
    m = "".concat(l, "Action"),
    g = "".concat(l, "Preview"),
    f = "crop",
    v = "move",
    w = "none",
    b = "crop",
    x = "cropend",
    y = "cropmove",
    M = "cropstart",
    R = "dblclick",
    S = o ? "pointerdown" : t ? "touchstart" : "mousedown",
    A = o ? "pointermove" : t ? "touchmove" : "mousemove",
    j = o ? "pointerup pointercancel" : t ? "touchend touchcancel" : "mouseup",
    I = "ready",
    U = "zoom",
    q = "image/jpeg",
    $ = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/,
    Q = /^data:/,
    K = /^data:image\/jpeg;base64,/,
    Z = /^img|canvas$/i,
    G = {
      viewMode: 0,
      dragMode: f,
      initialAspectRatio: NaN,
      aspectRatio: NaN,
      data: null,
      preview: "",
      responsive: !0,
      restore: !0,
      checkCrossOrigin: !0,
      checkOrientation: !0,
      modal: !0,
      guides: !0,
      center: !0,
      highlight: !0,
      background: !0,
      autoCrop: !0,
      autoCropArea: 0.8,
      movable: !0,
      rotatable: !0,
      scalable: !0,
      zoomable: !0,
      zoomOnTouch: !0,
      zoomOnWheel: !0,
      wheelZoomRatio: 0.1,
      cropBoxMovable: !0,
      cropBoxResizable: !0,
      toggleDragModeOnDblclick: !0,
      minCanvasWidth: 0,
      minCanvasHeight: 0,
      minCropBoxWidth: 0,
      minCropBoxHeight: 0,
      minContainerWidth: 200,
      minContainerHeight: 100,
      ready: null,
      cropstart: null,
      cropmove: null,
      cropend: null,
      crop: null,
      zoom: null,
    },
    V = Number.isNaN || r.isNaN;
  function F(t) {
    return "number" == typeof t && !V(t);
  }
  var J = function (t) {
    return 0 < t && t < 1 / 0;
  };
  function _(t) {
    return void 0 === t;
  }
  function tt(t) {
    return "object" === e(t) && null !== t;
  }
  var et = Object.prototype.hasOwnProperty;
  function it(t) {
    if (!tt(t)) return !1;
    try {
      var e = t.constructor,
        i = e.prototype;
      return e && i && et.call(i, "isPrototypeOf");
    } catch (t) {
      return !1;
    }
  }
  function at(t) {
    return "function" == typeof t;
  }
  var nt = Array.prototype.slice;
  function ot(t) {
    return Array.from ? Array.from(t) : nt.call(t);
  }
  function rt(i, a) {
    return (
      i &&
        at(a) &&
        (Array.isArray(i) || F(i.length)
          ? ot(i).forEach(function (t, e) {
              a.call(i, t, e, i);
            })
          : tt(i) &&
            Object.keys(i).forEach(function (t) {
              a.call(i, i[t], t, i);
            })),
      i
    );
  }
  var ht =
      Object.assign ||
      function (i) {
        for (
          var t = arguments.length, e = new Array(1 < t ? t - 1 : 0), a = 1;
          a < t;
          a++
        )
          e[a - 1] = arguments[a];
        return (
          tt(i) &&
            0 < e.length &&
            e.forEach(function (e) {
              tt(e) &&
                Object.keys(e).forEach(function (t) {
                  i[t] = e[t];
                });
            }),
          i
        );
      },
    st = /\.\d*(?:0|9){12}\d*$/;
  function ct(t, e) {
    var i = 1 < arguments.length && void 0 !== e ? e : 1e11;
    return st.test(t) ? Math.round(t * i) / i : t;
  }
  var lt = /^width|height|left|top|marginLeft|marginTop$/;
  function dt(t, e) {
    var i = t.style;
    rt(e, function (t, e) {
      lt.test(e) && F(t) && (t = "".concat(t, "px")), (i[e] = t);
    });
  }
  function pt(t, e) {
    if (e)
      if (F(t.length))
        rt(t, function (t) {
          pt(t, e);
        });
      else if (t.classList) t.classList.add(e);
      else {
        var i = t.className.trim();
        i
          ? i.indexOf(e) < 0 && (t.className = "".concat(i, " ").concat(e))
          : (t.className = e);
      }
  }
  function ut(t, e) {
    e &&
      (F(t.length)
        ? rt(t, function (t) {
            ut(t, e);
          })
        : t.classList
        ? t.classList.remove(e)
        : 0 <= t.className.indexOf(e) &&
          (t.className = t.className.replace(e, "")));
  }
  function mt(t, e, i) {
    e &&
      (F(t.length)
        ? rt(t, function (t) {
            mt(t, e, i);
          })
        : i
        ? pt(t, e)
        : ut(t, e));
  }
  var gt = /([a-z\d])([A-Z])/g;
  function ft(t) {
    return t.replace(gt, "$1-$2").toLowerCase();
  }
  function vt(t, e) {
    return tt(t[e])
      ? t[e]
      : t.dataset
      ? t.dataset[e]
      : t.getAttribute("data-".concat(ft(e)));
  }
  function wt(t, e, i) {
    tt(i)
      ? (t[e] = i)
      : t.dataset
      ? (t.dataset[e] = i)
      : t.setAttribute("data-".concat(ft(e)), i);
  }
  var bt = /\s\s*/,
    xt = (function () {
      var t = !1;
      if (n) {
        var e = !1,
          i = function () {},
          a = Object.defineProperty({}, "once", {
            get: function () {
              return (t = !0), e;
            },
            set: function (t) {
              e = t;
            },
          });
        r.addEventListener("test", i, a), r.removeEventListener("test", i, a);
      }
      return t;
    })();
  function yt(i, t, a, e) {
    var n = 3 < arguments.length && void 0 !== e ? e : {},
      o = a;
    t.trim()
      .split(bt)
      .forEach(function (t) {
        if (!xt) {
          var e = i.listeners;
          e &&
            e[t] &&
            e[t][a] &&
            ((o = e[t][a]),
            delete e[t][a],
            0 === Object.keys(e[t]).length && delete e[t],
            0 === Object.keys(e).length && delete i.listeners);
        }
        i.removeEventListener(t, o, n);
      });
  }
  function Mt(o, t, r, e) {
    var h = 3 < arguments.length && void 0 !== e ? e : {},
      s = r;
    t.trim()
      .split(bt)
      .forEach(function (a) {
        if (h.once && !xt) {
          var t = o.listeners,
            n = void 0 === t ? {} : t;
          (s = function () {
            delete n[a][r], o.removeEventListener(a, s, h);
            for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
              e[i] = arguments[i];
            r.apply(o, e);
          }),
            n[a] || (n[a] = {}),
            n[a][r] && o.removeEventListener(a, n[a][r], h),
            (n[a][r] = s),
            (o.listeners = n);
        }
        o.addEventListener(a, s, h);
      });
  }
  function Ct(t, e, i) {
    var a;
    return (
      at(Event) && at(CustomEvent)
        ? (a = new CustomEvent(e, { detail: i, bubbles: !0, cancelable: !0 }))
        : (a = document.createEvent("CustomEvent")).initCustomEvent(
            e,
            !0,
            !0,
            i
          ),
      t.dispatchEvent(a)
    );
  }
  function Dt(t) {
    var e = t.getBoundingClientRect();
    return {
      left: e.left + (window.pageXOffset - document.documentElement.clientLeft),
      top: e.top + (window.pageYOffset - document.documentElement.clientTop),
    };
  }
  var Bt = r.location,
    kt = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
  function Ot(t) {
    var e = t.match(kt);
    return (
      null !== e &&
      (e[1] !== Bt.protocol || e[2] !== Bt.hostname || e[3] !== Bt.port)
    );
  }
  function Tt(t) {
    var e = "timestamp=".concat(new Date().getTime());
    return t + (-1 === t.indexOf("?") ? "?" : "&") + e;
  }
  function Et(t) {
    var e = t.rotate,
      i = t.scaleX,
      a = t.scaleY,
      n = t.translateX,
      o = t.translateY,
      r = [];
    F(n) && 0 !== n && r.push("translateX(".concat(n, "px)")),
      F(o) && 0 !== o && r.push("translateY(".concat(o, "px)")),
      F(e) && 0 !== e && r.push("rotate(".concat(e, "deg)")),
      F(i) && 1 !== i && r.push("scaleX(".concat(i, ")")),
      F(a) && 1 !== a && r.push("scaleY(".concat(a, ")"));
    var h = r.length ? r.join(" ") : "none";
    return { WebkitTransform: h, msTransform: h, transform: h };
  }
  function Wt(t, e) {
    var i = t.pageX,
      a = t.pageY,
      n = { endX: i, endY: a };
    return e ? n : C({ startX: i, startY: a }, n);
  }
  function Nt(t, e) {
    var i = t.aspectRatio,
      a = t.height,
      n = t.width,
      o = 1 < arguments.length && void 0 !== e ? e : "contain",
      r = J(n),
      h = J(a);
    if (r && h) {
      var s = a * i;
      ("contain" === o && n < s) || ("cover" === o && s < n)
        ? (a = n / i)
        : (n = a * i);
    } else r ? (a = n / i) : h && (n = a * i);
    return { width: n, height: a };
  }
  var Ht = String.fromCharCode;
  var Lt = /^data:.*,/;
  function zt(t) {
    var e,
      i = new DataView(t);
    try {
      var a, n, o;
      if (255 === i.getUint8(0) && 216 === i.getUint8(1))
        for (var r = i.byteLength, h = 2; h + 1 < r; ) {
          if (255 === i.getUint8(h) && 225 === i.getUint8(h + 1)) {
            n = h;
            break;
          }
          h += 1;
        }
      if (n) {
        var s = n + 10;
        if (
          "Exif" ===
          (function (t, e, i) {
            var a = "";
            i += e;
            for (var n = e; n < i; n += 1) a += Ht(t.getUint8(n));
            return a;
          })(i, n + 4, 4)
        ) {
          var c = i.getUint16(s);
          if (
            ((a = 18761 === c) || 19789 === c) &&
            42 === i.getUint16(s + 2, a)
          ) {
            var l = i.getUint32(s + 4, a);
            8 <= l && (o = s + l);
          }
        }
      }
      if (o) {
        var d,
          p,
          u = i.getUint16(o, a);
        for (p = 0; p < u; p += 1)
          if (((d = o + 12 * p + 2), 274 === i.getUint16(d, a))) {
            (d += 8), (e = i.getUint16(d, a)), i.setUint16(d, 1, a);
            break;
          }
      }
    } catch (t) {
      e = 1;
    }
    return e;
  }
  var Yt = {
      render: function () {
        this.initContainer(),
          this.initCanvas(),
          this.initCropBox(),
          this.renderCanvas(),
          this.cropped && this.renderCropBox();
      },
      initContainer: function () {
        var t = this.element,
          e = this.options,
          i = this.container,
          a = this.cropper;
        pt(a, X), ut(t, X);
        var n = {
          width: Math.max(i.offsetWidth, Number(e.minContainerWidth) || 200),
          height: Math.max(i.offsetHeight, Number(e.minContainerHeight) || 100),
        };
        dt(a, { width: (this.containerData = n).width, height: n.height }),
          pt(t, X),
          ut(a, X);
      },
      initCanvas: function () {
        var t = this.containerData,
          e = this.imageData,
          i = this.options.viewMode,
          a = Math.abs(e.rotate) % 180 == 90,
          n = a ? e.naturalHeight : e.naturalWidth,
          o = a ? e.naturalWidth : e.naturalHeight,
          r = n / o,
          h = t.width,
          s = t.height;
        t.height * r > t.width
          ? 3 === i
            ? (h = t.height * r)
            : (s = t.width / r)
          : 3 === i
          ? (s = t.width / r)
          : (h = t.height * r);
        var c = {
          aspectRatio: r,
          naturalWidth: n,
          naturalHeight: o,
          width: h,
          height: s,
        };
        (c.left = (t.width - h) / 2),
          (c.top = (t.height - s) / 2),
          (c.oldLeft = c.left),
          (c.oldTop = c.top),
          (this.canvasData = c),
          (this.limited = 1 === i || 2 === i),
          this.limitCanvas(!0, !0),
          (this.initialImageData = ht({}, e)),
          (this.initialCanvasData = ht({}, c));
      },
      limitCanvas: function (t, e) {
        var i = this.options,
          a = this.containerData,
          n = this.canvasData,
          o = this.cropBoxData,
          r = i.viewMode,
          h = n.aspectRatio,
          s = this.cropped && o;
        if (t) {
          var c = Number(i.minCanvasWidth) || 0,
            l = Number(i.minCanvasHeight) || 0;
          1 < r
            ? ((c = Math.max(c, a.width)),
              (l = Math.max(l, a.height)),
              3 === r && (c < l * h ? (c = l * h) : (l = c / h)))
            : 0 < r &&
              (c
                ? (c = Math.max(c, s ? o.width : 0))
                : l
                ? (l = Math.max(l, s ? o.height : 0))
                : s &&
                  ((c = o.width) < (l = o.height) * h
                    ? (c = l * h)
                    : (l = c / h)));
          var d = Nt({ aspectRatio: h, width: c, height: l });
          (c = d.width),
            (l = d.height),
            (n.minWidth = c),
            (n.minHeight = l),
            (n.maxWidth = 1 / 0),
            (n.maxHeight = 1 / 0);
        }
        if (e)
          if ((s ? 0 : 1) < r) {
            var p = a.width - n.width,
              u = a.height - n.height;
            (n.minLeft = Math.min(0, p)),
              (n.minTop = Math.min(0, u)),
              (n.maxLeft = Math.max(0, p)),
              (n.maxTop = Math.max(0, u)),
              s &&
                this.limited &&
                ((n.minLeft = Math.min(o.left, o.left + (o.width - n.width))),
                (n.minTop = Math.min(o.top, o.top + (o.height - n.height))),
                (n.maxLeft = o.left),
                (n.maxTop = o.top),
                2 === r &&
                  (n.width >= a.width &&
                    ((n.minLeft = Math.min(0, p)),
                    (n.maxLeft = Math.max(0, p))),
                  n.height >= a.height &&
                    ((n.minTop = Math.min(0, u)),
                    (n.maxTop = Math.max(0, u)))));
          } else
            (n.minLeft = -n.width),
              (n.minTop = -n.height),
              (n.maxLeft = a.width),
              (n.maxTop = a.height);
      },
      renderCanvas: function (t, e) {
        var i = this.canvasData,
          a = this.imageData;
        if (e) {
          var n = (function (t) {
              var e = t.width,
                i = t.height,
                a = t.degree;
              if (90 === (a = Math.abs(a) % 180))
                return { width: i, height: e };
              var n = ((a % 90) * Math.PI) / 180,
                o = Math.sin(n),
                r = Math.cos(n),
                h = e * r + i * o,
                s = e * o + i * r;
              return 90 < a ? { width: s, height: h } : { width: h, height: s };
            })({
              width: a.naturalWidth * Math.abs(a.scaleX || 1),
              height: a.naturalHeight * Math.abs(a.scaleY || 1),
              degree: a.rotate || 0,
            }),
            o = n.width,
            r = n.height,
            h = i.width * (o / i.naturalWidth),
            s = i.height * (r / i.naturalHeight);
          (i.left -= (h - i.width) / 2),
            (i.top -= (s - i.height) / 2),
            (i.width = h),
            (i.height = s),
            (i.aspectRatio = o / r),
            (i.naturalWidth = o),
            (i.naturalHeight = r),
            this.limitCanvas(!0, !1);
        }
        (i.width > i.maxWidth || i.width < i.minWidth) && (i.left = i.oldLeft),
          (i.height > i.maxHeight || i.height < i.minHeight) &&
            (i.top = i.oldTop),
          (i.width = Math.min(Math.max(i.width, i.minWidth), i.maxWidth)),
          (i.height = Math.min(Math.max(i.height, i.minHeight), i.maxHeight)),
          this.limitCanvas(!1, !0),
          (i.left = Math.min(Math.max(i.left, i.minLeft), i.maxLeft)),
          (i.top = Math.min(Math.max(i.top, i.minTop), i.maxTop)),
          (i.oldLeft = i.left),
          (i.oldTop = i.top),
          dt(
            this.canvas,
            ht(
              { width: i.width, height: i.height },
              Et({ translateX: i.left, translateY: i.top })
            )
          ),
          this.renderImage(t),
          this.cropped && this.limited && this.limitCropBox(!0, !0);
      },
      renderImage: function (t) {
        var e = this.canvasData,
          i = this.imageData,
          a = i.naturalWidth * (e.width / e.naturalWidth),
          n = i.naturalHeight * (e.height / e.naturalHeight);
        ht(i, {
          width: a,
          height: n,
          left: (e.width - a) / 2,
          top: (e.height - n) / 2,
        }),
          dt(
            this.image,
            ht(
              { width: i.width, height: i.height },
              Et(ht({ translateX: i.left, translateY: i.top }, i))
            )
          ),
          t && this.output();
      },
      initCropBox: function () {
        var t = this.options,
          e = this.canvasData,
          i = t.aspectRatio || t.initialAspectRatio,
          a = Number(t.autoCropArea) || 0.8,
          n = { width: e.width, height: e.height };
        i &&
          (e.height * i > e.width
            ? (n.height = n.width / i)
            : (n.width = n.height * i)),
          (this.cropBoxData = n),
          this.limitCropBox(!0, !0),
          (n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth)),
          (n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight)),
          (n.width = Math.max(n.minWidth, n.width * a)),
          (n.height = Math.max(n.minHeight, n.height * a)),
          (n.left = e.left + (e.width - n.width) / 2),
          (n.top = e.top + (e.height - n.height) / 2),
          (n.oldLeft = n.left),
          (n.oldTop = n.top),
          (this.initialCropBoxData = ht({}, n));
      },
      limitCropBox: function (t, e) {
        var i = this.options,
          a = this.containerData,
          n = this.canvasData,
          o = this.cropBoxData,
          r = this.limited,
          h = i.aspectRatio;
        if (t) {
          var s = Number(i.minCropBoxWidth) || 0,
            c = Number(i.minCropBoxHeight) || 0,
            l = r
              ? Math.min(a.width, n.width, n.width + n.left, a.width - n.left)
              : a.width,
            d = r
              ? Math.min(a.height, n.height, n.height + n.top, a.height - n.top)
              : a.height;
          (s = Math.min(s, a.width)),
            (c = Math.min(c, a.height)),
            h &&
              (s && c
                ? s < c * h
                  ? (c = s / h)
                  : (s = c * h)
                : s
                ? (c = s / h)
                : c && (s = c * h),
              l < d * h ? (d = l / h) : (l = d * h)),
            (o.minWidth = Math.min(s, l)),
            (o.minHeight = Math.min(c, d)),
            (o.maxWidth = l),
            (o.maxHeight = d);
        }
        e &&
          (r
            ? ((o.minLeft = Math.max(0, n.left)),
              (o.minTop = Math.max(0, n.top)),
              (o.maxLeft = Math.min(a.width, n.left + n.width) - o.width),
              (o.maxTop = Math.min(a.height, n.top + n.height) - o.height))
            : ((o.minLeft = 0),
              (o.minTop = 0),
              (o.maxLeft = a.width - o.width),
              (o.maxTop = a.height - o.height)));
      },
      renderCropBox: function () {
        var t = this.options,
          e = this.containerData,
          i = this.cropBoxData;
        (i.width > i.maxWidth || i.width < i.minWidth) && (i.left = i.oldLeft),
          (i.height > i.maxHeight || i.height < i.minHeight) &&
            (i.top = i.oldTop),
          (i.width = Math.min(Math.max(i.width, i.minWidth), i.maxWidth)),
          (i.height = Math.min(Math.max(i.height, i.minHeight), i.maxHeight)),
          this.limitCropBox(!1, !0),
          (i.left = Math.min(Math.max(i.left, i.minLeft), i.maxLeft)),
          (i.top = Math.min(Math.max(i.top, i.minTop), i.maxTop)),
          (i.oldLeft = i.left),
          (i.oldTop = i.top),
          t.movable &&
            t.cropBoxMovable &&
            wt(
              this.face,
              m,
              i.width >= e.width && i.height >= e.height ? k : D
            ),
          dt(
            this.cropBox,
            ht(
              { width: i.width, height: i.height },
              Et({ translateX: i.left, translateY: i.top })
            )
          ),
          this.cropped && this.limited && this.limitCanvas(!0, !0),
          this.disabled || this.output();
      },
      output: function () {
        this.preview(), Ct(this.element, b, this.getData());
      },
    },
    Xt = {
      initPreview: function () {
        var t = this.element,
          i = this.crossOrigin,
          e = this.options.preview,
          a = i ? this.crossOriginUrl : this.url,
          n = t.alt || "The image to preview",
          o = document.createElement("img");
        if (
          (i && (o.crossOrigin = i),
          (o.src = a),
          (o.alt = n),
          this.viewBox.appendChild(o),
          (this.viewBoxImage = o),
          e)
        ) {
          var r = e;
          "string" == typeof e
            ? (r = t.ownerDocument.querySelectorAll(e))
            : e.querySelector && (r = [e]),
            rt((this.previews = r), function (t) {
              var e = document.createElement("img");
              wt(t, g, {
                width: t.offsetWidth,
                height: t.offsetHeight,
                html: t.innerHTML,
              }),
                i && (e.crossOrigin = i),
                (e.src = a),
                (e.alt = n),
                (e.style.cssText =
                  'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"'),
                (t.innerHTML = ""),
                t.appendChild(e);
            });
        }
      },
      resetPreview: function () {
        rt(this.previews, function (t) {
          var e = vt(t, g);
          dt(t, { width: e.width, height: e.height }),
            (t.innerHTML = e.html),
            (function (e, i) {
              if (tt(e[i]))
                try {
                  delete e[i];
                } catch (t) {
                  e[i] = void 0;
                }
              else if (e.dataset)
                try {
                  delete e.dataset[i];
                } catch (t) {
                  e.dataset[i] = void 0;
                }
              else e.removeAttribute("data-".concat(ft(i)));
            })(t, g);
        });
      },
      preview: function () {
        var h = this.imageData,
          t = this.canvasData,
          e = this.cropBoxData,
          s = e.width,
          c = e.height,
          l = h.width,
          d = h.height,
          p = e.left - t.left - h.left,
          u = e.top - t.top - h.top;
        this.cropped &&
          !this.disabled &&
          (dt(
            this.viewBoxImage,
            ht(
              { width: l, height: d },
              Et(ht({ translateX: -p, translateY: -u }, h))
            )
          ),
          rt(this.previews, function (t) {
            var e = vt(t, g),
              i = e.width,
              a = e.height,
              n = i,
              o = a,
              r = 1;
            s && (o = c * (r = i / s)),
              c && a < o && ((n = s * (r = a / c)), (o = a)),
              dt(t, { width: n, height: o }),
              dt(
                t.getElementsByTagName("img")[0],
                ht(
                  { width: l * r, height: d * r },
                  Et(ht({ translateX: -p * r, translateY: -u * r }, h))
                )
              );
          }));
      },
    },
    Rt = {
      bind: function () {
        var t = this.element,
          e = this.options,
          i = this.cropper;
        at(e.cropstart) && Mt(t, M, e.cropstart),
          at(e.cropmove) && Mt(t, y, e.cropmove),
          at(e.cropend) && Mt(t, x, e.cropend),
          at(e.crop) && Mt(t, b, e.crop),
          at(e.zoom) && Mt(t, U, e.zoom),
          Mt(i, S, (this.onCropStart = this.cropStart.bind(this))),
          e.zoomable &&
            e.zoomOnWheel &&
            Mt(i, "wheel", (this.onWheel = this.wheel.bind(this)), {
              passive: !1,
              capture: !0,
            }),
          e.toggleDragModeOnDblclick &&
            Mt(i, R, (this.onDblclick = this.dblclick.bind(this))),
          Mt(t.ownerDocument, A, (this.onCropMove = this.cropMove.bind(this))),
          Mt(t.ownerDocument, j, (this.onCropEnd = this.cropEnd.bind(this))),
          e.responsive &&
            Mt(window, "resize", (this.onResize = this.resize.bind(this)));
      },
      unbind: function () {
        var t = this.element,
          e = this.options,
          i = this.cropper;
        at(e.cropstart) && yt(t, M, e.cropstart),
          at(e.cropmove) && yt(t, y, e.cropmove),
          at(e.cropend) && yt(t, x, e.cropend),
          at(e.crop) && yt(t, b, e.crop),
          at(e.zoom) && yt(t, U, e.zoom),
          yt(i, S, this.onCropStart),
          e.zoomable &&
            e.zoomOnWheel &&
            yt(i, "wheel", this.onWheel, { passive: !1, capture: !0 }),
          e.toggleDragModeOnDblclick && yt(i, R, this.onDblclick),
          yt(t.ownerDocument, A, this.onCropMove),
          yt(t.ownerDocument, j, this.onCropEnd),
          e.responsive && yt(window, "resize", this.onResize);
      },
    },
    St = {
      resize: function () {
        var t = this.options,
          e = this.container,
          i = this.containerData,
          a = Number(t.minContainerWidth) || 200,
          n = Number(t.minContainerHeight) || 100;
        if (!(this.disabled || i.width <= a || i.height <= n)) {
          var o,
            r,
            h = e.offsetWidth / i.width;
          if (1 != h || e.offsetHeight !== i.height)
            t.restore &&
              ((o = this.getCanvasData()), (r = this.getCropBoxData())),
              this.render(),
              t.restore &&
                (this.setCanvasData(
                  rt(o, function (t, e) {
                    o[e] = t * h;
                  })
                ),
                this.setCropBoxData(
                  rt(r, function (t, e) {
                    r[e] = t * h;
                  })
                ));
        }
      },
      dblclick: function () {
        this.disabled ||
          this.options.dragMode === w ||
          this.setDragMode(
            (function (t, e) {
              return t.classList
                ? t.classList.contains(e)
                : -1 < t.className.indexOf(e);
            })(this.dragBox, h)
              ? v
              : f
          );
      },
      wheel: function (t) {
        var e = this,
          i = Number(this.options.wheelZoomRatio) || 0.1,
          a = 1;
        this.disabled ||
          (t.preventDefault(),
          this.wheeling ||
            ((this.wheeling = !0),
            setTimeout(function () {
              e.wheeling = !1;
            }, 50),
            t.deltaY
              ? (a = 0 < t.deltaY ? 1 : -1)
              : t.wheelDelta
              ? (a = -t.wheelDelta / 120)
              : t.detail && (a = 0 < t.detail ? 1 : -1),
            this.zoom(-a * i, t)));
      },
      cropStart: function (t) {
        var e = t.buttons,
          i = t.button;
        if (
          !(
            this.disabled ||
            (("mousedown" === t.type ||
              ("pointerdown" === t.type && "mouse" === t.pointerType)) &&
              ((F(e) && 1 !== e) || (F(i) && 0 !== i) || t.ctrlKey))
          )
        ) {
          var a,
            n = this.options,
            o = this.pointers;
          t.changedTouches
            ? rt(t.changedTouches, function (t) {
                o[t.identifier] = Wt(t);
              })
            : (o[t.pointerId || 0] = Wt(t)),
            (a =
              1 < Object.keys(o).length && n.zoomable && n.zoomOnTouch
                ? O
                : vt(t.target, m)),
            $.test(a) &&
              !1 !== Ct(this.element, M, { originalEvent: t, action: a }) &&
              (t.preventDefault(),
              (this.action = a),
              (this.cropping = !1),
              a === B && ((this.cropping = !0), pt(this.dragBox, c)));
        }
      },
      cropMove: function (t) {
        var e = this.action;
        if (!this.disabled && e) {
          var i = this.pointers;
          t.preventDefault(),
            !1 !== Ct(this.element, y, { originalEvent: t, action: e }) &&
              (t.changedTouches
                ? rt(t.changedTouches, function (t) {
                    ht(i[t.identifier] || {}, Wt(t, !0));
                  })
                : ht(i[t.pointerId || 0] || {}, Wt(t, !0)),
              this.change(t));
        }
      },
      cropEnd: function (t) {
        if (!this.disabled) {
          var e = this.action,
            i = this.pointers;
          t.changedTouches
            ? rt(t.changedTouches, function (t) {
                delete i[t.identifier];
              })
            : delete i[t.pointerId || 0],
            e &&
              (t.preventDefault(),
              Object.keys(i).length || (this.action = ""),
              this.cropping &&
                ((this.cropping = !1),
                mt(this.dragBox, c, this.cropped && this.options.modal)),
              Ct(this.element, x, { originalEvent: t, action: e }));
        }
      },
    },
    At = {
      change: function (t) {
        var e,
          i = this.options,
          a = this.canvasData,
          n = this.containerData,
          o = this.cropBoxData,
          r = this.pointers,
          h = this.action,
          s = i.aspectRatio,
          c = o.left,
          l = o.top,
          d = o.width,
          p = o.height,
          u = c + d,
          m = l + p,
          g = 0,
          f = 0,
          v = n.width,
          w = n.height,
          b = !0;
        !s && t.shiftKey && (s = d && p ? d / p : 1),
          this.limited &&
            ((g = o.minLeft),
            (f = o.minTop),
            (v = g + Math.min(n.width, a.width, a.left + a.width)),
            (w = f + Math.min(n.height, a.height, a.top + a.height)));
        function x(t) {
          switch (t) {
            case T:
              u + M.x > v && (M.x = v - u);
              break;
            case E:
              c + M.x < g && (M.x = g - c);
              break;
            case N:
              l + M.y < f && (M.y = f - l);
              break;
            case W:
              m + M.y > w && (M.y = w - m);
          }
        }
        var y = r[Object.keys(r)[0]],
          M = { x: y.endX - y.startX, y: y.endY - y.startY };
        switch (h) {
          case D:
            (c += M.x), (l += M.y);
            break;
          case T:
            if (0 <= M.x && (v <= u || (s && (l <= f || w <= m)))) {
              b = !1;
              break;
            }
            x(T),
              (d += M.x) < 0 && ((h = E), (c -= d = -d)),
              s && ((p = d / s), (l += (o.height - p) / 2));
            break;
          case N:
            if (M.y <= 0 && (l <= f || (s && (c <= g || v <= u)))) {
              b = !1;
              break;
            }
            x(N),
              (p -= M.y),
              (l += M.y),
              p < 0 && ((h = W), (l -= p = -p)),
              s && ((d = p * s), (c += (o.width - d) / 2));
            break;
          case E:
            if (M.x <= 0 && (c <= g || (s && (l <= f || w <= m)))) {
              b = !1;
              break;
            }
            x(E),
              (d -= M.x),
              (c += M.x),
              d < 0 && ((h = T), (c -= d = -d)),
              s && ((p = d / s), (l += (o.height - p) / 2));
            break;
          case W:
            if (0 <= M.y && (w <= m || (s && (c <= g || v <= u)))) {
              b = !1;
              break;
            }
            x(W),
              (p += M.y) < 0 && ((h = N), (l -= p = -p)),
              s && ((d = p * s), (c += (o.width - d) / 2));
            break;
          case H:
            if (s) {
              if (M.y <= 0 && (l <= f || v <= u)) {
                b = !1;
                break;
              }
              x(N), (p -= M.y), (l += M.y), (d = p * s);
            } else
              x(N),
                x(T),
                0 <= M.x
                  ? u < v
                    ? (d += M.x)
                    : M.y <= 0 && l <= f && (b = !1)
                  : (d += M.x),
                M.y <= 0
                  ? f < l && ((p -= M.y), (l += M.y))
                  : ((p -= M.y), (l += M.y));
            d < 0 && p < 0
              ? ((h = Y), (l -= p = -p), (c -= d = -d))
              : d < 0
              ? ((h = L), (c -= d = -d))
              : p < 0 && ((h = z), (l -= p = -p));
            break;
          case L:
            if (s) {
              if (M.y <= 0 && (l <= f || c <= g)) {
                b = !1;
                break;
              }
              x(N), (p -= M.y), (l += M.y), (d = p * s), (c += o.width - d);
            } else
              x(N),
                x(E),
                M.x <= 0
                  ? g < c
                    ? ((d -= M.x), (c += M.x))
                    : M.y <= 0 && l <= f && (b = !1)
                  : ((d -= M.x), (c += M.x)),
                M.y <= 0
                  ? f < l && ((p -= M.y), (l += M.y))
                  : ((p -= M.y), (l += M.y));
            d < 0 && p < 0
              ? ((h = z), (l -= p = -p), (c -= d = -d))
              : d < 0
              ? ((h = H), (c -= d = -d))
              : p < 0 && ((h = Y), (l -= p = -p));
            break;
          case Y:
            if (s) {
              if (M.x <= 0 && (c <= g || w <= m)) {
                b = !1;
                break;
              }
              x(E), (d -= M.x), (c += M.x), (p = d / s);
            } else
              x(W),
                x(E),
                M.x <= 0
                  ? g < c
                    ? ((d -= M.x), (c += M.x))
                    : 0 <= M.y && w <= m && (b = !1)
                  : ((d -= M.x), (c += M.x)),
                0 <= M.y ? m < w && (p += M.y) : (p += M.y);
            d < 0 && p < 0
              ? ((h = H), (l -= p = -p), (c -= d = -d))
              : d < 0
              ? ((h = z), (c -= d = -d))
              : p < 0 && ((h = L), (l -= p = -p));
            break;
          case z:
            if (s) {
              if (0 <= M.x && (v <= u || w <= m)) {
                b = !1;
                break;
              }
              x(T), (p = (d += M.x) / s);
            } else
              x(W),
                x(T),
                0 <= M.x
                  ? u < v
                    ? (d += M.x)
                    : 0 <= M.y && w <= m && (b = !1)
                  : (d += M.x),
                0 <= M.y ? m < w && (p += M.y) : (p += M.y);
            d < 0 && p < 0
              ? ((h = L), (l -= p = -p), (c -= d = -d))
              : d < 0
              ? ((h = Y), (c -= d = -d))
              : p < 0 && ((h = H), (l -= p = -p));
            break;
          case k:
            this.move(M.x, M.y), (b = !1);
            break;
          case O:
            this.zoom(
              (function (t) {
                var e = C({}, t),
                  s = [];
                return (
                  rt(t, function (h, t) {
                    delete e[t],
                      rt(e, function (t) {
                        var e = Math.abs(h.startX - t.startX),
                          i = Math.abs(h.startY - t.startY),
                          a = Math.abs(h.endX - t.endX),
                          n = Math.abs(h.endY - t.endY),
                          o = Math.sqrt(e * e + i * i),
                          r = (Math.sqrt(a * a + n * n) - o) / o;
                        s.push(r);
                      });
                  }),
                  s.sort(function (t, e) {
                    return Math.abs(t) < Math.abs(e);
                  }),
                  s[0]
                );
              })(r),
              t
            ),
              (b = !1);
            break;
          case B:
            if (!M.x || !M.y) {
              b = !1;
              break;
            }
            (e = Dt(this.cropper)),
              (c = y.startX - e.left),
              (l = y.startY - e.top),
              (d = o.minWidth),
              (p = o.minHeight),
              0 < M.x
                ? (h = 0 < M.y ? z : H)
                : M.x < 0 && ((c -= d), (h = 0 < M.y ? Y : L)),
              M.y < 0 && (l -= p),
              this.cropped ||
                (ut(this.cropBox, X),
                (this.cropped = !0),
                this.limited && this.limitCropBox(!0, !0));
        }
        b &&
          ((o.width = d),
          (o.height = p),
          (o.left = c),
          (o.top = l),
          (this.action = h),
          this.renderCropBox()),
          rt(r, function (t) {
            (t.startX = t.endX), (t.startY = t.endY);
          });
      },
    },
    jt = {
      crop: function () {
        return (
          !this.ready ||
            this.cropped ||
            this.disabled ||
            ((this.cropped = !0),
            this.limitCropBox(!0, !0),
            this.options.modal && pt(this.dragBox, c),
            ut(this.cropBox, X),
            this.setCropBoxData(this.initialCropBoxData)),
          this
        );
      },
      reset: function () {
        return (
          this.ready &&
            !this.disabled &&
            ((this.imageData = ht({}, this.initialImageData)),
            (this.canvasData = ht({}, this.initialCanvasData)),
            (this.cropBoxData = ht({}, this.initialCropBoxData)),
            this.renderCanvas(),
            this.cropped && this.renderCropBox()),
          this
        );
      },
      clear: function () {
        return (
          this.cropped &&
            !this.disabled &&
            (ht(this.cropBoxData, { left: 0, top: 0, width: 0, height: 0 }),
            (this.cropped = !1),
            this.renderCropBox(),
            this.limitCanvas(!0, !0),
            this.renderCanvas(),
            ut(this.dragBox, c),
            pt(this.cropBox, X)),
          this
        );
      },
      replace: function (e, t) {
        var i = 1 < arguments.length && void 0 !== t && t;
        return (
          !this.disabled &&
            e &&
            (this.isImg && (this.element.src = e),
            i
              ? ((this.url = e),
                (this.image.src = e),
                this.ready &&
                  ((this.viewBoxImage.src = e),
                  rt(this.previews, function (t) {
                    t.getElementsByTagName("img")[0].src = e;
                  })))
              : (this.isImg && (this.replaced = !0),
                (this.options.data = null),
                this.uncreate(),
                this.load(e))),
          this
        );
      },
      enable: function () {
        return (
          this.ready &&
            this.disabled &&
            ((this.disabled = !1), ut(this.cropper, s)),
          this
        );
      },
      disable: function () {
        return (
          this.ready &&
            !this.disabled &&
            ((this.disabled = !0), pt(this.cropper, s)),
          this
        );
      },
      destroy: function () {
        var t = this.element;
        return (
          t[l] &&
            ((t[l] = void 0),
            this.isImg && this.replaced && (t.src = this.originalUrl),
            this.uncreate()),
          this
        );
      },
      move: function (t, e) {
        var i = 1 < arguments.length && void 0 !== e ? e : t,
          a = this.canvasData,
          n = a.left,
          o = a.top;
        return this.moveTo(_(t) ? t : n + Number(t), _(i) ? i : o + Number(i));
      },
      moveTo: function (t, e) {
        var i = 1 < arguments.length && void 0 !== e ? e : t,
          a = this.canvasData,
          n = !1;
        return (
          (t = Number(t)),
          (i = Number(i)),
          this.ready &&
            !this.disabled &&
            this.options.movable &&
            (F(t) && ((a.left = t), (n = !0)),
            F(i) && ((a.top = i), (n = !0)),
            n && this.renderCanvas(!0)),
          this
        );
      },
      zoom: function (t, e) {
        var i = this.canvasData;
        return (
          (t = (t = Number(t)) < 0 ? 1 / (1 - t) : 1 + t),
          this.zoomTo((i.width * t) / i.naturalWidth, null, e)
        );
      },
      zoomTo: function (t, e, i) {
        var a = this.options,
          n = this.canvasData,
          o = n.width,
          r = n.height,
          h = n.naturalWidth,
          s = n.naturalHeight;
        if (
          0 <= (t = Number(t)) &&
          this.ready &&
          !this.disabled &&
          a.zoomable
        ) {
          var c = h * t,
            l = s * t;
          if (
            !1 ===
            Ct(this.element, U, { ratio: t, oldRatio: o / h, originalEvent: i })
          )
            return this;
          if (i) {
            var d = this.pointers,
              p = Dt(this.cropper),
              u =
                d && Object.keys(d).length
                  ? (function (t) {
                      var a = 0,
                        n = 0,
                        o = 0;
                      return (
                        rt(t, function (t) {
                          var e = t.startX,
                            i = t.startY;
                          (a += e), (n += i), (o += 1);
                        }),
                        { pageX: (a /= o), pageY: (n /= o) }
                      );
                    })(d)
                  : { pageX: i.pageX, pageY: i.pageY };
            (n.left -= (c - o) * ((u.pageX - p.left - n.left) / o)),
              (n.top -= (l - r) * ((u.pageY - p.top - n.top) / r));
          } else
            it(e) && F(e.x) && F(e.y)
              ? ((n.left -= (c - o) * ((e.x - n.left) / o)),
                (n.top -= (l - r) * ((e.y - n.top) / r)))
              : ((n.left -= (c - o) / 2), (n.top -= (l - r) / 2));
          (n.width = c), (n.height = l), this.renderCanvas(!0);
        }
        return this;
      },
      rotate: function (t) {
        return this.rotateTo((this.imageData.rotate || 0) + Number(t));
      },
      rotateTo: function (t) {
        return (
          F((t = Number(t))) &&
            this.ready &&
            !this.disabled &&
            this.options.rotatable &&
            ((this.imageData.rotate = t % 360), this.renderCanvas(!0, !0)),
          this
        );
      },
      scaleX: function (t) {
        var e = this.imageData.scaleY;
        return this.scale(t, F(e) ? e : 1);
      },
      scaleY: function (t) {
        var e = this.imageData.scaleX;
        return this.scale(F(e) ? e : 1, t);
      },
      scale: function (t, e) {
        var i = 1 < arguments.length && void 0 !== e ? e : t,
          a = this.imageData,
          n = !1;
        return (
          (t = Number(t)),
          (i = Number(i)),
          this.ready &&
            !this.disabled &&
            this.options.scalable &&
            (F(t) && ((a.scaleX = t), (n = !0)),
            F(i) && ((a.scaleY = i), (n = !0)),
            n && this.renderCanvas(!0, !0)),
          this
        );
      },
      getData: function (t) {
        var i,
          e = 0 < arguments.length && void 0 !== t && t,
          a = this.options,
          n = this.imageData,
          o = this.canvasData,
          r = this.cropBoxData;
        if (this.ready && this.cropped) {
          i = {
            x: r.left - o.left,
            y: r.top - o.top,
            width: r.width,
            height: r.height,
          };
          var h = n.width / n.naturalWidth;
          if (
            (rt(i, function (t, e) {
              i[e] = t / h;
            }),
            e)
          ) {
            var s = Math.round(i.y + i.height),
              c = Math.round(i.x + i.width);
            (i.x = Math.round(i.x)),
              (i.y = Math.round(i.y)),
              (i.width = c - i.x),
              (i.height = s - i.y);
          }
        } else i = { x: 0, y: 0, width: 0, height: 0 };
        return (
          a.rotatable && (i.rotate = n.rotate || 0),
          a.scalable &&
            ((i.scaleX = n.scaleX || 1), (i.scaleY = n.scaleY || 1)),
          i
        );
      },
      setData: function (t) {
        var e = this.options,
          i = this.imageData,
          a = this.canvasData,
          n = {};
        if (this.ready && !this.disabled && it(t)) {
          var o = !1;
          e.rotatable &&
            F(t.rotate) &&
            t.rotate !== i.rotate &&
            ((i.rotate = t.rotate), (o = !0)),
            e.scalable &&
              (F(t.scaleX) &&
                t.scaleX !== i.scaleX &&
                ((i.scaleX = t.scaleX), (o = !0)),
              F(t.scaleY) &&
                t.scaleY !== i.scaleY &&
                ((i.scaleY = t.scaleY), (o = !0))),
            o && this.renderCanvas(!0, !0);
          var r = i.width / i.naturalWidth;
          F(t.x) && (n.left = t.x * r + a.left),
            F(t.y) && (n.top = t.y * r + a.top),
            F(t.width) && (n.width = t.width * r),
            F(t.height) && (n.height = t.height * r),
            this.setCropBoxData(n);
        }
        return this;
      },
      getContainerData: function () {
        return this.ready ? ht({}, this.containerData) : {};
      },
      getImageData: function () {
        return this.sized ? ht({}, this.imageData) : {};
      },
      getCanvasData: function () {
        var e = this.canvasData,
          i = {};
        return (
          this.ready &&
            rt(
              [
                "left",
                "top",
                "width",
                "height",
                "naturalWidth",
                "naturalHeight",
              ],
              function (t) {
                i[t] = e[t];
              }
            ),
          i
        );
      },
      setCanvasData: function (t) {
        var e = this.canvasData,
          i = e.aspectRatio;
        return (
          this.ready &&
            !this.disabled &&
            it(t) &&
            (F(t.left) && (e.left = t.left),
            F(t.top) && (e.top = t.top),
            F(t.width)
              ? ((e.width = t.width), (e.height = t.width / i))
              : F(t.height) &&
                ((e.height = t.height), (e.width = t.height * i)),
            this.renderCanvas(!0)),
          this
        );
      },
      getCropBoxData: function () {
        var t,
          e = this.cropBoxData;
        return (
          this.ready &&
            this.cropped &&
            (t = {
              left: e.left,
              top: e.top,
              width: e.width,
              height: e.height,
            }),
          t || {}
        );
      },
      setCropBoxData: function (t) {
        var e,
          i,
          a = this.cropBoxData,
          n = this.options.aspectRatio;
        return (
          this.ready &&
            this.cropped &&
            !this.disabled &&
            it(t) &&
            (F(t.left) && (a.left = t.left),
            F(t.top) && (a.top = t.top),
            F(t.width) &&
              t.width !== a.width &&
              ((e = !0), (a.width = t.width)),
            F(t.height) &&
              t.height !== a.height &&
              ((i = !0), (a.height = t.height)),
            n && (e ? (a.height = a.width / n) : i && (a.width = a.height * n)),
            this.renderCropBox()),
          this
        );
      },
      getCroppedCanvas: function (t) {
        var e = 0 < arguments.length && void 0 !== t ? t : {};
        if (!this.ready || !window.HTMLCanvasElement) return null;
        var i = this.canvasData,
          a = (function (t, e, i, a) {
            var n = e.aspectRatio,
              o = e.naturalWidth,
              r = e.naturalHeight,
              h = e.rotate,
              s = void 0 === h ? 0 : h,
              c = e.scaleX,
              l = void 0 === c ? 1 : c,
              d = e.scaleY,
              p = void 0 === d ? 1 : d,
              u = i.aspectRatio,
              m = i.naturalWidth,
              g = i.naturalHeight,
              f = a.fillColor,
              v = void 0 === f ? "transparent" : f,
              w = a.imageSmoothingEnabled,
              b = void 0 === w || w,
              x = a.imageSmoothingQuality,
              y = void 0 === x ? "low" : x,
              M = a.maxWidth,
              C = void 0 === M ? 1 / 0 : M,
              D = a.maxHeight,
              B = void 0 === D ? 1 / 0 : D,
              k = a.minWidth,
              O = void 0 === k ? 0 : k,
              T = a.minHeight,
              E = void 0 === T ? 0 : T,
              W = document.createElement("canvas"),
              N = W.getContext("2d"),
              H = Nt({ aspectRatio: u, width: C, height: B }),
              L = Nt({ aspectRatio: u, width: O, height: E }, "cover"),
              z = Math.min(H.width, Math.max(L.width, m)),
              Y = Math.min(H.height, Math.max(L.height, g)),
              X = Nt({ aspectRatio: n, width: C, height: B }),
              R = Nt({ aspectRatio: n, width: O, height: E }, "cover"),
              S = Math.min(X.width, Math.max(R.width, o)),
              A = Math.min(X.height, Math.max(R.height, r)),
              j = [-S / 2, -A / 2, S, A];
            return (
              (W.width = ct(z)),
              (W.height = ct(Y)),
              (N.fillStyle = v),
              N.fillRect(0, 0, z, Y),
              N.save(),
              N.translate(z / 2, Y / 2),
              N.rotate((s * Math.PI) / 180),
              N.scale(l, p),
              (N.imageSmoothingEnabled = b),
              (N.imageSmoothingQuality = y),
              N.drawImage.apply(
                N,
                [t].concat(
                  P(
                    j.map(function (t) {
                      return Math.floor(ct(t));
                    })
                  )
                )
              ),
              N.restore(),
              W
            );
          })(this.image, this.imageData, i, e);
        if (!this.cropped) return a;
        var n = this.getData(),
          o = n.x,
          r = n.y,
          h = n.width,
          s = n.height,
          c = a.width / Math.floor(i.naturalWidth);
        1 != c && ((o *= c), (r *= c), (h *= c), (s *= c));
        var l = h / s,
          d = Nt({
            aspectRatio: l,
            width: e.maxWidth || 1 / 0,
            height: e.maxHeight || 1 / 0,
          }),
          p = Nt(
            {
              aspectRatio: l,
              width: e.minWidth || 0,
              height: e.minHeight || 0,
            },
            "cover"
          ),
          u = Nt({
            aspectRatio: l,
            width: e.width || (1 != c ? a.width : h),
            height: e.height || (1 != c ? a.height : s),
          }),
          m = u.width,
          g = u.height;
        (m = Math.min(d.width, Math.max(p.width, m))),
          (g = Math.min(d.height, Math.max(p.height, g)));
        var f = document.createElement("canvas"),
          v = f.getContext("2d");
        (f.width = ct(m)),
          (f.height = ct(g)),
          (v.fillStyle = e.fillColor || "transparent"),
          v.fillRect(0, 0, m, g);
        var w = e.imageSmoothingEnabled,
          b = void 0 === w || w,
          x = e.imageSmoothingQuality;
        (v.imageSmoothingEnabled = b), x && (v.imageSmoothingQuality = x);
        var y,
          M,
          C,
          D,
          B,
          k,
          O = a.width,
          T = a.height,
          E = o,
          W = r;
        E <= -h || O < E
          ? (B = C = y = E = 0)
          : E <= 0
          ? ((C = -E), (E = 0), (B = y = Math.min(O, h + E)))
          : E <= O && ((C = 0), (B = y = Math.min(h, O - E))),
          y <= 0 || W <= -s || T < W
            ? (k = D = M = W = 0)
            : W <= 0
            ? ((D = -W), (W = 0), (k = M = Math.min(T, s + W)))
            : W <= T && ((D = 0), (k = M = Math.min(s, T - W)));
        var N = [E, W, y, M];
        if (0 < B && 0 < k) {
          var H = m / h;
          N.push(C * H, D * H, B * H, k * H);
        }
        return (
          v.drawImage.apply(
            v,
            [a].concat(
              P(
                N.map(function (t) {
                  return Math.floor(ct(t));
                })
              )
            )
          ),
          f
        );
      },
      setAspectRatio: function (t) {
        var e = this.options;
        return (
          this.disabled ||
            _(t) ||
            ((e.aspectRatio = Math.max(0, t) || NaN),
            this.ready &&
              (this.initCropBox(), this.cropped && this.renderCropBox())),
          this
        );
      },
      setDragMode: function (t) {
        var e = this.options,
          i = this.dragBox,
          a = this.face;
        if (this.ready && !this.disabled) {
          var n = t === f,
            o = e.movable && t === v;
          (t = n || o ? t : w),
            (e.dragMode = t),
            wt(i, m, t),
            mt(i, h, n),
            mt(i, u, o),
            e.cropBoxMovable || (wt(a, m, t), mt(a, h, n), mt(a, u, o));
        }
        return this;
      },
    },
    Pt = r.Cropper,
    It = (function () {
      function i(t) {
        var e =
          1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
        if (
          ((function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, i),
          !t || !Z.test(t.tagName))
        )
          throw new Error(
            "The first argument is required and must be an <img> or <canvas> element."
          );
        (this.element = t),
          (this.options = ht({}, G, it(e) && e)),
          (this.cropped = !1),
          (this.disabled = !1),
          (this.pointers = {}),
          (this.ready = !1),
          (this.reloading = !1),
          (this.replaced = !1),
          (this.sized = !1),
          (this.sizing = !1),
          this.init();
      }
      return (
        (function (t, e, i) {
          e && a(t.prototype, e), i && a(t, i);
        })(
          i,
          [
            {
              key: "init",
              value: function () {
                var t,
                  e = this.element,
                  i = e.tagName.toLowerCase();
                if (!e[l]) {
                  if (((e[l] = this), "img" === i)) {
                    if (
                      ((this.isImg = !0),
                      (t = e.getAttribute("src") || ""),
                      !(this.originalUrl = t))
                    )
                      return;
                    t = e.src;
                  } else
                    "canvas" === i &&
                      window.HTMLCanvasElement &&
                      (t = e.toDataURL());
                  this.load(t);
                }
              },
            },
            {
              key: "load",
              value: function (t) {
                var e = this;
                if (t) {
                  (this.url = t), (this.imageData = {});
                  var i = this.element,
                    a = this.options;
                  if (
                    (a.rotatable || a.scalable || (a.checkOrientation = !1),
                    a.checkOrientation && window.ArrayBuffer)
                  )
                    if (Q.test(t))
                      K.test(t)
                        ? this.read(
                            (function (t) {
                              var e = t.replace(Lt, ""),
                                i = atob(e),
                                a = new ArrayBuffer(i.length),
                                n = new Uint8Array(a);
                              return (
                                rt(n, function (t, e) {
                                  n[e] = i.charCodeAt(e);
                                }),
                                a
                              );
                            })(t)
                          )
                        : this.clone();
                    else {
                      var n = new XMLHttpRequest(),
                        o = this.clone.bind(this);
                      (this.reloading = !0),
                        ((this.xhr = n).onabort = o),
                        (n.onerror = o),
                        (n.ontimeout = o),
                        (n.onprogress = function () {
                          n.getResponseHeader("content-type") !== q &&
                            n.abort();
                        }),
                        (n.onload = function () {
                          e.read(n.response);
                        }),
                        (n.onloadend = function () {
                          (e.reloading = !1), (e.xhr = null);
                        }),
                        a.checkCrossOrigin &&
                          Ot(t) &&
                          i.crossOrigin &&
                          (t = Tt(t)),
                        n.open("GET", t),
                        (n.responseType = "arraybuffer"),
                        (n.withCredentials =
                          "use-credentials" === i.crossOrigin),
                        n.send();
                    }
                  else this.clone();
                }
              },
            },
            {
              key: "read",
              value: function (t) {
                var e = this.options,
                  i = this.imageData,
                  a = zt(t),
                  n = 0,
                  o = 1,
                  r = 1;
                if (1 < a) {
                  this.url = (function (t, e) {
                    for (var i = [], a = new Uint8Array(t); 0 < a.length; )
                      i.push(Ht.apply(null, ot(a.subarray(0, 8192)))),
                        (a = a.subarray(8192));
                    return "data:"
                      .concat(e, ";base64,")
                      .concat(btoa(i.join("")));
                  })(t, q);
                  var h = (function (t) {
                    var e = 0,
                      i = 1,
                      a = 1;
                    switch (t) {
                      case 2:
                        i = -1;
                        break;
                      case 3:
                        e = -180;
                        break;
                      case 4:
                        a = -1;
                        break;
                      case 5:
                        (e = 90), (a = -1);
                        break;
                      case 6:
                        e = 90;
                        break;
                      case 7:
                        (e = 90), (i = -1);
                        break;
                      case 8:
                        e = -90;
                    }
                    return { rotate: e, scaleX: i, scaleY: a };
                  })(a);
                  (n = h.rotate), (o = h.scaleX), (r = h.scaleY);
                }
                e.rotatable && (i.rotate = n),
                  e.scalable && ((i.scaleX = o), (i.scaleY = r)),
                  this.clone();
              },
            },
            {
              key: "clone",
              value: function () {
                var t = this.element,
                  e = this.url,
                  i = t.crossOrigin,
                  a = e;
                this.options.checkCrossOrigin &&
                  Ot(e) &&
                  ((i = i || "anonymous"), (a = Tt(e))),
                  (this.crossOrigin = i),
                  (this.crossOriginUrl = a);
                var n = document.createElement("img");
                i && (n.crossOrigin = i),
                  (n.src = a || e),
                  (n.alt = t.alt || "The image to crop"),
                  ((this.image = n).onload = this.start.bind(this)),
                  (n.onerror = this.stop.bind(this)),
                  pt(n, d),
                  t.parentNode.insertBefore(n, t.nextSibling);
              },
            },
            {
              key: "start",
              value: function () {
                var i = this,
                  t = this.image;
                (t.onload = null), (t.onerror = null), (this.sizing = !0);
                function e(t, e) {
                  ht(i.imageData, {
                    naturalWidth: t,
                    naturalHeight: e,
                    aspectRatio: t / e,
                  }),
                    (i.sizing = !1),
                    (i.sized = !0),
                    i.build();
                }
                var a =
                  r.navigator &&
                  /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(
                    r.navigator.userAgent
                  );
                if (!t.naturalWidth || a) {
                  var n = document.createElement("img"),
                    o = document.body || document.documentElement;
                  ((this.sizingImage = n).onload = function () {
                    e(n.width, n.height), a || o.removeChild(n);
                  }),
                    (n.src = t.src),
                    a ||
                      ((n.style.cssText =
                        "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;"),
                      o.appendChild(n));
                } else e(t.naturalWidth, t.naturalHeight);
              },
            },
            {
              key: "stop",
              value: function () {
                var t = this.image;
                (t.onload = null),
                  (t.onerror = null),
                  t.parentNode.removeChild(t),
                  (this.image = null);
              },
            },
            {
              key: "build",
              value: function () {
                if (this.sized && !this.ready) {
                  var t = this.element,
                    e = this.options,
                    i = this.image,
                    a = t.parentNode,
                    n = document.createElement("div");
                  n.innerHTML =
                    '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>';
                  var o = n.querySelector(".".concat(l, "-container")),
                    r = o.querySelector(".".concat(l, "-canvas")),
                    h = o.querySelector(".".concat(l, "-drag-box")),
                    s = o.querySelector(".".concat(l, "-crop-box")),
                    c = s.querySelector(".".concat(l, "-face"));
                  (this.container = a),
                    (this.cropper = o),
                    (this.canvas = r),
                    (this.dragBox = h),
                    (this.cropBox = s),
                    (this.viewBox = o.querySelector(
                      ".".concat(l, "-view-box")
                    )),
                    (this.face = c),
                    r.appendChild(i),
                    pt(t, X),
                    a.insertBefore(o, t.nextSibling),
                    this.isImg || ut(i, d),
                    this.initPreview(),
                    this.bind(),
                    (e.initialAspectRatio =
                      Math.max(0, e.initialAspectRatio) || NaN),
                    (e.aspectRatio = Math.max(0, e.aspectRatio) || NaN),
                    (e.viewMode =
                      Math.max(0, Math.min(3, Math.round(e.viewMode))) || 0),
                    pt(s, X),
                    e.guides ||
                      pt(s.getElementsByClassName("".concat(l, "-dashed")), X),
                    e.center ||
                      pt(s.getElementsByClassName("".concat(l, "-center")), X),
                    e.background && pt(o, "".concat(l, "-bg")),
                    e.highlight || pt(c, p),
                    e.cropBoxMovable && (pt(c, u), wt(c, m, D)),
                    e.cropBoxResizable ||
                      (pt(s.getElementsByClassName("".concat(l, "-line")), X),
                      pt(s.getElementsByClassName("".concat(l, "-point")), X)),
                    this.render(),
                    (this.ready = !0),
                    this.setDragMode(e.dragMode),
                    e.autoCrop && this.crop(),
                    this.setData(e.data),
                    at(e.ready) && Mt(t, I, e.ready, { once: !0 }),
                    Ct(t, I);
                }
              },
            },
            {
              key: "unbuild",
              value: function () {
                this.ready &&
                  ((this.ready = !1),
                  this.unbind(),
                  this.resetPreview(),
                  this.cropper.parentNode.removeChild(this.cropper),
                  ut(this.element, X));
              },
            },
            {
              key: "uncreate",
              value: function () {
                this.ready
                  ? (this.unbuild(), (this.ready = !1), (this.cropped = !1))
                  : this.sizing
                  ? ((this.sizingImage.onload = null),
                    (this.sizing = !1),
                    (this.sized = !1))
                  : this.reloading
                  ? ((this.xhr.onabort = null), this.xhr.abort())
                  : this.image && this.stop();
              },
            },
          ],
          [
            {
              key: "noConflict",
              value: function () {
                return (window.Cropper = Pt), i;
              },
            },
            {
              key: "setDefaults",
              value: function (t) {
                ht(G, it(t) && t);
              },
            },
          ]
        ),
        i
      );
    })();
  return ht(It.prototype, Yt, Xt, Rt, St, At, jt), It;
});
/**
 * Modules in this bundle
 * @license
 *
 * modal-video:
 *   license: appleple
 *   author: appleple
 *   homepage: http://developer.a-blogcms.jp
 *   version: 2.4.1
 *
 * custom-event-polyfill:
 *   license: MIT (http://opensource.org/licenses/MIT)
 *   maintainers: krambuhl <evan.krambuhl@gmail.com>
 *   contributors: Frank Panetta, Mikhail Reenko <reenko@yandex.ru>, Joscha Feth <joscha@feth.com>
 *   homepage: https://github.com/krambuhl/custom-event-polyfill#readme
 *   version: 0.3.0
 *
 * es6-object-assign:
 *   license: MIT (http://opensource.org/licenses/MIT)
 *   author: Rubén Norte <rubennorte@gmail.com>
 *   homepage: https://github.com/rubennorte/es6-object-assign
 *   version: 1.1.0
 *
 * This header is generated by licensify (https://github.com/twada/licensify)
 */
!(function e(t, n, o) {
  function i(a, l) {
    if (!n[a]) {
      if (!t[a]) {
        var u = "function" == typeof require && require;
        if (!l && u) return u(a, !0);
        if (r) return r(a, !0);
        var d = new Error("Cannot find module '" + a + "'");
        throw ((d.code = "MODULE_NOT_FOUND"), d);
      }
      var s = (n[a] = { exports: {} });
      t[a][0].call(
        s.exports,
        function (e) {
          var n = t[a][1][e];
          return i(n || e);
        },
        s,
        s.exports,
        e,
        t,
        n,
        o
      );
    }
    return n[a].exports;
  }
  for (
    var r = "function" == typeof require && require, a = 0;
    a < o.length;
    a++
  )
    i(o[a]);
  return i;
})(
  {
    1: [
      function (e, t, n) {
        try {
          var o = new window.CustomEvent("test");
          if ((o.preventDefault(), !0 !== o.defaultPrevented))
            throw new Error("Could not prevent default");
        } catch (e) {
          var i = function (e, t) {
            var n, o;
            return (
              (t = t || { bubbles: !1, cancelable: !1, detail: void 0 }),
              (n = document.createEvent("CustomEvent")),
              n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail),
              (o = n.preventDefault),
              (n.preventDefault = function () {
                o.call(this);
                try {
                  Object.defineProperty(this, "defaultPrevented", {
                    get: function () {
                      return !0;
                    },
                  });
                } catch (e) {
                  this.defaultPrevented = !0;
                }
              }),
              n
            );
          };
          (i.prototype = window.Event.prototype), (window.CustomEvent = i);
        }
      },
      {},
    ],
    2: [
      function (e, t, n) {
        "use strict";
        function o(e, t) {
          if (void 0 === e || null === e)
            throw new TypeError("Cannot convert first argument to object");
          for (var n = Object(e), o = 1; o < arguments.length; o++) {
            var i = arguments[o];
            if (void 0 !== i && null !== i)
              for (
                var r = Object.keys(Object(i)), a = 0, l = r.length;
                a < l;
                a++
              ) {
                var u = r[a],
                  d = Object.getOwnPropertyDescriptor(i, u);
                void 0 !== d && d.enumerable && (n[u] = i[u]);
              }
          }
          return n;
        }
        function i() {
          Object.assign ||
            Object.defineProperty(Object, "assign", {
              enumerable: !1,
              configurable: !0,
              writable: !0,
              value: o,
            });
        }
        t.exports = { assign: o, polyfill: i };
      },
      {},
    ],
    3: [
      function (e, t, n) {
        "use strict";
        var o = e("../index"),
          i = function (e) {
            e.fn.modalVideo = function (e) {
              return "strings" == typeof e || new o(this, e), this;
            };
          };
        if ("function" == typeof define && define.amd) define(["jquery"], i);
        else {
          var r = window.jQuery ? window.jQuery : window.$;
          void 0 !== r && i(r);
        }
        t.exports = i;
      },
      { "../index": 5 },
    ],
    4: [
      function (e, t, n) {
        "use strict";
        function o(e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        }
        Object.defineProperty(n, "__esModule", { value: !0 });
        var i = (function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n];
              (o.enumerable = o.enumerable || !1),
                (o.configurable = !0),
                "value" in o && (o.writable = !0),
                Object.defineProperty(e, o.key, o);
            }
          }
          return function (t, n, o) {
            return n && e(t.prototype, n), o && e(t, o), t;
          };
        })();
        e("custom-event-polyfill");
        var r = e("../lib/util"),
          a = e("es6-object-assign").assign,
          l = {
            channel: "youtube",
            facebook: {},
            youtube: {
              autoplay: 1,
              cc_load_policy: 1,
              color: null,
              controls: 1,
              disablekb: 0,
              enablejsapi: 0,
              end: null,
              fs: 1,
              h1: null,
              iv_load_policy: 1,
              list: null,
              listType: null,
              loop: 0,
              modestbranding: null,
              origin: null,
              playlist: null,
              playsinline: null,
              rel: 0,
              showinfo: 1,
              start: 0,
              wmode: "transparent",
              theme: "dark",
              nocookie: !1,
            },
            ratio: "16:9",
            vimeo: {
              api: !1,
              autopause: !0,
              autoplay: !0,
              byline: !0,
              callback: null,
              color: null,
              height: null,
              loop: !1,
              maxheight: null,
              maxwidth: null,
              player_id: null,
              portrait: !0,
              title: !0,
              width: null,
              xhtml: !1,
            },
            allowFullScreen: !0,
            animationSpeed: 300,
            classNames: {
              modalVideo: "modal-video",
              modalVideoClose: "modal-video-close",
              modalVideoBody: "modal-video-body",
              modalVideoInner: "modal-video-inner",
              modalVideoIframeWrap: "modal-video-movie-wrap",
              modalVideoCloseBtn: "modal-video-close-btn",
            },
            aria: {
              openMessage: "You just openned the modal video",
              dismissBtnMessage: "Close the modal by clicking here",
            },
          },
          u = (function () {
            function e(t, n) {
              var i = this;
              o(this, e);
              var u = a({}, l, n),
                d = "string" == typeof t ? document.querySelectorAll(t) : t,
                s = document.querySelector("body"),
                c = u.classNames,
                f = u.animationSpeed;
              [].forEach.call(d, function (e) {
                e.addEventListener("click", function (t) {
                  "A" === e.tagName && t.preventDefault();
                  var n = e.dataset.videoId,
                    o = e.dataset.channel || u.channel,
                    a = (0, r.getUniqId)(),
                    l = e.dataset.videoUrl || i.getVideoUrl(u, o, n),
                    d = i.getHtml(u, l, a);
                  (0, r.append)(s, d);
                  var v = document.getElementById(a),
                    m = v.querySelector(".js-modal-video-dismiss-btn");
                  v.focus(),
                    v.addEventListener("click", function () {
                      (0, r.addClass)(v, c.modalVideoClose),
                        setTimeout(function () {
                          (0, r.remove)(v), e.focus();
                        }, f);
                    }),
                    v.addEventListener("keydown", function (e) {
                      9 === e.which &&
                        (e.preventDefault(),
                        document.activeElement === v
                          ? m.focus()
                          : (v.setAttribute("aria-label", ""), v.focus()));
                    }),
                    m.addEventListener("click", function () {
                      (0, r.triggerEvent)(v, "click");
                    });
                });
              });
            }
            return (
              i(e, [
                {
                  key: "getPadding",
                  value: function (e) {
                    var t = e.split(":"),
                      n = Number(t[0]);
                    return (100 * Number(t[1])) / n + "%";
                  },
                },
                {
                  key: "getQueryString",
                  value: function (e) {
                    var t = "";
                    return (
                      Object.keys(e).forEach(function (n) {
                        t += n + "=" + e[n] + "&";
                      }),
                      t.substr(0, t.length - 1)
                    );
                  },
                },
                {
                  key: "getVideoUrl",
                  value: function (e, t, n) {
                    return "youtube" === t
                      ? this.getYoutubeUrl(e.youtube, n)
                      : "vimeo" === t
                      ? this.getVimeoUrl(e.vimeo, n)
                      : "facebook" === t
                      ? this.getFacebookUrl(e.facebook, n)
                      : "";
                  },
                },
                {
                  key: "getVimeoUrl",
                  value: function (e, t) {
                    return (
                      "//player.vimeo.com/video/" +
                      t +
                      "?" +
                      this.getQueryString(e)
                    );
                  },
                },
                {
                  key: "getYoutubeUrl",
                  value: function (e, t) {
                    var n = this.getQueryString(e);
                    return !0 === e.nocookie
                      ? "//www.youtube-nocookie.com/embed/" + t + "?" + n
                      : "//www.youtube.com/embed/" + t + "?" + n;
                  },
                },
                {
                  key: "getFacebookUrl",
                  value: function (e, t) {
                    return (
                      "//www.facebook.com/v2.10/plugins/video.php?href=https://www.facebook.com/facebook/videos/" +
                      t +
                      "&" +
                      this.getQueryString(e)
                    );
                  },
                },
                {
                  key: "getHtml",
                  value: function (e, t, n) {
                    var o = this.getPadding(e.ratio),
                      i = e.classNames;
                    return (
                      '\n      <div class="' +
                      i.modalVideo +
                      '" tabindex="-1" role="dialog" aria-label="' +
                      e.aria.openMessage +
                      '" id="' +
                      n +
                      '">\n        <div class="' +
                      i.modalVideoBody +
                      '">\n          <div class="' +
                      i.modalVideoInner +
                      '">\n            <div class="' +
                      i.modalVideoIframeWrap +
                      '" style="padding-bottom:' +
                      o +
                      '">\n              <button class="' +
                      i.modalVideoCloseBtn +
                      ' js-modal-video-dismiss-btn" aria-label="' +
                      e.aria.dismissBtnMessage +
                      "\"></button>\n              <iframe width='460' height='230' src=\"" +
                      t +
                      "\" frameborder='0' allowfullscreen=" +
                      e.allowFullScreen +
                      ' tabindex="-1"/>\n            </div>\n          </div>\n        </div>\n      </div>\n    '
                    );
                  },
                },
              ]),
              e
            );
          })();
        (n.default = u), (t.exports = n.default);
      },
      { "../lib/util": 6, "custom-event-polyfill": 1, "es6-object-assign": 2 },
    ],
    5: [
      function (e, t, n) {
        "use strict";
        t.exports = e("./core/");
      },
      { "./core/": 4 },
    ],
    6: [
      function (e, t, n) {
        "use strict";
        Object.defineProperty(n, "__esModule", { value: !0 });
        (n.append = function (e, t) {
          var n = document.createElement("div");
          for (n.innerHTML = t; n.children.length > 0; )
            e.appendChild(n.children[0]);
        }),
          (n.getUniqId = function () {
            return (
              Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
            ).toUpperCase();
          }),
          (n.remove = function (e) {
            e && e.parentNode && e.parentNode.removeChild(e);
          }),
          (n.addClass = function (e, t) {
            e.classList ? e.classList.add(t) : (e.className += " " + t);
          }),
          (n.triggerEvent = function (e, t, n) {
            var o = void 0;
            window.CustomEvent
              ? (o = new CustomEvent(t, { cancelable: !0 }))
              : ((o = document.createEvent("CustomEvent")),
                o.initCustomEvent(t, !1, !1, n)),
              e.dispatchEvent(o);
          });
      },
      {},
    ],
  },
  {},
  [3]
);
"object" == typeof navigator &&
  (function (e, t) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define("Plyr", t)
      : ((e = e || self).Plyr = t());
  })(this, function () {
    "use strict";
    function e(e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
    }
    function t(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(e, i.key, i);
      }
    }
    function n(e, n, i) {
      return n && t(e.prototype, n), i && t(e, i), e;
    }
    function i(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    function a(e, t) {
      return (
        (function (e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function (e, t) {
          var n = [],
            i = !0,
            a = !1,
            s = void 0;
          try {
            for (
              var r, o = e[Symbol.iterator]();
              !(i = (r = o.next()).done) &&
              (n.push(r.value), !t || n.length !== t);
              i = !0
            );
          } catch (e) {
            (a = !0), (s = e);
          } finally {
            try {
              i || null == o.return || o.return();
            } finally {
              if (a) throw s;
            }
          }
          return n;
        })(e, t) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance"
          );
        })()
      );
    }
    function s(e) {
      return (
        (function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = new Array(e.length); t < e.length; t++)
              n[t] = e[t];
            return n;
          }
        })(e) ||
        (function (e) {
          if (
            Symbol.iterator in Object(e) ||
            "[object Arguments]" === Object.prototype.toString.call(e)
          )
            return Array.from(e);
        })(e) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to spread non-iterable instance"
          );
        })()
      );
    }
    var r = { addCSS: !0, thumbWidth: 15, watch: !0 };
    var o = function (e) {
        return null != e ? e.constructor : null;
      },
      l = function (e, t) {
        return Boolean(e && t && e instanceof t);
      },
      c = function (e) {
        return null == e;
      },
      u = function (e) {
        return o(e) === Object;
      },
      d = function (e) {
        return o(e) === String;
      },
      h = function (e) {
        return Array.isArray(e);
      },
      m = function (e) {
        return l(e, NodeList);
      },
      p = {
        nullOrUndefined: c,
        object: u,
        number: function (e) {
          return o(e) === Number && !Number.isNaN(e);
        },
        string: d,
        boolean: function (e) {
          return o(e) === Boolean;
        },
        function: function (e) {
          return o(e) === Function;
        },
        array: h,
        nodeList: m,
        element: function (e) {
          return l(e, Element);
        },
        event: function (e) {
          return l(e, Event);
        },
        empty: function (e) {
          return (
            c(e) ||
            ((d(e) || h(e) || m(e)) && !e.length) ||
            (u(e) && !Object.keys(e).length)
          );
        },
      };
    function f(e, t) {
      if (t < 1) {
        var n = (i = "".concat(t).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/))
          ? Math.max(0, (i[1] ? i[1].length : 0) - (i[2] ? +i[2] : 0))
          : 0;
        return parseFloat(e.toFixed(n));
      }
      var i;
      return Math.round(e / t) * t;
    }
    var g,
      y,
      v,
      b = (function () {
        function t(n, i) {
          e(this, t),
            p.element(n)
              ? (this.element = n)
              : p.string(n) && (this.element = document.querySelector(n)),
            p.element(this.element) &&
              p.empty(this.element.rangeTouch) &&
              ((this.config = Object.assign({}, r, i)), this.init());
        }
        return (
          n(
            t,
            [
              {
                key: "init",
                value: function () {
                  t.enabled &&
                    (this.config.addCSS &&
                      ((this.element.style.userSelect = "none"),
                      (this.element.style.webKitUserSelect = "none"),
                      (this.element.style.touchAction = "manipulation")),
                    this.listeners(!0),
                    (this.element.rangeTouch = this));
                },
              },
              {
                key: "destroy",
                value: function () {
                  t.enabled &&
                    (this.listeners(!1), (this.element.rangeTouch = null));
                },
              },
              {
                key: "listeners",
                value: function (e) {
                  var t = this,
                    n = e ? "addEventListener" : "removeEventListener";
                  ["touchstart", "touchmove", "touchend"].forEach(function (e) {
                    t.element[n](
                      e,
                      function (e) {
                        return t.set(e);
                      },
                      !1
                    );
                  });
                },
              },
              {
                key: "get",
                value: function (e) {
                  if (!t.enabled || !p.event(e)) return null;
                  var n,
                    i = e.target,
                    a = e.changedTouches[0],
                    s = parseFloat(i.getAttribute("min")) || 0,
                    r = parseFloat(i.getAttribute("max")) || 100,
                    o = parseFloat(i.getAttribute("step")) || 1,
                    l = r - s,
                    c = i.getBoundingClientRect(),
                    u = ((100 / c.width) * (this.config.thumbWidth / 2)) / 100;
                  return (
                    (n = (100 / c.width) * (a.clientX - c.left)) < 0
                      ? (n = 0)
                      : n > 100 && (n = 100),
                    n < 50
                      ? (n -= (100 - 2 * n) * u)
                      : n > 50 && (n += 2 * (n - 50) * u),
                    s + f(l * (n / 100), o)
                  );
                },
              },
              {
                key: "set",
                value: function (e) {
                  t.enabled &&
                    p.event(e) &&
                    !e.target.disabled &&
                    (e.preventDefault(),
                    (e.target.value = this.get(e)),
                    (function (e, t) {
                      if (e && t) {
                        var n = new Event(t);
                        e.dispatchEvent(n);
                      }
                    })(e.target, "touchend" === e.type ? "change" : "input"));
                },
              },
            ],
            [
              {
                key: "setup",
                value: function (e) {
                  var n =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    i = null;
                  if (
                    (p.empty(e) || p.string(e)
                      ? (i = Array.from(
                          document.querySelectorAll(
                            p.string(e) ? e : 'input[type="range"]'
                          )
                        ))
                      : p.element(e)
                      ? (i = [e])
                      : p.nodeList(e)
                      ? (i = Array.from(e))
                      : p.array(e) && (i = e.filter(p.element)),
                    p.empty(i))
                  )
                    return null;
                  var a = Object.assign({}, r, n);
                  p.string(e) &&
                    a.watch &&
                    new MutationObserver(function (n) {
                      Array.from(n).forEach(function (n) {
                        Array.from(n.addedNodes).forEach(function (n) {
                          if (
                            p.element(n) &&
                            function () {
                              return Array.from(
                                document.querySelectorAll(i)
                              ).includes(this);
                            }.call(n, (i = e))
                          ) {
                            var i;
                            new t(n, a);
                          }
                        });
                      });
                    }).observe(document.body, { childList: !0, subtree: !0 });
                  return i.map(function (e) {
                    return new t(e, n);
                  });
                },
              },
              {
                key: "enabled",
                get: function () {
                  return "ontouchstart" in document.documentElement;
                },
              },
            ]
          ),
          t
        );
      })(),
      k = function (e) {
        return null != e ? e.constructor : null;
      },
      w = function (e, t) {
        return Boolean(e && t && e instanceof t);
      },
      T = function (e) {
        return null == e;
      },
      C = function (e) {
        return k(e) === Object;
      },
      A = function (e) {
        return k(e) === String;
      },
      E = function (e) {
        return Array.isArray(e);
      },
      S = function (e) {
        return w(e, NodeList);
      },
      P = function (e) {
        return (
          T(e) ||
          ((A(e) || E(e) || S(e)) && !e.length) ||
          (C(e) && !Object.keys(e).length)
        );
      },
      N = {
        nullOrUndefined: T,
        object: C,
        number: function (e) {
          return k(e) === Number && !Number.isNaN(e);
        },
        string: A,
        boolean: function (e) {
          return k(e) === Boolean;
        },
        function: function (e) {
          return k(e) === Function;
        },
        array: E,
        weakMap: function (e) {
          return w(e, WeakMap);
        },
        nodeList: S,
        element: function (e) {
          return w(e, Element);
        },
        textNode: function (e) {
          return k(e) === Text;
        },
        event: function (e) {
          return w(e, Event);
        },
        keyboardEvent: function (e) {
          return w(e, KeyboardEvent);
        },
        cue: function (e) {
          return w(e, window.TextTrackCue) || w(e, window.VTTCue);
        },
        track: function (e) {
          return w(e, TextTrack) || (!T(e) && A(e.kind));
        },
        promise: function (e) {
          return w(e, Promise);
        },
        url: function (e) {
          if (w(e, window.URL)) return !0;
          if (!A(e)) return !1;
          var t = e;
          (e.startsWith("http://") && e.startsWith("https://")) ||
            (t = "http://".concat(e));
          try {
            return !P(new URL(t).hostname);
          } catch (e) {
            return !1;
          }
        },
        empty: P,
      },
      M =
        ((g = document.createElement("span")),
        (y = {
          WebkitTransition: "webkitTransitionEnd",
          MozTransition: "transitionend",
          OTransition: "oTransitionEnd otransitionend",
          transition: "transitionend",
        }),
        (v = Object.keys(y).find(function (e) {
          return void 0 !== g.style[e];
        })),
        !!N.string(v) && y[v]);
    function x(e, t) {
      setTimeout(function () {
        try {
          (e.hidden = !0), e.offsetHeight, (e.hidden = !1);
        } catch (e) {}
      }, t);
    }
    var L = {
        isIE: !!document.documentMode,
        isEdge: window.navigator.userAgent.includes("Edge"),
        isWebkit:
          "WebkitAppearance" in document.documentElement.style &&
          !/Edge/.test(navigator.userAgent),
        isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
        isIos: /(iPad|iPhone|iPod)/gi.test(navigator.platform),
      },
      I = (function () {
        var e = !1;
        try {
          var t = Object.defineProperty({}, "passive", {
            get: function () {
              return (e = !0), null;
            },
          });
          window.addEventListener("test", null, t),
            window.removeEventListener("test", null, t);
        } catch (e) {}
        return e;
      })();
    function _(e, t, n) {
      var i = this,
        a = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
        s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
        r = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
      if (e && "addEventListener" in e && !N.empty(t) && N.function(n)) {
        var o = t.split(" "),
          l = r;
        I && (l = { passive: s, capture: r }),
          o.forEach(function (t) {
            i &&
              i.eventListeners &&
              a &&
              i.eventListeners.push({
                element: e,
                type: t,
                callback: n,
                options: l,
              }),
              e[a ? "addEventListener" : "removeEventListener"](t, n, l);
          });
      }
    }
    function O(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        n = arguments.length > 2 ? arguments[2] : void 0,
        i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
        a = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
      _.call(this, e, t, n, !0, i, a);
    }
    function j(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        n = arguments.length > 2 ? arguments[2] : void 0,
        i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
        a = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
      _.call(this, e, t, n, !1, i, a);
    }
    function q(e) {
      var t = this,
        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        i = arguments.length > 2 ? arguments[2] : void 0,
        a = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
        s = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
      _.call(
        this,
        e,
        n,
        function r() {
          j(e, n, r, a, s);
          for (var o = arguments.length, l = new Array(o), c = 0; c < o; c++)
            l[c] = arguments[c];
          i.apply(t, l);
        },
        !0,
        a,
        s
      );
    }
    function H(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      if (N.element(e) && !N.empty(t)) {
        var a = new CustomEvent(t, {
          bubbles: n,
          detail: Object.assign({}, i, { plyr: this }),
        });
        e.dispatchEvent(a);
      }
    }
    function D(e, t) {
      return t.split(".").reduce(function (e, t) {
        return e && e[t];
      }, e);
    }
    function F() {
      for (
        var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length,
          n = new Array(t > 1 ? t - 1 : 0),
          a = 1;
        a < t;
        a++
      )
        n[a - 1] = arguments[a];
      if (!n.length) return e;
      var s = n.shift();
      return N.object(s)
        ? (Object.keys(s).forEach(function (t) {
            N.object(s[t])
              ? (Object.keys(e).includes(t) || Object.assign(e, i({}, t, {})),
                F(e[t], s[t]))
              : Object.assign(e, i({}, t, s[t]));
          }),
          F.apply(void 0, [e].concat(n)))
        : e;
    }
    function R(e, t) {
      var n = e.length ? e : [e];
      Array.from(n)
        .reverse()
        .forEach(function (e, n) {
          var i = n > 0 ? t.cloneNode(!0) : t,
            a = e.parentNode,
            s = e.nextSibling;
          i.appendChild(e), s ? a.insertBefore(i, s) : a.appendChild(i);
        });
    }
    function V(e, t) {
      N.element(e) &&
        !N.empty(t) &&
        Object.entries(t)
          .filter(function (e) {
            var t = a(e, 2)[1];
            return !N.nullOrUndefined(t);
          })
          .forEach(function (t) {
            var n = a(t, 2),
              i = n[0],
              s = n[1];
            return e.setAttribute(i, s);
          });
    }
    function B(e, t, n) {
      var i = document.createElement(e);
      return N.object(t) && V(i, t), N.string(n) && (i.innerText = n), i;
    }
    function U(e, t, n, i) {
      N.element(t) && t.appendChild(B(e, n, i));
    }
    function W(e) {
      N.nodeList(e) || N.array(e)
        ? Array.from(e).forEach(W)
        : N.element(e) &&
          N.element(e.parentNode) &&
          e.parentNode.removeChild(e);
    }
    function z(e) {
      if (N.element(e))
        for (var t = e.childNodes.length; t > 0; )
          e.removeChild(e.lastChild), (t -= 1);
    }
    function K(e, t) {
      return N.element(t) && N.element(t.parentNode) && N.element(e)
        ? (t.parentNode.replaceChild(e, t), e)
        : null;
    }
    function Y(e, t) {
      if (!N.string(e) || N.empty(e)) return {};
      var n = {},
        i = F({}, t);
      return (
        e.split(",").forEach(function (e) {
          var t = e.trim(),
            s = t.replace(".", ""),
            r = t.replace(/[[\]]/g, "").split("="),
            o = a(r, 1)[0],
            l = r.length > 1 ? r[1].replace(/["']/g, "") : "";
          switch (t.charAt(0)) {
            case ".":
              N.string(i.class)
                ? (n.class = "".concat(i.class, " ").concat(s))
                : (n.class = s);
              break;
            case "#":
              n.id = t.replace("#", "");
              break;
            case "[":
              n[o] = l;
          }
        }),
        F(i, n)
      );
    }
    function Q(e, t) {
      if (N.element(e)) {
        var n = t;
        N.boolean(n) || (n = !e.hidden), (e.hidden = n);
      }
    }
    function X(e, t, n) {
      if (N.nodeList(e))
        return Array.from(e).map(function (e) {
          return X(e, t, n);
        });
      if (N.element(e)) {
        var i = "toggle";
        return (
          void 0 !== n && (i = n ? "add" : "remove"),
          e.classList[i](t),
          e.classList.contains(t)
        );
      }
      return !1;
    }
    function J(e, t) {
      return N.element(e) && e.classList.contains(t);
    }
    function $(e, t) {
      return function () {
        return Array.from(document.querySelectorAll(t)).includes(this);
      }.call(e, t);
    }
    function G(e) {
      return this.elements.container.querySelectorAll(e);
    }
    function Z(e) {
      return this.elements.container.querySelector(e);
    }
    function ee() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
        t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      N.element(e) &&
        (e.focus({ preventScroll: !0 }),
        t && X(e, this.config.classNames.tabFocus));
    }
    var te,
      ne = {
        "audio/ogg": "vorbis",
        "audio/wav": "1",
        "video/webm": "vp8, vorbis",
        "video/mp4": "avc1.42E01E, mp4a.40.2",
        "video/ogg": "theora",
      },
      ie = {
        audio: "canPlayType" in document.createElement("audio"),
        video: "canPlayType" in document.createElement("video"),
        check: function (e, t, n) {
          var i = L.isIPhone && n && ie.playsinline,
            a = ie[e] || "html5" !== t;
          return {
            api: a,
            ui: a && ie.rangeInput && ("video" !== e || !L.isIPhone || i),
          };
        },
        pip: !(
          L.isIPhone ||
          (!N.function(B("video").webkitSetPresentationMode) &&
            (!document.pictureInPictureEnabled ||
              B("video").disablePictureInPicture))
        ),
        airplay: N.function(window.WebKitPlaybackTargetAvailabilityEvent),
        playsinline: "playsInline" in document.createElement("video"),
        mime: function (e) {
          if (N.empty(e)) return !1;
          var t = a(e.split("/"), 1)[0],
            n = e;
          if (!this.isHTML5 || t !== this.type) return !1;
          Object.keys(ne).includes(n) && (n += '; codecs="'.concat(ne[e], '"'));
          try {
            return Boolean(n && this.media.canPlayType(n).replace(/no/, ""));
          } catch (e) {
            return !1;
          }
        },
        textTracks: "textTracks" in document.createElement("video"),
        rangeInput:
          ((te = document.createElement("input")),
          (te.type = "range"),
          "range" === te.type),
        touch: "ontouchstart" in document.documentElement,
        transitions: !1 !== M,
        reducedMotion:
          "matchMedia" in window &&
          window.matchMedia("(prefers-reduced-motion)").matches,
      };
    function ae(e) {
      return (
        !!(N.array(e) || (N.string(e) && e.includes(":"))) &&
        (N.array(e) ? e : e.split(":")).map(Number).every(N.number)
      );
    }
    function se(e) {
      if (!N.array(e) || !e.every(N.number)) return null;
      var t = a(e, 2),
        n = t[0],
        i = t[1],
        s = (function e(t, n) {
          return 0 === n ? t : e(n, t % n);
        })(n, i);
      return [n / s, i / s];
    }
    function re(e) {
      var t = function (e) {
          return ae(e) ? e.split(":").map(Number) : null;
        },
        n = t(e);
      if (
        (null === n && (n = t(this.config.ratio)),
        null === n &&
          !N.empty(this.embed) &&
          N.array(this.embed.ratio) &&
          (n = this.embed.ratio),
        null === n && this.isHTML5)
      ) {
        var i = this.media;
        n = se([i.videoWidth, i.videoHeight]);
      }
      return n;
    }
    function oe(e) {
      if (!this.isVideo) return {};
      var t = re.call(this, e),
        n = a(N.array(t) ? t : [0, 0], 2),
        i = (100 / n[0]) * n[1];
      if (
        ((this.elements.wrapper.style.paddingBottom = "".concat(i, "%")),
        this.isVimeo && this.supported.ui)
      ) {
        var s = (240 - i) / 4.8;
        this.media.style.transform = "translateY(-".concat(s, "%)");
      } else this.isHTML5 && this.elements.wrapper.classList.toggle(this.config.classNames.videoFixedRatio, null !== t);
      return { padding: i, ratio: t };
    }
    var le = {
      getSources: function () {
        var e = this;
        return this.isHTML5
          ? Array.from(this.media.querySelectorAll("source")).filter(function (
              t
            ) {
              var n = t.getAttribute("type");
              return !!N.empty(n) || ie.mime.call(e, n);
            })
          : [];
      },
      getQualityOptions: function () {
        return le.getSources
          .call(this)
          .map(function (e) {
            return Number(e.getAttribute("size"));
          })
          .filter(Boolean);
      },
      extend: function () {
        if (this.isHTML5) {
          var e = this;
          N.empty(this.config.ratio) || oe.call(e),
            Object.defineProperty(e.media, "quality", {
              get: function () {
                var t = le.getSources.call(e).find(function (t) {
                  return t.getAttribute("src") === e.source;
                });
                return t && Number(t.getAttribute("size"));
              },
              set: function (t) {
                var n = le.getSources.call(e).find(function (e) {
                  return Number(e.getAttribute("size")) === t;
                });
                if (n) {
                  var i = e.media,
                    a = i.currentTime,
                    s = i.paused,
                    r = i.preload,
                    o = i.readyState;
                  (e.media.src = n.getAttribute("src")),
                    ("none" !== r || o) &&
                      (e.once("loadedmetadata", function () {
                        (e.currentTime = a), s || e.play();
                      }),
                      e.media.load()),
                    H.call(e, e.media, "qualitychange", !1, { quality: t });
                }
              },
            });
        }
      },
      cancelRequests: function () {
        this.isHTML5 &&
          (W(le.getSources.call(this)),
          this.media.setAttribute("src", this.config.blankVideo),
          this.media.load(),
          this.debug.log("Cancelled network requests"));
      },
    };
    function ce(e) {
      return N.array(e)
        ? e.filter(function (t, n) {
            return e.indexOf(t) === n;
          })
        : e;
    }
    function ue(e) {
      for (
        var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1;
        i < t;
        i++
      )
        n[i - 1] = arguments[i];
      return N.empty(e)
        ? e
        : e.toString().replace(/{(\d+)}/g, function (e, t) {
            return n[t].toString();
          });
    }
    function de() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
      return e.replace(
        new RegExp(
          t.toString().replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1"),
          "g"
        ),
        n.toString()
      );
    }
    function he() {
      return (arguments.length > 0 && void 0 !== arguments[0]
        ? arguments[0]
        : ""
      )
        .toString()
        .replace(/\w\S*/g, function (e) {
          return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
        });
    }
    function me() {
      var e = (arguments.length > 0 && void 0 !== arguments[0]
        ? arguments[0]
        : ""
      ).toString();
      return (
        (e = (function () {
          var e = (arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : ""
          ).toString();
          return (
            (e = de(e, "-", " ")),
            (e = de(e, "_", " ")),
            de((e = he(e)), " ", "")
          );
        })(e))
          .charAt(0)
          .toLowerCase() + e.slice(1)
      );
    }
    function pe(e) {
      var t = document.createElement("div");
      return t.appendChild(e), t.innerHTML;
    }
    var fe = {
        pip: "PIP",
        airplay: "AirPlay",
        html5: "HTML5",
        vimeo: "Vimeo",
        youtube: "YouTube",
      },
      ge = function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (N.empty(e) || N.empty(t)) return "";
        var n = D(t.i18n, e);
        if (N.empty(n)) return Object.keys(fe).includes(e) ? fe[e] : "";
        var i = { "{seektime}": t.seekTime, "{title}": t.title };
        return (
          Object.entries(i).forEach(function (e) {
            var t = a(e, 2),
              i = t[0],
              s = t[1];
            n = de(n, i, s);
          }),
          n
        );
      },
      ye = (function () {
        function t(n) {
          e(this, t),
            (this.enabled = n.config.storage.enabled),
            (this.key = n.config.storage.key);
        }
        return (
          n(
            t,
            [
              {
                key: "get",
                value: function (e) {
                  if (!t.supported || !this.enabled) return null;
                  var n = window.localStorage.getItem(this.key);
                  if (N.empty(n)) return null;
                  var i = JSON.parse(n);
                  return N.string(e) && e.length ? i[e] : i;
                },
              },
              {
                key: "set",
                value: function (e) {
                  if (t.supported && this.enabled && N.object(e)) {
                    var n = this.get();
                    N.empty(n) && (n = {}),
                      F(n, e),
                      window.localStorage.setItem(this.key, JSON.stringify(n));
                  }
                },
              },
            ],
            [
              {
                key: "supported",
                get: function () {
                  try {
                    if (!("localStorage" in window)) return !1;
                    return (
                      window.localStorage.setItem("___test", "___test"),
                      window.localStorage.removeItem("___test"),
                      !0
                    );
                  } catch (e) {
                    return !1;
                  }
                },
              },
            ]
          ),
          t
        );
      })();
    function ve(e) {
      var t =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "text";
      return new Promise(function (n, i) {
        try {
          var a = new XMLHttpRequest();
          if (!("withCredentials" in a)) return;
          a.addEventListener("load", function () {
            if ("text" === t)
              try {
                n(JSON.parse(a.responseText));
              } catch (e) {
                n(a.responseText);
              }
            else n(a.response);
          }),
            a.addEventListener("error", function () {
              throw new Error(a.status);
            }),
            a.open("GET", e, !0),
            (a.responseType = t),
            a.send();
        } catch (e) {
          i(e);
        }
      });
    }
    function be(e, t) {
      if (N.string(e)) {
        var n = N.string(t),
          i = function () {
            return null !== document.getElementById(t);
          },
          a = function (e, t) {
            (e.innerHTML = t),
              (n && i()) ||
                document.body.insertAdjacentElement("afterbegin", e);
          };
        if (!n || !i()) {
          var s = ye.supported,
            r = document.createElement("div");
          if ((r.setAttribute("hidden", ""), n && r.setAttribute("id", t), s)) {
            var o = window.localStorage.getItem(
              "".concat("cache", "-").concat(t)
            );
            if (null !== o) {
              var l = JSON.parse(o);
              a(r, l.content);
            }
          }
          ve(e)
            .then(function (e) {
              N.empty(e) ||
                (s &&
                  window.localStorage.setItem(
                    "".concat("cache", "-").concat(t),
                    JSON.stringify({ content: e })
                  ),
                a(r, e));
            })
            .catch(function () {});
        }
      }
    }
    var ke = function (e) {
        return Math.trunc((e / 60 / 60) % 60, 10);
      },
      we = function (e) {
        return Math.trunc((e / 60) % 60, 10);
      },
      Te = function (e) {
        return Math.trunc(e % 60, 10);
      };
    function Ce() {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
        t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
      if (!N.number(e)) return Ce(null, t, n);
      var i = function (e) {
          return "0".concat(e).slice(-2);
        },
        a = ke(e),
        s = we(e),
        r = Te(e);
      return (
        (a = t || a > 0 ? "".concat(a, ":") : ""),
        ""
          .concat(n && e > 0 ? "-" : "")
          .concat(a)
          .concat(i(s), ":")
          .concat(i(r))
      );
    }
    var Ae = {
      getIconUrl: function () {
        var e =
          new URL(this.config.iconUrl, window.location).host !==
            window.location.host ||
          (L.isIE && !window.svg4everybody);
        return { url: this.config.iconUrl, cors: e };
      },
      findElements: function () {
        try {
          return (
            (this.elements.controls = Z.call(
              this,
              this.config.selectors.controls.wrapper
            )),
            (this.elements.buttons = {
              play: G.call(this, this.config.selectors.buttons.play),
              pause: Z.call(this, this.config.selectors.buttons.pause),
              restart: Z.call(this, this.config.selectors.buttons.restart),
              rewind: Z.call(this, this.config.selectors.buttons.rewind),
              fastForward: Z.call(
                this,
                this.config.selectors.buttons.fastForward
              ),
              mute: Z.call(this, this.config.selectors.buttons.mute),
              pip: Z.call(this, this.config.selectors.buttons.pip),
              airplay: Z.call(this, this.config.selectors.buttons.airplay),
              settings: Z.call(this, this.config.selectors.buttons.settings),
              captions: Z.call(this, this.config.selectors.buttons.captions),
              fullscreen: Z.call(
                this,
                this.config.selectors.buttons.fullscreen
              ),
            }),
            (this.elements.progress = Z.call(
              this,
              this.config.selectors.progress
            )),
            (this.elements.inputs = {
              seek: Z.call(this, this.config.selectors.inputs.seek),
              volume: Z.call(this, this.config.selectors.inputs.volume),
            }),
            (this.elements.display = {
              buffer: Z.call(this, this.config.selectors.display.buffer),
              currentTime: Z.call(
                this,
                this.config.selectors.display.currentTime
              ),
              duration: Z.call(this, this.config.selectors.display.duration),
            }),
            N.element(this.elements.progress) &&
              (this.elements.display.seekTooltip = this.elements.progress.querySelector(
                ".".concat(this.config.classNames.tooltip)
              )),
            !0
          );
        } catch (e) {
          return (
            this.debug.warn(
              "It looks like there is a problem with your custom controls HTML",
              e
            ),
            this.toggleNativeControls(!0),
            !1
          );
        }
      },
      createIcon: function (e, t) {
        var n = Ae.getIconUrl.call(this),
          i = ""
            .concat(n.cors ? "" : n.url, "#")
            .concat(this.config.iconPrefix),
          a = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        V(a, F(t, { role: "presentation", focusable: "false" }));
        var s = document.createElementNS("http://www.w3.org/2000/svg", "use"),
          r = "".concat(i, "-").concat(e);
        return (
          "href" in s &&
            s.setAttributeNS("http://www.w3.org/1999/xlink", "href", r),
          s.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", r),
          a.appendChild(s),
          a
        );
      },
      createLabel: function (e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = ge(e, this.config);
        return B(
          "span",
          Object.assign({}, t, {
            class: [t.class, this.config.classNames.hidden]
              .filter(Boolean)
              .join(" "),
          }),
          n
        );
      },
      createBadge: function (e) {
        if (N.empty(e)) return null;
        var t = B("span", { class: this.config.classNames.menu.value });
        return (
          t.appendChild(
            B("span", { class: this.config.classNames.menu.badge }, e)
          ),
          t
        );
      },
      createButton: function (e, t) {
        var n = this,
          i = F({}, t),
          a = me(e),
          s = {
            element: "button",
            toggle: !1,
            label: null,
            icon: null,
            labelPressed: null,
            iconPressed: null,
          };
        switch (
          (["element", "icon", "label"].forEach(function (e) {
            Object.keys(i).includes(e) && ((s[e] = i[e]), delete i[e]);
          }),
          "button" !== s.element ||
            Object.keys(i).includes("type") ||
            (i.type = "button"),
          Object.keys(i).includes("class")
            ? i.class.split(" ").some(function (e) {
                return e === n.config.classNames.control;
              }) ||
              F(i, {
                class: ""
                  .concat(i.class, " ")
                  .concat(this.config.classNames.control),
              })
            : (i.class = this.config.classNames.control),
          e)
        ) {
          case "play":
            (s.toggle = !0),
              (s.label = "play"),
              (s.labelPressed = "pause"),
              (s.icon = "play"),
              (s.iconPressed = "pause");
            break;
          case "mute":
            (s.toggle = !0),
              (s.label = "mute"),
              (s.labelPressed = "unmute"),
              (s.icon = "volume"),
              (s.iconPressed = "muted");
            break;
          case "captions":
            (s.toggle = !0),
              (s.label = "enableCaptions"),
              (s.labelPressed = "disableCaptions"),
              (s.icon = "captions-off"),
              (s.iconPressed = "captions-on");
            break;
          case "fullscreen":
            (s.toggle = !0),
              (s.label = "enterFullscreen"),
              (s.labelPressed = "exitFullscreen"),
              (s.icon = "enter-fullscreen"),
              (s.iconPressed = "exit-fullscreen");
            break;
          case "play-large":
            (i.class += " ".concat(
              this.config.classNames.control,
              "--overlaid"
            )),
              (a = "play"),
              (s.label = "play"),
              (s.icon = "play");
            break;
          default:
            N.empty(s.label) && (s.label = a), N.empty(s.icon) && (s.icon = e);
        }
        var r = B(s.element);
        return (
          s.toggle
            ? (r.appendChild(
                Ae.createIcon.call(this, s.iconPressed, {
                  class: "icon--pressed",
                })
              ),
              r.appendChild(
                Ae.createIcon.call(this, s.icon, { class: "icon--not-pressed" })
              ),
              r.appendChild(
                Ae.createLabel.call(this, s.labelPressed, {
                  class: "label--pressed",
                })
              ),
              r.appendChild(
                Ae.createLabel.call(this, s.label, {
                  class: "label--not-pressed",
                })
              ))
            : (r.appendChild(Ae.createIcon.call(this, s.icon)),
              r.appendChild(Ae.createLabel.call(this, s.label))),
          F(i, Y(this.config.selectors.buttons[a], i)),
          V(r, i),
          "play" === a
            ? (N.array(this.elements.buttons[a]) ||
                (this.elements.buttons[a] = []),
              this.elements.buttons[a].push(r))
            : (this.elements.buttons[a] = r),
          r
        );
      },
      createRange: function (e, t) {
        var n = B(
          "input",
          F(
            Y(this.config.selectors.inputs[e]),
            {
              type: "range",
              min: 0,
              max: 100,
              step: 0.01,
              value: 0,
              autocomplete: "off",
              role: "slider",
              "aria-label": ge(e, this.config),
              "aria-valuemin": 0,
              "aria-valuemax": 100,
              "aria-valuenow": 0,
            },
            t
          )
        );
        return (
          (this.elements.inputs[e] = n),
          Ae.updateRangeFill.call(this, n),
          b.setup(n),
          n
        );
      },
      createProgress: function (e, t) {
        var n = B(
          "progress",
          F(
            Y(this.config.selectors.display[e]),
            {
              min: 0,
              max: 100,
              value: 0,
              role: "progressbar",
              "aria-hidden": !0,
            },
            t
          )
        );
        if ("volume" !== e) {
          n.appendChild(B("span", null, "0"));
          var i = { played: "played", buffer: "buffered" }[e],
            a = i ? ge(i, this.config) : "";
          n.innerText = "% ".concat(a.toLowerCase());
        }
        return (this.elements.display[e] = n), n;
      },
      createTime: function (e, t) {
        var n = Y(this.config.selectors.display[e], t),
          i = B(
            "div",
            F(n, {
              class: ""
                .concat(n.class ? n.class : "", " ")
                .concat(this.config.classNames.display.time, " ")
                .trim(),
              "aria-label": ge(e, this.config),
            }),
            "00:00"
          );
        return (this.elements.display[e] = i), i;
      },
      bindMenuItemShortcuts: function (e, t) {
        var n = this;
        O(
          e,
          "keydown keyup",
          function (i) {
            if (
              [32, 38, 39, 40].includes(i.which) &&
              (i.preventDefault(), i.stopPropagation(), "keydown" !== i.type)
            ) {
              var a,
                s = $(e, '[role="menuitemradio"]');
              if (!s && [32, 39].includes(i.which))
                Ae.showMenuPanel.call(n, t, !0);
              else
                32 !== i.which &&
                  (40 === i.which || (s && 39 === i.which)
                    ? ((a = e.nextElementSibling),
                      N.element(a) || (a = e.parentNode.firstElementChild))
                    : ((a = e.previousElementSibling),
                      N.element(a) || (a = e.parentNode.lastElementChild)),
                  ee.call(n, a, !0));
            }
          },
          !1
        ),
          O(e, "keyup", function (e) {
            13 === e.which && Ae.focusFirstMenuItem.call(n, null, !0);
          });
      },
      createMenuItem: function (e) {
        var t = this,
          n = e.value,
          i = e.list,
          a = e.type,
          s = e.title,
          r = e.badge,
          o = void 0 === r ? null : r,
          l = e.checked,
          c = void 0 !== l && l,
          u = Y(this.config.selectors.inputs[a]),
          d = B(
            "button",
            F(u, {
              type: "button",
              role: "menuitemradio",
              class: ""
                .concat(this.config.classNames.control, " ")
                .concat(u.class ? u.class : "")
                .trim(),
              "aria-checked": c,
              value: n,
            })
          ),
          h = B("span");
        (h.innerHTML = s),
          N.element(o) && h.appendChild(o),
          d.appendChild(h),
          Object.defineProperty(d, "checked", {
            enumerable: !0,
            get: function () {
              return "true" === d.getAttribute("aria-checked");
            },
            set: function (e) {
              e &&
                Array.from(d.parentNode.children)
                  .filter(function (e) {
                    return $(e, '[role="menuitemradio"]');
                  })
                  .forEach(function (e) {
                    return e.setAttribute("aria-checked", "false");
                  }),
                d.setAttribute("aria-checked", e ? "true" : "false");
            },
          }),
          this.listeners.bind(
            d,
            "click keyup",
            function (e) {
              if (!N.keyboardEvent(e) || 32 === e.which) {
                switch (
                  (e.preventDefault(), e.stopPropagation(), (d.checked = !0), a)
                ) {
                  case "language":
                    t.currentTrack = Number(n);
                    break;
                  case "quality":
                    t.quality = n;
                    break;
                  case "speed":
                    t.speed = parseFloat(n);
                }
                Ae.showMenuPanel.call(t, "home", N.keyboardEvent(e));
              }
            },
            a,
            !1
          ),
          Ae.bindMenuItemShortcuts.call(this, d, a),
          i.appendChild(d);
      },
      formatTime: function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return N.number(e) ? Ce(e, ke(this.duration) > 0, t) : e;
      },
      updateTimeDisplay: function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null,
          t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        N.element(e) && N.number(t) && (e.innerText = Ae.formatTime(t, n));
      },
      updateVolume: function () {
        this.supported.ui &&
          (N.element(this.elements.inputs.volume) &&
            Ae.setRange.call(
              this,
              this.elements.inputs.volume,
              this.muted ? 0 : this.volume
            ),
          N.element(this.elements.buttons.mute) &&
            (this.elements.buttons.mute.pressed =
              this.muted || 0 === this.volume));
      },
      setRange: function (e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        N.element(e) && ((e.value = t), Ae.updateRangeFill.call(this, e));
      },
      updateProgress: function (e) {
        var t = this;
        if (this.supported.ui && N.event(e)) {
          var n,
            i,
            a = 0;
          if (e)
            switch (e.type) {
              case "timeupdate":
              case "seeking":
              case "seeked":
                (n = this.currentTime),
                  (i = this.duration),
                  (a =
                    0 === n || 0 === i || Number.isNaN(n) || Number.isNaN(i)
                      ? 0
                      : ((n / i) * 100).toFixed(2)),
                  "timeupdate" === e.type &&
                    Ae.setRange.call(this, this.elements.inputs.seek, a);
                break;
              case "playing":
              case "progress":
                !(function (e, n) {
                  var i = N.number(n) ? n : 0,
                    a = N.element(e) ? e : t.elements.display.buffer;
                  if (N.element(a)) {
                    a.value = i;
                    var s = a.getElementsByTagName("span")[0];
                    N.element(s) && (s.childNodes[0].nodeValue = i);
                  }
                })(this.elements.display.buffer, 100 * this.buffered);
            }
        }
      },
      updateRangeFill: function (e) {
        var t = N.event(e) ? e.target : e;
        if (N.element(t) && "range" === t.getAttribute("type")) {
          if ($(t, this.config.selectors.inputs.seek)) {
            t.setAttribute("aria-valuenow", this.currentTime);
            var n = Ae.formatTime(this.currentTime),
              i = Ae.formatTime(this.duration),
              a = ge("seekLabel", this.config);
            t.setAttribute(
              "aria-valuetext",
              a.replace("{currentTime}", n).replace("{duration}", i)
            );
          } else if ($(t, this.config.selectors.inputs.volume)) {
            var s = 100 * t.value;
            t.setAttribute("aria-valuenow", s),
              t.setAttribute("aria-valuetext", "".concat(s.toFixed(1), "%"));
          } else t.setAttribute("aria-valuenow", t.value);
          L.isWebkit &&
            t.style.setProperty(
              "--value",
              "".concat((t.value / t.max) * 100, "%")
            );
        }
      },
      updateSeekTooltip: function (e) {
        var t = this;
        if (
          this.config.tooltips.seek &&
          N.element(this.elements.inputs.seek) &&
          N.element(this.elements.display.seekTooltip) &&
          0 !== this.duration
        ) {
          var n = "".concat(this.config.classNames.tooltip, "--visible"),
            i = function (e) {
              return X(t.elements.display.seekTooltip, n, e);
            };
          if (this.touch) i(!1);
          else {
            var a = 0,
              s = this.elements.progress.getBoundingClientRect();
            if (N.event(e)) a = (100 / s.width) * (e.pageX - s.left);
            else {
              if (!J(this.elements.display.seekTooltip, n)) return;
              a = parseFloat(this.elements.display.seekTooltip.style.left, 10);
            }
            a < 0 ? (a = 0) : a > 100 && (a = 100),
              Ae.updateTimeDisplay.call(
                this,
                this.elements.display.seekTooltip,
                (this.duration / 100) * a
              ),
              (this.elements.display.seekTooltip.style.left = "".concat(
                a,
                "%"
              )),
              N.event(e) &&
                ["mouseenter", "mouseleave"].includes(e.type) &&
                i("mouseenter" === e.type);
          }
        }
      },
      timeUpdate: function (e) {
        var t =
          !N.element(this.elements.display.duration) && this.config.invertTime;
        Ae.updateTimeDisplay.call(
          this,
          this.elements.display.currentTime,
          t ? this.duration - this.currentTime : this.currentTime,
          t
        ),
          (e && "timeupdate" === e.type && this.media.seeking) ||
            Ae.updateProgress.call(this, e);
      },
      durationUpdate: function () {
        if (
          this.supported.ui &&
          (this.config.invertTime || !this.currentTime)
        ) {
          if (this.duration >= Math.pow(2, 32))
            return (
              Q(this.elements.display.currentTime, !0),
              void Q(this.elements.progress, !0)
            );
          N.element(this.elements.inputs.seek) &&
            this.elements.inputs.seek.setAttribute(
              "aria-valuemax",
              this.duration
            );
          var e = N.element(this.elements.display.duration);
          !e &&
            this.config.displayDuration &&
            this.paused &&
            Ae.updateTimeDisplay.call(
              this,
              this.elements.display.currentTime,
              this.duration
            ),
            e &&
              Ae.updateTimeDisplay.call(
                this,
                this.elements.display.duration,
                this.duration
              ),
            Ae.updateSeekTooltip.call(this);
        }
      },
      toggleMenuButton: function (e, t) {
        Q(this.elements.settings.buttons[e], !t);
      },
      updateSetting: function (e, t, n) {
        var i = this.elements.settings.panels[e],
          a = null,
          s = t;
        if ("captions" === e) a = this.currentTrack;
        else {
          if (
            ((a = N.empty(n) ? this[e] : n),
            N.empty(a) && (a = this.config[e].default),
            !N.empty(this.options[e]) && !this.options[e].includes(a))
          )
            return void this.debug.warn(
              "Unsupported value of '".concat(a, "' for ").concat(e)
            );
          if (!this.config[e].options.includes(a))
            return void this.debug.warn(
              "Disabled value of '".concat(a, "' for ").concat(e)
            );
        }
        if (
          (N.element(s) || (s = i && i.querySelector('[role="menu"]')),
          N.element(s))
        ) {
          this.elements.settings.buttons[e].querySelector(
            ".".concat(this.config.classNames.menu.value)
          ).innerHTML = Ae.getLabel.call(this, e, a);
          var r = s && s.querySelector('[value="'.concat(a, '"]'));
          N.element(r) && (r.checked = !0);
        }
      },
      getLabel: function (e, t) {
        switch (e) {
          case "speed":
            return 1 === t
              ? ge("normal", this.config)
              : "".concat(t, "&times;");
          case "quality":
            if (N.number(t)) {
              var n = ge("qualityLabel.".concat(t), this.config);
              return n.length ? n : "".concat(t, "p");
            }
            return he(t);
          case "captions":
            return Pe.getLabel.call(this);
          default:
            return null;
        }
      },
      setQualityMenu: function (e) {
        var t = this;
        if (N.element(this.elements.settings.panels.quality)) {
          var n = this.elements.settings.panels.quality.querySelector(
            '[role="menu"]'
          );
          N.array(e) &&
            (this.options.quality = ce(e).filter(function (e) {
              return t.config.quality.options.includes(e);
            }));
          var i =
            !N.empty(this.options.quality) && this.options.quality.length > 1;
          if (
            (Ae.toggleMenuButton.call(this, "quality", i),
            z(n),
            Ae.checkMenu.call(this),
            i)
          ) {
            var a = function (e) {
              var n = ge("qualityBadge.".concat(e), t.config);
              return n.length ? Ae.createBadge.call(t, n) : null;
            };
            this.options.quality
              .sort(function (e, n) {
                var i = t.config.quality.options;
                return i.indexOf(e) > i.indexOf(n) ? 1 : -1;
              })
              .forEach(function (e) {
                Ae.createMenuItem.call(t, {
                  value: e,
                  list: n,
                  type: "quality",
                  title: Ae.getLabel.call(t, "quality", e),
                  badge: a(e),
                });
              }),
              Ae.updateSetting.call(this, "quality", n);
          }
        }
      },
      setCaptionsMenu: function () {
        var e = this;
        if (N.element(this.elements.settings.panels.captions)) {
          var t = this.elements.settings.panels.captions.querySelector(
              '[role="menu"]'
            ),
            n = Pe.getTracks.call(this),
            i = Boolean(n.length);
          if (
            (Ae.toggleMenuButton.call(this, "captions", i),
            z(t),
            Ae.checkMenu.call(this),
            i)
          ) {
            var a = n.map(function (n, i) {
              return {
                value: i,
                checked: e.captions.toggled && e.currentTrack === i,
                title: Pe.getLabel.call(e, n),
                badge:
                  n.language &&
                  Ae.createBadge.call(e, n.language.toUpperCase()),
                list: t,
                type: "language",
              };
            });
            a.unshift({
              value: -1,
              checked: !this.captions.toggled,
              title: ge("disabled", this.config),
              list: t,
              type: "language",
            }),
              a.forEach(Ae.createMenuItem.bind(this)),
              Ae.updateSetting.call(this, "captions", t);
          }
        }
      },
      setSpeedMenu: function (e) {
        var t = this;
        if (N.element(this.elements.settings.panels.speed)) {
          var n = this.elements.settings.panels.speed.querySelector(
            '[role="menu"]'
          );
          N.array(e)
            ? (this.options.speed = e)
            : (this.isHTML5 || this.isVimeo) &&
              (this.options.speed = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]),
            (this.options.speed = this.options.speed.filter(function (e) {
              return t.config.speed.options.includes(e);
            }));
          var i = !N.empty(this.options.speed) && this.options.speed.length > 1;
          Ae.toggleMenuButton.call(this, "speed", i),
            z(n),
            Ae.checkMenu.call(this),
            i &&
              (this.options.speed.forEach(function (e) {
                Ae.createMenuItem.call(t, {
                  value: e,
                  list: n,
                  type: "speed",
                  title: Ae.getLabel.call(t, "speed", e),
                });
              }),
              Ae.updateSetting.call(this, "speed", n));
        }
      },
      checkMenu: function () {
        var e = this.elements.settings.buttons,
          t =
            !N.empty(e) &&
            Object.values(e).some(function (e) {
              return !e.hidden;
            });
        Q(this.elements.settings.menu, !t);
      },
      focusFirstMenuItem: function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (!this.elements.settings.popup.hidden) {
          var n = e;
          N.element(n) ||
            (n = Object.values(this.elements.settings.panels).find(function (
              e
            ) {
              return !e.hidden;
            }));
          var i = n.querySelector('[role^="menuitem"]');
          ee.call(this, i, t);
        }
      },
      toggleMenu: function (e) {
        var t = this.elements.settings.popup,
          n = this.elements.buttons.settings;
        if (N.element(t) && N.element(n)) {
          var i = t.hidden,
            a = i;
          if (N.boolean(e)) a = e;
          else if (N.keyboardEvent(e) && 27 === e.which) a = !1;
          else if (N.event(e)) {
            var s = N.function(e.composedPath) ? e.composedPath()[0] : e.target,
              r = t.contains(s);
            if (r || (!r && e.target !== n && a)) return;
          }
          n.setAttribute("aria-expanded", a),
            Q(t, !a),
            X(this.elements.container, this.config.classNames.menu.open, a),
            a && N.keyboardEvent(e)
              ? Ae.focusFirstMenuItem.call(this, null, !0)
              : a || i || ee.call(this, n, N.keyboardEvent(e));
        }
      },
      getMenuSize: function (e) {
        var t = e.cloneNode(!0);
        (t.style.position = "absolute"),
          (t.style.opacity = 0),
          t.removeAttribute("hidden"),
          e.parentNode.appendChild(t);
        var n = t.scrollWidth,
          i = t.scrollHeight;
        return W(t), { width: n, height: i };
      },
      showMenuPanel: function () {
        var e = this,
          t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          i = this.elements.container.querySelector(
            "#plyr-settings-".concat(this.id, "-").concat(t)
          );
        if (N.element(i)) {
          var a = i.parentNode,
            s = Array.from(a.children).find(function (e) {
              return !e.hidden;
            });
          if (ie.transitions && !ie.reducedMotion) {
            (a.style.width = "".concat(s.scrollWidth, "px")),
              (a.style.height = "".concat(s.scrollHeight, "px"));
            var r = Ae.getMenuSize.call(this, i);
            O.call(this, a, M, function t(n) {
              n.target === a &&
                ["width", "height"].includes(n.propertyName) &&
                ((a.style.width = ""),
                (a.style.height = ""),
                j.call(e, a, M, t));
            }),
              (a.style.width = "".concat(r.width, "px")),
              (a.style.height = "".concat(r.height, "px"));
          }
          Q(s, !0), Q(i, !1), Ae.focusFirstMenuItem.call(this, i, n);
        }
      },
      setDownloadUrl: function () {
        var e = this.elements.buttons.download;
        N.element(e) && e.setAttribute("href", this.download);
      },
      create: function (e) {
        var t = this,
          n = Ae.bindMenuItemShortcuts,
          i = Ae.createButton,
          a = Ae.createProgress,
          s = Ae.createRange,
          r = Ae.createTime,
          o = Ae.setQualityMenu,
          l = Ae.setSpeedMenu,
          c = Ae.showMenuPanel;
        (this.elements.controls = null),
          this.config.controls.includes("play-large") &&
            this.elements.container.appendChild(i.call(this, "play-large"));
        var u = B("div", Y(this.config.selectors.controls.wrapper));
        this.elements.controls = u;
        var d = { class: "plyr__controls__item" };
        return (
          ce(this.config.controls).forEach(function (o) {
            if (
              ("restart" === o && u.appendChild(i.call(t, "restart", d)),
              "rewind" === o && u.appendChild(i.call(t, "rewind", d)),
              "play" === o && u.appendChild(i.call(t, "play", d)),
              "fast-forward" === o &&
                u.appendChild(i.call(t, "fast-forward", d)),
              "progress" === o)
            ) {
              var l = B("div", {
                  class: "".concat(d.class, " plyr__progress__container"),
                }),
                h = B("div", Y(t.config.selectors.progress));
              if (
                (h.appendChild(
                  s.call(t, "seek", { id: "plyr-seek-".concat(e.id) })
                ),
                h.appendChild(a.call(t, "buffer")),
                t.config.tooltips.seek)
              ) {
                var m = B(
                  "span",
                  { class: t.config.classNames.tooltip },
                  "00:00"
                );
                h.appendChild(m), (t.elements.display.seekTooltip = m);
              }
              (t.elements.progress = h),
                l.appendChild(t.elements.progress),
                u.appendChild(l);
            }
            if (
              ("current-time" === o &&
                u.appendChild(r.call(t, "currentTime", d)),
              "duration" === o && u.appendChild(r.call(t, "duration", d)),
              "mute" === o || "volume" === o)
            ) {
              var p = t.elements.volume;
              if (
                ((N.element(p) && u.contains(p)) ||
                  ((p = B(
                    "div",
                    F({}, d, {
                      class: "".concat(d.class, " plyr__volume").trim(),
                    })
                  )),
                  (t.elements.volume = p),
                  u.appendChild(p)),
                "mute" === o && p.appendChild(i.call(t, "mute")),
                "volume" === o)
              ) {
                var f = { max: 1, step: 0.05, value: t.config.volume };
                p.appendChild(
                  s.call(t, "volume", F(f, { id: "plyr-volume-".concat(e.id) }))
                );
              }
            }
            if (
              ("captions" === o && u.appendChild(i.call(t, "captions", d)),
              "settings" === o && !N.empty(t.config.settings))
            ) {
              var g = B(
                "div",
                F({}, d, {
                  class: "".concat(d.class, " plyr__menu").trim(),
                  hidden: "",
                })
              );
              g.appendChild(
                i.call(t, "settings", {
                  "aria-haspopup": !0,
                  "aria-controls": "plyr-settings-".concat(e.id),
                  "aria-expanded": !1,
                })
              );
              var y = B("div", {
                  class: "plyr__menu__container",
                  id: "plyr-settings-".concat(e.id),
                  hidden: "",
                }),
                v = B("div"),
                b = B("div", { id: "plyr-settings-".concat(e.id, "-home") }),
                k = B("div", { role: "menu" });
              b.appendChild(k),
                v.appendChild(b),
                (t.elements.settings.panels.home = b),
                t.config.settings.forEach(function (i) {
                  var a = B(
                    "button",
                    F(Y(t.config.selectors.buttons.settings), {
                      type: "button",
                      class: ""
                        .concat(t.config.classNames.control, " ")
                        .concat(t.config.classNames.control, "--forward"),
                      role: "menuitem",
                      "aria-haspopup": !0,
                      hidden: "",
                    })
                  );
                  n.call(t, a, i),
                    O(a, "click", function () {
                      c.call(t, i, !1);
                    });
                  var s = B("span", null, ge(i, t.config)),
                    r = B("span", { class: t.config.classNames.menu.value });
                  (r.innerHTML = e[i]),
                    s.appendChild(r),
                    a.appendChild(s),
                    k.appendChild(a);
                  var o = B("div", {
                      id: "plyr-settings-".concat(e.id, "-").concat(i),
                      hidden: "",
                    }),
                    l = B("button", {
                      type: "button",
                      class: ""
                        .concat(t.config.classNames.control, " ")
                        .concat(t.config.classNames.control, "--back"),
                    });
                  l.appendChild(
                    B("span", { "aria-hidden": !0 }, ge(i, t.config))
                  ),
                    l.appendChild(
                      B(
                        "span",
                        { class: t.config.classNames.hidden },
                        ge("menuBack", t.config)
                      )
                    ),
                    O(
                      o,
                      "keydown",
                      function (e) {
                        37 === e.which &&
                          (e.preventDefault(),
                          e.stopPropagation(),
                          c.call(t, "home", !0));
                      },
                      !1
                    ),
                    O(l, "click", function () {
                      c.call(t, "home", !1);
                    }),
                    o.appendChild(l),
                    o.appendChild(B("div", { role: "menu" })),
                    v.appendChild(o),
                    (t.elements.settings.buttons[i] = a),
                    (t.elements.settings.panels[i] = o);
                }),
                y.appendChild(v),
                g.appendChild(y),
                u.appendChild(g),
                (t.elements.settings.popup = y),
                (t.elements.settings.menu = g);
            }
            if (
              ("pip" === o && ie.pip && u.appendChild(i.call(t, "pip", d)),
              "airplay" === o &&
                ie.airplay &&
                u.appendChild(i.call(t, "airplay", d)),
              "download" === o)
            ) {
              var w = F({}, d, {
                  element: "a",
                  href: t.download,
                  target: "_blank",
                }),
                T = t.config.urls.download;
              !N.url(T) &&
                t.isEmbed &&
                F(w, { icon: "logo-".concat(t.provider), label: t.provider }),
                u.appendChild(i.call(t, "download", w));
            }
            "fullscreen" === o && u.appendChild(i.call(t, "fullscreen", d));
          }),
          this.isHTML5 && o.call(this, le.getQualityOptions.call(this)),
          l.call(this),
          u
        );
      },
      inject: function () {
        var e = this;
        if (this.config.loadSprite) {
          var t = Ae.getIconUrl.call(this);
          t.cors && be(t.url, "sprite-plyr");
        }
        this.id = Math.floor(1e4 * Math.random());
        var n = null;
        this.elements.controls = null;
        var i = {
            id: this.id,
            seektime: this.config.seekTime,
            title: this.config.title,
          },
          s = !0;
        N.function(this.config.controls) &&
          (this.config.controls = this.config.controls.call(this, i)),
          this.config.controls || (this.config.controls = []),
          N.element(this.config.controls) || N.string(this.config.controls)
            ? (n = this.config.controls)
            : ((n = Ae.create.call(this, {
                id: this.id,
                seektime: this.config.seekTime,
                speed: this.speed,
                quality: this.quality,
                captions: Pe.getLabel.call(this),
              })),
              (s = !1));
        var r,
          o = function (e) {
            var t = e;
            return (
              Object.entries(i).forEach(function (e) {
                var n = a(e, 2),
                  i = n[0],
                  s = n[1];
                t = de(t, "{".concat(i, "}"), s);
              }),
              t
            );
          };
        if (
          (s &&
            (N.string(this.config.controls)
              ? (n = o(n))
              : N.element(n) && (n.innerHTML = o(n.innerHTML))),
          N.string(this.config.selectors.controls.container) &&
            (r = document.querySelector(
              this.config.selectors.controls.container
            )),
          N.element(r) || (r = this.elements.container),
          r[N.element(n) ? "insertAdjacentElement" : "insertAdjacentHTML"](
            "afterbegin",
            n
          ),
          N.element(this.elements.controls) || Ae.findElements.call(this),
          !N.empty(this.elements.buttons))
        ) {
          var l = function (t) {
            var n = e.config.classNames.controlPressed;
            Object.defineProperty(t, "pressed", {
              enumerable: !0,
              get: function () {
                return J(t, n);
              },
              set: function () {
                var e =
                  arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0];
                X(t, n, e);
              },
            });
          };
          Object.values(this.elements.buttons)
            .filter(Boolean)
            .forEach(function (e) {
              N.array(e) || N.nodeList(e)
                ? Array.from(e).filter(Boolean).forEach(l)
                : l(e);
            });
        }
        if ((L.isEdge && x(r), this.config.tooltips.controls)) {
          var c = this.config,
            u = c.classNames,
            d = c.selectors,
            h = ""
              .concat(d.controls.wrapper, " ")
              .concat(d.labels, " .")
              .concat(u.hidden),
            m = G.call(this, h);
          Array.from(m).forEach(function (t) {
            X(t, e.config.classNames.hidden, !1),
              X(t, e.config.classNames.tooltip, !0);
          });
        }
      },
    };
    function Ee(e) {
      var t = e;
      if (!(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]) {
        var n = document.createElement("a");
        (n.href = t), (t = n.href);
      }
      try {
        return new URL(t);
      } catch (e) {
        return null;
      }
    }
    function Se(e) {
      var t = new URLSearchParams();
      return (
        N.object(e) &&
          Object.entries(e).forEach(function (e) {
            var n = a(e, 2),
              i = n[0],
              s = n[1];
            t.set(i, s);
          }),
        t
      );
    }
    var Pe = {
        setup: function () {
          if (this.supported.ui)
            if (
              !this.isVideo ||
              this.isYouTube ||
              (this.isHTML5 && !ie.textTracks)
            )
              N.array(this.config.controls) &&
                this.config.controls.includes("settings") &&
                this.config.settings.includes("captions") &&
                Ae.setCaptionsMenu.call(this);
            else {
              if (
                (N.element(this.elements.captions) ||
                  ((this.elements.captions = B(
                    "div",
                    Y(this.config.selectors.captions)
                  )),
                  (function (e, t) {
                    N.element(e) &&
                      N.element(t) &&
                      t.parentNode.insertBefore(e, t.nextSibling);
                  })(this.elements.captions, this.elements.wrapper)),
                L.isIE && window.URL)
              ) {
                var e = this.media.querySelectorAll("track");
                Array.from(e).forEach(function (e) {
                  var t = e.getAttribute("src"),
                    n = Ee(t);
                  null !== n &&
                    n.hostname !== window.location.href.hostname &&
                    ["http:", "https:"].includes(n.protocol) &&
                    ve(t, "blob")
                      .then(function (t) {
                        e.setAttribute("src", window.URL.createObjectURL(t));
                      })
                      .catch(function () {
                        W(e);
                      });
                });
              }
              var t = ce(
                  (
                    navigator.languages || [
                      navigator.language || navigator.userLanguage || "en",
                    ]
                  ).map(function (e) {
                    return e.split("-")[0];
                  })
                ),
                n = (
                  this.storage.get("language") ||
                  this.config.captions.language ||
                  "auto"
                ).toLowerCase();
              if ("auto" === n) n = a(t, 1)[0];
              var i = this.storage.get("captions");
              if (
                (N.boolean(i) || (i = this.config.captions.active),
                Object.assign(this.captions, {
                  toggled: !1,
                  active: i,
                  language: n,
                  languages: t,
                }),
                this.isHTML5)
              ) {
                var s = this.config.captions.update
                  ? "addtrack removetrack"
                  : "removetrack";
                O.call(this, this.media.textTracks, s, Pe.update.bind(this));
              }
              setTimeout(Pe.update.bind(this), 0);
            }
        },
        update: function () {
          var e = this,
            t = Pe.getTracks.call(this, !0),
            n = this.captions,
            i = n.active,
            a = n.language,
            s = n.meta,
            r = n.currentTrackNode,
            o = Boolean(
              t.find(function (e) {
                return e.language === a;
              })
            );
          this.isHTML5 &&
            this.isVideo &&
            t
              .filter(function (e) {
                return !s.get(e);
              })
              .forEach(function (t) {
                e.debug.log("Track added", t),
                  s.set(t, { default: "showing" === t.mode }),
                  (t.mode = "hidden"),
                  O.call(e, t, "cuechange", function () {
                    return Pe.updateCues.call(e);
                  });
              }),
            ((o && this.language !== a) || !t.includes(r)) &&
              (Pe.setLanguage.call(this, a), Pe.toggle.call(this, i && o)),
            X(
              this.elements.container,
              this.config.classNames.captions.enabled,
              !N.empty(t)
            ),
            (this.config.controls || []).includes("settings") &&
              this.config.settings.includes("captions") &&
              Ae.setCaptionsMenu.call(this);
        },
        toggle: function (e) {
          var t =
            !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          if (this.supported.ui) {
            var n = this.captions.toggled,
              i = this.config.classNames.captions.active,
              a = N.nullOrUndefined(e) ? !n : e;
            if (a !== n) {
              if (
                (t ||
                  ((this.captions.active = a),
                  this.storage.set({ captions: a })),
                !this.language && a && !t)
              ) {
                var r = Pe.getTracks.call(this),
                  o = Pe.findTrack.call(
                    this,
                    [this.captions.language].concat(s(this.captions.languages)),
                    !0
                  );
                return (
                  (this.captions.language = o.language),
                  void Pe.set.call(this, r.indexOf(o))
                );
              }
              this.elements.buttons.captions &&
                (this.elements.buttons.captions.pressed = a),
                X(this.elements.container, i, a),
                (this.captions.toggled = a),
                Ae.updateSetting.call(this, "captions"),
                H.call(
                  this,
                  this.media,
                  a ? "captionsenabled" : "captionsdisabled"
                );
            }
          }
        },
        set: function (e) {
          var t =
              !(arguments.length > 1 && void 0 !== arguments[1]) ||
              arguments[1],
            n = Pe.getTracks.call(this);
          if (-1 !== e)
            if (N.number(e))
              if (e in n) {
                if (this.captions.currentTrack !== e) {
                  this.captions.currentTrack = e;
                  var i = n[e],
                    a = (i || {}).language;
                  (this.captions.currentTrackNode = i),
                    Ae.updateSetting.call(this, "captions"),
                    t ||
                      ((this.captions.language = a),
                      this.storage.set({ language: a })),
                    this.isVimeo && this.embed.enableTextTrack(a),
                    H.call(this, this.media, "languagechange");
                }
                Pe.toggle.call(this, !0, t),
                  this.isHTML5 && this.isVideo && Pe.updateCues.call(this);
              } else this.debug.warn("Track not found", e);
            else this.debug.warn("Invalid caption argument", e);
          else Pe.toggle.call(this, !1, t);
        },
        setLanguage: function (e) {
          var t =
            !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          if (N.string(e)) {
            var n = e.toLowerCase();
            this.captions.language = n;
            var i = Pe.getTracks.call(this),
              a = Pe.findTrack.call(this, [n]);
            Pe.set.call(this, i.indexOf(a), t);
          } else this.debug.warn("Invalid language argument", e);
        },
        getTracks: function () {
          var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          return Array.from((this.media || {}).textTracks || [])
            .filter(function (n) {
              return !e.isHTML5 || t || e.captions.meta.has(n);
            })
            .filter(function (e) {
              return ["captions", "subtitles"].includes(e.kind);
            });
        },
        findTrack: function (e) {
          var t,
            n = this,
            i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            a = Pe.getTracks.call(this),
            s = function (e) {
              return Number((n.captions.meta.get(e) || {}).default);
            },
            r = Array.from(a).sort(function (e, t) {
              return s(t) - s(e);
            });
          return (
            e.every(function (e) {
              return !(t = r.find(function (t) {
                return t.language === e;
              }));
            }),
            t || (i ? r[0] : void 0)
          );
        },
        getCurrentTrack: function () {
          return Pe.getTracks.call(this)[this.currentTrack];
        },
        getLabel: function (e) {
          var t = e;
          return (
            !N.track(t) &&
              ie.textTracks &&
              this.captions.toggled &&
              (t = Pe.getCurrentTrack.call(this)),
            N.track(t)
              ? N.empty(t.label)
                ? N.empty(t.language)
                  ? ge("enabled", this.config)
                  : e.language.toUpperCase()
                : t.label
              : ge("disabled", this.config)
          );
        },
        updateCues: function (e) {
          if (this.supported.ui)
            if (N.element(this.elements.captions))
              if (N.nullOrUndefined(e) || Array.isArray(e)) {
                var t = e;
                if (!t) {
                  var n = Pe.getCurrentTrack.call(this);
                  t = Array.from((n || {}).activeCues || [])
                    .map(function (e) {
                      return e.getCueAsHTML();
                    })
                    .map(pe);
                }
                var i = t
                  .map(function (e) {
                    return e.trim();
                  })
                  .join("\n");
                if (i !== this.elements.captions.innerHTML) {
                  z(this.elements.captions);
                  var a = B("span", Y(this.config.selectors.caption));
                  (a.innerHTML = i),
                    this.elements.captions.appendChild(a),
                    H.call(this, this.media, "cuechange");
                }
              } else this.debug.warn("updateCues: Invalid input", e);
            else this.debug.warn("No captions element to render to");
        },
      },
      Ne = {
        enabled: !0,
        title: "",
        debug: !1,
        autoplay: !1,
        autopause: !0,
        playsinline: !0,
        seekTime: 10,
        volume: 1,
        muted: !1,
        duration: null,
        displayDuration: !0,
        invertTime: !0,
        toggleInvert: !0,
        ratio: null,
        clickToPlay: !0,
        hideControls: !0,
        resetOnEnd: !1,
        disableContextMenu: !0,
        loadSprite: !0,
        iconPrefix: "plyr",
        iconUrl: "https://cdn.plyr.io/3.5.6/plyr.svg",
        blankVideo: "https://cdn.plyr.io/static/blank.mp4",
        quality: {
          default: 576,
          options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240],
        },
        loop: { active: !1 },
        speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] },
        keyboard: { focused: !0, global: !1 },
        tooltips: { controls: !1, seek: !0 },
        captions: { active: !1, language: "auto", update: !1 },
        fullscreen: { enabled: !0, fallback: !0, iosNative: !1 },
        storage: { enabled: !0, key: "plyr" },
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "captions",
          "settings",
          "pip",
          "airplay",
          "fullscreen",
        ],
        settings: ["captions", "quality", "speed"],
        i18n: {
          restart: "Restart",
          rewind: "Rewind {seektime}s",
          play: "Play",
          pause: "Pause",
          fastForward: "Forward {seektime}s",
          seek: "Seek",
          seekLabel: "{currentTime} of {duration}",
          played: "Played",
          buffered: "Buffered",
          currentTime: "Current time",
          duration: "Duration",
          volume: "Volume",
          mute: "Mute",
          unmute: "Unmute",
          enableCaptions: "Enable captions",
          disableCaptions: "Disable captions",
          download: "Download",
          enterFullscreen: "Enter fullscreen",
          exitFullscreen: "Exit fullscreen",
          frameTitle: "Player for {title}",
          captions: "Captions",
          settings: "Settings",
          menuBack: "Go back to previous menu",
          speed: "Speed",
          normal: "Normal",
          quality: "Quality",
          loop: "Loop",
          start: "Start",
          end: "End",
          all: "All",
          reset: "Reset",
          disabled: "Disabled",
          enabled: "Enabled",
          advertisement: "Ad",
          qualityBadge: {
            2160: "4K",
            1440: "HD",
            1080: "HD",
            720: "HD",
            576: "SD",
            480: "SD",
          },
        },
        urls: {
          download: null,
          vimeo: {
            sdk: "https://player.vimeo.com/api/player.js",
            iframe: "https://player.vimeo.com/video/{0}?{1}",
            api: "https://vimeo.com/api/v2/video/{0}.json",
          },
          youtube: {
            sdk: "https://www.youtube.com/iframe_api",
            api:
              "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}",
          },
          googleIMA: {
            sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
          },
        },
        listeners: {
          seek: null,
          play: null,
          pause: null,
          restart: null,
          rewind: null,
          fastForward: null,
          mute: null,
          volume: null,
          captions: null,
          download: null,
          fullscreen: null,
          pip: null,
          airplay: null,
          speed: null,
          quality: null,
          loop: null,
          language: null,
        },
        events: [
          "ended",
          "progress",
          "stalled",
          "playing",
          "waiting",
          "canplay",
          "canplaythrough",
          "loadstart",
          "loadeddata",
          "loadedmetadata",
          "timeupdate",
          "volumechange",
          "play",
          "pause",
          "error",
          "seeking",
          "seeked",
          "emptied",
          "ratechange",
          "cuechange",
          "download",
          "enterfullscreen",
          "exitfullscreen",
          "captionsenabled",
          "captionsdisabled",
          "languagechange",
          "controlshidden",
          "controlsshown",
          "ready",
          "statechange",
          "qualitychange",
          "adsloaded",
          "adscontentpause",
          "adscontentresume",
          "adstarted",
          "adsmidpoint",
          "adscomplete",
          "adsallcomplete",
          "adsimpression",
          "adsclick",
        ],
        selectors: {
          editable: "input, textarea, select, [contenteditable]",
          container: ".plyr",
          controls: { container: null, wrapper: ".plyr__controls" },
          labels: "[data-plyr]",
          buttons: {
            play: '[data-plyr="play"]',
            pause: '[data-plyr="pause"]',
            restart: '[data-plyr="restart"]',
            rewind: '[data-plyr="rewind"]',
            fastForward: '[data-plyr="fast-forward"]',
            mute: '[data-plyr="mute"]',
            captions: '[data-plyr="captions"]',
            download: '[data-plyr="download"]',
            fullscreen: '[data-plyr="fullscreen"]',
            pip: '[data-plyr="pip"]',
            airplay: '[data-plyr="airplay"]',
            settings: '[data-plyr="settings"]',
            loop: '[data-plyr="loop"]',
          },
          inputs: {
            seek: '[data-plyr="seek"]',
            volume: '[data-plyr="volume"]',
            speed: '[data-plyr="speed"]',
            language: '[data-plyr="language"]',
            quality: '[data-plyr="quality"]',
          },
          display: {
            currentTime: ".plyr__time--current",
            duration: ".plyr__time--duration",
            buffer: ".plyr__progress__buffer",
            loop: ".plyr__progress__loop",
            volume: ".plyr__volume--display",
          },
          progress: ".plyr__progress",
          captions: ".plyr__captions",
          caption: ".plyr__caption",
        },
        classNames: {
          type: "plyr--{0}",
          provider: "plyr--{0}",
          video: "plyr__video-wrapper",
          embed: "plyr__video-embed",
          videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
          embedContainer: "plyr__video-embed__container",
          poster: "plyr__poster",
          posterEnabled: "plyr__poster-enabled",
          ads: "plyr__ads",
          control: "plyr__control",
          controlPressed: "plyr__control--pressed",
          playing: "plyr--playing",
          paused: "plyr--paused",
          stopped: "plyr--stopped",
          loading: "plyr--loading",
          hover: "plyr--hover",
          tooltip: "plyr__tooltip",
          cues: "plyr__cues",
          hidden: "plyr__sr-only",
          hideControls: "plyr--hide-controls",
          isIos: "plyr--is-ios",
          isTouch: "plyr--is-touch",
          uiSupported: "plyr--full-ui",
          noTransition: "plyr--no-transition",
          display: { time: "plyr__time" },
          menu: {
            value: "plyr__menu__value",
            badge: "plyr__badge",
            open: "plyr--menu-open",
          },
          captions: {
            enabled: "plyr--captions-enabled",
            active: "plyr--captions-active",
          },
          fullscreen: {
            enabled: "plyr--fullscreen-enabled",
            fallback: "plyr--fullscreen-fallback",
          },
          pip: { supported: "plyr--pip-supported", active: "plyr--pip-active" },
          airplay: {
            supported: "plyr--airplay-supported",
            active: "plyr--airplay-active",
          },
          tabFocus: "plyr__tab-focus",
          previewThumbnails: {
            thumbContainer: "plyr__preview-thumb",
            thumbContainerShown: "plyr__preview-thumb--is-shown",
            imageContainer: "plyr__preview-thumb__image-container",
            timeContainer: "plyr__preview-thumb__time-container",
            scrubbingContainer: "plyr__preview-scrubbing",
            scrubbingContainerShown: "plyr__preview-scrubbing--is-shown",
          },
        },
        attributes: {
          embed: { provider: "data-plyr-provider", id: "data-plyr-embed-id" },
        },
        ads: { enabled: !1, publisherId: "", tagUrl: "" },
        previewThumbnails: { enabled: !1, src: "" },
        vimeo: {
          byline: !1,
          portrait: !1,
          title: !1,
          speed: !0,
          transparent: !1,
        },
        youtube: {
          noCookie: !1,
          rel: 0,
          showinfo: 0,
          iv_load_policy: 3,
          modestbranding: 1,
        },
      },
      Me = "picture-in-picture",
      xe = "inline",
      Le = { html5: "html5", youtube: "youtube", vimeo: "vimeo" },
      Ie = { audio: "audio", video: "video" };
    var _e = function () {},
      Oe = (function () {
        function t() {
          var n =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          e(this, t),
            (this.enabled = window.console && n),
            this.enabled && this.log("Debugging enabled");
        }
        return (
          n(t, [
            {
              key: "log",
              get: function () {
                return this.enabled
                  ? Function.prototype.bind.call(console.log, console)
                  : _e;
              },
            },
            {
              key: "warn",
              get: function () {
                return this.enabled
                  ? Function.prototype.bind.call(console.warn, console)
                  : _e;
              },
            },
            {
              key: "error",
              get: function () {
                return this.enabled
                  ? Function.prototype.bind.call(console.error, console)
                  : _e;
              },
            },
          ]),
          t
        );
      })();
    function je() {
      if (this.enabled) {
        var e = this.player.elements.buttons.fullscreen;
        N.element(e) && (e.pressed = this.active),
          H.call(
            this.player,
            this.target,
            this.active ? "enterfullscreen" : "exitfullscreen",
            !0
          ),
          L.isIos ||
            function () {
              var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : null,
                t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1];
              if (N.element(e)) {
                var n = G.call(
                    this,
                    "button:not(:disabled), input:not(:disabled), [tabindex]"
                  ),
                  i = n[0],
                  a = n[n.length - 1];
                _.call(
                  this,
                  this.elements.container,
                  "keydown",
                  function (e) {
                    if ("Tab" === e.key && 9 === e.keyCode) {
                      var t = document.activeElement;
                      t !== a || e.shiftKey
                        ? t === i &&
                          e.shiftKey &&
                          (a.focus(), e.preventDefault())
                        : (i.focus(), e.preventDefault());
                    }
                  },
                  t,
                  !1
                );
              }
            }.call(this.player, this.target, this.active);
      }
    }
    function qe() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (
        (e
          ? (this.scrollPosition = {
              x: window.scrollX || 0,
              y: window.scrollY || 0,
            })
          : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y),
        (document.body.style.overflow = e ? "hidden" : ""),
        X(this.target, this.player.config.classNames.fullscreen.fallback, e),
        L.isIos)
      ) {
        var t = document.head.querySelector('meta[name="viewport"]'),
          n = "viewport-fit=cover";
        t ||
          (t = document.createElement("meta")).setAttribute("name", "viewport");
        var i = N.string(t.content) && t.content.includes(n);
        e
          ? ((this.cleanupViewport = !i), i || (t.content += ",".concat(n)))
          : this.cleanupViewport &&
            (t.content = t.content
              .split(",")
              .filter(function (e) {
                return e.trim() !== n;
              })
              .join(","));
      }
      je.call(this);
    }
    var He = (function () {
      function t(n) {
        var i = this;
        e(this, t),
          (this.player = n),
          (this.prefix = t.prefix),
          (this.property = t.property),
          (this.scrollPosition = { x: 0, y: 0 }),
          (this.forceFallback = "force" === n.config.fullscreen.fallback),
          O.call(
            this.player,
            document,
            "ms" === this.prefix
              ? "MSFullscreenChange"
              : "".concat(this.prefix, "fullscreenchange"),
            function () {
              je.call(i);
            }
          ),
          O.call(
            this.player,
            this.player.elements.container,
            "dblclick",
            function (e) {
              (N.element(i.player.elements.controls) &&
                i.player.elements.controls.contains(e.target)) ||
                i.toggle();
            }
          ),
          this.update();
      }
      return (
        n(
          t,
          [
            {
              key: "update",
              value: function () {
                var e;
                this.enabled
                  ? ((e = this.forceFallback
                      ? "Fallback (forced)"
                      : t.native
                      ? "Native"
                      : "Fallback"),
                    this.player.debug.log("".concat(e, " fullscreen enabled")))
                  : this.player.debug.log(
                      "Fullscreen not supported and fallback disabled"
                    );
                X(
                  this.player.elements.container,
                  this.player.config.classNames.fullscreen.enabled,
                  this.enabled
                );
              },
            },
            {
              key: "enter",
              value: function () {
                this.enabled &&
                  (L.isIos && this.player.config.fullscreen.iosNative
                    ? this.target.webkitEnterFullscreen()
                    : !t.native || this.forceFallback
                    ? qe.call(this, !0)
                    : this.prefix
                    ? N.empty(this.prefix) ||
                      this.target[
                        "".concat(this.prefix, "Request").concat(this.property)
                      ]()
                    : this.target.requestFullscreen());
              },
            },
            {
              key: "exit",
              value: function () {
                if (this.enabled)
                  if (L.isIos && this.player.config.fullscreen.iosNative)
                    this.target.webkitExitFullscreen(), this.player.play();
                  else if (!t.native || this.forceFallback) qe.call(this, !1);
                  else if (this.prefix) {
                    if (!N.empty(this.prefix)) {
                      var e = "moz" === this.prefix ? "Cancel" : "Exit";
                      document[
                        "".concat(this.prefix).concat(e).concat(this.property)
                      ]();
                    }
                  } else
                    (document.cancelFullScreen || document.exitFullscreen).call(
                      document
                    );
              },
            },
            {
              key: "toggle",
              value: function () {
                this.active ? this.exit() : this.enter();
              },
            },
            {
              key: "usingNative",
              get: function () {
                return t.native && !this.forceFallback;
              },
            },
            {
              key: "enabled",
              get: function () {
                return (
                  (t.native || this.player.config.fullscreen.fallback) &&
                  this.player.config.fullscreen.enabled &&
                  this.player.supported.ui &&
                  this.player.isVideo
                );
              },
            },
            {
              key: "active",
              get: function () {
                return (
                  !!this.enabled &&
                  (!t.native || this.forceFallback
                    ? J(
                        this.target,
                        this.player.config.classNames.fullscreen.fallback
                      )
                    : (this.prefix
                        ? document[
                            ""
                              .concat(this.prefix)
                              .concat(this.property, "Element")
                          ]
                        : document.fullscreenElement) === this.target)
                );
              },
            },
            {
              key: "target",
              get: function () {
                return L.isIos && this.player.config.fullscreen.iosNative
                  ? this.player.media
                  : this.player.elements.container;
              },
            },
          ],
          [
            {
              key: "native",
              get: function () {
                return !!(
                  document.fullscreenEnabled ||
                  document.webkitFullscreenEnabled ||
                  document.mozFullScreenEnabled ||
                  document.msFullscreenEnabled
                );
              },
            },
            {
              key: "prefix",
              get: function () {
                if (N.function(document.exitFullscreen)) return "";
                var e = "";
                return (
                  ["webkit", "moz", "ms"].some(function (t) {
                    return (
                      !(
                        !N.function(document["".concat(t, "ExitFullscreen")]) &&
                        !N.function(document["".concat(t, "CancelFullScreen")])
                      ) && ((e = t), !0)
                    );
                  }),
                  e
                );
              },
            },
            {
              key: "property",
              get: function () {
                return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
              },
            },
          ]
        ),
        t
      );
    })();
    function De(e) {
      var t =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
      return new Promise(function (n, i) {
        var a = new Image(),
          s = function () {
            delete a.onload, delete a.onerror, (a.naturalWidth >= t ? n : i)(a);
          };
        Object.assign(a, { onload: s, onerror: s, src: e });
      });
    }
    var Fe = {
        addStyleHook: function () {
          X(
            this.elements.container,
            this.config.selectors.container.replace(".", ""),
            !0
          ),
            X(
              this.elements.container,
              this.config.classNames.uiSupported,
              this.supported.ui
            );
        },
        toggleNativeControls: function () {
          arguments.length > 0 &&
          void 0 !== arguments[0] &&
          arguments[0] &&
          this.isHTML5
            ? this.media.setAttribute("controls", "")
            : this.media.removeAttribute("controls");
        },
        build: function () {
          var e = this;
          if ((this.listeners.media(), !this.supported.ui))
            return (
              this.debug.warn(
                "Basic support only for "
                  .concat(this.provider, " ")
                  .concat(this.type)
              ),
              void Fe.toggleNativeControls.call(this, !0)
            );
          N.element(this.elements.controls) ||
            (Ae.inject.call(this), this.listeners.controls()),
            Fe.toggleNativeControls.call(this),
            this.isHTML5 && Pe.setup.call(this),
            (this.volume = null),
            (this.muted = null),
            (this.loop = null),
            (this.quality = null),
            (this.speed = null),
            Ae.updateVolume.call(this),
            Ae.timeUpdate.call(this),
            Fe.checkPlaying.call(this),
            X(
              this.elements.container,
              this.config.classNames.pip.supported,
              ie.pip && this.isHTML5 && this.isVideo
            ),
            X(
              this.elements.container,
              this.config.classNames.airplay.supported,
              ie.airplay && this.isHTML5
            ),
            X(this.elements.container, this.config.classNames.isIos, L.isIos),
            X(
              this.elements.container,
              this.config.classNames.isTouch,
              this.touch
            ),
            (this.ready = !0),
            setTimeout(function () {
              H.call(e, e.media, "ready");
            }, 0),
            Fe.setTitle.call(this),
            this.poster &&
              Fe.setPoster.call(this, this.poster, !1).catch(function () {}),
            this.config.duration && Ae.durationUpdate.call(this);
        },
        setTitle: function () {
          var e = ge("play", this.config);
          if (
            (N.string(this.config.title) &&
              !N.empty(this.config.title) &&
              (e += ", ".concat(this.config.title)),
            Array.from(this.elements.buttons.play || []).forEach(function (t) {
              t.setAttribute("aria-label", e);
            }),
            this.isEmbed)
          ) {
            var t = Z.call(this, "iframe");
            if (!N.element(t)) return;
            var n = N.empty(this.config.title) ? "video" : this.config.title,
              i = ge("frameTitle", this.config);
            t.setAttribute("title", i.replace("{title}", n));
          }
        },
        togglePoster: function (e) {
          X(this.elements.container, this.config.classNames.posterEnabled, e);
        },
        setPoster: function (e) {
          var t = this;
          return (arguments.length > 1 &&
            void 0 !== arguments[1] &&
            !arguments[1]) ||
            !this.poster
            ? (this.media.setAttribute("poster", e),
              function () {
                var e = this;
                return new Promise(function (t) {
                  return e.ready
                    ? setTimeout(t, 0)
                    : O.call(e, e.elements.container, "ready", t);
                }).then(function () {});
              }
                .call(this)
                .then(function () {
                  return De(e);
                })
                .catch(function (n) {
                  throw (e === t.poster && Fe.togglePoster.call(t, !1), n);
                })
                .then(function () {
                  if (e !== t.poster)
                    throw new Error(
                      "setPoster cancelled by later call to setPoster"
                    );
                })
                .then(function () {
                  return (
                    Object.assign(t.elements.poster.style, {
                      backgroundImage: "url('".concat(e, "')"),
                      backgroundSize: "",
                    }),
                    Fe.togglePoster.call(t, !0),
                    e
                  );
                }))
            : Promise.reject(new Error("Poster already set"));
        },
        checkPlaying: function (e) {
          var t = this;
          X(
            this.elements.container,
            this.config.classNames.playing,
            this.playing
          ),
            X(
              this.elements.container,
              this.config.classNames.paused,
              this.paused
            ),
            X(
              this.elements.container,
              this.config.classNames.stopped,
              this.stopped
            ),
            Array.from(this.elements.buttons.play || []).forEach(function (e) {
              Object.assign(e, { pressed: t.playing });
            }),
            (N.event(e) && "timeupdate" === e.type) ||
              Fe.toggleControls.call(this);
        },
        checkLoading: function (e) {
          var t = this;
          (this.loading = ["stalled", "waiting"].includes(e.type)),
            clearTimeout(this.timers.loading),
            (this.timers.loading = setTimeout(
              function () {
                X(t.elements.container, t.config.classNames.loading, t.loading),
                  Fe.toggleControls.call(t);
              },
              this.loading ? 250 : 0
            ));
        },
        toggleControls: function (e) {
          var t = this.elements.controls;
          if (t && this.config.hideControls) {
            var n = this.touch && this.lastSeekTime + 2e3 > Date.now();
            this.toggleControls(
              Boolean(
                e || this.loading || this.paused || t.pressed || t.hover || n
              )
            );
          }
        },
      },
      Re = (function () {
        function t(n) {
          e(this, t),
            (this.player = n),
            (this.lastKey = null),
            (this.focusTimer = null),
            (this.lastKeyDown = null),
            (this.handleKey = this.handleKey.bind(this)),
            (this.toggleMenu = this.toggleMenu.bind(this)),
            (this.setTabFocus = this.setTabFocus.bind(this)),
            (this.firstTouch = this.firstTouch.bind(this));
        }
        return (
          n(t, [
            {
              key: "handleKey",
              value: function (e) {
                var t = this.player,
                  n = t.elements,
                  i = e.keyCode ? e.keyCode : e.which,
                  a = "keydown" === e.type,
                  s = a && i === this.lastKey;
                if (
                  !(e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) &&
                  N.number(i)
                ) {
                  if (a) {
                    var r = document.activeElement;
                    if (N.element(r)) {
                      var o = t.config.selectors.editable;
                      if (r !== n.inputs.seek && $(r, o)) return;
                      if (32 === e.which && $(r, 'button, [role^="menuitem"]'))
                        return;
                    }
                    switch (
                      ([
                        32,
                        37,
                        38,
                        39,
                        40,
                        48,
                        49,
                        50,
                        51,
                        52,
                        53,
                        54,
                        56,
                        57,
                        67,
                        70,
                        73,
                        75,
                        76,
                        77,
                        79,
                      ].includes(i) &&
                        (e.preventDefault(), e.stopPropagation()),
                      i)
                    ) {
                      case 48:
                      case 49:
                      case 50:
                      case 51:
                      case 52:
                      case 53:
                      case 54:
                      case 55:
                      case 56:
                      case 57:
                        s || (t.currentTime = (t.duration / 10) * (i - 48));
                        break;
                      case 32:
                      case 75:
                        s || t.togglePlay();
                        break;
                      case 38:
                        t.increaseVolume(0.1);
                        break;
                      case 40:
                        t.decreaseVolume(0.1);
                        break;
                      case 77:
                        s || (t.muted = !t.muted);
                        break;
                      case 39:
                        t.forward();
                        break;
                      case 37:
                        t.rewind();
                        break;
                      case 70:
                        t.fullscreen.toggle();
                        break;
                      case 67:
                        s || t.toggleCaptions();
                        break;
                      case 76:
                        t.loop = !t.loop;
                    }
                    27 === i &&
                      !t.fullscreen.usingNative &&
                      t.fullscreen.active &&
                      t.fullscreen.toggle(),
                      (this.lastKey = i);
                  } else this.lastKey = null;
                }
              },
            },
            {
              key: "toggleMenu",
              value: function (e) {
                Ae.toggleMenu.call(this.player, e);
              },
            },
            {
              key: "firstTouch",
              value: function () {
                var e = this.player,
                  t = e.elements;
                (e.touch = !0), X(t.container, e.config.classNames.isTouch, !0);
              },
            },
            {
              key: "setTabFocus",
              value: function (e) {
                var t = this.player,
                  n = t.elements;
                if (
                  (clearTimeout(this.focusTimer),
                  "keydown" !== e.type || 9 === e.which)
                ) {
                  "keydown" === e.type && (this.lastKeyDown = e.timeStamp);
                  var i,
                    a = e.timeStamp - this.lastKeyDown <= 20;
                  if ("focus" !== e.type || a)
                    (i = t.config.classNames.tabFocus),
                      X(G.call(t, ".".concat(i)), i, !1),
                      (this.focusTimer = setTimeout(function () {
                        var e = document.activeElement;
                        n.container.contains(e) &&
                          X(
                            document.activeElement,
                            t.config.classNames.tabFocus,
                            !0
                          );
                      }, 10));
                }
              },
            },
            {
              key: "global",
              value: function () {
                var e =
                    !(arguments.length > 0 && void 0 !== arguments[0]) ||
                    arguments[0],
                  t = this.player;
                t.config.keyboard.global &&
                  _.call(t, window, "keydown keyup", this.handleKey, e, !1),
                  _.call(t, document.body, "click", this.toggleMenu, e),
                  q.call(t, document.body, "touchstart", this.firstTouch),
                  _.call(
                    t,
                    document.body,
                    "keydown focus blur",
                    this.setTabFocus,
                    e,
                    !1,
                    !0
                  );
              },
            },
            {
              key: "container",
              value: function () {
                var e = this.player,
                  t = e.config,
                  n = e.elements,
                  i = e.timers;
                !t.keyboard.global &&
                  t.keyboard.focused &&
                  O.call(e, n.container, "keydown keyup", this.handleKey, !1),
                  O.call(
                    e,
                    n.container,
                    "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen",
                    function (t) {
                      var a = n.controls;
                      a &&
                        "enterfullscreen" === t.type &&
                        ((a.pressed = !1), (a.hover = !1));
                      var s = 0;
                      ["touchstart", "touchmove", "mousemove"].includes(
                        t.type
                      ) &&
                        (Fe.toggleControls.call(e, !0),
                        (s = e.touch ? 3e3 : 2e3)),
                        clearTimeout(i.controls),
                        (i.controls = setTimeout(function () {
                          return Fe.toggleControls.call(e, !1);
                        }, s));
                    }
                  );
                var s = function (t) {
                    if (!t) return oe.call(e);
                    var i = n.container.getBoundingClientRect(),
                      a = i.width,
                      s = i.height;
                    return oe.call(e, "".concat(a, ":").concat(s));
                  },
                  r = function () {
                    clearTimeout(i.resized), (i.resized = setTimeout(s, 50));
                  };
                O.call(
                  e,
                  n.container,
                  "enterfullscreen exitfullscreen",
                  function (t) {
                    var i = e.fullscreen,
                      o = i.target,
                      l = i.usingNative;
                    if (
                      o === n.container &&
                      (e.isEmbed || !N.empty(e.config.ratio))
                    ) {
                      var c = "enterfullscreen" === t.type,
                        u = s(c);
                      u.padding;
                      !(function (t, n, i) {
                        if (e.isVimeo) {
                          var s = e.elements.wrapper.firstChild,
                            r = a(t, 2)[1],
                            o = a(re.call(e), 2),
                            l = o[0],
                            c = o[1];
                          (s.style.maxWidth = i
                            ? "".concat((r / c) * l, "px")
                            : null),
                            (s.style.margin = i ? "0 auto" : null);
                        }
                      })(u.ratio, 0, c),
                        l ||
                          (c
                            ? O.call(e, window, "resize", r)
                            : j.call(e, window, "resize", r));
                    }
                  }
                );
              },
            },
            {
              key: "media",
              value: function () {
                var e = this,
                  t = this.player,
                  n = t.elements;
                if (
                  (O.call(t, t.media, "timeupdate seeking seeked", function (
                    e
                  ) {
                    return Ae.timeUpdate.call(t, e);
                  }),
                  O.call(
                    t,
                    t.media,
                    "durationchange loadeddata loadedmetadata",
                    function (e) {
                      return Ae.durationUpdate.call(t, e);
                    }
                  ),
                  O.call(t, t.media, "canplay loadeddata", function () {
                    Q(n.volume, !t.hasAudio), Q(n.buttons.mute, !t.hasAudio);
                  }),
                  O.call(t, t.media, "ended", function () {
                    t.isHTML5 &&
                      t.isVideo &&
                      t.config.resetOnEnd &&
                      t.restart();
                  }),
                  O.call(
                    t,
                    t.media,
                    "progress playing seeking seeked",
                    function (e) {
                      return Ae.updateProgress.call(t, e);
                    }
                  ),
                  O.call(t, t.media, "volumechange", function (e) {
                    return Ae.updateVolume.call(t, e);
                  }),
                  O.call(
                    t,
                    t.media,
                    "playing play pause ended emptied timeupdate",
                    function (e) {
                      return Fe.checkPlaying.call(t, e);
                    }
                  ),
                  O.call(
                    t,
                    t.media,
                    "waiting canplay seeked playing",
                    function (e) {
                      return Fe.checkLoading.call(t, e);
                    }
                  ),
                  t.supported.ui && t.config.clickToPlay && !t.isAudio)
                ) {
                  var i = Z.call(t, ".".concat(t.config.classNames.video));
                  if (!N.element(i)) return;
                  O.call(t, n.container, "click", function (a) {
                    ([n.container, i].includes(a.target) ||
                      i.contains(a.target)) &&
                      ((t.touch && t.config.hideControls) ||
                        (t.ended
                          ? (e.proxy(a, t.restart, "restart"),
                            e.proxy(a, t.play, "play"))
                          : e.proxy(a, t.togglePlay, "play")));
                  });
                }
                t.supported.ui &&
                  t.config.disableContextMenu &&
                  O.call(
                    t,
                    n.wrapper,
                    "contextmenu",
                    function (e) {
                      e.preventDefault();
                    },
                    !1
                  ),
                  O.call(t, t.media, "volumechange", function () {
                    t.storage.set({ volume: t.volume, muted: t.muted });
                  }),
                  O.call(t, t.media, "ratechange", function () {
                    Ae.updateSetting.call(t, "speed"),
                      t.storage.set({ speed: t.speed });
                  }),
                  O.call(t, t.media, "qualitychange", function (e) {
                    Ae.updateSetting.call(t, "quality", null, e.detail.quality);
                  }),
                  O.call(t, t.media, "ready qualitychange", function () {
                    Ae.setDownloadUrl.call(t);
                  });
                var a = t.config.events.concat(["keyup", "keydown"]).join(" ");
                O.call(t, t.media, a, function (e) {
                  var i = e.detail,
                    a = void 0 === i ? {} : i;
                  "error" === e.type && (a = t.media.error),
                    H.call(t, n.container, e.type, !0, a);
                });
              },
            },
            {
              key: "proxy",
              value: function (e, t, n) {
                var i = this.player,
                  a = i.config.listeners[n],
                  s = !0;
                N.function(a) && (s = a.call(i, e)),
                  s && N.function(t) && t.call(i, e);
              },
            },
            {
              key: "bind",
              value: function (e, t, n, i) {
                var a = this,
                  s =
                    !(arguments.length > 4 && void 0 !== arguments[4]) ||
                    arguments[4],
                  r = this.player,
                  o = r.config.listeners[i],
                  l = N.function(o);
                O.call(
                  r,
                  e,
                  t,
                  function (e) {
                    return a.proxy(e, n, i);
                  },
                  s && !l
                );
              },
            },
            {
              key: "controls",
              value: function () {
                var e = this,
                  t = this.player,
                  n = t.elements,
                  i = L.isIE ? "change" : "input";
                if (
                  (n.buttons.play &&
                    Array.from(n.buttons.play).forEach(function (n) {
                      e.bind(n, "click", t.togglePlay, "play");
                    }),
                  this.bind(n.buttons.restart, "click", t.restart, "restart"),
                  this.bind(n.buttons.rewind, "click", t.rewind, "rewind"),
                  this.bind(
                    n.buttons.fastForward,
                    "click",
                    t.forward,
                    "fastForward"
                  ),
                  this.bind(
                    n.buttons.mute,
                    "click",
                    function () {
                      t.muted = !t.muted;
                    },
                    "mute"
                  ),
                  this.bind(n.buttons.captions, "click", function () {
                    return t.toggleCaptions();
                  }),
                  this.bind(
                    n.buttons.download,
                    "click",
                    function () {
                      H.call(t, t.media, "download");
                    },
                    "download"
                  ),
                  this.bind(
                    n.buttons.fullscreen,
                    "click",
                    function () {
                      t.fullscreen.toggle();
                    },
                    "fullscreen"
                  ),
                  this.bind(
                    n.buttons.pip,
                    "click",
                    function () {
                      t.pip = "toggle";
                    },
                    "pip"
                  ),
                  this.bind(n.buttons.airplay, "click", t.airplay, "airplay"),
                  this.bind(n.buttons.settings, "click", function (e) {
                    e.stopPropagation(), Ae.toggleMenu.call(t, e);
                  }),
                  this.bind(
                    n.buttons.settings,
                    "keyup",
                    function (e) {
                      var n = e.which;
                      [13, 32].includes(n) &&
                        (13 !== n
                          ? (e.preventDefault(),
                            e.stopPropagation(),
                            Ae.toggleMenu.call(t, e))
                          : Ae.focusFirstMenuItem.call(t, null, !0));
                    },
                    null,
                    !1
                  ),
                  this.bind(n.settings.menu, "keydown", function (e) {
                    27 === e.which && Ae.toggleMenu.call(t, e);
                  }),
                  this.bind(n.inputs.seek, "mousedown mousemove", function (e) {
                    var t = n.progress.getBoundingClientRect(),
                      i = (100 / t.width) * (e.pageX - t.left);
                    e.currentTarget.setAttribute("seek-value", i);
                  }),
                  this.bind(
                    n.inputs.seek,
                    "mousedown mouseup keydown keyup touchstart touchend",
                    function (e) {
                      var n = e.currentTarget,
                        i = e.keyCode ? e.keyCode : e.which;
                      if (!N.keyboardEvent(e) || 39 === i || 37 === i) {
                        t.lastSeekTime = Date.now();
                        var a = n.hasAttribute("play-on-seeked"),
                          s = ["mouseup", "touchend", "keyup"].includes(e.type);
                        a && s
                          ? (n.removeAttribute("play-on-seeked"), t.play())
                          : !s &&
                            t.playing &&
                            (n.setAttribute("play-on-seeked", ""), t.pause());
                      }
                    }
                  ),
                  L.isIos)
                ) {
                  var s = G.call(t, 'input[type="range"]');
                  Array.from(s).forEach(function (t) {
                    return e.bind(t, i, function (e) {
                      return x(e.target);
                    });
                  });
                }
                this.bind(
                  n.inputs.seek,
                  i,
                  function (e) {
                    var n = e.currentTarget,
                      i = n.getAttribute("seek-value");
                    N.empty(i) && (i = n.value),
                      n.removeAttribute("seek-value"),
                      (t.currentTime = (i / n.max) * t.duration);
                  },
                  "seek"
                ),
                  this.bind(
                    n.progress,
                    "mouseenter mouseleave mousemove",
                    function (e) {
                      return Ae.updateSeekTooltip.call(t, e);
                    }
                  ),
                  this.bind(n.progress, "mousemove touchmove", function (e) {
                    var n = t.previewThumbnails;
                    n && n.loaded && n.startMove(e);
                  }),
                  this.bind(n.progress, "mouseleave click", function () {
                    var e = t.previewThumbnails;
                    e && e.loaded && e.endMove(!1, !0);
                  }),
                  this.bind(n.progress, "mousedown touchstart", function (e) {
                    var n = t.previewThumbnails;
                    n && n.loaded && n.startScrubbing(e);
                  }),
                  this.bind(n.progress, "mouseup touchend", function (e) {
                    var n = t.previewThumbnails;
                    n && n.loaded && n.endScrubbing(e);
                  }),
                  L.isWebkit &&
                    Array.from(G.call(t, 'input[type="range"]')).forEach(
                      function (n) {
                        e.bind(n, "input", function (e) {
                          return Ae.updateRangeFill.call(t, e.target);
                        });
                      }
                    ),
                  t.config.toggleInvert &&
                    !N.element(n.display.duration) &&
                    this.bind(n.display.currentTime, "click", function () {
                      0 !== t.currentTime &&
                        ((t.config.invertTime = !t.config.invertTime),
                        Ae.timeUpdate.call(t));
                    }),
                  this.bind(
                    n.inputs.volume,
                    i,
                    function (e) {
                      t.volume = e.target.value;
                    },
                    "volume"
                  ),
                  this.bind(n.controls, "mouseenter mouseleave", function (e) {
                    n.controls.hover = !t.touch && "mouseenter" === e.type;
                  }),
                  this.bind(
                    n.controls,
                    "mousedown mouseup touchstart touchend touchcancel",
                    function (e) {
                      n.controls.pressed = ["mousedown", "touchstart"].includes(
                        e.type
                      );
                    }
                  ),
                  this.bind(n.controls, "focusin", function () {
                    var i = t.config,
                      a = t.timers;
                    X(n.controls, i.classNames.noTransition, !0),
                      Fe.toggleControls.call(t, !0),
                      setTimeout(function () {
                        X(n.controls, i.classNames.noTransition, !1);
                      }, 0);
                    var s = e.touch ? 3e3 : 4e3;
                    clearTimeout(a.controls),
                      (a.controls = setTimeout(function () {
                        return Fe.toggleControls.call(t, !1);
                      }, s));
                  }),
                  this.bind(
                    n.inputs.volume,
                    "wheel",
                    function (e) {
                      var n = e.webkitDirectionInvertedFromDevice,
                        i = a(
                          [e.deltaX, -e.deltaY].map(function (e) {
                            return n ? -e : e;
                          }),
                          2
                        ),
                        s = i[0],
                        r = i[1],
                        o = Math.sign(Math.abs(s) > Math.abs(r) ? s : r);
                      t.increaseVolume(o / 50);
                      var l = t.media.volume;
                      ((1 === o && l < 1) || (-1 === o && l > 0)) &&
                        e.preventDefault();
                    },
                    "volume",
                    !1
                  );
              },
            },
          ]),
          t
        );
      })();
    "undefined" != typeof globalThis
      ? globalThis
      : "undefined" != typeof window
      ? window
      : "undefined" != typeof global
      ? global
      : "undefined" != typeof self && self;
    var Ve = (function (e, t) {
      return e((t = { exports: {} }), t.exports), t.exports;
    })(function (e, t) {
      e.exports = (function () {
        var e = function () {},
          t = {},
          n = {},
          i = {};
        function a(e, t) {
          if (e) {
            var a = i[e];
            if (((n[e] = t), a)) for (; a.length; ) a[0](e, t), a.splice(0, 1);
          }
        }
        function s(t, n) {
          t.call && (t = { success: t }),
            n.length ? (t.error || e)(n) : (t.success || e)(t);
        }
        function r(t, n, i, a) {
          var s,
            o,
            l = document,
            c = i.async,
            u = (i.numRetries || 0) + 1,
            d = i.before || e,
            h = t.replace(/^(css|img)!/, "");
          (a = a || 0),
            /(^css!|\.css$)/.test(t)
              ? (((o = l.createElement("link")).rel = "stylesheet"),
                (o.href = h),
                (s = "hideFocus" in o) &&
                  o.relList &&
                  ((s = 0), (o.rel = "preload"), (o.as = "style")))
              : /(^img!|\.(png|gif|jpg|svg)$)/.test(t)
              ? ((o = l.createElement("img")).src = h)
              : (((o = l.createElement("script")).src = t),
                (o.async = void 0 === c || c)),
            (o.onload = o.onerror = o.onbeforeload = function (e) {
              var l = e.type[0];
              if (s)
                try {
                  o.sheet.cssText.length || (l = "e");
                } catch (e) {
                  18 != e.code && (l = "e");
                }
              if ("e" == l) {
                if ((a += 1) < u) return r(t, n, i, a);
              } else if ("preload" == o.rel && "style" == o.as)
                return (o.rel = "stylesheet");
              n(t, l, e.defaultPrevented);
            }),
            !1 !== d(t, o) && l.head.appendChild(o);
        }
        function o(e, n, i) {
          var o, l;
          if ((n && n.trim && (o = n), (l = (o ? i : n) || {}), o)) {
            if (o in t) throw "LoadJS";
            t[o] = !0;
          }
          function c(t, n) {
            !(function (e, t, n) {
              var i,
                a,
                s = (e = e.push ? e : [e]).length,
                o = s,
                l = [];
              for (
                i = function (e, n, i) {
                  if (("e" == n && l.push(e), "b" == n)) {
                    if (!i) return;
                    l.push(e);
                  }
                  --s || t(l);
                },
                  a = 0;
                a < o;
                a++
              )
                r(e[a], i, n);
            })(
              e,
              function (e) {
                s(l, e), t && s({ success: t, error: n }, e), a(o, e);
              },
              l
            );
          }
          if (l.returnPromise) return new Promise(c);
          c();
        }
        return (
          (o.ready = function (e, t) {
            return (
              (function (e, t) {
                e = e.push ? e : [e];
                var a,
                  s,
                  r,
                  o = [],
                  l = e.length,
                  c = l;
                for (
                  a = function (e, n) {
                    n.length && o.push(e), --c || t(o);
                  };
                  l--;

                )
                  (s = e[l]),
                    (r = n[s]) ? a(s, r) : (i[s] = i[s] || []).push(a);
              })(e, function (e) {
                s(t, e);
              }),
              o
            );
          }),
          (o.done = function (e) {
            a(e, []);
          }),
          (o.reset = function () {
            (t = {}), (n = {}), (i = {});
          }),
          (o.isDefined = function (e) {
            return e in t;
          }),
          o
        );
      })();
    });
    function Be(e) {
      return new Promise(function (t, n) {
        Ve(e, { success: t, error: n });
      });
    }
    function Ue(e) {
      e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0),
        this.media.paused === e &&
          ((this.media.paused = !e),
          H.call(this, this.media, e ? "play" : "pause"));
    }
    var We = {
      setup: function () {
        var e = this;
        X(this.elements.wrapper, this.config.classNames.embed, !0),
          oe.call(this),
          N.object(window.Vimeo)
            ? We.ready.call(this)
            : Be(this.config.urls.vimeo.sdk)
                .then(function () {
                  We.ready.call(e);
                })
                .catch(function (t) {
                  e.debug.warn("Vimeo SDK (player.js) failed to load", t);
                });
      },
      ready: function () {
        var e = this,
          t = this,
          n = t.config.vimeo,
          i = Se(
            F(
              {},
              {
                loop: t.config.loop.active,
                autoplay: t.autoplay,
                muted: t.muted,
                gesture: "media",
                playsinline: !this.config.fullscreen.iosNative,
              },
              n
            )
          ),
          s = t.media.getAttribute("src");
        N.empty(s) && (s = t.media.getAttribute(t.config.attributes.embed.id));
        var r,
          o =
            ((r = s),
            N.empty(r)
              ? null
              : N.number(Number(r))
              ? r
              : r.match(/^.*(vimeo.com\/|video\/)(\d+).*/)
              ? RegExp.$2
              : r),
          l = B("iframe"),
          c = ue(t.config.urls.vimeo.iframe, o, i);
        l.setAttribute("src", c),
          l.setAttribute("allowfullscreen", ""),
          l.setAttribute("allowtransparency", ""),
          l.setAttribute("allow", "autoplay");
        var u = B("div", {
          poster: t.poster,
          class: t.config.classNames.embedContainer,
        });
        u.appendChild(l),
          (t.media = K(u, t.media)),
          ve(ue(t.config.urls.vimeo.api, o), "json").then(function (e) {
            if (!N.empty(e)) {
              var n = new URL(e[0].thumbnail_large);
              (n.pathname = "".concat(n.pathname.split("_")[0], ".jpg")),
                Fe.setPoster.call(t, n.href).catch(function () {});
            }
          }),
          (t.embed = new window.Vimeo.Player(l, {
            autopause: t.config.autopause,
            muted: t.muted,
          })),
          (t.media.paused = !0),
          (t.media.currentTime = 0),
          t.supported.ui && t.embed.disableTextTrack(),
          (t.media.play = function () {
            return Ue.call(t, !0), t.embed.play();
          }),
          (t.media.pause = function () {
            return Ue.call(t, !1), t.embed.pause();
          }),
          (t.media.stop = function () {
            t.pause(), (t.currentTime = 0);
          });
        var d = t.media.currentTime;
        Object.defineProperty(t.media, "currentTime", {
          get: function () {
            return d;
          },
          set: function (e) {
            var n = t.embed,
              i = t.media,
              a = t.paused,
              s = t.volume,
              r = a && !n.hasPlayed;
            (i.seeking = !0),
              H.call(t, i, "seeking"),
              Promise.resolve(r && n.setVolume(0))
                .then(function () {
                  return n.setCurrentTime(e);
                })
                .then(function () {
                  return r && n.pause();
                })
                .then(function () {
                  return r && n.setVolume(s);
                })
                .catch(function () {});
          },
        });
        var h = t.config.speed.selected;
        Object.defineProperty(t.media, "playbackRate", {
          get: function () {
            return h;
          },
          set: function (e) {
            t.embed
              .setPlaybackRate(e)
              .then(function () {
                (h = e), H.call(t, t.media, "ratechange");
              })
              .catch(function (e) {
                "Error" === e.name && Ae.setSpeedMenu.call(t, []);
              });
          },
        });
        var m = t.config.volume;
        Object.defineProperty(t.media, "volume", {
          get: function () {
            return m;
          },
          set: function (e) {
            t.embed.setVolume(e).then(function () {
              (m = e), H.call(t, t.media, "volumechange");
            });
          },
        });
        var p = t.config.muted;
        Object.defineProperty(t.media, "muted", {
          get: function () {
            return p;
          },
          set: function (e) {
            var n = !!N.boolean(e) && e;
            t.embed.setVolume(n ? 0 : t.config.volume).then(function () {
              (p = n), H.call(t, t.media, "volumechange");
            });
          },
        });
        var f,
          g = t.config.loop;
        Object.defineProperty(t.media, "loop", {
          get: function () {
            return g;
          },
          set: function (e) {
            var n = N.boolean(e) ? e : t.config.loop.active;
            t.embed.setLoop(n).then(function () {
              g = n;
            });
          },
        }),
          t.embed
            .getVideoUrl()
            .then(function (e) {
              (f = e), Ae.setDownloadUrl.call(t);
            })
            .catch(function (t) {
              e.debug.warn(t);
            }),
          Object.defineProperty(t.media, "currentSrc", {
            get: function () {
              return f;
            },
          }),
          Object.defineProperty(t.media, "ended", {
            get: function () {
              return t.currentTime === t.duration;
            },
          }),
          Promise.all([t.embed.getVideoWidth(), t.embed.getVideoHeight()]).then(
            function (n) {
              var i = a(n, 2),
                s = i[0],
                r = i[1];
              (t.embed.ratio = [s, r]), oe.call(e);
            }
          ),
          t.embed.setAutopause(t.config.autopause).then(function (e) {
            t.config.autopause = e;
          }),
          t.embed.getVideoTitle().then(function (n) {
            (t.config.title = n), Fe.setTitle.call(e);
          }),
          t.embed.getCurrentTime().then(function (e) {
            (d = e), H.call(t, t.media, "timeupdate");
          }),
          t.embed.getDuration().then(function (e) {
            (t.media.duration = e), H.call(t, t.media, "durationchange");
          }),
          t.embed.getTextTracks().then(function (e) {
            (t.media.textTracks = e), Pe.setup.call(t);
          }),
          t.embed.on("cuechange", function (e) {
            var n = e.cues,
              i = (void 0 === n ? [] : n).map(function (e) {
                return (function (e) {
                  var t = document.createDocumentFragment(),
                    n = document.createElement("div");
                  return (
                    t.appendChild(n), (n.innerHTML = e), t.firstChild.innerText
                  );
                })(e.text);
              });
            Pe.updateCues.call(t, i);
          }),
          t.embed.on("loaded", function () {
            (t.embed.getPaused().then(function (e) {
              Ue.call(t, !e), e || H.call(t, t.media, "playing");
            }),
            N.element(t.embed.element) && t.supported.ui) &&
              t.embed.element.setAttribute("tabindex", -1);
          }),
          t.embed.on("play", function () {
            Ue.call(t, !0), H.call(t, t.media, "playing");
          }),
          t.embed.on("pause", function () {
            Ue.call(t, !1);
          }),
          t.embed.on("timeupdate", function (e) {
            (t.media.seeking = !1),
              (d = e.seconds),
              H.call(t, t.media, "timeupdate");
          }),
          t.embed.on("progress", function (e) {
            (t.media.buffered = e.percent),
              H.call(t, t.media, "progress"),
              1 === parseInt(e.percent, 10) &&
                H.call(t, t.media, "canplaythrough"),
              t.embed.getDuration().then(function (e) {
                e !== t.media.duration &&
                  ((t.media.duration = e),
                  H.call(t, t.media, "durationchange"));
              });
          }),
          t.embed.on("seeked", function () {
            (t.media.seeking = !1), H.call(t, t.media, "seeked");
          }),
          t.embed.on("ended", function () {
            (t.media.paused = !0), H.call(t, t.media, "ended");
          }),
          t.embed.on("error", function (e) {
            (t.media.error = e), H.call(t, t.media, "error");
          }),
          setTimeout(function () {
            return Fe.build.call(t);
          }, 0);
      },
    };
    function ze(e) {
      e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0),
        this.media.paused === e &&
          ((this.media.paused = !e),
          H.call(this, this.media, e ? "play" : "pause"));
    }
    function Ke(e) {
      return e.noCookie
        ? "https://www.youtube-nocookie.com"
        : "http:" === window.location.protocol
        ? "http://www.youtube.com"
        : void 0;
    }
    var Ye = {
        setup: function () {
          var e = this;
          if (
            (X(this.elements.wrapper, this.config.classNames.embed, !0),
            N.object(window.YT) && N.function(window.YT.Player))
          )
            Ye.ready.call(this);
          else {
            var t = window.onYouTubeIframeAPIReady;
            (window.onYouTubeIframeAPIReady = function () {
              N.function(t) && t(), Ye.ready.call(e);
            }),
              Be(this.config.urls.youtube.sdk).catch(function (t) {
                e.debug.warn("YouTube API failed to load", t);
              });
          }
        },
        getTitle: function (e) {
          var t = this;
          ve(ue(this.config.urls.youtube.api, e))
            .then(function (e) {
              if (N.object(e)) {
                var n = e.title,
                  i = e.height,
                  a = e.width;
                (t.config.title = n),
                  Fe.setTitle.call(t),
                  (t.embed.ratio = [a, i]);
              }
              oe.call(t);
            })
            .catch(function () {
              oe.call(t);
            });
        },
        ready: function () {
          var e = this,
            t = e.media && e.media.getAttribute("id");
          if (N.empty(t) || !t.startsWith("youtube-")) {
            var n = e.media.getAttribute("src");
            N.empty(n) &&
              (n = e.media.getAttribute(this.config.attributes.embed.id));
            var i,
              a,
              s =
                ((i = n),
                N.empty(i)
                  ? null
                  : i.match(
                      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
                    )
                  ? RegExp.$2
                  : i),
              r =
                ((a = e.provider),
                "".concat(a, "-").concat(Math.floor(1e4 * Math.random()))),
              o = B("div", { id: r, poster: e.poster });
            e.media = K(o, e.media);
            var l = function (e) {
              return "https://i.ytimg.com/vi/"
                .concat(s, "/")
                .concat(e, "default.jpg");
            };
            De(l("maxres"), 121)
              .catch(function () {
                return De(l("sd"), 121);
              })
              .catch(function () {
                return De(l("hq"));
              })
              .then(function (t) {
                return Fe.setPoster.call(e, t.src);
              })
              .then(function (t) {
                t.includes("maxres") ||
                  (e.elements.poster.style.backgroundSize = "cover");
              })
              .catch(function () {});
            var c = e.config.youtube;
            e.embed = new window.YT.Player(r, {
              videoId: s,
              host: Ke(c),
              playerVars: F(
                {},
                {
                  autoplay: e.config.autoplay ? 1 : 0,
                  hl: e.config.hl,
                  controls: e.supported.ui ? 0 : 1,
                  disablekb: 1,
                  playsinline: e.config.fullscreen.iosNative ? 0 : 1,
                  cc_load_policy: e.captions.active ? 1 : 0,
                  cc_lang_pref: e.config.captions.language,
                  widget_referrer: window ? window.location.href : null,
                },
                c
              ),
              events: {
                onError: function (t) {
                  if (!e.media.error) {
                    var n = t.data,
                      i =
                        {
                          2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                          5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                          100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                          101: "The owner of the requested video does not allow it to be played in embedded players.",
                          150: "The owner of the requested video does not allow it to be played in embedded players.",
                        }[n] || "An unknown error occured";
                    (e.media.error = { code: n, message: i }),
                      H.call(e, e.media, "error");
                  }
                },
                onPlaybackRateChange: function (t) {
                  var n = t.target;
                  (e.media.playbackRate = n.getPlaybackRate()),
                    H.call(e, e.media, "ratechange");
                },
                onReady: function (t) {
                  if (!N.function(e.media.play)) {
                    var n = t.target;
                    Ye.getTitle.call(e, s),
                      (e.media.play = function () {
                        ze.call(e, !0), n.playVideo();
                      }),
                      (e.media.pause = function () {
                        ze.call(e, !1), n.pauseVideo();
                      }),
                      (e.media.stop = function () {
                        n.stopVideo();
                      }),
                      (e.media.duration = n.getDuration()),
                      (e.media.paused = !0),
                      (e.media.currentTime = 0),
                      Object.defineProperty(e.media, "currentTime", {
                        get: function () {
                          return Number(n.getCurrentTime());
                        },
                        set: function (t) {
                          e.paused && !e.embed.hasPlayed && e.embed.mute(),
                            (e.media.seeking = !0),
                            H.call(e, e.media, "seeking"),
                            n.seekTo(t);
                        },
                      }),
                      Object.defineProperty(e.media, "playbackRate", {
                        get: function () {
                          return n.getPlaybackRate();
                        },
                        set: function (e) {
                          n.setPlaybackRate(e);
                        },
                      });
                    var i = e.config.volume;
                    Object.defineProperty(e.media, "volume", {
                      get: function () {
                        return i;
                      },
                      set: function (t) {
                        (i = t),
                          n.setVolume(100 * i),
                          H.call(e, e.media, "volumechange");
                      },
                    });
                    var a = e.config.muted;
                    Object.defineProperty(e.media, "muted", {
                      get: function () {
                        return a;
                      },
                      set: function (t) {
                        var i = N.boolean(t) ? t : a;
                        (a = i),
                          n[i ? "mute" : "unMute"](),
                          H.call(e, e.media, "volumechange");
                      },
                    }),
                      Object.defineProperty(e.media, "currentSrc", {
                        get: function () {
                          return n.getVideoUrl();
                        },
                      }),
                      Object.defineProperty(e.media, "ended", {
                        get: function () {
                          return e.currentTime === e.duration;
                        },
                      }),
                      (e.options.speed = n.getAvailablePlaybackRates()),
                      e.supported.ui && e.media.setAttribute("tabindex", -1),
                      H.call(e, e.media, "timeupdate"),
                      H.call(e, e.media, "durationchange"),
                      clearInterval(e.timers.buffering),
                      (e.timers.buffering = setInterval(function () {
                        (e.media.buffered = n.getVideoLoadedFraction()),
                          (null === e.media.lastBuffered ||
                            e.media.lastBuffered < e.media.buffered) &&
                            H.call(e, e.media, "progress"),
                          (e.media.lastBuffered = e.media.buffered),
                          1 === e.media.buffered &&
                            (clearInterval(e.timers.buffering),
                            H.call(e, e.media, "canplaythrough"));
                      }, 200)),
                      setTimeout(function () {
                        return Fe.build.call(e);
                      }, 50);
                  }
                },
                onStateChange: function (t) {
                  var n = t.target;
                  switch (
                    (clearInterval(e.timers.playing),
                    e.media.seeking &&
                      [1, 2].includes(t.data) &&
                      ((e.media.seeking = !1), H.call(e, e.media, "seeked")),
                    t.data)
                  ) {
                    case -1:
                      H.call(e, e.media, "timeupdate"),
                        (e.media.buffered = n.getVideoLoadedFraction()),
                        H.call(e, e.media, "progress");
                      break;
                    case 0:
                      ze.call(e, !1),
                        e.media.loop
                          ? (n.stopVideo(), n.playVideo())
                          : H.call(e, e.media, "ended");
                      break;
                    case 1:
                      e.config.autoplay || !e.media.paused || e.embed.hasPlayed
                        ? (ze.call(e, !0),
                          H.call(e, e.media, "playing"),
                          (e.timers.playing = setInterval(function () {
                            H.call(e, e.media, "timeupdate");
                          }, 50)),
                          e.media.duration !== n.getDuration() &&
                            ((e.media.duration = n.getDuration()),
                            H.call(e, e.media, "durationchange")))
                        : e.media.pause();
                      break;
                    case 2:
                      e.muted || e.embed.unMute(), ze.call(e, !1);
                  }
                  H.call(e, e.elements.container, "statechange", !1, {
                    code: t.data,
                  });
                },
              },
            });
          }
        },
      },
      Qe = {
        setup: function () {
          this.media
            ? (X(
                this.elements.container,
                this.config.classNames.type.replace("{0}", this.type),
                !0
              ),
              X(
                this.elements.container,
                this.config.classNames.provider.replace("{0}", this.provider),
                !0
              ),
              this.isEmbed &&
                X(
                  this.elements.container,
                  this.config.classNames.type.replace("{0}", "video"),
                  !0
                ),
              this.isVideo &&
                ((this.elements.wrapper = B("div", {
                  class: this.config.classNames.video,
                })),
                R(this.media, this.elements.wrapper),
                (this.elements.poster = B("div", {
                  class: this.config.classNames.poster,
                })),
                this.elements.wrapper.appendChild(this.elements.poster)),
              this.isHTML5
                ? le.extend.call(this)
                : this.isYouTube
                ? Ye.setup.call(this)
                : this.isVimeo && We.setup.call(this))
            : this.debug.warn("No media element found!");
        },
      },
      Xe = (function () {
        function t(n) {
          var i = this;
          e(this, t),
            (this.player = n),
            (this.config = n.config.ads),
            (this.playing = !1),
            (this.initialized = !1),
            (this.elements = { container: null, displayContainer: null }),
            (this.manager = null),
            (this.loader = null),
            (this.cuePoints = null),
            (this.events = {}),
            (this.safetyTimer = null),
            (this.countdownTimer = null),
            (this.managerPromise = new Promise(function (e, t) {
              i.on("loaded", e), i.on("error", t);
            })),
            this.load();
        }
        return (
          n(t, [
            {
              key: "load",
              value: function () {
                var e = this;
                this.enabled &&
                  (N.object(window.google) && N.object(window.google.ima)
                    ? this.ready()
                    : Be(this.player.config.urls.googleIMA.sdk)
                        .then(function () {
                          e.ready();
                        })
                        .catch(function () {
                          e.trigger(
                            "error",
                            new Error("Google IMA SDK failed to load")
                          );
                        }));
              },
            },
            {
              key: "ready",
              value: function () {
                var e,
                  t = this;
                this.enabled ||
                  ((e = this).manager && e.manager.destroy(),
                  e.elements.displayContainer &&
                    e.elements.displayContainer.destroy(),
                  e.elements.container.remove()),
                  this.startSafetyTimer(12e3, "ready()"),
                  this.managerPromise.then(function () {
                    t.clearSafetyTimer("onAdsManagerLoaded()");
                  }),
                  this.listeners(),
                  this.setupIMA();
              },
            },
            {
              key: "setupIMA",
              value: function () {
                (this.elements.container = B("div", {
                  class: this.player.config.classNames.ads,
                })),
                  this.player.elements.container.appendChild(
                    this.elements.container
                  ),
                  google.ima.settings.setVpaidMode(
                    google.ima.ImaSdkSettings.VpaidMode.ENABLED
                  ),
                  google.ima.settings.setLocale(
                    this.player.config.ads.language
                  ),
                  google.ima.settings.setDisableCustomPlaybackForIOS10Plus(
                    this.player.config.playsinline
                  ),
                  (this.elements.displayContainer = new google.ima.AdDisplayContainer(
                    this.elements.container,
                    this.player.media
                  )),
                  this.requestAds();
              },
            },
            {
              key: "requestAds",
              value: function () {
                var e = this,
                  t = this.player.elements.container;
                try {
                  (this.loader = new google.ima.AdsLoader(
                    this.elements.displayContainer
                  )),
                    this.loader.addEventListener(
                      google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
                      function (t) {
                        return e.onAdsManagerLoaded(t);
                      },
                      !1
                    ),
                    this.loader.addEventListener(
                      google.ima.AdErrorEvent.Type.AD_ERROR,
                      function (t) {
                        return e.onAdError(t);
                      },
                      !1
                    );
                  var n = new google.ima.AdsRequest();
                  (n.adTagUrl = this.tagUrl),
                    (n.linearAdSlotWidth = t.offsetWidth),
                    (n.linearAdSlotHeight = t.offsetHeight),
                    (n.nonLinearAdSlotWidth = t.offsetWidth),
                    (n.nonLinearAdSlotHeight = t.offsetHeight),
                    (n.forceNonLinearFullSlot = !1),
                    n.setAdWillPlayMuted(!this.player.muted),
                    this.loader.requestAds(n);
                } catch (e) {
                  this.onAdError(e);
                }
              },
            },
            {
              key: "pollCountdown",
              value: function () {
                var e = this;
                if (
                  !(
                    arguments.length > 0 &&
                    void 0 !== arguments[0] &&
                    arguments[0]
                  )
                )
                  return (
                    clearInterval(this.countdownTimer),
                    void this.elements.container.removeAttribute(
                      "data-badge-text"
                    )
                  );
                this.countdownTimer = setInterval(function () {
                  var t = Ce(Math.max(e.manager.getRemainingTime(), 0)),
                    n = ""
                      .concat(ge("advertisement", e.player.config), " - ")
                      .concat(t);
                  e.elements.container.setAttribute("data-badge-text", n);
                }, 100);
              },
            },
            {
              key: "onAdsManagerLoaded",
              value: function (e) {
                var t = this;
                if (this.enabled) {
                  var n = new google.ima.AdsRenderingSettings();
                  (n.restoreCustomPlaybackStateOnAdBreakComplete = !0),
                    (n.enablePreloading = !0),
                    (this.manager = e.getAdsManager(this.player, n)),
                    (this.cuePoints = this.manager.getCuePoints()),
                    this.manager.addEventListener(
                      google.ima.AdErrorEvent.Type.AD_ERROR,
                      function (e) {
                        return t.onAdError(e);
                      }
                    ),
                    Object.keys(google.ima.AdEvent.Type).forEach(function (e) {
                      t.manager.addEventListener(
                        google.ima.AdEvent.Type[e],
                        function (e) {
                          return t.onAdEvent(e);
                        }
                      );
                    }),
                    this.trigger("loaded");
                }
              },
            },
            {
              key: "addCuePoints",
              value: function () {
                var e = this;
                N.empty(this.cuePoints) ||
                  this.cuePoints.forEach(function (t) {
                    if (0 !== t && -1 !== t && t < e.player.duration) {
                      var n = e.player.elements.progress;
                      if (N.element(n)) {
                        var i = (100 / e.player.duration) * t,
                          a = B("span", {
                            class: e.player.config.classNames.cues,
                          });
                        (a.style.left = "".concat(i.toString(), "%")),
                          n.appendChild(a);
                      }
                    }
                  });
              },
            },
            {
              key: "onAdEvent",
              value: function (e) {
                var t = this,
                  n = this.player.elements.container,
                  i = e.getAd(),
                  a = e.getAdData();
                switch (
                  ((function (e) {
                    H.call(
                      t.player,
                      t.player.media,
                      "ads".concat(e.replace(/_/g, "").toLowerCase())
                    );
                  })(e.type),
                  e.type)
                ) {
                  case google.ima.AdEvent.Type.LOADED:
                    this.trigger("loaded"),
                      this.pollCountdown(!0),
                      i.isLinear() ||
                        ((i.width = n.offsetWidth),
                        (i.height = n.offsetHeight));
                    break;
                  case google.ima.AdEvent.Type.STARTED:
                    this.manager.setVolume(this.player.volume);
                    break;
                  case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                    this.loadAds();
                    break;
                  case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                    this.pauseContent();
                    break;
                  case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                    this.pollCountdown(), this.resumeContent();
                    break;
                  case google.ima.AdEvent.Type.LOG:
                    a.adError &&
                      this.player.debug.warn(
                        "Non-fatal ad error: ".concat(a.adError.getMessage())
                      );
                }
              },
            },
            {
              key: "onAdError",
              value: function (e) {
                this.cancel(), this.player.debug.warn("Ads error", e);
              },
            },
            {
              key: "listeners",
              value: function () {
                var e,
                  t = this,
                  n = this.player.elements.container;
                this.player.on("canplay", function () {
                  t.addCuePoints();
                }),
                  this.player.on("ended", function () {
                    t.loader.contentComplete();
                  }),
                  this.player.on("timeupdate", function () {
                    e = t.player.currentTime;
                  }),
                  this.player.on("seeked", function () {
                    var n = t.player.currentTime;
                    N.empty(t.cuePoints) ||
                      t.cuePoints.forEach(function (i, a) {
                        e < i &&
                          i < n &&
                          (t.manager.discardAdBreak(),
                          t.cuePoints.splice(a, 1));
                      });
                  }),
                  window.addEventListener("resize", function () {
                    t.manager &&
                      t.manager.resize(
                        n.offsetWidth,
                        n.offsetHeight,
                        google.ima.ViewMode.NORMAL
                      );
                  });
              },
            },
            {
              key: "play",
              value: function () {
                var e = this,
                  t = this.player.elements.container;
                this.managerPromise || this.resumeContent(),
                  this.managerPromise
                    .then(function () {
                      e.manager.setVolume(e.player.volume),
                        e.elements.displayContainer.initialize();
                      try {
                        e.initialized ||
                          (e.manager.init(
                            t.offsetWidth,
                            t.offsetHeight,
                            google.ima.ViewMode.NORMAL
                          ),
                          e.manager.start()),
                          (e.initialized = !0);
                      } catch (t) {
                        e.onAdError(t);
                      }
                    })
                    .catch(function () {});
              },
            },
            {
              key: "resumeContent",
              value: function () {
                (this.elements.container.style.zIndex = ""),
                  (this.playing = !1),
                  this.player.media.play();
              },
            },
            {
              key: "pauseContent",
              value: function () {
                (this.elements.container.style.zIndex = 3),
                  (this.playing = !0),
                  this.player.media.pause();
              },
            },
            {
              key: "cancel",
              value: function () {
                this.initialized && this.resumeContent(),
                  this.trigger("error"),
                  this.loadAds();
              },
            },
            {
              key: "loadAds",
              value: function () {
                var e = this;
                this.managerPromise
                  .then(function () {
                    e.manager && e.manager.destroy(),
                      (e.managerPromise = new Promise(function (t) {
                        e.on("loaded", t), e.player.debug.log(e.manager);
                      })),
                      e.requestAds();
                  })
                  .catch(function () {});
              },
            },
            {
              key: "trigger",
              value: function (e) {
                for (
                  var t = this,
                    n = arguments.length,
                    i = new Array(n > 1 ? n - 1 : 0),
                    a = 1;
                  a < n;
                  a++
                )
                  i[a - 1] = arguments[a];
                var s = this.events[e];
                N.array(s) &&
                  s.forEach(function (e) {
                    N.function(e) && e.apply(t, i);
                  });
              },
            },
            {
              key: "on",
              value: function (e, t) {
                return (
                  N.array(this.events[e]) || (this.events[e] = []),
                  this.events[e].push(t),
                  this
                );
              },
            },
            {
              key: "startSafetyTimer",
              value: function (e, t) {
                var n = this;
                this.player.debug.log("Safety timer invoked from: ".concat(t)),
                  (this.safetyTimer = setTimeout(function () {
                    n.cancel(), n.clearSafetyTimer("startSafetyTimer()");
                  }, e));
              },
            },
            {
              key: "clearSafetyTimer",
              value: function (e) {
                N.nullOrUndefined(this.safetyTimer) ||
                  (this.player.debug.log(
                    "Safety timer cleared from: ".concat(e)
                  ),
                  clearTimeout(this.safetyTimer),
                  (this.safetyTimer = null));
              },
            },
            {
              key: "enabled",
              get: function () {
                var e = this.config;
                return (
                  this.player.isHTML5 &&
                  this.player.isVideo &&
                  e.enabled &&
                  (!N.empty(e.publisherId) || N.url(e.tagUrl))
                );
              },
            },
            {
              key: "tagUrl",
              get: function () {
                var e = this.config;
                if (N.url(e.tagUrl)) return e.tagUrl;
                var t = {
                  AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                  AV_CHANNELID: "5a0458dc28a06145e4519d21",
                  AV_URL: window.location.hostname,
                  cb: Date.now(),
                  AV_WIDTH: 640,
                  AV_HEIGHT: 480,
                  AV_CDIM2: this.publisherId,
                };
                return ""
                  .concat("https://go.aniview.com/api/adserver6/vast/", "?")
                  .concat(Se(t));
              },
            },
          ]),
          t
        );
      })(),
      Je = (function () {
        function t(n) {
          e(this, t),
            (this.player = n),
            (this.thumbnails = []),
            (this.loaded = !1),
            (this.lastMouseMoveTime = Date.now()),
            (this.mouseDown = !1),
            (this.loadedImages = []),
            (this.elements = { thumb: {}, scrubbing: {} }),
            this.load();
        }
        return (
          n(t, [
            {
              key: "load",
              value: function () {
                var e = this;
                this.player.elements.display.seekTooltip &&
                  (this.player.elements.display.seekTooltip.hidden = this.enabled),
                  this.enabled &&
                    this.getThumbnails().then(function () {
                      e.enabled &&
                        (e.render(),
                        e.determineContainerAutoSizing(),
                        (e.loaded = !0));
                    });
              },
            },
            {
              key: "getThumbnails",
              value: function () {
                var e = this;
                return new Promise(function (t) {
                  var n = e.player.config.previewThumbnails.src;
                  if (N.empty(n))
                    throw new Error(
                      "Missing previewThumbnails.src config attribute"
                    );
                  var i = (N.string(n) ? [n] : n).map(function (t) {
                    return e.getThumbnail(t);
                  });
                  Promise.all(i).then(function () {
                    e.thumbnails.sort(function (e, t) {
                      return e.height - t.height;
                    }),
                      e.player.debug.log("Preview thumbnails", e.thumbnails),
                      t();
                  });
                });
              },
            },
            {
              key: "getThumbnail",
              value: function (e) {
                var t = this;
                return new Promise(function (n) {
                  ve(e).then(function (i) {
                    var s,
                      r,
                      o = {
                        frames:
                          ((s = i),
                          (r = []),
                          s.split(/\r\n\r\n|\n\n|\r\r/).forEach(function (e) {
                            var t = {};
                            e.split(/\r\n|\n|\r/).forEach(function (e) {
                              if (N.number(t.startTime)) {
                                if (!N.empty(e.trim()) && N.empty(t.text)) {
                                  var n = e.trim().split("#xywh="),
                                    i = a(n, 1);
                                  if (((t.text = i[0]), n[1])) {
                                    var s = a(n[1].split(","), 4);
                                    (t.x = s[0]),
                                      (t.y = s[1]),
                                      (t.w = s[2]),
                                      (t.h = s[3]);
                                  }
                                }
                              } else {
                                var r = e.match(
                                  /([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/
                                );
                                r &&
                                  ((t.startTime =
                                    60 * Number(r[1] || 0) * 60 +
                                    60 * Number(r[2]) +
                                    Number(r[3]) +
                                    Number("0.".concat(r[4]))),
                                  (t.endTime =
                                    60 * Number(r[6] || 0) * 60 +
                                    60 * Number(r[7]) +
                                    Number(r[8]) +
                                    Number("0.".concat(r[9]))));
                              }
                            }),
                              t.text && r.push(t);
                          }),
                          r),
                        height: null,
                        urlPrefix: "",
                      };
                    o.frames[0].text.startsWith("/") ||
                      o.frames[0].text.startsWith("http://") ||
                      o.frames[0].text.startsWith("https://") ||
                      (o.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                    var l = new Image();
                    (l.onload = function () {
                      (o.height = l.naturalHeight),
                        (o.width = l.naturalWidth),
                        t.thumbnails.push(o),
                        n();
                    }),
                      (l.src = o.urlPrefix + o.frames[0].text);
                  });
                });
              },
            },
            {
              key: "startMove",
              value: function (e) {
                if (
                  this.loaded &&
                  N.event(e) &&
                  ["touchmove", "mousemove"].includes(e.type) &&
                  this.player.media.duration
                ) {
                  if ("touchmove" === e.type)
                    this.seekTime =
                      this.player.media.duration *
                      (this.player.elements.inputs.seek.value / 100);
                  else {
                    var t = this.player.elements.progress.getBoundingClientRect(),
                      n = (100 / t.width) * (e.pageX - t.left);
                    (this.seekTime = this.player.media.duration * (n / 100)),
                      this.seekTime < 0 && (this.seekTime = 0),
                      this.seekTime > this.player.media.duration - 1 &&
                        (this.seekTime = this.player.media.duration - 1),
                      (this.mousePosX = e.pageX),
                      (this.elements.thumb.time.innerText = Ce(this.seekTime));
                  }
                  this.showImageAtCurrentTime();
                }
              },
            },
            {
              key: "endMove",
              value: function () {
                this.toggleThumbContainer(!1, !0);
              },
            },
            {
              key: "startScrubbing",
              value: function (e) {
                (!1 !== e.button && 0 !== e.button) ||
                  ((this.mouseDown = !0),
                  this.player.media.duration &&
                    (this.toggleScrubbingContainer(!0),
                    this.toggleThumbContainer(!1, !0),
                    this.showImageAtCurrentTime()));
              },
            },
            {
              key: "endScrubbing",
              value: function () {
                var e = this;
                (this.mouseDown = !1),
                  Math.ceil(this.lastTime) ===
                  Math.ceil(this.player.media.currentTime)
                    ? this.toggleScrubbingContainer(!1)
                    : q.call(
                        this.player,
                        this.player.media,
                        "timeupdate",
                        function () {
                          e.mouseDown || e.toggleScrubbingContainer(!1);
                        }
                      );
              },
            },
            {
              key: "listeners",
              value: function () {
                var e = this;
                this.player.on("play", function () {
                  e.toggleThumbContainer(!1, !0);
                }),
                  this.player.on("seeked", function () {
                    e.toggleThumbContainer(!1);
                  }),
                  this.player.on("timeupdate", function () {
                    e.lastTime = e.player.media.currentTime;
                  });
              },
            },
            {
              key: "render",
              value: function () {
                (this.elements.thumb.container = B("div", {
                  class: this.player.config.classNames.previewThumbnails
                    .thumbContainer,
                })),
                  (this.elements.thumb.imageContainer = B("div", {
                    class: this.player.config.classNames.previewThumbnails
                      .imageContainer,
                  })),
                  this.elements.thumb.container.appendChild(
                    this.elements.thumb.imageContainer
                  );
                var e = B("div", {
                  class: this.player.config.classNames.previewThumbnails
                    .timeContainer,
                });
                (this.elements.thumb.time = B("span", {}, "00:00")),
                  e.appendChild(this.elements.thumb.time),
                  this.elements.thumb.container.appendChild(e),
                  N.element(this.player.elements.progress) &&
                    this.player.elements.progress.appendChild(
                      this.elements.thumb.container
                    ),
                  (this.elements.scrubbing.container = B("div", {
                    class: this.player.config.classNames.previewThumbnails
                      .scrubbingContainer,
                  })),
                  this.player.elements.wrapper.appendChild(
                    this.elements.scrubbing.container
                  );
              },
            },
            {
              key: "showImageAtCurrentTime",
              value: function () {
                var e = this;
                this.mouseDown
                  ? this.setScrubbingContainerSize()
                  : this.setThumbContainerSizeAndPos();
                var t = this.thumbnails[0].frames.findIndex(function (t) {
                    return e.seekTime >= t.startTime && e.seekTime <= t.endTime;
                  }),
                  n = t >= 0,
                  i = 0;
                this.mouseDown || this.toggleThumbContainer(n),
                  n &&
                    (this.thumbnails.forEach(function (n, a) {
                      e.loadedImages.includes(n.frames[t].text) && (i = a);
                    }),
                    t !== this.showingThumb &&
                      ((this.showingThumb = t), this.loadImage(i)));
              },
            },
            {
              key: "loadImage",
              value: function () {
                var e = this,
                  t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : 0,
                  n = this.showingThumb,
                  i = this.thumbnails[t],
                  a = i.urlPrefix,
                  s = i.frames[n],
                  r = i.frames[n].text,
                  o = a + r;
                if (
                  this.currentImageElement &&
                  this.currentImageElement.dataset.filename === r
                )
                  this.showImage(this.currentImageElement, s, t, n, r, !1),
                    (this.currentImageElement.dataset.index = n),
                    this.removeOldImages(this.currentImageElement);
                else {
                  this.loadingImage &&
                    this.usingSprites &&
                    (this.loadingImage.onload = null);
                  var l = new Image();
                  (l.src = o),
                    (l.dataset.index = n),
                    (l.dataset.filename = r),
                    (this.showingThumbFilename = r),
                    this.player.debug.log("Loading image: ".concat(o)),
                    (l.onload = function () {
                      return e.showImage(l, s, t, n, r, !0);
                    }),
                    (this.loadingImage = l),
                    this.removeOldImages(l);
                }
              },
            },
            {
              key: "showImage",
              value: function (e, t, n, i, a) {
                var s =
                  !(arguments.length > 5 && void 0 !== arguments[5]) ||
                  arguments[5];
                this.player.debug.log(
                  "Showing thumb: "
                    .concat(a, ". num: ")
                    .concat(i, ". qual: ")
                    .concat(n, ". newimg: ")
                    .concat(s)
                ),
                  this.setImageSizeAndOffset(e, t),
                  s &&
                    (this.currentImageContainer.appendChild(e),
                    (this.currentImageElement = e),
                    this.loadedImages.includes(a) || this.loadedImages.push(a)),
                  this.preloadNearby(i, !0)
                    .then(this.preloadNearby(i, !1))
                    .then(this.getHigherQuality(n, e, t, a));
              },
            },
            {
              key: "removeOldImages",
              value: function (e) {
                var t = this;
                Array.from(this.currentImageContainer.children).forEach(
                  function (n) {
                    if ("img" === n.tagName.toLowerCase()) {
                      var i = t.usingSprites ? 500 : 1e3;
                      if (
                        n.dataset.index !== e.dataset.index &&
                        !n.dataset.deleting
                      ) {
                        n.dataset.deleting = !0;
                        var a = t.currentImageContainer;
                        setTimeout(function () {
                          a.removeChild(n),
                            t.player.debug.log(
                              "Removing thumb: ".concat(n.dataset.filename)
                            );
                        }, i);
                      }
                    }
                  }
                );
              },
            },
            {
              key: "preloadNearby",
              value: function (e) {
                var t = this,
                  n =
                    !(arguments.length > 1 && void 0 !== arguments[1]) ||
                    arguments[1];
                return new Promise(function (i) {
                  setTimeout(function () {
                    var a = t.thumbnails[0].frames[e].text;
                    if (t.showingThumbFilename === a) {
                      var s;
                      s = n
                        ? t.thumbnails[0].frames.slice(e)
                        : t.thumbnails[0].frames.slice(0, e).reverse();
                      var r = !1;
                      s.forEach(function (e) {
                        var n = e.text;
                        if (n !== a && !t.loadedImages.includes(n)) {
                          (r = !0),
                            t.player.debug.log(
                              "Preloading thumb filename: ".concat(n)
                            );
                          var s = t.thumbnails[0].urlPrefix + n,
                            o = new Image();
                          (o.src = s),
                            (o.onload = function () {
                              t.player.debug.log(
                                "Preloaded thumb filename: ".concat(n)
                              ),
                                t.loadedImages.includes(n) ||
                                  t.loadedImages.push(n),
                                i();
                            });
                        }
                      }),
                        r || i();
                    }
                  }, 300);
                });
              },
            },
            {
              key: "getHigherQuality",
              value: function (e, t, n, i) {
                var a = this;
                if (e < this.thumbnails.length - 1) {
                  var s = t.naturalHeight;
                  this.usingSprites && (s = n.h),
                    s < this.thumbContainerHeight &&
                      setTimeout(function () {
                        a.showingThumbFilename === i &&
                          (a.player.debug.log(
                            "Showing higher quality thumb for: ".concat(i)
                          ),
                          a.loadImage(e + 1));
                      }, 300);
                }
              },
            },
            {
              key: "toggleThumbContainer",
              value: function () {
                var e =
                    arguments.length > 0 &&
                    void 0 !== arguments[0] &&
                    arguments[0],
                  t =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1],
                  n = this.player.config.classNames.previewThumbnails
                    .thumbContainerShown;
                this.elements.thumb.container.classList.toggle(n, e),
                  !e &&
                    t &&
                    ((this.showingThumb = null),
                    (this.showingThumbFilename = null));
              },
            },
            {
              key: "toggleScrubbingContainer",
              value: function () {
                var e =
                    arguments.length > 0 &&
                    void 0 !== arguments[0] &&
                    arguments[0],
                  t = this.player.config.classNames.previewThumbnails
                    .scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(t, e),
                  e ||
                    ((this.showingThumb = null),
                    (this.showingThumbFilename = null));
              },
            },
            {
              key: "determineContainerAutoSizing",
              value: function () {
                this.elements.thumb.imageContainer.clientHeight > 20 &&
                  (this.sizeSpecifiedInCSS = !0);
              },
            },
            {
              key: "setThumbContainerSizeAndPos",
              value: function () {
                if (!this.sizeSpecifiedInCSS) {
                  var e = Math.floor(
                    this.thumbContainerHeight * this.thumbAspectRatio
                  );
                  (this.elements.thumb.imageContainer.style.height = "".concat(
                    this.thumbContainerHeight,
                    "px"
                  )),
                    (this.elements.thumb.imageContainer.style.width = "".concat(
                      e,
                      "px"
                    ));
                }
                this.setThumbContainerPos();
              },
            },
            {
              key: "setThumbContainerPos",
              value: function () {
                var e = this.player.elements.progress.getBoundingClientRect(),
                  t = this.player.elements.container.getBoundingClientRect(),
                  n = this.elements.thumb.container,
                  i = t.left - e.left + 10,
                  a = t.right - e.left - n.clientWidth - 10,
                  s = this.mousePosX - e.left - n.clientWidth / 2;
                s < i && (s = i),
                  s > a && (s = a),
                  (n.style.left = "".concat(s, "px"));
              },
            },
            {
              key: "setScrubbingContainerSize",
              value: function () {
                (this.elements.scrubbing.container.style.width = "".concat(
                  this.player.media.clientWidth,
                  "px"
                )),
                  (this.elements.scrubbing.container.style.height = "".concat(
                    this.player.media.clientWidth / this.thumbAspectRatio,
                    "px"
                  ));
              },
            },
            {
              key: "setImageSizeAndOffset",
              value: function (e, t) {
                if (this.usingSprites) {
                  var n = this.thumbContainerHeight / t.h;
                  (e.style.height = "".concat(
                    Math.floor(e.naturalHeight * n),
                    "px"
                  )),
                    (e.style.width = "".concat(
                      Math.floor(e.naturalWidth * n),
                      "px"
                    )),
                    (e.style.left = "-".concat(t.x * n, "px")),
                    (e.style.top = "-".concat(t.y * n, "px"));
                }
              },
            },
            {
              key: "enabled",
              get: function () {
                return (
                  this.player.isHTML5 &&
                  this.player.isVideo &&
                  this.player.config.previewThumbnails.enabled
                );
              },
            },
            {
              key: "currentImageContainer",
              get: function () {
                return this.mouseDown
                  ? this.elements.scrubbing.container
                  : this.elements.thumb.imageContainer;
              },
            },
            {
              key: "usingSprites",
              get: function () {
                return Object.keys(this.thumbnails[0].frames[0]).includes("w");
              },
            },
            {
              key: "thumbAspectRatio",
              get: function () {
                return this.usingSprites
                  ? this.thumbnails[0].frames[0].w /
                      this.thumbnails[0].frames[0].h
                  : this.thumbnails[0].width / this.thumbnails[0].height;
              },
            },
            {
              key: "thumbContainerHeight",
              get: function () {
                return this.mouseDown
                  ? Math.floor(
                      this.player.media.clientWidth / this.thumbAspectRatio
                    )
                  : Math.floor(
                      this.player.media.clientWidth / this.thumbAspectRatio / 4
                    );
              },
            },
            {
              key: "currentImageElement",
              get: function () {
                return this.mouseDown
                  ? this.currentScrubbingImageElement
                  : this.currentThumbnailImageElement;
              },
              set: function (e) {
                this.mouseDown
                  ? (this.currentScrubbingImageElement = e)
                  : (this.currentThumbnailImageElement = e);
              },
            },
          ]),
          t
        );
      })(),
      $e = {
        insertElements: function (e, t) {
          var n = this;
          N.string(t)
            ? U(e, this.media, { src: t })
            : N.array(t) &&
              t.forEach(function (t) {
                U(e, n.media, t);
              });
        },
        change: function (e) {
          var t = this;
          D(e, "sources.length")
            ? (le.cancelRequests.call(this),
              this.destroy.call(
                this,
                function () {
                  (t.options.quality = []),
                    W(t.media),
                    (t.media = null),
                    N.element(t.elements.container) &&
                      t.elements.container.removeAttribute("class");
                  var n = e.sources,
                    i = e.type,
                    s = a(n, 1)[0],
                    r = s.provider,
                    o = void 0 === r ? Le.html5 : r,
                    l = s.src,
                    c = "html5" === o ? i : "div",
                    u = "html5" === o ? {} : { src: l };
                  Object.assign(t, {
                    provider: o,
                    type: i,
                    supported: ie.check(i, o, t.config.playsinline),
                    media: B(c, u),
                  }),
                    t.elements.container.appendChild(t.media),
                    N.boolean(e.autoplay) && (t.config.autoplay = e.autoplay),
                    t.isHTML5 &&
                      (t.config.crossorigin &&
                        t.media.setAttribute("crossorigin", ""),
                      t.config.autoplay && t.media.setAttribute("autoplay", ""),
                      N.empty(e.poster) || (t.poster = e.poster),
                      t.config.loop.active && t.media.setAttribute("loop", ""),
                      t.config.muted && t.media.setAttribute("muted", ""),
                      t.config.playsinline &&
                        t.media.setAttribute("playsinline", "")),
                    Fe.addStyleHook.call(t),
                    t.isHTML5 && $e.insertElements.call(t, "source", n),
                    (t.config.title = e.title),
                    Qe.setup.call(t),
                    t.isHTML5 &&
                      Object.keys(e).includes("tracks") &&
                      $e.insertElements.call(t, "track", e.tracks),
                    (t.isHTML5 || (t.isEmbed && !t.supported.ui)) &&
                      Fe.build.call(t),
                    t.isHTML5 && t.media.load(),
                    t.previewThumbnails && t.previewThumbnails.load(),
                    t.fullscreen.update();
                },
                !0
              ))
            : this.debug.warn("Invalid source format");
        },
      };
    var Ge,
      Ze = (function () {
        function t(n, i) {
          var a = this;
          if (
            (e(this, t),
            (this.timers = {}),
            (this.ready = !1),
            (this.loading = !1),
            (this.failed = !1),
            (this.touch = ie.touch),
            (this.media = n),
            N.string(this.media) &&
              (this.media = document.querySelectorAll(this.media)),
            ((window.jQuery && this.media instanceof jQuery) ||
              N.nodeList(this.media) ||
              N.array(this.media)) &&
              (this.media = this.media[0]),
            (this.config = F(
              {},
              Ne,
              t.defaults,
              i || {},
              (function () {
                try {
                  return JSON.parse(a.media.getAttribute("data-plyr-config"));
                } catch (e) {
                  return {};
                }
              })()
            )),
            (this.elements = {
              container: null,
              captions: null,
              buttons: {},
              display: {},
              progress: {},
              inputs: {},
              settings: { popup: null, menu: null, panels: {}, buttons: {} },
            }),
            (this.captions = {
              active: null,
              currentTrack: -1,
              meta: new WeakMap(),
            }),
            (this.fullscreen = { active: !1 }),
            (this.options = { speed: [], quality: [] }),
            (this.debug = new Oe(this.config.debug)),
            this.debug.log("Config", this.config),
            this.debug.log("Support", ie),
            !N.nullOrUndefined(this.media) && N.element(this.media))
          )
            if (this.media.plyr) this.debug.warn("Target already setup");
            else if (this.config.enabled)
              if (ie.check().api) {
                var s = this.media.cloneNode(!0);
                (s.autoplay = !1), (this.elements.original = s);
                var r = this.media.tagName.toLowerCase(),
                  o = null,
                  l = null;
                switch (r) {
                  case "div":
                    if (
                      ((o = this.media.querySelector("iframe")), N.element(o))
                    ) {
                      if (
                        ((l = Ee(o.getAttribute("src"))),
                        (this.provider = (function (e) {
                          return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                            e
                          )
                            ? Le.youtube
                            : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(
                                e
                              )
                            ? Le.vimeo
                            : null;
                        })(l.toString())),
                        (this.elements.container = this.media),
                        (this.media = o),
                        (this.elements.container.className = ""),
                        l.search.length)
                      ) {
                        var c = ["1", "true"];
                        c.includes(l.searchParams.get("autoplay")) &&
                          (this.config.autoplay = !0),
                          c.includes(l.searchParams.get("loop")) &&
                            (this.config.loop.active = !0),
                          this.isYouTube
                            ? ((this.config.playsinline = c.includes(
                                l.searchParams.get("playsinline")
                              )),
                              (this.config.youtube.hl = l.searchParams.get(
                                "hl"
                              )))
                            : (this.config.playsinline = !0);
                      }
                    } else
                      (this.provider = this.media.getAttribute(
                        this.config.attributes.embed.provider
                      )),
                        this.media.removeAttribute(
                          this.config.attributes.embed.provider
                        );
                    if (
                      N.empty(this.provider) ||
                      !Object.keys(Le).includes(this.provider)
                    )
                      return void this.debug.error(
                        "Setup failed: Invalid provider"
                      );
                    this.type = Ie.video;
                    break;
                  case "video":
                  case "audio":
                    (this.type = r),
                      (this.provider = Le.html5),
                      this.media.hasAttribute("crossorigin") &&
                        (this.config.crossorigin = !0),
                      this.media.hasAttribute("autoplay") &&
                        (this.config.autoplay = !0),
                      (this.media.hasAttribute("playsinline") ||
                        this.media.hasAttribute("webkit-playsinline")) &&
                        (this.config.playsinline = !0),
                      this.media.hasAttribute("muted") &&
                        (this.config.muted = !0),
                      this.media.hasAttribute("loop") &&
                        (this.config.loop.active = !0);
                    break;
                  default:
                    return void this.debug.error(
                      "Setup failed: unsupported type"
                    );
                }
                (this.supported = ie.check(
                  this.type,
                  this.provider,
                  this.config.playsinline
                )),
                  this.supported.api
                    ? ((this.eventListeners = []),
                      (this.listeners = new Re(this)),
                      (this.storage = new ye(this)),
                      (this.media.plyr = this),
                      N.element(this.elements.container) ||
                        ((this.elements.container = B("div", { tabindex: 0 })),
                        R(this.media, this.elements.container)),
                      Fe.addStyleHook.call(this),
                      Qe.setup.call(this),
                      this.config.debug &&
                        O.call(
                          this,
                          this.elements.container,
                          this.config.events.join(" "),
                          function (e) {
                            a.debug.log("event: ".concat(e.type));
                          }
                        ),
                      (this.isHTML5 || (this.isEmbed && !this.supported.ui)) &&
                        Fe.build.call(this),
                      this.listeners.container(),
                      this.listeners.global(),
                      (this.fullscreen = new He(this)),
                      this.config.ads.enabled && (this.ads = new Xe(this)),
                      this.isHTML5 &&
                        this.config.autoplay &&
                        setTimeout(function () {
                          return a.play();
                        }, 10),
                      (this.lastSeekTime = 0),
                      this.config.previewThumbnails.enabled &&
                        (this.previewThumbnails = new Je(this)))
                    : this.debug.error("Setup failed: no support");
              } else this.debug.error("Setup failed: no support");
            else this.debug.error("Setup failed: disabled by config");
          else this.debug.error("Setup failed: no suitable element passed");
        }
        return (
          n(
            t,
            [
              {
                key: "play",
                value: function () {
                  var e = this;
                  return N.function(this.media.play)
                    ? (this.ads &&
                        this.ads.enabled &&
                        this.ads.managerPromise
                          .then(function () {
                            return e.ads.play();
                          })
                          .catch(function () {
                            return e.media.play();
                          }),
                      this.media.play())
                    : null;
                },
              },
              {
                key: "pause",
                value: function () {
                  this.playing &&
                    N.function(this.media.pause) &&
                    this.media.pause();
                },
              },
              {
                key: "togglePlay",
                value: function (e) {
                  (N.boolean(e) ? e : !this.playing)
                    ? this.play()
                    : this.pause();
                },
              },
              {
                key: "stop",
                value: function () {
                  this.isHTML5
                    ? (this.pause(), this.restart())
                    : N.function(this.media.stop) && this.media.stop();
                },
              },
              {
                key: "restart",
                value: function () {
                  this.currentTime = 0;
                },
              },
              {
                key: "rewind",
                value: function (e) {
                  this.currentTime =
                    this.currentTime - (N.number(e) ? e : this.config.seekTime);
                },
              },
              {
                key: "forward",
                value: function (e) {
                  this.currentTime =
                    this.currentTime + (N.number(e) ? e : this.config.seekTime);
                },
              },
              {
                key: "increaseVolume",
                value: function (e) {
                  var t = this.media.muted ? 0 : this.volume;
                  this.volume = t + (N.number(e) ? e : 0);
                },
              },
              {
                key: "decreaseVolume",
                value: function (e) {
                  this.increaseVolume(-e);
                },
              },
              {
                key: "toggleCaptions",
                value: function (e) {
                  Pe.toggle.call(this, e, !1);
                },
              },
              {
                key: "airplay",
                value: function () {
                  ie.airplay && this.media.webkitShowPlaybackTargetPicker();
                },
              },
              {
                key: "toggleControls",
                value: function (e) {
                  if (this.supported.ui && !this.isAudio) {
                    var t = J(
                        this.elements.container,
                        this.config.classNames.hideControls
                      ),
                      n = void 0 === e ? void 0 : !e,
                      i = X(
                        this.elements.container,
                        this.config.classNames.hideControls,
                        n
                      );
                    if (
                      (i &&
                        this.config.controls.includes("settings") &&
                        !N.empty(this.config.settings) &&
                        Ae.toggleMenu.call(this, !1),
                      i !== t)
                    ) {
                      var a = i ? "controlshidden" : "controlsshown";
                      H.call(this, this.media, a);
                    }
                    return !i;
                  }
                  return !1;
                },
              },
              {
                key: "on",
                value: function (e, t) {
                  O.call(this, this.elements.container, e, t);
                },
              },
              {
                key: "once",
                value: function (e, t) {
                  q.call(this, this.elements.container, e, t);
                },
              },
              {
                key: "off",
                value: function (e, t) {
                  j(this.elements.container, e, t);
                },
              },
              {
                key: "destroy",
                value: function (e) {
                  var t = this,
                    n =
                      arguments.length > 1 &&
                      void 0 !== arguments[1] &&
                      arguments[1];
                  if (this.ready) {
                    var i = function () {
                      (document.body.style.overflow = ""),
                        (t.embed = null),
                        n
                          ? (Object.keys(t.elements).length &&
                              (W(t.elements.buttons.play),
                              W(t.elements.captions),
                              W(t.elements.controls),
                              W(t.elements.wrapper),
                              (t.elements.buttons.play = null),
                              (t.elements.captions = null),
                              (t.elements.controls = null),
                              (t.elements.wrapper = null)),
                            N.function(e) && e())
                          : (function () {
                              this &&
                                this.eventListeners &&
                                (this.eventListeners.forEach(function (e) {
                                  var t = e.element,
                                    n = e.type,
                                    i = e.callback,
                                    a = e.options;
                                  t.removeEventListener(n, i, a);
                                }),
                                (this.eventListeners = []));
                            }.call(t),
                            K(t.elements.original, t.elements.container),
                            H.call(t, t.elements.original, "destroyed", !0),
                            N.function(e) && e.call(t.elements.original),
                            (t.ready = !1),
                            setTimeout(function () {
                              (t.elements = null), (t.media = null);
                            }, 200));
                    };
                    this.stop(),
                      clearTimeout(this.timers.loading),
                      clearTimeout(this.timers.controls),
                      clearTimeout(this.timers.resized),
                      this.isHTML5
                        ? (Fe.toggleNativeControls.call(this, !0), i())
                        : this.isYouTube
                        ? (clearInterval(this.timers.buffering),
                          clearInterval(this.timers.playing),
                          null !== this.embed &&
                            N.function(this.embed.destroy) &&
                            this.embed.destroy(),
                          i())
                        : this.isVimeo &&
                          (null !== this.embed && this.embed.unload().then(i),
                          setTimeout(i, 200));
                  }
                },
              },
              {
                key: "supports",
                value: function (e) {
                  return ie.mime.call(this, e);
                },
              },
              {
                key: "isHTML5",
                get: function () {
                  return this.provider === Le.html5;
                },
              },
              {
                key: "isEmbed",
                get: function () {
                  return this.isYouTube || this.isVimeo;
                },
              },
              {
                key: "isYouTube",
                get: function () {
                  return this.provider === Le.youtube;
                },
              },
              {
                key: "isVimeo",
                get: function () {
                  return this.provider === Le.vimeo;
                },
              },
              {
                key: "isVideo",
                get: function () {
                  return this.type === Ie.video;
                },
              },
              {
                key: "isAudio",
                get: function () {
                  return this.type === Ie.audio;
                },
              },
              {
                key: "playing",
                get: function () {
                  return Boolean(this.ready && !this.paused && !this.ended);
                },
              },
              {
                key: "paused",
                get: function () {
                  return Boolean(this.media.paused);
                },
              },
              {
                key: "stopped",
                get: function () {
                  return Boolean(this.paused && 0 === this.currentTime);
                },
              },
              {
                key: "ended",
                get: function () {
                  return Boolean(this.media.ended);
                },
              },
              {
                key: "currentTime",
                set: function (e) {
                  if (this.duration) {
                    var t = N.number(e) && e > 0;
                    (this.media.currentTime = t
                      ? Math.min(e, this.duration)
                      : 0),
                      this.debug.log(
                        "Seeking to ".concat(this.currentTime, " seconds")
                      );
                  }
                },
                get: function () {
                  return Number(this.media.currentTime);
                },
              },
              {
                key: "buffered",
                get: function () {
                  var e = this.media.buffered;
                  return N.number(e)
                    ? e
                    : e && e.length && this.duration > 0
                    ? e.end(0) / this.duration
                    : 0;
                },
              },
              {
                key: "seeking",
                get: function () {
                  return Boolean(this.media.seeking);
                },
              },
              {
                key: "duration",
                get: function () {
                  var e = parseFloat(this.config.duration),
                    t = (this.media || {}).duration,
                    n = N.number(t) && t !== 1 / 0 ? t : 0;
                  return e || n;
                },
              },
              {
                key: "volume",
                set: function (e) {
                  var t = e;
                  N.string(t) && (t = Number(t)),
                    N.number(t) || (t = this.storage.get("volume")),
                    N.number(t) || (t = this.config.volume),
                    t > 1 && (t = 1),
                    t < 0 && (t = 0),
                    (this.config.volume = t),
                    (this.media.volume = t),
                    !N.empty(e) && this.muted && t > 0 && (this.muted = !1);
                },
                get: function () {
                  return Number(this.media.volume);
                },
              },
              {
                key: "muted",
                set: function (e) {
                  var t = e;
                  N.boolean(t) || (t = this.storage.get("muted")),
                    N.boolean(t) || (t = this.config.muted),
                    (this.config.muted = t),
                    (this.media.muted = t);
                },
                get: function () {
                  return Boolean(this.media.muted);
                },
              },
              {
                key: "hasAudio",
                get: function () {
                  return (
                    !this.isHTML5 ||
                    !!this.isAudio ||
                    Boolean(this.media.mozHasAudio) ||
                    Boolean(this.media.webkitAudioDecodedByteCount) ||
                    Boolean(
                      this.media.audioTracks && this.media.audioTracks.length
                    )
                  );
                },
              },
              {
                key: "speed",
                set: function (e) {
                  var t = this,
                    n = null;
                  N.number(e) && (n = e),
                    N.number(n) || (n = this.storage.get("speed")),
                    N.number(n) || (n = this.config.speed.selected);
                  var i = this.minimumSpeed,
                    a = this.maximumSpeed;
                  (n = (function () {
                    var e =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      t =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : 255;
                    return Math.min(Math.max(e, t), n);
                  })(n, i, a)),
                    (this.config.speed.selected = n),
                    setTimeout(function () {
                      t.media.playbackRate = n;
                    }, 0);
                },
                get: function () {
                  return Number(this.media.playbackRate);
                },
              },
              {
                key: "minimumSpeed",
                get: function () {
                  return this.isYouTube
                    ? Math.min.apply(Math, s(this.options.speed))
                    : this.isVimeo
                    ? 0.5
                    : 0.0625;
                },
              },
              {
                key: "maximumSpeed",
                get: function () {
                  return this.isYouTube
                    ? Math.max.apply(Math, s(this.options.speed))
                    : this.isVimeo
                    ? 2
                    : 16;
                },
              },
              {
                key: "quality",
                set: function (e) {
                  var t = this.config.quality,
                    n = this.options.quality;
                  if (n.length) {
                    var i = [
                        !N.empty(e) && Number(e),
                        this.storage.get("quality"),
                        t.selected,
                        t.default,
                      ].find(N.number),
                      a = !0;
                    if (!n.includes(i)) {
                      var s = (function (e, t) {
                        return N.array(e) && e.length
                          ? e.reduce(function (e, n) {
                              return Math.abs(n - t) < Math.abs(e - t) ? n : e;
                            })
                          : null;
                      })(n, i);
                      this.debug.warn(
                        "Unsupported quality option: "
                          .concat(i, ", using ")
                          .concat(s, " instead")
                      ),
                        (i = s),
                        (a = !1);
                    }
                    (t.selected = i),
                      (this.media.quality = i),
                      a && this.storage.set({ quality: i });
                  }
                },
                get: function () {
                  return this.media.quality;
                },
              },
              {
                key: "loop",
                set: function (e) {
                  var t = N.boolean(e) ? e : this.config.loop.active;
                  (this.config.loop.active = t), (this.media.loop = t);
                },
                get: function () {
                  return Boolean(this.media.loop);
                },
              },
              {
                key: "source",
                set: function (e) {
                  $e.change.call(this, e);
                },
                get: function () {
                  return this.media.currentSrc;
                },
              },
              {
                key: "download",
                get: function () {
                  var e = this.config.urls.download;
                  return N.url(e) ? e : this.source;
                },
                set: function (e) {
                  N.url(e) &&
                    ((this.config.urls.download = e),
                    Ae.setDownloadUrl.call(this));
                },
              },
              {
                key: "poster",
                set: function (e) {
                  this.isVideo
                    ? Fe.setPoster.call(this, e, !1).catch(function () {})
                    : this.debug.warn("Poster can only be set for video");
                },
                get: function () {
                  return this.isVideo
                    ? this.media.getAttribute("poster")
                    : null;
                },
              },
              {
                key: "ratio",
                get: function () {
                  if (!this.isVideo) return null;
                  var e = se(re.call(this));
                  return N.array(e) ? e.join(":") : e;
                },
                set: function (e) {
                  this.isVideo
                    ? N.string(e) && ae(e)
                      ? ((this.config.ratio = e), oe.call(this))
                      : this.debug.error(
                          "Invalid aspect ratio specified (".concat(e, ")")
                        )
                    : this.debug.warn("Aspect ratio can only be set for video");
                },
              },
              {
                key: "autoplay",
                set: function (e) {
                  var t = N.boolean(e) ? e : this.config.autoplay;
                  this.config.autoplay = t;
                },
                get: function () {
                  return Boolean(this.config.autoplay);
                },
              },
              {
                key: "currentTrack",
                set: function (e) {
                  Pe.set.call(this, e, !1);
                },
                get: function () {
                  var e = this.captions,
                    t = e.toggled,
                    n = e.currentTrack;
                  return t ? n : -1;
                },
              },
              {
                key: "language",
                set: function (e) {
                  Pe.setLanguage.call(this, e, !1);
                },
                get: function () {
                  return (Pe.getCurrentTrack.call(this) || {}).language;
                },
              },
              {
                key: "pip",
                set: function (e) {
                  if (ie.pip) {
                    var t = N.boolean(e) ? e : !this.pip;
                    N.function(this.media.webkitSetPresentationMode) &&
                      this.media.webkitSetPresentationMode(t ? Me : xe),
                      N.function(this.media.requestPictureInPicture) &&
                        (!this.pip && t
                          ? this.media.requestPictureInPicture()
                          : this.pip && !t && document.exitPictureInPicture());
                  }
                },
                get: function () {
                  return ie.pip
                    ? N.empty(this.media.webkitPresentationMode)
                      ? this.media === document.pictureInPictureElement
                      : this.media.webkitPresentationMode === Me
                    : null;
                },
              },
            ],
            [
              {
                key: "supported",
                value: function (e, t, n) {
                  return ie.check(e, t, n);
                },
              },
              {
                key: "loadSprite",
                value: function (e, t) {
                  return be(e, t);
                },
              },
              {
                key: "setup",
                value: function (e) {
                  var n =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    i = null;
                  return (
                    N.string(e)
                      ? (i = Array.from(document.querySelectorAll(e)))
                      : N.nodeList(e)
                      ? (i = Array.from(e))
                      : N.array(e) && (i = e.filter(N.element)),
                    N.empty(i)
                      ? null
                      : i.map(function (e) {
                          return new t(e, n);
                        })
                  );
                },
              },
            ]
          ),
          t
        );
      })();
    return (Ze.defaults = ((Ge = Ne), JSON.parse(JSON.stringify(Ge)))), Ze;
  });
//# sourceMappingURL=plyr.min.js.map

/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!(function (a, b, c, d) {
  "use strict";
  function e(a, b, c) {
    return setTimeout(j(a, c), b);
  }
  function f(a, b, c) {
    return Array.isArray(a) ? (g(a, c[b], c), !0) : !1;
  }
  function g(a, b, c) {
    var e;
    if (a)
      if (a.forEach) a.forEach(b, c);
      else if (a.length !== d)
        for (e = 0; e < a.length; ) b.call(c, a[e], e, a), e++;
      else for (e in a) a.hasOwnProperty(e) && b.call(c, a[e], e, a);
  }
  function h(b, c, d) {
    var e = "DEPRECATED METHOD: " + c + "\n" + d + " AT \n";
    return function () {
      var c = new Error("get-stack-trace"),
        d =
          c && c.stack
            ? c.stack
                .replace(/^[^\(]+?[\n$]/gm, "")
                .replace(/^\s+at\s+/gm, "")
                .replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@")
            : "Unknown Stack Trace",
        f = a.console && (a.console.warn || a.console.log);
      return f && f.call(a.console, e, d), b.apply(this, arguments);
    };
  }
  function i(a, b, c) {
    var d,
      e = b.prototype;
    (d = a.prototype = Object.create(e)),
      (d.constructor = a),
      (d._super = e),
      c && la(d, c);
  }
  function j(a, b) {
    return function () {
      return a.apply(b, arguments);
    };
  }
  function k(a, b) {
    return typeof a == oa ? a.apply(b ? b[0] || d : d, b) : a;
  }
  function l(a, b) {
    return a === d ? b : a;
  }
  function m(a, b, c) {
    g(q(b), function (b) {
      a.addEventListener(b, c, !1);
    });
  }
  function n(a, b, c) {
    g(q(b), function (b) {
      a.removeEventListener(b, c, !1);
    });
  }
  function o(a, b) {
    for (; a; ) {
      if (a == b) return !0;
      a = a.parentNode;
    }
    return !1;
  }
  function p(a, b) {
    return a.indexOf(b) > -1;
  }
  function q(a) {
    return a.trim().split(/\s+/g);
  }
  function r(a, b, c) {
    if (a.indexOf && !c) return a.indexOf(b);
    for (var d = 0; d < a.length; ) {
      if ((c && a[d][c] == b) || (!c && a[d] === b)) return d;
      d++;
    }
    return -1;
  }
  function s(a) {
    return Array.prototype.slice.call(a, 0);
  }
  function t(a, b, c) {
    for (var d = [], e = [], f = 0; f < a.length; ) {
      var g = b ? a[f][b] : a[f];
      r(e, g) < 0 && d.push(a[f]), (e[f] = g), f++;
    }
    return (
      c &&
        (d = b
          ? d.sort(function (a, c) {
              return a[b] > c[b];
            })
          : d.sort()),
      d
    );
  }
  function u(a, b) {
    for (
      var c, e, f = b[0].toUpperCase() + b.slice(1), g = 0;
      g < ma.length;

    ) {
      if (((c = ma[g]), (e = c ? c + f : b), e in a)) return e;
      g++;
    }
    return d;
  }
  function v() {
    return ua++;
  }
  function w(b) {
    var c = b.ownerDocument || b;
    return c.defaultView || c.parentWindow || a;
  }
  function x(a, b) {
    var c = this;
    (this.manager = a),
      (this.callback = b),
      (this.element = a.element),
      (this.target = a.options.inputTarget),
      (this.domHandler = function (b) {
        k(a.options.enable, [a]) && c.handler(b);
      }),
      this.init();
  }
  function y(a) {
    var b,
      c = a.options.inputClass;
    return new (b = c ? c : xa ? M : ya ? P : wa ? R : L)(a, z);
  }
  function z(a, b, c) {
    var d = c.pointers.length,
      e = c.changedPointers.length,
      f = b & Ea && d - e === 0,
      g = b & (Ga | Ha) && d - e === 0;
    (c.isFirst = !!f),
      (c.isFinal = !!g),
      f && (a.session = {}),
      (c.eventType = b),
      A(a, c),
      a.emit("hammer.input", c),
      a.recognize(c),
      (a.session.prevInput = c);
  }
  function A(a, b) {
    var c = a.session,
      d = b.pointers,
      e = d.length;
    c.firstInput || (c.firstInput = D(b)),
      e > 1 && !c.firstMultiple
        ? (c.firstMultiple = D(b))
        : 1 === e && (c.firstMultiple = !1);
    var f = c.firstInput,
      g = c.firstMultiple,
      h = g ? g.center : f.center,
      i = (b.center = E(d));
    (b.timeStamp = ra()),
      (b.deltaTime = b.timeStamp - f.timeStamp),
      (b.angle = I(h, i)),
      (b.distance = H(h, i)),
      B(c, b),
      (b.offsetDirection = G(b.deltaX, b.deltaY));
    var j = F(b.deltaTime, b.deltaX, b.deltaY);
    (b.overallVelocityX = j.x),
      (b.overallVelocityY = j.y),
      (b.overallVelocity = qa(j.x) > qa(j.y) ? j.x : j.y),
      (b.scale = g ? K(g.pointers, d) : 1),
      (b.rotation = g ? J(g.pointers, d) : 0),
      (b.maxPointers = c.prevInput
        ? b.pointers.length > c.prevInput.maxPointers
          ? b.pointers.length
          : c.prevInput.maxPointers
        : b.pointers.length),
      C(c, b);
    var k = a.element;
    o(b.srcEvent.target, k) && (k = b.srcEvent.target), (b.target = k);
  }
  function B(a, b) {
    var c = b.center,
      d = a.offsetDelta || {},
      e = a.prevDelta || {},
      f = a.prevInput || {};
    (b.eventType !== Ea && f.eventType !== Ga) ||
      ((e = a.prevDelta = { x: f.deltaX || 0, y: f.deltaY || 0 }),
      (d = a.offsetDelta = { x: c.x, y: c.y })),
      (b.deltaX = e.x + (c.x - d.x)),
      (b.deltaY = e.y + (c.y - d.y));
  }
  function C(a, b) {
    var c,
      e,
      f,
      g,
      h = a.lastInterval || b,
      i = b.timeStamp - h.timeStamp;
    if (b.eventType != Ha && (i > Da || h.velocity === d)) {
      var j = b.deltaX - h.deltaX,
        k = b.deltaY - h.deltaY,
        l = F(i, j, k);
      (e = l.x),
        (f = l.y),
        (c = qa(l.x) > qa(l.y) ? l.x : l.y),
        (g = G(j, k)),
        (a.lastInterval = b);
    } else
      (c = h.velocity), (e = h.velocityX), (f = h.velocityY), (g = h.direction);
    (b.velocity = c), (b.velocityX = e), (b.velocityY = f), (b.direction = g);
  }
  function D(a) {
    for (var b = [], c = 0; c < a.pointers.length; )
      (b[c] = {
        clientX: pa(a.pointers[c].clientX),
        clientY: pa(a.pointers[c].clientY),
      }),
        c++;
    return {
      timeStamp: ra(),
      pointers: b,
      center: E(b),
      deltaX: a.deltaX,
      deltaY: a.deltaY,
    };
  }
  function E(a) {
    var b = a.length;
    if (1 === b) return { x: pa(a[0].clientX), y: pa(a[0].clientY) };
    for (var c = 0, d = 0, e = 0; b > e; )
      (c += a[e].clientX), (d += a[e].clientY), e++;
    return { x: pa(c / b), y: pa(d / b) };
  }
  function F(a, b, c) {
    return { x: b / a || 0, y: c / a || 0 };
  }
  function G(a, b) {
    return a === b ? Ia : qa(a) >= qa(b) ? (0 > a ? Ja : Ka) : 0 > b ? La : Ma;
  }
  function H(a, b, c) {
    c || (c = Qa);
    var d = b[c[0]] - a[c[0]],
      e = b[c[1]] - a[c[1]];
    return Math.sqrt(d * d + e * e);
  }
  function I(a, b, c) {
    c || (c = Qa);
    var d = b[c[0]] - a[c[0]],
      e = b[c[1]] - a[c[1]];
    return (180 * Math.atan2(e, d)) / Math.PI;
  }
  function J(a, b) {
    return I(b[1], b[0], Ra) + I(a[1], a[0], Ra);
  }
  function K(a, b) {
    return H(b[0], b[1], Ra) / H(a[0], a[1], Ra);
  }
  function L() {
    (this.evEl = Ta),
      (this.evWin = Ua),
      (this.pressed = !1),
      x.apply(this, arguments);
  }
  function M() {
    (this.evEl = Xa),
      (this.evWin = Ya),
      x.apply(this, arguments),
      (this.store = this.manager.session.pointerEvents = []);
  }
  function N() {
    (this.evTarget = $a),
      (this.evWin = _a),
      (this.started = !1),
      x.apply(this, arguments);
  }
  function O(a, b) {
    var c = s(a.touches),
      d = s(a.changedTouches);
    return b & (Ga | Ha) && (c = t(c.concat(d), "identifier", !0)), [c, d];
  }
  function P() {
    (this.evTarget = bb), (this.targetIds = {}), x.apply(this, arguments);
  }
  function Q(a, b) {
    var c = s(a.touches),
      d = this.targetIds;
    if (b & (Ea | Fa) && 1 === c.length)
      return (d[c[0].identifier] = !0), [c, c];
    var e,
      f,
      g = s(a.changedTouches),
      h = [],
      i = this.target;
    if (
      ((f = c.filter(function (a) {
        return o(a.target, i);
      })),
      b === Ea)
    )
      for (e = 0; e < f.length; ) (d[f[e].identifier] = !0), e++;
    for (e = 0; e < g.length; )
      d[g[e].identifier] && h.push(g[e]),
        b & (Ga | Ha) && delete d[g[e].identifier],
        e++;
    return h.length ? [t(f.concat(h), "identifier", !0), h] : void 0;
  }
  function R() {
    x.apply(this, arguments);
    var a = j(this.handler, this);
    (this.touch = new P(this.manager, a)),
      (this.mouse = new L(this.manager, a)),
      (this.primaryTouch = null),
      (this.lastTouches = []);
  }
  function S(a, b) {
    a & Ea
      ? ((this.primaryTouch = b.changedPointers[0].identifier), T.call(this, b))
      : a & (Ga | Ha) && T.call(this, b);
  }
  function T(a) {
    var b = a.changedPointers[0];
    if (b.identifier === this.primaryTouch) {
      var c = { x: b.clientX, y: b.clientY };
      this.lastTouches.push(c);
      var d = this.lastTouches,
        e = function () {
          var a = d.indexOf(c);
          a > -1 && d.splice(a, 1);
        };
      setTimeout(e, cb);
    }
  }
  function U(a) {
    for (
      var b = a.srcEvent.clientX, c = a.srcEvent.clientY, d = 0;
      d < this.lastTouches.length;
      d++
    ) {
      var e = this.lastTouches[d],
        f = Math.abs(b - e.x),
        g = Math.abs(c - e.y);
      if (db >= f && db >= g) return !0;
    }
    return !1;
  }
  function V(a, b) {
    (this.manager = a), this.set(b);
  }
  function W(a) {
    if (p(a, jb)) return jb;
    var b = p(a, kb),
      c = p(a, lb);
    return b && c ? jb : b || c ? (b ? kb : lb) : p(a, ib) ? ib : hb;
  }
  function X() {
    if (!fb) return !1;
    var b = {},
      c = a.CSS && a.CSS.supports;
    return (
      ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(
        function (d) {
          b[d] = c ? a.CSS.supports("touch-action", d) : !0;
        }
      ),
      b
    );
  }
  function Y(a) {
    (this.options = la({}, this.defaults, a || {})),
      (this.id = v()),
      (this.manager = null),
      (this.options.enable = l(this.options.enable, !0)),
      (this.state = nb),
      (this.simultaneous = {}),
      (this.requireFail = []);
  }
  function Z(a) {
    return a & sb
      ? "cancel"
      : a & qb
      ? "end"
      : a & pb
      ? "move"
      : a & ob
      ? "start"
      : "";
  }
  function $(a) {
    return a == Ma
      ? "down"
      : a == La
      ? "up"
      : a == Ja
      ? "left"
      : a == Ka
      ? "right"
      : "";
  }
  function _(a, b) {
    var c = b.manager;
    return c ? c.get(a) : a;
  }
  function aa() {
    Y.apply(this, arguments);
  }
  function ba() {
    aa.apply(this, arguments), (this.pX = null), (this.pY = null);
  }
  function ca() {
    aa.apply(this, arguments);
  }
  function da() {
    Y.apply(this, arguments), (this._timer = null), (this._input = null);
  }
  function ea() {
    aa.apply(this, arguments);
  }
  function fa() {
    aa.apply(this, arguments);
  }
  function ga() {
    Y.apply(this, arguments),
      (this.pTime = !1),
      (this.pCenter = !1),
      (this._timer = null),
      (this._input = null),
      (this.count = 0);
  }
  function ha(a, b) {
    return (
      (b = b || {}),
      (b.recognizers = l(b.recognizers, ha.defaults.preset)),
      new ia(a, b)
    );
  }
  function ia(a, b) {
    (this.options = la({}, ha.defaults, b || {})),
      (this.options.inputTarget = this.options.inputTarget || a),
      (this.handlers = {}),
      (this.session = {}),
      (this.recognizers = []),
      (this.oldCssProps = {}),
      (this.element = a),
      (this.input = y(this)),
      (this.touchAction = new V(this, this.options.touchAction)),
      ja(this, !0),
      g(
        this.options.recognizers,
        function (a) {
          var b = this.add(new a[0](a[1]));
          a[2] && b.recognizeWith(a[2]), a[3] && b.requireFailure(a[3]);
        },
        this
      );
  }
  function ja(a, b) {
    var c = a.element;
    if (c.style) {
      var d;
      g(a.options.cssProps, function (e, f) {
        (d = u(c.style, f)),
          b
            ? ((a.oldCssProps[d] = c.style[d]), (c.style[d] = e))
            : (c.style[d] = a.oldCssProps[d] || "");
      }),
        b || (a.oldCssProps = {});
    }
  }
  function ka(a, c) {
    var d = b.createEvent("Event");
    d.initEvent(a, !0, !0), (d.gesture = c), c.target.dispatchEvent(d);
  }
  var la,
    ma = ["", "webkit", "Moz", "MS", "ms", "o"],
    na = b.createElement("div"),
    oa = "function",
    pa = Math.round,
    qa = Math.abs,
    ra = Date.now;
  la =
    "function" != typeof Object.assign
      ? function (a) {
          if (a === d || null === a)
            throw new TypeError("Cannot convert undefined or null to object");
          for (var b = Object(a), c = 1; c < arguments.length; c++) {
            var e = arguments[c];
            if (e !== d && null !== e)
              for (var f in e) e.hasOwnProperty(f) && (b[f] = e[f]);
          }
          return b;
        }
      : Object.assign;
  var sa = h(
      function (a, b, c) {
        for (var e = Object.keys(b), f = 0; f < e.length; )
          (!c || (c && a[e[f]] === d)) && (a[e[f]] = b[e[f]]), f++;
        return a;
      },
      "extend",
      "Use `assign`."
    ),
    ta = h(
      function (a, b) {
        return sa(a, b, !0);
      },
      "merge",
      "Use `assign`."
    ),
    ua = 1,
    va = /mobile|tablet|ip(ad|hone|od)|android/i,
    wa = "ontouchstart" in a,
    xa = u(a, "PointerEvent") !== d,
    ya = wa && va.test(navigator.userAgent),
    za = "touch",
    Aa = "pen",
    Ba = "mouse",
    Ca = "kinect",
    Da = 25,
    Ea = 1,
    Fa = 2,
    Ga = 4,
    Ha = 8,
    Ia = 1,
    Ja = 2,
    Ka = 4,
    La = 8,
    Ma = 16,
    Na = Ja | Ka,
    Oa = La | Ma,
    Pa = Na | Oa,
    Qa = ["x", "y"],
    Ra = ["clientX", "clientY"];
  x.prototype = {
    handler: function () {},
    init: function () {
      this.evEl && m(this.element, this.evEl, this.domHandler),
        this.evTarget && m(this.target, this.evTarget, this.domHandler),
        this.evWin && m(w(this.element), this.evWin, this.domHandler);
    },
    destroy: function () {
      this.evEl && n(this.element, this.evEl, this.domHandler),
        this.evTarget && n(this.target, this.evTarget, this.domHandler),
        this.evWin && n(w(this.element), this.evWin, this.domHandler);
    },
  };
  var Sa = { mousedown: Ea, mousemove: Fa, mouseup: Ga },
    Ta = "mousedown",
    Ua = "mousemove mouseup";
  i(L, x, {
    handler: function (a) {
      var b = Sa[a.type];
      b & Ea && 0 === a.button && (this.pressed = !0),
        b & Fa && 1 !== a.which && (b = Ga),
        this.pressed &&
          (b & Ga && (this.pressed = !1),
          this.callback(this.manager, b, {
            pointers: [a],
            changedPointers: [a],
            pointerType: Ba,
            srcEvent: a,
          }));
    },
  });
  var Va = {
      pointerdown: Ea,
      pointermove: Fa,
      pointerup: Ga,
      pointercancel: Ha,
      pointerout: Ha,
    },
    Wa = { 2: za, 3: Aa, 4: Ba, 5: Ca },
    Xa = "pointerdown",
    Ya = "pointermove pointerup pointercancel";
  a.MSPointerEvent &&
    !a.PointerEvent &&
    ((Xa = "MSPointerDown"),
    (Ya = "MSPointerMove MSPointerUp MSPointerCancel")),
    i(M, x, {
      handler: function (a) {
        var b = this.store,
          c = !1,
          d = a.type.toLowerCase().replace("ms", ""),
          e = Va[d],
          f = Wa[a.pointerType] || a.pointerType,
          g = f == za,
          h = r(b, a.pointerId, "pointerId");
        e & Ea && (0 === a.button || g)
          ? 0 > h && (b.push(a), (h = b.length - 1))
          : e & (Ga | Ha) && (c = !0),
          0 > h ||
            ((b[h] = a),
            this.callback(this.manager, e, {
              pointers: b,
              changedPointers: [a],
              pointerType: f,
              srcEvent: a,
            }),
            c && b.splice(h, 1));
      },
    });
  var Za = { touchstart: Ea, touchmove: Fa, touchend: Ga, touchcancel: Ha },
    $a = "touchstart",
    _a = "touchstart touchmove touchend touchcancel";
  i(N, x, {
    handler: function (a) {
      var b = Za[a.type];
      if ((b === Ea && (this.started = !0), this.started)) {
        var c = O.call(this, a, b);
        b & (Ga | Ha) && c[0].length - c[1].length === 0 && (this.started = !1),
          this.callback(this.manager, b, {
            pointers: c[0],
            changedPointers: c[1],
            pointerType: za,
            srcEvent: a,
          });
      }
    },
  });
  var ab = { touchstart: Ea, touchmove: Fa, touchend: Ga, touchcancel: Ha },
    bb = "touchstart touchmove touchend touchcancel";
  i(P, x, {
    handler: function (a) {
      var b = ab[a.type],
        c = Q.call(this, a, b);
      c &&
        this.callback(this.manager, b, {
          pointers: c[0],
          changedPointers: c[1],
          pointerType: za,
          srcEvent: a,
        });
    },
  });
  var cb = 2500,
    db = 25;
  i(R, x, {
    handler: function (a, b, c) {
      var d = c.pointerType == za,
        e = c.pointerType == Ba;
      if (
        !(e && c.sourceCapabilities && c.sourceCapabilities.firesTouchEvents)
      ) {
        if (d) S.call(this, b, c);
        else if (e && U.call(this, c)) return;
        this.callback(a, b, c);
      }
    },
    destroy: function () {
      this.touch.destroy(), this.mouse.destroy();
    },
  });
  var eb = u(na.style, "touchAction"),
    fb = eb !== d,
    gb = "compute",
    hb = "auto",
    ib = "manipulation",
    jb = "none",
    kb = "pan-x",
    lb = "pan-y",
    mb = X();
  V.prototype = {
    set: function (a) {
      a == gb && (a = this.compute()),
        fb &&
          this.manager.element.style &&
          mb[a] &&
          (this.manager.element.style[eb] = a),
        (this.actions = a.toLowerCase().trim());
    },
    update: function () {
      this.set(this.manager.options.touchAction);
    },
    compute: function () {
      var a = [];
      return (
        g(this.manager.recognizers, function (b) {
          k(b.options.enable, [b]) && (a = a.concat(b.getTouchAction()));
        }),
        W(a.join(" "))
      );
    },
    preventDefaults: function (a) {
      var b = a.srcEvent,
        c = a.offsetDirection;
      if (this.manager.session.prevented) return void b.preventDefault();
      var d = this.actions,
        e = p(d, jb) && !mb[jb],
        f = p(d, lb) && !mb[lb],
        g = p(d, kb) && !mb[kb];
      if (e) {
        var h = 1 === a.pointers.length,
          i = a.distance < 2,
          j = a.deltaTime < 250;
        if (h && i && j) return;
      }
      return g && f
        ? void 0
        : e || (f && c & Na) || (g && c & Oa)
        ? this.preventSrc(b)
        : void 0;
    },
    preventSrc: function (a) {
      (this.manager.session.prevented = !0), a.preventDefault();
    },
  };
  var nb = 1,
    ob = 2,
    pb = 4,
    qb = 8,
    rb = qb,
    sb = 16,
    tb = 32;
  (Y.prototype = {
    defaults: {},
    set: function (a) {
      return (
        la(this.options, a),
        this.manager && this.manager.touchAction.update(),
        this
      );
    },
    recognizeWith: function (a) {
      if (f(a, "recognizeWith", this)) return this;
      var b = this.simultaneous;
      return (
        (a = _(a, this)),
        b[a.id] || ((b[a.id] = a), a.recognizeWith(this)),
        this
      );
    },
    dropRecognizeWith: function (a) {
      return f(a, "dropRecognizeWith", this)
        ? this
        : ((a = _(a, this)), delete this.simultaneous[a.id], this);
    },
    requireFailure: function (a) {
      if (f(a, "requireFailure", this)) return this;
      var b = this.requireFail;
      return (
        (a = _(a, this)),
        -1 === r(b, a) && (b.push(a), a.requireFailure(this)),
        this
      );
    },
    dropRequireFailure: function (a) {
      if (f(a, "dropRequireFailure", this)) return this;
      a = _(a, this);
      var b = r(this.requireFail, a);
      return b > -1 && this.requireFail.splice(b, 1), this;
    },
    hasRequireFailures: function () {
      return this.requireFail.length > 0;
    },
    canRecognizeWith: function (a) {
      return !!this.simultaneous[a.id];
    },
    emit: function (a) {
      function b(b) {
        c.manager.emit(b, a);
      }
      var c = this,
        d = this.state;
      qb > d && b(c.options.event + Z(d)),
        b(c.options.event),
        a.additionalEvent && b(a.additionalEvent),
        d >= qb && b(c.options.event + Z(d));
    },
    tryEmit: function (a) {
      return this.canEmit() ? this.emit(a) : void (this.state = tb);
    },
    canEmit: function () {
      for (var a = 0; a < this.requireFail.length; ) {
        if (!(this.requireFail[a].state & (tb | nb))) return !1;
        a++;
      }
      return !0;
    },
    recognize: function (a) {
      var b = la({}, a);
      return k(this.options.enable, [this, b])
        ? (this.state & (rb | sb | tb) && (this.state = nb),
          (this.state = this.process(b)),
          void (this.state & (ob | pb | qb | sb) && this.tryEmit(b)))
        : (this.reset(), void (this.state = tb));
    },
    process: function (a) {},
    getTouchAction: function () {},
    reset: function () {},
  }),
    i(aa, Y, {
      defaults: { pointers: 1 },
      attrTest: function (a) {
        var b = this.options.pointers;
        return 0 === b || a.pointers.length === b;
      },
      process: function (a) {
        var b = this.state,
          c = a.eventType,
          d = b & (ob | pb),
          e = this.attrTest(a);
        return d && (c & Ha || !e)
          ? b | sb
          : d || e
          ? c & Ga
            ? b | qb
            : b & ob
            ? b | pb
            : ob
          : tb;
      },
    }),
    i(ba, aa, {
      defaults: { event: "pan", threshold: 10, pointers: 1, direction: Pa },
      getTouchAction: function () {
        var a = this.options.direction,
          b = [];
        return a & Na && b.push(lb), a & Oa && b.push(kb), b;
      },
      directionTest: function (a) {
        var b = this.options,
          c = !0,
          d = a.distance,
          e = a.direction,
          f = a.deltaX,
          g = a.deltaY;
        return (
          e & b.direction ||
            (b.direction & Na
              ? ((e = 0 === f ? Ia : 0 > f ? Ja : Ka),
                (c = f != this.pX),
                (d = Math.abs(a.deltaX)))
              : ((e = 0 === g ? Ia : 0 > g ? La : Ma),
                (c = g != this.pY),
                (d = Math.abs(a.deltaY)))),
          (a.direction = e),
          c && d > b.threshold && e & b.direction
        );
      },
      attrTest: function (a) {
        return (
          aa.prototype.attrTest.call(this, a) &&
          (this.state & ob || (!(this.state & ob) && this.directionTest(a)))
        );
      },
      emit: function (a) {
        (this.pX = a.deltaX), (this.pY = a.deltaY);
        var b = $(a.direction);
        b && (a.additionalEvent = this.options.event + b),
          this._super.emit.call(this, a);
      },
    }),
    i(ca, aa, {
      defaults: { event: "pinch", threshold: 0, pointers: 2 },
      getTouchAction: function () {
        return [jb];
      },
      attrTest: function (a) {
        return (
          this._super.attrTest.call(this, a) &&
          (Math.abs(a.scale - 1) > this.options.threshold || this.state & ob)
        );
      },
      emit: function (a) {
        if (1 !== a.scale) {
          var b = a.scale < 1 ? "in" : "out";
          a.additionalEvent = this.options.event + b;
        }
        this._super.emit.call(this, a);
      },
    }),
    i(da, Y, {
      defaults: { event: "press", pointers: 1, time: 251, threshold: 9 },
      getTouchAction: function () {
        return [hb];
      },
      process: function (a) {
        var b = this.options,
          c = a.pointers.length === b.pointers,
          d = a.distance < b.threshold,
          f = a.deltaTime > b.time;
        if (((this._input = a), !d || !c || (a.eventType & (Ga | Ha) && !f)))
          this.reset();
        else if (a.eventType & Ea)
          this.reset(),
            (this._timer = e(
              function () {
                (this.state = rb), this.tryEmit();
              },
              b.time,
              this
            ));
        else if (a.eventType & Ga) return rb;
        return tb;
      },
      reset: function () {
        clearTimeout(this._timer);
      },
      emit: function (a) {
        this.state === rb &&
          (a && a.eventType & Ga
            ? this.manager.emit(this.options.event + "up", a)
            : ((this._input.timeStamp = ra()),
              this.manager.emit(this.options.event, this._input)));
      },
    }),
    i(ea, aa, {
      defaults: { event: "rotate", threshold: 0, pointers: 2 },
      getTouchAction: function () {
        return [jb];
      },
      attrTest: function (a) {
        return (
          this._super.attrTest.call(this, a) &&
          (Math.abs(a.rotation) > this.options.threshold || this.state & ob)
        );
      },
    }),
    i(fa, aa, {
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: Na | Oa,
        pointers: 1,
      },
      getTouchAction: function () {
        return ba.prototype.getTouchAction.call(this);
      },
      attrTest: function (a) {
        var b,
          c = this.options.direction;
        return (
          c & (Na | Oa)
            ? (b = a.overallVelocity)
            : c & Na
            ? (b = a.overallVelocityX)
            : c & Oa && (b = a.overallVelocityY),
          this._super.attrTest.call(this, a) &&
            c & a.offsetDirection &&
            a.distance > this.options.threshold &&
            a.maxPointers == this.options.pointers &&
            qa(b) > this.options.velocity &&
            a.eventType & Ga
        );
      },
      emit: function (a) {
        var b = $(a.offsetDirection);
        b && this.manager.emit(this.options.event + b, a),
          this.manager.emit(this.options.event, a);
      },
    }),
    i(ga, Y, {
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        time: 250,
        threshold: 9,
        posThreshold: 10,
      },
      getTouchAction: function () {
        return [ib];
      },
      process: function (a) {
        var b = this.options,
          c = a.pointers.length === b.pointers,
          d = a.distance < b.threshold,
          f = a.deltaTime < b.time;
        if ((this.reset(), a.eventType & Ea && 0 === this.count))
          return this.failTimeout();
        if (d && f && c) {
          if (a.eventType != Ga) return this.failTimeout();
          var g = this.pTime ? a.timeStamp - this.pTime < b.interval : !0,
            h = !this.pCenter || H(this.pCenter, a.center) < b.posThreshold;
          (this.pTime = a.timeStamp),
            (this.pCenter = a.center),
            h && g ? (this.count += 1) : (this.count = 1),
            (this._input = a);
          var i = this.count % b.taps;
          if (0 === i)
            return this.hasRequireFailures()
              ? ((this._timer = e(
                  function () {
                    (this.state = rb), this.tryEmit();
                  },
                  b.interval,
                  this
                )),
                ob)
              : rb;
        }
        return tb;
      },
      failTimeout: function () {
        return (
          (this._timer = e(
            function () {
              this.state = tb;
            },
            this.options.interval,
            this
          )),
          tb
        );
      },
      reset: function () {
        clearTimeout(this._timer);
      },
      emit: function () {
        this.state == rb &&
          ((this._input.tapCount = this.count),
          this.manager.emit(this.options.event, this._input));
      },
    }),
    (ha.VERSION = "2.0.7"),
    (ha.defaults = {
      domEvents: !1,
      touchAction: gb,
      enable: !0,
      inputTarget: null,
      inputClass: null,
      preset: [
        [ea, { enable: !1 }],
        [ca, { enable: !1 }, ["rotate"]],
        [fa, { direction: Na }],
        [ba, { direction: Na }, ["swipe"]],
        [ga],
        [ga, { event: "doubletap", taps: 2 }, ["tap"]],
        [da],
      ],
      cssProps: {
        userSelect: "none",
        touchSelect: "none",
        touchCallout: "none",
        contentZooming: "none",
        userDrag: "none",
        tapHighlightColor: "rgba(0,0,0,0)",
      },
    });
  var ub = 1,
    vb = 2;
  (ia.prototype = {
    set: function (a) {
      return (
        la(this.options, a),
        a.touchAction && this.touchAction.update(),
        a.inputTarget &&
          (this.input.destroy(),
          (this.input.target = a.inputTarget),
          this.input.init()),
        this
      );
    },
    stop: function (a) {
      this.session.stopped = a ? vb : ub;
    },
    recognize: function (a) {
      var b = this.session;
      if (!b.stopped) {
        this.touchAction.preventDefaults(a);
        var c,
          d = this.recognizers,
          e = b.curRecognizer;
        (!e || (e && e.state & rb)) && (e = b.curRecognizer = null);
        for (var f = 0; f < d.length; )
          (c = d[f]),
            b.stopped === vb || (e && c != e && !c.canRecognizeWith(e))
              ? c.reset()
              : c.recognize(a),
            !e && c.state & (ob | pb | qb) && (e = b.curRecognizer = c),
            f++;
      }
    },
    get: function (a) {
      if (a instanceof Y) return a;
      for (var b = this.recognizers, c = 0; c < b.length; c++)
        if (b[c].options.event == a) return b[c];
      return null;
    },
    add: function (a) {
      if (f(a, "add", this)) return this;
      var b = this.get(a.options.event);
      return (
        b && this.remove(b),
        this.recognizers.push(a),
        (a.manager = this),
        this.touchAction.update(),
        a
      );
    },
    remove: function (a) {
      if (f(a, "remove", this)) return this;
      if ((a = this.get(a))) {
        var b = this.recognizers,
          c = r(b, a);
        -1 !== c && (b.splice(c, 1), this.touchAction.update());
      }
      return this;
    },
    on: function (a, b) {
      if (a !== d && b !== d) {
        var c = this.handlers;
        return (
          g(q(a), function (a) {
            (c[a] = c[a] || []), c[a].push(b);
          }),
          this
        );
      }
    },
    off: function (a, b) {
      if (a !== d) {
        var c = this.handlers;
        return (
          g(q(a), function (a) {
            b ? c[a] && c[a].splice(r(c[a], b), 1) : delete c[a];
          }),
          this
        );
      }
    },
    emit: function (a, b) {
      this.options.domEvents && ka(a, b);
      var c = this.handlers[a] && this.handlers[a].slice();
      if (c && c.length) {
        (b.type = a),
          (b.preventDefault = function () {
            b.srcEvent.preventDefault();
          });
        for (var d = 0; d < c.length; ) c[d](b), d++;
      }
    },
    destroy: function () {
      this.element && ja(this, !1),
        (this.handlers = {}),
        (this.session = {}),
        this.input.destroy(),
        (this.element = null);
    },
  }),
    la(ha, {
      INPUT_START: Ea,
      INPUT_MOVE: Fa,
      INPUT_END: Ga,
      INPUT_CANCEL: Ha,
      STATE_POSSIBLE: nb,
      STATE_BEGAN: ob,
      STATE_CHANGED: pb,
      STATE_ENDED: qb,
      STATE_RECOGNIZED: rb,
      STATE_CANCELLED: sb,
      STATE_FAILED: tb,
      DIRECTION_NONE: Ia,
      DIRECTION_LEFT: Ja,
      DIRECTION_RIGHT: Ka,
      DIRECTION_UP: La,
      DIRECTION_DOWN: Ma,
      DIRECTION_HORIZONTAL: Na,
      DIRECTION_VERTICAL: Oa,
      DIRECTION_ALL: Pa,
      Manager: ia,
      Input: x,
      TouchAction: V,
      TouchInput: P,
      MouseInput: L,
      PointerEventInput: M,
      TouchMouseInput: R,
      SingleTouchInput: N,
      Recognizer: Y,
      AttrRecognizer: aa,
      Tap: ga,
      Pan: ba,
      Swipe: fa,
      Pinch: ca,
      Rotate: ea,
      Press: da,
      on: m,
      off: n,
      each: g,
      merge: ta,
      extend: sa,
      assign: la,
      inherit: i,
      bindFn: j,
      prefixed: u,
    });
  var wb = "undefined" != typeof a ? a : "undefined" != typeof self ? self : {};
  (wb.Hammer = ha),
    "function" == typeof define && define.amd
      ? define(function () {
          return ha;
        })
      : "undefined" != typeof module && module.exports
      ? (module.exports = ha)
      : (a[c] = ha);
})(window, document, "Hammer");
//# sourceMappingURL=hammer.min.js.map
!(function () {
  "use strict";
  function e(n) {
    return "undefined" == typeof this ||
      Object.getPrototypeOf(this) !== e.prototype
      ? new e(n)
      : ((O = this),
        (O.version = "3.4.0"),
        (O.tools = new E()),
        O.isSupported()
          ? (O.tools.extend(O.defaults, n || {}),
            (O.defaults.container = t(O.defaults)),
            (O.store = { elements: {}, containers: [] }),
            (O.sequences = {}),
            (O.history = []),
            (O.uid = 0),
            (O.initialized = !1))
          : "undefined" != typeof console && null !== console,
        O);
  }
  function t(e) {
    if (e && e.container) {
      if ("string" == typeof e.container)
        return window.document.documentElement.querySelector(e.container);
      if (O.tools.isNode(e.container)) return e.container;
    }
    return O.defaults.container;
  }
  function n(e, t) {
    return "string" == typeof e
      ? Array.prototype.slice.call(t.querySelectorAll(e))
      : O.tools.isNode(e)
      ? [e]
      : O.tools.isNodeList(e)
      ? Array.prototype.slice.call(e)
      : Array.isArray(e)
      ? e.filter(O.tools.isNode)
      : [];
  }
  function i() {
    return ++O.uid;
  }
  function o(e, t, n) {
    t.container && (t.container = n),
      e.config
        ? (e.config = O.tools.extendClone(e.config, t))
        : (e.config = O.tools.extendClone(O.defaults, t)),
      "top" === e.config.origin || "bottom" === e.config.origin
        ? (e.config.axis = "Y")
        : (e.config.axis = "X");
  }
  function r(e) {
    var t = window.getComputedStyle(e.domEl);
    e.styles ||
      ((e.styles = { transition: {}, transform: {}, computed: {} }),
      (e.styles.inline = e.domEl.getAttribute("style") || ""),
      (e.styles.inline += "; visibility: visible; "),
      (e.styles.computed.opacity = t.opacity),
      t.transition && "all 0s ease 0s" !== t.transition
        ? (e.styles.computed.transition = t.transition + ", ")
        : (e.styles.computed.transition = "")),
      (e.styles.transition.instant = s(e, 0)),
      (e.styles.transition.delayed = s(e, e.config.delay)),
      (e.styles.transform.initial = " -webkit-transform:"),
      (e.styles.transform.target = " -webkit-transform:"),
      a(e),
      (e.styles.transform.initial += "transform:"),
      (e.styles.transform.target += "transform:"),
      a(e);
  }
  function s(e, t) {
    var n = e.config;
    return (
      "-webkit-transition: " +
      e.styles.computed.transition +
      "-webkit-transform " +
      n.duration / 1e3 +
      "s " +
      n.easing +
      " " +
      t / 1e3 +
      "s, opacity " +
      n.duration / 1e3 +
      "s " +
      n.easing +
      " " +
      t / 1e3 +
      "s; transition: " +
      e.styles.computed.transition +
      "transform " +
      n.duration / 1e3 +
      "s " +
      n.easing +
      " " +
      t / 1e3 +
      "s, opacity " +
      n.duration / 1e3 +
      "s " +
      n.easing +
      " " +
      t / 1e3 +
      "s; "
    );
  }
  function a(e) {
    var t,
      n = e.config,
      i = e.styles.transform;
    (t =
      "top" === n.origin || "left" === n.origin
        ? /^-/.test(n.distance)
          ? n.distance.substr(1)
          : "-" + n.distance
        : n.distance),
      parseInt(n.distance) &&
        ((i.initial += " translate" + n.axis + "(" + t + ")"),
        (i.target += " translate" + n.axis + "(0)")),
      n.scale &&
        ((i.initial += " scale(" + n.scale + ")"), (i.target += " scale(1)")),
      n.rotate.x &&
        ((i.initial += " rotateX(" + n.rotate.x + "deg)"),
        (i.target += " rotateX(0)")),
      n.rotate.y &&
        ((i.initial += " rotateY(" + n.rotate.y + "deg)"),
        (i.target += " rotateY(0)")),
      n.rotate.z &&
        ((i.initial += " rotateZ(" + n.rotate.z + "deg)"),
        (i.target += " rotateZ(0)")),
      (i.initial += "; opacity: " + n.opacity + ";"),
      (i.target += "; opacity: " + e.styles.computed.opacity + ";");
  }
  function l(e) {
    var t = e.config.container;
    t &&
      O.store.containers.indexOf(t) === -1 &&
      O.store.containers.push(e.config.container),
      (O.store.elements[e.id] = e);
  }
  function c(e, t, n) {
    var i = { target: e, config: t, interval: n };
    O.history.push(i);
  }
  function f() {
    if (O.isSupported()) {
      y();
      for (var e = 0; e < O.store.containers.length; e++)
        O.store.containers[e].addEventListener("scroll", d),
          O.store.containers[e].addEventListener("resize", d);
      O.initialized ||
        (window.addEventListener("scroll", d),
        window.addEventListener("resize", d),
        (O.initialized = !0));
    }
    return O;
  }
  function d() {
    A(y);
  }
  function u() {
    var e, t, n, i;
    O.tools.forOwn(O.sequences, function (o) {
      (i = O.sequences[o]), (e = !1);
      for (var r = 0; r < i.elemIds.length; r++)
        (n = i.elemIds[r]), (t = O.store.elements[n]), q(t) && !e && (e = !0);
      i.active = e;
    });
  }
  function y() {
    var e, t;
    u(),
      O.tools.forOwn(O.store.elements, function (n) {
        (t = O.store.elements[n]),
          (e = w(t)),
          g(t)
            ? (t.config.beforeReveal(t.domEl),
              e
                ? t.domEl.setAttribute(
                    "style",
                    t.styles.inline +
                      t.styles.transform.target +
                      t.styles.transition.delayed
                  )
                : t.domEl.setAttribute(
                    "style",
                    t.styles.inline +
                      t.styles.transform.target +
                      t.styles.transition.instant
                  ),
              p("reveal", t, e),
              (t.revealing = !0),
              (t.seen = !0),
              t.sequence && m(t, e))
            : v(t) &&
              (t.config.beforeReset(t.domEl),
              t.domEl.setAttribute(
                "style",
                t.styles.inline +
                  t.styles.transform.initial +
                  t.styles.transition.instant
              ),
              p("reset", t),
              (t.revealing = !1));
      });
  }
  function m(e, t) {
    var n = 0,
      i = 0,
      o = O.sequences[e.sequence.id];
    (o.blocked = !0),
      t && "onload" === e.config.useDelay && (i = e.config.delay),
      e.sequence.timer &&
        ((n = Math.abs(e.sequence.timer.started - new Date())),
        window.clearTimeout(e.sequence.timer)),
      (e.sequence.timer = { started: new Date() }),
      (e.sequence.timer.clock = window.setTimeout(function () {
        (o.blocked = !1), (e.sequence.timer = null), d();
      }, Math.abs(o.interval) + i - n));
  }
  function p(e, t, n) {
    var i = 0,
      o = 0,
      r = "after";
    switch (e) {
      case "reveal":
        (o = t.config.duration), n && (o += t.config.delay), (r += "Reveal");
        break;
      case "reset":
        (o = t.config.duration), (r += "Reset");
    }
    t.timer &&
      ((i = Math.abs(t.timer.started - new Date())),
      window.clearTimeout(t.timer.clock)),
      (t.timer = { started: new Date() }),
      (t.timer.clock = window.setTimeout(function () {
        t.config[r](t.domEl), (t.timer = null);
      }, o - i));
  }
  function g(e) {
    if (e.sequence) {
      var t = O.sequences[e.sequence.id];
      return t.active && !t.blocked && !e.revealing && !e.disabled;
    }
    return q(e) && !e.revealing && !e.disabled;
  }
  function w(e) {
    var t = e.config.useDelay;
    return (
      "always" === t ||
      ("onload" === t && !O.initialized) ||
      ("once" === t && !e.seen)
    );
  }
  function v(e) {
    if (e.sequence) {
      var t = O.sequences[e.sequence.id];
      return !t.active && e.config.reset && e.revealing && !e.disabled;
    }
    return !q(e) && e.config.reset && e.revealing && !e.disabled;
  }
  function b(e) {
    return { width: e.clientWidth, height: e.clientHeight };
  }
  function h(e) {
    if (e && e !== window.document.documentElement) {
      var t = x(e);
      return { x: e.scrollLeft + t.left, y: e.scrollTop + t.top };
    }
    return { x: window.pageXOffset, y: window.pageYOffset };
  }
  function x(e) {
    var t = 0,
      n = 0,
      i = e.offsetHeight,
      o = e.offsetWidth;
    do
      isNaN(e.offsetTop) || (t += e.offsetTop),
        isNaN(e.offsetLeft) || (n += e.offsetLeft),
        (e = e.offsetParent);
    while (e);
    return { top: t, left: n, height: i, width: o };
  }
  function q(e) {
    function t() {
      var t = c + a * s,
        n = f + l * s,
        i = d - a * s,
        y = u - l * s,
        m = r.y + e.config.viewOffset.top,
        p = r.x + e.config.viewOffset.left,
        g = r.y - e.config.viewOffset.bottom + o.height,
        w = r.x - e.config.viewOffset.right + o.width;
      return t < g && i > m && n < w && y > p;
    }
    function n() {
      return "fixed" === window.getComputedStyle(e.domEl).position;
    }
    var i = x(e.domEl),
      o = b(e.config.container),
      r = h(e.config.container),
      s = e.config.viewFactor,
      a = i.height,
      l = i.width,
      c = i.top,
      f = i.left,
      d = c + a,
      u = f + l;
    return t() || n();
  }
  function E() {}
  var O, A;
  (e.prototype.defaults = {
    origin: "bottom",
    distance: "20px",
    duration: 500,
    delay: 0,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 0.9,
    easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
    container: window.document.documentElement,
    mobile: !0,
    reset: !1,
    useDelay: "always",
    viewFactor: 0.2,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    beforeReveal: function (e) {},
    beforeReset: function (e) {},
    afterReveal: function (e) {},
    afterReset: function (e) {},
  }),
    (e.prototype.isSupported = function () {
      var e = document.documentElement.style;
      return (
        ("WebkitTransition" in e && "WebkitTransform" in e) ||
        ("transition" in e && "transform" in e)
      );
    }),
    (e.prototype.reveal = function (e, s, a, d) {
      var u, y, m, p, g, w;
      if (
        (void 0 !== s && "number" == typeof s
          ? ((a = s), (s = {}))
          : (void 0 !== s && null !== s) || (s = {}),
        (u = t(s)),
        (y = n(e, u)),
        !y.length)
      )
        return O;
      a &&
        "number" == typeof a &&
        ((w = i()),
        (g = O.sequences[w] = { id: w, interval: a, elemIds: [], active: !1 }));
      for (var v = 0; v < y.length; v++)
        (p = y[v].getAttribute("data-sr-id")),
          p
            ? (m = O.store.elements[p])
            : ((m = { id: i(), domEl: y[v], seen: !1, revealing: !1 }),
              m.domEl.setAttribute("data-sr-id", m.id)),
          g &&
            ((m.sequence = { id: g.id, index: g.elemIds.length }),
            g.elemIds.push(m.id)),
          o(m, s, u),
          r(m),
          l(m),
          (O.tools.isMobile() && !m.config.mobile) || !O.isSupported()
            ? (m.domEl.setAttribute("style", m.styles.inline),
              (m.disabled = !0))
            : m.revealing ||
              m.domEl.setAttribute(
                "style",
                m.styles.inline + m.styles.transform.initial
              );
      return (
        !d &&
          O.isSupported() &&
          (c(e, s, a),
          O.initTimeout && window.clearTimeout(O.initTimeout),
          (O.initTimeout = window.setTimeout(f, 0))),
        O
      );
    }),
    (e.prototype.sync = function () {
      if (O.history.length && O.isSupported()) {
        for (var e = 0; e < O.history.length; e++) {
          var t = O.history[e];
          O.reveal(t.target, t.config, t.interval, !0);
        }
        f();
      }
      return O;
    }),
    (E.prototype.isObject = function (e) {
      return null !== e && "object" == typeof e && e.constructor === Object;
    }),
    (E.prototype.isNode = function (e) {
      return "object" == typeof window.Node
        ? e instanceof window.Node
        : e &&
            "object" == typeof e &&
            "number" == typeof e.nodeType &&
            "string" == typeof e.nodeName;
    }),
    (E.prototype.isNodeList = function (e) {
      var t = Object.prototype.toString.call(e),
        n = /^\[object (HTMLCollection|NodeList|Object)\]$/;
      return "object" == typeof window.NodeList
        ? e instanceof window.NodeList
        : e &&
            "object" == typeof e &&
            n.test(t) &&
            "number" == typeof e.length &&
            (0 === e.length || this.isNode(e[0]));
    }),
    (E.prototype.forOwn = function (e, t) {
      if (!this.isObject(e))
        throw new TypeError(
          'Expected "object", but received "' + typeof e + '".'
        );
      for (var n in e) e.hasOwnProperty(n) && t(n);
    }),
    (E.prototype.extend = function (e, t) {
      return (
        this.forOwn(
          t,
          function (n) {
            this.isObject(t[n])
              ? ((e[n] && this.isObject(e[n])) || (e[n] = {}),
                this.extend(e[n], t[n]))
              : (e[n] = t[n]);
          }.bind(this)
        ),
        e
      );
    }),
    (E.prototype.extendClone = function (e, t) {
      return this.extend(this.extend({}, e), t);
    }),
    (E.prototype.isMobile = function () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    }),
    (A =
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      function (e) {
        window.setTimeout(e, 1e3 / 60);
      }),
    "function" == typeof define && "object" == typeof define.amd && define.amd
      ? define(function () {
          return e;
        })
      : "undefined" != typeof module && module.exports
      ? (module.exports = e)
      : (window.ScrollReveal = e);
})();
/**! hopscotch - v0.3.1
 *
 * Copyright 2017 LinkedIn Corp. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
!(function (a, b) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = b())
    : "function" == typeof define && define.amd
    ? define(b)
    : (a.hopscotch = b());
})(this, function () {
  "use strict";
  var a,
    b,
    c,
    d,
    e,
    f,
    g,
    h,
    i,
    j,
    k,
    l,
    m,
    n =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (a) {
            return typeof a;
          }
        : function (a) {
            return a &&
              "function" == typeof Symbol &&
              a.constructor === Symbol &&
              a !== Symbol.prototype
              ? "symbol"
              : typeof a;
          },
    o = "bubble_default",
    p = window.Sizzle || null,
    q = "undefined",
    r = !1,
    s = ("undefined" == typeof jQuery ? "undefined" : n(jQuery)) !== q,
    t = !1,
    u = !1,
    v = /^[a-zA-Z]+[a-zA-Z0-9_-]*$/,
    w = { left: "right", right: "left" };
  try {
    n(window.sessionStorage) !== q &&
      ((t = !0),
      sessionStorage.setItem("hopscotch.test.storage", "ok"),
      sessionStorage.removeItem("hopscotch.test.storage"),
      (u = !0));
  } catch (x) {}
  (l = {
    smoothScroll: !0,
    scrollDuration: 1e3,
    scrollTopMargin: 200,
    showCloseButton: !0,
    showPrevButton: !1,
    showNextButton: !0,
    bubbleWidth: 280,
    bubblePadding: 15,
    arrowWidth: 20,
    skipIfNoElement: !0,
    isRtl: !1,
    cookieName: "hopscotch.tour.state",
  }),
    Array.isArray ||
      (Array.isArray = function (a) {
        return "[object Array]" === Object.prototype.toString.call(a);
      }),
    (k = function () {
      r && m.startTour();
    }),
    (h = {
      addClass: function (a, b) {
        var c, d, e, f;
        if (a.className) {
          for (
            d = b.split(/\s+/),
              c = " " + a.className + " ",
              e = 0,
              f = d.length;
            f > e;
            ++e
          )
            c.indexOf(" " + d[e] + " ") < 0 && (c += d[e] + " ");
          a.className = c.replace(/^\s+|\s+$/g, "");
        } else a.className = b;
      },
      removeClass: function (a, b) {
        var c, d, e, f;
        for (
          d = b.split(/\s+/), c = " " + a.className + " ", e = 0, f = d.length;
          f > e;
          ++e
        )
          c = c.replace(" " + d[e] + " ", " ");
        a.className = c.replace(/^\s+|\s+$/g, "");
      },
      hasClass: function (a, b) {
        var c;
        return a.className
          ? ((c = " " + a.className + " "), -1 !== c.indexOf(" " + b + " "))
          : !1;
      },
      getPixelValue: function (a) {
        var b = "undefined" == typeof a ? "undefined" : n(a);
        return "number" === b ? a : "string" === b ? parseInt(a, 10) : 0;
      },
      valOrDefault: function (a, b) {
        return ("undefined" == typeof a ? "undefined" : n(a)) !== q ? a : b;
      },
      invokeCallbackArrayHelper: function (a) {
        var b;
        return Array.isArray(a) && ((b = j[a[0]]), "function" == typeof b)
          ? b.apply(this, a.slice(1))
          : void 0;
      },
      invokeCallbackArray: function (a) {
        var b, c;
        if (Array.isArray(a)) {
          if ("string" == typeof a[0]) return h.invokeCallbackArrayHelper(a);
          for (b = 0, c = a.length; c > b; ++b) h.invokeCallback(a[b]);
        }
      },
      invokeCallback: function (a) {
        return "function" == typeof a
          ? a()
          : "string" == typeof a && j[a]
          ? j[a]()
          : h.invokeCallbackArray(a);
      },
      invokeEventCallbacks: function (a, b) {
        var c,
          d,
          e = i[a];
        if (b) return this.invokeCallback(b);
        for (c = 0, d = e.length; d > c; ++c) this.invokeCallback(e[c].cb);
      },
      getScrollTop: function () {
        var a;
        return (a =
          n(window.pageYOffset) !== q
            ? window.pageYOffset
            : document.documentElement.scrollTop);
      },
      getScrollLeft: function () {
        var a;
        return (a =
          n(window.pageXOffset) !== q
            ? window.pageXOffset
            : document.documentElement.scrollLeft);
      },
      getWindowHeight: function () {
        return window.innerHeight || document.documentElement.clientHeight;
      },
      addEvtListener: function (a, b, c) {
        return a
          ? a.addEventListener
            ? a.addEventListener(b, c, !1)
            : a.attachEvent("on" + b, c)
          : void 0;
      },
      removeEvtListener: function (a, b, c) {
        return a
          ? a.removeEventListener
            ? a.removeEventListener(b, c, !1)
            : a.detachEvent("on" + b, c)
          : void 0;
      },
      documentIsReady: function () {
        return "complete" === document.readyState;
      },
      evtPreventDefault: function (a) {
        a.preventDefault
          ? a.preventDefault()
          : event && (event.returnValue = !1);
      },
      extend: function (a, b) {
        var c;
        for (c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
      },
      getStepTargetHelper: function (a) {
        var b = document.getElementById(a);
        if (b) return b;
        if (s) return (b = jQuery(a)), b.length ? b[0] : null;
        if (p) return (b = new p(a)), b.length ? b[0] : null;
        if (document.querySelector)
          try {
            return document.querySelector(a);
          } catch (c) {}
        return /^#[a-zA-Z][\w-_:.]*$/.test(a)
          ? document.getElementById(a.substring(1))
          : null;
      },
      getStepTarget: function (a) {
        var b;
        if (!a || !a.target) return null;
        if ("string" == typeof a.target) return h.getStepTargetHelper(a.target);
        if (Array.isArray(a.target)) {
          var c, d;
          for (c = 0, d = a.target.length; d > c; c++)
            if (
              "string" == typeof a.target[c] &&
              (b = h.getStepTargetHelper(a.target[c]))
            )
              return b;
          return null;
        }
        return a.target;
      },
      getI18NString: function (a) {
        return e[a] || d[a];
      },
      setState: function (a, b, c) {
        var d,
          e = "";
        if (t && u)
          try {
            sessionStorage.setItem(a, b);
          } catch (f) {
            (u = !1), this.setState(a, b, c);
          }
        else
          t && sessionStorage.removeItem(a),
            c &&
              ((d = new Date()),
              d.setTime(d.getTime() + 24 * c * 60 * 60 * 1e3),
              (e = "; expires=" + d.toGMTString())),
            (document.cookie = a + "=" + b + e + "; path=/");
      },
      getState: function (a) {
        var b,
          c,
          d,
          e = a + "=",
          f = document.cookie.split(";");
        if (t && (d = sessionStorage.getItem(a))) return d;
        for (b = 0; b < f.length; b++) {
          for (c = f[b]; " " === c.charAt(0); ) c = c.substring(1, c.length);
          if (0 === c.indexOf(e)) {
            d = c.substring(e.length, c.length);
            break;
          }
        }
        return d;
      },
      clearState: function (a) {
        t ? sessionStorage.removeItem(a) : this.setState(a, "", -1);
      },
      normalizePlacement: function (a) {
        !a.placement && a.orientation && (a.placement = a.orientation);
      },
      flipPlacement: function (a) {
        if (a.isRtl && !a._isFlipped) {
          var b,
            c,
            d = ["orientation", "placement"];
          a.xOffset && (a.xOffset = -1 * this.getPixelValue(a.xOffset));
          for (c in d)
            (b = d[c]),
              a.hasOwnProperty(b) && w.hasOwnProperty(a[b]) && (a[b] = w[a[b]]);
          a._isFlipped = !0;
        }
      },
    }),
    h.addEvtListener(window, "load", k),
    (i = {
      next: [],
      prev: [],
      start: [],
      end: [],
      show: [],
      error: [],
      close: [],
    }),
    (j = {}),
    (d = {
      stepNums: null,
      nextBtn: "Next",
      prevBtn: "Back",
      doneBtn: "Done",
      skipBtn: "Skip",
      closeTooltip: "Close",
    }),
    (e = {}),
    (b = function (a) {
      this.init(a);
    }),
    (b.prototype = {
      isShowing: !1,
      currStep: void 0,
      setPosition: function (a) {
        var b,
          c,
          d,
          e,
          f,
          g,
          i,
          j = h.getStepTarget(a),
          k = this.element,
          l = this.arrowEl,
          m = a.isRtl ? "right" : "left";
        if (
          (h.flipPlacement(a),
          h.normalizePlacement(a),
          (c = k.offsetWidth),
          (b = k.offsetHeight),
          h.removeClass(
            k,
            "fade-in-down fade-in-up fade-in-left fade-in-right"
          ),
          (d = j.getBoundingClientRect()),
          (i = a.isRtl ? d.right - c : d.left),
          "top" === a.placement)
        )
          (e = d.top - b - this.opt.arrowWidth), (f = i);
        else if ("bottom" === a.placement)
          (e = d.bottom + this.opt.arrowWidth), (f = i);
        else if ("left" === a.placement)
          (e = d.top), (f = d.left - c - this.opt.arrowWidth);
        else {
          if ("right" !== a.placement)
            throw new Error(
              "Bubble placement failed because step.placement is invalid or undefined!"
            );
          (e = d.top), (f = d.right + this.opt.arrowWidth);
        }
        (g =
          "center" !== a.arrowOffset
            ? h.getPixelValue(a.arrowOffset)
            : a.arrowOffset),
          g
            ? "top" === a.placement || "bottom" === a.placement
              ? ((l.style.top = ""),
                "center" === g
                  ? (l.style[m] = Math.floor(c / 2 - l.offsetWidth / 2) + "px")
                  : (l.style[m] = g + "px"))
              : ("left" === a.placement || "right" === a.placement) &&
                ((l.style[m] = ""),
                "center" === g
                  ? (l.style.top =
                      Math.floor(b / 2 - l.offsetHeight / 2) + "px")
                  : (l.style.top = g + "px"))
            : ((l.style.top = ""), (l.style[m] = "")),
          "center" === a.xOffset
            ? (f = d.left + j.offsetWidth / 2 - c / 2)
            : (f += h.getPixelValue(a.xOffset)),
          "center" === a.yOffset
            ? (e = d.top + j.offsetHeight / 2 - b / 2)
            : (e += h.getPixelValue(a.yOffset)),
          a.fixedElement || ((e += h.getScrollTop()), (f += h.getScrollLeft())),
          (k.style.position = a.fixedElement ? "fixed" : "absolute"),
          (k.style.top = e + "px"),
          (k.style.left = f + "px");
      },
      render: function (a, b, c) {
        var d,
          e,
          g,
          i,
          j,
          k,
          l,
          n,
          p,
          q,
          r = this.element;
        if (
          (a ? (this.currStep = a) : this.currStep && (a = this.currStep),
          this.opt.isTourBubble
            ? ((i = m.getCurrTour()),
              i &&
                ((e = i.customData),
                (d = i.customRenderer),
                (a.isRtl = a.hasOwnProperty("isRtl")
                  ? a.isRtl
                  : i.hasOwnProperty("isRtl")
                  ? i.isRtl
                  : this.opt.isRtl),
                (g = i.unsafe),
                Array.isArray(i.steps) &&
                  ((j = i.steps.length),
                  (k = this._getStepI18nNum(this._getStepNum(j - 1))),
                  (n = this._getStepNum(b) === this._getStepNum(j - 1)))))
            : ((e = a.customData),
              (d = a.customRenderer),
              (g = a.unsafe),
              (a.isRtl = a.hasOwnProperty("isRtl") ? a.isRtl : this.opt.isRtl)),
          (l = n
            ? h.getI18NString("doneBtn")
            : a.showSkip
            ? h.getI18NString("skipBtn")
            : h.getI18NString("nextBtn")),
          h.flipPlacement(a),
          h.normalizePlacement(a),
          (this.placement = a.placement),
          (q = {
            i18n: {
              prevBtn: h.getI18NString("prevBtn"),
              nextBtn: l,
              closeTooltip: h.getI18NString("closeTooltip"),
              stepNum: this._getStepI18nNum(this._getStepNum(b)),
              numSteps: k,
            },
            buttons: {
              showPrev:
                h.valOrDefault(a.showPrevButton, this.opt.showPrevButton) &&
                this._getStepNum(b) > 0,
              showNext: h.valOrDefault(
                a.showNextButton,
                this.opt.showNextButton
              ),
              showCTA: h.valOrDefault(a.showCTAButton && a.ctaLabel, !1),
              ctaLabel: a.ctaLabel,
              showClose: h.valOrDefault(this.opt.showCloseButton, !0),
            },
            step: {
              num: b,
              isLast: h.valOrDefault(n, !1),
              title: a.title || "",
              content: a.content || "",
              isRtl: a.isRtl,
              placement: a.placement,
              padding: h.valOrDefault(a.padding, this.opt.bubblePadding),
              width: h.getPixelValue(a.width) || this.opt.bubbleWidth,
              customData: a.customData || {},
            },
            tour: {
              isTour: this.opt.isTourBubble,
              numSteps: j,
              unsafe: h.valOrDefault(g, !1),
              customData: e || {},
            },
          }),
          "function" == typeof d)
        )
          r.innerHTML = d(q);
        else if ("string" == typeof d) {
          if (!m.templates || "function" != typeof m.templates[d])
            throw new Error(
              'Bubble rendering failed - template "' +
                d +
                '" is not a function.'
            );
          r.innerHTML = m.templates[d](q);
        } else if (f) r.innerHTML = f(q);
        else {
          if (!m.templates || "function" != typeof m.templates[o])
            throw new Error(
              'Bubble rendering failed - template "' +
                o +
                '" is not a function.'
            );
          r.innerHTML = m.templates[o](q);
        }
        var s,
          t = r.children,
          u = t.length;
        for (p = 0; u > p; p++)
          (s = t[p]), h.hasClass(s, "hopscotch-arrow") && (this.arrowEl = s);
        return (
          (r.style.zIndex = "number" == typeof a.zindex ? a.zindex : ""),
          this._setArrow(a.placement),
          this.hide(!1),
          this.setPosition(a),
          c && c(!a.fixedElement),
          this
        );
      },
      _getStepNum: function (a) {
        var b,
          c,
          d = 0,
          e = m.getSkippedStepsIndexes(),
          f = e.length;
        for (c = 0; f > c; c++) (b = e[c]), a > b && d++;
        return a - d;
      },
      _getStepI18nNum: function (a) {
        var b = h.getI18NString("stepNums");
        return b && a < b.length ? (a = b[a]) : (a += 1), a;
      },
      _setArrow: function (a) {
        h.removeClass(this.arrowEl, "down up right left"),
          "top" === a
            ? h.addClass(this.arrowEl, "down")
            : "bottom" === a
            ? h.addClass(this.arrowEl, "up")
            : "left" === a
            ? h.addClass(this.arrowEl, "right")
            : "right" === a && h.addClass(this.arrowEl, "left");
      },
      _getArrowDirection: function () {
        return "top" === this.placement
          ? "down"
          : "bottom" === this.placement
          ? "up"
          : "left" === this.placement
          ? "right"
          : "right" === this.placement
          ? "left"
          : void 0;
      },
      show: function () {
        var a = this,
          b = "fade-in-" + this._getArrowDirection(),
          c = 1e3;
        return (
          h.removeClass(this.element, "hide"),
          h.addClass(this.element, b),
          setTimeout(function () {
            h.removeClass(a.element, "invisible");
          }, 50),
          setTimeout(function () {
            h.removeClass(a.element, b);
          }, c),
          (this.isShowing = !0),
          this
        );
      },
      hide: function (a) {
        var b = this.element;
        return (
          (a = h.valOrDefault(a, !0)),
          (b.style.top = ""),
          (b.style.left = ""),
          a
            ? (h.addClass(b, "hide"), h.removeClass(b, "invisible"))
            : (h.removeClass(b, "hide"), h.addClass(b, "invisible")),
          h.removeClass(
            b,
            "animate fade-in-up fade-in-down fade-in-right fade-in-left"
          ),
          (this.isShowing = !1),
          this
        );
      },
      destroy: function () {
        var a = this.element;
        a && a.parentNode.removeChild(a),
          h.removeEvtListener(a, "click", this.clickCb);
      },
      _handleBubbleClick: function (a) {
        function b(c) {
          return c === a.currentTarget
            ? null
            : h.hasClass(c, "hopscotch-cta")
            ? "cta"
            : h.hasClass(c, "hopscotch-next")
            ? "next"
            : h.hasClass(c, "hopscotch-prev")
            ? "prev"
            : h.hasClass(c, "hopscotch-close")
            ? "close"
            : b(c.parentElement);
        }
        var c;
        a = a || window.event;
        var d = a.target || a.srcElement;
        if (((c = b(d)), "cta" === c))
          this.opt.isTourBubble ||
            m.getCalloutManager().removeCallout(this.currStep.id),
            this.currStep.onCTA && h.invokeCallback(this.currStep.onCTA);
        else if ("next" === c) m.nextStep(!0);
        else if ("prev" === c) m.prevStep(!0);
        else if ("close" === c) {
          if (this.opt.isTourBubble) {
            var e = m.getCurrStepNum(),
              f = m.getCurrTour(),
              g = e === f.steps.length - 1;
            h.invokeEventCallbacks("close"), m.endTour(!0, g);
          } else
            this.opt.onClose && h.invokeCallback(this.opt.onClose),
              this.opt.id && !this.opt.isTourBubble
                ? m.getCalloutManager().removeCallout(this.opt.id)
                : this.destroy();
          h.evtPreventDefault(a);
        }
      },
      init: function (a) {
        var b,
          c,
          d,
          e,
          f = document.createElement("div"),
          g = this,
          i = !1;
        (this.element = f),
          (e = {
            showPrevButton: l.showPrevButton,
            showNextButton: l.showNextButton,
            bubbleWidth: l.bubbleWidth,
            bubblePadding: l.bubblePadding,
            arrowWidth: l.arrowWidth,
            isRtl: l.isRtl,
            showNumber: !0,
            isTourBubble: !0,
          }),
          (a = ("undefined" == typeof a ? "undefined" : n(a)) === q ? {} : a),
          h.extend(e, a),
          (this.opt = e),
          (f.className = "hopscotch-bubble animated"),
          e.isTourBubble
            ? ((d = m.getCurrTour()), d && h.addClass(f, "tour-" + d.id))
            : h.addClass(f, "hopscotch-callout no-number"),
          (b = function () {
            !i &&
              g.isShowing &&
              ((i = !0),
              setTimeout(function () {
                g.setPosition(g.currStep), (i = !1);
              }, 100));
          }),
          h.addEvtListener(window, "resize", b),
          (this.clickCb = function (a) {
            g._handleBubbleClick(a);
          }),
          h.addEvtListener(f, "click", this.clickCb),
          this.hide(),
          h.documentIsReady()
            ? document.body.appendChild(f)
            : (document.addEventListener
                ? ((c = function () {
                    document.removeEventListener("DOMContentLoaded", c),
                      window.removeEventListener("load", c),
                      document.body.appendChild(f);
                  }),
                  document.addEventListener("DOMContentLoaded", c, !1))
                : ((c = function () {
                    "complete" === document.readyState &&
                      (document.detachEvent("onreadystatechange", c),
                      window.detachEvent("onload", c),
                      document.body.appendChild(f));
                  }),
                  document.attachEvent("onreadystatechange", c)),
              h.addEvtListener(window, "load", c));
      },
    }),
    (c = function () {
      var a = {},
        c = {};
      (this.createCallout = function (d) {
        var e;
        if (!d.id) throw new Error("Must specify a callout id.");
        if (!v.test(d.id))
          throw new Error(
            "Callout ID is using an invalid format. Use alphanumeric, underscores, and/or hyphens only. First character must be a letter."
          );
        if (a[d.id])
          throw new Error(
            "Callout by that id already exists. Please choose a unique id."
          );
        if (!h.getStepTarget(d))
          throw new Error(
            "Must specify existing target element via 'target' option."
          );
        return (
          (d.showNextButton = d.showPrevButton = !1),
          (d.isTourBubble = !1),
          (e = new b(d)),
          (a[d.id] = e),
          (c[d.id] = d),
          e.render(d, null, function () {
            e.show(), d.onShow && h.invokeCallback(d.onShow);
          }),
          e
        );
      }),
        (this.getCallout = function (b) {
          return a[b];
        }),
        (this.removeAllCallouts = function () {
          var b;
          for (b in a) a.hasOwnProperty(b) && this.removeCallout(b);
        }),
        (this.removeCallout = function (b) {
          var d = a[b];
          (a[b] = null), (c[b] = null), d && d.destroy();
        }),
        (this.refreshCalloutPositions = function () {
          var b, d, e;
          for (b in a)
            a.hasOwnProperty(b) &&
              c.hasOwnProperty(b) &&
              ((d = a[b]), (e = c[b]), d && e && d.setPosition(e));
        });
    }),
    (a = function (a) {
      var d,
        k,
        p,
        t,
        u,
        w,
        x,
        y,
        z = this,
        A = {},
        B = [],
        C = function (a) {
          return (
            (d && d.element && d.element.parentNode) || (d = new b(p)),
            a &&
              h.extend(d.opt, {
                bubblePadding: E("bubblePadding"),
                bubbleWidth: E("bubbleWidth"),
                showNextButton: E("showNextButton"),
                showPrevButton: E("showPrevButton"),
                showCloseButton: E("showCloseButton"),
                arrowWidth: E("arrowWidth"),
                isRtl: E("isRtl"),
              }),
            d
          );
        },
        D = function () {
          d && (d.destroy(), (d = null));
        },
        E = function (a) {
          return "undefined" == typeof p ? l[a] : h.valOrDefault(p[a], l[a]);
        },
        F = function () {
          var a;
          return (a = !t || 0 > u || u >= t.steps.length ? null : t.steps[u]);
        },
        G = function () {
          z.nextStep();
        },
        H = function (a) {
          var b,
            c,
            d,
            e,
            f,
            g,
            i = C(),
            j = i.element,
            k = h.getPixelValue(j.style.top),
            l = k + h.getPixelValue(j.offsetHeight),
            m = h.getStepTarget(F()),
            o = m.getBoundingClientRect(),
            p = o.top + h.getScrollTop(),
            r = o.bottom + h.getScrollTop(),
            t = p > k ? k : p,
            u = l > r ? l : r,
            v = h.getScrollTop(),
            w = v + h.getWindowHeight(),
            x = t - E("scrollTopMargin");
          t >= v && (t <= v + E("scrollTopMargin") || w >= u)
            ? a && a()
            : E("smoothScroll")
            ? ("undefined" == typeof YAHOO ? "undefined" : n(YAHOO)) !== q &&
              n(YAHOO.env) !== q &&
              n(YAHOO.env.ua) !== q &&
              n(YAHOO.util) !== q &&
              n(YAHOO.util.Scroll) !== q
              ? ((b = YAHOO.env.ua.webkit
                  ? document.body
                  : document.documentElement),
                (d = YAHOO.util.Easing ? YAHOO.util.Easing.easeOut : void 0),
                (c = new YAHOO.util.Scroll(
                  b,
                  { scroll: { to: [0, x] } },
                  E("scrollDuration") / 1e3,
                  d
                )),
                c.onComplete.subscribe(a),
                c.animate())
              : s
              ? jQuery("body, html").animate(
                  { scrollTop: x },
                  E("scrollDuration"),
                  a
                )
              : (0 > x && (x = 0),
                (e = v > t ? -1 : 1),
                (f = Math.abs(v - x) / (E("scrollDuration") / 10)),
                (g = function () {
                  var b = h.getScrollTop(),
                    c = b + e * f;
                  return (e > 0 && c >= x) || (0 > e && x >= c)
                    ? ((c = x), a && a(), void window.scrollTo(0, c))
                    : (window.scrollTo(0, c),
                      h.getScrollTop() === b
                        ? void (a && a())
                        : void setTimeout(g, 10));
                })())
            : (window.scrollTo(0, x), a && a());
        },
        I = function P(a, b) {
          var c, d, e;
          u + a >= 0 && u + a < t.steps.length
            ? ((u += a),
              (d = F()),
              (e = function () {
                (c = h.getStepTarget(d)),
                  c
                    ? (A[u] && delete A[u], b(u))
                    : ((A[u] = !0), h.invokeEventCallbacks("error"), P(a, b));
              }),
              d.delay ? setTimeout(e, d.delay) : e())
            : b(-1);
        },
        J = function (a, b) {
          var c,
            d,
            e,
            f,
            g = C(),
            i = this;
          if (
            (g.hide(),
            (a = h.valOrDefault(a, !0)),
            (c = F()),
            c.nextOnTargetClick &&
              h.removeEvtListener(h.getStepTarget(c), "click", G),
            (d = c),
            (e = b > 0 ? d.multipage : u > 0 && t.steps[u - 1].multipage),
            (f = function (c) {
              var f;
              if (-1 === c) return this.endTour(!0);
              if (
                (a &&
                  (f =
                    b > 0
                      ? h.invokeEventCallbacks("next", d.onNext)
                      : h.invokeEventCallbacks("prev", d.onPrev)),
                c === u)
              ) {
                if (e) return void N();
                (f = h.valOrDefault(f, !0)),
                  f ? this.showStep(c) : this.endTour(!1);
              }
            }),
            !e && E("skipIfNoElement"))
          )
            I(b, function (a) {
              f.call(i, a);
            });
          else if (u + b >= 0 && u + b < t.steps.length) {
            if (((u += b), (c = F()), !h.getStepTarget(c) && !e))
              return h.invokeEventCallbacks("error"), this.endTour(!0, !1);
            f.call(this, u);
          } else if (u + b === t.steps.length) return this.endTour();
          return this;
        },
        K = function (a) {
          var b,
            c,
            d,
            e = {};
          for (b in a)
            a.hasOwnProperty(b) && "id" !== b && "steps" !== b && (e[b] = a[b]);
          return (
            y.call(this, e, !0),
            (c = h.getState(E("cookieName"))),
            c &&
              ((d = c.split(":")),
              (w = d[0]),
              (x = d[1]),
              d.length > 2 && (B = d[2].split(",")),
              (x = parseInt(x, 10))),
            this
          );
        },
        L = function (a, b, c) {
          var d, e;
          if (
            ((u = a || 0), (A = b || {}), (d = F()), (e = h.getStepTarget(d)))
          )
            return void c(u);
          if (!e) {
            if (
              (h.invokeEventCallbacks("error"),
              (A[u] = !0),
              E("skipIfNoElement"))
            )
              return void I(1, c);
            (u = -1), c(u);
          }
        },
        M = function (a) {
          function b() {
            d.show(), h.invokeEventCallbacks("show", c.onShow);
          }
          var c = t.steps[a],
            d = C(),
            e = h.getStepTarget(c);
          u !== a &&
            F().nextOnTargetClick &&
            h.removeEvtListener(h.getStepTarget(F()), "click", G),
            (u = a),
            d.hide(!1),
            d.render(c, a, function (a) {
              a ? H(b) : b(),
                c.nextOnTargetClick && h.addEvtListener(e, "click", G);
            }),
            N();
        },
        N = function () {
          var a = t.id + ":" + u,
            b = m.getSkippedStepsIndexes();
          b && b.length > 0 && (a += ":" + b.join(",")),
            h.setState(E("cookieName"), a, 1);
        },
        O = function (a) {
          a && this.configure(a);
        };
      (this.getCalloutManager = function () {
        return (
          ("undefined" == typeof k ? "undefined" : n(k)) === q && (k = new c()),
          k
        );
      }),
        (this.startTour = function (a, b) {
          var c,
            d,
            e = {},
            f = this;
          if (!t) {
            if (!a) throw new Error("Tour data is required for startTour.");
            if (!a.id || !v.test(a.id))
              throw new Error(
                "Tour ID is using an invalid format. Use alphanumeric, underscores, and/or hyphens only. First character must be a letter."
              );
            (t = a), K.call(this, a);
          }
          if (("undefined" == typeof b ? "undefined" : n(b)) !== q) {
            if (b >= t.steps.length)
              throw new Error("Specified step number out of bounds.");
            d = b;
          }
          if (!h.documentIsReady()) return (r = !0), this;
          if (
            "undefined" == typeof d &&
            t.id === w &&
            ("undefined" == typeof x ? "undefined" : n(x)) !== q
          ) {
            if (((d = x), B.length > 0))
              for (var g = 0, i = B.length; i > g; g++) e[B[g]] = !0;
          } else d || (d = 0);
          return (
            L(d, e, function (a) {
              var b = -1 !== a && h.getStepTarget(t.steps[a]);
              return b
                ? (h.invokeEventCallbacks("start"),
                  (c = C()),
                  c.hide(!1),
                  (f.isActive = !0),
                  void (h.getStepTarget(F())
                    ? f.showStep(a)
                    : (h.invokeEventCallbacks("error"),
                      E("skipIfNoElement") && f.nextStep(!1))))
                : void f.endTour(!1, !1);
            }),
            this
          );
        }),
        (this.showStep = function (a) {
          var b = t.steps[a],
            c = u;
          return h.getStepTarget(b)
            ? (b.delay
                ? setTimeout(function () {
                    M(a);
                  }, b.delay)
                : M(a),
              this)
            : ((u = a), h.invokeEventCallbacks("error"), void (u = c));
        }),
        (this.prevStep = function (a) {
          return J.call(this, a, -1), this;
        }),
        (this.nextStep = function (a) {
          return J.call(this, a, 1), this;
        }),
        (this.endTour = function (a, b) {
          var c,
            d = C();
          return (
            (a = h.valOrDefault(a, !0)),
            (b = h.valOrDefault(b, !0)),
            t &&
              ((c = F()),
              c &&
                c.nextOnTargetClick &&
                h.removeEvtListener(h.getStepTarget(c), "click", G)),
            (u = 0),
            (x = void 0),
            d.hide(),
            a && h.clearState(E("cookieName")),
            this.isActive &&
              ((this.isActive = !1), t && b && h.invokeEventCallbacks("end")),
            this.removeCallbacks(null, !0),
            this.resetDefaultOptions(),
            D(),
            (t = null),
            this
          );
        }),
        (this.getCurrTour = function () {
          return t;
        }),
        (this.getCurrTarget = function () {
          return h.getStepTarget(F());
        }),
        (this.getCurrStepNum = function () {
          return u;
        }),
        (this.getSkippedStepsIndexes = function () {
          var a,
            b = [];
          for (a in A) b.push(a);
          return b;
        }),
        (this.refreshBubblePosition = function () {
          var a = F();
          return (
            a && C().setPosition(a),
            this.getCalloutManager().refreshCalloutPositions(),
            this
          );
        }),
        (this.listen = function (a, b, c) {
          return a && i[a].push({ cb: b, fromTour: c }), this;
        }),
        (this.unlisten = function (a, b) {
          var c,
            d,
            e = i[a];
          for (c = 0, d = e.length; d > c; ++c) e[c].cb === b && e.splice(c, 1);
          return this;
        }),
        (this.removeCallbacks = function (a, b) {
          var c, d, e, f;
          for (f in i)
            if (!a || a === f)
              if (b)
                for (c = i[f], d = 0, e = c.length; e > d; ++d)
                  c[d].fromTour && (c.splice(d--, 1), --e);
              else i[f] = [];
          return this;
        }),
        (this.registerHelper = function (a, b) {
          "string" == typeof a && "function" == typeof b && (j[a] = b);
        }),
        (this.unregisterHelper = function (a) {
          j[a] = null;
        }),
        (this.invokeHelper = function (a) {
          var b,
            c,
            d = [];
          for (b = 1, c = arguments.length; c > b; ++b) d.push(arguments[b]);
          j[a] && j[a].call(null, d);
        }),
        (this.setCookieName = function (a) {
          return (p.cookieName = a), this;
        }),
        (this.resetDefaultOptions = function () {
          return (p = {}), this;
        }),
        (this.resetDefaultI18N = function () {
          return (e = {}), this;
        }),
        (this.getState = function () {
          return h.getState(E("cookieName"));
        }),
        (y = function (a, b) {
          var c,
            d,
            f,
            g,
            i = ["next", "prev", "start", "end", "show", "error", "close"];
          for (
            p || this.resetDefaultOptions(),
              h.extend(p, a),
              a && h.extend(e, a.i18n),
              f = 0,
              g = i.length;
            g > f;
            ++f
          )
            (d = "on" + i[f].charAt(0).toUpperCase() + i[f].substring(1)),
              a[d] && this.listen(i[f], a[d], b);
          return (c = C(!0)), this;
        }),
        (this.configure = function (a) {
          return y.call(this, a, !1);
        }),
        (this.setRenderer = function (a) {
          var b = "undefined" == typeof a ? "undefined" : n(a);
          return (
            "string" === b
              ? ((o = a), (f = void 0))
              : "function" === b && (f = a),
            this
          );
        }),
        (this.setEscaper = function (a) {
          return "function" == typeof a && (g = a), this;
        }),
        O.call(this, a);
    }),
    (m = new a()),
    function () {
      var a = {};
      (a.escape = function (a) {
        return g
          ? g(a)
          : null == a
          ? ""
          : ("" + a).replace(new RegExp("[&<>\"']", "g"), function (a) {
              return "&" == a
                ? "&amp;"
                : "<" == a
                ? "&lt;"
                : ">" == a
                ? "&gt;"
                : '"' == a
                ? "&quot;"
                : "'" == a
                ? "&#x27;"
                : void 0;
            });
      }),
        (this.templates = this.templates || {}),
        (this.templates.bubble_default = function (b) {
          function c(b, c) {
            return c ? a.escape(b) : b;
          }
          var d,
            e = "";
          a.escape, Array.prototype.join;
          e += "\n";
          var f = b.i18n,
            g = b.buttons,
            h = b.step,
            i = b.tour;
          return (
            (e +=
              '\n<div class="hopscotch-bubble-container" style="width: ' +
              (null == (d = h.width) ? "" : d) +
              "px; padding: " +
              (null == (d = h.padding) ? "" : d) +
              'px;">\n  '),
            i.isTour &&
              (e +=
                '<span class="hopscotch-bubble-number">' +
                (null == (d = f.stepNum) ? "" : d) +
                "</span>"),
            (e += '\n  <div class="hopscotch-bubble-content">\n    '),
            "" !== h.title &&
              (e +=
                '<h3 class="hopscotch-title">' +
                (null == (d = c(h.title, i.unsafe)) ? "" : d) +
                "</h3>"),
            (e += "\n    "),
            "" !== h.content &&
              (e +=
                '<div class="hopscotch-content">' +
                (null == (d = c(h.content, i.unsafe)) ? "" : d) +
                "</div>"),
            (e += '\n  </div>\n  <div class="hopscotch-actions">\n    '),
            g.showPrev &&
              (e +=
                '<button class="hopscotch-nav-button prev hopscotch-prev">' +
                (null == (d = f.prevBtn) ? "" : d) +
                "</button>"),
            (e += "\n    "),
            g.showCTA &&
              (e +=
                '<button class="hopscotch-nav-button next hopscotch-cta">' +
                (null == (d = g.ctaLabel) ? "" : d) +
                "</button>"),
            (e += "\n    "),
            g.showNext &&
              (e +=
                '<button class="hopscotch-nav-button next hopscotch-next">' +
                (null == (d = f.nextBtn) ? "" : d) +
                "</button>"),
            (e += "\n  </div>\n  "),
            g.showClose &&
              (e +=
                '<button class="hopscotch-bubble-close hopscotch-close">' +
                (null == (d = f.closeTooltip) ? "" : d) +
                "</button>"),
            (e +=
              '\n</div>\n<div class="hopscotch-bubble-arrow-container hopscotch-arrow">\n  <div class="hopscotch-bubble-arrow-border"></div>\n  <div class="hopscotch-bubble-arrow"></div>\n</div>\n')
          );
        });
    }.call(m);
  var y = m;
  return y;
});
/* @preserve
    _____ __ _     __                _
   / ___// /(_)___/ /___  ____      (_)___
  / (_ // // // _  // -_)/ __/_    / /(_-<
  \___//_//_/ \_,_/ \__//_/  (_)__/ //___/
                              |___/

  Version: 1.7.1
  Author: Nick Piscitelli (pickykneee)
  Website: https://nickpiscitelli.com
  Documentation: http://nickpiscitelli.github.io/Glider.js
  License: MIT License
  Release Date: October 25th, 2018

*/
!(function (e) {
  "function" == typeof define && define.amd
    ? define(e)
    : "object" == typeof exports
    ? (module.exports = e())
    : e();
})(function () {
  var a = "undefined" != typeof window ? window : this,
    e = (a.Glider = function (e, t) {
      var o = this;
      if (e._glider) return e._glider;
      if (
        ((o.ele = e),
        o.ele.classList.add("glider"),
        ((o.ele._glider = o).opt = Object.assign(
          {},
          {
            slidesToScroll: 1,
            slidesToShow: 1,
            resizeLock: !0,
            duration: 0.5,
            easing: function (e, t, o, i, r) {
              return i * (t /= r) * t + o;
            },
          },
          t
        )),
        (o.animate_id = o.page = o.slide = 0),
        (o.arrows = {}),
        (o._opt = o.opt),
        o.opt.skipTrack)
      )
        o.track = o.ele.children[0];
      else
        for (
          o.track = document.createElement("div"), o.ele.appendChild(o.track);
          1 !== o.ele.children.length;

        )
          o.track.appendChild(o.ele.children[0]);
      o.track.classList.add("glider-track"),
        o.init(),
        (o.resize = o.init.bind(o, !0)),
        o.event(o.ele, "add", { scroll: o.updateControls.bind(o) }),
        o.event(a, "add", { resize: o.resize });
    }),
    t = e.prototype;
  return (
    (t.init = function (e, t) {
      var o = this,
        i = 0,
        r = 0;
      (o.slides = o.track.children),
        [].forEach.call(o.slides, function (e) {
          e.classList.add("glider-slide");
        }),
        (o.containerWidth = o.ele.clientWidth);
      var s = o.settingsBreakpoint();
      if (((t = t || s), "auto" === o.opt.slidesToShow || o.opt._autoSlide)) {
        var l = o.containerWidth / o.opt.itemWidth;
        o.opt._autoSlide = o.opt.slidesToShow = o.opt.exactWidth
          ? l
          : Math.floor(l);
      }
      "auto" === o.opt.slidesToScroll &&
        (o.opt.slidesToScroll = Math.floor(o.opt.slidesToShow)),
        (o.itemWidth = o.opt.exactWidth
          ? o.opt.itemWidth
          : o.containerWidth / o.opt.slidesToShow),
        [].forEach.call(o.slides, function (e) {
          (e.style.height = "auto"),
            (e.style.width = o.itemWidth + "px"),
            (i += o.itemWidth),
            (r = Math.max(e.offsetHeight, r));
        }),
        (o.track.style.width = i + "px"),
        (o.trackWidth = i),
        o.opt.resizeLock && o.scrollTo(o.slide * o.itemWidth, 0),
        (s || t) && (o.bindArrows(), o.buildDots(), o.bindDrag()),
        o.updateControls(),
        o.emit(e ? "refresh" : "loaded");
    }),
    (t.bindDrag = function () {
      var t = this;
      t.mouse = t.mouse || t.handleMouse.bind(t);
      function e() {
        (t.mouseDown = void 0), t.ele.classList.remove("drag");
      }
      var o = {
        mouseup: e,
        mouseleave: e,
        mousedown: function (e) {
          (t.mouseDown = e.clientX), t.ele.classList.add("drag");
        },
        mousemove: t.mouse,
      };
      t.ele.classList.toggle("draggable", !0 === t.opt.draggable),
        t.event(t.ele, "remove", o),
        t.opt.draggable && t.event(t.ele, "add", o);
    }),
    (t.buildDots = function () {
      var e = this;
      if (e.opt.dots) {
        if (
          ("string" == typeof e.opt.dots
            ? (e.dots = document.querySelector(e.opt.dots))
            : (e.dots = e.opt.dots),
          e.dots)
        ) {
          (e.dots.innerHTML = ""), (e.dots.className += " glider-dots");
          for (
            var t = 0;
            t < Math.ceil(e.slides.length / e.opt.slidesToShow);
            ++t
          ) {
            var o = document.createElement("button");
            (o.dataset.index = t),
              o.setAttribute("aria-label", "Page " + (t + 1)),
              (o.className = "glider-dot " + (t ? "" : "active")),
              e.event(o, "add", { click: e.scrollItem.bind(e, t, !0) }),
              e.dots.appendChild(o);
          }
        }
      } else e.dots && (e.dots.innerHTML = "");
    }),
    (t.bindArrows = function () {
      var o = this;
      o.opt.arrows
        ? ["prev", "next"].forEach(function (e) {
            var t = o.opt.arrows[e];
            t &&
              ("string" == typeof t && (t = document.querySelector(t)),
              (t._func = t._func || o.scrollItem.bind(o, e)),
              o.event(t, "remove", { click: t._func }),
              o.event(t, "add", { click: t._func }),
              (o.arrows[e] = t));
          })
        : Object.keys(o.arrows).forEach(function (e) {
            var t = o.arrows[e];
            o.event(t, "remove", { click: t._func });
          });
    }),
    (t.updateControls = function (e) {
      var d = this;
      e && !d.opt.scrollPropagate && e.stopPropagation();
      var t = d.containerWidth >= d.trackWidth;
      d.opt.rewind ||
        (d.arrows.prev &&
          d.arrows.prev.classList.toggle(
            "disabled",
            d.ele.scrollLeft <= 0 || t
          ),
        d.arrows.next &&
          d.arrows.next.classList.toggle(
            "disabled",
            d.ele.scrollLeft + d.containerWidth >= Math.floor(d.trackWidth) || t
          )),
        (d.slide = Math.round(d.ele.scrollLeft / d.itemWidth)),
        (d.page = Math.round(d.ele.scrollLeft / d.containerWidth));
      var c = d.slide + Math.floor(Math.floor(d.opt.slidesToShow) / 2),
        h = Math.floor(d.opt.slidesToShow) % 2 ? 0 : c + 1;
      1 === Math.floor(d.opt.slidesToShow) && (h = 0),
        d.ele.scrollLeft + d.containerWidth >= Math.floor(d.trackWidth) &&
          (d.page = d.dots ? d.dots.children.length - 1 : 0),
        [].forEach.call(d.slides, function (e, t) {
          var o = e.classList,
            i = o.contains("visible"),
            r = d.ele.scrollLeft,
            s = d.ele.scrollLeft + d.containerWidth,
            l = d.itemWidth * t,
            n = l + d.itemWidth;
          [].forEach.call(o, function (e) {
            /^left|right/.test(e) && o.remove(e);
          }),
            o.toggle("active", d.slide === t),
            c === t || (h && h === t)
              ? o.add("center")
              : (o.remove("center"),
                o.add(
                  [
                    t < c ? "left" : "right",
                    Math.abs(t - (t < c ? c : h || c)),
                  ].join("-")
                ));
          var a = Math.ceil(l) >= r && Math.floor(n) <= s;
          o.toggle("visible", a),
            a !== i &&
              d.emit("slide-" + (a ? "visible" : "hidden"), { slide: t });
        }),
        d.dots &&
          [].forEach.call(d.dots.children, function (e, t) {
            e.classList.toggle("active", d.page === t);
          }),
        e &&
          d.opt.scrollLock &&
          (clearTimeout(d.scrollLock),
          (d.scrollLock = setTimeout(function () {
            clearTimeout(d.scrollLock),
              0.02 < Math.abs(d.ele.scrollLeft / d.itemWidth - d.slide) &&
                (d.mouseDown ||
                  d.scrollItem(d.round(d.ele.scrollLeft / d.itemWidth)));
          }, d.opt.scrollLockDelay || 250)));
    }),
    (t.scrollItem = function (e, t, o) {
      o && o.preventDefault();
      var i = this,
        r = e;
      if ((++i.animate_id, !0 === t))
        (e *= i.containerWidth),
          (e = Math.round(e / i.itemWidth) * i.itemWidth);
      else {
        if ("string" == typeof e) {
          var s = "prev" === e;
          if (
            ((e =
              i.opt.slidesToScroll % 1 || i.opt.slidesToShow % 1
                ? i.round(i.ele.scrollLeft / i.itemWidth)
                : i.slide),
            s ? (e -= i.opt.slidesToScroll) : (e += i.opt.slidesToScroll),
            i.opt.rewind)
          ) {
            var l = i.ele.scrollLeft;
            e =
              s && !l
                ? i.slides.length
                : !s && l + i.containerWidth >= Math.floor(i.trackWidth)
                ? 0
                : e;
          }
        }
        (e = Math.max(Math.min(e, i.slides.length), 0)),
          (i.slide = e),
          (e = i.itemWidth * e);
      }
      return (
        i.scrollTo(
          e,
          i.opt.duration * Math.abs(i.ele.scrollLeft - e),
          function () {
            i.updateControls(),
              i.emit("animated", {
                value: r,
                type: "string" == typeof r ? "arrow" : t ? "dot" : "slide",
              });
          }
        ),
        !1
      );
    }),
    (t.settingsBreakpoint = function () {
      var e = this,
        t = e._opt.responsive;
      if (t) {
        t.sort(function (e, t) {
          return t.breakpoint - e.breakpoint;
        });
        for (var o = 0; o < t.length; ++o) {
          var i = t[o];
          if (a.innerWidth >= i.breakpoint)
            return (
              e.breakpoint !== i.breakpoint &&
              ((e.opt = Object.assign({}, e._opt, i.settings)),
              (e.breakpoint = i.breakpoint),
              !0)
            );
        }
      }
      var r = 0 !== e.breakpoint;
      return (e.opt = Object.assign({}, e._opt)), (e.breakpoint = 0), r;
    }),
    (t.scrollTo = function (t, o, i) {
      var r = this,
        s = new Date().getTime(),
        l = r.animate_id,
        n = function () {
          var e = new Date().getTime() - s;
          (r.ele.scrollLeft =
            r.ele.scrollLeft +
            (t - r.ele.scrollLeft) * r.opt.easing(0, e, 0, 1, o)),
            e < o && l === r.animate_id
              ? a.requestAnimationFrame(n)
              : ((r.ele.scrollLeft = t), i && i.call(r));
        };
      a.requestAnimationFrame(n);
    }),
    (t.removeItem = function (e) {
      var t = this;
      t.slides.length &&
        (t.track.removeChild(t.slides[e]), t.refresh(!0), t.emit("remove"));
    }),
    (t.addItem = function (e) {
      this.track.appendChild(e), this.refresh(!0), this.emit("add");
    }),
    (t.handleMouse = function (e) {
      var t = this;
      t.mouseDown &&
        ((t.ele.scrollLeft +=
          (t.mouseDown - e.clientX) * (t.opt.dragVelocity || 3.3)),
        (t.mouseDown = e.clientX));
    }),
    (t.round = function (e) {
      var t = 1 / (this.opt.slidesToScroll % 1 || 1);
      return Math.round(e * t) / t;
    }),
    (t.refresh = function (e) {
      this.init(!0, e);
    }),
    (t.setOption = function (t, e) {
      var o = this;
      o.breakpoint && !e
        ? o._opt.responsive.forEach(function (e) {
            e.breakpoint === o.breakpoint &&
              (e.settings = Object.assign({}, e.settings, t));
          })
        : (o._opt = Object.assign({}, o._opt, t)),
        (o.breakpoint = 0),
        o.settingsBreakpoint();
    }),
    (t.destroy = function () {
      function e(t) {
        t.removeAttribute("style"),
          [].forEach.call(t.classList, function (e) {
            /^glider/.test(e) && t.classList.remove(e);
          });
      }
      var t = this,
        o = t.ele.cloneNode(!0);
      (o.children[0].outerHTML = o.children[0].innerHTML),
        e(o),
        [].forEach.call(o.getElementsByTagName("*"), e),
        t.ele.parentNode.replaceChild(o, t.ele),
        t.event(a, "remove", { resize: t.resize }),
        t.emit("destroy");
    }),
    (t.emit = function (e, t) {
      var o = new a.CustomEvent("glider-" + e, {
        bubbles: !this.opt.eventPropagate,
        detail: t,
      });
      this.ele.dispatchEvent(o);
    }),
    (t.event = function (e, t, o) {
      var i = e[t + "EventListener"].bind(e);
      Object.keys(o).forEach(function (e) {
        i(e, o[e]);
      });
    }),
    e
  );
});
/*! embed.js v1.0.0 | Custom youtube and vimeo embed plugin */

function embedVideo(container) {
  var video_url = $(container).data("url");

  function get_video_thumb(url, callback) {
    var id = get_video_id(url);
    if (id["type"] == "y") {
      return processYouTube(id);
    } else if (id["type"] == "v") {
      $.ajax({
        url: "http://vimeo.com/api/v2/video/" + id["id"] + ".json",
        dataType: "jsonp",
        success: function (data) {
          callback({ type: "v", id: id["id"], url: data[0].thumbnail_large });
        },
      });
    }

    function processYouTube(id) {
      if (!id) {
        throw new Error("Unsupported YouTube URL");
      }

      callback({
        type: "y",
        id: id["id"],
        url: "http://i2.ytimg.com/vi/" + id["id"] + "/hqdefault.jpg",
      });
    }
  }

  function get_video_id(url) {
    var id;
    var a;
    if (url.indexOf("youtube.com") > -1) {
      if (url.indexOf("v=") > -1) {
        id = url.split("v=")[1].split("&")[0];
      } else if (url.indexOf("embed") > -1) {
        id = url.split("embed/")[1].split("?")[0];
      }
      return processYouTube(id);
    } else if (url.indexOf("youtu.be") > -1) {
      id = url.split("/")[1];
      return processYouTube(id);
    } else if (url.indexOf("vimeo.com") > -1) {
      if (url.match(/https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/)) {
        id = url.split("/")[3];
      } else if (url.match(/^vimeo.com\/channels\/[\d\w]+#[0-9]+/)) {
        id = url.split("#")[1];
      } else if (url.match(/vimeo.com\/groups\/[\d\w]+\/videos\/[0-9]+/)) {
        id = url.split("/")[4];
      } else if (url.match(/player.vimeo.com\/video\/[0-9]+/)) {
        id = url.split("/")[2];
      } else {
        throw new Error("Unsupported Vimeo URL");
      }
    } else {
      throw new Error("Unrecognised URL");
    }
    a = { type: "v", id: id };
    return a;
    function processYouTube(id) {
      if (!id) {
        throw new Error("Unsupported YouTube URL");
      }
      a = { type: "y", id: id };
      return a; // default.jpg OR hqdefault.jpg
    }
  }

  function callback(video) {
    $(container + " .video-overlay").css({
      "background-image": "url('" + video.url + "')",
    });

    var frame;

    if (video.type == "v") {
      frame =
        '<iframe src="https://player.vimeo.com/video/' +
        video.id +
        '?autoplay=1&mute=0&color=3aafd6&portrait=0" width="500" height="281" frameborder="0" allow="autoplay" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
    } else {
      frame =
        '<iframe src="https://www.youtube.com/embed/' +
        video.id +
        '?autoplay=1&mute=0&color=white&rel=0" frameborder="0" allow="autoplay" allowfullscreen width="560" height="315" showinfo="0"></iframe>';
    }

    $(container).click(function () {
      $(container).fadeOut("fast", "linear", function () {
        $(this).html(frame);
        $(this).fadeIn("fast");
      });
    });
  }

  get_video_thumb(video_url, callback);
}
(function (global, factory) {
  typeof exports === "object" && typeof module !== "undefined"
    ? (module.exports = factory())
    : typeof define === "function" && define.amd
    ? define(factory)
    : ((global = global || self), (global.EmojiButton = factory()));
})(this, function () {
  "use strict";

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true,
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly)
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(
          target,
          Object.getOwnPropertyDescriptors(source)
        );
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(
            target,
            key,
            Object.getOwnPropertyDescriptor(source, key)
          );
        });
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return (
      _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread()
    );
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)
        arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (
      Symbol.iterator in Object(iter) ||
      Object.prototype.toString.call(iter) === "[object Arguments]"
    )
      return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
      return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css =
    '.emoji-picker {\n  margin: 0 0.5em;\n  border: 1px solid #999999;\n  border-radius: 5px;\n  box-shadow: 0px 0px 3px 1px #CCCCCC;\n  background: #FFFFFF;\n  width: 20.5rem;\n  height: 27.5rem;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.emoji-picker__content {\n  padding: 0.5em;\n  height: 20.5rem;\n}\n\n.emoji-picker__preview {\n  height: 2em;\n  padding: 0.5em;\n  border-top: 1px solid #999999;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.emoji-picker__preview-emoji {\n  font-size: 2em;\n  margin-right: 0.25em;\n  font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji";\n}\n\n.emoji-picker__preview-name {\n  color: #666666;\n  font-size: 0.85em;\n  overflow-wrap: break-word;\n  word-break: break-all;\n}\n\n.emoji-picker__tabs {\n  margin: 0;\n  padding: 0;\n  display: flex;\n}\n\n.emoji-picker__tab {\n  list-style: none;\n  display: inline-block;\n  padding: 0 0.5em;\n  cursor: pointer;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.emoji-picker__tab.active {\n  border-bottom: 3px solid #4F81E5;\n  color: #4F81E5;\n}\n\n.emoji-picker__tab-body {\n  display: none;\n  margin-top: 0.5em;\n}\n\n.emoji-picker__tab-body h2 {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  color: #333333;\n  margin: 0;\n}\n\n.emoji-picker__tab-body.active {\n  display: block;\n}\n\n.emoji-picker__emojis {\n  height: 17.5rem;\n  overflow-y: scroll;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  width: calc(1.3rem * 1.5 * 10);\n  margin: auto;\n}\n\n.emoji-picker__emojis.search-results {\n  height: 21rem;\n}\n\n.emoji-picker__emoji {\n  background: transparent;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1.3rem;\n  width: 1.5em;\n  height: 1.5em;\n  padding: 0;\n  margin: 0;\n  font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji";\n}\n\n.emoji-picker__emoji:hover {\n  background: #E8F4F9;\n}\n\n.emoji-picker__search-container {\n  margin: 0.5em;\n  position: relative;\n  height: 2em;\n  display: flex;\n}\n\n.emoji-picker__search-container input {\n  box-sizing: border-box;\n  width: 100%;\n  border-radius: 5px;\n  border: 1px solid #CCCCCC;\n  padding-right: 2em;\n}\n\n.emoji-picker__search-icon {\n  position: absolute;\n  color: #CCCCCC;\n  width: 1em;\n  height: 1em;\n  right: 0.75em;\n  top: calc(50% - 0.5em);\n}\n\n.emoji-picker__search-not-found {\n  color: #666666;\n  text-align: center;\n  margin-top: 2em;\n}\n\n.emoji-picker__search-not-found-icon {\n  font-size: 3em;\n}\n\n.emoji-picker__search-not-found h2 {\n  margin: 0.5em 0;\n  font-size: 1em;\n}\n\n.emoji-picker__variant-overlay {\n  background: rgba(0, 0, 0, 0.7);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20.5rem;\n  height: 27.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.emoji-picker__variant-popup {\n  background: #FFFFFF;\n  margin: 0.5em;\n  padding: 0.5em;\n  text-align: center;\n}\n\n.emoji-picker__variant-popup-close-button {\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  position: absolute;\n  right: 1em;\n  padding: 0;\n  top: calc(50% - 0.5em);\n  height: 1em;\n  width: 1em;\n}';
  styleInject(css);

  function E() {
    // Keep this empty so it's easier to inherit from
    // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
  }
  E.prototype = {
    on: function (name, callback, ctx) {
      var e = this.e || (this.e = {});
      (e[name] || (e[name] = [])).push({ fn: callback, ctx: ctx });
      return this;
    },
    once: function (name, callback, ctx) {
      var self = this;
      function listener() {
        self.off(name, listener);
        callback.apply(ctx, arguments);
      }
      listener._ = callback;
      return this.on(name, listener, ctx);
    },
    emit: function (name) {
      var data = [].slice.call(arguments, 1);
      var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
      var i = 0;
      var len = evtArr.length;
      for (i; i < len; i++) {
        evtArr[i].fn.apply(evtArr[i].ctx, data);
      }
      return this;
    },
    off: function (name, callback) {
      var e = this.e || (this.e = {});
      var evts = e[name];
      var liveEvents = [];
      if (evts && callback) {
        for (var i = 0, len = evts.length; i < len; i++) {
          if (evts[i].fn !== callback && evts[i].fn._ !== callback)
            liveEvents.push(evts[i]);
        }
      } // Remove event from queue to prevent memory leak
      // Suggested by https://github.com/lazd
      // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
      liveEvents.length ? (e[name] = liveEvents) : delete e[name];
      return this;
    },
  };
  var tinyEmitter = E;
  var TinyEmitter = E;
  tinyEmitter.TinyEmitter = TinyEmitter;

  /**!
   * @fileOverview Kickass library to create and place poppers near their reference elements.
   * @version 1.15.0
   * @license
   * Copyright (c) 2016 Federico Zivolo and contributors
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   */ var isBrowser =
    typeof window !== "undefined" && typeof document !== "undefined";
  var longerTimeoutBrowsers = ["Edge", "Trident", "Firefox"];
  var timeoutDuration = 0;
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (
      isBrowser &&
      navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0
    ) {
      timeoutDuration = 1;
      break;
    }
  }
  function microtaskDebounce(fn) {
    var called = false;
    return function () {
      if (called) {
        return;
      }
      called = true;
      window.Promise.resolve().then(function () {
        called = false;
        fn();
      });
    };
  }
  function taskDebounce(fn) {
    var scheduled = false;
    return function () {
      if (!scheduled) {
        scheduled = true;
        setTimeout(function () {
          scheduled = false;
          fn();
        }, timeoutDuration);
      }
    };
  }
  var supportsMicroTasks = isBrowser && window.Promise;
  /**
   * Create a debounced version of a method, that's asynchronously deferred
   * but called in the minimum time possible.
   *
   * @method
   * @memberof Popper.Utils
   * @argument {Function} fn
   * @returns {Function}
   */ var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
  /**
   * Check if the given variable is a function
   * @method
   * @memberof Popper.Utils
   * @argument {Any} functionToCheck - variable to check
   * @returns {Boolean} answer to: is a function?
   */ function isFunction(functionToCheck) {
    var getType = {};
    return (
      functionToCheck &&
      getType.toString.call(functionToCheck) === "[object Function]"
    );
  }
  /**
   * Get CSS computed property of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Eement} element
   * @argument {String} property
   */ function getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) {
      return [];
    } // NOTE: 1 DOM access here
    var window = element.ownerDocument.defaultView;
    var css = window.getComputedStyle(element, null);
    return property ? css[property] : css;
  }
  /**
   * Returns the parentNode or the host of the element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} parent
   */ function getParentNode(element) {
    if (element.nodeName === "HTML") {
      return element;
    }
    return element.parentNode || element.host;
  }
  /**
   * Returns the scrolling parent of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} scroll parent
   */ function getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) {
      return document.body;
    }
    switch (element.nodeName) {
      case "HTML":
      case "BODY":
        return element.ownerDocument.body;
      case "#document":
        return element.body;
    } // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
      return element;
    }
    return getScrollParent(getParentNode(element));
  }
  var isIE11 =
    isBrowser && !!(window.MSInputMethodContext && document.documentMode);
  var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
  /**
   * Determines if the browser is Internet Explorer
   * @method
   * @memberof Popper.Utils
   * @param {Number} version to check
   * @returns {Boolean} isIE
   */ function isIE(version) {
    if (version === 11) {
      return isIE11;
    }
    if (version === 10) {
      return isIE10;
    }
    return isIE11 || isIE10;
  }
  /**
   * Returns the offset parent of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} offset parent
   */ function getOffsetParent(element) {
    if (!element) {
      return document.documentElement;
    }
    var noOffsetParent = isIE(10) ? document.body : null; // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null; // Skip hidden elements which don't have an offsetParent
    while (offsetParent === noOffsetParent && element.nextElementSibling) {
      offsetParent = (element = element.nextElementSibling).offsetParent;
    }
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === "BODY" || nodeName === "HTML") {
      return element
        ? element.ownerDocument.documentElement
        : document.documentElement;
    } // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if (
      ["TH", "TD", "TABLE"].indexOf(offsetParent.nodeName) !== -1 &&
      getStyleComputedProperty(offsetParent, "position") === "static"
    ) {
      return getOffsetParent(offsetParent);
    }
    return offsetParent;
  }
  function isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY") {
      return false;
    }
    return (
      nodeName === "HTML" ||
      getOffsetParent(element.firstElementChild) === element
    );
  }
  /**
   * Finds the root node (document, shadowDOM root) of the given element
   * @method
   * @memberof Popper.Utils
   * @argument {Element} node
   * @returns {Element} root node
   */ function getRoot(node) {
    if (node.parentNode !== null) {
      return getRoot(node.parentNode);
    }
    return node;
  }
  /**
   * Finds the offset parent common to the two provided nodes
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element1
   * @argument {Element} element2
   * @returns {Element} common offset parent
   */ function findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
      return document.documentElement;
    } // Here we make sure to give as "start" the element that comes first in the DOM
    var order =
      element1.compareDocumentPosition(element2) &
      Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1; // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer; // Both nodes are inside #document
    if (
      (element1 !== commonAncestorContainer &&
        element2 !== commonAncestorContainer) ||
      start.contains(end)
    ) {
      if (isOffsetContainer(commonAncestorContainer)) {
        return commonAncestorContainer;
      }
      return getOffsetParent(commonAncestorContainer);
    } // one of the nodes is inside shadowDOM, find which one
    var element1root = getRoot(element1);
    if (element1root.host) {
      return findCommonOffsetParent(element1root.host, element2);
    } else {
      return findCommonOffsetParent(element1, getRoot(element2).host);
    }
  }
  /**
   * Gets the scroll value of the given element in the given side (top and left)
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @argument {String} side `top` or `left`
   * @returns {number} amount of scrolled pixels
   */ function getScroll(element) {
    var side =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
    var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") {
      var html = element.ownerDocument.documentElement;
      var scrollingElement = element.ownerDocument.scrollingElement || html;
      return scrollingElement[upperSide];
    }
    return element[upperSide];
  }
  /*
   * Sum or subtract the element scroll values (left and top) from a given rect object
   * @method
   * @memberof Popper.Utils
   * @param {Object} rect - Rect object you want to change
   * @param {HTMLElement} element - The element from the function reads the scroll values
   * @param {Boolean} subtract - set to true if you want to subtract the scroll values
   * @return {Object} rect - The modifier rect object
   */ function includeScroll(rect, element) {
    var subtract =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = getScroll(element, "top");
    var scrollLeft = getScroll(element, "left");
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
  }
  /*
   * Helper to detect borders of a given element
   * @method
   * @memberof Popper.Utils
   * @param {CSSStyleDeclaration} styles
   * Result of `getStyleComputedProperty` on the given element
   * @param {String} axis - `x` or `y`
   * @return {number} borders - The borders size of the given axis
   */ function getBordersSize(styles, axis) {
    var sideA = axis === "x" ? "Left" : "Top";
    var sideB = sideA === "Left" ? "Right" : "Bottom";
    return (
      parseFloat(styles["border" + sideA + "Width"], 10) +
      parseFloat(styles["border" + sideB + "Width"], 10)
    );
  }
  function getSize(axis, body, html, computedStyle) {
    return Math.max(
      body["offset" + axis],
      body["scroll" + axis],
      html["client" + axis],
      html["offset" + axis],
      html["scroll" + axis],
      isIE(10)
        ? parseInt(html["offset" + axis]) +
            parseInt(
              computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]
            ) +
            parseInt(
              computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]
            )
        : 0
    );
  }
  function getWindowSizes(document) {
    var body = document.body;
    var html = document.documentElement;
    var computedStyle = isIE(10) && getComputedStyle(html);
    return {
      height: getSize("Height", body, html, computedStyle),
      width: getSize("Width", body, html, computedStyle),
    };
  }
  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  var createClass = (function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var defineProperty = function (obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true,
      });
    } else {
      obj[key] = value;
    }
    return obj;
  };
  var _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  /**
   * Given element offsets, generate an output similar to getBoundingClientRect
   * @method
   * @memberof Popper.Utils
   * @argument {Object} offsets
   * @returns {Object} ClientRect like output
   */ function getClientRect(offsets) {
    return _extends({}, offsets, {
      right: offsets.left + offsets.width,
      bottom: offsets.top + offsets.height,
    });
  }
  /**
   * Get bounding client rect of given element
   * @method
   * @memberof Popper.Utils
   * @param {HTMLElement} element
   * @return {Object} client rect
   */ function getBoundingClientRect(element) {
    var rect = {}; // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
      if (isIE(10)) {
        rect = element.getBoundingClientRect();
        var scrollTop = getScroll(element, "top");
        var scrollLeft = getScroll(element, "left");
        rect.top += scrollTop;
        rect.left += scrollLeft;
        rect.bottom += scrollTop;
        rect.right += scrollLeft;
      } else {
        rect = element.getBoundingClientRect();
      }
    } catch (e) {}
    var result = {
      left: rect.left,
      top: rect.top,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top,
    }; // subtract scrollbar size from sizes
    var sizes =
      element.nodeName === "HTML" ? getWindowSizes(element.ownerDocument) : {};
    var width =
      sizes.width || element.clientWidth || result.right - result.left;
    var height =
      sizes.height || element.clientHeight || result.bottom - result.top;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height; // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
      var styles = getStyleComputedProperty(element);
      horizScrollbar -= getBordersSize(styles, "x");
      vertScrollbar -= getBordersSize(styles, "y");
      result.width -= horizScrollbar;
      result.height -= vertScrollbar;
    }
    return getClientRect(result);
  }
  function getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = isIE(10);
    var isHTML = parent.nodeName === "HTML";
    var childrenRect = getBoundingClientRect(children);
    var parentRect = getBoundingClientRect(parent);
    var scrollParent = getScrollParent(children);
    var styles = getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10); // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
      parentRect.top = Math.max(parentRect.top, 0);
      parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = getClientRect({
      top: childrenRect.top - parentRect.top - borderTopWidth,
      left: childrenRect.left - parentRect.left - borderLeftWidth,
      width: childrenRect.width,
      height: childrenRect.height,
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0; // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
      var marginTop = parseFloat(styles.marginTop, 10);
      var marginLeft = parseFloat(styles.marginLeft, 10);
      offsets.top -= borderTopWidth - marginTop;
      offsets.bottom -= borderTopWidth - marginTop;
      offsets.left -= borderLeftWidth - marginLeft;
      offsets.right -= borderLeftWidth - marginLeft; // Attach marginTop and marginLeft because in some circumstances we may need them
      offsets.marginTop = marginTop;
      offsets.marginLeft = marginLeft;
    }
    if (
      isIE10 && !fixedPosition
        ? parent.contains(scrollParent)
        : parent === scrollParent && scrollParent.nodeName !== "BODY"
    ) {
      offsets = includeScroll(offsets, parent);
    }
    return offsets;
  }
  function getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? getScroll(html, "left") : 0;
    var offset = {
      top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
      left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
      width: width,
      height: height,
    };
    return getClientRect(offset);
  }
  /**
   * Check if the given element is fixed or is inside a fixed parent
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @argument {Element} customContainer
   * @returns {Boolean} answer to "isFixed?"
   */ function isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") {
      return false;
    }
    if (getStyleComputedProperty(element, "position") === "fixed") {
      return true;
    }
    var parentNode = getParentNode(element);
    if (!parentNode) {
      return false;
    }
    return isFixed(parentNode);
  }
  /**
   * Finds the first parent of an element that has a transformed property defined
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Element} first transformed parent or documentElement
   */ function getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || isIE()) {
      return document.documentElement;
    }
    var el = element.parentElement;
    while (el && getStyleComputedProperty(el, "transform") === "none") {
      el = el.parentElement;
    }
    return el || document.documentElement;
  }
  /**
   * Computed the boundaries limits and return them
   * @method
   * @memberof Popper.Utils
   * @param {HTMLElement} popper
   * @param {HTMLElement} reference
   * @param {number} padding
   * @param {HTMLElement} boundariesElement - Element used to define the boundaries
   * @param {Boolean} fixedPosition - Is in fixed position mode
   * @returns {Object} Coordinates of the boundaries
   */ function getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition =
      arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false; // NOTE: 1 DOM access here
    var boundaries = { top: 0, left: 0 };
    var offsetParent = fixedPosition
      ? getFixedPositionOffsetParent(popper)
      : findCommonOffsetParent(popper, reference); // Handle viewport case
    if (boundariesElement === "viewport") {
      boundaries = getViewportOffsetRectRelativeToArtbitraryNode(
        offsetParent,
        fixedPosition
      );
    } else {
      // Handle other cases based on DOM element used as boundaries
      var boundariesNode = void 0;
      if (boundariesElement === "scrollParent") {
        boundariesNode = getScrollParent(getParentNode(reference));
        if (boundariesNode.nodeName === "BODY") {
          boundariesNode = popper.ownerDocument.documentElement;
        }
      } else if (boundariesElement === "window") {
        boundariesNode = popper.ownerDocument.documentElement;
      } else {
        boundariesNode = boundariesElement;
      }
      var offsets = getOffsetRectRelativeToArbitraryNode(
        boundariesNode,
        offsetParent,
        fixedPosition
      ); // In case of HTML, we need a different computation
      if (boundariesNode.nodeName === "HTML" && !isFixed(offsetParent)) {
        var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;
        boundaries.top += offsets.top - offsets.marginTop;
        boundaries.bottom = height + offsets.top;
        boundaries.left += offsets.left - offsets.marginLeft;
        boundaries.right = width + offsets.left;
      } else {
        // for all the other DOM elements, this one is good
        boundaries = offsets;
      }
    } // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === "number";
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
  }
  function getArea(_ref) {
    var width = _ref.width,
      height = _ref.height;
    return width * height;
  }
  /**
   * Utility used to transform the `auto` placement to the placement with more
   * available space.
   * @method
   * @memberof Popper.Utils
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function computeAutoPlacement(
    placement,
    refRect,
    popper,
    reference,
    boundariesElement
  ) {
    var padding =
      arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf("auto") === -1) {
      return placement;
    }
    var boundaries = getBoundaries(
      popper,
      reference,
      padding,
      boundariesElement
    );
    var rects = {
      top: { width: boundaries.width, height: refRect.top - boundaries.top },
      right: {
        width: boundaries.right - refRect.right,
        height: boundaries.height,
      },
      bottom: {
        width: boundaries.width,
        height: boundaries.bottom - refRect.bottom,
      },
      left: {
        width: refRect.left - boundaries.left,
        height: boundaries.height,
      },
    };
    var sortedAreas = Object.keys(rects)
      .map(function (key) {
        return _extends({ key: key }, rects[key], {
          area: getArea(rects[key]),
        });
      })
      .sort(function (a, b) {
        return b.area - a.area;
      });
    var filteredAreas = sortedAreas.filter(function (_ref2) {
      var width = _ref2.width,
        height = _ref2.height;
      return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement =
      filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split("-")[1];
    return computedPlacement + (variation ? "-" + variation : "");
  }
  /**
   * Get offsets to the reference element
   * @method
   * @memberof Popper.Utils
   * @param {Object} state
   * @param {Element} popper - the popper element
   * @param {Element} reference - the reference element (the popper will be relative to this)
   * @param {Element} fixedPosition - is in fixed position mode
   * @returns {Object} An object containing the offsets which will be applied to the popper
   */ function getReferenceOffsets(state, popper, reference) {
    var fixedPosition =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition
      ? getFixedPositionOffsetParent(popper)
      : findCommonOffsetParent(popper, reference);
    return getOffsetRectRelativeToArbitraryNode(
      reference,
      commonOffsetParent,
      fixedPosition
    );
  }
  /**
   * Get the outer sizes of the given element (offset size + margins)
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element
   * @returns {Object} object containing width and height properties
   */ function getOuterSizes(element) {
    var window = element.ownerDocument.defaultView;
    var styles = window.getComputedStyle(element);
    var x =
      parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y =
      parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
      width: element.offsetWidth + y,
      height: element.offsetHeight + x,
    };
    return result;
  }
  /**
   * Get the opposite placement of the given one
   * @method
   * @memberof Popper.Utils
   * @argument {String} placement
   * @returns {String} flipped placement
   */ function getOppositePlacement(placement) {
    var hash = { left: "right", right: "left", bottom: "top", top: "bottom" };
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash[matched];
    });
  }
  /**
   * Get offsets to the popper
   * @method
   * @memberof Popper.Utils
   * @param {Object} position - CSS position the Popper will get applied
   * @param {HTMLElement} popper - the popper element
   * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
   * @param {String} placement - one of the valid placement options
   * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
   */ function getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split("-")[0]; // Get popper node sizes
    var popperRect = getOuterSizes(popper); // Add position, width and height to our offsets object
    var popperOffsets = { width: popperRect.width, height: popperRect.height }; // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = ["right", "left"].indexOf(placement) !== -1;
    var mainSide = isHoriz ? "top" : "left";
    var secondarySide = isHoriz ? "left" : "top";
    var measurement = isHoriz ? "height" : "width";
    var secondaryMeasurement = !isHoriz ? "height" : "width";
    popperOffsets[mainSide] =
      referenceOffsets[mainSide] +
      referenceOffsets[measurement] / 2 -
      popperRect[measurement] / 2;
    if (placement === secondarySide) {
      popperOffsets[secondarySide] =
        referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    } else {
      popperOffsets[secondarySide] =
        referenceOffsets[getOppositePlacement(secondarySide)];
    }
    return popperOffsets;
  }
  /**
   * Mimics the `find` method of Array
   * @method
   * @memberof Popper.Utils
   * @argument {Array} arr
   * @argument prop
   * @argument value
   * @returns index or -1
   */ function find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) {
      return arr.find(check);
    } // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
  }
  /**
   * Return the index of the matching object
   * @method
   * @memberof Popper.Utils
   * @argument {Array} arr
   * @argument prop
   * @argument value
   * @returns index or -1
   */ function findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) {
      return arr.findIndex(function (cur) {
        return cur[prop] === value;
      });
    } // use `find` + `indexOf` if `findIndex` isn't supported
    var match = find(arr, function (obj) {
      return obj[prop] === value;
    });
    return arr.indexOf(match);
  }
  /**
   * Loop trough the list of modifiers and run them in order,
   * each of them will then edit the data object.
   * @method
   * @memberof Popper.Utils
   * @param {dataObject} data
   * @param {Array} modifiers
   * @param {String} ends - Optional modifier name used as stopper
   * @returns {dataObject}
   */ function runModifiers(modifiers, data, ends) {
    var modifiersToRun =
      ends === undefined
        ? modifiers
        : modifiers.slice(0, findIndex(modifiers, "name", ends));
    modifiersToRun.forEach(function (modifier) {
      if (modifier["function"]) {
        // eslint-disable-line dot-notation
        console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
      }
      var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
      if (modifier.enabled && isFunction(fn)) {
        // Add properties to offsets to make them a complete clientRect object
        // we do this before each modifier to make sure the previous one doesn't
        // mess with these values
        data.offsets.popper = getClientRect(data.offsets.popper);
        data.offsets.reference = getClientRect(data.offsets.reference);
        data = fn(data, modifier);
      }
    });
    return data;
  }
  /**
   * Updates the position of the popper, computing the new offsets and applying
   * the new style.<br />
   * Prefer `scheduleUpdate` over `update` because of performance reasons.
   * @method
   * @memberof Popper
   */ function update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) {
      return;
    }
    var data = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: false,
      offsets: {},
    }; // compute reference element offsets
    data.offsets.reference = getReferenceOffsets(
      this.state,
      this.popper,
      this.reference,
      this.options.positionFixed
    ); // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = computeAutoPlacement(
      this.options.placement,
      data.offsets.reference,
      this.popper,
      this.reference,
      this.options.modifiers.flip.boundariesElement,
      this.options.modifiers.flip.padding
    ); // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed; // compute the popper offsets
    data.offsets.popper = getPopperOffsets(
      this.popper,
      data.offsets.reference,
      data.placement
    );
    data.offsets.popper.position = this.options.positionFixed
      ? "fixed"
      : "absolute"; // run the modifiers
    data = runModifiers(this.modifiers, data); // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
      this.state.isCreated = true;
      this.options.onCreate(data);
    } else {
      this.options.onUpdate(data);
    }
  }
  /**
   * Helper used to know if the given modifier is enabled.
   * @method
   * @memberof Popper.Utils
   * @returns {Boolean}
   */ function isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function (_ref) {
      var name = _ref.name,
        enabled = _ref.enabled;
      return enabled && name === modifierName;
    });
  }
  /**
   * Get the prefixed supported property name
   * @method
   * @memberof Popper.Utils
   * @argument {String} property (camelCase)
   * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
   */ function getSupportedPropertyName(property) {
    var prefixes = [false, "ms", "Webkit", "Moz", "O"];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for (var i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      var toCheck = prefix ? "" + prefix + upperProp : property;
      if (typeof document.body.style[toCheck] !== "undefined") {
        return toCheck;
      }
    }
    return null;
  }
  /**
   * Destroys the popper.
   * @method
   * @memberof Popper
   */ function destroy() {
    this.state.isDestroyed = true; // touch DOM only if `applyStyle` modifier is enabled
    if (isModifierEnabled(this.modifiers, "applyStyle")) {
      this.popper.removeAttribute("x-placement");
      this.popper.style.position = "";
      this.popper.style.top = "";
      this.popper.style.left = "";
      this.popper.style.right = "";
      this.popper.style.bottom = "";
      this.popper.style.willChange = "";
      this.popper.style[getSupportedPropertyName("transform")] = "";
    }
    this.disableEventListeners(); // remove the popper if user explicity asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) {
      this.popper.parentNode.removeChild(this.popper);
    }
    return this;
  }
  /**
   * Get the window associated with the element
   * @argument {Element} element
   * @returns {Window}
   */ function getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
  }
  function attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === "BODY";
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, { passive: true });
    if (!isBody) {
      attachToScrollParents(
        getScrollParent(target.parentNode),
        event,
        callback,
        scrollParents
      );
    }
    scrollParents.push(target);
  }
  /**
   * Setup needed event listeners used to update the popper position
   * @method
   * @memberof Popper.Utils
   * @private
   */ function setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    getWindow(reference).addEventListener("resize", state.updateBound, {
      passive: true,
    }); // Scroll event listener on scroll parents
    var scrollElement = getScrollParent(reference);
    attachToScrollParents(
      scrollElement,
      "scroll",
      state.updateBound,
      state.scrollParents
    );
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
  }
  /**
   * It will add resize/scroll events and start recalculating
   * position of the popper element when they are triggered.
   * @method
   * @memberof Popper
   */ function enableEventListeners() {
    if (!this.state.eventsEnabled) {
      this.state = setupEventListeners(
        this.reference,
        this.options,
        this.state,
        this.scheduleUpdate
      );
    }
  }
  /**
   * Remove event listeners used to update the popper position
   * @method
   * @memberof Popper.Utils
   * @private
   */ function removeEventListeners(reference, state) {
    // Remove resize event listener on window
    getWindow(reference).removeEventListener("resize", state.updateBound); // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function (target) {
      target.removeEventListener("scroll", state.updateBound);
    }); // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
  }
  /**
   * It will remove resize/scroll events and won't recalculate popper position
   * when they are triggered. It also won't trigger `onUpdate` callback anymore,
   * unless you call `update` method manually.
   * @method
   * @memberof Popper
   */ function disableEventListeners() {
    if (this.state.eventsEnabled) {
      cancelAnimationFrame(this.scheduleUpdate);
      this.state = removeEventListeners(this.reference, this.state);
    }
  }
  /**
   * Tells if a given input is a number
   * @method
   * @memberof Popper.Utils
   * @param {*} input to check
   * @return {Boolean}
   */ function isNumeric(n) {
    return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
  }
  /**
   * Set the style to the given popper
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element - Element to apply the style to
   * @argument {Object} styles
   * Object with a list of properties and values which will be applied to the element
   */ function setStyles(element, styles) {
    Object.keys(styles).forEach(function (prop) {
      var unit = ""; // add unit if the value is numeric and is one of the following
      if (
        ["width", "height", "top", "right", "bottom", "left"].indexOf(prop) !==
          -1 &&
        isNumeric(styles[prop])
      ) {
        unit = "px";
      }
      element.style[prop] = styles[prop] + unit;
    });
  }
  /**
   * Set the attributes to the given popper
   * @method
   * @memberof Popper.Utils
   * @argument {Element} element - Element to apply the attributes to
   * @argument {Object} styles
   * Object with a list of properties and values which will be applied to the element
   */ function setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function (prop) {
      var value = attributes[prop];
      if (value !== false) {
        element.setAttribute(prop, attributes[prop]);
      } else {
        element.removeAttribute(prop);
      }
    });
  }
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} data.styles - List of style properties - values to apply to popper element
   * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The same data object
   */ function applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    setStyles(data.instance.popper, data.styles); // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    setAttributes(data.instance.popper, data.attributes); // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) {
      setStyles(data.arrowElement, data.arrowStyles);
    }
    return data;
  }
  /**
   * Set the x-placement attribute before everything else because it could be used
   * to add margins to the popper margins needs to be calculated to get the
   * correct popper offsets.
   * @method
   * @memberof Popper.modifiers
   * @param {HTMLElement} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper
   * @param {Object} options - Popper.js options
   */ function applyStyleOnLoad(
    reference,
    popper,
    options,
    modifierOptions,
    state
  ) {
    // compute reference element offsets
    var referenceOffsets = getReferenceOffsets(
      state,
      popper,
      reference,
      options.positionFixed
    ); // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = computeAutoPlacement(
      options.placement,
      referenceOffsets,
      popper,
      reference,
      options.modifiers.flip.boundariesElement,
      options.modifiers.flip.padding
    );
    popper.setAttribute("x-placement", placement); // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    setStyles(popper, {
      position: options.positionFixed ? "fixed" : "absolute",
    });
    return options;
  }
  /**
   * @function
   * @memberof Popper.Utils
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Boolean} shouldRound - If the offsets should be rounded at all
   * @returns {Object} The popper's position offsets rounded
   *
   * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
   * good as it can be within reason.
   * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
   *
   * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
   * as well on High DPI screens).
   *
   * Firefox prefers no rounding for positioning and does not have blurriness on
   * high DPI screens.
   *
   * Only horizontal placement and left/right values need to be considered.
   */ function getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
    var round = Math.round,
      floor = Math.floor;
    var noRound = function noRound(v) {
      return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = ["left", "right"].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf("-") !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound
      ? noRound
      : isVertical || isVariation || sameWidthParity
      ? round
      : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
      left: horizontalToInteger(
        bothOddWidth && !isVariation && shouldRound
          ? popper.left - 1
          : popper.left
      ),
      top: verticalToInteger(popper.top),
      bottom: verticalToInteger(popper.bottom),
      right: horizontalToInteger(popper.right),
    };
  }
  var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function computeStyle(data, options) {
    var x = options.x,
      y = options.y;
    var popper = data.offsets.popper; // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = find(data.instance.modifiers, function (
      modifier
    ) {
      return modifier.name === "applyStyle";
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) {
      console.warn(
        "WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!"
      );
    }
    var gpuAcceleration =
      legacyGpuAccelerationOption !== undefined
        ? legacyGpuAccelerationOption
        : options.gpuAcceleration;
    var offsetParent = getOffsetParent(data.instance.popper);
    var offsetParentRect = getBoundingClientRect(offsetParent); // Styles
    var styles = { position: popper.position };
    var offsets = getRoundedOffsets(
      data,
      window.devicePixelRatio < 2 || !isFirefox
    );
    var sideA = x === "bottom" ? "top" : "bottom";
    var sideB = y === "right" ? "left" : "right"; // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = getSupportedPropertyName("transform"); // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0,
      top = void 0;
    if (sideA === "bottom") {
      // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
      // and not the bottom of the html element
      if (offsetParent.nodeName === "HTML") {
        top = -offsetParent.clientHeight + offsets.bottom;
      } else {
        top = -offsetParentRect.height + offsets.bottom;
      }
    } else {
      top = offsets.top;
    }
    if (sideB === "right") {
      if (offsetParent.nodeName === "HTML") {
        left = -offsetParent.clientWidth + offsets.right;
      } else {
        left = -offsetParentRect.width + offsets.right;
      }
    } else {
      left = offsets.left;
    }
    if (gpuAcceleration && prefixedProperty) {
      styles[prefixedProperty] =
        "translate3d(" + left + "px, " + top + "px, 0)";
      styles[sideA] = 0;
      styles[sideB] = 0;
      styles.willChange = "transform";
    } else {
      // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
      var invertTop = sideA === "bottom" ? -1 : 1;
      var invertLeft = sideB === "right" ? -1 : 1;
      styles[sideA] = top * invertTop;
      styles[sideB] = left * invertLeft;
      styles.willChange = sideA + ", " + sideB;
    } // Attributes
    var attributes = { "x-placement": data.placement }; // Update `data` attributes, styles and arrowStyles
    data.attributes = _extends({}, attributes, data.attributes);
    data.styles = _extends({}, styles, data.styles);
    data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
  }
  /**
   * Helper used to know if the given modifier depends from another one.<br />
   * It checks if the needed modifier is listed and enabled.
   * @method
   * @memberof Popper.Utils
   * @param {Array} modifiers - list of modifiers
   * @param {String} requestingName - name of requesting modifier
   * @param {String} requestedName - name of requested modifier
   * @returns {Boolean}
   */ function isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = find(modifiers, function (_ref) {
      var name = _ref.name;
      return name === requestingName;
    });
    var isRequired =
      !!requesting &&
      modifiers.some(function (modifier) {
        return (
          modifier.name === requestedName &&
          modifier.enabled &&
          modifier.order < requesting.order
        );
      });
    if (!isRequired) {
      var _requesting = "`" + requestingName + "`";
      var requested = "`" + requestedName + "`";
      console.warn(
        requested +
          " modifier is required by " +
          _requesting +
          " modifier in order to work, be sure to include it before " +
          _requesting +
          "!"
      );
    }
    return isRequired;
  }
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function arrow(data, options) {
    var _data$offsets$arrow; // arrow depends on keepTogether in order to work
    if (!isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) {
      return data;
    }
    var arrowElement = options.element; // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === "string") {
      arrowElement = data.instance.popper.querySelector(arrowElement); // if arrowElement is not found, don't run the modifier
      if (!arrowElement) {
        return data;
      }
    } else {
      // if the arrowElement isn't a query selector we must check that the
      // provided DOM node is child of its popper node
      if (!data.instance.popper.contains(arrowElement)) {
        console.warn(
          "WARNING: `arrow.element` must be child of its popper element!"
        );
        return data;
      }
    }
    var placement = data.placement.split("-")[0];
    var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
    var isVertical = ["left", "right"].indexOf(placement) !== -1;
    var len = isVertical ? "height" : "width";
    var sideCapitalized = isVertical ? "Top" : "Left";
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? "left" : "top";
    var opSide = isVertical ? "bottom" : "right";
    var arrowElementSize = getOuterSizes(arrowElement)[len]; //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) {
      data.offsets.popper[side] -=
        popper[side] - (reference[opSide] - arrowElementSize);
    } // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) {
      data.offsets.popper[side] +=
        reference[side] + arrowElementSize - popper[opSide];
    }
    data.offsets.popper = getClientRect(data.offsets.popper); // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2; // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css["margin" + sideCapitalized], 10);
    var popperBorderSide = parseFloat(
      css["border" + sideCapitalized + "Width"],
      10
    );
    var sideValue =
      center - data.offsets.popper[side] - popperMarginSide - popperBorderSide; // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(
      Math.min(popper[len] - arrowElementSize, sideValue),
      0
    );
    data.arrowElement = arrowElement;
    data.offsets.arrow =
      ((_data$offsets$arrow = {}),
      defineProperty(_data$offsets$arrow, side, Math.round(sideValue)),
      defineProperty(_data$offsets$arrow, altSide, ""),
      _data$offsets$arrow);
    return data;
  }
  /**
   * Get the opposite placement variation of the given one
   * @method
   * @memberof Popper.Utils
   * @argument {String} placement variation
   * @returns {String} flipped placement variation
   */ function getOppositeVariation(variation) {
    if (variation === "end") {
      return "start";
    } else if (variation === "start") {
      return "end";
    }
    return variation;
  }
  /**
   * List of accepted placements to use as values of the `placement` option.<br />
   * Valid placements are:
   * - `auto`
   * - `top`
   * - `right`
   * - `bottom`
   * - `left`
   *
   * Each placement can have a variation from this list:
   * - `-start`
   * - `-end`
   *
   * Variations are interpreted easily if you think of them as the left to right
   * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
   * is right.<br />
   * Vertically (`left` and `right`), `start` is top and `end` is bottom.
   *
   * Some valid examples are:
   * - `top-end` (on top of reference, right aligned)
   * - `right-start` (on right of reference, top aligned)
   * - `bottom` (on bottom, centered)
   * - `auto-end` (on the side with more space available, alignment depends by placement)
   *
   * @static
   * @type {Array}
   * @enum {String}
   * @readonly
   * @method placements
   * @memberof Popper
   */ var placements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start",
  ]; // Get rid of `auto` `auto-start` and `auto-end`
  var validPlacements = placements.slice(3);
  /**
   * Given an initial placement, returns all the subsequent placements
   * clockwise (or counter-clockwise).
   *
   * @method
   * @memberof Popper.Utils
   * @argument {String} placement - A valid placement (it accepts variations)
   * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
   * @returns {Array} placements including their variations
   */ function clockwise(placement) {
    var counter =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = validPlacements.indexOf(placement);
    var arr = validPlacements
      .slice(index + 1)
      .concat(validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
  }
  var BEHAVIORS = {
    FLIP: "flip",
    CLOCKWISE: "clockwise",
    COUNTERCLOCKWISE: "counterclockwise",
  };
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if (isModifierEnabled(data.instance.modifiers, "inner")) {
      return data;
    }
    if (data.flipped && data.placement === data.originalPlacement) {
      // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
      return data;
    }
    var boundaries = getBoundaries(
      data.instance.popper,
      data.instance.reference,
      options.padding,
      options.boundariesElement,
      data.positionFixed
    );
    var placement = data.placement.split("-")[0];
    var placementOpposite = getOppositePlacement(placement);
    var variation = data.placement.split("-")[1] || "";
    var flipOrder = [];
    switch (options.behavior) {
      case BEHAVIORS.FLIP:
        flipOrder = [placement, placementOpposite];
        break;
      case BEHAVIORS.CLOCKWISE:
        flipOrder = clockwise(placement);
        break;
      case BEHAVIORS.COUNTERCLOCKWISE:
        flipOrder = clockwise(placement, true);
        break;
      default:
        flipOrder = options.behavior;
    }
    flipOrder.forEach(function (step, index) {
      if (placement !== step || flipOrder.length === index + 1) {
        return data;
      }
      placement = data.placement.split("-")[0];
      placementOpposite = getOppositePlacement(placement);
      var popperOffsets = data.offsets.popper;
      var refOffsets = data.offsets.reference; // using floor because the reference offsets may contain decimals we are not going to consider here
      var floor = Math.floor;
      var overlapsRef =
        (placement === "left" &&
          floor(popperOffsets.right) > floor(refOffsets.left)) ||
        (placement === "right" &&
          floor(popperOffsets.left) < floor(refOffsets.right)) ||
        (placement === "top" &&
          floor(popperOffsets.bottom) > floor(refOffsets.top)) ||
        (placement === "bottom" &&
          floor(popperOffsets.top) < floor(refOffsets.bottom));
      var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
      var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
      var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
      var overflowsBottom =
        floor(popperOffsets.bottom) > floor(boundaries.bottom);
      var overflowsBoundaries =
        (placement === "left" && overflowsLeft) ||
        (placement === "right" && overflowsRight) ||
        (placement === "top" && overflowsTop) ||
        (placement === "bottom" && overflowsBottom); // flip the variation if required
      var isVertical = ["top", "bottom"].indexOf(placement) !== -1; // flips variation if reference element overflows boundaries
      var flippedVariationByRef =
        !!options.flipVariations &&
        ((isVertical && variation === "start" && overflowsLeft) ||
          (isVertical && variation === "end" && overflowsRight) ||
          (!isVertical && variation === "start" && overflowsTop) ||
          (!isVertical && variation === "end" && overflowsBottom)); // flips variation if popper content overflows boundaries
      var flippedVariationByContent =
        !!options.flipVariationsByContent &&
        ((isVertical && variation === "start" && overflowsRight) ||
          (isVertical && variation === "end" && overflowsLeft) ||
          (!isVertical && variation === "start" && overflowsBottom) ||
          (!isVertical && variation === "end" && overflowsTop));
      var flippedVariation = flippedVariationByRef || flippedVariationByContent;
      if (overlapsRef || overflowsBoundaries || flippedVariation) {
        // this boolean to detect any flip loop
        data.flipped = true;
        if (overlapsRef || overflowsBoundaries) {
          placement = flipOrder[index + 1];
        }
        if (flippedVariation) {
          variation = getOppositeVariation(variation);
        }
        data.placement = placement + (variation ? "-" + variation : ""); // this object contains `position`, we want to preserve it along with
        // any additional property we may add in the future
        data.offsets.popper = _extends(
          {},
          data.offsets.popper,
          getPopperOffsets(
            data.instance.popper,
            data.offsets.reference,
            data.placement
          )
        );
        data = runModifiers(data.instance.modifiers, data, "flip");
      }
    });
    return data;
  }
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function keepTogether(data) {
    var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
    var placement = data.placement.split("-")[0];
    var floor = Math.floor;
    var isVertical = ["top", "bottom"].indexOf(placement) !== -1;
    var side = isVertical ? "right" : "bottom";
    var opSide = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    if (popper[side] < floor(reference[opSide])) {
      data.offsets.popper[opSide] =
        floor(reference[opSide]) - popper[measurement];
    }
    if (popper[opSide] > floor(reference[side])) {
      data.offsets.popper[opSide] = floor(reference[side]);
    }
    return data;
  }
  /**
   * Converts a string containing value + unit into a px value number
   * @function
   * @memberof {modifiers~offset}
   * @private
   * @argument {String} str - Value + unit string
   * @argument {String} measurement - `height` or `width`
   * @argument {Object} popperOffsets
   * @argument {Object} referenceOffsets
   * @returns {Number|String}
   * Value in pixels, or original string if no values were extracted
   */ function toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2]; // If it's not a number it's an operator, I guess
    if (!value) {
      return str;
    }
    if (unit.indexOf("%") === 0) {
      var element = void 0;
      switch (unit) {
        case "%p":
          element = popperOffsets;
          break;
        case "%":
        case "%r":
        default:
          element = referenceOffsets;
      }
      var rect = getClientRect(element);
      return (rect[measurement] / 100) * value;
    } else if (unit === "vh" || unit === "vw") {
      // if is a vh or vw, we calculate the size based on the viewport
      var size = void 0;
      if (unit === "vh") {
        size = Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        );
      } else {
        size = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );
      }
      return (size / 100) * value;
    } else {
      // if is an explicit pixel unit, we get rid of the unit and keep the value
      // if is an implicit unit, it's px, and we return just the value
      return value;
    }
  }
  /**
   * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
   * @function
   * @memberof {modifiers~offset}
   * @private
   * @argument {String} offset
   * @argument {Object} popperOffsets
   * @argument {Object} referenceOffsets
   * @argument {String} basePlacement
   * @returns {Array} a two cells array with x and y offsets in numbers
   */ function parseOffset(
    offset,
    popperOffsets,
    referenceOffsets,
    basePlacement
  ) {
    var offsets = [0, 0]; // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = ["right", "left"].indexOf(basePlacement) !== -1; // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function (frag) {
      return frag.trim();
    }); // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf(
      find(fragments, function (frag) {
        return frag.search(/,|\s/) !== -1;
      })
    );
    if (fragments[divider] && fragments[divider].indexOf(",") === -1) {
      console.warn(
        "Offsets separated by white space(s) are deprecated, use a comma (,) instead."
      );
    } // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops =
      divider !== -1
        ? [
            fragments
              .slice(0, divider)
              .concat([fragments[divider].split(splitRegex)[0]]),
            [fragments[divider].split(splitRegex)[1]].concat(
              fragments.slice(divider + 1)
            ),
          ]
        : [fragments]; // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function (op, index) {
      // Most of the units rely on the orientation of the popper
      var measurement = (index === 1 ? !useHeight : useHeight)
        ? "height"
        : "width";
      var mergeWithPrevious = false;
      return (
        op // This aggregates any `+` or `-` sign that aren't considered operators
          // e.g.: 10 + +5 => [10, +, +5]
          .reduce(function (a, b) {
            if (a[a.length - 1] === "" && ["+", "-"].indexOf(b) !== -1) {
              a[a.length - 1] = b;
              mergeWithPrevious = true;
              return a;
            } else if (mergeWithPrevious) {
              a[a.length - 1] += b;
              mergeWithPrevious = false;
              return a;
            } else {
              return a.concat(b);
            }
          }, []) // Here we convert the string values into number values (in px)
          .map(function (str) {
            return toValue(str, measurement, popperOffsets, referenceOffsets);
          })
      );
    }); // Loop trough the offsets arrays and execute the operations
    ops.forEach(function (op, index) {
      op.forEach(function (frag, index2) {
        if (isNumeric(frag)) {
          offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
        }
      });
    });
    return offsets;
  }
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @argument {Number|String} options.offset=0
   * The offset value as described in the modifier description
   * @returns {Object} The data object, properly modified
   */ function offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
    var basePlacement = placement.split("-")[0];
    var offsets = void 0;
    if (isNumeric(+offset)) {
      offsets = [+offset, 0];
    } else {
      offsets = parseOffset(offset, popper, reference, basePlacement);
    }
    if (basePlacement === "left") {
      popper.top += offsets[0];
      popper.left -= offsets[1];
    } else if (basePlacement === "right") {
      popper.top += offsets[0];
      popper.left += offsets[1];
    } else if (basePlacement === "top") {
      popper.left += offsets[0];
      popper.top -= offsets[1];
    } else if (basePlacement === "bottom") {
      popper.left += offsets[0];
      popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
  }
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function preventOverflow(data, options) {
    var boundariesElement =
      options.boundariesElement || getOffsetParent(data.instance.popper); // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) {
      boundariesElement = getOffsetParent(boundariesElement);
    } // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = getSupportedPropertyName("transform");
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];
    popperStyles.top = "";
    popperStyles.left = "";
    popperStyles[transformProp] = "";
    var boundaries = getBoundaries(
      data.instance.popper,
      data.instance.reference,
      options.padding,
      boundariesElement,
      data.positionFixed
    ); // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
      primary: function primary(placement) {
        var value = popper[placement];
        if (
          popper[placement] < boundaries[placement] &&
          !options.escapeWithReference
        ) {
          value = Math.max(popper[placement], boundaries[placement]);
        }
        return defineProperty({}, placement, value);
      },
      secondary: function secondary(placement) {
        var mainSide = placement === "right" ? "left" : "top";
        var value = popper[mainSide];
        if (
          popper[placement] > boundaries[placement] &&
          !options.escapeWithReference
        ) {
          value = Math.min(
            popper[mainSide],
            boundaries[placement] -
              (placement === "right" ? popper.width : popper.height)
          );
        }
        return defineProperty({}, mainSide, value);
      },
    };
    order.forEach(function (placement) {
      var side =
        ["left", "top"].indexOf(placement) !== -1 ? "primary" : "secondary";
      popper = _extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
  }
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var shiftvariation = placement.split("-")[1]; // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
      var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;
      var isVertical = ["bottom", "top"].indexOf(basePlacement) !== -1;
      var side = isVertical ? "left" : "top";
      var measurement = isVertical ? "width" : "height";
      var shiftOffsets = {
        start: defineProperty({}, side, reference[side]),
        end: defineProperty(
          {},
          side,
          reference[side] + reference[measurement] - popper[measurement]
        ),
      };
      data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
  }
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by update method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function hide(data) {
    if (
      !isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")
    ) {
      return data;
    }
    var refRect = data.offsets.reference;
    var bound = find(data.instance.modifiers, function (modifier) {
      return modifier.name === "preventOverflow";
    }).boundaries;
    if (
      refRect.bottom < bound.top ||
      refRect.left > bound.right ||
      refRect.top > bound.bottom ||
      refRect.right < bound.left
    ) {
      // Avoid unnecessary DOM access if visibility hasn't changed
      if (data.hide === true) {
        return data;
      }
      data.hide = true;
      data.attributes["x-out-of-boundaries"] = "";
    } else {
      // Avoid unnecessary DOM access if visibility hasn't changed
      if (data.hide === false) {
        return data;
      }
      data.hide = false;
      data.attributes["x-out-of-boundaries"] = false;
    }
    return data;
  }
  /**
   * @function
   * @memberof Modifiers
   * @argument {Object} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {Object} The data object, properly modified
   */ function inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
    var isHoriz = ["left", "right"].indexOf(basePlacement) !== -1;
    var subtractLength = ["top", "left"].indexOf(basePlacement) === -1;
    popper[isHoriz ? "left" : "top"] =
      reference[basePlacement] -
      (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
    data.placement = getOppositePlacement(placement);
    data.offsets.popper = getClientRect(popper);
    return data;
  }
  /**
   * Modifier function, each modifier can have a function of this type assigned
   * to its `fn` property.<br />
   * These functions will be called on each update, this means that you must
   * make sure they are performant enough to avoid performance bottlenecks.
   *
   * @function ModifierFn
   * @argument {dataObject} data - The data object generated by `update` method
   * @argument {Object} options - Modifiers configuration and options
   * @returns {dataObject} The data object, properly modified
   */ /**
   * Modifiers are plugins used to alter the behavior of your poppers.<br />
   * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
   * needed by the library.
   *
   * Usually you don't want to override the `order`, `fn` and `onLoad` props.
   * All the other properties are configurations that could be tweaked.
   * @namespace modifiers
   */ var modifiers = {
    /**
     * Modifier used to shift the popper on the start or end of its reference
     * element.<br />
     * It will read the variation of the `placement` property.<br />
     * It can be one either `-end` or `-start`.
     * @memberof modifiers
     * @inner
     */ shift: {
      /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
      /** @prop {ModifierFn} */ fn: shift,
    },
    /**
     * The `offset` modifier can shift your popper on both its axis.
     *
     * It accepts the following units:
     * - `px` or unit-less, interpreted as pixels
     * - `%` or `%r`, percentage relative to the length of the reference element
     * - `%p`, percentage relative to the length of the popper element
     * - `vw`, CSS viewport width unit
     * - `vh`, CSS viewport height unit
     *
     * For length is intended the main axis relative to the placement of the popper.<br />
     * This means that if the placement is `top` or `bottom`, the length will be the
     * `width`. In case of `left` or `right`, it will be the `height`.
     *
     * You can provide a single value (as `Number` or `String`), or a pair of values
     * as `String` divided by a comma or one (or more) white spaces.<br />
     * The latter is a deprecated method because it leads to confusion and will be
     * removed in v2.<br />
     * Additionally, it accepts additions and subtractions between different units.
     * Note that multiplications and divisions aren't supported.
     *
     * Valid examples are:
     * ```
     * 10
     * '10%'
     * '10, 10'
     * '10%, 10'
     * '10 + 10%'
     * '10 - 5vh + 3%'
     * '-10px + 5vh, 5px - 6%'
     * ```
     * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
     * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
     * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
     *
     * @memberof modifiers
     * @inner
     */ offset: {
      /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
      /** @prop {ModifierFn} */ fn: offset,
      /** @prop {Number|String} offset=0
       * The offset value as described in the modifier description
       */ offset: 0,
    },
    /**
     * Modifier used to prevent the popper from being positioned outside the boundary.
     *
     * A scenario exists where the reference itself is not within the boundaries.<br />
     * We can say it has "escaped the boundaries" — or just "escaped".<br />
     * In this case we need to decide whether the popper should either:
     *
     * - detach from the reference and remain "trapped" in the boundaries, or
     * - if it should ignore the boundary and "escape with its reference"
     *
     * When `escapeWithReference` is set to`true` and reference is completely
     * outside its boundaries, the popper will overflow (or completely leave)
     * the boundaries in order to remain attached to the edge of the reference.
     *
     * @memberof modifiers
     * @inner
     */ preventOverflow: {
      /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
      /** @prop {ModifierFn} */ fn: preventOverflow,
      /**
       * @prop {Array} [priority=['left','right','top','bottom']]
       * Popper will try to prevent overflow following these priorities by default,
       * then, it could overflow on the left and on top of the `boundariesElement`
       */ priority: ["left", "right", "top", "bottom"],
      /**
       * @prop {number} padding=5
       * Amount of pixel used to define a minimum distance between the boundaries
       * and the popper. This makes sure the popper always has a little padding
       * between the edges of its container
       */ padding: 5,
      /**
       * @prop {String|HTMLElement} boundariesElement='scrollParent'
       * Boundaries used by the modifier. Can be `scrollParent`, `window`,
       * `viewport` or any DOM element.
       */ boundariesElement: "scrollParent",
    },
    /**
     * Modifier used to make sure the reference and its popper stay near each other
     * without leaving any gap between the two. Especially useful when the arrow is
     * enabled and you want to ensure that it points to its reference element.
     * It cares only about the first axis. You can still have poppers with margin
     * between the popper and its reference element.
     * @memberof modifiers
     * @inner
     */ keepTogether: {
      /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
      /** @prop {ModifierFn} */ fn: keepTogether,
    },
    /**
     * This modifier is used to move the `arrowElement` of the popper to make
     * sure it is positioned between the reference element and its popper element.
     * It will read the outer size of the `arrowElement` node to detect how many
     * pixels of conjunction are needed.
     *
     * It has no effect if no `arrowElement` is provided.
     * @memberof modifiers
     * @inner
     */ arrow: {
      /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
      /** @prop {ModifierFn} */ fn: arrow,
      /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element:
        "[x-arrow]",
    },
    /**
     * Modifier used to flip the popper's placement when it starts to overlap its
     * reference element.
     *
     * Requires the `preventOverflow` modifier before it in order to work.
     *
     * **NOTE:** this modifier will interrupt the current update cycle and will
     * restart it if it detects the need to flip the placement.
     * @memberof modifiers
     * @inner
     */ flip: {
      /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
      /** @prop {ModifierFn} */ fn: flip,
      /**
       * @prop {String|Array} behavior='flip'
       * The behavior used to change the popper's placement. It can be one of
       * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
       * placements (with optional variations)
       */ behavior: "flip",
      /**
       * @prop {number} padding=5
       * The popper will flip if it hits the edges of the `boundariesElement`
       */ padding: 5,
      /**
       * @prop {String|HTMLElement} boundariesElement='viewport'
       * The element which will define the boundaries of the popper position.
       * The popper will never be placed outside of the defined boundaries
       * (except if `keepTogether` is enabled)
       */ boundariesElement: "viewport",
      /**
       * @prop {Boolean} flipVariations=false
       * The popper will switch placement variation between `-start` and `-end` when
       * the reference element overlaps its boundaries.
       *
       * The original placement should have a set variation.
       */ flipVariations: false,
      /**
       * @prop {Boolean} flipVariationsByContent=false
       * The popper will switch placement variation between `-start` and `-end` when
       * the popper element overlaps its reference boundaries.
       *
       * The original placement should have a set variation.
       */ flipVariationsByContent: false,
    },
    /**
     * Modifier used to make the popper flow toward the inner of the reference element.
     * By default, when this modifier is disabled, the popper will be placed outside
     * the reference element.
     * @memberof modifiers
     * @inner
     */ inner: {
      /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
      /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
      /** @prop {ModifierFn} */ fn: inner,
    },
    /**
     * Modifier used to hide the popper when its reference element is outside of the
     * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
     * be used to hide with a CSS selector the popper when its reference is
     * out of boundaries.
     *
     * Requires the `preventOverflow` modifier before it in order to work.
     * @memberof modifiers
     * @inner
     */ hide: {
      /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
      /** @prop {ModifierFn} */ fn: hide,
    },
    /**
     * Computes the style that will be applied to the popper element to gets
     * properly positioned.
     *
     * Note that this modifier will not touch the DOM, it just prepares the styles
     * so that `applyStyle` modifier can apply it. This separation is useful
     * in case you need to replace `applyStyle` with a custom implementation.
     *
     * This modifier has `850` as `order` value to maintain backward compatibility
     * with previous versions of Popper.js. Expect the modifiers ordering method
     * to change in future major versions of the library.
     *
     * @memberof modifiers
     * @inner
     */ computeStyle: {
      /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
      /** @prop {ModifierFn} */ fn: computeStyle,
      /**
       * @prop {Boolean} gpuAcceleration=true
       * If true, it uses the CSS 3D transformation to position the popper.
       * Otherwise, it will use the `top` and `left` properties
       */ gpuAcceleration: true,
      /**
       * @prop {string} [x='bottom']
       * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
       * Change this if your popper should grow in a direction different from `bottom`
       */ x: "bottom",
      /**
       * @prop {string} [x='left']
       * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
       * Change this if your popper should grow in a direction different from `right`
       */ y: "right",
    },
    /**
     * Applies the computed styles to the popper element.
     *
     * All the DOM manipulations are limited to this modifier. This is useful in case
     * you want to integrate Popper.js inside a framework or view library and you
     * want to delegate all the DOM manipulations to it.
     *
     * Note that if you disable this modifier, you must make sure the popper element
     * has its position set to `absolute` before Popper.js can do its work!
     *
     * Just disable this modifier and define your own to achieve the desired effect.
     *
     * @memberof modifiers
     * @inner
     */ applyStyle: {
      /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
      /** @prop {ModifierFn} */ fn: applyStyle,
      /** @prop {Function} */ onLoad: applyStyleOnLoad,
      /**
       * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
       * @prop {Boolean} gpuAcceleration=true
       * If true, it uses the CSS 3D transformation to position the popper.
       * Otherwise, it will use the `top` and `left` properties
       */ gpuAcceleration: undefined,
    },
  };
  /**
   * The `dataObject` is an object containing all the information used by Popper.js.
   * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
   * @name dataObject
   * @property {Object} data.instance The Popper.js instance
   * @property {String} data.placement Placement applied to popper
   * @property {String} data.originalPlacement Placement originally defined on init
   * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
   * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
   * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
   * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
   * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
   * @property {Object} data.boundaries Offsets of the popper boundaries
   * @property {Object} data.offsets The measurements of popper, reference and arrow elements
   * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
   * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
   * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
   */ /**
   * Default options provided to Popper.js constructor.<br />
   * These can be overridden using the `options` argument of Popper.js.<br />
   * To override an option, simply pass an object with the same
   * structure of the `options` object, as the 3rd argument. For example:
   * ```
   * new Popper(ref, pop, {
   *   modifiers: {
   *     preventOverflow: { enabled: false }
   *   }
   * })
   * ```
   * @type {Object}
   * @static
   * @memberof Popper
   */ var Defaults = {
    /**
     * Popper's placement.
     * @prop {Popper.placements} placement='bottom'
     */ placement: "bottom",
    /**
     * Set this to true if you want popper to position it self in 'fixed' mode
     * @prop {Boolean} positionFixed=false
     */ positionFixed: false,
    /**
     * Whether events (resize, scroll) are initially enabled.
     * @prop {Boolean} eventsEnabled=true
     */ eventsEnabled: true,
    /**
     * Set to true if you want to automatically remove the popper when
     * you call the `destroy` method.
     * @prop {Boolean} removeOnDestroy=false
     */ removeOnDestroy: false,
    /**
     * Callback called when the popper is created.<br />
     * By default, it is set to no-op.<br />
     * Access Popper.js instance with `data.instance`.
     * @prop {onCreate}
     */ onCreate: function onCreate() {},
    /**
     * Callback called when the popper is updated. This callback is not called
     * on the initialization/creation of the popper, but only on subsequent
     * updates.<br />
     * By default, it is set to no-op.<br />
     * Access Popper.js instance with `data.instance`.
     * @prop {onUpdate}
     */ onUpdate: function onUpdate() {},
    /**
     * List of modifiers used to modify the offsets before they are applied to the popper.
     * They provide most of the functionalities of Popper.js.
     * @prop {modifiers}
     */ modifiers: modifiers,
  }; // Utils
  /**
   * @callback onCreate
   * @param {dataObject} data
   */
  /**
   * @callback onUpdate
   * @param {dataObject} data
   */ // Methods
  var Popper = (function () {
    /**
     * Creates a new Popper.js instance.
     * @class Popper
     * @param {Element|referenceObject} reference - The reference element used to position the popper
     * @param {Element} popper - The HTML / XML element used as the popper
     * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
     * @return {Object} instance - The generated Popper.js instance
     */ function Popper(reference, popper) {
      var _this = this;
      var options =
        arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      classCallCheck(this, Popper);
      this.scheduleUpdate = function () {
        return requestAnimationFrame(_this.update);
      }; // make update() debounced, so that it only runs at most once-per-tick
      this.update = debounce(this.update.bind(this)); // with {} we create a new object with the options inside it
      this.options = _extends({}, Popper.Defaults, options); // init state
      this.state = { isDestroyed: false, isCreated: false, scrollParents: [] }; // get reference and popper elements (allow jQuery wrappers)
      this.reference = reference && reference.jquery ? reference[0] : reference;
      this.popper = popper && popper.jquery ? popper[0] : popper; // Deep merge modifiers options
      this.options.modifiers = {};
      Object.keys(
        _extends({}, Popper.Defaults.modifiers, options.modifiers)
      ).forEach(function (name) {
        _this.options.modifiers[name] = _extends(
          {},
          Popper.Defaults.modifiers[name] || {},
          options.modifiers ? options.modifiers[name] : {}
        );
      }); // Refactoring modifiers' list (Object => Array)
      this.modifiers = Object.keys(this.options.modifiers)
        .map(function (name) {
          return _extends({ name: name }, _this.options.modifiers[name]);
        }) // sort the modifiers by order
        .sort(function (a, b) {
          return a.order - b.order;
        }); // modifiers have the ability to execute arbitrary code when Popper.js get inited
      // such code is executed in the same order of its modifier
      // they could add new properties to their options configuration
      // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
      this.modifiers.forEach(function (modifierOptions) {
        if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
          modifierOptions.onLoad(
            _this.reference,
            _this.popper,
            _this.options,
            modifierOptions,
            _this.state
          );
        }
      }); // fire the first update to position the popper in the right place
      this.update();
      var eventsEnabled = this.options.eventsEnabled;
      if (eventsEnabled) {
        // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
      }
      this.state.eventsEnabled = eventsEnabled;
    } // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    createClass(Popper, [
      {
        key: "update",
        value: function update$$1() {
          return update.call(this);
        },
      },
      {
        key: "destroy",
        value: function destroy$$1() {
          return destroy.call(this);
        },
      },
      {
        key: "enableEventListeners",
        value: function enableEventListeners$$1() {
          return enableEventListeners.call(this);
        },
      },
      {
        key: "disableEventListeners",
        value: function disableEventListeners$$1() {
          return disableEventListeners.call(this);
        },
        /**
         * Schedules an update. It will run on the next UI update available.
         * @method scheduleUpdate
         * @memberof Popper
         */
        /**
         * Collection of utilities useful when writing custom modifiers.
         * Starting from version 1.7, this method is available only if you
         * include `popper-utils.js` before `popper.js`.
         *
         * **DEPRECATION**: This way to access PopperUtils is deprecated
         * and will be removed in v2! Use the PopperUtils module directly instead.
         * Due to the high instability of the methods contained in Utils, we can't
         * guarantee them to follow semver. Use them at your own risk!
         * @static
         * @private
         * @type {Object}
         * @deprecated since version 1.8
         * @member Utils
         * @memberof Popper
         */
      },
    ]);
    return Popper;
  })();
  /**
   * The `referenceObject` is an object that provides an interface compatible with Popper.js
   * and lets you use it as replacement of a real DOM node.<br />
   * You can use this method to position a popper relatively to a set of coordinates
   * in case you don't have a DOM node to use as reference.
   *
   * ```
   * new Popper(referenceObject, popperNode);
   * ```
   *
   * NB: This feature isn't supported in Internet Explorer 10.
   * @name referenceObject
   * @property {Function} data.getBoundingClientRect
   * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
   * @property {number} data.clientWidth
   * An ES6 getter that will return the width of the virtual reference element.
   * @property {number} data.clientHeight
   * An ES6 getter that will return the height of the virtual reference element.
   */ Popper.Utils = (typeof window !== "undefined"
    ? window
    : global
  ).PopperUtils;
  Popper.placements = placements;
  Popper.Defaults = Defaults;

  var categories = [
    "animals",
    "smileys",
    "skinTones",
    "travel",
    "flags",
    "objects",
    "activities",
    "symbols",
    "food",
  ];
  var emojiData = [
    { n: ["monkey_face"], e: "🐵", c: 0 },
    { n: ["grinning"], e: "😀", c: 1 },
    { n: ["skin-tone-2"], e: "🏻", c: 2 },
    { n: ["earth_africa"], e: "🌍", c: 3 },
    { n: ["checkered_flag"], e: "🏁", c: 4 },
    { n: ["mute"], e: "🔇", c: 5 },
    { n: ["jack_o_lantern"], e: "🎃", c: 6 },
    { n: ["atm"], e: "🏧", c: 7 },
    { n: ["grapes"], e: "🍇", c: 8 },
    { n: ["earth_americas"], e: "🌎", c: 3 },
    { n: ["grin"], e: "😁", c: 1 },
    { n: ["melon"], e: "🍈", c: 8 },
    { n: ["triangular_flag_on_post"], e: "🚩", c: 4 },
    { n: ["monkey"], e: "🐒", c: 0 },
    { n: ["christmas_tree"], e: "🎄", c: 6 },
    { n: ["skin-tone-3"], e: "🏼", c: 2 },
    { n: ["put_litter_in_its_place"], e: "🚮", c: 7 },
    { n: ["speaker"], e: "🔈", c: 5 },
    { n: ["earth_asia"], e: "🌏", c: 3 },
    { n: ["crossed_flags"], e: "🎌", c: 4 },
    { n: ["joy"], e: "😂", c: 1 },
    { n: ["sound"], e: "🔉", c: 5 },
    { n: ["watermelon"], e: "🍉", c: 8 },
    { n: ["gorilla"], e: "🦍", c: 0 },
    { n: ["fireworks"], e: "🎆", c: 6 },
    { n: ["potable_water"], e: "🚰", c: 7 },
    { n: ["skin-tone-4"], e: "🏽", c: 2 },
    { n: ["wheelchair"], e: "♿", c: 7 },
    { n: ["rolling_on_the_floor_laughing"], e: "🤣", c: 1 },
    { n: ["loud_sound"], e: "🔊", c: 5 },
    { n: ["waving_black_flag"], e: "🏴", c: 4 },
    { n: ["tangerine"], e: "🍊", c: 8 },
    { n: ["dog"], e: "🐶", c: 0 },
    { n: ["sparkler"], e: "🎇", c: 6 },
    { n: ["skin-tone-5"], e: "🏾", c: 2 },
    { n: ["globe_with_meridians"], e: "🌐", c: 3 },
    { n: ["skin-tone-6"], e: "🏿", c: 2 },
    { n: ["smiley"], e: "😃", c: 1 },
    { n: ["loudspeaker"], e: "📢", c: 5 },
    { n: ["sparkles"], e: "✨", c: 6 },
    { n: ["dog2"], e: "🐕", c: 0 },
    { n: ["waving_white_flag"], e: "🏳️", c: 4 },
    { n: ["world_map"], e: "🗺️", c: 3 },
    { n: ["lemon"], e: "🍋", c: 8 },
    { n: ["mens"], e: "🚹", c: 7 },
    { n: ["womens"], e: "🚺", c: 7 },
    { n: ["rainbow-flag"], e: "🏳️‍🌈", c: 4 },
    { n: ["smile"], e: "😄", c: 1 },
    { n: ["banana"], e: "🍌", c: 8 },
    { n: ["mega"], e: "📣", c: 5 },
    { n: ["japan"], e: "🗾", c: 3 },
    { n: ["poodle"], e: "🐩", c: 0 },
    { n: ["balloon"], e: "🎈", c: 6 },
    { n: ["flag-ac"], e: "🇦🇨", c: 4 },
    { n: ["sweat_smile"], e: "😅", c: 1 },
    { n: ["pineapple"], e: "🍍", c: 8 },
    { n: ["restroom"], e: "🚻", c: 7 },
    { n: ["postal_horn"], e: "📯", c: 5 },
    { n: ["wolf"], e: "🐺", c: 0 },
    { n: ["tada"], e: "🎉", c: 6 },
    { n: ["snow_capped_mountain"], e: "🏔️", c: 3 },
    { n: ["laughing", "satisfied"], e: "😆", c: 1 },
    { n: ["apple"], e: "🍎", c: 8 },
    { n: ["flag-ad"], e: "🇦🇩", c: 4 },
    { n: ["fox_face"], e: "🦊", c: 0 },
    { n: ["confetti_ball"], e: "🎊", c: 6 },
    { n: ["bell"], e: "🔔", c: 5 },
    { n: ["mountain"], e: "⛰️", c: 3 },
    { n: ["baby_symbol"], e: "🚼", c: 7 },
    { n: ["wc"], e: "🚾", c: 7 },
    { n: ["wink"], e: "😉", c: 1 },
    { n: ["no_bell"], e: "🔕", c: 5 },
    { n: ["green_apple"], e: "🍏", c: 8 },
    { n: ["tanabata_tree"], e: "🎋", c: 6 },
    { n: ["flag-ae"], e: "🇦🇪", c: 4 },
    { n: ["volcano"], e: "🌋", c: 3 },
    { n: ["cat"], e: "🐱", c: 0 },
    { n: ["flag-af"], e: "🇦🇫", c: 4 },
    { n: ["musical_score"], e: "🎼", c: 5 },
    { n: ["blush"], e: "😊", c: 1 },
    { n: ["pear"], e: "🍐", c: 8 },
    { n: ["bamboo"], e: "🎍", c: 6 },
    { n: ["passport_control"], e: "🛂", c: 7 },
    { n: ["mount_fuji"], e: "🗻", c: 3 },
    { n: ["cat2"], e: "🐈", c: 0 },
    { n: ["musical_note"], e: "🎵", c: 5 },
    { n: ["dolls"], e: "🎎", c: 6 },
    { n: ["lion_face"], e: "🦁", c: 0 },
    { n: ["camping"], e: "🏕️", c: 3 },
    { n: ["flag-ag"], e: "🇦🇬", c: 4 },
    { n: ["customs"], e: "🛃", c: 7 },
    { n: ["yum"], e: "😋", c: 1 },
    { n: ["peach"], e: "🍑", c: 8 },
    { n: ["tiger"], e: "🐯", c: 0 },
    { n: ["notes"], e: "🎶", c: 5 },
    { n: ["flags"], e: "🎏", c: 6 },
    { n: ["beach_with_umbrella"], e: "🏖️", c: 3 },
    { n: ["cherries"], e: "🍒", c: 8 },
    { n: ["flag-ai"], e: "🇦🇮", c: 4 },
    { n: ["baggage_claim"], e: "🛄", c: 7 },
    { n: ["sunglasses"], e: "😎", c: 1 },
    { n: ["left_luggage"], e: "🛅", c: 7 },
    { n: ["wind_chime"], e: "🎐", c: 6 },
    { n: ["strawberry"], e: "🍓", c: 8 },
    { n: ["desert"], e: "🏜️", c: 3 },
    { n: ["studio_microphone"], e: "🎙️", c: 5 },
    { n: ["flag-al"], e: "🇦🇱", c: 4 },
    { n: ["tiger2"], e: "🐅", c: 0 },
    { n: ["heart_eyes"], e: "😍", c: 1 },
    { n: ["desert_island"], e: "🏝️", c: 3 },
    { n: ["kiwifruit"], e: "🥝", c: 8 },
    { n: ["rice_scene"], e: "🎑", c: 6 },
    { n: ["kissing_heart"], e: "😘", c: 1 },
    { n: ["warning"], e: "⚠️", c: 7 },
    { n: ["flag-am"], e: "🇦🇲", c: 4 },
    { n: ["leopard"], e: "🐆", c: 0 },
    { n: ["level_slider"], e: "🎚️", c: 5 },
    { n: ["horse"], e: "🐴", c: 0 },
    { n: ["children_crossing"], e: "🚸", c: 7 },
    { n: ["ribbon"], e: "🎀", c: 6 },
    { n: ["national_park"], e: "🏞️", c: 3 },
    { n: ["control_knobs"], e: "🎛️", c: 5 },
    { n: ["kissing"], e: "😗", c: 1 },
    { n: ["tomato"], e: "🍅", c: 8 },
    { n: ["flag-ao"], e: "🇦🇴", c: 4 },
    { n: ["stadium"], e: "🏟️", c: 3 },
    { n: ["flag-aq"], e: "🇦🇶", c: 4 },
    { n: ["gift"], e: "🎁", c: 6 },
    { n: ["no_entry"], e: "⛔", c: 7 },
    { n: ["kissing_smiling_eyes"], e: "😙", c: 1 },
    { n: ["coconut"], e: "🥥", c: 8 },
    { n: ["racehorse"], e: "🐎", c: 0 },
    { n: ["microphone"], e: "🎤", c: 5 },
    { n: ["classical_building"], e: "🏛️", c: 3 },
    { n: ["no_entry_sign"], e: "🚫", c: 7 },
    { n: ["reminder_ribbon"], e: "🎗️", c: 6 },
    { n: ["kissing_closed_eyes"], e: "😚", c: 1 },
    { n: ["unicorn_face"], e: "🦄", c: 0 },
    { n: ["flag-ar"], e: "🇦🇷", c: 4 },
    { n: ["headphones"], e: "🎧", c: 5 },
    { n: ["avocado"], e: "🥑", c: 8 },
    { n: ["relaxed"], e: "☺️", c: 1 },
    { n: ["zebra_face"], e: "🦓", c: 0 },
    { n: ["eggplant"], e: "🍆", c: 8 },
    { n: ["radio"], e: "📻", c: 5 },
    { n: ["building_construction"], e: "🏗️", c: 3 },
    { n: ["flag-as"], e: "🇦🇸", c: 4 },
    { n: ["admission_tickets"], e: "🎟️", c: 6 },
    { n: ["no_bicycles"], e: "🚳", c: 7 },
    { n: ["no_smoking"], e: "🚭", c: 7 },
    { n: ["slightly_smiling_face"], e: "🙂", c: 1 },
    { n: ["flag-at"], e: "🇦🇹", c: 4 },
    { n: ["ticket"], e: "🎫", c: 6 },
    { n: ["saxophone"], e: "🎷", c: 5 },
    { n: ["deer"], e: "🦌", c: 0 },
    { n: ["house_buildings"], e: "🏘️", c: 3 },
    { n: ["potato"], e: "🥔", c: 8 },
    { n: ["guitar"], e: "🎸", c: 5 },
    { n: ["carrot"], e: "🥕", c: 8 },
    { n: ["cityscape"], e: "🏙️", c: 3 },
    { n: ["flag-au"], e: "🇦🇺", c: 4 },
    { n: ["do_not_litter"], e: "🚯", c: 7 },
    { n: ["hugging_face"], e: "🤗", c: 1 },
    { n: ["cow"], e: "🐮", c: 0 },
    { n: ["medal"], e: "🎖️", c: 6 },
    { n: ["musical_keyboard"], e: "🎹", c: 5 },
    { n: ["corn"], e: "🌽", c: 8 },
    { n: ["derelict_house_building"], e: "🏚️", c: 3 },
    { n: ["non-potable_water"], e: "🚱", c: 7 },
    { n: ["trophy"], e: "🏆", c: 6 },
    { n: ["flag-aw"], e: "🇦🇼", c: 4 },
    { n: ["star-struck", "grinning_face_with_star_eyes"], e: "🤩", c: 1 },
    { n: ["ox"], e: "🐂", c: 0 },
    { n: ["trumpet"], e: "🎺", c: 5 },
    { n: ["hot_pepper"], e: "🌶️", c: 8 },
    { n: ["sports_medal"], e: "🏅", c: 6 },
    { n: ["flag-ax"], e: "🇦🇽", c: 4 },
    { n: ["water_buffalo"], e: "🐃", c: 0 },
    { n: ["no_pedestrians"], e: "🚷", c: 7 },
    { n: ["thinking_face"], e: "🤔", c: 1 },
    { n: ["house"], e: "🏠", c: 3 },
    { n: ["no_mobile_phones"], e: "📵", c: 7 },
    { n: ["flag-az"], e: "🇦🇿", c: 4 },
    { n: ["first_place_medal"], e: "🥇", c: 6 },
    { n: ["house_with_garden"], e: "🏡", c: 3 },
    { n: ["violin"], e: "🎻", c: 5 },
    {
      n: ["face_with_raised_eyebrow", "face_with_one_eyebrow_raised"],
      e: "🤨",
      c: 1,
    },
    { n: ["cucumber"], e: "🥒", c: 8 },
    { n: ["cow2"], e: "🐄", c: 0 },
    { n: ["flag-ba"], e: "🇧🇦", c: 4 },
    { n: ["pig"], e: "🐷", c: 0 },
    { n: ["drum_with_drumsticks"], e: "🥁", c: 5 },
    { n: ["underage"], e: "🔞", c: 7 },
    { n: ["broccoli"], e: "🥦", c: 8 },
    { n: ["office"], e: "🏢", c: 3 },
    { n: ["second_place_medal"], e: "🥈", c: 6 },
    { n: ["neutral_face"], e: "😐", c: 1 },
    { n: ["third_place_medal"], e: "🥉", c: 6 },
    { n: ["mushroom"], e: "🍄", c: 8 },
    { n: ["flag-bb"], e: "🇧🇧", c: 4 },
    { n: ["radioactive_sign"], e: "☢️", c: 7 },
    { n: ["pig2"], e: "🐖", c: 0 },
    { n: ["expressionless"], e: "😑", c: 1 },
    { n: ["iphone"], e: "📱", c: 5 },
    { n: ["post_office"], e: "🏣", c: 3 },
    { n: ["european_post_office"], e: "🏤", c: 3 },
    { n: ["soccer"], e: "⚽", c: 6 },
    { n: ["boar"], e: "🐗", c: 0 },
    { n: ["peanuts"], e: "🥜", c: 8 },
    { n: ["calling"], e: "📲", c: 5 },
    { n: ["biohazard_sign"], e: "☣️", c: 7 },
    { n: ["flag-bd"], e: "🇧🇩", c: 4 },
    { n: ["no_mouth"], e: "😶", c: 1 },
    { n: ["face_with_rolling_eyes"], e: "🙄", c: 1 },
    { n: ["phone", "telephone"], e: "☎️", c: 5 },
    { n: ["pig_nose"], e: "🐽", c: 0 },
    { n: ["chestnut"], e: "🌰", c: 8 },
    { n: ["arrow_up"], e: "⬆️", c: 7 },
    { n: ["hospital"], e: "🏥", c: 3 },
    { n: ["flag-be"], e: "🇧🇪", c: 4 },
    { n: ["baseball"], e: "⚾", c: 6 },
    { n: ["smirk"], e: "😏", c: 1 },
    { n: ["arrow_upper_right"], e: "↗️", c: 7 },
    { n: ["flag-bf"], e: "🇧🇫", c: 4 },
    { n: ["basketball"], e: "🏀", c: 6 },
    { n: ["ram"], e: "🐏", c: 0 },
    { n: ["bank"], e: "🏦", c: 3 },
    { n: ["bread"], e: "🍞", c: 8 },
    { n: ["telephone_receiver"], e: "📞", c: 5 },
    { n: ["croissant"], e: "🥐", c: 8 },
    { n: ["pager"], e: "📟", c: 5 },
    { n: ["sheep"], e: "🐑", c: 0 },
    { n: ["arrow_right"], e: "➡️", c: 7 },
    { n: ["persevere"], e: "😣", c: 1 },
    { n: ["flag-bg"], e: "🇧🇬", c: 4 },
    { n: ["volleyball"], e: "🏐", c: 6 },
    { n: ["hotel"], e: "🏨", c: 3 },
    { n: ["arrow_lower_right"], e: "↘️", c: 7 },
    { n: ["goat"], e: "🐐", c: 0 },
    { n: ["flag-bh"], e: "🇧🇭", c: 4 },
    { n: ["love_hotel"], e: "🏩", c: 3 },
    { n: ["disappointed_relieved"], e: "😥", c: 1 },
    { n: ["baguette_bread"], e: "🥖", c: 8 },
    { n: ["football"], e: "🏈", c: 6 },
    { n: ["fax"], e: "📠", c: 5 },
    { n: ["convenience_store"], e: "🏪", c: 3 },
    { n: ["dromedary_camel"], e: "🐪", c: 0 },
    { n: ["arrow_down"], e: "⬇️", c: 7 },
    { n: ["battery"], e: "🔋", c: 5 },
    { n: ["rugby_football"], e: "🏉", c: 6 },
    { n: ["pretzel"], e: "🥨", c: 8 },
    { n: ["open_mouth"], e: "😮", c: 1 },
    { n: ["flag-bi"], e: "🇧🇮", c: 4 },
    { n: ["flag-bj"], e: "🇧🇯", c: 4 },
    { n: ["pancakes"], e: "🥞", c: 8 },
    { n: ["school"], e: "🏫", c: 3 },
    { n: ["tennis"], e: "🎾", c: 6 },
    { n: ["zipper_mouth_face"], e: "🤐", c: 1 },
    { n: ["camel"], e: "🐫", c: 0 },
    { n: ["arrow_lower_left"], e: "↙️", c: 7 },
    { n: ["electric_plug"], e: "🔌", c: 5 },
    { n: ["cheese_wedge"], e: "🧀", c: 8 },
    { n: ["hushed"], e: "😯", c: 1 },
    { n: ["computer"], e: "💻", c: 5 },
    { n: ["giraffe_face"], e: "🦒", c: 0 },
    { n: ["8ball"], e: "🎱", c: 6 },
    { n: ["flag-bl"], e: "🇧🇱", c: 4 },
    { n: ["arrow_left"], e: "⬅️", c: 7 },
    { n: ["department_store"], e: "🏬", c: 3 },
    { n: ["meat_on_bone"], e: "🍖", c: 8 },
    { n: ["arrow_upper_left"], e: "↖️", c: 7 },
    { n: ["flag-bm"], e: "🇧🇲", c: 4 },
    { n: ["sleepy"], e: "😪", c: 1 },
    { n: ["bowling"], e: "🎳", c: 6 },
    { n: ["factory"], e: "🏭", c: 3 },
    { n: ["desktop_computer"], e: "🖥️", c: 5 },
    { n: ["elephant"], e: "🐘", c: 0 },
    { n: ["rhinoceros"], e: "🦏", c: 0 },
    { n: ["arrow_up_down"], e: "↕️", c: 7 },
    { n: ["cricket_bat_and_ball"], e: "🏏", c: 6 },
    { n: ["printer"], e: "🖨️", c: 5 },
    { n: ["poultry_leg"], e: "🍗", c: 8 },
    { n: ["tired_face"], e: "😫", c: 1 },
    { n: ["japanese_castle"], e: "🏯", c: 3 },
    { n: ["flag-bn"], e: "🇧🇳", c: 4 },
    { n: ["field_hockey_stick_and_ball"], e: "🏑", c: 6 },
    { n: ["sleeping"], e: "😴", c: 1 },
    { n: ["left_right_arrow"], e: "↔️", c: 7 },
    { n: ["keyboard"], e: "⌨️", c: 5 },
    { n: ["european_castle"], e: "🏰", c: 3 },
    { n: ["mouse"], e: "🐭", c: 0 },
    { n: ["flag-bo"], e: "🇧🇴", c: 4 },
    { n: ["cut_of_meat"], e: "🥩", c: 8 },
    { n: ["ice_hockey_stick_and_puck"], e: "🏒", c: 6 },
    { n: ["mouse2"], e: "🐁", c: 0 },
    { n: ["three_button_mouse"], e: "🖱️", c: 5 },
    { n: ["leftwards_arrow_with_hook"], e: "↩️", c: 7 },
    { n: ["bacon"], e: "🥓", c: 8 },
    { n: ["relieved"], e: "😌", c: 1 },
    { n: ["flag-bq"], e: "🇧🇶", c: 4 },
    { n: ["wedding"], e: "💒", c: 3 },
    { n: ["tokyo_tower"], e: "🗼", c: 3 },
    { n: ["arrow_right_hook"], e: "↪️", c: 7 },
    { n: ["hamburger"], e: "🍔", c: 8 },
    { n: ["stuck_out_tongue"], e: "😛", c: 1 },
    { n: ["trackball"], e: "🖲️", c: 5 },
    { n: ["flag-br"], e: "🇧🇷", c: 4 },
    { n: ["rat"], e: "🐀", c: 0 },
    { n: ["table_tennis_paddle_and_ball"], e: "🏓", c: 6 },
    { n: ["minidisc"], e: "💽", c: 5 },
    { n: ["stuck_out_tongue_winking_eye"], e: "😜", c: 1 },
    { n: ["fries"], e: "🍟", c: 8 },
    { n: ["badminton_racquet_and_shuttlecock"], e: "🏸", c: 6 },
    { n: ["statue_of_liberty"], e: "🗽", c: 3 },
    { n: ["flag-bs"], e: "🇧🇸", c: 4 },
    { n: ["arrow_heading_up"], e: "⤴️", c: 7 },
    { n: ["hamster"], e: "🐹", c: 0 },
    { n: ["stuck_out_tongue_closed_eyes"], e: "😝", c: 1 },
    { n: ["pizza"], e: "🍕", c: 8 },
    { n: ["boxing_glove"], e: "🥊", c: 6 },
    { n: ["floppy_disk"], e: "💾", c: 5 },
    { n: ["arrow_heading_down"], e: "⤵️", c: 7 },
    { n: ["flag-bt"], e: "🇧🇹", c: 4 },
    { n: ["rabbit"], e: "🐰", c: 0 },
    { n: ["church"], e: "⛪", c: 3 },
    { n: ["drooling_face"], e: "🤤", c: 1 },
    { n: ["flag-bv"], e: "🇧🇻", c: 4 },
    { n: ["mosque"], e: "🕌", c: 3 },
    { n: ["rabbit2"], e: "🐇", c: 0 },
    { n: ["hotdog"], e: "🌭", c: 8 },
    { n: ["martial_arts_uniform"], e: "🥋", c: 6 },
    { n: ["arrows_clockwise"], e: "🔃", c: 7 },
    { n: ["cd"], e: "💿", c: 5 },
    { n: ["arrows_counterclockwise"], e: "🔄", c: 7 },
    { n: ["sandwich"], e: "🥪", c: 8 },
    { n: ["chipmunk"], e: "🐿️", c: 0 },
    { n: ["synagogue"], e: "🕍", c: 3 },
    { n: ["unamused"], e: "😒", c: 1 },
    { n: ["goal_net"], e: "🥅", c: 6 },
    { n: ["flag-bw"], e: "🇧🇼", c: 4 },
    { n: ["dvd"], e: "📀", c: 5 },
    { n: ["hedgehog"], e: "🦔", c: 0 },
    { n: ["dart"], e: "🎯", c: 6 },
    { n: ["taco"], e: "🌮", c: 8 },
    { n: ["back"], e: "🔙", c: 7 },
    { n: ["flag-by"], e: "🇧🇾", c: 4 },
    { n: ["shinto_shrine"], e: "⛩️", c: 3 },
    { n: ["movie_camera"], e: "🎥", c: 5 },
    { n: ["sweat"], e: "😓", c: 1 },
    { n: ["burrito"], e: "🌯", c: 8 },
    { n: ["flag-bz"], e: "🇧🇿", c: 4 },
    { n: ["pensive"], e: "😔", c: 1 },
    { n: ["kaaba"], e: "🕋", c: 3 },
    { n: ["film_frames"], e: "🎞️", c: 5 },
    { n: ["bat"], e: "🦇", c: 0 },
    { n: ["golf"], e: "⛳", c: 6 },
    { n: ["end"], e: "🔚", c: 7 },
    { n: ["film_projector"], e: "📽️", c: 5 },
    { n: ["bear"], e: "🐻", c: 0 },
    { n: ["ice_skate"], e: "⛸️", c: 6 },
    { n: ["fountain"], e: "⛲", c: 3 },
    { n: ["confused"], e: "😕", c: 1 },
    { n: ["flag-ca"], e: "🇨🇦", c: 4 },
    { n: ["on"], e: "🔛", c: 7 },
    { n: ["stuffed_flatbread"], e: "🥙", c: 8 },
    { n: ["soon"], e: "🔜", c: 7 },
    { n: ["upside_down_face"], e: "🙃", c: 1 },
    { n: ["fishing_pole_and_fish"], e: "🎣", c: 6 },
    { n: ["tent"], e: "⛺", c: 3 },
    { n: ["clapper"], e: "🎬", c: 5 },
    { n: ["egg"], e: "🥚", c: 8 },
    { n: ["flag-cc"], e: "🇨🇨", c: 4 },
    { n: ["koala"], e: "🐨", c: 0 },
    { n: ["foggy"], e: "🌁", c: 3 },
    { n: ["tv"], e: "📺", c: 5 },
    { n: ["panda_face"], e: "🐼", c: 0 },
    { n: ["fried_egg", "cooking"], e: "🍳", c: 8 },
    { n: ["top"], e: "🔝", c: 7 },
    { n: ["flag-cd"], e: "🇨🇩", c: 4 },
    { n: ["money_mouth_face"], e: "🤑", c: 1 },
    { n: ["running_shirt_with_sash"], e: "🎽", c: 6 },
    { n: ["astonished"], e: "😲", c: 1 },
    { n: ["feet", "paw_prints"], e: "🐾", c: 0 },
    { n: ["camera"], e: "📷", c: 5 },
    { n: ["flag-cf"], e: "🇨🇫", c: 4 },
    { n: ["place_of_worship"], e: "🛐", c: 7 },
    { n: ["night_with_stars"], e: "🌃", c: 3 },
    { n: ["ski"], e: "🎿", c: 6 },
    { n: ["shallow_pan_of_food"], e: "🥘", c: 8 },
    { n: ["camera_with_flash"], e: "📸", c: 5 },
    { n: ["sunrise_over_mountains"], e: "🌄", c: 3 },
    { n: ["turkey"], e: "🦃", c: 0 },
    { n: ["white_frowning_face"], e: "☹️", c: 1 },
    { n: ["flag-cg"], e: "🇨🇬", c: 4 },
    { n: ["stew"], e: "🍲", c: 8 },
    { n: ["sled"], e: "🛷", c: 6 },
    { n: ["atom_symbol"], e: "⚛️", c: 7 },
    { n: ["curling_stone"], e: "🥌", c: 6 },
    { n: ["slightly_frowning_face"], e: "🙁", c: 1 },
    { n: ["sunrise"], e: "🌅", c: 3 },
    { n: ["om_symbol"], e: "🕉️", c: 7 },
    { n: ["chicken"], e: "🐔", c: 0 },
    { n: ["bowl_with_spoon"], e: "🥣", c: 8 },
    { n: ["flag-ch"], e: "🇨🇭", c: 4 },
    { n: ["video_camera"], e: "📹", c: 5 },
    { n: ["video_game"], e: "🎮", c: 6 },
    { n: ["rooster"], e: "🐓", c: 0 },
    { n: ["vhs"], e: "📼", c: 5 },
    { n: ["city_sunset"], e: "🌆", c: 3 },
    { n: ["confounded"], e: "😖", c: 1 },
    { n: ["green_salad"], e: "🥗", c: 8 },
    { n: ["star_of_david"], e: "✡️", c: 7 },
    { n: ["flag-ci"], e: "🇨🇮", c: 4 },
    { n: ["popcorn"], e: "🍿", c: 8 },
    { n: ["city_sunrise"], e: "🌇", c: 3 },
    { n: ["disappointed"], e: "😞", c: 1 },
    { n: ["mag"], e: "🔍", c: 5 },
    { n: ["hatching_chick"], e: "🐣", c: 0 },
    { n: ["joystick"], e: "🕹️", c: 6 },
    { n: ["wheel_of_dharma"], e: "☸️", c: 7 },
    { n: ["flag-ck"], e: "🇨🇰", c: 4 },
    { n: ["canned_food"], e: "🥫", c: 8 },
    { n: ["worried"], e: "😟", c: 1 },
    { n: ["baby_chick"], e: "🐤", c: 0 },
    { n: ["flag-cl"], e: "🇨🇱", c: 4 },
    { n: ["game_die"], e: "🎲", c: 6 },
    { n: ["mag_right"], e: "🔎", c: 5 },
    { n: ["yin_yang"], e: "☯️", c: 7 },
    { n: ["bridge_at_night"], e: "🌉", c: 3 },
    { n: ["spades"], e: "♠️", c: 6 },
    { n: ["hatched_chick"], e: "🐥", c: 0 },
    { n: ["flag-cm"], e: "🇨🇲", c: 4 },
    { n: ["latin_cross"], e: "✝️", c: 7 },
    { n: ["triumph"], e: "😤", c: 1 },
    { n: ["hotsprings"], e: "♨️", c: 3 },
    { n: ["bento"], e: "🍱", c: 8 },
    { n: ["microscope"], e: "🔬", c: 5 },
    { n: ["cry"], e: "😢", c: 1 },
    { n: ["bird"], e: "🐦", c: 0 },
    { n: ["cn", "flag-cn"], e: "🇨🇳", c: 4 },
    { n: ["telescope"], e: "🔭", c: 5 },
    { n: ["rice_cracker"], e: "🍘", c: 8 },
    { n: ["hearts"], e: "♥️", c: 6 },
    { n: ["orthodox_cross"], e: "☦️", c: 7 },
    { n: ["milky_way"], e: "🌌", c: 3 },
    { n: ["rice_ball"], e: "🍙", c: 8 },
    { n: ["satellite_antenna"], e: "📡", c: 5 },
    { n: ["flag-co"], e: "🇨🇴", c: 4 },
    { n: ["carousel_horse"], e: "🎠", c: 3 },
    { n: ["sob"], e: "😭", c: 1 },
    { n: ["diamonds"], e: "♦️", c: 6 },
    { n: ["star_and_crescent"], e: "☪️", c: 7 },
    { n: ["penguin"], e: "🐧", c: 0 },
    { n: ["dove_of_peace"], e: "🕊️", c: 0 },
    { n: ["flag-cp"], e: "🇨🇵", c: 4 },
    { n: ["ferris_wheel"], e: "🎡", c: 3 },
    { n: ["clubs"], e: "♣️", c: 6 },
    { n: ["peace_symbol"], e: "☮️", c: 7 },
    { n: ["candle"], e: "🕯️", c: 5 },
    { n: ["frowning"], e: "😦", c: 1 },
    { n: ["rice"], e: "🍚", c: 8 },
    { n: ["flag-cr"], e: "🇨🇷", c: 4 },
    { n: ["roller_coaster"], e: "🎢", c: 3 },
    { n: ["menorah_with_nine_branches"], e: "🕎", c: 7 },
    { n: ["black_joker"], e: "🃏", c: 6 },
    { n: ["eagle"], e: "🦅", c: 0 },
    { n: ["curry"], e: "🍛", c: 8 },
    { n: ["bulb"], e: "💡", c: 5 },
    { n: ["anguished"], e: "😧", c: 1 },
    { n: ["flag-cu"], e: "🇨🇺", c: 4 },
    { n: ["barber"], e: "💈", c: 3 },
    { n: ["duck"], e: "🦆", c: 0 },
    { n: ["six_pointed_star"], e: "🔯", c: 7 },
    { n: ["ramen"], e: "🍜", c: 8 },
    { n: ["flashlight"], e: "🔦", c: 5 },
    { n: ["mahjong"], e: "🀄", c: 6 },
    { n: ["fearful"], e: "😨", c: 1 },
    { n: ["aries"], e: "♈", c: 7 },
    { n: ["spaghetti"], e: "🍝", c: 8 },
    { n: ["circus_tent"], e: "🎪", c: 3 },
    { n: ["izakaya_lantern", "lantern"], e: "🏮", c: 5 },
    { n: ["flag-cv"], e: "🇨🇻", c: 4 },
    { n: ["weary"], e: "😩", c: 1 },
    { n: ["flower_playing_cards"], e: "🎴", c: 6 },
    { n: ["owl"], e: "🦉", c: 0 },
    { n: ["performing_arts"], e: "🎭", c: 3 },
    { n: ["frog"], e: "🐸", c: 0 },
    { n: ["flag-cw"], e: "🇨🇼", c: 4 },
    { n: ["notebook_with_decorative_cover"], e: "📔", c: 5 },
    {
      n: ["exploding_head", "shocked_face_with_exploding_head"],
      e: "🤯",
      c: 1,
    },
    { n: ["taurus"], e: "♉", c: 7 },
    { n: ["sweet_potato"], e: "🍠", c: 8 },
    { n: ["closed_book"], e: "📕", c: 5 },
    { n: ["gemini"], e: "♊", c: 7 },
    { n: ["frame_with_picture"], e: "🖼️", c: 3 },
    { n: ["flag-cx"], e: "🇨🇽", c: 4 },
    { n: ["grimacing"], e: "😬", c: 1 },
    { n: ["crocodile"], e: "🐊", c: 0 },
    { n: ["oden"], e: "🍢", c: 8 },
    { n: ["flag-cy"], e: "🇨🇾", c: 4 },
    { n: ["book", "open_book"], e: "📖", c: 5 },
    { n: ["turtle"], e: "🐢", c: 0 },
    { n: ["art"], e: "🎨", c: 3 },
    { n: ["sushi"], e: "🍣", c: 8 },
    { n: ["cold_sweat"], e: "😰", c: 1 },
    { n: ["cancer"], e: "♋", c: 7 },
    { n: ["fried_shrimp"], e: "🍤", c: 8 },
    { n: ["slot_machine"], e: "🎰", c: 3 },
    { n: ["scream"], e: "😱", c: 1 },
    { n: ["green_book"], e: "📗", c: 5 },
    { n: ["leo"], e: "♌", c: 7 },
    { n: ["flag-cz"], e: "🇨🇿", c: 4 },
    { n: ["lizard"], e: "🦎", c: 0 },
    { n: ["virgo"], e: "♍", c: 7 },
    { n: ["steam_locomotive"], e: "🚂", c: 3 },
    { n: ["de", "flag-de"], e: "🇩🇪", c: 4 },
    { n: ["flushed"], e: "😳", c: 1 },
    { n: ["blue_book"], e: "📘", c: 5 },
    { n: ["snake"], e: "🐍", c: 0 },
    { n: ["fish_cake"], e: "🍥", c: 8 },
    { n: ["railway_car"], e: "🚃", c: 3 },
    { n: ["dango"], e: "🍡", c: 8 },
    { n: ["orange_book"], e: "📙", c: 5 },
    { n: ["libra"], e: "♎", c: 7 },
    { n: ["dragon_face"], e: "🐲", c: 0 },
    { n: ["flag-dg"], e: "🇩🇬", c: 4 },
    {
      n: ["zany_face", "grinning_face_with_one_large_and_one_small_eye"],
      e: "🤪",
      c: 1,
    },
    { n: ["books"], e: "📚", c: 5 },
    { n: ["dragon"], e: "🐉", c: 0 },
    { n: ["flag-dj"], e: "🇩🇯", c: 4 },
    { n: ["dumpling"], e: "🥟", c: 8 },
    { n: ["dizzy_face"], e: "😵", c: 1 },
    { n: ["scorpius"], e: "♏", c: 7 },
    { n: ["bullettrain_side"], e: "🚄", c: 3 },
    { n: ["bullettrain_front"], e: "🚅", c: 3 },
    { n: ["notebook"], e: "📓", c: 5 },
    { n: ["fortune_cookie"], e: "🥠", c: 8 },
    { n: ["sagittarius"], e: "♐", c: 7 },
    { n: ["sauropod"], e: "🦕", c: 0 },
    { n: ["flag-dk"], e: "🇩🇰", c: 4 },
    { n: ["rage"], e: "😡", c: 1 },
    { n: ["ledger"], e: "📒", c: 5 },
    { n: ["angry"], e: "😠", c: 1 },
    { n: ["t-rex"], e: "🦖", c: 0 },
    { n: ["capricorn"], e: "♑", c: 7 },
    { n: ["takeout_box"], e: "🥡", c: 8 },
    { n: ["flag-dm"], e: "🇩🇲", c: 4 },
    { n: ["train2"], e: "🚆", c: 3 },
    { n: ["page_with_curl"], e: "📃", c: 5 },
    { n: ["whale"], e: "🐳", c: 0 },
    {
      n: [
        "face_with_symbols_on_mouth",
        "serious_face_with_symbols_covering_mouth",
      ],
      e: "🤬",
      c: 1,
    },
    { n: ["flag-do"], e: "🇩🇴", c: 4 },
    { n: ["metro"], e: "🚇", c: 3 },
    { n: ["icecream"], e: "🍦", c: 8 },
    { n: ["aquarius"], e: "♒", c: 7 },
    { n: ["flag-dz"], e: "🇩🇿", c: 4 },
    { n: ["whale2"], e: "🐋", c: 0 },
    { n: ["mask"], e: "😷", c: 1 },
    { n: ["scroll"], e: "📜", c: 5 },
    { n: ["shaved_ice"], e: "🍧", c: 8 },
    { n: ["pisces"], e: "♓", c: 7 },
    { n: ["light_rail"], e: "🚈", c: 3 },
    { n: ["dolphin", "flipper"], e: "🐬", c: 0 },
    { n: ["face_with_thermometer"], e: "🤒", c: 1 },
    { n: ["flag-ea"], e: "🇪🇦", c: 4 },
    { n: ["ophiuchus"], e: "⛎", c: 7 },
    { n: ["station"], e: "🚉", c: 3 },
    { n: ["ice_cream"], e: "🍨", c: 8 },
    { n: ["page_facing_up"], e: "📄", c: 5 },
    { n: ["doughnut"], e: "🍩", c: 8 },
    { n: ["face_with_head_bandage"], e: "🤕", c: 1 },
    { n: ["fish"], e: "🐟", c: 0 },
    { n: ["newspaper"], e: "📰", c: 5 },
    { n: ["tram"], e: "🚊", c: 3 },
    { n: ["flag-ec"], e: "🇪🇨", c: 4 },
    { n: ["twisted_rightwards_arrows"], e: "🔀", c: 7 },
    { n: ["flag-ee"], e: "🇪🇪", c: 4 },
    { n: ["cookie"], e: "🍪", c: 8 },
    { n: ["monorail"], e: "🚝", c: 3 },
    { n: ["tropical_fish"], e: "🐠", c: 0 },
    { n: ["rolled_up_newspaper"], e: "🗞️", c: 5 },
    { n: ["nauseated_face"], e: "🤢", c: 1 },
    { n: ["repeat"], e: "🔁", c: 7 },
    { n: ["bookmark_tabs"], e: "📑", c: 5 },
    { n: ["repeat_one"], e: "🔂", c: 7 },
    { n: ["flag-eg"], e: "🇪🇬", c: 4 },
    { n: ["mountain_railway"], e: "🚞", c: 3 },
    { n: ["birthday"], e: "🎂", c: 8 },
    { n: ["blowfish"], e: "🐡", c: 0 },
    { n: ["face_vomiting", "face_with_open_mouth_vomiting"], e: "🤮", c: 1 },
    { n: ["arrow_forward"], e: "▶️", c: 7 },
    { n: ["bookmark"], e: "🔖", c: 5 },
    { n: ["flag-eh"], e: "🇪🇭", c: 4 },
    { n: ["shark"], e: "🦈", c: 0 },
    { n: ["train"], e: "🚋", c: 3 },
    { n: ["sneezing_face"], e: "🤧", c: 1 },
    { n: ["cake"], e: "🍰", c: 8 },
    { n: ["bus"], e: "🚌", c: 3 },
    { n: ["pie"], e: "🥧", c: 8 },
    { n: ["innocent"], e: "😇", c: 1 },
    { n: ["fast_forward"], e: "⏩", c: 7 },
    { n: ["label"], e: "🏷️", c: 5 },
    { n: ["octopus"], e: "🐙", c: 0 },
    { n: ["flag-er"], e: "🇪🇷", c: 4 },
    {
      n: ["black_right_pointing_double_triangle_with_vertical_bar"],
      e: "⏭️",
      c: 7,
    },
    { n: ["chocolate_bar"], e: "🍫", c: 8 },
    { n: ["oncoming_bus"], e: "🚍", c: 3 },
    { n: ["shell"], e: "🐚", c: 0 },
    { n: ["face_with_cowboy_hat"], e: "🤠", c: 1 },
    { n: ["moneybag"], e: "💰", c: 5 },
    { n: ["es", "flag-es"], e: "🇪🇸", c: 4 },
    { n: ["crab"], e: "🦀", c: 0 },
    { n: ["yen"], e: "💴", c: 5 },
    { n: ["flag-et"], e: "🇪🇹", c: 4 },
    { n: ["clown_face"], e: "🤡", c: 1 },
    {
      n: ["black_right_pointing_triangle_with_double_vertical_bar"],
      e: "⏯️",
      c: 7,
    },
    { n: ["trolleybus"], e: "🚎", c: 3 },
    { n: ["candy"], e: "🍬", c: 8 },
    { n: ["lying_face"], e: "🤥", c: 1 },
    { n: ["arrow_backward"], e: "◀️", c: 7 },
    { n: ["dollar"], e: "💵", c: 5 },
    { n: ["shrimp"], e: "🦐", c: 0 },
    { n: ["minibus"], e: "🚐", c: 3 },
    { n: ["flag-eu"], e: "🇪🇺", c: 4 },
    { n: ["lollipop"], e: "🍭", c: 8 },
    { n: ["squid"], e: "🦑", c: 0 },
    { n: ["euro"], e: "💶", c: 5 },
    { n: ["flag-fi"], e: "🇫🇮", c: 4 },
    { n: ["ambulance"], e: "🚑", c: 3 },
    { n: ["custard"], e: "🍮", c: 8 },
    {
      n: ["shushing_face", "face_with_finger_covering_closed_lips"],
      e: "🤫",
      c: 1,
    },
    { n: ["rewind"], e: "⏪", c: 7 },
    {
      n: ["black_left_pointing_double_triangle_with_vertical_bar"],
      e: "⏮️",
      c: 7,
    },
    {
      n: [
        "face_with_hand_over_mouth",
        "smiling_face_with_smiling_eyes_and_hand_covering_mouth",
      ],
      e: "🤭",
      c: 1,
    },
    { n: ["flag-fj"], e: "🇫🇯", c: 4 },
    { n: ["honey_pot"], e: "🍯", c: 8 },
    { n: ["snail"], e: "🐌", c: 0 },
    { n: ["pound"], e: "💷", c: 5 },
    { n: ["fire_engine"], e: "🚒", c: 3 },
    { n: ["baby_bottle"], e: "🍼", c: 8 },
    { n: ["flag-fk"], e: "🇫🇰", c: 4 },
    { n: ["butterfly"], e: "🦋", c: 0 },
    { n: ["money_with_wings"], e: "💸", c: 5 },
    { n: ["face_with_monocle"], e: "🧐", c: 1 },
    { n: ["police_car"], e: "🚓", c: 3 },
    { n: ["arrow_up_small"], e: "🔼", c: 7 },
    { n: ["flag-fm"], e: "🇫🇲", c: 4 },
    { n: ["glass_of_milk"], e: "🥛", c: 8 },
    { n: ["credit_card"], e: "💳", c: 5 },
    { n: ["oncoming_police_car"], e: "🚔", c: 3 },
    { n: ["bug"], e: "🐛", c: 0 },
    { n: ["nerd_face"], e: "🤓", c: 1 },
    { n: ["arrow_double_up"], e: "⏫", c: 7 },
    { n: ["chart"], e: "💹", c: 5 },
    { n: ["flag-fo"], e: "🇫🇴", c: 4 },
    { n: ["ant"], e: "🐜", c: 0 },
    { n: ["arrow_down_small"], e: "🔽", c: 7 },
    { n: ["smiling_imp"], e: "😈", c: 1 },
    { n: ["taxi"], e: "🚕", c: 3 },
    { n: ["coffee"], e: "☕", c: 8 },
    { n: ["fr", "flag-fr"], e: "🇫🇷", c: 4 },
    { n: ["oncoming_taxi"], e: "🚖", c: 3 },
    { n: ["arrow_double_down"], e: "⏬", c: 7 },
    { n: ["imp"], e: "👿", c: 1 },
    { n: ["currency_exchange"], e: "💱", c: 5 },
    { n: ["tea"], e: "🍵", c: 8 },
    { n: ["bee", "honeybee"], e: "🐝", c: 0 },
    { n: ["heavy_dollar_sign"], e: "💲", c: 5 },
    { n: ["car", "red_car"], e: "🚗", c: 3 },
    { n: ["sake"], e: "🍶", c: 8 },
    { n: ["flag-ga"], e: "🇬🇦", c: 4 },
    { n: ["beetle"], e: "🐞", c: 0 },
    { n: ["japanese_ogre"], e: "👹", c: 1 },
    { n: ["double_vertical_bar"], e: "⏸️", c: 7 },
    { n: ["champagne"], e: "🍾", c: 8 },
    { n: ["japanese_goblin"], e: "👺", c: 1 },
    { n: ["black_square_for_stop"], e: "⏹️", c: 7 },
    { n: ["oncoming_automobile"], e: "🚘", c: 3 },
    { n: ["email", "envelope"], e: "✉️", c: 5 },
    { n: ["cricket"], e: "🦗", c: 0 },
    { n: ["gb", "uk", "flag-gb"], e: "🇬🇧", c: 4 },
    { n: ["black_circle_for_record"], e: "⏺️", c: 7 },
    { n: ["flag-gd"], e: "🇬🇩", c: 4 },
    { n: ["spider"], e: "🕷️", c: 0 },
    { n: ["blue_car"], e: "🚙", c: 3 },
    { n: ["skull"], e: "💀", c: 1 },
    { n: ["e-mail"], e: "📧", c: 5 },
    { n: ["wine_glass"], e: "🍷", c: 8 },
    { n: ["spider_web"], e: "🕸️", c: 0 },
    { n: ["cocktail"], e: "🍸", c: 8 },
    { n: ["skull_and_crossbones"], e: "☠️", c: 1 },
    { n: ["flag-ge"], e: "🇬🇪", c: 4 },
    { n: ["eject"], e: "⏏️", c: 7 },
    { n: ["truck"], e: "🚚", c: 3 },
    { n: ["incoming_envelope"], e: "📨", c: 5 },
    { n: ["tropical_drink"], e: "🍹", c: 8 },
    { n: ["scorpion"], e: "🦂", c: 0 },
    { n: ["cinema"], e: "🎦", c: 7 },
    { n: ["articulated_lorry"], e: "🚛", c: 3 },
    { n: ["envelope_with_arrow"], e: "📩", c: 5 },
    { n: ["ghost"], e: "👻", c: 1 },
    { n: ["flag-gf"], e: "🇬🇫", c: 4 },
    { n: ["bouquet"], e: "💐", c: 0 },
    { n: ["tractor"], e: "🚜", c: 3 },
    { n: ["beer"], e: "🍺", c: 8 },
    { n: ["outbox_tray"], e: "📤", c: 5 },
    { n: ["low_brightness"], e: "🔅", c: 7 },
    { n: ["alien"], e: "👽", c: 1 },
    { n: ["flag-gg"], e: "🇬🇬", c: 4 },
    { n: ["cherry_blossom"], e: "🌸", c: 0 },
    { n: ["inbox_tray"], e: "📥", c: 5 },
    { n: ["flag-gh"], e: "🇬🇭", c: 4 },
    { n: ["bike"], e: "🚲", c: 3 },
    { n: ["space_invader"], e: "👾", c: 1 },
    { n: ["beers"], e: "🍻", c: 8 },
    { n: ["high_brightness"], e: "🔆", c: 7 },
    { n: ["package"], e: "📦", c: 5 },
    { n: ["scooter"], e: "🛴", c: 3 },
    { n: ["white_flower"], e: "💮", c: 0 },
    { n: ["clinking_glasses"], e: "🥂", c: 8 },
    { n: ["robot_face"], e: "🤖", c: 1 },
    { n: ["signal_strength"], e: "📶", c: 7 },
    { n: ["flag-gi"], e: "🇬🇮", c: 4 },
    { n: ["flag-gl"], e: "🇬🇱", c: 4 },
    { n: ["motor_scooter"], e: "🛵", c: 3 },
    { n: ["mailbox"], e: "📫", c: 5 },
    { n: ["vibration_mode"], e: "📳", c: 7 },
    { n: ["hankey", "poop", "shit"], e: "💩", c: 1 },
    { n: ["rosette"], e: "🏵️", c: 0 },
    { n: ["tumbler_glass"], e: "🥃", c: 8 },
    { n: ["cup_with_straw"], e: "🥤", c: 8 },
    { n: ["flag-gm"], e: "🇬🇲", c: 4 },
    { n: ["mailbox_closed"], e: "📪", c: 5 },
    { n: ["mobile_phone_off"], e: "📴", c: 7 },
    { n: ["busstop"], e: "🚏", c: 3 },
    { n: ["smiley_cat"], e: "😺", c: 1 },
    { n: ["rose"], e: "🌹", c: 0 },
    { n: ["motorway"], e: "🛣️", c: 3 },
    { n: ["smile_cat"], e: "😸", c: 1 },
    { n: ["flag-gn"], e: "🇬🇳", c: 4 },
    { n: ["wilted_flower"], e: "🥀", c: 0 },
    { n: ["mailbox_with_mail"], e: "📬", c: 5 },
    { n: ["chopsticks"], e: "🥢", c: 8 },
    { n: ["female_sign"], e: "♀️", c: 7 },
    { n: ["mailbox_with_no_mail"], e: "📭", c: 5 },
    { n: ["knife_fork_plate"], e: "🍽️", c: 8 },
    { n: ["hibiscus"], e: "🌺", c: 0 },
    { n: ["flag-gp"], e: "🇬🇵", c: 4 },
    { n: ["railway_track"], e: "🛤️", c: 3 },
    { n: ["male_sign"], e: "♂️", c: 7 },
    { n: ["joy_cat"], e: "😹", c: 1 },
    { n: ["fuelpump"], e: "⛽", c: 3 },
    { n: ["sunflower"], e: "🌻", c: 0 },
    { n: ["postbox"], e: "📮", c: 5 },
    { n: ["flag-gq"], e: "🇬🇶", c: 4 },
    { n: ["heart_eyes_cat"], e: "😻", c: 1 },
    { n: ["fork_and_knife"], e: "🍴", c: 8 },
    { n: ["medical_symbol", "staff_of_aesculapius"], e: "⚕️", c: 7 },
    { n: ["recycle"], e: "♻️", c: 7 },
    { n: ["spoon"], e: "🥄", c: 8 },
    { n: ["blossom"], e: "🌼", c: 0 },
    { n: ["rotating_light"], e: "🚨", c: 3 },
    { n: ["smirk_cat"], e: "😼", c: 1 },
    { n: ["ballot_box_with_ballot"], e: "🗳️", c: 5 },
    { n: ["flag-gr"], e: "🇬🇷", c: 4 },
    { n: ["kissing_cat"], e: "😽", c: 1 },
    { n: ["pencil2"], e: "✏️", c: 5 },
    { n: ["traffic_light"], e: "🚥", c: 3 },
    { n: ["fleur_de_lis"], e: "⚜️", c: 7 },
    { n: ["tulip"], e: "🌷", c: 0 },
    { n: ["hocho", "knife"], e: "🔪", c: 8 },
    { n: ["flag-gs"], e: "🇬🇸", c: 4 },
    { n: ["seedling"], e: "🌱", c: 0 },
    { n: ["amphora"], e: "🏺", c: 8 },
    { n: ["scream_cat"], e: "🙀", c: 1 },
    { n: ["vertical_traffic_light"], e: "🚦", c: 3 },
    { n: ["black_nib"], e: "✒️", c: 5 },
    { n: ["flag-gt"], e: "🇬🇹", c: 4 },
    { n: ["trident"], e: "🔱", c: 7 },
    { n: ["flag-gu"], e: "🇬🇺", c: 4 },
    { n: ["name_badge"], e: "📛", c: 7 },
    { n: ["construction"], e: "🚧", c: 3 },
    { n: ["lower_left_fountain_pen"], e: "🖋️", c: 5 },
    { n: ["evergreen_tree"], e: "🌲", c: 0 },
    { n: ["crying_cat_face"], e: "😿", c: 1 },
    { n: ["flag-gw"], e: "🇬🇼", c: 4 },
    { n: ["lower_left_ballpoint_pen"], e: "🖊️", c: 5 },
    { n: ["pouting_cat"], e: "😾", c: 1 },
    { n: ["deciduous_tree"], e: "🌳", c: 0 },
    { n: ["octagonal_sign"], e: "🛑", c: 3 },
    { n: ["beginner"], e: "🔰", c: 7 },
    { n: ["flag-gy"], e: "🇬🇾", c: 4 },
    { n: ["lower_left_paintbrush"], e: "🖌️", c: 5 },
    { n: ["o"], e: "⭕", c: 7 },
    { n: ["palm_tree"], e: "🌴", c: 0 },
    { n: ["anchor"], e: "⚓", c: 3 },
    { n: ["see_no_evil"], e: "🙈", c: 1 },
    { n: ["boat", "sailboat"], e: "⛵", c: 3 },
    { n: ["white_check_mark"], e: "✅", c: 7 },
    { n: ["flag-hk"], e: "🇭🇰", c: 4 },
    { n: ["lower_left_crayon"], e: "🖍️", c: 5 },
    { n: ["hear_no_evil"], e: "🙉", c: 1 },
    { n: ["cactus"], e: "🌵", c: 0 },
    { n: ["ear_of_rice"], e: "🌾", c: 0 },
    { n: ["speak_no_evil"], e: "🙊", c: 1 },
    { n: ["flag-hm"], e: "🇭🇲", c: 4 },
    { n: ["ballot_box_with_check"], e: "☑️", c: 7 },
    { n: ["canoe"], e: "🛶", c: 3 },
    { n: ["memo", "pencil"], e: "📝", c: 5 },
    { n: ["herb"], e: "🌿", c: 0 },
    { n: ["flag-hn"], e: "🇭🇳", c: 4 },
    { n: ["heavy_check_mark"], e: "✔️", c: 7 },
    { n: ["briefcase"], e: "💼", c: 5 },
    { n: ["speedboat"], e: "🚤", c: 3 },
    {
      n: ["baby"],
      e: "👶",
      c: 1,
      v: {
        "1F3FB": { k: "baby-1F3FB", n: "baby", e: "👶🏻" },
        "1F3FC": { k: "baby-1F3FC", n: "baby", e: "👶🏼" },
        "1F3FD": { k: "baby-1F3FD", n: "baby", e: "👶🏽" },
        "1F3FE": { k: "baby-1F3FE", n: "baby", e: "👶🏾" },
        "1F3FF": { k: "baby-1F3FF", n: "baby", e: "👶🏿" },
      },
    },
    { n: ["heavy_multiplication_x"], e: "✖️", c: 7 },
    {
      n: ["child"],
      e: "🧒",
      c: 1,
      v: {
        "1F3FB": { k: "child-1F3FB", n: "child", e: "🧒🏻" },
        "1F3FC": { k: "child-1F3FC", n: "child", e: "🧒🏼" },
        "1F3FD": { k: "child-1F3FD", n: "child", e: "🧒🏽" },
        "1F3FE": { k: "child-1F3FE", n: "child", e: "🧒🏾" },
        "1F3FF": { k: "child-1F3FF", n: "child", e: "🧒🏿" },
      },
    },
    { n: ["shamrock"], e: "☘️", c: 0 },
    { n: ["passenger_ship"], e: "🛳️", c: 3 },
    { n: ["flag-hr"], e: "🇭🇷", c: 4 },
    { n: ["file_folder"], e: "📁", c: 5 },
    { n: ["x"], e: "❌", c: 7 },
    { n: ["four_leaf_clover"], e: "🍀", c: 0 },
    { n: ["open_file_folder"], e: "📂", c: 5 },
    {
      n: ["boy"],
      e: "👦",
      c: 1,
      v: {
        "1F3FB": { k: "boy-1F3FB", n: "boy", e: "👦🏻" },
        "1F3FC": { k: "boy-1F3FC", n: "boy", e: "👦🏼" },
        "1F3FD": { k: "boy-1F3FD", n: "boy", e: "👦🏽" },
        "1F3FE": { k: "boy-1F3FE", n: "boy", e: "👦🏾" },
        "1F3FF": { k: "boy-1F3FF", n: "boy", e: "👦🏿" },
      },
    },
    { n: ["ferry"], e: "⛴️", c: 3 },
    { n: ["flag-ht"], e: "🇭🇹", c: 4 },
    {
      n: ["girl"],
      e: "👧",
      c: 1,
      v: {
        "1F3FB": { k: "girl-1F3FB", n: "girl", e: "👧🏻" },
        "1F3FC": { k: "girl-1F3FC", n: "girl", e: "👧🏼" },
        "1F3FD": { k: "girl-1F3FD", n: "girl", e: "👧🏽" },
        "1F3FE": { k: "girl-1F3FE", n: "girl", e: "👧🏾" },
        "1F3FF": { k: "girl-1F3FF", n: "girl", e: "👧🏿" },
      },
    },
    { n: ["negative_squared_cross_mark"], e: "❎", c: 7 },
    { n: ["flag-hu"], e: "🇭🇺", c: 4 },
    { n: ["card_index_dividers"], e: "🗂️", c: 5 },
    { n: ["maple_leaf"], e: "🍁", c: 0 },
    { n: ["motor_boat"], e: "🛥️", c: 3 },
    { n: ["flag-ic"], e: "🇮🇨", c: 4 },
    { n: ["fallen_leaf"], e: "🍂", c: 0 },
    {
      n: ["adult"],
      e: "🧑",
      c: 1,
      v: {
        "1F3FB": { k: "adult-1F3FB", n: "adult", e: "🧑🏻" },
        "1F3FC": { k: "adult-1F3FC", n: "adult", e: "🧑🏼" },
        "1F3FD": { k: "adult-1F3FD", n: "adult", e: "🧑🏽" },
        "1F3FE": { k: "adult-1F3FE", n: "adult", e: "🧑🏾" },
        "1F3FF": { k: "adult-1F3FF", n: "adult", e: "🧑🏿" },
      },
    },
    { n: ["ship"], e: "🚢", c: 3 },
    { n: ["heavy_plus_sign"], e: "➕", c: 7 },
    { n: ["date"], e: "📅", c: 5 },
    {
      n: ["man"],
      e: "👨",
      c: 1,
      v: {
        "1F3FB": { k: "man-1F3FB", n: "man", e: "👨🏻" },
        "1F3FC": { k: "man-1F3FC", n: "man", e: "👨🏼" },
        "1F3FD": { k: "man-1F3FD", n: "man", e: "👨🏽" },
        "1F3FE": { k: "man-1F3FE", n: "man", e: "👨🏾" },
        "1F3FF": { k: "man-1F3FF", n: "man", e: "👨🏿" },
      },
    },
    { n: ["flag-id"], e: "🇮🇩", c: 4 },
    { n: ["leaves"], e: "🍃", c: 0 },
    { n: ["heavy_minus_sign"], e: "➖", c: 7 },
    { n: ["calendar"], e: "📆", c: 5 },
    { n: ["airplane"], e: "✈️", c: 3 },
    { n: ["spiral_note_pad"], e: "🗒️", c: 5 },
    { n: ["heavy_division_sign"], e: "➗", c: 7 },
    { n: ["small_airplane"], e: "🛩️", c: 3 },
    {
      n: ["woman"],
      e: "👩",
      c: 1,
      v: {
        "1F3FB": { k: "woman-1F3FB", n: "woman", e: "👩🏻" },
        "1F3FC": { k: "woman-1F3FC", n: "woman", e: "👩🏼" },
        "1F3FD": { k: "woman-1F3FD", n: "woman", e: "👩🏽" },
        "1F3FE": { k: "woman-1F3FE", n: "woman", e: "👩🏾" },
        "1F3FF": { k: "woman-1F3FF", n: "woman", e: "👩🏿" },
      },
    },
    { n: ["flag-ie"], e: "🇮🇪", c: 4 },
    { n: ["curly_loop"], e: "➰", c: 7 },
    { n: ["flag-il"], e: "🇮🇱", c: 4 },
    { n: ["airplane_departure"], e: "🛫", c: 3 },
    { n: ["spiral_calendar_pad"], e: "🗓️", c: 5 },
    {
      n: ["older_adult"],
      e: "🧓",
      c: 1,
      v: {
        "1F3FB": { k: "older_adult-1F3FB", n: "older_adult", e: "🧓🏻" },
        "1F3FC": { k: "older_adult-1F3FC", n: "older_adult", e: "🧓🏼" },
        "1F3FD": { k: "older_adult-1F3FD", n: "older_adult", e: "🧓🏽" },
        "1F3FE": { k: "older_adult-1F3FE", n: "older_adult", e: "🧓🏾" },
        "1F3FF": { k: "older_adult-1F3FF", n: "older_adult", e: "🧓🏿" },
      },
    },
    { n: ["airplane_arriving"], e: "🛬", c: 3 },
    { n: ["card_index"], e: "📇", c: 5 },
    { n: ["loop"], e: "➿", c: 7 },
    {
      n: ["older_man"],
      e: "👴",
      c: 1,
      v: {
        "1F3FB": { k: "older_man-1F3FB", n: "older_man", e: "👴🏻" },
        "1F3FC": { k: "older_man-1F3FC", n: "older_man", e: "👴🏼" },
        "1F3FD": { k: "older_man-1F3FD", n: "older_man", e: "👴🏽" },
        "1F3FE": { k: "older_man-1F3FE", n: "older_man", e: "👴🏾" },
        "1F3FF": { k: "older_man-1F3FF", n: "older_man", e: "👴🏿" },
      },
    },
    { n: ["flag-im"], e: "🇮🇲", c: 4 },
    { n: ["flag-in"], e: "🇮🇳", c: 4 },
    { n: ["chart_with_upwards_trend"], e: "📈", c: 5 },
    { n: ["part_alternation_mark"], e: "〽️", c: 7 },
    { n: ["seat"], e: "💺", c: 3 },
    {
      n: ["older_woman"],
      e: "👵",
      c: 1,
      v: {
        "1F3FB": { k: "older_woman-1F3FB", n: "older_woman", e: "👵🏻" },
        "1F3FC": { k: "older_woman-1F3FC", n: "older_woman", e: "👵🏼" },
        "1F3FD": { k: "older_woman-1F3FD", n: "older_woman", e: "👵🏽" },
        "1F3FE": { k: "older_woman-1F3FE", n: "older_woman", e: "👵🏾" },
        "1F3FF": { k: "older_woman-1F3FF", n: "older_woman", e: "👵🏿" },
      },
    },
    { n: ["eight_spoked_asterisk"], e: "✳️", c: 7 },
    { n: ["chart_with_downwards_trend"], e: "📉", c: 5 },
    { n: ["flag-io"], e: "🇮🇴", c: 4 },
    {
      n: ["male-doctor"],
      e: "👨‍⚕️",
      c: 1,
      v: {
        "1F3FB": { k: "male-doctor-1F3FB", n: "male-doctor", e: "👨🏻‍⚕️" },
        "1F3FC": { k: "male-doctor-1F3FC", n: "male-doctor", e: "👨🏼‍⚕️" },
        "1F3FD": { k: "male-doctor-1F3FD", n: "male-doctor", e: "👨🏽‍⚕️" },
        "1F3FE": { k: "male-doctor-1F3FE", n: "male-doctor", e: "👨🏾‍⚕️" },
        "1F3FF": { k: "male-doctor-1F3FF", n: "male-doctor", e: "👨🏿‍⚕️" },
      },
    },
    { n: ["helicopter"], e: "🚁", c: 3 },
    {
      n: ["female-doctor"],
      e: "👩‍⚕️",
      c: 1,
      v: {
        "1F3FB": { k: "female-doctor-1F3FB", n: "female-doctor", e: "👩🏻‍⚕️" },
        "1F3FC": { k: "female-doctor-1F3FC", n: "female-doctor", e: "👩🏼‍⚕️" },
        "1F3FD": { k: "female-doctor-1F3FD", n: "female-doctor", e: "👩🏽‍⚕️" },
        "1F3FE": { k: "female-doctor-1F3FE", n: "female-doctor", e: "👩🏾‍⚕️" },
        "1F3FF": { k: "female-doctor-1F3FF", n: "female-doctor", e: "👩🏿‍⚕️" },
      },
    },
    { n: ["suspension_railway"], e: "🚟", c: 3 },
    { n: ["bar_chart"], e: "📊", c: 5 },
    { n: ["flag-iq"], e: "🇮🇶", c: 4 },
    { n: ["eight_pointed_black_star"], e: "✴️", c: 7 },
    { n: ["mountain_cableway"], e: "🚠", c: 3 },
    {
      n: ["male-student"],
      e: "👨‍🎓",
      c: 1,
      v: {
        "1F3FB": { k: "male-student-1F3FB", n: "male-student", e: "👨🏻‍🎓" },
        "1F3FC": { k: "male-student-1F3FC", n: "male-student", e: "👨🏼‍🎓" },
        "1F3FD": { k: "male-student-1F3FD", n: "male-student", e: "👨🏽‍🎓" },
        "1F3FE": { k: "male-student-1F3FE", n: "male-student", e: "👨🏾‍🎓" },
        "1F3FF": { k: "male-student-1F3FF", n: "male-student", e: "👨🏿‍🎓" },
      },
    },
    { n: ["clipboard"], e: "📋", c: 5 },
    { n: ["flag-ir"], e: "🇮🇷", c: 4 },
    { n: ["sparkle"], e: "❇️", c: 7 },
    {
      n: ["female-student"],
      e: "👩‍🎓",
      c: 1,
      v: {
        "1F3FB": { k: "female-student-1F3FB", n: "female-student", e: "👩🏻‍🎓" },
        "1F3FC": { k: "female-student-1F3FC", n: "female-student", e: "👩🏼‍🎓" },
        "1F3FD": { k: "female-student-1F3FD", n: "female-student", e: "👩🏽‍🎓" },
        "1F3FE": { k: "female-student-1F3FE", n: "female-student", e: "👩🏾‍🎓" },
        "1F3FF": { k: "female-student-1F3FF", n: "female-student", e: "👩🏿‍🎓" },
      },
    },
    { n: ["pushpin"], e: "📌", c: 5 },
    { n: ["aerial_tramway"], e: "🚡", c: 3 },
    { n: ["flag-is"], e: "🇮🇸", c: 4 },
    { n: ["bangbang"], e: "‼️", c: 7 },
    { n: ["interrobang"], e: "⁉️", c: 7 },
    { n: ["satellite"], e: "🛰️", c: 3 },
    { n: ["it", "flag-it"], e: "🇮🇹", c: 4 },
    {
      n: ["male-teacher"],
      e: "👨‍🏫",
      c: 1,
      v: {
        "1F3FB": { k: "male-teacher-1F3FB", n: "male-teacher", e: "👨🏻‍🏫" },
        "1F3FC": { k: "male-teacher-1F3FC", n: "male-teacher", e: "👨🏼‍🏫" },
        "1F3FD": { k: "male-teacher-1F3FD", n: "male-teacher", e: "👨🏽‍🏫" },
        "1F3FE": { k: "male-teacher-1F3FE", n: "male-teacher", e: "👨🏾‍🏫" },
        "1F3FF": { k: "male-teacher-1F3FF", n: "male-teacher", e: "👨🏿‍🏫" },
      },
    },
    { n: ["round_pushpin"], e: "📍", c: 5 },
    { n: ["flag-je"], e: "🇯🇪", c: 4 },
    { n: ["question"], e: "❓", c: 7 },
    { n: ["rocket"], e: "🚀", c: 3 },
    {
      n: ["female-teacher"],
      e: "👩‍🏫",
      c: 1,
      v: {
        "1F3FB": { k: "female-teacher-1F3FB", n: "female-teacher", e: "👩🏻‍🏫" },
        "1F3FC": { k: "female-teacher-1F3FC", n: "female-teacher", e: "👩🏼‍🏫" },
        "1F3FD": { k: "female-teacher-1F3FD", n: "female-teacher", e: "👩🏽‍🏫" },
        "1F3FE": { k: "female-teacher-1F3FE", n: "female-teacher", e: "👩🏾‍🏫" },
        "1F3FF": { k: "female-teacher-1F3FF", n: "female-teacher", e: "👩🏿‍🏫" },
      },
    },
    { n: ["paperclip"], e: "📎", c: 5 },
    { n: ["linked_paperclips"], e: "🖇️", c: 5 },
    { n: ["flying_saucer"], e: "🛸", c: 3 },
    {
      n: ["male-judge"],
      e: "👨‍⚖️",
      c: 1,
      v: {
        "1F3FB": { k: "male-judge-1F3FB", n: "male-judge", e: "👨🏻‍⚖️" },
        "1F3FC": { k: "male-judge-1F3FC", n: "male-judge", e: "👨🏼‍⚖️" },
        "1F3FD": { k: "male-judge-1F3FD", n: "male-judge", e: "👨🏽‍⚖️" },
        "1F3FE": { k: "male-judge-1F3FE", n: "male-judge", e: "👨🏾‍⚖️" },
        "1F3FF": { k: "male-judge-1F3FF", n: "male-judge", e: "👨🏿‍⚖️" },
      },
    },
    { n: ["grey_question"], e: "❔", c: 7 },
    { n: ["flag-jm"], e: "🇯🇲", c: 4 },
    { n: ["bellhop_bell"], e: "🛎️", c: 3 },
    { n: ["straight_ruler"], e: "📏", c: 5 },
    { n: ["flag-jo"], e: "🇯🇴", c: 4 },
    {
      n: ["female-judge"],
      e: "👩‍⚖️",
      c: 1,
      v: {
        "1F3FB": { k: "female-judge-1F3FB", n: "female-judge", e: "👩🏻‍⚖️" },
        "1F3FC": { k: "female-judge-1F3FC", n: "female-judge", e: "👩🏼‍⚖️" },
        "1F3FD": { k: "female-judge-1F3FD", n: "female-judge", e: "👩🏽‍⚖️" },
        "1F3FE": { k: "female-judge-1F3FE", n: "female-judge", e: "👩🏾‍⚖️" },
        "1F3FF": { k: "female-judge-1F3FF", n: "female-judge", e: "👩🏿‍⚖️" },
      },
    },
    { n: ["grey_exclamation"], e: "❕", c: 7 },
    { n: ["door"], e: "🚪", c: 3 },
    {
      n: ["male-farmer"],
      e: "👨‍🌾",
      c: 1,
      v: {
        "1F3FB": { k: "male-farmer-1F3FB", n: "male-farmer", e: "👨🏻‍🌾" },
        "1F3FC": { k: "male-farmer-1F3FC", n: "male-farmer", e: "👨🏼‍🌾" },
        "1F3FD": { k: "male-farmer-1F3FD", n: "male-farmer", e: "👨🏽‍🌾" },
        "1F3FE": { k: "male-farmer-1F3FE", n: "male-farmer", e: "👨🏾‍🌾" },
        "1F3FF": { k: "male-farmer-1F3FF", n: "male-farmer", e: "👨🏿‍🌾" },
      },
    },
    { n: ["jp", "flag-jp"], e: "🇯🇵", c: 4 },
    { n: ["triangular_ruler"], e: "📐", c: 5 },
    { n: ["exclamation", "heavy_exclamation_mark"], e: "❗", c: 7 },
    { n: ["bed"], e: "🛏️", c: 3 },
    {
      n: ["female-farmer"],
      e: "👩‍🌾",
      c: 1,
      v: {
        "1F3FB": { k: "female-farmer-1F3FB", n: "female-farmer", e: "👩🏻‍🌾" },
        "1F3FC": { k: "female-farmer-1F3FC", n: "female-farmer", e: "👩🏼‍🌾" },
        "1F3FD": { k: "female-farmer-1F3FD", n: "female-farmer", e: "👩🏽‍🌾" },
        "1F3FE": { k: "female-farmer-1F3FE", n: "female-farmer", e: "👩🏾‍🌾" },
        "1F3FF": { k: "female-farmer-1F3FF", n: "female-farmer", e: "👩🏿‍🌾" },
      },
    },
    { n: ["scissors"], e: "✂️", c: 5 },
    { n: ["wavy_dash"], e: "〰️", c: 7 },
    { n: ["flag-ke"], e: "🇰🇪", c: 4 },
    { n: ["flag-kg"], e: "🇰🇬", c: 4 },
    { n: ["couch_and_lamp"], e: "🛋️", c: 3 },
    {
      n: ["male-cook"],
      e: "👨‍🍳",
      c: 1,
      v: {
        "1F3FB": { k: "male-cook-1F3FB", n: "male-cook", e: "👨🏻‍🍳" },
        "1F3FC": { k: "male-cook-1F3FC", n: "male-cook", e: "👨🏼‍🍳" },
        "1F3FD": { k: "male-cook-1F3FD", n: "male-cook", e: "👨🏽‍🍳" },
        "1F3FE": { k: "male-cook-1F3FE", n: "male-cook", e: "👨🏾‍🍳" },
        "1F3FF": { k: "male-cook-1F3FF", n: "male-cook", e: "👨🏿‍🍳" },
      },
    },
    { n: ["card_file_box"], e: "🗃️", c: 5 },
    { n: ["copyright"], e: "©️", c: 7 },
    { n: ["file_cabinet"], e: "🗄️", c: 5 },
    { n: ["registered"], e: "®️", c: 7 },
    { n: ["flag-kh"], e: "🇰🇭", c: 4 },
    {
      n: ["female-cook"],
      e: "👩‍🍳",
      c: 1,
      v: {
        "1F3FB": { k: "female-cook-1F3FB", n: "female-cook", e: "👩🏻‍🍳" },
        "1F3FC": { k: "female-cook-1F3FC", n: "female-cook", e: "👩🏼‍🍳" },
        "1F3FD": { k: "female-cook-1F3FD", n: "female-cook", e: "👩🏽‍🍳" },
        "1F3FE": { k: "female-cook-1F3FE", n: "female-cook", e: "👩🏾‍🍳" },
        "1F3FF": { k: "female-cook-1F3FF", n: "female-cook", e: "👩🏿‍🍳" },
      },
    },
    { n: ["toilet"], e: "🚽", c: 3 },
    { n: ["wastebasket"], e: "🗑️", c: 5 },
    { n: ["flag-ki"], e: "🇰🇮", c: 4 },
    { n: ["shower"], e: "🚿", c: 3 },
    {
      n: ["male-mechanic"],
      e: "👨‍🔧",
      c: 1,
      v: {
        "1F3FB": { k: "male-mechanic-1F3FB", n: "male-mechanic", e: "👨🏻‍🔧" },
        "1F3FC": { k: "male-mechanic-1F3FC", n: "male-mechanic", e: "👨🏼‍🔧" },
        "1F3FD": { k: "male-mechanic-1F3FD", n: "male-mechanic", e: "👨🏽‍🔧" },
        "1F3FE": { k: "male-mechanic-1F3FE", n: "male-mechanic", e: "👨🏾‍🔧" },
        "1F3FF": { k: "male-mechanic-1F3FF", n: "male-mechanic", e: "👨🏿‍🔧" },
      },
    },
    { n: ["tm"], e: "™️", c: 7 },
    { n: ["hash"], e: "#️⃣", c: 7 },
    { n: ["flag-km"], e: "🇰🇲", c: 4 },
    { n: ["bathtub"], e: "🛁", c: 3 },
    {
      n: ["female-mechanic"],
      e: "👩‍🔧",
      c: 1,
      v: {
        "1F3FB": { k: "female-mechanic-1F3FB", n: "female-mechanic", e: "👩🏻‍🔧" },
        "1F3FC": { k: "female-mechanic-1F3FC", n: "female-mechanic", e: "👩🏼‍🔧" },
        "1F3FD": { k: "female-mechanic-1F3FD", n: "female-mechanic", e: "👩🏽‍🔧" },
        "1F3FE": { k: "female-mechanic-1F3FE", n: "female-mechanic", e: "👩🏾‍🔧" },
        "1F3FF": { k: "female-mechanic-1F3FF", n: "female-mechanic", e: "👩🏿‍🔧" },
      },
    },
    { n: ["lock"], e: "🔒", c: 5 },
    {
      n: ["male-factory-worker"],
      e: "👨‍🏭",
      c: 1,
      v: {
        "1F3FB": {
          k: "male-factory-worker-1F3FB",
          n: "male-factory-worker",
          e: "👨🏻‍🏭",
        },
        "1F3FC": {
          k: "male-factory-worker-1F3FC",
          n: "male-factory-worker",
          e: "👨🏼‍🏭",
        },
        "1F3FD": {
          k: "male-factory-worker-1F3FD",
          n: "male-factory-worker",
          e: "👨🏽‍🏭",
        },
        "1F3FE": {
          k: "male-factory-worker-1F3FE",
          n: "male-factory-worker",
          e: "👨🏾‍🏭",
        },
        "1F3FF": {
          k: "male-factory-worker-1F3FF",
          n: "male-factory-worker",
          e: "👨🏿‍🏭",
        },
      },
    },
    { n: ["flag-kn"], e: "🇰🇳", c: 4 },
    { n: ["hourglass"], e: "⌛", c: 3 },
    { n: ["keycap_star"], e: "*️⃣", c: 7 },
    { n: ["unlock"], e: "🔓", c: 5 },
    { n: ["flag-kp"], e: "🇰🇵", c: 4 },
    {
      n: ["female-factory-worker"],
      e: "👩‍🏭",
      c: 1,
      v: {
        "1F3FB": {
          k: "female-factory-worker-1F3FB",
          n: "female-factory-worker",
          e: "👩🏻‍🏭",
        },
        "1F3FC": {
          k: "female-factory-worker-1F3FC",
          n: "female-factory-worker",
          e: "👩🏼‍🏭",
        },
        "1F3FD": {
          k: "female-factory-worker-1F3FD",
          n: "female-factory-worker",
          e: "👩🏽‍🏭",
        },
        "1F3FE": {
          k: "female-factory-worker-1F3FE",
          n: "female-factory-worker",
          e: "👩🏾‍🏭",
        },
        "1F3FF": {
          k: "female-factory-worker-1F3FF",
          n: "female-factory-worker",
          e: "👩🏿‍🏭",
        },
      },
    },
    { n: ["zero"], e: "0️⃣", c: 7 },
    { n: ["lock_with_ink_pen"], e: "🔏", c: 5 },
    { n: ["hourglass_flowing_sand"], e: "⏳", c: 3 },
    { n: ["one"], e: "1️⃣", c: 7 },
    { n: ["kr", "flag-kr"], e: "🇰🇷", c: 4 },
    { n: ["watch"], e: "⌚", c: 3 },
    {
      n: ["male-office-worker"],
      e: "👨‍💼",
      c: 1,
      v: {
        "1F3FB": {
          k: "male-office-worker-1F3FB",
          n: "male-office-worker",
          e: "👨🏻‍💼",
        },
        "1F3FC": {
          k: "male-office-worker-1F3FC",
          n: "male-office-worker",
          e: "👨🏼‍💼",
        },
        "1F3FD": {
          k: "male-office-worker-1F3FD",
          n: "male-office-worker",
          e: "👨🏽‍💼",
        },
        "1F3FE": {
          k: "male-office-worker-1F3FE",
          n: "male-office-worker",
          e: "👨🏾‍💼",
        },
        "1F3FF": {
          k: "male-office-worker-1F3FF",
          n: "male-office-worker",
          e: "👨🏿‍💼",
        },
      },
    },
    { n: ["closed_lock_with_key"], e: "🔐", c: 5 },
    {
      n: ["female-office-worker"],
      e: "👩‍💼",
      c: 1,
      v: {
        "1F3FB": {
          k: "female-office-worker-1F3FB",
          n: "female-office-worker",
          e: "👩🏻‍💼",
        },
        "1F3FC": {
          k: "female-office-worker-1F3FC",
          n: "female-office-worker",
          e: "👩🏼‍💼",
        },
        "1F3FD": {
          k: "female-office-worker-1F3FD",
          n: "female-office-worker",
          e: "👩🏽‍💼",
        },
        "1F3FE": {
          k: "female-office-worker-1F3FE",
          n: "female-office-worker",
          e: "👩🏾‍💼",
        },
        "1F3FF": {
          k: "female-office-worker-1F3FF",
          n: "female-office-worker",
          e: "👩🏿‍💼",
        },
      },
    },
    { n: ["two"], e: "2️⃣", c: 7 },
    { n: ["alarm_clock"], e: "⏰", c: 3 },
    { n: ["key"], e: "🔑", c: 5 },
    { n: ["flag-kw"], e: "🇰🇼", c: 4 },
    { n: ["stopwatch"], e: "⏱️", c: 3 },
    {
      n: ["male-scientist"],
      e: "👨‍🔬",
      c: 1,
      v: {
        "1F3FB": { k: "male-scientist-1F3FB", n: "male-scientist", e: "👨🏻‍🔬" },
        "1F3FC": { k: "male-scientist-1F3FC", n: "male-scientist", e: "👨🏼‍🔬" },
        "1F3FD": { k: "male-scientist-1F3FD", n: "male-scientist", e: "👨🏽‍🔬" },
        "1F3FE": { k: "male-scientist-1F3FE", n: "male-scientist", e: "👨🏾‍🔬" },
        "1F3FF": { k: "male-scientist-1F3FF", n: "male-scientist", e: "👨🏿‍🔬" },
      },
    },
    { n: ["three"], e: "3️⃣", c: 7 },
    { n: ["flag-ky"], e: "🇰🇾", c: 4 },
    { n: ["old_key"], e: "🗝️", c: 5 },
    { n: ["flag-kz"], e: "🇰🇿", c: 4 },
    { n: ["hammer"], e: "🔨", c: 5 },
    {
      n: ["female-scientist"],
      e: "👩‍🔬",
      c: 1,
      v: {
        "1F3FB": {
          k: "female-scientist-1F3FB",
          n: "female-scientist",
          e: "👩🏻‍🔬",
        },
        "1F3FC": {
          k: "female-scientist-1F3FC",
          n: "female-scientist",
          e: "👩🏼‍🔬",
        },
        "1F3FD": {
          k: "female-scientist-1F3FD",
          n: "female-scientist",
          e: "👩🏽‍🔬",
        },
        "1F3FE": {
          k: "female-scientist-1F3FE",
          n: "female-scientist",
          e: "👩🏾‍🔬",
        },
        "1F3FF": {
          k: "female-scientist-1F3FF",
          n: "female-scientist",
          e: "👩🏿‍🔬",
        },
      },
    },
    { n: ["timer_clock"], e: "⏲️", c: 3 },
    { n: ["four"], e: "4️⃣", c: 7 },
    {
      n: ["male-technologist"],
      e: "👨‍💻",
      c: 1,
      v: {
        "1F3FB": {
          k: "male-technologist-1F3FB",
          n: "male-technologist",
          e: "👨🏻‍💻",
        },
        "1F3FC": {
          k: "male-technologist-1F3FC",
          n: "male-technologist",
          e: "👨🏼‍💻",
        },
        "1F3FD": {
          k: "male-technologist-1F3FD",
          n: "male-technologist",
          e: "👨🏽‍💻",
        },
        "1F3FE": {
          k: "male-technologist-1F3FE",
          n: "male-technologist",
          e: "👨🏾‍💻",
        },
        "1F3FF": {
          k: "male-technologist-1F3FF",
          n: "male-technologist",
          e: "👨🏿‍💻",
        },
      },
    },
    { n: ["mantelpiece_clock"], e: "🕰️", c: 3 },
    { n: ["five"], e: "5️⃣", c: 7 },
    { n: ["flag-la"], e: "🇱🇦", c: 4 },
    { n: ["pick"], e: "⛏️", c: 5 },
    { n: ["flag-lb"], e: "🇱🇧", c: 4 },
    { n: ["clock12"], e: "🕛", c: 3 },
    { n: ["hammer_and_pick"], e: "⚒️", c: 5 },
    { n: ["six"], e: "6️⃣", c: 7 },
    {
      n: ["female-technologist"],
      e: "👩‍💻",
      c: 1,
      v: {
        "1F3FB": {
          k: "female-technologist-1F3FB",
          n: "female-technologist",
          e: "👩🏻‍💻",
        },
        "1F3FC": {
          k: "female-technologist-1F3FC",
          n: "female-technologist",
          e: "👩🏼‍💻",
        },
        "1F3FD": {
          k: "female-technologist-1F3FD",
          n: "female-technologist",
          e: "👩🏽‍💻",
        },
        "1F3FE": {
          k: "female-technologist-1F3FE",
          n: "female-technologist",
          e: "👩🏾‍💻",
        },
        "1F3FF": {
          k: "female-technologist-1F3FF",
          n: "female-technologist",
          e: "👩🏿‍💻",
        },
      },
    },
    { n: ["hammer_and_wrench"], e: "🛠️", c: 5 },
    { n: ["flag-lc"], e: "🇱🇨", c: 4 },
    { n: ["clock1230"], e: "🕧", c: 3 },
    { n: ["seven"], e: "7️⃣", c: 7 },
    {
      n: ["male-singer"],
      e: "👨‍🎤",
      c: 1,
      v: {
        "1F3FB": { k: "male-singer-1F3FB", n: "male-singer", e: "👨🏻‍🎤" },
        "1F3FC": { k: "male-singer-1F3FC", n: "male-singer", e: "👨🏼‍🎤" },
        "1F3FD": { k: "male-singer-1F3FD", n: "male-singer", e: "👨🏽‍🎤" },
        "1F3FE": { k: "male-singer-1F3FE", n: "male-singer", e: "👨🏾‍🎤" },
        "1F3FF": { k: "male-singer-1F3FF", n: "male-singer", e: "👨🏿‍🎤" },
      },
    },
    { n: ["eight"], e: "8️⃣", c: 7 },
    { n: ["flag-li"], e: "🇱🇮", c: 4 },
    { n: ["dagger_knife"], e: "🗡️", c: 5 },
    { n: ["clock1"], e: "🕐", c: 3 },
    {
      n: ["female-singer"],
      e: "👩‍🎤",
      c: 1,
      v: {
        "1F3FB": { k: "female-singer-1F3FB", n: "female-singer", e: "👩🏻‍🎤" },
        "1F3FC": { k: "female-singer-1F3FC", n: "female-singer", e: "👩🏼‍🎤" },
        "1F3FD": { k: "female-singer-1F3FD", n: "female-singer", e: "👩🏽‍🎤" },
        "1F3FE": { k: "female-singer-1F3FE", n: "female-singer", e: "👩🏾‍🎤" },
        "1F3FF": { k: "female-singer-1F3FF", n: "female-singer", e: "👩🏿‍🎤" },
      },
    },
    {
      n: ["male-artist"],
      e: "👨‍🎨",
      c: 1,
      v: {
        "1F3FB": { k: "male-artist-1F3FB", n: "male-artist", e: "👨🏻‍🎨" },
        "1F3FC": { k: "male-artist-1F3FC", n: "male-artist", e: "👨🏼‍🎨" },
        "1F3FD": { k: "male-artist-1F3FD", n: "male-artist", e: "👨🏽‍🎨" },
        "1F3FE": { k: "male-artist-1F3FE", n: "male-artist", e: "👨🏾‍🎨" },
        "1F3FF": { k: "male-artist-1F3FF", n: "male-artist", e: "👨🏿‍🎨" },
      },
    },
    { n: ["crossed_swords"], e: "⚔️", c: 5 },
    { n: ["nine"], e: "9️⃣", c: 7 },
    { n: ["flag-lk"], e: "🇱🇰", c: 4 },
    { n: ["clock130"], e: "🕜", c: 3 },
    { n: ["clock2"], e: "🕑", c: 3 },
    { n: ["gun"], e: "🔫", c: 5 },
    { n: ["keycap_ten"], e: "🔟", c: 7 },
    {
      n: ["female-artist"],
      e: "👩‍🎨",
      c: 1,
      v: {
        "1F3FB": { k: "female-artist-1F3FB", n: "female-artist", e: "👩🏻‍🎨" },
        "1F3FC": { k: "female-artist-1F3FC", n: "female-artist", e: "👩🏼‍🎨" },
        "1F3FD": { k: "female-artist-1F3FD", n: "female-artist", e: "👩🏽‍🎨" },
        "1F3FE": { k: "female-artist-1F3FE", n: "female-artist", e: "👩🏾‍🎨" },
        "1F3FF": { k: "female-artist-1F3FF", n: "female-artist", e: "👩🏿‍🎨" },
      },
    },
    { n: ["flag-lr"], e: "🇱🇷", c: 4 },
    { n: ["clock230"], e: "🕝", c: 3 },
    { n: ["100"], e: "💯", c: 7 },
    { n: ["bow_and_arrow"], e: "🏹", c: 5 },
    {
      n: ["male-pilot"],
      e: "👨‍✈️",
      c: 1,
      v: {
        "1F3FB": { k: "male-pilot-1F3FB", n: "male-pilot", e: "👨🏻‍✈️" },
        "1F3FC": { k: "male-pilot-1F3FC", n: "male-pilot", e: "👨🏼‍✈️" },
        "1F3FD": { k: "male-pilot-1F3FD", n: "male-pilot", e: "👨🏽‍✈️" },
        "1F3FE": { k: "male-pilot-1F3FE", n: "male-pilot", e: "👨🏾‍✈️" },
        "1F3FF": { k: "male-pilot-1F3FF", n: "male-pilot", e: "👨🏿‍✈️" },
      },
    },
    { n: ["flag-ls"], e: "🇱🇸", c: 4 },
    { n: ["flag-lt"], e: "🇱🇹", c: 4 },
    { n: ["capital_abcd"], e: "🔠", c: 7 },
    {
      n: ["female-pilot"],
      e: "👩‍✈️",
      c: 1,
      v: {
        "1F3FB": { k: "female-pilot-1F3FB", n: "female-pilot", e: "👩🏻‍✈️" },
        "1F3FC": { k: "female-pilot-1F3FC", n: "female-pilot", e: "👩🏼‍✈️" },
        "1F3FD": { k: "female-pilot-1F3FD", n: "female-pilot", e: "👩🏽‍✈️" },
        "1F3FE": { k: "female-pilot-1F3FE", n: "female-pilot", e: "👩🏾‍✈️" },
        "1F3FF": { k: "female-pilot-1F3FF", n: "female-pilot", e: "👩🏿‍✈️" },
      },
    },
    { n: ["clock3"], e: "🕒", c: 3 },
    { n: ["shield"], e: "🛡️", c: 5 },
    {
      n: ["male-astronaut"],
      e: "👨‍🚀",
      c: 1,
      v: {
        "1F3FB": { k: "male-astronaut-1F3FB", n: "male-astronaut", e: "👨🏻‍🚀" },
        "1F3FC": { k: "male-astronaut-1F3FC", n: "male-astronaut", e: "👨🏼‍🚀" },
        "1F3FD": { k: "male-astronaut-1F3FD", n: "male-astronaut", e: "👨🏽‍🚀" },
        "1F3FE": { k: "male-astronaut-1F3FE", n: "male-astronaut", e: "👨🏾‍🚀" },
        "1F3FF": { k: "male-astronaut-1F3FF", n: "male-astronaut", e: "👨🏿‍🚀" },
      },
    },
    { n: ["abcd"], e: "🔡", c: 7 },
    { n: ["clock330"], e: "🕞", c: 3 },
    { n: ["flag-lu"], e: "🇱🇺", c: 4 },
    { n: ["wrench"], e: "🔧", c: 5 },
    { n: ["nut_and_bolt"], e: "🔩", c: 5 },
    { n: ["1234"], e: "🔢", c: 7 },
    { n: ["clock4"], e: "🕓", c: 3 },
    {
      n: ["female-astronaut"],
      e: "👩‍🚀",
      c: 1,
      v: {
        "1F3FB": {
          k: "female-astronaut-1F3FB",
          n: "female-astronaut",
          e: "👩🏻‍🚀",
        },
        "1F3FC": {
          k: "female-astronaut-1F3FC",
          n: "female-astronaut",
          e: "👩🏼‍🚀",
        },
        "1F3FD": {
          k: "female-astronaut-1F3FD",
          n: "female-astronaut",
          e: "👩🏽‍🚀",
        },
        "1F3FE": {
          k: "female-astronaut-1F3FE",
          n: "female-astronaut",
          e: "👩🏾‍🚀",
        },
        "1F3FF": {
          k: "female-astronaut-1F3FF",
          n: "female-astronaut",
          e: "👩🏿‍🚀",
        },
      },
    },
    { n: ["flag-lv"], e: "🇱🇻", c: 4 },
    { n: ["gear"], e: "⚙️", c: 5 },
    {
      n: ["male-firefighter"],
      e: "👨‍🚒",
      c: 1,
      v: {
        "1F3FB": {
          k: "male-firefighter-1F3FB",
          n: "male-firefighter",
          e: "👨🏻‍🚒",
        },
        "1F3FC": {
          k: "male-firefighter-1F3FC",
          n: "male-firefighter",
          e: "👨🏼‍🚒",
        },
        "1F3FD": {
          k: "male-firefighter-1F3FD",
          n: "male-firefighter",
          e: "👨🏽‍🚒",
        },
        "1F3FE": {
          k: "male-firefighter-1F3FE",
          n: "male-firefighter",
          e: "👨🏾‍🚒",
        },
        "1F3FF": {
          k: "male-firefighter-1F3FF",
          n: "male-firefighter",
          e: "👨🏿‍🚒",
        },
      },
    },
    { n: ["flag-ly"], e: "🇱🇾", c: 4 },
    { n: ["symbols"], e: "🔣", c: 7 },
    { n: ["clock430"], e: "🕟", c: 3 },
    { n: ["flag-ma"], e: "🇲🇦", c: 4 },
    { n: ["compression"], e: "🗜️", c: 5 },
    {
      n: ["female-firefighter"],
      e: "👩‍🚒",
      c: 1,
      v: {
        "1F3FB": {
          k: "female-firefighter-1F3FB",
          n: "female-firefighter",
          e: "👩🏻‍🚒",
        },
        "1F3FC": {
          k: "female-firefighter-1F3FC",
          n: "female-firefighter",
          e: "👩🏼‍🚒",
        },
        "1F3FD": {
          k: "female-firefighter-1F3FD",
          n: "female-firefighter",
          e: "👩🏽‍🚒",
        },
        "1F3FE": {
          k: "female-firefighter-1F3FE",
          n: "female-firefighter",
          e: "👩🏾‍🚒",
        },
        "1F3FF": {
          k: "female-firefighter-1F3FF",
          n: "female-firefighter",
          e: "👩🏿‍🚒",
        },
      },
    },
    { n: ["abc"], e: "🔤", c: 7 },
    { n: ["clock5"], e: "🕔", c: 3 },
    { n: ["clock530"], e: "🕠", c: 3 },
    { n: ["a"], e: "🅰️", c: 7 },
    { n: ["alembic"], e: "⚗️", c: 5 },
    { n: ["flag-mc"], e: "🇲🇨", c: 4 },
    {
      n: ["cop"],
      e: "👮",
      c: 1,
      v: {
        "1F3FB": { k: "cop-1F3FB", n: "cop", e: "👮🏻" },
        "1F3FC": { k: "cop-1F3FC", n: "cop", e: "👮🏼" },
        "1F3FD": { k: "cop-1F3FD", n: "cop", e: "👮🏽" },
        "1F3FE": { k: "cop-1F3FE", n: "cop", e: "👮🏾" },
        "1F3FF": { k: "cop-1F3FF", n: "cop", e: "👮🏿" },
      },
    },
    { n: ["scales"], e: "⚖️", c: 5 },
    { n: ["clock6"], e: "🕕", c: 3 },
    { n: ["flag-md"], e: "🇲🇩", c: 4 },
    { n: ["ab"], e: "🆎", c: 7 },
    {
      n: ["male-police-officer"],
      e: "👮‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "male-police-officer-1F3FB",
          n: "male-police-officer",
          e: "👮🏻‍♂️",
        },
        "1F3FC": {
          k: "male-police-officer-1F3FC",
          n: "male-police-officer",
          e: "👮🏼‍♂️",
        },
        "1F3FD": {
          k: "male-police-officer-1F3FD",
          n: "male-police-officer",
          e: "👮🏽‍♂️",
        },
        "1F3FE": {
          k: "male-police-officer-1F3FE",
          n: "male-police-officer",
          e: "👮🏾‍♂️",
        },
        "1F3FF": {
          k: "male-police-officer-1F3FF",
          n: "male-police-officer",
          e: "👮🏿‍♂️",
        },
      },
    },
    { n: ["link"], e: "🔗", c: 5 },
    { n: ["flag-me"], e: "🇲🇪", c: 4 },
    { n: ["clock630"], e: "🕡", c: 3 },
    { n: ["b"], e: "🅱️", c: 7 },
    {
      n: ["female-police-officer"],
      e: "👮‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "female-police-officer-1F3FB",
          n: "female-police-officer",
          e: "👮🏻‍♀️",
        },
        "1F3FC": {
          k: "female-police-officer-1F3FC",
          n: "female-police-officer",
          e: "👮🏼‍♀️",
        },
        "1F3FD": {
          k: "female-police-officer-1F3FD",
          n: "female-police-officer",
          e: "👮🏽‍♀️",
        },
        "1F3FE": {
          k: "female-police-officer-1F3FE",
          n: "female-police-officer",
          e: "👮🏾‍♀️",
        },
        "1F3FF": {
          k: "female-police-officer-1F3FF",
          n: "female-police-officer",
          e: "👮🏿‍♀️",
        },
      },
    },
    { n: ["clock7"], e: "🕖", c: 3 },
    { n: ["cl"], e: "🆑", c: 7 },
    {
      n: ["sleuth_or_spy"],
      e: "🕵️",
      c: 1,
      v: {
        "1F3FB": { k: "sleuth_or_spy-1F3FB", n: "sleuth_or_spy", e: "🕵🏻" },
        "1F3FC": { k: "sleuth_or_spy-1F3FC", n: "sleuth_or_spy", e: "🕵🏼" },
        "1F3FD": { k: "sleuth_or_spy-1F3FD", n: "sleuth_or_spy", e: "🕵🏽" },
        "1F3FE": { k: "sleuth_or_spy-1F3FE", n: "sleuth_or_spy", e: "🕵🏾" },
        "1F3FF": { k: "sleuth_or_spy-1F3FF", n: "sleuth_or_spy", e: "🕵🏿" },
      },
    },
    { n: ["flag-mf"], e: "🇲🇫", c: 4 },
    { n: ["chains"], e: "⛓️", c: 5 },
    { n: ["syringe"], e: "💉", c: 5 },
    {
      n: ["male-detective"],
      e: "🕵️‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "male-detective-1F3FB", n: "male-detective", e: "🕵🏻‍♂️" },
        "1F3FC": { k: "male-detective-1F3FC", n: "male-detective", e: "🕵🏼‍♂️" },
        "1F3FD": { k: "male-detective-1F3FD", n: "male-detective", e: "🕵🏽‍♂️" },
        "1F3FE": { k: "male-detective-1F3FE", n: "male-detective", e: "🕵🏾‍♂️" },
        "1F3FF": { k: "male-detective-1F3FF", n: "male-detective", e: "🕵🏿‍♂️" },
      },
    },
    { n: ["cool"], e: "🆒", c: 7 },
    { n: ["clock730"], e: "🕢", c: 3 },
    { n: ["flag-mg"], e: "🇲🇬", c: 4 },
    { n: ["free"], e: "🆓", c: 7 },
    { n: ["flag-mh"], e: "🇲🇭", c: 4 },
    { n: ["clock8"], e: "🕗", c: 3 },
    { n: ["pill"], e: "💊", c: 5 },
    {
      n: ["female-detective"],
      e: "🕵️‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "female-detective-1F3FB",
          n: "female-detective",
          e: "🕵🏻‍♀️",
        },
        "1F3FC": {
          k: "female-detective-1F3FC",
          n: "female-detective",
          e: "🕵🏼‍♀️",
        },
        "1F3FD": {
          k: "female-detective-1F3FD",
          n: "female-detective",
          e: "🕵🏽‍♀️",
        },
        "1F3FE": {
          k: "female-detective-1F3FE",
          n: "female-detective",
          e: "🕵🏾‍♀️",
        },
        "1F3FF": {
          k: "female-detective-1F3FF",
          n: "female-detective",
          e: "🕵🏿‍♀️",
        },
      },
    },
    { n: ["clock830"], e: "🕣", c: 3 },
    {
      n: ["guardsman"],
      e: "💂",
      c: 1,
      v: {
        "1F3FB": { k: "guardsman-1F3FB", n: "guardsman", e: "💂🏻" },
        "1F3FC": { k: "guardsman-1F3FC", n: "guardsman", e: "💂🏼" },
        "1F3FD": { k: "guardsman-1F3FD", n: "guardsman", e: "💂🏽" },
        "1F3FE": { k: "guardsman-1F3FE", n: "guardsman", e: "💂🏾" },
        "1F3FF": { k: "guardsman-1F3FF", n: "guardsman", e: "💂🏿" },
      },
    },
    { n: ["information_source"], e: "ℹ️", c: 7 },
    { n: ["flag-mk"], e: "🇲🇰", c: 4 },
    { n: ["smoking"], e: "🚬", c: 5 },
    { n: ["id"], e: "🆔", c: 7 },
    { n: ["clock9"], e: "🕘", c: 3 },
    { n: ["flag-ml"], e: "🇲🇱", c: 4 },
    { n: ["coffin"], e: "⚰️", c: 5 },
    {
      n: ["male-guard"],
      e: "💂‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "male-guard-1F3FB", n: "male-guard", e: "💂🏻‍♂️" },
        "1F3FC": { k: "male-guard-1F3FC", n: "male-guard", e: "💂🏼‍♂️" },
        "1F3FD": { k: "male-guard-1F3FD", n: "male-guard", e: "💂🏽‍♂️" },
        "1F3FE": { k: "male-guard-1F3FE", n: "male-guard", e: "💂🏾‍♂️" },
        "1F3FF": { k: "male-guard-1F3FF", n: "male-guard", e: "💂🏿‍♂️" },
      },
    },
    { n: ["m"], e: "Ⓜ️", c: 7 },
    { n: ["funeral_urn"], e: "⚱️", c: 5 },
    {
      n: ["female-guard"],
      e: "💂‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "female-guard-1F3FB", n: "female-guard", e: "💂🏻‍♀️" },
        "1F3FC": { k: "female-guard-1F3FC", n: "female-guard", e: "💂🏼‍♀️" },
        "1F3FD": { k: "female-guard-1F3FD", n: "female-guard", e: "💂🏽‍♀️" },
        "1F3FE": { k: "female-guard-1F3FE", n: "female-guard", e: "💂🏾‍♀️" },
        "1F3FF": { k: "female-guard-1F3FF", n: "female-guard", e: "💂🏿‍♀️" },
      },
    },
    { n: ["flag-mm"], e: "🇲🇲", c: 4 },
    { n: ["clock930"], e: "🕤", c: 3 },
    { n: ["moyai"], e: "🗿", c: 5 },
    { n: ["new"], e: "🆕", c: 7 },
    { n: ["flag-mn"], e: "🇲🇳", c: 4 },
    {
      n: ["construction_worker"],
      e: "👷",
      c: 1,
      v: {
        "1F3FB": {
          k: "construction_worker-1F3FB",
          n: "construction_worker",
          e: "👷🏻",
        },
        "1F3FC": {
          k: "construction_worker-1F3FC",
          n: "construction_worker",
          e: "👷🏼",
        },
        "1F3FD": {
          k: "construction_worker-1F3FD",
          n: "construction_worker",
          e: "👷🏽",
        },
        "1F3FE": {
          k: "construction_worker-1F3FE",
          n: "construction_worker",
          e: "👷🏾",
        },
        "1F3FF": {
          k: "construction_worker-1F3FF",
          n: "construction_worker",
          e: "👷🏿",
        },
      },
    },
    { n: ["clock10"], e: "🕙", c: 3 },
    { n: ["clock1030"], e: "🕥", c: 3 },
    { n: ["ng"], e: "🆖", c: 7 },
    {
      n: ["male-construction-worker"],
      e: "👷‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "male-construction-worker-1F3FB",
          n: "male-construction-worker",
          e: "👷🏻‍♂️",
        },
        "1F3FC": {
          k: "male-construction-worker-1F3FC",
          n: "male-construction-worker",
          e: "👷🏼‍♂️",
        },
        "1F3FD": {
          k: "male-construction-worker-1F3FD",
          n: "male-construction-worker",
          e: "👷🏽‍♂️",
        },
        "1F3FE": {
          k: "male-construction-worker-1F3FE",
          n: "male-construction-worker",
          e: "👷🏾‍♂️",
        },
        "1F3FF": {
          k: "male-construction-worker-1F3FF",
          n: "male-construction-worker",
          e: "👷🏿‍♂️",
        },
      },
    },
    { n: ["flag-mo"], e: "🇲🇴", c: 4 },
    { n: ["oil_drum"], e: "🛢️", c: 5 },
    { n: ["o2"], e: "🅾️", c: 7 },
    {
      n: ["female-construction-worker"],
      e: "👷‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "female-construction-worker-1F3FB",
          n: "female-construction-worker",
          e: "👷🏻‍♀️",
        },
        "1F3FC": {
          k: "female-construction-worker-1F3FC",
          n: "female-construction-worker",
          e: "👷🏼‍♀️",
        },
        "1F3FD": {
          k: "female-construction-worker-1F3FD",
          n: "female-construction-worker",
          e: "👷🏽‍♀️",
        },
        "1F3FE": {
          k: "female-construction-worker-1F3FE",
          n: "female-construction-worker",
          e: "👷🏾‍♀️",
        },
        "1F3FF": {
          k: "female-construction-worker-1F3FF",
          n: "female-construction-worker",
          e: "👷🏿‍♀️",
        },
      },
    },
    { n: ["clock11"], e: "🕚", c: 3 },
    { n: ["crystal_ball"], e: "🔮", c: 5 },
    { n: ["flag-mp"], e: "🇲🇵", c: 4 },
    { n: ["flag-mq"], e: "🇲🇶", c: 4 },
    {
      n: ["prince"],
      e: "🤴",
      c: 1,
      v: {
        "1F3FB": { k: "prince-1F3FB", n: "prince", e: "🤴🏻" },
        "1F3FC": { k: "prince-1F3FC", n: "prince", e: "🤴🏼" },
        "1F3FD": { k: "prince-1F3FD", n: "prince", e: "🤴🏽" },
        "1F3FE": { k: "prince-1F3FE", n: "prince", e: "🤴🏾" },
        "1F3FF": { k: "prince-1F3FF", n: "prince", e: "🤴🏿" },
      },
    },
    { n: ["ok"], e: "🆗", c: 7 },
    { n: ["clock1130"], e: "🕦", c: 3 },
    { n: ["shopping_trolley"], e: "🛒", c: 5 },
    { n: ["flag-mr"], e: "🇲🇷", c: 4 },
    {
      n: ["princess"],
      e: "👸",
      c: 1,
      v: {
        "1F3FB": { k: "princess-1F3FB", n: "princess", e: "👸🏻" },
        "1F3FC": { k: "princess-1F3FC", n: "princess", e: "👸🏼" },
        "1F3FD": { k: "princess-1F3FD", n: "princess", e: "👸🏽" },
        "1F3FE": { k: "princess-1F3FE", n: "princess", e: "👸🏾" },
        "1F3FF": { k: "princess-1F3FF", n: "princess", e: "👸🏿" },
      },
    },
    { n: ["new_moon"], e: "🌑", c: 3 },
    { n: ["parking"], e: "🅿️", c: 7 },
    { n: ["sos"], e: "🆘", c: 7 },
    {
      n: ["man_with_turban"],
      e: "👳",
      c: 1,
      v: {
        "1F3FB": { k: "man_with_turban-1F3FB", n: "man_with_turban", e: "👳🏻" },
        "1F3FC": { k: "man_with_turban-1F3FC", n: "man_with_turban", e: "👳🏼" },
        "1F3FD": { k: "man_with_turban-1F3FD", n: "man_with_turban", e: "👳🏽" },
        "1F3FE": { k: "man_with_turban-1F3FE", n: "man_with_turban", e: "👳🏾" },
        "1F3FF": { k: "man_with_turban-1F3FF", n: "man_with_turban", e: "👳🏿" },
      },
    },
    { n: ["flag-ms"], e: "🇲🇸", c: 4 },
    { n: ["waxing_crescent_moon"], e: "🌒", c: 3 },
    { n: ["up"], e: "🆙", c: 7 },
    { n: ["first_quarter_moon"], e: "🌓", c: 3 },
    { n: ["flag-mt"], e: "🇲🇹", c: 4 },
    {
      n: ["man-wearing-turban"],
      e: "👳‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-wearing-turban-1F3FB",
          n: "man-wearing-turban",
          e: "👳🏻‍♂️",
        },
        "1F3FC": {
          k: "man-wearing-turban-1F3FC",
          n: "man-wearing-turban",
          e: "👳🏼‍♂️",
        },
        "1F3FD": {
          k: "man-wearing-turban-1F3FD",
          n: "man-wearing-turban",
          e: "👳🏽‍♂️",
        },
        "1F3FE": {
          k: "man-wearing-turban-1F3FE",
          n: "man-wearing-turban",
          e: "👳🏾‍♂️",
        },
        "1F3FF": {
          k: "man-wearing-turban-1F3FF",
          n: "man-wearing-turban",
          e: "👳🏿‍♂️",
        },
      },
    },
    { n: ["moon", "waxing_gibbous_moon"], e: "🌔", c: 3 },
    {
      n: ["woman-wearing-turban"],
      e: "👳‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-wearing-turban-1F3FB",
          n: "woman-wearing-turban",
          e: "👳🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-wearing-turban-1F3FC",
          n: "woman-wearing-turban",
          e: "👳🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-wearing-turban-1F3FD",
          n: "woman-wearing-turban",
          e: "👳🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-wearing-turban-1F3FE",
          n: "woman-wearing-turban",
          e: "👳🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-wearing-turban-1F3FF",
          n: "woman-wearing-turban",
          e: "👳🏿‍♀️",
        },
      },
    },
    { n: ["vs"], e: "🆚", c: 7 },
    { n: ["flag-mu"], e: "🇲🇺", c: 4 },
    {
      n: ["man_with_gua_pi_mao"],
      e: "👲",
      c: 1,
      v: {
        "1F3FB": {
          k: "man_with_gua_pi_mao-1F3FB",
          n: "man_with_gua_pi_mao",
          e: "👲🏻",
        },
        "1F3FC": {
          k: "man_with_gua_pi_mao-1F3FC",
          n: "man_with_gua_pi_mao",
          e: "👲🏼",
        },
        "1F3FD": {
          k: "man_with_gua_pi_mao-1F3FD",
          n: "man_with_gua_pi_mao",
          e: "👲🏽",
        },
        "1F3FE": {
          k: "man_with_gua_pi_mao-1F3FE",
          n: "man_with_gua_pi_mao",
          e: "👲🏾",
        },
        "1F3FF": {
          k: "man_with_gua_pi_mao-1F3FF",
          n: "man_with_gua_pi_mao",
          e: "👲🏿",
        },
      },
    },
    { n: ["koko"], e: "🈁", c: 7 },
    { n: ["full_moon"], e: "🌕", c: 3 },
    { n: ["flag-mv"], e: "🇲🇻", c: 4 },
    {
      n: ["person_with_headscarf"],
      e: "🧕",
      c: 1,
      v: {
        "1F3FB": {
          k: "person_with_headscarf-1F3FB",
          n: "person_with_headscarf",
          e: "🧕🏻",
        },
        "1F3FC": {
          k: "person_with_headscarf-1F3FC",
          n: "person_with_headscarf",
          e: "🧕🏼",
        },
        "1F3FD": {
          k: "person_with_headscarf-1F3FD",
          n: "person_with_headscarf",
          e: "🧕🏽",
        },
        "1F3FE": {
          k: "person_with_headscarf-1F3FE",
          n: "person_with_headscarf",
          e: "🧕🏾",
        },
        "1F3FF": {
          k: "person_with_headscarf-1F3FF",
          n: "person_with_headscarf",
          e: "🧕🏿",
        },
      },
    },
    { n: ["waning_gibbous_moon"], e: "🌖", c: 3 },
    { n: ["sa"], e: "🈂️", c: 7 },
    { n: ["flag-mw"], e: "🇲🇼", c: 4 },
    { n: ["last_quarter_moon"], e: "🌗", c: 3 },
    { n: ["u6708"], e: "🈷️", c: 7 },
    {
      n: ["bearded_person"],
      e: "🧔",
      c: 1,
      v: {
        "1F3FB": { k: "bearded_person-1F3FB", n: "bearded_person", e: "🧔🏻" },
        "1F3FC": { k: "bearded_person-1F3FC", n: "bearded_person", e: "🧔🏼" },
        "1F3FD": { k: "bearded_person-1F3FD", n: "bearded_person", e: "🧔🏽" },
        "1F3FE": { k: "bearded_person-1F3FE", n: "bearded_person", e: "🧔🏾" },
        "1F3FF": { k: "bearded_person-1F3FF", n: "bearded_person", e: "🧔🏿" },
      },
    },
    { n: ["flag-mx"], e: "🇲🇽", c: 4 },
    { n: ["u6709"], e: "🈶", c: 7 },
    {
      n: ["person_with_blond_hair"],
      e: "👱",
      c: 1,
      v: {
        "1F3FB": {
          k: "person_with_blond_hair-1F3FB",
          n: "person_with_blond_hair",
          e: "👱🏻",
        },
        "1F3FC": {
          k: "person_with_blond_hair-1F3FC",
          n: "person_with_blond_hair",
          e: "👱🏼",
        },
        "1F3FD": {
          k: "person_with_blond_hair-1F3FD",
          n: "person_with_blond_hair",
          e: "👱🏽",
        },
        "1F3FE": {
          k: "person_with_blond_hair-1F3FE",
          n: "person_with_blond_hair",
          e: "👱🏾",
        },
        "1F3FF": {
          k: "person_with_blond_hair-1F3FF",
          n: "person_with_blond_hair",
          e: "👱🏿",
        },
      },
    },
    { n: ["waning_crescent_moon"], e: "🌘", c: 3 },
    { n: ["flag-my"], e: "🇲🇾", c: 4 },
    { n: ["u6307"], e: "🈯", c: 7 },
    {
      n: ["blond-haired-man"],
      e: "👱‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "blond-haired-man-1F3FB",
          n: "blond-haired-man",
          e: "👱🏻‍♂️",
        },
        "1F3FC": {
          k: "blond-haired-man-1F3FC",
          n: "blond-haired-man",
          e: "👱🏼‍♂️",
        },
        "1F3FD": {
          k: "blond-haired-man-1F3FD",
          n: "blond-haired-man",
          e: "👱🏽‍♂️",
        },
        "1F3FE": {
          k: "blond-haired-man-1F3FE",
          n: "blond-haired-man",
          e: "👱🏾‍♂️",
        },
        "1F3FF": {
          k: "blond-haired-man-1F3FF",
          n: "blond-haired-man",
          e: "👱🏿‍♂️",
        },
      },
    },
    { n: ["crescent_moon"], e: "🌙", c: 3 },
    { n: ["flag-mz"], e: "🇲🇿", c: 4 },
    { n: ["new_moon_with_face"], e: "🌚", c: 3 },
    { n: ["flag-na"], e: "🇳🇦", c: 4 },
    {
      n: ["blond-haired-woman"],
      e: "👱‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "blond-haired-woman-1F3FB",
          n: "blond-haired-woman",
          e: "👱🏻‍♀️",
        },
        "1F3FC": {
          k: "blond-haired-woman-1F3FC",
          n: "blond-haired-woman",
          e: "👱🏼‍♀️",
        },
        "1F3FD": {
          k: "blond-haired-woman-1F3FD",
          n: "blond-haired-woman",
          e: "👱🏽‍♀️",
        },
        "1F3FE": {
          k: "blond-haired-woman-1F3FE",
          n: "blond-haired-woman",
          e: "👱🏾‍♀️",
        },
        "1F3FF": {
          k: "blond-haired-woman-1F3FF",
          n: "blond-haired-woman",
          e: "👱🏿‍♀️",
        },
      },
    },
    { n: ["ideograph_advantage"], e: "🉐", c: 7 },
    { n: ["first_quarter_moon_with_face"], e: "🌛", c: 3 },
    {
      n: ["man_in_tuxedo"],
      e: "🤵",
      c: 1,
      v: {
        "1F3FB": { k: "man_in_tuxedo-1F3FB", n: "man_in_tuxedo", e: "🤵🏻" },
        "1F3FC": { k: "man_in_tuxedo-1F3FC", n: "man_in_tuxedo", e: "🤵🏼" },
        "1F3FD": { k: "man_in_tuxedo-1F3FD", n: "man_in_tuxedo", e: "🤵🏽" },
        "1F3FE": { k: "man_in_tuxedo-1F3FE", n: "man_in_tuxedo", e: "🤵🏾" },
        "1F3FF": { k: "man_in_tuxedo-1F3FF", n: "man_in_tuxedo", e: "🤵🏿" },
      },
    },
    { n: ["flag-nc"], e: "🇳🇨", c: 4 },
    { n: ["u5272"], e: "🈹", c: 7 },
    { n: ["flag-ne"], e: "🇳🇪", c: 4 },
    { n: ["last_quarter_moon_with_face"], e: "🌜", c: 3 },
    { n: ["u7121"], e: "🈚", c: 7 },
    {
      n: ["bride_with_veil"],
      e: "👰",
      c: 1,
      v: {
        "1F3FB": { k: "bride_with_veil-1F3FB", n: "bride_with_veil", e: "👰🏻" },
        "1F3FC": { k: "bride_with_veil-1F3FC", n: "bride_with_veil", e: "👰🏼" },
        "1F3FD": { k: "bride_with_veil-1F3FD", n: "bride_with_veil", e: "👰🏽" },
        "1F3FE": { k: "bride_with_veil-1F3FE", n: "bride_with_veil", e: "👰🏾" },
        "1F3FF": { k: "bride_with_veil-1F3FF", n: "bride_with_veil", e: "👰🏿" },
      },
    },
    { n: ["u7981"], e: "🈲", c: 7 },
    {
      n: ["pregnant_woman"],
      e: "🤰",
      c: 1,
      v: {
        "1F3FB": { k: "pregnant_woman-1F3FB", n: "pregnant_woman", e: "🤰🏻" },
        "1F3FC": { k: "pregnant_woman-1F3FC", n: "pregnant_woman", e: "🤰🏼" },
        "1F3FD": { k: "pregnant_woman-1F3FD", n: "pregnant_woman", e: "🤰🏽" },
        "1F3FE": { k: "pregnant_woman-1F3FE", n: "pregnant_woman", e: "🤰🏾" },
        "1F3FF": { k: "pregnant_woman-1F3FF", n: "pregnant_woman", e: "🤰🏿" },
      },
    },
    { n: ["thermometer"], e: "🌡️", c: 3 },
    { n: ["flag-nf"], e: "🇳🇫", c: 4 },
    { n: ["sunny"], e: "☀️", c: 3 },
    { n: ["accept"], e: "🉑", c: 7 },
    { n: ["flag-ng"], e: "🇳🇬", c: 4 },
    {
      n: ["breast-feeding"],
      e: "🤱",
      c: 1,
      v: {
        "1F3FB": { k: "breast-feeding-1F3FB", n: "breast-feeding", e: "🤱🏻" },
        "1F3FC": { k: "breast-feeding-1F3FC", n: "breast-feeding", e: "🤱🏼" },
        "1F3FD": { k: "breast-feeding-1F3FD", n: "breast-feeding", e: "🤱🏽" },
        "1F3FE": { k: "breast-feeding-1F3FE", n: "breast-feeding", e: "🤱🏾" },
        "1F3FF": { k: "breast-feeding-1F3FF", n: "breast-feeding", e: "🤱🏿" },
      },
    },
    { n: ["full_moon_with_face"], e: "🌝", c: 3 },
    { n: ["flag-ni"], e: "🇳🇮", c: 4 },
    { n: ["u7533"], e: "🈸", c: 7 },
    {
      n: ["angel"],
      e: "👼",
      c: 1,
      v: {
        "1F3FB": { k: "angel-1F3FB", n: "angel", e: "👼🏻" },
        "1F3FC": { k: "angel-1F3FC", n: "angel", e: "👼🏼" },
        "1F3FD": { k: "angel-1F3FD", n: "angel", e: "👼🏽" },
        "1F3FE": { k: "angel-1F3FE", n: "angel", e: "👼🏾" },
        "1F3FF": { k: "angel-1F3FF", n: "angel", e: "👼🏿" },
      },
    },
    { n: ["sun_with_face"], e: "🌞", c: 3 },
    {
      n: ["santa"],
      e: "🎅",
      c: 1,
      v: {
        "1F3FB": { k: "santa-1F3FB", n: "santa", e: "🎅🏻" },
        "1F3FC": { k: "santa-1F3FC", n: "santa", e: "🎅🏼" },
        "1F3FD": { k: "santa-1F3FD", n: "santa", e: "🎅🏽" },
        "1F3FE": { k: "santa-1F3FE", n: "santa", e: "🎅🏾" },
        "1F3FF": { k: "santa-1F3FF", n: "santa", e: "🎅🏿" },
      },
    },
    { n: ["u5408"], e: "🈴", c: 7 },
    { n: ["flag-nl"], e: "🇳🇱", c: 4 },
    {
      n: ["mrs_claus", "mother_christmas"],
      e: "🤶",
      c: 1,
      v: {
        "1F3FB": { k: "mrs_claus-1F3FB", n: "mrs_claus", e: "🤶🏻" },
        "1F3FC": { k: "mrs_claus-1F3FC", n: "mrs_claus", e: "🤶🏼" },
        "1F3FD": { k: "mrs_claus-1F3FD", n: "mrs_claus", e: "🤶🏽" },
        "1F3FE": { k: "mrs_claus-1F3FE", n: "mrs_claus", e: "🤶🏾" },
        "1F3FF": { k: "mrs_claus-1F3FF", n: "mrs_claus", e: "🤶🏿" },
      },
    },
    { n: ["u7a7a"], e: "🈳", c: 7 },
    { n: ["star"], e: "⭐", c: 3 },
    { n: ["flag-no"], e: "🇳🇴", c: 4 },
    {
      n: ["mage"],
      e: "🧙",
      c: 1,
      v: {
        "1F3FB": { k: "mage-1F3FB", n: "mage", e: "🧙🏻" },
        "1F3FC": { k: "mage-1F3FC", n: "mage", e: "🧙🏼" },
        "1F3FD": { k: "mage-1F3FD", n: "mage", e: "🧙🏽" },
        "1F3FE": { k: "mage-1F3FE", n: "mage", e: "🧙🏾" },
        "1F3FF": { k: "mage-1F3FF", n: "mage", e: "🧙🏿" },
      },
    },
    { n: ["star2"], e: "🌟", c: 3 },
    { n: ["flag-np"], e: "🇳🇵", c: 4 },
    { n: ["congratulations"], e: "㊗️", c: 7 },
    { n: ["flag-nr"], e: "🇳🇷", c: 4 },
    { n: ["stars"], e: "🌠", c: 3 },
    {
      n: ["female_mage"],
      e: "🧙‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "female_mage-1F3FB", n: "female_mage", e: "🧙🏻‍♀️" },
        "1F3FC": { k: "female_mage-1F3FC", n: "female_mage", e: "🧙🏼‍♀️" },
        "1F3FD": { k: "female_mage-1F3FD", n: "female_mage", e: "🧙🏽‍♀️" },
        "1F3FE": { k: "female_mage-1F3FE", n: "female_mage", e: "🧙🏾‍♀️" },
        "1F3FF": { k: "female_mage-1F3FF", n: "female_mage", e: "🧙🏿‍♀️" },
      },
    },
    { n: ["secret"], e: "㊙️", c: 7 },
    { n: ["flag-nu"], e: "🇳🇺", c: 4 },
    { n: ["u55b6"], e: "🈺", c: 7 },
    {
      n: ["male_mage"],
      e: "🧙‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "male_mage-1F3FB", n: "male_mage", e: "🧙🏻‍♂️" },
        "1F3FC": { k: "male_mage-1F3FC", n: "male_mage", e: "🧙🏼‍♂️" },
        "1F3FD": { k: "male_mage-1F3FD", n: "male_mage", e: "🧙🏽‍♂️" },
        "1F3FE": { k: "male_mage-1F3FE", n: "male_mage", e: "🧙🏾‍♂️" },
        "1F3FF": { k: "male_mage-1F3FF", n: "male_mage", e: "🧙🏿‍♂️" },
      },
    },
    { n: ["cloud"], e: "☁️", c: 3 },
    { n: ["flag-nz"], e: "🇳🇿", c: 4 },
    { n: ["partly_sunny"], e: "⛅", c: 3 },
    {
      n: ["fairy"],
      e: "🧚",
      c: 1,
      v: {
        "1F3FB": { k: "fairy-1F3FB", n: "fairy", e: "🧚🏻" },
        "1F3FC": { k: "fairy-1F3FC", n: "fairy", e: "🧚🏼" },
        "1F3FD": { k: "fairy-1F3FD", n: "fairy", e: "🧚🏽" },
        "1F3FE": { k: "fairy-1F3FE", n: "fairy", e: "🧚🏾" },
        "1F3FF": { k: "fairy-1F3FF", n: "fairy", e: "🧚🏿" },
      },
    },
    { n: ["u6e80"], e: "🈵", c: 7 },
    { n: ["black_small_square"], e: "▪️", c: 7 },
    { n: ["thunder_cloud_and_rain"], e: "⛈️", c: 3 },
    {
      n: ["female_fairy"],
      e: "🧚‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "female_fairy-1F3FB", n: "female_fairy", e: "🧚🏻‍♀️" },
        "1F3FC": { k: "female_fairy-1F3FC", n: "female_fairy", e: "🧚🏼‍♀️" },
        "1F3FD": { k: "female_fairy-1F3FD", n: "female_fairy", e: "🧚🏽‍♀️" },
        "1F3FE": { k: "female_fairy-1F3FE", n: "female_fairy", e: "🧚🏾‍♀️" },
        "1F3FF": { k: "female_fairy-1F3FF", n: "female_fairy", e: "🧚🏿‍♀️" },
      },
    },
    { n: ["flag-om"], e: "🇴🇲", c: 4 },
    { n: ["white_small_square"], e: "▫️", c: 7 },
    { n: ["flag-pa"], e: "🇵🇦", c: 4 },
    { n: ["mostly_sunny", "sun_small_cloud"], e: "🌤️", c: 3 },
    {
      n: ["male_fairy"],
      e: "🧚‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "male_fairy-1F3FB", n: "male_fairy", e: "🧚🏻‍♂️" },
        "1F3FC": { k: "male_fairy-1F3FC", n: "male_fairy", e: "🧚🏼‍♂️" },
        "1F3FD": { k: "male_fairy-1F3FD", n: "male_fairy", e: "🧚🏽‍♂️" },
        "1F3FE": { k: "male_fairy-1F3FE", n: "male_fairy", e: "🧚🏾‍♂️" },
        "1F3FF": { k: "male_fairy-1F3FF", n: "male_fairy", e: "🧚🏿‍♂️" },
      },
    },
    { n: ["barely_sunny", "sun_behind_cloud"], e: "🌥️", c: 3 },
    { n: ["white_medium_square"], e: "◻️", c: 7 },
    { n: ["flag-pe"], e: "🇵🇪", c: 4 },
    {
      n: ["vampire"],
      e: "🧛",
      c: 1,
      v: {
        "1F3FB": { k: "vampire-1F3FB", n: "vampire", e: "🧛🏻" },
        "1F3FC": { k: "vampire-1F3FC", n: "vampire", e: "🧛🏼" },
        "1F3FD": { k: "vampire-1F3FD", n: "vampire", e: "🧛🏽" },
        "1F3FE": { k: "vampire-1F3FE", n: "vampire", e: "🧛🏾" },
        "1F3FF": { k: "vampire-1F3FF", n: "vampire", e: "🧛🏿" },
      },
    },
    {
      n: ["female_vampire"],
      e: "🧛‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "female_vampire-1F3FB", n: "female_vampire", e: "🧛🏻‍♀️" },
        "1F3FC": { k: "female_vampire-1F3FC", n: "female_vampire", e: "🧛🏼‍♀️" },
        "1F3FD": { k: "female_vampire-1F3FD", n: "female_vampire", e: "🧛🏽‍♀️" },
        "1F3FE": { k: "female_vampire-1F3FE", n: "female_vampire", e: "🧛🏾‍♀️" },
        "1F3FF": { k: "female_vampire-1F3FF", n: "female_vampire", e: "🧛🏿‍♀️" },
      },
    },
    { n: ["partly_sunny_rain", "sun_behind_rain_cloud"], e: "🌦️", c: 3 },
    { n: ["flag-pf"], e: "🇵🇫", c: 4 },
    { n: ["black_medium_square"], e: "◼️", c: 7 },
    { n: ["white_medium_small_square"], e: "◽", c: 7 },
    { n: ["rain_cloud"], e: "🌧️", c: 3 },
    { n: ["flag-pg"], e: "🇵🇬", c: 4 },
    {
      n: ["male_vampire"],
      e: "🧛‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "male_vampire-1F3FB", n: "male_vampire", e: "🧛🏻‍♂️" },
        "1F3FC": { k: "male_vampire-1F3FC", n: "male_vampire", e: "🧛🏼‍♂️" },
        "1F3FD": { k: "male_vampire-1F3FD", n: "male_vampire", e: "🧛🏽‍♂️" },
        "1F3FE": { k: "male_vampire-1F3FE", n: "male_vampire", e: "🧛🏾‍♂️" },
        "1F3FF": { k: "male_vampire-1F3FF", n: "male_vampire", e: "🧛🏿‍♂️" },
      },
    },
    { n: ["flag-ph"], e: "🇵🇭", c: 4 },
    {
      n: ["merperson"],
      e: "🧜",
      c: 1,
      v: {
        "1F3FB": { k: "merperson-1F3FB", n: "merperson", e: "🧜🏻" },
        "1F3FC": { k: "merperson-1F3FC", n: "merperson", e: "🧜🏼" },
        "1F3FD": { k: "merperson-1F3FD", n: "merperson", e: "🧜🏽" },
        "1F3FE": { k: "merperson-1F3FE", n: "merperson", e: "🧜🏾" },
        "1F3FF": { k: "merperson-1F3FF", n: "merperson", e: "🧜🏿" },
      },
    },
    { n: ["black_medium_small_square"], e: "◾", c: 7 },
    { n: ["snow_cloud"], e: "🌨️", c: 3 },
    { n: ["lightning", "lightning_cloud"], e: "🌩️", c: 3 },
    { n: ["black_large_square"], e: "⬛", c: 7 },
    {
      n: ["mermaid"],
      e: "🧜‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "mermaid-1F3FB", n: "mermaid", e: "🧜🏻‍♀️" },
        "1F3FC": { k: "mermaid-1F3FC", n: "mermaid", e: "🧜🏼‍♀️" },
        "1F3FD": { k: "mermaid-1F3FD", n: "mermaid", e: "🧜🏽‍♀️" },
        "1F3FE": { k: "mermaid-1F3FE", n: "mermaid", e: "🧜🏾‍♀️" },
        "1F3FF": { k: "mermaid-1F3FF", n: "mermaid", e: "🧜🏿‍♀️" },
      },
    },
    { n: ["flag-pk"], e: "🇵🇰", c: 4 },
    {
      n: ["merman"],
      e: "🧜‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "merman-1F3FB", n: "merman", e: "🧜🏻‍♂️" },
        "1F3FC": { k: "merman-1F3FC", n: "merman", e: "🧜🏼‍♂️" },
        "1F3FD": { k: "merman-1F3FD", n: "merman", e: "🧜🏽‍♂️" },
        "1F3FE": { k: "merman-1F3FE", n: "merman", e: "🧜🏾‍♂️" },
        "1F3FF": { k: "merman-1F3FF", n: "merman", e: "🧜🏿‍♂️" },
      },
    },
    { n: ["white_large_square"], e: "⬜", c: 7 },
    { n: ["tornado", "tornado_cloud"], e: "🌪️", c: 3 },
    { n: ["flag-pl"], e: "🇵🇱", c: 4 },
    {
      n: ["elf"],
      e: "🧝",
      c: 1,
      v: {
        "1F3FB": { k: "elf-1F3FB", n: "elf", e: "🧝🏻" },
        "1F3FC": { k: "elf-1F3FC", n: "elf", e: "🧝🏼" },
        "1F3FD": { k: "elf-1F3FD", n: "elf", e: "🧝🏽" },
        "1F3FE": { k: "elf-1F3FE", n: "elf", e: "🧝🏾" },
        "1F3FF": { k: "elf-1F3FF", n: "elf", e: "🧝🏿" },
      },
    },
    { n: ["fog"], e: "🌫️", c: 3 },
    { n: ["large_orange_diamond"], e: "🔶", c: 7 },
    { n: ["flag-pm"], e: "🇵🇲", c: 4 },
    { n: ["flag-pn"], e: "🇵🇳", c: 4 },
    { n: ["wind_blowing_face"], e: "🌬️", c: 3 },
    {
      n: ["female_elf"],
      e: "🧝‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "female_elf-1F3FB", n: "female_elf", e: "🧝🏻‍♀️" },
        "1F3FC": { k: "female_elf-1F3FC", n: "female_elf", e: "🧝🏼‍♀️" },
        "1F3FD": { k: "female_elf-1F3FD", n: "female_elf", e: "🧝🏽‍♀️" },
        "1F3FE": { k: "female_elf-1F3FE", n: "female_elf", e: "🧝🏾‍♀️" },
        "1F3FF": { k: "female_elf-1F3FF", n: "female_elf", e: "🧝🏿‍♀️" },
      },
    },
    { n: ["large_blue_diamond"], e: "🔷", c: 7 },
    {
      n: ["male_elf"],
      e: "🧝‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "male_elf-1F3FB", n: "male_elf", e: "🧝🏻‍♂️" },
        "1F3FC": { k: "male_elf-1F3FC", n: "male_elf", e: "🧝🏼‍♂️" },
        "1F3FD": { k: "male_elf-1F3FD", n: "male_elf", e: "🧝🏽‍♂️" },
        "1F3FE": { k: "male_elf-1F3FE", n: "male_elf", e: "🧝🏾‍♂️" },
        "1F3FF": { k: "male_elf-1F3FF", n: "male_elf", e: "🧝🏿‍♂️" },
      },
    },
    { n: ["small_orange_diamond"], e: "🔸", c: 7 },
    { n: ["flag-pr"], e: "🇵🇷", c: 4 },
    { n: ["cyclone"], e: "🌀", c: 3 },
    { n: ["rainbow"], e: "🌈", c: 3 },
    { n: ["small_blue_diamond"], e: "🔹", c: 7 },
    { n: ["genie"], e: "🧞", c: 1 },
    { n: ["flag-ps"], e: "🇵🇸", c: 4 },
    { n: ["small_red_triangle"], e: "🔺", c: 7 },
    { n: ["closed_umbrella"], e: "🌂", c: 3 },
    { n: ["female_genie"], e: "🧞‍♀️", c: 1 },
    { n: ["flag-pt"], e: "🇵🇹", c: 4 },
    { n: ["flag-pw"], e: "🇵🇼", c: 4 },
    { n: ["small_red_triangle_down"], e: "🔻", c: 7 },
    { n: ["umbrella"], e: "☂️", c: 3 },
    { n: ["male_genie"], e: "🧞‍♂️", c: 1 },
    { n: ["zombie"], e: "🧟", c: 1 },
    { n: ["flag-py"], e: "🇵🇾", c: 4 },
    { n: ["diamond_shape_with_a_dot_inside"], e: "💠", c: 7 },
    { n: ["umbrella_with_rain_drops"], e: "☔", c: 3 },
    { n: ["radio_button"], e: "🔘", c: 7 },
    { n: ["female_zombie"], e: "🧟‍♀️", c: 1 },
    { n: ["flag-qa"], e: "🇶🇦", c: 4 },
    { n: ["umbrella_on_ground"], e: "⛱️", c: 3 },
    { n: ["black_square_button"], e: "🔲", c: 7 },
    { n: ["zap"], e: "⚡", c: 3 },
    { n: ["male_zombie"], e: "🧟‍♂️", c: 1 },
    { n: ["flag-re"], e: "🇷🇪", c: 4 },
    { n: ["flag-ro"], e: "🇷🇴", c: 4 },
    { n: ["snowflake"], e: "❄️", c: 3 },
    { n: ["white_square_button"], e: "🔳", c: 7 },
    {
      n: ["person_frowning"],
      e: "🙍",
      c: 1,
      v: {
        "1F3FB": { k: "person_frowning-1F3FB", n: "person_frowning", e: "🙍🏻" },
        "1F3FC": { k: "person_frowning-1F3FC", n: "person_frowning", e: "🙍🏼" },
        "1F3FD": { k: "person_frowning-1F3FD", n: "person_frowning", e: "🙍🏽" },
        "1F3FE": { k: "person_frowning-1F3FE", n: "person_frowning", e: "🙍🏾" },
        "1F3FF": { k: "person_frowning-1F3FF", n: "person_frowning", e: "🙍🏿" },
      },
    },
    { n: ["flag-rs"], e: "🇷🇸", c: 4 },
    {
      n: ["man-frowning"],
      e: "🙍‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-frowning-1F3FB", n: "man-frowning", e: "🙍🏻‍♂️" },
        "1F3FC": { k: "man-frowning-1F3FC", n: "man-frowning", e: "🙍🏼‍♂️" },
        "1F3FD": { k: "man-frowning-1F3FD", n: "man-frowning", e: "🙍🏽‍♂️" },
        "1F3FE": { k: "man-frowning-1F3FE", n: "man-frowning", e: "🙍🏾‍♂️" },
        "1F3FF": { k: "man-frowning-1F3FF", n: "man-frowning", e: "🙍🏿‍♂️" },
      },
    },
    { n: ["white_circle"], e: "⚪", c: 7 },
    { n: ["snowman"], e: "☃️", c: 3 },
    { n: ["snowman_without_snow"], e: "⛄", c: 3 },
    { n: ["ru", "flag-ru"], e: "🇷🇺", c: 4 },
    { n: ["black_circle"], e: "⚫", c: 7 },
    {
      n: ["woman-frowning"],
      e: "🙍‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-frowning-1F3FB", n: "woman-frowning", e: "🙍🏻‍♀️" },
        "1F3FC": { k: "woman-frowning-1F3FC", n: "woman-frowning", e: "🙍🏼‍♀️" },
        "1F3FD": { k: "woman-frowning-1F3FD", n: "woman-frowning", e: "🙍🏽‍♀️" },
        "1F3FE": { k: "woman-frowning-1F3FE", n: "woman-frowning", e: "🙍🏾‍♀️" },
        "1F3FF": { k: "woman-frowning-1F3FF", n: "woman-frowning", e: "🙍🏿‍♀️" },
      },
    },
    { n: ["flag-rw"], e: "🇷🇼", c: 4 },
    { n: ["comet"], e: "☄️", c: 3 },
    {
      n: ["person_with_pouting_face"],
      e: "🙎",
      c: 1,
      v: {
        "1F3FB": {
          k: "person_with_pouting_face-1F3FB",
          n: "person_with_pouting_face",
          e: "🙎🏻",
        },
        "1F3FC": {
          k: "person_with_pouting_face-1F3FC",
          n: "person_with_pouting_face",
          e: "🙎🏼",
        },
        "1F3FD": {
          k: "person_with_pouting_face-1F3FD",
          n: "person_with_pouting_face",
          e: "🙎🏽",
        },
        "1F3FE": {
          k: "person_with_pouting_face-1F3FE",
          n: "person_with_pouting_face",
          e: "🙎🏾",
        },
        "1F3FF": {
          k: "person_with_pouting_face-1F3FF",
          n: "person_with_pouting_face",
          e: "🙎🏿",
        },
      },
    },
    { n: ["red_circle"], e: "🔴", c: 7 },
    { n: ["large_blue_circle"], e: "🔵", c: 7 },
    {
      n: ["man-pouting"],
      e: "🙎‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-pouting-1F3FB", n: "man-pouting", e: "🙎🏻‍♂️" },
        "1F3FC": { k: "man-pouting-1F3FC", n: "man-pouting", e: "🙎🏼‍♂️" },
        "1F3FD": { k: "man-pouting-1F3FD", n: "man-pouting", e: "🙎🏽‍♂️" },
        "1F3FE": { k: "man-pouting-1F3FE", n: "man-pouting", e: "🙎🏾‍♂️" },
        "1F3FF": { k: "man-pouting-1F3FF", n: "man-pouting", e: "🙎🏿‍♂️" },
      },
    },
    { n: ["flag-sa"], e: "🇸🇦", c: 4 },
    { n: ["fire"], e: "🔥", c: 3 },
    {
      n: ["woman-pouting"],
      e: "🙎‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-pouting-1F3FB", n: "woman-pouting", e: "🙎🏻‍♀️" },
        "1F3FC": { k: "woman-pouting-1F3FC", n: "woman-pouting", e: "🙎🏼‍♀️" },
        "1F3FD": { k: "woman-pouting-1F3FD", n: "woman-pouting", e: "🙎🏽‍♀️" },
        "1F3FE": { k: "woman-pouting-1F3FE", n: "woman-pouting", e: "🙎🏾‍♀️" },
        "1F3FF": { k: "woman-pouting-1F3FF", n: "woman-pouting", e: "🙎🏿‍♀️" },
      },
    },
    { n: ["flag-sb"], e: "🇸🇧", c: 4 },
    { n: ["droplet"], e: "💧", c: 3 },
    {
      n: ["no_good"],
      e: "🙅",
      c: 1,
      v: {
        "1F3FB": { k: "no_good-1F3FB", n: "no_good", e: "🙅🏻" },
        "1F3FC": { k: "no_good-1F3FC", n: "no_good", e: "🙅🏼" },
        "1F3FD": { k: "no_good-1F3FD", n: "no_good", e: "🙅🏽" },
        "1F3FE": { k: "no_good-1F3FE", n: "no_good", e: "🙅🏾" },
        "1F3FF": { k: "no_good-1F3FF", n: "no_good", e: "🙅🏿" },
      },
    },
    { n: ["flag-sc"], e: "🇸🇨", c: 4 },
    { n: ["ocean"], e: "🌊", c: 3 },
    {
      n: ["man-gesturing-no"],
      e: "🙅‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-gesturing-no-1F3FB",
          n: "man-gesturing-no",
          e: "🙅🏻‍♂️",
        },
        "1F3FC": {
          k: "man-gesturing-no-1F3FC",
          n: "man-gesturing-no",
          e: "🙅🏼‍♂️",
        },
        "1F3FD": {
          k: "man-gesturing-no-1F3FD",
          n: "man-gesturing-no",
          e: "🙅🏽‍♂️",
        },
        "1F3FE": {
          k: "man-gesturing-no-1F3FE",
          n: "man-gesturing-no",
          e: "🙅🏾‍♂️",
        },
        "1F3FF": {
          k: "man-gesturing-no-1F3FF",
          n: "man-gesturing-no",
          e: "🙅🏿‍♂️",
        },
      },
    },
    { n: ["flag-sd"], e: "🇸🇩", c: 4 },
    {
      n: ["woman-gesturing-no"],
      e: "🙅‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-gesturing-no-1F3FB",
          n: "woman-gesturing-no",
          e: "🙅🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-gesturing-no-1F3FC",
          n: "woman-gesturing-no",
          e: "🙅🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-gesturing-no-1F3FD",
          n: "woman-gesturing-no",
          e: "🙅🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-gesturing-no-1F3FE",
          n: "woman-gesturing-no",
          e: "🙅🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-gesturing-no-1F3FF",
          n: "woman-gesturing-no",
          e: "🙅🏿‍♀️",
        },
      },
    },
    { n: ["flag-se"], e: "🇸🇪", c: 4 },
    { n: ["flag-sg"], e: "🇸🇬", c: 4 },
    {
      n: ["ok_woman"],
      e: "🙆",
      c: 1,
      v: {
        "1F3FB": { k: "ok_woman-1F3FB", n: "ok_woman", e: "🙆🏻" },
        "1F3FC": { k: "ok_woman-1F3FC", n: "ok_woman", e: "🙆🏼" },
        "1F3FD": { k: "ok_woman-1F3FD", n: "ok_woman", e: "🙆🏽" },
        "1F3FE": { k: "ok_woman-1F3FE", n: "ok_woman", e: "🙆🏾" },
        "1F3FF": { k: "ok_woman-1F3FF", n: "ok_woman", e: "🙆🏿" },
      },
    },
    { n: ["flag-sh"], e: "🇸🇭", c: 4 },
    {
      n: ["man-gesturing-ok"],
      e: "🙆‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-gesturing-ok-1F3FB",
          n: "man-gesturing-ok",
          e: "🙆🏻‍♂️",
        },
        "1F3FC": {
          k: "man-gesturing-ok-1F3FC",
          n: "man-gesturing-ok",
          e: "🙆🏼‍♂️",
        },
        "1F3FD": {
          k: "man-gesturing-ok-1F3FD",
          n: "man-gesturing-ok",
          e: "🙆🏽‍♂️",
        },
        "1F3FE": {
          k: "man-gesturing-ok-1F3FE",
          n: "man-gesturing-ok",
          e: "🙆🏾‍♂️",
        },
        "1F3FF": {
          k: "man-gesturing-ok-1F3FF",
          n: "man-gesturing-ok",
          e: "🙆🏿‍♂️",
        },
      },
    },
    { n: ["flag-si"], e: "🇸🇮", c: 4 },
    {
      n: ["woman-gesturing-ok"],
      e: "🙆‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-gesturing-ok-1F3FB",
          n: "woman-gesturing-ok",
          e: "🙆🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-gesturing-ok-1F3FC",
          n: "woman-gesturing-ok",
          e: "🙆🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-gesturing-ok-1F3FD",
          n: "woman-gesturing-ok",
          e: "🙆🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-gesturing-ok-1F3FE",
          n: "woman-gesturing-ok",
          e: "🙆🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-gesturing-ok-1F3FF",
          n: "woman-gesturing-ok",
          e: "🙆🏿‍♀️",
        },
      },
    },
    {
      n: ["information_desk_person"],
      e: "💁",
      c: 1,
      v: {
        "1F3FB": {
          k: "information_desk_person-1F3FB",
          n: "information_desk_person",
          e: "💁🏻",
        },
        "1F3FC": {
          k: "information_desk_person-1F3FC",
          n: "information_desk_person",
          e: "💁🏼",
        },
        "1F3FD": {
          k: "information_desk_person-1F3FD",
          n: "information_desk_person",
          e: "💁🏽",
        },
        "1F3FE": {
          k: "information_desk_person-1F3FE",
          n: "information_desk_person",
          e: "💁🏾",
        },
        "1F3FF": {
          k: "information_desk_person-1F3FF",
          n: "information_desk_person",
          e: "💁🏿",
        },
      },
    },
    { n: ["flag-sj"], e: "🇸🇯", c: 4 },
    {
      n: ["man-tipping-hand"],
      e: "💁‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-tipping-hand-1F3FB",
          n: "man-tipping-hand",
          e: "💁🏻‍♂️",
        },
        "1F3FC": {
          k: "man-tipping-hand-1F3FC",
          n: "man-tipping-hand",
          e: "💁🏼‍♂️",
        },
        "1F3FD": {
          k: "man-tipping-hand-1F3FD",
          n: "man-tipping-hand",
          e: "💁🏽‍♂️",
        },
        "1F3FE": {
          k: "man-tipping-hand-1F3FE",
          n: "man-tipping-hand",
          e: "💁🏾‍♂️",
        },
        "1F3FF": {
          k: "man-tipping-hand-1F3FF",
          n: "man-tipping-hand",
          e: "💁🏿‍♂️",
        },
      },
    },
    { n: ["flag-sk"], e: "🇸🇰", c: 4 },
    { n: ["flag-sl"], e: "🇸🇱", c: 4 },
    {
      n: ["woman-tipping-hand"],
      e: "💁‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-tipping-hand-1F3FB",
          n: "woman-tipping-hand",
          e: "💁🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-tipping-hand-1F3FC",
          n: "woman-tipping-hand",
          e: "💁🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-tipping-hand-1F3FD",
          n: "woman-tipping-hand",
          e: "💁🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-tipping-hand-1F3FE",
          n: "woman-tipping-hand",
          e: "💁🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-tipping-hand-1F3FF",
          n: "woman-tipping-hand",
          e: "💁🏿‍♀️",
        },
      },
    },
    { n: ["flag-sm"], e: "🇸🇲", c: 4 },
    {
      n: ["raising_hand"],
      e: "🙋",
      c: 1,
      v: {
        "1F3FB": { k: "raising_hand-1F3FB", n: "raising_hand", e: "🙋🏻" },
        "1F3FC": { k: "raising_hand-1F3FC", n: "raising_hand", e: "🙋🏼" },
        "1F3FD": { k: "raising_hand-1F3FD", n: "raising_hand", e: "🙋🏽" },
        "1F3FE": { k: "raising_hand-1F3FE", n: "raising_hand", e: "🙋🏾" },
        "1F3FF": { k: "raising_hand-1F3FF", n: "raising_hand", e: "🙋🏿" },
      },
    },
    { n: ["flag-sn"], e: "🇸🇳", c: 4 },
    {
      n: ["man-raising-hand"],
      e: "🙋‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-raising-hand-1F3FB",
          n: "man-raising-hand",
          e: "🙋🏻‍♂️",
        },
        "1F3FC": {
          k: "man-raising-hand-1F3FC",
          n: "man-raising-hand",
          e: "🙋🏼‍♂️",
        },
        "1F3FD": {
          k: "man-raising-hand-1F3FD",
          n: "man-raising-hand",
          e: "🙋🏽‍♂️",
        },
        "1F3FE": {
          k: "man-raising-hand-1F3FE",
          n: "man-raising-hand",
          e: "🙋🏾‍♂️",
        },
        "1F3FF": {
          k: "man-raising-hand-1F3FF",
          n: "man-raising-hand",
          e: "🙋🏿‍♂️",
        },
      },
    },
    { n: ["flag-so"], e: "🇸🇴", c: 4 },
    {
      n: ["woman-raising-hand"],
      e: "🙋‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-raising-hand-1F3FB",
          n: "woman-raising-hand",
          e: "🙋🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-raising-hand-1F3FC",
          n: "woman-raising-hand",
          e: "🙋🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-raising-hand-1F3FD",
          n: "woman-raising-hand",
          e: "🙋🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-raising-hand-1F3FE",
          n: "woman-raising-hand",
          e: "🙋🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-raising-hand-1F3FF",
          n: "woman-raising-hand",
          e: "🙋🏿‍♀️",
        },
      },
    },
    { n: ["flag-sr"], e: "🇸🇷", c: 4 },
    {
      n: ["bow"],
      e: "🙇",
      c: 1,
      v: {
        "1F3FB": { k: "bow-1F3FB", n: "bow", e: "🙇🏻" },
        "1F3FC": { k: "bow-1F3FC", n: "bow", e: "🙇🏼" },
        "1F3FD": { k: "bow-1F3FD", n: "bow", e: "🙇🏽" },
        "1F3FE": { k: "bow-1F3FE", n: "bow", e: "🙇🏾" },
        "1F3FF": { k: "bow-1F3FF", n: "bow", e: "🙇🏿" },
      },
    },
    {
      n: ["man-bowing"],
      e: "🙇‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-bowing-1F3FB", n: "man-bowing", e: "🙇🏻‍♂️" },
        "1F3FC": { k: "man-bowing-1F3FC", n: "man-bowing", e: "🙇🏼‍♂️" },
        "1F3FD": { k: "man-bowing-1F3FD", n: "man-bowing", e: "🙇🏽‍♂️" },
        "1F3FE": { k: "man-bowing-1F3FE", n: "man-bowing", e: "🙇🏾‍♂️" },
        "1F3FF": { k: "man-bowing-1F3FF", n: "man-bowing", e: "🙇🏿‍♂️" },
      },
    },
    { n: ["flag-ss"], e: "🇸🇸", c: 4 },
    {
      n: ["woman-bowing"],
      e: "🙇‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-bowing-1F3FB", n: "woman-bowing", e: "🙇🏻‍♀️" },
        "1F3FC": { k: "woman-bowing-1F3FC", n: "woman-bowing", e: "🙇🏼‍♀️" },
        "1F3FD": { k: "woman-bowing-1F3FD", n: "woman-bowing", e: "🙇🏽‍♀️" },
        "1F3FE": { k: "woman-bowing-1F3FE", n: "woman-bowing", e: "🙇🏾‍♀️" },
        "1F3FF": { k: "woman-bowing-1F3FF", n: "woman-bowing", e: "🙇🏿‍♀️" },
      },
    },
    { n: ["flag-st"], e: "🇸🇹", c: 4 },
    {
      n: ["face_palm"],
      e: "🤦",
      c: 1,
      v: {
        "1F3FB": { k: "face_palm-1F3FB", n: "face_palm", e: "🤦🏻" },
        "1F3FC": { k: "face_palm-1F3FC", n: "face_palm", e: "🤦🏼" },
        "1F3FD": { k: "face_palm-1F3FD", n: "face_palm", e: "🤦🏽" },
        "1F3FE": { k: "face_palm-1F3FE", n: "face_palm", e: "🤦🏾" },
        "1F3FF": { k: "face_palm-1F3FF", n: "face_palm", e: "🤦🏿" },
      },
    },
    { n: ["flag-sv"], e: "🇸🇻", c: 4 },
    {
      n: ["man-facepalming"],
      e: "🤦‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-facepalming-1F3FB", n: "man-facepalming", e: "🤦🏻‍♂️" },
        "1F3FC": { k: "man-facepalming-1F3FC", n: "man-facepalming", e: "🤦🏼‍♂️" },
        "1F3FD": { k: "man-facepalming-1F3FD", n: "man-facepalming", e: "🤦🏽‍♂️" },
        "1F3FE": { k: "man-facepalming-1F3FE", n: "man-facepalming", e: "🤦🏾‍♂️" },
        "1F3FF": { k: "man-facepalming-1F3FF", n: "man-facepalming", e: "🤦🏿‍♂️" },
      },
    },
    { n: ["flag-sx"], e: "🇸🇽", c: 4 },
    { n: ["flag-sy"], e: "🇸🇾", c: 4 },
    {
      n: ["woman-facepalming"],
      e: "🤦‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-facepalming-1F3FB",
          n: "woman-facepalming",
          e: "🤦🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-facepalming-1F3FC",
          n: "woman-facepalming",
          e: "🤦🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-facepalming-1F3FD",
          n: "woman-facepalming",
          e: "🤦🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-facepalming-1F3FE",
          n: "woman-facepalming",
          e: "🤦🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-facepalming-1F3FF",
          n: "woman-facepalming",
          e: "🤦🏿‍♀️",
        },
      },
    },
    {
      n: ["shrug"],
      e: "🤷",
      c: 1,
      v: {
        "1F3FB": { k: "shrug-1F3FB", n: "shrug", e: "🤷🏻" },
        "1F3FC": { k: "shrug-1F3FC", n: "shrug", e: "🤷🏼" },
        "1F3FD": { k: "shrug-1F3FD", n: "shrug", e: "🤷🏽" },
        "1F3FE": { k: "shrug-1F3FE", n: "shrug", e: "🤷🏾" },
        "1F3FF": { k: "shrug-1F3FF", n: "shrug", e: "🤷🏿" },
      },
    },
    { n: ["flag-sz"], e: "🇸🇿", c: 4 },
    { n: ["flag-ta"], e: "🇹🇦", c: 4 },
    {
      n: ["man-shrugging"],
      e: "🤷‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-shrugging-1F3FB", n: "man-shrugging", e: "🤷🏻‍♂️" },
        "1F3FC": { k: "man-shrugging-1F3FC", n: "man-shrugging", e: "🤷🏼‍♂️" },
        "1F3FD": { k: "man-shrugging-1F3FD", n: "man-shrugging", e: "🤷🏽‍♂️" },
        "1F3FE": { k: "man-shrugging-1F3FE", n: "man-shrugging", e: "🤷🏾‍♂️" },
        "1F3FF": { k: "man-shrugging-1F3FF", n: "man-shrugging", e: "🤷🏿‍♂️" },
      },
    },
    {
      n: ["woman-shrugging"],
      e: "🤷‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-shrugging-1F3FB", n: "woman-shrugging", e: "🤷🏻‍♀️" },
        "1F3FC": { k: "woman-shrugging-1F3FC", n: "woman-shrugging", e: "🤷🏼‍♀️" },
        "1F3FD": { k: "woman-shrugging-1F3FD", n: "woman-shrugging", e: "🤷🏽‍♀️" },
        "1F3FE": { k: "woman-shrugging-1F3FE", n: "woman-shrugging", e: "🤷🏾‍♀️" },
        "1F3FF": { k: "woman-shrugging-1F3FF", n: "woman-shrugging", e: "🤷🏿‍♀️" },
      },
    },
    { n: ["flag-tc"], e: "🇹🇨", c: 4 },
    {
      n: ["massage"],
      e: "💆",
      c: 1,
      v: {
        "1F3FB": { k: "massage-1F3FB", n: "massage", e: "💆🏻" },
        "1F3FC": { k: "massage-1F3FC", n: "massage", e: "💆🏼" },
        "1F3FD": { k: "massage-1F3FD", n: "massage", e: "💆🏽" },
        "1F3FE": { k: "massage-1F3FE", n: "massage", e: "💆🏾" },
        "1F3FF": { k: "massage-1F3FF", n: "massage", e: "💆🏿" },
      },
    },
    { n: ["flag-td"], e: "🇹🇩", c: 4 },
    {
      n: ["man-getting-massage"],
      e: "💆‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-getting-massage-1F3FB",
          n: "man-getting-massage",
          e: "💆🏻‍♂️",
        },
        "1F3FC": {
          k: "man-getting-massage-1F3FC",
          n: "man-getting-massage",
          e: "💆🏼‍♂️",
        },
        "1F3FD": {
          k: "man-getting-massage-1F3FD",
          n: "man-getting-massage",
          e: "💆🏽‍♂️",
        },
        "1F3FE": {
          k: "man-getting-massage-1F3FE",
          n: "man-getting-massage",
          e: "💆🏾‍♂️",
        },
        "1F3FF": {
          k: "man-getting-massage-1F3FF",
          n: "man-getting-massage",
          e: "💆🏿‍♂️",
        },
      },
    },
    { n: ["flag-tf"], e: "🇹🇫", c: 4 },
    {
      n: ["woman-getting-massage"],
      e: "💆‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-getting-massage-1F3FB",
          n: "woman-getting-massage",
          e: "💆🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-getting-massage-1F3FC",
          n: "woman-getting-massage",
          e: "💆🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-getting-massage-1F3FD",
          n: "woman-getting-massage",
          e: "💆🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-getting-massage-1F3FE",
          n: "woman-getting-massage",
          e: "💆🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-getting-massage-1F3FF",
          n: "woman-getting-massage",
          e: "💆🏿‍♀️",
        },
      },
    },
    { n: ["flag-tg"], e: "🇹🇬", c: 4 },
    {
      n: ["haircut"],
      e: "💇",
      c: 1,
      v: {
        "1F3FB": { k: "haircut-1F3FB", n: "haircut", e: "💇🏻" },
        "1F3FC": { k: "haircut-1F3FC", n: "haircut", e: "💇🏼" },
        "1F3FD": { k: "haircut-1F3FD", n: "haircut", e: "💇🏽" },
        "1F3FE": { k: "haircut-1F3FE", n: "haircut", e: "💇🏾" },
        "1F3FF": { k: "haircut-1F3FF", n: "haircut", e: "💇🏿" },
      },
    },
    { n: ["flag-th"], e: "🇹🇭", c: 4 },
    {
      n: ["man-getting-haircut"],
      e: "💇‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-getting-haircut-1F3FB",
          n: "man-getting-haircut",
          e: "💇🏻‍♂️",
        },
        "1F3FC": {
          k: "man-getting-haircut-1F3FC",
          n: "man-getting-haircut",
          e: "💇🏼‍♂️",
        },
        "1F3FD": {
          k: "man-getting-haircut-1F3FD",
          n: "man-getting-haircut",
          e: "💇🏽‍♂️",
        },
        "1F3FE": {
          k: "man-getting-haircut-1F3FE",
          n: "man-getting-haircut",
          e: "💇🏾‍♂️",
        },
        "1F3FF": {
          k: "man-getting-haircut-1F3FF",
          n: "man-getting-haircut",
          e: "💇🏿‍♂️",
        },
      },
    },
    { n: ["flag-tj"], e: "🇹🇯", c: 4 },
    { n: ["flag-tk"], e: "🇹🇰", c: 4 },
    {
      n: ["woman-getting-haircut"],
      e: "💇‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-getting-haircut-1F3FB",
          n: "woman-getting-haircut",
          e: "💇🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-getting-haircut-1F3FC",
          n: "woman-getting-haircut",
          e: "💇🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-getting-haircut-1F3FD",
          n: "woman-getting-haircut",
          e: "💇🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-getting-haircut-1F3FE",
          n: "woman-getting-haircut",
          e: "💇🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-getting-haircut-1F3FF",
          n: "woman-getting-haircut",
          e: "💇🏿‍♀️",
        },
      },
    },
    {
      n: ["walking"],
      e: "🚶",
      c: 1,
      v: {
        "1F3FB": { k: "walking-1F3FB", n: "walking", e: "🚶🏻" },
        "1F3FC": { k: "walking-1F3FC", n: "walking", e: "🚶🏼" },
        "1F3FD": { k: "walking-1F3FD", n: "walking", e: "🚶🏽" },
        "1F3FE": { k: "walking-1F3FE", n: "walking", e: "🚶🏾" },
        "1F3FF": { k: "walking-1F3FF", n: "walking", e: "🚶🏿" },
      },
    },
    { n: ["flag-tl"], e: "🇹🇱", c: 4 },
    {
      n: ["man-walking"],
      e: "🚶‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-walking-1F3FB", n: "man-walking", e: "🚶🏻‍♂️" },
        "1F3FC": { k: "man-walking-1F3FC", n: "man-walking", e: "🚶🏼‍♂️" },
        "1F3FD": { k: "man-walking-1F3FD", n: "man-walking", e: "🚶🏽‍♂️" },
        "1F3FE": { k: "man-walking-1F3FE", n: "man-walking", e: "🚶🏾‍♂️" },
        "1F3FF": { k: "man-walking-1F3FF", n: "man-walking", e: "🚶🏿‍♂️" },
      },
    },
    { n: ["flag-tm"], e: "🇹🇲", c: 4 },
    {
      n: ["woman-walking"],
      e: "🚶‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-walking-1F3FB", n: "woman-walking", e: "🚶🏻‍♀️" },
        "1F3FC": { k: "woman-walking-1F3FC", n: "woman-walking", e: "🚶🏼‍♀️" },
        "1F3FD": { k: "woman-walking-1F3FD", n: "woman-walking", e: "🚶🏽‍♀️" },
        "1F3FE": { k: "woman-walking-1F3FE", n: "woman-walking", e: "🚶🏾‍♀️" },
        "1F3FF": { k: "woman-walking-1F3FF", n: "woman-walking", e: "🚶🏿‍♀️" },
      },
    },
    { n: ["flag-tn"], e: "🇹🇳", c: 4 },
    {
      n: ["runner", "running"],
      e: "🏃",
      c: 1,
      v: {
        "1F3FB": { k: "runner-1F3FB", n: "runner", e: "🏃🏻" },
        "1F3FC": { k: "runner-1F3FC", n: "runner", e: "🏃🏼" },
        "1F3FD": { k: "runner-1F3FD", n: "runner", e: "🏃🏽" },
        "1F3FE": { k: "runner-1F3FE", n: "runner", e: "🏃🏾" },
        "1F3FF": { k: "runner-1F3FF", n: "runner", e: "🏃🏿" },
      },
    },
    { n: ["flag-to"], e: "🇹🇴", c: 4 },
    {
      n: ["man-running"],
      e: "🏃‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-running-1F3FB", n: "man-running", e: "🏃🏻‍♂️" },
        "1F3FC": { k: "man-running-1F3FC", n: "man-running", e: "🏃🏼‍♂️" },
        "1F3FD": { k: "man-running-1F3FD", n: "man-running", e: "🏃🏽‍♂️" },
        "1F3FE": { k: "man-running-1F3FE", n: "man-running", e: "🏃🏾‍♂️" },
        "1F3FF": { k: "man-running-1F3FF", n: "man-running", e: "🏃🏿‍♂️" },
      },
    },
    { n: ["flag-tr"], e: "🇹🇷", c: 4 },
    { n: ["flag-tt"], e: "🇹🇹", c: 4 },
    {
      n: ["woman-running"],
      e: "🏃‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-running-1F3FB", n: "woman-running", e: "🏃🏻‍♀️" },
        "1F3FC": { k: "woman-running-1F3FC", n: "woman-running", e: "🏃🏼‍♀️" },
        "1F3FD": { k: "woman-running-1F3FD", n: "woman-running", e: "🏃🏽‍♀️" },
        "1F3FE": { k: "woman-running-1F3FE", n: "woman-running", e: "🏃🏾‍♀️" },
        "1F3FF": { k: "woman-running-1F3FF", n: "woman-running", e: "🏃🏿‍♀️" },
      },
    },
    { n: ["flag-tv"], e: "🇹🇻", c: 4 },
    {
      n: ["dancer"],
      e: "💃",
      c: 1,
      v: {
        "1F3FB": { k: "dancer-1F3FB", n: "dancer", e: "💃🏻" },
        "1F3FC": { k: "dancer-1F3FC", n: "dancer", e: "💃🏼" },
        "1F3FD": { k: "dancer-1F3FD", n: "dancer", e: "💃🏽" },
        "1F3FE": { k: "dancer-1F3FE", n: "dancer", e: "💃🏾" },
        "1F3FF": { k: "dancer-1F3FF", n: "dancer", e: "💃🏿" },
      },
    },
    { n: ["flag-tw"], e: "🇹🇼", c: 4 },
    {
      n: ["man_dancing"],
      e: "🕺",
      c: 1,
      v: {
        "1F3FB": { k: "man_dancing-1F3FB", n: "man_dancing", e: "🕺🏻" },
        "1F3FC": { k: "man_dancing-1F3FC", n: "man_dancing", e: "🕺🏼" },
        "1F3FD": { k: "man_dancing-1F3FD", n: "man_dancing", e: "🕺🏽" },
        "1F3FE": { k: "man_dancing-1F3FE", n: "man_dancing", e: "🕺🏾" },
        "1F3FF": { k: "man_dancing-1F3FF", n: "man_dancing", e: "🕺🏿" },
      },
    },
    { n: ["dancers"], e: "👯", c: 1 },
    { n: ["flag-tz"], e: "🇹🇿", c: 4 },
    { n: ["flag-ua"], e: "🇺🇦", c: 4 },
    { n: ["man-with-bunny-ears-partying"], e: "👯‍♂️", c: 1 },
    { n: ["woman-with-bunny-ears-partying"], e: "👯‍♀️", c: 1 },
    { n: ["flag-ug"], e: "🇺🇬", c: 4 },
    { n: ["flag-um"], e: "🇺🇲", c: 4 },
    {
      n: ["person_in_steamy_room"],
      e: "🧖",
      c: 1,
      v: {
        "1F3FB": {
          k: "person_in_steamy_room-1F3FB",
          n: "person_in_steamy_room",
          e: "🧖🏻",
        },
        "1F3FC": {
          k: "person_in_steamy_room-1F3FC",
          n: "person_in_steamy_room",
          e: "🧖🏼",
        },
        "1F3FD": {
          k: "person_in_steamy_room-1F3FD",
          n: "person_in_steamy_room",
          e: "🧖🏽",
        },
        "1F3FE": {
          k: "person_in_steamy_room-1F3FE",
          n: "person_in_steamy_room",
          e: "🧖🏾",
        },
        "1F3FF": {
          k: "person_in_steamy_room-1F3FF",
          n: "person_in_steamy_room",
          e: "🧖🏿",
        },
      },
    },
    {
      n: ["woman_in_steamy_room"],
      e: "🧖‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman_in_steamy_room-1F3FB",
          n: "woman_in_steamy_room",
          e: "🧖🏻‍♀️",
        },
        "1F3FC": {
          k: "woman_in_steamy_room-1F3FC",
          n: "woman_in_steamy_room",
          e: "🧖🏼‍♀️",
        },
        "1F3FD": {
          k: "woman_in_steamy_room-1F3FD",
          n: "woman_in_steamy_room",
          e: "🧖🏽‍♀️",
        },
        "1F3FE": {
          k: "woman_in_steamy_room-1F3FE",
          n: "woman_in_steamy_room",
          e: "🧖🏾‍♀️",
        },
        "1F3FF": {
          k: "woman_in_steamy_room-1F3FF",
          n: "woman_in_steamy_room",
          e: "🧖🏿‍♀️",
        },
      },
    },
    { n: ["flag-un"], e: "🇺🇳", c: 4 },
    { n: ["us", "flag-us"], e: "🇺🇸", c: 4 },
    {
      n: ["man_in_steamy_room"],
      e: "🧖‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man_in_steamy_room-1F3FB",
          n: "man_in_steamy_room",
          e: "🧖🏻‍♂️",
        },
        "1F3FC": {
          k: "man_in_steamy_room-1F3FC",
          n: "man_in_steamy_room",
          e: "🧖🏼‍♂️",
        },
        "1F3FD": {
          k: "man_in_steamy_room-1F3FD",
          n: "man_in_steamy_room",
          e: "🧖🏽‍♂️",
        },
        "1F3FE": {
          k: "man_in_steamy_room-1F3FE",
          n: "man_in_steamy_room",
          e: "🧖🏾‍♂️",
        },
        "1F3FF": {
          k: "man_in_steamy_room-1F3FF",
          n: "man_in_steamy_room",
          e: "🧖🏿‍♂️",
        },
      },
    },
    {
      n: ["person_climbing"],
      e: "🧗",
      c: 1,
      v: {
        "1F3FB": { k: "person_climbing-1F3FB", n: "person_climbing", e: "🧗🏻" },
        "1F3FC": { k: "person_climbing-1F3FC", n: "person_climbing", e: "🧗🏼" },
        "1F3FD": { k: "person_climbing-1F3FD", n: "person_climbing", e: "🧗🏽" },
        "1F3FE": { k: "person_climbing-1F3FE", n: "person_climbing", e: "🧗🏾" },
        "1F3FF": { k: "person_climbing-1F3FF", n: "person_climbing", e: "🧗🏿" },
      },
    },
    { n: ["flag-uy"], e: "🇺🇾", c: 4 },
    {
      n: ["woman_climbing"],
      e: "🧗‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman_climbing-1F3FB", n: "woman_climbing", e: "🧗🏻‍♀️" },
        "1F3FC": { k: "woman_climbing-1F3FC", n: "woman_climbing", e: "🧗🏼‍♀️" },
        "1F3FD": { k: "woman_climbing-1F3FD", n: "woman_climbing", e: "🧗🏽‍♀️" },
        "1F3FE": { k: "woman_climbing-1F3FE", n: "woman_climbing", e: "🧗🏾‍♀️" },
        "1F3FF": { k: "woman_climbing-1F3FF", n: "woman_climbing", e: "🧗🏿‍♀️" },
      },
    },
    { n: ["flag-uz"], e: "🇺🇿", c: 4 },
    {
      n: ["man_climbing"],
      e: "🧗‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man_climbing-1F3FB", n: "man_climbing", e: "🧗🏻‍♂️" },
        "1F3FC": { k: "man_climbing-1F3FC", n: "man_climbing", e: "🧗🏼‍♂️" },
        "1F3FD": { k: "man_climbing-1F3FD", n: "man_climbing", e: "🧗🏽‍♂️" },
        "1F3FE": { k: "man_climbing-1F3FE", n: "man_climbing", e: "🧗🏾‍♂️" },
        "1F3FF": { k: "man_climbing-1F3FF", n: "man_climbing", e: "🧗🏿‍♂️" },
      },
    },
    { n: ["flag-va"], e: "🇻🇦", c: 4 },
    {
      n: ["person_in_lotus_position"],
      e: "🧘",
      c: 1,
      v: {
        "1F3FB": {
          k: "person_in_lotus_position-1F3FB",
          n: "person_in_lotus_position",
          e: "🧘🏻",
        },
        "1F3FC": {
          k: "person_in_lotus_position-1F3FC",
          n: "person_in_lotus_position",
          e: "🧘🏼",
        },
        "1F3FD": {
          k: "person_in_lotus_position-1F3FD",
          n: "person_in_lotus_position",
          e: "🧘🏽",
        },
        "1F3FE": {
          k: "person_in_lotus_position-1F3FE",
          n: "person_in_lotus_position",
          e: "🧘🏾",
        },
        "1F3FF": {
          k: "person_in_lotus_position-1F3FF",
          n: "person_in_lotus_position",
          e: "🧘🏿",
        },
      },
    },
    { n: ["flag-vc"], e: "🇻🇨", c: 4 },
    { n: ["flag-ve"], e: "🇻🇪", c: 4 },
    {
      n: ["woman_in_lotus_position"],
      e: "🧘‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman_in_lotus_position-1F3FB",
          n: "woman_in_lotus_position",
          e: "🧘🏻‍♀️",
        },
        "1F3FC": {
          k: "woman_in_lotus_position-1F3FC",
          n: "woman_in_lotus_position",
          e: "🧘🏼‍♀️",
        },
        "1F3FD": {
          k: "woman_in_lotus_position-1F3FD",
          n: "woman_in_lotus_position",
          e: "🧘🏽‍♀️",
        },
        "1F3FE": {
          k: "woman_in_lotus_position-1F3FE",
          n: "woman_in_lotus_position",
          e: "🧘🏾‍♀️",
        },
        "1F3FF": {
          k: "woman_in_lotus_position-1F3FF",
          n: "woman_in_lotus_position",
          e: "🧘🏿‍♀️",
        },
      },
    },
    {
      n: ["man_in_lotus_position"],
      e: "🧘‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man_in_lotus_position-1F3FB",
          n: "man_in_lotus_position",
          e: "🧘🏻‍♂️",
        },
        "1F3FC": {
          k: "man_in_lotus_position-1F3FC",
          n: "man_in_lotus_position",
          e: "🧘🏼‍♂️",
        },
        "1F3FD": {
          k: "man_in_lotus_position-1F3FD",
          n: "man_in_lotus_position",
          e: "🧘🏽‍♂️",
        },
        "1F3FE": {
          k: "man_in_lotus_position-1F3FE",
          n: "man_in_lotus_position",
          e: "🧘🏾‍♂️",
        },
        "1F3FF": {
          k: "man_in_lotus_position-1F3FF",
          n: "man_in_lotus_position",
          e: "🧘🏿‍♂️",
        },
      },
    },
    { n: ["flag-vg"], e: "🇻🇬", c: 4 },
    { n: ["flag-vi"], e: "🇻🇮", c: 4 },
    {
      n: ["bath"],
      e: "🛀",
      c: 1,
      v: {
        "1F3FB": { k: "bath-1F3FB", n: "bath", e: "🛀🏻" },
        "1F3FC": { k: "bath-1F3FC", n: "bath", e: "🛀🏼" },
        "1F3FD": { k: "bath-1F3FD", n: "bath", e: "🛀🏽" },
        "1F3FE": { k: "bath-1F3FE", n: "bath", e: "🛀🏾" },
        "1F3FF": { k: "bath-1F3FF", n: "bath", e: "🛀🏿" },
      },
    },
    {
      n: ["sleeping_accommodation"],
      e: "🛌",
      c: 1,
      v: {
        "1F3FB": {
          k: "sleeping_accommodation-1F3FB",
          n: "sleeping_accommodation",
          e: "🛌🏻",
        },
        "1F3FC": {
          k: "sleeping_accommodation-1F3FC",
          n: "sleeping_accommodation",
          e: "🛌🏼",
        },
        "1F3FD": {
          k: "sleeping_accommodation-1F3FD",
          n: "sleeping_accommodation",
          e: "🛌🏽",
        },
        "1F3FE": {
          k: "sleeping_accommodation-1F3FE",
          n: "sleeping_accommodation",
          e: "🛌🏾",
        },
        "1F3FF": {
          k: "sleeping_accommodation-1F3FF",
          n: "sleeping_accommodation",
          e: "🛌🏿",
        },
      },
    },
    { n: ["flag-vn"], e: "🇻🇳", c: 4 },
    {
      n: ["man_in_business_suit_levitating"],
      e: "🕴️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man_in_business_suit_levitating-1F3FB",
          n: "man_in_business_suit_levitating",
          e: "🕴🏻",
        },
        "1F3FC": {
          k: "man_in_business_suit_levitating-1F3FC",
          n: "man_in_business_suit_levitating",
          e: "🕴🏼",
        },
        "1F3FD": {
          k: "man_in_business_suit_levitating-1F3FD",
          n: "man_in_business_suit_levitating",
          e: "🕴🏽",
        },
        "1F3FE": {
          k: "man_in_business_suit_levitating-1F3FE",
          n: "man_in_business_suit_levitating",
          e: "🕴🏾",
        },
        "1F3FF": {
          k: "man_in_business_suit_levitating-1F3FF",
          n: "man_in_business_suit_levitating",
          e: "🕴🏿",
        },
      },
    },
    { n: ["flag-vu"], e: "🇻🇺", c: 4 },
    { n: ["flag-wf"], e: "🇼🇫", c: 4 },
    { n: ["speaking_head_in_silhouette"], e: "🗣️", c: 1 },
    { n: ["bust_in_silhouette"], e: "👤", c: 1 },
    { n: ["flag-ws"], e: "🇼🇸", c: 4 },
    { n: ["busts_in_silhouette"], e: "👥", c: 1 },
    { n: ["flag-xk"], e: "🇽🇰", c: 4 },
    { n: ["fencer"], e: "🤺", c: 1 },
    { n: ["flag-ye"], e: "🇾🇪", c: 4 },
    { n: ["flag-yt"], e: "🇾🇹", c: 4 },
    {
      n: ["horse_racing"],
      e: "🏇",
      c: 1,
      v: {
        "1F3FB": { k: "horse_racing-1F3FB", n: "horse_racing", e: "🏇🏻" },
        "1F3FC": { k: "horse_racing-1F3FC", n: "horse_racing", e: "🏇🏼" },
        "1F3FD": { k: "horse_racing-1F3FD", n: "horse_racing", e: "🏇🏽" },
        "1F3FE": { k: "horse_racing-1F3FE", n: "horse_racing", e: "🏇🏾" },
        "1F3FF": { k: "horse_racing-1F3FF", n: "horse_racing", e: "🏇🏿" },
      },
    },
    { n: ["flag-za"], e: "🇿🇦", c: 4 },
    { n: ["skier"], e: "⛷️", c: 1 },
    { n: ["flag-zm"], e: "🇿🇲", c: 4 },
    {
      n: ["snowboarder"],
      e: "🏂",
      c: 1,
      v: {
        "1F3FB": { k: "snowboarder-1F3FB", n: "snowboarder", e: "🏂🏻" },
        "1F3FC": { k: "snowboarder-1F3FC", n: "snowboarder", e: "🏂🏼" },
        "1F3FD": { k: "snowboarder-1F3FD", n: "snowboarder", e: "🏂🏽" },
        "1F3FE": { k: "snowboarder-1F3FE", n: "snowboarder", e: "🏂🏾" },
        "1F3FF": { k: "snowboarder-1F3FF", n: "snowboarder", e: "🏂🏿" },
      },
    },
    {
      n: ["golfer"],
      e: "🏌️",
      c: 1,
      v: {
        "1F3FB": { k: "golfer-1F3FB", n: "golfer", e: "🏌🏻" },
        "1F3FC": { k: "golfer-1F3FC", n: "golfer", e: "🏌🏼" },
        "1F3FD": { k: "golfer-1F3FD", n: "golfer", e: "🏌🏽" },
        "1F3FE": { k: "golfer-1F3FE", n: "golfer", e: "🏌🏾" },
        "1F3FF": { k: "golfer-1F3FF", n: "golfer", e: "🏌🏿" },
      },
    },
    { n: ["flag-zw"], e: "🇿🇼", c: 4 },
    {
      n: ["man-golfing"],
      e: "🏌️‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-golfing-1F3FB", n: "man-golfing", e: "🏌🏻‍♂️" },
        "1F3FC": { k: "man-golfing-1F3FC", n: "man-golfing", e: "🏌🏼‍♂️" },
        "1F3FD": { k: "man-golfing-1F3FD", n: "man-golfing", e: "🏌🏽‍♂️" },
        "1F3FE": { k: "man-golfing-1F3FE", n: "man-golfing", e: "🏌🏾‍♂️" },
        "1F3FF": { k: "man-golfing-1F3FF", n: "man-golfing", e: "🏌🏿‍♂️" },
      },
    },
    { n: ["flag-england"], e: "🏴󠁧󠁢󠁥󠁮󠁧󠁿", c: 4 },
    {
      n: ["woman-golfing"],
      e: "🏌️‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-golfing-1F3FB", n: "woman-golfing", e: "🏌🏻‍♀️" },
        "1F3FC": { k: "woman-golfing-1F3FC", n: "woman-golfing", e: "🏌🏼‍♀️" },
        "1F3FD": { k: "woman-golfing-1F3FD", n: "woman-golfing", e: "🏌🏽‍♀️" },
        "1F3FE": { k: "woman-golfing-1F3FE", n: "woman-golfing", e: "🏌🏾‍♀️" },
        "1F3FF": { k: "woman-golfing-1F3FF", n: "woman-golfing", e: "🏌🏿‍♀️" },
      },
    },
    { n: ["flag-scotland"], e: "🏴󠁧󠁢󠁳󠁣󠁴󠁿", c: 4 },
    { n: ["flag-wales"], e: "🏴󠁧󠁢󠁷󠁬󠁳󠁿", c: 4 },
    {
      n: ["surfer"],
      e: "🏄",
      c: 1,
      v: {
        "1F3FB": { k: "surfer-1F3FB", n: "surfer", e: "🏄🏻" },
        "1F3FC": { k: "surfer-1F3FC", n: "surfer", e: "🏄🏼" },
        "1F3FD": { k: "surfer-1F3FD", n: "surfer", e: "🏄🏽" },
        "1F3FE": { k: "surfer-1F3FE", n: "surfer", e: "🏄🏾" },
        "1F3FF": { k: "surfer-1F3FF", n: "surfer", e: "🏄🏿" },
      },
    },
    {
      n: ["man-surfing"],
      e: "🏄‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-surfing-1F3FB", n: "man-surfing", e: "🏄🏻‍♂️" },
        "1F3FC": { k: "man-surfing-1F3FC", n: "man-surfing", e: "🏄🏼‍♂️" },
        "1F3FD": { k: "man-surfing-1F3FD", n: "man-surfing", e: "🏄🏽‍♂️" },
        "1F3FE": { k: "man-surfing-1F3FE", n: "man-surfing", e: "🏄🏾‍♂️" },
        "1F3FF": { k: "man-surfing-1F3FF", n: "man-surfing", e: "🏄🏿‍♂️" },
      },
    },
    {
      n: ["woman-surfing"],
      e: "🏄‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-surfing-1F3FB", n: "woman-surfing", e: "🏄🏻‍♀️" },
        "1F3FC": { k: "woman-surfing-1F3FC", n: "woman-surfing", e: "🏄🏼‍♀️" },
        "1F3FD": { k: "woman-surfing-1F3FD", n: "woman-surfing", e: "🏄🏽‍♀️" },
        "1F3FE": { k: "woman-surfing-1F3FE", n: "woman-surfing", e: "🏄🏾‍♀️" },
        "1F3FF": { k: "woman-surfing-1F3FF", n: "woman-surfing", e: "🏄🏿‍♀️" },
      },
    },
    {
      n: ["rowboat"],
      e: "🚣",
      c: 1,
      v: {
        "1F3FB": { k: "rowboat-1F3FB", n: "rowboat", e: "🚣🏻" },
        "1F3FC": { k: "rowboat-1F3FC", n: "rowboat", e: "🚣🏼" },
        "1F3FD": { k: "rowboat-1F3FD", n: "rowboat", e: "🚣🏽" },
        "1F3FE": { k: "rowboat-1F3FE", n: "rowboat", e: "🚣🏾" },
        "1F3FF": { k: "rowboat-1F3FF", n: "rowboat", e: "🚣🏿" },
      },
    },
    {
      n: ["man-rowing-boat"],
      e: "🚣‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-rowing-boat-1F3FB", n: "man-rowing-boat", e: "🚣🏻‍♂️" },
        "1F3FC": { k: "man-rowing-boat-1F3FC", n: "man-rowing-boat", e: "🚣🏼‍♂️" },
        "1F3FD": { k: "man-rowing-boat-1F3FD", n: "man-rowing-boat", e: "🚣🏽‍♂️" },
        "1F3FE": { k: "man-rowing-boat-1F3FE", n: "man-rowing-boat", e: "🚣🏾‍♂️" },
        "1F3FF": { k: "man-rowing-boat-1F3FF", n: "man-rowing-boat", e: "🚣🏿‍♂️" },
      },
    },
    {
      n: ["woman-rowing-boat"],
      e: "🚣‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-rowing-boat-1F3FB",
          n: "woman-rowing-boat",
          e: "🚣🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-rowing-boat-1F3FC",
          n: "woman-rowing-boat",
          e: "🚣🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-rowing-boat-1F3FD",
          n: "woman-rowing-boat",
          e: "🚣🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-rowing-boat-1F3FE",
          n: "woman-rowing-boat",
          e: "🚣🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-rowing-boat-1F3FF",
          n: "woman-rowing-boat",
          e: "🚣🏿‍♀️",
        },
      },
    },
    {
      n: ["swimmer"],
      e: "🏊",
      c: 1,
      v: {
        "1F3FB": { k: "swimmer-1F3FB", n: "swimmer", e: "🏊🏻" },
        "1F3FC": { k: "swimmer-1F3FC", n: "swimmer", e: "🏊🏼" },
        "1F3FD": { k: "swimmer-1F3FD", n: "swimmer", e: "🏊🏽" },
        "1F3FE": { k: "swimmer-1F3FE", n: "swimmer", e: "🏊🏾" },
        "1F3FF": { k: "swimmer-1F3FF", n: "swimmer", e: "🏊🏿" },
      },
    },
    {
      n: ["man-swimming"],
      e: "🏊‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-swimming-1F3FB", n: "man-swimming", e: "🏊🏻‍♂️" },
        "1F3FC": { k: "man-swimming-1F3FC", n: "man-swimming", e: "🏊🏼‍♂️" },
        "1F3FD": { k: "man-swimming-1F3FD", n: "man-swimming", e: "🏊🏽‍♂️" },
        "1F3FE": { k: "man-swimming-1F3FE", n: "man-swimming", e: "🏊🏾‍♂️" },
        "1F3FF": { k: "man-swimming-1F3FF", n: "man-swimming", e: "🏊🏿‍♂️" },
      },
    },
    {
      n: ["woman-swimming"],
      e: "🏊‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-swimming-1F3FB", n: "woman-swimming", e: "🏊🏻‍♀️" },
        "1F3FC": { k: "woman-swimming-1F3FC", n: "woman-swimming", e: "🏊🏼‍♀️" },
        "1F3FD": { k: "woman-swimming-1F3FD", n: "woman-swimming", e: "🏊🏽‍♀️" },
        "1F3FE": { k: "woman-swimming-1F3FE", n: "woman-swimming", e: "🏊🏾‍♀️" },
        "1F3FF": { k: "woman-swimming-1F3FF", n: "woman-swimming", e: "🏊🏿‍♀️" },
      },
    },
    {
      n: ["person_with_ball"],
      e: "⛹️",
      c: 1,
      v: {
        "1F3FB": {
          k: "person_with_ball-1F3FB",
          n: "person_with_ball",
          e: "⛹🏻",
        },
        "1F3FC": {
          k: "person_with_ball-1F3FC",
          n: "person_with_ball",
          e: "⛹🏼",
        },
        "1F3FD": {
          k: "person_with_ball-1F3FD",
          n: "person_with_ball",
          e: "⛹🏽",
        },
        "1F3FE": {
          k: "person_with_ball-1F3FE",
          n: "person_with_ball",
          e: "⛹🏾",
        },
        "1F3FF": {
          k: "person_with_ball-1F3FF",
          n: "person_with_ball",
          e: "⛹🏿",
        },
      },
    },
    {
      n: ["man-bouncing-ball"],
      e: "⛹️‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-bouncing-ball-1F3FB",
          n: "man-bouncing-ball",
          e: "⛹🏻‍♂️",
        },
        "1F3FC": {
          k: "man-bouncing-ball-1F3FC",
          n: "man-bouncing-ball",
          e: "⛹🏼‍♂️",
        },
        "1F3FD": {
          k: "man-bouncing-ball-1F3FD",
          n: "man-bouncing-ball",
          e: "⛹🏽‍♂️",
        },
        "1F3FE": {
          k: "man-bouncing-ball-1F3FE",
          n: "man-bouncing-ball",
          e: "⛹🏾‍♂️",
        },
        "1F3FF": {
          k: "man-bouncing-ball-1F3FF",
          n: "man-bouncing-ball",
          e: "⛹🏿‍♂️",
        },
      },
    },
    {
      n: ["woman-bouncing-ball"],
      e: "⛹️‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-bouncing-ball-1F3FB",
          n: "woman-bouncing-ball",
          e: "⛹🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-bouncing-ball-1F3FC",
          n: "woman-bouncing-ball",
          e: "⛹🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-bouncing-ball-1F3FD",
          n: "woman-bouncing-ball",
          e: "⛹🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-bouncing-ball-1F3FE",
          n: "woman-bouncing-ball",
          e: "⛹🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-bouncing-ball-1F3FF",
          n: "woman-bouncing-ball",
          e: "⛹🏿‍♀️",
        },
      },
    },
    {
      n: ["weight_lifter"],
      e: "🏋️",
      c: 1,
      v: {
        "1F3FB": { k: "weight_lifter-1F3FB", n: "weight_lifter", e: "🏋🏻" },
        "1F3FC": { k: "weight_lifter-1F3FC", n: "weight_lifter", e: "🏋🏼" },
        "1F3FD": { k: "weight_lifter-1F3FD", n: "weight_lifter", e: "🏋🏽" },
        "1F3FE": { k: "weight_lifter-1F3FE", n: "weight_lifter", e: "🏋🏾" },
        "1F3FF": { k: "weight_lifter-1F3FF", n: "weight_lifter", e: "🏋🏿" },
      },
    },
    {
      n: ["man-lifting-weights"],
      e: "🏋️‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-lifting-weights-1F3FB",
          n: "man-lifting-weights",
          e: "🏋🏻‍♂️",
        },
        "1F3FC": {
          k: "man-lifting-weights-1F3FC",
          n: "man-lifting-weights",
          e: "🏋🏼‍♂️",
        },
        "1F3FD": {
          k: "man-lifting-weights-1F3FD",
          n: "man-lifting-weights",
          e: "🏋🏽‍♂️",
        },
        "1F3FE": {
          k: "man-lifting-weights-1F3FE",
          n: "man-lifting-weights",
          e: "🏋🏾‍♂️",
        },
        "1F3FF": {
          k: "man-lifting-weights-1F3FF",
          n: "man-lifting-weights",
          e: "🏋🏿‍♂️",
        },
      },
    },
    {
      n: ["woman-lifting-weights"],
      e: "🏋️‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-lifting-weights-1F3FB",
          n: "woman-lifting-weights",
          e: "🏋🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-lifting-weights-1F3FC",
          n: "woman-lifting-weights",
          e: "🏋🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-lifting-weights-1F3FD",
          n: "woman-lifting-weights",
          e: "🏋🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-lifting-weights-1F3FE",
          n: "woman-lifting-weights",
          e: "🏋🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-lifting-weights-1F3FF",
          n: "woman-lifting-weights",
          e: "🏋🏿‍♀️",
        },
      },
    },
    {
      n: ["bicyclist"],
      e: "🚴",
      c: 1,
      v: {
        "1F3FB": { k: "bicyclist-1F3FB", n: "bicyclist", e: "🚴🏻" },
        "1F3FC": { k: "bicyclist-1F3FC", n: "bicyclist", e: "🚴🏼" },
        "1F3FD": { k: "bicyclist-1F3FD", n: "bicyclist", e: "🚴🏽" },
        "1F3FE": { k: "bicyclist-1F3FE", n: "bicyclist", e: "🚴🏾" },
        "1F3FF": { k: "bicyclist-1F3FF", n: "bicyclist", e: "🚴🏿" },
      },
    },
    {
      n: ["man-biking"],
      e: "🚴‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-biking-1F3FB", n: "man-biking", e: "🚴🏻‍♂️" },
        "1F3FC": { k: "man-biking-1F3FC", n: "man-biking", e: "🚴🏼‍♂️" },
        "1F3FD": { k: "man-biking-1F3FD", n: "man-biking", e: "🚴🏽‍♂️" },
        "1F3FE": { k: "man-biking-1F3FE", n: "man-biking", e: "🚴🏾‍♂️" },
        "1F3FF": { k: "man-biking-1F3FF", n: "man-biking", e: "🚴🏿‍♂️" },
      },
    },
    {
      n: ["woman-biking"],
      e: "🚴‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-biking-1F3FB", n: "woman-biking", e: "🚴🏻‍♀️" },
        "1F3FC": { k: "woman-biking-1F3FC", n: "woman-biking", e: "🚴🏼‍♀️" },
        "1F3FD": { k: "woman-biking-1F3FD", n: "woman-biking", e: "🚴🏽‍♀️" },
        "1F3FE": { k: "woman-biking-1F3FE", n: "woman-biking", e: "🚴🏾‍♀️" },
        "1F3FF": { k: "woman-biking-1F3FF", n: "woman-biking", e: "🚴🏿‍♀️" },
      },
    },
    {
      n: ["mountain_bicyclist"],
      e: "🚵",
      c: 1,
      v: {
        "1F3FB": {
          k: "mountain_bicyclist-1F3FB",
          n: "mountain_bicyclist",
          e: "🚵🏻",
        },
        "1F3FC": {
          k: "mountain_bicyclist-1F3FC",
          n: "mountain_bicyclist",
          e: "🚵🏼",
        },
        "1F3FD": {
          k: "mountain_bicyclist-1F3FD",
          n: "mountain_bicyclist",
          e: "🚵🏽",
        },
        "1F3FE": {
          k: "mountain_bicyclist-1F3FE",
          n: "mountain_bicyclist",
          e: "🚵🏾",
        },
        "1F3FF": {
          k: "mountain_bicyclist-1F3FF",
          n: "mountain_bicyclist",
          e: "🚵🏿",
        },
      },
    },
    {
      n: ["man-mountain-biking"],
      e: "🚵‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-mountain-biking-1F3FB",
          n: "man-mountain-biking",
          e: "🚵🏻‍♂️",
        },
        "1F3FC": {
          k: "man-mountain-biking-1F3FC",
          n: "man-mountain-biking",
          e: "🚵🏼‍♂️",
        },
        "1F3FD": {
          k: "man-mountain-biking-1F3FD",
          n: "man-mountain-biking",
          e: "🚵🏽‍♂️",
        },
        "1F3FE": {
          k: "man-mountain-biking-1F3FE",
          n: "man-mountain-biking",
          e: "🚵🏾‍♂️",
        },
        "1F3FF": {
          k: "man-mountain-biking-1F3FF",
          n: "man-mountain-biking",
          e: "🚵🏿‍♂️",
        },
      },
    },
    {
      n: ["woman-mountain-biking"],
      e: "🚵‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-mountain-biking-1F3FB",
          n: "woman-mountain-biking",
          e: "🚵🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-mountain-biking-1F3FC",
          n: "woman-mountain-biking",
          e: "🚵🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-mountain-biking-1F3FD",
          n: "woman-mountain-biking",
          e: "🚵🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-mountain-biking-1F3FE",
          n: "woman-mountain-biking",
          e: "🚵🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-mountain-biking-1F3FF",
          n: "woman-mountain-biking",
          e: "🚵🏿‍♀️",
        },
      },
    },
    { n: ["racing_car"], e: "🏎️", c: 1 },
    { n: ["racing_motorcycle"], e: "🏍️", c: 1 },
    {
      n: ["person_doing_cartwheel"],
      e: "🤸",
      c: 1,
      v: {
        "1F3FB": {
          k: "person_doing_cartwheel-1F3FB",
          n: "person_doing_cartwheel",
          e: "🤸🏻",
        },
        "1F3FC": {
          k: "person_doing_cartwheel-1F3FC",
          n: "person_doing_cartwheel",
          e: "🤸🏼",
        },
        "1F3FD": {
          k: "person_doing_cartwheel-1F3FD",
          n: "person_doing_cartwheel",
          e: "🤸🏽",
        },
        "1F3FE": {
          k: "person_doing_cartwheel-1F3FE",
          n: "person_doing_cartwheel",
          e: "🤸🏾",
        },
        "1F3FF": {
          k: "person_doing_cartwheel-1F3FF",
          n: "person_doing_cartwheel",
          e: "🤸🏿",
        },
      },
    },
    {
      n: ["man-cartwheeling"],
      e: "🤸‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-cartwheeling-1F3FB",
          n: "man-cartwheeling",
          e: "🤸🏻‍♂️",
        },
        "1F3FC": {
          k: "man-cartwheeling-1F3FC",
          n: "man-cartwheeling",
          e: "🤸🏼‍♂️",
        },
        "1F3FD": {
          k: "man-cartwheeling-1F3FD",
          n: "man-cartwheeling",
          e: "🤸🏽‍♂️",
        },
        "1F3FE": {
          k: "man-cartwheeling-1F3FE",
          n: "man-cartwheeling",
          e: "🤸🏾‍♂️",
        },
        "1F3FF": {
          k: "man-cartwheeling-1F3FF",
          n: "man-cartwheeling",
          e: "🤸🏿‍♂️",
        },
      },
    },
    {
      n: ["woman-cartwheeling"],
      e: "🤸‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-cartwheeling-1F3FB",
          n: "woman-cartwheeling",
          e: "🤸🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-cartwheeling-1F3FC",
          n: "woman-cartwheeling",
          e: "🤸🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-cartwheeling-1F3FD",
          n: "woman-cartwheeling",
          e: "🤸🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-cartwheeling-1F3FE",
          n: "woman-cartwheeling",
          e: "🤸🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-cartwheeling-1F3FF",
          n: "woman-cartwheeling",
          e: "🤸🏿‍♀️",
        },
      },
    },
    { n: ["wrestlers"], e: "🤼", c: 1 },
    { n: ["man-wrestling"], e: "🤼‍♂️", c: 1 },
    { n: ["woman-wrestling"], e: "🤼‍♀️", c: 1 },
    {
      n: ["water_polo"],
      e: "🤽",
      c: 1,
      v: {
        "1F3FB": { k: "water_polo-1F3FB", n: "water_polo", e: "🤽🏻" },
        "1F3FC": { k: "water_polo-1F3FC", n: "water_polo", e: "🤽🏼" },
        "1F3FD": { k: "water_polo-1F3FD", n: "water_polo", e: "🤽🏽" },
        "1F3FE": { k: "water_polo-1F3FE", n: "water_polo", e: "🤽🏾" },
        "1F3FF": { k: "water_polo-1F3FF", n: "water_polo", e: "🤽🏿" },
      },
    },
    {
      n: ["man-playing-water-polo"],
      e: "🤽‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-playing-water-polo-1F3FB",
          n: "man-playing-water-polo",
          e: "🤽🏻‍♂️",
        },
        "1F3FC": {
          k: "man-playing-water-polo-1F3FC",
          n: "man-playing-water-polo",
          e: "🤽🏼‍♂️",
        },
        "1F3FD": {
          k: "man-playing-water-polo-1F3FD",
          n: "man-playing-water-polo",
          e: "🤽🏽‍♂️",
        },
        "1F3FE": {
          k: "man-playing-water-polo-1F3FE",
          n: "man-playing-water-polo",
          e: "🤽🏾‍♂️",
        },
        "1F3FF": {
          k: "man-playing-water-polo-1F3FF",
          n: "man-playing-water-polo",
          e: "🤽🏿‍♂️",
        },
      },
    },
    {
      n: ["woman-playing-water-polo"],
      e: "🤽‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-playing-water-polo-1F3FB",
          n: "woman-playing-water-polo",
          e: "🤽🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-playing-water-polo-1F3FC",
          n: "woman-playing-water-polo",
          e: "🤽🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-playing-water-polo-1F3FD",
          n: "woman-playing-water-polo",
          e: "🤽🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-playing-water-polo-1F3FE",
          n: "woman-playing-water-polo",
          e: "🤽🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-playing-water-polo-1F3FF",
          n: "woman-playing-water-polo",
          e: "🤽🏿‍♀️",
        },
      },
    },
    {
      n: ["handball"],
      e: "🤾",
      c: 1,
      v: {
        "1F3FB": { k: "handball-1F3FB", n: "handball", e: "🤾🏻" },
        "1F3FC": { k: "handball-1F3FC", n: "handball", e: "🤾🏼" },
        "1F3FD": { k: "handball-1F3FD", n: "handball", e: "🤾🏽" },
        "1F3FE": { k: "handball-1F3FE", n: "handball", e: "🤾🏾" },
        "1F3FF": { k: "handball-1F3FF", n: "handball", e: "🤾🏿" },
      },
    },
    {
      n: ["man-playing-handball"],
      e: "🤾‍♂️",
      c: 1,
      v: {
        "1F3FB": {
          k: "man-playing-handball-1F3FB",
          n: "man-playing-handball",
          e: "🤾🏻‍♂️",
        },
        "1F3FC": {
          k: "man-playing-handball-1F3FC",
          n: "man-playing-handball",
          e: "🤾🏼‍♂️",
        },
        "1F3FD": {
          k: "man-playing-handball-1F3FD",
          n: "man-playing-handball",
          e: "🤾🏽‍♂️",
        },
        "1F3FE": {
          k: "man-playing-handball-1F3FE",
          n: "man-playing-handball",
          e: "🤾🏾‍♂️",
        },
        "1F3FF": {
          k: "man-playing-handball-1F3FF",
          n: "man-playing-handball",
          e: "🤾🏿‍♂️",
        },
      },
    },
    {
      n: ["woman-playing-handball"],
      e: "🤾‍♀️",
      c: 1,
      v: {
        "1F3FB": {
          k: "woman-playing-handball-1F3FB",
          n: "woman-playing-handball",
          e: "🤾🏻‍♀️",
        },
        "1F3FC": {
          k: "woman-playing-handball-1F3FC",
          n: "woman-playing-handball",
          e: "🤾🏼‍♀️",
        },
        "1F3FD": {
          k: "woman-playing-handball-1F3FD",
          n: "woman-playing-handball",
          e: "🤾🏽‍♀️",
        },
        "1F3FE": {
          k: "woman-playing-handball-1F3FE",
          n: "woman-playing-handball",
          e: "🤾🏾‍♀️",
        },
        "1F3FF": {
          k: "woman-playing-handball-1F3FF",
          n: "woman-playing-handball",
          e: "🤾🏿‍♀️",
        },
      },
    },
    {
      n: ["juggling"],
      e: "🤹",
      c: 1,
      v: {
        "1F3FB": { k: "juggling-1F3FB", n: "juggling", e: "🤹🏻" },
        "1F3FC": { k: "juggling-1F3FC", n: "juggling", e: "🤹🏼" },
        "1F3FD": { k: "juggling-1F3FD", n: "juggling", e: "🤹🏽" },
        "1F3FE": { k: "juggling-1F3FE", n: "juggling", e: "🤹🏾" },
        "1F3FF": { k: "juggling-1F3FF", n: "juggling", e: "🤹🏿" },
      },
    },
    {
      n: ["man-juggling"],
      e: "🤹‍♂️",
      c: 1,
      v: {
        "1F3FB": { k: "man-juggling-1F3FB", n: "man-juggling", e: "🤹🏻‍♂️" },
        "1F3FC": { k: "man-juggling-1F3FC", n: "man-juggling", e: "🤹🏼‍♂️" },
        "1F3FD": { k: "man-juggling-1F3FD", n: "man-juggling", e: "🤹🏽‍♂️" },
        "1F3FE": { k: "man-juggling-1F3FE", n: "man-juggling", e: "🤹🏾‍♂️" },
        "1F3FF": { k: "man-juggling-1F3FF", n: "man-juggling", e: "🤹🏿‍♂️" },
      },
    },
    {
      n: ["woman-juggling"],
      e: "🤹‍♀️",
      c: 1,
      v: {
        "1F3FB": { k: "woman-juggling-1F3FB", n: "woman-juggling", e: "🤹🏻‍♀️" },
        "1F3FC": { k: "woman-juggling-1F3FC", n: "woman-juggling", e: "🤹🏼‍♀️" },
        "1F3FD": { k: "woman-juggling-1F3FD", n: "woman-juggling", e: "🤹🏽‍♀️" },
        "1F3FE": { k: "woman-juggling-1F3FE", n: "woman-juggling", e: "🤹🏾‍♀️" },
        "1F3FF": { k: "woman-juggling-1F3FF", n: "woman-juggling", e: "🤹🏿‍♀️" },
      },
    },
    { n: ["couple", "man_and_woman_holding_hands"], e: "👫", c: 1 },
    { n: ["two_men_holding_hands"], e: "👬", c: 1 },
    { n: ["two_women_holding_hands"], e: "👭", c: 1 },
    { n: ["couplekiss"], e: "💏", c: 1 },
    { n: ["woman-kiss-man"], e: "👩‍❤️‍💋‍👨", c: 1 },
    { n: ["man-kiss-man"], e: "👨‍❤️‍💋‍👨", c: 1 },
    { n: ["woman-kiss-woman"], e: "👩‍❤️‍💋‍👩", c: 1 },
    { n: ["couple_with_heart"], e: "💑", c: 1 },
    { n: ["woman-heart-man"], e: "👩‍❤️‍👨", c: 1 },
    { n: ["man-heart-man"], e: "👨‍❤️‍👨", c: 1 },
    { n: ["woman-heart-woman"], e: "👩‍❤️‍👩", c: 1 },
    { n: ["family", "man-woman-boy"], e: "👪", c: 1 },
    { n: ["man-woman-boy", "family"], e: "👨‍👩‍👦", c: 1 },
    { n: ["man-woman-girl"], e: "👨‍👩‍👧", c: 1 },
    { n: ["man-woman-girl-boy"], e: "👨‍👩‍👧‍👦", c: 1 },
    { n: ["man-woman-boy-boy"], e: "👨‍👩‍👦‍👦", c: 1 },
    { n: ["man-woman-girl-girl"], e: "👨‍👩‍👧‍👧", c: 1 },
    { n: ["man-man-boy"], e: "👨‍👨‍👦", c: 1 },
    { n: ["man-man-girl"], e: "👨‍👨‍👧", c: 1 },
    { n: ["man-man-girl-boy"], e: "👨‍👨‍👧‍👦", c: 1 },
    { n: ["man-man-boy-boy"], e: "👨‍👨‍👦‍👦", c: 1 },
    { n: ["man-man-girl-girl"], e: "👨‍👨‍👧‍👧", c: 1 },
    { n: ["woman-woman-boy"], e: "👩‍👩‍👦", c: 1 },
    { n: ["woman-woman-girl"], e: "👩‍👩‍👧", c: 1 },
    { n: ["woman-woman-girl-boy"], e: "👩‍👩‍👧‍👦", c: 1 },
    { n: ["woman-woman-boy-boy"], e: "👩‍👩‍👦‍👦", c: 1 },
    { n: ["woman-woman-girl-girl"], e: "👩‍👩‍👧‍👧", c: 1 },
    { n: ["man-boy"], e: "👨‍👦", c: 1 },
    { n: ["man-boy-boy"], e: "👨‍👦‍👦", c: 1 },
    { n: ["man-girl"], e: "👨‍👧", c: 1 },
    { n: ["man-girl-boy"], e: "👨‍👧‍👦", c: 1 },
    { n: ["man-girl-girl"], e: "👨‍👧‍👧", c: 1 },
    { n: ["woman-boy"], e: "👩‍👦", c: 1 },
    { n: ["woman-boy-boy"], e: "👩‍👦‍👦", c: 1 },
    { n: ["woman-girl"], e: "👩‍👧", c: 1 },
    { n: ["woman-girl-boy"], e: "👩‍👧‍👦", c: 1 },
    { n: ["woman-girl-girl"], e: "👩‍👧‍👧", c: 1 },
    {
      n: ["selfie"],
      e: "🤳",
      c: 1,
      v: {
        "1F3FB": { k: "selfie-1F3FB", n: "selfie", e: "🤳🏻" },
        "1F3FC": { k: "selfie-1F3FC", n: "selfie", e: "🤳🏼" },
        "1F3FD": { k: "selfie-1F3FD", n: "selfie", e: "🤳🏽" },
        "1F3FE": { k: "selfie-1F3FE", n: "selfie", e: "🤳🏾" },
        "1F3FF": { k: "selfie-1F3FF", n: "selfie", e: "🤳🏿" },
      },
    },
    {
      n: ["muscle"],
      e: "💪",
      c: 1,
      v: {
        "1F3FB": { k: "muscle-1F3FB", n: "muscle", e: "💪🏻" },
        "1F3FC": { k: "muscle-1F3FC", n: "muscle", e: "💪🏼" },
        "1F3FD": { k: "muscle-1F3FD", n: "muscle", e: "💪🏽" },
        "1F3FE": { k: "muscle-1F3FE", n: "muscle", e: "💪🏾" },
        "1F3FF": { k: "muscle-1F3FF", n: "muscle", e: "💪🏿" },
      },
    },
    {
      n: ["point_left"],
      e: "👈",
      c: 1,
      v: {
        "1F3FB": { k: "point_left-1F3FB", n: "point_left", e: "👈🏻" },
        "1F3FC": { k: "point_left-1F3FC", n: "point_left", e: "👈🏼" },
        "1F3FD": { k: "point_left-1F3FD", n: "point_left", e: "👈🏽" },
        "1F3FE": { k: "point_left-1F3FE", n: "point_left", e: "👈🏾" },
        "1F3FF": { k: "point_left-1F3FF", n: "point_left", e: "👈🏿" },
      },
    },
    {
      n: ["point_right"],
      e: "👉",
      c: 1,
      v: {
        "1F3FB": { k: "point_right-1F3FB", n: "point_right", e: "👉🏻" },
        "1F3FC": { k: "point_right-1F3FC", n: "point_right", e: "👉🏼" },
        "1F3FD": { k: "point_right-1F3FD", n: "point_right", e: "👉🏽" },
        "1F3FE": { k: "point_right-1F3FE", n: "point_right", e: "👉🏾" },
        "1F3FF": { k: "point_right-1F3FF", n: "point_right", e: "👉🏿" },
      },
    },
    {
      n: ["point_up"],
      e: "☝️",
      c: 1,
      v: {
        "1F3FB": { k: "point_up-1F3FB", n: "point_up", e: "☝🏻" },
        "1F3FC": { k: "point_up-1F3FC", n: "point_up", e: "☝🏼" },
        "1F3FD": { k: "point_up-1F3FD", n: "point_up", e: "☝🏽" },
        "1F3FE": { k: "point_up-1F3FE", n: "point_up", e: "☝🏾" },
        "1F3FF": { k: "point_up-1F3FF", n: "point_up", e: "☝🏿" },
      },
    },
    {
      n: ["point_up_2"],
      e: "👆",
      c: 1,
      v: {
        "1F3FB": { k: "point_up_2-1F3FB", n: "point_up_2", e: "👆🏻" },
        "1F3FC": { k: "point_up_2-1F3FC", n: "point_up_2", e: "👆🏼" },
        "1F3FD": { k: "point_up_2-1F3FD", n: "point_up_2", e: "👆🏽" },
        "1F3FE": { k: "point_up_2-1F3FE", n: "point_up_2", e: "👆🏾" },
        "1F3FF": { k: "point_up_2-1F3FF", n: "point_up_2", e: "👆🏿" },
      },
    },
    {
      n: ["middle_finger", "reversed_hand_with_middle_finger_extended"],
      e: "🖕",
      c: 1,
      v: {
        "1F3FB": { k: "middle_finger-1F3FB", n: "middle_finger", e: "🖕🏻" },
        "1F3FC": { k: "middle_finger-1F3FC", n: "middle_finger", e: "🖕🏼" },
        "1F3FD": { k: "middle_finger-1F3FD", n: "middle_finger", e: "🖕🏽" },
        "1F3FE": { k: "middle_finger-1F3FE", n: "middle_finger", e: "🖕🏾" },
        "1F3FF": { k: "middle_finger-1F3FF", n: "middle_finger", e: "🖕🏿" },
      },
    },
    {
      n: ["point_down"],
      e: "👇",
      c: 1,
      v: {
        "1F3FB": { k: "point_down-1F3FB", n: "point_down", e: "👇🏻" },
        "1F3FC": { k: "point_down-1F3FC", n: "point_down", e: "👇🏼" },
        "1F3FD": { k: "point_down-1F3FD", n: "point_down", e: "👇🏽" },
        "1F3FE": { k: "point_down-1F3FE", n: "point_down", e: "👇🏾" },
        "1F3FF": { k: "point_down-1F3FF", n: "point_down", e: "👇🏿" },
      },
    },
    {
      n: ["v"],
      e: "✌️",
      c: 1,
      v: {
        "1F3FB": { k: "v-1F3FB", n: "v", e: "✌🏻" },
        "1F3FC": { k: "v-1F3FC", n: "v", e: "✌🏼" },
        "1F3FD": { k: "v-1F3FD", n: "v", e: "✌🏽" },
        "1F3FE": { k: "v-1F3FE", n: "v", e: "✌🏾" },
        "1F3FF": { k: "v-1F3FF", n: "v", e: "✌🏿" },
      },
    },
    {
      n: ["crossed_fingers", "hand_with_index_and_middle_fingers_crossed"],
      e: "🤞",
      c: 1,
      v: {
        "1F3FB": { k: "crossed_fingers-1F3FB", n: "crossed_fingers", e: "🤞🏻" },
        "1F3FC": { k: "crossed_fingers-1F3FC", n: "crossed_fingers", e: "🤞🏼" },
        "1F3FD": { k: "crossed_fingers-1F3FD", n: "crossed_fingers", e: "🤞🏽" },
        "1F3FE": { k: "crossed_fingers-1F3FE", n: "crossed_fingers", e: "🤞🏾" },
        "1F3FF": { k: "crossed_fingers-1F3FF", n: "crossed_fingers", e: "🤞🏿" },
      },
    },
    {
      n: ["spock-hand"],
      e: "🖖",
      c: 1,
      v: {
        "1F3FB": { k: "spock-hand-1F3FB", n: "spock-hand", e: "🖖🏻" },
        "1F3FC": { k: "spock-hand-1F3FC", n: "spock-hand", e: "🖖🏼" },
        "1F3FD": { k: "spock-hand-1F3FD", n: "spock-hand", e: "🖖🏽" },
        "1F3FE": { k: "spock-hand-1F3FE", n: "spock-hand", e: "🖖🏾" },
        "1F3FF": { k: "spock-hand-1F3FF", n: "spock-hand", e: "🖖🏿" },
      },
    },
    {
      n: ["the_horns", "sign_of_the_horns"],
      e: "🤘",
      c: 1,
      v: {
        "1F3FB": { k: "the_horns-1F3FB", n: "the_horns", e: "🤘🏻" },
        "1F3FC": { k: "the_horns-1F3FC", n: "the_horns", e: "🤘🏼" },
        "1F3FD": { k: "the_horns-1F3FD", n: "the_horns", e: "🤘🏽" },
        "1F3FE": { k: "the_horns-1F3FE", n: "the_horns", e: "🤘🏾" },
        "1F3FF": { k: "the_horns-1F3FF", n: "the_horns", e: "🤘🏿" },
      },
    },
    {
      n: ["call_me_hand"],
      e: "🤙",
      c: 1,
      v: {
        "1F3FB": { k: "call_me_hand-1F3FB", n: "call_me_hand", e: "🤙🏻" },
        "1F3FC": { k: "call_me_hand-1F3FC", n: "call_me_hand", e: "🤙🏼" },
        "1F3FD": { k: "call_me_hand-1F3FD", n: "call_me_hand", e: "🤙🏽" },
        "1F3FE": { k: "call_me_hand-1F3FE", n: "call_me_hand", e: "🤙🏾" },
        "1F3FF": { k: "call_me_hand-1F3FF", n: "call_me_hand", e: "🤙🏿" },
      },
    },
    {
      n: ["raised_hand_with_fingers_splayed"],
      e: "🖐️",
      c: 1,
      v: {
        "1F3FB": {
          k: "raised_hand_with_fingers_splayed-1F3FB",
          n: "raised_hand_with_fingers_splayed",
          e: "🖐🏻",
        },
        "1F3FC": {
          k: "raised_hand_with_fingers_splayed-1F3FC",
          n: "raised_hand_with_fingers_splayed",
          e: "🖐🏼",
        },
        "1F3FD": {
          k: "raised_hand_with_fingers_splayed-1F3FD",
          n: "raised_hand_with_fingers_splayed",
          e: "🖐🏽",
        },
        "1F3FE": {
          k: "raised_hand_with_fingers_splayed-1F3FE",
          n: "raised_hand_with_fingers_splayed",
          e: "🖐🏾",
        },
        "1F3FF": {
          k: "raised_hand_with_fingers_splayed-1F3FF",
          n: "raised_hand_with_fingers_splayed",
          e: "🖐🏿",
        },
      },
    },
    {
      n: ["hand", "raised_hand"],
      e: "✋",
      c: 1,
      v: {
        "1F3FB": { k: "hand-1F3FB", n: "hand", e: "✋🏻" },
        "1F3FC": { k: "hand-1F3FC", n: "hand", e: "✋🏼" },
        "1F3FD": { k: "hand-1F3FD", n: "hand", e: "✋🏽" },
        "1F3FE": { k: "hand-1F3FE", n: "hand", e: "✋🏾" },
        "1F3FF": { k: "hand-1F3FF", n: "hand", e: "✋🏿" },
      },
    },
    {
      n: ["ok_hand"],
      e: "👌",
      c: 1,
      v: {
        "1F3FB": { k: "ok_hand-1F3FB", n: "ok_hand", e: "👌🏻" },
        "1F3FC": { k: "ok_hand-1F3FC", n: "ok_hand", e: "👌🏼" },
        "1F3FD": { k: "ok_hand-1F3FD", n: "ok_hand", e: "👌🏽" },
        "1F3FE": { k: "ok_hand-1F3FE", n: "ok_hand", e: "👌🏾" },
        "1F3FF": { k: "ok_hand-1F3FF", n: "ok_hand", e: "👌🏿" },
      },
    },
    {
      n: ["+1", "thumbsup"],
      e: "👍",
      c: 1,
      v: {
        "1F3FB": { k: "+1-1F3FB", n: "+1", e: "👍🏻" },
        "1F3FC": { k: "+1-1F3FC", n: "+1", e: "👍🏼" },
        "1F3FD": { k: "+1-1F3FD", n: "+1", e: "👍🏽" },
        "1F3FE": { k: "+1-1F3FE", n: "+1", e: "👍🏾" },
        "1F3FF": { k: "+1-1F3FF", n: "+1", e: "👍🏿" },
      },
    },
    {
      n: ["-1", "thumbsdown"],
      e: "👎",
      c: 1,
      v: {
        "1F3FB": { k: "-1-1F3FB", n: "-1", e: "👎🏻" },
        "1F3FC": { k: "-1-1F3FC", n: "-1", e: "👎🏼" },
        "1F3FD": { k: "-1-1F3FD", n: "-1", e: "👎🏽" },
        "1F3FE": { k: "-1-1F3FE", n: "-1", e: "👎🏾" },
        "1F3FF": { k: "-1-1F3FF", n: "-1", e: "👎🏿" },
      },
    },
    {
      n: ["fist"],
      e: "✊",
      c: 1,
      v: {
        "1F3FB": { k: "fist-1F3FB", n: "fist", e: "✊🏻" },
        "1F3FC": { k: "fist-1F3FC", n: "fist", e: "✊🏼" },
        "1F3FD": { k: "fist-1F3FD", n: "fist", e: "✊🏽" },
        "1F3FE": { k: "fist-1F3FE", n: "fist", e: "✊🏾" },
        "1F3FF": { k: "fist-1F3FF", n: "fist", e: "✊🏿" },
      },
    },
    {
      n: ["facepunch", "punch"],
      e: "👊",
      c: 1,
      v: {
        "1F3FB": { k: "facepunch-1F3FB", n: "facepunch", e: "👊🏻" },
        "1F3FC": { k: "facepunch-1F3FC", n: "facepunch", e: "👊🏼" },
        "1F3FD": { k: "facepunch-1F3FD", n: "facepunch", e: "👊🏽" },
        "1F3FE": { k: "facepunch-1F3FE", n: "facepunch", e: "👊🏾" },
        "1F3FF": { k: "facepunch-1F3FF", n: "facepunch", e: "👊🏿" },
      },
    },
    {
      n: ["left-facing_fist"],
      e: "🤛",
      c: 1,
      v: {
        "1F3FB": {
          k: "left-facing_fist-1F3FB",
          n: "left-facing_fist",
          e: "🤛🏻",
        },
        "1F3FC": {
          k: "left-facing_fist-1F3FC",
          n: "left-facing_fist",
          e: "🤛🏼",
        },
        "1F3FD": {
          k: "left-facing_fist-1F3FD",
          n: "left-facing_fist",
          e: "🤛🏽",
        },
        "1F3FE": {
          k: "left-facing_fist-1F3FE",
          n: "left-facing_fist",
          e: "🤛🏾",
        },
        "1F3FF": {
          k: "left-facing_fist-1F3FF",
          n: "left-facing_fist",
          e: "🤛🏿",
        },
      },
    },
    {
      n: ["right-facing_fist"],
      e: "🤜",
      c: 1,
      v: {
        "1F3FB": {
          k: "right-facing_fist-1F3FB",
          n: "right-facing_fist",
          e: "🤜🏻",
        },
        "1F3FC": {
          k: "right-facing_fist-1F3FC",
          n: "right-facing_fist",
          e: "🤜🏼",
        },
        "1F3FD": {
          k: "right-facing_fist-1F3FD",
          n: "right-facing_fist",
          e: "🤜🏽",
        },
        "1F3FE": {
          k: "right-facing_fist-1F3FE",
          n: "right-facing_fist",
          e: "🤜🏾",
        },
        "1F3FF": {
          k: "right-facing_fist-1F3FF",
          n: "right-facing_fist",
          e: "🤜🏿",
        },
      },
    },
    {
      n: ["raised_back_of_hand"],
      e: "🤚",
      c: 1,
      v: {
        "1F3FB": {
          k: "raised_back_of_hand-1F3FB",
          n: "raised_back_of_hand",
          e: "🤚🏻",
        },
        "1F3FC": {
          k: "raised_back_of_hand-1F3FC",
          n: "raised_back_of_hand",
          e: "🤚🏼",
        },
        "1F3FD": {
          k: "raised_back_of_hand-1F3FD",
          n: "raised_back_of_hand",
          e: "🤚🏽",
        },
        "1F3FE": {
          k: "raised_back_of_hand-1F3FE",
          n: "raised_back_of_hand",
          e: "🤚🏾",
        },
        "1F3FF": {
          k: "raised_back_of_hand-1F3FF",
          n: "raised_back_of_hand",
          e: "🤚🏿",
        },
      },
    },
    {
      n: ["wave"],
      e: "👋",
      c: 1,
      v: {
        "1F3FB": { k: "wave-1F3FB", n: "wave", e: "👋🏻" },
        "1F3FC": { k: "wave-1F3FC", n: "wave", e: "👋🏼" },
        "1F3FD": { k: "wave-1F3FD", n: "wave", e: "👋🏽" },
        "1F3FE": { k: "wave-1F3FE", n: "wave", e: "👋🏾" },
        "1F3FF": { k: "wave-1F3FF", n: "wave", e: "👋🏿" },
      },
    },
    {
      n: ["i_love_you_hand_sign"],
      e: "🤟",
      c: 1,
      v: {
        "1F3FB": {
          k: "i_love_you_hand_sign-1F3FB",
          n: "i_love_you_hand_sign",
          e: "🤟🏻",
        },
        "1F3FC": {
          k: "i_love_you_hand_sign-1F3FC",
          n: "i_love_you_hand_sign",
          e: "🤟🏼",
        },
        "1F3FD": {
          k: "i_love_you_hand_sign-1F3FD",
          n: "i_love_you_hand_sign",
          e: "🤟🏽",
        },
        "1F3FE": {
          k: "i_love_you_hand_sign-1F3FE",
          n: "i_love_you_hand_sign",
          e: "🤟🏾",
        },
        "1F3FF": {
          k: "i_love_you_hand_sign-1F3FF",
          n: "i_love_you_hand_sign",
          e: "🤟🏿",
        },
      },
    },
    {
      n: ["writing_hand"],
      e: "✍️",
      c: 1,
      v: {
        "1F3FB": { k: "writing_hand-1F3FB", n: "writing_hand", e: "✍🏻" },
        "1F3FC": { k: "writing_hand-1F3FC", n: "writing_hand", e: "✍🏼" },
        "1F3FD": { k: "writing_hand-1F3FD", n: "writing_hand", e: "✍🏽" },
        "1F3FE": { k: "writing_hand-1F3FE", n: "writing_hand", e: "✍🏾" },
        "1F3FF": { k: "writing_hand-1F3FF", n: "writing_hand", e: "✍🏿" },
      },
    },
    {
      n: ["clap"],
      e: "👏",
      c: 1,
      v: {
        "1F3FB": { k: "clap-1F3FB", n: "clap", e: "👏🏻" },
        "1F3FC": { k: "clap-1F3FC", n: "clap", e: "👏🏼" },
        "1F3FD": { k: "clap-1F3FD", n: "clap", e: "👏🏽" },
        "1F3FE": { k: "clap-1F3FE", n: "clap", e: "👏🏾" },
        "1F3FF": { k: "clap-1F3FF", n: "clap", e: "👏🏿" },
      },
    },
    {
      n: ["open_hands"],
      e: "👐",
      c: 1,
      v: {
        "1F3FB": { k: "open_hands-1F3FB", n: "open_hands", e: "👐🏻" },
        "1F3FC": { k: "open_hands-1F3FC", n: "open_hands", e: "👐🏼" },
        "1F3FD": { k: "open_hands-1F3FD", n: "open_hands", e: "👐🏽" },
        "1F3FE": { k: "open_hands-1F3FE", n: "open_hands", e: "👐🏾" },
        "1F3FF": { k: "open_hands-1F3FF", n: "open_hands", e: "👐🏿" },
      },
    },
    {
      n: ["raised_hands"],
      e: "🙌",
      c: 1,
      v: {
        "1F3FB": { k: "raised_hands-1F3FB", n: "raised_hands", e: "🙌🏻" },
        "1F3FC": { k: "raised_hands-1F3FC", n: "raised_hands", e: "🙌🏼" },
        "1F3FD": { k: "raised_hands-1F3FD", n: "raised_hands", e: "🙌🏽" },
        "1F3FE": { k: "raised_hands-1F3FE", n: "raised_hands", e: "🙌🏾" },
        "1F3FF": { k: "raised_hands-1F3FF", n: "raised_hands", e: "🙌🏿" },
      },
    },
    {
      n: ["palms_up_together"],
      e: "🤲",
      c: 1,
      v: {
        "1F3FB": {
          k: "palms_up_together-1F3FB",
          n: "palms_up_together",
          e: "🤲🏻",
        },
        "1F3FC": {
          k: "palms_up_together-1F3FC",
          n: "palms_up_together",
          e: "🤲🏼",
        },
        "1F3FD": {
          k: "palms_up_together-1F3FD",
          n: "palms_up_together",
          e: "🤲🏽",
        },
        "1F3FE": {
          k: "palms_up_together-1F3FE",
          n: "palms_up_together",
          e: "🤲🏾",
        },
        "1F3FF": {
          k: "palms_up_together-1F3FF",
          n: "palms_up_together",
          e: "🤲🏿",
        },
      },
    },
    {
      n: ["pray"],
      e: "🙏",
      c: 1,
      v: {
        "1F3FB": { k: "pray-1F3FB", n: "pray", e: "🙏🏻" },
        "1F3FC": { k: "pray-1F3FC", n: "pray", e: "🙏🏼" },
        "1F3FD": { k: "pray-1F3FD", n: "pray", e: "🙏🏽" },
        "1F3FE": { k: "pray-1F3FE", n: "pray", e: "🙏🏾" },
        "1F3FF": { k: "pray-1F3FF", n: "pray", e: "🙏🏿" },
      },
    },
    { n: ["handshake"], e: "🤝", c: 1 },
    {
      n: ["nail_care"],
      e: "💅",
      c: 1,
      v: {
        "1F3FB": { k: "nail_care-1F3FB", n: "nail_care", e: "💅🏻" },
        "1F3FC": { k: "nail_care-1F3FC", n: "nail_care", e: "💅🏼" },
        "1F3FD": { k: "nail_care-1F3FD", n: "nail_care", e: "💅🏽" },
        "1F3FE": { k: "nail_care-1F3FE", n: "nail_care", e: "💅🏾" },
        "1F3FF": { k: "nail_care-1F3FF", n: "nail_care", e: "💅🏿" },
      },
    },
    {
      n: ["ear"],
      e: "👂",
      c: 1,
      v: {
        "1F3FB": { k: "ear-1F3FB", n: "ear", e: "👂🏻" },
        "1F3FC": { k: "ear-1F3FC", n: "ear", e: "👂🏼" },
        "1F3FD": { k: "ear-1F3FD", n: "ear", e: "👂🏽" },
        "1F3FE": { k: "ear-1F3FE", n: "ear", e: "👂🏾" },
        "1F3FF": { k: "ear-1F3FF", n: "ear", e: "👂🏿" },
      },
    },
    {
      n: ["nose"],
      e: "👃",
      c: 1,
      v: {
        "1F3FB": { k: "nose-1F3FB", n: "nose", e: "👃🏻" },
        "1F3FC": { k: "nose-1F3FC", n: "nose", e: "👃🏼" },
        "1F3FD": { k: "nose-1F3FD", n: "nose", e: "👃🏽" },
        "1F3FE": { k: "nose-1F3FE", n: "nose", e: "👃🏾" },
        "1F3FF": { k: "nose-1F3FF", n: "nose", e: "👃🏿" },
      },
    },
    { n: ["footprints"], e: "👣", c: 1 },
    { n: ["eyes"], e: "👀", c: 1 },
    { n: ["eye"], e: "👁️", c: 1 },
    { n: ["eye-in-speech-bubble"], e: "👁️‍🗨️", c: 1 },
    { n: ["brain"], e: "🧠", c: 1 },
    { n: ["tongue"], e: "👅", c: 1 },
    { n: ["lips"], e: "👄", c: 1 },
    { n: ["kiss"], e: "💋", c: 1 },
    { n: ["cupid"], e: "💘", c: 1 },
    { n: ["heart"], e: "❤️", c: 1 },
    { n: ["heartbeat"], e: "💓", c: 1 },
    { n: ["broken_heart"], e: "💔", c: 1 },
    { n: ["two_hearts"], e: "💕", c: 1 },
    { n: ["sparkling_heart"], e: "💖", c: 1 },
    { n: ["heartpulse"], e: "💗", c: 1 },
    { n: ["blue_heart"], e: "💙", c: 1 },
    { n: ["green_heart"], e: "💚", c: 1 },
    { n: ["yellow_heart"], e: "💛", c: 1 },
    { n: ["orange_heart"], e: "🧡", c: 1 },
    { n: ["purple_heart"], e: "💜", c: 1 },
    { n: ["black_heart"], e: "🖤", c: 1 },
    { n: ["gift_heart"], e: "💝", c: 1 },
    { n: ["revolving_hearts"], e: "💞", c: 1 },
    { n: ["heart_decoration"], e: "💟", c: 1 },
    { n: ["heavy_heart_exclamation_mark_ornament"], e: "❣️", c: 1 },
    { n: ["love_letter"], e: "💌", c: 1 },
    { n: ["zzz"], e: "💤", c: 1 },
    { n: ["anger"], e: "💢", c: 1 },
    { n: ["bomb"], e: "💣", c: 1 },
    { n: ["boom", "collision"], e: "💥", c: 1 },
    { n: ["sweat_drops"], e: "💦", c: 1 },
    { n: ["dash"], e: "💨", c: 1 },
    { n: ["dizzy"], e: "💫", c: 1 },
    { n: ["speech_balloon"], e: "💬", c: 1 },
    { n: ["left_speech_bubble"], e: "🗨️", c: 1 },
    { n: ["right_anger_bubble"], e: "🗯️", c: 1 },
    { n: ["thought_balloon"], e: "💭", c: 1 },
    { n: ["hole"], e: "🕳️", c: 1 },
    { n: ["eyeglasses"], e: "👓", c: 1 },
    { n: ["dark_sunglasses"], e: "🕶️", c: 1 },
    { n: ["necktie"], e: "👔", c: 1 },
    { n: ["shirt", "tshirt"], e: "👕", c: 1 },
    { n: ["jeans"], e: "👖", c: 1 },
    { n: ["scarf"], e: "🧣", c: 1 },
    { n: ["gloves"], e: "🧤", c: 1 },
    { n: ["coat"], e: "🧥", c: 1 },
    { n: ["socks"], e: "🧦", c: 1 },
    { n: ["dress"], e: "👗", c: 1 },
    { n: ["kimono"], e: "👘", c: 1 },
    { n: ["bikini"], e: "👙", c: 1 },
    { n: ["womans_clothes"], e: "👚", c: 1 },
    { n: ["purse"], e: "👛", c: 1 },
    { n: ["handbag"], e: "👜", c: 1 },
    { n: ["pouch"], e: "👝", c: 1 },
    { n: ["shopping_bags"], e: "🛍️", c: 1 },
    { n: ["school_satchel"], e: "🎒", c: 1 },
    { n: ["mans_shoe", "shoe"], e: "👞", c: 1 },
    { n: ["athletic_shoe"], e: "👟", c: 1 },
    { n: ["high_heel"], e: "👠", c: 1 },
    { n: ["sandal"], e: "👡", c: 1 },
    { n: ["boot"], e: "👢", c: 1 },
    { n: ["crown"], e: "👑", c: 1 },
    { n: ["womans_hat"], e: "👒", c: 1 },
    { n: ["tophat"], e: "🎩", c: 1 },
    { n: ["mortar_board"], e: "🎓", c: 1 },
    { n: ["billed_cap"], e: "🧢", c: 1 },
    { n: ["helmet_with_white_cross"], e: "⛑️", c: 1 },
    { n: ["prayer_beads"], e: "📿", c: 1 },
    { n: ["lipstick"], e: "💄", c: 1 },
    { n: ["ring"], e: "💍", c: 1 },
    { n: ["gem"], e: "💎", c: 1 },
  ];

  var EMOJI = "emoji";
  var SHOW_TABS = "showTabs";
  var HIDE_TABS = "hideTabs";
  var SHOW_SEARCH_RESULTS = "showSearchResults";
  var SHOW_PREVIEW = "showPreview";
  var HIDE_PREVIEW = "hidePreview";
  var HIDE_VARIANT_POPUP = "hideVariantPopup";

  function createElement(tagName, className) {
    var element = document.createElement(tagName);
    if (className) {
      element.className = className;
    }
    return element;
  }
  function empty(element) {
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }
  function getEmojiName(emoji) {
    return typeof emoji.n === "string" ? emoji.n : emoji.n[0];
  }

  var CLASS_PREVIEW = "emoji-picker__preview";
  var CLASS_PREVIEW_EMOJI = "emoji-picker__preview-emoji";
  var CLASS_PREVIEW_NAME = "emoji-picker__preview-name";
  var EmojiPreview = /*#__PURE__*/ (function () {
    function EmojiPreview(events) {
      _classCallCheck(this, EmojiPreview);
      this.events = events;
    }
    _createClass(EmojiPreview, [
      {
        key: "render",
        value: function render() {
          var _this = this;
          var preview = createElement("div", CLASS_PREVIEW);
          this.emoji = createElement("div", CLASS_PREVIEW_EMOJI);
          preview.appendChild(this.emoji);
          this.name = createElement("div", CLASS_PREVIEW_NAME);
          preview.appendChild(this.name);
          this.events.on(SHOW_PREVIEW, function (emoji) {
            return _this.showPreview(emoji);
          });
          this.events.on(HIDE_PREVIEW, function () {
            return _this.hidePreview();
          });
          return preview;
        },
      },
      {
        key: "showPreview",
        value: function showPreview(emoji) {
          this.emoji.innerHTML = emoji.e;
          this.name.innerHTML = getEmojiName(emoji);
        },
      },
      {
        key: "hidePreview",
        value: function hidePreview() {
          this.emoji.innerHTML = "";
          this.name.innerHTML = "";
        },
      },
    ]);
    return EmojiPreview;
  })();

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }
  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true,
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);
      if (typeof Object.getOwnPropertySymbols === "function") {
        ownKeys = ownKeys.concat(
          Object.getOwnPropertySymbols(source).filter(function (sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          })
        );
      }
      ownKeys.forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    }
    return target;
  }
  function _slicedToArray(arr, i) {
    return (
      _arrayWithHoles(arr) ||
      _iterableToArrayLimit(arr, i) ||
      _nonIterableRest()
    );
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (
        var _i = arr[Symbol.iterator](), _s;
        !(_n = (_s = _i.next()).done);
        _n = true
      ) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  var noop = function noop() {};
  var _WINDOW = {};
  var _DOCUMENT = {};
  var _MUTATION_OBSERVER = null;
  var _PERFORMANCE = { mark: noop, measure: noop };
  try {
    if (typeof window !== "undefined") _WINDOW = window;
    if (typeof document !== "undefined") _DOCUMENT = document;
    if (typeof MutationObserver !== "undefined")
      _MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") _PERFORMANCE = performance;
  } catch (e) {}
  var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
  var WINDOW = _WINDOW;
  var DOCUMENT = _DOCUMENT;
  var PERFORMANCE = _PERFORMANCE;
  var IS_BROWSER = !!WINDOW.document;
  var IS_DOM =
    !!DOCUMENT.documentElement &&
    !!DOCUMENT.head &&
    typeof DOCUMENT.addEventListener === "function" &&
    typeof DOCUMENT.createElement === "function";
  var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
  var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
  var DEFAULT_FAMILY_PREFIX = "fa";
  var DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
  var DATA_FA_I2SVG = "data-fa-i2svg";
  var PRODUCTION = (function () {
    try {
      return process.env.NODE_ENV === "production";
    } catch (e) {
      return false;
    }
  })();
  var DUOTONE_CLASSES = {
    GROUP: "group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary",
  };
  var initial = WINDOW.FontAwesomeConfig || {};
  function getAttrConfig(attr) {
    var element = DOCUMENT.querySelector("script[" + attr + "]");
    if (element) {
      return element.getAttribute(attr);
    }
  }
  function coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    // For example <script data-search-pseudo-elements src="..."></script>
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
  }
  if (DOCUMENT && typeof DOCUMENT.querySelector === "function") {
    var attrs = [
      ["data-family-prefix", "familyPrefix"],
      ["data-replacement-class", "replacementClass"],
      ["data-auto-replace-svg", "autoReplaceSvg"],
      ["data-auto-add-css", "autoAddCss"],
      ["data-auto-a11y", "autoA11y"],
      ["data-search-pseudo-elements", "searchPseudoElements"],
      ["data-observe-mutations", "observeMutations"],
      ["data-mutate-approach", "mutateApproach"],
      ["data-keep-original-source", "keepOriginalSource"],
      ["data-measure-performance", "measurePerformance"],
      ["data-show-missing-icons", "showMissingIcons"],
    ];
    attrs.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];
      var val = coerce(getAttrConfig(attr));
      if (val !== undefined && val !== null) {
        initial[key] = val;
      }
    });
  }
  var _default = {
    familyPrefix: DEFAULT_FAMILY_PREFIX,
    replacementClass: DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true,
  };
  var _config = _objectSpread({}, _default, initial);
  if (!_config.autoReplaceSvg) _config.observeMutations = false;
  var config = _objectSpread({}, _config);
  WINDOW.FontAwesomeConfig = config;
  var w = WINDOW || {};
  if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
  if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
  if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
  if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
  var namespace = w[NAMESPACE_IDENTIFIER];
  var functions = [];
  var listener = function listener() {
    DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    loaded = 1;
    functions.map(function (fn) {
      return fn();
    });
  };
  var loaded = false;
  if (IS_DOM) {
    loaded = (DOCUMENT.documentElement.doScroll
      ? /^loaded|^c/
      : /^loaded|^i|^c/
    ).test(DOCUMENT.readyState);
    if (!loaded) DOCUMENT.addEventListener("DOMContentLoaded", listener);
  }
  var isNode =
    typeof global !== "undefined" &&
    typeof global.process !== "undefined" &&
    typeof global.process.emit === "function";
  var meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false,
  };
  function insertCss(css) {
    if (!css || !IS_DOM) {
      return;
    }
    var style = DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = DOCUMENT.head.childNodes;
    var beforeChild = null;
    for (var i = headChildren.length - 1; i > -1; i--) {
      var child = headChildren[i];
      var tagName = (child.tagName || "").toUpperCase();
      if (["STYLE", "LINK"].indexOf(tagName) > -1) {
        beforeChild = child;
      }
    }
    DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
  }
  var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  function nextUniqueId() {
    var size = 12;
    var id = "";
    while (size-- > 0) {
      id += idPool[(Math.random() * 62) | 0];
    }
    return id;
  }
  function htmlEscape(str) {
    return ""
      .concat(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }
  function joinAttributes(attributes) {
    return Object.keys(attributes || {})
      .reduce(function (acc, attributeName) {
        return (
          acc +
          ""
            .concat(attributeName, '="')
            .concat(htmlEscape(attributes[attributeName]), '" ')
        );
      }, "")
      .trim();
  }
  function joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function (acc, styleName) {
      return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
    }, "");
  }
  function transformIsMeaningful(transform) {
    return (
      transform.size !== meaninglessTransform.size ||
      transform.x !== meaninglessTransform.x ||
      transform.y !== meaninglessTransform.y ||
      transform.rotate !== meaninglessTransform.rotate ||
      transform.flipX ||
      transform.flipY
    );
  }
  function transformForSvg(_ref) {
    var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
    var outer = { transform: "translate(".concat(containerWidth / 2, " 256)") };
    var innerTranslate = "translate("
      .concat(transform.x * 32, ", ")
      .concat(transform.y * 32, ") ");
    var innerScale = "scale("
      .concat((transform.size / 16) * (transform.flipX ? -1 : 1), ", ")
      .concat((transform.size / 16) * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
      transform: ""
        .concat(innerTranslate, " ")
        .concat(innerScale, " ")
        .concat(innerRotate),
    };
    var path = {
      transform: "translate(".concat((iconWidth / 2) * -1, " -256)"),
    };
    return { outer: outer, inner: inner, path: path };
  }
  var ALL_SPACE = { x: 0, y: 0, width: "100%", height: "100%" };
  function fillBlack(abstract) {
    var force =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) {
      abstract.attributes.fill = "black";
    }
    return abstract;
  }
  function deGroup(abstract) {
    if (abstract.tag === "g") {
      return abstract.children;
    } else {
      return [abstract];
    }
  }
  function makeIconMasking(_ref) {
    var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      transform = _ref.transform;
    var mainWidth = main.width,
      mainPath = main.icon;
    var maskWidth = mask.width,
      maskPath = mask.icon;
    var trans = transformForSvg({
      transform: transform,
      containerWidth: maskWidth,
      iconWidth: mainWidth,
    });
    var maskRect = {
      tag: "rect",
      attributes: _objectSpread({}, ALL_SPACE, { fill: "white" }),
    };
    var maskInnerGroupChildrenMixin = mainPath.children
      ? { children: mainPath.children.map(fillBlack) }
      : {};
    var maskInnerGroup = {
      tag: "g",
      attributes: _objectSpread({}, trans.inner),
      children: [
        fillBlack(
          _objectSpread(
            {
              tag: mainPath.tag,
              attributes: _objectSpread({}, mainPath.attributes, trans.path),
            },
            maskInnerGroupChildrenMixin
          )
        ),
      ],
    };
    var maskOuterGroup = {
      tag: "g",
      attributes: _objectSpread({}, trans.outer),
      children: [maskInnerGroup],
    };
    var maskId = "mask-".concat(nextUniqueId());
    var clipId = "clip-".concat(nextUniqueId());
    var maskTag = {
      tag: "mask",
      attributes: _objectSpread({}, ALL_SPACE, {
        id: maskId,
        maskUnits: "userSpaceOnUse",
        maskContentUnits: "userSpaceOnUse",
      }),
      children: [maskRect, maskOuterGroup],
    };
    var defs = {
      tag: "defs",
      children: [
        {
          tag: "clipPath",
          attributes: { id: clipId },
          children: deGroup(maskPath),
        },
        maskTag,
      ],
    };
    children.push(defs, {
      tag: "rect",
      attributes: _objectSpread(
        {
          fill: "currentColor",
          "clip-path": "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")"),
        },
        ALL_SPACE
      ),
    });
    return { children: children, attributes: attributes };
  }
  function makeIconStandard(_ref) {
    var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;
    var styleString = joinStyles(styles);
    if (styleString.length > 0) {
      attributes["style"] = styleString;
    }
    if (transformIsMeaningful(transform)) {
      var trans = transformForSvg({
        transform: transform,
        containerWidth: main.width,
        iconWidth: main.width,
      });
      children.push({
        tag: "g",
        attributes: _objectSpread({}, trans.outer),
        children: [
          {
            tag: "g",
            attributes: _objectSpread({}, trans.inner),
            children: [
              {
                tag: main.icon.tag,
                children: main.icon.children,
                attributes: _objectSpread({}, main.icon.attributes, trans.path),
              },
            ],
          },
        ],
      });
    } else {
      children.push(main.icon);
    }
    return { children: children, attributes: attributes };
  }
  function asIcon(_ref) {
    var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;
    if (transformIsMeaningful(transform) && main.found && !mask.found) {
      var width = main.width,
        height = main.height;
      var offset = { x: width / height / 2, y: 0.5 };
      attributes["style"] = joinStyles(
        _objectSpread({}, styles, {
          "transform-origin": ""
            .concat(offset.x + transform.x / 16, "em ")
            .concat(offset.y + transform.y / 16, "em"),
        })
      );
    }
    return [{ tag: "svg", attributes: attributes, children: children }];
  }
  function asSymbol(_ref) {
    var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
    var id =
      symbol === true
        ? ""
            .concat(prefix, "-")
            .concat(config.familyPrefix, "-")
            .concat(iconName)
        : symbol;
    return [
      {
        tag: "svg",
        attributes: { style: "display: none;" },
        children: [
          {
            tag: "symbol",
            attributes: _objectSpread({}, attributes, { id: id }),
            children: children,
          },
        ],
      },
    ];
  }
  function makeInlineSvgAbstract(params) {
    var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;
    var widthClass = "fa-w-".concat(Math.ceil((width / height) * 16));
    var attrClass = [
      config.replacementClass,
      iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : "",
      widthClass,
    ]
      .filter(function (c) {
        return extra.classes.indexOf(c) === -1;
      })
      .concat(extra.classes)
      .join(" ");
    var content = {
      children: [],
      attributes: _objectSpread({}, extra.attributes, {
        "data-prefix": prefix,
        "data-icon": iconName,
        class: attrClass,
        role: extra.attributes.role || "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 ".concat(width, " ").concat(height),
      }),
    };
    if (watchable) {
      content.attributes[DATA_FA_I2SVG] = "";
    }
    if (title)
      content.children.push({
        tag: "title",
        attributes: {
          id:
            content.attributes["aria-labelledby"] ||
            "title-".concat(nextUniqueId()),
        },
        children: [title],
      });
    var args = _objectSpread({}, content, {
      prefix: prefix,
      iconName: iconName,
      main: main,
      mask: mask,
      transform: transform,
      symbol: symbol,
      styles: extra.styles,
    });
    var _ref2 =
        mask.found && main.found
          ? makeIconMasking(args)
          : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) {
      return asSymbol(args);
    } else {
      return asIcon(args);
    }
  }
  var noop$1 = function noop() {};
  var p =
    config.measurePerformance &&
    PERFORMANCE &&
    PERFORMANCE.mark &&
    PERFORMANCE.measure
      ? PERFORMANCE
      : { mark: noop$1, measure: noop$1 };
  /**
   * Internal helper to bind a function known to have 4 arguments
   * to a given context.
   */ var bindInternal4 = function bindInternal4(func, thisContext) {
    return function (a, b, c, d) {
      return func.call(thisContext, a, b, c, d);
    };
  };
  /**
   * # Reduce
   *
   * A fast object `.reduce()` implementation.
   *
   * @param  {Object}   subject      The object to reduce over.
   * @param  {Function} fn           The reducer function.
   * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
   * @param  {Object}   thisContext  The context for the reducer.
   * @return {mixed}                 The final result.
   */ var reduce = function fastReduceObject(
    subject,
    fn,
    initialValue,
    thisContext
  ) {
    var keys = Object.keys(subject),
      length = keys.length,
      iterator =
        thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;
    if (initialValue === undefined) {
      i = 1;
      result = subject[keys[0]];
    } else {
      i = 0;
      result = initialValue;
    }
    for (; i < length; i++) {
      key = keys[i];
      result = iterator(result, subject[key], key, subject);
    }
    return result;
  };
  function defineIcons(prefix, icons) {
    var params =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = Object.keys(icons).reduce(function (acc, iconName) {
      var icon = icons[iconName];
      var expanded = !!icon.icon;
      if (expanded) {
        acc[icon.iconName] = icon.icon;
      } else {
        acc[iconName] = icon;
      }
      return acc;
    }, {});
    if (typeof namespace.hooks.addPack === "function" && !skipHooks) {
      namespace.hooks.addPack(prefix, normalized);
    } else {
      namespace.styles[prefix] = _objectSpread(
        {},
        namespace.styles[prefix] || {},
        normalized
      );
    }
    /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll easy the upgrade process for our users by automatically defining
     * this as well.
     */ if (prefix === "fas") {
      defineIcons("fa", icons);
    }
  }
  var styles = namespace.styles,
    shims = namespace.shims;
  var _byUnicode = {};
  var _byLigature = {};
  var _byOldName = {};
  var build = function build() {
    var lookup = function lookup(reducer) {
      return reduce(
        styles,
        function (o, style, prefix) {
          o[prefix] = reduce(style, reducer, {});
          return o;
        },
        {}
      );
    };
    _byUnicode = lookup(function (acc, icon, iconName) {
      if (icon[3]) {
        acc[icon[3]] = iconName;
      }
      return acc;
    });
    _byLigature = lookup(function (acc, icon, iconName) {
      var ligatures = icon[2];
      acc[iconName] = iconName;
      ligatures.forEach(function (ligature) {
        acc[ligature] = iconName;
      });
      return acc;
    });
    var hasRegular = "far" in styles;
    _byOldName = reduce(
      shims,
      function (acc, shim) {
        var oldName = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) {
          prefix = "fas";
        }
        acc[oldName] = { prefix: prefix, iconName: iconName };
        return acc;
      },
      {}
    );
  };
  build();
  var styles$1 = namespace.styles;
  function iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
      return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName],
      };
    }
  }
  function toHtml(abstractNodes) {
    var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes =
        _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") {
      return htmlEscape(abstractNodes);
    } else {
      return "<"
        .concat(tag, " ")
        .concat(joinAttributes(attributes), ">")
        .concat(children.map(toHtml).join(""), "</")
        .concat(tag, ">");
    }
  }
  function MissingIcon(error) {
    this.name = "MissingIcon";
    this.message = error || "Icon unavailable";
    this.stack = new Error().stack;
  }
  MissingIcon.prototype = Object.create(Error.prototype);
  MissingIcon.prototype.constructor = MissingIcon;
  var FILL = { fill: "currentColor" };
  var ANIMATION_BASE = {
    attributeType: "XML",
    repeatCount: "indefinite",
    dur: "2s",
  };
  var RING = {
    tag: "path",
    attributes: _objectSpread({}, FILL, {
      d:
        "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z",
    }),
  };
  var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
    attributeName: "opacity",
  });
  var DOT = {
    tag: "circle",
    attributes: _objectSpread({}, FILL, { cx: "256", cy: "364", r: "28" }),
    children: [
      {
        tag: "animate",
        attributes: _objectSpread({}, ANIMATION_BASE, {
          attributeName: "r",
          values: "28;14;28;28;14;28;",
        }),
      },
      {
        tag: "animate",
        attributes: _objectSpread({}, OPACITY_ANIMATE, {
          values: "1;0;1;1;0;1;",
        }),
      },
    ],
  };
  var QUESTION = {
    tag: "path",
    attributes: _objectSpread({}, FILL, {
      opacity: "1",
      d:
        "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z",
    }),
    children: [
      {
        tag: "animate",
        attributes: _objectSpread({}, OPACITY_ANIMATE, {
          values: "1;0;0;0;0;1;",
        }),
      },
    ],
  };
  var EXCLAMATION = {
    tag: "path",
    attributes: _objectSpread({}, FILL, {
      opacity: "0",
      d:
        "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z",
    }),
    children: [
      {
        tag: "animate",
        attributes: _objectSpread({}, OPACITY_ANIMATE, {
          values: "0;0;1;1;0;0;",
        }),
      },
    ],
  };
  var styles$2 = namespace.styles;
  function asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) {
      element = {
        tag: "g",
        attributes: {
          class: ""
            .concat(config.familyPrefix, "-")
            .concat(DUOTONE_CLASSES.GROUP),
        },
        children: [
          {
            tag: "path",
            attributes: {
              class: ""
                .concat(config.familyPrefix, "-")
                .concat(DUOTONE_CLASSES.SECONDARY),
              fill: "currentColor",
              d: vectorData[0],
            },
          },
          {
            tag: "path",
            attributes: {
              class: ""
                .concat(config.familyPrefix, "-")
                .concat(DUOTONE_CLASSES.PRIMARY),
              fill: "currentColor",
              d: vectorData[1],
            },
          },
        ],
      };
    } else {
      element = {
        tag: "path",
        attributes: { fill: "currentColor", d: vectorData },
      };
    }
    return { found: true, width: width, height: height, icon: element };
  }
  var styles$3 = namespace.styles;
  var baseStyles =
    'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';
  function css$1() {
    var dfp = DEFAULT_FAMILY_PREFIX;
    var drc = DEFAULT_REPLACEMENT_CLASS;
    var fp = config.familyPrefix;
    var rc = config.replacementClass;
    var s = baseStyles;
    if (fp !== dfp || rc !== drc) {
      var dPatt = new RegExp("\\.".concat(dfp, "\\-"), "g");
      var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), "g");
      var rPatt = new RegExp("\\.".concat(drc), "g");
      s = s
        .replace(dPatt, ".".concat(fp, "-"))
        .replace(customPropPatt, "--".concat(fp, "-"))
        .replace(rPatt, ".".concat(rc));
    }
    return s;
  }
  var Library = /*#__PURE__*/ (function () {
    function Library() {
      _classCallCheck$1(this, Library);
      this.definitions = {};
    }
    _createClass$1(Library, [
      {
        key: "add",
        value: function add() {
          var _this = this;
          for (
            var _len = arguments.length,
              definitions = new Array(_len),
              _key = 0;
            _key < _len;
            _key++
          ) {
            definitions[_key] = arguments[_key];
          }
          var additions = definitions.reduce(this._pullDefinitions, {});
          Object.keys(additions).forEach(function (key) {
            _this.definitions[key] = _objectSpread(
              {},
              _this.definitions[key] || {},
              additions[key]
            );
            defineIcons(key, additions[key]);
            build();
          });
        },
      },
      {
        key: "reset",
        value: function reset() {
          this.definitions = {};
        },
      },
      {
        key: "_pullDefinitions",
        value: function _pullDefinitions(additions, definition) {
          var normalized =
            definition.prefix && definition.iconName && definition.icon
              ? { 0: definition }
              : definition;
          Object.keys(normalized).map(function (key) {
            var _normalized$key = normalized[key],
              prefix = _normalized$key.prefix,
              iconName = _normalized$key.iconName,
              icon = _normalized$key.icon;
            if (!additions[prefix]) additions[prefix] = {};
            additions[prefix][iconName] = icon;
          });
          return additions;
        },
      },
    ]);
    return Library;
  })();
  function ensureCss() {
    if (config.autoAddCss && !_cssInserted) {
      insertCss(css$1());
      _cssInserted = true;
    }
  }
  function apiObject(val, abstractCreator) {
    Object.defineProperty(val, "abstract", { get: abstractCreator });
    Object.defineProperty(val, "html", {
      get: function get() {
        return val.abstract.map(function (a) {
          return toHtml(a);
        });
      },
    });
    Object.defineProperty(val, "node", {
      get: function get() {
        if (!IS_DOM) return;
        var container = DOCUMENT.createElement("div");
        container.innerHTML = val.html;
        return container.children;
      },
    });
    return val;
  }
  function findIconDefinition(iconLookup) {
    var _iconLookup$prefix = iconLookup.prefix,
      prefix = _iconLookup$prefix === void 0 ? "fa" : _iconLookup$prefix,
      iconName = iconLookup.iconName;
    if (!iconName) return;
    return (
      iconFromMapping(library.definitions, prefix, iconName) ||
      iconFromMapping(namespace.styles, prefix, iconName)
    );
  }
  function resolveIcons(next) {
    return function (maybeIconDefinition) {
      var params =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var iconDefinition = (maybeIconDefinition || {}).icon
        ? maybeIconDefinition
        : findIconDefinition(maybeIconDefinition || {});
      var mask = params.mask;
      if (mask) {
        mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
      }
      return next(iconDefinition, _objectSpread({}, params, { mask: mask }));
    };
  }
  var library = new Library();
  var _cssInserted = false;
  var icon = resolveIcons(function (iconDefinition) {
    var params =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform,
      transform =
        _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
    return apiObject(
      _objectSpread({ type: "icon" }, iconDefinition),
      function () {
        ensureCss();
        if (config.autoA11y) {
          if (title) {
            attributes["aria-labelledby"] = ""
              .concat(config.replacementClass, "-title-")
              .concat(nextUniqueId());
          } else {
            attributes["aria-hidden"] = "true";
            attributes["focusable"] = "false";
          }
        }
        return makeInlineSvgAbstract({
          icons: {
            main: asFoundIcon(icon),
            mask: mask
              ? asFoundIcon(mask.icon)
              : { found: false, width: null, height: null, icon: {} },
          },
          prefix: prefix,
          iconName: iconName,
          transform: _objectSpread({}, meaninglessTransform, transform),
          symbol: symbol,
          title: title,
          extra: { attributes: attributes, styles: styles, classes: classes },
        });
      }
    );
  });

  var faCat = {
    prefix: "fas",
    iconName: "cat",
    icon: [
      512,
      512,
      [],
      "f6be",
      "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z",
    ],
  };
  var faCoffee = {
    prefix: "fas",
    iconName: "coffee",
    icon: [
      640,
      512,
      [],
      "f0f4",
      "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z",
    ],
  };
  var faFutbol = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
      512,
      512,
      [],
      "f1e3",
      "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z",
    ],
  };
  var faHistory = {
    prefix: "fas",
    iconName: "history",
    icon: [
      512,
      512,
      [],
      "f1da",
      "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z",
    ],
  };
  var faMusic = {
    prefix: "fas",
    iconName: "music",
    icon: [
      512,
      512,
      [],
      "f001",
      "M511.99 32.01c0-21.71-21.1-37.01-41.6-30.51L150.4 96c-13.3 4.2-22.4 16.5-22.4 30.5v261.42c-10.05-2.38-20.72-3.92-32-3.92-53.02 0-96 28.65-96 64s42.98 64 96 64 96-28.65 96-64V214.31l256-75.02v184.63c-10.05-2.38-20.72-3.92-32-3.92-53.02 0-96 28.65-96 64s42.98 64 96 64 96-28.65 96-64l-.01-351.99z",
    ],
  };
  var faSearch = {
    prefix: "fas",
    iconName: "search",
    icon: [
      512,
      512,
      [],
      "f002",
      "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z",
    ],
  };
  var faTimes = {
    prefix: "fas",
    iconName: "times",
    icon: [
      352,
      512,
      [],
      "f00d",
      "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z",
    ],
  };

  var faBuilding = {
    prefix: "far",
    iconName: "building",
    icon: [
      448,
      512,
      [],
      "f1ad",
      "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z",
    ],
  };
  var faFlag = {
    prefix: "far",
    iconName: "flag",
    icon: [
      512,
      512,
      [],
      "f024",
      "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z",
    ],
  };
  var faFrown = {
    prefix: "far",
    iconName: "frown",
    icon: [
      496,
      512,
      [],
      "f119",
      "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z",
    ],
  };
  var faLightbulb = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
      352,
      512,
      [],
      "f0eb",
      "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z",
    ],
  };
  var faSmile = {
    prefix: "far",
    iconName: "smile",
    icon: [
      496,
      512,
      [],
      "f118",
      "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z",
    ],
  };

  library.add(
    faBuilding,
    faCat,
    faCoffee,
    faFlag,
    faFrown,
    faFutbol,
    faHistory,
    faLightbulb,
    faMusic,
    faSearch,
    faSmile,
    faTimes
  );
  var building = icon({ prefix: "far", iconName: "building" }).html;
  var cat = icon({ prefix: "fas", iconName: "cat" }).html;
  var coffee = icon({ prefix: "fas", iconName: "coffee" }).html;
  var flag = icon({ prefix: "far", iconName: "flag" }).html;
  var futbol = icon({ prefix: "fas", iconName: "futbol" }).html;
  var frown = icon({ prefix: "far", iconName: "frown" }).html;
  var history = icon({ prefix: "fas", iconName: "history" }).html;
  var lightbulb = icon({ prefix: "far", iconName: "lightbulb" }).html;
  var music = icon({ prefix: "fas", iconName: "music" }).html;
  var search = icon({ prefix: "fas", iconName: "search" }).html;
  var smile = icon({ prefix: "far", iconName: "smile" }).html;
  var times = icon({ prefix: "fas", iconName: "times" }).html;

  var LOCAL_STORAGE_KEY = "emojiPicker.recent";
  function load() {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
  }
  function save(emoji) {
    var recents = load();
    var recent = {
      e: emoji.e,
      n: getEmojiName(emoji),
      k: emoji.k || getEmojiName(emoji),
    };
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify(
        [recent]
          .concat(
            _toConsumableArray(
              recents.filter(function (r) {
                return r.k !== recent.k;
              })
            )
          )
          .slice(0, 50)
      )
    );
  }

  var CLASS_EMOJI = "emoji-picker__emoji";
  var Emoji = /*#__PURE__*/ (function () {
    function Emoji(emoji, showVariants, showPreview, events) {
      _classCallCheck(this, Emoji);
      this.emoji = emoji;
      this.showVariants = showVariants;
      this.showPreview = showPreview;
      this.events = events;
    }
    _createClass(Emoji, [
      {
        key: "render",
        value: function render() {
          var _this = this;
          var emojiButton = createElement("button", CLASS_EMOJI);
          emojiButton.innerHTML = this.emoji.e;
          emojiButton.addEventListener("click", function () {
            return _this.onEmojiClick();
          });
          emojiButton.addEventListener("mouseover", function () {
            return _this.onEmojiHover();
          });
          emojiButton.addEventListener("mouseout", function () {
            return _this.onEmojiLeave();
          });
          return emojiButton;
        },
      },
      {
        key: "onEmojiClick",
        value: function onEmojiClick() {
          // TODO move this side effect out of Emoji, make the recent module listen for event
          if (!this.emoji.v || !this.showVariants) {
            save(this.emoji);
          }
          this.events.emit(EMOJI, {
            emoji: this.emoji,
            showVariants: this.showVariants,
          });
        },
      },
      {
        key: "onEmojiHover",
        value: function onEmojiHover() {
          if (this.showPreview) {
            this.events.emit(SHOW_PREVIEW, this.emoji);
          }
        },
      },
      {
        key: "onEmojiLeave",
        value: function onEmojiLeave() {
          if (this.showPreview) {
            this.events.emit(HIDE_PREVIEW);
          }
        },
      },
    ]);
    return Emoji;
  })();

  var CLASS_EMOJI_CONTAINER = "emoji-picker__emojis";
  var EmojiContainer = /*#__PURE__*/ (function () {
    function EmojiContainer(emojis, showVariants, events) {
      _classCallCheck(this, EmojiContainer);
      this.emojis = emojis;
      this.showVariants = showVariants;
      this.events = events;
    }
    _createClass(EmojiContainer, [
      {
        key: "render",
        value: function render() {
          var _this = this;
          var emojiContainer = createElement("div", CLASS_EMOJI_CONTAINER);
          this.emojis.forEach(function (emoji) {
            return emojiContainer.appendChild(
              new Emoji(emoji, _this.showVariants, true, _this.events).render()
            );
          });
          return emojiContainer;
        },
      },
    ]);
    return EmojiContainer;
  })();

  var CLASS_SEARCH_CONTAINER = "emoji-picker__search-container";
  var CLASS_SEARCH_FIELD = "emoji-picker__search";
  var CLASS_SEARCH_ICON = "emoji-picker__search-icon";
  var CLASS_NOT_FOUND = "emoji-picker__search-not-found";
  var CLASS_NOT_FOUND_ICON = "emoji-picker__search-not-found-icon";
  var Search = /*#__PURE__*/ (function () {
    function Search(events, i18n, emojiData, autoFocusSearch) {
      _classCallCheck(this, Search);
      this.events = events;
      this.i18n = i18n;
      this.emojiData = emojiData;
      this.autoFocusSearch = autoFocusSearch;
    }
    _createClass(Search, [
      {
        key: "render",
        value: function render() {
          var _this = this;
          this.searchContainer = createElement("div", CLASS_SEARCH_CONTAINER);
          this.searchField = createElement("input", CLASS_SEARCH_FIELD);
          this.searchField.placeholder = this.i18n.search;
          this.searchContainer.appendChild(this.searchField);
          var searchIcon = createElement("span", CLASS_SEARCH_ICON);
          searchIcon.innerHTML = search;
          this.searchContainer.appendChild(searchIcon);
          if (this.autoFocusSearch) {
            setTimeout(function () {
              return _this.searchField.focus();
            });
          }
          this.searchField.addEventListener("keydown", function (event) {
            return _this.onKeyDown(event);
          });
          this.searchField.addEventListener("keyup", function () {
            return _this.onKeyUp();
          });
          return this.searchContainer;
        },
      },
      {
        key: "onKeyDown",
        value: function onKeyDown(event) {
          if (event.key === "Escape" && this.searchField.value !== "") {
            event.stopPropagation();
            this.searchField.value = "";
            this.events.emit(SHOW_TABS);
          }
        },
      },
      {
        key: "onKeyUp",
        value: function onKeyUp() {
          var _this2 = this;
          if (!this.searchField.value) {
            this.events.emit(SHOW_TABS);
          } else {
            this.events.emit(HIDE_TABS);
            var searchResults = this.emojiData.filter(function (emoji) {
              return emoji.n.filter(function (name) {
                return (
                  name
                    .toLowerCase()
                    .indexOf(_this2.searchField.value.toLowerCase()) >= 0
                );
              }).length;
            });
            this.events.emit(HIDE_PREVIEW);
            if (searchResults.length) {
              this.events.emit(
                SHOW_SEARCH_RESULTS,
                new EmojiContainer(searchResults, true, this.events).render()
              );
            } else {
              this.events.emit(
                SHOW_SEARCH_RESULTS,
                new NotFoundMessage(this.i18n.notFound).render()
              );
            }
          }
        },
      },
    ]);
    return Search;
  })();
  var NotFoundMessage = /*#__PURE__*/ (function () {
    function NotFoundMessage(message) {
      _classCallCheck(this, NotFoundMessage);
      this.message = message;
    }
    _createClass(NotFoundMessage, [
      {
        key: "render",
        value: function render() {
          var container = createElement("div", CLASS_NOT_FOUND);
          var iconContainer = createElement("div", CLASS_NOT_FOUND_ICON);
          iconContainer.innerHTML = frown;
          container.appendChild(iconContainer);
          var messageContainer = createElement("h2");
          messageContainer.innerHTML = this.message;
          container.appendChild(messageContainer);
          return container;
        },
      },
    ]);
    return NotFoundMessage;
  })();

  var i18n = {
    search: "Search",
    categories: {
      recents: "Recently Used",
      smileys: "Smileys & People",
      animals: "Animals & Nature",
      food: "Food & Drink",
      activities: "Activities",
      travel: "Travel & Places",
      objects: "Objects",
      symbols: "Symbols",
      flags: "Flags",
    },
    notFound: "No emojis found",
  };

  var CLASS_ACTIVE_TAB = "active";
  var CLASS_TABS_CONTAINER = "emoji-picker__tabs-container";
  var CLASS_TABS = "emoji-picker__tabs";
  var CLASS_TAB = "emoji-picker__tab";
  var CLASS_TAB_BODY = "emoji-picker__tab-body";
  var emojiCategories = {};
  emojiData.forEach(function (emoji) {
    var categoryList = emojiCategories[categories[emoji.c]];
    if (!categoryList) {
      categoryList = emojiCategories[categories[emoji.c]] = [];
    }
    categoryList.push(emoji);
  });
  var categoryIcons = {
    smileys: smile,
    animals: cat,
    food: coffee,
    activities: futbol,
    travel: building,
    objects: lightbulb,
    symbols: music,
    flags: flag,
  };
  var Tabs = /*#__PURE__*/ (function () {
    function Tabs(events, i18n) {
      _classCallCheck(this, Tabs);
      this.events = events;
      this.i18n = i18n;
      this.activeTab = 1;
      this.setActiveTab = this.setActiveTab.bind(this);
    }
    _createClass(Tabs, [
      {
        key: "setActiveTab",
        value: function setActiveTab(index) {
          if (this.activeTab >= 0) {
            this.tabBodies[this.activeTab].setActive(false);
            this.tabs[this.activeTab].setActive(false);
          }
          this.activeTab = index;
          this.tabBodies[this.activeTab].setActive(true);
          this.tabs[this.activeTab].setActive(true);
        },
      },
      {
        key: "render",
        value: function render() {
          var tabsContainer = createElement("div", CLASS_TABS_CONTAINER);
          tabsContainer.appendChild(this.createTabs());
          tabsContainer.appendChild(this.createTabBodies());
          this.setActiveTab(1);
          return tabsContainer;
        },
      },
      {
        key: "createTabs",
        value: function createTabs() {
          var _this = this;
          this.tabsList = createElement("ul", CLASS_TABS);
          this.tabs = Object.keys(categoryIcons).map(function (
            category,
            index
          ) {
            return new Tab(
              categoryIcons[category],
              index + 1,
              _this.setActiveTab
            );
          });
          var recentTab = new Tab(history, 0, this.setActiveTab);
          this.tabs.splice(0, 0, recentTab);
          this.tabs.forEach(function (tab) {
            return _this.tabsList.appendChild(tab.render());
          });
          return this.tabsList;
        },
      },
      {
        key: "createTabBodies",
        value: function createTabBodies() {
          var _this2 = this;
          this.tabBodyContainer = createElement("div");
          this.tabBodies = Object.keys(categoryIcons).map(function (
            category,
            index
          ) {
            return new TabBody(
              _this2.i18n.categories[category] || i18n.categories[category],
              new EmojiContainer(
                emojiCategories[category],
                true,
                _this2.events
              ).render(),
              index + 1
            );
          });
          var recentTabBody = new TabBody(
            this.i18n.categories.recents || i18n.categories.recents,
            new EmojiContainer(load(), false, this.events).render(),
            0
          );
          this.tabBodies.splice(0, 0, recentTabBody);
          this.events.on(EMOJI, function () {
            var newRecents = new TabBody(
              _this2.i18n.categories.recents || i18n.categories.recents,
              new EmojiContainer(load(), false, _this2.events).render(),
              0
            );
            setTimeout(function () {
              _this2.tabBodyContainer.replaceChild(
                newRecents.render(),
                _this2.tabBodyContainer.firstChild
              );
              _this2.tabBodies[0] = newRecents;
              if (_this2.activeTab === 0) {
                _this2.setActiveTab(0);
              }
            });
          });
          this.tabBodies.forEach(function (tabBody) {
            return _this2.tabBodyContainer.appendChild(tabBody.render());
          });
          return this.tabBodyContainer;
        },
      },
    ]);
    return Tabs;
  })();
  var Tab = /*#__PURE__*/ (function () {
    function Tab(icon, index, setActiveTab) {
      _classCallCheck(this, Tab);
      this.icon = icon;
      this.index = index;
      this.setActiveTab = setActiveTab;
    }
    _createClass(Tab, [
      {
        key: "render",
        value: function render() {
          var _this3 = this;
          this.tab = createElement("li", CLASS_TAB);
          this.tab.innerHTML = this.icon;
          this.tab.addEventListener("click", function () {
            return _this3.setActiveTab(_this3.index);
          });
          return this.tab;
        },
      },
      {
        key: "setActive",
        value: function setActive(active) {
          if (active) {
            this.tab.classList.add(CLASS_ACTIVE_TAB);
          } else {
            this.tab.classList.remove(CLASS_ACTIVE_TAB);
          }
        },
      },
    ]);
    return Tab;
  })();
  var TabBody = /*#__PURE__*/ (function () {
    function TabBody(category, content, index) {
      _classCallCheck(this, TabBody);
      this.category = category;
      this.content = content;
      this.index = index;
    }
    _createClass(TabBody, [
      {
        key: "render",
        value: function render() {
          this.container = createElement("div", CLASS_TAB_BODY);
          var title = createElement("h2");
          title.innerHTML = this.category;
          this.container.appendChild(title);
          this.container.appendChild(this.content);
          return this.container;
        },
      },
      {
        key: "setActive",
        value: function setActive(active) {
          if (active) {
            this.container.classList.add(CLASS_ACTIVE_TAB);
          } else {
            this.container.classList.remove(CLASS_ACTIVE_TAB);
          }
        },
      },
    ]);
    return TabBody;
  })();

  var CLASS_OVERLAY = "emoji-picker__variant-overlay";
  var CLASS_POPUP = "emoji-picker__variant-popup";
  var CLASS_CLOSE_BUTTON = "emoji-picker__variant-popup-close-button";
  var VariantPopup = /*#__PURE__*/ (function () {
    function VariantPopup(events, emoji) {
      _classCallCheck(this, VariantPopup);
      this.events = events;
      this.emoji = emoji;
    }
    _createClass(VariantPopup, [
      {
        key: "render",
        value: function render() {
          var _this = this;
          var popup = createElement("div", CLASS_POPUP);
          var overlay = createElement("div", CLASS_OVERLAY);
          overlay.addEventListener("click", function (event) {
            event.stopPropagation();
            if (!popup.contains(event.target)) {
              _this.events.emit(HIDE_VARIANT_POPUP);
            }
          });
          popup.appendChild(
            new Emoji(this.emoji, false, false, this.events).render()
          );
          Object.keys(this.emoji.v).forEach(function (variant) {
            popup.appendChild(
              new Emoji(
                _this.emoji.v[variant],
                false,
                false,
                _this.events
              ).render()
            );
          });
          var closeButton = createElement("button", CLASS_CLOSE_BUTTON);
          closeButton.innerHTML = times;
          closeButton.addEventListener("click", function (event) {
            event.stopPropagation();
            _this.events.emit(HIDE_VARIANT_POPUP);
          });
          popup.appendChild(closeButton);
          overlay.appendChild(popup);
          return overlay;
        },
      },
    ]);
    return VariantPopup;
  })();

  var CLASS_PICKER = "emoji-picker";
  var CLASS_PICKER_CONTENT = "emoji-picker__content";
  var DEFAULT_OPTIONS = {
    position: "right-start",
    autoHide: true,
    autoFocusSearch: true,
  };
  var EmojiButton = /*#__PURE__*/ (function () {
    function EmojiButton() {
      var options =
        arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, EmojiButton);
      this.pickerVisible = false;
      this.options = _objectSpread2({}, DEFAULT_OPTIONS, {}, options);
      if (!this.options.rootElement) {
        this.options.rootElement = document.body;
      }
      this.i18n = _objectSpread2({}, i18n, {}, options.i18n);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
      this.events = new tinyEmitter();
      this.publicEvents = new tinyEmitter();
    }
    _createClass(EmojiButton, [
      {
        key: "on",
        value: function on(event, callback) {
          this.publicEvents.on(event, callback);
        },
      },
      {
        key: "off",
        value: function off(event, callback) {
          this.publicEvents.off(event, callback);
        },
      },
      {
        key: "buildPicker",
        value: function buildPicker() {
          var _this = this;
          this.pickerEl = createElement("div", CLASS_PICKER);
          var pickerContent = createElement("div", CLASS_PICKER_CONTENT);
          var searchContainer = new Search(
            this.events,
            this.i18n,
            emojiData,
            this.options.autoFocusSearch
          ).render();
          this.pickerEl.appendChild(searchContainer);
          this.pickerEl.appendChild(pickerContent);
          var tabs = new Tabs(this.events, this.i18n).render();
          pickerContent.appendChild(tabs);
          this.events.on(HIDE_TABS, function () {
            if (pickerContent.contains(tabs)) {
              pickerContent.removeChild(tabs);
            }
          });
          this.events.on(SHOW_TABS, function () {
            if (!pickerContent.contains(tabs)) {
              empty(pickerContent);
              pickerContent.appendChild(tabs);
            }
          });
          this.events.on(SHOW_SEARCH_RESULTS, function (searchResults) {
            empty(pickerContent);
            searchResults.classList.add("search-results");
            pickerContent.appendChild(searchResults);
          });
          this.pickerEl.appendChild(new EmojiPreview(this.events).render());
          var variantPopup;
          this.events.on(EMOJI, function (_ref) {
            var emoji = _ref.emoji,
              showVariants = _ref.showVariants;
            if (emoji.v && showVariants) {
              variantPopup = new VariantPopup(_this.events, emoji).render();
              _this.pickerEl.appendChild(variantPopup);
            } else {
              if (variantPopup && variantPopup.parentNode === _this.pickerEl) {
                _this.pickerEl.removeChild(variantPopup);
              }
              _this.publicEvents.emit("emoji", emoji.e);
              if (_this.options.autoHide) {
                _this.hidePicker();
              }
            }
          });
          this.events.on(HIDE_VARIANT_POPUP, function () {
            _this.pickerEl.removeChild(variantPopup);
            variantPopup = null;
          });
          this.options.rootElement.appendChild(this.pickerEl);
          setTimeout(function () {
            document.addEventListener("click", _this.onDocumentClick);
            document.addEventListener("keydown", _this.onDocumentKeydown);
          });
        },
      },
      {
        key: "onDocumentClick",
        value: function onDocumentClick(event) {
          if (!this.pickerEl.contains(event.target)) {
            this.hidePicker();
          }
        },
      },
      {
        key: "hidePicker",
        value: function hidePicker() {
          this.pickerVisible = false;
          this.events.off(EMOJI);
          this.events.off(HIDE_VARIANT_POPUP);
          this.options.rootElement.removeChild(this.pickerEl);
          this.popper.destroy();
          document.removeEventListener("click", this.onDocumentClick);
          document.removeEventListener("keydown", this.onDocumentKeydown);
        },
      },
      {
        key: "showPicker",
        value: function showPicker(referenceEl) {
          var options =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : {};
          this.pickerVisible = true;
          this.buildPicker();
          this.popper = new Popper(referenceEl, this.pickerEl, {
            placement: options.position || this.options.position,
          });
        },
      },
      {
        key: "onDocumentKeydown",
        value: function onDocumentKeydown(event) {
          if (event.key === "Escape") {
            this.hidePicker();
          }
        },
      },
    ]);
    return EmojiButton;
  })();

  return EmojiButton;
});

!(function ($) {
  "use strict"; // jshint ;_;

  var ggTooltip = function (element, options) {
    this.init("ggtooltip", element, options);
  };

  ggTooltip.prototype = {
    constructor: ggTooltip,

    init: function (type, element, options) {
      var eventIn, eventOut;

      this.type = type;
      this.$element = $(element);
      this.options = this.getOptions(options);
      this.enabled = true;

      if (this.options.trigger == "click") {
        this.$element.on(
          "click." + this.type,
          this.options.selector,
          $.proxy(this.toggle, this)
        );
      } else if (this.options.trigger != "manual") {
        eventIn = this.options.trigger == "hover" ? "mouseenter" : "focus";
        eventOut = this.options.trigger == "hover" ? "mouseleave" : "blur";
        this.$element.on(
          eventIn + "." + this.type,
          this.options.selector,
          $.proxy(this.enter, this)
        );
        this.$element.on(
          eventOut + "." + this.type,
          this.options.selector,
          $.proxy(this.leave, this)
        );
      }

      this.options.selector
        ? (this._options = $.extend({}, this.options, {
            trigger: "manual",
            selector: "",
          }))
        : this.fixTitle();
    },

    getOptions: function (options) {
      options = $.extend(
        {},
        $.fn[this.type].defaults,
        options,
        this.$element.data()
      );

      if (options.delay && typeof options.delay == "number") {
        options.delay = {
          show: options.delay,
          hide: options.delay,
        };
      }

      return options;
    },

    enter: function (e) {
      var self = $(e.currentTarget)[this.type](this._options).data(this.type);

      if (!self.options.delay || !self.options.delay.show) return self.show();

      clearTimeout(this.timeout);
      self.hoverState = "in";
      this.timeout = setTimeout(function () {
        if (self.hoverState == "in") self.show();
      }, self.options.delay.show);
    },

    leave: function (e) {
      var self = $(e.currentTarget)[this.type](this._options).data(this.type);

      if (this.timeout) clearTimeout(this.timeout);
      if (!self.options.delay || !self.options.delay.hide) return self.hide();

      self.hoverState = "out";
      this.timeout = setTimeout(function () {
        if (self.hoverState == "out") self.hide();
      }, self.options.delay.hide);
    },

    show: function () {
      var $tip, inside, pos, actualWidth, actualHeight, placement, tp;

      if (this.hasContent() && this.enabled) {
        $tip = this.tip();
        this.setContent();

        if (this.options.animation) {
          $tip.addClass("fade");
        }

        placement =
          typeof this.options.placement == "function"
            ? this.options.placement.call(this, $tip[0], this.$element[0])
            : this.options.placement;

        inside = /in/.test(placement);

        $tip
          .detach()
          .css({ top: 0, left: 0, display: "block" })
          .insertAfter(this.$element);

        pos = this.getPosition(inside);

        actualWidth = $tip[0].offsetWidth;
        actualHeight = $tip[0].offsetHeight;

        switch (inside ? placement.split(" ")[1] : placement) {
          case "bottom":
            tp = {
              top: pos.top + pos.height,
              left: pos.left + pos.width / 2 - actualWidth / 2,
            };
            break;
          case "top":
            tp = {
              top: pos.top - actualHeight,
              left: pos.left + pos.width / 2 - actualWidth / 2,
            };
            break;
          case "left":
            tp = {
              top: pos.top + pos.height / 2 - actualHeight / 2,
              left: pos.left - actualWidth,
            };
            break;
          case "right":
            tp = {
              top: pos.top + pos.height / 2 - actualHeight / 2,
              left: pos.left + pos.width,
            };
            break;
        }

        $tip.offset(tp).addClass(placement).addClass("in");
      }
    },

    setContent: function () {
      var $tip = this.tip(),
        title = this.getTitle();

      $tip.find(".ggtooltip-inner").css({
        background: this.options.backcolor,
        color: this.options.textcolor,
        "border-color": this.options.bordercolor,
      });
      $tip
        .find(".ggtooltip-arrow")
        .css(
          "border-" + this.options.placement + "-color",
          this.options.backcolor
        );
      $tip
        .find(".ggtooltip-arrow-shadow")
        .css(
          "border-" + this.options.placement + "-color",
          this.options.bordercolor
        );
      $tip.find(".ggtooltip-inner")[this.options.html ? "html" : "text"](title);
      $tip.removeClass("fade in top bottom left right");
    },

    hide: function () {
      var that = this,
        $tip = this.tip();

      $tip.removeClass("in");

      function removeWithAnimation() {
        var timeout = setTimeout(function () {
          $tip.off($.support.transition.end).detach();
        }, 500);

        $tip.one($.support.transition.end, function () {
          clearTimeout(timeout);
          $tip.detach();
        });
      }

      $.support.transition && this.$tip.hasClass("fade")
        ? removeWithAnimation()
        : $tip.detach();

      return this;
    },

    fixTitle: function () {
      var $e = this.$element;
      if (
        $e.attr("title") ||
        typeof $e.attr("data-original-title") != "string"
      ) {
        $e.attr("data-original-title", $e.attr("title") || "").removeAttr(
          "title"
        );
      }
    },

    hasContent: function () {
      return this.getTitle();
    },

    getPosition: function (inside) {
      return $.extend(
        {},
        inside ? { top: 0, left: 0 } : this.$element.offset(),
        {
          width: this.$element[0].offsetWidth,
          height: this.$element[0].offsetHeight,
        }
      );
    },

    getTitle: function () {
      var title,
        $e = this.$element,
        o = this.options;

      title =
        $e.attr("data-original-title") ||
        (typeof o.title == "function" ? o.title.call($e[0]) : o.title);

      return title;
    },

    tip: function () {
      return (this.$tip = this.$tip || $(this.options.template));
    },

    validate: function () {
      if (!this.$element[0].parentNode) {
        this.hide();
        this.$element = null;
        this.options = null;
      }
    },

    enable: function () {
      this.enabled = true;
    },

    disable: function () {
      this.enabled = false;
    },

    toggleEnabled: function () {
      this.enabled = !this.enabled;
    },

    toggle: function (e) {
      var self = $(e.currentTarget)[this.type](this._options).data(this.type);
      self[self.tip().hasClass("in") ? "hide" : "show"]();
    },

    destroy: function () {
      this.hide()
        .$element.off("." + this.type)
        .removeData(this.type);
    },
  };

  var old = $.fn.ggtooltip;

  $.fn.ggtooltip = function (option) {
    return this.each(function () {
      var $this = $(this),
        data = $this.data("ggtooltip"),
        options = typeof option == "object" && option;
      if (!data) $this.data("ggtooltip", (data = new ggTooltip(this, options)));
      if (typeof option == "string") data[option]();
    });
  };

  $.fn.ggtooltip.Constructor = ggTooltip;

  $.fn.ggtooltip.defaults = {
    animation: true,
    placement: "top",
    selector: false,
    template:
      '<div class="ggtooltip"><div class="ggtooltip-arrow-shadow"></div><div class="ggtooltip-arrow"></div><div class="ggtooltip-inner"></div></div>',
    trigger: "hover",
    title: "",
    delay: 0,
    html: false,
    backcolor: "#00ffcc",
    textcolor: "#000000",
    bordercolor: "#0066cc",
  };

  $.fn.ggtooltip.noConflict = function () {
    $.fn.ggtooltip = old;
    return this;
  };
})(window.jQuery);
/*! highlight.js v9.12.0 | BSD3 License | git.io/hljslicense */
!(function (e) {
  var n =
    ("object" == typeof window && window) || ("object" == typeof self && self);
  "undefined" != typeof exports
    ? e(exports)
    : n &&
      ((n.hljs = e({})),
      "function" == typeof define &&
        define.amd &&
        define([], function () {
          return n.hljs;
        }));
})(function (e) {
  function n(e) {
    return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function t(e) {
    return e.nodeName.toLowerCase();
  }
  function r(e, n) {
    var t = e && e.exec(n);
    return t && 0 === t.index;
  }
  function a(e) {
    return k.test(e);
  }
  function i(e) {
    var n,
      t,
      r,
      i,
      o = e.className + " ";
    if (((o += e.parentNode ? e.parentNode.className : ""), (t = B.exec(o))))
      return w(t[1]) ? t[1] : "no-highlight";
    for (o = o.split(/\s+/), n = 0, r = o.length; r > n; n++)
      if (((i = o[n]), a(i) || w(i))) return i;
  }
  function o(e) {
    var n,
      t = {},
      r = Array.prototype.slice.call(arguments, 1);
    for (n in e) t[n] = e[n];
    return (
      r.forEach(function (e) {
        for (n in e) t[n] = e[n];
      }),
      t
    );
  }
  function u(e) {
    var n = [];
    return (
      (function r(e, a) {
        for (var i = e.firstChild; i; i = i.nextSibling)
          3 === i.nodeType
            ? (a += i.nodeValue.length)
            : 1 === i.nodeType &&
              (n.push({ event: "start", offset: a, node: i }),
              (a = r(i, a)),
              t(i).match(/br|hr|img|input/) ||
                n.push({ event: "stop", offset: a, node: i }));
        return a;
      })(e, 0),
      n
    );
  }
  function c(e, r, a) {
    function i() {
      return e.length && r.length
        ? e[0].offset !== r[0].offset
          ? e[0].offset < r[0].offset
            ? e
            : r
          : "start" === r[0].event
          ? e
          : r
        : e.length
        ? e
        : r;
    }
    function o(e) {
      function r(e) {
        return (
          " " + e.nodeName + '="' + n(e.value).replace('"', "&quot;") + '"'
        );
      }
      s += "<" + t(e) + E.map.call(e.attributes, r).join("") + ">";
    }
    function u(e) {
      s += "</" + t(e) + ">";
    }
    function c(e) {
      ("start" === e.event ? o : u)(e.node);
    }
    for (var l = 0, s = "", f = []; e.length || r.length; ) {
      var g = i();
      if (((s += n(a.substring(l, g[0].offset))), (l = g[0].offset), g === e)) {
        f.reverse().forEach(u);
        do c(g.splice(0, 1)[0]), (g = i());
        while (g === e && g.length && g[0].offset === l);
        f.reverse().forEach(o);
      } else
        "start" === g[0].event ? f.push(g[0].node) : f.pop(),
          c(g.splice(0, 1)[0]);
    }
    return s + n(a.substr(l));
  }
  function l(e) {
    return (
      e.v &&
        !e.cached_variants &&
        (e.cached_variants = e.v.map(function (n) {
          return o(e, { v: null }, n);
        })),
      e.cached_variants || (e.eW && [o(e)]) || [e]
    );
  }
  function s(e) {
    function n(e) {
      return (e && e.source) || e;
    }
    function t(t, r) {
      return new RegExp(n(t), "m" + (e.cI ? "i" : "") + (r ? "g" : ""));
    }
    function r(a, i) {
      if (!a.compiled) {
        if (((a.compiled = !0), (a.k = a.k || a.bK), a.k)) {
          var o = {},
            u = function (n, t) {
              e.cI && (t = t.toLowerCase()),
                t.split(" ").forEach(function (e) {
                  var t = e.split("|");
                  o[t[0]] = [n, t[1] ? Number(t[1]) : 1];
                });
            };
          "string" == typeof a.k
            ? u("keyword", a.k)
            : x(a.k).forEach(function (e) {
                u(e, a.k[e]);
              }),
            (a.k = o);
        }
        (a.lR = t(a.l || /\w+/, !0)),
          i &&
            (a.bK && (a.b = "\\b(" + a.bK.split(" ").join("|") + ")\\b"),
            a.b || (a.b = /\B|\b/),
            (a.bR = t(a.b)),
            a.e || a.eW || (a.e = /\B|\b/),
            a.e && (a.eR = t(a.e)),
            (a.tE = n(a.e) || ""),
            a.eW && i.tE && (a.tE += (a.e ? "|" : "") + i.tE)),
          a.i && (a.iR = t(a.i)),
          null == a.r && (a.r = 1),
          a.c || (a.c = []),
          (a.c = Array.prototype.concat.apply(
            [],
            a.c.map(function (e) {
              return l("self" === e ? a : e);
            })
          )),
          a.c.forEach(function (e) {
            r(e, a);
          }),
          a.starts && r(a.starts, i);
        var c = a.c
          .map(function (e) {
            return e.bK ? "\\.?(" + e.b + ")\\.?" : e.b;
          })
          .concat([a.tE, a.i])
          .map(n)
          .filter(Boolean);
        a.t = c.length
          ? t(c.join("|"), !0)
          : {
              exec: function () {
                return null;
              },
            };
      }
    }
    r(e);
  }
  function f(e, t, a, i) {
    function o(e, n) {
      var t, a;
      for (t = 0, a = n.c.length; a > t; t++)
        if (r(n.c[t].bR, e)) return n.c[t];
    }
    function u(e, n) {
      if (r(e.eR, n)) {
        for (; e.endsParent && e.parent; ) e = e.parent;
        return e;
      }
      return e.eW ? u(e.parent, n) : void 0;
    }
    function c(e, n) {
      return !a && r(n.iR, e);
    }
    function l(e, n) {
      var t = N.cI ? n[0].toLowerCase() : n[0];
      return e.k.hasOwnProperty(t) && e.k[t];
    }
    function p(e, n, t, r) {
      var a = r ? "" : I.classPrefix,
        i = '<span class="' + a,
        o = t ? "" : C;
      return (i += e + '">'), i + n + o;
    }
    function h() {
      var e, t, r, a;
      if (!E.k) return n(k);
      for (a = "", t = 0, E.lR.lastIndex = 0, r = E.lR.exec(k); r; )
        (a += n(k.substring(t, r.index))),
          (e = l(E, r)),
          e ? ((B += e[1]), (a += p(e[0], n(r[0])))) : (a += n(r[0])),
          (t = E.lR.lastIndex),
          (r = E.lR.exec(k));
      return a + n(k.substr(t));
    }
    function d() {
      var e = "string" == typeof E.sL;
      if (e && !y[E.sL]) return n(k);
      var t = e ? f(E.sL, k, !0, x[E.sL]) : g(k, E.sL.length ? E.sL : void 0);
      return (
        E.r > 0 && (B += t.r),
        e && (x[E.sL] = t.top),
        p(t.language, t.value, !1, !0)
      );
    }
    function b() {
      (L += null != E.sL ? d() : h()), (k = "");
    }
    function v(e) {
      (L += e.cN ? p(e.cN, "", !0) : ""),
        (E = Object.create(e, { parent: { value: E } }));
    }
    function m(e, n) {
      if (((k += e), null == n)) return b(), 0;
      var t = o(n, E);
      if (t)
        return (
          t.skip ? (k += n) : (t.eB && (k += n), b(), t.rB || t.eB || (k = n)),
          v(t, n),
          t.rB ? 0 : n.length
        );
      var r = u(E, n);
      if (r) {
        var a = E;
        a.skip ? (k += n) : (a.rE || a.eE || (k += n), b(), a.eE && (k = n));
        do E.cN && (L += C), E.skip || (B += E.r), (E = E.parent);
        while (E !== r.parent);
        return r.starts && v(r.starts, ""), a.rE ? 0 : n.length;
      }
      if (c(n, E))
        throw new Error(
          'Illegal lexeme "' + n + '" for mode "' + (E.cN || "<unnamed>") + '"'
        );
      return (k += n), n.length || 1;
    }
    var N = w(e);
    if (!N) throw new Error('Unknown language: "' + e + '"');
    s(N);
    var R,
      E = i || N,
      x = {},
      L = "";
    for (R = E; R !== N; R = R.parent) R.cN && (L = p(R.cN, "", !0) + L);
    var k = "",
      B = 0;
    try {
      for (var M, j, O = 0; ; ) {
        if (((E.t.lastIndex = O), (M = E.t.exec(t)), !M)) break;
        (j = m(t.substring(O, M.index), M[0])), (O = M.index + j);
      }
      for (m(t.substr(O)), R = E; R.parent; R = R.parent) R.cN && (L += C);
      return { r: B, value: L, language: e, top: E };
    } catch (T) {
      if (T.message && -1 !== T.message.indexOf("Illegal"))
        return { r: 0, value: n(t) };
      throw T;
    }
  }
  function g(e, t) {
    t = t || I.languages || x(y);
    var r = { r: 0, value: n(e) },
      a = r;
    return (
      t.filter(w).forEach(function (n) {
        var t = f(n, e, !1);
        (t.language = n), t.r > a.r && (a = t), t.r > r.r && ((a = r), (r = t));
      }),
      a.language && (r.second_best = a),
      r
    );
  }
  function p(e) {
    return I.tabReplace || I.useBR
      ? e.replace(M, function (e, n) {
          return I.useBR && "\n" === e
            ? "<br>"
            : I.tabReplace
            ? n.replace(/\t/g, I.tabReplace)
            : "";
        })
      : e;
  }
  function h(e, n, t) {
    var r = n ? L[n] : t,
      a = [e.trim()];
    return (
      e.match(/\bhljs\b/) || a.push("hljs"),
      -1 === e.indexOf(r) && a.push(r),
      a.join(" ").trim()
    );
  }
  function d(e) {
    var n,
      t,
      r,
      o,
      l,
      s = i(e);
    a(s) ||
      (I.useBR
        ? ((n = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "div"
          )),
          (n.innerHTML = e.innerHTML
            .replace(/\n/g, "")
            .replace(/<br[ \/]*>/g, "\n")))
        : (n = e),
      (l = n.textContent),
      (r = s ? f(s, l, !0) : g(l)),
      (t = u(n)),
      t.length &&
        ((o = document.createElementNS("http://www.w3.org/1999/xhtml", "div")),
        (o.innerHTML = r.value),
        (r.value = c(t, u(o), l))),
      (r.value = p(r.value)),
      (e.innerHTML = r.value),
      (e.className = h(e.className, s, r.language)),
      (e.result = { language: r.language, re: r.r }),
      r.second_best &&
        (e.second_best = {
          language: r.second_best.language,
          re: r.second_best.r,
        }));
  }
  function b(e) {
    I = o(I, e);
  }
  function v() {
    if (!v.called) {
      v.called = !0;
      var e = document.querySelectorAll("pre code");
      E.forEach.call(e, d);
    }
  }
  function m() {
    addEventListener("DOMContentLoaded", v, !1),
      addEventListener("load", v, !1);
  }
  function N(n, t) {
    var r = (y[n] = t(e));
    r.aliases &&
      r.aliases.forEach(function (e) {
        L[e] = n;
      });
  }
  function R() {
    return x(y);
  }
  function w(e) {
    return (e = (e || "").toLowerCase()), y[e] || y[L[e]];
  }
  var E = [],
    x = Object.keys,
    y = {},
    L = {},
    k = /^(no-?highlight|plain|text)$/i,
    B = /\blang(?:uage)?-([\w-]+)\b/i,
    M = /((^(<[^>]+>|\t|)+|(?:\n)))/gm,
    C = "</span>",
    I = {
      classPrefix: "hljs-",
      tabReplace: null,
      useBR: !1,
      languages: void 0,
    };
  return (
    (e.highlight = f),
    (e.highlightAuto = g),
    (e.fixMarkup = p),
    (e.highlightBlock = d),
    (e.configure = b),
    (e.initHighlighting = v),
    (e.initHighlightingOnLoad = m),
    (e.registerLanguage = N),
    (e.listLanguages = R),
    (e.getLanguage = w),
    (e.inherit = o),
    (e.IR = "[a-zA-Z]\\w*"),
    (e.UIR = "[a-zA-Z_]\\w*"),
    (e.NR = "\\b\\d+(\\.\\d+)?"),
    (e.CNR =
      "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)"),
    (e.BNR = "\\b(0b[01]+)"),
    (e.RSR =
      "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~"),
    (e.BE = { b: "\\\\[\\s\\S]", r: 0 }),
    (e.ASM = { cN: "string", b: "'", e: "'", i: "\\n", c: [e.BE] }),
    (e.QSM = { cN: "string", b: '"', e: '"', i: "\\n", c: [e.BE] }),
    (e.PWM = {
      b: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/,
    }),
    (e.C = function (n, t, r) {
      var a = e.inherit({ cN: "comment", b: n, e: t, c: [] }, r || {});
      return (
        a.c.push(e.PWM),
        a.c.push({ cN: "doctag", b: "(?:TODO|FIXME|NOTE|BUG|XXX):", r: 0 }),
        a
      );
    }),
    (e.CLCM = e.C("//", "$")),
    (e.CBCM = e.C("/\\*", "\\*/")),
    (e.HCM = e.C("#", "$")),
    (e.NM = { cN: "number", b: e.NR, r: 0 }),
    (e.CNM = { cN: "number", b: e.CNR, r: 0 }),
    (e.BNM = { cN: "number", b: e.BNR, r: 0 }),
    (e.CSSNM = {
      cN: "number",
      b:
        e.NR +
        "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
      r: 0,
    }),
    (e.RM = {
      cN: "regexp",
      b: /\//,
      e: /\/[gimuy]*/,
      i: /\n/,
      c: [e.BE, { b: /\[/, e: /\]/, r: 0, c: [e.BE] }],
    }),
    (e.TM = { cN: "title", b: e.IR, r: 0 }),
    (e.UTM = { cN: "title", b: e.UIR, r: 0 }),
    (e.METHOD_GUARD = { b: "\\.\\s*" + e.UIR, r: 0 }),
    e
  );
});
hljs.registerLanguage("ruby", function (e) {
  var b =
      "[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?",
    r = {
      keyword:
        "and then defined module in return redo if BEGIN retry end for self when next until do begin unless END rescue else break undef not super class case require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor",
      literal: "true false nil",
    },
    c = { cN: "doctag", b: "@[A-Za-z]+" },
    a = { b: "#<", e: ">" },
    s = [
      e.C("#", "$", { c: [c] }),
      e.C("^\\=begin", "^\\=end", { c: [c], r: 10 }),
      e.C("^__END__", "\\n$"),
    ],
    n = { cN: "subst", b: "#\\{", e: "}", k: r },
    t = {
      cN: "string",
      c: [e.BE, n],
      v: [
        { b: /'/, e: /'/ },
        { b: /"/, e: /"/ },
        { b: /`/, e: /`/ },
        { b: "%[qQwWx]?\\(", e: "\\)" },
        { b: "%[qQwWx]?\\[", e: "\\]" },
        { b: "%[qQwWx]?{", e: "}" },
        { b: "%[qQwWx]?<", e: ">" },
        { b: "%[qQwWx]?/", e: "/" },
        { b: "%[qQwWx]?%", e: "%" },
        { b: "%[qQwWx]?-", e: "-" },
        { b: "%[qQwWx]?\\|", e: "\\|" },
        { b: /\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/ },
        { b: /<<(-?)\w+$/, e: /^\s*\w+$/ },
      ],
    },
    i = { cN: "params", b: "\\(", e: "\\)", endsParent: !0, k: r },
    d = [
      t,
      a,
      {
        cN: "class",
        bK: "class module",
        e: "$|;",
        i: /=/,
        c: [
          e.inherit(e.TM, { b: "[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?" }),
          { b: "<\\s*", c: [{ b: "(" + e.IR + "::)?" + e.IR }] },
        ].concat(s),
      },
      {
        cN: "function",
        bK: "def",
        e: "$|;",
        c: [e.inherit(e.TM, { b: b }), i].concat(s),
      },
      { b: e.IR + "::" },
      { cN: "symbol", b: e.UIR + "(\\!|\\?)?:", r: 0 },
      { cN: "symbol", b: ":(?!\\s)", c: [t, { b: b }], r: 0 },
      {
        cN: "number",
        b:
          "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
        r: 0,
      },
      { b: "(\\$\\W)|((\\$|\\@\\@?)(\\w+))" },
      { cN: "params", b: /\|/, e: /\|/, k: r },
      {
        b: "(" + e.RSR + "|unless)\\s*",
        k: "unless",
        c: [
          a,
          {
            cN: "regexp",
            c: [e.BE, n],
            i: /\n/,
            v: [
              { b: "/", e: "/[a-z]*" },
              { b: "%r{", e: "}[a-z]*" },
              { b: "%r\\(", e: "\\)[a-z]*" },
              { b: "%r!", e: "![a-z]*" },
              { b: "%r\\[", e: "\\][a-z]*" },
            ],
          },
        ].concat(s),
        r: 0,
      },
    ].concat(s);
  (n.c = d), (i.c = d);
  var l = "[>?]>",
    o = "[\\w#]+\\(\\w+\\):\\d+:\\d+>",
    u = "(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>",
    w = [
      { b: /^\s*=>/, starts: { e: "$", c: d } },
      {
        cN: "meta",
        b: "^(" + l + "|" + o + "|" + u + ")",
        starts: { e: "$", c: d },
      },
    ];
  return {
    aliases: ["rb", "gemspec", "podspec", "thor", "irb"],
    k: r,
    i: /\/\*/,
    c: s.concat(w).concat(d),
  };
});
hljs.registerLanguage("sql", function (e) {
  var t = e.C("--", "$");
  return {
    cI: !0,
    i: /[<>{}*#]/,
    c: [
      {
        bK:
          "begin end start commit rollback savepoint lock alter create drop rename call delete do handler insert load replace select truncate update set show pragma grant merge describe use explain help declare prepare execute deallocate release unlock purge reset change stop analyze cache flush optimize repair kill install uninstall checksum restore check backup revoke comment",
        e: /;/,
        eW: !0,
        l: /[\w\.]+/,
        k: {
          keyword:
            "abort abs absolute acc acce accep accept access accessed accessible account acos action activate add addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias allocate allow alter always analyze ancillary and any anydata anydataset anyschema anytype apply archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base char_length character_length characters characterset charindex charset charsetform charsetid check checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation collect colu colum column column_value columns columns_updated comment commit compact compatibility compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection consider consistent constant constraint constraints constructor container content contents context contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor deterministic diagnostics difference dimension direct_load directory disable disable_all disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding execu execut execute exempt exists exit exp expire explain export export_set extended extent external external_1 external_2 externally extract failed failed_login_attempts failover failure far fast feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final finish first first_value fixed flash_cache flashback floor flush following follows for forall force form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ftp full function general generated get get_format get_lock getdate getutcdate global global_name globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex hierarchy high high_priority hosts hour http id ident_current ident_incr ident_seed identified identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile initial initialized initially initrans inmemory inner innodb input insert install instance instantiable instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lax lcase lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime managed management manual map mapping mask master master_pos_wait match matched materialized max maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans md5 measures median medium member memcompress memory merge microsecond mid migration min minextents minimum mining minus minute minvalue missing mod mode model modification modify module monitoring month months mount move movement multiset mutex name name_const names nan national native natural nav nchar nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck noswitch not nothing notice notrim novalidate now nowait nth_value nullif nulls num numb numbe nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary out outer outfile outline output over overflow overriding package pad parallel parallel_enable parameters parent parse partial partition partitions pascal passing password password_grace_time password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction prediction_cost prediction_details prediction_probability prediction_set prepare present preserve prior priority private private_sga privileges procedural procedure procedure_analyze processlist profiles project prompt protection public publishingservername purge quarter query quick quiesce quota quotename radians raise rand range rank raw read reads readsize rebuild record records recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename repair repeat replace replicate replication required reset resetlogs resize resource respect restore restricted result result_cache resumable resume retention return returning returns reuse reverse revoke right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll sdo_georaster sdo_topo_geometry search sec_to_time second section securefile security seed segment select self sequence sequential serializable server servererror session session_user sessions_per_user set sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone standby start starting startup statement static statistics stats_binomial_test stats_crosstab stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tan tdo template temporary terminated tertiary_weights test than then thread through tier ties time time_format time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unpivot unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear wellformed when whene whenev wheneve whenever where while whitespace with within without work wrapped xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek",
          literal: "true false null",
          built_in:
            "array bigint binary bit blob boolean char character date dec decimal float int int8 integer interval number numeric real record serial serial8 smallint text varchar varying void",
        },
        c: [
          { cN: "string", b: "'", e: "'", c: [e.BE, { b: "''" }] },
          { cN: "string", b: '"', e: '"', c: [e.BE, { b: '""' }] },
          { cN: "string", b: "`", e: "`", c: [e.BE] },
          e.CNM,
          e.CBCM,
          t,
        ],
      },
      e.CBCM,
      t,
    ],
  };
});
hljs.registerLanguage("perl", function (e) {
  var t =
      "getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qqfileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent shutdown dump chomp connect getsockname die socketpair close flock exists index shmgetsub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedirioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when",
    r = { cN: "subst", b: "[$@]\\{", e: "\\}", k: t },
    s = { b: "->{", e: "}" },
    n = {
      v: [
        { b: /\$\d/ },
        { b: /[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/ },
        { b: /[\$%@][^\s\w{]/, r: 0 },
      ],
    },
    i = [e.BE, r, n],
    o = [
      n,
      e.HCM,
      e.C("^\\=\\w", "\\=cut", { eW: !0 }),
      s,
      {
        cN: "string",
        c: i,
        v: [
          { b: "q[qwxr]?\\s*\\(", e: "\\)", r: 5 },
          { b: "q[qwxr]?\\s*\\[", e: "\\]", r: 5 },
          { b: "q[qwxr]?\\s*\\{", e: "\\}", r: 5 },
          { b: "q[qwxr]?\\s*\\|", e: "\\|", r: 5 },
          { b: "q[qwxr]?\\s*\\<", e: "\\>", r: 5 },
          { b: "qw\\s+q", e: "q", r: 5 },
          { b: "'", e: "'", c: [e.BE] },
          { b: '"', e: '"' },
          { b: "`", e: "`", c: [e.BE] },
          { b: "{\\w+}", c: [], r: 0 },
          { b: "-?\\w+\\s*\\=\\>", c: [], r: 0 },
        ],
      },
      {
        cN: "number",
        b:
          "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
        r: 0,
      },
      {
        b: "(\\/\\/|" + e.RSR + "|\\b(split|return|print|reverse|grep)\\b)\\s*",
        k: "split return print reverse grep",
        r: 0,
        c: [
          e.HCM,
          {
            cN: "regexp",
            b: "(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*",
            r: 10,
          },
          { cN: "regexp", b: "(m|qr)?/", e: "/[a-z]*", c: [e.BE], r: 0 },
        ],
      },
      {
        cN: "function",
        bK: "sub",
        e: "(\\s*\\(.*?\\))?[;{]",
        eE: !0,
        r: 5,
        c: [e.TM],
      },
      { b: "-\\w\\b", r: 0 },
      {
        b: "^__DATA__$",
        e: "^__END__$",
        sL: "mojolicious",
        c: [{ b: "^@@.*", e: "$", cN: "comment" }],
      },
    ];
  return (
    (r.c = o), (s.c = o), { aliases: ["pl", "pm"], l: /[\w\.]+/, k: t, c: o }
  );
});
hljs.registerLanguage("php", function (e) {
  var c = { b: "\\$+[a-zA-Z_-ÿ][a-zA-Z0-9_-ÿ]*" },
    i = { cN: "meta", b: /<\?(php)?|\?>/ },
    t = {
      cN: "string",
      c: [e.BE, i],
      v: [
        { b: 'b"', e: '"' },
        { b: "b'", e: "'" },
        e.inherit(e.ASM, { i: null }),
        e.inherit(e.QSM, { i: null }),
      ],
    },
    a = { v: [e.BNM, e.CNM] };
  return {
    aliases: ["php3", "php4", "php5", "php6"],
    cI: !0,
    k:
      "and include_once list abstract global private echo interface as static endswitch array null if endwhile or const for endforeach self var while isset public protected exit foreach throw elseif include __FILE__ empty require_once do xor return parent clone use __CLASS__ __LINE__ else break print eval new catch __METHOD__ case exception default die require __FUNCTION__ enddeclare final try switch continue endfor endif declare unset true false trait goto instanceof insteadof __DIR__ __NAMESPACE__ yield finally",
    c: [
      e.HCM,
      e.C("//", "$", { c: [i] }),
      e.C("/\\*", "\\*/", { c: [{ cN: "doctag", b: "@[A-Za-z]+" }] }),
      e.C("__halt_compiler.+?;", !1, {
        eW: !0,
        k: "__halt_compiler",
        l: e.UIR,
      }),
      {
        cN: "string",
        b: /<<<['"]?\w+['"]?$/,
        e: /^\w+;?$/,
        c: [e.BE, { cN: "subst", v: [{ b: /\$\w+/ }, { b: /\{\$/, e: /\}/ }] }],
      },
      i,
      { cN: "keyword", b: /\$this\b/ },
      c,
      { b: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/ },
      {
        cN: "function",
        bK: "function",
        e: /[;{]/,
        eE: !0,
        i: "\\$|\\[|%",
        c: [
          e.UTM,
          { cN: "params", b: "\\(", e: "\\)", c: ["self", c, e.CBCM, t, a] },
        ],
      },
      {
        cN: "class",
        bK: "class interface",
        e: "{",
        eE: !0,
        i: /[:\(\$"]/,
        c: [{ bK: "extends implements" }, e.UTM],
      },
      { bK: "namespace", e: ";", i: /[\.']/, c: [e.UTM] },
      { bK: "use", e: ";", c: [e.UTM] },
      { b: "=>" },
      t,
      a,
    ],
  };
});
hljs.registerLanguage("json", function (e) {
  var i = { literal: "true false null" },
    n = [e.QSM, e.CNM],
    r = { e: ",", eW: !0, eE: !0, c: n, k: i },
    t = {
      b: "{",
      e: "}",
      c: [
        { cN: "attr", b: /"/, e: /"/, c: [e.BE], i: "\\n" },
        e.inherit(r, { b: /:/ }),
      ],
      i: "\\S",
    },
    c = { b: "\\[", e: "\\]", c: [e.inherit(r)], i: "\\S" };
  return n.splice(n.length, 0, t, c), { c: n, k: i, i: "\\S" };
});
hljs.registerLanguage("http", function (e) {
  var t = "HTTP/[0-9\\.]+";
  return {
    aliases: ["https"],
    i: "\\S",
    c: [
      { b: "^" + t, e: "$", c: [{ cN: "number", b: "\\b\\d{3}\\b" }] },
      {
        b: "^[A-Z]+ (.*?) " + t + "$",
        rB: !0,
        e: "$",
        c: [
          { cN: "string", b: " ", e: " ", eB: !0, eE: !0 },
          { b: t },
          { cN: "keyword", b: "[A-Z]+" },
        ],
      },
      {
        cN: "attribute",
        b: "^\\w",
        e: ": ",
        eE: !0,
        i: "\\n|\\s|=",
        starts: { e: "$", r: 0 },
      },
      { b: "\\n\\n", starts: { sL: [], eW: !0 } },
    ],
  };
});
hljs.registerLanguage("bash", function (e) {
  var t = {
      cN: "variable",
      v: [{ b: /\$[\w\d#@][\w\d_]*/ }, { b: /\$\{(.*?)}/ }],
    },
    s = {
      cN: "string",
      b: /"/,
      e: /"/,
      c: [e.BE, t, { cN: "variable", b: /\$\(/, e: /\)/, c: [e.BE] }],
    },
    a = { cN: "string", b: /'/, e: /'/ };
  return {
    aliases: ["sh", "zsh"],
    l: /\b-?[a-z\._]+\b/,
    k: {
      keyword: "if then else elif fi for while in do done case esac function",
      literal: "true false",
      built_in:
        "break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp",
      _: "-ne -eq -lt -gt -f -d -e -s -l -a",
    },
    c: [
      { cN: "meta", b: /^#![^\n]+sh\s*$/, r: 10 },
      {
        cN: "function",
        b: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        rB: !0,
        c: [e.inherit(e.TM, { b: /\w[\w\d_]*/ })],
        r: 0,
      },
      e.HCM,
      s,
      a,
      t,
    ],
  };
});
hljs.registerLanguage("javascript", function (e) {
  var r = "[A-Za-z$_][0-9A-Za-z$_]*",
    t = {
      keyword:
        "in of if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await static import from as",
      literal: "true false null undefined NaN Infinity",
      built_in:
        "eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Promise",
    },
    a = {
      cN: "number",
      v: [{ b: "\\b(0[bB][01]+)" }, { b: "\\b(0[oO][0-7]+)" }, { b: e.CNR }],
      r: 0,
    },
    n = { cN: "subst", b: "\\$\\{", e: "\\}", k: t, c: [] },
    c = { cN: "string", b: "`", e: "`", c: [e.BE, n] };
  n.c = [e.ASM, e.QSM, c, a, e.RM];
  var s = n.c.concat([e.CBCM, e.CLCM]);
  return {
    aliases: ["js", "jsx"],
    k: t,
    c: [
      { cN: "meta", r: 10, b: /^\s*['"]use (strict|asm)['"]/ },
      { cN: "meta", b: /^#!/, e: /$/ },
      e.ASM,
      e.QSM,
      c,
      e.CLCM,
      e.CBCM,
      a,
      {
        b: /[{,]\s*/,
        r: 0,
        c: [{ b: r + "\\s*:", rB: !0, r: 0, c: [{ cN: "attr", b: r, r: 0 }] }],
      },
      {
        b: "(" + e.RSR + "|\\b(case|return|throw)\\b)\\s*",
        k: "return throw case",
        c: [
          e.CLCM,
          e.CBCM,
          e.RM,
          {
            cN: "function",
            b: "(\\(.*?\\)|" + r + ")\\s*=>",
            rB: !0,
            e: "\\s*=>",
            c: [
              {
                cN: "params",
                v: [
                  { b: r },
                  { b: /\(\s*\)/ },
                  { b: /\(/, e: /\)/, eB: !0, eE: !0, k: t, c: s },
                ],
              },
            ],
          },
          {
            b: /</,
            e: /(\/\w+|\w+\/)>/,
            sL: "xml",
            c: [
              { b: /<\w+\s*\/>/, skip: !0 },
              {
                b: /<\w+/,
                e: /(\/\w+|\w+\/)>/,
                skip: !0,
                c: [{ b: /<\w+\s*\/>/, skip: !0 }, "self"],
              },
            ],
          },
        ],
        r: 0,
      },
      {
        cN: "function",
        bK: "function",
        e: /\{/,
        eE: !0,
        c: [
          e.inherit(e.TM, { b: r }),
          { cN: "params", b: /\(/, e: /\)/, eB: !0, eE: !0, c: s },
        ],
        i: /\[|%/,
      },
      { b: /\$[(.]/ },
      e.METHOD_GUARD,
      {
        cN: "class",
        bK: "class",
        e: /[{;=]/,
        eE: !0,
        i: /[:"\[\]]/,
        c: [{ bK: "extends" }, e.UTM],
      },
      { bK: "constructor", e: /\{/, eE: !0 },
    ],
    i: /#(?!!)/,
  };
});
hljs.registerLanguage("xml", function (s) {
  var e = "[A-Za-z0-9\\._:-]+",
    t = {
      eW: !0,
      i: /</,
      r: 0,
      c: [
        { cN: "attr", b: e, r: 0 },
        {
          b: /=\s*/,
          r: 0,
          c: [
            {
              cN: "string",
              endsParent: !0,
              v: [
                { b: /"/, e: /"/ },
                { b: /'/, e: /'/ },
                { b: /[^\s"'=<>`]+/ },
              ],
            },
          ],
        },
      ],
    };
  return {
    aliases: ["html", "xhtml", "rss", "atom", "xjb", "xsd", "xsl", "plist"],
    cI: !0,
    c: [
      {
        cN: "meta",
        b: "<!DOCTYPE",
        e: ">",
        r: 10,
        c: [{ b: "\\[", e: "\\]" }],
      },
      s.C("<!--", "-->", { r: 10 }),
      { b: "<\\!\\[CDATA\\[", e: "\\]\\]>", r: 10 },
      {
        b: /<\?(php)?/,
        e: /\?>/,
        sL: "php",
        c: [{ b: "/\\*", e: "\\*/", skip: !0 }],
      },
      {
        cN: "tag",
        b: "<style(?=\\s|>|$)",
        e: ">",
        k: { name: "style" },
        c: [t],
        starts: { e: "</style>", rE: !0, sL: ["css", "xml"] },
      },
      {
        cN: "tag",
        b: "<script(?=\\s|>|$)",
        e: ">",
        k: { name: "script" },
        c: [t],
        starts: {
          e: "</script>",
          rE: !0,
          sL: ["actionscript", "javascript", "handlebars", "xml"],
        },
      },
      {
        cN: "meta",
        v: [
          { b: /<\?xml/, e: /\?>/, r: 10 },
          { b: /<\?\w+/, e: /\?>/ },
        ],
      },
      {
        cN: "tag",
        b: "</?",
        e: "/?>",
        c: [{ cN: "name", b: /[^\/><\s]+/, r: 0 }, t],
      },
    ],
  };
});
hljs.registerLanguage("markdown", function (e) {
  return {
    aliases: ["md", "mkdown", "mkd"],
    c: [
      {
        cN: "section",
        v: [{ b: "^#{1,6}", e: "$" }, { b: "^.+?\\n[=-]{2,}$" }],
      },
      { b: "<", e: ">", sL: "xml", r: 0 },
      { cN: "bullet", b: "^([*+-]|(\\d+\\.))\\s+" },
      { cN: "strong", b: "[*_]{2}.+?[*_]{2}" },
      { cN: "emphasis", v: [{ b: "\\*.+?\\*" }, { b: "_.+?_", r: 0 }] },
      { cN: "quote", b: "^>\\s+", e: "$" },
      {
        cN: "code",
        v: [
          { b: "^```w*s*$", e: "^```s*$" },
          { b: "`.+?`" },
          { b: "^( {4}|	)", e: "$", r: 0 },
        ],
      },
      { b: "^[-\\*]{3,}", e: "$" },
      {
        b: "\\[.+?\\][\\(\\[].*?[\\)\\]]",
        rB: !0,
        c: [
          { cN: "string", b: "\\[", e: "\\]", eB: !0, rE: !0, r: 0 },
          { cN: "link", b: "\\]\\(", e: "\\)", eB: !0, eE: !0 },
          { cN: "symbol", b: "\\]\\[", e: "\\]", eB: !0, eE: !0 },
        ],
        r: 10,
      },
      {
        b: /^\[[^\n]+\]:/,
        rB: !0,
        c: [
          { cN: "symbol", b: /\[/, e: /\]/, eB: !0, eE: !0 },
          { cN: "link", b: /:\s*/, e: /$/, eB: !0 },
        ],
      },
    ],
  };
});
hljs.registerLanguage("coffeescript", function (e) {
  var c = {
      keyword:
        "in if for while finally new do return else break catch instanceof throw try this switch continue typeof delete debugger super yield import export from as default await then unless until loop of by when and or is isnt not",
      literal: "true false null undefined yes no on off",
      built_in: "npm require console print module global window document",
    },
    n = "[A-Za-z$_][0-9A-Za-z$_]*",
    r = { cN: "subst", b: /#\{/, e: /}/, k: c },
    i = [
      e.BNM,
      e.inherit(e.CNM, { starts: { e: "(\\s*/)?", r: 0 } }),
      {
        cN: "string",
        v: [
          { b: /'''/, e: /'''/, c: [e.BE] },
          { b: /'/, e: /'/, c: [e.BE] },
          { b: /"""/, e: /"""/, c: [e.BE, r] },
          { b: /"/, e: /"/, c: [e.BE, r] },
        ],
      },
      {
        cN: "regexp",
        v: [
          { b: "///", e: "///", c: [r, e.HCM] },
          { b: "//[gim]*", r: 0 },
          { b: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/ },
        ],
      },
      { b: "@" + n },
      {
        sL: "javascript",
        eB: !0,
        eE: !0,
        v: [
          { b: "```", e: "```" },
          { b: "`", e: "`" },
        ],
      },
    ];
  r.c = i;
  var s = e.inherit(e.TM, { b: n }),
    t = "(\\(.*\\))?\\s*\\B[-=]>",
    o = {
      cN: "params",
      b: "\\([^\\(]",
      rB: !0,
      c: [{ b: /\(/, e: /\)/, k: c, c: ["self"].concat(i) }],
    };
  return {
    aliases: ["coffee", "cson", "iced"],
    k: c,
    i: /\/\*/,
    c: i.concat([
      e.C("###", "###"),
      e.HCM,
      {
        cN: "function",
        b: "^\\s*" + n + "\\s*=\\s*" + t,
        e: "[-=]>",
        rB: !0,
        c: [s, o],
      },
      {
        b: /[:\(,=]\s*/,
        r: 0,
        c: [{ cN: "function", b: t, e: "[-=]>", rB: !0, c: [o] }],
      },
      {
        cN: "class",
        bK: "class",
        e: "$",
        i: /[:="\[\]]/,
        c: [{ bK: "extends", eW: !0, i: /[:="\[\]]/, c: [s] }, s],
      },
      { b: n + ":", e: ":", rB: !0, rE: !0, r: 0 },
    ]),
  };
});
hljs.registerLanguage("shell", function (s) {
  return {
    aliases: ["console"],
    c: [
      {
        cN: "meta",
        b: "^\\s{0,3}[\\w\\d\\[\\]()@-]*[>%$#]",
        starts: { e: "$", sL: "bash" },
      },
    ],
  };
});
hljs.registerLanguage("css", function (e) {
  var c = "[a-zA-Z-][a-zA-Z0-9_-]*",
    t = {
      b: /[A-Z\_\.\-]+\s*:/,
      rB: !0,
      e: ";",
      eW: !0,
      c: [
        {
          cN: "attribute",
          b: /\S/,
          e: ":",
          eE: !0,
          starts: {
            eW: !0,
            eE: !0,
            c: [
              {
                b: /[\w-]+\(/,
                rB: !0,
                c: [
                  { cN: "built_in", b: /[\w-]+/ },
                  { b: /\(/, e: /\)/, c: [e.ASM, e.QSM] },
                ],
              },
              e.CSSNM,
              e.QSM,
              e.ASM,
              e.CBCM,
              { cN: "number", b: "#[0-9A-Fa-f]+" },
              { cN: "meta", b: "!important" },
            ],
          },
        },
      ],
    };
  return {
    cI: !0,
    i: /[=\/|'\$]/,
    c: [
      e.CBCM,
      { cN: "selector-id", b: /#[A-Za-z0-9_-]+/ },
      { cN: "selector-class", b: /\.[A-Za-z0-9_-]+/ },
      { cN: "selector-attr", b: /\[/, e: /\]/, i: "$" },
      { cN: "selector-pseudo", b: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/ },
      { b: "@(font-face|page)", l: "[a-z-]+", k: "font-face page" },
      {
        b: "@",
        e: "[{;]",
        i: /:/,
        c: [
          { cN: "keyword", b: /\w+/ },
          { b: /\s/, eW: !0, eE: !0, r: 0, c: [e.ASM, e.QSM, e.CSSNM] },
        ],
      },
      { cN: "selector-tag", b: c, r: 0 },
      { b: "{", e: "}", i: /\S/, c: [e.CBCM, t] },
    ],
  };
});
// ==================================================
// fancyBox v3.5.7
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2019 fancyApps
//
// ==================================================
!(function (t, e, n, o) {
  "use strict";
  function i(t, e) {
    var o,
      i,
      a,
      s = [],
      r = 0;
    (t && t.isDefaultPrevented()) ||
      (t.preventDefault(),
      (e = e || {}),
      t && t.data && (e = h(t.data.options, e)),
      (o = e.$target || n(t.currentTarget).trigger("blur")),
      ((a = n.fancybox.getInstance()) && a.$trigger && a.$trigger.is(o)) ||
        (e.selector
          ? (s = n(e.selector))
          : ((i = o.attr("data-fancybox") || ""),
            i
              ? ((s = t.data ? t.data.items : []),
                (s = s.length
                  ? s.filter('[data-fancybox="' + i + '"]')
                  : n('[data-fancybox="' + i + '"]')))
              : (s = [o])),
        (r = n(s).index(o)),
        r < 0 && (r = 0),
        (a = n.fancybox.open(s, e, r)),
        (a.$trigger = o)));
  }
  if (((t.console = t.console || { info: function (t) {} }), n)) {
    if (n.fn.fancybox) return void console.info("fancyBox already initialized");
    var a = {
        closeExisting: !1,
        loop: !1,
        gutter: 50,
        keyboard: !0,
        preventCaptionOverlap: !0,
        arrows: !0,
        infobar: !0,
        smallBtn: "auto",
        toolbar: "auto",
        buttons: ["zoom", "slideShow", "thumbs", "close"],
        idleTime: 3,
        protect: !1,
        modal: !1,
        image: { preload: !1 },
        ajax: { settings: { data: { fancybox: !0 } } },
        iframe: {
          tpl:
            '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
          preload: !0,
          css: {},
          attr: { scrolling: "auto" },
        },
        video: {
          tpl:
            '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
          format: "",
          autoStart: !0,
        },
        defaultType: "image",
        animationEffect: "zoom",
        animationDuration: 366,
        zoomOpacity: "auto",
        transitionEffect: "fade",
        transitionDuration: 366,
        slideClass: "",
        baseClass: "",
        baseTpl:
          '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
        spinnerTpl: '<div class="fancybox-loading"></div>',
        errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
        btnTpl: {
          download:
            '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
          zoom:
            '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
          close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
          arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
          arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
          smallBtn:
            '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>',
        },
        parentEl: "body",
        hideScrollbar: !0,
        autoFocus: !0,
        backFocus: !0,
        trapFocus: !0,
        fullScreen: { autoStart: !1 },
        touch: { vertical: !0, momentum: !0 },
        hash: null,
        media: {},
        slideShow: { autoStart: !1, speed: 3e3 },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
        wheel: "auto",
        onInit: n.noop,
        beforeLoad: n.noop,
        afterLoad: n.noop,
        beforeShow: n.noop,
        afterShow: n.noop,
        beforeClose: n.noop,
        afterClose: n.noop,
        onActivate: n.noop,
        onDeactivate: n.noop,
        clickContent: function (t, e) {
          return "image" === t.type && "zoom";
        },
        clickSlide: "close",
        clickOutside: "close",
        dblclickContent: !1,
        dblclickSlide: !1,
        dblclickOutside: !1,
        mobile: {
          preventCaptionOverlap: !1,
          idleTime: !1,
          clickContent: function (t, e) {
            return "image" === t.type && "toggleControls";
          },
          clickSlide: function (t, e) {
            return "image" === t.type ? "toggleControls" : "close";
          },
          dblclickContent: function (t, e) {
            return "image" === t.type && "zoom";
          },
          dblclickSlide: function (t, e) {
            return "image" === t.type && "zoom";
          },
        },
        lang: "en",
        i18n: {
          en: {
            CLOSE: "Close",
            NEXT: "Next",
            PREV: "Previous",
            ERROR:
              "The requested content cannot be loaded. <br/> Please try again later.",
            PLAY_START: "Start slideshow",
            PLAY_STOP: "Pause slideshow",
            FULL_SCREEN: "Full screen",
            THUMBS: "Thumbnails",
            DOWNLOAD: "Download",
            SHARE: "Share",
            ZOOM: "Zoom",
          },
          de: {
            CLOSE: "Schlie&szlig;en",
            NEXT: "Weiter",
            PREV: "Zur&uuml;ck",
            ERROR:
              "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
            PLAY_START: "Diaschau starten",
            PLAY_STOP: "Diaschau beenden",
            FULL_SCREEN: "Vollbild",
            THUMBS: "Vorschaubilder",
            DOWNLOAD: "Herunterladen",
            SHARE: "Teilen",
            ZOOM: "Vergr&ouml;&szlig;ern",
          },
        },
      },
      s = n(t),
      r = n(e),
      c = 0,
      l = function (t) {
        return t && t.hasOwnProperty && t instanceof n;
      },
      d = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      u = (function () {
        return (
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          }
        );
      })(),
      f = (function () {
        var t,
          n = e.createElement("fakeelement"),
          o = {
            transition: "transitionend",
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
          };
        for (t in o) if (void 0 !== n.style[t]) return o[t];
        return "transitionend";
      })(),
      p = function (t) {
        return t && t.length && t[0].offsetHeight;
      },
      h = function (t, e) {
        var o = n.extend(!0, {}, t, e);
        return (
          n.each(e, function (t, e) {
            n.isArray(e) && (o[t] = e);
          }),
          o
        );
      },
      g = function (t) {
        var o, i;
        return (
          !(!t || t.ownerDocument !== e) &&
          (n(".fancybox-container").css("pointer-events", "none"),
          (o = {
            x: t.getBoundingClientRect().left + t.offsetWidth / 2,
            y: t.getBoundingClientRect().top + t.offsetHeight / 2,
          }),
          (i = e.elementFromPoint(o.x, o.y) === t),
          n(".fancybox-container").css("pointer-events", ""),
          i)
        );
      },
      b = function (t, e, o) {
        var i = this;
        (i.opts = h({ index: o }, n.fancybox.defaults)),
          n.isPlainObject(e) && (i.opts = h(i.opts, e)),
          n.fancybox.isMobile && (i.opts = h(i.opts, i.opts.mobile)),
          (i.id = i.opts.id || ++c),
          (i.currIndex = parseInt(i.opts.index, 10) || 0),
          (i.prevIndex = null),
          (i.prevPos = null),
          (i.currPos = 0),
          (i.firstRun = !0),
          (i.group = []),
          (i.slides = {}),
          i.addContent(t),
          i.group.length && i.init();
      };
    n.extend(b.prototype, {
      init: function () {
        var o,
          i,
          a = this,
          s = a.group[a.currIndex],
          r = s.opts;
        r.closeExisting && n.fancybox.close(!0),
          n("body").addClass("fancybox-active"),
          !n.fancybox.getInstance() &&
            !1 !== r.hideScrollbar &&
            !n.fancybox.isMobile &&
            e.body.scrollHeight > t.innerHeight &&
            (n("head").append(
              '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' +
                (t.innerWidth - e.documentElement.clientWidth) +
                "px;}</style>"
            ),
            n("body").addClass("compensate-for-scrollbar")),
          (i = ""),
          n.each(r.buttons, function (t, e) {
            i += r.btnTpl[e] || "";
          }),
          (o = n(
            a.translate(
              a,
              r.baseTpl
                .replace("{{buttons}}", i)
                .replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight)
            )
          )
            .attr("id", "fancybox-container-" + a.id)
            .addClass(r.baseClass)
            .data("FancyBox", a)
            .appendTo(r.parentEl)),
          (a.$refs = { container: o }),
          [
            "bg",
            "inner",
            "infobar",
            "toolbar",
            "stage",
            "caption",
            "navigation",
          ].forEach(function (t) {
            a.$refs[t] = o.find(".fancybox-" + t);
          }),
          a.trigger("onInit"),
          a.activate(),
          a.jumpTo(a.currIndex);
      },
      translate: function (t, e) {
        var n = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
        return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
          return void 0 === n[e] ? t : n[e];
        });
      },
      addContent: function (t) {
        var e,
          o = this,
          i = n.makeArray(t);
        n.each(i, function (t, e) {
          var i,
            a,
            s,
            r,
            c,
            l = {},
            d = {};
          n.isPlainObject(e)
            ? ((l = e), (d = e.opts || e))
            : "object" === n.type(e) && n(e).length
            ? ((i = n(e)),
              (d = i.data() || {}),
              (d = n.extend(!0, {}, d, d.options)),
              (d.$orig = i),
              (l.src = o.opts.src || d.src || i.attr("href")),
              l.type || l.src || ((l.type = "inline"), (l.src = e)))
            : (l = { type: "html", src: e + "" }),
            (l.opts = n.extend(!0, {}, o.opts, d)),
            n.isArray(d.buttons) && (l.opts.buttons = d.buttons),
            n.fancybox.isMobile &&
              l.opts.mobile &&
              (l.opts = h(l.opts, l.opts.mobile)),
            (a = l.type || l.opts.type),
            (r = l.src || ""),
            !a &&
              r &&
              ((s = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                ? ((a = "video"),
                  l.opts.video.format ||
                    (l.opts.video.format =
                      "video/" + ("ogv" === s[1] ? "ogg" : s[1])))
                : r.match(
                    /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i
                  )
                ? (a = "image")
                : r.match(/\.(pdf)((\?|#).*)?$/i)
                ? ((a = "iframe"),
                  (l = n.extend(!0, l, {
                    contentType: "pdf",
                    opts: { iframe: { preload: !1 } },
                  })))
                : "#" === r.charAt(0) && (a = "inline")),
            a ? (l.type = a) : o.trigger("objectNeedsType", l),
            l.contentType ||
              (l.contentType =
                n.inArray(l.type, ["html", "inline", "ajax"]) > -1
                  ? "html"
                  : l.type),
            (l.index = o.group.length),
            "auto" == l.opts.smallBtn &&
              (l.opts.smallBtn =
                n.inArray(l.type, ["html", "inline", "ajax"]) > -1),
            "auto" === l.opts.toolbar && (l.opts.toolbar = !l.opts.smallBtn),
            (l.$thumb = l.opts.$thumb || null),
            l.opts.$trigger &&
              l.index === o.opts.index &&
              ((l.$thumb = l.opts.$trigger.find("img:first")),
              l.$thumb.length && (l.opts.$orig = l.opts.$trigger)),
            (l.$thumb && l.$thumb.length) ||
              !l.opts.$orig ||
              (l.$thumb = l.opts.$orig.find("img:first")),
            l.$thumb && !l.$thumb.length && (l.$thumb = null),
            (l.thumb = l.opts.thumb || (l.$thumb ? l.$thumb[0].src : null)),
            "function" === n.type(l.opts.caption) &&
              (l.opts.caption = l.opts.caption.apply(e, [o, l])),
            "function" === n.type(o.opts.caption) &&
              (l.opts.caption = o.opts.caption.apply(e, [o, l])),
            l.opts.caption instanceof n ||
              (l.opts.caption =
                void 0 === l.opts.caption ? "" : l.opts.caption + ""),
            "ajax" === l.type &&
              ((c = r.split(/\s+/, 2)),
              c.length > 1 &&
                ((l.src = c.shift()), (l.opts.filter = c.shift()))),
            l.opts.modal &&
              (l.opts = n.extend(!0, l.opts, {
                trapFocus: !0,
                infobar: 0,
                toolbar: 0,
                smallBtn: 0,
                keyboard: 0,
                slideShow: 0,
                fullScreen: 0,
                thumbs: 0,
                touch: 0,
                clickContent: !1,
                clickSlide: !1,
                clickOutside: !1,
                dblclickContent: !1,
                dblclickSlide: !1,
                dblclickOutside: !1,
              })),
            o.group.push(l);
        }),
          Object.keys(o.slides).length &&
            (o.updateControls(),
            (e = o.Thumbs) && e.isActive && (e.create(), e.focus()));
      },
      addEvents: function () {
        var e = this;
        e.removeEvents(),
          e.$refs.container
            .on("click.fb-close", "[data-fancybox-close]", function (t) {
              t.stopPropagation(), t.preventDefault(), e.close(t);
            })
            .on(
              "touchstart.fb-prev click.fb-prev",
              "[data-fancybox-prev]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), e.previous();
              }
            )
            .on(
              "touchstart.fb-next click.fb-next",
              "[data-fancybox-next]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), e.next();
              }
            )
            .on("click.fb", "[data-fancybox-zoom]", function (t) {
              e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
            }),
          s.on("orientationchange.fb resize.fb", function (t) {
            t && t.originalEvent && "resize" === t.originalEvent.type
              ? (e.requestId && u(e.requestId),
                (e.requestId = d(function () {
                  e.update(t);
                })))
              : (e.current &&
                  "iframe" === e.current.type &&
                  e.$refs.stage.hide(),
                setTimeout(
                  function () {
                    e.$refs.stage.show(), e.update(t);
                  },
                  n.fancybox.isMobile ? 600 : 250
                ));
          }),
          r.on("keydown.fb", function (t) {
            var o = n.fancybox ? n.fancybox.getInstance() : null,
              i = o.current,
              a = t.keyCode || t.which;
            if (9 == a) return void (i.opts.trapFocus && e.focus(t));
            if (
              !(
                !i.opts.keyboard ||
                t.ctrlKey ||
                t.altKey ||
                t.shiftKey ||
                n(t.target).is("input,textarea,video,audio,select")
              )
            )
              return 8 === a || 27 === a
                ? (t.preventDefault(), void e.close(t))
                : 37 === a || 38 === a
                ? (t.preventDefault(), void e.previous())
                : 39 === a || 40 === a
                ? (t.preventDefault(), void e.next())
                : void e.trigger("afterKeydown", t, a);
          }),
          e.group[e.currIndex].opts.idleTime &&
            ((e.idleSecondsCounter = 0),
            r.on(
              "mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",
              function (t) {
                (e.idleSecondsCounter = 0),
                  e.isIdle && e.showControls(),
                  (e.isIdle = !1);
              }
            ),
            (e.idleInterval = t.setInterval(function () {
              ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime &&
                !e.isDragging &&
                ((e.isIdle = !0), (e.idleSecondsCounter = 0), e.hideControls());
            }, 1e3)));
      },
      removeEvents: function () {
        var e = this;
        s.off("orientationchange.fb resize.fb"),
          r.off("keydown.fb .fb-idle"),
          this.$refs.container.off(".fb-close .fb-prev .fb-next"),
          e.idleInterval &&
            (t.clearInterval(e.idleInterval), (e.idleInterval = null));
      },
      previous: function (t) {
        return this.jumpTo(this.currPos - 1, t);
      },
      next: function (t) {
        return this.jumpTo(this.currPos + 1, t);
      },
      jumpTo: function (t, e) {
        var o,
          i,
          a,
          s,
          r,
          c,
          l,
          d,
          u,
          f = this,
          h = f.group.length;
        if (!(f.isDragging || f.isClosing || (f.isAnimating && f.firstRun))) {
          if (
            ((t = parseInt(t, 10)),
            !(a = f.current ? f.current.opts.loop : f.opts.loop) &&
              (t < 0 || t >= h))
          )
            return !1;
          if (
            ((o = f.firstRun = !Object.keys(f.slides).length),
            (r = f.current),
            (f.prevIndex = f.currIndex),
            (f.prevPos = f.currPos),
            (s = f.createSlide(t)),
            h > 1 &&
              ((a || s.index < h - 1) && f.createSlide(t + 1),
              (a || s.index > 0) && f.createSlide(t - 1)),
            (f.current = s),
            (f.currIndex = s.index),
            (f.currPos = s.pos),
            f.trigger("beforeShow", o),
            f.updateControls(),
            (s.forcedDuration = void 0),
            n.isNumeric(e)
              ? (s.forcedDuration = e)
              : (e = s.opts[o ? "animationDuration" : "transitionDuration"]),
            (e = parseInt(e, 10)),
            (i = f.isMoved(s)),
            s.$slide.addClass("fancybox-slide--current"),
            o)
          )
            return (
              s.opts.animationEffect &&
                e &&
                f.$refs.container.css("transition-duration", e + "ms"),
              f.$refs.container.addClass("fancybox-is-open").trigger("focus"),
              f.loadSlide(s),
              void f.preload("image")
            );
          (c = n.fancybox.getTranslate(r.$slide)),
            (l = n.fancybox.getTranslate(f.$refs.stage)),
            n.each(f.slides, function (t, e) {
              n.fancybox.stop(e.$slide, !0);
            }),
            r.pos !== s.pos && (r.isComplete = !1),
            r.$slide.removeClass(
              "fancybox-slide--complete fancybox-slide--current"
            ),
            i
              ? ((u = c.left - (r.pos * c.width + r.pos * r.opts.gutter)),
                n.each(f.slides, function (t, o) {
                  o.$slide
                    .removeClass("fancybox-animated")
                    .removeClass(function (t, e) {
                      return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(
                        " "
                      );
                    });
                  var i = o.pos * c.width + o.pos * o.opts.gutter;
                  n.fancybox.setTranslate(o.$slide, {
                    top: 0,
                    left: i - l.left + u,
                  }),
                    o.pos !== s.pos &&
                      o.$slide.addClass(
                        "fancybox-slide--" +
                          (o.pos > s.pos ? "next" : "previous")
                      ),
                    p(o.$slide),
                    n.fancybox.animate(
                      o.$slide,
                      {
                        top: 0,
                        left:
                          (o.pos - s.pos) * c.width +
                          (o.pos - s.pos) * o.opts.gutter,
                      },
                      e,
                      function () {
                        o.$slide
                          .css({ transform: "", opacity: "" })
                          .removeClass(
                            "fancybox-slide--next fancybox-slide--previous"
                          ),
                          o.pos === f.currPos && f.complete();
                      }
                    );
                }))
              : e &&
                s.opts.transitionEffect &&
                ((d =
                  "fancybox-animated fancybox-fx-" + s.opts.transitionEffect),
                r.$slide.addClass(
                  "fancybox-slide--" + (r.pos > s.pos ? "next" : "previous")
                ),
                n.fancybox.animate(
                  r.$slide,
                  d,
                  e,
                  function () {
                    r.$slide
                      .removeClass(d)
                      .removeClass(
                        "fancybox-slide--next fancybox-slide--previous"
                      );
                  },
                  !1
                )),
            s.isLoaded ? f.revealContent(s) : f.loadSlide(s),
            f.preload("image");
        }
      },
      createSlide: function (t) {
        var e,
          o,
          i = this;
        return (
          (o = t % i.group.length),
          (o = o < 0 ? i.group.length + o : o),
          !i.slides[t] &&
            i.group[o] &&
            ((e = n('<div class="fancybox-slide"></div>').appendTo(
              i.$refs.stage
            )),
            (i.slides[t] = n.extend(!0, {}, i.group[o], {
              pos: t,
              $slide: e,
              isLoaded: !1,
            })),
            i.updateSlide(i.slides[t])),
          i.slides[t]
        );
      },
      scaleToActual: function (t, e, o) {
        var i,
          a,
          s,
          r,
          c,
          l = this,
          d = l.current,
          u = d.$content,
          f = n.fancybox.getTranslate(d.$slide).width,
          p = n.fancybox.getTranslate(d.$slide).height,
          h = d.width,
          g = d.height;
        l.isAnimating ||
          l.isMoved() ||
          !u ||
          "image" != d.type ||
          !d.isLoaded ||
          d.hasError ||
          ((l.isAnimating = !0),
          n.fancybox.stop(u),
          (t = void 0 === t ? 0.5 * f : t),
          (e = void 0 === e ? 0.5 * p : e),
          (i = n.fancybox.getTranslate(u)),
          (i.top -= n.fancybox.getTranslate(d.$slide).top),
          (i.left -= n.fancybox.getTranslate(d.$slide).left),
          (r = h / i.width),
          (c = g / i.height),
          (a = 0.5 * f - 0.5 * h),
          (s = 0.5 * p - 0.5 * g),
          h > f &&
            ((a = i.left * r - (t * r - t)),
            a > 0 && (a = 0),
            a < f - h && (a = f - h)),
          g > p &&
            ((s = i.top * c - (e * c - e)),
            s > 0 && (s = 0),
            s < p - g && (s = p - g)),
          l.updateCursor(h, g),
          n.fancybox.animate(
            u,
            { top: s, left: a, scaleX: r, scaleY: c },
            o || 366,
            function () {
              l.isAnimating = !1;
            }
          ),
          l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop());
      },
      scaleToFit: function (t) {
        var e,
          o = this,
          i = o.current,
          a = i.$content;
        o.isAnimating ||
          o.isMoved() ||
          !a ||
          "image" != i.type ||
          !i.isLoaded ||
          i.hasError ||
          ((o.isAnimating = !0),
          n.fancybox.stop(a),
          (e = o.getFitPos(i)),
          o.updateCursor(e.width, e.height),
          n.fancybox.animate(
            a,
            {
              top: e.top,
              left: e.left,
              scaleX: e.width / a.width(),
              scaleY: e.height / a.height(),
            },
            t || 366,
            function () {
              o.isAnimating = !1;
            }
          ));
      },
      getFitPos: function (t) {
        var e,
          o,
          i,
          a,
          s = this,
          r = t.$content,
          c = t.$slide,
          l = t.width || t.opts.width,
          d = t.height || t.opts.height,
          u = {};
        return (
          !!(t.isLoaded && r && r.length) &&
          ((e = n.fancybox.getTranslate(s.$refs.stage).width),
          (o = n.fancybox.getTranslate(s.$refs.stage).height),
          (e -=
            parseFloat(c.css("paddingLeft")) +
            parseFloat(c.css("paddingRight")) +
            parseFloat(r.css("marginLeft")) +
            parseFloat(r.css("marginRight"))),
          (o -=
            parseFloat(c.css("paddingTop")) +
            parseFloat(c.css("paddingBottom")) +
            parseFloat(r.css("marginTop")) +
            parseFloat(r.css("marginBottom"))),
          (l && d) || ((l = e), (d = o)),
          (i = Math.min(1, e / l, o / d)),
          (l *= i),
          (d *= i),
          l > e - 0.5 && (l = e),
          d > o - 0.5 && (d = o),
          "image" === t.type
            ? ((u.top =
                Math.floor(0.5 * (o - d)) + parseFloat(c.css("paddingTop"))),
              (u.left =
                Math.floor(0.5 * (e - l)) + parseFloat(c.css("paddingLeft"))))
            : "video" === t.contentType &&
              ((a =
                t.opts.width && t.opts.height ? l / d : t.opts.ratio || 16 / 9),
              d > l / a ? (d = l / a) : l > d * a && (l = d * a)),
          (u.width = l),
          (u.height = d),
          u)
        );
      },
      update: function (t) {
        var e = this;
        n.each(e.slides, function (n, o) {
          e.updateSlide(o, t);
        });
      },
      updateSlide: function (t, e) {
        var o = this,
          i = t && t.$content,
          a = t.width || t.opts.width,
          s = t.height || t.opts.height,
          r = t.$slide;
        o.adjustCaption(t),
          i &&
            (a || s || "video" === t.contentType) &&
            !t.hasError &&
            (n.fancybox.stop(i),
            n.fancybox.setTranslate(i, o.getFitPos(t)),
            t.pos === o.currPos && ((o.isAnimating = !1), o.updateCursor())),
          o.adjustLayout(t),
          r.length &&
            (r.trigger("refresh"),
            t.pos === o.currPos &&
              o.$refs.toolbar
                .add(o.$refs.navigation.find(".fancybox-button--arrow_right"))
                .toggleClass(
                  "compensate-for-scrollbar",
                  r.get(0).scrollHeight > r.get(0).clientHeight
                )),
          o.trigger("onUpdate", t, e);
      },
      centerSlide: function (t) {
        var e = this,
          o = e.current,
          i = o.$slide;
        !e.isClosing &&
          o &&
          (i.siblings().css({ transform: "", opacity: "" }),
          i
            .parent()
            .children()
            .removeClass("fancybox-slide--previous fancybox-slide--next"),
          n.fancybox.animate(
            i,
            { top: 0, left: 0, opacity: 1 },
            void 0 === t ? 0 : t,
            function () {
              i.css({ transform: "", opacity: "" }),
                o.isComplete || e.complete();
            },
            !1
          ));
      },
      isMoved: function (t) {
        var e,
          o,
          i = t || this.current;
        return (
          !!i &&
          ((o = n.fancybox.getTranslate(this.$refs.stage)),
          (e = n.fancybox.getTranslate(i.$slide)),
          !i.$slide.hasClass("fancybox-animated") &&
            (Math.abs(e.top - o.top) > 0.5 || Math.abs(e.left - o.left) > 0.5))
        );
      },
      updateCursor: function (t, e) {
        var o,
          i,
          a = this,
          s = a.current,
          r = a.$refs.container;
        s &&
          !a.isClosing &&
          a.Guestures &&
          (r.removeClass(
            "fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"
          ),
          (o = a.canPan(t, e)),
          (i = !!o || a.isZoomable()),
          r.toggleClass("fancybox-is-zoomable", i),
          n("[data-fancybox-zoom]").prop("disabled", !i),
          o
            ? r.addClass("fancybox-can-pan")
            : i &&
              ("zoom" === s.opts.clickContent ||
                (n.isFunction(s.opts.clickContent) &&
                  "zoom" == s.opts.clickContent(s)))
            ? r.addClass("fancybox-can-zoomIn")
            : s.opts.touch &&
              (s.opts.touch.vertical || a.group.length > 1) &&
              "video" !== s.contentType &&
              r.addClass("fancybox-can-swipe"));
      },
      isZoomable: function () {
        var t,
          e = this,
          n = e.current;
        if (n && !e.isClosing && "image" === n.type && !n.hasError) {
          if (!n.isLoaded) return !0;
          if (
            (t = e.getFitPos(n)) &&
            (n.width > t.width || n.height > t.height)
          )
            return !0;
        }
        return !1;
      },
      isScaledDown: function (t, e) {
        var o = this,
          i = !1,
          a = o.current,
          s = a.$content;
        return (
          void 0 !== t && void 0 !== e
            ? (i = t < a.width && e < a.height)
            : s &&
              ((i = n.fancybox.getTranslate(s)),
              (i = i.width < a.width && i.height < a.height)),
          i
        );
      },
      canPan: function (t, e) {
        var o = this,
          i = o.current,
          a = null,
          s = !1;
        return (
          "image" === i.type &&
            (i.isComplete || (t && e)) &&
            !i.hasError &&
            ((s = o.getFitPos(i)),
            void 0 !== t && void 0 !== e
              ? (a = { width: t, height: e })
              : i.isComplete && (a = n.fancybox.getTranslate(i.$content)),
            a &&
              s &&
              (s =
                Math.abs(a.width - s.width) > 1.5 ||
                Math.abs(a.height - s.height) > 1.5)),
          s
        );
      },
      loadSlide: function (t) {
        var e,
          o,
          i,
          a = this;
        if (!t.isLoading && !t.isLoaded) {
          if (((t.isLoading = !0), !1 === a.trigger("beforeLoad", t)))
            return (t.isLoading = !1), !1;
          switch (
            ((e = t.type),
            (o = t.$slide),
            o.off("refresh").trigger("onReset").addClass(t.opts.slideClass),
            e)
          ) {
            case "image":
              a.setImage(t);
              break;
            case "iframe":
              a.setIframe(t);
              break;
            case "html":
              a.setContent(t, t.src || t.content);
              break;
            case "video":
              a.setContent(
                t,
                t.opts.video.tpl
                  .replace(/\{\{src\}\}/gi, t.src)
                  .replace(
                    "{{format}}",
                    t.opts.videoFormat || t.opts.video.format || ""
                  )
                  .replace("{{poster}}", t.thumb || "")
              );
              break;
            case "inline":
              n(t.src).length ? a.setContent(t, n(t.src)) : a.setError(t);
              break;
            case "ajax":
              a.showLoading(t),
                (i = n.ajax(
                  n.extend({}, t.opts.ajax.settings, {
                    url: t.src,
                    success: function (e, n) {
                      "success" === n && a.setContent(t, e);
                    },
                    error: function (e, n) {
                      e && "abort" !== n && a.setError(t);
                    },
                  })
                )),
                o.one("onReset", function () {
                  i.abort();
                });
              break;
            default:
              a.setError(t);
          }
          return !0;
        }
      },
      setImage: function (t) {
        var o,
          i = this;
        setTimeout(function () {
          var e = t.$image;
          i.isClosing ||
            !t.isLoading ||
            (e && e.length && e[0].complete) ||
            t.hasError ||
            i.showLoading(t);
        }, 50),
          i.checkSrcset(t),
          (t.$content = n('<div class="fancybox-content"></div>')
            .addClass("fancybox-is-hidden")
            .appendTo(t.$slide.addClass("fancybox-slide--image"))),
          !1 !== t.opts.preload &&
            t.opts.width &&
            t.opts.height &&
            t.thumb &&
            ((t.width = t.opts.width),
            (t.height = t.opts.height),
            (o = e.createElement("img")),
            (o.onerror = function () {
              n(this).remove(), (t.$ghost = null);
            }),
            (o.onload = function () {
              i.afterLoad(t);
            }),
            (t.$ghost = n(o)
              .addClass("fancybox-image")
              .appendTo(t.$content)
              .attr("src", t.thumb))),
          i.setBigImage(t);
      },
      checkSrcset: function (e) {
        var n,
          o,
          i,
          a,
          s = e.opts.srcset || e.opts.image.srcset;
        if (s) {
          (i = t.devicePixelRatio || 1),
            (a = t.innerWidth * i),
            (o = s.split(",").map(function (t) {
              var e = {};
              return (
                t
                  .trim()
                  .split(/\s+/)
                  .forEach(function (t, n) {
                    var o = parseInt(t.substring(0, t.length - 1), 10);
                    if (0 === n) return (e.url = t);
                    o && ((e.value = o), (e.postfix = t[t.length - 1]));
                  }),
                e
              );
            })),
            o.sort(function (t, e) {
              return t.value - e.value;
            });
          for (var r = 0; r < o.length; r++) {
            var c = o[r];
            if (
              ("w" === c.postfix && c.value >= a) ||
              ("x" === c.postfix && c.value >= i)
            ) {
              n = c;
              break;
            }
          }
          !n && o.length && (n = o[o.length - 1]),
            n &&
              ((e.src = n.url),
              e.width &&
                e.height &&
                "w" == n.postfix &&
                ((e.height = (e.width / e.height) * n.value),
                (e.width = n.value)),
              (e.opts.srcset = s));
        }
      },
      setBigImage: function (t) {
        var o = this,
          i = e.createElement("img"),
          a = n(i);
        (t.$image = a
          .one("error", function () {
            o.setError(t);
          })
          .one("load", function () {
            var e;
            t.$ghost ||
              (o.resolveImageSlideSize(
                t,
                this.naturalWidth,
                this.naturalHeight
              ),
              o.afterLoad(t)),
              o.isClosing ||
                (t.opts.srcset &&
                  ((e = t.opts.sizes),
                  (e && "auto" !== e) ||
                    (e =
                      (t.width / t.height > 1 && s.width() / s.height() > 1
                        ? "100"
                        : Math.round((t.width / t.height) * 100)) + "vw"),
                  a.attr("sizes", e).attr("srcset", t.opts.srcset)),
                t.$ghost &&
                  setTimeout(function () {
                    t.$ghost && !o.isClosing && t.$ghost.hide();
                  }, Math.min(300, Math.max(1e3, t.height / 1600))),
                o.hideLoading(t));
          })
          .addClass("fancybox-image")
          .attr("src", t.src)
          .appendTo(t.$content)),
          (i.complete || "complete" == i.readyState) &&
          a.naturalWidth &&
          a.naturalHeight
            ? a.trigger("load")
            : i.error && a.trigger("error");
      },
      resolveImageSlideSize: function (t, e, n) {
        var o = parseInt(t.opts.width, 10),
          i = parseInt(t.opts.height, 10);
        (t.width = e),
          (t.height = n),
          o > 0 && ((t.width = o), (t.height = Math.floor((o * n) / e))),
          i > 0 && ((t.width = Math.floor((i * e) / n)), (t.height = i));
      },
      setIframe: function (t) {
        var e,
          o = this,
          i = t.opts.iframe,
          a = t.$slide;
        (t.$content = n(
          '<div class="fancybox-content' +
            (i.preload ? " fancybox-is-hidden" : "") +
            '"></div>'
        )
          .css(i.css)
          .appendTo(a)),
          a.addClass("fancybox-slide--" + t.contentType),
          (t.$iframe = e = n(i.tpl.replace(/\{rnd\}/g, new Date().getTime()))
            .attr(i.attr)
            .appendTo(t.$content)),
          i.preload
            ? (o.showLoading(t),
              e.on("load.fb error.fb", function (e) {
                (this.isReady = 1), t.$slide.trigger("refresh"), o.afterLoad(t);
              }),
              a.on("refresh.fb", function () {
                var n,
                  o,
                  s = t.$content,
                  r = i.css.width,
                  c = i.css.height;
                if (1 === e[0].isReady) {
                  try {
                    (n = e.contents()), (o = n.find("body"));
                  } catch (t) {}
                  o &&
                    o.length &&
                    o.children().length &&
                    (a.css("overflow", "visible"),
                    s.css({
                      width: "100%",
                      "max-width": "100%",
                      height: "9999px",
                    }),
                    void 0 === r &&
                      (r = Math.ceil(
                        Math.max(o[0].clientWidth, o.outerWidth(!0))
                      )),
                    s.css("width", r || "").css("max-width", ""),
                    void 0 === c &&
                      (c = Math.ceil(
                        Math.max(o[0].clientHeight, o.outerHeight(!0))
                      )),
                    s.css("height", c || ""),
                    a.css("overflow", "auto")),
                    s.removeClass("fancybox-is-hidden");
                }
              }))
            : o.afterLoad(t),
          e.attr("src", t.src),
          a.one("onReset", function () {
            try {
              n(this)
                .find("iframe")
                .hide()
                .unbind()
                .attr("src", "//about:blank");
            } catch (t) {}
            n(this).off("refresh.fb").empty(),
              (t.isLoaded = !1),
              (t.isRevealed = !1);
          });
      },
      setContent: function (t, e) {
        var o = this;
        o.isClosing ||
          (o.hideLoading(t),
          t.$content && n.fancybox.stop(t.$content),
          t.$slide.empty(),
          l(e) && e.parent().length
            ? ((e.hasClass("fancybox-content") ||
                e.parent().hasClass("fancybox-content")) &&
                e.parents(".fancybox-slide").trigger("onReset"),
              (t.$placeholder = n("<div>").hide().insertAfter(e)),
              e.css("display", "inline-block"))
            : t.hasError ||
              ("string" === n.type(e) &&
                (e = n("<div>").append(n.trim(e)).contents()),
              t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))),
          t.$slide.one("onReset", function () {
            n(this).find("video,audio").trigger("pause"),
              t.$placeholder &&
                (t.$placeholder
                  .after(e.removeClass("fancybox-content").hide())
                  .remove(),
                (t.$placeholder = null)),
              t.$smallBtn && (t.$smallBtn.remove(), (t.$smallBtn = null)),
              t.hasError ||
                (n(this).empty(), (t.isLoaded = !1), (t.isRevealed = !1));
          }),
          n(e).appendTo(t.$slide),
          n(e).is("video,audio") &&
            (n(e).addClass("fancybox-video"),
            n(e).wrap("<div></div>"),
            (t.contentType = "video"),
            (t.opts.width = t.opts.width || n(e).attr("width")),
            (t.opts.height = t.opts.height || n(e).attr("height"))),
          (t.$content = t.$slide
            .children()
            .filter("div,form,main,video,audio,article,.fancybox-content")
            .first()),
          t.$content.siblings().hide(),
          t.$content.length ||
            (t.$content = t.$slide.wrapInner("<div></div>").children().first()),
          t.$content.addClass("fancybox-content"),
          t.$slide.addClass("fancybox-slide--" + t.contentType),
          o.afterLoad(t));
      },
      setError: function (t) {
        (t.hasError = !0),
          t.$slide
            .trigger("onReset")
            .removeClass("fancybox-slide--" + t.contentType)
            .addClass("fancybox-slide--error"),
          (t.contentType = "html"),
          this.setContent(t, this.translate(t, t.opts.errorTpl)),
          t.pos === this.currPos && (this.isAnimating = !1);
      },
      showLoading: function (t) {
        var e = this;
        (t = t || e.current) &&
          !t.$spinner &&
          (t.$spinner = n(e.translate(e, e.opts.spinnerTpl))
            .appendTo(t.$slide)
            .hide()
            .fadeIn("fast"));
      },
      hideLoading: function (t) {
        var e = this;
        (t = t || e.current) &&
          t.$spinner &&
          (t.$spinner.stop().remove(), delete t.$spinner);
      },
      afterLoad: function (t) {
        var e = this;
        e.isClosing ||
          ((t.isLoading = !1),
          (t.isLoaded = !0),
          e.trigger("afterLoad", t),
          e.hideLoading(t),
          !t.opts.smallBtn ||
            (t.$smallBtn && t.$smallBtn.length) ||
            (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(
              t.$content
            )),
          t.opts.protect &&
            t.$content &&
            !t.hasError &&
            (t.$content.on("contextmenu.fb", function (t) {
              return 2 == t.button && t.preventDefault(), !0;
            }),
            "image" === t.type &&
              n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
          e.adjustCaption(t),
          e.adjustLayout(t),
          t.pos === e.currPos && e.updateCursor(),
          e.revealContent(t));
      },
      adjustCaption: function (t) {
        var e,
          n = this,
          o = t || n.current,
          i = o.opts.caption,
          a = o.opts.preventCaptionOverlap,
          s = n.$refs.caption,
          r = !1;
        s.toggleClass("fancybox-caption--separate", a),
          a &&
            i &&
            i.length &&
            (o.pos !== n.currPos
              ? ((e = s.clone().appendTo(s.parent())),
                e.children().eq(0).empty().html(i),
                (r = e.outerHeight(!0)),
                e.empty().remove())
              : n.$caption && (r = n.$caption.outerHeight(!0)),
            o.$slide.css("padding-bottom", r || ""));
      },
      adjustLayout: function (t) {
        var e,
          n,
          o,
          i,
          a = this,
          s = t || a.current;
        s.isLoaded &&
          !0 !== s.opts.disableLayoutFix &&
          (s.$content.css("margin-bottom", ""),
          s.$content.outerHeight() > s.$slide.height() + 0.5 &&
            ((o = s.$slide[0].style["padding-bottom"]),
            (i = s.$slide.css("padding-bottom")),
            parseFloat(i) > 0 &&
              ((e = s.$slide[0].scrollHeight),
              s.$slide.css("padding-bottom", 0),
              Math.abs(e - s.$slide[0].scrollHeight) < 1 && (n = i),
              s.$slide.css("padding-bottom", o))),
          s.$content.css("margin-bottom", n));
      },
      revealContent: function (t) {
        var e,
          o,
          i,
          a,
          s = this,
          r = t.$slide,
          c = !1,
          l = !1,
          d = s.isMoved(t),
          u = t.isRevealed;
        return (
          (t.isRevealed = !0),
          (e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"]),
          (i = t.opts[s.firstRun ? "animationDuration" : "transitionDuration"]),
          (i = parseInt(
            void 0 === t.forcedDuration ? i : t.forcedDuration,
            10
          )),
          (!d && t.pos === s.currPos && i) || (e = !1),
          "zoom" === e &&
            (t.pos === s.currPos &&
            i &&
            "image" === t.type &&
            !t.hasError &&
            (l = s.getThumbPos(t))
              ? (c = s.getFitPos(t))
              : (e = "fade")),
          "zoom" === e
            ? ((s.isAnimating = !0),
              (c.scaleX = c.width / l.width),
              (c.scaleY = c.height / l.height),
              (a = t.opts.zoomOpacity),
              "auto" == a &&
                (a = Math.abs(t.width / t.height - l.width / l.height) > 0.1),
              a && ((l.opacity = 0.1), (c.opacity = 1)),
              n.fancybox.setTranslate(
                t.$content.removeClass("fancybox-is-hidden"),
                l
              ),
              p(t.$content),
              void n.fancybox.animate(t.$content, c, i, function () {
                (s.isAnimating = !1), s.complete();
              }))
            : (s.updateSlide(t),
              e
                ? (n.fancybox.stop(r),
                  (o =
                    "fancybox-slide--" +
                    (t.pos >= s.prevPos ? "next" : "previous") +
                    " fancybox-animated fancybox-fx-" +
                    e),
                  r.addClass(o).removeClass("fancybox-slide--current"),
                  t.$content.removeClass("fancybox-is-hidden"),
                  p(r),
                  "image" !== t.type && t.$content.hide().show(0),
                  void n.fancybox.animate(
                    r,
                    "fancybox-slide--current",
                    i,
                    function () {
                      r.removeClass(o).css({ transform: "", opacity: "" }),
                        t.pos === s.currPos && s.complete();
                    },
                    !0
                  ))
                : (t.$content.removeClass("fancybox-is-hidden"),
                  u ||
                    !d ||
                    "image" !== t.type ||
                    t.hasError ||
                    t.$content.hide().fadeIn("fast"),
                  void (t.pos === s.currPos && s.complete())))
        );
      },
      getThumbPos: function (t) {
        var e,
          o,
          i,
          a,
          s,
          r = !1,
          c = t.$thumb;
        return (
          !(!c || !g(c[0])) &&
          ((e = n.fancybox.getTranslate(c)),
          (o = parseFloat(c.css("border-top-width") || 0)),
          (i = parseFloat(c.css("border-right-width") || 0)),
          (a = parseFloat(c.css("border-bottom-width") || 0)),
          (s = parseFloat(c.css("border-left-width") || 0)),
          (r = {
            top: e.top + o,
            left: e.left + s,
            width: e.width - i - s,
            height: e.height - o - a,
            scaleX: 1,
            scaleY: 1,
          }),
          e.width > 0 && e.height > 0 && r)
        );
      },
      complete: function () {
        var t,
          e = this,
          o = e.current,
          i = {};
        !e.isMoved() &&
          o.isLoaded &&
          (o.isComplete ||
            ((o.isComplete = !0),
            o.$slide.siblings().trigger("onReset"),
            e.preload("inline"),
            p(o.$slide),
            o.$slide.addClass("fancybox-slide--complete"),
            n.each(e.slides, function (t, o) {
              o.pos >= e.currPos - 1 && o.pos <= e.currPos + 1
                ? (i[o.pos] = o)
                : o && (n.fancybox.stop(o.$slide), o.$slide.off().remove());
            }),
            (e.slides = i)),
          (e.isAnimating = !1),
          e.updateCursor(),
          e.trigger("afterShow"),
          o.opts.video.autoStart &&
            o.$slide
              .find("video,audio")
              .filter(":visible:first")
              .trigger("play")
              .one("ended", function () {
                Document.exitFullscreen
                  ? Document.exitFullscreen()
                  : this.webkitExitFullscreen && this.webkitExitFullscreen(),
                  e.next();
              }),
          o.opts.autoFocus &&
            "html" === o.contentType &&
            ((t = o.$content.find("input[autofocus]:enabled:visible:first")),
            t.length ? t.trigger("focus") : e.focus(null, !0)),
          o.$slide.scrollTop(0).scrollLeft(0));
      },
      preload: function (t) {
        var e,
          n,
          o = this;
        o.group.length < 2 ||
          ((n = o.slides[o.currPos + 1]),
          (e = o.slides[o.currPos - 1]),
          e && e.type === t && o.loadSlide(e),
          n && n.type === t && o.loadSlide(n));
      },
      focus: function (t, o) {
        var i,
          a,
          s = this,
          r = [
            "a[href]",
            "area[href]",
            'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
            "select:not([disabled]):not([aria-hidden])",
            "textarea:not([disabled]):not([aria-hidden])",
            "button:not([disabled]):not([aria-hidden])",
            "iframe",
            "object",
            "embed",
            "video",
            "audio",
            "[contenteditable]",
            '[tabindex]:not([tabindex^="-"])',
          ].join(",");
        s.isClosing ||
          ((i =
            !t && s.current && s.current.isComplete
              ? s.current.$slide.find(
                  "*:visible" + (o ? ":not(.fancybox-close-small)" : "")
                )
              : s.$refs.container.find("*:visible")),
          (i = i.filter(r).filter(function () {
            return (
              "hidden" !== n(this).css("visibility") &&
              !n(this).hasClass("disabled")
            );
          })),
          i.length
            ? ((a = i.index(e.activeElement)),
              t && t.shiftKey
                ? (a < 0 || 0 == a) &&
                  (t.preventDefault(), i.eq(i.length - 1).trigger("focus"))
                : (a < 0 || a == i.length - 1) &&
                  (t && t.preventDefault(), i.eq(0).trigger("focus")))
            : s.$refs.container.trigger("focus"));
      },
      activate: function () {
        var t = this;
        n(".fancybox-container").each(function () {
          var e = n(this).data("FancyBox");
          e &&
            e.id !== t.id &&
            !e.isClosing &&
            (e.trigger("onDeactivate"), e.removeEvents(), (e.isVisible = !1));
        }),
          (t.isVisible = !0),
          (t.current || t.isIdle) && (t.update(), t.updateControls()),
          t.trigger("onActivate"),
          t.addEvents();
      },
      close: function (t, e) {
        var o,
          i,
          a,
          s,
          r,
          c,
          l,
          u = this,
          f = u.current,
          h = function () {
            u.cleanUp(t);
          };
        return (
          !u.isClosing &&
          ((u.isClosing = !0),
          !1 === u.trigger("beforeClose", t)
            ? ((u.isClosing = !1),
              d(function () {
                u.update();
              }),
              !1)
            : (u.removeEvents(),
              (a = f.$content),
              (o = f.opts.animationEffect),
              (i = n.isNumeric(e) ? e : o ? f.opts.animationDuration : 0),
              f.$slide.removeClass(
                "fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"
              ),
              !0 !== t ? n.fancybox.stop(f.$slide) : (o = !1),
              f.$slide.siblings().trigger("onReset").remove(),
              i &&
                u.$refs.container
                  .removeClass("fancybox-is-open")
                  .addClass("fancybox-is-closing")
                  .css("transition-duration", i + "ms"),
              u.hideLoading(f),
              u.hideControls(!0),
              u.updateCursor(),
              "zoom" !== o ||
                (a &&
                  i &&
                  "image" === f.type &&
                  !u.isMoved() &&
                  !f.hasError &&
                  (l = u.getThumbPos(f))) ||
                (o = "fade"),
              "zoom" === o
                ? (n.fancybox.stop(a),
                  (s = n.fancybox.getTranslate(a)),
                  (c = {
                    top: s.top,
                    left: s.left,
                    scaleX: s.width / l.width,
                    scaleY: s.height / l.height,
                    width: l.width,
                    height: l.height,
                  }),
                  (r = f.opts.zoomOpacity),
                  "auto" == r &&
                    (r =
                      Math.abs(f.width / f.height - l.width / l.height) > 0.1),
                  r && (l.opacity = 0),
                  n.fancybox.setTranslate(a, c),
                  p(a),
                  n.fancybox.animate(a, l, i, h),
                  !0)
                : (o && i
                    ? n.fancybox.animate(
                        f.$slide
                          .addClass("fancybox-slide--previous")
                          .removeClass("fancybox-slide--current"),
                        "fancybox-animated fancybox-fx-" + o,
                        i,
                        h
                      )
                    : !0 === t
                    ? setTimeout(h, i)
                    : h(),
                  !0)))
        );
      },
      cleanUp: function (e) {
        var o,
          i,
          a,
          s = this,
          r = s.current.opts.$orig;
        s.current.$slide.trigger("onReset"),
          s.$refs.container.empty().remove(),
          s.trigger("afterClose", e),
          s.current.opts.backFocus &&
            ((r && r.length && r.is(":visible")) || (r = s.$trigger),
            r &&
              r.length &&
              ((i = t.scrollX),
              (a = t.scrollY),
              r.trigger("focus"),
              n("html, body").scrollTop(a).scrollLeft(i))),
          (s.current = null),
          (o = n.fancybox.getInstance()),
          o
            ? o.activate()
            : (n("body").removeClass(
                "fancybox-active compensate-for-scrollbar"
              ),
              n("#fancybox-style-noscroll").remove());
      },
      trigger: function (t, e) {
        var o,
          i = Array.prototype.slice.call(arguments, 1),
          a = this,
          s = e && e.opts ? e : a.current;
        if (
          (s ? i.unshift(s) : (s = a),
          i.unshift(a),
          n.isFunction(s.opts[t]) && (o = s.opts[t].apply(s, i)),
          !1 === o)
        )
          return o;
        "afterClose" !== t && a.$refs
          ? a.$refs.container.trigger(t + ".fb", i)
          : r.trigger(t + ".fb", i);
      },
      updateControls: function () {
        var t = this,
          o = t.current,
          i = o.index,
          a = t.$refs.container,
          s = t.$refs.caption,
          r = o.opts.caption;
        o.$slide.trigger("refresh"),
          r && r.length
            ? ((t.$caption = s), s.children().eq(0).html(r))
            : (t.$caption = null),
          t.hasHiddenControls || t.isIdle || t.showControls(),
          a.find("[data-fancybox-count]").html(t.group.length),
          a.find("[data-fancybox-index]").html(i + 1),
          a
            .find("[data-fancybox-prev]")
            .prop("disabled", !o.opts.loop && i <= 0),
          a
            .find("[data-fancybox-next]")
            .prop("disabled", !o.opts.loop && i >= t.group.length - 1),
          "image" === o.type
            ? a
                .find("[data-fancybox-zoom]")
                .show()
                .end()
                .find("[data-fancybox-download]")
                .attr("href", o.opts.image.src || o.src)
                .show()
            : o.opts.toolbar &&
              a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
          n(e.activeElement).is(":hidden,[disabled]") &&
            t.$refs.container.trigger("focus");
      },
      hideControls: function (t) {
        var e = this,
          n = ["infobar", "toolbar", "nav"];
        (!t && e.current.opts.preventCaptionOverlap) || n.push("caption"),
          this.$refs.container.removeClass(
            n
              .map(function (t) {
                return "fancybox-show-" + t;
              })
              .join(" ")
          ),
          (this.hasHiddenControls = !0);
      },
      showControls: function () {
        var t = this,
          e = t.current ? t.current.opts : t.opts,
          n = t.$refs.container;
        (t.hasHiddenControls = !1),
          (t.idleSecondsCounter = 0),
          n
            .toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons))
            .toggleClass(
              "fancybox-show-infobar",
              !!(e.infobar && t.group.length > 1)
            )
            .toggleClass("fancybox-show-caption", !!t.$caption)
            .toggleClass(
              "fancybox-show-nav",
              !!(e.arrows && t.group.length > 1)
            )
            .toggleClass("fancybox-is-modal", !!e.modal);
      },
      toggleControls: function () {
        this.hasHiddenControls ? this.showControls() : this.hideControls();
      },
    }),
      (n.fancybox = {
        version: "3.5.7",
        defaults: a,
        getInstance: function (t) {
          var e = n(
              '.fancybox-container:not(".fancybox-is-closing"):last'
            ).data("FancyBox"),
            o = Array.prototype.slice.call(arguments, 1);
          return (
            e instanceof b &&
            ("string" === n.type(t)
              ? e[t].apply(e, o)
              : "function" === n.type(t) && t.apply(e, o),
            e)
          );
        },
        open: function (t, e, n) {
          return new b(t, e, n);
        },
        close: function (t) {
          var e = this.getInstance();
          e && (e.close(), !0 === t && this.close(t));
        },
        destroy: function () {
          this.close(!0), r.add("body").off("click.fb-start", "**");
        },
        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ),
        use3d: (function () {
          var n = e.createElement("div");
          return (
            t.getComputedStyle &&
            t.getComputedStyle(n) &&
            t.getComputedStyle(n).getPropertyValue("transform") &&
            !(e.documentMode && e.documentMode < 11)
          );
        })(),
        getTranslate: function (t) {
          var e;
          return (
            !(!t || !t.length) &&
            ((e = t[0].getBoundingClientRect()),
            {
              top: e.top || 0,
              left: e.left || 0,
              width: e.width,
              height: e.height,
              opacity: parseFloat(t.css("opacity")),
            })
          );
        },
        setTranslate: function (t, e) {
          var n = "",
            o = {};
          if (t && e)
            return (
              (void 0 === e.left && void 0 === e.top) ||
                ((n =
                  (void 0 === e.left ? t.position().left : e.left) +
                  "px, " +
                  (void 0 === e.top ? t.position().top : e.top) +
                  "px"),
                (n = this.use3d
                  ? "translate3d(" + n + ", 0px)"
                  : "translate(" + n + ")")),
              void 0 !== e.scaleX && void 0 !== e.scaleY
                ? (n += " scale(" + e.scaleX + ", " + e.scaleY + ")")
                : void 0 !== e.scaleX && (n += " scaleX(" + e.scaleX + ")"),
              n.length && (o.transform = n),
              void 0 !== e.opacity && (o.opacity = e.opacity),
              void 0 !== e.width && (o.width = e.width),
              void 0 !== e.height && (o.height = e.height),
              t.css(o)
            );
        },
        animate: function (t, e, o, i, a) {
          var s,
            r = this;
          n.isFunction(o) && ((i = o), (o = null)),
            r.stop(t),
            (s = r.getTranslate(t)),
            t.on(f, function (c) {
              (!c ||
                !c.originalEvent ||
                (t.is(c.originalEvent.target) &&
                  "z-index" != c.originalEvent.propertyName)) &&
                (r.stop(t),
                n.isNumeric(o) && t.css("transition-duration", ""),
                n.isPlainObject(e)
                  ? void 0 !== e.scaleX &&
                    void 0 !== e.scaleY &&
                    r.setTranslate(t, {
                      top: e.top,
                      left: e.left,
                      width: s.width * e.scaleX,
                      height: s.height * e.scaleY,
                      scaleX: 1,
                      scaleY: 1,
                    })
                  : !0 !== a && t.removeClass(e),
                n.isFunction(i) && i(c));
            }),
            n.isNumeric(o) && t.css("transition-duration", o + "ms"),
            n.isPlainObject(e)
              ? (void 0 !== e.scaleX &&
                  void 0 !== e.scaleY &&
                  (delete e.width,
                  delete e.height,
                  t.parent().hasClass("fancybox-slide--image") &&
                    t.parent().addClass("fancybox-is-scaling")),
                n.fancybox.setTranslate(t, e))
              : t.addClass(e),
            t.data(
              "timer",
              setTimeout(function () {
                t.trigger(f);
              }, o + 33)
            );
        },
        stop: function (t, e) {
          t &&
            t.length &&
            (clearTimeout(t.data("timer")),
            e && t.trigger(f),
            t.off(f).css("transition-duration", ""),
            t.parent().removeClass("fancybox-is-scaling"));
        },
      }),
      (n.fn.fancybox = function (t) {
        var e;
        return (
          (t = t || {}),
          (e = t.selector || !1),
          e
            ? n("body")
                .off("click.fb-start", e)
                .on("click.fb-start", e, { options: t }, i)
            : this.off("click.fb-start").on(
                "click.fb-start",
                { items: this, options: t },
                i
              ),
          this
        );
      }),
      r.on("click.fb-start", "[data-fancybox]", i),
      r.on("click.fb-start", "[data-fancybox-trigger]", function (t) {
        n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]')
          .eq(n(this).attr("data-fancybox-index") || 0)
          .trigger("click.fb-start", { $trigger: n(this) });
      }),
      (function () {
        var t = null;
        r.on("mousedown mouseup focus blur", ".fancybox-button", function (e) {
          switch (e.type) {
            case "mousedown":
              t = n(this);
              break;
            case "mouseup":
              t = null;
              break;
            case "focusin":
              n(".fancybox-button").removeClass("fancybox-focus"),
                n(this).is(t) ||
                  n(this).is("[disabled]") ||
                  n(this).addClass("fancybox-focus");
              break;
            case "focusout":
              n(".fancybox-button").removeClass("fancybox-focus");
          }
        });
      })();
  }
})(window, document, jQuery),
  (function (t) {
    "use strict";
    var e = {
        youtube: {
          matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
          params: {
            autoplay: 1,
            autohide: 1,
            fs: 1,
            rel: 0,
            hd: 1,
            wmode: "transparent",
            enablejsapi: 1,
            html5: 1,
          },
          paramPlace: 8,
          type: "iframe",
          url: "https://www.youtube-nocookie.com/embed/$4",
          thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg",
        },
        vimeo: {
          matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
          params: {
            autoplay: 1,
            hd: 1,
            show_title: 1,
            show_byline: 1,
            show_portrait: 0,
            fullscreen: 1,
          },
          paramPlace: 3,
          type: "iframe",
          url: "//player.vimeo.com/video/$2",
        },
        instagram: {
          matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
          type: "image",
          url: "//$1/p/$2/media/?size=l",
        },
        gmap_place: {
          matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/?ll=" +
              (t[9]
                ? t[9] +
                  "&z=" +
                  Math.floor(t[10]) +
                  (t[12] ? t[12].replace(/^\//, "&") : "")
                : t[12] + ""
              ).replace(/\?/, "&") +
              "&output=" +
              (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
            );
          },
        },
        gmap_search: {
          matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/maps?q=" +
              t[5].replace("query=", "q=").replace("api=1", "") +
              "&output=embed"
            );
          },
        },
      },
      n = function (e, n, o) {
        if (e)
          return (
            (o = o || ""),
            "object" === t.type(o) && (o = t.param(o, !0)),
            t.each(n, function (t, n) {
              e = e.replace("$" + t, n || "");
            }),
            o.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + o),
            e
          );
      };
    t(document).on("objectNeedsType.fb", function (o, i, a) {
      var s,
        r,
        c,
        l,
        d,
        u,
        f,
        p = a.src || "",
        h = !1;
      (s = t.extend(!0, {}, e, a.opts.media)),
        t.each(s, function (e, o) {
          if ((c = p.match(o.matcher))) {
            if (
              ((h = o.type), (f = e), (u = {}), o.paramPlace && c[o.paramPlace])
            ) {
              (d = c[o.paramPlace]),
                "?" == d[0] && (d = d.substring(1)),
                (d = d.split("&"));
              for (var i = 0; i < d.length; ++i) {
                var s = d[i].split("=", 2);
                2 == s.length &&
                  (u[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")));
              }
            }
            return (
              (l = t.extend(!0, {}, o.params, a.opts[e], u)),
              (p =
                "function" === t.type(o.url)
                  ? o.url.call(this, c, l, a)
                  : n(o.url, c, l)),
              (r =
                "function" === t.type(o.thumb)
                  ? o.thumb.call(this, c, l, a)
                  : n(o.thumb, c)),
              "youtube" === e
                ? (p = p.replace(/&t=((\d+)m)?(\d+)s/, function (t, e, n, o) {
                    return (
                      "&start=" +
                      ((n ? 60 * parseInt(n, 10) : 0) + parseInt(o, 10))
                    );
                  }))
                : "vimeo" === e && (p = p.replace("&%23", "#")),
              !1
            );
          }
        }),
        h
          ? (a.opts.thumb ||
              (a.opts.$thumb && a.opts.$thumb.length) ||
              (a.opts.thumb = r),
            "iframe" === h &&
              (a.opts = t.extend(!0, a.opts, {
                iframe: { preload: !1, attr: { scrolling: "no" } },
              })),
            t.extend(a, {
              type: h,
              src: p,
              origSrc: a.src,
              contentSource: f,
              contentType:
                "image" === h
                  ? "image"
                  : "gmap_place" == f || "gmap_search" == f
                  ? "map"
                  : "video",
            }))
          : p && (a.type = a.opts.defaultType);
    });
    var o = {
      youtube: {
        src: "https://www.youtube.com/iframe_api",
        class: "YT",
        loading: !1,
        loaded: !1,
      },
      vimeo: {
        src: "https://player.vimeo.com/api/player.js",
        class: "Vimeo",
        loading: !1,
        loaded: !1,
      },
      load: function (t) {
        var e,
          n = this;
        if (this[t].loaded)
          return void setTimeout(function () {
            n.done(t);
          });
        this[t].loading ||
          ((this[t].loading = !0),
          (e = document.createElement("script")),
          (e.type = "text/javascript"),
          (e.src = this[t].src),
          "youtube" === t
            ? (window.onYouTubeIframeAPIReady = function () {
                (n[t].loaded = !0), n.done(t);
              })
            : (e.onload = function () {
                (n[t].loaded = !0), n.done(t);
              }),
          document.body.appendChild(e));
      },
      done: function (e) {
        var n, o, i;
        "youtube" === e && delete window.onYouTubeIframeAPIReady,
          (n = t.fancybox.getInstance()) &&
            ((o = n.current.$content.find("iframe")),
            "youtube" === e && void 0 !== YT && YT
              ? (i = new YT.Player(o.attr("id"), {
                  events: {
                    onStateChange: function (t) {
                      0 == t.data && n.next();
                    },
                  },
                }))
              : "vimeo" === e &&
                void 0 !== Vimeo &&
                Vimeo &&
                ((i = new Vimeo.Player(o)),
                i.on("ended", function () {
                  n.next();
                })));
      },
    };
    t(document).on({
      "afterShow.fb": function (t, e, n) {
        e.group.length > 1 &&
          ("youtube" === n.contentSource || "vimeo" === n.contentSource) &&
          o.load(n.contentSource);
      },
    });
  })(jQuery),
  (function (t, e, n) {
    "use strict";
    var o = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      i = (function () {
        return (
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          }
        );
      })(),
      a = function (e) {
        var n = [];
        (e = e.originalEvent || e || t.e),
          (e =
            e.touches && e.touches.length
              ? e.touches
              : e.changedTouches && e.changedTouches.length
              ? e.changedTouches
              : [e]);
        for (var o in e)
          e[o].pageX
            ? n.push({ x: e[o].pageX, y: e[o].pageY })
            : e[o].clientX && n.push({ x: e[o].clientX, y: e[o].clientY });
        return n;
      },
      s = function (t, e, n) {
        return e && t
          ? "x" === n
            ? t.x - e.x
            : "y" === n
            ? t.y - e.y
            : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))
          : 0;
      },
      r = function (t) {
        if (
          t.is(
            'a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe'
          ) ||
          n.isFunction(t.get(0).onclick) ||
          t.data("selectable")
        )
          return !0;
        for (var e = 0, o = t[0].attributes, i = o.length; e < i; e++)
          if ("data-fancybox-" === o[e].nodeName.substr(0, 14)) return !0;
        return !1;
      },
      c = function (e) {
        var n = t.getComputedStyle(e)["overflow-y"],
          o = t.getComputedStyle(e)["overflow-x"],
          i =
            ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
          a = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;
        return i || a;
      },
      l = function (t) {
        for (var e = !1; ; ) {
          if ((e = c(t.get(0)))) break;
          if (
            ((t = t.parent()),
            !t.length || t.hasClass("fancybox-stage") || t.is("body"))
          )
            break;
        }
        return e;
      },
      d = function (t) {
        var e = this;
        (e.instance = t),
          (e.$bg = t.$refs.bg),
          (e.$stage = t.$refs.stage),
          (e.$container = t.$refs.container),
          e.destroy(),
          e.$container.on(
            "touchstart.fb.touch mousedown.fb.touch",
            n.proxy(e, "ontouchstart")
          );
      };
    (d.prototype.destroy = function () {
      var t = this;
      t.$container.off(".fb.touch"),
        n(e).off(".fb.touch"),
        t.requestId && (i(t.requestId), (t.requestId = null)),
        t.tapped && (clearTimeout(t.tapped), (t.tapped = null));
    }),
      (d.prototype.ontouchstart = function (o) {
        var i = this,
          c = n(o.target),
          d = i.instance,
          u = d.current,
          f = u.$slide,
          p = u.$content,
          h = "touchstart" == o.type;
        if (
          (h && i.$container.off("mousedown.fb.touch"),
          (!o.originalEvent || 2 != o.originalEvent.button) &&
            f.length &&
            c.length &&
            !r(c) &&
            !r(c.parent()) &&
            (c.is("img") ||
              !(o.originalEvent.clientX > c[0].clientWidth + c.offset().left)))
        ) {
          if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated"))
            return o.stopPropagation(), void o.preventDefault();
          (i.realPoints = i.startPoints = a(o)),
            i.startPoints.length &&
              (u.touch && o.stopPropagation(),
              (i.startEvent = o),
              (i.canTap = !0),
              (i.$target = c),
              (i.$content = p),
              (i.opts = u.opts.touch),
              (i.isPanning = !1),
              (i.isSwiping = !1),
              (i.isZooming = !1),
              (i.isScrolling = !1),
              (i.canPan = d.canPan()),
              (i.startTime = new Date().getTime()),
              (i.distanceX = i.distanceY = i.distance = 0),
              (i.canvasWidth = Math.round(f[0].clientWidth)),
              (i.canvasHeight = Math.round(f[0].clientHeight)),
              (i.contentLastPos = null),
              (i.contentStartPos = n.fancybox.getTranslate(i.$content) || {
                top: 0,
                left: 0,
              }),
              (i.sliderStartPos = n.fancybox.getTranslate(f)),
              (i.stagePos = n.fancybox.getTranslate(d.$refs.stage)),
              (i.sliderStartPos.top -= i.stagePos.top),
              (i.sliderStartPos.left -= i.stagePos.left),
              (i.contentStartPos.top -= i.stagePos.top),
              (i.contentStartPos.left -= i.stagePos.left),
              n(e)
                .off(".fb.touch")
                .on(
                  h
                    ? "touchend.fb.touch touchcancel.fb.touch"
                    : "mouseup.fb.touch mouseleave.fb.touch",
                  n.proxy(i, "ontouchend")
                )
                .on(
                  h ? "touchmove.fb.touch" : "mousemove.fb.touch",
                  n.proxy(i, "ontouchmove")
                ),
              n.fancybox.isMobile &&
                e.addEventListener("scroll", i.onscroll, !0),
              (((i.opts || i.canPan) &&
                (c.is(i.$stage) || i.$stage.find(c).length)) ||
                (c.is(".fancybox-image") && o.preventDefault(),
                n.fancybox.isMobile &&
                  c.parents(".fancybox-caption").length)) &&
                ((i.isScrollable = l(c) || l(c.parent())),
                (n.fancybox.isMobile && i.isScrollable) || o.preventDefault(),
                (1 === i.startPoints.length || u.hasError) &&
                  (i.canPan
                    ? (n.fancybox.stop(i.$content), (i.isPanning = !0))
                    : (i.isSwiping = !0),
                  i.$container.addClass("fancybox-is-grabbing")),
                2 === i.startPoints.length &&
                  "image" === u.type &&
                  (u.isLoaded || u.$ghost) &&
                  ((i.canTap = !1),
                  (i.isSwiping = !1),
                  (i.isPanning = !1),
                  (i.isZooming = !0),
                  n.fancybox.stop(i.$content),
                  (i.centerPointStartX =
                    0.5 * (i.startPoints[0].x + i.startPoints[1].x) -
                    n(t).scrollLeft()),
                  (i.centerPointStartY =
                    0.5 * (i.startPoints[0].y + i.startPoints[1].y) -
                    n(t).scrollTop()),
                  (i.percentageOfImageAtPinchPointX =
                    (i.centerPointStartX - i.contentStartPos.left) /
                    i.contentStartPos.width),
                  (i.percentageOfImageAtPinchPointY =
                    (i.centerPointStartY - i.contentStartPos.top) /
                    i.contentStartPos.height),
                  (i.startDistanceBetweenFingers = s(
                    i.startPoints[0],
                    i.startPoints[1]
                  )))));
        }
      }),
      (d.prototype.onscroll = function (t) {
        var n = this;
        (n.isScrolling = !0), e.removeEventListener("scroll", n.onscroll, !0);
      }),
      (d.prototype.ontouchmove = function (t) {
        var e = this;
        return void 0 !== t.originalEvent.buttons &&
          0 === t.originalEvent.buttons
          ? void e.ontouchend(t)
          : e.isScrolling
          ? void (e.canTap = !1)
          : ((e.newPoints = a(t)),
            void (
              (e.opts || e.canPan) &&
              e.newPoints.length &&
              e.newPoints.length &&
              ((e.isSwiping && !0 === e.isSwiping) || t.preventDefault(),
              (e.distanceX = s(e.newPoints[0], e.startPoints[0], "x")),
              (e.distanceY = s(e.newPoints[0], e.startPoints[0], "y")),
              (e.distance = s(e.newPoints[0], e.startPoints[0])),
              e.distance > 0 &&
                (e.isSwiping
                  ? e.onSwipe(t)
                  : e.isPanning
                  ? e.onPan()
                  : e.isZooming && e.onZoom()))
            ));
      }),
      (d.prototype.onSwipe = function (e) {
        var a,
          s = this,
          r = s.instance,
          c = s.isSwiping,
          l = s.sliderStartPos.left || 0;
        if (!0 !== c)
          "x" == c &&
            (s.distanceX > 0 &&
            (s.instance.group.length < 2 ||
              (0 === s.instance.current.index && !s.instance.current.opts.loop))
              ? (l += Math.pow(s.distanceX, 0.8))
              : s.distanceX < 0 &&
                (s.instance.group.length < 2 ||
                  (s.instance.current.index === s.instance.group.length - 1 &&
                    !s.instance.current.opts.loop))
              ? (l -= Math.pow(-s.distanceX, 0.8))
              : (l += s.distanceX)),
            (s.sliderLastPos = {
              top: "x" == c ? 0 : s.sliderStartPos.top + s.distanceY,
              left: l,
            }),
            s.requestId && (i(s.requestId), (s.requestId = null)),
            (s.requestId = o(function () {
              s.sliderLastPos &&
                (n.each(s.instance.slides, function (t, e) {
                  var o = e.pos - s.instance.currPos;
                  n.fancybox.setTranslate(e.$slide, {
                    top: s.sliderLastPos.top,
                    left:
                      s.sliderLastPos.left +
                      o * s.canvasWidth +
                      o * e.opts.gutter,
                  });
                }),
                s.$container.addClass("fancybox-is-sliding"));
            }));
        else if (Math.abs(s.distance) > 10) {
          if (
            ((s.canTap = !1),
            r.group.length < 2 && s.opts.vertical
              ? (s.isSwiping = "y")
              : r.isDragging ||
                !1 === s.opts.vertical ||
                ("auto" === s.opts.vertical && n(t).width() > 800)
              ? (s.isSwiping = "x")
              : ((a = Math.abs(
                  (180 * Math.atan2(s.distanceY, s.distanceX)) / Math.PI
                )),
                (s.isSwiping = a > 45 && a < 135 ? "y" : "x")),
            "y" === s.isSwiping && n.fancybox.isMobile && s.isScrollable)
          )
            return void (s.isScrolling = !0);
          (r.isDragging = s.isSwiping),
            (s.startPoints = s.newPoints),
            n.each(r.slides, function (t, e) {
              var o, i;
              n.fancybox.stop(e.$slide),
                (o = n.fancybox.getTranslate(e.$slide)),
                (i = n.fancybox.getTranslate(r.$refs.stage)),
                e.$slide
                  .css({
                    transform: "",
                    opacity: "",
                    "transition-duration": "",
                  })
                  .removeClass("fancybox-animated")
                  .removeClass(function (t, e) {
                    return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                  }),
                e.pos === r.current.pos &&
                  ((s.sliderStartPos.top = o.top - i.top),
                  (s.sliderStartPos.left = o.left - i.left)),
                n.fancybox.setTranslate(e.$slide, {
                  top: o.top - i.top,
                  left: o.left - i.left,
                });
            }),
            r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop();
        }
      }),
      (d.prototype.onPan = function () {
        var t = this;
        if (s(t.newPoints[0], t.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5))
          return void (t.startPoints = t.newPoints);
        (t.canTap = !1),
          (t.contentLastPos = t.limitMovement()),
          t.requestId && i(t.requestId),
          (t.requestId = o(function () {
            n.fancybox.setTranslate(t.$content, t.contentLastPos);
          }));
      }),
      (d.prototype.limitMovement = function () {
        var t,
          e,
          n,
          o,
          i,
          a,
          s = this,
          r = s.canvasWidth,
          c = s.canvasHeight,
          l = s.distanceX,
          d = s.distanceY,
          u = s.contentStartPos,
          f = u.left,
          p = u.top,
          h = u.width,
          g = u.height;
        return (
          (i = h > r ? f + l : f),
          (a = p + d),
          (t = Math.max(0, 0.5 * r - 0.5 * h)),
          (e = Math.max(0, 0.5 * c - 0.5 * g)),
          (n = Math.min(r - h, 0.5 * r - 0.5 * h)),
          (o = Math.min(c - g, 0.5 * c - 0.5 * g)),
          l > 0 && i > t && (i = t - 1 + Math.pow(-t + f + l, 0.8) || 0),
          l < 0 && i < n && (i = n + 1 - Math.pow(n - f - l, 0.8) || 0),
          d > 0 && a > e && (a = e - 1 + Math.pow(-e + p + d, 0.8) || 0),
          d < 0 && a < o && (a = o + 1 - Math.pow(o - p - d, 0.8) || 0),
          { top: a, left: i }
        );
      }),
      (d.prototype.limitPosition = function (t, e, n, o) {
        var i = this,
          a = i.canvasWidth,
          s = i.canvasHeight;
        return (
          n > a
            ? ((t = t > 0 ? 0 : t), (t = t < a - n ? a - n : t))
            : (t = Math.max(0, a / 2 - n / 2)),
          o > s
            ? ((e = e > 0 ? 0 : e), (e = e < s - o ? s - o : e))
            : (e = Math.max(0, s / 2 - o / 2)),
          { top: e, left: t }
        );
      }),
      (d.prototype.onZoom = function () {
        var e = this,
          a = e.contentStartPos,
          r = a.width,
          c = a.height,
          l = a.left,
          d = a.top,
          u = s(e.newPoints[0], e.newPoints[1]),
          f = u / e.startDistanceBetweenFingers,
          p = Math.floor(r * f),
          h = Math.floor(c * f),
          g = (r - p) * e.percentageOfImageAtPinchPointX,
          b = (c - h) * e.percentageOfImageAtPinchPointY,
          m = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
          v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
          y = m - e.centerPointStartX,
          x = v - e.centerPointStartY,
          w = l + (g + y),
          $ = d + (b + x),
          S = { top: $, left: w, scaleX: f, scaleY: f };
        (e.canTap = !1),
          (e.newWidth = p),
          (e.newHeight = h),
          (e.contentLastPos = S),
          e.requestId && i(e.requestId),
          (e.requestId = o(function () {
            n.fancybox.setTranslate(e.$content, e.contentLastPos);
          }));
      }),
      (d.prototype.ontouchend = function (t) {
        var o = this,
          s = o.isSwiping,
          r = o.isPanning,
          c = o.isZooming,
          l = o.isScrolling;
        if (
          ((o.endPoints = a(t)),
          (o.dMs = Math.max(new Date().getTime() - o.startTime, 1)),
          o.$container.removeClass("fancybox-is-grabbing"),
          n(e).off(".fb.touch"),
          e.removeEventListener("scroll", o.onscroll, !0),
          o.requestId && (i(o.requestId), (o.requestId = null)),
          (o.isSwiping = !1),
          (o.isPanning = !1),
          (o.isZooming = !1),
          (o.isScrolling = !1),
          (o.instance.isDragging = !1),
          o.canTap)
        )
          return o.onTap(t);
        (o.speed = 100),
          (o.velocityX = (o.distanceX / o.dMs) * 0.5),
          (o.velocityY = (o.distanceY / o.dMs) * 0.5),
          r ? o.endPanning() : c ? o.endZooming() : o.endSwiping(s, l);
      }),
      (d.prototype.endSwiping = function (t, e) {
        var o = this,
          i = !1,
          a = o.instance.group.length,
          s = Math.abs(o.distanceX),
          r = "x" == t && a > 1 && ((o.dMs > 130 && s > 10) || s > 50);
        (o.sliderLastPos = null),
          "y" == t && !e && Math.abs(o.distanceY) > 50
            ? (n.fancybox.animate(
                o.instance.current.$slide,
                {
                  top: o.sliderStartPos.top + o.distanceY + 150 * o.velocityY,
                  opacity: 0,
                },
                200
              ),
              (i = o.instance.close(!0, 250)))
            : r && o.distanceX > 0
            ? (i = o.instance.previous(300))
            : r && o.distanceX < 0 && (i = o.instance.next(300)),
          !1 !== i || ("x" != t && "y" != t) || o.instance.centerSlide(200),
          o.$container.removeClass("fancybox-is-sliding");
      }),
      (d.prototype.endPanning = function () {
        var t,
          e,
          o,
          i = this;
        i.contentLastPos &&
          (!1 === i.opts.momentum || i.dMs > 350
            ? ((t = i.contentLastPos.left), (e = i.contentLastPos.top))
            : ((t = i.contentLastPos.left + 500 * i.velocityX),
              (e = i.contentLastPos.top + 500 * i.velocityY)),
          (o = i.limitPosition(
            t,
            e,
            i.contentStartPos.width,
            i.contentStartPos.height
          )),
          (o.width = i.contentStartPos.width),
          (o.height = i.contentStartPos.height),
          n.fancybox.animate(i.$content, o, 366));
      }),
      (d.prototype.endZooming = function () {
        var t,
          e,
          o,
          i,
          a = this,
          s = a.instance.current,
          r = a.newWidth,
          c = a.newHeight;
        a.contentLastPos &&
          ((t = a.contentLastPos.left),
          (e = a.contentLastPos.top),
          (i = { top: e, left: t, width: r, height: c, scaleX: 1, scaleY: 1 }),
          n.fancybox.setTranslate(a.$content, i),
          r < a.canvasWidth && c < a.canvasHeight
            ? a.instance.scaleToFit(150)
            : r > s.width || c > s.height
            ? a.instance.scaleToActual(
                a.centerPointStartX,
                a.centerPointStartY,
                150
              )
            : ((o = a.limitPosition(t, e, r, c)),
              n.fancybox.animate(a.$content, o, 150)));
      }),
      (d.prototype.onTap = function (e) {
        var o,
          i = this,
          s = n(e.target),
          r = i.instance,
          c = r.current,
          l = (e && a(e)) || i.startPoints,
          d = l[0] ? l[0].x - n(t).scrollLeft() - i.stagePos.left : 0,
          u = l[0] ? l[0].y - n(t).scrollTop() - i.stagePos.top : 0,
          f = function (t) {
            var o = c.opts[t];
            if ((n.isFunction(o) && (o = o.apply(r, [c, e])), o))
              switch (o) {
                case "close":
                  r.close(i.startEvent);
                  break;
                case "toggleControls":
                  r.toggleControls();
                  break;
                case "next":
                  r.next();
                  break;
                case "nextOrClose":
                  r.group.length > 1 ? r.next() : r.close(i.startEvent);
                  break;
                case "zoom":
                  "image" == c.type &&
                    (c.isLoaded || c.$ghost) &&
                    (r.canPan()
                      ? r.scaleToFit()
                      : r.isScaledDown()
                      ? r.scaleToActual(d, u)
                      : r.group.length < 2 && r.close(i.startEvent));
              }
          };
        if (
          (!e.originalEvent || 2 != e.originalEvent.button) &&
          (s.is("img") || !(d > s[0].clientWidth + s.offset().left))
        ) {
          if (
            s.is(
              ".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"
            )
          )
            o = "Outside";
          else if (s.is(".fancybox-slide")) o = "Slide";
          else {
            if (
              !r.current.$content ||
              !r.current.$content.find(s).addBack().filter(s).length
            )
              return;
            o = "Content";
          }
          if (i.tapped) {
            if (
              (clearTimeout(i.tapped),
              (i.tapped = null),
              Math.abs(d - i.tapX) > 50 || Math.abs(u - i.tapY) > 50)
            )
              return this;
            f("dblclick" + o);
          } else
            (i.tapX = d),
              (i.tapY = u),
              c.opts["dblclick" + o] &&
              c.opts["dblclick" + o] !== c.opts["click" + o]
                ? (i.tapped = setTimeout(function () {
                    (i.tapped = null), r.isAnimating || f("click" + o);
                  }, 500))
                : f("click" + o);
          return this;
        }
      }),
      n(e)
        .on("onActivate.fb", function (t, e) {
          e && !e.Guestures && (e.Guestures = new d(e));
        })
        .on("beforeClose.fb", function (t, e) {
          e && e.Guestures && e.Guestures.destroy();
        });
  })(window, document, jQuery),
  (function (t, e) {
    "use strict";
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        slideShow:
          '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>',
      },
      slideShow: { autoStart: !1, speed: 3e3, progress: !0 },
    });
    var n = function (t) {
      (this.instance = t), this.init();
    };
    e.extend(n.prototype, {
      timer: null,
      isActive: !1,
      $button: null,
      init: function () {
        var t = this,
          n = t.instance,
          o = n.group[n.currIndex].opts.slideShow;
        (t.$button = n.$refs.toolbar
          .find("[data-fancybox-play]")
          .on("click", function () {
            t.toggle();
          })),
          n.group.length < 2 || !o
            ? t.$button.hide()
            : o.progress &&
              (t.$progress = e(
                '<div class="fancybox-progress"></div>'
              ).appendTo(n.$refs.inner));
      },
      set: function (t) {
        var n = this,
          o = n.instance,
          i = o.current;
        i && (!0 === t || i.opts.loop || o.currIndex < o.group.length - 1)
          ? n.isActive &&
            "video" !== i.contentType &&
            (n.$progress &&
              e.fancybox.animate(
                n.$progress.show(),
                { scaleX: 1 },
                i.opts.slideShow.speed
              ),
            (n.timer = setTimeout(function () {
              o.current.opts.loop || o.current.index != o.group.length - 1
                ? o.next()
                : o.jumpTo(0);
            }, i.opts.slideShow.speed)))
          : (n.stop(), (o.idleSecondsCounter = 0), o.showControls());
      },
      clear: function () {
        var t = this;
        clearTimeout(t.timer),
          (t.timer = null),
          t.$progress && t.$progress.removeAttr("style").hide();
      },
      start: function () {
        var t = this,
          e = t.instance.current;
        e &&
          (t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP
            )
            .removeClass("fancybox-button--play")
            .addClass("fancybox-button--pause"),
          (t.isActive = !0),
          e.isComplete && t.set(!0),
          t.instance.trigger("onSlideShowChange", !0));
      },
      stop: function () {
        var t = this,
          e = t.instance.current;
        t.clear(),
          t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START
            )
            .removeClass("fancybox-button--pause")
            .addClass("fancybox-button--play"),
          (t.isActive = !1),
          t.instance.trigger("onSlideShowChange", !1),
          t.$progress && t.$progress.removeAttr("style").hide();
      },
      toggle: function () {
        var t = this;
        t.isActive ? t.stop() : t.start();
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          e && !e.SlideShow && (e.SlideShow = new n(e));
        },
        "beforeShow.fb": function (t, e, n, o) {
          var i = e && e.SlideShow;
          o
            ? i && n.opts.slideShow.autoStart && i.start()
            : i && i.isActive && i.clear();
        },
        "afterShow.fb": function (t, e, n) {
          var o = e && e.SlideShow;
          o && o.isActive && o.set();
        },
        "afterKeydown.fb": function (n, o, i, a, s) {
          var r = o && o.SlideShow;
          !r ||
            !i.opts.slideShow ||
            (80 !== s && 32 !== s) ||
            e(t.activeElement).is("button,a,input") ||
            (a.preventDefault(), r.toggle());
        },
        "beforeClose.fb onDeactivate.fb": function (t, e) {
          var n = e && e.SlideShow;
          n && n.stop();
        },
      }),
      e(t).on("visibilitychange", function () {
        var n = e.fancybox.getInstance(),
          o = n && n.SlideShow;
        o && o.isActive && (t.hidden ? o.clear() : o.set());
      });
  })(document, jQuery),
  (function (t, e) {
    "use strict";
    var n = (function () {
      for (
        var e = [
            [
              "requestFullscreen",
              "exitFullscreen",
              "fullscreenElement",
              "fullscreenEnabled",
              "fullscreenchange",
              "fullscreenerror",
            ],
            [
              "webkitRequestFullscreen",
              "webkitExitFullscreen",
              "webkitFullscreenElement",
              "webkitFullscreenEnabled",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "webkitRequestFullScreen",
              "webkitCancelFullScreen",
              "webkitCurrentFullScreenElement",
              "webkitCancelFullScreen",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "mozRequestFullScreen",
              "mozCancelFullScreen",
              "mozFullScreenElement",
              "mozFullScreenEnabled",
              "mozfullscreenchange",
              "mozfullscreenerror",
            ],
            [
              "msRequestFullscreen",
              "msExitFullscreen",
              "msFullscreenElement",
              "msFullscreenEnabled",
              "MSFullscreenChange",
              "MSFullscreenError",
            ],
          ],
          n = {},
          o = 0;
        o < e.length;
        o++
      ) {
        var i = e[o];
        if (i && i[1] in t) {
          for (var a = 0; a < i.length; a++) n[e[0][a]] = i[a];
          return n;
        }
      }
      return !1;
    })();
    if (n) {
      var o = {
        request: function (e) {
          (e = e || t.documentElement),
            e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
        },
        exit: function () {
          t[n.exitFullscreen]();
        },
        toggle: function (e) {
          (e = e || t.documentElement),
            this.isFullscreen() ? this.exit() : this.request(e);
        },
        isFullscreen: function () {
          return Boolean(t[n.fullscreenElement]);
        },
        enabled: function () {
          return Boolean(t[n.fullscreenEnabled]);
        },
      };
      e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
          fullScreen:
            '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>',
        },
        fullScreen: { autoStart: !1 },
      }),
        e(t).on(n.fullscreenchange, function () {
          var t = o.isFullscreen(),
            n = e.fancybox.getInstance();
          n &&
            (n.current &&
              "image" === n.current.type &&
              n.isAnimating &&
              ((n.isAnimating = !1),
              n.update(!0, !0, 0),
              n.isComplete || n.complete()),
            n.trigger("onFullscreenChange", t),
            n.$refs.container.toggleClass("fancybox-is-fullscreen", t),
            n.$refs.toolbar
              .find("[data-fancybox-fullscreen]")
              .toggleClass("fancybox-button--fsenter", !t)
              .toggleClass("fancybox-button--fsexit", t));
        });
    }
    e(t).on({
      "onInit.fb": function (t, e) {
        var i;
        if (!n)
          return void e.$refs.toolbar
            .find("[data-fancybox-fullscreen]")
            .remove();
        e && e.group[e.currIndex].opts.fullScreen
          ? ((i = e.$refs.container),
            i.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function (
              t
            ) {
              t.stopPropagation(), t.preventDefault(), o.toggle();
            }),
            e.opts.fullScreen &&
              !0 === e.opts.fullScreen.autoStart &&
              o.request(),
            (e.FullScreen = o))
          : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
      },
      "afterKeydown.fb": function (t, e, n, o, i) {
        e &&
          e.FullScreen &&
          70 === i &&
          (o.preventDefault(), e.FullScreen.toggle());
      },
      "beforeClose.fb": function (t, e) {
        e &&
          e.FullScreen &&
          e.$refs.container.hasClass("fancybox-is-fullscreen") &&
          o.exit();
      },
    });
  })(document, jQuery),
  (function (t, e) {
    "use strict";
    var n = "fancybox-thumbs";
    e.fancybox.defaults = e.extend(
      !0,
      {
        btnTpl: {
          thumbs:
            '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>',
        },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
      },
      e.fancybox.defaults
    );
    var o = function (t) {
      this.init(t);
    };
    e.extend(o.prototype, {
      $button: null,
      $grid: null,
      $list: null,
      isVisible: !1,
      isActive: !1,
      init: function (t) {
        var e = this,
          n = t.group,
          o = 0;
        (e.instance = t),
          (e.opts = n[t.currIndex].opts.thumbs),
          (t.Thumbs = e),
          (e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]"));
        for (
          var i = 0, a = n.length;
          i < a && (n[i].thumb && o++, !(o > 1));
          i++
        );
        o > 1 && e.opts
          ? (e.$button.removeAttr("style").on("click", function () {
              e.toggle();
            }),
            (e.isActive = !0))
          : e.$button.hide();
      },
      create: function () {
        var t,
          o = this,
          i = o.instance,
          a = o.opts.parentEl,
          s = [];
        o.$grid ||
          ((o.$grid = e(
            '<div class="' + n + " " + n + "-" + o.opts.axis + '"></div>'
          ).appendTo(i.$refs.container.find(a).addBack().filter(a))),
          o.$grid.on("click", "a", function () {
            i.jumpTo(e(this).attr("data-index"));
          })),
          o.$list ||
            (o.$list = e('<div class="' + n + '__list">').appendTo(o.$grid)),
          e.each(i.group, function (e, n) {
            (t = n.thumb),
              t || "image" !== n.type || (t = n.src),
              s.push(
                '<a href="javascript:;" tabindex="0" data-index="' +
                  e +
                  '"' +
                  (t && t.length
                    ? ' style="background-image:url(' + t + ')"'
                    : 'class="fancybox-thumbs-missing"') +
                  "></a>"
              );
          }),
          (o.$list[0].innerHTML = s.join("")),
          "x" === o.opts.axis &&
            o.$list.width(
              parseInt(o.$grid.css("padding-right"), 10) +
                i.group.length * o.$list.children().eq(0).outerWidth(!0)
            );
      },
      focus: function (t) {
        var e,
          n,
          o = this,
          i = o.$list,
          a = o.$grid;
        o.instance.current &&
          ((e = i
            .children()
            .removeClass("fancybox-thumbs-active")
            .filter('[data-index="' + o.instance.current.index + '"]')
            .addClass("fancybox-thumbs-active")),
          (n = e.position()),
          "y" === o.opts.axis &&
          (n.top < 0 || n.top > i.height() - e.outerHeight())
            ? i.stop().animate({ scrollTop: i.scrollTop() + n.top }, t)
            : "x" === o.opts.axis &&
              (n.left < a.scrollLeft() ||
                n.left > a.scrollLeft() + (a.width() - e.outerWidth())) &&
              i.parent().stop().animate({ scrollLeft: n.left }, t));
      },
      update: function () {
        var t = this;
        t.instance.$refs.container.toggleClass(
          "fancybox-show-thumbs",
          this.isVisible
        ),
          t.isVisible
            ? (t.$grid || t.create(),
              t.instance.trigger("onThumbsShow"),
              t.focus(0))
            : t.$grid && t.instance.trigger("onThumbsHide"),
          t.instance.update();
      },
      hide: function () {
        (this.isVisible = !1), this.update();
      },
      show: function () {
        (this.isVisible = !0), this.update();
      },
      toggle: function () {
        (this.isVisible = !this.isVisible), this.update();
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          var n;
          e &&
            !e.Thumbs &&
            ((n = new o(e)), n.isActive && !0 === n.opts.autoStart && n.show());
        },
        "beforeShow.fb": function (t, e, n, o) {
          var i = e && e.Thumbs;
          i && i.isVisible && i.focus(o ? 0 : 250);
        },
        "afterKeydown.fb": function (t, e, n, o, i) {
          var a = e && e.Thumbs;
          a && a.isActive && 71 === i && (o.preventDefault(), a.toggle());
        },
        "beforeClose.fb": function (t, e) {
          var n = e && e.Thumbs;
          n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
        },
      });
  })(document, jQuery),
  (function (t, e) {
    "use strict";
    function n(t) {
      var e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;",
      };
      return String(t).replace(/[&<>"'`=\/]/g, function (t) {
        return e[t];
      });
    }
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        share:
          '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>',
      },
      share: {
        url: function (t, e) {
          return (
            (!t.currentHash &&
              "inline" !== e.type &&
              "html" !== e.type &&
              (e.origSrc || e.src)) ||
            window.location
          );
        },
        tpl:
          '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>',
      },
    }),
      e(t).on("click", "[data-fancybox-share]", function () {
        var t,
          o,
          i = e.fancybox.getInstance(),
          a = i.current || null;
        a &&
          ("function" === e.type(a.opts.share.url) &&
            (t = a.opts.share.url.apply(a, [i, a])),
          (o = a.opts.share.tpl
            .replace(
              /\{\{media\}\}/g,
              "image" === a.type ? encodeURIComponent(a.src) : ""
            )
            .replace(/\{\{url\}\}/g, encodeURIComponent(t))
            .replace(/\{\{url_raw\}\}/g, n(t))
            .replace(
              /\{\{descr\}\}/g,
              i.$caption ? encodeURIComponent(i.$caption.text()) : ""
            )),
          e.fancybox.open({
            src: i.translate(i, o),
            type: "html",
            opts: {
              touch: !1,
              animationEffect: !1,
              afterLoad: function (t, e) {
                i.$refs.container.one("beforeClose.fb", function () {
                  t.close(null, 0);
                }),
                  e.$content.find(".fancybox-share__button").click(function () {
                    return (
                      window.open(this.href, "Share", "width=550, height=450"),
                      !1
                    );
                  });
              },
              mobile: { autoFocus: !1 },
            },
          }));
      });
  })(document, jQuery),
  (function (t, e, n) {
    "use strict";
    function o() {
      var e = t.location.hash.substr(1),
        n = e.split("-"),
        o =
          n.length > 1 && /^\+?\d+$/.test(n[n.length - 1])
            ? parseInt(n.pop(-1), 10) || 1
            : 1,
        i = n.join("-");
      return { hash: e, index: o < 1 ? 1 : o, gallery: i };
    }
    function i(t) {
      "" !== t.gallery &&
        n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']")
          .eq(t.index - 1)
          .focus()
          .trigger("click.fb-start");
    }
    function a(t) {
      var e, n;
      return (
        !!t &&
        ((e = t.current ? t.current.opts : t.opts),
        "" !==
          (n =
            e.hash ||
            (e.$orig
              ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger")
              : "")) && n)
      );
    }
    n.escapeSelector ||
      (n.escapeSelector = function (t) {
        return (t + "").replace(
          /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
          function (t, e) {
            return e
              ? "\0" === t
                ? "�"
                : t.slice(0, -1) +
                  "\\" +
                  t.charCodeAt(t.length - 1).toString(16) +
                  " "
              : "\\" + t;
          }
        );
      }),
      n(function () {
        !1 !== n.fancybox.defaults.hash &&
          (n(e).on({
            "onInit.fb": function (t, e) {
              var n, i;
              !1 !== e.group[e.currIndex].opts.hash &&
                ((n = o()),
                (i = a(e)) &&
                  n.gallery &&
                  i == n.gallery &&
                  (e.currIndex = n.index - 1));
            },
            "beforeShow.fb": function (n, o, i, s) {
              var r;
              i &&
                !1 !== i.opts.hash &&
                (r = a(o)) &&
                ((o.currentHash =
                  r + (o.group.length > 1 ? "-" + (i.index + 1) : "")),
                t.location.hash !== "#" + o.currentHash &&
                  (s && !o.origHash && (o.origHash = t.location.hash),
                  o.hashTimer && clearTimeout(o.hashTimer),
                  (o.hashTimer = setTimeout(function () {
                    "replaceState" in t.history
                      ? (t.history[s ? "pushState" : "replaceState"](
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            "#" +
                            o.currentHash
                        ),
                        s && (o.hasCreatedHistory = !0))
                      : (t.location.hash = o.currentHash),
                      (o.hashTimer = null);
                  }, 300))));
            },
            "beforeClose.fb": function (n, o, i) {
              i &&
                !1 !== i.opts.hash &&
                (clearTimeout(o.hashTimer),
                o.currentHash && o.hasCreatedHistory
                  ? t.history.back()
                  : o.currentHash &&
                    ("replaceState" in t.history
                      ? t.history.replaceState(
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            (o.origHash || "")
                        )
                      : (t.location.hash = o.origHash)),
                (o.currentHash = null));
            },
          }),
          n(t).on("hashchange.fb", function () {
            var t = o(),
              e = null;
            n.each(n(".fancybox-container").get().reverse(), function (t, o) {
              var i = n(o).data("FancyBox");
              if (i && i.currentHash) return (e = i), !1;
            }),
              e
                ? e.currentHash === t.gallery + "-" + t.index ||
                  (1 === t.index && e.currentHash == t.gallery) ||
                  ((e.currentHash = null), e.close())
                : "" !== t.gallery && i(t);
          }),
          setTimeout(function () {
            n.fancybox.getInstance() || i(o());
          }, 50));
      });
  })(window, document, jQuery),
  (function (t, e) {
    "use strict";
    var n = new Date().getTime();
    e(t).on({
      "onInit.fb": function (t, e, o) {
        e.$refs.stage.on(
          "mousewheel DOMMouseScroll wheel MozMousePixelScroll",
          function (t) {
            var o = e.current,
              i = new Date().getTime();
            e.group.length < 2 ||
              !1 === o.opts.wheel ||
              ("auto" === o.opts.wheel && "image" !== o.type) ||
              (t.preventDefault(),
              t.stopPropagation(),
              o.$slide.hasClass("fancybox-animated") ||
                ((t = t.originalEvent || t),
                i - n < 250 ||
                  ((n = i),
                  e[
                    (-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0
                      ? "next"
                      : "previous"
                  ]())));
          }
        );
      },
    });
  })(document, jQuery);
/* -----------------------------------------------
/* Author : Vincent Garreau  - vincentgarreau.com
/* MIT license: http://opensource.org/licenses/MIT
/* Demo / Generator : vincentgarreau.com/particles.js
/* GitHub : github.com/VincentGarreau/particles.js
/* How to use? : Check the GitHub README
/* v2.0.0
/* ----------------------------------------------- */
function hexToRgb(e) {
  var a = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  e = e.replace(a, function (e, a, t, i) {
    return a + a + t + t + i + i;
  });
  var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t
    ? { r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16) }
    : null;
}
function clamp(e, a, t) {
  return Math.min(Math.max(e, a), t);
}
function isInArray(e, a) {
  return a.indexOf(e) > -1;
}
var pJS = function (e, a) {
  var t = document.querySelector("#" + e + " > .particles-js-canvas-el");
  this.pJS = {
    canvas: { el: t, w: t.offsetWidth, h: t.offsetHeight },
    particles: {
      number: { value: 400, density: { enable: !0, value_area: 800 } },
      color: { value: "#fff" },
      shape: {
        type: "circle",
        stroke: { width: 0, color: "#ff0000" },
        polygon: { nb_sides: 5 },
        image: { src: "", width: 100, height: 100 },
      },
      opacity: {
        value: 1,
        random: !1,
        anim: { enable: !1, speed: 2, opacity_min: 0, sync: !1 },
      },
      size: {
        value: 20,
        random: !1,
        anim: { enable: !1, speed: 20, size_min: 0, sync: !1 },
      },
      line_linked: {
        enable: !0,
        distance: 100,
        color: "#fff",
        opacity: 1,
        width: 1,
      },
      move: {
        enable: !0,
        speed: 2,
        direction: "none",
        random: !1,
        straight: !1,
        out_mode: "out",
        bounce: !1,
        attract: { enable: !1, rotateX: 3e3, rotateY: 3e3 },
      },
      array: [],
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: { enable: !0, mode: "grab" },
        onclick: { enable: !0, mode: "push" },
        resize: !0,
      },
      modes: {
        grab: { distance: 100, line_linked: { opacity: 1 } },
        bubble: { distance: 200, size: 80, duration: 0.4 },
        repulse: { distance: 200, duration: 0.4 },
        push: { particles_nb: 4 },
        remove: { particles_nb: 2 },
      },
      mouse: {},
    },
    retina_detect: !1,
    fn: { interact: {}, modes: {}, vendors: {} },
    tmp: {},
  };
  var i = this.pJS;
  a && Object.deepExtend(i, a),
    (i.tmp.obj = {
      size_value: i.particles.size.value,
      size_anim_speed: i.particles.size.anim.speed,
      move_speed: i.particles.move.speed,
      line_linked_distance: i.particles.line_linked.distance,
      line_linked_width: i.particles.line_linked.width,
      mode_grab_distance: i.interactivity.modes.grab.distance,
      mode_bubble_distance: i.interactivity.modes.bubble.distance,
      mode_bubble_size: i.interactivity.modes.bubble.size,
      mode_repulse_distance: i.interactivity.modes.repulse.distance,
    }),
    (i.fn.retinaInit = function () {
      i.retina_detect && window.devicePixelRatio > 1
        ? ((i.canvas.pxratio = window.devicePixelRatio), (i.tmp.retina = !0))
        : ((i.canvas.pxratio = 1), (i.tmp.retina = !1)),
        (i.canvas.w = i.canvas.el.offsetWidth * i.canvas.pxratio),
        (i.canvas.h = i.canvas.el.offsetHeight * i.canvas.pxratio),
        (i.particles.size.value = i.tmp.obj.size_value * i.canvas.pxratio),
        (i.particles.size.anim.speed =
          i.tmp.obj.size_anim_speed * i.canvas.pxratio),
        (i.particles.move.speed = i.tmp.obj.move_speed * i.canvas.pxratio),
        (i.particles.line_linked.distance =
          i.tmp.obj.line_linked_distance * i.canvas.pxratio),
        (i.interactivity.modes.grab.distance =
          i.tmp.obj.mode_grab_distance * i.canvas.pxratio),
        (i.interactivity.modes.bubble.distance =
          i.tmp.obj.mode_bubble_distance * i.canvas.pxratio),
        (i.particles.line_linked.width =
          i.tmp.obj.line_linked_width * i.canvas.pxratio),
        (i.interactivity.modes.bubble.size =
          i.tmp.obj.mode_bubble_size * i.canvas.pxratio),
        (i.interactivity.modes.repulse.distance =
          i.tmp.obj.mode_repulse_distance * i.canvas.pxratio);
    }),
    (i.fn.canvasInit = function () {
      i.canvas.ctx = i.canvas.el.getContext("2d");
    }),
    (i.fn.canvasSize = function () {
      (i.canvas.el.width = i.canvas.w),
        (i.canvas.el.height = i.canvas.h),
        i &&
          i.interactivity.events.resize &&
          window.addEventListener("resize", function () {
            (i.canvas.w = i.canvas.el.offsetWidth),
              (i.canvas.h = i.canvas.el.offsetHeight),
              i.tmp.retina &&
                ((i.canvas.w *= i.canvas.pxratio),
                (i.canvas.h *= i.canvas.pxratio)),
              (i.canvas.el.width = i.canvas.w),
              (i.canvas.el.height = i.canvas.h),
              i.particles.move.enable ||
                (i.fn.particlesEmpty(),
                i.fn.particlesCreate(),
                i.fn.particlesDraw(),
                i.fn.vendors.densityAutoParticles()),
              i.fn.vendors.densityAutoParticles();
          });
    }),
    (i.fn.canvasPaint = function () {
      i.canvas.ctx.fillRect(0, 0, i.canvas.w, i.canvas.h);
    }),
    (i.fn.canvasClear = function () {
      i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h);
    }),
    (i.fn.particle = function (e, a, t) {
      if (
        ((this.radius =
          (i.particles.size.random ? Math.random() : 1) *
          i.particles.size.value),
        i.particles.size.anim.enable &&
          ((this.size_status = !1),
          (this.vs = i.particles.size.anim.speed / 100),
          i.particles.size.anim.sync || (this.vs = this.vs * Math.random())),
        (this.x = t ? t.x : Math.random() * i.canvas.w),
        (this.y = t ? t.y : Math.random() * i.canvas.h),
        this.x > i.canvas.w - 2 * this.radius
          ? (this.x = this.x - this.radius)
          : this.x < 2 * this.radius && (this.x = this.x + this.radius),
        this.y > i.canvas.h - 2 * this.radius
          ? (this.y = this.y - this.radius)
          : this.y < 2 * this.radius && (this.y = this.y + this.radius),
        i.particles.move.bounce && i.fn.vendors.checkOverlap(this, t),
        (this.color = {}),
        "object" == typeof e.value)
      )
        if (e.value instanceof Array) {
          var s =
            e.value[Math.floor(Math.random() * i.particles.color.value.length)];
          this.color.rgb = hexToRgb(s);
        } else
          void 0 != e.value.r &&
            void 0 != e.value.g &&
            void 0 != e.value.b &&
            (this.color.rgb = { r: e.value.r, g: e.value.g, b: e.value.b }),
            void 0 != e.value.h &&
              void 0 != e.value.s &&
              void 0 != e.value.l &&
              (this.color.hsl = { h: e.value.h, s: e.value.s, l: e.value.l });
      else
        "random" == e.value
          ? (this.color.rgb = {
              r: Math.floor(256 * Math.random()) + 0,
              g: Math.floor(256 * Math.random()) + 0,
              b: Math.floor(256 * Math.random()) + 0,
            })
          : "string" == typeof e.value &&
            ((this.color = e), (this.color.rgb = hexToRgb(this.color.value)));
      (this.opacity =
        (i.particles.opacity.random ? Math.random() : 1) *
        i.particles.opacity.value),
        i.particles.opacity.anim.enable &&
          ((this.opacity_status = !1),
          (this.vo = i.particles.opacity.anim.speed / 100),
          i.particles.opacity.anim.sync || (this.vo = this.vo * Math.random()));
      var n = {};
      switch (i.particles.move.direction) {
        case "top":
          n = { x: 0, y: -1 };
          break;
        case "top-right":
          n = { x: 0.5, y: -0.5 };
          break;
        case "right":
          n = { x: 1, y: -0 };
          break;
        case "bottom-right":
          n = { x: 0.5, y: 0.5 };
          break;
        case "bottom":
          n = { x: 0, y: 1 };
          break;
        case "bottom-left":
          n = { x: -0.5, y: 1 };
          break;
        case "left":
          n = { x: -1, y: 0 };
          break;
        case "top-left":
          n = { x: -0.5, y: -0.5 };
          break;
        default:
          n = { x: 0, y: 0 };
      }
      i.particles.move.straight
        ? ((this.vx = n.x),
          (this.vy = n.y),
          i.particles.move.random &&
            ((this.vx = this.vx * Math.random()),
            (this.vy = this.vy * Math.random())))
        : ((this.vx = n.x + Math.random() - 0.5),
          (this.vy = n.y + Math.random() - 0.5)),
        (this.vx_i = this.vx),
        (this.vy_i = this.vy);
      var r = i.particles.shape.type;
      if ("object" == typeof r) {
        if (r instanceof Array) {
          var c = r[Math.floor(Math.random() * r.length)];
          this.shape = c;
        }
      } else this.shape = r;
      if ("image" == this.shape) {
        var o = i.particles.shape;
        (this.img = {
          src: o.image.src,
          ratio: o.image.width / o.image.height,
        }),
          this.img.ratio || (this.img.ratio = 1),
          "svg" == i.tmp.img_type &&
            void 0 != i.tmp.source_svg &&
            (i.fn.vendors.createSvgImg(this),
            i.tmp.pushing && (this.img.loaded = !1));
      }
    }),
    (i.fn.particle.prototype.draw = function () {
      function e() {
        i.canvas.ctx.drawImage(
          r,
          a.x - t,
          a.y - t,
          2 * t,
          (2 * t) / a.img.ratio
        );
      }
      var a = this;
      if (void 0 != a.radius_bubble) var t = a.radius_bubble;
      else var t = a.radius;
      if (void 0 != a.opacity_bubble) var s = a.opacity_bubble;
      else var s = a.opacity;
      if (a.color.rgb)
        var n =
          "rgba(" +
          a.color.rgb.r +
          "," +
          a.color.rgb.g +
          "," +
          a.color.rgb.b +
          "," +
          s +
          ")";
      else
        var n =
          "hsla(" +
          a.color.hsl.h +
          "," +
          a.color.hsl.s +
          "%," +
          a.color.hsl.l +
          "%," +
          s +
          ")";
      switch (
        ((i.canvas.ctx.fillStyle = n), i.canvas.ctx.beginPath(), a.shape)
      ) {
        case "circle":
          i.canvas.ctx.arc(a.x, a.y, t, 0, 2 * Math.PI, !1);
          break;
        case "edge":
          i.canvas.ctx.rect(a.x - t, a.y - t, 2 * t, 2 * t);
          break;
        case "triangle":
          i.fn.vendors.drawShape(
            i.canvas.ctx,
            a.x - t,
            a.y + t / 1.66,
            2 * t,
            3,
            2
          );
          break;
        case "polygon":
          i.fn.vendors.drawShape(
            i.canvas.ctx,
            a.x - t / (i.particles.shape.polygon.nb_sides / 3.5),
            a.y - t / 0.76,
            (2.66 * t) / (i.particles.shape.polygon.nb_sides / 3),
            i.particles.shape.polygon.nb_sides,
            1
          );
          break;
        case "star":
          i.fn.vendors.drawShape(
            i.canvas.ctx,
            a.x - (2 * t) / (i.particles.shape.polygon.nb_sides / 4),
            a.y - t / 1.52,
            (2 * t * 2.66) / (i.particles.shape.polygon.nb_sides / 3),
            i.particles.shape.polygon.nb_sides,
            2
          );
          break;
        case "image":
          if ("svg" == i.tmp.img_type) var r = a.img.obj;
          else var r = i.tmp.img_obj;
          r && e();
      }
      i.canvas.ctx.closePath(),
        i.particles.shape.stroke.width > 0 &&
          ((i.canvas.ctx.strokeStyle = i.particles.shape.stroke.color),
          (i.canvas.ctx.lineWidth = i.particles.shape.stroke.width),
          i.canvas.ctx.stroke()),
        i.canvas.ctx.fill();
    }),
    (i.fn.particlesCreate = function () {
      for (var e = 0; e < i.particles.number.value; e++)
        i.particles.array.push(
          new i.fn.particle(i.particles.color, i.particles.opacity.value)
        );
    }),
    (i.fn.particlesUpdate = function () {
      for (var e = 0; e < i.particles.array.length; e++) {
        var a = i.particles.array[e];
        if (i.particles.move.enable) {
          var t = i.particles.move.speed / 2;
          (a.x += a.vx * t), (a.y += a.vy * t);
        }
        if (
          (i.particles.opacity.anim.enable &&
            (1 == a.opacity_status
              ? (a.opacity >= i.particles.opacity.value &&
                  (a.opacity_status = !1),
                (a.opacity += a.vo))
              : (a.opacity <= i.particles.opacity.anim.opacity_min &&
                  (a.opacity_status = !0),
                (a.opacity -= a.vo)),
            a.opacity < 0 && (a.opacity = 0)),
          i.particles.size.anim.enable &&
            (1 == a.size_status
              ? (a.radius >= i.particles.size.value && (a.size_status = !1),
                (a.radius += a.vs))
              : (a.radius <= i.particles.size.anim.size_min &&
                  (a.size_status = !0),
                (a.radius -= a.vs)),
            a.radius < 0 && (a.radius = 0)),
          "bounce" == i.particles.move.out_mode)
        )
          var s = {
            x_left: a.radius,
            x_right: i.canvas.w,
            y_top: a.radius,
            y_bottom: i.canvas.h,
          };
        else
          var s = {
            x_left: -a.radius,
            x_right: i.canvas.w + a.radius,
            y_top: -a.radius,
            y_bottom: i.canvas.h + a.radius,
          };
        switch (
          (a.x - a.radius > i.canvas.w
            ? ((a.x = s.x_left), (a.y = Math.random() * i.canvas.h))
            : a.x + a.radius < 0 &&
              ((a.x = s.x_right), (a.y = Math.random() * i.canvas.h)),
          a.y - a.radius > i.canvas.h
            ? ((a.y = s.y_top), (a.x = Math.random() * i.canvas.w))
            : a.y + a.radius < 0 &&
              ((a.y = s.y_bottom), (a.x = Math.random() * i.canvas.w)),
          i.particles.move.out_mode)
        ) {
          case "bounce":
            a.x + a.radius > i.canvas.w
              ? (a.vx = -a.vx)
              : a.x - a.radius < 0 && (a.vx = -a.vx),
              a.y + a.radius > i.canvas.h
                ? (a.vy = -a.vy)
                : a.y - a.radius < 0 && (a.vy = -a.vy);
        }
        if (
          (isInArray("grab", i.interactivity.events.onhover.mode) &&
            i.fn.modes.grabParticle(a),
          (isInArray("bubble", i.interactivity.events.onhover.mode) ||
            isInArray("bubble", i.interactivity.events.onclick.mode)) &&
            i.fn.modes.bubbleParticle(a),
          (isInArray("repulse", i.interactivity.events.onhover.mode) ||
            isInArray("repulse", i.interactivity.events.onclick.mode)) &&
            i.fn.modes.repulseParticle(a),
          i.particles.line_linked.enable || i.particles.move.attract.enable)
        )
          for (var n = e + 1; n < i.particles.array.length; n++) {
            var r = i.particles.array[n];
            i.particles.line_linked.enable && i.fn.interact.linkParticles(a, r),
              i.particles.move.attract.enable &&
                i.fn.interact.attractParticles(a, r),
              i.particles.move.bounce && i.fn.interact.bounceParticles(a, r);
          }
      }
    }),
    (i.fn.particlesDraw = function () {
      i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h),
        i.fn.particlesUpdate();
      for (var e = 0; e < i.particles.array.length; e++) {
        var a = i.particles.array[e];
        a.draw();
      }
    }),
    (i.fn.particlesEmpty = function () {
      i.particles.array = [];
    }),
    (i.fn.particlesRefresh = function () {
      cancelRequestAnimFrame(i.fn.checkAnimFrame),
        cancelRequestAnimFrame(i.fn.drawAnimFrame),
        (i.tmp.source_svg = void 0),
        (i.tmp.img_obj = void 0),
        (i.tmp.count_svg = 0),
        i.fn.particlesEmpty(),
        i.fn.canvasClear(),
        i.fn.vendors.start();
    }),
    (i.fn.interact.linkParticles = function (e, a) {
      var t = e.x - a.x,
        s = e.y - a.y,
        n = Math.sqrt(t * t + s * s);
      if (n <= i.particles.line_linked.distance) {
        var r =
          i.particles.line_linked.opacity -
          n /
            (1 / i.particles.line_linked.opacity) /
            i.particles.line_linked.distance;
        if (r > 0) {
          var c = i.particles.line_linked.color_rgb_line;
          (i.canvas.ctx.strokeStyle =
            "rgba(" + c.r + "," + c.g + "," + c.b + "," + r + ")"),
            (i.canvas.ctx.lineWidth = i.particles.line_linked.width),
            i.canvas.ctx.beginPath(),
            i.canvas.ctx.moveTo(e.x, e.y),
            i.canvas.ctx.lineTo(a.x, a.y),
            i.canvas.ctx.stroke(),
            i.canvas.ctx.closePath();
        }
      }
    }),
    (i.fn.interact.attractParticles = function (e, a) {
      var t = e.x - a.x,
        s = e.y - a.y,
        n = Math.sqrt(t * t + s * s);
      if (n <= i.particles.line_linked.distance) {
        var r = t / (1e3 * i.particles.move.attract.rotateX),
          c = s / (1e3 * i.particles.move.attract.rotateY);
        (e.vx -= r), (e.vy -= c), (a.vx += r), (a.vy += c);
      }
    }),
    (i.fn.interact.bounceParticles = function (e, a) {
      var t = e.x - a.x,
        i = e.y - a.y,
        s = Math.sqrt(t * t + i * i),
        n = e.radius + a.radius;
      n >= s &&
        ((e.vx = -e.vx), (e.vy = -e.vy), (a.vx = -a.vx), (a.vy = -a.vy));
    }),
    (i.fn.modes.pushParticles = function (e, a) {
      i.tmp.pushing = !0;
      for (var t = 0; e > t; t++)
        i.particles.array.push(
          new i.fn.particle(i.particles.color, i.particles.opacity.value, {
            x: a ? a.pos_x : Math.random() * i.canvas.w,
            y: a ? a.pos_y : Math.random() * i.canvas.h,
          })
        ),
          t == e - 1 &&
            (i.particles.move.enable || i.fn.particlesDraw(),
            (i.tmp.pushing = !1));
    }),
    (i.fn.modes.removeParticles = function (e) {
      i.particles.array.splice(0, e),
        i.particles.move.enable || i.fn.particlesDraw();
    }),
    (i.fn.modes.bubbleParticle = function (e) {
      function a() {
        (e.opacity_bubble = e.opacity), (e.radius_bubble = e.radius);
      }
      function t(a, t, s, n, c) {
        if (a != t)
          if (i.tmp.bubble_duration_end) {
            if (void 0 != s) {
              var o = n - (p * (n - a)) / i.interactivity.modes.bubble.duration,
                l = a - o;
              (d = a + l),
                "size" == c && (e.radius_bubble = d),
                "opacity" == c && (e.opacity_bubble = d);
            }
          } else if (r <= i.interactivity.modes.bubble.distance) {
            if (void 0 != s) var v = s;
            else var v = n;
            if (v != a) {
              var d = n - (p * (n - a)) / i.interactivity.modes.bubble.duration;
              "size" == c && (e.radius_bubble = d),
                "opacity" == c && (e.opacity_bubble = d);
            }
          } else
            "size" == c && (e.radius_bubble = void 0),
              "opacity" == c && (e.opacity_bubble = void 0);
      }
      if (
        i.interactivity.events.onhover.enable &&
        isInArray("bubble", i.interactivity.events.onhover.mode)
      ) {
        var s = e.x - i.interactivity.mouse.pos_x,
          n = e.y - i.interactivity.mouse.pos_y,
          r = Math.sqrt(s * s + n * n),
          c = 1 - r / i.interactivity.modes.bubble.distance;
        if (r <= i.interactivity.modes.bubble.distance) {
          if (c >= 0 && "mousemove" == i.interactivity.status) {
            if (i.interactivity.modes.bubble.size != i.particles.size.value)
              if (i.interactivity.modes.bubble.size > i.particles.size.value) {
                var o = e.radius + i.interactivity.modes.bubble.size * c;
                o >= 0 && (e.radius_bubble = o);
              } else {
                var l = e.radius - i.interactivity.modes.bubble.size,
                  o = e.radius - l * c;
                o > 0 ? (e.radius_bubble = o) : (e.radius_bubble = 0);
              }
            if (
              i.interactivity.modes.bubble.opacity != i.particles.opacity.value
            )
              if (
                i.interactivity.modes.bubble.opacity > i.particles.opacity.value
              ) {
                var v = i.interactivity.modes.bubble.opacity * c;
                v > e.opacity &&
                  v <= i.interactivity.modes.bubble.opacity &&
                  (e.opacity_bubble = v);
              } else {
                var v =
                  e.opacity -
                  (i.particles.opacity.value -
                    i.interactivity.modes.bubble.opacity) *
                    c;
                v < e.opacity &&
                  v >= i.interactivity.modes.bubble.opacity &&
                  (e.opacity_bubble = v);
              }
          }
        } else a();
        "mouseleave" == i.interactivity.status && a();
      } else if (
        i.interactivity.events.onclick.enable &&
        isInArray("bubble", i.interactivity.events.onclick.mode)
      ) {
        if (i.tmp.bubble_clicking) {
          var s = e.x - i.interactivity.mouse.click_pos_x,
            n = e.y - i.interactivity.mouse.click_pos_y,
            r = Math.sqrt(s * s + n * n),
            p = (new Date().getTime() - i.interactivity.mouse.click_time) / 1e3;
          p > i.interactivity.modes.bubble.duration &&
            (i.tmp.bubble_duration_end = !0),
            p > 2 * i.interactivity.modes.bubble.duration &&
              ((i.tmp.bubble_clicking = !1), (i.tmp.bubble_duration_end = !1));
        }
        i.tmp.bubble_clicking &&
          (t(
            i.interactivity.modes.bubble.size,
            i.particles.size.value,
            e.radius_bubble,
            e.radius,
            "size"
          ),
          t(
            i.interactivity.modes.bubble.opacity,
            i.particles.opacity.value,
            e.opacity_bubble,
            e.opacity,
            "opacity"
          ));
      }
    }),
    (i.fn.modes.repulseParticle = function (e) {
      function a() {
        var a = Math.atan2(d, p);
        if (
          ((e.vx = u * Math.cos(a)),
          (e.vy = u * Math.sin(a)),
          "bounce" == i.particles.move.out_mode)
        ) {
          var t = { x: e.x + e.vx, y: e.y + e.vy };
          t.x + e.radius > i.canvas.w
            ? (e.vx = -e.vx)
            : t.x - e.radius < 0 && (e.vx = -e.vx),
            t.y + e.radius > i.canvas.h
              ? (e.vy = -e.vy)
              : t.y - e.radius < 0 && (e.vy = -e.vy);
        }
      }
      if (
        i.interactivity.events.onhover.enable &&
        isInArray("repulse", i.interactivity.events.onhover.mode) &&
        "mousemove" == i.interactivity.status
      ) {
        var t = e.x - i.interactivity.mouse.pos_x,
          s = e.y - i.interactivity.mouse.pos_y,
          n = Math.sqrt(t * t + s * s),
          r = { x: t / n, y: s / n },
          c = i.interactivity.modes.repulse.distance,
          o = 100,
          l = clamp((1 / c) * (-1 * Math.pow(n / c, 2) + 1) * c * o, 0, 50),
          v = { x: e.x + r.x * l, y: e.y + r.y * l };
        "bounce" == i.particles.move.out_mode
          ? (v.x - e.radius > 0 && v.x + e.radius < i.canvas.w && (e.x = v.x),
            v.y - e.radius > 0 && v.y + e.radius < i.canvas.h && (e.y = v.y))
          : ((e.x = v.x), (e.y = v.y));
      } else if (
        i.interactivity.events.onclick.enable &&
        isInArray("repulse", i.interactivity.events.onclick.mode)
      )
        if (
          (i.tmp.repulse_finish ||
            (i.tmp.repulse_count++,
            i.tmp.repulse_count == i.particles.array.length &&
              (i.tmp.repulse_finish = !0)),
          i.tmp.repulse_clicking)
        ) {
          var c = Math.pow(i.interactivity.modes.repulse.distance / 6, 3),
            p = i.interactivity.mouse.click_pos_x - e.x,
            d = i.interactivity.mouse.click_pos_y - e.y,
            m = p * p + d * d,
            u = (-c / m) * 1;
          c >= m && a();
        } else
          0 == i.tmp.repulse_clicking && ((e.vx = e.vx_i), (e.vy = e.vy_i));
    }),
    (i.fn.modes.grabParticle = function (e) {
      if (
        i.interactivity.events.onhover.enable &&
        "mousemove" == i.interactivity.status
      ) {
        var a = e.x - i.interactivity.mouse.pos_x,
          t = e.y - i.interactivity.mouse.pos_y,
          s = Math.sqrt(a * a + t * t);
        if (s <= i.interactivity.modes.grab.distance) {
          var n =
            i.interactivity.modes.grab.line_linked.opacity -
            s /
              (1 / i.interactivity.modes.grab.line_linked.opacity) /
              i.interactivity.modes.grab.distance;
          if (n > 0) {
            var r = i.particles.line_linked.color_rgb_line;
            (i.canvas.ctx.strokeStyle =
              "rgba(" + r.r + "," + r.g + "," + r.b + "," + n + ")"),
              (i.canvas.ctx.lineWidth = i.particles.line_linked.width),
              i.canvas.ctx.beginPath(),
              i.canvas.ctx.moveTo(e.x, e.y),
              i.canvas.ctx.lineTo(
                i.interactivity.mouse.pos_x,
                i.interactivity.mouse.pos_y
              ),
              i.canvas.ctx.stroke(),
              i.canvas.ctx.closePath();
          }
        }
      }
    }),
    (i.fn.vendors.eventsListeners = function () {
      "window" == i.interactivity.detect_on
        ? (i.interactivity.el = window)
        : (i.interactivity.el = i.canvas.el),
        (i.interactivity.events.onhover.enable ||
          i.interactivity.events.onclick.enable) &&
          (i.interactivity.el.addEventListener("mousemove", function (e) {
            if (i.interactivity.el == window)
              var a = e.clientX,
                t = e.clientY;
            else
              var a = e.offsetX || e.clientX,
                t = e.offsetY || e.clientY;
            (i.interactivity.mouse.pos_x = a),
              (i.interactivity.mouse.pos_y = t),
              i.tmp.retina &&
                ((i.interactivity.mouse.pos_x *= i.canvas.pxratio),
                (i.interactivity.mouse.pos_y *= i.canvas.pxratio)),
              (i.interactivity.status = "mousemove");
          }),
          i.interactivity.el.addEventListener("mouseleave", function (e) {
            (i.interactivity.mouse.pos_x = null),
              (i.interactivity.mouse.pos_y = null),
              (i.interactivity.status = "mouseleave");
          })),
        i.interactivity.events.onclick.enable &&
          i.interactivity.el.addEventListener("click", function () {
            if (
              ((i.interactivity.mouse.click_pos_x =
                i.interactivity.mouse.pos_x),
              (i.interactivity.mouse.click_pos_y = i.interactivity.mouse.pos_y),
              (i.interactivity.mouse.click_time = new Date().getTime()),
              i.interactivity.events.onclick.enable)
            )
              switch (i.interactivity.events.onclick.mode) {
                case "push":
                  i.particles.move.enable
                    ? i.fn.modes.pushParticles(
                        i.interactivity.modes.push.particles_nb,
                        i.interactivity.mouse
                      )
                    : 1 == i.interactivity.modes.push.particles_nb
                    ? i.fn.modes.pushParticles(
                        i.interactivity.modes.push.particles_nb,
                        i.interactivity.mouse
                      )
                    : i.interactivity.modes.push.particles_nb > 1 &&
                      i.fn.modes.pushParticles(
                        i.interactivity.modes.push.particles_nb
                      );
                  break;
                case "remove":
                  i.fn.modes.removeParticles(
                    i.interactivity.modes.remove.particles_nb
                  );
                  break;
                case "bubble":
                  i.tmp.bubble_clicking = !0;
                  break;
                case "repulse":
                  (i.tmp.repulse_clicking = !0),
                    (i.tmp.repulse_count = 0),
                    (i.tmp.repulse_finish = !1),
                    setTimeout(function () {
                      i.tmp.repulse_clicking = !1;
                    }, 1e3 * i.interactivity.modes.repulse.duration);
              }
          });
    }),
    (i.fn.vendors.densityAutoParticles = function () {
      if (i.particles.number.density.enable) {
        var e = (i.canvas.el.width * i.canvas.el.height) / 1e3;
        i.tmp.retina && (e /= 2 * i.canvas.pxratio);
        var a =
            (e * i.particles.number.value) /
            i.particles.number.density.value_area,
          t = i.particles.array.length - a;
        0 > t
          ? i.fn.modes.pushParticles(Math.abs(t))
          : i.fn.modes.removeParticles(t);
      }
    }),
    (i.fn.vendors.checkOverlap = function (e, a) {
      for (var t = 0; t < i.particles.array.length; t++) {
        var s = i.particles.array[t],
          n = e.x - s.x,
          r = e.y - s.y,
          c = Math.sqrt(n * n + r * r);
        c <= e.radius + s.radius &&
          ((e.x = a ? a.x : Math.random() * i.canvas.w),
          (e.y = a ? a.y : Math.random() * i.canvas.h),
          i.fn.vendors.checkOverlap(e));
      }
    }),
    (i.fn.vendors.createSvgImg = function (e) {
      var a = i.tmp.source_svg,
        t = /#([0-9A-F]{3,6})/gi,
        s = a.replace(t, function (a, t, i, s) {
          if (e.color.rgb)
            var n =
              "rgba(" +
              e.color.rgb.r +
              "," +
              e.color.rgb.g +
              "," +
              e.color.rgb.b +
              "," +
              e.opacity +
              ")";
          else
            var n =
              "hsla(" +
              e.color.hsl.h +
              "," +
              e.color.hsl.s +
              "%," +
              e.color.hsl.l +
              "%," +
              e.opacity +
              ")";
          return n;
        }),
        n = new Blob([s], { type: "image/svg+xml;charset=utf-8" }),
        r = window.URL || window.webkitURL || window,
        c = r.createObjectURL(n),
        o = new Image();
      o.addEventListener("load", function () {
        (e.img.obj = o),
          (e.img.loaded = !0),
          r.revokeObjectURL(c),
          i.tmp.count_svg++;
      }),
        (o.src = c);
    }),
    (i.fn.vendors.destroypJS = function () {
      cancelAnimationFrame(i.fn.drawAnimFrame), t.remove(), (pJSDom = null);
    }),
    (i.fn.vendors.drawShape = function (e, a, t, i, s, n) {
      var r = s * n,
        c = s / n,
        o = (180 * (c - 2)) / c,
        l = Math.PI - (Math.PI * o) / 180;
      e.save(), e.beginPath(), e.translate(a, t), e.moveTo(0, 0);
      for (var v = 0; r > v; v++)
        e.lineTo(i, 0), e.translate(i, 0), e.rotate(l);
      e.fill(), e.restore();
    }),
    (i.fn.vendors.exportImg = function () {
      window.open(i.canvas.el.toDataURL("image/png"), "_blank");
    }),
    (i.fn.vendors.loadImg = function (e) {
      if (((i.tmp.img_error = void 0), "" != i.particles.shape.image.src))
        if ("svg" == e) {
          var a = new XMLHttpRequest();
          a.open("GET", i.particles.shape.image.src),
            (a.onreadystatechange = function (e) {
              4 == a.readyState &&
                (200 == a.status
                  ? ((i.tmp.source_svg = e.currentTarget.response),
                    i.fn.vendors.checkBeforeDraw())
                  : (console.log("Error pJS - Image not found"),
                    (i.tmp.img_error = !0)));
            }),
            a.send();
        } else {
          var t = new Image();
          t.addEventListener("load", function () {
            (i.tmp.img_obj = t), i.fn.vendors.checkBeforeDraw();
          }),
            (t.src = i.particles.shape.image.src);
        }
      else console.log("Error pJS - No image.src"), (i.tmp.img_error = !0);
    }),
    (i.fn.vendors.draw = function () {
      "image" == i.particles.shape.type
        ? "svg" == i.tmp.img_type
          ? i.tmp.count_svg >= i.particles.number.value
            ? (i.fn.particlesDraw(),
              i.particles.move.enable
                ? (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw))
                : cancelRequestAnimFrame(i.fn.drawAnimFrame))
            : i.tmp.img_error ||
              (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw))
          : void 0 != i.tmp.img_obj
          ? (i.fn.particlesDraw(),
            i.particles.move.enable
              ? (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw))
              : cancelRequestAnimFrame(i.fn.drawAnimFrame))
          : i.tmp.img_error ||
            (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw))
        : (i.fn.particlesDraw(),
          i.particles.move.enable
            ? (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw))
            : cancelRequestAnimFrame(i.fn.drawAnimFrame));
    }),
    (i.fn.vendors.checkBeforeDraw = function () {
      "image" == i.particles.shape.type
        ? "svg" == i.tmp.img_type && void 0 == i.tmp.source_svg
          ? (i.tmp.checkAnimFrame = requestAnimFrame(check))
          : (cancelRequestAnimFrame(i.tmp.checkAnimFrame),
            i.tmp.img_error || (i.fn.vendors.init(), i.fn.vendors.draw()))
        : (i.fn.vendors.init(), i.fn.vendors.draw());
    }),
    (i.fn.vendors.init = function () {
      i.fn.retinaInit(),
        i.fn.canvasInit(),
        i.fn.canvasSize(),
        i.fn.canvasPaint(),
        i.fn.particlesCreate(),
        i.fn.vendors.densityAutoParticles(),
        (i.particles.line_linked.color_rgb_line = hexToRgb(
          i.particles.line_linked.color
        ));
    }),
    (i.fn.vendors.start = function () {
      isInArray("image", i.particles.shape.type)
        ? ((i.tmp.img_type = i.particles.shape.image.src.substr(
            i.particles.shape.image.src.length - 3
          )),
          i.fn.vendors.loadImg(i.tmp.img_type))
        : i.fn.vendors.checkBeforeDraw();
    }),
    i.fn.vendors.eventsListeners(),
    i.fn.vendors.start();
};
(Object.deepExtend = function (e, a) {
  for (var t in a)
    a[t] && a[t].constructor && a[t].constructor === Object
      ? ((e[t] = e[t] || {}), arguments.callee(e[t], a[t]))
      : (e[t] = a[t]);
  return e;
}),
  (window.requestAnimFrame = (function () {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (e) {
        window.setTimeout(e, 1e3 / 60);
      }
    );
  })()),
  (window.cancelRequestAnimFrame = (function () {
    return (
      window.cancelAnimationFrame ||
      window.webkitCancelRequestAnimationFrame ||
      window.mozCancelRequestAnimationFrame ||
      window.oCancelRequestAnimationFrame ||
      window.msCancelRequestAnimationFrame ||
      clearTimeout
    );
  })()),
  (window.pJSDom = []),
  (window.particlesJS = function (e, a) {
    "string" != typeof e && ((a = e), (e = "particles-js")),
      e || (e = "particles-js");
    var t = document.getElementById(e),
      i = "particles-js-canvas-el",
      s = t.getElementsByClassName(i);
    if (s.length) for (; s.length > 0; ) t.removeChild(s[0]);
    var n = document.createElement("canvas");
    (n.className = i), (n.style.width = "100%"), (n.style.height = "100%");
    var r = document.getElementById(e).appendChild(n);
    null != r && pJSDom.push(new pJS(e, a));
  }),
  (window.particlesJS.load = function (e, a, t) {
    var i = new XMLHttpRequest();
    i.open("GET", a),
      (i.onreadystatechange = function (a) {
        if (4 == i.readyState)
          if (200 == i.status) {
            var s = JSON.parse(a.currentTarget.response);
            window.particlesJS(e, s), t && t();
          } else
            console.log("Error pJS - XMLHttpRequest status: " + i.status),
              console.log("Error pJS - File config not found");
      }),
      i.send();
  });

/*
Tipue drop 5.0.2
Copyright (c) 2015 Tipue
Tipue drop is released under the MIT License
http://www.tipue.com/drop
*/

(function ($) {
  $.fn.tipuedrop = function (options) {
    var set = $.extend(
      {
        show: 5,
        speed: 300,
        newWindow: false,
        mode: "static",
        contentLocation: "assets/js/data/tipuedrop_content.json",
        //'contentLocation'        : 'tipuedrop/tipuedrop_content.json'
      },
      options
    );

    return this.each(function () {
      var tipuedrop_in = {
        pages: [],
      };
      $.ajaxSetup({
        async: false,
      });

      if (set.mode == "json") {
        $.getJSON(set.contentLocation).done(function (json) {
          tipuedrop_in = $.extend({}, json);
        });
      }

      if (set.mode == "static") {
        tipuedrop_in = $.extend({}, tipuedrop);
      }

      $(this).keyup(function (event) {
        getTipuedrop($(this));
      });

      function getTipuedrop($obj) {
        if ($obj.val()) {
          var c = 0;
          for (var i = 0; i < tipuedrop_in.pages.length; i++) {
            var pat = new RegExp($obj.val(), "i");
            if (
              (tipuedrop_in.pages[i].title.search(pat) != -1 ||
                tipuedrop_in.pages[i].text.search(pat) != -1) &&
              c < set.show
            ) {
              if (c == 0) {
                var out =
                  '<div class="tipue_drop_box"><div id="tipue_drop_wrapper">';
              }
              out += '<a href="' + tipuedrop_in.pages[i].url + '"';
              if (set.newWindow) {
                out += ' target="_blank"';
              }
              out +=
                '><div class="tipue_drop_item"><div class="tipue_drop_left"><img src="' +
                tipuedrop_in.pages[i].thumb +
                '" class="tipue_drop_image"></div><div class="tipue_drop_right">' +
                tipuedrop_in.pages[i].title +
                "<div>" +
                tipuedrop_in.pages[i].text +
                "</div></div></div></a>";
              c++;
            }
          }
          if (c != 0) {
            out += "</div></div>";
            $("#tipue_drop_content").html(out);
            $("#tipue_drop_content").fadeIn(set.speed);
          }
        } else {
          $("#tipue_drop_content").fadeOut(set.speed);
        }
      }

      $("html").click(function () {
        $("#tipue_drop_content").fadeOut(set.speed);
      });
    });
  };
})(jQuery);

(function ($) {
  $.fn.tipuedrop = function (options) {
    var set = $.extend(
      {
        show: 3,
        speed: 300,
        newWindow: false,
        mode: "static",
        contentLocation: "tipuedrop/tipuedrop_content.json",
      },
      options
    );
    return this.each(function () {
      var tipuedrop_in = { pages: [] };
      $.ajaxSetup({ async: false });
      if (set.mode == "json") {
        $.getJSON(set.contentLocation).done(function (json) {
          tipuedrop_in = $.extend({}, json);
        });
      }
      if (set.mode == "static") {
        tipuedrop_in = $.extend({}, tipuedrop);
      }
      $(this).keyup(function (event) {
        getTipuedrop($(this));
      });
      function getTipuedrop($obj) {
        if ($obj.val()) {
          var c = 0;
          for (var i = 0; i < tipuedrop_in.pages.length; i++) {
            var pat = new RegExp($obj.val(), "i");
            if (
              (tipuedrop_in.pages[i].title.search(pat) != -1 ||
                tipuedrop_in.pages[i].text.search(pat) != -1) &&
              c < set.show
            ) {
              if (c == 0) {
                var out =
                  '<div class="tipue_drop_box"><div id="tipue_drop_wrapper">';
              }
              out += '<a href="' + tipuedrop_in.pages[i].url + '"';
              if (set.newWindow) {
                out += ' target="_blank"';
              }
              out +=
                '><div class="tipue_drop_item"><div class="tipue_drop_left"><img src="' +
                tipuedrop_in.pages[i].thumb +
                '" class="tipue_drop_image"></div><div class="tipue_drop_right">' +
                tipuedrop_in.pages[i].title +
                "</div></div></a>";
              c++;
            }
          }
          if (c != 0) {
            out += "</div></div>";
            $("#tipue_drop_content").html(out);
            $("#tipue_drop_content").fadeIn(set.speed);
          }
        } else {
          $("#tipue_drop_content").fadeOut(set.speed);
        }
      }
      $("html").click(function () {
        $("#tipue_drop_content").fadeOut(set.speed);
      });
    });
  };
})(jQuery);
/*!
 * Tokenize2 v1.3.1 (https://github.com/dragonofmercy/Tokenize2)
 * Copyright 2016-2017 DragonOfMercy.
 * Licensed under the new BSD license
 */
(function (a) {
  if (typeof define === "function" && define.amd) {
    define(["jquery"], a);
  } else {
    if (typeof module === "object" && module.exports) {
      module.exports = function (b, c) {
        if (c === undefined) {
          if (typeof window !== "undefined") {
            c = require("jquery");
          } else {
            c = require("jquery")(b);
          }
        }
        a(c);
        return c;
      };
    } else {
      a(jQuery);
    }
  }
})(function (e) {
  var c = function (g, f) {
    this.control = false;
    this.element = e(g);
    this.options = e.extend({}, c.DEFAULTS, f);
    this.options.tabIndex =
      this.options.tabIndex === -1 ? 0 : this.options.tabIndex;
    this.options.sortable =
      this.options.tokensMaxItems === 1 ? false : this.options.sortable;
    this.bind();
    this.trigger("tokenize:load");
  };
  var a = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    ARROW_UP: 38,
    ARROW_DOWN: 40,
    CTRL: 17,
    MAJ: 16,
  };
  c.VERSION = "1.3";
  c.DEBOUNCE = null;
  c.DEFAULTS = {
    tokensMaxItems: 0,
    tokensAllowCustom: false,
    dropdownMaxItems: 10,
    searchMinLength: 0,
    searchMaxLength: 0,
    searchFromStart: true,
    searchHighlight: true,
    displayNoResultsMessage: false,
    noResultsMessageText: 'No results mached "%s"',
    delimiter: ",",
    dataSource: "select",
    debounce: 0,
    placeholder: false,
    sortable: false,
    allowEmptyValues: false,
    zIndexMargin: 500,
    tabIndex: 0,
  };
  c.prototype.trigger = function (h, i, g, f) {
    this.element.trigger(h, i, g, f);
  };
  c.prototype.bind = function () {
    this.element
      .on(
        "tokenize:load",
        {},
        e.proxy(function () {
          this.init();
        }, this)
      )
      .on(
        "tokenize:clear",
        {},
        e.proxy(function () {
          this.clear();
        }, this)
      )
      .on(
        "tokenize:remap",
        {},
        e.proxy(function () {
          this.remap();
        }, this)
      )
      .on(
        "tokenize:select",
        {},
        e.proxy(function (f, g) {
          this.focus(g);
        }, this)
      )
      .on(
        "tokenize:deselect",
        {},
        e.proxy(function () {
          this.blur();
        }, this)
      )
      .on(
        "tokenize:search",
        {},
        e.proxy(function (g, f) {
          this.find(f);
        }, this)
      )
      .on(
        "tokenize:paste",
        {},
        e.proxy(function () {
          this.paste();
        }, this)
      )
      .on(
        "tokenize:dropdown:up",
        {},
        e.proxy(function () {
          this.dropdownSelectionMove(-1);
        }, this)
      )
      .on(
        "tokenize:dropdown:down",
        {},
        e.proxy(function () {
          this.dropdownSelectionMove(1);
        }, this)
      )
      .on(
        "tokenize:dropdown:clear",
        {},
        e.proxy(function () {
          this.dropdownClear();
        }, this)
      )
      .on(
        "tokenize:dropdown:show",
        {},
        e.proxy(function () {
          this.dropdownShow();
        }, this)
      )
      .on(
        "tokenize:dropdown:hide",
        {},
        e.proxy(function () {
          this.dropdownHide();
        }, this)
      )
      .on(
        "tokenize:dropdown:fill",
        {},
        e.proxy(function (g, f) {
          this.dropdownFill(f);
        }, this)
      )
      .on(
        "tokenize:dropdown:itemAdd",
        {},
        e.proxy(function (g, f) {
          this.dropdownAddItem(f);
        }, this)
      )
      .on(
        "tokenize:keypress",
        {},
        e.proxy(function (g, f) {
          this.keypress(f);
        }, this)
      )
      .on(
        "tokenize:keydown",
        {},
        e.proxy(function (g, f) {
          this.keydown(f);
        }, this)
      )
      .on(
        "tokenize:keyup",
        {},
        e.proxy(function (g, f) {
          this.keyup(f);
        }, this)
      )
      .on(
        "tokenize:tokens:reorder",
        {},
        e.proxy(function () {
          this.reorder();
        }, this)
      )
      .on(
        "tokenize:tokens:add",
        {},
        e.proxy(function (h, f, g, i) {
          this.tokenAdd(f, g, i);
        }, this)
      )
      .on(
        "tokenize:tokens:remove",
        {},
        e.proxy(function (g, f) {
          this.tokenRemove(f);
        }, this)
      );
  };
  c.prototype.init = function () {
    this.id = this.guid();
    this.element.hide();
    if (!this.element.attr("multiple")) {
      console.error("Attribute multiple is missing, tokenize2 can be buggy !");
    }
    this.dropdown = undefined;
    this.searchContainer = e('<li class="token-search" />');
    this.input = e('<input autocomplete="off" />')
      .on(
        "keydown",
        {},
        e.proxy(function (f) {
          this.trigger("tokenize:keydown", [f]);
        }, this)
      )
      .on(
        "keypress",
        {},
        e.proxy(function (f) {
          this.trigger("tokenize:keypress", [f]);
        }, this)
      )
      .on(
        "keyup",
        {},
        e.proxy(function (f) {
          this.trigger("tokenize:keyup", [f]);
        }, this)
      )
      .on(
        "focus",
        {},
        e.proxy(function () {
          if (
            this.input.val().length >= this.options.searchMinLength &&
            this.input.val().length > 0
          ) {
            this.trigger("tokenize:search", [this.input.val()]);
          }
        }, this)
      )
      .on(
        "paste",
        {},
        e.proxy(function () {
          if (this.options.tokensAllowCustom) {
            setTimeout(
              e.proxy(function () {
                this.trigger("tokenize:paste");
              }, this),
              10
            );
          }
        }, this)
      );
    if (this.options.searchMaxLength > 0) {
      this.input.attr("maxlength", this.options.searchMaxLength);
    }
    this.tokensContainer = e('<ul class="tokens-container form-control" />')
      .addClass(this.element.attr("data-class"))
      .attr("tabindex", this.options.tabIndex)
      .append(this.searchContainer.append(this.input));
    if (this.options.placeholder !== false) {
      this.placeholder = e('<li class="placeholder" />').html(
        this.options.placeholder
      );
      this.tokensContainer.prepend(this.placeholder);
      this.element.on(
        "tokenize:tokens:add tokenize:remap tokenize:select tokenize:deselect tokenize:tokens:remove",
        e.proxy(function () {
          if (
            this.container.hasClass("focus") ||
            e("li.token", this.tokensContainer).length > 0 ||
            this.input.val().length > 0
          ) {
            this.placeholder.hide();
          } else {
            this.placeholder.show();
          }
        }, this)
      );
    }
    this.container = e('<div class="tokenize" />').attr("id", this.id);
    this.container.append(this.tokensContainer).insertAfter(this.element);
    this.container
      .focusin(
        e.proxy(function (f) {
          this.trigger("tokenize:select", [
            e(f.target)[0] === this.tokensContainer[0],
          ]);
        }, this)
      )
      .focusout(
        e.proxy(function () {
          if (this.container.hasClass("focus")) {
            this.trigger("tokenize:deselect");
          }
        }, this)
      );
    if (this.options.tokensMaxItems === 1) {
      this.container.addClass("single");
    }
    if (this.options.sortable) {
      this.container.addClass("sortable");
      this.tokensContainer.tokenize2sortable({
        itemSelector: "li.token",
        cursor: "move",
        placeholder: '<li class="token shadow"><br /></li>',
        placeholderClass: "token shadow",
        onDragStart: e.proxy(function (g, f, h) {
          this.searchContainer.hide();
          h(g, f);
        }, this),
        onDrop: e.proxy(function (g, f, h) {
          this.searchContainer.show();
          this.trigger("tokenize:tokens:reorder");
          h(g, f);
        }, this),
      });
    }
    this.element
      .on(
        "tokenize:tokens:add tokenize:tokens:remove",
        e.proxy(function () {
          if (
            this.options.tokensMaxItems > 0 &&
            e("li.token", this.tokensContainer).length >=
              this.options.tokensMaxItems
          ) {
            this.searchContainer.hide();
          } else {
            this.searchContainer.show();
          }
        }, this)
      )
      .on(
        "tokenize:keydown tokenize:keyup tokenize:loaded",
        e.proxy(function () {
          this.scaleInput();
        }, this)
      );
    this.trigger("tokenize:remap");
    this.trigger("tokenize:tokens:reorder");
    this.trigger("tokenize:loaded");
    if (this.element.is(":disabled")) {
      this.disable();
    }
  };
  c.prototype.reorder = function () {
    if (this.options.sortable) {
      var f,
        h,
        g = this.tokensContainer.tokenize2sortable("serialize").get(0);
      e.each(
        g,
        e.proxy(function (j, i) {
          h = e('option[value="' + i.value + '"]', this.element);
          if (f === undefined) {
            h.prependTo(this.element);
          } else {
            f.after(h);
          }
          f = h;
        }, this)
      );
    }
  };
  c.prototype.paste = function () {
    var f = new RegExp(
      this.escapeRegex(
        Array.isArray(this.options.delimiter)
          ? this.options.delimiter.join("|")
          : this.options.delimiter
      ),
      "ig"
    );
    if (f.test(this.input.val())) {
      e.each(
        this.input.val().split(f),
        e.proxy(function (g, h) {
          this.trigger("tokenize:tokens:add", [h, null, true]);
        }, this)
      );
    }
  };
  c.prototype.tokenAdd = function (g, h, f) {
    g = this.escape(g);
    h = h || g;
    f = f || false;
    this.resetInput();
    if (g === undefined || (!this.options.allowEmptyValues && g === "")) {
      this.trigger("tokenize:tokens:error:empty");
      return this;
    }
    if (
      this.options.tokensMaxItems > 0 &&
      e("li.token", this.tokensContainer).length >= this.options.tokensMaxItems
    ) {
      this.trigger("tokenize:tokens:error:max");
      return this;
    }
    if (
      e('li.token[data-value="' + g + '"]', this.tokensContainer).length > 0
    ) {
      this.trigger("tokenize:tokens:error:duplicate", [g, h]);
      return this;
    }
    if (e('option[value="' + g + '"]', this.element).length) {
      e('option[value="' + g + '"]', this.element)
        .attr("selected", "selected")
        .prop("selected", true);
    } else {
      if (f) {
        this.element.append(e("<option selected />").val(g).html(h));
      } else {
        if (this.options.tokensAllowCustom) {
          this.element.append(
            e('<option selected data-type="custom" />').val(g).html(h)
          );
        } else {
          this.trigger("tokenize:tokens:error:notokensAllowCustom");
          return this;
        }
      }
    }
    e('<li class="token" />')
      .attr("data-value", g)
      .append("<span>" + h + "</span>")
      .prepend(
        e('<a class="dismiss" />').on(
          "mousedown touchstart",
          {},
          e.proxy(function (i) {
            i.preventDefault();
            if (i.which == 1) {
              this.trigger("tokenize:tokens:remove", [g]);
            }
          }, this)
        )
      )
      .insertBefore(this.searchContainer);
    this.trigger("tokenize:dropdown:hide");
    this.trigger("tokenize:tokens:added", [g, h]);
    return this;
  };
  c.prototype.tokenRemove = function (g) {
    var f = e('option[value="' + g + '"]', this.element);
    if (f.attr("data-type") === "custom") {
      f.remove();
    } else {
      f.removeAttr("selected").prop("selected", false);
    }
    e('li.token[data-value="' + g + '"]', this.tokensContainer).remove();
    this.trigger("tokenize:tokens:reorder");
    return this;
  };
  c.prototype.remap = function () {
    var f = e("option:selected", this.element);
    f.each(
      e.proxy(function (g, h) {
        this.trigger("tokenize:tokens:add", [e(h).val(), e(h).html(), false]);
      }, this)
    );
    return this;
  };
  c.prototype.disable = function () {
    this.tokensContainer.addClass("disabled");
    this.searchContainer.hide();
    return this;
  };
  c.prototype.enable = function () {
    this.tokensContainer.removeClass("disabled");
    this.searchContainer.show();
    return this;
  };
  c.prototype.focus = function (f) {
    if (this.element.is(":disabled")) {
      this.tokensContainer.blur();
      return;
    }
    if (f) {
      this.input.focus();
    }
    if (!this.container.hasClass("focus")) {
      this.container.addClass("focus");
      this.trigger("tokenize:focus");
    }
  };
  c.prototype.blur = function () {
    if (this.isDropdownOpen()) {
      this.trigger("tokenize:dropdown:hide");
    }
    this.container.removeClass("focus");
    this.resetPending();
    if (!this.tokensContainer.attr("tabindex")) {
      this.tokensContainer.attr("tabindex", this.options.tabIndex);
    }
  };
  c.prototype.keydown = function (g) {
    if (g.type === "keydown") {
      switch (g.keyCode) {
        case a.BACKSPACE:
          if (this.input.val().length < 1) {
            g.preventDefault();
            if (e("li.token.pending-delete", this.tokensContainer).length > 0) {
              this.trigger("tokenize:tokens:remove", [
                e("li.token.pending-delete", this.tokensContainer)
                  .first()
                  .attr("data-value"),
              ]);
            } else {
              var f = e("li.token:last", this.tokensContainer);
              if (f.length > 0) {
                this.trigger("tokenize:tokens:markForDelete", [
                  f.attr("data-value"),
                ]);
                f.addClass("pending-delete");
              }
            }
            this.trigger("tokenize:dropdown:hide");
          }
          break;
        case a.TAB:
          if (!g.shiftKey) {
            this.pressedDelimiter(g);
          } else {
            this.tokensContainer.removeAttr("tabindex");
          }
          break;
        case a.ENTER:
          this.pressedDelimiter(g);
          break;
        case a.ESCAPE:
          this.resetPending();
          break;
        case a.ARROW_UP:
          g.preventDefault();
          this.trigger("tokenize:dropdown:up");
          break;
        case a.ARROW_DOWN:
          g.preventDefault();
          this.trigger("tokenize:dropdown:down");
          break;
        case a.CTRL:
          this.control = true;
          break;
        default:
          this.resetPending();
          break;
      }
    } else {
      g.preventDefault();
    }
  };
  c.prototype.keyup = function (f) {
    if (f.type === "keyup") {
      switch (f.keyCode) {
        case a.TAB:
        case a.ENTER:
        case a.ESCAPE:
        case a.ARROW_UP:
        case a.ARROW_DOWN:
        case a.MAJ:
          break;
        case a.CTRL:
          this.control = false;
          break;
        case a.BACKSPACE:
        default:
          if (
            this.input.val().length >= this.options.searchMinLength &&
            this.input.val().length > 0
          ) {
            this.trigger("tokenize:search", [this.input.val()]);
          } else {
            this.trigger("tokenize:dropdown:hide");
          }
          break;
      }
    } else {
      f.preventDefault();
    }
  };
  c.prototype.keypress = function (f) {
    if (f.type === "keypress" && !this.element.is(":disabled")) {
      var g = false;
      if (Array.isArray(this.options.delimiter)) {
        if (this.options.delimiter.indexOf(String.fromCharCode(f.which)) >= 0) {
          g = true;
        }
      } else {
        if (String.fromCharCode(f.which) === this.options.delimiter) {
          g = true;
        }
      }
      if (g) {
        this.pressedDelimiter(f);
      }
    } else {
      f.preventDefault();
    }
  };
  c.prototype.pressedDelimiter = function (f) {
    this.resetPending();
    if (
      this.isDropdownOpen() &&
      e("li.active", this.dropdown).length > 0 &&
      this.control === false
    ) {
      f.preventDefault();
      e("li.active a", this.dropdown).trigger("mousedown");
    } else {
      if (this.input.val().length > 0) {
        f.preventDefault();
        this.trigger("tokenize:tokens:add", [this.input.val()]);
      }
    }
  };
  c.prototype.find = function (f) {
    if (f.length < this.options.searchMinLength) {
      this.trigger("tokenize:dropdown:hide");
      return false;
    }
    this.lastSearchTerms = f;
    if (this.options.dataSource === "select") {
      this.dataSourceLocal(f);
    } else {
      if (typeof this.options.dataSource === "function") {
        this.options.dataSource(f, this);
      } else {
        this.dataSourceRemote(f);
      }
    }
  };
  c.prototype.dataSourceRemote = function (f) {
    this.debounce(
      e.proxy(function () {
        if (this.xhr !== undefined) {
          this.xhr.abort();
        }
        this.xhr = e.ajax(this.options.dataSource, {
          data: { search: f },
          dataType: "json",
          success: e.proxy(function (g) {
            var h = [];
            e.each(g, function (j, i) {
              h.push(i);
            });
            this.trigger("tokenize:dropdown:fill", [h]);
          }, this),
        });
      }, this),
      this.options.debounce
    );
  };
  c.prototype.dataSourceLocal = function (h) {
    var f = this.transliteration(h);
    var k = [];
    var g = (this.options.searchFromStart ? "^" : "") + this.escapeRegex(f);
    var j = new RegExp(g, "i");
    var i = this;
    e("option", this.element)
      .not(":selected, :disabled")
      .each(function () {
        if (j.test(i.transliteration(e(this).html()))) {
          k.push({ value: e(this).attr("value"), text: e(this).html() });
        }
      });
    this.trigger("tokenize:dropdown:fill", [k]);
  };
  c.prototype.debounce = function (h, g) {
    var i = arguments;
    var f = e.proxy(function () {
      h.apply(this, i);
      this.debounceTimeout = undefined;
    }, this);
    if (this.debounceTimeout !== undefined) {
      clearTimeout(this.debounceTimeout);
    }
    this.debounceTimeout = setTimeout(f, g || 0);
  };
  c.prototype.dropdownShow = function () {
    if (!this.isDropdownOpen()) {
      e(".tokenize-dropdown").remove();
      this.dropdown = e(
        '<div class="tokenize-dropdown dropdown"><ul class="dropdown-menu" /></div>'
      ).attr("data-related", this.id);
      e("body").append(this.dropdown);
      this.dropdown.show();
      this.dropdown.css(
        "z-index",
        this.calculatezindex() + this.options.zIndexMargin
      );
      e(window)
        .on(
          "resize scroll",
          {},
          e.proxy(function () {
            this.dropdownMove();
          }, this)
        )
        .trigger("resize");
      this.trigger("tokenize:dropdown:shown");
    }
  };
  c.prototype.calculatezindex = function () {
    var g = this.container;
    var f = 0;
    if (!isNaN(parseInt(g.css("z-index"))) && parseInt(g.css("z-index")) > 0) {
      f = parseInt(g.css("z-index"));
    }
    if (f < 1) {
      while (g.length) {
        g = g.parent();
        if (g.length > 0) {
          if (
            !isNaN(parseInt(g.css("z-index"))) &&
            parseInt(g.css("z-index")) > 0
          ) {
            return parseInt(g.css("z-index"));
          }
          if (g.is("html")) {
            break;
          }
        }
      }
    }
    return f;
  };
  c.prototype.dropdownHide = function () {
    if (this.isDropdownOpen()) {
      e(window).off("resize scroll");
      this.dropdown.remove();
      this.dropdown = undefined;
      this.trigger("tokenize:dropdown:hidden");
    }
  };
  c.prototype.dropdownClear = function () {
    if (this.dropdown) {
      this.dropdown.find(".dropdown-menu li").remove();
    }
  };
  c.prototype.dropdownFill = function (f) {
    if (f && f.length > 0) {
      this.trigger("tokenize:dropdown:show");
      this.trigger("tokenize:dropdown:clear");
      e.each(
        f,
        e.proxy(function (h, g) {
          if (
            e("li.dropdown-item", this.dropdown).length <=
            this.options.dropdownMaxItems
          ) {
            this.trigger("tokenize:dropdown:itemAdd", [g]);
          }
        }, this)
      );
      if (e("li.active", this.dropdown).length < 1) {
        e("li:first", this.dropdown).addClass("active");
      }
      if (e("li.dropdown-item", this.dropdown).length < 1) {
        this.trigger("tokenize:dropdown:hide");
      } else {
        this.trigger("tokenize:dropdown:filled");
      }
    } else {
      if (this.options.displayNoResultsMessage) {
        this.trigger("tokenize:dropdown:show");
        this.trigger("tokenize:dropdown:clear");
        this.dropdown
          .find(".dropdown-menu")
          .append(
            e('<li class="dropdown-item locked" />').html(
              this.options.noResultsMessageText.replace("%s", this.input.val())
            )
          );
      } else {
        this.trigger("tokenize:dropdown:hide");
      }
    }
    e(window).trigger("resize");
  };
  c.prototype.dropdownSelectionMove = function (g) {
    if (e("li.active", this.dropdown).length > 0) {
      if (
        !e("li.active", this.dropdown).is(
          "li:" + (g > 0 ? "last-child" : "first-child")
        )
      ) {
        var f = e("li.active", this.dropdown);
        f.removeClass("active");
        if (g > 0) {
          f.next().addClass("active");
        } else {
          f.prev().addClass("active");
        }
      } else {
        e("li.active", this.dropdown).removeClass("active");
        e(
          "li:" + (g > 0 ? "first-child" : "last-child"),
          this.dropdown
        ).addClass("active");
      }
    } else {
      e("li:first", this.dropdown).addClass("active");
    }
  };
  c.prototype.dropdownAddItem = function (f) {
    if (this.isDropdownOpen()) {
      var g = e('<li class="dropdown-item" />')
        .html(this.dropdownItemFormat(f))
        .on(
          "mouseover",
          e.proxy(function (h) {
            h.preventDefault();
            h.target = this.fixTarget(h.target);
            e("li", this.dropdown).removeClass("active");
            e(h.target).parent().addClass("active");
          }, this)
        )
        .on(
          "mouseout",
          e.proxy(function () {
            e("li", this.dropdown).removeClass("active");
          }, this)
        )
        .on(
          "mousedown touchstart",
          e.proxy(function (h) {
            h.preventDefault();
            h.target = this.fixTarget(h.target);
            this.trigger("tokenize:tokens:add", [
              e(h.target).attr("data-value"),
              e(h.target).attr("data-text"),
              true,
            ]);
          }, this)
        );
      if (
        e(
          'li.token[data-value="' + g.find("a").attr("data-value") + '"]',
          this.tokensContainer
        ).length < 1
      ) {
        this.dropdown.find(".dropdown-menu").append(g);
        this.trigger("tokenize:dropdown:itemAdded", [f]);
      }
    }
  };
  c.prototype.fixTarget = function (i) {
    var f = e(i);
    if (!f.data("value")) {
      var g = f.find("a");
      if (g.length) {
        return g.get(0);
      }
      var h = f.parents("[data-value]");
      if (h.length) {
        return h.get(0);
      }
    }
    return f.get(0);
  };
  c.prototype.dropdownItemFormat = function (h) {
    if (h.hasOwnProperty("text")) {
      var g = "";
      if (this.options.searchHighlight) {
        var f = new RegExp(
          (this.options.searchFromStart ? "^" : "") +
            "(" +
            this.escapeRegex(this.transliteration(this.lastSearchTerms)) +
            ")",
          "gi"
        );
        g = h.text.replace(f, '<span class="tokenize-highlight">$1</span>');
      } else {
        g = h.text;
      }
      return e("<a />")
        .html(g)
        .attr({ "data-value": h.value, "data-text": h.text });
    }
  };
  c.prototype.dropdownMove = function () {
    var h = this.tokensContainer.offset();
    var g = this.tokensContainer.outerHeight();
    var f = this.tokensContainer.outerWidth();
    h.top += g;
    this.dropdown.css({ width: f }).offset(h);
  };
  c.prototype.isDropdownOpen = function () {
    return this.dropdown !== undefined;
  };
  c.prototype.clear = function () {
    e.each(
      e("li.token", this.tokensContainer),
      e.proxy(function (g, f) {
        this.trigger("tokenize:tokens:remove", [e(f).attr("data-value")]);
      }, this)
    );
    this.trigger("tokenize:dropdown:hide");
    return this;
  };
  c.prototype.resetPending = function () {
    var f = e("li.pending-delete:last", this.tokensContainer);
    if (f.length > 0) {
      this.trigger("tokenize:tokens:cancelDelete", [f.attr("data-value")]);
      f.removeClass("pending-delete");
    }
  };
  c.prototype.scaleInput = function () {
    if (!this.ctx) {
      this.ctx = document.createElement("canvas").getContext("2d");
    }
    var f, g;
    this.ctx.font =
      this.input.css("font-style") +
      " " +
      this.input.css("font-variant") +
      " " +
      this.input.css("font-weight") +
      " " +
      Math.ceil(parseFloat(this.input.css("font-size"))) +
      "px " +
      this.input.css("font-family");
    f =
      Math.round(this.ctx.measureText(this.input.val() + "M").width) +
      Math.ceil(parseFloat(this.searchContainer.css("margin-left"))) +
      Math.ceil(parseFloat(this.searchContainer.css("margin-right")));
    g =
      this.tokensContainer.width() -
      (Math.ceil(parseFloat(this.tokensContainer.css("border-left-width"))) +
        Math.ceil(
          parseFloat(this.tokensContainer.css("border-right-width")) +
            Math.ceil(parseFloat(this.tokensContainer.css("padding-left"))) +
            Math.ceil(parseFloat(this.tokensContainer.css("padding-right")))
        ));
    if (f >= g) {
      f = g;
    }
    this.searchContainer.width(f);
    this.ctx.restore();
  };
  c.prototype.resetInput = function () {
    this.input.val("");
    this.scaleInput();
  };
  c.prototype.escape = function (f) {
    var g = document.createElement("div");
    g.innerHTML = f;
    f = g.textContent || g.innerText || "";
    return String(f).replace(/["]/g, function () {
      return '"';
    });
  };
  c.prototype.escapeRegex = function (f) {
    return f.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
  };
  c.prototype.guid = function () {
    function f() {
      return Math.floor((1 + Math.random()) * 65536)
        .toString(16)
        .substring(1);
    }
    return (
      f() + f() + "-" + f() + "-" + f() + "-" + f() + "-" + f() + f() + f()
    );
  };
  c.prototype.toArray = function () {
    var f = [];
    e("option:selected", this.element).each(function () {
      f.push(e(this).val());
    });
    return f;
  };
  c.prototype.transliteration = function (h) {
    var g = {
      "\u24B6": "A",
      "\uFF21": "A",
      "\u00C0": "A",
      "\u00C1": "A",
      "\u00C2": "A",
      "\u1EA6": "A",
      "\u1EA4": "A",
      "\u1EAA": "A",
      "\u1EA8": "A",
      "\u00C3": "A",
      "\u0100": "A",
      "\u0102": "A",
      "\u1EB0": "A",
      "\u1EAE": "A",
      "\u1EB4": "A",
      "\u1EB2": "A",
      "\u0226": "A",
      "\u01E0": "A",
      "\u00C4": "A",
      "\u01DE": "A",
      "\u1EA2": "A",
      "\u00C5": "A",
      "\u01FA": "A",
      "\u01CD": "A",
      "\u0200": "A",
      "\u0202": "A",
      "\u1EA0": "A",
      "\u1EAC": "A",
      "\u1EB6": "A",
      "\u1E00": "A",
      "\u0104": "A",
      "\u023A": "A",
      "\u2C6F": "A",
      "\uA732": "AA",
      "\u00C6": "AE",
      "\u01FC": "AE",
      "\u01E2": "AE",
      "\uA734": "AO",
      "\uA736": "AU",
      "\uA738": "AV",
      "\uA73A": "AV",
      "\uA73C": "AY",
      "\u24B7": "B",
      "\uFF22": "B",
      "\u1E02": "B",
      "\u1E04": "B",
      "\u1E06": "B",
      "\u0243": "B",
      "\u0182": "B",
      "\u0181": "B",
      "\u24B8": "C",
      "\uFF23": "C",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u00C7": "C",
      "\u1E08": "C",
      "\u0187": "C",
      "\u023B": "C",
      "\uA73E": "C",
      "\u24B9": "D",
      "\uFF24": "D",
      "\u1E0A": "D",
      "\u010E": "D",
      "\u1E0C": "D",
      "\u1E10": "D",
      "\u1E12": "D",
      "\u1E0E": "D",
      "\u0110": "D",
      "\u018B": "D",
      "\u018A": "D",
      "\u0189": "D",
      "\uA779": "D",
      "\u01F1": "DZ",
      "\u01C4": "DZ",
      "\u01F2": "Dz",
      "\u01C5": "Dz",
      "\u24BA": "E",
      "\uFF25": "E",
      "\u00C8": "E",
      "\u00C9": "E",
      "\u00CA": "E",
      "\u1EC0": "E",
      "\u1EBE": "E",
      "\u1EC4": "E",
      "\u1EC2": "E",
      "\u1EBC": "E",
      "\u0112": "E",
      "\u1E14": "E",
      "\u1E16": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u00CB": "E",
      "\u1EBA": "E",
      "\u011A": "E",
      "\u0204": "E",
      "\u0206": "E",
      "\u1EB8": "E",
      "\u1EC6": "E",
      "\u0228": "E",
      "\u1E1C": "E",
      "\u0118": "E",
      "\u1E18": "E",
      "\u1E1A": "E",
      "\u0190": "E",
      "\u018E": "E",
      "\u24BB": "F",
      "\uFF26": "F",
      "\u1E1E": "F",
      "\u0191": "F",
      "\uA77B": "F",
      "\u24BC": "G",
      "\uFF27": "G",
      "\u01F4": "G",
      "\u011C": "G",
      "\u1E20": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u01E6": "G",
      "\u0122": "G",
      "\u01E4": "G",
      "\u0193": "G",
      "\uA7A0": "G",
      "\uA77D": "G",
      "\uA77E": "G",
      "\u24BD": "H",
      "\uFF28": "H",
      "\u0124": "H",
      "\u1E22": "H",
      "\u1E26": "H",
      "\u021E": "H",
      "\u1E24": "H",
      "\u1E28": "H",
      "\u1E2A": "H",
      "\u0126": "H",
      "\u2C67": "H",
      "\u2C75": "H",
      "\uA78D": "H",
      "\u24BE": "I",
      "\uFF29": "I",
      "\u00CC": "I",
      "\u00CD": "I",
      "\u00CE": "I",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u0130": "I",
      "\u00CF": "I",
      "\u1E2E": "I",
      "\u1EC8": "I",
      "\u01CF": "I",
      "\u0208": "I",
      "\u020A": "I",
      "\u1ECA": "I",
      "\u012E": "I",
      "\u1E2C": "I",
      "\u0197": "I",
      "\u24BF": "J",
      "\uFF2A": "J",
      "\u0134": "J",
      "\u0248": "J",
      "\u24C0": "K",
      "\uFF2B": "K",
      "\u1E30": "K",
      "\u01E8": "K",
      "\u1E32": "K",
      "\u0136": "K",
      "\u1E34": "K",
      "\u0198": "K",
      "\u2C69": "K",
      "\uA740": "K",
      "\uA742": "K",
      "\uA744": "K",
      "\uA7A2": "K",
      "\u24C1": "L",
      "\uFF2C": "L",
      "\u013F": "L",
      "\u0139": "L",
      "\u013D": "L",
      "\u1E36": "L",
      "\u1E38": "L",
      "\u013B": "L",
      "\u1E3C": "L",
      "\u1E3A": "L",
      "\u0141": "L",
      "\u023D": "L",
      "\u2C62": "L",
      "\u2C60": "L",
      "\uA748": "L",
      "\uA746": "L",
      "\uA780": "L",
      "\u01C7": "LJ",
      "\u01C8": "Lj",
      "\u24C2": "M",
      "\uFF2D": "M",
      "\u1E3E": "M",
      "\u1E40": "M",
      "\u1E42": "M",
      "\u2C6E": "M",
      "\u019C": "M",
      "\u24C3": "N",
      "\uFF2E": "N",
      "\u01F8": "N",
      "\u0143": "N",
      "\u00D1": "N",
      "\u1E44": "N",
      "\u0147": "N",
      "\u1E46": "N",
      "\u0145": "N",
      "\u1E4A": "N",
      "\u1E48": "N",
      "\u0220": "N",
      "\u019D": "N",
      "\uA790": "N",
      "\uA7A4": "N",
      "\u01CA": "NJ",
      "\u01CB": "Nj",
      "\u24C4": "O",
      "\uFF2F": "O",
      "\u00D2": "O",
      "\u00D3": "O",
      "\u00D4": "O",
      "\u1ED2": "O",
      "\u1ED0": "O",
      "\u1ED6": "O",
      "\u1ED4": "O",
      "\u00D5": "O",
      "\u1E4C": "O",
      "\u022C": "O",
      "\u1E4E": "O",
      "\u014C": "O",
      "\u1E50": "O",
      "\u1E52": "O",
      "\u014E": "O",
      "\u022E": "O",
      "\u0230": "O",
      "\u00D6": "O",
      "\u022A": "O",
      "\u1ECE": "O",
      "\u0150": "O",
      "\u01D1": "O",
      "\u020C": "O",
      "\u020E": "O",
      "\u01A0": "O",
      "\u1EDC": "O",
      "\u1EDA": "O",
      "\u1EE0": "O",
      "\u1EDE": "O",
      "\u1EE2": "O",
      "\u1ECC": "O",
      "\u1ED8": "O",
      "\u01EA": "O",
      "\u01EC": "O",
      "\u00D8": "O",
      "\u01FE": "O",
      "\u0186": "O",
      "\u019F": "O",
      "\uA74A": "O",
      "\uA74C": "O",
      "\u01A2": "OI",
      "\uA74E": "OO",
      "\u0222": "OU",
      "\u24C5": "P",
      "\uFF30": "P",
      "\u1E54": "P",
      "\u1E56": "P",
      "\u01A4": "P",
      "\u2C63": "P",
      "\uA750": "P",
      "\uA752": "P",
      "\uA754": "P",
      "\u24C6": "Q",
      "\uFF31": "Q",
      "\uA756": "Q",
      "\uA758": "Q",
      "\u024A": "Q",
      "\u24C7": "R",
      "\uFF32": "R",
      "\u0154": "R",
      "\u1E58": "R",
      "\u0158": "R",
      "\u0210": "R",
      "\u0212": "R",
      "\u1E5A": "R",
      "\u1E5C": "R",
      "\u0156": "R",
      "\u1E5E": "R",
      "\u024C": "R",
      "\u2C64": "R",
      "\uA75A": "R",
      "\uA7A6": "R",
      "\uA782": "R",
      "\u24C8": "S",
      "\uFF33": "S",
      "\u1E9E": "S",
      "\u015A": "S",
      "\u1E64": "S",
      "\u015C": "S",
      "\u1E60": "S",
      "\u0160": "S",
      "\u1E66": "S",
      "\u1E62": "S",
      "\u1E68": "S",
      "\u0218": "S",
      "\u015E": "S",
      "\u2C7E": "S",
      "\uA7A8": "S",
      "\uA784": "S",
      "\u24C9": "T",
      "\uFF34": "T",
      "\u1E6A": "T",
      "\u0164": "T",
      "\u1E6C": "T",
      "\u021A": "T",
      "\u0162": "T",
      "\u1E70": "T",
      "\u1E6E": "T",
      "\u0166": "T",
      "\u01AC": "T",
      "\u01AE": "T",
      "\u023E": "T",
      "\uA786": "T",
      "\uA728": "TZ",
      "\u24CA": "U",
      "\uFF35": "U",
      "\u00D9": "U",
      "\u00DA": "U",
      "\u00DB": "U",
      "\u0168": "U",
      "\u1E78": "U",
      "\u016A": "U",
      "\u1E7A": "U",
      "\u016C": "U",
      "\u00DC": "U",
      "\u01DB": "U",
      "\u01D7": "U",
      "\u01D5": "U",
      "\u01D9": "U",
      "\u1EE6": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u01D3": "U",
      "\u0214": "U",
      "\u0216": "U",
      "\u01AF": "U",
      "\u1EEA": "U",
      "\u1EE8": "U",
      "\u1EEE": "U",
      "\u1EEC": "U",
      "\u1EF0": "U",
      "\u1EE4": "U",
      "\u1E72": "U",
      "\u0172": "U",
      "\u1E76": "U",
      "\u1E74": "U",
      "\u0244": "U",
      "\u24CB": "V",
      "\uFF36": "V",
      "\u1E7C": "V",
      "\u1E7E": "V",
      "\u01B2": "V",
      "\uA75E": "V",
      "\u0245": "V",
      "\uA760": "VY",
      "\u24CC": "W",
      "\uFF37": "W",
      "\u1E80": "W",
      "\u1E82": "W",
      "\u0174": "W",
      "\u1E86": "W",
      "\u1E84": "W",
      "\u1E88": "W",
      "\u2C72": "W",
      "\u24CD": "X",
      "\uFF38": "X",
      "\u1E8A": "X",
      "\u1E8C": "X",
      "\u24CE": "Y",
      "\uFF39": "Y",
      "\u1EF2": "Y",
      "\u00DD": "Y",
      "\u0176": "Y",
      "\u1EF8": "Y",
      "\u0232": "Y",
      "\u1E8E": "Y",
      "\u0178": "Y",
      "\u1EF6": "Y",
      "\u1EF4": "Y",
      "\u01B3": "Y",
      "\u024E": "Y",
      "\u1EFE": "Y",
      "\u24CF": "Z",
      "\uFF3A": "Z",
      "\u0179": "Z",
      "\u1E90": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u1E92": "Z",
      "\u1E94": "Z",
      "\u01B5": "Z",
      "\u0224": "Z",
      "\u2C7F": "Z",
      "\u2C6B": "Z",
      "\uA762": "Z",
      "\u24D0": "a",
      "\uFF41": "a",
      "\u1E9A": "a",
      "\u00E0": "a",
      "\u00E1": "a",
      "\u00E2": "a",
      "\u1EA7": "a",
      "\u1EA5": "a",
      "\u1EAB": "a",
      "\u1EA9": "a",
      "\u00E3": "a",
      "\u0101": "a",
      "\u0103": "a",
      "\u1EB1": "a",
      "\u1EAF": "a",
      "\u1EB5": "a",
      "\u1EB3": "a",
      "\u0227": "a",
      "\u01E1": "a",
      "\u00E4": "a",
      "\u01DF": "a",
      "\u1EA3": "a",
      "\u00E5": "a",
      "\u01FB": "a",
      "\u01CE": "a",
      "\u0201": "a",
      "\u0203": "a",
      "\u1EA1": "a",
      "\u1EAD": "a",
      "\u1EB7": "a",
      "\u1E01": "a",
      "\u0105": "a",
      "\u2C65": "a",
      "\u0250": "a",
      "\uA733": "aa",
      "\u00E6": "ae",
      "\u01FD": "ae",
      "\u01E3": "ae",
      "\uA735": "ao",
      "\uA737": "au",
      "\uA739": "av",
      "\uA73B": "av",
      "\uA73D": "ay",
      "\u24D1": "b",
      "\uFF42": "b",
      "\u1E03": "b",
      "\u1E05": "b",
      "\u1E07": "b",
      "\u0180": "b",
      "\u0183": "b",
      "\u0253": "b",
      "\u24D2": "c",
      "\uFF43": "c",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u00E7": "c",
      "\u1E09": "c",
      "\u0188": "c",
      "\u023C": "c",
      "\uA73F": "c",
      "\u2184": "c",
      "\u24D3": "d",
      "\uFF44": "d",
      "\u1E0B": "d",
      "\u010F": "d",
      "\u1E0D": "d",
      "\u1E11": "d",
      "\u1E13": "d",
      "\u1E0F": "d",
      "\u0111": "d",
      "\u018C": "d",
      "\u0256": "d",
      "\u0257": "d",
      "\uA77A": "d",
      "\u01F3": "dz",
      "\u01C6": "dz",
      "\u24D4": "e",
      "\uFF45": "e",
      "\u00E8": "e",
      "\u00E9": "e",
      "\u00EA": "e",
      "\u1EC1": "e",
      "\u1EBF": "e",
      "\u1EC5": "e",
      "\u1EC3": "e",
      "\u1EBD": "e",
      "\u0113": "e",
      "\u1E15": "e",
      "\u1E17": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u00EB": "e",
      "\u1EBB": "e",
      "\u011B": "e",
      "\u0205": "e",
      "\u0207": "e",
      "\u1EB9": "e",
      "\u1EC7": "e",
      "\u0229": "e",
      "\u1E1D": "e",
      "\u0119": "e",
      "\u1E19": "e",
      "\u1E1B": "e",
      "\u0247": "e",
      "\u025B": "e",
      "\u01DD": "e",
      "\u24D5": "f",
      "\uFF46": "f",
      "\u1E1F": "f",
      "\u0192": "f",
      "\uA77C": "f",
      "\u24D6": "g",
      "\uFF47": "g",
      "\u01F5": "g",
      "\u011D": "g",
      "\u1E21": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u01E7": "g",
      "\u0123": "g",
      "\u01E5": "g",
      "\u0260": "g",
      "\uA7A1": "g",
      "\u1D79": "g",
      "\uA77F": "g",
      "\u24D7": "h",
      "\uFF48": "h",
      "\u0125": "h",
      "\u1E23": "h",
      "\u1E27": "h",
      "\u021F": "h",
      "\u1E25": "h",
      "\u1E29": "h",
      "\u1E2B": "h",
      "\u1E96": "h",
      "\u0127": "h",
      "\u2C68": "h",
      "\u2C76": "h",
      "\u0265": "h",
      "\u0195": "hv",
      "\u24D8": "i",
      "\uFF49": "i",
      "\u00EC": "i",
      "\u00ED": "i",
      "\u00EE": "i",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u00EF": "i",
      "\u1E2F": "i",
      "\u1EC9": "i",
      "\u01D0": "i",
      "\u0209": "i",
      "\u020B": "i",
      "\u1ECB": "i",
      "\u012F": "i",
      "\u1E2D": "i",
      "\u0268": "i",
      "\u0131": "i",
      "\u24D9": "j",
      "\uFF4A": "j",
      "\u0135": "j",
      "\u01F0": "j",
      "\u0249": "j",
      "\u24DA": "k",
      "\uFF4B": "k",
      "\u1E31": "k",
      "\u01E9": "k",
      "\u1E33": "k",
      "\u0137": "k",
      "\u1E35": "k",
      "\u0199": "k",
      "\u2C6A": "k",
      "\uA741": "k",
      "\uA743": "k",
      "\uA745": "k",
      "\uA7A3": "k",
      "\u24DB": "l",
      "\uFF4C": "l",
      "\u0140": "l",
      "\u013A": "l",
      "\u013E": "l",
      "\u1E37": "l",
      "\u1E39": "l",
      "\u013C": "l",
      "\u1E3D": "l",
      "\u1E3B": "l",
      "\u017F": "l",
      "\u0142": "l",
      "\u019A": "l",
      "\u026B": "l",
      "\u2C61": "l",
      "\uA749": "l",
      "\uA781": "l",
      "\uA747": "l",
      "\u01C9": "lj",
      "\u24DC": "m",
      "\uFF4D": "m",
      "\u1E3F": "m",
      "\u1E41": "m",
      "\u1E43": "m",
      "\u0271": "m",
      "\u026F": "m",
      "\u24DD": "n",
      "\uFF4E": "n",
      "\u01F9": "n",
      "\u0144": "n",
      "\u00F1": "n",
      "\u1E45": "n",
      "\u0148": "n",
      "\u1E47": "n",
      "\u0146": "n",
      "\u1E4B": "n",
      "\u1E49": "n",
      "\u019E": "n",
      "\u0272": "n",
      "\u0149": "n",
      "\uA791": "n",
      "\uA7A5": "n",
      "\u01CC": "nj",
      "\u24DE": "o",
      "\uFF4F": "o",
      "\u00F2": "o",
      "\u00F3": "o",
      "\u00F4": "o",
      "\u1ED3": "o",
      "\u1ED1": "o",
      "\u1ED7": "o",
      "\u1ED5": "o",
      "\u00F5": "o",
      "\u1E4D": "o",
      "\u022D": "o",
      "\u1E4F": "o",
      "\u014D": "o",
      "\u1E51": "o",
      "\u1E53": "o",
      "\u014F": "o",
      "\u022F": "o",
      "\u0231": "o",
      "\u00F6": "o",
      "\u022B": "o",
      "\u1ECF": "o",
      "\u0151": "o",
      "\u01D2": "o",
      "\u020D": "o",
      "\u020F": "o",
      "\u01A1": "o",
      "\u1EDD": "o",
      "\u1EDB": "o",
      "\u1EE1": "o",
      "\u1EDF": "o",
      "\u1EE3": "o",
      "\u1ECD": "o",
      "\u1ED9": "o",
      "\u01EB": "o",
      "\u01ED": "o",
      "\u00F8": "o",
      "\u01FF": "o",
      "\u0254": "o",
      "\uA74B": "o",
      "\uA74D": "o",
      "\u0275": "o",
      "\u01A3": "oi",
      "\u0223": "ou",
      "\uA74F": "oo",
      "\u24DF": "p",
      "\uFF50": "p",
      "\u1E55": "p",
      "\u1E57": "p",
      "\u01A5": "p",
      "\u1D7D": "p",
      "\uA751": "p",
      "\uA753": "p",
      "\uA755": "p",
      "\u24E0": "q",
      "\uFF51": "q",
      "\u024B": "q",
      "\uA757": "q",
      "\uA759": "q",
      "\u24E1": "r",
      "\uFF52": "r",
      "\u0155": "r",
      "\u1E59": "r",
      "\u0159": "r",
      "\u0211": "r",
      "\u0213": "r",
      "\u1E5B": "r",
      "\u1E5D": "r",
      "\u0157": "r",
      "\u1E5F": "r",
      "\u024D": "r",
      "\u027D": "r",
      "\uA75B": "r",
      "\uA7A7": "r",
      "\uA783": "r",
      "\u24E2": "s",
      "\uFF53": "s",
      "\u00DF": "s",
      "\u015B": "s",
      "\u1E65": "s",
      "\u015D": "s",
      "\u1E61": "s",
      "\u0161": "s",
      "\u1E67": "s",
      "\u1E63": "s",
      "\u1E69": "s",
      "\u0219": "s",
      "\u015F": "s",
      "\u023F": "s",
      "\uA7A9": "s",
      "\uA785": "s",
      "\u1E9B": "s",
      "\u24E3": "t",
      "\uFF54": "t",
      "\u1E6B": "t",
      "\u1E97": "t",
      "\u0165": "t",
      "\u1E6D": "t",
      "\u021B": "t",
      "\u0163": "t",
      "\u1E71": "t",
      "\u1E6F": "t",
      "\u0167": "t",
      "\u01AD": "t",
      "\u0288": "t",
      "\u2C66": "t",
      "\uA787": "t",
      "\uA729": "tz",
      "\u24E4": "u",
      "\uFF55": "u",
      "\u00F9": "u",
      "\u00FA": "u",
      "\u00FB": "u",
      "\u0169": "u",
      "\u1E79": "u",
      "\u016B": "u",
      "\u1E7B": "u",
      "\u016D": "u",
      "\u00FC": "u",
      "\u01DC": "u",
      "\u01D8": "u",
      "\u01D6": "u",
      "\u01DA": "u",
      "\u1EE7": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u01D4": "u",
      "\u0215": "u",
      "\u0217": "u",
      "\u01B0": "u",
      "\u1EEB": "u",
      "\u1EE9": "u",
      "\u1EEF": "u",
      "\u1EED": "u",
      "\u1EF1": "u",
      "\u1EE5": "u",
      "\u1E73": "u",
      "\u0173": "u",
      "\u1E77": "u",
      "\u1E75": "u",
      "\u0289": "u",
      "\u24E5": "v",
      "\uFF56": "v",
      "\u1E7D": "v",
      "\u1E7F": "v",
      "\u028B": "v",
      "\uA75F": "v",
      "\u028C": "v",
      "\uA761": "vy",
      "\u24E6": "w",
      "\uFF57": "w",
      "\u1E81": "w",
      "\u1E83": "w",
      "\u0175": "w",
      "\u1E87": "w",
      "\u1E85": "w",
      "\u1E98": "w",
      "\u1E89": "w",
      "\u2C73": "w",
      "\u24E7": "x",
      "\uFF58": "x",
      "\u1E8B": "x",
      "\u1E8D": "x",
      "\u24E8": "y",
      "\uFF59": "y",
      "\u1EF3": "y",
      "\u00FD": "y",
      "\u0177": "y",
      "\u1EF9": "y",
      "\u0233": "y",
      "\u1E8F": "y",
      "\u00FF": "y",
      "\u1EF7": "y",
      "\u1E99": "y",
      "\u1EF5": "y",
      "\u01B4": "y",
      "\u024F": "y",
      "\u1EFF": "y",
      "\u24E9": "z",
      "\uFF5A": "z",
      "\u017A": "z",
      "\u1E91": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u1E93": "z",
      "\u1E95": "z",
      "\u01B6": "z",
      "\u0225": "z",
      "\u0240": "z",
      "\u2C6C": "z",
      "\uA763": "z",
      "\u0386": "\u0391",
      "\u0388": "\u0395",
      "\u0389": "\u0397",
      "\u038A": "\u0399",
      "\u03AA": "\u0399",
      "\u038C": "\u039F",
      "\u038E": "\u03A5",
      "\u03AB": "\u03A5",
      "\u038F": "\u03A9",
      "\u03AC": "\u03B1",
      "\u03AD": "\u03B5",
      "\u03AE": "\u03B7",
      "\u03AF": "\u03B9",
      "\u03CA": "\u03B9",
      "\u0390": "\u03B9",
      "\u03CC": "\u03BF",
      "\u03CD": "\u03C5",
      "\u03CB": "\u03C5",
      "\u03B0": "\u03C5",
      "\u03C9": "\u03C9",
      "\u03C2": "\u03C3",
    };
    var f = function (i) {
      return g[i] || i;
    };
    return h.replace(/[^\u0000-\u007E]/g, f);
  };
  function d(f) {
    var g = [];
    this.filter("select").each(function () {
      var j = e(this);
      var i = j.data("tokenize2");
      var h = typeof f === "object" && f;
      if (!i) {
        j.data("tokenize2", new c(this, h));
      }
      g.push(j.data("tokenize2"));
    });
    if (g.length > 1) {
      return g;
    } else {
      return g[0];
    }
  }
  var b = e.fn.tokenize2;
  e.fn.tokenize2 = d;
  e.fn.tokenize2.Constructor = c;
  e.fn.tokenize2.noConflict = function () {
    e.fn.tokenize2 = b;
    return this;
  };
});
!(function (c, f, a, e) {
  var i = { drag: true, drop: true, exclude: "", nested: true, vertical: true },
    o = {
      afterMove: function (t, d, u) {},
      containerPath: "",
      containerSelector: "ol, ul",
      distance: 0,
      delay: 0,
      handle: "",
      itemPath: "",
      itemSelector: "li",
      bodyClass: "dragging",
      draggedClass: "dragged",
      isValidTarget: function (t, d) {
        return true;
      },
      onCancel: function (t, d, v, u) {},
      onDrag: function (t, d, v, u) {
        t.css(d);
      },
      onDragStart: function (t, d, v, u) {
        t.css({ height: t.outerHeight(), width: t.outerWidth() });
        t.addClass(d.group.options.draggedClass);
        c("body").addClass(d.group.options.bodyClass);
      },
      onDrop: function (t, d, v, u) {
        t.removeClass(d.group.options.draggedClass).removeAttr("style");
        c("body").removeClass(d.group.options.bodyClass);
      },
      onMousedown: function (d, u, t) {
        if (!t.target.nodeName.match(/^(input|select|textarea)$/i)) {
          t.preventDefault();
          return true;
        }
      },
      placeholderClass: "placeholder",
      placeholder: '<li class="placeholder"></li>',
      pullPlaceholder: true,
      serialize: function (v, u, t) {
        var d = c.extend({}, v.data());
        if (t) {
          return [u];
        } else {
          if (u[0]) {
            d.children = u;
          }
        }
        delete d.subContainers;
        delete d.sortable;
        return d;
      },
      tolerance: 0,
    },
    q = {},
    l = 0,
    h = { left: 0, top: 0, bottom: 0, right: 0 },
    g = {
      start: "touchstart.sortable mousedown.sortable",
      drop: "touchend.sortable touchcancel.sortable mouseup.sortable",
      drag: "touchmove.sortable mousemove.sortable",
      scroll: "scroll.sortable",
    },
    s = "subContainers";
  function r(u, t) {
    var d = Math.max(0, u[0] - t[0], t[0] - u[1]),
      v = Math.max(0, u[2] - t[1], t[1] - u[3]);
    return d + v;
  }
  function n(z, x, t, v) {
    var u = z.length,
      d = v ? "offset" : "position";
    t = t || 0;
    while (u--) {
      var w = z[u].el ? z[u].el : c(z[u]),
        y = w[d]();
      y.left += parseInt(w.css("margin-left"), 10);
      y.top += parseInt(w.css("margin-top"), 10);
      x[u] = [
        y.left - t,
        y.left + w.outerWidth() + t,
        y.top - t,
        y.top + w.outerHeight() + t,
      ];
    }
  }
  function b(u, d) {
    var t = d.offset();
    return { left: u.left - t.left, top: u.top - t.top };
  }
  function p(v, x, u) {
    x = [x.left, x.top];
    u = u && [u.left, u.top];
    var w,
      t = v.length,
      d = [];
    while (t--) {
      w = v[t];
      d[t] = [t, r(w, x), u && r(w, u)];
    }
    d = d.sort(function (z, y) {
      return y[1] - z[1] || y[2] - z[2] || y[0] - z[0];
    });
    return d;
  }
  function m(d) {
    this.options = c.extend({}, o, d);
    this.containers = [];
    if (!this.options.rootGroup) {
      this.scrollProxy = c.proxy(this.scroll, this);
      this.dragProxy = c.proxy(this.drag, this);
      this.dropProxy = c.proxy(this.drop, this);
      this.placeholder = c(this.options.placeholder);
      if (!d.isValidTarget) {
        this.options.isValidTarget = e;
      }
    }
  }
  m.get = function (d) {
    if (!q[d.group]) {
      if (d.group === e) {
        d.group = l++;
      }
      q[d.group] = new m(d);
    }
    return q[d.group];
  };
  m.prototype = {
    dragInit: function (u, t) {
      this.$document = c(t.el[0].ownerDocument);
      var d = c(u.target).closest(this.options.itemSelector);
      if (d.length) {
        this.item = d;
        this.itemContainer = t;
        if (
          this.item.is(this.options.exclude) ||
          !this.options.onMousedown(this.item, o.onMousedown, u)
        ) {
          return;
        }
        this.setPointer(u);
        this.toggleListeners("on");
        this.setupDelayTimer();
        this.dragInitDone = true;
      }
    },
    drag: function (w) {
      if (!this.dragging) {
        if (!this.distanceMet(w) || !this.delayMet) {
          return;
        }
        this.options.onDragStart(
          this.item,
          this.itemContainer,
          o.onDragStart,
          w
        );
        this.item.before(this.placeholder);
        this.dragging = true;
      }
      this.setPointer(w);
      this.options.onDrag(
        this.item,
        b(this.pointer, this.item.offsetParent()),
        o.onDrag,
        w
      );
      var v = this.getPointer(w),
        u = this.sameResultBox,
        d = this.options.tolerance;
      if (
        !u ||
        u.top - d > v.top ||
        u.bottom + d < v.top ||
        u.left - d > v.left ||
        u.right + d < v.left
      ) {
        if (!this.searchValidTarget()) {
          this.placeholder.detach();
          this.lastAppendedItem = e;
        }
      }
    },
    drop: function (d) {
      this.toggleListeners("off");
      this.dragInitDone = false;
      if (this.dragging) {
        if (this.placeholder.closest("html")[0]) {
          this.placeholder.before(this.item).detach();
        } else {
          this.options.onCancel(this.item, this.itemContainer, o.onCancel, d);
        }
        this.options.onDrop(
          this.item,
          this.getContainer(this.item),
          o.onDrop,
          d
        );
        this.clearDimensions();
        this.clearOffsetParent();
        this.lastAppendedItem = this.sameResultBox = e;
        this.dragging = false;
      }
    },
    searchValidTarget: function (y, w) {
      if (!y) {
        y = this.relativePointer || this.pointer;
        w = this.lastRelativePointer || this.lastPointer;
      }
      var t = p(this.getContainerDimensions(), y, w),
        v = t.length;
      while (v--) {
        var u = t[v][0],
          z = t[v][1];
        if (!z || this.options.pullPlaceholder) {
          var d = this.containers[u];
          if (!d.disabled) {
            if (!this.$getOffsetParent()) {
              var x = d.getItemOffsetParent();
              y = b(y, x);
              w = b(w, x);
            }
            if (d.searchValidTarget(y, w)) {
              return true;
            }
          }
        }
      }
      if (this.sameResultBox) {
        this.sameResultBox = e;
      }
    },
    movePlaceholder: function (t, u, w, d) {
      var v = this.lastAppendedItem;
      if (!d && v && v[0] === u[0]) {
        return;
      }
      u[w](this.placeholder);
      this.lastAppendedItem = u;
      this.sameResultBox = d;
      this.options.afterMove(this.placeholder, t, u);
    },
    getContainerDimensions: function () {
      if (!this.containerDimensions) {
        n(
          this.containers,
          (this.containerDimensions = []),
          this.options.tolerance,
          !this.$getOffsetParent()
        );
      }
      return this.containerDimensions;
    },
    getContainer: function (d) {
      return d.closest(this.options.containerSelector).data(a);
    },
    $getOffsetParent: function () {
      if (this.offsetParent === e) {
        var d = this.containers.length - 1,
          t = this.containers[d].getItemOffsetParent();
        if (!this.options.rootGroup) {
          while (d--) {
            if (t[0] != this.containers[d].getItemOffsetParent()[0]) {
              t = false;
              break;
            }
          }
        }
        this.offsetParent = t;
      }
      return this.offsetParent;
    },
    setPointer: function (t) {
      var u = this.getPointer(t);
      if (this.$getOffsetParent()) {
        var d = b(u, this.$getOffsetParent());
        this.lastRelativePointer = this.relativePointer;
        this.relativePointer = d;
      }
      this.lastPointer = this.pointer;
      this.pointer = u;
    },
    distanceMet: function (d) {
      var t = this.getPointer(d);
      return (
        Math.max(
          Math.abs(this.pointer.left - t.left),
          Math.abs(this.pointer.top - t.top)
        ) >= this.options.distance
      );
    },
    getPointer: function (d) {
      var t =
        d.originalEvent ||
        (d.originalEvent.touches && d.originalEvent.touches[0]);
      return { left: d.pageX || t.pageX, top: d.pageY || t.pageY };
    },
    setupDelayTimer: function () {
      var d = this;
      this.delayMet = !this.options.delay;
      if (!this.delayMet) {
        clearTimeout(this._mouseDelayTimer);
        this._mouseDelayTimer = setTimeout(function () {
          d.delayMet = true;
        }, this.options.delay);
      }
    },
    scroll: function (d) {
      this.clearDimensions();
      this.clearOffsetParent();
    },
    toggleListeners: function (u) {
      var t = this,
        d = ["drag", "drop", "scroll"];
      c.each(d, function (v, w) {
        t.$document[u](g[w], t[w + "Proxy"]);
      });
    },
    clearOffsetParent: function () {
      this.offsetParent = e;
    },
    clearDimensions: function () {
      this.traverse(function (d) {
        d._clearDimensions();
      });
    },
    traverse: function (t) {
      t(this);
      var d = this.containers.length;
      while (d--) {
        this.containers[d].traverse(t);
      }
    },
    _clearDimensions: function () {
      this.containerDimensions = e;
    },
    _destroy: function () {
      q[this.options.group] = e;
    },
  };
  function j(u, t) {
    this.el = u;
    this.options = c.extend({}, i, t);
    this.group = m.get(this.options);
    this.rootGroup = this.options.rootGroup || this.group;
    this.handle =
      this.rootGroup.options.handle || this.rootGroup.options.itemSelector;
    var d = this.rootGroup.options.itemPath;
    this.target = d ? this.el.find(d) : this.el;
    this.target.on(g.start, this.handle, c.proxy(this.dragInit, this));
    if (this.options.drop) {
      this.group.containers.push(this);
    }
  }
  j.prototype = {
    dragInit: function (t) {
      var d = this.rootGroup;
      if (
        !this.disabled &&
        !d.dragInitDone &&
        this.options.drag &&
        this.isValidDrag(t)
      ) {
        d.dragInit(t, this);
      }
    },
    isValidDrag: function (d) {
      return (
        d.which == 1 ||
        (d.type == "touchstart" && d.originalEvent.touches.length == 1)
      );
    },
    searchValidTarget: function (d, u) {
      var x = p(this.getItemDimensions(), d, u),
        v = x.length,
        y = this.rootGroup,
        z = !y.options.isValidTarget || y.options.isValidTarget(y.item, this);
      if (!v && z) {
        y.movePlaceholder(this, this.target, "append");
        return true;
      } else {
        while (v--) {
          var w = x[v][0],
            t = x[v][1];
          if (!t && this.hasChildGroup(w)) {
            var A = this.getContainerGroup(w).searchValidTarget(d, u);
            if (A) {
              return true;
            }
          } else {
            if (z) {
              this.movePlaceholder(w, d);
              return true;
            }
          }
        }
      }
    },
    movePlaceholder: function (A, t) {
      var E = c(this.items[A]),
        z = this.itemDimensions[A],
        d = "after",
        u = E.outerWidth(),
        D = E.outerHeight(),
        y = E.offset(),
        v = { left: y.left, right: y.left + u, top: y.top, bottom: y.top + D };
      if (this.options.vertical) {
        var C = (z[2] + z[3]) / 2,
          B = t.top <= C;
        if (B) {
          d = "before";
          v.bottom -= D / 2;
        } else {
          v.top += D / 2;
        }
      } else {
        var w = (z[0] + z[1]) / 2,
          x = t.left <= w;
        if (x) {
          d = "before";
          v.right -= u / 2;
        } else {
          v.left += u / 2;
        }
      }
      if (this.hasChildGroup(A)) {
        v = h;
      }
      this.rootGroup.movePlaceholder(this, E, d, v);
    },
    getItemDimensions: function () {
      if (!this.itemDimensions) {
        this.items = this.$getChildren(this.el, "item")
          .filter(
            ":not(." +
              this.group.options.placeholderClass +
              ", ." +
              this.group.options.draggedClass +
              ")"
          )
          .get();
        n(this.items, (this.itemDimensions = []), this.options.tolerance);
      }
      return this.itemDimensions;
    },
    getItemOffsetParent: function () {
      var t,
        d = this.el;
      if (
        d.css("position") === "relative" ||
        d.css("position") === "absolute" ||
        d.css("position") === "fixed"
      ) {
        t = d;
      } else {
        t = d.offsetParent();
      }
      return t;
    },
    hasChildGroup: function (d) {
      return this.options.nested && this.getContainerGroup(d);
    },
    getContainerGroup: function (u) {
      var v = c.data(this.items[u], s);
      if (v === e) {
        var t = this.$getChildren(this.items[u], "container");
        v = false;
        if (t[0]) {
          var d = c.extend({}, this.options, {
            rootGroup: this.rootGroup,
            group: l++,
          });
          v = t[a](d).data(a).group;
        }
        c.data(this.items[u], s, v);
      }
      return v;
    },
    $getChildren: function (v, u) {
      var t = this.rootGroup.options,
        w = t[u + "Path"],
        d = t[u + "Selector"];
      v = c(v);
      if (w) {
        v = v.find(w);
      }
      return v.children(d);
    },
    _serialize: function (v, u) {
      var w = this,
        d = u ? "item" : "container",
        t = this.$getChildren(v, d)
          .not(this.options.exclude)
          .map(function () {
            return w._serialize(c(this), !u);
          })
          .get();
      return this.rootGroup.options.serialize(v, t, u);
    },
    traverse: function (d) {
      c.each(this.items || [], function (t) {
        var u = c.data(this, s);
        if (u) {
          u.traverse(d);
        }
      });
      d(this);
    },
    _clearDimensions: function () {
      this.itemDimensions = e;
    },
    _destroy: function () {
      var d = this;
      this.target.off(g.start, this.handle);
      this.el.removeData(a);
      if (this.options.drop) {
        this.group.containers = c.grep(this.group.containers, function (t) {
          return t != d;
        });
      }
      c.each(this.items || [], function () {
        c.removeData(this, s);
      });
    },
  };
  var k = {
    enable: function () {
      this.traverse(function (d) {
        d.disabled = false;
      });
    },
    disable: function () {
      this.traverse(function (d) {
        d.disabled = true;
      });
    },
    serialize: function () {
      return this._serialize(this.el, true);
    },
    refresh: function () {
      this.traverse(function (d) {
        d._clearDimensions();
      });
    },
    destroy: function () {
      this.traverse(function (d) {
        d._destroy();
      });
    },
  };
  c.extend(j.prototype, k);
  c.fn[a] = function (d) {
    var t = Array.prototype.slice.call(arguments, 1);
    return this.map(function () {
      var v = c(this),
        u = v.data(a);
      if (u && k[d]) {
        return k[d].apply(u, t) || this;
      } else {
        if (!u && (d === e || typeof d === "object")) {
          v.data(a, new j(v, d));
        }
      }
      return this;
    });
  };
})(jQuery, window, "tokenize2sortable");
//# sourceMappingURL=app.js.map
